var Remote,
  Amount,
  moment;

if (typeof require != 'undefined') {

  /* Loading with Node.js */
  var Remote = require('ripple-lib').Remote,
    Amount = require('ripple-lib').Amount,
    moment = require('moment');

} else if (ripple && moment) {

  /* Loading in a webpage */
  Remote = ripple.Remote;
  Amount = ripple.Amount;

  // Note: also be sure to load momentjs before loading this file

} else {
  throw (new Error('Error: cannot load offersExercisedListener without ripple-lib, momentjs'));

}


/**
 *  HOW-TO use this script...
 *
 *  Load it in Node.js or on a webpage after loading its dependencies.
 *  Then, initialize an OffersExercisedListener with (pretty much) the
 *  same options you use to query the offersExercised API route.
 *
 *  If you query the API route again with different options and want the
 *  OffersExercisedListener to be updated accordingly, simply call
 *  the instance's updateViewOpts() method with the new options.
 *
 *  To use multiple OffersExercisedListeners on a single page, simply
 *  initialize one instance per option set, save a reference to each,
 *  and call the stopListener() function for any that you wish to remove.
 *
 *  To create an OffersExercisedListener that listens for all offers exercised,
 *  intitialize one with no view options and it will call the display function
 *  each time it hears an offer exercised with an object of the form:
 *  {key: [[trade currency, trade curr issuer][base currency, base curr issuer], year, month, day, hour, minute second], value: [trade curr volume, base curr volume, exchange rate]}
 */



/**
 *  createOffersExercisedListener listens to the live transaction feed,
 *  parses offersExercised events, and passes the parsed data to the
 *  given displayFn
 *
 *  Available options include:
 *  {
 *    base: {currency: "XRP"},
 *    counter: {currency: "USD", issuer: "rvYAfWj5gh67oV6fW32ZzP3Aw4Eubs59B"},
 *
 *    reduce: true/false, // optional, defaults to false if timeIncrement is not set
 *    timeIncrement: (any of the following: "all", "none", "year", "month", "day", "hour", "minute", "second") // optional
 *    timeMultiple: positive integer // optional, defaults to 1
 *
 *    openTime: a momentjs-readable value // optional, defaults to now
 *    incompleteApiRow: if the last timeIncrement returned by the API is
 *      incomplete, that row can be passed in here to be completed by the live feed listener
 *  }
 */
function OffersExercisedListener(remote, opts, displayFn) {

  // Connect to ripple-lib
  if (!remote) {
    throw new Erorr('Remote not loaded')
  }

  this.remote = remote;

  if (typeof opts === 'function') {
    displayFn = opts;
    opts      = {};
  }

  this.displayFn = displayFn;
  this.txProcessor;
  this.interval;
  this.baseAccount = null;
  this.counterAccount = null;

  // Wrapper to call the displayFn and update the openTime and closeTime
  this.finishedInterval = function() {

    //send to display
    this.displayFn(formatReduceResult(this.storedResults), true);

    //reset the stored results
    var startTime = moment.utc(this.storedResults.startTime)
      .add(this.viewOpts.timeMultiple, this.viewOpts.timeIncrement);
    this.resetStored([startTime.toISOString()]);
  };

  // setup this instance based on the given opts
  this.updateViewOpts(opts);

  if (opts.base.currency !== 'XRP') {
    this.baseAccount = this.remote.account(opts.base.issuer);
    this.baseAccount.on('transaction', this.txProcessor);
  }
  if (opts.counter.currency !== 'XRP') {
    this.counterAccount = this.remote.account(opts.counter.issuer);
    this.counterAccount.on('transaction', this.txProcessor);
  }
}


OffersExercisedListener.prototype.resetStored = function (row) {
  if (!row) row = [];

  this.storedResults = {
    startTime   : moment.utc(row.startTime || row.time || row[0]).toISOString(),
    curr1Volume : row.baseVolume    || row[1]  || 0.0,
    curr2Volume : row.counterVolume || row[2]  || 0.0,
    numTrades   : row.count         || row[3]  || 0,
    open        : row.open          || row[4]  || 0.0,
    high        : row.high          || row[5]  || 0.0,
    low         : row.low           || row[6]  || 0.0,
    close       : row.close         || row[7]  || 0.0,
    volumeWeightedAvg: row.vwap     || row[8]  || 0.0,
    openTime    : row.openTime      || row[9]  || 0,
    closeTime   : row.closeTime     || row[10] || 0,
  };

  this.storedResults.curr1VwavNumerator = this.storedResults.volumeWeightedAvg * this.storedResults.curr1Volume;

}


/**
 *  stopListener resets the OffersExercisedListener
 */
OffersExercisedListener.prototype.stopListener = function() {

  var listener = this;
  listener.storedResults = {};

  if (listener.interval) clearInterval(listener.interval);
  if (listener.timeout)  clearTimeout(listener.timeout);
  if (listener.check)    clearInterval(listener.check);

  if (listener.txProcessor) {
    if (listener.baseAccount) {
        listener.baseAccount.removeListener('transaction', listener.txProcessor);
    }
    if (listener.counterAccount) {
        listener.counterAccount.removeListener('transaction', listener.txProcessor);
    }
  }
};


/**
 *  updateViewOpts updates the viewOpts, resets the stored results
 *  and resets the txProcessor and transaction listener
 */
OffersExercisedListener.prototype.updateViewOpts = function(newOpts) {

  var listener = this;

  listener.stopListener();
  listener.viewOpts = parseViewOpts(newOpts);

  // If timeIncrement is set, setup an interval to call the displayFn,
  // otherwise, pass the displayFn directly to createTransactionProcessor()
  if (!listener.viewOpts.timeIncrement) {
    listener.txProcessor = createTransactionProcessor(listener.viewOpts, listener.displayFn);

  } else {

    //if there isnt a row, start time will be set to now
    listener.resetStored(listener.viewOpts.incompleteApiRow || []);

    // create regular listener
    listener.txProcessor = createTransactionProcessor(listener.viewOpts, function(reducedTrade){

      listener.storedResults = offersExercisedReduce([listener.storedResults, reducedTrade], true);

      // Call displayFn every time a new trade comes in, as well as after the interval
      listener.displayFn(formatReduceResult(listener.storedResults));

    });


    // handle first interval

    var endTime   = moment.utc(listener.storedResults.startTime)
      .add(listener.viewOpts.timeMultiple, listener.viewOpts.timeIncrement);
    var remainder = endTime.diff(moment.utc());

    //if its more than 24 days, it will overflow
    //the set timeout function. just assume no one
    //will keep the browser open that long
    if (remainder > 2073600000) return;

    // If there is time left in the first timeIncrement, wait until that
    // is finished to start the interval
    if (remainder > 0) {

      listener.timeout = setTimeout(function(){
        listener.finishedInterval();
        setNext(listener);

      }, remainder);

    } else {
      listener.finishedInterval();
      setNext(listener);
    }

  }

  function setNext(listener) {
    listener.interval = setInterval(function(){
      listener.finishedInterval();
    }, moment.duration(listener.viewOpts.timeMultiple, listener.viewOpts.timeIncrement).asMilliseconds());
  }

//   listener.remote.on('transaction_all', listener.txProcessor);
}


/**
 *  parseViewOpts parses and validates the given view options
 */
function parseViewOpts(opts) {
  // TODO validate opts more thoroughly

  opts.openTime = moment.utc(opts.openTime).toArray().slice(0,6);

  if (opts.timeIncrement) {
    opts.reduce = true;

    if (!opts.timeMultiple) {
      opts.timeMultiple = 1;
    }
  }

  if (!opts.base || !opts.counter) opts.reduce = false;
  else if (opts.base    && opts.base.issuer == '')    delete opts.base.issuer;
  else if (opts.counter && opts.counter.issuer == '') delete opts.counter.issuer;

  if (opts.base && opts.base.issuer === undefined) delete opts.base.issuer;
  if (opts.counter && opts.counter.issuer === undefined) delete opts.counter.issuer;

  return opts;
}


/**
 *  createTransactionProcessor returns a function that accepts txData
 *  and parses it according to the viewOpts
 */
function createTransactionProcessor(viewOpts, resultHandler) {

  function txProcessor (txData){
    var txContainer = {
      close_time_timestamp: (new Date()).getTime(),
      transactions: [txData.transaction]
    };
    txContainer.transactions[0].metaData = txData.meta;

    // use the map function to parse txContainer data
    offersExercisedMap(txContainer, function(key, value){

      if (viewOpts.counter) {
        // return if trade doesn't match either currency in the pair
        if ((viewOpts.counter.currency !== key[0][0] || viewOpts.counter.issuer !== key[0][1])
            && (viewOpts.counter.currency !== key[1][0] || viewOpts.counter.issuer !== key[1][1])) {
          return;
        }
      }

      if (viewOpts.base) {
        // return if base doesn't match either currency in the pair
        if ((viewOpts.base.currency !== key[0][0] || viewOpts.base.issuer !== key[0][1])
            && (viewOpts.base.currency !== key[1][0] || viewOpts.base.issuer !== key[1][1])) {
          return;
        }
      }

      // Flip the currencies if necessary
      if (viewOpts.base.currency === key[1][0] && viewOpts.base.issuer === key[1][1]) {
        key      = [key[1], key[0]]
        value    = [value[1], value[0], 1/value[2], value[3], value[4], value[5], value[6]];
      }

      //console.log(value);
      if (!viewOpts.reduce) {
        resultHandler({key: key, value: value})
      }
      else resultHandler(offersExercisedReduce([value], false));

    });
  }

  return txProcessor;
}

OffersExercisedListener.prototype.createTransactionProcessor = createTransactionProcessor;


/**
 *  offersExercisedMap is, with three exceptions, the same as the
 *  map function used in the CouchDB view offersExercised
 *
 *  the only exceptions are 'emit' as a parameter, emit only
 *  being called once, and the line that parses the exchange_rate
 */

function offersExercisedMap(doc, emit) {

    var time = new Date(doc.close_time_timestamp),
      unix   = Math.round(time.getTime());

    doc.transactions.forEach(function(tx) {


        if (tx.metaData.TransactionResult !== 'tesSUCCESS') {
            return;
        }

        if (tx.TransactionType !== 'Payment' && tx.TransactionType !== 'OfferCreate') {
            return;
        }

        //console.log(tx.hash);
        tx.metaData.AffectedNodes.forEach(function(affNode) {

            var node = affNode.ModifiedNode || affNode.DeletedNode;

            if (!node || node.LedgerEntryType !== 'Offer') {
                return;
            }

            if (!node.PreviousFields || !node.PreviousFields.TakerPays || !node.PreviousFields.TakerGets) {
                return;
            }

            // parse exchange_rate
            // note: this block was inserted in addition to what is used in CouchDB
            if ((node.FinalFields || node.NewFields) && typeof(node.FinalFields || node.NewFields).BookDirectory === "string") {
                node.exchange_rate = Amount.from_quality((node.FinalFields || node.NewFields).BookDirectory).to_json().value;
            }

            var exchangeRate = node.exchange_rate,
                counterparty = node.FinalFields.Account,
                payCurr,
                payAmnt,
                getCurr,
                getAmnt;

            if (typeof node.PreviousFields.TakerPays === "object") {
                payCurr = [node.PreviousFields.TakerPays.currency, node.PreviousFields.TakerPays.issuer];
                payAmnt = node.PreviousFields.TakerPays.value - node.FinalFields.TakerPays.value;
            } else {
                payCurr = ["XRP"];
                payAmnt = (node.PreviousFields.TakerPays - node.FinalFields.TakerPays) / 1000000.0; // convert from drops
                exchangeRate = exchangeRate / 1000000.0;
            }

            if (typeof node.PreviousFields.TakerGets === "object") {
                getCurr = [node.PreviousFields.TakerGets.currency, node.PreviousFields.TakerGets.issuer];
                getAmnt = node.PreviousFields.TakerGets.value - node.FinalFields.TakerGets.value;
            } else {
                getCurr = ["XRP"];
                getAmnt = (node.PreviousFields.TakerGets - node.FinalFields.TakerGets) / 1000000.0;
                exchangeRate = exchangeRate * 1000000.0;
            }

            emit([payCurr, getCurr], [payAmnt, getAmnt, 1/exchangeRate, counterparty, tx.Account, unix, tx.hash]);
        });


    });
}

/**
 *  offersExercisedReduce is the same reduce function used by the
 *  offersExercised view in CouchDB
 *  (note the difference between the 'reduce' and 'rereduce' modes)
 */
function offersExercisedReduce(values, rereduce) {

  var stats;

  if ( !rereduce ) {

    var firstTime = values[0][5], //unix timestamp
      firstPrice  = values[0][2]; //exchange rate

    // initial values
    stats = {
      openTime  : firstTime,
      closeTime : firstTime,

      open  : firstPrice,
      close : firstPrice,
      high  : firstPrice,
      low   : firstPrice,

      curr1Volume : 0,
      curr2Volume : 0,
      numTrades   : 0
    };

    values.forEach( function( trade, index ) {

      var time = trade[5], //unix timestamp
        price  = trade[2]; //exchange rate

      if (time<stats.openTime) {
        stats.openTime = time;
        stats.open     = price;
      }

      if (stats.closeTime<time) {
        stats.closeTime = time;
        stats.close     = price;
      }

      if (price>stats.high) stats.high = price;
      if (price<stats.low)  stats.low  = price;

      stats.curr1Volume += trade[0];
      stats.curr2Volume += trade[1];
      stats.numTrades++;
    });

    stats.volumeWeightedAvg = stats.curr2Volume / stats.curr1Volume;
    return stats;

  } else {

    stats = values[0];
    if (typeof stats.openTime === 'string')
      stats.openTime  = moment.utc(stats.openTime).unix();
    if (typeof stats.closeTime === 'string')
      stats.closeTime = moment.utc(stats.closeTime).unix();

    values.forEach( function( segment, index ) {

      // skip values[0]
      if (index === 0) return;

      if (typeof segment.openTime === 'string')
        segment.openTime  = moment.utc(segment.openTime).unix();
      if (typeof segment.closeTime === 'string')
        segment.closeTime = moment.utc(segment.closeTime).unix();


      if (!stats.open || segment.openTime<stats.openTime) {
        stats.openTime = segment.openTime;
        stats.open     = segment.open;
      }
      if (!stats.close || stats.closeTime<segment.closeTime) {
        stats.closeTime = segment.closeTime;
        stats.close     = segment.close;
      }

      if (!stats.high || segment.high>stats.high) stats.high = segment.high;
      if (!stats.low  || segment.low<stats.low)   stats.low  = segment.low;

      stats.curr1Volume += segment.curr1Volume;
      stats.curr2Volume += segment.curr2Volume;
      stats.numTrades   += segment.numTrades;
    });

    stats.volumeWeightedAvg = stats.curr2Volume / stats.curr1Volume;
    return stats;
  }
}


function formatReduceResult (result) {

  return {
    startTime     : result.startTime,
    openTime      : moment.utc(result.openTime).toISOString(),
    closeTime     : moment.utc(result.closeTime).toISOString(),
    baseVolume    : result.curr1Volume,
    counterVolume : result.curr2Volume,
    count         : result.numTrades,
    open          : result.open,
    close         : result.close,
    high          : result.high,
    low           : result.low,
    vwap          : result.volumeWeightedAvg
  };
}


if (typeof module != 'undefined') {
  module.exports = OffersExercisedListener;
}

var pairs = {name: 'XRP/USD.SnapSwap', last_used: 10};

/**
 * Calculate executed order price
 *
 * @param effect
 * @returns {*}
 */
var getPrice = function(effect, referenceDate) {
  var g = effect.got ? effect.got : effect.gets;
  var p = effect.paid ? effect.paid : effect.pays;
  var price;

  if (!p.is_zero() && !g.is_zero()) {
    _.find(pairs, function(pair) {
      if (pair.name == g.currency().to_human() + '/' + p.currency().to_human()) {
        price = p.ratio_human(g, {reference_date: referenceDate});
      }
    });

    if (!price) {
      price = g.ratio_human(p, {reference_date: referenceDate});
    }
  }

  return price || 0;
};

var getStraightPrice = function(effect, referenceDate) {
  var g = effect.got ? effect.got : effect.gets;
  var p = effect.paid ? effect.paid : effect.pays;
  var price;

  if (!p.is_zero() && !g.is_zero()) {
    price = g.ratio_human(p, {reference_date: referenceDate});
  }

  return price || 0;
};

var getInvStraightPrice = function(effect, referenceDate) {
  var g = effect.got ? effect.got : effect.gets;
  var p = effect.paid ? effect.paid : effect.pays;
  var price;

  if (!p.is_zero() && !g.is_zero()) {
    price = p.ratio_human(g, {reference_date: referenceDate});
  }

  return price || 0;
};

/**
 * Determine if the transaction is a 'rippling' transaction based on effects
 *
 * @param effects
 */
var isRippling = function(effects) {
  if (
    effects
    && effects.length
    && 2 === effects.length
    && 'trust_change_balance' == effects[0].type
    && 'trust_change_balance' == effects[1].type
    && effects[0].currency == effects[1].currency
    && !effects[0].amount.compareTo(effects[1].amount.negate())
  ) {
    return true;
  }
};

/**
 * Simple static class for processing server-side JSON.
 */
var JsonRewriter = {
  /**
   * Filter affected nodes by type.
   *
   * If affectedNodes is not a valid set of nodes, returns an empty array.
   */
  filterAnodes: function (affectedNodes, type) {
    if (!affectedNodes) return [];

    return affectedNodes.filter(function (an) {
      an = an.CreatedNode ? an.CreatedNode :
          an.ModifiedNode ? an.ModifiedNode :
          {};

      return an.LedgerEntryType === type;
    });
  },

  /**
   * Returns resulting (new or modified) fields from an affected node.
   */
  getAnodeResult: function (an) {
    an = an.CreatedNode ? an.CreatedNode :
        an.ModifiedNode ? an.ModifiedNode :
        {};

    var fields = $.extend({}, an.NewFields, an.FinalFields);

    return fields;
  },

  /**
   * Takes a metadata affected node and returns a simpler JSON object.
   *
   * The resulting object looks like this:
   *
   *   {
   *     // Type of diff, e.g. CreatedNode, ModifiedNode
   *     diffType: 'CreatedNode'
   *
   *     // Type of node affected, e.g. RippleState, AccountRoot
   *     entryType: 'RippleState',
   *
   *     // Index of the ledger this change occurred in
   *     ledgerIndex: '01AB01AB...',
   *
   *     // Contains all fields with later versions taking precedence
   *     //
   *     // This is a shorthand for doing things like checking which account
   *     // this affected without having to check the diffType.
   *     fields: {...},
   *
   *     // Old fields (before the change)
   *     fieldsPrev: {...},
   *
   *     // New fields (that have been added)
   *     fieldsNew: {...},
   *
   *     // Changed fields
   *     fieldsFinal: {...}
   *   }
   */
  processAnode: function (an) {
    var result = {};

    ['CreatedNode', 'ModifiedNode', 'DeletedNode'].forEach(function (x) {
      if (an[x]) result.diffType = x;
    });

    if (!result.diffType) return null;

    an = an[result.diffType];

    result.entryType = an.LedgerEntryType;
    result.ledgerIndex = an.LedgerIndex;

    result.fields = $.extend({}, an.PreviousFields, an.NewFields, an.FinalFields);
    result.fieldsPrev = an.PreviousFields || {};
    result.fieldsNew = an.NewFields || {};
    result.fieldsFinal = an.FinalFields || {};

    return result;
  },

  /**
   * Takes a transaction and its metadata and returns the amount sent as:
   *
   * If XRP, value sent as String
   *
   * If not XRP,
      {
       value: value sent as String,
       currency: currency code of value sent
      }
    *
    * If unable to determine, returns undefined
    *
    * If the caller needs the issuer of sent currency as well, try tx.sendMax.issuer
   */
  getAmountSent: function (tx, meta) {
    var sender = tx.Account,
        difference = null,
        tmpDifference,
        cur = null,
        i,
        affectedNode,
        amtSent;

    if (tx.TransactionType === 'Payment') {
      if (meta.DeliveredAmount) {
        return meta.DeliveredAmount;
      }

      if (meta.AffectedNodes) {
        // Find the metadata node with entry type == 'RippleState'
        // and either HighLimit.issuer == [sender's account] or
        // LowLimit.issuer == [sender's account] and
        // Balance.currency == [currency of SendMax || Amount]
        if (tx.SendMax && tx.SendMax.currency) {
          for (i = 0; i < meta.AffectedNodes.length; i++) {
            affectedNode = meta.AffectedNodes[i];
            if (affectedNode.ModifiedNode && affectedNode.ModifiedNode.LedgerEntryType === 'RippleState' &&
              (affectedNode.ModifiedNode.FinalFields.HighLimit.issuer === sender ||
                affectedNode.ModifiedNode.FinalFields.LowLimit.issuer === sender) &&
              affectedNode.ModifiedNode.FinalFields.Balance.currency === tx.SendMax.currency) {
              // Calculate the difference before/after. If HighLimit.issuer == [sender's account] negate it.

              tmpDifference = affectedNode.ModifiedNode.PreviousFields.Balance.value - affectedNode.ModifiedNode.FinalFields.Balance.value;
              if (affectedNode.ModifiedNode.FinalFields.HighLimit.issuer === sender) tmpDifference *= -1;
              difference += tmpDifference;
              cur = affectedNode.ModifiedNode.FinalFields.Balance.currency;
            }
          }
        }

        if (difference === null) {
          // Find the metadata node with entry type == 'AccountRoot' and Account == [sender's account].
          for (i = 0; i < meta.AffectedNodes.length; i++) {
            affectedNode = meta.AffectedNodes[i];
            if (affectedNode.ModifiedNode && affectedNode.ModifiedNode.LedgerEntryType === 'AccountRoot' &&
              affectedNode.ModifiedNode.FinalFields && affectedNode.ModifiedNode.FinalFields.Account === sender) {
              // Calculate the difference minus the fee

              difference = affectedNode.ModifiedNode.PreviousFields.Balance - affectedNode.ModifiedNode.FinalFields.Balance - tx.Fee;
              break;
            }
          }
        }

        if (difference) {  // calculated and non-zero
          var diff = String(difference);
          amtSent = cur ? {value: diff, currency : cur} : diff;
        }

        else {
          amtSent = tx.Amount;
        }
      }
    }

    return amtSent;
  },

  /**
   * Convert transactions into a more useful (for our purposes) format.
   *
   * The main operation this function performs is to change the view on the
   * transaction from a neutral view to a subjective view specific to our
   * account.
   *
   * For example, rather than having a sender and receiver, the transaction has
   * a counterparty and a flag whether it is incoming or outgoing.
   *
   * processTxn returns main purpose of transaction and side effects.
   *
   * Main purpose
   *  Real transaction names
   *  - Payment (sent/received/exchange)
   *  - TrustSet (trusting/trusted)
   *  - OfferCreate (offernew)
   *  - OfferCancel (offercancel)
   *
   *  Virtual transaction names
   *  - Failed
   *  - Rippling
   *
   * Side effects
   *  - balance_change
   *  - Trust (trust_create_local, trust_create_remote, trust_change_local,
   *          trust_change_remote, trust_change_balance, trust_change_no_ripple)
   *  - Offer (offer_created, offer_funded, offer_partially_funded,
   *          offer_cancelled, offer_bought)
   */
  processTxn: function (tx, meta, account) {
    try {
      return JsonRewriter._processTxn(tx, meta, account);
    } catch (err) {
      var transaction = {};
      transaction.type = 'error';
      if (tx && 'object' === typeof tx) {
        transaction.hash = tx.hash;
        transaction.date = ripple.utils.toTimestamp(tx.date);
        transaction.dateRaw = tx.date;
      } else {
        transaction.hash = 'unknown';
        transaction.date = new Date().getTime();
        transaction.dateRaw = ripple.utils.fromTimestamp(fromTimestamp);
      }
      return {transaction: transaction, error: err};
    }
  },

  _processTxn: function (tx, meta, account) {
    var obj = {},
        hasFee = false;

    // Currency balances that have been affected by the transaction
    var affectedCurrencies = [];

    // Main transaction
    if (tx.Account === account
        || (tx.Destination && tx.Destination === account)
        || (tx.LimitAmount && tx.LimitAmount.issuer === account)) {

      var transaction = {};

      if ('tesSUCCESS' === meta.TransactionResult) {
        switch (tx.TransactionType) {
          case 'Payment':

            var amount;
            // If partial payment, use delivered amount
            if(meta.DeliveredAmount){
              amount = ripple.Amount.from_json(meta.DeliveredAmount);
            }
            else {
              amount = ripple.Amount.from_json(tx.Amount);
            }

            if (tx.Account === account) {
              if (tx.Destination === account) {
                transaction.type = 'exchange';
                transaction.spent = ripple.Amount.from_json(tx.SendMax);
              }
              else {
                transaction.type = 'sent';
                transaction.counterparty = tx.Destination;
              }
            }
            else {
              transaction.type = 'received';
              transaction.counterparty = tx.Account;
            }

            if (tx.DestinationTag) {
                transaction.dt = tx.DestinationTag;
            }

            if (typeof tx.SendMax === 'object') transaction.sendMax = tx.SendMax;

            var amtSent = JsonRewriter.getAmountSent(tx, meta);
            if (amtSent) transaction.amountSent = amtSent;

            transaction.amount = amount;
            transaction.currency = amount.currency().to_human();
            break;

          case 'TrustSet':
            transaction.type = tx.Account === account ? 'trusting' : 'trusted';
            transaction.counterparty = tx.Account === account ? tx.LimitAmount.issuer : tx.Account;
            transaction.amount = ripple.Amount.from_json(tx.LimitAmount);
            transaction.currency = tx.LimitAmount.currency;
            break;

          case 'OfferCreate':
            transaction.type = 'offernew';
            transaction.pays = ripple.Amount.from_json(tx.TakerPays);
            transaction.gets = ripple.Amount.from_json(tx.TakerGets);
            transaction.sell = tx.Flags & ripple.Transaction.flags.OfferCreate.Sell;
            break;

          case 'OfferCancel':
            transaction.type = 'offercancel';
            transaction.sell = ripple.Transaction.flags.OfferCreate.Sell;
            break;

          case 'AccountSet':
            // Ignore empty accountset transactions. (Used to sync sequence numbers)
            if (meta.AffectedNodes.length === 1 && _.size(meta.AffectedNodes[0].ModifiedNode.PreviousFields) === 2)
              break;

            transaction.type = 'accountset';
            break;

          default:
            // console.log('Unknown transaction type: \''+tx.TransactionType+'\'', tx);
        }

        if (tx.Flags) {
          transaction.flags = tx.Flags;
        }
      } else {
        transaction.type = 'failed';
      }

      if (!$.isEmptyObject(transaction)) {
        obj.transaction = transaction;
      }
    }

    // Side effects
    if ('tesSUCCESS' === meta.TransactionResult) {
      meta.AffectedNodes.forEach(function (n) {
        var node = JsonRewriter.processAnode(n);
        var feeEff;
        var effect = {};

        // AccountRoot - Current account node
        if (node.entryType === 'AccountRoot' && node.fields.Account === account) {
          obj.accountRoot = node.fields;

          // This is the first transaction on current account
          if (node.diffType === 'CreatedNode') {
            effect.type = 'balance_change';
            effect.amount = ripple.Amount.from_json(node.fields.Balance);
            effect.balance = effect.amount;

            obj.balance_changer = effect.balance_changer = true;
            affectedCurrencies.push('XRP');
          }

          // Balance has been changed
          else if (node.fieldsPrev.Balance) {
            var balance = ripple.Amount.from_json(node.fields.Balance);

            // Fee
            if (tx.Account === account && tx.Fee) {
              feeEff = {
                type: 'fee',
                amount: ripple.Amount.from_json(tx.Fee).negate(),
                balance: balance
              };
            }

            // Updated XRP Balance
            if (tx.Fee != node.fieldsPrev.Balance - node.fields.Balance) {
              if (feeEff)
                balance = balance.subtract(feeEff.amount);

              effect.type = 'balance_change';
              effect.amount = balance.subtract(node.fieldsPrev.Balance);
              effect.balance = balance;

              // balance_changer is set to true if the transaction / effect has changed one of the account balances
              obj.balance_changer = effect.balance_changer = true;
              affectedCurrencies.push('XRP');
            }
          }
        }

        // RippleState - Ripple Lines
        if (node.entryType === 'RippleState'
            && (node.fields.HighLimit.issuer === account || node.fields.LowLimit.issuer === account)) {

          var high = node.fields.HighLimit;
          var low = node.fields.LowLimit;
          var viewHigh = high.issuer === account;

          // old method, because sometimes there is no transaction
          var which = viewHigh ? 'HighNoRipple' : 'LowNoRipple';

          if (obj.transaction) {
            which = obj.transaction.type === 'trusting' ? (viewHigh ? 'HighNoRipple' : 'LowNoRipple') :
                                                            (viewHigh ? 'LowNoRipple' : 'HighNoRipple');
          }

          // New trust line
          if (node.diffType === 'CreatedNode') {
            effect.limit = ripple.Amount.from_json(viewHigh ? high : low);
            effect.limit_peer = ripple.Amount.from_json(viewHigh ? low : high);

            if (obj.transaction) {
              effect.type = obj.transaction.type === 'trusting' ? 'trust_create_local' : 'trust_create_remote';
            } else {
              if ((high.value > 0 && high.issuer === account)
                   || (low.value > 0 && low.issuer === account)) {
                effect.type = 'trust_create_local';
              } else {
                effect.type = 'trust_create_remote';
              }
            }
          }

          // Modified trust line
          else if (node.diffType === 'ModifiedNode' || node.diffType === 'DeletedNode') {
            var highPrev = node.fieldsPrev.HighLimit;
            var lowPrev = node.fieldsPrev.LowLimit;

            // Trust Balance change
            if (node.fieldsPrev.Balance) {
              effect.type = 'trust_change_balance';

              var issuer =  node.fields.Balance.value > 0 || node.fieldsPrev.Balance.value > 0
                  ? high.issuer : low.issuer;

              effect.amount = high.issuer === account
                  ? effect.amount = ripple.Amount.from_json(
                  node.fieldsPrev.Balance.value
                      + '/' + node.fieldsPrev.Balance.currency
                      + '/' + issuer).subtract(node.fields.Balance)
                  : effect.amount = ripple.Amount.from_json(
                  node.fields.Balance.value
                      + '/' + node.fields.Balance.currency
                      + '/' + issuer).subtract(node.fieldsPrev.Balance);

              obj.balance_changer = effect.balance_changer = true;
              affectedCurrencies.push(high.currency.toUpperCase());
            }

            // Trust Limit change
            else if (highPrev || lowPrev) {
              if (high.issuer === account) {
                effect.limit = ripple.Amount.from_json(high);
                effect.limit_peer = ripple.Amount.from_json(low);
              } else {
                effect.limit = ripple.Amount.from_json(low);
                effect.limit_peer = ripple.Amount.from_json(high);
              }

              if (highPrev) {
                effect.prevLimit = ripple.Amount.from_json(highPrev);
                effect.type = high.issuer === account ? 'trust_change_local' : 'trust_change_remote';
              }
              else if (lowPrev) {
                effect.prevLimit = ripple.Amount.from_json(lowPrev);
                effect.type = high.issuer === account ? 'trust_change_remote' : 'trust_change_local';
              }
            }

            // Trust flag change (effect gets this type only if nothing else but flags has been changed)
            else if (node.fieldsPrev.Flags) {
              // Account set a noRipple flag
              if (node.fields.Flags & ripple.Remote.flags.state[which] &&
                  !(node.fieldsPrev.Flags & ripple.Remote.flags.state[which])) {
                effect.type = 'trust_change_no_ripple';
              }

              // Account removed the noRipple flag
              else if (node.fieldsPrev.Flags & ripple.Remote.flags.state[which] &&
                  !(node.fields.Flags & ripple.Remote.flags.state[which])) {
                effect.type = 'trust_change_no_ripple';
              }

              if (effect.type)
                effect.flags = node.fields.Flags;
            }
          }

          if (!$.isEmptyObject(effect)) {
            effect.counterparty = high.issuer === account ? low.issuer : high.issuer;
            effect.currency = high.currency;
            effect.balance = high.issuer === account
                ? ripple.Amount.from_json(node.fields.Balance).negate(true)
                : ripple.Amount.from_json(node.fields.Balance);

            if (effect.balance.is_zero() && effect.balance.is_negative()) {
              effect.balance = effect.balance.negate(true);
            }

            if (obj.transaction && obj.transaction.type === 'trust_change_balance') {
              obj.transaction.balance = effect.balance;
            }

            // noRipple flag
            if (node.fields.Flags & ripple.Remote.flags.state[which]) {
              effect.noRipple = true;
            }
          }
        }

        // Offer
        else if (node.entryType === 'Offer') {
          // For new and cancelled offers we use 'fields'
          var fieldSet = node.fields;

          // Current account offer
          if (node.fields.Account === account) {
            // Partially funded offer [and deleted.. no more funds]
            /* Offer has been partially funded and deleted (because of the luck of funds)
             if the node is deleted and the TakerGets/TakerPays field has been changed */
            if (node.diffType === 'ModifiedNode' ||
                (node.diffType === 'DeletedNode'
                    && node.fieldsPrev.TakerGets
                    && !ripple.Amount.from_json(node.fieldsFinal.TakerGets).is_zero())) {
              effect.type = 'offer_partially_funded';

              if (node.diffType !== 'DeletedNode') {
                effect.remaining = ripple.Amount.from_json(node.fields.TakerGets);
              }
              else {
                effect.cancelled = true;
              }
            }
            else {
              // New / Funded / Cancelled offer
              effect.type = node.diffType === 'CreatedNode'
                  ? 'offer_created'
                  : node.fieldsPrev.TakerPays
                  ? 'offer_funded'
                  : 'offer_cancelled';

              // For funded offers we use 'fieldsPrev'.
              if (effect.type === 'offer_funded')
                fieldSet = node.fieldsPrev;

              // We don't count cancelling an offer as a side effect if it's
              // already the primary effect of the transaction.
              if (effect.type === 'offer_cancelled' &&
                  obj.transaction &&
                  obj.transaction.type === 'offercancel') {
                // Fill in remaining information about offer
                obj.transaction.gets = fieldSet.TakerGets;
                obj.transaction.pays = fieldSet.TakerPays;
              }
            }

            effect.seq = +node.fields.Sequence;
          }

          // Another account offer. We care about it only if our transaction changed the offer amount (we bought currency)
          else if (tx.Account === account && !$.isEmptyObject(node.fieldsPrev) // Offer is unfunded if node.fieldsPrev is empty
            && !$.isEmptyObject(node.fieldsPrev.TakerGets) && !$.isEmptyObject(node.fieldsPrev.TakerPays)) { // TakerGets or TakerPays might not be there if the change is smaller then a drop
            effect.type = 'offer_bought';
          }

          if (effect.type) {
            effect.gets = ripple.Amount.from_json(fieldSet.TakerGets);
            effect.pays = ripple.Amount.from_json(fieldSet.TakerPays);

            if ('offer_partially_funded' === effect.type || 'offer_bought' === effect.type) {
              effect.got = ripple.Amount.from_json(node.fieldsPrev.TakerGets).subtract(node.fields.TakerGets);
              effect.paid = ripple.Amount.from_json(node.fieldsPrev.TakerPays).subtract(node.fields.TakerPays);
            }

            effect.price = getPrice(effect, tx.date);
            effect.straightPrice = getStraightPrice(effect, tx.date);
            effect.invStraightPrice = getInvStraightPrice(effect, tx.date);

            // Flags
            if (node.fields.Flags) {
              effect.flags = node.fields.Flags;
              effect.sell = node.fields.Flags & ripple.Remote.flags.offer.Sell;
            }
          }
        }

        if (!$.isEmptyObject(effect)) {
          if (node.diffType === 'DeletedNode') {
            effect.deleted = true;
          }

          if (!obj.effects) obj.effects = [];
          obj.effects.push(effect);
        }

        // Fee effect
        if (feeEff) {
          hasFee = true;
          if (!obj.effects) obj.effects = [];
          obj.effects.push(feeEff);
        }
      });
    }

    // Balance after the transaction
    if (obj.accountRoot && obj.transaction && 'undefined' === typeof obj.transaction.balance) {
      obj.transaction.balance = ripple.Amount.from_json(obj.accountRoot.Balance);
    }

    if ($.isEmptyObject(obj))
      return;

    // If the transaction didn't wind up cancelling an offer
    if (tx.TransactionType === 'OfferCancel' && obj.transaction &&
      (!obj.transaction.gets || !obj.transaction.pays)) {
      return;
    }

    // Rippling transaction
    if (isRippling(obj.effects)) {
      if (!obj.transaction) {
        obj.transaction = {};
      }
      obj.transaction.type = 'rippling';
    }

    obj.tx_type = tx.TransactionType;
    obj.tx_result = meta.TransactionResult;
    obj.fee = ripple.Amount.from_json(hasFee ? tx.Fee : 0);
    obj.date = tx.date;
    obj.dateRaw = tx.date;
    obj.hash = tx.hash;
    obj.affectedCurrencies = affectedCurrencies || [];
    obj.ledger_index = tx.ledger_index;

    return obj;
  }
};

// returns the raw address after removing any parameters
function stripRippleAddress(addr) {
  if(typeof(addr)=='string')
  {
    var index=addr.indexOf('?');
    if (index >= 0)
    {
      return(addr.slice(0, index));
    }
  }
  return addr;
};

//returns the destination tag of an address if there is one
function getDestTagFromAddress(addr) {
  if(typeof addr === 'undefined') return undefined;
  var index=addr.indexOf('?');
  if(index >= 0)
  {
    addr=addr.slice(index,addr.length);
    index=addr.indexOf('dt=');
    if(index >= 0)
    {
      addr=addr.slice(index+3,addr.length);
      index=addr.indexOf('&');
      if(index > 0) return( addr.slice(0, index) );
      else return addr;
    }
    index=addr.indexOf('d=');
    if(index>=0)
    {
      addr=addr.slice(index+2,addr.length);
      index=addr.indexOf('&');
      if(index > 0) return( addr.slice(0, index) );
      else return addr;
    }
  }
  return undefined;
};

function isRippleName(str) {
  var nameRegex = /^~[a-zA-Z0-9]([\-]?[a-zA-Z0-9]){0,19}$/;
  return nameRegex.test(str);
};

function isGatehubName(str) {
  var nameRegex = /^\+[a-zA-Z0-9]([\-]?[a-zA-Z0-9]){0,19}$/;
  return nameRegex.test(str);
};

function isBIC(str) {
  var re = /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/i;
  return re.test(str);
};

function isEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

function isPayString(email) {
    var re = /^[a-z0-9][a-z0-9\.\-]{0,62}[a-z0-9]\$.*(\w+\.\w+)$/;
    return re.test(email);
  };

function isGatehubWallet(value) {
  if (value && (!isNaN(parseFloat(value)) && isFinite(value) && value > 10000000 && value < 999999999 )) {
    return true;
  } else {
    return false;
  }
};

function calculateTotalFee(amount, vault) {
  var relativeFee = new Decimal(amount).times(new Decimal(vault.fee_withdrawal_relative));
  if (new Decimal(vault.fee_withdrawal_max).equals(0) == false && relativeFee.gt(new Decimal(vault.fee_withdrawal_max))) {
    relativeFee = new Decimal(vault.fee_withdrawal_max);
  }
  if (new Decimal(vault.fee_withdrawal_min).equals(0) == false && relativeFee.lt(new Decimal(vault.fee_withdrawal_min))) {
    relativeFee = new Decimal(vault.fee_withdrawal_min);
  }
  var totalFee = relativeFee.plus(new Decimal(vault.fee_withdrawal_absolute));

  return totalFee.toDecimalPlaces(vault.scale, Decimal.ROUND_UP);
};

/*
calculateTotal(amount: decimal.Decimal, scale: number): decimal.Decimal {
    var relativeFee = new Decimal(amount).times(new Decimal(this.relative));
    if (this.max.equals(0) == false && relativeFee.gt(this.max)) {
      relativeFee = this.max;
    }
    if (this.min.equals(0) == false && relativeFee.lt(this.min)) {
      relativeFee = this.min;
    }
    var totalFee = relativeFee.plus(new Decimal(this.absolute));
    return totalFee.toDecimalPlaces(scale, Decimal.ROUND_UP);
  }
*/

// PDF needs to be base64 encoded
const downloadPDF = (base64pdf, name) => {
    const fileURL = 'data:application/pdf;base64,' + base64pdf;
    const link = document.createElement('a');
    link.href = fileURL;
    link.download = name + '.pdf';
    link.click();
  };

/* decimal.js v5.0.3 https://github.com/MikeMcl/decimal.js/LICENCE */
!function(n){"use strict";function e(n){var e,i,t,r=n.length-1,s="",o=n[0];if(r>0){for(s+=o,e=1;r>e;e++)t=n[e]+"",i=Un-t.length,i&&(s+=l(i)),s+=t;o=n[e],t=o+"",i=Un-t.length,i&&(s+=l(i))}else if(0===o)return"0";for(;o%10===0;)o/=10;return s+o}function i(n,e,i){if(n!==~~n||e>n||n>i)throw Error(On+n)}function t(n,e,i,t){var r,s,o,u;for(s=n[0];s>=10;s/=10)--e;return--e<0?(e+=Un,r=0):(r=Math.ceil((e+1)/Un),e%=Un),s=Dn(10,Un-e),u=n[r]%s|0,null==t?3>e?(0==e?u=u/100|0:1==e&&(u=u/10|0),o=4>i&&99999==u||i>3&&49999==u||5e4==u||0==u):o=(4>i&&u+1==s||i>3&&u+1==s/2)&&(n[r+1]/s/100|0)==Dn(10,e-2)-1||(u==s/2||0==u)&&0==(n[r+1]/s/100|0):4>e?(0==e?u=u/1e3|0:1==e?u=u/100|0:2==e&&(u=u/10|0),o=(t||4>i)&&9999==u||!t&&i>3&&4999==u):o=((t||4>i)&&u+1==s||!t&&i>3&&u+1==s/2)&&(n[r+1]/s/1e3|0)==Dn(10,e-3)-1,o}function r(n,e,i){for(var t,r,s=[0],o=0,u=n.length;u>o;){for(r=s.length;r--;)s[r]*=e;for(s[0]+=Nn.indexOf(n.charAt(o++)),t=0;t<s.length;t++)s[t]>i-1&&(void 0===s[t+1]&&(s[t+1]=0),s[t+1]+=s[t]/i|0,s[t]%=i)}return s.reverse()}function s(n,e){var i,t,r=e.d.length;32>r?(i=Math.ceil(r/3),t=Math.pow(4,-i).toString()):(i=16,t="2.3283064365386962890625e-10"),n.precision+=i,e=E(n,1,e.times(t),new n(wn));for(var s=i;s--;){var o=e.times(e);e=o.times(o).minus(o).times(8).plus(wn)}return n.precision-=i,e}function o(n,e,i,t){var r,s,o,u,c,f,h,a,l,d=n.constructor;n:if(null!=e){if(a=n.d,!a)return n;for(r=1,u=a[0];u>=10;u/=10)r++;if(s=e-r,0>s)s+=Un,o=e,h=a[l=0],c=h/Dn(10,r-o-1)%10|0;else if(l=Math.ceil((s+1)/Un),u=a.length,l>=u){if(!t)break n;for(;u++<=l;)a.push(0);h=c=0,r=1,s%=Un,o=s-Un+1}else{for(h=u=a[l],r=1;u>=10;u/=10)r++;s%=Un,o=s-Un+r,c=0>o?0:Fn(h/Dn(10,r-o-1)%10)}if(t=t||0>e||void 0!==a[l+1]||(0>o?h:h%Dn(10,r-o-1)),f=4>i?(c||t)&&(0==i||i==(n.s<0?3:2)):c>5||5==c&&(4==i||t||6==i&&(s>0?o>0?h/Dn(10,r-o):0:a[l-1])%10&1||i==(n.s<0?8:7)),1>e||!a[0])return a.length=0,f?(e-=n.e+1,a[0]=Dn(10,(Un-e%Un)%Un),n.e=-e||0):a[0]=n.e=0,n;if(0==s?(a.length=l,u=1,l--):(a.length=l+1,u=Dn(10,Un-s),a[l]=o>0?(h/Dn(10,r-o)%Dn(10,o)|0)*u:0),f)for(;;){if(0==l){for(s=1,o=a[0];o>=10;o/=10)s++;for(o=a[0]+=u,u=1;o>=10;o/=10)u++;s!=u&&(n.e++,a[0]==Ln&&(a[0]=1));break}if(a[l]+=u,a[l]!=Ln)break;a[l--]=0,u=1}for(s=a.length;0===a[--s];)a.pop()}return yn&&(n.e>d.maxE?(n.d=null,n.e=NaN):n.e<d.minE&&(n.e=0,n.d=[0])),n}function u(n,i,t){if(!n.isFinite())return v(n);var r,s=n.e,o=e(n.d),u=o.length;return i?(t&&(r=t-u)>0?o=o.charAt(0)+"."+o.slice(1)+l(r):u>1&&(o=o.charAt(0)+"."+o.slice(1)),o=o+(n.e<0?"e":"e+")+n.e):0>s?(o="0."+l(-s-1)+o,t&&(r=t-u)>0&&(o+=l(r))):s>=u?(o+=l(s+1-u),t&&(r=t-s-1)>0&&(o=o+"."+l(r))):((r=s+1)<u&&(o=o.slice(0,r)+"."+o.slice(r)),t&&(r=t-u)>0&&(s+1===u&&(o+="."),o+=l(r))),o}function c(n,e){for(var i=1,t=n[0];t>=10;t/=10)i++;return i+e*Un-1}function f(n,e,i){if(e>kn)throw yn=!0,i&&(n.precision=i),Error(qn);return o(new n(xn),e,1,!0)}function h(n,e,i){if(e>Tn)throw Error(qn);return o(new n(bn),e,i,!0)}function a(n){var e=n.length-1,i=e*Un+1;if(e=n[e]){for(;e%10==0;e/=10)i--;for(e=n[0];e>=10;e/=10)i++}return i}function l(n){for(var e="";n--;)e+="0";return e}function d(n,e,i,t){var r,s=new n(wn),o=Math.ceil(t/Un+4);for(yn=!1;;){if(i%2&&(s=s.times(e),A(s.d,o)&&(r=!0)),i=Fn(i/2),0===i){i=s.d.length-1,r&&0===s.d[i]&&++s.d[i];break}e=e.times(e),A(e.d,o)}return yn=!0,s}function g(n){return 1&n.d[n.d.length-1]}function p(n,e,i){for(var t,r=new n(e[0]),s=0;++s<e.length;){if(t=new n(e[s]),!t.s){r=t;break}r[i](t)&&(r=t)}return r}function w(n,i){var r,s,u,c,f,h,a,l=0,d=0,g=0,p=n.constructor,w=p.rounding,m=p.precision;if(!n.d||!n.d[0]||n.e>17)return new p(n.d?n.d[0]?n.s<0?0:1/0:wn:n.s?n.s<0?0:n:NaN);for(null==i?(yn=!1,a=m):a=i,h=new p(.03125);n.e>-2;)n=n.times(h),g+=5;for(s=Math.log(Dn(2,g))/Math.LN10*2+5|0,a+=s,r=c=f=new p(wn),p.precision=a;;){if(c=o(c.times(n),a,1),r=r.times(++d),h=f.plus(In(c,r,a,1)),e(h.d).slice(0,a)===e(f.d).slice(0,a)){for(u=g;u--;)f=o(f.times(f),a,1);if(null!=i)return p.precision=m,f;if(!(3>l&&t(f.d,a-s,w,l)))return o(f,p.precision=m,w,yn=!0);p.precision=a+=10,r=c=h=new p(wn),d=0,l++}f=h}}function m(n,i){var r,s,u,c,h,a,l,d,g,p,w,v=1,N=10,x=n,b=x.d,E=x.constructor,M=E.rounding,y=E.precision;if(x.s<0||!b||!b[0]||!x.e&&1==b[0]&&1==b.length)return new E(b&&!b[0]?-1/0:1!=x.s?NaN:b?0:x);if(null==i?(yn=!1,g=y):g=i,E.precision=g+=N,r=e(b),s=r.charAt(0),!(Math.abs(c=x.e)<15e14))return d=f(E,g+2,y).times(c+""),x=m(new E(s+"."+r.slice(1)),g-N).plus(d),E.precision=y,null==i?o(x,y,M,yn=!0):x;for(;7>s&&1!=s||1==s&&r.charAt(1)>3;)x=x.times(n),r=e(x.d),s=r.charAt(0),v++;for(c=x.e,s>1?(x=new E("0."+r),c++):x=new E(s+"."+r.slice(1)),p=x,l=h=x=In(x.minus(wn),x.plus(wn),g,1),w=o(x.times(x),g,1),u=3;;){if(h=o(h.times(w),g,1),d=l.plus(In(h,new E(u),g,1)),e(d.d).slice(0,g)===e(l.d).slice(0,g)){if(l=l.times(2),0!==c&&(l=l.plus(f(E,g+2,y).times(c+""))),l=In(l,new E(v),g,1),null!=i)return E.precision=y,l;if(!t(l.d,g-N,M,a))return o(l,E.precision=y,M,yn=!0);E.precision=g+=N,d=h=x=In(p.minus(wn),p.plus(wn),g,1),w=o(x.times(x),g,1),u=a=1}l=d,u+=2}}function v(n){return String(n.s*n.s/0)}function N(n,e){var i,t,r;for((i=e.indexOf("."))>-1&&(e=e.replace(".","")),(t=e.search(/e/i))>0?(0>i&&(i=t),i+=+e.slice(t+1),e=e.substring(0,t)):0>i&&(i=e.length),t=0;48===e.charCodeAt(t);t++);for(r=e.length;48===e.charCodeAt(r-1);--r);if(e=e.slice(t,r)){if(r-=t,n.e=i=i-t-1,n.d=[],t=(i+1)%Un,0>i&&(t+=Un),r>t){for(t&&n.d.push(+e.slice(0,t)),r-=Un;r>t;)n.d.push(+e.slice(t,t+=Un));e=e.slice(t),t=Un-e.length}else t-=r;for(;t--;)e+="0";n.d.push(+e),yn&&(n.e>n.constructor.maxE?(n.d=null,n.e=NaN):n.e<n.constructor.minE&&(n.e=0,n.d=[0]))}else n.e=0,n.d=[0];return n}function x(n,e){var i,t,s,o,u,f,h,a,l;if("Infinity"===e||"NaN"===e)return+e||(n.s=NaN),n.e=NaN,n.d=null,n;if(Pn.test(e))i=16,e=e.toLowerCase();else if(Zn.test(e))i=2;else{if(!Rn.test(e))throw Error(On+e);i=8}for(o=e.search(/p/i),o>0?(h=+e.slice(o+1),e=e.substring(2,o)):e=e.slice(2),o=e.indexOf("."),u=o>=0,t=n.constructor,u&&(e=e.replace(".",""),f=e.length,o=f-o,s=d(t,new t(i),o,2*o)),a=r(e,i,Ln),l=a.length-1,o=l;0===a[o];--o)a.pop();return 0>o?new t(0*n.s):(n.e=c(a,l),n.d=a,yn=!1,u&&(n=In(n,s,4*f)),h&&(n=n.times(Math.abs(h)<54?Math.pow(2,h):En.pow(2,h))),yn=!0,n)}function b(n,e){var i,t=e.d.length;if(3>t)return E(n,2,e,e);i=1.4*Math.sqrt(t),i=i>16?16:0|i,e=e.times(Math.pow(5,-i)),e=E(n,2,e,e);for(var r,s=new n(5),o=new n(16),u=new n(20);i--;)r=e.times(e),e=e.times(s.plus(r.times(o.times(r).minus(u))));return e}function E(n,e,i,t,r){var s,o,u,c,f=1,h=n.precision,a=Math.ceil(h/Un);for(yn=!1,c=i.times(i),u=new n(t);;){if(o=In(u.times(c),new n(e++*e++),h,1),u=r?t.plus(o):t.minus(o),t=In(o.times(c),new n(e++*e++),h,1),o=u.plus(t),void 0!==o.d[a]){for(s=a;o.d[s]===u.d[s]&&s--;);if(-1==s)break}s=u,u=t,t=o,o=s,f++}return yn=!0,o.d.length=a+1,o}function M(n,e){var i,t=e.s<0,r=h(n,n.precision,1),s=r.times(pn);if(e=e.abs(),e.lte(s))return gn=t?4:1,e;if(i=e.divToInt(r),i.isZero())gn=t?3:2;else{if(e=e.minus(i.times(r)),e.lte(s))return gn=g(i)?t?2:3:t?4:1,e;gn=g(i)?t?1:4:t?3:2}return e.minus(r).abs()}function y(n,e,t,s){var o,c,f,h,a,l,d,g,p,w=n.constructor,m=void 0!==t;if(m?(i(t,1,vn),void 0===s?s=w.rounding:i(s,0,8)):(t=w.precision,s=w.rounding),n.isFinite()){for(d=u(n),f=d.indexOf("."),m?(o=2,16==e?t=4*t-3:8==e&&(t=3*t-2)):o=e,f>=0&&(d=d.replace(".",""),p=new w(wn),p.e=d.length-f,p.d=r(u(p),10,o),p.e=p.d.length),g=r(d,10,o),c=a=g.length;0==g[--a];)g.pop();if(g[0]){if(0>f?c--:(n=new w(n),n.d=g,n.e=c,n=In(n,p,t,s,0,o),g=n.d,c=n.e,l=ln),f=g[t],h=o/2,l=l||void 0!==g[t+1],l=4>s?(void 0!==f||l)&&(0===s||s===(n.s<0?3:2)):f>h||f===h&&(4===s||l||6===s&&1&g[t-1]||s===(n.s<0?8:7)),g.length=t,l)for(;++g[--t]>o-1;)g[t]=0,t||(++c,g.unshift(1));for(a=g.length;!g[a-1];--a);for(f=0,d="";a>f;f++)d+=Nn.charAt(g[f]);if(m){if(a>1)if(16==e||8==e){for(f=16==e?4:3,--a;a%f;a++)d+="0";for(g=r(d,o,e),a=g.length;!g[a-1];--a);for(f=1,d="1.";a>f;f++)d+=Nn.charAt(g[f])}else d=d.charAt(0)+"."+d.slice(1);d=d+(0>c?"p":"p+")+c}else if(0>c){for(;++c;)d="0"+d;d="0."+d}else if(++c>a)for(c-=a;c--;)d+="0";else a>c&&(d=d.slice(0,c)+"."+d.slice(c))}else d=m?"0p+0":"0";d=(16==e?"0x":2==e?"0b":8==e?"0o":"")+d}else d=v(n);return n.s<0?"-"+d:d}function A(n,e){return n.length>e?(n.length=e,!0):void 0}function O(n){return new this(n).abs()}function q(n){return new this(n).acos()}function F(n){return new this(n).acosh()}function D(n,e){return new this(n).plus(e)}function Z(n){return new this(n).asin()}function P(n){return new this(n).asinh()}function R(n){return new this(n).atan()}function S(n){return new this(n).atanh()}function L(n,e){n=new this(n),e=new this(e);var i,t=this.precision,r=this.rounding,s=t+4;return n.s&&e.s?n.d||e.d?!e.d||n.isZero()?(i=e.s<0?h(this,t,r):new this(0),i.s=n.s):!n.d||e.isZero()?(i=h(this,s,1).times(pn),i.s=n.s):e.s<0?(this.precision=s,this.rounding=1,i=this.atan(In(n,e,s,1)),e=h(this,s,1),this.precision=t,this.rounding=r,i=n.s<0?i.minus(e):i.plus(e)):i=this.atan(In(n,e,s,1)):(i=h(this,s,1).times(e.s>0?.25:.75),i.s=n.s):i=new this(NaN),i}function U(n){return new this(n).cbrt()}function _(n){return o(n=new this(n),n.e+1,2)}function k(n){if(!n||"object"!=typeof n)throw Error(An+"Object expected");var e,i,t,r=["precision",1,vn,"rounding",0,8,"toExpNeg",-mn,0,"toExpPos",0,mn,"maxE",0,mn,"minE",-mn,0,"modulo",0,9];for(e=0;e<r.length;e+=3)if(void 0!==(t=n[i=r[e]])){if(!(Fn(t)===t&&t>=r[e+1]&&t<=r[e+2]))throw Error(On+i+": "+t);this[i]=t}if(n.hasOwnProperty(i="crypto"))if(void 0===(t=n[i]))this[i]=t;else{if(t!==!0&&t!==!1&&0!==t&&1!==t)throw Error(On+i+": "+t);this[i]=!(!t||!Mn||!Mn.getRandomValues&&!Mn.randomBytes)}return this}function T(n){return new this(n).cos()}function C(n){return new this(n).cosh()}function I(n){function e(n){var i,t,r,s=this;if(!(s instanceof e))return new e(n);if(s.constructor=e,n instanceof e)return s.s=n.s,s.e=n.e,void(s.d=(n=n.d)?n.slice():n);if(r=typeof n,"number"===r){if(0===n)return s.s=0>1/n?-1:1,s.e=0,void(s.d=[0]);if(0>n?(n=-n,s.s=-1):s.s=1,n===~~n&&1e7>n){for(i=0,t=n;t>=10;t/=10)i++;return s.e=i,void(s.d=[n])}return 0*n!==0?(n||(s.s=NaN),s.e=NaN,void(s.d=null)):N(s,n.toString())}if("string"!==r)throw Error(On+n);return 45===n.charCodeAt(0)?(n=n.slice(1),s.s=-1):s.s=1,Sn.test(n)?N(s,n):x(s,n)}return e.prototype=Cn,e.ROUND_UP=0,e.ROUND_DOWN=1,e.ROUND_CEIL=2,e.ROUND_FLOOR=3,e.ROUND_HALF_UP=4,e.ROUND_HALF_DOWN=5,e.ROUND_HALF_EVEN=6,e.ROUND_HALF_CEIL=7,e.ROUND_HALF_FLOOR=8,e.EUCLID=9,e.config=k,e.clone=I,e.abs=O,e.acos=q,e.acosh=F,e.add=D,e.asin=Z,e.asinh=P,e.atan=R,e.atanh=S,e.atan2=L,e.cbrt=U,e.ceil=_,e.cos=T,e.cosh=C,e.div=H,e.exp=B,e.floor=V,e.fromJSON=j,e.hypot=$,e.ln=J,e.log=W,e.log10=G,e.log2=z,e.max=K,e.min=Q,e.mod=X,e.mul=Y,e.pow=nn,e.random=en,e.round=tn,e.sign=rn,e.sin=sn,e.sinh=on,e.sqrt=un,e.sub=cn,e.tan=fn,e.tanh=hn,e.trunc=an,void 0===n&&(n=this,n={precision:n.precision,rounding:n.rounding,modulo:n.modulo,toExpNeg:n.toExpNeg,toExpPos:n.toExpPos,minE:n.minE,maxE:n.maxE,crypto:n.crypto}),e.config(n),e}function H(n,e){return new this(n).div(e)}function B(n){return new this(n).exp()}function V(n){return o(n=new this(n),n.e+1,3)}function j(n){var e,i,t,s;if("string"!=typeof n||!n)throw Error(On+n);if(t=n.length,s=Nn.indexOf(n.charAt(0)),1===t)return new this(s>81?[-1/0,1/0,NaN][s-82]:s>40?-(s-41):s);if(64&s)i=16&s,e=i?(7&s)-3:(15&s)-7,t=1;else{if(2===t)return s=88*s+Nn.indexOf(n.charAt(1)),new this(s>=2816?-(s-2816)-41:s+41);if(i=32&s,!(31&s))return n=r(n.slice(1),88,10).join(""),new this(i?"-"+n:n);e=15&s,t=e+1,e=1===e?Nn.indexOf(n.charAt(1)):2===e?88*Nn.indexOf(n.charAt(1))+Nn.indexOf(n.charAt(2)):+r(n.slice(1,t),88,10).join(""),16&s&&(e=-e)}return n=r(n.slice(t),88,10).join(""),e=e-n.length+1,n=n+"e"+e,new this(i?"-"+n:n)}function $(){var n,e,i=new this(0);for(yn=!1,n=0;n<arguments.length;)if(e=new this(arguments[n++]),e.d)i.d&&(i=i.plus(e.times(e)));else{if(e.s)return yn=!0,new this(1/0);i=e}return yn=!0,i.sqrt()}function J(n){return new this(n).ln()}function W(n,e){return new this(n).log(e)}function z(n){return new this(n).log(2)}function G(n){return new this(n).log(10)}function K(){return p(this,arguments,"lt")}function Q(){return p(this,arguments,"gt")}function X(n,e){return new this(n).mod(e)}function Y(n,e){return new this(n).mul(e)}function nn(n,e){return new this(n).pow(e)}function en(n){var e,t,r,s,o=0,u=new this(wn),c=[];if(void 0===n?n=this.precision:i(n,1,vn),r=Math.ceil(n/Un),this.crypto===!1)for(;r>o;)c[o++]=1e7*Math.random()|0;else if(Mn&&Mn.getRandomValues)for(e=Mn.getRandomValues(new Uint32Array(r));r>o;)s=e[o],s>=429e7?e[o]=Mn.getRandomValues(new Uint32Array(1))[0]:c[o++]=s%1e7;else if(Mn&&Mn.randomBytes){for(e=Mn.randomBytes(r*=4);r>o;)s=e[o]+(e[o+1]<<8)+(e[o+2]<<16)+((127&e[o+3])<<24),s>=214e7?Mn.randomBytes(4).copy(e,o):(c.push(s%1e7),o+=4);o=r/4}else{if(this.crypto)throw Error(An+"crypto unavailable");for(;r>o;)c[o++]=1e7*Math.random()|0}for(r=c[--o],n%=Un,r&&n&&(s=Dn(10,Un-n),c[o]=(r/s|0)*s);0===c[o];o--)c.pop();if(0>o)t=0,c=[0];else{for(t=-1;0===c[0];t-=Un)c.shift();for(r=1,s=c[0];s>=10;s/=10)r++;Un>r&&(t-=Un-r)}return u.e=t,u.d=c,u}function tn(n){return o(n=new this(n),n.e+1,this.rounding)}function rn(n){return n=new this(n),n.d?n.d[0]?n.s:0*n.s:n.s||NaN}function sn(n){return new this(n).sin()}function on(n){return new this(n).sinh()}function un(n){return new this(n).sqrt()}function cn(n,e){return new this(n).sub(e)}function fn(n){return new this(n).tan()}function hn(n){return new this(n).tanh()}function an(n){return o(n=new this(n),n.e+1,1)}var ln,dn,gn,pn,wn,mn=9e15,vn=1e9,Nn="0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ!#$%()*+,-./:;=?@[]^_`{|}~",xn="2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058",bn="3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789",En={precision:20,rounding:4,modulo:1,toExpNeg:-7,toExpPos:21,minE:-mn,maxE:mn,crypto:void 0},Mn="undefined"!=typeof crypto?crypto:null,yn=!0,An="[DecimalError] ",On=An+"Invalid argument: ",qn=An+"Precision limit exceeded",Fn=Math.floor,Dn=Math.pow,Zn=/^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i,Pn=/^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i,Rn=/^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i,Sn=/^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,Ln=1e7,Un=7,_n=9007199254740991,kn=xn.length-1,Tn=bn.length-1,Cn={};Cn.absoluteValue=Cn.abs=function(){var n=new this.constructor(this);return n.s<0&&(n.s=1),o(n)},Cn.ceil=function(){return o(new this.constructor(this),this.e+1,2)},Cn.comparedTo=Cn.cmp=function(n){var e,i,t,r,s=this,o=s.d,u=(n=new s.constructor(n)).d,c=s.s,f=n.s;if(!o||!u)return c&&f?c!==f?c:o===u?0:!o^0>c?1:-1:NaN;if(!o[0]||!u[0])return o[0]?c:u[0]?-f:0;if(c!==f)return c;if(s.e!==n.e)return s.e>n.e^0>c?1:-1;for(t=o.length,r=u.length,e=0,i=r>t?t:r;i>e;++e)if(o[e]!==u[e])return o[e]>u[e]^0>c?1:-1;return t===r?0:t>r^0>c?1:-1},Cn.cosine=Cn.cos=function(){var n,e,i=this,t=i.constructor;return i.d?i.d[0]?(n=t.precision,e=t.rounding,t.precision=n+Math.max(i.e,i.sd())+Un,t.rounding=1,i=s(t,M(t,i)),t.precision=n,t.rounding=e,o(2==gn||3==gn?i.neg():i,n,e,!0)):new t(wn):new t(NaN)},Cn.cubeRoot=Cn.cbrt=function(){var n,i,t,r,s,u,c,f,h,a,l=this,d=l.constructor;if(!l.isFinite()||l.isZero())return new d(l);for(yn=!1,u=l.s*Math.pow(l.s*l,1/3),u&&Math.abs(u)!=1/0?r=new d(u.toString()):(t=e(l.d),n=l.e,(u=(n-t.length+1)%3)&&(t+=1==u||-2==u?"0":"00"),u=Math.pow(t,1/3),n=Fn((n+1)/3)-(n%3==(0>n?-1:2)),u==1/0?t="5e"+n:(t=u.toExponential(),t=t.slice(0,t.indexOf("e")+1)+n),r=new d(t),r.s=l.s),c=(n=d.precision)+3;;)if(f=r,h=f.times(f).times(f),a=h.plus(l),r=In(a.plus(l).times(f),a.plus(h),c+2,1),e(f.d).slice(0,c)===(t=e(r.d)).slice(0,c)){if(t=t.slice(c-3,c+1),"9999"!=t&&(s||"4999"!=t)){(!+t||!+t.slice(1)&&"5"==t.charAt(0))&&(o(r,n+1,1),i=!r.times(r).times(r).eq(l));break}if(!s&&(o(f,n+1,0),f.times(f).times(f).eq(l))){r=f;break}c+=4,s=1}return yn=!0,o(r,n,d.rounding,i)},Cn.decimalPlaces=Cn.dp=function(){var n,e=this.d,i=NaN;if(e){if(n=e.length-1,i=(n-Fn(this.e/Un))*Un,n=e[n])for(;n%10==0;n/=10)i--;0>i&&(i=0)}return i},Cn.dividedBy=Cn.div=function(n){return In(this,new this.constructor(n))},Cn.dividedToIntegerBy=Cn.divToInt=function(n){var e=this,i=e.constructor;return o(In(e,new i(n),0,1,1),i.precision,i.rounding)},Cn.equals=Cn.eq=function(n){return 0===this.cmp(n)},Cn.floor=function(){return o(new this.constructor(this),this.e+1,3)},Cn.greaterThan=Cn.gt=function(n){return this.cmp(n)>0},Cn.greaterThanOrEqualTo=Cn.gte=function(n){var e=this.cmp(n);return 1==e||0===e},Cn.hyperbolicCosine=Cn.cosh=function(){var n,e,i,t,r,s=this,u=s.constructor,c=new u(wn);if(!s.isFinite())return new u(s.s?1/0:NaN);if(s.isZero())return c;i=u.precision,t=u.rounding,u.precision=i+Math.max(s.e,s.sd())+4,u.rounding=1,r=s.d.length,32>r?(n=Math.ceil(r/3),e=Math.pow(4,-n).toString()):(n=16,e="2.3283064365386962890625e-10"),s=E(u,1,s.times(e),new u(wn),!0);for(var f,h=n,a=new u(8);h--;)f=s.times(s),s=c.minus(f.times(a.minus(f.times(a))));return o(s,u.precision=i,u.rounding=t,!0)},Cn.hyperbolicSine=Cn.sinh=function(){var n,e,i,t,r=this,s=r.constructor;if(!r.isFinite()||r.isZero())return new s(r);if(e=s.precision,i=s.rounding,s.precision=e+Math.max(r.e,r.sd())+4,s.rounding=1,t=r.d.length,3>t)r=E(s,2,r,r,!0);else{n=1.4*Math.sqrt(t),n=n>16?16:0|n,r=r.times(Math.pow(5,-n)),r=E(s,2,r,r,!0);for(var u,c=new s(5),f=new s(16),h=new s(20);n--;)u=r.times(r),r=r.times(c.plus(u.times(f.times(u).plus(h))))}return s.precision=e,s.rounding=i,o(r,e,i,!0)},Cn.hyperbolicTangent=Cn.tanh=function(){var n,e,i=this,t=i.constructor;return i.isFinite()?i.isZero()?new t(i):(n=t.precision,e=t.rounding,t.precision=n+7,t.rounding=1,In(i.sinh(),i.cosh(),t.precision=n,t.rounding=e)):new t(i.s)},Cn.inverseCosine=Cn.acos=function(){var n,e=this,i=e.constructor,t=e.abs().cmp(wn),r=i.precision,s=i.rounding;return-1!==t?0===t?e.isNeg()?h(i,r,s):new i(0):new i(NaN):e.isZero()?h(i,r+4,s).times(pn):(i.precision=r+6,i.rounding=1,e=e.asin(),n=h(i,r+4,s).times(pn),i.precision=r,i.rounding=s,n.minus(e))},Cn.inverseHyperbolicCosine=Cn.acosh=function(){var n,e,i=this,t=i.constructor;return i.lte(wn)?new t(i.eq(wn)?0:NaN):i.isFinite()?(n=t.precision,e=t.rounding,t.precision=n+Math.max(Math.abs(i.e),i.sd())+4,t.rounding=1,yn=!1,i=i.times(i).minus(wn).sqrt().plus(i),yn=!0,t.precision=n,t.rounding=e,i.ln()):new t(i)},Cn.inverseHyperbolicSine=Cn.asinh=function(){var n,e,i=this,t=i.constructor;return!i.isFinite()||i.isZero()?new t(i):(n=t.precision,e=t.rounding,t.precision=n+2*Math.max(Math.abs(i.e),i.sd())+6,t.rounding=1,yn=!1,i=i.times(i).plus(wn).sqrt().plus(i),yn=!0,t.precision=n,t.rounding=e,i.ln())},Cn.inverseHyperbolicTangent=Cn.atanh=function(){var n,e,i,t,r=this,s=r.constructor;return r.isFinite()?r.e>=0?new s(r.abs().eq(wn)?r.s/0:r.isZero()?r:NaN):(n=s.precision,e=s.rounding,t=r.sd(),Math.max(t,n)<2*-r.e-1?o(new s(r),n,e,!0):(s.precision=i=t-r.e,r=In(r.plus(wn),wn.minus(r),i+n,1),s.precision=n+4,s.rounding=1,r=r.ln(),s.precision=n,s.rounding=e,r.times(pn))):new s(NaN)},Cn.inverseSine=Cn.asin=function(){var n,e,i,t,r=this,s=r.constructor;return r.isZero()?new s(r):(e=r.abs().cmp(wn),i=s.precision,t=s.rounding,-1!==e?0===e?(n=h(s,i+4,t).times(pn),n.s=r.s,n):new s(NaN):(s.precision=i+6,s.rounding=1,r=r.div(wn.plus(s.sqrt(wn.minus(r.times(r))))).atan(),s.precision=i,s.rounding=t,r.times(2)))},Cn.inverseTangent=Cn.atan=function(){var n,e,i,t,r,s,u,c,f,a=this,l=a.constructor,d=l.precision,g=l.rounding;if(a.isFinite()){if(a.isZero())return new l(a);if(a.abs().eq(wn)&&Tn>=d+4)return u=h(l,d+4,g).times(.25),u.s=a.s,u}else{if(!a.s)return new l(NaN);if(Tn>=d+4)return u=h(l,d+4,g).times(pn),u.s=a.s,u}for(l.precision=c=d+10,l.rounding=1,i=Math.min(28,c/Un+2|0),n=i;n;--n)a=a.div(a.times(a).plus(wn).sqrt().plus(wn));for(yn=!1,e=Math.ceil(c/Un),t=1,f=a.times(a),u=new l(a),r=a;-1!==n;)if(r=r.times(f),s=u.minus(r.div(t+=2)),r=r.times(f),u=s.plus(r.div(t+=2)),void 0!==u.d[e])for(n=e;u.d[n]===s.d[n]&&n--;);return i&&(u=u.times(2<<i-1)),yn=!0,o(u,l.precision=d,l.rounding=g,!0)},Cn.isFinite=function(){return!!this.d},Cn.isInteger=Cn.isInt=function(){return!!this.d&&Fn(this.e/Un)>this.d.length-2},Cn.isNaN=function(){return!this.s},Cn.isNegative=Cn.isNeg=function(){return this.s<0},Cn.isPositive=Cn.isPos=function(){return this.s>0},Cn.isZero=function(){return!!this.d&&0===this.d[0]},Cn.lessThan=Cn.lt=function(n){return this.cmp(n)<0},Cn.lessThanOrEqualTo=Cn.lte=function(n){return this.cmp(n)<1},Cn.logarithm=Cn.log=function(n){var i,r,s,u,c,h,a,l,d=this,g=d.constructor,p=g.precision,w=g.rounding,v=5;if(null==n)n=new g(10),i=!0;else{if(n=new g(n),r=n.d,n.s<0||!r||!r[0]||n.eq(wn))return new g(NaN);i=n.eq(10)}if(r=d.d,d.s<0||!r||!r[0]||d.eq(wn))return new g(r&&!r[0]?-1/0:1!=d.s?NaN:r?0:1/0);if(i)if(r.length>1)c=!0;else{for(u=r[0];u%10===0;)u/=10;c=1!==u}if(yn=!1,a=p+v,h=m(d,a),s=i?f(g,a+10):m(n,a),l=In(h,s,a,1),t(l.d,u=p,w))do if(a+=10,h=m(d,a),s=i?f(g,a+10):m(n,a),l=In(h,s,a,1),!c){+e(l.d).slice(u+1,u+15)+1==1e14&&(l=o(l,p+1,0));break}while(t(l.d,u+=10,w));return yn=!0,o(l,p,w)},Cn.minus=Cn.sub=function(n){var e,i,t,r,s,u,f,h,a,l,d,g,p=this,w=p.constructor;if(n=new w(n),!p.d||!n.d)return p.s&&n.s?p.d?n.s=-n.s:n=new w(n.d||p.s!==n.s?p:NaN):n=new w(NaN),n;if(p.s!=n.s)return n.s=-n.s,p.plus(n);if(a=p.d,g=n.d,f=w.precision,h=w.rounding,!a[0]||!g[0]){if(g[0])n.s=-n.s;else{if(!a[0])return new w(3===h?-0:0);n=new w(p)}return yn?o(n,f,h):n}if(i=Fn(n.e/Un),l=Fn(p.e/Un),a=a.slice(),s=l-i){for(d=0>s,d?(e=a,s=-s,u=g.length):(e=g,i=l,u=a.length),t=Math.max(Math.ceil(f/Un),u)+2,s>t&&(s=t,e.length=1),e.reverse(),t=s;t--;)e.push(0);e.reverse()}else{for(t=a.length,u=g.length,d=u>t,d&&(u=t),t=0;u>t;t++)if(a[t]!=g[t]){d=a[t]<g[t];break}s=0}for(d&&(e=a,a=g,g=e,n.s=-n.s),u=a.length,t=g.length-u;t>0;--t)a[u++]=0;for(t=g.length;t>s;){if(a[--t]<g[t]){for(r=t;r&&0===a[--r];)a[r]=Ln-1;--a[r],a[t]+=Ln}a[t]-=g[t]}for(;0===a[--u];)a.pop();for(;0===a[0];a.shift())--i;return a[0]?(n.d=a,n.e=c(a,i),yn?o(n,f,h):n):new w(3===h?-0:0)},Cn.modulo=Cn.mod=function(n){var e,i=this,t=i.constructor;return n=new t(n),!i.d||!n.s||n.d&&!n.d[0]?new t(NaN):!n.d||i.d&&!i.d[0]?o(new t(i),t.precision,t.rounding):(yn=!1,9==t.modulo?(e=In(i,n.abs(),0,3,1),e.s*=n.s):e=In(i,n,0,t.modulo,1),e=e.times(n),yn=!0,i.minus(e))},Cn.naturalExponential=Cn.exp=function(){return w(this)},Cn.naturalLogarithm=Cn.ln=function(){return m(this)},Cn.negated=Cn.neg=function(){var n=new this.constructor(this);return n.s=-n.s,o(n)},Cn.plus=Cn.add=function(n){var e,i,t,r,s,u,f,h,a,l,d=this,g=d.constructor;if(n=new g(n),!d.d||!n.d)return d.s&&n.s?d.d||(n=new g(n.d||d.s===n.s?d:NaN)):n=new g(NaN),n;if(d.s!=n.s)return n.s=-n.s,d.minus(n);if(a=d.d,l=n.d,f=g.precision,h=g.rounding,!a[0]||!l[0])return l[0]||(n=new g(d)),yn?o(n,f,h):n;if(s=Fn(d.e/Un),t=Fn(n.e/Un),a=a.slice(),r=s-t){for(0>r?(i=a,r=-r,u=l.length):(i=l,t=s,u=a.length),s=Math.ceil(f/Un),u=s>u?s+1:u+1,r>u&&(r=u,i.length=1),i.reverse();r--;)i.push(0);i.reverse()}for(u=a.length,r=l.length,0>u-r&&(r=u,i=l,l=a,a=i),e=0;r;)e=(a[--r]=a[r]+l[r]+e)/Ln|0,a[r]%=Ln;for(e&&(a.unshift(e),++t),u=a.length;0==a[--u];)a.pop();return n.d=a,n.e=c(a,t),yn?o(n,f,h):n},Cn.precision=Cn.sd=function(n){var e,i=this;if(void 0!==n&&n!==!!n&&1!==n&&0!==n)throw Error(On+n);return i.d?(e=a(i.d),n&&i.e+1>e&&(e=i.e+1)):e=NaN,e},Cn.round=function(){var n=this,e=n.constructor;return o(new e(n),n.e+1,e.rounding)},Cn.sine=Cn.sin=function(){var n,e,i=this,t=i.constructor;return i.isFinite()?i.isZero()?new t(i):(n=t.precision,e=t.rounding,t.precision=n+Math.max(i.e,i.sd())+Un,t.rounding=1,i=b(t,M(t,i)),t.precision=n,t.rounding=e,o(gn>2?i.neg():i,n,e,!0)):new t(NaN)},Cn.squareRoot=Cn.sqrt=function(){var n,i,t,r,s,u,c=this,f=c.d,h=c.e,a=c.s,l=c.constructor;if(1!==a||!f||!f[0])return new l(!a||0>a&&(!f||f[0])?NaN:f?c:1/0);for(yn=!1,a=Math.sqrt(+c),0==a||a==1/0?(i=e(f),(i.length+h)%2==0&&(i+="0"),a=Math.sqrt(i),h=Fn((h+1)/2)-(0>h||h%2),a==1/0?i="1e"+h:(i=a.toExponential(),i=i.slice(0,i.indexOf("e")+1)+h),r=new l(i)):r=new l(a.toString()),t=(h=l.precision)+3;;)if(u=r,r=u.plus(In(c,u,t+2,1)).times(pn),e(u.d).slice(0,t)===(i=e(r.d)).slice(0,t)){if(i=i.slice(t-3,t+1),"9999"!=i&&(s||"4999"!=i)){(!+i||!+i.slice(1)&&"5"==i.charAt(0))&&(o(r,h+1,1),n=!r.times(r).eq(c));break}if(!s&&(o(u,h+1,0),u.times(u).eq(c))){r=u;break}t+=4,s=1}return yn=!0,o(r,h,l.rounding,n)},Cn.tangent=Cn.tan=function(){var n,e,i=this,t=i.constructor;return i.isFinite()?i.isZero()?new t(i):(n=t.precision,e=t.rounding,t.precision=n+10,t.rounding=1,i=i.sin(),i.s=1,i=In(i,wn.minus(i.times(i)).sqrt(),n+10,0),t.precision=n,t.rounding=e,o(2==gn||4==gn?i.neg():i,n,e,!0)):new t(NaN)},Cn.times=Cn.mul=function(n){var e,i,t,r,s,u,f,h,a,l=this,d=l.constructor,g=l.d,p=(n=new d(n)).d;if(n.s*=l.s,!(g&&g[0]&&p&&p[0]))return new d(!n.s||g&&!g[0]&&!p||p&&!p[0]&&!g?NaN:g&&p?0*n.s:n.s/0);for(i=Fn(l.e/Un)+Fn(n.e/Un),h=g.length,a=p.length,a>h&&(s=g,g=p,p=s,u=h,h=a,a=u),s=[],u=h+a,t=u;t--;)s.push(0);for(t=a;--t>=0;){for(e=0,r=h+t;r>t;)f=s[r]+p[t]*g[r-t-1]+e,s[r--]=f%Ln|0,e=f/Ln|0;s[r]=(s[r]+e)%Ln|0}for(;!s[--u];)s.pop();for(e?++i:s.shift(),t=s.length;!s[--t];)s.pop();return n.d=s,n.e=c(s,i),yn?o(n,d.precision,d.rounding):n},Cn.toBinary=function(n,e){return y(this,2,n,e)},Cn.toDecimalPlaces=Cn.toDP=function(n,e){var t=this,r=t.constructor;return t=new r(t),void 0===n?t:(i(n,0,vn),void 0===e?e=r.rounding:i(e,0,8),o(t,n+t.e+1,e))},Cn.toExponential=function(n,e){var t,r=this,s=r.constructor;return void 0===n?t=u(r,!0):(i(n,0,vn),void 0===e?e=s.rounding:i(e,0,8),r=o(new s(r),n+1,e),t=u(r,!0,n+1)),r.isNeg()&&!r.isZero()?"-"+t:t},Cn.toFixed=function(n,e){var t,r,s=this,c=s.constructor;return void 0===n?t=u(s):(i(n,0,vn),void 0===e?e=c.rounding:i(e,0,8),r=o(new c(s),n+s.e+1,e),t=u(r,!1,n+r.e+1)),s.isNeg()&&!s.isZero()?"-"+t:t},Cn.toFraction=function(n){var i,t,r,s,o,u,c,f,h,l,d,g,p=this,w=p.d,m=p.constructor;if(!w)return new m(p);if(h=t=new m(wn),r=f=new m(0),i=new m(r),o=i.e=a(w)-p.e-1,u=o%Un,i.d[0]=Dn(10,0>u?Un+u:u),null==n)n=o>0?i:h;else{if(c=new m(n),!c.isInt()||c.lt(h))throw Error(On+c);n=c.gt(i)?o>0?i:h:c}for(yn=!1,c=new m(e(w)),l=m.precision,m.precision=o=w.length*Un*2;d=In(c,i,0,1,1),s=t.plus(d.times(r)),1!=s.cmp(n);)t=r,r=s,s=h,h=f.plus(d.times(s)),f=s,s=i,i=c.minus(d.times(s)),c=s;return s=In(n.minus(t),r,0,1,1),f=f.plus(s.times(h)),t=t.plus(s.times(r)),f.s=h.s=p.s,g=In(h,r,o,1).minus(p).abs().cmp(In(f,t,o,1).minus(p).abs())<1?[h,r]:[f,t],m.precision=l,yn=!0,g},Cn.toHexadecimal=Cn.toHex=function(n,e){return y(this,16,n,e)},Cn.toJSON=function(){var n,i,t,s,o,u,c,f,h=this,a=h.s<0;if(!h.d)return Nn.charAt(h.s?a?82:83:84);if(i=h.e,1===h.d.length&&4>i&&i>=0&&(u=h.d[0],2857>u))return 41>u?Nn.charAt(a?u+41:u):(u-=41,a&&(u+=2816),s=u/88|0,Nn.charAt(s)+Nn.charAt(u-88*s));if(f=e(h.d),c="",!a&&8>=i&&i>=-7)s=64+i+7;else if(a&&4>=i&&i>=-3)s=80+i+3;else if(f.length===i+1)s=32*a;else if(s=32*a+16*(0>i),i=Math.abs(i),88>i)s+=1,c=Nn.charAt(i);else if(7744>i)s+=2,u=i/88|0,c=Nn.charAt(u)+Nn.charAt(i-88*u);else for(n=r(String(i),10,88),o=n.length,s+=o,t=0;o>t;t++)c+=Nn.charAt(n[t]);for(c=Nn.charAt(s)+c,n=r(f,10,88),o=n.length,t=0;o>t;t++)c+=Nn.charAt(n[t]);return c},Cn.toNearest=function(n,e){var t=this,r=t.constructor;if(t=new r(t),null==n){if(!t.d)return t;n=new r(wn),e=r.rounding}else{if(n=new r(n),void 0!==e&&i(e,0,8),!t.d)return n.s?t:n;if(!n.d)return n.s&&(n.s=t.s),n}return n.d[0]?(yn=!1,4>e&&(e=[4,5,7,8][e]),t=In(t,n,0,e,1).times(n),yn=!0,o(t)):(n.s=t.s,t=n),t},Cn.toNumber=function(){return+this},Cn.toOctal=function(n,e){return y(this,8,n,e)},Cn.toPower=Cn.pow=function(n){var i,r,s,u,c,f,h,a=this,l=a.constructor,g=+(n=new l(n));if(!(a.d&&n.d&&a.d[0]&&n.d[0]))return new l(Dn(+a,g));if(a=new l(a),a.eq(wn))return a;if(s=l.precision,c=l.rounding,n.eq(wn))return o(a,s,c);if(i=Fn(n.e/Un),r=n.d.length-1,h=i>=r,f=a.s,h){if((r=0>g?-g:g)<=_n)return u=d(l,a,r,s),n.s<0?new l(wn).div(u):o(u,s,c)}else if(0>f)return new l(NaN);return f=0>f&&1&n.d[Math.max(i,r)]?-1:1,r=Dn(+a,g),i=0!=r&&isFinite(r)?new l(r+"").e:Fn(g*(Math.log("0."+e(a.d))/Math.LN10+a.e+1)),i>l.maxE+1||i<l.minE-1?new l(i>0?f/0:0):(yn=!1,l.rounding=a.s=1,r=Math.min(12,(i+"").length),u=w(n.times(m(a,s+r)),s),u=o(u,s+5,1),t(u.d,s,c)&&(i=s+10,u=o(w(n.times(m(a,i+r)),i),i+5,1),+e(u.d).slice(s+1,s+15)+1==1e14&&(u=o(u,s+1,0))),u.s=f,yn=!0,l.rounding=c,o(u,s,c))},Cn.toPrecision=function(n,e){var t,r=this,s=r.constructor;return void 0===n?t=u(r,r.e<=s.toExpNeg||r.e>=s.toExpPos):(i(n,1,vn),void 0===e?e=s.rounding:i(e,0,8),r=o(new s(r),n,e),t=u(r,n<=r.e||r.e<=s.toExpNeg,n)),r.isNeg()&&!r.isZero()?"-"+t:t},Cn.toSignificantDigits=Cn.toSD=function(n,e){var t=this,r=t.constructor;return void 0===n?(n=r.precision,e=r.rounding):(i(n,1,vn),void 0===e?e=r.rounding:i(e,0,8)),o(new r(t),n,e)},Cn.toString=function(){var n=this,e=n.constructor,i=u(n,n.e<=e.toExpNeg||n.e>=e.toExpPos);return n.isNeg()&&!n.isZero()?"-"+i:i},Cn.truncated=Cn.trunc=function(){return o(new this.constructor(this),this.e+1,1)},Cn.valueOf=function(){var n=this,e=n.constructor,i=u(n,n.e<=e.toExpNeg||n.e>=e.toExpPos);return n.isNeg()?"-"+i:i};var In=function(){function n(n,e,i){var t,r=0,s=n.length;for(n=n.slice();s--;)t=n[s]*e+r,n[s]=t%i|0,r=t/i|0;return r&&n.unshift(r),n}function e(n,e,i,t){var r,s;if(i!=t)s=i>t?1:-1;else for(r=s=0;i>r;r++)if(n[r]!=e[r]){s=n[r]>e[r]?1:-1;break}return s}function i(n,e,i,t){for(var r=0;i--;)n[i]-=r,r=n[i]<e[i]?1:0,n[i]=r*t+n[i]-e[i];for(;!n[0]&&n.length>1;)n.shift()}return function(t,r,s,u,c,f){var h,a,l,d,g,p,w,m,v,N,x,b,E,M,y,A,O,q,F,D,Z=t.constructor,P=t.s==r.s?1:-1,R=t.d,S=r.d;if(!(R&&R[0]&&S&&S[0]))return new Z(t.s&&r.s&&(R?!S||R[0]!=S[0]:S)?R&&0==R[0]||!S?0*P:P/0:NaN);for(f?(g=1,a=t.e-r.e):(f=Ln,g=Un,a=Fn(t.e/g)-Fn(r.e/g)),F=S.length,O=R.length,v=new Z(P),N=v.d=[],l=0;S[l]==(R[l]||0);l++);if(S[l]>(R[l]||0)&&a--,null==s?(M=s=Z.precision,u=Z.rounding):M=c?s+(t.e-r.e)+1:s,0>M)N.push(1),p=!0;else{if(M=M/g+2|0,l=0,1==F){for(d=0,S=S[0],M++;(O>l||d)&&M--;l++)y=d*f+(R[l]||0),N[l]=y/S|0,d=y%S|0;p=d||O>l}else{for(d=f/(S[0]+1)|0,d>1&&(S=n(S,d,f),R=n(R,d,f),F=S.length,O=R.length),A=F,x=R.slice(0,F),b=x.length;F>b;)x[b++]=0;D=S.slice(),D.unshift(0),q=S[0],S[1]>=f/2&&++q;do d=0,h=e(S,x,F,b),0>h?(E=x[0],F!=b&&(E=E*f+(x[1]||0)),d=E/q|0,d>1?(d>=f&&(d=f-1),w=n(S,d,f),m=w.length,b=x.length,h=e(w,x,m,b),1==h&&(d--,i(w,m>F?D:S,m,f))):(0==d&&(h=d=1),
w=S.slice()),m=w.length,b>m&&w.unshift(0),i(x,w,b,f),-1==h&&(b=x.length,h=e(S,x,F,b),1>h&&(d++,i(x,b>F?D:S,b,f))),b=x.length):0===h&&(d++,x=[0]),N[l++]=d,h&&x[0]?x[b++]=R[A]||0:(x=[R[A]],b=1);while((A++<O||void 0!==x[0])&&M--);p=void 0!==x[0]}N[0]||N.shift()}if(1==g)v.e=a,ln=p;else{for(l=1,d=N[0];d>=10;d/=10)l++;v.e=l+a*g-1,o(v,c?s+v.e+1:s,u,p)}return v}}();if(En=I(En),pn=new En(.5),wn=new En(1),xn=new En(xn),bn=new En(bn),"function"==typeof define&&define.amd)define(function(){return En});else if("undefined"!=typeof module&&module.exports){if(module.exports=En,!Mn)try{Mn=require("crypto")}catch(Hn){}}else n||(n="undefined"!=typeof self&&self&&self.self==self?self:Function("return this")()),dn=n.Decimal,En.noConflict=function(){return n.Decimal=dn,En},n.Decimal=En}(this);
//# sourceMappingURL=doc/decimal.js.map
function _instanceof(left, right) {
    if (
      right != null &&
      typeof Symbol !== "undefined" &&
      right[Symbol.hasInstance]
    ) {
      return !!right[Symbol.hasInstance](left);
    } else {
      return left instanceof right;
    }
  }
  function _classCallCheck2(instance, Constructor) {
    if (!_instanceof(instance, Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass2(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: { value: subClass, writable: true, configurable: true }
    });
    if (superClass) _setPrototypeOf2(subClass, superClass);
  }
  function _setPrototypeOf2(o, p) {
    _setPrototypeOf2 =
      Object.setPrototypeOf ||
      function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
    return _setPrototypeOf2(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf2(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf2(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn2(this, result);
    };
  }
  function _possibleConstructorReturn2(self, call) {
    if (call && (_typeof2(call) === "object" || typeof call === "function")) {
      return call;
    }
    return _assertThisInitialized2(self);
  }
  function _assertThisInitialized2(self) {
    if (self === void 0) {
      throw new ReferenceError(
        "this hasn't been initialised - super() hasn't been called"
      );
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf2(o) {
    _getPrototypeOf2 = Object.setPrototypeOf
      ? Object.getPrototypeOf
      : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
    return _getPrototypeOf2(o);
  }
  function _typeof2(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof2 = function _typeof2(obj) {
        return typeof obj;
      };
    } else {
      _typeof2 = function _typeof2(obj) {
        return obj &&
          typeof Symbol === "function" &&
          obj.constructor === Symbol &&
          obj !== Symbol.prototype
          ? "symbol"
          : typeof obj;
      };
    }
    return _typeof2(obj);
  } // modules are defined as an array
  // [ module function, map of requires ]
  //
  // map of requires is short require name -> numeric require
  //
  // anything defined in a previous bundle is accessed via the
  // orig method which is the require for previous bundles
  (function (modules, cache, entry, globalName) {
    /* eslint-disable no-undef */ var globalObject =
      typeof globalThis !== "undefined"
        ? globalThis
        : typeof self !== "undefined"
        ? self
        : typeof window !== "undefined"
        ? window
        : typeof global !== "undefined"
        ? global
        : {}; /* eslint-enable no-undef */ // Save the require from previous bundle to this closure if any
    var previousRequire =
      typeof globalObject.parcelRequire === "function" &&
      globalObject.parcelRequire; // Do not use `require` to prevent Webpack from trying to bundle this call
    var nodeRequire =
      typeof module !== "undefined" &&
      typeof module.require === "function" &&
      module.require.bind(module);
    function newRequire(name, jumped) {
      if (!cache[name]) {
        if (!modules[name]) {
          // if we cannot find the module within our internal map or
          // cache jump to the current global require ie. the last bundle
          // that was added to the page.
          var currentRequire =
            typeof parcelRequire === "function" && parcelRequire;
          if (!jumped && currentRequire) {
            return currentRequire(name, true);
          } // If there are other bundles on this page the require from the
          // previous one is saved to 'previousRequire'. Repeat this as
          // many times as there are bundles until the module is found or
          // we exhaust the require chain.
          if (previousRequire) {
            return previousRequire(name, true);
          } // Try the node require function if it exists.
          if (nodeRequire && typeof name === "string") {
            return nodeRequire(name);
          }
          var err = new Error("Cannot find module '" + name + "'");
          err.code = "MODULE_NOT_FOUND";
          throw err;
        }
        localRequire.resolve = resolve;
        localRequire.cache = {};
        var module = (cache[name] = new newRequire.Module(name));
        modules[name][0].call(
          module.exports,
          localRequire,
          module,
          module.exports,
          this
        );
      }
      return cache[name].exports;
      function localRequire(x) {
        return newRequire(localRequire.resolve(x));
      }
      function resolve(x) {
        return modules[name][1][x] || x;
      }
    }
    function Module(moduleName) {
      this.id = moduleName;
      this.bundle = newRequire;
      this.exports = {};
    }
    newRequire.isParcelRequire = true;
    newRequire.Module = Module;
    newRequire.modules = modules;
    newRequire.cache = cache;
    newRequire.parent = previousRequire;
    newRequire.register = function (id, exports) {
      modules[id] = [
        function (require, module) {
          module.exports = exports;
        },
        {}
      ];
    };
    globalObject.parcelRequire = newRequire;
    for (var i = 0; i < entry.length; i++) {
      newRequire(entry[i]);
    }
    if (entry.length) {
      // Expose entry point to Node, AMD or browser globals
      // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
      var mainExports = newRequire(entry[entry.length - 1]); // CommonJS
      if (
        (typeof exports === "undefined" ? "undefined" : _typeof2(exports)) ===
          "object" &&
        typeof module !== "undefined"
      ) {
        module.exports = mainExports; // RequireJS
      } else if (typeof define === "function" && define.amd) {
        define(function () {
          return mainExports;
        }); // <script>
      } else if (globalName) {
        this[globalName] = mainExports;
      }
    }
  })(
    {
      ef408730b35eee5b4412d2e31169913a: [
        function (require, module, exports) {
          "use strict";
          require("buffer");
          var _rippleBinaryCodec = _interopRequireDefault(
            require("ripple-binary-codec")
          );
          var _rippleKeypairs = _interopRequireDefault(
            require("ripple-keypairs")
          );
          var _lodash = _interopRequireDefault(require("lodash.isequal"));
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          } // console.log(Buffer);
          // import Buffer from 'buffer';
          function computeSignature(tx, privateKey, signAs) {
            var signingData = signAs
              ? _rippleBinaryCodec.default.encodeForMultisigning(tx, signAs)
              : _rippleBinaryCodec.default.encodeForSigning(tx);
            return _rippleKeypairs.default.sign(signingData, privateKey);
          }
          function signWithKeypair(txJSON, keypair) {
            var options =
              arguments.length > 2 && arguments[2] !== undefined
                ? arguments[2]
                : { signAs: "" }; // validate.sign({ txJSON, keypair })
            var tx = JSON.parse(txJSON);
            if (tx.TxnSignature || tx.Signers) {
              throw new Error(
                'txJSON must not contain "TxnSignature" or "Signers" properties'
              );
            } // checkFee(api, tx.Fee)
            var txToSignAndEncode = Object.assign({}, tx);
            txToSignAndEncode.SigningPubKey = options.signAs
              ? ""
              : keypair.publicKey;
            if (options.signAs) {
              var signer = {
                Account: options.signAs,
                SigningPubKey: keypair.publicKey,
                TxnSignature: computeSignature(
                  txToSignAndEncode,
                  keypair.privateKey,
                  options.signAs
                )
              };
              txToSignAndEncode.Signers = [{ Signer: signer }];
            } else {
              txToSignAndEncode.TxnSignature = computeSignature(
                txToSignAndEncode,
                keypair.privateKey
              );
            }
            var serialized = _rippleBinaryCodec.default.encode(txToSignAndEncode);
            checkTxSerialization(serialized, tx);
            return {
              signedTransaction: serialized // id: computeBinaryTransactionHash(serialized)
            };
          }
          /**
           * Compares two objects and creates a diff.
           *
           * @param a An object to compare.
           * @param b The other object to compare with.
           *
           * @returns An object containing the differences between the two objects.
           */ function objectDiff(a, b) {
            var diffs = {}; // Compare two items and push non-matches to object
            var compare = function compare(i1, i2, k) {
              var type1 = Object.prototype.toString.call(i1);
              var type2 = Object.prototype.toString.call(i2);
              if (type2 === "[object Undefined]") {
                diffs[k] = null; // Indicate that the item has been removed
                return;
              }
              if (type1 !== type2) {
                diffs[k] = i2; // Indicate that the item has changed types
                return;
              }
              if (type1 === "[object Object]") {
                var objDiff = objectDiff(i1, i2);
                if (Object.keys(objDiff).length > 0) {
                  diffs[k] = objDiff;
                }
                return;
              }
              if (type1 === "[object Array]") {
                if (!(0, _lodash.default)(i1, i2)) {
                  diffs[k] = i2; // If arrays do not match, add second item to diffs
                }
                return;
              }
              if (type1 === "[object Function]") {
                if (i1.toString() !== i2.toString()) {
                  diffs[k] = i2; // If functions differ, add second one to diffs
                }
                return;
              }
              if (i1 !== i2) {
                diffs[k] = i2;
              }
            }; // Check items in first object
            for (var key in a) {
              if (a.hasOwnProperty(key)) {
                compare(a[key], b[key], key);
              }
            } // Get items that are in the second object but not the first
            for (var _key in b) {
              if (b.hasOwnProperty(_key)) {
                if (!a[_key] && a[_key] !== b[_key]) {
                  diffs[_key] = b[_key];
                }
              }
            }
            return diffs;
          }
          /**
           *  Decode a serialized transaction, remove the fields that are added during the signing process,
           *  and verify that it matches the transaction prior to signing.
           *
           *  @param {string} serialized A signed and serialized transaction.
           *  @param {TransactionJSON} tx The transaction prior to signing.
           *
           *  @returns {void} This method does not return a value, but throws an error if the check fails.
           */ function checkTxSerialization(serialized, tx) {
            // Decode the serialized transaction:
            var decoded = _rippleBinaryCodec.default.decode(serialized); // ...And ensure it is equal to the original tx, except:
            // - It must have a TxnSignature or Signers (multisign).
            if (!decoded.TxnSignature && !decoded.Signers) {
              throw new Error(
                "Serialized transaction must have a TxnSignature or Signers property"
              );
            } // - We know that the original tx did not have TxnSignature, so we should delete it:
            delete decoded.TxnSignature; // - We know that the original tx did not have Signers, so if it exists, we should delete it:
            delete decoded.Signers; // - If SigningPubKey was not in the original tx, then we should delete it.
            //   But if it was in the original tx, then we should ensure that it has not been changed.
            if (!tx.SigningPubKey) {
              delete decoded.SigningPubKey;
            }
            if (!(0, _lodash.default)(decoded, tx)) {
              throw { decoded: decoded, tx: tx, diff: objectDiff(tx, decoded) };
            }
          }
          function sign(txJSON, secret, options, keypair) {
            if (typeof secret === "string") {
              // we can't validate that the secret matches the account because
              // the secret could correspond to the regular key
              // validate.sign({ txJSON, secret })
              return signWithKeypair(
                txJSON,
                _rippleKeypairs.default.deriveKeypair(secret),
                options
              );
            } else {
              if (!keypair && !secret) {
                // Clearer message than 'ValidationError: instance is not exactly one from [subschema 0],[subschema 1]'
                throw new Error("sign: Missing secret or keypair.");
              }
              return signWithKeypair(txJSON, keypair ? keypair : secret, options);
            }
          }
          window.sign = sign; //   console.log(sign);
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          "ripple-binary-codec": "afff7b3d3d8d99252449144a624c3663",
          "ripple-keypairs": "fd317075df46e2c62116d9e3725a3f9c",
          "lodash.isequal": "d7ef83308b42a154558e199779d37f7d"
        }
      ],
      "1948b2a05a083f82087512f711e79e4d": [
        function (require, module, exports) {
          /*!
           * The buffer module from node.js, for the browser.
           *
           * @author   Feross Aboukhadijeh <https://feross.org>
           * @license  MIT
           */ /* eslint-disable no-proto */ "use strict";
          var base64 = require("base64-js");
          var ieee754 = require("ieee754");
          var customInspectSymbol =
            typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
              ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
              : null;
          exports.Buffer = Buffer;
          exports.SlowBuffer = SlowBuffer;
          exports.INSPECT_MAX_BYTES = 50;
          var K_MAX_LENGTH = 0x7fffffff;
          exports.kMaxLength = K_MAX_LENGTH;
          /**
           * If `Buffer.TYPED_ARRAY_SUPPORT`:
           *   === true    Use Uint8Array implementation (fastest)
           *   === false   Print warning and recommend using `buffer` v4.x which has an Object
           *               implementation (most compatible, even IE6)
           *
           * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
           * Opera 11.6+, iOS 4.2+.
           *
           * We report that the browser does not support typed arrays if the are not subclassable
           * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
           * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
           * for __proto__ and has a buggy typed array implementation.
           */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
          if (
            !Buffer.TYPED_ARRAY_SUPPORT &&
            typeof console !== "undefined" &&
            typeof console.error === "function"
          ) {
            console.error(
              "This browser lacks typed array (Uint8Array) support which is required by " +
                "`buffer` v5.x. Use `buffer` v4.x if you require old browser support."
            );
          }
          function typedArraySupport() {
            // Can typed array instances can be augmented?
            try {
              var arr = new Uint8Array(1);
              var proto = {
                foo: function foo() {
                  return 42;
                }
              };
              Object.setPrototypeOf(proto, Uint8Array.prototype);
              Object.setPrototypeOf(arr, proto);
              return arr.foo() === 42;
            } catch (e) {
              return false;
            }
          }
          Object.defineProperty(Buffer.prototype, "parent", {
            enumerable: true,
            get: function get() {
              if (!Buffer.isBuffer(this)) return undefined;
              return this.buffer;
            }
          });
          Object.defineProperty(Buffer.prototype, "offset", {
            enumerable: true,
            get: function get() {
              if (!Buffer.isBuffer(this)) return undefined;
              return this.byteOffset;
            }
          });
          function createBuffer(length) {
            if (length > K_MAX_LENGTH) {
              throw new RangeError(
                'The value "' + length + '" is invalid for option "size"'
              );
            } // Return an augmented `Uint8Array` instance
            var buf = new Uint8Array(length);
            Object.setPrototypeOf(buf, Buffer.prototype);
            return buf;
          }
          /**
           * The Buffer constructor returns instances of `Uint8Array` that have their
           * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
           * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
           * and the `Uint8Array` methods. Square bracket notation works as expected -- it
           * returns a single octet.
           *
           * The `Uint8Array` prototype remains unmodified.
           */ function Buffer(arg, encodingOrOffset, length) {
            // Common case.
            if (typeof arg === "number") {
              if (typeof encodingOrOffset === "string") {
                throw new TypeError(
                  'The "string" argument must be of type string. Received type number'
                );
              }
              return allocUnsafe(arg);
            }
            return from(arg, encodingOrOffset, length);
          }
          Buffer.poolSize = 8192; // not used by this implementation
          function from(value, encodingOrOffset, length) {
            if (typeof value === "string") {
              return fromString(value, encodingOrOffset);
            }
            if (ArrayBuffer.isView(value)) {
              return fromArrayView(value);
            }
            if (value == null) {
              throw new TypeError(
                "The first argument must be one of type string, Buffer, ArrayBuffer, Array, " +
                  "or Array-like Object. Received type " +
                  _typeof2(value)
              );
            }
            if (
              isInstance(value, ArrayBuffer) ||
              (value && isInstance(value.buffer, ArrayBuffer))
            ) {
              return fromArrayBuffer(value, encodingOrOffset, length);
            }
            if (
              typeof SharedArrayBuffer !== "undefined" &&
              (isInstance(value, SharedArrayBuffer) ||
                (value && isInstance(value.buffer, SharedArrayBuffer)))
            ) {
              return fromArrayBuffer(value, encodingOrOffset, length);
            }
            if (typeof value === "number") {
              throw new TypeError(
                'The "value" argument must not be of type number. Received type number'
              );
            }
            var valueOf = value.valueOf && value.valueOf();
            if (valueOf != null && valueOf !== value) {
              return Buffer.from(valueOf, encodingOrOffset, length);
            }
            var b = fromObject(value);
            if (b) return b;
            if (
              typeof Symbol !== "undefined" &&
              Symbol.toPrimitive != null &&
              typeof value[Symbol.toPrimitive] === "function"
            ) {
              return Buffer.from(
                value[Symbol.toPrimitive]("string"),
                encodingOrOffset,
                length
              );
            }
            throw new TypeError(
              "The first argument must be one of type string, Buffer, ArrayBuffer, Array, " +
                "or Array-like Object. Received type " +
                _typeof2(value)
            );
          }
          /**
           * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
           * if value is a number.
           * Buffer.from(str[, encoding])
           * Buffer.from(array)
           * Buffer.from(buffer)
           * Buffer.from(arrayBuffer[, byteOffset[, length]])
           **/ Buffer.from = function (value, encodingOrOffset, length) {
            return from(value, encodingOrOffset, length);
          }; // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
          // https://github.com/feross/buffer/pull/148
          Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
          Object.setPrototypeOf(Buffer, Uint8Array);
          function assertSize(size) {
            if (typeof size !== "number") {
              throw new TypeError('"size" argument must be of type number');
            } else if (size < 0) {
              throw new RangeError(
                'The value "' + size + '" is invalid for option "size"'
              );
            }
          }
          function alloc(size, fill, encoding) {
            assertSize(size);
            if (size <= 0) {
              return createBuffer(size);
            }
            if (fill !== undefined) {
              // Only pay attention to encoding if it's a string. This
              // prevents accidentally sending in a number that would
              // be interpreted as a start offset.
              return typeof encoding === "string"
                ? createBuffer(size).fill(fill, encoding)
                : createBuffer(size).fill(fill);
            }
            return createBuffer(size);
          }
          /**
           * Creates a new filled Buffer instance.
           * alloc(size[, fill[, encoding]])
           **/ Buffer.alloc = function (size, fill, encoding) {
            return alloc(size, fill, encoding);
          };
          function allocUnsafe(size) {
            assertSize(size);
            return createBuffer(size < 0 ? 0 : checked(size) | 0);
          }
          /**
           * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
           * */ Buffer.allocUnsafe = function (size) {
            return allocUnsafe(size);
          };
          /**
           * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
           */ Buffer.allocUnsafeSlow = function (size) {
            return allocUnsafe(size);
          };
          function fromString(string, encoding) {
            if (typeof encoding !== "string" || encoding === "") {
              encoding = "utf8";
            }
            if (!Buffer.isEncoding(encoding)) {
              throw new TypeError("Unknown encoding: " + encoding);
            }
            var length = byteLength(string, encoding) | 0;
            var buf = createBuffer(length);
            var actual = buf.write(string, encoding);
            if (actual !== length) {
              // Writing a hex string, for example, that contains invalid characters will
              // cause everything after the first invalid character to be ignored. (e.g.
              // 'abxxcd' will be treated as 'ab')
              buf = buf.slice(0, actual);
            }
            return buf;
          }
          function fromArrayLike(array) {
            var length = array.length < 0 ? 0 : checked(array.length) | 0;
            var buf = createBuffer(length);
            for (var i = 0; i < length; i += 1) {
              buf[i] = array[i] & 255;
            }
            return buf;
          }
          function fromArrayView(arrayView) {
            if (isInstance(arrayView, Uint8Array)) {
              var copy = new Uint8Array(arrayView);
              return fromArrayBuffer(
                copy.buffer,
                copy.byteOffset,
                copy.byteLength
              );
            }
            return fromArrayLike(arrayView);
          }
          function fromArrayBuffer(array, byteOffset, length) {
            if (byteOffset < 0 || array.byteLength < byteOffset) {
              throw new RangeError('"offset" is outside of buffer bounds');
            }
            if (array.byteLength < byteOffset + (length || 0)) {
              throw new RangeError('"length" is outside of buffer bounds');
            }
            var buf;
            if (byteOffset === undefined && length === undefined) {
              buf = new Uint8Array(array);
            } else if (length === undefined) {
              buf = new Uint8Array(array, byteOffset);
            } else {
              buf = new Uint8Array(array, byteOffset, length);
            } // Return an augmented `Uint8Array` instance
            Object.setPrototypeOf(buf, Buffer.prototype);
            return buf;
          }
          function fromObject(obj) {
            if (Buffer.isBuffer(obj)) {
              var len = checked(obj.length) | 0;
              var buf = createBuffer(len);
              if (buf.length === 0) {
                return buf;
              }
              obj.copy(buf, 0, 0, len);
              return buf;
            }
            if (obj.length !== undefined) {
              if (typeof obj.length !== "number" || numberIsNaN(obj.length)) {
                return createBuffer(0);
              }
              return fromArrayLike(obj);
            }
            if (obj.type === "Buffer" && Array.isArray(obj.data)) {
              return fromArrayLike(obj.data);
            }
          }
          function checked(length) {
            // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
            // length is NaN (which is otherwise coerced to zero.)
            if (length >= K_MAX_LENGTH) {
              throw new RangeError(
                "Attempt to allocate Buffer larger than maximum " +
                  "size: 0x" +
                  K_MAX_LENGTH.toString(16) +
                  " bytes"
              );
            }
            return length | 0;
          }
          function SlowBuffer(length) {
            if (+length != length) {
              // eslint-disable-line eqeqeq
              length = 0;
            }
            return Buffer.alloc(+length);
          }
          Buffer.isBuffer = function isBuffer(b) {
            return b != null && b._isBuffer === true && b !== Buffer.prototype; // so Buffer.isBuffer(Buffer.prototype) will be false
          };
          Buffer.compare = function compare(a, b) {
            if (isInstance(a, Uint8Array))
              a = Buffer.from(a, a.offset, a.byteLength);
            if (isInstance(b, Uint8Array))
              b = Buffer.from(b, b.offset, b.byteLength);
            if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
              throw new TypeError(
                'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
              );
            }
            if (a === b) return 0;
            var x = a.length;
            var y = b.length;
            for (var i = 0, len = Math.min(x, y); i < len; ++i) {
              if (a[i] !== b[i]) {
                x = a[i];
                y = b[i];
                break;
              }
            }
            if (x < y) return -1;
            if (y < x) return 1;
            return 0;
          };
          Buffer.isEncoding = function isEncoding(encoding) {
            switch (String(encoding).toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "latin1":
              case "binary":
              case "base64":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return true;
              default:
                return false;
            }
          };
          Buffer.concat = function concat(list, length) {
            if (!Array.isArray(list)) {
              throw new TypeError('"list" argument must be an Array of Buffers');
            }
            if (list.length === 0) {
              return Buffer.alloc(0);
            }
            var i;
            if (length === undefined) {
              length = 0;
              for (i = 0; i < list.length; ++i) {
                length += list[i].length;
              }
            }
            var buffer = Buffer.allocUnsafe(length);
            var pos = 0;
            for (i = 0; i < list.length; ++i) {
              var buf = list[i];
              if (isInstance(buf, Uint8Array)) {
                if (pos + buf.length > buffer.length) {
                  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                  buf.copy(buffer, pos);
                } else {
                  Uint8Array.prototype.set.call(buffer, buf, pos);
                }
              } else if (!Buffer.isBuffer(buf)) {
                throw new TypeError(
                  '"list" argument must be an Array of Buffers'
                );
              } else {
                buf.copy(buffer, pos);
              }
              pos += buf.length;
            }
            return buffer;
          };
          function byteLength(string, encoding) {
            if (Buffer.isBuffer(string)) {
              return string.length;
            }
            if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
              return string.byteLength;
            }
            if (typeof string !== "string") {
              throw new TypeError(
                'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
                  "Received type " +
                  _typeof2(string)
              );
            }
            var len = string.length;
            var mustMatch = arguments.length > 2 && arguments[2] === true;
            if (!mustMatch && len === 0) return 0; // Use a for loop to avoid recursion
            var loweredCase = false;
            for (;;) {
              switch (encoding) {
                case "ascii":
                case "latin1":
                case "binary":
                  return len;
                case "utf8":
                case "utf-8":
                  return utf8ToBytes(string).length;
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return len * 2;
                case "hex":
                  return len >>> 1;
                case "base64":
                  return base64ToBytes(string).length;
                default:
                  if (loweredCase) {
                    return mustMatch ? -1 : utf8ToBytes(string).length; // assume utf8
                  }
                  encoding = ("" + encoding).toLowerCase();
                  loweredCase = true;
              }
            }
          }
          Buffer.byteLength = byteLength;
          function slowToString(encoding, start, end) {
            var loweredCase = false; // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
            // property of a typed array.
            // This behaves neither like String nor Uint8Array in that we set start/end
            // to their upper/lower bounds if the value passed is out of range.
            // undefined is handled specially as per ECMA-262 6th Edition,
            // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
            if (start === undefined || start < 0) {
              start = 0;
            } // Return early if start > this.length. Done here to prevent potential uint32
            // coercion fail below.
            if (start > this.length) {
              return "";
            }
            if (end === undefined || end > this.length) {
              end = this.length;
            }
            if (end <= 0) {
              return "";
            } // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
            end >>>= 0;
            start >>>= 0;
            if (end <= start) {
              return "";
            }
            if (!encoding) encoding = "utf8";
            while (true) {
              switch (encoding) {
                case "hex":
                  return hexSlice(this, start, end);
                case "utf8":
                case "utf-8":
                  return utf8Slice(this, start, end);
                case "ascii":
                  return asciiSlice(this, start, end);
                case "latin1":
                case "binary":
                  return latin1Slice(this, start, end);
                case "base64":
                  return base64Slice(this, start, end);
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return utf16leSlice(this, start, end);
                default:
                  if (loweredCase)
                    throw new TypeError("Unknown encoding: " + encoding);
                  encoding = (encoding + "").toLowerCase();
                  loweredCase = true;
              }
            }
          } // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
          // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
          // reliably in a browserify context because there could be multiple different
          // copies of the 'buffer' package in use. This method works even for Buffer
          // instances that were created from another copy of the `buffer` package.
          // See: https://github.com/feross/buffer/issues/154
          Buffer.prototype._isBuffer = true;
          function swap(b, n, m) {
            var i = b[n];
            b[n] = b[m];
            b[m] = i;
          }
          Buffer.prototype.swap16 = function swap16() {
            var len = this.length;
            if (len % 2 !== 0) {
              throw new RangeError("Buffer size must be a multiple of 16-bits");
            }
            for (var i = 0; i < len; i += 2) {
              swap(this, i, i + 1);
            }
            return this;
          };
          Buffer.prototype.swap32 = function swap32() {
            var len = this.length;
            if (len % 4 !== 0) {
              throw new RangeError("Buffer size must be a multiple of 32-bits");
            }
            for (var i = 0; i < len; i += 4) {
              swap(this, i, i + 3);
              swap(this, i + 1, i + 2);
            }
            return this;
          };
          Buffer.prototype.swap64 = function swap64() {
            var len = this.length;
            if (len % 8 !== 0) {
              throw new RangeError("Buffer size must be a multiple of 64-bits");
            }
            for (var i = 0; i < len; i += 8) {
              swap(this, i, i + 7);
              swap(this, i + 1, i + 6);
              swap(this, i + 2, i + 5);
              swap(this, i + 3, i + 4);
            }
            return this;
          };
          Buffer.prototype.toString = function toString() {
            var length = this.length;
            if (length === 0) return "";
            if (arguments.length === 0) return utf8Slice(this, 0, length);
            return slowToString.apply(this, arguments);
          };
          Buffer.prototype.toLocaleString = Buffer.prototype.toString;
          Buffer.prototype.equals = function equals(b) {
            if (!Buffer.isBuffer(b))
              throw new TypeError("Argument must be a Buffer");
            if (this === b) return true;
            return Buffer.compare(this, b) === 0;
          };
          Buffer.prototype.inspect = function inspect() {
            var str = "";
            var max = exports.INSPECT_MAX_BYTES;
            str = this.toString("hex", 0, max)
              .replace(/(.{2})/g, "$1 ")
              .trim();
            if (this.length > max) str += " ... ";
            return "<Buffer " + str + ">";
          };
          if (customInspectSymbol) {
            Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
          }
          Buffer.prototype.compare = function compare(
            target,
            start,
            end,
            thisStart,
            thisEnd
          ) {
            if (isInstance(target, Uint8Array)) {
              target = Buffer.from(target, target.offset, target.byteLength);
            }
            if (!Buffer.isBuffer(target)) {
              throw new TypeError(
                'The "target" argument must be one of type Buffer or Uint8Array. ' +
                  "Received type " +
                  _typeof2(target)
              );
            }
            if (start === undefined) {
              start = 0;
            }
            if (end === undefined) {
              end = target ? target.length : 0;
            }
            if (thisStart === undefined) {
              thisStart = 0;
            }
            if (thisEnd === undefined) {
              thisEnd = this.length;
            }
            if (
              start < 0 ||
              end > target.length ||
              thisStart < 0 ||
              thisEnd > this.length
            ) {
              throw new RangeError("out of range index");
            }
            if (thisStart >= thisEnd && start >= end) {
              return 0;
            }
            if (thisStart >= thisEnd) {
              return -1;
            }
            if (start >= end) {
              return 1;
            }
            start >>>= 0;
            end >>>= 0;
            thisStart >>>= 0;
            thisEnd >>>= 0;
            if (this === target) return 0;
            var x = thisEnd - thisStart;
            var y = end - start;
            var len = Math.min(x, y);
            var thisCopy = this.slice(thisStart, thisEnd);
            var targetCopy = target.slice(start, end);
            for (var i = 0; i < len; ++i) {
              if (thisCopy[i] !== targetCopy[i]) {
                x = thisCopy[i];
                y = targetCopy[i];
                break;
              }
            }
            if (x < y) return -1;
            if (y < x) return 1;
            return 0;
          }; // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
          // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
          //
          // Arguments:
          // - buffer - a Buffer to search
          // - val - a string, Buffer, or number
          // - byteOffset - an index into `buffer`; will be clamped to an int32
          // - encoding - an optional encoding, relevant is val is a string
          // - dir - true for indexOf, false for lastIndexOf
          function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
            // Empty buffer means no match
            if (buffer.length === 0) return -1; // Normalize byteOffset
            if (typeof byteOffset === "string") {
              encoding = byteOffset;
              byteOffset = 0;
            } else if (byteOffset > 0x7fffffff) {
              byteOffset = 0x7fffffff;
            } else if (byteOffset < -0x80000000) {
              byteOffset = -0x80000000;
            }
            byteOffset = +byteOffset; // Coerce to Number.
            if (numberIsNaN(byteOffset)) {
              // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
              byteOffset = dir ? 0 : buffer.length - 1;
            } // Normalize byteOffset: negative offsets start from the end of the buffer
            if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
            if (byteOffset >= buffer.length) {
              if (dir) return -1;
              else byteOffset = buffer.length - 1;
            } else if (byteOffset < 0) {
              if (dir) byteOffset = 0;
              else return -1;
            } // Normalize val
            if (typeof val === "string") {
              val = Buffer.from(val, encoding);
            } // Finally, search either indexOf (if dir is true) or lastIndexOf
            if (Buffer.isBuffer(val)) {
              // Special case: looking for empty string/buffer always fails
              if (val.length === 0) {
                return -1;
              }
              return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
            } else if (typeof val === "number") {
              val = val & 0xff; // Search for a byte value [0-255]
              if (typeof Uint8Array.prototype.indexOf === "function") {
                if (dir) {
                  return Uint8Array.prototype.indexOf.call(
                    buffer,
                    val,
                    byteOffset
                  );
                } else {
                  return Uint8Array.prototype.lastIndexOf.call(
                    buffer,
                    val,
                    byteOffset
                  );
                }
              }
              return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
            }
            throw new TypeError("val must be string, number or Buffer");
          }
          function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
            var indexSize = 1;
            var arrLength = arr.length;
            var valLength = val.length;
            if (encoding !== undefined) {
              encoding = String(encoding).toLowerCase();
              if (
                encoding === "ucs2" ||
                encoding === "ucs-2" ||
                encoding === "utf16le" ||
                encoding === "utf-16le"
              ) {
                if (arr.length < 2 || val.length < 2) {
                  return -1;
                }
                indexSize = 2;
                arrLength /= 2;
                valLength /= 2;
                byteOffset /= 2;
              }
            }
            function read(buf, i) {
              if (indexSize === 1) {
                return buf[i];
              } else {
                return buf.readUInt16BE(i * indexSize);
              }
            }
            var i;
            if (dir) {
              var foundIndex = -1;
              for (i = byteOffset; i < arrLength; i++) {
                if (
                  read(arr, i) ===
                  read(val, foundIndex === -1 ? 0 : i - foundIndex)
                ) {
                  if (foundIndex === -1) foundIndex = i;
                  if (i - foundIndex + 1 === valLength)
                    return foundIndex * indexSize;
                } else {
                  if (foundIndex !== -1) i -= i - foundIndex;
                  foundIndex = -1;
                }
              }
            } else {
              if (byteOffset + valLength > arrLength)
                byteOffset = arrLength - valLength;
              for (i = byteOffset; i >= 0; i--) {
                var found = true;
                for (var j = 0; j < valLength; j++) {
                  if (read(arr, i + j) !== read(val, j)) {
                    found = false;
                    break;
                  }
                }
                if (found) return i;
              }
            }
            return -1;
          }
          Buffer.prototype.includes = function includes(
            val,
            byteOffset,
            encoding
          ) {
            return this.indexOf(val, byteOffset, encoding) !== -1;
          };
          Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
            return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
          };
          Buffer.prototype.lastIndexOf = function lastIndexOf(
            val,
            byteOffset,
            encoding
          ) {
            return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
          };
          function hexWrite(buf, string, offset, length) {
            offset = Number(offset) || 0;
            var remaining = buf.length - offset;
            if (!length) {
              length = remaining;
            } else {
              length = Number(length);
              if (length > remaining) {
                length = remaining;
              }
            }
            var strLen = string.length;
            if (length > strLen / 2) {
              length = strLen / 2;
            }
            var i;
            for (i = 0; i < length; ++i) {
              var parsed = parseInt(string.substr(i * 2, 2), 16);
              if (numberIsNaN(parsed)) return i;
              buf[offset + i] = parsed;
            }
            return i;
          }
          function utf8Write(buf, string, offset, length) {
            return blitBuffer(
              utf8ToBytes(string, buf.length - offset),
              buf,
              offset,
              length
            );
          }
          function asciiWrite(buf, string, offset, length) {
            return blitBuffer(asciiToBytes(string), buf, offset, length);
          }
          function base64Write(buf, string, offset, length) {
            return blitBuffer(base64ToBytes(string), buf, offset, length);
          }
          function ucs2Write(buf, string, offset, length) {
            return blitBuffer(
              utf16leToBytes(string, buf.length - offset),
              buf,
              offset,
              length
            );
          }
          Buffer.prototype.write = function write(
            string,
            offset,
            length,
            encoding
          ) {
            // Buffer#write(string)
            if (offset === undefined) {
              encoding = "utf8";
              length = this.length;
              offset = 0; // Buffer#write(string, encoding)
            } else if (length === undefined && typeof offset === "string") {
              encoding = offset;
              length = this.length;
              offset = 0; // Buffer#write(string, offset[, length][, encoding])
            } else if (isFinite(offset)) {
              offset = offset >>> 0;
              if (isFinite(length)) {
                length = length >>> 0;
                if (encoding === undefined) encoding = "utf8";
              } else {
                encoding = length;
                length = undefined;
              }
            } else {
              throw new Error(
                "Buffer.write(string, encoding, offset[, length]) is no longer supported"
              );
            }
            var remaining = this.length - offset;
            if (length === undefined || length > remaining) length = remaining;
            if (
              (string.length > 0 && (length < 0 || offset < 0)) ||
              offset > this.length
            ) {
              throw new RangeError("Attempt to write outside buffer bounds");
            }
            if (!encoding) encoding = "utf8";
            var loweredCase = false;
            for (;;) {
              switch (encoding) {
                case "hex":
                  return hexWrite(this, string, offset, length);
                case "utf8":
                case "utf-8":
                  return utf8Write(this, string, offset, length);
                case "ascii":
                case "latin1":
                case "binary":
                  return asciiWrite(this, string, offset, length);
                case "base64": // Warning: maxLength not taken into account in base64Write
                  return base64Write(this, string, offset, length);
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return ucs2Write(this, string, offset, length);
                default:
                  if (loweredCase)
                    throw new TypeError("Unknown encoding: " + encoding);
                  encoding = ("" + encoding).toLowerCase();
                  loweredCase = true;
              }
            }
          };
          Buffer.prototype.toJSON = function toJSON() {
            return {
              type: "Buffer",
              data: Array.prototype.slice.call(this._arr || this, 0)
            };
          };
          function base64Slice(buf, start, end) {
            if (start === 0 && end === buf.length) {
              return base64.fromByteArray(buf);
            } else {
              return base64.fromByteArray(buf.slice(start, end));
            }
          }
          function utf8Slice(buf, start, end) {
            end = Math.min(buf.length, end);
            var res = [];
            var i = start;
            while (i < end) {
              var firstByte = buf[i];
              var codePoint = null;
              var bytesPerSequence =
                firstByte > 0xef
                  ? 4
                  : firstByte > 0xdf
                  ? 3
                  : firstByte > 0xbf
                  ? 2
                  : 1;
              if (i + bytesPerSequence <= end) {
                var secondByte = void 0,
                  thirdByte = void 0,
                  fourthByte = void 0,
                  tempCodePoint = void 0;
                switch (bytesPerSequence) {
                  case 1:
                    if (firstByte < 0x80) {
                      codePoint = firstByte;
                    }
                    break;
                  case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xc0) === 0x80) {
                      tempCodePoint =
                        ((firstByte & 0x1f) << 0x6) | (secondByte & 0x3f);
                      if (tempCodePoint > 0x7f) {
                        codePoint = tempCodePoint;
                      }
                    }
                    break;
                  case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if (
                      (secondByte & 0xc0) === 0x80 &&
                      (thirdByte & 0xc0) === 0x80
                    ) {
                      tempCodePoint =
                        ((firstByte & 0xf) << 0xc) |
                        ((secondByte & 0x3f) << 0x6) |
                        (thirdByte & 0x3f);
                      if (
                        tempCodePoint > 0x7ff &&
                        (tempCodePoint < 0xd800 || tempCodePoint > 0xdfff)
                      ) {
                        codePoint = tempCodePoint;
                      }
                    }
                    break;
                  case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if (
                      (secondByte & 0xc0) === 0x80 &&
                      (thirdByte & 0xc0) === 0x80 &&
                      (fourthByte & 0xc0) === 0x80
                    ) {
                      tempCodePoint =
                        ((firstByte & 0xf) << 0x12) |
                        ((secondByte & 0x3f) << 0xc) |
                        ((thirdByte & 0x3f) << 0x6) |
                        (fourthByte & 0x3f);
                      if (tempCodePoint > 0xffff && tempCodePoint < 0x110000) {
                        codePoint = tempCodePoint;
                      }
                    }
                }
              }
              if (codePoint === null) {
                // we did not generate a valid codePoint so insert a
                // replacement char (U+FFFD) and advance only 1 byte
                codePoint = 0xfffd;
                bytesPerSequence = 1;
              } else if (codePoint > 0xffff) {
                // encode to utf16 (surrogate pair dance)
                codePoint -= 0x10000;
                res.push(((codePoint >>> 10) & 0x3ff) | 0xd800);
                codePoint = 0xdc00 | (codePoint & 0x3ff);
              }
              res.push(codePoint);
              i += bytesPerSequence;
            }
            return decodeCodePointsArray(res);
          } // Based on http://stackoverflow.com/a/22747272/680742, the browser with
          // the lowest limit is Chrome, with 0x10000 args.
          // We go 1 magnitude less, for safety
          var MAX_ARGUMENTS_LENGTH = 0x1000;
          function decodeCodePointsArray(codePoints) {
            var len = codePoints.length;
            if (len <= MAX_ARGUMENTS_LENGTH) {
              return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
            } // Decode in chunks to avoid "call stack size exceeded".
            var res = "";
            var i = 0;
            while (i < len) {
              res += String.fromCharCode.apply(
                String,
                codePoints.slice(i, (i += MAX_ARGUMENTS_LENGTH))
              );
            }
            return res;
          }
          function asciiSlice(buf, start, end) {
            var ret = "";
            end = Math.min(buf.length, end);
            for (var i = start; i < end; ++i) {
              ret += String.fromCharCode(buf[i] & 0x7f);
            }
            return ret;
          }
          function latin1Slice(buf, start, end) {
            var ret = "";
            end = Math.min(buf.length, end);
            for (var i = start; i < end; ++i) {
              ret += String.fromCharCode(buf[i]);
            }
            return ret;
          }
          function hexSlice(buf, start, end) {
            var len = buf.length;
            if (!start || start < 0) start = 0;
            if (!end || end < 0 || end > len) end = len;
            var out = "";
            for (var i = start; i < end; ++i) {
              out += hexSliceLookupTable[buf[i]];
            }
            return out;
          }
          function utf16leSlice(buf, start, end) {
            var bytes = buf.slice(start, end);
            var res = ""; // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
            for (var i = 0; i < bytes.length - 1; i += 2) {
              res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
            }
            return res;
          }
          Buffer.prototype.slice = function slice(start, end) {
            var len = this.length;
            start = ~~start;
            end = end === undefined ? len : ~~end;
            if (start < 0) {
              start += len;
              if (start < 0) start = 0;
            } else if (start > len) {
              start = len;
            }
            if (end < 0) {
              end += len;
              if (end < 0) end = 0;
            } else if (end > len) {
              end = len;
            }
            if (end < start) end = start;
            var newBuf = this.subarray(start, end); // Return an augmented `Uint8Array` instance
            Object.setPrototypeOf(newBuf, Buffer.prototype);
            return newBuf;
          };
          /*
           * Need to make sure that buffer isn't trying to write out of bounds.
           */ function checkOffset(offset, ext, length) {
            if (offset % 1 !== 0 || offset < 0)
              throw new RangeError("offset is not uint");
            if (offset + ext > length)
              throw new RangeError("Trying to access beyond buffer length");
          }
          Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(
            offset,
            byteLength,
            noAssert
          ) {
            offset = offset >>> 0;
            byteLength = byteLength >>> 0;
            if (!noAssert) checkOffset(offset, byteLength, this.length);
            var val = this[offset];
            var mul = 1;
            var i = 0;
            while (++i < byteLength && (mul *= 0x100)) {
              val += this[offset + i] * mul;
            }
            return val;
          };
          Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(
            offset,
            byteLength,
            noAssert
          ) {
            offset = offset >>> 0;
            byteLength = byteLength >>> 0;
            if (!noAssert) {
              checkOffset(offset, byteLength, this.length);
            }
            var val = this[offset + --byteLength];
            var mul = 1;
            while (byteLength > 0 && (mul *= 0x100)) {
              val += this[offset + --byteLength] * mul;
            }
            return val;
          };
          Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(
            offset,
            noAssert
          ) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 1, this.length);
            return this[offset];
          };
          Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(
            offset,
            noAssert
          ) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 2, this.length);
            return this[offset] | (this[offset + 1] << 8);
          };
          Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(
            offset,
            noAssert
          ) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 2, this.length);
            return (this[offset] << 8) | this[offset + 1];
          };
          Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(
            offset,
            noAssert
          ) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 4, this.length);
            return (
              (this[offset] |
                (this[offset + 1] << 8) |
                (this[offset + 2] << 16)) +
              this[offset + 3] * 0x1000000
            );
          };
          Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(
            offset,
            noAssert
          ) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 4, this.length);
            return (
              this[offset] * 0x1000000 +
              ((this[offset + 1] << 16) |
                (this[offset + 2] << 8) |
                this[offset + 3])
            );
          };
          Buffer.prototype.readBigUInt64LE = defineBigIntMethod(
            function readBigUInt64LE(offset) {
              offset = offset >>> 0;
              validateNumber(offset, "offset");
              var first = this[offset];
              var last = this[offset + 7];
              if (first === undefined || last === undefined) {
                boundsError(offset, this.length - 8);
              }
              var lo =
                first +
                this[++offset] * Math.pow(2, 8) +
                this[++offset] * Math.pow(2, 16) +
                this[++offset] * Math.pow(2, 24);
              var hi =
                this[++offset] +
                this[++offset] * Math.pow(2, 8) +
                this[++offset] * Math.pow(2, 16) +
                last * Math.pow(2, 24);
              return BigInt(lo) + (BigInt(hi) << BigInt(32));
            }
          );
          Buffer.prototype.readBigUInt64BE = defineBigIntMethod(
            function readBigUInt64BE(offset) {
              offset = offset >>> 0;
              validateNumber(offset, "offset");
              var first = this[offset];
              var last = this[offset + 7];
              if (first === undefined || last === undefined) {
                boundsError(offset, this.length - 8);
              }
              var hi =
                first * Math.pow(2, 24) +
                this[++offset] * Math.pow(2, 16) +
                this[++offset] * Math.pow(2, 8) +
                this[++offset];
              var lo =
                this[++offset] * Math.pow(2, 24) +
                this[++offset] * Math.pow(2, 16) +
                this[++offset] * Math.pow(2, 8) +
                last;
              return (BigInt(hi) << BigInt(32)) + BigInt(lo);
            }
          );
          Buffer.prototype.readIntLE = function readIntLE(
            offset,
            byteLength,
            noAssert
          ) {
            offset = offset >>> 0;
            byteLength = byteLength >>> 0;
            if (!noAssert) checkOffset(offset, byteLength, this.length);
            var val = this[offset];
            var mul = 1;
            var i = 0;
            while (++i < byteLength && (mul *= 0x100)) {
              val += this[offset + i] * mul;
            }
            mul *= 0x80;
            if (val >= mul) val -= Math.pow(2, 8 * byteLength);
            return val;
          };
          Buffer.prototype.readIntBE = function readIntBE(
            offset,
            byteLength,
            noAssert
          ) {
            offset = offset >>> 0;
            byteLength = byteLength >>> 0;
            if (!noAssert) checkOffset(offset, byteLength, this.length);
            var i = byteLength;
            var mul = 1;
            var val = this[offset + --i];
            while (i > 0 && (mul *= 0x100)) {
              val += this[offset + --i] * mul;
            }
            mul *= 0x80;
            if (val >= mul) val -= Math.pow(2, 8 * byteLength);
            return val;
          };
          Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 1, this.length);
            if (!(this[offset] & 0x80)) return this[offset];
            return (0xff - this[offset] + 1) * -1;
          };
          Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 2, this.length);
            var val = this[offset] | (this[offset + 1] << 8);
            return val & 0x8000 ? val | 0xffff0000 : val;
          };
          Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 2, this.length);
            var val = this[offset + 1] | (this[offset] << 8);
            return val & 0x8000 ? val | 0xffff0000 : val;
          };
          Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 4, this.length);
            return (
              this[offset] |
              (this[offset + 1] << 8) |
              (this[offset + 2] << 16) |
              (this[offset + 3] << 24)
            );
          };
          Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 4, this.length);
            return (
              (this[offset] << 24) |
              (this[offset + 1] << 16) |
              (this[offset + 2] << 8) |
              this[offset + 3]
            );
          };
          Buffer.prototype.readBigInt64LE = defineBigIntMethod(
            function readBigInt64LE(offset) {
              offset = offset >>> 0;
              validateNumber(offset, "offset");
              var first = this[offset];
              var last = this[offset + 7];
              if (first === undefined || last === undefined) {
                boundsError(offset, this.length - 8);
              }
              var val =
                this[offset + 4] +
                this[offset + 5] * Math.pow(2, 8) +
                this[offset + 6] * Math.pow(2, 16) +
                (last << 24); // Overflow
              return (
                (BigInt(val) << BigInt(32)) +
                BigInt(
                  first +
                    this[++offset] * Math.pow(2, 8) +
                    this[++offset] * Math.pow(2, 16) +
                    this[++offset] * Math.pow(2, 24)
                )
              );
            }
          );
          Buffer.prototype.readBigInt64BE = defineBigIntMethod(
            function readBigInt64BE(offset) {
              offset = offset >>> 0;
              validateNumber(offset, "offset");
              var first = this[offset];
              var last = this[offset + 7];
              if (first === undefined || last === undefined) {
                boundsError(offset, this.length - 8);
              }
              var val =
                (first << 24) + // Overflow
                this[++offset] * Math.pow(2, 16) +
                this[++offset] * Math.pow(2, 8) +
                this[++offset];
              return (
                (BigInt(val) << BigInt(32)) +
                BigInt(
                  this[++offset] * Math.pow(2, 24) +
                    this[++offset] * Math.pow(2, 16) +
                    this[++offset] * Math.pow(2, 8) +
                    last
                )
              );
            }
          );
          Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 4, this.length);
            return ieee754.read(this, offset, true, 23, 4);
          };
          Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 4, this.length);
            return ieee754.read(this, offset, false, 23, 4);
          };
          Buffer.prototype.readDoubleLE = function readDoubleLE(
            offset,
            noAssert
          ) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 8, this.length);
            return ieee754.read(this, offset, true, 52, 8);
          };
          Buffer.prototype.readDoubleBE = function readDoubleBE(
            offset,
            noAssert
          ) {
            offset = offset >>> 0;
            if (!noAssert) checkOffset(offset, 8, this.length);
            return ieee754.read(this, offset, false, 52, 8);
          };
          function checkInt(buf, value, offset, ext, max, min) {
            if (!Buffer.isBuffer(buf))
              throw new TypeError('"buffer" argument must be a Buffer instance');
            if (value > max || value < min)
              throw new RangeError('"value" argument is out of bounds');
            if (offset + ext > buf.length)
              throw new RangeError("Index out of range");
          }
          Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(
            value,
            offset,
            byteLength,
            noAssert
          ) {
            value = +value;
            offset = offset >>> 0;
            byteLength = byteLength >>> 0;
            if (!noAssert) {
              var maxBytes = Math.pow(2, 8 * byteLength) - 1;
              checkInt(this, value, offset, byteLength, maxBytes, 0);
            }
            var mul = 1;
            var i = 0;
            this[offset] = value & 0xff;
            while (++i < byteLength && (mul *= 0x100)) {
              this[offset + i] = (value / mul) & 0xff;
            }
            return offset + byteLength;
          };
          Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(
            value,
            offset,
            byteLength,
            noAssert
          ) {
            value = +value;
            offset = offset >>> 0;
            byteLength = byteLength >>> 0;
            if (!noAssert) {
              var maxBytes = Math.pow(2, 8 * byteLength) - 1;
              checkInt(this, value, offset, byteLength, maxBytes, 0);
            }
            var i = byteLength - 1;
            var mul = 1;
            this[offset + i] = value & 0xff;
            while (--i >= 0 && (mul *= 0x100)) {
              this[offset + i] = (value / mul) & 0xff;
            }
            return offset + byteLength;
          };
          Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(
            value,
            offset,
            noAssert
          ) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
            this[offset] = value & 0xff;
            return offset + 1;
          };
          Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(
            value,
            offset,
            noAssert
          ) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
            this[offset] = value & 0xff;
            this[offset + 1] = value >>> 8;
            return offset + 2;
          };
          Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(
            value,
            offset,
            noAssert
          ) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
            this[offset] = value >>> 8;
            this[offset + 1] = value & 0xff;
            return offset + 2;
          };
          Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(
            value,
            offset,
            noAssert
          ) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
            this[offset + 3] = value >>> 24;
            this[offset + 2] = value >>> 16;
            this[offset + 1] = value >>> 8;
            this[offset] = value & 0xff;
            return offset + 4;
          };
          Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(
            value,
            offset,
            noAssert
          ) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
            this[offset] = value >>> 24;
            this[offset + 1] = value >>> 16;
            this[offset + 2] = value >>> 8;
            this[offset + 3] = value & 0xff;
            return offset + 4;
          };
          function wrtBigUInt64LE(buf, value, offset, min, max) {
            checkIntBI(value, min, max, buf, offset, 7);
            var lo = Number(value & BigInt(0xffffffff));
            buf[offset++] = lo;
            lo = lo >> 8;
            buf[offset++] = lo;
            lo = lo >> 8;
            buf[offset++] = lo;
            lo = lo >> 8;
            buf[offset++] = lo;
            var hi = Number((value >> BigInt(32)) & BigInt(0xffffffff));
            buf[offset++] = hi;
            hi = hi >> 8;
            buf[offset++] = hi;
            hi = hi >> 8;
            buf[offset++] = hi;
            hi = hi >> 8;
            buf[offset++] = hi;
            return offset;
          }
          function wrtBigUInt64BE(buf, value, offset, min, max) {
            checkIntBI(value, min, max, buf, offset, 7);
            var lo = Number(value & BigInt(0xffffffff));
            buf[offset + 7] = lo;
            lo = lo >> 8;
            buf[offset + 6] = lo;
            lo = lo >> 8;
            buf[offset + 5] = lo;
            lo = lo >> 8;
            buf[offset + 4] = lo;
            var hi = Number((value >> BigInt(32)) & BigInt(0xffffffff));
            buf[offset + 3] = hi;
            hi = hi >> 8;
            buf[offset + 2] = hi;
            hi = hi >> 8;
            buf[offset + 1] = hi;
            hi = hi >> 8;
            buf[offset] = hi;
            return offset + 8;
          }
          Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(
            function writeBigUInt64LE(value) {
              var offset =
                arguments.length > 1 && arguments[1] !== undefined
                  ? arguments[1]
                  : 0;
              return wrtBigUInt64LE(
                this,
                value,
                offset,
                BigInt(0),
                BigInt("0xffffffffffffffff")
              );
            }
          );
          Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(
            function writeBigUInt64BE(value) {
              var offset =
                arguments.length > 1 && arguments[1] !== undefined
                  ? arguments[1]
                  : 0;
              return wrtBigUInt64BE(
                this,
                value,
                offset,
                BigInt(0),
                BigInt("0xffffffffffffffff")
              );
            }
          );
          Buffer.prototype.writeIntLE = function writeIntLE(
            value,
            offset,
            byteLength,
            noAssert
          ) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) {
              var limit = Math.pow(2, 8 * byteLength - 1);
              checkInt(this, value, offset, byteLength, limit - 1, -limit);
            }
            var i = 0;
            var mul = 1;
            var sub = 0;
            this[offset] = value & 0xff;
            while (++i < byteLength && (mul *= 0x100)) {
              if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
                sub = 1;
              }
              this[offset + i] = (((value / mul) >> 0) - sub) & 0xff;
            }
            return offset + byteLength;
          };
          Buffer.prototype.writeIntBE = function writeIntBE(
            value,
            offset,
            byteLength,
            noAssert
          ) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) {
              var limit = Math.pow(2, 8 * byteLength - 1);
              checkInt(this, value, offset, byteLength, limit - 1, -limit);
            }
            var i = byteLength - 1;
            var mul = 1;
            var sub = 0;
            this[offset + i] = value & 0xff;
            while (--i >= 0 && (mul *= 0x100)) {
              if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
                sub = 1;
              }
              this[offset + i] = (((value / mul) >> 0) - sub) & 0xff;
            }
            return offset + byteLength;
          };
          Buffer.prototype.writeInt8 = function writeInt8(
            value,
            offset,
            noAssert
          ) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
            if (value < 0) value = 0xff + value + 1;
            this[offset] = value & 0xff;
            return offset + 1;
          };
          Buffer.prototype.writeInt16LE = function writeInt16LE(
            value,
            offset,
            noAssert
          ) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
            this[offset] = value & 0xff;
            this[offset + 1] = value >>> 8;
            return offset + 2;
          };
          Buffer.prototype.writeInt16BE = function writeInt16BE(
            value,
            offset,
            noAssert
          ) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
            this[offset] = value >>> 8;
            this[offset + 1] = value & 0xff;
            return offset + 2;
          };
          Buffer.prototype.writeInt32LE = function writeInt32LE(
            value,
            offset,
            noAssert
          ) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert)
              checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
            this[offset] = value & 0xff;
            this[offset + 1] = value >>> 8;
            this[offset + 2] = value >>> 16;
            this[offset + 3] = value >>> 24;
            return offset + 4;
          };
          Buffer.prototype.writeInt32BE = function writeInt32BE(
            value,
            offset,
            noAssert
          ) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert)
              checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
            if (value < 0) value = 0xffffffff + value + 1;
            this[offset] = value >>> 24;
            this[offset + 1] = value >>> 16;
            this[offset + 2] = value >>> 8;
            this[offset + 3] = value & 0xff;
            return offset + 4;
          };
          Buffer.prototype.writeBigInt64LE = defineBigIntMethod(
            function writeBigInt64LE(value) {
              var offset =
                arguments.length > 1 && arguments[1] !== undefined
                  ? arguments[1]
                  : 0;
              return wrtBigUInt64LE(
                this,
                value,
                offset,
                -BigInt("0x8000000000000000"),
                BigInt("0x7fffffffffffffff")
              );
            }
          );
          Buffer.prototype.writeBigInt64BE = defineBigIntMethod(
            function writeBigInt64BE(value) {
              var offset =
                arguments.length > 1 && arguments[1] !== undefined
                  ? arguments[1]
                  : 0;
              return wrtBigUInt64BE(
                this,
                value,
                offset,
                -BigInt("0x8000000000000000"),
                BigInt("0x7fffffffffffffff")
              );
            }
          );
          function checkIEEE754(buf, value, offset, ext, max, min) {
            if (offset + ext > buf.length)
              throw new RangeError("Index out of range");
            if (offset < 0) throw new RangeError("Index out of range");
          }
          function writeFloat(buf, value, offset, littleEndian, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) {
              checkIEEE754(
                buf,
                value,
                offset,
                4,
                3.4028234663852886e38,
                -3.4028234663852886e38
              );
            }
            ieee754.write(buf, value, offset, littleEndian, 23, 4);
            return offset + 4;
          }
          Buffer.prototype.writeFloatLE = function writeFloatLE(
            value,
            offset,
            noAssert
          ) {
            return writeFloat(this, value, offset, true, noAssert);
          };
          Buffer.prototype.writeFloatBE = function writeFloatBE(
            value,
            offset,
            noAssert
          ) {
            return writeFloat(this, value, offset, false, noAssert);
          };
          function writeDouble(buf, value, offset, littleEndian, noAssert) {
            value = +value;
            offset = offset >>> 0;
            if (!noAssert) {
              checkIEEE754(
                buf,
                value,
                offset,
                8,
                1.7976931348623157e308,
                -1.7976931348623157e308
              );
            }
            ieee754.write(buf, value, offset, littleEndian, 52, 8);
            return offset + 8;
          }
          Buffer.prototype.writeDoubleLE = function writeDoubleLE(
            value,
            offset,
            noAssert
          ) {
            return writeDouble(this, value, offset, true, noAssert);
          };
          Buffer.prototype.writeDoubleBE = function writeDoubleBE(
            value,
            offset,
            noAssert
          ) {
            return writeDouble(this, value, offset, false, noAssert);
          }; // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
          Buffer.prototype.copy = function copy(target, targetStart, start, end) {
            if (!Buffer.isBuffer(target))
              throw new TypeError("argument should be a Buffer");
            if (!start) start = 0;
            if (!end && end !== 0) end = this.length;
            if (targetStart >= target.length) targetStart = target.length;
            if (!targetStart) targetStart = 0;
            if (end > 0 && end < start) end = start; // Copy 0 bytes; we're done
            if (end === start) return 0;
            if (target.length === 0 || this.length === 0) return 0; // Fatal error conditions
            if (targetStart < 0) {
              throw new RangeError("targetStart out of bounds");
            }
            if (start < 0 || start >= this.length)
              throw new RangeError("Index out of range");
            if (end < 0) throw new RangeError("sourceEnd out of bounds"); // Are we oob?
            if (end > this.length) end = this.length;
            if (target.length - targetStart < end - start) {
              end = target.length - targetStart + start;
            }
            var len = end - start;
            if (
              this === target &&
              typeof Uint8Array.prototype.copyWithin === "function"
            ) {
              // Use built-in when available, missing from IE11
              this.copyWithin(targetStart, start, end);
            } else {
              Uint8Array.prototype.set.call(
                target,
                this.subarray(start, end),
                targetStart
              );
            }
            return len;
          }; // Usage:
          //    buffer.fill(number[, offset[, end]])
          //    buffer.fill(buffer[, offset[, end]])
          //    buffer.fill(string[, offset[, end]][, encoding])
          Buffer.prototype.fill = function fill(val, start, end, encoding) {
            // Handle string cases:
            if (typeof val === "string") {
              if (typeof start === "string") {
                encoding = start;
                start = 0;
                end = this.length;
              } else if (typeof end === "string") {
                encoding = end;
                end = this.length;
              }
              if (encoding !== undefined && typeof encoding !== "string") {
                throw new TypeError("encoding must be a string");
              }
              if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) {
                throw new TypeError("Unknown encoding: " + encoding);
              }
              if (val.length === 1) {
                var code = val.charCodeAt(0);
                if (
                  (encoding === "utf8" && code < 128) ||
                  encoding === "latin1"
                ) {
                  // Fast path: If `val` fits into a single byte, use that numeric value.
                  val = code;
                }
              }
            } else if (typeof val === "number") {
              val = val & 255;
            } else if (typeof val === "boolean") {
              val = Number(val);
            } // Invalid ranges are not set to a default, so can range check early.
            if (start < 0 || this.length < start || this.length < end) {
              throw new RangeError("Out of range index");
            }
            if (end <= start) {
              return this;
            }
            start = start >>> 0;
            end = end === undefined ? this.length : end >>> 0;
            if (!val) val = 0;
            var i;
            if (typeof val === "number") {
              for (i = start; i < end; ++i) {
                this[i] = val;
              }
            } else {
              var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
              var len = bytes.length;
              if (len === 0) {
                throw new TypeError(
                  'The value "' + val + '" is invalid for argument "value"'
                );
              }
              for (i = 0; i < end - start; ++i) {
                this[i + start] = bytes[i % len];
              }
            }
            return this;
          }; // CUSTOM ERRORS
          // =============
          // Simplified versions from Node, changed for Buffer-only usage
          var errors = {};
          function E(sym, getMessage, Base) {
            errors[sym] = /*#__PURE__*/ (function (_Base2) {
              _inherits2(NodeError, _Base2);
              var _super2 = _createSuper(NodeError);
              function NodeError() {
                var _this3;
                _classCallCheck2(this, NodeError);
                _this3 = _super2.call(this);
                Object.defineProperty(
                  _assertThisInitialized2(_this3),
                  "message",
                  {
                    value: getMessage.apply(
                      _assertThisInitialized2(_this3),
                      arguments
                    ),
                    writable: true,
                    configurable: true
                  }
                ); // Add the error code to the name to include it in the stack trace.
                _this3.name = "".concat(_this3.name, " [").concat(sym, "]"); // Access the stack to generate the error message including the error code
                // from the name.
                _this3.stack; // eslint-disable-line no-unused-expressions
                // Reset the name to the actual name.
                delete _this3.name;
                return _this3;
              }
              _createClass2(NodeError, [
                {
                  key: "toString",
                  value: function toString() {
                    return ""
                      .concat(this.name, " [")
                      .concat(sym, "]: ")
                      .concat(this.message);
                  }
                },
                {
                  key: "code",
                  get: function get() {
                    return sym;
                  },
                  set: function set(value) {
                    Object.defineProperty(this, "code", {
                      configurable: true,
                      enumerable: true,
                      value: value,
                      writable: true
                    });
                  }
                }
              ]);
              return NodeError;
            })(Base);
          }
          E(
            "ERR_BUFFER_OUT_OF_BOUNDS",
            function (name) {
              if (name) {
                return "".concat(name, " is outside of buffer bounds");
              }
              return "Attempt to access memory outside buffer bounds";
            },
            RangeError
          );
          E(
            "ERR_INVALID_ARG_TYPE",
            function (name, actual) {
              return 'The "'
                .concat(name, '" argument must be of type number. Received type ')
                .concat(_typeof2(actual));
            },
            TypeError
          );
          E(
            "ERR_OUT_OF_RANGE",
            function (str, range, input) {
              var msg = 'The value of "'.concat(str, '" is out of range.');
              var received = input;
              if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) {
                received = addNumericalSeparator(String(input));
              } else if (typeof input === "bigint") {
                received = String(input);
                if (
                  input > Math.pow(BigInt(2), BigInt(32)) ||
                  input < -Math.pow(BigInt(2), BigInt(32))
                ) {
                  received = addNumericalSeparator(received);
                }
                received += "n";
              }
              msg += " It must be ".concat(range, ". Received ").concat(received);
              return msg;
            },
            RangeError
          );
          function addNumericalSeparator(val) {
            var res = "";
            var i = val.length;
            var start = val[0] === "-" ? 1 : 0;
            for (; i >= start + 4; i -= 3) {
              res = "_".concat(val.slice(i - 3, i)).concat(res);
            }
            return "".concat(val.slice(0, i)).concat(res);
          } // CHECK FUNCTIONS
          // ===============
          function checkBounds(buf, offset, byteLength) {
            validateNumber(offset, "offset");
            if (
              buf[offset] === undefined ||
              buf[offset + byteLength] === undefined
            ) {
              boundsError(offset, buf.length - (byteLength + 1));
            }
          }
          function checkIntBI(value, min, max, buf, offset, byteLength) {
            if (value > max || value < min) {
              var n = typeof min === "bigint" ? "n" : "";
              var range;
              if (byteLength > 3) {
                if (min === 0 || min === BigInt(0)) {
                  range = ">= 0"
                    .concat(n, " and < 2")
                    .concat(n, " ** ")
                    .concat((byteLength + 1) * 8)
                    .concat(n);
                } else {
                  range =
                    ">= -(2"
                      .concat(n, " ** ")
                      .concat((byteLength + 1) * 8 - 1)
                      .concat(n, ") and < 2 ** ") +
                    "".concat((byteLength + 1) * 8 - 1).concat(n);
                }
              } else {
                range = ">= "
                  .concat(min)
                  .concat(n, " and <= ")
                  .concat(max)
                  .concat(n);
              }
              throw new errors.ERR_OUT_OF_RANGE("value", range, value);
            }
            checkBounds(buf, offset, byteLength);
          }
          function validateNumber(value, name) {
            if (typeof value !== "number") {
              throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
            }
          }
          function boundsError(value, length, type) {
            if (Math.floor(value) !== value) {
              validateNumber(value, type);
              throw new errors.ERR_OUT_OF_RANGE(
                type || "offset",
                "an integer",
                value
              );
            }
            if (length < 0) {
              throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
            }
            throw new errors.ERR_OUT_OF_RANGE(
              type || "offset",
              ">= ".concat(type ? 1 : 0, " and <= ").concat(length),
              value
            );
          } // HELPER FUNCTIONS
          // ================
          var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
          function base64clean(str) {
            // Node takes equal signs as end of the Base64 encoding
            str = str.split("=")[0]; // Node strips out invalid characters like \n and \t from the string, base64-js does not
            str = str.trim().replace(INVALID_BASE64_RE, ""); // Node converts strings with length < 2 to ''
            if (str.length < 2) return ""; // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
            while (str.length % 4 !== 0) {
              str = str + "=";
            }
            return str;
          }
          function utf8ToBytes(string, units) {
            units = units || Infinity;
            var codePoint;
            var length = string.length;
            var leadSurrogate = null;
            var bytes = [];
            for (var i = 0; i < length; ++i) {
              codePoint = string.charCodeAt(i); // is surrogate component
              if (codePoint > 0xd7ff && codePoint < 0xe000) {
                // last char was a lead
                if (!leadSurrogate) {
                  // no lead yet
                  if (codePoint > 0xdbff) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xef, 0xbf, 0xbd);
                    continue;
                  } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xef, 0xbf, 0xbd);
                    continue;
                  } // valid lead
                  leadSurrogate = codePoint;
                  continue;
                } // 2 leads in a row
                if (codePoint < 0xdc00) {
                  if ((units -= 3) > -1) bytes.push(0xef, 0xbf, 0xbd);
                  leadSurrogate = codePoint;
                  continue;
                } // valid surrogate pair
                codePoint =
                  (((leadSurrogate - 0xd800) << 10) | (codePoint - 0xdc00)) +
                  0x10000;
              } else if (leadSurrogate) {
                // valid bmp char, but last char was a lead
                if ((units -= 3) > -1) bytes.push(0xef, 0xbf, 0xbd);
              }
              leadSurrogate = null; // encode utf8
              if (codePoint < 0x80) {
                if ((units -= 1) < 0) break;
                bytes.push(codePoint);
              } else if (codePoint < 0x800) {
                if ((units -= 2) < 0) break;
                bytes.push((codePoint >> 0x6) | 0xc0, (codePoint & 0x3f) | 0x80);
              } else if (codePoint < 0x10000) {
                if ((units -= 3) < 0) break;
                bytes.push(
                  (codePoint >> 0xc) | 0xe0,
                  ((codePoint >> 0x6) & 0x3f) | 0x80,
                  (codePoint & 0x3f) | 0x80
                );
              } else if (codePoint < 0x110000) {
                if ((units -= 4) < 0) break;
                bytes.push(
                  (codePoint >> 0x12) | 0xf0,
                  ((codePoint >> 0xc) & 0x3f) | 0x80,
                  ((codePoint >> 0x6) & 0x3f) | 0x80,
                  (codePoint & 0x3f) | 0x80
                );
              } else {
                throw new Error("Invalid code point");
              }
            }
            return bytes;
          }
          function asciiToBytes(str) {
            var byteArray = [];
            for (var i = 0; i < str.length; ++i) {
              // Node's code seems to be doing this and not & 0x7F..
              byteArray.push(str.charCodeAt(i) & 0xff);
            }
            return byteArray;
          }
          function utf16leToBytes(str, units) {
            var c, hi, lo;
            var byteArray = [];
            for (var i = 0; i < str.length; ++i) {
              if ((units -= 2) < 0) break;
              c = str.charCodeAt(i);
              hi = c >> 8;
              lo = c % 256;
              byteArray.push(lo);
              byteArray.push(hi);
            }
            return byteArray;
          }
          function base64ToBytes(str) {
            return base64.toByteArray(base64clean(str));
          }
          function blitBuffer(src, dst, offset, length) {
            var i;
            for (i = 0; i < length; ++i) {
              if (i + offset >= dst.length || i >= src.length) break;
              dst[i + offset] = src[i];
            }
            return i;
          } // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
          // the `instanceof` check but they should be treated as of that type.
          // See: https://github.com/feross/buffer/issues/166
          function isInstance(obj, type) {
            return (
              _instanceof(obj, type) ||
              (obj != null &&
                obj.constructor != null &&
                obj.constructor.name != null &&
                obj.constructor.name === type.name)
            );
          }
          function numberIsNaN(obj) {
            // For IE11 support
            return obj !== obj; // eslint-disable-line no-self-compare
          } // Create lookup table for `toString('hex')`
          // See: https://github.com/feross/buffer/issues/219
          var hexSliceLookupTable = (function () {
            var alphabet = "0123456789abcdef";
            var table = new Array(256);
            for (var i = 0; i < 16; ++i) {
              var i16 = i * 16;
              for (var j = 0; j < 16; ++j) {
                table[i16 + j] = alphabet[i] + alphabet[j];
              }
            }
            return table;
          })(); // Return not function with Error if BigInt not supported
          function defineBigIntMethod(fn) {
            return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
          }
          function BufferBigIntNotDefined() {
            throw new Error("BigInt not supported");
          }
        },
        {
          "base64-js": "6bdeb48eeba9cd042d882728ed0243fd",
          ieee754: "bad534271a686d81ed8bb4a2a357f146"
        }
      ],
      "6bdeb48eeba9cd042d882728ed0243fd": [
        function (require, module, exports) {
          "use strict";
          exports.byteLength = byteLength;
          exports.toByteArray = toByteArray;
          exports.fromByteArray = fromByteArray;
          var lookup = [];
          var revLookup = [];
          var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
          var code =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
          for (var i = 0, len = code.length; i < len; ++i) {
            lookup[i] = code[i];
            revLookup[code.charCodeAt(i)] = i;
          } // Support decoding URL-safe base64 strings, as Node.js does.
          // See: https://en.wikipedia.org/wiki/Base64#URL_applications
          revLookup["-".charCodeAt(0)] = 62;
          revLookup["_".charCodeAt(0)] = 63;
          function getLens(b64) {
            var len = b64.length;
            if (len % 4 > 0) {
              throw new Error("Invalid string. Length must be a multiple of 4");
            } // Trim off extra bytes after placeholder bytes are found
            // See: https://github.com/beatgammit/base64-js/issues/42
            var validLen = b64.indexOf("=");
            if (validLen === -1) validLen = len;
            var placeHoldersLen = validLen === len ? 0 : 4 - (validLen % 4);
            return [validLen, placeHoldersLen];
          } // base64 is 4/3 + up to two characters of the original data
          function byteLength(b64) {
            var lens = getLens(b64);
            var validLen = lens[0];
            var placeHoldersLen = lens[1];
            return ((validLen + placeHoldersLen) * 3) / 4 - placeHoldersLen;
          }
          function _byteLength(b64, validLen, placeHoldersLen) {
            return ((validLen + placeHoldersLen) * 3) / 4 - placeHoldersLen;
          }
          function toByteArray(b64) {
            var tmp;
            var lens = getLens(b64);
            var validLen = lens[0];
            var placeHoldersLen = lens[1];
            var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
            var curByte = 0; // if there are placeholders, only get up to the last complete 4 chars
            var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
            var i;
            for (i = 0; i < len; i += 4) {
              tmp =
                (revLookup[b64.charCodeAt(i)] << 18) |
                (revLookup[b64.charCodeAt(i + 1)] << 12) |
                (revLookup[b64.charCodeAt(i + 2)] << 6) |
                revLookup[b64.charCodeAt(i + 3)];
              arr[curByte++] = (tmp >> 16) & 0xff;
              arr[curByte++] = (tmp >> 8) & 0xff;
              arr[curByte++] = tmp & 0xff;
            }
            if (placeHoldersLen === 2) {
              tmp =
                (revLookup[b64.charCodeAt(i)] << 2) |
                (revLookup[b64.charCodeAt(i + 1)] >> 4);
              arr[curByte++] = tmp & 0xff;
            }
            if (placeHoldersLen === 1) {
              tmp =
                (revLookup[b64.charCodeAt(i)] << 10) |
                (revLookup[b64.charCodeAt(i + 1)] << 4) |
                (revLookup[b64.charCodeAt(i + 2)] >> 2);
              arr[curByte++] = (tmp >> 8) & 0xff;
              arr[curByte++] = tmp & 0xff;
            }
            return arr;
          }
          function tripletToBase64(num) {
            return (
              lookup[(num >> 18) & 0x3f] +
              lookup[(num >> 12) & 0x3f] +
              lookup[(num >> 6) & 0x3f] +
              lookup[num & 0x3f]
            );
          }
          function encodeChunk(uint8, start, end) {
            var tmp;
            var output = [];
            for (var i = start; i < end; i += 3) {
              tmp =
                ((uint8[i] << 16) & 0xff0000) +
                ((uint8[i + 1] << 8) & 0xff00) +
                (uint8[i + 2] & 0xff);
              output.push(tripletToBase64(tmp));
            }
            return output.join("");
          }
          function fromByteArray(uint8) {
            var tmp;
            var len = uint8.length;
            var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
            var parts = [];
            var maxChunkLength = 16383; // must be multiple of 3
            // go through the array every three bytes, we'll deal with trailing stuff later
            for (
              var i = 0, len2 = len - extraBytes;
              i < len2;
              i += maxChunkLength
            ) {
              parts.push(
                encodeChunk(
                  uint8,
                  i,
                  i + maxChunkLength > len2 ? len2 : i + maxChunkLength
                )
              );
            } // pad the end with zeros, but make sure to not forget the extra bytes
            if (extraBytes === 1) {
              tmp = uint8[len - 1];
              parts.push(lookup[tmp >> 2] + lookup[(tmp << 4) & 0x3f] + "==");
            } else if (extraBytes === 2) {
              tmp = (uint8[len - 2] << 8) + uint8[len - 1];
              parts.push(
                lookup[tmp >> 10] +
                  lookup[(tmp >> 4) & 0x3f] +
                  lookup[(tmp << 2) & 0x3f] +
                  "="
              );
            }
            return parts.join("");
          }
        },
        {}
      ],
      bad534271a686d81ed8bb4a2a357f146: [
        function (require, module, exports) {
          exports.read = function (buffer, offset, isLE, mLen, nBytes) {
            var e, m;
            var eLen = nBytes * 8 - mLen - 1;
            var eMax = (1 << eLen) - 1;
            var eBias = eMax >> 1;
            var nBits = -7;
            var i = isLE ? nBytes - 1 : 0;
            var d = isLE ? -1 : 1;
            var s = buffer[offset + i];
            i += d;
            e = s & ((1 << -nBits) - 1);
            s >>= -nBits;
            nBits += eLen;
            for (
              ;
              nBits > 0;
              e = e * 256 + buffer[offset + i], i += d, nBits -= 8
            ) {}
            m = e & ((1 << -nBits) - 1);
            e >>= -nBits;
            nBits += mLen;
            for (
              ;
              nBits > 0;
              m = m * 256 + buffer[offset + i], i += d, nBits -= 8
            ) {}
            if (e === 0) {
              e = 1 - eBias;
            } else if (e === eMax) {
              return m ? NaN : (s ? -1 : 1) * Infinity;
            } else {
              m = m + Math.pow(2, mLen);
              e = e - eBias;
            }
            return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
          };
          exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
            var e, m, c;
            var eLen = nBytes * 8 - mLen - 1;
            var eMax = (1 << eLen) - 1;
            var eBias = eMax >> 1;
            var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
            var i = isLE ? 0 : nBytes - 1;
            var d = isLE ? 1 : -1;
            var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;
            value = Math.abs(value);
            if (isNaN(value) || value === Infinity) {
              m = isNaN(value) ? 1 : 0;
              e = eMax;
            } else {
              e = Math.floor(Math.log(value) / Math.LN2);
              if (value * (c = Math.pow(2, -e)) < 1) {
                e--;
                c *= 2;
              }
              if (e + eBias >= 1) {
                value += rt / c;
              } else {
                value += rt * Math.pow(2, 1 - eBias);
              }
              if (value * c >= 2) {
                e++;
                c /= 2;
              }
              if (e + eBias >= eMax) {
                m = 0;
                e = eMax;
              } else if (e + eBias >= 1) {
                m = (value * c - 1) * Math.pow(2, mLen);
                e = e + eBias;
              } else {
                m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
                e = 0;
              }
            }
            for (
              ;
              mLen >= 8;
              buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8
            ) {}
            e = (e << mLen) | m;
            eLen += mLen;
            for (
              ;
              eLen > 0;
              buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8
            ) {}
            buffer[offset + i - d] |= s * 128;
          };
        },
        {}
      ],
      afff7b3d3d8d99252449144a624c3663: [
        function (require, module, exports) {
          "use strict";
          var assert = require("assert");
          var coretypes_1 = require("./coretypes");
          var ledger_hashes_1 = require("./ledger-hashes");
          var signingData = coretypes_1.binary.signingData,
            signingClaimData = coretypes_1.binary.signingClaimData,
            multiSigningData = coretypes_1.binary.multiSigningData,
            binaryToJSON = coretypes_1.binary.binaryToJSON,
            serializeObject = coretypes_1.binary.serializeObject;
          /**
           * Decode a transaction
           *
           * @param binary hex-string of the encoded transaction
           * @returns the JSON representation of the transaction
           */ function decode(binary) {
            assert(typeof binary === "string", "binary must be a hex string");
            return binaryToJSON(binary);
          }
          /**
           * Encode a transaction
           *
           * @param json The JSON representation of a transaction
           * @returns A hex-string of the encoded transaction
           */ function encode(json) {
            assert(_typeof2(json) === "object");
            return serializeObject(json).toString("hex").toUpperCase();
          }
          /**
           * Encode a transaction and prepare for signing
           *
           * @param json JSON object representing the transaction
           * @param signer string representing the account to sign the transaction with
           * @returns a hex string of the encoded transaction
           */ function encodeForSigning(json) {
            assert(_typeof2(json) === "object");
            return signingData(json).toString("hex").toUpperCase();
          }
          /**
           * Encode a transaction and prepare for signing with a claim
           *
           * @param json JSON object representing the transaction
           * @param signer string representing the account to sign the transaction with
           * @returns a hex string of the encoded transaction
           */ function encodeForSigningClaim(json) {
            assert(_typeof2(json) === "object");
            return signingClaimData(json).toString("hex").toUpperCase();
          }
          /**
           * Encode a transaction and prepare for multi-signing
           *
           * @param json JSON object representing the transaction
           * @param signer string representing the account to sign the transaction with
           * @returns a hex string of the encoded transaction
           */ function encodeForMultisigning(json, signer) {
            assert(_typeof2(json) === "object");
            assert.equal(json["SigningPubKey"], "");
            return multiSigningData(json, signer).toString("hex").toUpperCase();
          }
          /**
           * Encode a quality value
           *
           * @param value string representation of a number
           * @returns a hex-string representing the quality
           */ function encodeQuality(value) {
            assert(typeof value === "string");
            return coretypes_1.quality
              .encode(value)
              .toString("hex")
              .toUpperCase();
          }
          /**
           * Decode a quality value
           *
           * @param value hex-string of a quality
           * @returns a string representing the quality
           */ function decodeQuality(value) {
            assert(typeof value === "string");
            return coretypes_1.quality.decode(value).toString();
          }
          module.exports = {
            decode: decode,
            encode: encode,
            encodeForSigning: encodeForSigning,
            encodeForSigningClaim: encodeForSigningClaim,
            encodeForMultisigning: encodeForMultisigning,
            encodeQuality: encodeQuality,
            decodeQuality: decodeQuality,
            decodeLedgerData: ledger_hashes_1.decodeLedgerData
          };
        },
        {
          assert: "cdcb67ab5f6acbeabe6d878ee73d6e25",
          "./coretypes": "26538967e1aaac4012759f537e3a1243",
          "./ledger-hashes": "8409c82d684e65900f24b69e56e3520e"
        }
      ],
      cdcb67ab5f6acbeabe6d878ee73d6e25: [
        function (require, module, exports) {
          // Currently in sync with Node.js lib/assert.js
          // https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
          // Originally from narwhal.js (http://narwhaljs.org)
          // Copyright (c) 2009 Thomas Robinson <280north.com>
          //
          // Permission is hereby granted, free of charge, to any person obtaining a copy
          // of this software and associated documentation files (the 'Software'), to
          // deal in the Software without restriction, including without limitation the
          // rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
          // sell copies of the Software, and to permit persons to whom the Software is
          // furnished to do so, subject to the following conditions:
          //
          // The above copyright notice and this permission notice shall be included in
          // all copies or substantial portions of the Software.
          //
          // THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
          // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
          // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
          // AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
          // ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
          // WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          "use strict";
          var process = require("process");
          function _typeof(obj) {
            if (
              typeof Symbol === "function" &&
              _typeof2(Symbol.iterator) === "symbol"
            ) {
              _typeof = function _typeof(obj) {
                return _typeof2(obj);
              };
            } else {
              _typeof = function _typeof(obj) {
                return obj &&
                  typeof Symbol === "function" &&
                  obj.constructor === Symbol &&
                  obj !== Symbol.prototype
                  ? "symbol"
                  : _typeof2(obj);
              };
            }
            return _typeof(obj);
          }
          function _classCallCheck(instance, Constructor) {
            if (!_instanceof(instance, Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          var _require = require("./internal/errors"),
            _require$codes = _require.codes,
            ERR_AMBIGUOUS_ARGUMENT = _require$codes.ERR_AMBIGUOUS_ARGUMENT,
            ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
            ERR_INVALID_ARG_VALUE = _require$codes.ERR_INVALID_ARG_VALUE,
            ERR_INVALID_RETURN_VALUE = _require$codes.ERR_INVALID_RETURN_VALUE,
            ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS;
          var AssertionError = require("./internal/assert/assertion_error");
          var _require2 = require("util/"),
            inspect = _require2.inspect;
          var _require$types = require("util/").types,
            isPromise = _require$types.isPromise,
            isRegExp = _require$types.isRegExp;
          var objectAssign = Object.assign
            ? Object.assign
            : require("es6-object-assign").assign;
          var objectIs = Object.is ? Object.is : require("object-is");
          var errorCache = new Map();
          var isDeepEqual;
          var isDeepStrictEqual;
          var parseExpressionAt;
          var findNodeAround;
          var decoder;
          function lazyLoadComparison() {
            var comparison = require("./internal/util/comparisons");
            isDeepEqual = comparison.isDeepEqual;
            isDeepStrictEqual = comparison.isDeepStrictEqual;
          } // Escape control characters but not \n and \t to keep the line breaks and
          // indentation intact.
          // eslint-disable-next-line no-control-regex
          var escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
          var meta = [
            "\\u0000",
            "\\u0001",
            "\\u0002",
            "\\u0003",
            "\\u0004",
            "\\u0005",
            "\\u0006",
            "\\u0007",
            "\\b",
            "",
            "",
            "\\u000b",
            "\\f",
            "",
            "\\u000e",
            "\\u000f",
            "\\u0010",
            "\\u0011",
            "\\u0012",
            "\\u0013",
            "\\u0014",
            "\\u0015",
            "\\u0016",
            "\\u0017",
            "\\u0018",
            "\\u0019",
            "\\u001a",
            "\\u001b",
            "\\u001c",
            "\\u001d",
            "\\u001e",
            "\\u001f"
          ];
          var escapeFn = function escapeFn(str) {
            return meta[str.charCodeAt(0)];
          };
          var warned = false; // The assert module provides functions that throw
          // AssertionError's when particular conditions are not met. The
          // assert module must conform to the following interface.
          var assert = (module.exports = ok);
          var NO_EXCEPTION_SENTINEL = {}; // All of the following functions must throw an AssertionError
          // when a corresponding condition is not met, with a message that
          // may be undefined if not provided. All assertion methods provide
          // both the actual and expected values to the assertion error for
          // display purposes.
          function innerFail(obj) {
            if (_instanceof(obj.message, Error)) throw obj.message;
            throw new AssertionError(obj);
          }
          function fail(actual, expected, message, operator, stackStartFn) {
            var argsLen = arguments.length;
            var internalMessage;
            if (argsLen === 0) {
              internalMessage = "Failed";
            } else if (argsLen === 1) {
              message = actual;
              actual = undefined;
            } else {
              if (warned === false) {
                warned = true;
                var warn = process.emitWarning
                  ? process.emitWarning
                  : console.warn.bind(console);
                warn(
                  "assert.fail() with more than one argument is deprecated. " +
                    "Please use assert.strictEqual() instead or only pass a message.",
                  "DeprecationWarning",
                  "DEP0094"
                );
              }
              if (argsLen === 2) operator = "!=";
            }
            if (_instanceof(message, Error)) throw message;
            var errArgs = {
              actual: actual,
              expected: expected,
              operator: operator === undefined ? "fail" : operator,
              stackStartFn: stackStartFn || fail
            };
            if (message !== undefined) {
              errArgs.message = message;
            }
            var err = new AssertionError(errArgs);
            if (internalMessage) {
              err.message = internalMessage;
              err.generatedMessage = true;
            }
            throw err;
          }
          assert.fail = fail; // The AssertionError is defined in internal/error.
          assert.AssertionError = AssertionError;
          function innerOk(fn, argLen, value, message) {
            if (!value) {
              var generatedMessage = false;
              if (argLen === 0) {
                generatedMessage = true;
                message = "No value argument passed to `assert.ok()`";
              } else if (_instanceof(message, Error)) {
                throw message;
              }
              var err = new AssertionError({
                actual: value,
                expected: true,
                message: message,
                operator: "==",
                stackStartFn: fn
              });
              err.generatedMessage = generatedMessage;
              throw err;
            }
          } // Pure assertion tests whether a value is truthy, as determined
          // by !!value.
          function ok() {
            for (
              var _len = arguments.length, args = new Array(_len), _key = 0;
              _key < _len;
              _key++
            ) {
              args[_key] = arguments[_key];
            }
            innerOk.apply(void 0, [ok, args.length].concat(args));
          }
          assert.ok = ok; // The equality assertion tests shallow, coercive equality with ==.
          /* eslint-disable no-restricted-properties */ assert.equal = function equal(
            actual,
            expected,
            message
          ) {
            if (arguments.length < 2) {
              throw new ERR_MISSING_ARGS("actual", "expected");
            } // eslint-disable-next-line eqeqeq
            if (actual != expected) {
              innerFail({
                actual: actual,
                expected: expected,
                message: message,
                operator: "==",
                stackStartFn: equal
              });
            }
          }; // The non-equality assertion tests for whether two objects are not
          // equal with !=.
          assert.notEqual = function notEqual(actual, expected, message) {
            if (arguments.length < 2) {
              throw new ERR_MISSING_ARGS("actual", "expected");
            } // eslint-disable-next-line eqeqeq
            if (actual == expected) {
              innerFail({
                actual: actual,
                expected: expected,
                message: message,
                operator: "!=",
                stackStartFn: notEqual
              });
            }
          }; // The equivalence assertion tests a deep equality relation.
          assert.deepEqual = function deepEqual(actual, expected, message) {
            if (arguments.length < 2) {
              throw new ERR_MISSING_ARGS("actual", "expected");
            }
            if (isDeepEqual === undefined) lazyLoadComparison();
            if (!isDeepEqual(actual, expected)) {
              innerFail({
                actual: actual,
                expected: expected,
                message: message,
                operator: "deepEqual",
                stackStartFn: deepEqual
              });
            }
          }; // The non-equivalence assertion tests for any deep inequality.
          assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
            if (arguments.length < 2) {
              throw new ERR_MISSING_ARGS("actual", "expected");
            }
            if (isDeepEqual === undefined) lazyLoadComparison();
            if (isDeepEqual(actual, expected)) {
              innerFail({
                actual: actual,
                expected: expected,
                message: message,
                operator: "notDeepEqual",
                stackStartFn: notDeepEqual
              });
            }
          };
          /* eslint-enable */ assert.deepStrictEqual = function deepStrictEqual(
            actual,
            expected,
            message
          ) {
            if (arguments.length < 2) {
              throw new ERR_MISSING_ARGS("actual", "expected");
            }
            if (isDeepEqual === undefined) lazyLoadComparison();
            if (!isDeepStrictEqual(actual, expected)) {
              innerFail({
                actual: actual,
                expected: expected,
                message: message,
                operator: "deepStrictEqual",
                stackStartFn: deepStrictEqual
              });
            }
          };
          assert.notDeepStrictEqual = notDeepStrictEqual;
          function notDeepStrictEqual(actual, expected, message) {
            if (arguments.length < 2) {
              throw new ERR_MISSING_ARGS("actual", "expected");
            }
            if (isDeepEqual === undefined) lazyLoadComparison();
            if (isDeepStrictEqual(actual, expected)) {
              innerFail({
                actual: actual,
                expected: expected,
                message: message,
                operator: "notDeepStrictEqual",
                stackStartFn: notDeepStrictEqual
              });
            }
          }
          assert.strictEqual = function strictEqual(actual, expected, message) {
            if (arguments.length < 2) {
              throw new ERR_MISSING_ARGS("actual", "expected");
            }
            if (!objectIs(actual, expected)) {
              innerFail({
                actual: actual,
                expected: expected,
                message: message,
                operator: "strictEqual",
                stackStartFn: strictEqual
              });
            }
          };
          assert.notStrictEqual = function notStrictEqual(
            actual,
            expected,
            message
          ) {
            if (arguments.length < 2) {
              throw new ERR_MISSING_ARGS("actual", "expected");
            }
            if (objectIs(actual, expected)) {
              innerFail({
                actual: actual,
                expected: expected,
                message: message,
                operator: "notStrictEqual",
                stackStartFn: notStrictEqual
              });
            }
          };
          var Comparison = function Comparison(obj, keys, actual) {
            var _this = this;
            _classCallCheck(this, Comparison);
            keys.forEach(function (key) {
              if (key in obj) {
                if (
                  actual !== undefined &&
                  typeof actual[key] === "string" &&
                  isRegExp(obj[key]) &&
                  obj[key].test(actual[key])
                ) {
                  _this[key] = actual[key];
                } else {
                  _this[key] = obj[key];
                }
              }
            });
          };
          function compareExceptionKey(actual, expected, key, message, keys, fn) {
            if (
              !(key in actual) ||
              !isDeepStrictEqual(actual[key], expected[key])
            ) {
              if (!message) {
                // Create placeholder objects to create a nice output.
                var a = new Comparison(actual, keys);
                var b = new Comparison(expected, keys, actual);
                var err = new AssertionError({
                  actual: a,
                  expected: b,
                  operator: "deepStrictEqual",
                  stackStartFn: fn
                });
                err.actual = actual;
                err.expected = expected;
                err.operator = fn.name;
                throw err;
              }
              innerFail({
                actual: actual,
                expected: expected,
                message: message,
                operator: fn.name,
                stackStartFn: fn
              });
            }
          }
          function expectedException(actual, expected, msg, fn) {
            if (typeof expected !== "function") {
              if (isRegExp(expected)) return expected.test(actual); // assert.doesNotThrow does not accept objects.
              if (arguments.length === 2) {
                throw new ERR_INVALID_ARG_TYPE(
                  "expected",
                  ["Function", "RegExp"],
                  expected
                );
              } // Handle primitives properly.
              if (_typeof(actual) !== "object" || actual === null) {
                var err = new AssertionError({
                  actual: actual,
                  expected: expected,
                  message: msg,
                  operator: "deepStrictEqual",
                  stackStartFn: fn
                });
                err.operator = fn.name;
                throw err;
              }
              var keys = Object.keys(expected); // Special handle errors to make sure the name and the message are compared
              // as well.
              if (_instanceof(expected, Error)) {
                keys.push("name", "message");
              } else if (keys.length === 0) {
                throw new ERR_INVALID_ARG_VALUE(
                  "error",
                  expected,
                  "may not be an empty object"
                );
              }
              if (isDeepEqual === undefined) lazyLoadComparison();
              keys.forEach(function (key) {
                if (
                  typeof actual[key] === "string" &&
                  isRegExp(expected[key]) &&
                  expected[key].test(actual[key])
                ) {
                  return;
                }
                compareExceptionKey(actual, expected, key, msg, keys, fn);
              });
              return true;
            } // Guard instanceof against arrow functions as they don't have a prototype.
            if (
              expected.prototype !== undefined &&
              _instanceof(actual, expected)
            ) {
              return true;
            }
            if (Error.isPrototypeOf(expected)) {
              return false;
            }
            return expected.call({}, actual) === true;
          }
          function getActual(fn) {
            if (typeof fn !== "function") {
              throw new ERR_INVALID_ARG_TYPE("fn", "Function", fn);
            }
            try {
              fn();
            } catch (e) {
              return e;
            }
            return NO_EXCEPTION_SENTINEL;
          }
          function checkIsPromise(obj) {
            // Accept native ES6 promises and promises that are implemented in a similar
            // way. Do not accept thenables that use a function as `obj` and that have no
            // `catch` handler.
            // TODO: thenables are checked up until they have the correct methods,
            // but according to documentation, the `then` method should receive
            // the `fulfill` and `reject` arguments as well or it may be never resolved.
            return (
              isPromise(obj) ||
              (obj !== null &&
                _typeof(obj) === "object" &&
                typeof obj.then === "function" &&
                typeof obj.catch === "function")
            );
          }
          function waitForActual(promiseFn) {
            return Promise.resolve().then(function () {
              var resultPromise;
              if (typeof promiseFn === "function") {
                // Return a rejected promise if `promiseFn` throws synchronously.
                resultPromise = promiseFn(); // Fail in case no promise is returned.
                if (!checkIsPromise(resultPromise)) {
                  throw new ERR_INVALID_RETURN_VALUE(
                    "instance of Promise",
                    "promiseFn",
                    resultPromise
                  );
                }
              } else if (checkIsPromise(promiseFn)) {
                resultPromise = promiseFn;
              } else {
                throw new ERR_INVALID_ARG_TYPE(
                  "promiseFn",
                  ["Function", "Promise"],
                  promiseFn
                );
              }
              return Promise.resolve()
                .then(function () {
                  return resultPromise;
                })
                .then(function () {
                  return NO_EXCEPTION_SENTINEL;
                })
                .catch(function (e) {
                  return e;
                });
            });
          }
          function expectsError(stackStartFn, actual, error, message) {
            if (typeof error === "string") {
              if (arguments.length === 4) {
                throw new ERR_INVALID_ARG_TYPE(
                  "error",
                  ["Object", "Error", "Function", "RegExp"],
                  error
                );
              }
              if (_typeof(actual) === "object" && actual !== null) {
                if (actual.message === error) {
                  throw new ERR_AMBIGUOUS_ARGUMENT(
                    "error/message",
                    'The error message "'.concat(
                      actual.message,
                      '" is identical to the message.'
                    )
                  );
                }
              } else if (actual === error) {
                throw new ERR_AMBIGUOUS_ARGUMENT(
                  "error/message",
                  'The error "'.concat(actual, '" is identical to the message.')
                );
              }
              message = error;
              error = undefined;
            } else if (
              error != null &&
              _typeof(error) !== "object" &&
              typeof error !== "function"
            ) {
              throw new ERR_INVALID_ARG_TYPE(
                "error",
                ["Object", "Error", "Function", "RegExp"],
                error
              );
            }
            if (actual === NO_EXCEPTION_SENTINEL) {
              var details = "";
              if (error && error.name) {
                details += " (".concat(error.name, ")");
              }
              details += message ? ": ".concat(message) : ".";
              var fnType =
                stackStartFn.name === "rejects" ? "rejection" : "exception";
              innerFail({
                actual: undefined,
                expected: error,
                operator: stackStartFn.name,
                message: "Missing expected ".concat(fnType).concat(details),
                stackStartFn: stackStartFn
              });
            }
            if (
              error &&
              !expectedException(actual, error, message, stackStartFn)
            ) {
              throw actual;
            }
          }
          function expectsNoError(stackStartFn, actual, error, message) {
            if (actual === NO_EXCEPTION_SENTINEL) return;
            if (typeof error === "string") {
              message = error;
              error = undefined;
            }
            if (!error || expectedException(actual, error)) {
              var details = message ? ": ".concat(message) : ".";
              var fnType =
                stackStartFn.name === "doesNotReject" ? "rejection" : "exception";
              innerFail({
                actual: actual,
                expected: error,
                operator: stackStartFn.name,
                message:
                  "Got unwanted ".concat(fnType).concat(details, "\n") +
                  'Actual message: "'.concat(actual && actual.message, '"'),
                stackStartFn: stackStartFn
              });
            }
            throw actual;
          }
          assert.throws = function throws(promiseFn) {
            for (
              var _len2 = arguments.length,
                args = new Array(_len2 > 1 ? _len2 - 1 : 0),
                _key2 = 1;
              _key2 < _len2;
              _key2++
            ) {
              args[_key2 - 1] = arguments[_key2];
            }
            expectsError.apply(
              void 0,
              [throws, getActual(promiseFn)].concat(args)
            );
          };
          assert.rejects = function rejects(promiseFn) {
            for (
              var _len3 = arguments.length,
                args = new Array(_len3 > 1 ? _len3 - 1 : 0),
                _key3 = 1;
              _key3 < _len3;
              _key3++
            ) {
              args[_key3 - 1] = arguments[_key3];
            }
            return waitForActual(promiseFn).then(function (result) {
              return expectsError.apply(void 0, [rejects, result].concat(args));
            });
          };
          assert.doesNotThrow = function doesNotThrow(fn) {
            for (
              var _len4 = arguments.length,
                args = new Array(_len4 > 1 ? _len4 - 1 : 0),
                _key4 = 1;
              _key4 < _len4;
              _key4++
            ) {
              args[_key4 - 1] = arguments[_key4];
            }
            expectsNoError.apply(
              void 0,
              [doesNotThrow, getActual(fn)].concat(args)
            );
          };
          assert.doesNotReject = function doesNotReject(fn) {
            for (
              var _len5 = arguments.length,
                args = new Array(_len5 > 1 ? _len5 - 1 : 0),
                _key5 = 1;
              _key5 < _len5;
              _key5++
            ) {
              args[_key5 - 1] = arguments[_key5];
            }
            return waitForActual(fn).then(function (result) {
              return expectsNoError.apply(
                void 0,
                [doesNotReject, result].concat(args)
              );
            });
          };
          assert.ifError = function ifError(err) {
            if (err !== null && err !== undefined) {
              var message = "ifError got unwanted exception: ";
              if (_typeof(err) === "object" && typeof err.message === "string") {
                if (err.message.length === 0 && err.constructor) {
                  message += err.constructor.name;
                } else {
                  message += err.message;
                }
              } else {
                message += inspect(err);
              }
              var newErr = new AssertionError({
                actual: err,
                expected: null,
                operator: "ifError",
                message: message,
                stackStartFn: ifError
              }); // Make sure we actually have a stack trace!
              var origStack = err.stack;
              if (typeof origStack === "string") {
                // This will remove any duplicated frames from the error frames taken
                // from within `ifError` and add the original error frames to the newly
                // created ones.
                var tmp2 = origStack.split("\n");
                tmp2.shift(); // Filter all frames existing in err.stack.
                var tmp1 = newErr.stack.split("\n");
                for (var i = 0; i < tmp2.length; i++) {
                  // Find the first occurrence of the frame.
                  var pos = tmp1.indexOf(tmp2[i]);
                  if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                  }
                }
                newErr.stack = ""
                  .concat(tmp1.join("\n"), "\n")
                  .concat(tmp2.join("\n"));
              }
              throw newErr;
            }
          }; // Expose a strict only variant of assert
          function strict() {
            for (
              var _len6 = arguments.length, args = new Array(_len6), _key6 = 0;
              _key6 < _len6;
              _key6++
            ) {
              args[_key6] = arguments[_key6];
            }
            innerOk.apply(void 0, [strict, args.length].concat(args));
          }
          assert.strict = objectAssign(strict, assert, {
            equal: assert.strictEqual,
            deepEqual: assert.deepStrictEqual,
            notEqual: assert.notStrictEqual,
            notDeepEqual: assert.notDeepStrictEqual
          });
          assert.strict.strict = assert.strict;
        },
        {
          process: "ec0e1432c6522aad9b4b16c4b3b080f4",
          "./internal/errors": "e3df48c6765df2e893a51bdb2215d1da",
          "./internal/assert/assertion_error": "6ccc58afafec3074c6dc49c66a0a0358",
          "util/": "ea7cbe466cf2ea1251a276e89980c958",
          "es6-object-assign": "eceeeccfb91751c1711e67f92616a0bf",
          "object-is": "bab75db18635ed9619713d116b72d21d",
          "./internal/util/comparisons": "83018a296d9e8eb8cf843b2dd7659a9e"
        }
      ],
      ec0e1432c6522aad9b4b16c4b3b080f4: [
        function (require, module, exports) {
          // shim for using process in browser
          var process = (module.exports = {}); // cached from whatever global is present so that test runners that stub it
          // don't break things.  But we need to wrap it in a try catch in case it is
          // wrapped in strict mode code which doesn't define any globals.  It's inside a
          // function because try/catches deoptimize in certain engines.
          var cachedSetTimeout;
          var cachedClearTimeout;
          function defaultSetTimout() {
            throw new Error("setTimeout has not been defined");
          }
          function defaultClearTimeout() {
            throw new Error("clearTimeout has not been defined");
          }
          (function () {
            try {
              if (typeof setTimeout === "function") {
                cachedSetTimeout = setTimeout;
              } else {
                cachedSetTimeout = defaultSetTimout;
              }
            } catch (e) {
              cachedSetTimeout = defaultSetTimout;
            }
            try {
              if (typeof clearTimeout === "function") {
                cachedClearTimeout = clearTimeout;
              } else {
                cachedClearTimeout = defaultClearTimeout;
              }
            } catch (e) {
              cachedClearTimeout = defaultClearTimeout;
            }
          })();
          function runTimeout(fun) {
            if (cachedSetTimeout === setTimeout) {
              //normal enviroments in sane situations
              return setTimeout(fun, 0);
            } // if setTimeout wasn't available but was latter defined
            if (
              (cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) &&
              setTimeout
            ) {
              cachedSetTimeout = setTimeout;
              return setTimeout(fun, 0);
            }
            try {
              // when when somebody has screwed with setTimeout but no I.E. maddness
              return cachedSetTimeout(fun, 0);
            } catch (e) {
              try {
                // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                return cachedSetTimeout.call(null, fun, 0);
              } catch (e) {
                // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                return cachedSetTimeout.call(this, fun, 0);
              }
            }
          }
          function runClearTimeout(marker) {
            if (cachedClearTimeout === clearTimeout) {
              //normal enviroments in sane situations
              return clearTimeout(marker);
            } // if clearTimeout wasn't available but was latter defined
            if (
              (cachedClearTimeout === defaultClearTimeout ||
                !cachedClearTimeout) &&
              clearTimeout
            ) {
              cachedClearTimeout = clearTimeout;
              return clearTimeout(marker);
            }
            try {
              // when when somebody has screwed with setTimeout but no I.E. maddness
              return cachedClearTimeout(marker);
            } catch (e) {
              try {
                // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                return cachedClearTimeout.call(null, marker);
              } catch (e) {
                // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                return cachedClearTimeout.call(this, marker);
              }
            }
          }
          var queue = [];
          var draining = false;
          var currentQueue;
          var queueIndex = -1;
          function cleanUpNextTick() {
            if (!draining || !currentQueue) {
              return;
            }
            draining = false;
            if (currentQueue.length) {
              queue = currentQueue.concat(queue);
            } else {
              queueIndex = -1;
            }
            if (queue.length) {
              drainQueue();
            }
          }
          function drainQueue() {
            if (draining) {
              return;
            }
            var timeout = runTimeout(cleanUpNextTick);
            draining = true;
            var len = queue.length;
            while (len) {
              currentQueue = queue;
              queue = [];
              while (++queueIndex < len) {
                if (currentQueue) {
                  currentQueue[queueIndex].run();
                }
              }
              queueIndex = -1;
              len = queue.length;
            }
            currentQueue = null;
            draining = false;
            runClearTimeout(timeout);
          }
          process.nextTick = function (fun) {
            var args = new Array(arguments.length - 1);
            if (arguments.length > 1) {
              for (var i = 1; i < arguments.length; i++) {
                args[i - 1] = arguments[i];
              }
            }
            queue.push(new Item(fun, args));
            if (queue.length === 1 && !draining) {
              runTimeout(drainQueue);
            }
          }; // v8 likes predictible objects
          function Item(fun, array) {
            this.fun = fun;
            this.array = array;
          }
          Item.prototype.run = function () {
            this.fun.apply(null, this.array);
          };
          process.title = "browser";
          process.browser = true;
          process.env = {};
          process.argv = [];
          process.version = ""; // empty string to avoid regexp issues
          process.versions = {};
          function noop() {}
          process.on = noop;
          process.addListener = noop;
          process.once = noop;
          process.off = noop;
          process.removeListener = noop;
          process.removeAllListeners = noop;
          process.emit = noop;
          process.prependListener = noop;
          process.prependOnceListener = noop;
          process.listeners = function (name) {
            return [];
          };
          process.binding = function (name) {
            throw new Error("process.binding is not supported");
          };
          process.cwd = function () {
            return "/";
          };
          process.chdir = function (dir) {
            throw new Error("process.chdir is not supported");
          };
          process.umask = function () {
            return 0;
          };
        },
        {}
      ],
      e3df48c6765df2e893a51bdb2215d1da: [
        function (require, module, exports) {
          // Currently in sync with Node.js lib/internal/errors.js
          // https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
          /* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ "use strict"; // The whole point behind this internal module is to allow Node.js to no
          // longer be forced to treat every error message change as a semver-major
          // change. The NodeError classes here all expose a `code` property whose
          // value statically and permanently identifies the error. While the error
          // message may change, the code should not.
          function _typeof(obj) {
            if (
              typeof Symbol === "function" &&
              _typeof2(Symbol.iterator) === "symbol"
            ) {
              _typeof = function _typeof(obj) {
                return _typeof2(obj);
              };
            } else {
              _typeof = function _typeof(obj) {
                return obj &&
                  typeof Symbol === "function" &&
                  obj.constructor === Symbol &&
                  obj !== Symbol.prototype
                  ? "symbol"
                  : _typeof2(obj);
              };
            }
            return _typeof(obj);
          }
          function _classCallCheck(instance, Constructor) {
            if (!_instanceof(instance, Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self, call) {
            if (
              call &&
              (_typeof(call) === "object" || typeof call === "function")
            ) {
              return call;
            }
            return _assertThisInitialized(self);
          }
          function _assertThisInitialized(self) {
            if (self === void 0) {
              throw new ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            }
            return self;
          }
          function _getPrototypeOf(o) {
            _getPrototypeOf = Object.setPrototypeOf
              ? Object.getPrototypeOf
              : function _getPrototypeOf(o) {
                  return o.__proto__ || Object.getPrototypeOf(o);
                };
            return _getPrototypeOf(o);
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError(
                "Super expression must either be null or a function"
              );
            }
            subClass.prototype = Object.create(
              superClass && superClass.prototype,
              {
                constructor: {
                  value: subClass,
                  writable: true,
                  configurable: true
                }
              }
            );
            if (superClass) _setPrototypeOf(subClass, superClass);
          }
          function _setPrototypeOf(o, p) {
            _setPrototypeOf =
              Object.setPrototypeOf ||
              function _setPrototypeOf(o, p) {
                o.__proto__ = p;
                return o;
              };
            return _setPrototypeOf(o, p);
          }
          var codes = {}; // Lazy loaded
          var assert;
          var util;
          function createErrorType(code, message, Base) {
            if (!Base) {
              Base = Error;
            }
            function getMessage(arg1, arg2, arg3) {
              if (typeof message === "string") {
                return message;
              } else {
                return message(arg1, arg2, arg3);
              }
            }
            var NodeError = /*#__PURE__*/ (function (_Base) {
              _inherits(NodeError, _Base);
              function NodeError(arg1, arg2, arg3) {
                var _this;
                _classCallCheck(this, NodeError);
                _this = _possibleConstructorReturn(
                  this,
                  _getPrototypeOf(NodeError).call(
                    this,
                    getMessage(arg1, arg2, arg3)
                  )
                );
                _this.code = code;
                return _this;
              }
              return NodeError;
            })(Base);
            codes[code] = NodeError;
          } // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
          function oneOf(expected, thing) {
            if (Array.isArray(expected)) {
              var len = expected.length;
              expected = expected.map(function (i) {
                return String(i);
              });
              if (len > 2) {
                return (
                  "one of "
                    .concat(thing, " ")
                    .concat(expected.slice(0, len - 1).join(", "), ", or ") +
                  expected[len - 1]
                );
              } else if (len === 2) {
                return "one of "
                  .concat(thing, " ")
                  .concat(expected[0], " or ")
                  .concat(expected[1]);
              } else {
                return "of ".concat(thing, " ").concat(expected[0]);
              }
            } else {
              return "of ".concat(thing, " ").concat(String(expected));
            }
          } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
          function startsWith(str, search, pos) {
            return (
              str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search
            );
          } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
          function endsWith(str, search, this_len) {
            if (this_len === undefined || this_len > str.length) {
              this_len = str.length;
            }
            return str.substring(this_len - search.length, this_len) === search;
          } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
          function includes(str, search, start) {
            if (typeof start !== "number") {
              start = 0;
            }
            if (start + search.length > str.length) {
              return false;
            } else {
              return str.indexOf(search, start) !== -1;
            }
          }
          createErrorType(
            "ERR_AMBIGUOUS_ARGUMENT",
            'The "%s" argument is ambiguous. %s',
            TypeError
          );
          createErrorType(
            "ERR_INVALID_ARG_TYPE",
            function (name, expected, actual) {
              if (assert === undefined) assert = require("../assert");
              assert(typeof name === "string", "'name' must be a string"); // determiner: 'must be' or 'must not be'
              var determiner;
              if (typeof expected === "string" && startsWith(expected, "not ")) {
                determiner = "must not be";
                expected = expected.replace(/^not /, "");
              } else {
                determiner = "must be";
              }
              var msg;
              if (endsWith(name, " argument")) {
                // For cases like 'first argument'
                msg = "The "
                  .concat(name, " ")
                  .concat(determiner, " ")
                  .concat(oneOf(expected, "type"));
              } else {
                var type = includes(name, ".") ? "property" : "argument";
                msg = 'The "'
                  .concat(name, '" ')
                  .concat(type, " ")
                  .concat(determiner, " ")
                  .concat(oneOf(expected, "type"));
              } // TODO(BridgeAR): Improve the output by showing `null` and similar.
              msg += ". Received type ".concat(_typeof(actual));
              return msg;
            },
            TypeError
          );
          createErrorType(
            "ERR_INVALID_ARG_VALUE",
            function (name, value) {
              var reason =
                arguments.length > 2 && arguments[2] !== undefined
                  ? arguments[2]
                  : "is invalid";
              if (util === undefined) util = require("util/");
              var inspected = util.inspect(value);
              if (inspected.length > 128) {
                inspected = "".concat(inspected.slice(0, 128), "...");
              }
              return "The argument '"
                .concat(name, "' ")
                .concat(reason, ". Received ")
                .concat(inspected);
            },
            TypeError,
            RangeError
          );
          createErrorType(
            "ERR_INVALID_RETURN_VALUE",
            function (input, name, value) {
              var type;
              if (value && value.constructor && value.constructor.name) {
                type = "instance of ".concat(value.constructor.name);
              } else {
                type = "type ".concat(_typeof(value));
              }
              return (
                "Expected "
                  .concat(input, ' to be returned from the "')
                  .concat(name, '"') + " function but got ".concat(type, ".")
              );
            },
            TypeError
          );
          createErrorType(
            "ERR_MISSING_ARGS",
            function () {
              for (
                var _len = arguments.length, args = new Array(_len), _key = 0;
                _key < _len;
                _key++
              ) {
                args[_key] = arguments[_key];
              }
              if (assert === undefined) assert = require("../assert");
              assert(args.length > 0, "At least one arg needs to be specified");
              var msg = "The ";
              var len = args.length;
              args = args.map(function (a) {
                return '"'.concat(a, '"');
              });
              switch (len) {
                case 1:
                  msg += "".concat(args[0], " argument");
                  break;
                case 2:
                  msg += ""
                    .concat(args[0], " and ")
                    .concat(args[1], " arguments");
                  break;
                default:
                  msg += args.slice(0, len - 1).join(", ");
                  msg += ", and ".concat(args[len - 1], " arguments");
                  break;
              }
              return "".concat(msg, " must be specified");
            },
            TypeError
          );
          module.exports.codes = codes;
        },
        {
          "../assert": "cdcb67ab5f6acbeabe6d878ee73d6e25",
          "util/": "ea7cbe466cf2ea1251a276e89980c958"
        }
      ],
      ea7cbe466cf2ea1251a276e89980c958: [
        function (require, module, exports) {
          var process = require("process"); // Copyright Joyent, Inc. and other Node contributors.
          //
          // Permission is hereby granted, free of charge, to any person obtaining a
          // copy of this software and associated documentation files (the
          // "Software"), to deal in the Software without restriction, including
          // without limitation the rights to use, copy, modify, merge, publish,
          // distribute, sublicense, and/or sell copies of the Software, and to permit
          // persons to whom the Software is furnished to do so, subject to the
          // following conditions:
          //
          // The above copyright notice and this permission notice shall be included
          // in all copies or substantial portions of the Software.
          //
          // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
          // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
          // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
          // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
          // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
          // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
          // USE OR OTHER DEALINGS IN THE SOFTWARE.
          var getOwnPropertyDescriptors =
            Object.getOwnPropertyDescriptors ||
            function getOwnPropertyDescriptors(obj) {
              var keys = Object.keys(obj);
              var descriptors = {};
              for (var i = 0; i < keys.length; i++) {
                descriptors[keys[i]] = Object.getOwnPropertyDescriptor(
                  obj,
                  keys[i]
                );
              }
              return descriptors;
            };
          var formatRegExp = /%[sdj%]/g;
          exports.format = function (f) {
            if (!isString(f)) {
              var objects = [];
              for (var i = 0; i < arguments.length; i++) {
                objects.push(inspect(arguments[i]));
              }
              return objects.join(" ");
            }
            var i = 1;
            var args = arguments;
            var len = args.length;
            var str = String(f).replace(formatRegExp, function (x) {
              if (x === "%%") return "%";
              if (i >= len) return x;
              switch (x) {
                case "%s":
                  return String(args[i++]);
                case "%d":
                  return Number(args[i++]);
                case "%j":
                  try {
                    return JSON.stringify(args[i++]);
                  } catch (_) {
                    return "[Circular]";
                  }
                default:
                  return x;
              }
            });
            for (var x = args[i]; i < len; x = args[++i]) {
              if (isNull(x) || !isObject(x)) {
                str += " " + x;
              } else {
                str += " " + inspect(x);
              }
            }
            return str;
          }; // Mark that a method should not be used.
          // Returns a modified function which warns once by default.
          // If --no-deprecation is set, then it is a no-op.
          exports.deprecate = function (fn, msg) {
            if (
              typeof process !== "undefined" &&
              process.noDeprecation === true
            ) {
              return fn;
            } // Allow for deprecating things in the process of starting up.
            if (typeof process === "undefined") {
              return function () {
                return exports.deprecate(fn, msg).apply(this, arguments);
              };
            }
            var warned = false;
            function deprecated() {
              if (!warned) {
                if (process.throwDeprecation) {
                  throw new Error(msg);
                } else if (process.traceDeprecation) {
                  console.trace(msg);
                } else {
                  console.error(msg);
                }
                warned = true;
              }
              return fn.apply(this, arguments);
            }
            return deprecated;
          };
          var debugs = {};
          var debugEnvRegex = /^$/;
          if (undefined) {
            var debugEnv = undefined;
            debugEnv = debugEnv
              .replace(/[|\\{}()[\]^$+?.]/g, "\\$&")
              .replace(/\*/g, ".*")
              .replace(/,/g, "$|^")
              .toUpperCase();
            debugEnvRegex = new RegExp("^" + debugEnv + "$", "i");
          }
          exports.debuglog = function (set) {
            set = set.toUpperCase();
            if (!debugs[set]) {
              if (debugEnvRegex.test(set)) {
                var pid = process.pid;
                debugs[set] = function () {
                  var msg = exports.format.apply(exports, arguments);
                  console.error("%s %d: %s", set, pid, msg);
                };
              } else {
                debugs[set] = function () {};
              }
            }
            return debugs[set];
          };
          /**
           * Echos the value of a value. Trys to print the value out
           * in the best way possible given the different types.
           *
           * @param {Object} obj The object to print out.
           * @param {Object} opts Optional options object that alters the output.
           */ /* legacy: obj, showHidden, depth, colors*/ function inspect(
            obj,
            opts
          ) {
            // default options
            var ctx = { seen: [], stylize: stylizeNoColor }; // legacy...
            if (arguments.length >= 3) ctx.depth = arguments[2];
            if (arguments.length >= 4) ctx.colors = arguments[3];
            if (isBoolean(opts)) {
              // legacy...
              ctx.showHidden = opts;
            } else if (opts) {
              // got an "options" object
              exports._extend(ctx, opts);
            } // set default options
            if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
            if (isUndefined(ctx.depth)) ctx.depth = 2;
            if (isUndefined(ctx.colors)) ctx.colors = false;
            if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
            if (ctx.colors) ctx.stylize = stylizeWithColor;
            return formatValue(ctx, obj, ctx.depth);
          }
          exports.inspect = inspect; // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
          inspect.colors = {
            bold: [1, 22],
            italic: [3, 23],
            underline: [4, 24],
            inverse: [7, 27],
            white: [37, 39],
            grey: [90, 39],
            black: [30, 39],
            blue: [34, 39],
            cyan: [36, 39],
            green: [32, 39],
            magenta: [35, 39],
            red: [31, 39],
            yellow: [33, 39]
          }; // Don't use 'blue' not visible on cmd.exe
          inspect.styles = {
            special: "cyan",
            number: "yellow",
            boolean: "yellow",
            undefined: "grey",
            null: "bold",
            string: "green",
            date: "magenta", // "name": intentionally not styling
            regexp: "red"
          };
          function stylizeWithColor(str, styleType) {
            var style = inspect.styles[styleType];
            if (style) {
              return (
                "\x1B[" +
                inspect.colors[style][0] +
                "m" +
                str +
                "\x1B[" +
                inspect.colors[style][1] +
                "m"
              );
            } else {
              return str;
            }
          }
          function stylizeNoColor(str, styleType) {
            return str;
          }
          function arrayToHash(array) {
            var hash = {};
            array.forEach(function (val, idx) {
              hash[val] = true;
            });
            return hash;
          }
          function formatValue(ctx, value, recurseTimes) {
            // Provide a hook for user-specified inspect functions.
            // Check that value is an object with an inspect function on it
            if (
              ctx.customInspect &&
              value &&
              isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
              value.inspect !== exports.inspect && // Also filter out any prototype objects using the circular check.
              !(value.constructor && value.constructor.prototype === value)
            ) {
              var ret = value.inspect(recurseTimes, ctx);
              if (!isString(ret)) {
                ret = formatValue(ctx, ret, recurseTimes);
              }
              return ret;
            } // Primitive types cannot have properties
            var primitive = formatPrimitive(ctx, value);
            if (primitive) {
              return primitive;
            } // Look up the keys of the object.
            var keys = Object.keys(value);
            var visibleKeys = arrayToHash(keys);
            if (ctx.showHidden) {
              keys = Object.getOwnPropertyNames(value);
            } // IE doesn't make error fields non-enumerable
            // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
            if (
              isError(value) &&
              (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)
            ) {
              return formatError(value);
            } // Some type of object without properties can be shortcutted.
            if (keys.length === 0) {
              if (isFunction(value)) {
                var name = value.name ? ": " + value.name : "";
                return ctx.stylize("[Function" + name + "]", "special");
              }
              if (isRegExp(value)) {
                return ctx.stylize(
                  RegExp.prototype.toString.call(value),
                  "regexp"
                );
              }
              if (isDate(value)) {
                return ctx.stylize(Date.prototype.toString.call(value), "date");
              }
              if (isError(value)) {
                return formatError(value);
              }
            }
            var base = "",
              array = false,
              braces = ["{", "}"]; // Make Array say that they are Array
            if (isArray(value)) {
              array = true;
              braces = ["[", "]"];
            } // Make functions say that they are functions
            if (isFunction(value)) {
              var n = value.name ? ": " + value.name : "";
              base = " [Function" + n + "]";
            } // Make RegExps say that they are RegExps
            if (isRegExp(value)) {
              base = " " + RegExp.prototype.toString.call(value);
            } // Make dates with properties first say the date
            if (isDate(value)) {
              base = " " + Date.prototype.toUTCString.call(value);
            } // Make error with message first say the error
            if (isError(value)) {
              base = " " + formatError(value);
            }
            if (keys.length === 0 && (!array || value.length == 0)) {
              return braces[0] + base + braces[1];
            }
            if (recurseTimes < 0) {
              if (isRegExp(value)) {
                return ctx.stylize(
                  RegExp.prototype.toString.call(value),
                  "regexp"
                );
              } else {
                return ctx.stylize("[Object]", "special");
              }
            }
            ctx.seen.push(value);
            var output;
            if (array) {
              output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
            } else {
              output = keys.map(function (key) {
                return formatProperty(
                  ctx,
                  value,
                  recurseTimes,
                  visibleKeys,
                  key,
                  array
                );
              });
            }
            ctx.seen.pop();
            return reduceToSingleString(output, base, braces);
          }
          function formatPrimitive(ctx, value) {
            if (isUndefined(value)) return ctx.stylize("undefined", "undefined");
            if (isString(value)) {
              var simple =
                "'" +
                JSON.stringify(value)
                  .replace(/^"|"$/g, "")
                  .replace(/'/g, "\\'")
                  .replace(/\\"/g, '"') +
                "'";
              return ctx.stylize(simple, "string");
            }
            if (isNumber(value)) return ctx.stylize("" + value, "number");
            if (isBoolean(value)) return ctx.stylize("" + value, "boolean"); // For some reason typeof null is "object", so special case here.
            if (isNull(value)) return ctx.stylize("null", "null");
          }
          function formatError(value) {
            return "[" + Error.prototype.toString.call(value) + "]";
          }
          function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
            var output = [];
            for (var i = 0, l = value.length; i < l; ++i) {
              if (hasOwnProperty(value, String(i))) {
                output.push(
                  formatProperty(
                    ctx,
                    value,
                    recurseTimes,
                    visibleKeys,
                    String(i),
                    true
                  )
                );
              } else {
                output.push("");
              }
            }
            keys.forEach(function (key) {
              if (!key.match(/^\d+$/)) {
                output.push(
                  formatProperty(ctx, value, recurseTimes, visibleKeys, key, true)
                );
              }
            });
            return output;
          }
          function formatProperty(
            ctx,
            value,
            recurseTimes,
            visibleKeys,
            key,
            array
          ) {
            var name, str, desc;
            desc = Object.getOwnPropertyDescriptor(value, key) || {
              value: value[key]
            };
            if (desc.get) {
              if (desc.set) {
                str = ctx.stylize("[Getter/Setter]", "special");
              } else {
                str = ctx.stylize("[Getter]", "special");
              }
            } else {
              if (desc.set) {
                str = ctx.stylize("[Setter]", "special");
              }
            }
            if (!hasOwnProperty(visibleKeys, key)) {
              name = "[" + key + "]";
            }
            if (!str) {
              if (ctx.seen.indexOf(desc.value) < 0) {
                if (isNull(recurseTimes)) {
                  str = formatValue(ctx, desc.value, null);
                } else {
                  str = formatValue(ctx, desc.value, recurseTimes - 1);
                }
                if (str.indexOf("\n") > -1) {
                  if (array) {
                    str = str
                      .split("\n")
                      .map(function (line) {
                        return "  " + line;
                      })
                      .join("\n")
                      .substr(2);
                  } else {
                    str =
                      "\n" +
                      str
                        .split("\n")
                        .map(function (line) {
                          return "   " + line;
                        })
                        .join("\n");
                  }
                }
              } else {
                str = ctx.stylize("[Circular]", "special");
              }
            }
            if (isUndefined(name)) {
              if (array && key.match(/^\d+$/)) {
                return str;
              }
              name = JSON.stringify("" + key);
              if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
                name = name.substr(1, name.length - 2);
                name = ctx.stylize(name, "name");
              } else {
                name = name
                  .replace(/'/g, "\\'")
                  .replace(/\\"/g, '"')
                  .replace(/(^"|"$)/g, "'");
                name = ctx.stylize(name, "string");
              }
            }
            return name + ": " + str;
          }
          function reduceToSingleString(output, base, braces) {
            var numLinesEst = 0;
            var length = output.reduce(function (prev, cur) {
              numLinesEst++;
              if (cur.indexOf("\n") >= 0) numLinesEst++;
              return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
            }, 0);
            if (length > 60) {
              return (
                braces[0] +
                (base === "" ? "" : base + "\n ") +
                " " +
                output.join(",\n  ") +
                " " +
                braces[1]
              );
            }
            return braces[0] + base + " " + output.join(", ") + " " + braces[1];
          } // NOTE: These type checking functions intentionally don't use `instanceof`
          // because it is fragile and can be easily faked with `Object.create()`.
          exports.types = require("./support/types");
          function isArray(ar) {
            return Array.isArray(ar);
          }
          exports.isArray = isArray;
          function isBoolean(arg) {
            return typeof arg === "boolean";
          }
          exports.isBoolean = isBoolean;
          function isNull(arg) {
            return arg === null;
          }
          exports.isNull = isNull;
          function isNullOrUndefined(arg) {
            return arg == null;
          }
          exports.isNullOrUndefined = isNullOrUndefined;
          function isNumber(arg) {
            return typeof arg === "number";
          }
          exports.isNumber = isNumber;
          function isString(arg) {
            return typeof arg === "string";
          }
          exports.isString = isString;
          function isSymbol(arg) {
            return _typeof2(arg) === "symbol";
          }
          exports.isSymbol = isSymbol;
          function isUndefined(arg) {
            return arg === void 0;
          }
          exports.isUndefined = isUndefined;
          function isRegExp(re) {
            return isObject(re) && objectToString(re) === "[object RegExp]";
          }
          exports.isRegExp = isRegExp;
          exports.types.isRegExp = isRegExp;
          function isObject(arg) {
            return _typeof2(arg) === "object" && arg !== null;
          }
          exports.isObject = isObject;
          function isDate(d) {
            return isObject(d) && objectToString(d) === "[object Date]";
          }
          exports.isDate = isDate;
          exports.types.isDate = isDate;
          function isError(e) {
            return (
              isObject(e) &&
              (objectToString(e) === "[object Error]" || _instanceof(e, Error))
            );
          }
          exports.isError = isError;
          exports.types.isNativeError = isError;
          function isFunction(arg) {
            return typeof arg === "function";
          }
          exports.isFunction = isFunction;
          function isPrimitive(arg) {
            return (
              arg === null ||
              typeof arg === "boolean" ||
              typeof arg === "number" ||
              typeof arg === "string" ||
              _typeof2(arg) === "symbol" || // ES6 symbol
              typeof arg === "undefined"
            );
          }
          exports.isPrimitive = isPrimitive;
          exports.isBuffer = require("./support/isBuffer");
          function objectToString(o) {
            return Object.prototype.toString.call(o);
          }
          function pad(n) {
            return n < 10 ? "0" + n.toString(10) : n.toString(10);
          }
          var months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
          ]; // 26 Feb 16:19:34
          function timestamp() {
            var d = new Date();
            var time = [
              pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())
            ].join(":");
            return [d.getDate(), months[d.getMonth()], time].join(" ");
          } // log is just a thin wrapper to console.log that prepends a timestamp
          exports.log = function () {
            console.log(
              "%s - %s",
              timestamp(),
              exports.format.apply(exports, arguments)
            );
          };
          /**
           * Inherit the prototype methods from one constructor into another.
           *
           * The Function.prototype.inherits from lang.js rewritten as a standalone
           * function (not on Function.prototype). NOTE: If this file is to be loaded
           * during bootstrapping this function needs to be rewritten using some native
           * functions as prototype setup using normal JavaScript does not work as
           * expected during bootstrapping (see mirror.js in r114903).
           *
           * @param {function} ctor Constructor function which needs to inherit the
           *     prototype.
           * @param {function} superCtor Constructor function to inherit prototype from.
           */ exports.inherits = require("inherits");
          exports._extend = function (origin, add) {
            // Don't do anything if add isn't an object
            if (!add || !isObject(add)) return origin;
            var keys = Object.keys(add);
            var i = keys.length;
            while (i--) {
              origin[keys[i]] = add[keys[i]];
            }
            return origin;
          };
          function hasOwnProperty(obj, prop) {
            return Object.prototype.hasOwnProperty.call(obj, prop);
          }
          var kCustomPromisifiedSymbol =
            typeof Symbol !== "undefined"
              ? Symbol("util.promisify.custom")
              : undefined;
          exports.promisify = function promisify(original) {
            if (typeof original !== "function")
              throw new TypeError(
                'The "original" argument must be of type Function'
              );
            if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
              var fn = original[kCustomPromisifiedSymbol];
              if (typeof fn !== "function") {
                throw new TypeError(
                  'The "util.promisify.custom" argument must be of type Function'
                );
              }
              Object.defineProperty(fn, kCustomPromisifiedSymbol, {
                value: fn,
                enumerable: false,
                writable: false,
                configurable: true
              });
              return fn;
            }
            function fn() {
              var promiseResolve, promiseReject;
              var promise = new Promise(function (resolve, reject) {
                promiseResolve = resolve;
                promiseReject = reject;
              });
              var args = [];
              for (var i = 0; i < arguments.length; i++) {
                args.push(arguments[i]);
              }
              args.push(function (err, value) {
                if (err) {
                  promiseReject(err);
                } else {
                  promiseResolve(value);
                }
              });
              try {
                original.apply(this, args);
              } catch (err) {
                promiseReject(err);
              }
              return promise;
            }
            Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
            if (kCustomPromisifiedSymbol)
              Object.defineProperty(fn, kCustomPromisifiedSymbol, {
                value: fn,
                enumerable: false,
                writable: false,
                configurable: true
              });
            return Object.defineProperties(
              fn,
              getOwnPropertyDescriptors(original)
            );
          };
          exports.promisify.custom = kCustomPromisifiedSymbol;
          function callbackifyOnRejected(reason, cb) {
            // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
            // Because `null` is a special error value in callbacks which means "no error
            // occurred", we error-wrap so the callback consumer can distinguish between
            // "the promise rejected with null" or "the promise fulfilled with undefined".
            if (!reason) {
              var newReason = new Error(
                "Promise was rejected with a falsy value"
              );
              newReason.reason = reason;
              reason = newReason;
            }
            return cb(reason);
          }
          function callbackify(original) {
            if (typeof original !== "function") {
              throw new TypeError(
                'The "original" argument must be of type Function'
              );
            } // We DO NOT return the promise as it gives the user a false sense that
            // the promise is actually somehow related to the callback's execution
            // and that the callback throwing will reject the promise.
            function callbackified() {
              var args = [];
              for (var i = 0; i < arguments.length; i++) {
                args.push(arguments[i]);
              }
              var maybeCb = args.pop();
              if (typeof maybeCb !== "function") {
                throw new TypeError("The last argument must be of type Function");
              }
              var self = this;
              var cb = function cb() {
                return maybeCb.apply(self, arguments);
              }; // In true node style we process the callback on `nextTick` with all the
              // implications (stack, `uncaughtException`, `async_hooks`)
              original.apply(this, args).then(
                function (ret) {
                  process.nextTick(cb.bind(null, null, ret));
                },
                function (rej) {
                  process.nextTick(callbackifyOnRejected.bind(null, rej, cb));
                }
              );
            }
            Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
            Object.defineProperties(
              callbackified,
              getOwnPropertyDescriptors(original)
            );
            return callbackified;
          }
          exports.callbackify = callbackify;
        },
        {
          process: "ec0e1432c6522aad9b4b16c4b3b080f4",
          "./support/types": "9e956bd360bbba5956b3e64309d78221",
          "./support/isBuffer": "0ed75156de43f54f1ade1747693857ce",
          inherits: "9a4ae5d8f832c8333ee4e7b933c46353"
        }
      ],
      "9e956bd360bbba5956b3e64309d78221": [
        function (require, module, exports) {
          // Currently in sync with Node.js lib/internal/util/types.js
          // https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
          "use strict";
          var isBuffer = require("./isBuffer");
          var isArgumentsObject = require("is-arguments");
          var isGeneratorFunction = require("is-generator-function");
          function uncurryThis(f) {
            return f.call.bind(f);
          }
          var BigIntSupported = typeof BigInt !== "undefined";
          var SymbolSupported = typeof Symbol !== "undefined";
          var SymbolToStringTagSupported =
            SymbolSupported && typeof Symbol.toStringTag !== "undefined";
          var Uint8ArraySupported = typeof Uint8Array !== "undefined";
          var ArrayBufferSupported = typeof ArrayBuffer !== "undefined";
          if (Uint8ArraySupported && SymbolToStringTagSupported) {
            var TypedArrayPrototype = Object.getPrototypeOf(Uint8Array.prototype);
            var TypedArrayProto_toStringTag = uncurryThis(
              Object.getOwnPropertyDescriptor(
                TypedArrayPrototype,
                Symbol.toStringTag
              ).get
            );
          }
          var ObjectToString = uncurryThis(Object.prototype.toString);
          var numberValue = uncurryThis(Number.prototype.valueOf);
          var stringValue = uncurryThis(String.prototype.valueOf);
          var booleanValue = uncurryThis(Boolean.prototype.valueOf);
          if (BigIntSupported) {
            var bigIntValue = uncurryThis(BigInt.prototype.valueOf);
          }
          if (SymbolSupported) {
            var symbolValue = uncurryThis(Symbol.prototype.valueOf);
          }
          function checkBoxedPrimitive(value, prototypeValueOf) {
            if (_typeof2(value) !== "object") {
              return false;
            }
            try {
              prototypeValueOf(value);
              return true;
            } catch (e) {
              return false;
            }
          }
          exports.isArgumentsObject = isArgumentsObject;
          exports.isGeneratorFunction = isGeneratorFunction; // Taken from here and modified for better browser support
          // https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
          function isPromise(input) {
            return (
              (typeof Promise !== "undefined" && _instanceof(input, Promise)) ||
              (input !== null &&
                _typeof2(input) === "object" &&
                typeof input.then === "function" &&
                typeof input.catch === "function")
            );
          }
          exports.isPromise = isPromise;
          function isArrayBufferView(value) {
            if (ArrayBufferSupported && ArrayBuffer.isView) {
              return ArrayBuffer.isView(value);
            }
            return isTypedArray(value) || isDataView(value);
          }
          exports.isArrayBufferView = isArrayBufferView;
          function isTypedArray(value) {
            if (Uint8ArraySupported && SymbolToStringTagSupported) {
              return TypedArrayProto_toStringTag(value) !== undefined;
            } else {
              return (
                isUint8Array(value) ||
                isUint8ClampedArray(value) ||
                isUint16Array(value) ||
                isUint32Array(value) ||
                isInt8Array(value) ||
                isInt16Array(value) ||
                isInt32Array(value) ||
                isFloat32Array(value) ||
                isFloat64Array(value) ||
                isBigInt64Array(value) ||
                isBigUint64Array(value)
              );
            }
          }
          exports.isTypedArray = isTypedArray;
          function isUint8Array(value) {
            if (Uint8ArraySupported && SymbolToStringTagSupported) {
              return TypedArrayProto_toStringTag(value) === "Uint8Array";
            } else {
              return (
                ObjectToString(value) === "[object Uint8Array]" || // If it's a Buffer instance _and_ has a `.buffer` property,
                // this is an ArrayBuffer based buffer; thus it's an Uint8Array
                // (Old Node.js had a custom non-Uint8Array implementation)
                (isBuffer(value) && value.buffer !== undefined)
              );
            }
          }
          exports.isUint8Array = isUint8Array;
          function isUint8ClampedArray(value) {
            if (Uint8ArraySupported && SymbolToStringTagSupported) {
              return TypedArrayProto_toStringTag(value) === "Uint8ClampedArray";
            } else {
              return ObjectToString(value) === "[object Uint8ClampedArray]";
            }
          }
          exports.isUint8ClampedArray = isUint8ClampedArray;
          function isUint16Array(value) {
            if (Uint8ArraySupported && SymbolToStringTagSupported) {
              return TypedArrayProto_toStringTag(value) === "Uint16Array";
            } else {
              return ObjectToString(value) === "[object Uint16Array]";
            }
          }
          exports.isUint16Array = isUint16Array;
          function isUint32Array(value) {
            if (Uint8ArraySupported && SymbolToStringTagSupported) {
              return TypedArrayProto_toStringTag(value) === "Uint32Array";
            } else {
              return ObjectToString(value) === "[object Uint32Array]";
            }
          }
          exports.isUint32Array = isUint32Array;
          function isInt8Array(value) {
            if (Uint8ArraySupported && SymbolToStringTagSupported) {
              return TypedArrayProto_toStringTag(value) === "Int8Array";
            } else {
              return ObjectToString(value) === "[object Int8Array]";
            }
          }
          exports.isInt8Array = isInt8Array;
          function isInt16Array(value) {
            if (Uint8ArraySupported && SymbolToStringTagSupported) {
              return TypedArrayProto_toStringTag(value) === "Int16Array";
            } else {
              return ObjectToString(value) === "[object Int16Array]";
            }
          }
          exports.isInt16Array = isInt16Array;
          function isInt32Array(value) {
            if (Uint8ArraySupported && SymbolToStringTagSupported) {
              return TypedArrayProto_toStringTag(value) === "Int32Array";
            } else {
              return ObjectToString(value) === "[object Int32Array]";
            }
          }
          exports.isInt32Array = isInt32Array;
          function isFloat32Array(value) {
            if (Uint8ArraySupported && SymbolToStringTagSupported) {
              return TypedArrayProto_toStringTag(value) === "Float32Array";
            } else {
              return ObjectToString(value) === "[object Float32Array]";
            }
          }
          exports.isFloat32Array = isFloat32Array;
          function isFloat64Array(value) {
            if (Uint8ArraySupported && SymbolToStringTagSupported) {
              return TypedArrayProto_toStringTag(value) === "Float64Array";
            } else {
              return ObjectToString(value) === "[object Float64Array]";
            }
          }
          exports.isFloat64Array = isFloat64Array;
          function isBigInt64Array(value) {
            if (Uint8ArraySupported && SymbolToStringTagSupported) {
              return TypedArrayProto_toStringTag(value) === "BigInt64Array";
            } else {
              return ObjectToString(value) === "[object BigInt64Array]";
            }
          }
          exports.isBigInt64Array = isBigInt64Array;
          function isBigUint64Array(value) {
            if (Uint8ArraySupported && SymbolToStringTagSupported) {
              return TypedArrayProto_toStringTag(value) === "BigUint64Array";
            } else {
              return ObjectToString(value) === "[object BigUint64Array]";
            }
          }
          exports.isBigUint64Array = isBigUint64Array;
          function isMapToString(value) {
            return ObjectToString(value) === "[object Map]";
          }
          isMapToString.working =
            typeof Map !== "undefined" && isMapToString(new Map());
          function isMap(value) {
            if (typeof Map === "undefined") {
              return false;
            }
            return isMapToString.working
              ? isMapToString(value)
              : _instanceof(value, Map);
          }
          exports.isMap = isMap;
          function isSetToString(value) {
            return ObjectToString(value) === "[object Set]";
          }
          isSetToString.working =
            typeof Set !== "undefined" && isSetToString(new Set());
          function isSet(value) {
            if (typeof Set === "undefined") {
              return false;
            }
            return isSetToString.working
              ? isSetToString(value)
              : _instanceof(value, Set);
          }
          exports.isSet = isSet;
          function isWeakMapToString(value) {
            return ObjectToString(value) === "[object WeakMap]";
          }
          isWeakMapToString.working =
            typeof WeakMap !== "undefined" && isWeakMapToString(new WeakMap());
          function isWeakMap(value) {
            if (typeof WeakMap === "undefined") {
              return false;
            }
            return isWeakMapToString.working
              ? isWeakMapToString(value)
              : _instanceof(value, WeakMap);
          }
          exports.isWeakMap = isWeakMap;
          function isWeakSetToString(value) {
            return ObjectToString(value) === "[object WeakSet]";
          }
          isWeakSetToString.working =
            typeof WeakSet !== "undefined" && isWeakSetToString(new WeakSet());
          function isWeakSet(value) {
            return isWeakSetToString(value);
            if (typeof WeakSet === "undefined") {
              return false;
            }
            return isWeakSetToString.working
              ? isWeakSetToString(value)
              : _instanceof(value, WeakSet);
          }
          exports.isWeakSet = isWeakSet;
          function isArrayBufferToString(value) {
            return ObjectToString(value) === "[object ArrayBuffer]";
          }
          isArrayBufferToString.working =
            typeof ArrayBuffer !== "undefined" &&
            isArrayBufferToString(new ArrayBuffer());
          function isArrayBuffer(value) {
            if (typeof ArrayBuffer === "undefined") {
              return false;
            }
            return isArrayBufferToString.working
              ? isArrayBufferToString(value)
              : _instanceof(value, ArrayBuffer);
          }
          exports.isArrayBuffer = isArrayBuffer;
          function isDataViewToString(value) {
            return ObjectToString(value) === "[object DataView]";
          }
          isDataViewToString.working =
            typeof ArrayBuffer !== "undefined" &&
            typeof DataView !== "undefined" &&
            isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
          function isDataView(value) {
            if (typeof DataView === "undefined") {
              return false;
            }
            return isDataViewToString.working
              ? isDataViewToString(value)
              : _instanceof(value, DataView);
          }
          exports.isDataView = isDataView;
          function isSharedArrayBufferToString(value) {
            return ObjectToString(value) === "[object SharedArrayBuffer]";
          }
          isSharedArrayBufferToString.working =
            typeof SharedArrayBuffer !== "undefined" &&
            isSharedArrayBufferToString(new SharedArrayBuffer());
          function isSharedArrayBuffer(value) {
            if (typeof SharedArrayBuffer === "undefined") {
              return false;
            }
            return isSharedArrayBufferToString.working
              ? isSharedArrayBufferToString(value)
              : _instanceof(value, SharedArrayBuffer);
          }
          exports.isSharedArrayBuffer = isSharedArrayBuffer;
          function isAsyncFunction(value) {
            return ObjectToString(value) === "[object AsyncFunction]";
          }
          exports.isAsyncFunction = isAsyncFunction;
          function isMapIterator(value) {
            return ObjectToString(value) === "[object Map Iterator]";
          }
          exports.isMapIterator = isMapIterator;
          function isSetIterator(value) {
            return ObjectToString(value) === "[object Set Iterator]";
          }
          exports.isSetIterator = isSetIterator;
          function isGeneratorObject(value) {
            return ObjectToString(value) === "[object Generator]";
          }
          exports.isGeneratorObject = isGeneratorObject;
          function isWebAssemblyCompiledModule(value) {
            return ObjectToString(value) === "[object WebAssembly.Module]";
          }
          exports.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;
          function isNumberObject(value) {
            return checkBoxedPrimitive(value, numberValue);
          }
          exports.isNumberObject = isNumberObject;
          function isStringObject(value) {
            return checkBoxedPrimitive(value, stringValue);
          }
          exports.isStringObject = isStringObject;
          function isBooleanObject(value) {
            return checkBoxedPrimitive(value, booleanValue);
          }
          exports.isBooleanObject = isBooleanObject;
          function isBigIntObject(value) {
            return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
          }
          exports.isBigIntObject = isBigIntObject;
          function isSymbolObject(value) {
            return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
          }
          exports.isSymbolObject = isSymbolObject;
          function isBoxedPrimitive(value) {
            return (
              isNumberObject(value) ||
              isStringObject(value) ||
              isBooleanObject(value) ||
              isBigIntObject(value) ||
              isSymbolObject(value)
            );
          }
          exports.isBoxedPrimitive = isBoxedPrimitive;
          function isAnyArrayBuffer(value) {
            return (
              Uint8ArraySupported &&
              (isArrayBuffer(value) || isSharedArrayBuffer(value))
            );
          }
          exports.isAnyArrayBuffer = isAnyArrayBuffer;
          ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function (
            method
          ) {
            Object.defineProperty(exports, method, {
              enumerable: false,
              value: function value() {
                throw new Error(method + " is not supported in userland");
              }
            });
          });
        },
        {
          "./isBuffer": "0ed75156de43f54f1ade1747693857ce",
          "is-arguments": "6024feb7573ff473ee9a944b6f7a7a85",
          "is-generator-function": "dbceb9a067c59822a69bf97561667304"
        }
      ],
      "0ed75156de43f54f1ade1747693857ce": [
        function (require, module, exports) {
          module.exports = function isBuffer(arg) {
            return (
              arg &&
              _typeof2(arg) === "object" &&
              typeof arg.copy === "function" &&
              typeof arg.fill === "function" &&
              typeof arg.readUInt8 === "function"
            );
          };
        },
        {}
      ],
      "6024feb7573ff473ee9a944b6f7a7a85": [
        function (require, module, exports) {
          "use strict";
          var hasToStringTag =
            typeof Symbol === "function" &&
            _typeof2(Symbol.toStringTag) === "symbol";
          var toStr = Object.prototype.toString;
          var isStandardArguments = function isArguments(value) {
            if (
              hasToStringTag &&
              value &&
              _typeof2(value) === "object" &&
              Symbol.toStringTag in value
            ) {
              return false;
            }
            return toStr.call(value) === "[object Arguments]";
          };
          var isLegacyArguments = function isArguments(value) {
            if (isStandardArguments(value)) {
              return true;
            }
            return (
              value !== null &&
              _typeof2(value) === "object" &&
              typeof value.length === "number" &&
              value.length >= 0 &&
              toStr.call(value) !== "[object Array]" &&
              toStr.call(value.callee) === "[object Function]"
            );
          };
          var supportsStandardArguments = (function () {
            return isStandardArguments(arguments);
          })();
          isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
          module.exports = supportsStandardArguments
            ? isStandardArguments
            : isLegacyArguments;
        },
        {}
      ],
      dbceb9a067c59822a69bf97561667304: [
        function (require, module, exports) {
          "use strict";
          var toStr = Object.prototype.toString;
          var fnToStr = Function.prototype.toString;
          var isFnRegex = /^\s*(?:function)?\*/;
          var hasToStringTag =
            typeof Symbol === "function" &&
            _typeof2(Symbol.toStringTag) === "symbol";
          var getProto = Object.getPrototypeOf;
          var getGeneratorFunc = function getGeneratorFunc() {
            // eslint-disable-line consistent-return
            if (!hasToStringTag) {
              return false;
            }
            try {
              return Function("return function*() {}")();
            } catch (e) {}
          };
          var generatorFunc = getGeneratorFunc();
          var GeneratorFunction = generatorFunc ? getProto(generatorFunc) : {};
          module.exports = function isGeneratorFunction(fn) {
            if (typeof fn !== "function") {
              return false;
            }
            if (isFnRegex.test(fnToStr.call(fn))) {
              return true;
            }
            if (!hasToStringTag) {
              var str = toStr.call(fn);
              return str === "[object GeneratorFunction]";
            }
            return getProto(fn) === GeneratorFunction;
          };
        },
        {}
      ],
      "9a4ae5d8f832c8333ee4e7b933c46353": [
        function (require, module, exports) {
          if (typeof Object.create === "function") {
            // implementation from standard node.js 'util' module
            module.exports = function inherits(ctor, superCtor) {
              if (superCtor) {
                ctor.super_ = superCtor;
                ctor.prototype = Object.create(superCtor.prototype, {
                  constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                  }
                });
              }
            };
          } else {
            // old school shim for old browsers
            module.exports = function inherits(ctor, superCtor) {
              if (superCtor) {
                ctor.super_ = superCtor;
                var TempCtor = function TempCtor() {};
                TempCtor.prototype = superCtor.prototype;
                ctor.prototype = new TempCtor();
                ctor.prototype.constructor = ctor;
              }
            };
          }
        },
        {}
      ],
      "6ccc58afafec3074c6dc49c66a0a0358": [
        function (require, module, exports) {
          // Currently in sync with Node.js lib/internal/assert/assertion_error.js
          // https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c
          "use strict";
          var process = require("process");
          function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i] != null ? arguments[i] : {};
              var ownKeys = Object.keys(source);
              if (typeof Object.getOwnPropertySymbols === "function") {
                ownKeys = ownKeys.concat(
                  Object.getOwnPropertySymbols(source).filter(function (sym) {
                    return Object.getOwnPropertyDescriptor(
                      source,
                      sym
                    ).enumerable;
                  })
                );
              }
              ownKeys.forEach(function (key) {
                _defineProperty(target, key, source[key]);
              });
            }
            return target;
          }
          function _defineProperty(obj, key, value) {
            if (key in obj) {
              Object.defineProperty(obj, key, {
                value: value,
                enumerable: true,
                configurable: true,
                writable: true
              });
            } else {
              obj[key] = value;
            }
            return obj;
          }
          function _classCallCheck(instance, Constructor) {
            if (!_instanceof(instance, Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) _defineProperties(Constructor.prototype, protoProps);
            if (staticProps) _defineProperties(Constructor, staticProps);
            return Constructor;
          }
          function _possibleConstructorReturn(self, call) {
            if (
              call &&
              (_typeof(call) === "object" || typeof call === "function")
            ) {
              return call;
            }
            return _assertThisInitialized(self);
          }
          function _assertThisInitialized(self) {
            if (self === void 0) {
              throw new ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            }
            return self;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError(
                "Super expression must either be null or a function"
              );
            }
            subClass.prototype = Object.create(
              superClass && superClass.prototype,
              {
                constructor: {
                  value: subClass,
                  writable: true,
                  configurable: true
                }
              }
            );
            if (superClass) _setPrototypeOf(subClass, superClass);
          }
          function _wrapNativeSuper(Class) {
            var _cache = typeof Map === "function" ? new Map() : undefined;
            _wrapNativeSuper = function _wrapNativeSuper(Class) {
              if (Class === null || !_isNativeFunction(Class)) return Class;
              if (typeof Class !== "function") {
                throw new TypeError(
                  "Super expression must either be null or a function"
                );
              }
              if (typeof _cache !== "undefined") {
                if (_cache.has(Class)) return _cache.get(Class);
                _cache.set(Class, Wrapper);
              }
              function Wrapper() {
                return _construct(
                  Class,
                  arguments,
                  _getPrototypeOf(this).constructor
                );
              }
              Wrapper.prototype = Object.create(Class.prototype, {
                constructor: {
                  value: Wrapper,
                  enumerable: false,
                  writable: true,
                  configurable: true
                }
              });
              return _setPrototypeOf(Wrapper, Class);
            };
            return _wrapNativeSuper(Class);
          }
          function isNativeReflectConstruct() {
            if (typeof Reflect === "undefined" || !Reflect.construct)
              return false;
            if (Reflect.construct.sham) return false;
            if (typeof Proxy === "function") return true;
            try {
              Date.prototype.toString.call(
                Reflect.construct(Date, [], function () {})
              );
              return true;
            } catch (e) {
              return false;
            }
          }
          function _construct(Parent, args, Class) {
            if (isNativeReflectConstruct()) {
              _construct = Reflect.construct;
            } else {
              _construct = function _construct(Parent, args, Class) {
                var a = [null];
                a.push.apply(a, args);
                var Constructor = Function.bind.apply(Parent, a);
                var instance = new Constructor();
                if (Class) _setPrototypeOf(instance, Class.prototype);
                return instance;
              };
            }
            return _construct.apply(null, arguments);
          }
          function _isNativeFunction(fn) {
            return Function.toString.call(fn).indexOf("[native code]") !== -1;
          }
          function _setPrototypeOf(o, p) {
            _setPrototypeOf =
              Object.setPrototypeOf ||
              function _setPrototypeOf(o, p) {
                o.__proto__ = p;
                return o;
              };
            return _setPrototypeOf(o, p);
          }
          function _getPrototypeOf(o) {
            _getPrototypeOf = Object.setPrototypeOf
              ? Object.getPrototypeOf
              : function _getPrototypeOf(o) {
                  return o.__proto__ || Object.getPrototypeOf(o);
                };
            return _getPrototypeOf(o);
          }
          function _typeof(obj) {
            if (
              typeof Symbol === "function" &&
              _typeof2(Symbol.iterator) === "symbol"
            ) {
              _typeof = function _typeof(obj) {
                return _typeof2(obj);
              };
            } else {
              _typeof = function _typeof(obj) {
                return obj &&
                  typeof Symbol === "function" &&
                  obj.constructor === Symbol &&
                  obj !== Symbol.prototype
                  ? "symbol"
                  : _typeof2(obj);
              };
            }
            return _typeof(obj);
          }
          var _require = require("util/"),
            inspect = _require.inspect;
          var _require2 = require("../errors"),
            ERR_INVALID_ARG_TYPE = _require2.codes.ERR_INVALID_ARG_TYPE; // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
          function endsWith(str, search, this_len) {
            if (this_len === undefined || this_len > str.length) {
              this_len = str.length;
            }
            return str.substring(this_len - search.length, this_len) === search;
          } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
          function repeat(str, count) {
            count = Math.floor(count);
            if (str.length == 0 || count == 0) return "";
            var maxCount = str.length * count;
            count = Math.floor(Math.log(count) / Math.log(2));
            while (count) {
              str += str;
              count--;
            }
            str += str.substring(0, maxCount - str.length);
            return str;
          }
          var blue = "";
          var green = "";
          var red = "";
          var white = "";
          var kReadableOperator = {
            deepStrictEqual: "Expected values to be strictly deep-equal:",
            strictEqual: "Expected values to be strictly equal:",
            strictEqualObject:
              'Expected "actual" to be reference-equal to "expected":',
            deepEqual: "Expected values to be loosely deep-equal:",
            equal: "Expected values to be loosely equal:",
            notDeepStrictEqual:
              'Expected "actual" not to be strictly deep-equal to:',
            notStrictEqual: 'Expected "actual" to be strictly unequal to:',
            notStrictEqualObject:
              'Expected "actual" not to be reference-equal to "expected":',
            notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
            notEqual: 'Expected "actual" to be loosely unequal to:',
            notIdentical: "Values identical but not reference-equal:"
          }; // Comparing short primitives should just show === / !== instead of using the
          // diff.
          var kMaxShortLength = 10;
          function copyError(source) {
            var keys = Object.keys(source);
            var target = Object.create(Object.getPrototypeOf(source));
            keys.forEach(function (key) {
              target[key] = source[key];
            });
            Object.defineProperty(target, "message", { value: source.message });
            return target;
          }
          function inspectValue(val) {
            // The util.inspect default values could be changed. This makes sure the
            // error messages contain the necessary information nevertheless.
            return inspect(val, {
              compact: false,
              customInspect: false,
              depth: 1000,
              maxArrayLength: Infinity, // Assert compares only enumerable properties (with a few exceptions).
              showHidden: false, // Having a long line as error is better than wrapping the line for
              // comparison for now.
              // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
              // have meta information about the inspected properties (i.e., know where
              // in what line the property starts and ends).
              breakLength: Infinity, // Assert does not detect proxies currently.
              showProxy: false,
              sorted: true, // Inspect getters as we also check them when comparing entries.
              getters: true
            });
          }
          function createErrDiff(actual, expected, operator) {
            var other = "";
            var res = "";
            var lastPos = 0;
            var end = "";
            var skipped = false;
            var actualInspected = inspectValue(actual);
            var actualLines = actualInspected.split("\n");
            var expectedLines = inspectValue(expected).split("\n");
            var i = 0;
            var indicator = ""; // In case both values are objects explicitly mark them as not reference equal
            // for the `strictEqual` operator.
            if (
              operator === "strictEqual" &&
              _typeof(actual) === "object" &&
              _typeof(expected) === "object" &&
              actual !== null &&
              expected !== null
            ) {
              operator = "strictEqualObject";
            } // If "actual" and "expected" fit on a single line and they are not strictly
            // equal, check further special handling.
            if (
              actualLines.length === 1 &&
              expectedLines.length === 1 &&
              actualLines[0] !== expectedLines[0]
            ) {
              var inputLength = actualLines[0].length + expectedLines[0].length; // If the character length of "actual" and "expected" together is less than
              // kMaxShortLength and if neither is an object and at least one of them is
              // not `zero`, use the strict equal comparison to visualize the output.
              if (inputLength <= kMaxShortLength) {
                if (
                  (_typeof(actual) !== "object" || actual === null) &&
                  (_typeof(expected) !== "object" || expected === null) &&
                  (actual !== 0 || expected !== 0)
                ) {
                  // -0 === +0
                  return (
                    "".concat(kReadableOperator[operator], "\n\n") +
                    ""
                      .concat(actualLines[0], " !== ")
                      .concat(expectedLines[0], "\n")
                  );
                }
              } else if (operator !== "strictEqualObject") {
                // If the stderr is a tty and the input length is lower than the current
                // columns per line, add a mismatch indicator below the output. If it is
                // not a tty, use a default value of 80 characters.
                var maxLength =
                  process.stderr && process.stderr.isTTY
                    ? process.stderr.columns
                    : 80;
                if (inputLength < maxLength) {
                  while (actualLines[0][i] === expectedLines[0][i]) {
                    i++;
                  } // Ignore the first characters.
                  if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat(repeat(" ", i), "^");
                    i = 0;
                  }
                }
              }
            } // Remove all ending lines that match (this optimizes the output for
            // readability by reducing the number of total changed lines).
            var a = actualLines[actualLines.length - 1];
            var b = expectedLines[expectedLines.length - 1];
            while (a === b) {
              if (i++ < 2) {
                end = "\n  ".concat(a).concat(end);
              } else {
                other = a;
              }
              actualLines.pop();
              expectedLines.pop();
              if (actualLines.length === 0 || expectedLines.length === 0) break;
              a = actualLines[actualLines.length - 1];
              b = expectedLines[expectedLines.length - 1];
            }
            var maxLines = Math.max(actualLines.length, expectedLines.length); // Strict equal with identical objects that are not identical by reference.
            // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
            if (maxLines === 0) {
              // We have to get the result again. The lines were all removed before.
              var _actualLines = actualInspected.split("\n"); // Only remove lines in case it makes sense to collapse those.
              // TODO: Accept env to always show the full error.
              if (_actualLines.length > 30) {
                _actualLines[26] = "".concat(blue, "...").concat(white);
                while (_actualLines.length > 27) {
                  _actualLines.pop();
                }
              }
              return ""
                .concat(kReadableOperator.notIdentical, "\n\n")
                .concat(_actualLines.join("\n"), "\n");
            }
            if (i > 3) {
              end = "\n".concat(blue, "...").concat(white).concat(end);
              skipped = true;
            }
            if (other !== "") {
              end = "\n  ".concat(other).concat(end);
              other = "";
            }
            var printedLines = 0;
            var msg =
              kReadableOperator[operator] +
              "\n"
                .concat(green, "+ actual")
                .concat(white, " ")
                .concat(red, "- expected")
                .concat(white);
            var skippedMsg = " "
              .concat(blue, "...")
              .concat(white, " Lines skipped");
            for (i = 0; i < maxLines; i++) {
              // Only extra expected lines exist
              var cur = i - lastPos;
              if (actualLines.length < i + 1) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                  if (cur > 4) {
                    res += "\n".concat(blue, "...").concat(white);
                    skipped = true;
                  } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                  }
                  res += "\n  ".concat(expectedLines[i - 1]);
                  printedLines++;
                } // Mark the current line as the last diverging one.
                lastPos = i; // Add the expected line to the cache.
                other += "\n"
                  .concat(red, "-")
                  .concat(white, " ")
                  .concat(expectedLines[i]);
                printedLines++; // Only extra actual lines exist
              } else if (expectedLines.length < i + 1) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                  if (cur > 4) {
                    res += "\n".concat(blue, "...").concat(white);
                    skipped = true;
                  } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                  }
                  res += "\n  ".concat(actualLines[i - 1]);
                  printedLines++;
                } // Mark the current line as the last diverging one.
                lastPos = i; // Add the actual line to the result.
                res += "\n"
                  .concat(green, "+")
                  .concat(white, " ")
                  .concat(actualLines[i]);
                printedLines++; // Lines diverge
              } else {
                var expectedLine = expectedLines[i];
                var actualLine = actualLines[i]; // If the lines diverge, specifically check for lines that only diverge by
                // a trailing comma. In that case it is actually identical and we should
                // mark it as such.
                var divergingLines =
                  actualLine !== expectedLine &&
                  (!endsWith(actualLine, ",") ||
                    actualLine.slice(0, -1) !== expectedLine); // If the expected line has a trailing comma but is otherwise identical,
                // add a comma at the end of the actual line. Otherwise the output could
                // look weird as in:
                //
                //   [
                //     1         // No comma at the end!
                // +   2
                //   ]
                //
                if (
                  divergingLines &&
                  endsWith(expectedLine, ",") &&
                  expectedLine.slice(0, -1) === actualLine
                ) {
                  divergingLines = false;
                  actualLine += ",";
                }
                if (divergingLines) {
                  // If the last diverging line is more than one line above and the
                  // current line is at least line three, add some of the former lines and
                  // also add dots to indicate skipped entries.
                  if (cur > 1 && i > 2) {
                    if (cur > 4) {
                      res += "\n".concat(blue, "...").concat(white);
                      skipped = true;
                    } else if (cur > 3) {
                      res += "\n  ".concat(actualLines[i - 2]);
                      printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                  } // Mark the current line as the last diverging one.
                  lastPos = i; // Add the actual line to the result and cache the expected diverging
                  // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                  res += "\n"
                    .concat(green, "+")
                    .concat(white, " ")
                    .concat(actualLine);
                  other += "\n"
                    .concat(red, "-")
                    .concat(white, " ")
                    .concat(expectedLine);
                  printedLines += 2; // Lines are identical
                } else {
                  // Add all cached information to the result before adding other things
                  // and reset the cache.
                  res += other;
                  other = ""; // If the last diverging line is exactly one line above or if it is the
                  // very first line, add the line to the result.
                  if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                  }
                }
              } // Inspected object to big (Show ~20 rows max)
              if (printedLines > 20 && i < maxLines - 2) {
                return (
                  ""
                    .concat(msg)
                    .concat(skippedMsg, "\n")
                    .concat(res, "\n")
                    .concat(blue, "...")
                    .concat(white)
                    .concat(other, "\n") + "".concat(blue, "...").concat(white)
                );
              }
            }
            return ""
              .concat(msg)
              .concat(skipped ? skippedMsg : "", "\n")
              .concat(res)
              .concat(other)
              .concat(end)
              .concat(indicator);
          }
          var AssertionError = /*#__PURE__*/ (function (_Error) {
            _inherits(AssertionError, _Error);
            function AssertionError(options) {
              var _this;
              _classCallCheck(this, AssertionError);
              if (_typeof(options) !== "object" || options === null) {
                throw new ERR_INVALID_ARG_TYPE("options", "Object", options);
              }
              var message = options.message,
                operator = options.operator,
                stackStartFn = options.stackStartFn;
              var actual = options.actual,
                expected = options.expected;
              var limit = Error.stackTraceLimit;
              Error.stackTraceLimit = 0;
              if (message != null) {
                _this = _possibleConstructorReturn(
                  this,
                  _getPrototypeOf(AssertionError).call(this, String(message))
                );
              } else {
                if (process.stderr && process.stderr.isTTY) {
                  // Reset on each call to make sure we handle dynamically set environment
                  // variables correct.
                  if (
                    process.stderr &&
                    process.stderr.getColorDepth &&
                    process.stderr.getColorDepth() !== 1
                  ) {
                    blue = "\x1B[34m";
                    green = "\x1B[32m";
                    white = "\x1B[39m";
                    red = "\x1B[31m";
                  } else {
                    blue = "";
                    green = "";
                    white = "";
                    red = "";
                  }
                } // Prevent the error stack from being visible by duplicating the error
                // in a very close way to the original in case both sides are actually
                // instances of Error.
                if (
                  _typeof(actual) === "object" &&
                  actual !== null &&
                  _typeof(expected) === "object" &&
                  expected !== null &&
                  "stack" in actual &&
                  _instanceof(actual, Error) &&
                  "stack" in expected &&
                  _instanceof(expected, Error)
                ) {
                  actual = copyError(actual);
                  expected = copyError(expected);
                }
                if (
                  operator === "deepStrictEqual" ||
                  operator === "strictEqual"
                ) {
                  _this = _possibleConstructorReturn(
                    this,
                    _getPrototypeOf(AssertionError).call(
                      this,
                      createErrDiff(actual, expected, operator)
                    )
                  );
                } else if (
                  operator === "notDeepStrictEqual" ||
                  operator === "notStrictEqual"
                ) {
                  // In case the objects are equal but the operator requires unequal, show
                  // the first object and say A equals B
                  var base = kReadableOperator[operator];
                  var res = inspectValue(actual).split("\n"); // In case "actual" is an object, it should not be reference equal.
                  if (
                    operator === "notStrictEqual" &&
                    _typeof(actual) === "object" &&
                    actual !== null
                  ) {
                    base = kReadableOperator.notStrictEqualObject;
                  } // Only remove lines in case it makes sense to collapse those.
                  // TODO: Accept env to always show the full error.
                  if (res.length > 30) {
                    res[26] = "".concat(blue, "...").concat(white);
                    while (res.length > 27) {
                      res.pop();
                    }
                  } // Only print a single input.
                  if (res.length === 1) {
                    _this = _possibleConstructorReturn(
                      this,
                      _getPrototypeOf(AssertionError).call(
                        this,
                        "".concat(base, " ").concat(res[0])
                      )
                    );
                  } else {
                    _this = _possibleConstructorReturn(
                      this,
                      _getPrototypeOf(AssertionError).call(
                        this,
                        "".concat(base, "\n\n").concat(res.join("\n"), "\n")
                      )
                    );
                  }
                } else {
                  var _res = inspectValue(actual);
                  var other = "";
                  var knownOperators = kReadableOperator[operator];
                  if (operator === "notDeepEqual" || operator === "notEqual") {
                    _res = ""
                      .concat(kReadableOperator[operator], "\n\n")
                      .concat(_res);
                    if (_res.length > 1024) {
                      _res = "".concat(_res.slice(0, 1021), "...");
                    }
                  } else {
                    other = "".concat(inspectValue(expected));
                    if (_res.length > 512) {
                      _res = "".concat(_res.slice(0, 509), "...");
                    }
                    if (other.length > 512) {
                      other = "".concat(other.slice(0, 509), "...");
                    }
                    if (operator === "deepEqual" || operator === "equal") {
                      _res = ""
                        .concat(knownOperators, "\n\n")
                        .concat(_res, "\n\nshould equal\n\n");
                    } else {
                      other = " ".concat(operator, " ").concat(other);
                    }
                  }
                  _this = _possibleConstructorReturn(
                    this,
                    _getPrototypeOf(AssertionError).call(
                      this,
                      "".concat(_res).concat(other)
                    )
                  );
                }
              }
              Error.stackTraceLimit = limit;
              _this.generatedMessage = !message;
              Object.defineProperty(_assertThisInitialized(_this), "name", {
                value: "AssertionError [ERR_ASSERTION]",
                enumerable: false,
                writable: true,
                configurable: true
              });
              _this.code = "ERR_ASSERTION";
              _this.actual = actual;
              _this.expected = expected;
              _this.operator = operator;
              if (Error.captureStackTrace) {
                // eslint-disable-next-line no-restricted-syntax
                Error.captureStackTrace(
                  _assertThisInitialized(_this),
                  stackStartFn
                );
              } // Create error message including the error code in the name.
              _this.stack; // Reset the name.
              _this.name = "AssertionError";
              return _possibleConstructorReturn(_this);
            }
            _createClass(AssertionError, [
              {
                key: "toString",
                value: function toString() {
                  return ""
                    .concat(this.name, " [")
                    .concat(this.code, "]: ")
                    .concat(this.message);
                }
              },
              {
                key: inspect.custom,
                value: function value(recurseTimes, ctx) {
                  // This limits the `actual` and `expected` property default inspection to
                  // the minimum depth. Otherwise those values would be too verbose compared
                  // to the actual error message which contains a combined view of these two
                  // input values.
                  return inspect(
                    this,
                    _objectSpread({}, ctx, { customInspect: false, depth: 0 })
                  );
                }
              }
            ]);
            return AssertionError;
          })(_wrapNativeSuper(Error));
          module.exports = AssertionError;
        },
        {
          process: "ec0e1432c6522aad9b4b16c4b3b080f4",
          "util/": "ea7cbe466cf2ea1251a276e89980c958",
          "../errors": "e3df48c6765df2e893a51bdb2215d1da"
        }
      ],
      eceeeccfb91751c1711e67f92616a0bf: [
        function (require, module, exports) {
          /**
           * Code refactored from Mozilla Developer Network:
           * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
           */ "use strict";
          function assign(target, firstSource) {
            if (target === undefined || target === null) {
              throw new TypeError("Cannot convert first argument to object");
            }
            var to = Object(target);
            for (var i = 1; i < arguments.length; i++) {
              var nextSource = arguments[i];
              if (nextSource === undefined || nextSource === null) {
                continue;
              }
              var keysArray = Object.keys(Object(nextSource));
              for (
                var nextIndex = 0, len = keysArray.length;
                nextIndex < len;
                nextIndex++
              ) {
                var nextKey = keysArray[nextIndex];
                var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                  to[nextKey] = nextSource[nextKey];
                }
              }
            }
            return to;
          }
          function polyfill() {
            if (!Object.assign) {
              Object.defineProperty(Object, "assign", {
                enumerable: false,
                configurable: true,
                writable: true,
                value: assign
              });
            }
          }
          module.exports = { assign: assign, polyfill: polyfill };
        },
        {}
      ],
      bab75db18635ed9619713d116b72d21d: [
        function (require, module, exports) {
          "use strict"; // http://www.ecma-international.org/ecma-262/6.0/#sec-object.is
          var numberIsNaN = function numberIsNaN(value) {
            return value !== value;
          };
          module.exports = function is(a, b) {
            if (a === 0 && b === 0) {
              return 1 / a === 1 / b;
            }
            if (a === b) {
              return true;
            }
            if (numberIsNaN(a) && numberIsNaN(b)) {
              return true;
            }
            return false;
          };
        },
        {}
      ],
      "83018a296d9e8eb8cf843b2dd7659a9e": [
        function (require, module, exports) {
          // Currently in sync with Node.js lib/internal/util/comparisons.js
          // https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
          "use strict";
          function _slicedToArray(arr, i) {
            return (
              _arrayWithHoles(arr) ||
              _iterableToArrayLimit(arr, i) ||
              _nonIterableRest()
            );
          }
          function _nonIterableRest() {
            throw new TypeError(
              "Invalid attempt to destructure non-iterable instance"
            );
          }
          function _iterableToArrayLimit(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;
            try {
              for (
                var _i = arr[Symbol.iterator](), _s;
                !(_n = (_s = _i.next()).done);
                _n = true
              ) {
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
              }
            } catch (err) {
              _d = true;
              _e = err;
            } finally {
              try {
                if (!_n && _i["return"] != null) _i["return"]();
              } finally {
                if (_d) throw _e;
              }
            }
            return _arr;
          }
          function _arrayWithHoles(arr) {
            if (Array.isArray(arr)) return arr;
          }
          function _typeof(obj) {
            if (
              typeof Symbol === "function" &&
              _typeof2(Symbol.iterator) === "symbol"
            ) {
              _typeof = function _typeof(obj) {
                return _typeof2(obj);
              };
            } else {
              _typeof = function _typeof(obj) {
                return obj &&
                  typeof Symbol === "function" &&
                  obj.constructor === Symbol &&
                  obj !== Symbol.prototype
                  ? "symbol"
                  : _typeof2(obj);
              };
            }
            return _typeof(obj);
          }
          var regexFlagsSupported = /a/g.flags !== undefined;
          var arrayFromSet = function arrayFromSet(set) {
            var array = [];
            set.forEach(function (value) {
              return array.push(value);
            });
            return array;
          };
          var arrayFromMap = function arrayFromMap(map) {
            var array = [];
            map.forEach(function (value, key) {
              return array.push([key, value]);
            });
            return array;
          };
          var objectIs = Object.is ? Object.is : require("object-is");
          var objectGetOwnPropertySymbols = Object.getOwnPropertySymbols
            ? Object.getOwnPropertySymbols
            : function () {
                return [];
              };
          var numberIsNaN = Number.isNaN ? Number.isNaN : require("is-nan");
          function uncurryThis(f) {
            return f.call.bind(f);
          }
          var hasOwnProperty = uncurryThis(Object.prototype.hasOwnProperty);
          var propertyIsEnumerable = uncurryThis(
            Object.prototype.propertyIsEnumerable
          );
          var objectToString = uncurryThis(Object.prototype.toString);
          var _require$types = require("util/").types,
            isAnyArrayBuffer = _require$types.isAnyArrayBuffer,
            isArrayBufferView = _require$types.isArrayBufferView,
            isDate = _require$types.isDate,
            isMap = _require$types.isMap,
            isRegExp = _require$types.isRegExp,
            isSet = _require$types.isSet,
            isNativeError = _require$types.isNativeError,
            isBoxedPrimitive = _require$types.isBoxedPrimitive,
            isNumberObject = _require$types.isNumberObject,
            isStringObject = _require$types.isStringObject,
            isBooleanObject = _require$types.isBooleanObject,
            isBigIntObject = _require$types.isBigIntObject,
            isSymbolObject = _require$types.isSymbolObject,
            isFloat32Array = _require$types.isFloat32Array,
            isFloat64Array = _require$types.isFloat64Array;
          function isNonIndex(key) {
            if (key.length === 0 || key.length > 10) return true;
            for (var i = 0; i < key.length; i++) {
              var code = key.charCodeAt(i);
              if (code < 48 || code > 57) return true;
            } // The maximum size for an array is 2 ** 32 -1.
            return key.length === 10 && key >= Math.pow(2, 32);
          }
          function getOwnNonIndexProperties(value) {
            return Object.keys(value)
              .filter(isNonIndex)
              .concat(
                objectGetOwnPropertySymbols(value).filter(
                  Object.prototype.propertyIsEnumerable.bind(value)
                )
              );
          } // Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
          // original notice:
          /*!
           * The buffer module from node.js, for the browser.
           *
           * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
           * @license  MIT
           */ function compare(a, b) {
            if (a === b) {
              return 0;
            }
            var x = a.length;
            var y = b.length;
            for (var i = 0, len = Math.min(x, y); i < len; ++i) {
              if (a[i] !== b[i]) {
                x = a[i];
                y = b[i];
                break;
              }
            }
            if (x < y) {
              return -1;
            }
            if (y < x) {
              return 1;
            }
            return 0;
          }
          var ONLY_ENUMERABLE = undefined;
          var kStrict = true;
          var kLoose = false;
          var kNoIterator = 0;
          var kIsArray = 1;
          var kIsSet = 2;
          var kIsMap = 3; // Check if they have the same source and flags
          function areSimilarRegExps(a, b) {
            return regexFlagsSupported
              ? a.source === b.source && a.flags === b.flags
              : RegExp.prototype.toString.call(a) ===
                  RegExp.prototype.toString.call(b);
          }
          function areSimilarFloatArrays(a, b) {
            if (a.byteLength !== b.byteLength) {
              return false;
            }
            for (var offset = 0; offset < a.byteLength; offset++) {
              if (a[offset] !== b[offset]) {
                return false;
              }
            }
            return true;
          }
          function areSimilarTypedArrays(a, b) {
            if (a.byteLength !== b.byteLength) {
              return false;
            }
            return (
              compare(
                new Uint8Array(a.buffer, a.byteOffset, a.byteLength),
                new Uint8Array(b.buffer, b.byteOffset, b.byteLength)
              ) === 0
            );
          }
          function areEqualArrayBuffers(buf1, buf2) {
            return (
              buf1.byteLength === buf2.byteLength &&
              compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0
            );
          }
          function isEqualBoxedPrimitive(val1, val2) {
            if (isNumberObject(val1)) {
              return (
                isNumberObject(val2) &&
                objectIs(
                  Number.prototype.valueOf.call(val1),
                  Number.prototype.valueOf.call(val2)
                )
              );
            }
            if (isStringObject(val1)) {
              return (
                isStringObject(val2) &&
                String.prototype.valueOf.call(val1) ===
                  String.prototype.valueOf.call(val2)
              );
            }
            if (isBooleanObject(val1)) {
              return (
                isBooleanObject(val2) &&
                Boolean.prototype.valueOf.call(val1) ===
                  Boolean.prototype.valueOf.call(val2)
              );
            }
            if (isBigIntObject(val1)) {
              return (
                isBigIntObject(val2) &&
                BigInt.prototype.valueOf.call(val1) ===
                  BigInt.prototype.valueOf.call(val2)
              );
            }
            return (
              isSymbolObject(val2) &&
              Symbol.prototype.valueOf.call(val1) ===
                Symbol.prototype.valueOf.call(val2)
            );
          } // Notes: Type tags are historical [[Class]] properties that can be set by
          // FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
          // and retrieved using Object.prototype.toString.call(obj) in JS
          // See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
          // for a list of tags pre-defined in the spec.
          // There are some unspecified tags in the wild too (e.g. typed array tags).
          // Since tags can be altered, they only serve fast failures
          //
          // Typed arrays and buffers are checked by comparing the content in their
          // underlying ArrayBuffer. This optimization requires that it's
          // reasonable to interpret their underlying memory in the same way,
          // which is checked by comparing their type tags.
          // (e.g. a Uint8Array and a Uint16Array with the same memory content
          // could still be different because they will be interpreted differently).
          //
          // For strict comparison, objects should have
          // a) The same built-in type tags
          // b) The same prototypes.
          function innerDeepEqual(val1, val2, strict, memos) {
            // All identical values are equivalent, as determined by ===.
            if (val1 === val2) {
              if (val1 !== 0) return true;
              return strict ? objectIs(val1, val2) : true;
            } // Check more closely if val1 and val2 are equal.
            if (strict) {
              if (_typeof(val1) !== "object") {
                return (
                  typeof val1 === "number" &&
                  numberIsNaN(val1) &&
                  numberIsNaN(val2)
                );
              }
              if (_typeof(val2) !== "object" || val1 === null || val2 === null) {
                return false;
              }
              if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) {
                return false;
              }
            } else {
              if (val1 === null || _typeof(val1) !== "object") {
                if (val2 === null || _typeof(val2) !== "object") {
                  // eslint-disable-next-line eqeqeq
                  return val1 == val2;
                }
                return false;
              }
              if (val2 === null || _typeof(val2) !== "object") {
                return false;
              }
            }
            var val1Tag = objectToString(val1);
            var val2Tag = objectToString(val2);
            if (val1Tag !== val2Tag) {
              return false;
            }
            if (Array.isArray(val1)) {
              // Check for sparse arrays and general fast path
              if (val1.length !== val2.length) {
                return false;
              }
              var keys1 = getOwnNonIndexProperties(val1, ONLY_ENUMERABLE);
              var keys2 = getOwnNonIndexProperties(val2, ONLY_ENUMERABLE);
              if (keys1.length !== keys2.length) {
                return false;
              }
              return keyCheck(val1, val2, strict, memos, kIsArray, keys1);
            } // [browserify] This triggers on certain types in IE (Map/Set) so we don't
            // wan't to early return out of the rest of the checks. However we can check
            // if the second value is one of these values and the first isn't.
            if (val1Tag === "[object Object]") {
              // return keyCheck(val1, val2, strict, memos, kNoIterator);
              if (
                (!isMap(val1) && isMap(val2)) ||
                (!isSet(val1) && isSet(val2))
              ) {
                return false;
              }
            }
            if (isDate(val1)) {
              if (
                !isDate(val2) ||
                Date.prototype.getTime.call(val1) !==
                  Date.prototype.getTime.call(val2)
              ) {
                return false;
              }
            } else if (isRegExp(val1)) {
              if (!isRegExp(val2) || !areSimilarRegExps(val1, val2)) {
                return false;
              }
            } else if (isNativeError(val1) || _instanceof(val1, Error)) {
              // Do not compare the stack as it might differ even though the error itself
              // is otherwise identical.
              if (val1.message !== val2.message || val1.name !== val2.name) {
                return false;
              }
            } else if (isArrayBufferView(val1)) {
              if (!strict && (isFloat32Array(val1) || isFloat64Array(val1))) {
                if (!areSimilarFloatArrays(val1, val2)) {
                  return false;
                }
              } else if (!areSimilarTypedArrays(val1, val2)) {
                return false;
              } // Buffer.compare returns true, so val1.length === val2.length. If they both
              // only contain numeric keys, we don't need to exam further than checking
              // the symbols.
              var _keys = getOwnNonIndexProperties(val1, ONLY_ENUMERABLE);
              var _keys2 = getOwnNonIndexProperties(val2, ONLY_ENUMERABLE);
              if (_keys.length !== _keys2.length) {
                return false;
              }
              return keyCheck(val1, val2, strict, memos, kNoIterator, _keys);
            } else if (isSet(val1)) {
              if (!isSet(val2) || val1.size !== val2.size) {
                return false;
              }
              return keyCheck(val1, val2, strict, memos, kIsSet);
            } else if (isMap(val1)) {
              if (!isMap(val2) || val1.size !== val2.size) {
                return false;
              }
              return keyCheck(val1, val2, strict, memos, kIsMap);
            } else if (isAnyArrayBuffer(val1)) {
              if (!areEqualArrayBuffers(val1, val2)) {
                return false;
              }
            } else if (
              isBoxedPrimitive(val1) &&
              !isEqualBoxedPrimitive(val1, val2)
            ) {
              return false;
            }
            return keyCheck(val1, val2, strict, memos, kNoIterator);
          }
          function getEnumerables(val, keys) {
            return keys.filter(function (k) {
              return propertyIsEnumerable(val, k);
            });
          }
          function keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
            // For all remaining Object pairs, including Array, objects and Maps,
            // equivalence is determined by having:
            // a) The same number of owned enumerable properties
            // b) The same set of keys/indexes (although not necessarily the same order)
            // c) Equivalent values for every corresponding key/index
            // d) For Sets and Maps, equal contents
            // Note: this accounts for both named and indexed properties on Arrays.
            if (arguments.length === 5) {
              aKeys = Object.keys(val1);
              var bKeys = Object.keys(val2); // The pair must have the same number of owned properties.
              if (aKeys.length !== bKeys.length) {
                return false;
              }
            } // Cheap key test
            var i = 0;
            for (; i < aKeys.length; i++) {
              if (!hasOwnProperty(val2, aKeys[i])) {
                return false;
              }
            }
            if (strict && arguments.length === 5) {
              var symbolKeysA = objectGetOwnPropertySymbols(val1);
              if (symbolKeysA.length !== 0) {
                var count = 0;
                for (i = 0; i < symbolKeysA.length; i++) {
                  var key = symbolKeysA[i];
                  if (propertyIsEnumerable(val1, key)) {
                    if (!propertyIsEnumerable(val2, key)) {
                      return false;
                    }
                    aKeys.push(key);
                    count++;
                  } else if (propertyIsEnumerable(val2, key)) {
                    return false;
                  }
                }
                var symbolKeysB = objectGetOwnPropertySymbols(val2);
                if (
                  symbolKeysA.length !== symbolKeysB.length &&
                  getEnumerables(val2, symbolKeysB).length !== count
                ) {
                  return false;
                }
              } else {
                var _symbolKeysB = objectGetOwnPropertySymbols(val2);
                if (
                  _symbolKeysB.length !== 0 &&
                  getEnumerables(val2, _symbolKeysB).length !== 0
                ) {
                  return false;
                }
              }
            }
            if (
              aKeys.length === 0 &&
              (iterationType === kNoIterator ||
                (iterationType === kIsArray && val1.length === 0) ||
                val1.size === 0)
            ) {
              return true;
            } // Use memos to handle cycles.
            if (memos === undefined) {
              memos = { val1: new Map(), val2: new Map(), position: 0 };
            } else {
              // We prevent up to two map.has(x) calls by directly retrieving the value
              // and checking for undefined. The map can only contain numbers, so it is
              // safe to check for undefined only.
              var val2MemoA = memos.val1.get(val1);
              if (val2MemoA !== undefined) {
                var val2MemoB = memos.val2.get(val2);
                if (val2MemoB !== undefined) {
                  return val2MemoA === val2MemoB;
                }
              }
              memos.position++;
            }
            memos.val1.set(val1, memos.position);
            memos.val2.set(val2, memos.position);
            var areEq = objEquiv(val1, val2, strict, aKeys, memos, iterationType);
            memos.val1.delete(val1);
            memos.val2.delete(val2);
            return areEq;
          }
          function setHasEqualElement(set, val1, strict, memo) {
            // Go looking.
            var setValues = arrayFromSet(set);
            for (var i = 0; i < setValues.length; i++) {
              var val2 = setValues[i];
              if (innerDeepEqual(val1, val2, strict, memo)) {
                // Remove the matching element to make sure we do not check that again.
                set.delete(val2);
                return true;
              }
            }
            return false;
          } // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
          // Sadly it is not possible to detect corresponding values properly in case the
          // type is a string, number, bigint or boolean. The reason is that those values
          // can match lots of different string values (e.g., 1n == '+00001').
          function findLooseMatchingPrimitives(prim) {
            switch (_typeof(prim)) {
              case "undefined":
                return null;
              case "object": // Only pass in null as object!
                return undefined;
              case "symbol":
                return false;
              case "string":
                prim = +prim; // Loose equal entries exist only if the string is possible to convert to
              // a regular number and not NaN.
              // Fall through
              case "number":
                if (numberIsNaN(prim)) {
                  return false;
                }
            }
            return true;
          }
          function setMightHaveLoosePrim(a, b, prim) {
            var altValue = findLooseMatchingPrimitives(prim);
            if (altValue != null) return altValue;
            return b.has(altValue) && !a.has(altValue);
          }
          function mapMightHaveLoosePrim(a, b, prim, item, memo) {
            var altValue = findLooseMatchingPrimitives(prim);
            if (altValue != null) {
              return altValue;
            }
            var curB = b.get(altValue);
            if (
              (curB === undefined && !b.has(altValue)) ||
              !innerDeepEqual(item, curB, false, memo)
            ) {
              return false;
            }
            return !a.has(altValue) && innerDeepEqual(item, curB, false, memo);
          }
          function setEquiv(a, b, strict, memo) {
            // This is a lazily initiated Set of entries which have to be compared
            // pairwise.
            var set = null;
            var aValues = arrayFromSet(a);
            for (var i = 0; i < aValues.length; i++) {
              var val = aValues[i]; // Note: Checking for the objects first improves the performance for object
              // heavy sets but it is a minor slow down for primitives. As they are fast
              // to check this improves the worst case scenario instead.
              if (_typeof(val) === "object" && val !== null) {
                if (set === null) {
                  set = new Set();
                } // If the specified value doesn't exist in the second set its an not null
                // object (or non strict only: a not matching primitive) we'll need to go
                // hunting for something thats deep-(strict-)equal to it. To make this
                // O(n log n) complexity we have to copy these values in a new set first.
                set.add(val);
              } else if (!b.has(val)) {
                if (strict) return false; // Fast path to detect missing string, symbol, undefined and null values.
                if (!setMightHaveLoosePrim(a, b, val)) {
                  return false;
                }
                if (set === null) {
                  set = new Set();
                }
                set.add(val);
              }
            }
            if (set !== null) {
              var bValues = arrayFromSet(b);
              for (var _i = 0; _i < bValues.length; _i++) {
                var _val = bValues[_i]; // We have to check if a primitive value is already
                // matching and only if it's not, go hunting for it.
                if (_typeof(_val) === "object" && _val !== null) {
                  if (!setHasEqualElement(set, _val, strict, memo)) return false;
                } else if (
                  !strict &&
                  !a.has(_val) &&
                  !setHasEqualElement(set, _val, strict, memo)
                ) {
                  return false;
                }
              }
              return set.size === 0;
            }
            return true;
          }
          function mapHasEqualEntry(set, map, key1, item1, strict, memo) {
            // To be able to handle cases like:
            //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
            // ... we need to consider *all* matching keys, not just the first we find.
            var setValues = arrayFromSet(set);
            for (var i = 0; i < setValues.length; i++) {
              var key2 = setValues[i];
              if (
                innerDeepEqual(key1, key2, strict, memo) &&
                innerDeepEqual(item1, map.get(key2), strict, memo)
              ) {
                set.delete(key2);
                return true;
              }
            }
            return false;
          }
          function mapEquiv(a, b, strict, memo) {
            var set = null;
            var aEntries = arrayFromMap(a);
            for (var i = 0; i < aEntries.length; i++) {
              var _aEntries$i = _slicedToArray(aEntries[i], 2),
                key = _aEntries$i[0],
                item1 = _aEntries$i[1];
              if (_typeof(key) === "object" && key !== null) {
                if (set === null) {
                  set = new Set();
                }
                set.add(key);
              } else {
                // By directly retrieving the value we prevent another b.has(key) check in
                // almost all possible cases.
                var item2 = b.get(key);
                if (
                  (item2 === undefined && !b.has(key)) ||
                  !innerDeepEqual(item1, item2, strict, memo)
                ) {
                  if (strict) return false; // Fast path to detect missing string, symbol, undefined and null
                  // keys.
                  if (!mapMightHaveLoosePrim(a, b, key, item1, memo))
                    return false;
                  if (set === null) {
                    set = new Set();
                  }
                  set.add(key);
                }
              }
            }
            if (set !== null) {
              var bEntries = arrayFromMap(b);
              for (var _i2 = 0; _i2 < bEntries.length; _i2++) {
                var _bEntries$_i = _slicedToArray(bEntries[_i2], 2),
                  key = _bEntries$_i[0],
                  item = _bEntries$_i[1];
                if (_typeof(key) === "object" && key !== null) {
                  if (!mapHasEqualEntry(set, a, key, item, strict, memo))
                    return false;
                } else if (
                  !strict &&
                  (!a.has(key) ||
                    !innerDeepEqual(a.get(key), item, false, memo)) &&
                  !mapHasEqualEntry(set, a, key, item, false, memo)
                ) {
                  return false;
                }
              }
              return set.size === 0;
            }
            return true;
          }
          function objEquiv(a, b, strict, keys, memos, iterationType) {
            // Sets and maps don't have their entries accessible via normal object
            // properties.
            var i = 0;
            if (iterationType === kIsSet) {
              if (!setEquiv(a, b, strict, memos)) {
                return false;
              }
            } else if (iterationType === kIsMap) {
              if (!mapEquiv(a, b, strict, memos)) {
                return false;
              }
            } else if (iterationType === kIsArray) {
              for (; i < a.length; i++) {
                if (hasOwnProperty(a, i)) {
                  if (
                    !hasOwnProperty(b, i) ||
                    !innerDeepEqual(a[i], b[i], strict, memos)
                  ) {
                    return false;
                  }
                } else if (hasOwnProperty(b, i)) {
                  return false;
                } else {
                  // Array is sparse.
                  var keysA = Object.keys(a);
                  for (; i < keysA.length; i++) {
                    var key = keysA[i];
                    if (
                      !hasOwnProperty(b, key) ||
                      !innerDeepEqual(a[key], b[key], strict, memos)
                    ) {
                      return false;
                    }
                  }
                  if (keysA.length !== Object.keys(b).length) {
                    return false;
                  }
                  return true;
                }
              }
            } // The pair must have equivalent values for every corresponding key.
            // Possibly expensive deep test:
            for (i = 0; i < keys.length; i++) {
              var _key = keys[i];
              if (!innerDeepEqual(a[_key], b[_key], strict, memos)) {
                return false;
              }
            }
            return true;
          }
          function isDeepEqual(val1, val2) {
            return innerDeepEqual(val1, val2, kLoose);
          }
          function isDeepStrictEqual(val1, val2) {
            return innerDeepEqual(val1, val2, kStrict);
          }
          module.exports = {
            isDeepEqual: isDeepEqual,
            isDeepStrictEqual: isDeepStrictEqual
          };
        },
        {
          "object-is": "bab75db18635ed9619713d116b72d21d",
          "is-nan": "058bcdb80df838014d962f3c9de28ede",
          "util/": "ea7cbe466cf2ea1251a276e89980c958"
        }
      ],
      "058bcdb80df838014d962f3c9de28ede": [
        function (require, module, exports) {
          "use strict";
          var define = require("define-properties");
          var implementation = require("./implementation");
          var getPolyfill = require("./polyfill");
          var shim = require("./shim");
          var polyfill = getPolyfill();
          /* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ define(polyfill, {
            getPolyfill: getPolyfill,
            implementation: implementation,
            shim: shim
          });
          module.exports = polyfill;
        },
        {
          "define-properties": "ea0390932cbe11b1eadde457a2c9c281",
          "./implementation": "ebda40e0586ede9d11216a6bc754a82a",
          "./polyfill": "e9ae70f28bfabd4852e75925d60fb488",
          "./shim": "75beb48f4d4ff9f0229942eb5785825e"
        }
      ],
      ea0390932cbe11b1eadde457a2c9c281: [
        function (require, module, exports) {
          "use strict";
          var keys = require("object-keys");
          var hasSymbols =
            typeof Symbol === "function" && _typeof2(Symbol("foo")) === "symbol";
          var toStr = Object.prototype.toString;
          var concat = Array.prototype.concat;
          var origDefineProperty = Object.defineProperty;
          var isFunction = function isFunction(fn) {
            return (
              typeof fn === "function" && toStr.call(fn) === "[object Function]"
            );
          };
          var arePropertyDescriptorsSupported = function arePropertyDescriptorsSupported() {
            var obj = {};
            try {
              origDefineProperty(obj, "x", { enumerable: false, value: obj }); // eslint-disable-next-line no-unused-vars, no-restricted-syntax
              for (var _ in obj) {
                // jscs:ignore disallowUnusedVariables
                return false;
              }
              return obj.x === obj;
            } catch (e) {
              /* this is IE 8. */ return false;
            }
          };
          var supportsDescriptors =
            origDefineProperty && arePropertyDescriptorsSupported();
          var defineProperty = function defineProperty(
            object,
            name,
            value,
            predicate
          ) {
            if (name in object && (!isFunction(predicate) || !predicate())) {
              return;
            }
            if (supportsDescriptors) {
              origDefineProperty(object, name, {
                configurable: true,
                enumerable: false,
                value: value,
                writable: true
              });
            } else {
              object[name] = value;
            }
          };
          var defineProperties = function defineProperties(object, map) {
            var predicates = arguments.length > 2 ? arguments[2] : {};
            var props = keys(map);
            if (hasSymbols) {
              props = concat.call(props, Object.getOwnPropertySymbols(map));
            }
            for (var i = 0; i < props.length; i += 1) {
              defineProperty(
                object,
                props[i],
                map[props[i]],
                predicates[props[i]]
              );
            }
          };
          defineProperties.supportsDescriptors = !!supportsDescriptors;
          module.exports = defineProperties;
        },
        { "object-keys": "fb0738f86fdcdff4915257022fb5fb29" }
      ],
      fb0738f86fdcdff4915257022fb5fb29: [
        function (require, module, exports) {
          "use strict";
          var slice = Array.prototype.slice;
          var isArgs = require("./isArguments");
          var origKeys = Object.keys;
          var keysShim = origKeys
            ? function keys(o) {
                return origKeys(o);
              }
            : require("./implementation");
          var originalKeys = Object.keys;
          keysShim.shim = function shimObjectKeys() {
            if (Object.keys) {
              var keysWorksWithArguments = (function () {
                // Safari 5.0 bug
                var args = Object.keys(arguments);
                return args && args.length === arguments.length;
              })(1, 2);
              if (!keysWorksWithArguments) {
                Object.keys = function keys(object) {
                  // eslint-disable-line func-name-matching
                  if (isArgs(object)) {
                    return originalKeys(slice.call(object));
                  }
                  return originalKeys(object);
                };
              }
            } else {
              Object.keys = keysShim;
            }
            return Object.keys || keysShim;
          };
          module.exports = keysShim;
        },
        {
          "./isArguments": "2c76665e961e7a22ff6535797258f04c",
          "./implementation": "15b21c9f4f7ea08622a03eae66a3bf2b"
        }
      ],
      "2c76665e961e7a22ff6535797258f04c": [
        function (require, module, exports) {
          "use strict";
          var toStr = Object.prototype.toString;
          module.exports = function isArguments(value) {
            var str = toStr.call(value);
            var isArgs = str === "[object Arguments]";
            if (!isArgs) {
              isArgs =
                str !== "[object Array]" &&
                value !== null &&
                _typeof2(value) === "object" &&
                typeof value.length === "number" &&
                value.length >= 0 &&
                toStr.call(value.callee) === "[object Function]";
            }
            return isArgs;
          };
        },
        {}
      ],
      "15b21c9f4f7ea08622a03eae66a3bf2b": [
        function (require, module, exports) {
          "use strict";
          var keysShim;
          if (!Object.keys) {
            // modified from https://github.com/es-shims/es5-shim
            var has = Object.prototype.hasOwnProperty;
            var toStr = Object.prototype.toString;
            var isArgs = require("./isArguments"); // eslint-disable-line global-require
            var isEnumerable = Object.prototype.propertyIsEnumerable;
            var hasDontEnumBug = !isEnumerable.call(
              { toString: null },
              "toString"
            );
            var hasProtoEnumBug = isEnumerable.call(function () {}, "prototype");
            var dontEnums = [
              "toString",
              "toLocaleString",
              "valueOf",
              "hasOwnProperty",
              "isPrototypeOf",
              "propertyIsEnumerable",
              "constructor"
            ];
            var equalsConstructorPrototype = function equalsConstructorPrototype(
              o
            ) {
              var ctor = o.constructor;
              return ctor && ctor.prototype === o;
            };
            var excludedKeys = {
              $applicationCache: true,
              $console: true,
              $external: true,
              $frame: true,
              $frameElement: true,
              $frames: true,
              $innerHeight: true,
              $innerWidth: true,
              $onmozfullscreenchange: true,
              $onmozfullscreenerror: true,
              $outerHeight: true,
              $outerWidth: true,
              $pageXOffset: true,
              $pageYOffset: true,
              $parent: true,
              $scrollLeft: true,
              $scrollTop: true,
              $scrollX: true,
              $scrollY: true,
              $self: true,
              $webkitIndexedDB: true,
              $webkitStorageInfo: true,
              $window: true
            };
            var hasAutomationEqualityBug = (function () {
              /* global window */ if (typeof window === "undefined") {
                return false;
              }
              for (var k in window) {
                try {
                  if (
                    !excludedKeys["$" + k] &&
                    has.call(window, k) &&
                    window[k] !== null &&
                    _typeof2(window[k]) === "object"
                  ) {
                    try {
                      equalsConstructorPrototype(window[k]);
                    } catch (e) {
                      return true;
                    }
                  }
                } catch (e) {
                  return true;
                }
              }
              return false;
            })();
            var equalsConstructorPrototypeIfNotBuggy = function equalsConstructorPrototypeIfNotBuggy(
              o
            ) {
              /* global window */ if (
                typeof window === "undefined" ||
                !hasAutomationEqualityBug
              ) {
                return equalsConstructorPrototype(o);
              }
              try {
                return equalsConstructorPrototype(o);
              } catch (e) {
                return false;
              }
            };
            keysShim = function keys(object) {
              var isObject = object !== null && _typeof2(object) === "object";
              var isFunction = toStr.call(object) === "[object Function]";
              var isArguments = isArgs(object);
              var isString = isObject && toStr.call(object) === "[object String]";
              var theKeys = [];
              if (!isObject && !isFunction && !isArguments) {
                throw new TypeError("Object.keys called on a non-object");
              }
              var skipProto = hasProtoEnumBug && isFunction;
              if (isString && object.length > 0 && !has.call(object, 0)) {
                for (var i = 0; i < object.length; ++i) {
                  theKeys.push(String(i));
                }
              }
              if (isArguments && object.length > 0) {
                for (var j = 0; j < object.length; ++j) {
                  theKeys.push(String(j));
                }
              } else {
                for (var name in object) {
                  if (
                    !(skipProto && name === "prototype") &&
                    has.call(object, name)
                  ) {
                    theKeys.push(String(name));
                  }
                }
              }
              if (hasDontEnumBug) {
                var skipConstructor = equalsConstructorPrototypeIfNotBuggy(
                  object
                );
                for (var k = 0; k < dontEnums.length; ++k) {
                  if (
                    !(skipConstructor && dontEnums[k] === "constructor") &&
                    has.call(object, dontEnums[k])
                  ) {
                    theKeys.push(dontEnums[k]);
                  }
                }
              }
              return theKeys;
            };
          }
          module.exports = keysShim;
        },
        { "./isArguments": "2c76665e961e7a22ff6535797258f04c" }
      ],
      ebda40e0586ede9d11216a6bc754a82a: [
        function (require, module, exports) {
          "use strict";
          /* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(
            value
          ) {
            return value !== value;
          };
        },
        {}
      ],
      e9ae70f28bfabd4852e75925d60fb488: [
        function (require, module, exports) {
          "use strict";
          var implementation = require("./implementation");
          module.exports = function getPolyfill() {
            if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a")) {
              return Number.isNaN;
            }
            return implementation;
          };
        },
        { "./implementation": "ebda40e0586ede9d11216a6bc754a82a" }
      ],
      "75beb48f4d4ff9f0229942eb5785825e": [
        function (require, module, exports) {
          "use strict";
          var define = require("define-properties");
          var getPolyfill = require("./polyfill");
          /* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
            var polyfill = getPolyfill();
            define(Number, { isNaN: polyfill }, {
              isNaN: function testIsNaN() {
                return Number.isNaN !== polyfill;
              }
            });
            return polyfill;
          };
        },
        {
          "define-properties": "ea0390932cbe11b1eadde457a2c9c281",
          "./polyfill": "e9ae70f28bfabd4852e75925d60fb488"
        }
      ],
      "26538967e1aaac4012759f537e3a1243": [
        function (require, module, exports) {
          "use strict";
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.types = exports.ShaMap = exports.HashPrefix = exports.quality = exports.TransactionResult = exports.Type = exports.LedgerEntryType = exports.TransactionType = exports.Field = exports.ledgerHashes = exports.binary = exports.hashes = void 0;
          var enums_1 = require("./enums");
          Object.defineProperty(exports, "Field", {
            enumerable: true,
            get: function get() {
              return enums_1.Field;
            }
          });
          Object.defineProperty(exports, "TransactionType", {
            enumerable: true,
            get: function get() {
              return enums_1.TransactionType;
            }
          });
          Object.defineProperty(exports, "LedgerEntryType", {
            enumerable: true,
            get: function get() {
              return enums_1.LedgerEntryType;
            }
          });
          Object.defineProperty(exports, "Type", {
            enumerable: true,
            get: function get() {
              return enums_1.Type;
            }
          });
          Object.defineProperty(exports, "TransactionResult", {
            enumerable: true,
            get: function get() {
              return enums_1.TransactionResult;
            }
          });
          var types = require("./types");
          exports.types = types;
          var binary = require("./binary");
          exports.binary = binary;
          var shamap_1 = require("./shamap");
          Object.defineProperty(exports, "ShaMap", {
            enumerable: true,
            get: function get() {
              return shamap_1.ShaMap;
            }
          });
          var ledgerHashes = require("./ledger-hashes");
          exports.ledgerHashes = ledgerHashes;
          var hashes = require("./hashes");
          exports.hashes = hashes;
          var quality_1 = require("./quality");
          Object.defineProperty(exports, "quality", {
            enumerable: true,
            get: function get() {
              return quality_1.quality;
            }
          });
          var hash_prefixes_1 = require("./hash-prefixes");
          Object.defineProperty(exports, "HashPrefix", {
            enumerable: true,
            get: function get() {
              return hash_prefixes_1.HashPrefix;
            }
          });
        },
        {
          "./enums": "b4c7d31c276a9e273ef13c8edd1ea3c0",
          "./types": "2f5058ac620289ba00afd2d63dec38ff",
          "./binary": "235e4e3c6dabdad7fc149dc613c6a64d",
          "./shamap": "6db0b113dbcf6a9e61cddb46f9d3cc2c",
          "./ledger-hashes": "8409c82d684e65900f24b69e56e3520e",
          "./hashes": "591b92021ceaddc947db9b773fc52b5b",
          "./quality": "f51f94f12f45486b6b6bb709aef787a3",
          "./hash-prefixes": "278aa5cba36abaadc3cd0043382a9cc0"
        }
      ],
      b4c7d31c276a9e273ef13c8edd1ea3c0: [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("buffer").Buffer;
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.TransactionType = exports.TransactionResult = exports.LedgerEntryType = exports.Type = exports.Field = void 0;
          var enums = require("./definitions.json");
          var serialized_type_1 = require("../types/serialized-type");
          var TYPE_WIDTH = 2;
          var LEDGER_ENTRY_WIDTH = 2;
          var TRANSACTION_TYPE_WIDTH = 2;
          var TRANSACTION_RESULT_WIDTH = 1;
          /*
           * @brief: Serialize a field based on type_code and Field.nth
           */ function fieldHeader(type, nth) {
            var header = [];
            if (type < 16) {
              if (nth < 16) {
                header.push((type << 4) | nth);
              } else {
                header.push(type << 4, nth);
              }
            } else if (nth < 16) {
              header.push(nth, type);
            } else {
              header.push(0, type, nth);
            }
            return Buffer.from(header);
          }
          /*
           * @brief: Bytes, name, and ordinal representing one type, ledger_type, transaction type, or result
           */ var Bytes = /** @class */ (function () {
            function Bytes(name, ordinal, ordinalWidth) {
              this.name = name;
              this.ordinal = ordinal;
              this.ordinalWidth = ordinalWidth;
              this.bytes = Buffer.alloc(ordinalWidth);
              for (var i = 0; i < ordinalWidth; i++) {
                this.bytes[ordinalWidth - i - 1] = (ordinal >>> (i * 8)) & 0xff;
              }
            }
            Bytes.prototype.toJSON = function () {
              return this.name;
            };
            Bytes.prototype.toBytesSink = function (sink) {
              sink.put(this.bytes);
            };
            Bytes.prototype.toBytes = function () {
              return this.bytes;
            };
            return Bytes;
          })();
          /*
           * @brief: Collection of Bytes objects, mapping bidirectionally
           */ var BytesLookup = /** @class */ (function () {
            function BytesLookup(types, ordinalWidth) {
              var _this = this;
              this.ordinalWidth = ordinalWidth;
              Object.entries(types).forEach(function (_a) {
                var k = _a[0],
                  v = _a[1];
                _this[k] = new Bytes(k, v, ordinalWidth);
                _this[v.toString()] = _this[k];
              });
            }
            BytesLookup.prototype.from = function (value) {
              return _instanceof(value, Bytes) ? value : this[value];
            };
            BytesLookup.prototype.fromParser = function (parser) {
              return this.from(parser.readUIntN(this.ordinalWidth).toString());
            };
            return BytesLookup;
          })();
          function buildField(_a) {
            var name = _a[0],
              info = _a[1];
            var typeOrdinal = enums.TYPES[info.type];
            var field = fieldHeader(typeOrdinal, info.nth);
            return {
              name: name,
              nth: info.nth,
              isVariableLengthEncoded: info.isVLEncoded,
              isSerialized: info.isSerialized,
              isSigningField: info.isSigningField,
              ordinal: (typeOrdinal << 16) | info.nth,
              type: new Bytes(info.type, typeOrdinal, TYPE_WIDTH),
              header: field,
              associatedType: serialized_type_1.SerializedType
            };
          }
          /*
           * @brief: The collection of all fields as defined in definitions.json
           */ var FieldLookup = /** @class */ (function () {
            function FieldLookup(fields) {
              var _this = this;
              fields.forEach(function (_a) {
                var k = _a[0],
                  v = _a[1];
                _this[k] = buildField([k, v]);
                _this[_this[k].ordinal.toString()] = _this[k];
              });
            }
            FieldLookup.prototype.fromString = function (value) {
              return this[value];
            };
            return FieldLookup;
          })();
          var Type = new BytesLookup(enums.TYPES, TYPE_WIDTH);
          exports.Type = Type;
          var LedgerEntryType = new BytesLookup(
            enums.LEDGER_ENTRY_TYPES,
            LEDGER_ENTRY_WIDTH
          );
          exports.LedgerEntryType = LedgerEntryType;
          var TransactionType = new BytesLookup(
            enums.TRANSACTION_TYPES,
            TRANSACTION_TYPE_WIDTH
          );
          exports.TransactionType = TransactionType;
          var TransactionResult = new BytesLookup(
            enums.TRANSACTION_RESULTS,
            TRANSACTION_RESULT_WIDTH
          );
          exports.TransactionResult = TransactionResult;
          var Field = new FieldLookup(enums.FIELDS);
          exports.Field = Field;
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          "./definitions.json": "57af660a61de29645086bff8e825577d",
          "../types/serialized-type": "0f0f786f836b5aa515dc3100a1d71ee2"
        }
      ],
      "57af660a61de29645086bff8e825577d": [
        function (require, module, exports) {
          module.exports = JSON.parse(
            '{"TYPES":{"Validation":10003,"Done":-1,"Hash128":4,"Blob":7,"AccountID":8,"Amount":6,"Hash256":5,"UInt8":16,"Vector256":19,"STObject":14,"Unknown":-2,"Transaction":10001,"Hash160":17,"PathSet":18,"LedgerEntry":10002,"UInt16":1,"NotPresent":0,"UInt64":3,"UInt32":2,"STArray":15},"LEDGER_ENTRY_TYPES":{"Any":-3,"Child":-2,"Invalid":-1,"AccountRoot":97,"DirectoryNode":100,"RippleState":114,"Ticket":84,"SignerList":83,"Offer":111,"LedgerHashes":104,"Amendments":102,"FeeSettings":115,"Escrow":117,"PayChannel":120,"DepositPreauth":112,"Check":67,"Nickname":110,"Contract":99,"GeneratorMap":103,"NegativeUNL":78},"FIELDS":[["Generic",{"nth":0,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"Unknown"}],["Invalid",{"nth":-1,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"Unknown"}],["LedgerEntryType",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt16"}],["TransactionType",{"nth":2,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt16"}],["SignerWeight",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt16"}],["Flags",{"nth":2,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["SourceTag",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["Sequence",{"nth":4,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["PreviousTxnLgrSeq",{"nth":5,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["LedgerSequence",{"nth":6,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["CloseTime",{"nth":7,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["ParentCloseTime",{"nth":8,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["SigningTime",{"nth":9,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["Expiration",{"nth":10,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["TransferRate",{"nth":11,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["WalletSize",{"nth":12,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["OwnerCount",{"nth":13,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["DestinationTag",{"nth":14,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["HighQualityIn",{"nth":16,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["HighQualityOut",{"nth":17,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["LowQualityIn",{"nth":18,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["LowQualityOut",{"nth":19,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["QualityIn",{"nth":20,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["QualityOut",{"nth":21,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["StampEscrow",{"nth":22,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["BondAmount",{"nth":23,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["LoadFee",{"nth":24,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["OfferSequence",{"nth":25,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["FirstLedgerSequence",{"nth":26,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["LastLedgerSequence",{"nth":27,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["TransactionIndex",{"nth":28,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["OperationLimit",{"nth":29,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["ReferenceFeeUnits",{"nth":30,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["ReserveBase",{"nth":31,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["ReserveIncrement",{"nth":32,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["SetFlag",{"nth":33,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["ClearFlag",{"nth":34,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["SignerQuorum",{"nth":35,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["CancelAfter",{"nth":36,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["FinishAfter",{"nth":37,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["IndexNext",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["IndexPrevious",{"nth":2,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["BookNode",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["OwnerNode",{"nth":4,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["BaseFee",{"nth":5,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["ExchangeRate",{"nth":6,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["LowNode",{"nth":7,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["HighNode",{"nth":8,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}],["EmailHash",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash128"}],["LedgerHash",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["ParentHash",{"nth":2,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["TransactionHash",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["AccountHash",{"nth":4,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["PreviousTxnID",{"nth":5,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["LedgerIndex",{"nth":6,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["WalletLocator",{"nth":7,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["RootIndex",{"nth":8,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["AccountTxnID",{"nth":9,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["BookDirectory",{"nth":16,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["InvoiceID",{"nth":17,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["Nickname",{"nth":18,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["Amendment",{"nth":19,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["TicketID",{"nth":20,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["Digest",{"nth":21,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["hash",{"nth":257,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"Hash256"}],["index",{"nth":258,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"Hash256"}],["Amount",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["Balance",{"nth":2,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["LimitAmount",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["TakerPays",{"nth":4,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["TakerGets",{"nth":5,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["LowLimit",{"nth":6,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["HighLimit",{"nth":7,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["Fee",{"nth":8,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["SendMax",{"nth":9,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["DeliverMin",{"nth":10,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["MinimumOffer",{"nth":16,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["RippleEscrow",{"nth":17,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["DeliveredAmount",{"nth":18,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Amount"}],["taker_gets_funded",{"nth":258,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"Amount"}],["taker_pays_funded",{"nth":259,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"Amount"}],["PublicKey",{"nth":1,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["MessageKey",{"nth":2,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["SigningPubKey",{"nth":3,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["TxnSignature",{"nth":4,"isVLEncoded":true,"isSerialized":true,"isSigningField":false,"type":"Blob"}],["Generator",{"nth":5,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["Signature",{"nth":6,"isVLEncoded":true,"isSerialized":true,"isSigningField":false,"type":"Blob"}],["Domain",{"nth":7,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["FundCode",{"nth":8,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["RemoveCode",{"nth":9,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["ExpireCode",{"nth":10,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["CreateCode",{"nth":11,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["MemoType",{"nth":12,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["MemoData",{"nth":13,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["MemoFormat",{"nth":14,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["Fulfillment",{"nth":16,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["Condition",{"nth":17,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["MasterSignature",{"nth":18,"isVLEncoded":true,"isSerialized":true,"isSigningField":false,"type":"Blob"}],["UNLModifyValidator",{"nth":19,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["ValidatorToDisable",{"nth":20,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["ValidatorToReEnable",{"nth":20,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Blob"}],["Account",{"nth":1,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["Owner",{"nth":2,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["Destination",{"nth":3,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["Issuer",{"nth":4,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["Authorize",{"nth":5,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["Unauthorize",{"nth":6,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["Target",{"nth":7,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["RegularKey",{"nth":8,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"AccountID"}],["ObjectEndMarker",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["TransactionMetaData",{"nth":2,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["CreatedNode",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["DeletedNode",{"nth":4,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["ModifiedNode",{"nth":5,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["PreviousFields",{"nth":6,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["FinalFields",{"nth":7,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["NewFields",{"nth":8,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["TemplateEntry",{"nth":9,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["Memo",{"nth":10,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["SignerEntry",{"nth":11,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["Signer",{"nth":16,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["Majority",{"nth":18,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["DisabledValidator",{"nth":19,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STObject"}],["ArrayEndMarker",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["Signers",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":false,"type":"STArray"}],["SignerEntries",{"nth":4,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["Template",{"nth":5,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["Necessary",{"nth":6,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["Sufficient",{"nth":7,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["AffectedNodes",{"nth":8,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["Memos",{"nth":9,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["Majorities",{"nth":16,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["DisabledValidators",{"nth":17,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"STArray"}],["CloseResolution",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt8"}],["Method",{"nth":2,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt8"}],["TransactionResult",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt8"}],["TakerPaysCurrency",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash160"}],["TakerPaysIssuer",{"nth":2,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash160"}],["TakerGetsCurrency",{"nth":3,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash160"}],["TakerGetsIssuer",{"nth":4,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash160"}],["Paths",{"nth":1,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"PathSet"}],["Indexes",{"nth":1,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Vector256"}],["Hashes",{"nth":2,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Vector256"}],["Amendments",{"nth":3,"isVLEncoded":true,"isSerialized":true,"isSigningField":true,"type":"Vector256"}],["Transaction",{"nth":1,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"Transaction"}],["LedgerEntry",{"nth":1,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"LedgerEntry"}],["Validation",{"nth":1,"isVLEncoded":false,"isSerialized":false,"isSigningField":false,"type":"Validation"}],["SignerListID",{"nth":38,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["SettleDelay",{"nth":39,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["BeginLedgerSeq",{"nth":40,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt32"}],["Channel",{"nth":22,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["ConsensusHash",{"nth":23,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["CheckID",{"nth":24,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"Hash256"}],["TickSize",{"nth":16,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt8"}],["UNLModifyDisabling",{"nth":17,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt8"}],["DestinationNode",{"nth":9,"isVLEncoded":false,"isSerialized":true,"isSigningField":true,"type":"UInt64"}]],"TRANSACTION_RESULTS":{"telLOCAL_ERROR":-399,"telBAD_DOMAIN":-398,"telBAD_PATH_COUNT":-397,"telBAD_PUBLIC_KEY":-396,"telFAILED_PROCESSING":-395,"telINSUF_FEE_P":-394,"telNO_DST_PARTIAL":-393,"telCAN_NOT_QUEUE":-392,"telCAN_NOT_QUEUE_BALANCE":-391,"telCAN_NOT_QUEUE_BLOCKS":-390,"telCAN_NOT_QUEUE_BLOCKED":-389,"telCAN_NOT_QUEUE_FEE":-388,"telCAN_NOT_QUEUE_FULL":-387,"temMALFORMED":-299,"temBAD_AMOUNT":-298,"temBAD_CURRENCY":-297,"temBAD_EXPIRATION":-296,"temBAD_FEE":-295,"temBAD_ISSUER":-294,"temBAD_LIMIT":-293,"temBAD_OFFER":-292,"temBAD_PATH":-291,"temBAD_PATH_LOOP":-290,"temBAD_REGKEY":-289,"temBAD_SEND_XRP_LIMIT":-288,"temBAD_SEND_XRP_MAX":-287,"temBAD_SEND_XRP_NO_DIRECT":-286,"temBAD_SEND_XRP_PARTIAL":-285,"temBAD_SEND_XRP_PATHS":-284,"temBAD_SEQUENCE":-283,"temBAD_SIGNATURE":-282,"temBAD_SRC_ACCOUNT":-281,"temBAD_TRANSFER_RATE":-280,"temDST_IS_SRC":-279,"temDST_NEEDED":-278,"temINVALID":-277,"temINVALID_FLAG":-276,"temREDUNDANT":-275,"temRIPPLE_EMPTY":-274,"temDISABLED":-273,"temBAD_SIGNER":-272,"temBAD_QUORUM":-271,"temBAD_WEIGHT":-270,"temBAD_TICK_SIZE":-269,"temINVALID_ACCOUNT_ID":-268,"temCANNOT_PREAUTH_SELF":-267,"temUNCERTAIN":-266,"temUNKNOWN":-265,"tefFAILURE":-199,"tefALREADY":-198,"tefBAD_ADD_AUTH":-197,"tefBAD_AUTH":-196,"tefBAD_LEDGER":-195,"tefCREATED":-194,"tefEXCEPTION":-193,"tefINTERNAL":-192,"tefNO_AUTH_REQUIRED":-191,"tefPAST_SEQ":-190,"tefWRONG_PRIOR":-189,"tefMASTER_DISABLED":-188,"tefMAX_LEDGER":-187,"tefBAD_SIGNATURE":-186,"tefBAD_QUORUM":-185,"tefNOT_MULTI_SIGNING":-184,"tefBAD_AUTH_MASTER":-183,"tefINVARIANT_FAILED":-182,"tefTOO_BIG":-181,"terRETRY":-99,"terFUNDS_SPENT":-98,"terINSUF_FEE_B":-97,"terNO_ACCOUNT":-96,"terNO_AUTH":-95,"terNO_LINE":-94,"terOWNERS":-93,"terPRE_SEQ":-92,"terLAST":-91,"terNO_RIPPLE":-90,"terQUEUED":-89,"tesSUCCESS":0,"tecCLAIM":100,"tecPATH_PARTIAL":101,"tecUNFUNDED_ADD":102,"tecUNFUNDED_OFFER":103,"tecUNFUNDED_PAYMENT":104,"tecFAILED_PROCESSING":105,"tecDIR_FULL":121,"tecINSUF_RESERVE_LINE":122,"tecINSUF_RESERVE_OFFER":123,"tecNO_DST":124,"tecNO_DST_INSUF_XRP":125,"tecNO_LINE_INSUF_RESERVE":126,"tecNO_LINE_REDUNDANT":127,"tecPATH_DRY":128,"tecUNFUNDED":129,"tecNO_ALTERNATIVE_KEY":130,"tecNO_REGULAR_KEY":131,"tecOWNERS":132,"tecNO_ISSUER":133,"tecNO_AUTH":134,"tecNO_LINE":135,"tecINSUFF_FEE":136,"tecFROZEN":137,"tecNO_TARGET":138,"tecNO_PERMISSION":139,"tecNO_ENTRY":140,"tecINSUFFICIENT_RESERVE":141,"tecNEED_MASTER_KEY":142,"tecDST_TAG_NEEDED":143,"tecINTERNAL":144,"tecOVERSIZE":145,"tecCRYPTOCONDITION_ERROR":146,"tecINVARIANT_FAILED":147,"tecEXPIRED":148,"tecDUPLICATE":149,"tecKILLED":150,"tecHAS_OBLIGATIONS":151,"tecTOO_SOON":152},"TRANSACTION_TYPES":{"Invalid":-1,"Payment":0,"EscrowCreate":1,"EscrowFinish":2,"AccountSet":3,"EscrowCancel":4,"SetRegularKey":5,"NickNameSet":6,"OfferCreate":7,"OfferCancel":8,"Contract":9,"TicketCreate":10,"TicketCancel":11,"SignerListSet":12,"PaymentChannelCreate":13,"PaymentChannelFund":14,"PaymentChannelClaim":15,"CheckCreate":16,"CheckCash":17,"CheckCancel":18,"DepositPreauth":19,"TrustSet":20,"AccountDelete":21,"EnableAmendment":100,"SetFee":101,"UNLModify":102}}'
          );
        },
        {}
      ],
      "0f0f786f836b5aa515dc3100a1d71ee2": [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("buffer").Buffer;
          var __extends =
            (this && this.__extends) ||
            (function () {
              var _extendStatics = function extendStatics(d, b) {
                _extendStatics =
                  Object.setPrototypeOf ||
                  (_instanceof({ __proto__: [] }, Array) &&
                    function (d, b) {
                      d.__proto__ = b;
                    }) ||
                  function (d, b) {
                    for (var p in b) {
                      if (b.hasOwnProperty(p)) d[p] = b[p];
                    }
                  };
                return _extendStatics(d, b);
              };
              return function (d, b) {
                _extendStatics(d, b);
                function __() {
                  this.constructor = d;
                }
                d.prototype =
                  b === null
                    ? Object.create(b)
                    : ((__.prototype = b.prototype), new __());
              };
            })();
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.Comparable = exports.SerializedType = void 0;
          var binary_serializer_1 = require("../serdes/binary-serializer");
          /**
           * The base class for all binary-codec types
           */ var SerializedType = /** @class */ (function () {
            function SerializedType(bytes) {
              this.bytes = Buffer.alloc(0);
              this.bytes =
                bytes !== null && bytes !== void 0 ? bytes : Buffer.alloc(0);
            }
            SerializedType.fromParser = function (parser, hint) {
              throw new Error("fromParser not implemented");
              return this.fromParser(parser, hint);
            };
            SerializedType.from = function (value) {
              throw new Error("from not implemented");
              return this.from(value);
            };
            /**
             * Write the bytes representation of a SerializedType to a BytesList
             *
             * @param list The BytesList to write SerializedType bytes to
             */ SerializedType.prototype.toBytesSink = function (list) {
              list.put(this.bytes);
            };
            /**
             * Get the hex representation of a SerializedType's bytes
             *
             * @returns hex String of this.bytes
             */ SerializedType.prototype.toHex = function () {
              return this.toBytes().toString("hex").toUpperCase();
            };
            /**
             * Get the bytes representation of a SerializedType
             *
             * @returns A buffer of the bytes
             */ SerializedType.prototype.toBytes = function () {
              if (this.bytes) {
                return this.bytes;
              }
              var bytes = new binary_serializer_1.BytesList();
              this.toBytesSink(bytes);
              return bytes.toBytes();
            };
            /**
             * Return the JSON representation of a SerializedType
             *
             * @returns any type, if not overloaded returns hexString representation of bytes
             */ SerializedType.prototype.toJSON = function () {
              return this.toHex();
            };
            /**
             * @returns hexString representation of this.bytes
             */ SerializedType.prototype.toString = function () {
              return this.toHex();
            };
            return SerializedType;
          })();
          exports.SerializedType = SerializedType;
          /**
           * Base class for SerializedTypes that are comparable
           */ var Comparable = /** @class */ (function (_super) {
            __extends(Comparable, _super);
            function Comparable() {
              return (_super !== null && _super.apply(this, arguments)) || this;
            }
            Comparable.prototype.lt = function (other) {
              return this.compareTo(other) < 0;
            };
            Comparable.prototype.eq = function (other) {
              return this.compareTo(other) === 0;
            };
            Comparable.prototype.gt = function (other) {
              return this.compareTo(other) > 0;
            };
            Comparable.prototype.gte = function (other) {
              return this.compareTo(other) > -1;
            };
            Comparable.prototype.lte = function (other) {
              return this.compareTo(other) < 1;
            };
            /**
             * Overload this method to define how two Comparable SerializedTypes are compared
             *
             * @param other The comparable object to compare this to
             * @returns A number denoting the relationship of this and other
             */ Comparable.prototype.compareTo = function (other) {
              throw new Error(
                "cannot compare " + this.toString() + " and " + other.toString()
              );
            };
            return Comparable;
          })(SerializedType);
          exports.Comparable = Comparable;
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          "../serdes/binary-serializer": "abc1426ad32b9cb626ea24d137d353ef"
        }
      ],
      abc1426ad32b9cb626ea24d137d353ef: [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("buffer").Buffer;
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.BinarySerializer = exports.BytesList = void 0;
          var assert = require("assert");
          /**
           * Bytes list is a collection of buffer objects
           */ var BytesList = /** @class */ (function () {
            function BytesList() {
              this.bytesArray = [];
            }
            /**
             * Get the total number of bytes in the BytesList
             *
             * @return the number of bytes
             */ BytesList.prototype.getLength = function () {
              return Buffer.concat(this.bytesArray).byteLength;
            };
            /**
             * Put bytes in the BytesList
             *
             * @param bytesArg A Buffer
             * @return this BytesList
             */ BytesList.prototype.put = function (bytesArg) {
              var bytes = Buffer.from(bytesArg); // Temporary, to catch instances of Uint8Array being passed in
              this.bytesArray.push(bytes);
              return this;
            };
            /**
             * Write this BytesList to the back of another bytes list
             *
             *  @param list The BytesList to write to
             */ BytesList.prototype.toBytesSink = function (list) {
              list.put(this.toBytes());
            };
            BytesList.prototype.toBytes = function () {
              return Buffer.concat(this.bytesArray);
            };
            BytesList.prototype.toHex = function () {
              return this.toBytes().toString("hex").toUpperCase();
            };
            return BytesList;
          })();
          exports.BytesList = BytesList;
          /**
           * BinarySerializer is used to write fields and values to buffers
           */ var BinarySerializer = /** @class */ (function () {
            function BinarySerializer(sink) {
              this.sink = new BytesList();
              this.sink = sink;
            }
            /**
             * Write a value to this BinarySerializer
             *
             * @param value a SerializedType value
             */ BinarySerializer.prototype.write = function (value) {
              value.toBytesSink(this.sink);
            };
            /**
             * Write bytes to this BinarySerializer
             *
             * @param bytes the bytes to write
             */ BinarySerializer.prototype.put = function (bytes) {
              this.sink.put(bytes);
            };
            /**
             * Write a value of a given type to this BinarySerializer
             *
             * @param type the type to write
             * @param value a value of that type
             */ BinarySerializer.prototype.writeType = function (type, value) {
              this.write(type.from(value));
            };
            /**
             * Write BytesList to this BinarySerializer
             *
             * @param bl BytesList to write to BinarySerializer
             */ BinarySerializer.prototype.writeBytesList = function (bl) {
              bl.toBytesSink(this.sink);
            };
            /**
             * Calculate the header of Variable Length encoded bytes
             *
             * @param length the length of the bytes
             */ BinarySerializer.prototype.encodeVariableLength = function (
              length
            ) {
              var lenBytes = Buffer.alloc(3);
              if (length <= 192) {
                lenBytes[0] = length;
                return lenBytes.slice(0, 1);
              } else if (length <= 12480) {
                length -= 193;
                lenBytes[0] = 193 + (length >>> 8);
                lenBytes[1] = length & 0xff;
                return lenBytes.slice(0, 2);
              } else if (length <= 918744) {
                length -= 12481;
                lenBytes[0] = 241 + (length >>> 16);
                lenBytes[1] = (length >> 8) & 0xff;
                lenBytes[2] = length & 0xff;
                return lenBytes.slice(0, 3);
              }
              throw new Error("Overflow error");
            };
            /**
             * Write field and value to BinarySerializer
             *
             * @param field field to write to BinarySerializer
             * @param value value to write to BinarySerializer
             */ BinarySerializer.prototype.writeFieldAndValue = function (
              field,
              value
            ) {
              var associatedValue = field.associatedType.from(value);
              assert(associatedValue.toBytesSink !== undefined);
              assert(field.name !== undefined);
              this.sink.put(field.header);
              if (field.isVariableLengthEncoded) {
                this.writeLengthEncoded(associatedValue);
              } else {
                associatedValue.toBytesSink(this.sink);
              }
            };
            /**
             * Write a variable length encoded value to the BinarySerializer
             *
             * @param value length encoded value to write to BytesList
             */ BinarySerializer.prototype.writeLengthEncoded = function (value) {
              var bytes = new BytesList();
              value.toBytesSink(bytes);
              this.put(this.encodeVariableLength(bytes.getLength()));
              this.writeBytesList(bytes);
            };
            return BinarySerializer;
          })();
          exports.BinarySerializer = BinarySerializer;
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          assert: "cdcb67ab5f6acbeabe6d878ee73d6e25"
        }
      ],
      "2f5058ac620289ba00afd2d63dec38ff": [
        function (require, module, exports) {
          "use strict";
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.coreTypes = void 0;
          var enums_1 = require("../enums");
          var account_id_1 = require("./account-id");
          var amount_1 = require("./amount");
          var blob_1 = require("./blob");
          var currency_1 = require("./currency");
          var hash_128_1 = require("./hash-128");
          var hash_160_1 = require("./hash-160");
          var hash_256_1 = require("./hash-256");
          var path_set_1 = require("./path-set");
          var st_array_1 = require("./st-array");
          var st_object_1 = require("./st-object");
          var uint_16_1 = require("./uint-16");
          var uint_32_1 = require("./uint-32");
          var uint_64_1 = require("./uint-64");
          var uint_8_1 = require("./uint-8");
          var vector_256_1 = require("./vector-256");
          var coreTypes = {
            AccountID: account_id_1.AccountID,
            Amount: amount_1.Amount,
            Blob: blob_1.Blob,
            Currency: currency_1.Currency,
            Hash128: hash_128_1.Hash128,
            Hash160: hash_160_1.Hash160,
            Hash256: hash_256_1.Hash256,
            PathSet: path_set_1.PathSet,
            STArray: st_array_1.STArray,
            STObject: st_object_1.STObject,
            UInt8: uint_8_1.UInt8,
            UInt16: uint_16_1.UInt16,
            UInt32: uint_32_1.UInt32,
            UInt64: uint_64_1.UInt64,
            Vector256: vector_256_1.Vector256
          };
          exports.coreTypes = coreTypes;
          Object.values(enums_1.Field).forEach(function (field) {
            field.associatedType = coreTypes[field.type.name];
          });
          enums_1.Field["TransactionType"].associatedType =
            enums_1.TransactionType;
          enums_1.Field["TransactionResult"].associatedType =
            enums_1.TransactionResult;
          enums_1.Field["LedgerEntryType"].associatedType =
            enums_1.LedgerEntryType;
        },
        {
          "../enums": "b4c7d31c276a9e273ef13c8edd1ea3c0",
          "./account-id": "eb20d852480fd223e8be71fa0e2c6b42",
          "./amount": "8641feb12d5dad6f3709ef3fc068b428",
          "./blob": "7966fe1b0061af7f75aa26df61df6fe7",
          "./currency": "8027a02b1465ac283be1b684e5f1989b",
          "./hash-128": "e1656935a8c23443a267c1b42a85ecf6",
          "./hash-160": "002b66db5149e202a57ace584b1424aa",
          "./hash-256": "8dba9529a2980e9679fcb11337850744",
          "./path-set": "b9d3700a099312e5265dd9a7f8da6d7b",
          "./st-array": "72364fa2f3c32062ddb9e02d8b450544",
          "./st-object": "448eadfe0b180c0a569a829367a9ee86",
          "./uint-16": "7235c20966e2926308f4c7393154f6d5",
          "./uint-32": "3c53eeba0cbce1f6d03a34e1ea1cd745",
          "./uint-64": "90902fad86c60ac44e4a4d8edccf01e2",
          "./uint-8": "9bf579378d0e5d60f96209520092628b",
          "./vector-256": "391c8b7a002cb7de229534282309addf"
        }
      ],
      eb20d852480fd223e8be71fa0e2c6b42: [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("buffer").Buffer;
          var __extends =
            (this && this.__extends) ||
            (function () {
              var _extendStatics2 = function extendStatics(d, b) {
                _extendStatics2 =
                  Object.setPrototypeOf ||
                  (_instanceof({ __proto__: [] }, Array) &&
                    function (d, b) {
                      d.__proto__ = b;
                    }) ||
                  function (d, b) {
                    for (var p in b) {
                      if (b.hasOwnProperty(p)) d[p] = b[p];
                    }
                  };
                return _extendStatics2(d, b);
              };
              return function (d, b) {
                _extendStatics2(d, b);
                function __() {
                  this.constructor = d;
                }
                d.prototype =
                  b === null
                    ? Object.create(b)
                    : ((__.prototype = b.prototype), new __());
              };
            })();
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.AccountID = void 0;
          var ripple_address_codec_1 = require("ripple-address-codec");
          var hash_160_1 = require("./hash-160");
          var HEX_REGEX = /^[A-F0-9]{40}$/;
          /**
           * Class defining how to encode and decode an AccountID
           */ var AccountID = /** @class */ (function (_super) {
            __extends(AccountID, _super);
            function AccountID(bytes) {
              return (
                _super.call(
                  this,
                  bytes !== null && bytes !== void 0
                    ? bytes
                    : AccountID.defaultAccountID.bytes
                ) || this
              );
            }
            /**
             * Defines how to construct an AccountID
             *
             * @param value either an existing AccountID, a hex-string, or a base58 r-Address
             * @returns an AccountID object
             */ AccountID.from = function (value) {
              if (_instanceof(value, AccountID)) {
                return value;
              }
              if (typeof value === "string") {
                if (value === "") {
                  return new AccountID();
                }
                return HEX_REGEX.test(value)
                  ? new AccountID(Buffer.from(value, "hex"))
                  : this.fromBase58(value);
              }
              throw new Error("Cannot construct AccountID from value given");
            };
            /**
             * Defines how to build an AccountID from a base58 r-Address
             *
             * @param value a base58 r-Address
             * @returns an AccountID object
             */ AccountID.fromBase58 = function (value) {
              return new AccountID(ripple_address_codec_1.decodeAccountID(value));
            };
            /**
             * Overload of toJSON
             *
             * @returns the base58 string for this AccountID
             */ AccountID.prototype.toJSON = function () {
              return this.toBase58();
            };
            /**
             * Defines how to encode AccountID into a base58 address
             *
             * @returns the base58 string defined by this.bytes
             */ AccountID.prototype.toBase58 = function () {
              return ripple_address_codec_1.encodeAccountID(this.bytes);
            };
            AccountID.defaultAccountID = new AccountID(Buffer.alloc(20));
            return AccountID;
          })(hash_160_1.Hash160);
          exports.AccountID = AccountID;
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          "ripple-address-codec": "371ff8c84e04afd24921f37bc92aa65b",
          "./hash-160": "002b66db5149e202a57ace584b1424aa"
        }
      ],
      "371ff8c84e04afd24921f37bc92aa65b": [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("buffer").Buffer;
          Object.defineProperty(exports, "__esModule", { value: true });
          var xrp_codec_1 = require("./xrp-codec");
          exports.codec = xrp_codec_1.codec;
          exports.encodeSeed = xrp_codec_1.encodeSeed;
          exports.decodeSeed = xrp_codec_1.decodeSeed;
          exports.encodeAccountID = xrp_codec_1.encodeAccountID;
          exports.decodeAccountID = xrp_codec_1.decodeAccountID;
          exports.encodeNodePublic = xrp_codec_1.encodeNodePublic;
          exports.decodeNodePublic = xrp_codec_1.decodeNodePublic;
          exports.encodeAccountPublic = xrp_codec_1.encodeAccountPublic;
          exports.decodeAccountPublic = xrp_codec_1.decodeAccountPublic;
          exports.isValidClassicAddress = xrp_codec_1.isValidClassicAddress;
          var assert = require("assert");
          var PREFIX_BYTES = {
            MAIN: Buffer.from([0x05, 0x44]),
            TEST: Buffer.from([0x04, 0x93]) // 4, 147
          };
          function classicAddressToXAddress(classicAddress, tag, test) {
            var accountId = xrp_codec_1.decodeAccountID(classicAddress);
            return encodeXAddress(accountId, tag, test);
          }
          exports.classicAddressToXAddress = classicAddressToXAddress;
          function encodeXAddress(accountId, tag, test) {
            if (accountId.length !== 20) {
              // RIPEMD160 is 160 bits = 20 bytes
              throw new Error("Account ID must be 20 bytes");
            }
            var MAX_32_BIT_UNSIGNED_INT = 4294967295;
            var flag = tag === false ? 0 : tag <= MAX_32_BIT_UNSIGNED_INT ? 1 : 2;
            if (flag === 2) {
              throw new Error("Invalid tag");
            }
            if (tag === false) {
              tag = 0;
            }
            var bytes = Buffer.concat([
              test ? PREFIX_BYTES.TEST : PREFIX_BYTES.MAIN,
              accountId,
              Buffer.from([
                flag,
                tag & 0xff,
                (tag >> 8) & 0xff,
                (tag >> 16) & 0xff,
                (tag >> 24) & 0xff,
                0,
                0,
                0,
                0 // four zero bytes (reserved for 64-bit tags)
              ])
            ]);
            var xAddress = xrp_codec_1.codec.encodeChecked(bytes);
            return xAddress;
          }
          exports.encodeXAddress = encodeXAddress;
          function xAddressToClassicAddress(xAddress) {
            var _decodeXAddress = decodeXAddress(xAddress),
              accountId = _decodeXAddress.accountId,
              tag = _decodeXAddress.tag,
              test = _decodeXAddress.test;
            var classicAddress = xrp_codec_1.encodeAccountID(accountId);
            return { classicAddress: classicAddress, tag: tag, test: test };
          }
          exports.xAddressToClassicAddress = xAddressToClassicAddress;
          function decodeXAddress(xAddress) {
            var decoded = xrp_codec_1.codec.decodeChecked(xAddress);
            var test = isBufferForTestAddress(decoded);
            var accountId = decoded.slice(2, 22);
            var tag = tagFromBuffer(decoded);
            return { accountId: accountId, tag: tag, test: test };
          }
          exports.decodeXAddress = decodeXAddress;
          function isBufferForTestAddress(buf) {
            var decodedPrefix = buf.slice(0, 2);
            if (PREFIX_BYTES.MAIN.equals(decodedPrefix)) {
              return false;
            } else if (PREFIX_BYTES.TEST.equals(decodedPrefix)) {
              return true;
            } else {
              throw new Error("Invalid X-address: bad prefix");
            }
          }
          function tagFromBuffer(buf) {
            var flag = buf[22];
            if (flag >= 2) {
              // No support for 64-bit tags at this time
              throw new Error("Unsupported X-address");
            }
            if (flag === 1) {
              // Little-endian to big-endian
              return (
                buf[23] +
                buf[24] * 0x100 +
                buf[25] * 0x10000 +
                buf[26] * 0x1000000
              );
            }
            assert.strictEqual(flag, 0, "flag must be zero to indicate no tag");
            assert.ok(
              Buffer.from("0000000000000000", "hex").equals(
                buf.slice(23, 23 + 8)
              ),
              "remaining bytes must be zero"
            );
            return false;
          }
          function isValidXAddress(xAddress) {
            try {
              decodeXAddress(xAddress);
            } catch (e) {
              return false;
            }
            return true;
          }
          exports.isValidXAddress = isValidXAddress;
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          "./xrp-codec": "9e043047b239849710f822a0857c909d",
          assert: "cdcb67ab5f6acbeabe6d878ee73d6e25"
        }
      ],
      "9e043047b239849710f822a0857c909d": [
        function (require, module, exports) {
          "use strict";
          /**
           * Codec class
           */ var Buffer = require("buffer").Buffer;
          Object.defineProperty(exports, "__esModule", { value: true });
          var baseCodec = require("base-x");
          var utils_1 = require("./utils");
          var Codec = /*#__PURE__*/ (function () {
            function Codec(options) {
              _classCallCheck2(this, Codec);
              this.sha256 = options.sha256;
              this.alphabet = options.alphabet;
              this.codec = baseCodec(this.alphabet);
              this.base = this.alphabet.length;
            }
            /**
             * Encoder.
             *
             * @param bytes Buffer of data to encode.
             * @param opts Options object including the version bytes and the expected length of the data to encode.
             */ _createClass2(Codec, [
              {
                key: "encode",
                value: function encode(bytes, opts) {
                  var versions = opts.versions;
                  return this.encodeVersioned(
                    bytes,
                    versions,
                    opts.expectedLength
                  );
                }
              },
              {
                key: "encodeVersioned",
                value: function encodeVersioned(bytes, versions, expectedLength) {
                  if (expectedLength && bytes.length !== expectedLength) {
                    throw new Error(
                      "unexpected_payload_length: bytes.length does not match expectedLength." +
                        " Ensure that the bytes are a Buffer."
                    );
                  }
                  return this.encodeChecked(
                    Buffer.from(utils_1.concatArgs(versions, bytes))
                  );
                }
              },
              {
                key: "encodeChecked",
                value: function encodeChecked(buffer) {
                  var check = this.sha256(this.sha256(buffer)).slice(0, 4);
                  return this.encodeRaw(
                    Buffer.from(utils_1.concatArgs(buffer, check))
                  );
                }
              },
              {
                key: "encodeRaw",
                value: function encodeRaw(bytes) {
                  return this.codec.encode(bytes);
                }
                /**
                 * Decoder.
                 *
                 * @param base58string Base58Check-encoded string to decode.
                 * @param opts Options object including the version byte(s) and the expected length of the data after decoding.
                 */
              },
              {
                key: "decode",
                value: function decode(base58string, opts) {
                  var versions = opts.versions;
                  var types = opts.versionTypes;
                  var withoutSum = this.decodeChecked(base58string);
                  if (versions.length > 1 && !opts.expectedLength) {
                    throw new Error(
                      "expectedLength is required because there are >= 2 possible versions"
                    );
                  }
                  var versionLengthGuess =
                    typeof versions[0] === "number" ? 1 : versions[0].length;
                  var payloadLength =
                    opts.expectedLength || withoutSum.length - versionLengthGuess;
                  var versionBytes = withoutSum.slice(0, -payloadLength);
                  var payload = withoutSum.slice(-payloadLength);
                  for (var i = 0; i < versions.length; i++) {
                    var version = Array.isArray(versions[i])
                      ? versions[i]
                      : [versions[i]];
                    if (utils_1.seqEqual(versionBytes, version)) {
                      return {
                        version: version,
                        bytes: payload,
                        type: types ? types[i] : null
                      };
                    }
                  }
                  throw new Error(
                    "version_invalid: version bytes do not match any of the provided version(s)"
                  );
                }
              },
              {
                key: "decodeChecked",
                value: function decodeChecked(base58string) {
                  var buffer = this.decodeRaw(base58string);
                  if (buffer.length < 5) {
                    throw new Error(
                      "invalid_input_size: decoded data must have length >= 5"
                    );
                  }
                  if (!this.verifyCheckSum(buffer)) {
                    throw new Error("checksum_invalid");
                  }
                  return buffer.slice(0, -4);
                }
              },
              {
                key: "decodeRaw",
                value: function decodeRaw(base58string) {
                  return this.codec.decode(base58string);
                }
              },
              {
                key: "verifyCheckSum",
                value: function verifyCheckSum(bytes) {
                  var computed = this.sha256(
                    this.sha256(bytes.slice(0, -4))
                  ).slice(0, 4);
                  var checksum = bytes.slice(-4);
                  return utils_1.seqEqual(computed, checksum);
                }
              }
            ]);
            return Codec;
          })();
          /**
           * XRP codec
           */ // Pure JavaScript hash functions in the browser, native hash functions in Node.js
          var createHash = require("create-hash"); // base58 encodings: https://xrpl.org/base58-encodings.html
          var ACCOUNT_ID = 0; // Account address (20 bytes)
          var ACCOUNT_PUBLIC_KEY = 0x23; // Account public key (33 bytes)
          var FAMILY_SEED = 0x21; // 33; Seed value (for secret keys) (16 bytes)
          var NODE_PUBLIC = 0x1c; // 28; Validation public key (33 bytes)
          var ED25519_SEED = [0x01, 0xe1, 0x4b]; // [1, 225, 75]
          var codecOptions = {
            sha256: function sha256(bytes) {
              return createHash("sha256").update(Buffer.from(bytes)).digest();
            },
            alphabet: "rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz"
          };
          var codecWithXrpAlphabet = new Codec(codecOptions);
          exports.codec = codecWithXrpAlphabet; // entropy is a Buffer of size 16
          // type is 'ed25519' or 'secp256k1'
          function encodeSeed(entropy, type) {
            if (entropy.length !== 16) {
              throw new Error("entropy must have length 16");
            }
            var opts = {
              expectedLength: 16, // for secp256k1, use `FAMILY_SEED`
              versions: type === "ed25519" ? ED25519_SEED : [FAMILY_SEED]
            }; // prefixes entropy with version bytes
            return codecWithXrpAlphabet.encode(entropy, opts);
          }
          exports.encodeSeed = encodeSeed;
          function decodeSeed(seed) {
            var opts =
              arguments.length > 1 && arguments[1] !== undefined
                ? arguments[1]
                : {
                    versionTypes: ["ed25519", "secp256k1"],
                    versions: [ED25519_SEED, FAMILY_SEED],
                    expectedLength: 16
                  };
            return codecWithXrpAlphabet.decode(seed, opts);
          }
          exports.decodeSeed = decodeSeed;
          function encodeAccountID(bytes) {
            var opts = { versions: [ACCOUNT_ID], expectedLength: 20 };
            return codecWithXrpAlphabet.encode(bytes, opts);
          }
          exports.encodeAccountID = encodeAccountID;
          exports.encodeAddress = encodeAccountID;
          function decodeAccountID(accountId) {
            var opts = { versions: [ACCOUNT_ID], expectedLength: 20 };
            return codecWithXrpAlphabet.decode(accountId, opts).bytes;
          }
          exports.decodeAccountID = decodeAccountID;
          exports.decodeAddress = decodeAccountID;
          function decodeNodePublic(base58string) {
            var opts = { versions: [NODE_PUBLIC], expectedLength: 33 };
            return codecWithXrpAlphabet.decode(base58string, opts).bytes;
          }
          exports.decodeNodePublic = decodeNodePublic;
          function encodeNodePublic(bytes) {
            var opts = { versions: [NODE_PUBLIC], expectedLength: 33 };
            return codecWithXrpAlphabet.encode(bytes, opts);
          }
          exports.encodeNodePublic = encodeNodePublic;
          function encodeAccountPublic(bytes) {
            var opts = { versions: [ACCOUNT_PUBLIC_KEY], expectedLength: 33 };
            return codecWithXrpAlphabet.encode(bytes, opts);
          }
          exports.encodeAccountPublic = encodeAccountPublic;
          function decodeAccountPublic(base58string) {
            var opts = { versions: [ACCOUNT_PUBLIC_KEY], expectedLength: 33 };
            return codecWithXrpAlphabet.decode(base58string, opts).bytes;
          }
          exports.decodeAccountPublic = decodeAccountPublic;
          function isValidClassicAddress(address) {
            try {
              decodeAccountID(address);
            } catch (e) {
              return false;
            }
            return true;
          }
          exports.isValidClassicAddress = isValidClassicAddress;
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          "base-x": "771e313687afd3f5f73a543cdb028df2",
          "./utils": "ad61b9b7782b828b8e2f0cd822192e22",
          "create-hash": "b705fb93268134befc4305132ca33648"
        }
      ],
      "771e313687afd3f5f73a543cdb028df2": [
        function (require, module, exports) {
          "use strict"; // base-x encoding / decoding
          // Copyright (c) 2018 base-x contributors
          // Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
          // Distributed under the MIT software license, see the accompanying
          // file LICENSE or http://www.opensource.org/licenses/mit-license.php.
          // @ts-ignore
          var _Buffer = require("safe-buffer").Buffer;
          function base(ALPHABET) {
            if (ALPHABET.length >= 255) {
              throw new TypeError("Alphabet too long");
            }
            var BASE_MAP = new Uint8Array(256);
            BASE_MAP.fill(255);
            for (var i = 0; i < ALPHABET.length; i++) {
              var x = ALPHABET.charAt(i);
              var xc = x.charCodeAt(0);
              if (BASE_MAP[xc] !== 255) {
                throw new TypeError(x + " is ambiguous");
              }
              BASE_MAP[xc] = i;
            }
            var BASE = ALPHABET.length;
            var LEADER = ALPHABET.charAt(0);
            var FACTOR = Math.log(BASE) / Math.log(256); // log(BASE) / log(256), rounded up
            var iFACTOR = Math.log(256) / Math.log(BASE); // log(256) / log(BASE), rounded up
            function encode(source) {
              if (!_Buffer.isBuffer(source)) {
                throw new TypeError("Expected Buffer");
              }
              if (source.length === 0) {
                return "";
              } // Skip & count leading zeroes.
              var zeroes = 0;
              var length = 0;
              var pbegin = 0;
              var pend = source.length;
              while (pbegin !== pend && source[pbegin] === 0) {
                pbegin++;
                zeroes++;
              } // Allocate enough space in big-endian base58 representation.
              var size = ((pend - pbegin) * iFACTOR + 1) >>> 0;
              var b58 = new Uint8Array(size); // Process the bytes.
              while (pbegin !== pend) {
                var carry = source[pbegin]; // Apply "b58 = b58 * 256 + ch".
                var i = 0;
                for (
                  var it1 = size - 1;
                  (carry !== 0 || i < length) && it1 !== -1;
                  it1--, i++
                ) {
                  carry += (256 * b58[it1]) >>> 0;
                  b58[it1] = carry % BASE >>> 0;
                  carry = (carry / BASE) >>> 0;
                }
                if (carry !== 0) {
                  throw new Error("Non-zero carry");
                }
                length = i;
                pbegin++;
              } // Skip leading zeroes in base58 result.
              var it2 = size - length;
              while (it2 !== size && b58[it2] === 0) {
                it2++;
              } // Translate the result into a string.
              var str = LEADER.repeat(zeroes);
              for (; it2 < size; ++it2) {
                str += ALPHABET.charAt(b58[it2]);
              }
              return str;
            }
            function decodeUnsafe(source) {
              if (typeof source !== "string") {
                throw new TypeError("Expected String");
              }
              if (source.length === 0) {
                return _Buffer.alloc(0);
              }
              var psz = 0; // Skip leading spaces.
              if (source[psz] === " ") {
                return;
              } // Skip and count leading '1's.
              var zeroes = 0;
              var length = 0;
              while (source[psz] === LEADER) {
                zeroes++;
                psz++;
              } // Allocate enough space in big-endian base256 representation.
              var size = ((source.length - psz) * FACTOR + 1) >>> 0; // log(58) / log(256), rounded up.
              var b256 = new Uint8Array(size); // Process the characters.
              while (source[psz]) {
                // Decode character
                var carry = BASE_MAP[source.charCodeAt(psz)]; // Invalid character
                if (carry === 255) {
                  return;
                }
                var i = 0;
                for (
                  var it3 = size - 1;
                  (carry !== 0 || i < length) && it3 !== -1;
                  it3--, i++
                ) {
                  carry += (BASE * b256[it3]) >>> 0;
                  b256[it3] = carry % 256 >>> 0;
                  carry = (carry / 256) >>> 0;
                }
                if (carry !== 0) {
                  throw new Error("Non-zero carry");
                }
                length = i;
                psz++;
              } // Skip trailing spaces.
              if (source[psz] === " ") {
                return;
              } // Skip leading zeroes in b256.
              var it4 = size - length;
              while (it4 !== size && b256[it4] === 0) {
                it4++;
              }
              var vch = _Buffer.allocUnsafe(zeroes + (size - it4));
              vch.fill(0x00, 0, zeroes);
              var j = zeroes;
              while (it4 !== size) {
                vch[j++] = b256[it4++];
              }
              return vch;
            }
            function decode(string) {
              var buffer = decodeUnsafe(string);
              if (buffer) {
                return buffer;
              }
              throw new Error("Non-base" + BASE + " character");
            }
            return { encode: encode, decodeUnsafe: decodeUnsafe, decode: decode };
          }
          module.exports = base;
        },
        { "safe-buffer": "4e0959a531d73b3690537fbc38856961" }
      ],
      "4e0959a531d73b3690537fbc38856961": [
        function (require, module, exports) {
          /*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ var buffer = require("buffer");
          var Buffer = buffer.Buffer; // alternative to using Object.keys for old browsers
          function copyProps(src, dst) {
            for (var key in src) {
              dst[key] = src[key];
            }
          }
          if (
            Buffer.from &&
            Buffer.alloc &&
            Buffer.allocUnsafe &&
            Buffer.allocUnsafeSlow
          ) {
            module.exports = buffer;
          } else {
            // Copy properties from require('buffer')
            copyProps(buffer, exports);
            exports.Buffer = SafeBuffer;
          }
          function SafeBuffer(arg, encodingOrOffset, length) {
            return Buffer(arg, encodingOrOffset, length);
          }
          SafeBuffer.prototype = Object.create(Buffer.prototype); // Copy static methods from Buffer
          copyProps(Buffer, SafeBuffer);
          SafeBuffer.from = function (arg, encodingOrOffset, length) {
            if (typeof arg === "number") {
              throw new TypeError("Argument must not be a number");
            }
            return Buffer(arg, encodingOrOffset, length);
          };
          SafeBuffer.alloc = function (size, fill, encoding) {
            if (typeof size !== "number") {
              throw new TypeError("Argument must be a number");
            }
            var buf = Buffer(size);
            if (fill !== undefined) {
              if (typeof encoding === "string") {
                buf.fill(fill, encoding);
              } else {
                buf.fill(fill);
              }
            } else {
              buf.fill(0);
            }
            return buf;
          };
          SafeBuffer.allocUnsafe = function (size) {
            if (typeof size !== "number") {
              throw new TypeError("Argument must be a number");
            }
            return Buffer(size);
          };
          SafeBuffer.allocUnsafeSlow = function (size) {
            if (typeof size !== "number") {
              throw new TypeError("Argument must be a number");
            }
            return buffer.SlowBuffer(size);
          };
        },
        { buffer: "1948b2a05a083f82087512f711e79e4d" }
      ],
      ad61b9b7782b828b8e2f0cd822192e22: [
        function (require, module, exports) {
          "use strict";
          Object.defineProperty(exports, "__esModule", { value: true });
          /**
           * Check whether two sequences (e.g. arrays of numbers) are equal.
           *
           * @param arr1 One of the arrays to compare.
           * @param arr2 The other array to compare.
           */ function seqEqual(arr1, arr2) {
            if (arr1.length !== arr2.length) {
              return false;
            }
            for (var i = 0; i < arr1.length; i++) {
              if (arr1[i] !== arr2[i]) {
                return false;
              }
            }
            return true;
          }
          exports.seqEqual = seqEqual;
          /**
           * Check whether a value is a sequence (e.g. array of numbers).
           *
           * @param val The value to check.
           */ function isSequence(val) {
            return val.length !== undefined;
          }
          /**
           * Concatenate all `arguments` into a single array. Each argument can be either
           * a single element or a sequence, which has a `length` property and supports
           * element retrieval via sequence[ix].
           *
           * > concatArgs(1, [2, 3], Buffer.from([4,5]), new Uint8Array([6, 7]));
           *  [1,2,3,4,5,6,7]
           *
           * @returns {number[]} Array of concatenated arguments
           */ function concatArgs() {
            var ret = [];
            for (
              var _len7 = arguments.length, args = new Array(_len7), _key7 = 0;
              _key7 < _len7;
              _key7++
            ) {
              args[_key7] = arguments[_key7];
            }
            args.forEach(function (arg) {
              if (isSequence(arg)) {
                for (var j = 0; j < arg.length; j++) {
                  ret.push(arg[j]);
                }
              } else {
                ret.push(arg);
              }
            });
            return ret;
          }
          exports.concatArgs = concatArgs;
        },
        {}
      ],
      b705fb93268134befc4305132ca33648: [
        function (require, module, exports) {
          "use strict";
          var inherits = require("inherits");
          var MD5 = require("md5.js");
          var RIPEMD160 = require("ripemd160");
          var sha = require("sha.js");
          var Base = require("cipher-base");
          function Hash(hash) {
            Base.call(this, "digest");
            this._hash = hash;
          }
          inherits(Hash, Base);
          Hash.prototype._update = function (data) {
            this._hash.update(data);
          };
          Hash.prototype._final = function () {
            return this._hash.digest();
          };
          module.exports = function createHash(alg) {
            alg = alg.toLowerCase();
            if (alg === "md5") return new MD5();
            if (alg === "rmd160" || alg === "ripemd160") return new RIPEMD160();
            return new Hash(sha(alg));
          };
        },
        {
          inherits: "cd61047e9289e4b62768390878fc0b01",
          "md5.js": "a83917f661caba048749497722794bde",
          ripemd160: "f1c87c91800247cc2998c4c840dee6a0",
          "sha.js": "e45004c4900ed3f294bee27791c95d0e",
          "cipher-base": "20b612331822224e6d245498f492db41"
        }
      ],
      cd61047e9289e4b62768390878fc0b01: [
        function (require, module, exports) {
          if (typeof Object.create === "function") {
            // implementation from standard node.js 'util' module
            module.exports = function inherits(ctor, superCtor) {
              if (superCtor) {
                ctor.super_ = superCtor;
                ctor.prototype = Object.create(superCtor.prototype, {
                  constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                  }
                });
              }
            };
          } else {
            // old school shim for old browsers
            module.exports = function inherits(ctor, superCtor) {
              if (superCtor) {
                ctor.super_ = superCtor;
                var TempCtor = function TempCtor() {};
                TempCtor.prototype = superCtor.prototype;
                ctor.prototype = new TempCtor();
                ctor.prototype.constructor = ctor;
              }
            };
          }
        },
        {}
      ],
      a83917f661caba048749497722794bde: [
        function (require, module, exports) {
          "use strict";
          var inherits = require("inherits");
          var HashBase = require("hash-base");
          var Buffer = require("safe-buffer").Buffer;
          var ARRAY16 = new Array(16);
          function MD5() {
            HashBase.call(this, 64); // state
            this._a = 0x67452301;
            this._b = 0xefcdab89;
            this._c = 0x98badcfe;
            this._d = 0x10325476;
          }
          inherits(MD5, HashBase);
          MD5.prototype._update = function () {
            var M = ARRAY16;
            for (var i = 0; i < 16; ++i) {
              M[i] = this._block.readInt32LE(i * 4);
            }
            var a = this._a;
            var b = this._b;
            var c = this._c;
            var d = this._d;
            a = fnF(a, b, c, d, M[0], 0xd76aa478, 7);
            d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
            c = fnF(c, d, a, b, M[2], 0x242070db, 17);
            b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
            a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
            d = fnF(d, a, b, c, M[5], 0x4787c62a, 12);
            c = fnF(c, d, a, b, M[6], 0xa8304613, 17);
            b = fnF(b, c, d, a, M[7], 0xfd469501, 22);
            a = fnF(a, b, c, d, M[8], 0x698098d8, 7);
            d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
            c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
            b = fnF(b, c, d, a, M[11], 0x895cd7be, 22);
            a = fnF(a, b, c, d, M[12], 0x6b901122, 7);
            d = fnF(d, a, b, c, M[13], 0xfd987193, 12);
            c = fnF(c, d, a, b, M[14], 0xa679438e, 17);
            b = fnF(b, c, d, a, M[15], 0x49b40821, 22);
            a = fnG(a, b, c, d, M[1], 0xf61e2562, 5);
            d = fnG(d, a, b, c, M[6], 0xc040b340, 9);
            c = fnG(c, d, a, b, M[11], 0x265e5a51, 14);
            b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
            a = fnG(a, b, c, d, M[5], 0xd62f105d, 5);
            d = fnG(d, a, b, c, M[10], 0x02441453, 9);
            c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
            b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
            a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
            d = fnG(d, a, b, c, M[14], 0xc33707d6, 9);
            c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
            b = fnG(b, c, d, a, M[8], 0x455a14ed, 20);
            a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
            d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
            c = fnG(c, d, a, b, M[7], 0x676f02d9, 14);
            b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
            a = fnH(a, b, c, d, M[5], 0xfffa3942, 4);
            d = fnH(d, a, b, c, M[8], 0x8771f681, 11);
            c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
            b = fnH(b, c, d, a, M[14], 0xfde5380c, 23);
            a = fnH(a, b, c, d, M[1], 0xa4beea44, 4);
            d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
            c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
            b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
            a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
            d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
            c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
            b = fnH(b, c, d, a, M[6], 0x04881d05, 23);
            a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
            d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
            c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
            b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
            a = fnI(a, b, c, d, M[0], 0xf4292244, 6);
            d = fnI(d, a, b, c, M[7], 0x432aff97, 10);
            c = fnI(c, d, a, b, M[14], 0xab9423a7, 15);
            b = fnI(b, c, d, a, M[5], 0xfc93a039, 21);
            a = fnI(a, b, c, d, M[12], 0x655b59c3, 6);
            d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
            c = fnI(c, d, a, b, M[10], 0xffeff47d, 15);
            b = fnI(b, c, d, a, M[1], 0x85845dd1, 21);
            a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
            d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
            c = fnI(c, d, a, b, M[6], 0xa3014314, 15);
            b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
            a = fnI(a, b, c, d, M[4], 0xf7537e82, 6);
            d = fnI(d, a, b, c, M[11], 0xbd3af235, 10);
            c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
            b = fnI(b, c, d, a, M[9], 0xeb86d391, 21);
            this._a = (this._a + a) | 0;
            this._b = (this._b + b) | 0;
            this._c = (this._c + c) | 0;
            this._d = (this._d + d) | 0;
          };
          MD5.prototype._digest = function () {
            // create padding and handle blocks
            this._block[this._blockOffset++] = 0x80;
            if (this._blockOffset > 56) {
              this._block.fill(0, this._blockOffset, 64);
              this._update();
              this._blockOffset = 0;
            }
            this._block.fill(0, this._blockOffset, 56);
            this._block.writeUInt32LE(this._length[0], 56);
            this._block.writeUInt32LE(this._length[1], 60);
            this._update(); // produce result
            var buffer = Buffer.allocUnsafe(16);
            buffer.writeInt32LE(this._a, 0);
            buffer.writeInt32LE(this._b, 4);
            buffer.writeInt32LE(this._c, 8);
            buffer.writeInt32LE(this._d, 12);
            return buffer;
          };
          function rotl(x, n) {
            return (x << n) | (x >>> (32 - n));
          }
          function fnF(a, b, c, d, m, k, s) {
            return (rotl((a + ((b & c) | (~b & d)) + m + k) | 0, s) + b) | 0;
          }
          function fnG(a, b, c, d, m, k, s) {
            return (rotl((a + ((b & d) | (c & ~d)) + m + k) | 0, s) + b) | 0;
          }
          function fnH(a, b, c, d, m, k, s) {
            return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0;
          }
          function fnI(a, b, c, d, m, k, s) {
            return (rotl((a + (c ^ (b | ~d)) + m + k) | 0, s) + b) | 0;
          }
          module.exports = MD5;
        },
        {
          inherits: "cd61047e9289e4b62768390878fc0b01",
          "hash-base": "1ae08a57c8842df4a4747e45ec9b850c",
          "safe-buffer": "4e0959a531d73b3690537fbc38856961"
        }
      ],
      "1ae08a57c8842df4a4747e45ec9b850c": [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("safe-buffer").Buffer;
          var Transform = require("readable-stream").Transform;
          var inherits = require("inherits");
          function throwIfNotStringOrBuffer(val, prefix) {
            if (!Buffer.isBuffer(val) && typeof val !== "string") {
              throw new TypeError(prefix + " must be a string or a buffer");
            }
          }
          function HashBase(blockSize) {
            Transform.call(this);
            this._block = Buffer.allocUnsafe(blockSize);
            this._blockSize = blockSize;
            this._blockOffset = 0;
            this._length = [0, 0, 0, 0];
            this._finalized = false;
          }
          inherits(HashBase, Transform);
          HashBase.prototype._transform = function (chunk, encoding, callback) {
            var error = null;
            try {
              this.update(chunk, encoding);
            } catch (err) {
              error = err;
            }
            callback(error);
          };
          HashBase.prototype._flush = function (callback) {
            var error = null;
            try {
              this.push(this.digest());
            } catch (err) {
              error = err;
            }
            callback(error);
          };
          HashBase.prototype.update = function (data, encoding) {
            throwIfNotStringOrBuffer(data, "Data");
            if (this._finalized) throw new Error("Digest already called");
            if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding); // consume data
            var block = this._block;
            var offset = 0;
            while (this._blockOffset + data.length - offset >= this._blockSize) {
              for (var i = this._blockOffset; i < this._blockSize; ) {
                block[i++] = data[offset++];
              }
              this._update();
              this._blockOffset = 0;
            }
            while (offset < data.length) {
              block[this._blockOffset++] = data[offset++];
            } // update length
            for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
              this._length[j] += carry;
              carry = (this._length[j] / 0x0100000000) | 0;
              if (carry > 0) this._length[j] -= 0x0100000000 * carry;
            }
            return this;
          };
          HashBase.prototype._update = function () {
            throw new Error("_update is not implemented");
          };
          HashBase.prototype.digest = function (encoding) {
            if (this._finalized) throw new Error("Digest already called");
            this._finalized = true;
            var digest = this._digest();
            if (encoding !== undefined) digest = digest.toString(encoding); // reset state
            this._block.fill(0);
            this._blockOffset = 0;
            for (var i = 0; i < 4; ++i) {
              this._length[i] = 0;
            }
            return digest;
          };
          HashBase.prototype._digest = function () {
            throw new Error("_digest is not implemented");
          };
          module.exports = HashBase;
        },
        {
          "safe-buffer": "4e0959a531d73b3690537fbc38856961",
          "readable-stream": "d5ff815fc3d1cfe117e1b6f54f63c118",
          inherits: "cd61047e9289e4b62768390878fc0b01"
        }
      ],
      d5ff815fc3d1cfe117e1b6f54f63c118: [
        function (require, module, exports) {
          exports = module.exports = require("./lib/_stream_readable.js");
          exports.Stream = exports;
          exports.Readable = exports;
          exports.Writable = require("./lib/_stream_writable.js");
          exports.Duplex = require("./lib/_stream_duplex.js");
          exports.Transform = require("./lib/_stream_transform.js");
          exports.PassThrough = require("./lib/_stream_passthrough.js");
          exports.finished = require("./lib/internal/streams/end-of-stream.js");
          exports.pipeline = require("./lib/internal/streams/pipeline.js");
        },
        {
          "./lib/_stream_readable.js": "c37d344d12758e7cd78c45f7416b586b",
          "./lib/_stream_writable.js": "855d7632df7e6abfe3f768de89c31cba",
          "./lib/_stream_duplex.js": "697a6b37b3553e220776ac06dc162ff3",
          "./lib/_stream_transform.js": "5a00bf4d8e0f1eb85f9f8b889e5f633c",
          "./lib/_stream_passthrough.js": "bedf5ddeb978a21f9b2504317671d350",
          "./lib/internal/streams/end-of-stream.js":
            "9cf0302cde5d6261ef306b6ba09b954d",
          "./lib/internal/streams/pipeline.js": "f51ae73eb0cd3a21f6784b33d7675413"
        }
      ],
      c37d344d12758e7cd78c45f7416b586b: [
        function (require, module, exports) {
          // Copyright Joyent, Inc. and other Node contributors.
          //
          // Permission is hereby granted, free of charge, to any person obtaining a
          // copy of this software and associated documentation files (the
          // "Software"), to deal in the Software without restriction, including
          // without limitation the rights to use, copy, modify, merge, publish,
          // distribute, sublicense, and/or sell copies of the Software, and to permit
          // persons to whom the Software is furnished to do so, subject to the
          // following conditions:
          //
          // The above copyright notice and this permission notice shall be included
          // in all copies or substantial portions of the Software.
          //
          // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
          // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
          // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
          // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
          // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
          // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
          // USE OR OTHER DEALINGS IN THE SOFTWARE.
          "use strict";
          var global = arguments[3];
          var process = require("process");
          module.exports = Readable;
          /*<replacement>*/ var Duplex;
          /*</replacement>*/ Readable.ReadableState = ReadableState;
          /*<replacement>*/ var EE = require("events").EventEmitter;
          var EElistenerCount = function EElistenerCount(emitter, type) {
            return emitter.listeners(type).length;
          };
          /*</replacement>*/ /*<replacement>*/ var Stream = require("./internal/streams/stream");
          /*</replacement>*/ var Buffer = require("buffer").Buffer;
          var OurUint8Array = global.Uint8Array || function () {};
          function _uint8ArrayToBuffer(chunk) {
            return Buffer.from(chunk);
          }
          function _isUint8Array(obj) {
            return Buffer.isBuffer(obj) || _instanceof(obj, OurUint8Array);
          }
          /*<replacement>*/ var debugUtil = require("util");
          var debug;
          if (debugUtil && debugUtil.debuglog) {
            debug = debugUtil.debuglog("stream");
          } else {
            debug = function debug() {};
          }
          /*</replacement>*/ var BufferList = require("./internal/streams/buffer_list");
          var destroyImpl = require("./internal/streams/destroy");
          var _require = require("./internal/streams/state"),
            getHighWaterMark = _require.getHighWaterMark;
          var _require$codes = require("../errors").codes,
            ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
            ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
            ERR_METHOD_NOT_IMPLEMENTED =
              _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
            ERR_STREAM_UNSHIFT_AFTER_END_EVENT =
              _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT; // Lazy loaded to improve the startup performance.
          var StringDecoder;
          var createReadableStreamAsyncIterator;
          var from;
          require("inherits")(Readable, Stream);
          var errorOrDestroy = destroyImpl.errorOrDestroy;
          var kProxyEvents = ["error", "close", "destroy", "pause", "resume"];
          function prependListener(emitter, event, fn) {
            // Sadly this is not cacheable as some libraries bundle their own
            // event emitter implementation with them.
            if (typeof emitter.prependListener === "function")
              return emitter.prependListener(event, fn); // This is a hack to make sure that our error handler is attached before any
            // userland ones.  NEVER DO THIS. This is here only because this code needs
            // to continue to work with older versions of Node.js that do not include
            // the prependListener() method. The goal is to eventually remove this hack.
            if (!emitter._events || !emitter._events[event])
              emitter.on(event, fn);
            else if (Array.isArray(emitter._events[event]))
              emitter._events[event].unshift(fn);
            else emitter._events[event] = [fn, emitter._events[event]];
          }
          function ReadableState(options, stream, isDuplex) {
            Duplex = Duplex || require("./_stream_duplex");
            options = options || {}; // Duplex streams are both readable and writable, but share
            // the same options object.
            // However, some cases require setting options to different
            // values for the readable and the writable sides of the duplex stream.
            // These options can be provided separately as readableXXX and writableXXX.
            if (typeof isDuplex !== "boolean")
              isDuplex = _instanceof(stream, Duplex); // object stream flag. Used to make read(n) ignore n and to
            // make all the buffer merging and length checks go away
            this.objectMode = !!options.objectMode;
            if (isDuplex)
              this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
            // Note: 0 is a valid value, means "don't call _read preemptively ever"
            this.highWaterMark = getHighWaterMark(
              this,
              options,
              "readableHighWaterMark",
              isDuplex
            ); // A linked list is used to store data chunks instead of an array because the
            // linked list can remove elements from the beginning faster than
            // array.shift()
            this.buffer = new BufferList();
            this.length = 0;
            this.pipes = null;
            this.pipesCount = 0;
            this.flowing = null;
            this.ended = false;
            this.endEmitted = false;
            this.reading = false; // a flag to be able to tell if the event 'readable'/'data' is emitted
            // immediately, or on a later tick.  We set this to true at first, because
            // any actions that shouldn't happen until "later" should generally also
            // not happen before the first read call.
            this.sync = true; // whenever we return null, then we set a flag to say
            // that we're awaiting a 'readable' event emission.
            this.needReadable = false;
            this.emittedReadable = false;
            this.readableListening = false;
            this.resumeScheduled = false;
            this.paused = true; // Should close be emitted on destroy. Defaults to true.
            this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'end' (and potentially 'finish')
            this.autoDestroy = !!options.autoDestroy; // has it been destroyed
            this.destroyed = false; // Crypto is kind of old and crusty.  Historically, its default string
            // encoding is 'binary' so we have to make this configurable.
            // Everything else in the universe uses 'utf8', though.
            this.defaultEncoding = options.defaultEncoding || "utf8"; // the number of writers that are awaiting a drain event in .pipe()s
            this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled
            this.readingMore = false;
            this.decoder = null;
            this.encoding = null;
            if (options.encoding) {
              if (!StringDecoder)
                StringDecoder = require("string_decoder/").StringDecoder;
              this.decoder = new StringDecoder(options.encoding);
              this.encoding = options.encoding;
            }
          }
          function Readable(options) {
            Duplex = Duplex || require("./_stream_duplex");
            if (!_instanceof(this, Readable)) return new Readable(options); // Checking for a Stream.Duplex instance is faster here instead of inside
            // the ReadableState constructor, at least with V8 6.5
            var isDuplex = _instanceof(this, Duplex);
            this._readableState = new ReadableState(options, this, isDuplex); // legacy
            this.readable = true;
            if (options) {
              if (typeof options.read === "function") this._read = options.read;
              if (typeof options.destroy === "function")
                this._destroy = options.destroy;
            }
            Stream.call(this);
          }
          Object.defineProperty(Readable.prototype, "destroyed", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              if (this._readableState === undefined) {
                return false;
              }
              return this._readableState.destroyed;
            },
            set: function set(value) {
              // we ignore the value if the stream
              // has not been initialized yet
              if (!this._readableState) {
                return;
              } // backward compatibility, the user is explicitly
              // managing destroyed
              this._readableState.destroyed = value;
            }
          });
          Readable.prototype.destroy = destroyImpl.destroy;
          Readable.prototype._undestroy = destroyImpl.undestroy;
          Readable.prototype._destroy = function (err, cb) {
            cb(err);
          }; // Manually shove something into the read() buffer.
          // This returns true if the highWaterMark has not been hit yet,
          // similar to how Writable.write() returns true if you should
          // write() some more.
          Readable.prototype.push = function (chunk, encoding) {
            var state = this._readableState;
            var skipChunkCheck;
            if (!state.objectMode) {
              if (typeof chunk === "string") {
                encoding = encoding || state.defaultEncoding;
                if (encoding !== state.encoding) {
                  chunk = Buffer.from(chunk, encoding);
                  encoding = "";
                }
                skipChunkCheck = true;
              }
            } else {
              skipChunkCheck = true;
            }
            return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
          }; // Unshift should *always* be something directly out of read()
          Readable.prototype.unshift = function (chunk) {
            return readableAddChunk(this, chunk, null, true, false);
          };
          function readableAddChunk(
            stream,
            chunk,
            encoding,
            addToFront,
            skipChunkCheck
          ) {
            debug("readableAddChunk", chunk);
            var state = stream._readableState;
            if (chunk === null) {
              state.reading = false;
              onEofChunk(stream, state);
            } else {
              var er;
              if (!skipChunkCheck) er = chunkInvalid(state, chunk);
              if (er) {
                errorOrDestroy(stream, er);
              } else if (state.objectMode || (chunk && chunk.length > 0)) {
                if (
                  typeof chunk !== "string" &&
                  !state.objectMode &&
                  Object.getPrototypeOf(chunk) !== Buffer.prototype
                ) {
                  chunk = _uint8ArrayToBuffer(chunk);
                }
                if (addToFront) {
                  if (state.endEmitted)
                    errorOrDestroy(
                      stream,
                      new ERR_STREAM_UNSHIFT_AFTER_END_EVENT()
                    );
                  else addChunk(stream, state, chunk, true);
                } else if (state.ended) {
                  errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
                } else if (state.destroyed) {
                  return false;
                } else {
                  state.reading = false;
                  if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0)
                      addChunk(stream, state, chunk, false);
                    else maybeReadMore(stream, state);
                  } else {
                    addChunk(stream, state, chunk, false);
                  }
                }
              } else if (!addToFront) {
                state.reading = false;
                maybeReadMore(stream, state);
              }
            } // We can push more data if we are below the highWaterMark.
            // Also, if we have no data yet, we can stand some more bytes.
            // This is to work around cases where hwm=0, such as the repl.
            return (
              !state.ended &&
              (state.length < state.highWaterMark || state.length === 0)
            );
          }
          function addChunk(stream, state, chunk, addToFront) {
            if (state.flowing && state.length === 0 && !state.sync) {
              state.awaitDrain = 0;
              stream.emit("data", chunk);
            } else {
              // update the buffer info.
              state.length += state.objectMode ? 1 : chunk.length;
              if (addToFront) state.buffer.unshift(chunk);
              else state.buffer.push(chunk);
              if (state.needReadable) emitReadable(stream);
            }
            maybeReadMore(stream, state);
          }
          function chunkInvalid(state, chunk) {
            var er;
            if (
              !_isUint8Array(chunk) &&
              typeof chunk !== "string" &&
              chunk !== undefined &&
              !state.objectMode
            ) {
              er = new ERR_INVALID_ARG_TYPE(
                "chunk",
                ["string", "Buffer", "Uint8Array"],
                chunk
              );
            }
            return er;
          }
          Readable.prototype.isPaused = function () {
            return this._readableState.flowing === false;
          }; // backwards compatibility.
          Readable.prototype.setEncoding = function (enc) {
            if (!StringDecoder)
              StringDecoder = require("string_decoder/").StringDecoder;
            var decoder = new StringDecoder(enc);
            this._readableState.decoder = decoder; // If setEncoding(null), decoder.encoding equals utf8
            this._readableState.encoding = this._readableState.decoder.encoding; // Iterate over current buffer to convert already stored Buffers:
            var p = this._readableState.buffer.head;
            var content = "";
            while (p !== null) {
              content += decoder.write(p.data);
              p = p.next;
            }
            this._readableState.buffer.clear();
            if (content !== "") this._readableState.buffer.push(content);
            this._readableState.length = content.length;
            return this;
          }; // Don't raise the hwm > 1GB
          var MAX_HWM = 0x40000000;
          function computeNewHighWaterMark(n) {
            if (n >= MAX_HWM) {
              // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
              n = MAX_HWM;
            } else {
              // Get the next highest power of 2 to prevent increasing hwm excessively in
              // tiny amounts
              n--;
              n |= n >>> 1;
              n |= n >>> 2;
              n |= n >>> 4;
              n |= n >>> 8;
              n |= n >>> 16;
              n++;
            }
            return n;
          } // This function is designed to be inlinable, so please take care when making
          // changes to the function body.
          function howMuchToRead(n, state) {
            if (n <= 0 || (state.length === 0 && state.ended)) return 0;
            if (state.objectMode) return 1;
            if (n !== n) {
              // Only flow one buffer at a time
              if (state.flowing && state.length)
                return state.buffer.head.data.length;
              else return state.length;
            } // If we're asking for more than the current hwm, then raise the hwm.
            if (n > state.highWaterMark)
              state.highWaterMark = computeNewHighWaterMark(n);
            if (n <= state.length) return n; // Don't have enough
            if (!state.ended) {
              state.needReadable = true;
              return 0;
            }
            return state.length;
          } // you can override either this method, or the async _read(n) below.
          Readable.prototype.read = function (n) {
            debug("read", n);
            n = parseInt(n, 10);
            var state = this._readableState;
            var nOrig = n;
            if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
            // already have a bunch of data in the buffer, then just trigger
            // the 'readable' event and move on.
            if (
              n === 0 &&
              state.needReadable &&
              ((state.highWaterMark !== 0
                ? state.length >= state.highWaterMark
                : state.length > 0) ||
                state.ended)
            ) {
              debug("read: emitReadable", state.length, state.ended);
              if (state.length === 0 && state.ended) endReadable(this);
              else emitReadable(this);
              return null;
            }
            n = howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.
            if (n === 0 && state.ended) {
              if (state.length === 0) endReadable(this);
              return null;
            } // All the actual chunk generation logic needs to be
            // *below* the call to _read.  The reason is that in certain
            // synthetic stream cases, such as passthrough streams, _read
            // may be a completely synchronous operation which may change
            // the state of the read buffer, providing enough data when
            // before there was *not* enough.
            //
            // So, the steps are:
            // 1. Figure out what the state of things will be after we do
            // a read from the buffer.
            //
            // 2. If that resulting state will trigger a _read, then call _read.
            // Note that this may be asynchronous, or synchronous.  Yes, it is
            // deeply ugly to write APIs this way, but that still doesn't mean
            // that the Readable class should behave improperly, as streams are
            // designed to be sync/async agnostic.
            // Take note if the _read call is sync or async (ie, if the read call
            // has returned yet), so that we know whether or not it's safe to emit
            // 'readable' etc.
            //
            // 3. Actually pull the requested chunks out of the buffer and return.
            // if we need a readable event, then we need to do some reading.
            var doRead = state.needReadable;
            debug("need readable", doRead); // if we currently have less than the highWaterMark, then also read some
            if (state.length === 0 || state.length - n < state.highWaterMark) {
              doRead = true;
              debug("length less than watermark", doRead);
            } // however, if we've ended, then there's no point, and if we're already
            // reading, then it's unnecessary.
            if (state.ended || state.reading) {
              doRead = false;
              debug("reading or ended", doRead);
            } else if (doRead) {
              debug("do read");
              state.reading = true;
              state.sync = true; // if the length is currently zero, then we *need* a readable event.
              if (state.length === 0) state.needReadable = true; // call internal read method
              this._read(state.highWaterMark);
              state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
              // and we need to re-evaluate how much data we can return to the user.
              if (!state.reading) n = howMuchToRead(nOrig, state);
            }
            var ret;
            if (n > 0) ret = fromList(n, state);
            else ret = null;
            if (ret === null) {
              state.needReadable = state.length <= state.highWaterMark;
              n = 0;
            } else {
              state.length -= n;
              state.awaitDrain = 0;
            }
            if (state.length === 0) {
              // If we have nothing in the buffer, then we want to know
              // as soon as we *do* get something into the buffer.
              if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.
              if (nOrig !== n && state.ended) endReadable(this);
            }
            if (ret !== null) this.emit("data", ret);
            return ret;
          };
          function onEofChunk(stream, state) {
            debug("onEofChunk");
            if (state.ended) return;
            if (state.decoder) {
              var chunk = state.decoder.end();
              if (chunk && chunk.length) {
                state.buffer.push(chunk);
                state.length += state.objectMode ? 1 : chunk.length;
              }
            }
            state.ended = true;
            if (state.sync) {
              // if we are sync, wait until next tick to emit the data.
              // Otherwise we risk emitting data in the flow()
              // the readable code triggers during a read() call
              emitReadable(stream);
            } else {
              // emit 'readable' now to make sure it gets picked up.
              state.needReadable = false;
              if (!state.emittedReadable) {
                state.emittedReadable = true;
                emitReadable_(stream);
              }
            }
          } // Don't emit readable right away in sync mode, because this can trigger
          // another read() call => stack overflow.  This way, it might trigger
          // a nextTick recursion warning, but that's not so bad.
          function emitReadable(stream) {
            var state = stream._readableState;
            debug("emitReadable", state.needReadable, state.emittedReadable);
            state.needReadable = false;
            if (!state.emittedReadable) {
              debug("emitReadable", state.flowing);
              state.emittedReadable = true;
              process.nextTick(emitReadable_, stream);
            }
          }
          function emitReadable_(stream) {
            var state = stream._readableState;
            debug("emitReadable_", state.destroyed, state.length, state.ended);
            if (!state.destroyed && (state.length || state.ended)) {
              stream.emit("readable");
              state.emittedReadable = false;
            } // The stream needs another readable event if
            // 1. It is not flowing, as the flow mechanism will take
            //    care of it.
            // 2. It is not ended.
            // 3. It is below the highWaterMark, so we can schedule
            //    another readable later.
            state.needReadable =
              !state.flowing &&
              !state.ended &&
              state.length <= state.highWaterMark;
            flow(stream);
          } // at this point, the user has presumably seen the 'readable' event,
          // and called read() to consume some data.  that may have triggered
          // in turn another _read(n) call, in which case reading = true if
          // it's in progress.
          // However, if we're not ended, or reading, and the length < hwm,
          // then go ahead and try to read some more preemptively.
          function maybeReadMore(stream, state) {
            if (!state.readingMore) {
              state.readingMore = true;
              process.nextTick(maybeReadMore_, stream, state);
            }
          }
          function maybeReadMore_(stream, state) {
            // Attempt to read more data if we should.
            //
            // The conditions for reading more data are (one of):
            // - Not enough data buffered (state.length < state.highWaterMark). The loop
            //   is responsible for filling the buffer with enough data if such data
            //   is available. If highWaterMark is 0 and we are not in the flowing mode
            //   we should _not_ attempt to buffer any extra data. We'll get more data
            //   when the stream consumer calls read() instead.
            // - No data in the buffer, and the stream is in flowing mode. In this mode
            //   the loop below is responsible for ensuring read() is called. Failing to
            //   call read here would abort the flow and there's no other mechanism for
            //   continuing the flow if the stream consumer has just subscribed to the
            //   'data' event.
            //
            // In addition to the above conditions to keep reading data, the following
            // conditions prevent the data from being read:
            // - The stream has ended (state.ended).
            // - There is already a pending 'read' operation (state.reading). This is a
            //   case where the the stream has called the implementation defined _read()
            //   method, but they are processing the call asynchronously and have _not_
            //   called push() with new data. In this case we skip performing more
            //   read()s. The execution ends in this method again after the _read() ends
            //   up calling push() with more data.
            while (
              !state.reading &&
              !state.ended &&
              (state.length < state.highWaterMark ||
                (state.flowing && state.length === 0))
            ) {
              var len = state.length;
              debug("maybeReadMore read 0");
              stream.read(0);
              if (len === state.length)
                // didn't get any data, stop spinning.
                break;
            }
            state.readingMore = false;
          } // abstract method.  to be overridden in specific implementation classes.
          // call cb(er, data) where data is <= n in length.
          // for virtual (non-string, non-buffer) streams, "length" is somewhat
          // arbitrary, and perhaps not very meaningful.
          Readable.prototype._read = function (n) {
            errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED("_read()"));
          };
          Readable.prototype.pipe = function (dest, pipeOpts) {
            var src = this;
            var state = this._readableState;
            switch (state.pipesCount) {
              case 0:
                state.pipes = dest;
                break;
              case 1:
                state.pipes = [state.pipes, dest];
                break;
              default:
                state.pipes.push(dest);
                break;
            }
            state.pipesCount += 1;
            debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
            var doEnd =
              (!pipeOpts || pipeOpts.end !== false) &&
              dest !== process.stdout &&
              dest !== process.stderr;
            var endFn = doEnd ? onend : unpipe;
            if (state.endEmitted) process.nextTick(endFn);
            else src.once("end", endFn);
            dest.on("unpipe", onunpipe);
            function onunpipe(readable, unpipeInfo) {
              debug("onunpipe");
              if (readable === src) {
                if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                  unpipeInfo.hasUnpiped = true;
                  cleanup();
                }
              }
            }
            function onend() {
              debug("onend");
              dest.end();
            } // when the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            var ondrain = pipeOnDrain(src);
            dest.on("drain", ondrain);
            var cleanedUp = false;
            function cleanup() {
              debug("cleanup"); // cleanup event handlers once the pipe is broken
              dest.removeListener("close", onclose);
              dest.removeListener("finish", onfinish);
              dest.removeListener("drain", ondrain);
              dest.removeListener("error", onerror);
              dest.removeListener("unpipe", onunpipe);
              src.removeListener("end", onend);
              src.removeListener("end", unpipe);
              src.removeListener("data", ondata);
              cleanedUp = true; // if the reader is waiting for a drain event from this
              // specific writer, then it would cause it to never start
              // flowing again.
              // So, if this is awaiting a drain, then we just call it now.
              // If we don't know, then assume that we are waiting for one.
              if (
                state.awaitDrain &&
                (!dest._writableState || dest._writableState.needDrain)
              )
                ondrain();
            }
            src.on("data", ondata);
            function ondata(chunk) {
              debug("ondata");
              var ret = dest.write(chunk);
              debug("dest.write", ret);
              if (ret === false) {
                // If the user unpiped during `dest.write()`, it is possible
                // to get stuck in a permanently paused state if that write
                // also returned false.
                // => Check whether `dest` is still a piping destination.
                if (
                  ((state.pipesCount === 1 && state.pipes === dest) ||
                    (state.pipesCount > 1 &&
                      indexOf(state.pipes, dest) !== -1)) &&
                  !cleanedUp
                ) {
                  debug("false write response, pause", state.awaitDrain);
                  state.awaitDrain++;
                }
                src.pause();
              }
            } // if the dest has an error, then stop piping into it.
            // however, don't suppress the throwing behavior for this.
            function onerror(er) {
              debug("onerror", er);
              unpipe();
              dest.removeListener("error", onerror);
              if (EElistenerCount(dest, "error") === 0) errorOrDestroy(dest, er);
            } // Make sure our error handler is attached before userland ones.
            prependListener(dest, "error", onerror); // Both close and finish should trigger unpipe, but only once.
            function onclose() {
              dest.removeListener("finish", onfinish);
              unpipe();
            }
            dest.once("close", onclose);
            function onfinish() {
              debug("onfinish");
              dest.removeListener("close", onclose);
              unpipe();
            }
            dest.once("finish", onfinish);
            function unpipe() {
              debug("unpipe");
              src.unpipe(dest);
            } // tell the dest that it's being piped to
            dest.emit("pipe", src); // start the flow if it hasn't been started already.
            if (!state.flowing) {
              debug("pipe resume");
              src.resume();
            }
            return dest;
          };
          function pipeOnDrain(src) {
            return function pipeOnDrainFunctionResult() {
              var state = src._readableState;
              debug("pipeOnDrain", state.awaitDrain);
              if (state.awaitDrain) state.awaitDrain--;
              if (state.awaitDrain === 0 && EElistenerCount(src, "data")) {
                state.flowing = true;
                flow(src);
              }
            };
          }
          Readable.prototype.unpipe = function (dest) {
            var state = this._readableState;
            var unpipeInfo = { hasUnpiped: false }; // if we're not piping anywhere, then do nothing.
            if (state.pipesCount === 0) return this; // just one destination.  most common case.
            if (state.pipesCount === 1) {
              // passed in one, but it's not the right one.
              if (dest && dest !== state.pipes) return this;
              if (!dest) dest = state.pipes; // got a match.
              state.pipes = null;
              state.pipesCount = 0;
              state.flowing = false;
              if (dest) dest.emit("unpipe", this, unpipeInfo);
              return this;
            } // slow case. multiple pipe destinations.
            if (!dest) {
              // remove all.
              var dests = state.pipes;
              var len = state.pipesCount;
              state.pipes = null;
              state.pipesCount = 0;
              state.flowing = false;
              for (var i = 0; i < len; i++) {
                dests[i].emit("unpipe", this, { hasUnpiped: false });
              }
              return this;
            } // try to find the right one.
            var index = indexOf(state.pipes, dest);
            if (index === -1) return this;
            state.pipes.splice(index, 1);
            state.pipesCount -= 1;
            if (state.pipesCount === 1) state.pipes = state.pipes[0];
            dest.emit("unpipe", this, unpipeInfo);
            return this;
          }; // set up data events if they are asked for
          // Ensure readable listeners eventually get something
          Readable.prototype.on = function (ev, fn) {
            var res = Stream.prototype.on.call(this, ev, fn);
            var state = this._readableState;
            if (ev === "data") {
              // update readableListening so that resume() may be a no-op
              // a few lines down. This is needed to support once('readable').
              state.readableListening = this.listenerCount("readable") > 0; // Try start flowing on next tick if stream isn't explicitly paused
              if (state.flowing !== false) this.resume();
            } else if (ev === "readable") {
              if (!state.endEmitted && !state.readableListening) {
                state.readableListening = state.needReadable = true;
                state.flowing = false;
                state.emittedReadable = false;
                debug("on readable", state.length, state.reading);
                if (state.length) {
                  emitReadable(this);
                } else if (!state.reading) {
                  process.nextTick(nReadingNextTick, this);
                }
              }
            }
            return res;
          };
          Readable.prototype.addListener = Readable.prototype.on;
          Readable.prototype.removeListener = function (ev, fn) {
            var res = Stream.prototype.removeListener.call(this, ev, fn);
            if (ev === "readable") {
              // We need to check if there is someone still listening to
              // readable and reset the state. However this needs to happen
              // after readable has been emitted but before I/O (nextTick) to
              // support once('readable', fn) cycles. This means that calling
              // resume within the same tick will have no
              // effect.
              process.nextTick(updateReadableListening, this);
            }
            return res;
          };
          Readable.prototype.removeAllListeners = function (ev) {
            var res = Stream.prototype.removeAllListeners.apply(this, arguments);
            if (ev === "readable" || ev === undefined) {
              // We need to check if there is someone still listening to
              // readable and reset the state. However this needs to happen
              // after readable has been emitted but before I/O (nextTick) to
              // support once('readable', fn) cycles. This means that calling
              // resume within the same tick will have no
              // effect.
              process.nextTick(updateReadableListening, this);
            }
            return res;
          };
          function updateReadableListening(self) {
            var state = self._readableState;
            state.readableListening = self.listenerCount("readable") > 0;
            if (state.resumeScheduled && !state.paused) {
              // flowing needs to be set to true now, otherwise
              // the upcoming resume will not flow.
              state.flowing = true; // crude way to check if we should resume
            } else if (self.listenerCount("data") > 0) {
              self.resume();
            }
          }
          function nReadingNextTick(self) {
            debug("readable nexttick read 0");
            self.read(0);
          } // pause() and resume() are remnants of the legacy readable stream API
          // If the user uses them, then switch into old mode.
          Readable.prototype.resume = function () {
            var state = this._readableState;
            if (!state.flowing) {
              debug("resume"); // we flow only if there is no one listening
              // for readable, but we still have to call
              // resume()
              state.flowing = !state.readableListening;
              resume(this, state);
            }
            state.paused = false;
            return this;
          };
          function resume(stream, state) {
            if (!state.resumeScheduled) {
              state.resumeScheduled = true;
              process.nextTick(resume_, stream, state);
            }
          }
          function resume_(stream, state) {
            debug("resume", state.reading);
            if (!state.reading) {
              stream.read(0);
            }
            state.resumeScheduled = false;
            stream.emit("resume");
            flow(stream);
            if (state.flowing && !state.reading) stream.read(0);
          }
          Readable.prototype.pause = function () {
            debug("call pause flowing=%j", this._readableState.flowing);
            if (this._readableState.flowing !== false) {
              debug("pause");
              this._readableState.flowing = false;
              this.emit("pause");
            }
            this._readableState.paused = true;
            return this;
          };
          function flow(stream) {
            var state = stream._readableState;
            debug("flow", state.flowing);
            while (state.flowing && stream.read() !== null) {}
          } // wrap an old-style stream as the async data source.
          // This is *not* part of the readable stream interface.
          // It is an ugly unfortunate mess of history.
          Readable.prototype.wrap = function (stream) {
            var _this = this;
            var state = this._readableState;
            var paused = false;
            stream.on("end", function () {
              debug("wrapped end");
              if (state.decoder && !state.ended) {
                var chunk = state.decoder.end();
                if (chunk && chunk.length) _this.push(chunk);
              }
              _this.push(null);
            });
            stream.on("data", function (chunk) {
              debug("wrapped data");
              if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode
              if (state.objectMode && (chunk === null || chunk === undefined))
                return;
              else if (!state.objectMode && (!chunk || !chunk.length)) return;
              var ret = _this.push(chunk);
              if (!ret) {
                paused = true;
                stream.pause();
              }
            }); // proxy all the other methods.
            // important when wrapping filters and duplexes.
            for (var i in stream) {
              if (this[i] === undefined && typeof stream[i] === "function") {
                this[i] = (function methodWrap(method) {
                  return function methodWrapReturnFunction() {
                    return stream[method].apply(stream, arguments);
                  };
                })(i);
              }
            } // proxy certain important events.
            for (var n = 0; n < kProxyEvents.length; n++) {
              stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
            } // when we try to consume some more bytes, simply unpause the
            // underlying stream.
            this._read = function (n) {
              debug("wrapped _read", n);
              if (paused) {
                paused = false;
                stream.resume();
              }
            };
            return this;
          };
          if (typeof Symbol === "function") {
            Readable.prototype[Symbol.asyncIterator] = function () {
              if (createReadableStreamAsyncIterator === undefined) {
                createReadableStreamAsyncIterator = require("./internal/streams/async_iterator");
              }
              return createReadableStreamAsyncIterator(this);
            };
          }
          Object.defineProperty(Readable.prototype, "readableHighWaterMark", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._readableState.highWaterMark;
            }
          });
          Object.defineProperty(Readable.prototype, "readableBuffer", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._readableState && this._readableState.buffer;
            }
          });
          Object.defineProperty(Readable.prototype, "readableFlowing", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._readableState.flowing;
            },
            set: function set(state) {
              if (this._readableState) {
                this._readableState.flowing = state;
              }
            }
          }); // exposed for testing purposes only.
          Readable._fromList = fromList;
          Object.defineProperty(Readable.prototype, "readableLength", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._readableState.length;
            }
          }); // Pluck off n bytes from an array of buffers.
          // Length is the combined lengths of all the buffers in the list.
          // This function is designed to be inlinable, so please take care when making
          // changes to the function body.
          function fromList(n, state) {
            // nothing buffered
            if (state.length === 0) return null;
            var ret;
            if (state.objectMode) ret = state.buffer.shift();
            else if (!n || n >= state.length) {
              // read it all, truncate the list
              if (state.decoder) ret = state.buffer.join("");
              else if (state.buffer.length === 1) ret = state.buffer.first();
              else ret = state.buffer.concat(state.length);
              state.buffer.clear();
            } else {
              // read part of list
              ret = state.buffer.consume(n, state.decoder);
            }
            return ret;
          }
          function endReadable(stream) {
            var state = stream._readableState;
            debug("endReadable", state.endEmitted);
            if (!state.endEmitted) {
              state.ended = true;
              process.nextTick(endReadableNT, state, stream);
            }
          }
          function endReadableNT(state, stream) {
            debug("endReadableNT", state.endEmitted, state.length); // Check that we didn't get one last unshift.
            if (!state.endEmitted && state.length === 0) {
              state.endEmitted = true;
              stream.readable = false;
              stream.emit("end");
              if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the writable side is ready for autoDestroy as well
                var wState = stream._writableState;
                if (!wState || (wState.autoDestroy && wState.finished)) {
                  stream.destroy();
                }
              }
            }
          }
          if (typeof Symbol === "function") {
            Readable.from = function (iterable, opts) {
              if (from === undefined) {
                from = require("./internal/streams/from");
              }
              return from(Readable, iterable, opts);
            };
          }
          function indexOf(xs, x) {
            for (var i = 0, l = xs.length; i < l; i++) {
              if (xs[i] === x) return i;
            }
            return -1;
          }
        },
        {
          process: "ec0e1432c6522aad9b4b16c4b3b080f4",
          events: "b7e625dd36a8c733268400e6bdb0e234",
          "./internal/streams/stream": "c50b17c9da9608e14ed0bdff3989a7e3",
          buffer: "1948b2a05a083f82087512f711e79e4d",
          util: "83fb80501e6599b7f0cf455c47cd5c1a",
          "./internal/streams/buffer_list": "fe52dc644e3ad3431b912a472e58f6b5",
          "./internal/streams/destroy": "608647b45545cc3cc150ba420eae74b3",
          "./internal/streams/state": "40b1422fe5ffbedd93cdedf2dafc4729",
          "../errors": "9e8b965127778a5bef42160d55499ba5",
          inherits: "cd61047e9289e4b62768390878fc0b01",
          "./_stream_duplex": "697a6b37b3553e220776ac06dc162ff3",
          "string_decoder/": "638172f07d088eb6b6073fec0c6138fc",
          "./internal/streams/async_iterator": "7f48ac4879062fde46442a5cd4917d19",
          "./internal/streams/from": "180f5f76cf99d66dda918fd2e277bfbf"
        }
      ],
      b7e625dd36a8c733268400e6bdb0e234: [
        function (require, module, exports) {
          // Copyright Joyent, Inc. and other Node contributors.
          //
          // Permission is hereby granted, free of charge, to any person obtaining a
          // copy of this software and associated documentation files (the
          // "Software"), to deal in the Software without restriction, including
          // without limitation the rights to use, copy, modify, merge, publish,
          // distribute, sublicense, and/or sell copies of the Software, and to permit
          // persons to whom the Software is furnished to do so, subject to the
          // following conditions:
          //
          // The above copyright notice and this permission notice shall be included
          // in all copies or substantial portions of the Software.
          //
          // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
          // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
          // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
          // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
          // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
          // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
          // USE OR OTHER DEALINGS IN THE SOFTWARE.
          "use strict";
          var R =
            (typeof Reflect === "undefined" ? "undefined" : _typeof2(Reflect)) ===
            "object"
              ? Reflect
              : null;
          var ReflectApply =
            R && typeof R.apply === "function"
              ? R.apply
              : function ReflectApply(target, receiver, args) {
                  return Function.prototype.apply.call(target, receiver, args);
                };
          var ReflectOwnKeys;
          if (R && typeof R.ownKeys === "function") {
            ReflectOwnKeys = R.ownKeys;
          } else if (Object.getOwnPropertySymbols) {
            ReflectOwnKeys = function ReflectOwnKeys(target) {
              return Object.getOwnPropertyNames(target).concat(
                Object.getOwnPropertySymbols(target)
              );
            };
          } else {
            ReflectOwnKeys = function ReflectOwnKeys(target) {
              return Object.getOwnPropertyNames(target);
            };
          }
          function ProcessEmitWarning(warning) {
            if (console && console.warn) console.warn(warning);
          }
          var NumberIsNaN =
            Number.isNaN ||
            function NumberIsNaN(value) {
              return value !== value;
            };
          function EventEmitter() {
            EventEmitter.init.call(this);
          }
          module.exports = EventEmitter; // Backwards-compat with node 0.10.x
          EventEmitter.EventEmitter = EventEmitter;
          EventEmitter.prototype._events = undefined;
          EventEmitter.prototype._eventsCount = 0;
          EventEmitter.prototype._maxListeners = undefined; // By default EventEmitters will print a warning if more than 10 listeners are
          // added to it. This is a useful default which helps finding memory leaks.
          var defaultMaxListeners = 10;
          function checkListener(listener) {
            if (typeof listener !== "function") {
              throw new TypeError(
                'The "listener" argument must be of type Function. Received type ' +
                  _typeof2(listener)
              );
            }
          }
          Object.defineProperty(EventEmitter, "defaultMaxListeners", {
            enumerable: true,
            get: function get() {
              return defaultMaxListeners;
            },
            set: function set(arg) {
              if (typeof arg !== "number" || arg < 0 || NumberIsNaN(arg)) {
                throw new RangeError(
                  'The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' +
                    arg +
                    "."
                );
              }
              defaultMaxListeners = arg;
            }
          });
          EventEmitter.init = function () {
            if (
              this._events === undefined ||
              this._events === Object.getPrototypeOf(this)._events
            ) {
              this._events = Object.create(null);
              this._eventsCount = 0;
            }
            this._maxListeners = this._maxListeners || undefined;
          }; // Obviously not all Emitters should be limited to 10. This function allows
          // that to be increased. Set to zero for unlimited.
          EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
            if (typeof n !== "number" || n < 0 || NumberIsNaN(n)) {
              throw new RangeError(
                'The value of "n" is out of range. It must be a non-negative number. Received ' +
                  n +
                  "."
              );
            }
            this._maxListeners = n;
            return this;
          };
          function _getMaxListeners(that) {
            if (that._maxListeners === undefined)
              return EventEmitter.defaultMaxListeners;
            return that._maxListeners;
          }
          EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
            return _getMaxListeners(this);
          };
          EventEmitter.prototype.emit = function emit(type) {
            var args = [];
            for (var i = 1; i < arguments.length; i++) {
              args.push(arguments[i]);
            }
            var doError = type === "error";
            var events = this._events;
            if (events !== undefined)
              doError = doError && events.error === undefined;
            else if (!doError) return false; // If there is no 'error' event listener then throw.
            if (doError) {
              var er;
              if (args.length > 0) er = args[0];
              if (_instanceof(er, Error)) {
                // Note: The comments on the `throw` lines are intentional, they show
                // up in Node's output if this results in an unhandled exception.
                throw er; // Unhandled 'error' event
              } // At least give some kind of context to the user
              var err = new Error(
                "Unhandled error." + (er ? " (" + er.message + ")" : "")
              );
              err.context = er;
              throw err; // Unhandled 'error' event
            }
            var handler = events[type];
            if (handler === undefined) return false;
            if (typeof handler === "function") {
              ReflectApply(handler, this, args);
            } else {
              var len = handler.length;
              var listeners = arrayClone(handler, len);
              for (var i = 0; i < len; ++i) {
                ReflectApply(listeners[i], this, args);
              }
            }
            return true;
          };
          function _addListener(target, type, listener, prepend) {
            var m;
            var events;
            var existing;
            checkListener(listener);
            events = target._events;
            if (events === undefined) {
              events = target._events = Object.create(null);
              target._eventsCount = 0;
            } else {
              // To avoid recursion in the case that type === "newListener"! Before
              // adding it to the listeners, first emit "newListener".
              if (events.newListener !== undefined) {
                target.emit(
                  "newListener",
                  type,
                  listener.listener ? listener.listener : listener
                ); // Re-assign `events` because a newListener handler could have caused the
                // this._events to be assigned to a new object
                events = target._events;
              }
              existing = events[type];
            }
            if (existing === undefined) {
              // Optimize the case of one listener. Don't need the extra array object.
              existing = events[type] = listener;
              ++target._eventsCount;
            } else {
              if (typeof existing === "function") {
                // Adding the second element, need to change to array.
                existing = events[type] = prepend
                  ? [listener, existing]
                  : [existing, listener]; // If we've already got an array, just append.
              } else if (prepend) {
                existing.unshift(listener);
              } else {
                existing.push(listener);
              } // Check for listener leak
              m = _getMaxListeners(target);
              if (m > 0 && existing.length > m && !existing.warned) {
                existing.warned = true; // No error code for this since it is a Warning
                // eslint-disable-next-line no-restricted-syntax
                var w = new Error(
                  "Possible EventEmitter memory leak detected. " +
                    existing.length +
                    " " +
                    String(type) +
                    " listeners " +
                    "added. Use emitter.setMaxListeners() to " +
                    "increase limit"
                );
                w.name = "MaxListenersExceededWarning";
                w.emitter = target;
                w.type = type;
                w.count = existing.length;
                ProcessEmitWarning(w);
              }
            }
            return target;
          }
          EventEmitter.prototype.addListener = function addListener(
            type,
            listener
          ) {
            return _addListener(this, type, listener, false);
          };
          EventEmitter.prototype.on = EventEmitter.prototype.addListener;
          EventEmitter.prototype.prependListener = function prependListener(
            type,
            listener
          ) {
            return _addListener(this, type, listener, true);
          };
          function onceWrapper() {
            if (!this.fired) {
              this.target.removeListener(this.type, this.wrapFn);
              this.fired = true;
              if (arguments.length === 0) return this.listener.call(this.target);
              return this.listener.apply(this.target, arguments);
            }
          }
          function _onceWrap(target, type, listener) {
            var state = {
              fired: false,
              wrapFn: undefined,
              target: target,
              type: type,
              listener: listener
            };
            var wrapped = onceWrapper.bind(state);
            wrapped.listener = listener;
            state.wrapFn = wrapped;
            return wrapped;
          }
          EventEmitter.prototype.once = function once(type, listener) {
            checkListener(listener);
            this.on(type, _onceWrap(this, type, listener));
            return this;
          };
          EventEmitter.prototype.prependOnceListener = function prependOnceListener(
            type,
            listener
          ) {
            checkListener(listener);
            this.prependListener(type, _onceWrap(this, type, listener));
            return this;
          }; // Emits a 'removeListener' event if and only if the listener was removed.
          EventEmitter.prototype.removeListener = function removeListener(
            type,
            listener
          ) {
            var list, events, position, i, originalListener;
            checkListener(listener);
            events = this._events;
            if (events === undefined) return this;
            list = events[type];
            if (list === undefined) return this;
            if (list === listener || list.listener === listener) {
              if (--this._eventsCount === 0) this._events = Object.create(null);
              else {
                delete events[type];
                if (events.removeListener)
                  this.emit("removeListener", type, list.listener || listener);
              }
            } else if (typeof list !== "function") {
              position = -1;
              for (i = list.length - 1; i >= 0; i--) {
                if (list[i] === listener || list[i].listener === listener) {
                  originalListener = list[i].listener;
                  position = i;
                  break;
                }
              }
              if (position < 0) return this;
              if (position === 0) list.shift();
              else {
                spliceOne(list, position);
              }
              if (list.length === 1) events[type] = list[0];
              if (events.removeListener !== undefined)
                this.emit("removeListener", type, originalListener || listener);
            }
            return this;
          };
          EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
          EventEmitter.prototype.removeAllListeners = function removeAllListeners(
            type
          ) {
            var listeners, events, i;
            events = this._events;
            if (events === undefined) return this; // not listening for removeListener, no need to emit
            if (events.removeListener === undefined) {
              if (arguments.length === 0) {
                this._events = Object.create(null);
                this._eventsCount = 0;
              } else if (events[type] !== undefined) {
                if (--this._eventsCount === 0) this._events = Object.create(null);
                else delete events[type];
              }
              return this;
            } // emit removeListener for all listeners on all events
            if (arguments.length === 0) {
              var keys = Object.keys(events);
              var key;
              for (i = 0; i < keys.length; ++i) {
                key = keys[i];
                if (key === "removeListener") continue;
                this.removeAllListeners(key);
              }
              this.removeAllListeners("removeListener");
              this._events = Object.create(null);
              this._eventsCount = 0;
              return this;
            }
            listeners = events[type];
            if (typeof listeners === "function") {
              this.removeListener(type, listeners);
            } else if (listeners !== undefined) {
              // LIFO order
              for (i = listeners.length - 1; i >= 0; i--) {
                this.removeListener(type, listeners[i]);
              }
            }
            return this;
          };
          function _listeners(target, type, unwrap) {
            var events = target._events;
            if (events === undefined) return [];
            var evlistener = events[type];
            if (evlistener === undefined) return [];
            if (typeof evlistener === "function")
              return unwrap ? [evlistener.listener || evlistener] : [evlistener];
            return unwrap
              ? unwrapListeners(evlistener)
              : arrayClone(evlistener, evlistener.length);
          }
          EventEmitter.prototype.listeners = function listeners(type) {
            return _listeners(this, type, true);
          };
          EventEmitter.prototype.rawListeners = function rawListeners(type) {
            return _listeners(this, type, false);
          };
          EventEmitter.listenerCount = function (emitter, type) {
            if (typeof emitter.listenerCount === "function") {
              return emitter.listenerCount(type);
            } else {
              return listenerCount.call(emitter, type);
            }
          };
          EventEmitter.prototype.listenerCount = listenerCount;
          function listenerCount(type) {
            var events = this._events;
            if (events !== undefined) {
              var evlistener = events[type];
              if (typeof evlistener === "function") {
                return 1;
              } else if (evlistener !== undefined) {
                return evlistener.length;
              }
            }
            return 0;
          }
          EventEmitter.prototype.eventNames = function eventNames() {
            return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
          };
          function arrayClone(arr, n) {
            var copy = new Array(n);
            for (var i = 0; i < n; ++i) {
              copy[i] = arr[i];
            }
            return copy;
          }
          function spliceOne(list, index) {
            for (; index + 1 < list.length; index++) {
              list[index] = list[index + 1];
            }
            list.pop();
          }
          function unwrapListeners(arr) {
            var ret = new Array(arr.length);
            for (var i = 0; i < ret.length; ++i) {
              ret[i] = arr[i].listener || arr[i];
            }
            return ret;
          }
        },
        {}
      ],
      c50b17c9da9608e14ed0bdff3989a7e3: [
        function (require, module, exports) {
          module.exports = require("events").EventEmitter;
        },
        { events: "b7e625dd36a8c733268400e6bdb0e234" }
      ],
      "83fb80501e6599b7f0cf455c47cd5c1a": [
        function (require, module, exports) {
          "use strict";
        },
        {}
      ],
      fe52dc644e3ad3431b912a472e58f6b5: [
        function (require, module, exports) {
          "use strict";
          function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
              var symbols = Object.getOwnPropertySymbols(object);
              if (enumerableOnly)
                symbols = symbols.filter(function (sym) {
                  return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                });
              keys.push.apply(keys, symbols);
            }
            return keys;
          }
          function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i] != null ? arguments[i] : {};
              if (i % 2) {
                ownKeys(Object(source), true).forEach(function (key) {
                  _defineProperty(target, key, source[key]);
                });
              } else if (Object.getOwnPropertyDescriptors) {
                Object.defineProperties(
                  target,
                  Object.getOwnPropertyDescriptors(source)
                );
              } else {
                ownKeys(Object(source)).forEach(function (key) {
                  Object.defineProperty(
                    target,
                    key,
                    Object.getOwnPropertyDescriptor(source, key)
                  );
                });
              }
            }
            return target;
          }
          function _defineProperty(obj, key, value) {
            if (key in obj) {
              Object.defineProperty(obj, key, {
                value: value,
                enumerable: true,
                configurable: true,
                writable: true
              });
            } else {
              obj[key] = value;
            }
            return obj;
          }
          function _classCallCheck(instance, Constructor) {
            if (!_instanceof(instance, Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) _defineProperties(Constructor.prototype, protoProps);
            if (staticProps) _defineProperties(Constructor, staticProps);
            return Constructor;
          }
          var _require = require("buffer"),
            Buffer = _require.Buffer;
          var _require2 = require("util"),
            inspect = _require2.inspect;
          var custom = (inspect && inspect.custom) || "inspect";
          function copyBuffer(src, target, offset) {
            Buffer.prototype.copy.call(src, target, offset);
          }
          module.exports = /*#__PURE__*/ (function () {
            function BufferList() {
              _classCallCheck(this, BufferList);
              this.head = null;
              this.tail = null;
              this.length = 0;
            }
            _createClass(BufferList, [
              {
                key: "push",
                value: function push(v) {
                  var entry = { data: v, next: null };
                  if (this.length > 0) this.tail.next = entry;
                  else this.head = entry;
                  this.tail = entry;
                  ++this.length;
                }
              },
              {
                key: "unshift",
                value: function unshift(v) {
                  var entry = { data: v, next: this.head };
                  if (this.length === 0) this.tail = entry;
                  this.head = entry;
                  ++this.length;
                }
              },
              {
                key: "shift",
                value: function shift() {
                  if (this.length === 0) return;
                  var ret = this.head.data;
                  if (this.length === 1) this.head = this.tail = null;
                  else this.head = this.head.next;
                  --this.length;
                  return ret;
                }
              },
              {
                key: "clear",
                value: function clear() {
                  this.head = this.tail = null;
                  this.length = 0;
                }
              },
              {
                key: "join",
                value: function join(s) {
                  if (this.length === 0) return "";
                  var p = this.head;
                  var ret = "" + p.data;
                  while ((p = p.next)) {
                    ret += s + p.data;
                  }
                  return ret;
                }
              },
              {
                key: "concat",
                value: function concat(n) {
                  if (this.length === 0) return Buffer.alloc(0);
                  var ret = Buffer.allocUnsafe(n >>> 0);
                  var p = this.head;
                  var i = 0;
                  while (p) {
                    copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                  }
                  return ret;
                } // Consumes a specified amount of bytes or characters from the buffered data.
              },
              {
                key: "consume",
                value: function consume(n, hasStrings) {
                  var ret;
                  if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                  } else if (n === this.head.data.length) {
                    // First chunk is a perfect match.
                    ret = this.shift();
                  } else {
                    // Result spans more than one buffer.
                    ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                  }
                  return ret;
                }
              },
              {
                key: "first",
                value: function first() {
                  return this.head.data;
                } // Consumes a specified amount of characters from the buffered data.
              },
              {
                key: "_getString",
                value: function _getString(n) {
                  var p = this.head;
                  var c = 1;
                  var ret = p.data;
                  n -= ret.length;
                  while ((p = p.next)) {
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                      if (nb === str.length) {
                        ++c;
                        if (p.next) this.head = p.next;
                        else this.head = this.tail = null;
                      } else {
                        this.head = p;
                        p.data = str.slice(nb);
                      }
                      break;
                    }
                    ++c;
                  }
                  this.length -= c;
                  return ret;
                } // Consumes a specified amount of bytes from the buffered data.
              },
              {
                key: "_getBuffer",
                value: function _getBuffer(n) {
                  var ret = Buffer.allocUnsafe(n);
                  var p = this.head;
                  var c = 1;
                  p.data.copy(ret);
                  n -= p.data.length;
                  while ((p = p.next)) {
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                      if (nb === buf.length) {
                        ++c;
                        if (p.next) this.head = p.next;
                        else this.head = this.tail = null;
                      } else {
                        this.head = p;
                        p.data = buf.slice(nb);
                      }
                      break;
                    }
                    ++c;
                  }
                  this.length -= c;
                  return ret;
                } // Make sure the linked list only shows the minimal necessary information.
              },
              {
                key: custom,
                value: function value(_, options) {
                  return inspect(
                    this,
                    _objectSpread({}, options, {
                      // Only inspect one level.
                      depth: 0, // It should not recurse.
                      customInspect: false
                    })
                  );
                }
              }
            ]);
            return BufferList;
          })();
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          util: "83fb80501e6599b7f0cf455c47cd5c1a"
        }
      ],
      "608647b45545cc3cc150ba420eae74b3": [
        function (require, module, exports) {
          "use strict"; // undocumented cb() API, needed for core, not for public API
          var process = require("process");
          function destroy(err, cb) {
            var _this = this;
            var readableDestroyed =
              this._readableState && this._readableState.destroyed;
            var writableDestroyed =
              this._writableState && this._writableState.destroyed;
            if (readableDestroyed || writableDestroyed) {
              if (cb) {
                cb(err);
              } else if (err) {
                if (!this._writableState) {
                  process.nextTick(emitErrorNT, this, err);
                } else if (!this._writableState.errorEmitted) {
                  this._writableState.errorEmitted = true;
                  process.nextTick(emitErrorNT, this, err);
                }
              }
              return this;
            } // we set destroyed to true before firing error callbacks in order
            // to make it re-entrance safe in case destroy() is called within callbacks
            if (this._readableState) {
              this._readableState.destroyed = true;
            } // if this is a duplex stream mark the writable part as destroyed as well
            if (this._writableState) {
              this._writableState.destroyed = true;
            }
            this._destroy(err || null, function (err) {
              if (!cb && err) {
                if (!_this._writableState) {
                  process.nextTick(emitErrorAndCloseNT, _this, err);
                } else if (!_this._writableState.errorEmitted) {
                  _this._writableState.errorEmitted = true;
                  process.nextTick(emitErrorAndCloseNT, _this, err);
                } else {
                  process.nextTick(emitCloseNT, _this);
                }
              } else if (cb) {
                process.nextTick(emitCloseNT, _this);
                cb(err);
              } else {
                process.nextTick(emitCloseNT, _this);
              }
            });
            return this;
          }
          function emitErrorAndCloseNT(self, err) {
            emitErrorNT(self, err);
            emitCloseNT(self);
          }
          function emitCloseNT(self) {
            if (self._writableState && !self._writableState.emitClose) return;
            if (self._readableState && !self._readableState.emitClose) return;
            self.emit("close");
          }
          function undestroy() {
            if (this._readableState) {
              this._readableState.destroyed = false;
              this._readableState.reading = false;
              this._readableState.ended = false;
              this._readableState.endEmitted = false;
            }
            if (this._writableState) {
              this._writableState.destroyed = false;
              this._writableState.ended = false;
              this._writableState.ending = false;
              this._writableState.finalCalled = false;
              this._writableState.prefinished = false;
              this._writableState.finished = false;
              this._writableState.errorEmitted = false;
            }
          }
          function emitErrorNT(self, err) {
            self.emit("error", err);
          }
          function errorOrDestroy(stream, err) {
            // We have tests that rely on errors being emitted
            // in the same tick, so changing this is semver major.
            // For now when you opt-in to autoDestroy we allow
            // the error to be emitted nextTick. In a future
            // semver major update we should change the default to this.
            var rState = stream._readableState;
            var wState = stream._writableState;
            if ((rState && rState.autoDestroy) || (wState && wState.autoDestroy))
              stream.destroy(err);
            else stream.emit("error", err);
          }
          module.exports = {
            destroy: destroy,
            undestroy: undestroy,
            errorOrDestroy: errorOrDestroy
          };
        },
        { process: "ec0e1432c6522aad9b4b16c4b3b080f4" }
      ],
      "40b1422fe5ffbedd93cdedf2dafc4729": [
        function (require, module, exports) {
          "use strict";
          var ERR_INVALID_OPT_VALUE = require("../../../errors").codes
            .ERR_INVALID_OPT_VALUE;
          function highWaterMarkFrom(options, isDuplex, duplexKey) {
            return options.highWaterMark != null
              ? options.highWaterMark
              : isDuplex
              ? options[duplexKey]
              : null;
          }
          function getHighWaterMark(state, options, duplexKey, isDuplex) {
            var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
            if (hwm != null) {
              if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
                var name = isDuplex ? duplexKey : "highWaterMark";
                throw new ERR_INVALID_OPT_VALUE(name, hwm);
              }
              return Math.floor(hwm);
            } // Default value
            return state.objectMode ? 16 : 16 * 1024;
          }
          module.exports = { getHighWaterMark: getHighWaterMark };
        },
        { "../../../errors": "9e8b965127778a5bef42160d55499ba5" }
      ],
      "9e8b965127778a5bef42160d55499ba5": [
        function (require, module, exports) {
          "use strict";
          function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            subClass.__proto__ = superClass;
          }
          var codes = {};
          function createErrorType(code, message, Base) {
            if (!Base) {
              Base = Error;
            }
            function getMessage(arg1, arg2, arg3) {
              if (typeof message === "string") {
                return message;
              } else {
                return message(arg1, arg2, arg3);
              }
            }
            var NodeError = /*#__PURE__*/ (function (_Base) {
              _inheritsLoose(NodeError, _Base);
              function NodeError(arg1, arg2, arg3) {
                return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
              }
              return NodeError;
            })(Base);
            NodeError.prototype.name = Base.name;
            NodeError.prototype.code = code;
            codes[code] = NodeError;
          } // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
          function oneOf(expected, thing) {
            if (Array.isArray(expected)) {
              var len = expected.length;
              expected = expected.map(function (i) {
                return String(i);
              });
              if (len > 2) {
                return (
                  "one of "
                    .concat(thing, " ")
                    .concat(expected.slice(0, len - 1).join(", "), ", or ") +
                  expected[len - 1]
                );
              } else if (len === 2) {
                return "one of "
                  .concat(thing, " ")
                  .concat(expected[0], " or ")
                  .concat(expected[1]);
              } else {
                return "of ".concat(thing, " ").concat(expected[0]);
              }
            } else {
              return "of ".concat(thing, " ").concat(String(expected));
            }
          } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
          function startsWith(str, search, pos) {
            return (
              str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search
            );
          } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
          function endsWith(str, search, this_len) {
            if (this_len === undefined || this_len > str.length) {
              this_len = str.length;
            }
            return str.substring(this_len - search.length, this_len) === search;
          } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
          function includes(str, search, start) {
            if (typeof start !== "number") {
              start = 0;
            }
            if (start + search.length > str.length) {
              return false;
            } else {
              return str.indexOf(search, start) !== -1;
            }
          }
          createErrorType(
            "ERR_INVALID_OPT_VALUE",
            function (name, value) {
              return (
                'The value "' + value + '" is invalid for option "' + name + '"'
              );
            },
            TypeError
          );
          createErrorType(
            "ERR_INVALID_ARG_TYPE",
            function (name, expected, actual) {
              // determiner: 'must be' or 'must not be'
              var determiner;
              if (typeof expected === "string" && startsWith(expected, "not ")) {
                determiner = "must not be";
                expected = expected.replace(/^not /, "");
              } else {
                determiner = "must be";
              }
              var msg;
              if (endsWith(name, " argument")) {
                // For cases like 'first argument'
                msg = "The "
                  .concat(name, " ")
                  .concat(determiner, " ")
                  .concat(oneOf(expected, "type"));
              } else {
                var type = includes(name, ".") ? "property" : "argument";
                msg = 'The "'
                  .concat(name, '" ')
                  .concat(type, " ")
                  .concat(determiner, " ")
                  .concat(oneOf(expected, "type"));
              }
              msg += ". Received type ".concat(_typeof2(actual));
              return msg;
            },
            TypeError
          );
          createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
          createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function (name) {
            return "The " + name + " method is not implemented";
          });
          createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
          createErrorType("ERR_STREAM_DESTROYED", function (name) {
            return "Cannot call " + name + " after a stream was destroyed";
          });
          createErrorType(
            "ERR_MULTIPLE_CALLBACK",
            "Callback called multiple times"
          );
          createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
          createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
          createErrorType(
            "ERR_STREAM_NULL_VALUES",
            "May not write null values to stream",
            TypeError
          );
          createErrorType(
            "ERR_UNKNOWN_ENCODING",
            function (arg) {
              return "Unknown encoding: " + arg;
            },
            TypeError
          );
          createErrorType(
            "ERR_STREAM_UNSHIFT_AFTER_END_EVENT",
            "stream.unshift() after end event"
          );
          module.exports.codes = codes;
        },
        {}
      ],
      "697a6b37b3553e220776ac06dc162ff3": [
        function (require, module, exports) {
          // Copyright Joyent, Inc. and other Node contributors.
          //
          // Permission is hereby granted, free of charge, to any person obtaining a
          // copy of this software and associated documentation files (the
          // "Software"), to deal in the Software without restriction, including
          // without limitation the rights to use, copy, modify, merge, publish,
          // distribute, sublicense, and/or sell copies of the Software, and to permit
          // persons to whom the Software is furnished to do so, subject to the
          // following conditions:
          //
          // The above copyright notice and this permission notice shall be included
          // in all copies or substantial portions of the Software.
          //
          // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
          // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
          // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
          // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
          // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
          // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
          // USE OR OTHER DEALINGS IN THE SOFTWARE.
          // a duplex stream is just a stream that is both readable and writable.
          // Since JS doesn't have multiple prototypal inheritance, this class
          // prototypally inherits from Readable, and then parasitically from
          // Writable.
          "use strict";
          /*<replacement>*/ var process = require("process");
          var objectKeys =
            Object.keys ||
            function (obj) {
              var keys = [];
              for (var key in obj) {
                keys.push(key);
              }
              return keys;
            };
          /*</replacement>*/ module.exports = Duplex;
          var Readable = require("./_stream_readable");
          var Writable = require("./_stream_writable");
          require("inherits")(Duplex, Readable);
          {
            // Allow the keys array to be GC'ed.
            var keys = objectKeys(Writable.prototype);
            for (var v = 0; v < keys.length; v++) {
              var method = keys[v];
              if (!Duplex.prototype[method])
                Duplex.prototype[method] = Writable.prototype[method];
            }
          }
          function Duplex(options) {
            if (!_instanceof(this, Duplex)) return new Duplex(options);
            Readable.call(this, options);
            Writable.call(this, options);
            this.allowHalfOpen = true;
            if (options) {
              if (options.readable === false) this.readable = false;
              if (options.writable === false) this.writable = false;
              if (options.allowHalfOpen === false) {
                this.allowHalfOpen = false;
                this.once("end", onend);
              }
            }
          }
          Object.defineProperty(Duplex.prototype, "writableHighWaterMark", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._writableState.highWaterMark;
            }
          });
          Object.defineProperty(Duplex.prototype, "writableBuffer", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._writableState && this._writableState.getBuffer();
            }
          });
          Object.defineProperty(Duplex.prototype, "writableLength", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._writableState.length;
            }
          }); // the no-half-open enforcer
          function onend() {
            // If the writable side ended, then we're ok.
            if (this._writableState.ended) return; // no more data can be written.
            // But allow more writes to happen in this tick.
            process.nextTick(onEndNT, this);
          }
          function onEndNT(self) {
            self.end();
          }
          Object.defineProperty(Duplex.prototype, "destroyed", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              if (
                this._readableState === undefined ||
                this._writableState === undefined
              ) {
                return false;
              }
              return (
                this._readableState.destroyed && this._writableState.destroyed
              );
            },
            set: function set(value) {
              // we ignore the value if the stream
              // has not been initialized yet
              if (
                this._readableState === undefined ||
                this._writableState === undefined
              ) {
                return;
              } // backward compatibility, the user is explicitly
              // managing destroyed
              this._readableState.destroyed = value;
              this._writableState.destroyed = value;
            }
          });
        },
        {
          process: "ec0e1432c6522aad9b4b16c4b3b080f4",
          "./_stream_readable": "c37d344d12758e7cd78c45f7416b586b",
          "./_stream_writable": "855d7632df7e6abfe3f768de89c31cba",
          inherits: "cd61047e9289e4b62768390878fc0b01"
        }
      ],
      "855d7632df7e6abfe3f768de89c31cba": [
        function (require, module, exports) {
          // Copyright Joyent, Inc. and other Node contributors.
          //
          // Permission is hereby granted, free of charge, to any person obtaining a
          // copy of this software and associated documentation files (the
          // "Software"), to deal in the Software without restriction, including
          // without limitation the rights to use, copy, modify, merge, publish,
          // distribute, sublicense, and/or sell copies of the Software, and to permit
          // persons to whom the Software is furnished to do so, subject to the
          // following conditions:
          //
          // The above copyright notice and this permission notice shall be included
          // in all copies or substantial portions of the Software.
          //
          // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
          // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
          // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
          // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
          // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
          // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
          // USE OR OTHER DEALINGS IN THE SOFTWARE.
          // A bit simpler than readable streams.
          // Implement an async ._write(chunk, encoding, cb), and it'll handle all
          // the drain event emission and buffering.
          "use strict";
          var global = arguments[3];
          var process = require("process");
          module.exports = Writable;
          /* <replacement> */ function WriteReq(chunk, encoding, cb) {
            this.chunk = chunk;
            this.encoding = encoding;
            this.callback = cb;
            this.next = null;
          } // It seems a linked list but it is not
          // there will be only 2 of these for each stream
          function CorkedRequest(state) {
            var _this = this;
            this.next = null;
            this.entry = null;
            this.finish = function () {
              onCorkedFinish(_this, state);
            };
          }
          /* </replacement> */ /*<replacement>*/ var Duplex;
          /*</replacement>*/ Writable.WritableState = WritableState;
          /*<replacement>*/ var internalUtil = {
            deprecate: require("util-deprecate")
          };
          /*</replacement>*/ /*<replacement>*/ var Stream = require("./internal/streams/stream");
          /*</replacement>*/ var Buffer = require("buffer").Buffer;
          var OurUint8Array = global.Uint8Array || function () {};
          function _uint8ArrayToBuffer(chunk) {
            return Buffer.from(chunk);
          }
          function _isUint8Array(obj) {
            return Buffer.isBuffer(obj) || _instanceof(obj, OurUint8Array);
          }
          var destroyImpl = require("./internal/streams/destroy");
          var _require = require("./internal/streams/state"),
            getHighWaterMark = _require.getHighWaterMark;
          var _require$codes = require("../errors").codes,
            ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
            ERR_METHOD_NOT_IMPLEMENTED =
              _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
            ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
            ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
            ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
            ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
            ERR_STREAM_WRITE_AFTER_END =
              _require$codes.ERR_STREAM_WRITE_AFTER_END,
            ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
          var errorOrDestroy = destroyImpl.errorOrDestroy;
          require("inherits")(Writable, Stream);
          function nop() {}
          function WritableState(options, stream, isDuplex) {
            Duplex = Duplex || require("./_stream_duplex");
            options = options || {}; // Duplex streams are both readable and writable, but share
            // the same options object.
            // However, some cases require setting options to different
            // values for the readable and the writable sides of the duplex stream,
            // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
            if (typeof isDuplex !== "boolean")
              isDuplex = _instanceof(stream, Duplex); // object stream flag to indicate whether or not this stream
            // contains buffers or objects.
            this.objectMode = !!options.objectMode;
            if (isDuplex)
              this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
            // Note: 0 is a valid value, means that we always return false if
            // the entire buffer is not flushed immediately on write()
            this.highWaterMark = getHighWaterMark(
              this,
              options,
              "writableHighWaterMark",
              isDuplex
            ); // if _final has been called
            this.finalCalled = false; // drain event flag.
            this.needDrain = false; // at the start of calling end()
            this.ending = false; // when end() has been called, and returned
            this.ended = false; // when 'finish' is emitted
            this.finished = false; // has it been destroyed
            this.destroyed = false; // should we decode strings into buffers before passing to _write?
            // this is here so that some node-core streams can optimize string
            // handling at a lower level.
            var noDecode = options.decodeStrings === false;
            this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
            // encoding is 'binary' so we have to make this configurable.
            // Everything else in the universe uses 'utf8', though.
            this.defaultEncoding = options.defaultEncoding || "utf8"; // not an actual buffer we keep track of, but a measurement
            // of how much we're waiting to get pushed to some underlying
            // socket or file.
            this.length = 0; // a flag to see when we're in the middle of a write.
            this.writing = false; // when true all writes will be buffered until .uncork() call
            this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
            // or on a later tick.  We set this to true at first, because any
            // actions that shouldn't happen until "later" should generally also
            // not happen before the first write call.
            this.sync = true; // a flag to know if we're processing previously buffered items, which
            // may call the _write() callback in the same tick, so that we don't
            // end up in an overlapped onwrite situation.
            this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)
            this.onwrite = function (er) {
              onwrite(stream, er);
            }; // the callback that the user supplies to write(chunk,encoding,cb)
            this.writecb = null; // the amount that is being written when _write is called.
            this.writelen = 0;
            this.bufferedRequest = null;
            this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
            // this must be 0 before 'finish' can be emitted
            this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
            // This is relevant for synchronous Transform streams
            this.prefinished = false; // True if the error was already emitted and should not be thrown again
            this.errorEmitted = false; // Should close be emitted on destroy. Defaults to true.
            this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'finish' (and potentially 'end')
            this.autoDestroy = !!options.autoDestroy; // count buffered requests
            this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
            // one allocated and free to use, and we maintain at most two
            this.corkedRequestsFree = new CorkedRequest(this);
          }
          WritableState.prototype.getBuffer = function getBuffer() {
            var current = this.bufferedRequest;
            var out = [];
            while (current) {
              out.push(current);
              current = current.next;
            }
            return out;
          };
          (function () {
            try {
              Object.defineProperty(WritableState.prototype, "buffer", {
                get: internalUtil.deprecate(
                  function writableStateBufferGetter() {
                    return this.getBuffer();
                  },
                  "_writableState.buffer is deprecated. Use _writableState.getBuffer " +
                    "instead.",
                  "DEP0003"
                )
              });
            } catch (_) {}
          })(); // Test _writableState for inheritance to account for Duplex streams,
          // whose prototype chain only points to Readable.
          var realHasInstance;
          if (
            typeof Symbol === "function" &&
            Symbol.hasInstance &&
            typeof Function.prototype[Symbol.hasInstance] === "function"
          ) {
            realHasInstance = Function.prototype[Symbol.hasInstance];
            Object.defineProperty(Writable, Symbol.hasInstance, {
              value: function value(object) {
                if (realHasInstance.call(this, object)) return true;
                if (this !== Writable) return false;
                return (
                  object && _instanceof(object._writableState, WritableState)
                );
              }
            });
          } else {
            realHasInstance = function realHasInstance(object) {
              return _instanceof(object, this);
            };
          }
          function Writable(options) {
            Duplex = Duplex || require("./_stream_duplex"); // Writable ctor is applied to Duplexes, too.
            // `realHasInstance` is necessary because using plain `instanceof`
            // would return false, as no `_writableState` property is attached.
            // Trying to use the custom `instanceof` for Writable here will also break the
            // Node.js LazyTransform implementation, which has a non-trivial getter for
            // `_writableState` that would lead to infinite recursion.
            // Checking for a Stream.Duplex instance is faster here instead of inside
            // the WritableState constructor, at least with V8 6.5
            var isDuplex = _instanceof(this, Duplex);
            if (!isDuplex && !realHasInstance.call(Writable, this))
              return new Writable(options);
            this._writableState = new WritableState(options, this, isDuplex); // legacy.
            this.writable = true;
            if (options) {
              if (typeof options.write === "function")
                this._write = options.write;
              if (typeof options.writev === "function")
                this._writev = options.writev;
              if (typeof options.destroy === "function")
                this._destroy = options.destroy;
              if (typeof options.final === "function")
                this._final = options.final;
            }
            Stream.call(this);
          } // Otherwise people can pipe Writable streams, which is just wrong.
          Writable.prototype.pipe = function () {
            errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
          };
          function writeAfterEnd(stream, cb) {
            var er = new ERR_STREAM_WRITE_AFTER_END(); // TODO: defer error events consistently everywhere, not just the cb
            errorOrDestroy(stream, er);
            process.nextTick(cb, er);
          } // Checks that a user-supplied chunk is valid, especially for the particular
          // mode the stream is in. Currently this means that `null` is never accepted
          // and undefined/non-string values are only allowed in object mode.
          function validChunk(stream, state, chunk, cb) {
            var er;
            if (chunk === null) {
              er = new ERR_STREAM_NULL_VALUES();
            } else if (typeof chunk !== "string" && !state.objectMode) {
              er = new ERR_INVALID_ARG_TYPE("chunk", ["string", "Buffer"], chunk);
            }
            if (er) {
              errorOrDestroy(stream, er);
              process.nextTick(cb, er);
              return false;
            }
            return true;
          }
          Writable.prototype.write = function (chunk, encoding, cb) {
            var state = this._writableState;
            var ret = false;
            var isBuf = !state.objectMode && _isUint8Array(chunk);
            if (isBuf && !Buffer.isBuffer(chunk)) {
              chunk = _uint8ArrayToBuffer(chunk);
            }
            if (typeof encoding === "function") {
              cb = encoding;
              encoding = null;
            }
            if (isBuf) encoding = "buffer";
            else if (!encoding) encoding = state.defaultEncoding;
            if (typeof cb !== "function") cb = nop;
            if (state.ending) writeAfterEnd(this, cb);
            else if (isBuf || validChunk(this, state, chunk, cb)) {
              state.pendingcb++;
              ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
            }
            return ret;
          };
          Writable.prototype.cork = function () {
            this._writableState.corked++;
          };
          Writable.prototype.uncork = function () {
            var state = this._writableState;
            if (state.corked) {
              state.corked--;
              if (
                !state.writing &&
                !state.corked &&
                !state.bufferProcessing &&
                state.bufferedRequest
              )
                clearBuffer(this, state);
            }
          };
          Writable.prototype.setDefaultEncoding = function setDefaultEncoding(
            encoding
          ) {
            // node::ParseEncoding() requires lower case.
            if (typeof encoding === "string") encoding = encoding.toLowerCase();
            if (
              !(
                [
                  "hex",
                  "utf8",
                  "utf-8",
                  "ascii",
                  "binary",
                  "base64",
                  "ucs2",
                  "ucs-2",
                  "utf16le",
                  "utf-16le",
                  "raw"
                ].indexOf((encoding + "").toLowerCase()) > -1
              )
            )
              throw new ERR_UNKNOWN_ENCODING(encoding);
            this._writableState.defaultEncoding = encoding;
            return this;
          };
          Object.defineProperty(Writable.prototype, "writableBuffer", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._writableState && this._writableState.getBuffer();
            }
          });
          function decodeChunk(state, chunk, encoding) {
            if (
              !state.objectMode &&
              state.decodeStrings !== false &&
              typeof chunk === "string"
            ) {
              chunk = Buffer.from(chunk, encoding);
            }
            return chunk;
          }
          Object.defineProperty(Writable.prototype, "writableHighWaterMark", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._writableState.highWaterMark;
            }
          }); // if we're already writing something, then just put this
          // in the queue, and wait our turn.  Otherwise, call _write
          // If we return false, then we need a drain event, so set that flag.
          function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
            if (!isBuf) {
              var newChunk = decodeChunk(state, chunk, encoding);
              if (chunk !== newChunk) {
                isBuf = true;
                encoding = "buffer";
                chunk = newChunk;
              }
            }
            var len = state.objectMode ? 1 : chunk.length;
            state.length += len;
            var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.
            if (!ret) state.needDrain = true;
            if (state.writing || state.corked) {
              var last = state.lastBufferedRequest;
              state.lastBufferedRequest = {
                chunk: chunk,
                encoding: encoding,
                isBuf: isBuf,
                callback: cb,
                next: null
              };
              if (last) {
                last.next = state.lastBufferedRequest;
              } else {
                state.bufferedRequest = state.lastBufferedRequest;
              }
              state.bufferedRequestCount += 1;
            } else {
              doWrite(stream, state, false, len, chunk, encoding, cb);
            }
            return ret;
          }
          function doWrite(stream, state, writev, len, chunk, encoding, cb) {
            state.writelen = len;
            state.writecb = cb;
            state.writing = true;
            state.sync = true;
            if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED("write"));
            else if (writev) stream._writev(chunk, state.onwrite);
            else stream._write(chunk, encoding, state.onwrite);
            state.sync = false;
          }
          function onwriteError(stream, state, sync, er, cb) {
            --state.pendingcb;
            if (sync) {
              // defer the callback if we are being called synchronously
              // to avoid piling up things on the stack
              process.nextTick(cb, er); // this can emit finish, and it will always happen
              // after error
              process.nextTick(finishMaybe, stream, state);
              stream._writableState.errorEmitted = true;
              errorOrDestroy(stream, er);
            } else {
              // the caller expect this to happen before if
              // it is async
              cb(er);
              stream._writableState.errorEmitted = true;
              errorOrDestroy(stream, er); // this can emit finish, but finish must
              // always follow error
              finishMaybe(stream, state);
            }
          }
          function onwriteStateUpdate(state) {
            state.writing = false;
            state.writecb = null;
            state.length -= state.writelen;
            state.writelen = 0;
          }
          function onwrite(stream, er) {
            var state = stream._writableState;
            var sync = state.sync;
            var cb = state.writecb;
            if (typeof cb !== "function") throw new ERR_MULTIPLE_CALLBACK();
            onwriteStateUpdate(state);
            if (er) onwriteError(stream, state, sync, er, cb);
            else {
              // Check if we're actually ready to finish, but don't emit yet
              var finished = needFinish(state) || stream.destroyed;
              if (
                !finished &&
                !state.corked &&
                !state.bufferProcessing &&
                state.bufferedRequest
              ) {
                clearBuffer(stream, state);
              }
              if (sync) {
                process.nextTick(afterWrite, stream, state, finished, cb);
              } else {
                afterWrite(stream, state, finished, cb);
              }
            }
          }
          function afterWrite(stream, state, finished, cb) {
            if (!finished) onwriteDrain(stream, state);
            state.pendingcb--;
            cb();
            finishMaybe(stream, state);
          } // Must force callback to be called on nextTick, so that we don't
          // emit 'drain' before the write() consumer gets the 'false' return
          // value, and has a chance to attach a 'drain' listener.
          function onwriteDrain(stream, state) {
            if (state.length === 0 && state.needDrain) {
              state.needDrain = false;
              stream.emit("drain");
            }
          } // if there's something in the buffer waiting, then process it
          function clearBuffer(stream, state) {
            state.bufferProcessing = true;
            var entry = state.bufferedRequest;
            if (stream._writev && entry && entry.next) {
              // Fast case, write everything using _writev()
              var l = state.bufferedRequestCount;
              var buffer = new Array(l);
              var holder = state.corkedRequestsFree;
              holder.entry = entry;
              var count = 0;
              var allBuffers = true;
              while (entry) {
                buffer[count] = entry;
                if (!entry.isBuf) allBuffers = false;
                entry = entry.next;
                count += 1;
              }
              buffer.allBuffers = allBuffers;
              doWrite(
                stream,
                state,
                true,
                state.length,
                buffer,
                "",
                holder.finish
              ); // doWrite is almost always async, defer these to save a bit of time
              // as the hot path ends with doWrite
              state.pendingcb++;
              state.lastBufferedRequest = null;
              if (holder.next) {
                state.corkedRequestsFree = holder.next;
                holder.next = null;
              } else {
                state.corkedRequestsFree = new CorkedRequest(state);
              }
              state.bufferedRequestCount = 0;
            } else {
              // Slow case, write chunks one-by-one
              while (entry) {
                var chunk = entry.chunk;
                var encoding = entry.encoding;
                var cb = entry.callback;
                var len = state.objectMode ? 1 : chunk.length;
                doWrite(stream, state, false, len, chunk, encoding, cb);
                entry = entry.next;
                state.bufferedRequestCount--; // if we didn't call the onwrite immediately, then
                // it means that we need to wait until it does.
                // also, that means that the chunk and cb are currently
                // being processed, so move the buffer counter past them.
                if (state.writing) {
                  break;
                }
              }
              if (entry === null) state.lastBufferedRequest = null;
            }
            state.bufferedRequest = entry;
            state.bufferProcessing = false;
          }
          Writable.prototype._write = function (chunk, encoding, cb) {
            cb(new ERR_METHOD_NOT_IMPLEMENTED("_write()"));
          };
          Writable.prototype._writev = null;
          Writable.prototype.end = function (chunk, encoding, cb) {
            var state = this._writableState;
            if (typeof chunk === "function") {
              cb = chunk;
              chunk = null;
              encoding = null;
            } else if (typeof encoding === "function") {
              cb = encoding;
              encoding = null;
            }
            if (chunk !== null && chunk !== undefined)
              this.write(chunk, encoding); // .end() fully uncorks
            if (state.corked) {
              state.corked = 1;
              this.uncork();
            } // ignore unnecessary end() calls.
            if (!state.ending) endWritable(this, state, cb);
            return this;
          };
          Object.defineProperty(Writable.prototype, "writableLength", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._writableState.length;
            }
          });
          function needFinish(state) {
            return (
              state.ending &&
              state.length === 0 &&
              state.bufferedRequest === null &&
              !state.finished &&
              !state.writing
            );
          }
          function callFinal(stream, state) {
            stream._final(function (err) {
              state.pendingcb--;
              if (err) {
                errorOrDestroy(stream, err);
              }
              state.prefinished = true;
              stream.emit("prefinish");
              finishMaybe(stream, state);
            });
          }
          function prefinish(stream, state) {
            if (!state.prefinished && !state.finalCalled) {
              if (typeof stream._final === "function" && !state.destroyed) {
                state.pendingcb++;
                state.finalCalled = true;
                process.nextTick(callFinal, stream, state);
              } else {
                state.prefinished = true;
                stream.emit("prefinish");
              }
            }
          }
          function finishMaybe(stream, state) {
            var need = needFinish(state);
            if (need) {
              prefinish(stream, state);
              if (state.pendingcb === 0) {
                state.finished = true;
                stream.emit("finish");
                if (state.autoDestroy) {
                  // In case of duplex streams we need a way to detect
                  // if the readable side is ready for autoDestroy as well
                  var rState = stream._readableState;
                  if (!rState || (rState.autoDestroy && rState.endEmitted)) {
                    stream.destroy();
                  }
                }
              }
            }
            return need;
          }
          function endWritable(stream, state, cb) {
            state.ending = true;
            finishMaybe(stream, state);
            if (cb) {
              if (state.finished) process.nextTick(cb);
              else stream.once("finish", cb);
            }
            state.ended = true;
            stream.writable = false;
          }
          function onCorkedFinish(corkReq, state, err) {
            var entry = corkReq.entry;
            corkReq.entry = null;
            while (entry) {
              var cb = entry.callback;
              state.pendingcb--;
              cb(err);
              entry = entry.next;
            } // reuse the free corkReq.
            state.corkedRequestsFree.next = corkReq;
          }
          Object.defineProperty(Writable.prototype, "destroyed", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              if (this._writableState === undefined) {
                return false;
              }
              return this._writableState.destroyed;
            },
            set: function set(value) {
              // we ignore the value if the stream
              // has not been initialized yet
              if (!this._writableState) {
                return;
              } // backward compatibility, the user is explicitly
              // managing destroyed
              this._writableState.destroyed = value;
            }
          });
          Writable.prototype.destroy = destroyImpl.destroy;
          Writable.prototype._undestroy = destroyImpl.undestroy;
          Writable.prototype._destroy = function (err, cb) {
            cb(err);
          };
        },
        {
          process: "ec0e1432c6522aad9b4b16c4b3b080f4",
          "util-deprecate": "5f8dbc3fac2a63760c835261ada7becd",
          "./internal/streams/stream": "c50b17c9da9608e14ed0bdff3989a7e3",
          buffer: "1948b2a05a083f82087512f711e79e4d",
          "./internal/streams/destroy": "608647b45545cc3cc150ba420eae74b3",
          "./internal/streams/state": "40b1422fe5ffbedd93cdedf2dafc4729",
          "../errors": "9e8b965127778a5bef42160d55499ba5",
          inherits: "cd61047e9289e4b62768390878fc0b01",
          "./_stream_duplex": "697a6b37b3553e220776ac06dc162ff3"
        }
      ],
      "5f8dbc3fac2a63760c835261ada7becd": [
        function (require, module, exports) {
          var global = arguments[3];
          /**
           * Module exports.
           */ module.exports = deprecate;
          /**
           * Mark that a method should not be used.
           * Returns a modified function which warns once by default.
           *
           * If `localStorage.noDeprecation = true` is set, then it is a no-op.
           *
           * If `localStorage.throwDeprecation = true` is set, then deprecated functions
           * will throw an Error when invoked.
           *
           * If `localStorage.traceDeprecation = true` is set, then deprecated functions
           * will invoke `console.trace()` instead of `console.error()`.
           *
           * @param {Function} fn - the function to deprecate
           * @param {String} msg - the string to print to the console when `fn` is invoked
           * @returns {Function} a new "deprecated" version of `fn`
           * @api public
           */ function deprecate(fn, msg) {
            if (config("noDeprecation")) {
              return fn;
            }
            var warned = false;
            function deprecated() {
              if (!warned) {
                if (config("throwDeprecation")) {
                  throw new Error(msg);
                } else if (config("traceDeprecation")) {
                  console.trace(msg);
                } else {
                  console.warn(msg);
                }
                warned = true;
              }
              return fn.apply(this, arguments);
            }
            return deprecated;
          }
          /**
           * Checks `localStorage` for boolean values for the given `name`.
           *
           * @param {String} name
           * @returns {Boolean}
           * @api private
           */ function config(name) {
            // accessing global.localStorage can trigger a DOMException in sandboxed iframes
            try {
              if (!global.localStorage) return false;
            } catch (_) {
              return false;
            }
            var val = global.localStorage[name];
            if (null == val) return false;
            return String(val).toLowerCase() === "true";
          }
        },
        {}
      ],
      "638172f07d088eb6b6073fec0c6138fc": [
        function (require, module, exports) {
          // Copyright Joyent, Inc. and other Node contributors.
          //
          // Permission is hereby granted, free of charge, to any person obtaining a
          // copy of this software and associated documentation files (the
          // "Software"), to deal in the Software without restriction, including
          // without limitation the rights to use, copy, modify, merge, publish,
          // distribute, sublicense, and/or sell copies of the Software, and to permit
          // persons to whom the Software is furnished to do so, subject to the
          // following conditions:
          //
          // The above copyright notice and this permission notice shall be included
          // in all copies or substantial portions of the Software.
          //
          // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
          // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
          // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
          // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
          // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
          // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
          // USE OR OTHER DEALINGS IN THE SOFTWARE.
          "use strict";
          /*<replacement>*/ var Buffer = require("safe-buffer").Buffer;
          /*</replacement>*/ var isEncoding =
            Buffer.isEncoding ||
            function (encoding) {
              encoding = "" + encoding;
              switch (encoding && encoding.toLowerCase()) {
                case "hex":
                case "utf8":
                case "utf-8":
                case "ascii":
                case "binary":
                case "base64":
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                case "raw":
                  return true;
                default:
                  return false;
              }
            };
          function _normalizeEncoding(enc) {
            if (!enc) return "utf8";
            var retried;
            while (true) {
              switch (enc) {
                case "utf8":
                case "utf-8":
                  return "utf8";
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return "utf16le";
                case "latin1":
                case "binary":
                  return "latin1";
                case "base64":
                case "ascii":
                case "hex":
                  return enc;
                default:
                  if (retried) return; // undefined
                  enc = ("" + enc).toLowerCase();
                  retried = true;
              }
            }
          } // Do not cache `Buffer.isEncoding` when checking encoding names as some
          // modules monkey-patch it to support additional encodings
          function normalizeEncoding(enc) {
            var nenc = _normalizeEncoding(enc);
            if (
              typeof nenc !== "string" &&
              (Buffer.isEncoding === isEncoding || !isEncoding(enc))
            )
              throw new Error("Unknown encoding: " + enc);
            return nenc || enc;
          } // StringDecoder provides an interface for efficiently splitting a series of
          // buffers into a series of JS strings without breaking apart multi-byte
          // characters.
          exports.StringDecoder = StringDecoder;
          function StringDecoder(encoding) {
            this.encoding = normalizeEncoding(encoding);
            var nb;
            switch (this.encoding) {
              case "utf16le":
                this.text = utf16Text;
                this.end = utf16End;
                nb = 4;
                break;
              case "utf8":
                this.fillLast = utf8FillLast;
                nb = 4;
                break;
              case "base64":
                this.text = base64Text;
                this.end = base64End;
                nb = 3;
                break;
              default:
                this.write = simpleWrite;
                this.end = simpleEnd;
                return;
            }
            this.lastNeed = 0;
            this.lastTotal = 0;
            this.lastChar = Buffer.allocUnsafe(nb);
          }
          StringDecoder.prototype.write = function (buf) {
            if (buf.length === 0) return "";
            var r;
            var i;
            if (this.lastNeed) {
              r = this.fillLast(buf);
              if (r === undefined) return "";
              i = this.lastNeed;
              this.lastNeed = 0;
            } else {
              i = 0;
            }
            if (i < buf.length)
              return r ? r + this.text(buf, i) : this.text(buf, i);
            return r || "";
          };
          StringDecoder.prototype.end = utf8End; // Returns only complete characters in a Buffer
          StringDecoder.prototype.text = utf8Text; // Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
          StringDecoder.prototype.fillLast = function (buf) {
            if (this.lastNeed <= buf.length) {
              buf.copy(
                this.lastChar,
                this.lastTotal - this.lastNeed,
                0,
                this.lastNeed
              );
              return this.lastChar.toString(this.encoding, 0, this.lastTotal);
            }
            buf.copy(
              this.lastChar,
              this.lastTotal - this.lastNeed,
              0,
              buf.length
            );
            this.lastNeed -= buf.length;
          }; // Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
          // continuation byte. If an invalid byte is detected, -2 is returned.
          function utf8CheckByte(byte) {
            if (byte <= 0x7f) return 0;
            else if (byte >> 5 === 0x06) return 2;
            else if (byte >> 4 === 0x0e) return 3;
            else if (byte >> 3 === 0x1e) return 4;
            return byte >> 6 === 0x02 ? -1 : -2;
          } // Checks at most 3 bytes at the end of a Buffer in order to detect an
          // incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
          // needed to complete the UTF-8 character (if applicable) are returned.
          function utf8CheckIncomplete(self, buf, i) {
            var j = buf.length - 1;
            if (j < i) return 0;
            var nb = utf8CheckByte(buf[j]);
            if (nb >= 0) {
              if (nb > 0) self.lastNeed = nb - 1;
              return nb;
            }
            if (--j < i || nb === -2) return 0;
            nb = utf8CheckByte(buf[j]);
            if (nb >= 0) {
              if (nb > 0) self.lastNeed = nb - 2;
              return nb;
            }
            if (--j < i || nb === -2) return 0;
            nb = utf8CheckByte(buf[j]);
            if (nb >= 0) {
              if (nb > 0) {
                if (nb === 2) nb = 0;
                else self.lastNeed = nb - 3;
              }
              return nb;
            }
            return 0;
          } // Validates as many continuation bytes for a multi-byte UTF-8 character as
          // needed or are available. If we see a non-continuation byte where we expect
          // one, we "replace" the validated continuation bytes we've seen so far with
          // a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
          // behavior. The continuation byte check is included three times in the case
          // where all of the continuation bytes for a character exist in the same buffer.
          // It is also done this way as a slight performance increase instead of using a
          // loop.
          function utf8CheckExtraBytes(self, buf, p) {
            if ((buf[0] & 0xc0) !== 0x80) {
              self.lastNeed = 0;
              return "\uFFFD";
            }
            if (self.lastNeed > 1 && buf.length > 1) {
              if ((buf[1] & 0xc0) !== 0x80) {
                self.lastNeed = 1;
                return "\uFFFD";
              }
              if (self.lastNeed > 2 && buf.length > 2) {
                if ((buf[2] & 0xc0) !== 0x80) {
                  self.lastNeed = 2;
                  return "\uFFFD";
                }
              }
            }
          } // Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
          function utf8FillLast(buf) {
            var p = this.lastTotal - this.lastNeed;
            var r = utf8CheckExtraBytes(this, buf, p);
            if (r !== undefined) return r;
            if (this.lastNeed <= buf.length) {
              buf.copy(this.lastChar, p, 0, this.lastNeed);
              return this.lastChar.toString(this.encoding, 0, this.lastTotal);
            }
            buf.copy(this.lastChar, p, 0, buf.length);
            this.lastNeed -= buf.length;
          } // Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
          // partial character, the character's bytes are buffered until the required
          // number of bytes are available.
          function utf8Text(buf, i) {
            var total = utf8CheckIncomplete(this, buf, i);
            if (!this.lastNeed) return buf.toString("utf8", i);
            this.lastTotal = total;
            var end = buf.length - (total - this.lastNeed);
            buf.copy(this.lastChar, 0, end);
            return buf.toString("utf8", i, end);
          } // For UTF-8, a replacement character is added when ending on a partial
          // character.
          function utf8End(buf) {
            var r = buf && buf.length ? this.write(buf) : "";
            if (this.lastNeed) return r + "\uFFFD";
            return r;
          } // UTF-16LE typically needs two bytes per character, but even if we have an even
          // number of bytes available, we need to check if we end on a leading/high
          // surrogate. In that case, we need to wait for the next two bytes in order to
          // decode the last character properly.
          function utf16Text(buf, i) {
            if ((buf.length - i) % 2 === 0) {
              var r = buf.toString("utf16le", i);
              if (r) {
                var c = r.charCodeAt(r.length - 1);
                if (c >= 0xd800 && c <= 0xdbff) {
                  this.lastNeed = 2;
                  this.lastTotal = 4;
                  this.lastChar[0] = buf[buf.length - 2];
                  this.lastChar[1] = buf[buf.length - 1];
                  return r.slice(0, -1);
                }
              }
              return r;
            }
            this.lastNeed = 1;
            this.lastTotal = 2;
            this.lastChar[0] = buf[buf.length - 1];
            return buf.toString("utf16le", i, buf.length - 1);
          } // For UTF-16LE we do not explicitly append special replacement characters if we
          // end on a partial character, we simply let v8 handle that.
          function utf16End(buf) {
            var r = buf && buf.length ? this.write(buf) : "";
            if (this.lastNeed) {
              var end = this.lastTotal - this.lastNeed;
              return r + this.lastChar.toString("utf16le", 0, end);
            }
            return r;
          }
          function base64Text(buf, i) {
            var n = (buf.length - i) % 3;
            if (n === 0) return buf.toString("base64", i);
            this.lastNeed = 3 - n;
            this.lastTotal = 3;
            if (n === 1) {
              this.lastChar[0] = buf[buf.length - 1];
            } else {
              this.lastChar[0] = buf[buf.length - 2];
              this.lastChar[1] = buf[buf.length - 1];
            }
            return buf.toString("base64", i, buf.length - n);
          }
          function base64End(buf) {
            var r = buf && buf.length ? this.write(buf) : "";
            if (this.lastNeed)
              return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
            return r;
          } // Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
          function simpleWrite(buf) {
            return buf.toString(this.encoding);
          }
          function simpleEnd(buf) {
            return buf && buf.length ? this.write(buf) : "";
          }
        },
        { "safe-buffer": "4e0959a531d73b3690537fbc38856961" }
      ],
      "7f48ac4879062fde46442a5cd4917d19": [
        function (require, module, exports) {
          "use strict";
          var process = require("process");
          var _Object$setPrototypeO;
          function _defineProperty(obj, key, value) {
            if (key in obj) {
              Object.defineProperty(obj, key, {
                value: value,
                enumerable: true,
                configurable: true,
                writable: true
              });
            } else {
              obj[key] = value;
            }
            return obj;
          }
          var finished = require("./end-of-stream");
          var kLastResolve = Symbol("lastResolve");
          var kLastReject = Symbol("lastReject");
          var kError = Symbol("error");
          var kEnded = Symbol("ended");
          var kLastPromise = Symbol("lastPromise");
          var kHandlePromise = Symbol("handlePromise");
          var kStream = Symbol("stream");
          function createIterResult(value, done) {
            return { value: value, done: done };
          }
          function readAndResolve(iter) {
            var resolve = iter[kLastResolve];
            if (resolve !== null) {
              var data = iter[kStream].read(); // we defer if data is null
              // we can be expecting either 'end' or
              // 'error'
              if (data !== null) {
                iter[kLastPromise] = null;
                iter[kLastResolve] = null;
                iter[kLastReject] = null;
                resolve(createIterResult(data, false));
              }
            }
          }
          function onReadable(iter) {
            // we wait for the next tick, because it might
            // emit an error with process.nextTick
            process.nextTick(readAndResolve, iter);
          }
          function wrapForNext(lastPromise, iter) {
            return function (resolve, reject) {
              lastPromise.then(function () {
                if (iter[kEnded]) {
                  resolve(createIterResult(undefined, true));
                  return;
                }
                iter[kHandlePromise](resolve, reject);
              }, reject);
            };
          }
          var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
          var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(
            ((_Object$setPrototypeO = {
              get stream() {
                return this[kStream];
              },
              next: function next() {
                var _this = this; // if we have detected an error in the meanwhile
                // reject straight away
                var error = this[kError];
                if (error !== null) {
                  return Promise.reject(error);
                }
                if (this[kEnded]) {
                  return Promise.resolve(createIterResult(undefined, true));
                }
                if (this[kStream].destroyed) {
                  // We need to defer via nextTick because if .destroy(err) is
                  // called, the error will be emitted via nextTick, and
                  // we cannot guarantee that there is no error lingering around
                  // waiting to be emitted.
                  return new Promise(function (resolve, reject) {
                    process.nextTick(function () {
                      if (_this[kError]) {
                        reject(_this[kError]);
                      } else {
                        resolve(createIterResult(undefined, true));
                      }
                    });
                  });
                } // if we have multiple next() calls
                // we will wait for the previous Promise to finish
                // this logic is optimized to support for await loops,
                // where next() is only called once at a time
                var lastPromise = this[kLastPromise];
                var promise;
                if (lastPromise) {
                  promise = new Promise(wrapForNext(lastPromise, this));
                } else {
                  // fast path needed to support multiple this.push()
                  // without triggering the next() queue
                  var data = this[kStream].read();
                  if (data !== null) {
                    return Promise.resolve(createIterResult(data, false));
                  }
                  promise = new Promise(this[kHandlePromise]);
                }
                this[kLastPromise] = promise;
                return promise;
              }
            }),
            _defineProperty(
              _Object$setPrototypeO,
              Symbol.asyncIterator,
              function () {
                return this;
              }
            ),
            _defineProperty(_Object$setPrototypeO, "return", function _return() {
              var _this2 = this; // destroy(err, cb) is a private API
              // we can guarantee we have that here, because we control the
              // Readable class this is attached to
              return new Promise(function (resolve, reject) {
                _this2[kStream].destroy(null, function (err) {
                  if (err) {
                    reject(err);
                    return;
                  }
                  resolve(createIterResult(undefined, true));
                });
              });
            }),
            _Object$setPrototypeO),
            AsyncIteratorPrototype
          );
          var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(
            stream
          ) {
            var _Object$create;
            var iterator = Object.create(
              ReadableStreamAsyncIteratorPrototype,
              ((_Object$create = {}),
              _defineProperty(_Object$create, kStream, {
                value: stream,
                writable: true
              }),
              _defineProperty(_Object$create, kLastResolve, {
                value: null,
                writable: true
              }),
              _defineProperty(_Object$create, kLastReject, {
                value: null,
                writable: true
              }),
              _defineProperty(_Object$create, kError, {
                value: null,
                writable: true
              }),
              _defineProperty(_Object$create, kEnded, {
                value: stream._readableState.endEmitted,
                writable: true
              }),
              _defineProperty(_Object$create, kHandlePromise, {
                value: function value(resolve, reject) {
                  var data = iterator[kStream].read();
                  if (data) {
                    iterator[kLastPromise] = null;
                    iterator[kLastResolve] = null;
                    iterator[kLastReject] = null;
                    resolve(createIterResult(data, false));
                  } else {
                    iterator[kLastResolve] = resolve;
                    iterator[kLastReject] = reject;
                  }
                },
                writable: true
              }),
              _Object$create)
            );
            iterator[kLastPromise] = null;
            finished(stream, function (err) {
              if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
                var reject = iterator[kLastReject]; // reject if we are waiting for data in the Promise
                // returned by next() and store the error
                if (reject !== null) {
                  iterator[kLastPromise] = null;
                  iterator[kLastResolve] = null;
                  iterator[kLastReject] = null;
                  reject(err);
                }
                iterator[kError] = err;
                return;
              }
              var resolve = iterator[kLastResolve];
              if (resolve !== null) {
                iterator[kLastPromise] = null;
                iterator[kLastResolve] = null;
                iterator[kLastReject] = null;
                resolve(createIterResult(undefined, true));
              }
              iterator[kEnded] = true;
            });
            stream.on("readable", onReadable.bind(null, iterator));
            return iterator;
          };
          module.exports = createReadableStreamAsyncIterator;
        },
        {
          process: "ec0e1432c6522aad9b4b16c4b3b080f4",
          "./end-of-stream": "9cf0302cde5d6261ef306b6ba09b954d"
        }
      ],
      "9cf0302cde5d6261ef306b6ba09b954d": [
        function (require, module, exports) {
          // Ported from https://github.com/mafintosh/end-of-stream with
          // permission from the author, Mathias Buus (@mafintosh).
          "use strict";
          var ERR_STREAM_PREMATURE_CLOSE = require("../../../errors").codes
            .ERR_STREAM_PREMATURE_CLOSE;
          function once(callback) {
            var called = false;
            return function () {
              if (called) return;
              called = true;
              for (
                var _len = arguments.length, args = new Array(_len), _key = 0;
                _key < _len;
                _key++
              ) {
                args[_key] = arguments[_key];
              }
              callback.apply(this, args);
            };
          }
          function noop() {}
          function isRequest(stream) {
            return stream.setHeader && typeof stream.abort === "function";
          }
          function eos(stream, opts, callback) {
            if (typeof opts === "function") return eos(stream, null, opts);
            if (!opts) opts = {};
            callback = once(callback || noop);
            var readable =
              opts.readable || (opts.readable !== false && stream.readable);
            var writable =
              opts.writable || (opts.writable !== false && stream.writable);
            var onlegacyfinish = function onlegacyfinish() {
              if (!stream.writable) onfinish();
            };
            var writableEnded =
              stream._writableState && stream._writableState.finished;
            var onfinish = function onfinish() {
              writable = false;
              writableEnded = true;
              if (!readable) callback.call(stream);
            };
            var readableEnded =
              stream._readableState && stream._readableState.endEmitted;
            var onend = function onend() {
              readable = false;
              readableEnded = true;
              if (!writable) callback.call(stream);
            };
            var onerror = function onerror(err) {
              callback.call(stream, err);
            };
            var onclose = function onclose() {
              var err;
              if (readable && !readableEnded) {
                if (!stream._readableState || !stream._readableState.ended)
                  err = new ERR_STREAM_PREMATURE_CLOSE();
                return callback.call(stream, err);
              }
              if (writable && !writableEnded) {
                if (!stream._writableState || !stream._writableState.ended)
                  err = new ERR_STREAM_PREMATURE_CLOSE();
                return callback.call(stream, err);
              }
            };
            var onrequest = function onrequest() {
              stream.req.on("finish", onfinish);
            };
            if (isRequest(stream)) {
              stream.on("complete", onfinish);
              stream.on("abort", onclose);
              if (stream.req) onrequest();
              else stream.on("request", onrequest);
            } else if (writable && !stream._writableState) {
              // legacy streams
              stream.on("end", onlegacyfinish);
              stream.on("close", onlegacyfinish);
            }
            stream.on("end", onend);
            stream.on("finish", onfinish);
            if (opts.error !== false) stream.on("error", onerror);
            stream.on("close", onclose);
            return function () {
              stream.removeListener("complete", onfinish);
              stream.removeListener("abort", onclose);
              stream.removeListener("request", onrequest);
              if (stream.req) stream.req.removeListener("finish", onfinish);
              stream.removeListener("end", onlegacyfinish);
              stream.removeListener("close", onlegacyfinish);
              stream.removeListener("finish", onfinish);
              stream.removeListener("end", onend);
              stream.removeListener("error", onerror);
              stream.removeListener("close", onclose);
            };
          }
          module.exports = eos;
        },
        { "../../../errors": "9e8b965127778a5bef42160d55499ba5" }
      ],
      "180f5f76cf99d66dda918fd2e277bfbf": [
        function (require, module, exports) {
          module.exports = function () {
            throw new Error("Readable.from is not available in the browser");
          };
        },
        {}
      ],
      "5a00bf4d8e0f1eb85f9f8b889e5f633c": [
        function (require, module, exports) {
          // Copyright Joyent, Inc. and other Node contributors.
          //
          // Permission is hereby granted, free of charge, to any person obtaining a
          // copy of this software and associated documentation files (the
          // "Software"), to deal in the Software without restriction, including
          // without limitation the rights to use, copy, modify, merge, publish,
          // distribute, sublicense, and/or sell copies of the Software, and to permit
          // persons to whom the Software is furnished to do so, subject to the
          // following conditions:
          //
          // The above copyright notice and this permission notice shall be included
          // in all copies or substantial portions of the Software.
          //
          // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
          // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
          // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
          // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
          // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
          // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
          // USE OR OTHER DEALINGS IN THE SOFTWARE.
          // a transform stream is a readable/writable stream where you do
          // something with the data.  Sometimes it's called a "filter",
          // but that's not a great name for it, since that implies a thing where
          // some bits pass through, and others are simply ignored.  (That would
          // be a valid example of a transform, of course.)
          //
          // While the output is causally related to the input, it's not a
          // necessarily symmetric or synchronous transformation.  For example,
          // a zlib stream might take multiple plain-text writes(), and then
          // emit a single compressed chunk some time in the future.
          //
          // Here's how this works:
          //
          // The Transform stream has all the aspects of the readable and writable
          // stream classes.  When you write(chunk), that calls _write(chunk,cb)
          // internally, and returns false if there's a lot of pending writes
          // buffered up.  When you call read(), that calls _read(n) until
          // there's enough pending readable data buffered up.
          //
          // In a transform stream, the written data is placed in a buffer.  When
          // _read(n) is called, it transforms the queued up data, calling the
          // buffered _write cb's as it consumes chunks.  If consuming a single
          // written chunk would result in multiple output chunks, then the first
          // outputted bit calls the readcb, and subsequent chunks just go into
          // the read buffer, and will cause it to emit 'readable' if necessary.
          //
          // This way, back-pressure is actually determined by the reading side,
          // since _read has to be called to start processing a new chunk.  However,
          // a pathological inflate type of transform can cause excessive buffering
          // here.  For example, imagine a stream where every byte of input is
          // interpreted as an integer from 0-255, and then results in that many
          // bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
          // 1kb of data being output.  In this case, you could write a very small
          // amount of input, and end up with a very large amount of output.  In
          // such a pathological inflating mechanism, there'd be no way to tell
          // the system to stop doing the transform.  A single 4MB write could
          // cause the system to run out of memory.
          //
          // However, even in such a pathological case, only a single written chunk
          // would be consumed, and then the rest would wait (un-transformed) until
          // the results of the previous transformed chunk were consumed.
          "use strict";
          module.exports = Transform;
          var _require$codes = require("../errors").codes,
            ERR_METHOD_NOT_IMPLEMENTED =
              _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
            ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
            ERR_TRANSFORM_ALREADY_TRANSFORMING =
              _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
            ERR_TRANSFORM_WITH_LENGTH_0 =
              _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
          var Duplex = require("./_stream_duplex");
          require("inherits")(Transform, Duplex);
          function afterTransform(er, data) {
            var ts = this._transformState;
            ts.transforming = false;
            var cb = ts.writecb;
            if (cb === null) {
              return this.emit("error", new ERR_MULTIPLE_CALLBACK());
            }
            ts.writechunk = null;
            ts.writecb = null;
            if (data != null)
              // single equals check for both `null` and `undefined`
              this.push(data);
            cb(er);
            var rs = this._readableState;
            rs.reading = false;
            if (rs.needReadable || rs.length < rs.highWaterMark) {
              this._read(rs.highWaterMark);
            }
          }
          function Transform(options) {
            if (!_instanceof(this, Transform)) return new Transform(options);
            Duplex.call(this, options);
            this._transformState = {
              afterTransform: afterTransform.bind(this),
              needTransform: false,
              transforming: false,
              writecb: null,
              writechunk: null,
              writeencoding: null
            }; // start out asking for a readable event once data is transformed.
            this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
            // that Readable wants before the first _read call, so unset the
            // sync guard flag.
            this._readableState.sync = false;
            if (options) {
              if (typeof options.transform === "function")
                this._transform = options.transform;
              if (typeof options.flush === "function")
                this._flush = options.flush;
            } // When the writable side finishes, then flush out anything remaining.
            this.on("prefinish", prefinish);
          }
          function prefinish() {
            var _this = this;
            if (
              typeof this._flush === "function" &&
              !this._readableState.destroyed
            ) {
              this._flush(function (er, data) {
                done(_this, er, data);
              });
            } else {
              done(this, null, null);
            }
          }
          Transform.prototype.push = function (chunk, encoding) {
            this._transformState.needTransform = false;
            return Duplex.prototype.push.call(this, chunk, encoding);
          }; // This is the part where you do stuff!
          // override this function in implementation classes.
          // 'chunk' is an input chunk.
          //
          // Call `push(newChunk)` to pass along transformed output
          // to the readable side.  You may call 'push' zero or more times.
          //
          // Call `cb(err)` when you are done with this chunk.  If you pass
          // an error, then that'll put the hurt on the whole operation.  If you
          // never call cb(), then you'll never get another chunk.
          Transform.prototype._transform = function (chunk, encoding, cb) {
            cb(new ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
          };
          Transform.prototype._write = function (chunk, encoding, cb) {
            var ts = this._transformState;
            ts.writecb = cb;
            ts.writechunk = chunk;
            ts.writeencoding = encoding;
            if (!ts.transforming) {
              var rs = this._readableState;
              if (
                ts.needTransform ||
                rs.needReadable ||
                rs.length < rs.highWaterMark
              )
                this._read(rs.highWaterMark);
            }
          }; // Doesn't matter what the args are here.
          // _transform does all the work.
          // That we got here means that the readable side wants more data.
          Transform.prototype._read = function (n) {
            var ts = this._transformState;
            if (ts.writechunk !== null && !ts.transforming) {
              ts.transforming = true;
              this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
            } else {
              // mark that we need a transform, so that any data that comes in
              // will get processed, now that we've asked for it.
              ts.needTransform = true;
            }
          };
          Transform.prototype._destroy = function (err, cb) {
            Duplex.prototype._destroy.call(this, err, function (err2) {
              cb(err2);
            });
          };
          function done(stream, er, data) {
            if (er) return stream.emit("error", er);
            if (data != null)
              // single equals check for both `null` and `undefined`
              stream.push(data); // TODO(BridgeAR): Write a test for these two error cases
            // if there's nothing in the write buffer, then that means
            // that nothing more will ever be provided
            if (stream._writableState.length)
              throw new ERR_TRANSFORM_WITH_LENGTH_0();
            if (stream._transformState.transforming)
              throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
            return stream.push(null);
          }
        },
        {
          "../errors": "9e8b965127778a5bef42160d55499ba5",
          "./_stream_duplex": "697a6b37b3553e220776ac06dc162ff3",
          inherits: "cd61047e9289e4b62768390878fc0b01"
        }
      ],
      bedf5ddeb978a21f9b2504317671d350: [
        function (require, module, exports) {
          // Copyright Joyent, Inc. and other Node contributors.
          //
          // Permission is hereby granted, free of charge, to any person obtaining a
          // copy of this software and associated documentation files (the
          // "Software"), to deal in the Software without restriction, including
          // without limitation the rights to use, copy, modify, merge, publish,
          // distribute, sublicense, and/or sell copies of the Software, and to permit
          // persons to whom the Software is furnished to do so, subject to the
          // following conditions:
          //
          // The above copyright notice and this permission notice shall be included
          // in all copies or substantial portions of the Software.
          //
          // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
          // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
          // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
          // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
          // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
          // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
          // USE OR OTHER DEALINGS IN THE SOFTWARE.
          // a passthrough stream.
          // basically just the most minimal sort of Transform stream.
          // Every written chunk gets output as-is.
          "use strict";
          module.exports = PassThrough;
          var Transform = require("./_stream_transform");
          require("inherits")(PassThrough, Transform);
          function PassThrough(options) {
            if (!_instanceof(this, PassThrough)) return new PassThrough(options);
            Transform.call(this, options);
          }
          PassThrough.prototype._transform = function (chunk, encoding, cb) {
            cb(null, chunk);
          };
        },
        {
          "./_stream_transform": "5a00bf4d8e0f1eb85f9f8b889e5f633c",
          inherits: "cd61047e9289e4b62768390878fc0b01"
        }
      ],
      f51ae73eb0cd3a21f6784b33d7675413: [
        function (require, module, exports) {
          // Ported from https://github.com/mafintosh/pump with
          // permission from the author, Mathias Buus (@mafintosh).
          "use strict";
          var eos;
          function once(callback) {
            var called = false;
            return function () {
              if (called) return;
              called = true;
              callback.apply(void 0, arguments);
            };
          }
          var _require$codes = require("../../../errors").codes,
            ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
            ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
          function noop(err) {
            // Rethrow the error if it exists to avoid swallowing it
            if (err) throw err;
          }
          function isRequest(stream) {
            return stream.setHeader && typeof stream.abort === "function";
          }
          function destroyer(stream, reading, writing, callback) {
            callback = once(callback);
            var closed = false;
            stream.on("close", function () {
              closed = true;
            });
            if (eos === undefined) eos = require("./end-of-stream");
            eos(stream, { readable: reading, writable: writing }, function (err) {
              if (err) return callback(err);
              closed = true;
              callback();
            });
            var destroyed = false;
            return function (err) {
              if (closed) return;
              if (destroyed) return;
              destroyed = true; // request.destroy just do .end - .abort is what we want
              if (isRequest(stream)) return stream.abort();
              if (typeof stream.destroy === "function") return stream.destroy();
              callback(err || new ERR_STREAM_DESTROYED("pipe"));
            };
          }
          function call(fn) {
            fn();
          }
          function pipe(from, to) {
            return from.pipe(to);
          }
          function popCallback(streams) {
            if (!streams.length) return noop;
            if (typeof streams[streams.length - 1] !== "function") return noop;
            return streams.pop();
          }
          function pipeline() {
            for (
              var _len = arguments.length, streams = new Array(_len), _key = 0;
              _key < _len;
              _key++
            ) {
              streams[_key] = arguments[_key];
            }
            var callback = popCallback(streams);
            if (Array.isArray(streams[0])) streams = streams[0];
            if (streams.length < 2) {
              throw new ERR_MISSING_ARGS("streams");
            }
            var error;
            var destroys = streams.map(function (stream, i) {
              var reading = i < streams.length - 1;
              var writing = i > 0;
              return destroyer(stream, reading, writing, function (err) {
                if (!error) error = err;
                if (err) destroys.forEach(call);
                if (reading) return;
                destroys.forEach(call);
                callback(error);
              });
            });
            return streams.reduce(pipe);
          }
          module.exports = pipeline;
        },
        {
          "../../../errors": "9e8b965127778a5bef42160d55499ba5",
          "./end-of-stream": "9cf0302cde5d6261ef306b6ba09b954d"
        }
      ],
      f1c87c91800247cc2998c4c840dee6a0: [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("buffer").Buffer;
          var inherits = require("inherits");
          var HashBase = require("hash-base");
          var ARRAY16 = new Array(16);
          var zl = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            7,
            4,
            13,
            1,
            10,
            6,
            15,
            3,
            12,
            0,
            9,
            5,
            2,
            14,
            11,
            8,
            3,
            10,
            14,
            4,
            9,
            15,
            8,
            1,
            2,
            7,
            0,
            6,
            13,
            11,
            5,
            12,
            1,
            9,
            11,
            10,
            0,
            8,
            12,
            4,
            13,
            3,
            7,
            15,
            14,
            5,
            6,
            2,
            4,
            0,
            5,
            9,
            7,
            12,
            2,
            10,
            14,
            1,
            3,
            8,
            11,
            6,
            15,
            13
          ];
          var zr = [
            5,
            14,
            7,
            0,
            9,
            2,
            11,
            4,
            13,
            6,
            15,
            8,
            1,
            10,
            3,
            12,
            6,
            11,
            3,
            7,
            0,
            13,
            5,
            10,
            14,
            15,
            8,
            12,
            4,
            9,
            1,
            2,
            15,
            5,
            1,
            3,
            7,
            14,
            6,
            9,
            11,
            8,
            12,
            2,
            10,
            0,
            4,
            13,
            8,
            6,
            4,
            1,
            3,
            11,
            15,
            0,
            5,
            12,
            2,
            13,
            9,
            7,
            10,
            14,
            12,
            15,
            10,
            4,
            1,
            5,
            8,
            7,
            6,
            2,
            13,
            14,
            0,
            3,
            9,
            11
          ];
          var sl = [
            11,
            14,
            15,
            12,
            5,
            8,
            7,
            9,
            11,
            13,
            14,
            15,
            6,
            7,
            9,
            8,
            7,
            6,
            8,
            13,
            11,
            9,
            7,
            15,
            7,
            12,
            15,
            9,
            11,
            7,
            13,
            12,
            11,
            13,
            6,
            7,
            14,
            9,
            13,
            15,
            14,
            8,
            13,
            6,
            5,
            12,
            7,
            5,
            11,
            12,
            14,
            15,
            14,
            15,
            9,
            8,
            9,
            14,
            5,
            6,
            8,
            6,
            5,
            12,
            9,
            15,
            5,
            11,
            6,
            8,
            13,
            12,
            5,
            12,
            13,
            14,
            11,
            8,
            5,
            6
          ];
          var sr = [
            8,
            9,
            9,
            11,
            13,
            15,
            15,
            5,
            7,
            7,
            8,
            11,
            14,
            14,
            12,
            6,
            9,
            13,
            15,
            7,
            12,
            8,
            9,
            11,
            7,
            7,
            12,
            7,
            6,
            15,
            13,
            11,
            9,
            7,
            15,
            11,
            8,
            6,
            6,
            14,
            12,
            13,
            5,
            14,
            13,
            13,
            7,
            5,
            15,
            5,
            8,
            11,
            14,
            14,
            6,
            14,
            6,
            9,
            12,
            9,
            12,
            5,
            15,
            8,
            8,
            5,
            12,
            9,
            12,
            5,
            14,
            6,
            8,
            13,
            6,
            5,
            15,
            13,
            11,
            11
          ];
          var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e];
          var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000];
          function RIPEMD160() {
            HashBase.call(this, 64); // state
            this._a = 0x67452301;
            this._b = 0xefcdab89;
            this._c = 0x98badcfe;
            this._d = 0x10325476;
            this._e = 0xc3d2e1f0;
          }
          inherits(RIPEMD160, HashBase);
          RIPEMD160.prototype._update = function () {
            var words = ARRAY16;
            for (var j = 0; j < 16; ++j) {
              words[j] = this._block.readInt32LE(j * 4);
            }
            var al = this._a | 0;
            var bl = this._b | 0;
            var cl = this._c | 0;
            var dl = this._d | 0;
            var el = this._e | 0;
            var ar = this._a | 0;
            var br = this._b | 0;
            var cr = this._c | 0;
            var dr = this._d | 0;
            var er = this._e | 0; // computation
            for (var i = 0; i < 80; i += 1) {
              var tl;
              var tr;
              if (i < 16) {
                tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i]);
                tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i]);
              } else if (i < 32) {
                tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i]);
                tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i]);
              } else if (i < 48) {
                tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i]);
                tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i]);
              } else if (i < 64) {
                tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i]);
                tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i]);
              } else {
                // if (i<80) {
                tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i]);
                tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i]);
              }
              al = el;
              el = dl;
              dl = rotl(cl, 10);
              cl = bl;
              bl = tl;
              ar = er;
              er = dr;
              dr = rotl(cr, 10);
              cr = br;
              br = tr;
            } // update state
            var t = (this._b + cl + dr) | 0;
            this._b = (this._c + dl + er) | 0;
            this._c = (this._d + el + ar) | 0;
            this._d = (this._e + al + br) | 0;
            this._e = (this._a + bl + cr) | 0;
            this._a = t;
          };
          RIPEMD160.prototype._digest = function () {
            // create padding and handle blocks
            this._block[this._blockOffset++] = 0x80;
            if (this._blockOffset > 56) {
              this._block.fill(0, this._blockOffset, 64);
              this._update();
              this._blockOffset = 0;
            }
            this._block.fill(0, this._blockOffset, 56);
            this._block.writeUInt32LE(this._length[0], 56);
            this._block.writeUInt32LE(this._length[1], 60);
            this._update(); // produce result
            var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20);
            buffer.writeInt32LE(this._a, 0);
            buffer.writeInt32LE(this._b, 4);
            buffer.writeInt32LE(this._c, 8);
            buffer.writeInt32LE(this._d, 12);
            buffer.writeInt32LE(this._e, 16);
            return buffer;
          };
          function rotl(x, n) {
            return (x << n) | (x >>> (32 - n));
          }
          function fn1(a, b, c, d, e, m, k, s) {
            return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0;
          }
          function fn2(a, b, c, d, e, m, k, s) {
            return (rotl((a + ((b & c) | (~b & d)) + m + k) | 0, s) + e) | 0;
          }
          function fn3(a, b, c, d, e, m, k, s) {
            return (rotl((a + ((b | ~c) ^ d) + m + k) | 0, s) + e) | 0;
          }
          function fn4(a, b, c, d, e, m, k, s) {
            return (rotl((a + ((b & d) | (c & ~d)) + m + k) | 0, s) + e) | 0;
          }
          function fn5(a, b, c, d, e, m, k, s) {
            return (rotl((a + (b ^ (c | ~d)) + m + k) | 0, s) + e) | 0;
          }
          module.exports = RIPEMD160;
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          inherits: "cd61047e9289e4b62768390878fc0b01",
          "hash-base": "1ae08a57c8842df4a4747e45ec9b850c"
        }
      ],
      e45004c4900ed3f294bee27791c95d0e: [
        function (require, module, exports) {
          var exports = (module.exports = function SHA(algorithm) {
            algorithm = algorithm.toLowerCase();
            var Algorithm = exports[algorithm];
            if (!Algorithm)
              throw new Error(
                algorithm + " is not supported (we accept pull requests)"
              );
            return new Algorithm();
          });
          exports.sha = require("./sha");
          exports.sha1 = require("./sha1");
          exports.sha224 = require("./sha224");
          exports.sha256 = require("./sha256");
          exports.sha384 = require("./sha384");
          exports.sha512 = require("./sha512");
        },
        {
          "./sha": "b0881f103561114a6c9b1c4e418f017c",
          "./sha1": "181132ac59016ab411e8ed44a012cca8",
          "./sha224": "124ab0d84e305237c07eb5b872c0318d",
          "./sha256": "8206be5fb2060cb37197b2d104f2a6a2",
          "./sha384": "2c763fdc10db02ca92c1e7b58c874a81",
          "./sha512": "56a99037953fd00fe06e3b0174067139"
        }
      ],
      b0881f103561114a6c9b1c4e418f017c: [
        function (require, module, exports) {
          /*
           * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
           * in FIPS PUB 180-1
           * This source code is derived from sha1.js of the same repository.
           * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
           * operation was added.
           */ var inherits = require("inherits");
          var Hash = require("./hash");
          var Buffer = require("safe-buffer").Buffer;
          var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0];
          var W = new Array(80);
          function Sha() {
            this.init();
            this._w = W;
            Hash.call(this, 64, 56);
          }
          inherits(Sha, Hash);
          Sha.prototype.init = function () {
            this._a = 0x67452301;
            this._b = 0xefcdab89;
            this._c = 0x98badcfe;
            this._d = 0x10325476;
            this._e = 0xc3d2e1f0;
            return this;
          };
          function rotl5(num) {
            return (num << 5) | (num >>> 27);
          }
          function rotl30(num) {
            return (num << 30) | (num >>> 2);
          }
          function ft(s, b, c, d) {
            if (s === 0) return (b & c) | (~b & d);
            if (s === 2) return (b & c) | (b & d) | (c & d);
            return b ^ c ^ d;
          }
          Sha.prototype._update = function (M) {
            var W = this._w;
            var a = this._a | 0;
            var b = this._b | 0;
            var c = this._c | 0;
            var d = this._d | 0;
            var e = this._e | 0;
            for (var i = 0; i < 16; ++i) {
              W[i] = M.readInt32BE(i * 4);
            }
            for (; i < 80; ++i) {
              W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            }
            for (var j = 0; j < 80; ++j) {
              var s = ~~(j / 20);
              var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0;
              e = d;
              d = c;
              c = rotl30(b);
              b = a;
              a = t;
            }
            this._a = (a + this._a) | 0;
            this._b = (b + this._b) | 0;
            this._c = (c + this._c) | 0;
            this._d = (d + this._d) | 0;
            this._e = (e + this._e) | 0;
          };
          Sha.prototype._hash = function () {
            var H = Buffer.allocUnsafe(20);
            H.writeInt32BE(this._a | 0, 0);
            H.writeInt32BE(this._b | 0, 4);
            H.writeInt32BE(this._c | 0, 8);
            H.writeInt32BE(this._d | 0, 12);
            H.writeInt32BE(this._e | 0, 16);
            return H;
          };
          module.exports = Sha;
        },
        {
          inherits: "cd61047e9289e4b62768390878fc0b01",
          "./hash": "5c314afcbcb8393dd3cd0fb4d5c1fd53",
          "safe-buffer": "4e0959a531d73b3690537fbc38856961"
        }
      ],
      "5c314afcbcb8393dd3cd0fb4d5c1fd53": [
        function (require, module, exports) {
          var Buffer = require("safe-buffer").Buffer; // prototype class for hash functions
          function Hash(blockSize, finalSize) {
            this._block = Buffer.alloc(blockSize);
            this._finalSize = finalSize;
            this._blockSize = blockSize;
            this._len = 0;
          }
          Hash.prototype.update = function (data, enc) {
            if (typeof data === "string") {
              enc = enc || "utf8";
              data = Buffer.from(data, enc);
            }
            var block = this._block;
            var blockSize = this._blockSize;
            var length = data.length;
            var accum = this._len;
            for (var offset = 0; offset < length; ) {
              var assigned = accum % blockSize;
              var remainder = Math.min(length - offset, blockSize - assigned);
              for (var i = 0; i < remainder; i++) {
                block[assigned + i] = data[offset + i];
              }
              accum += remainder;
              offset += remainder;
              if (accum % blockSize === 0) {
                this._update(block);
              }
            }
            this._len += length;
            return this;
          };
          Hash.prototype.digest = function (enc) {
            var rem = this._len % this._blockSize;
            this._block[rem] = 0x80; // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
            // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
            this._block.fill(0, rem + 1);
            if (rem >= this._finalSize) {
              this._update(this._block);
              this._block.fill(0);
            }
            var bits = this._len * 8; // uint32
            if (bits <= 0xffffffff) {
              this._block.writeUInt32BE(bits, this._blockSize - 4); // uint64
            } else {
              var lowBits = (bits & 0xffffffff) >>> 0;
              var highBits = (bits - lowBits) / 0x100000000;
              this._block.writeUInt32BE(highBits, this._blockSize - 8);
              this._block.writeUInt32BE(lowBits, this._blockSize - 4);
            }
            this._update(this._block);
            var hash = this._hash();
            return enc ? hash.toString(enc) : hash;
          };
          Hash.prototype._update = function () {
            throw new Error("_update must be implemented by subclass");
          };
          module.exports = Hash;
        },
        { "safe-buffer": "4e0959a531d73b3690537fbc38856961" }
      ],
      "181132ac59016ab411e8ed44a012cca8": [
        function (require, module, exports) {
          /*
           * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
           * in FIPS PUB 180-1
           * Version 2.1a Copyright Paul Johnston 2000 - 2002.
           * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
           * Distributed under the BSD License
           * See http://pajhome.org.uk/crypt/md5 for details.
           */ var inherits = require("inherits");
          var Hash = require("./hash");
          var Buffer = require("safe-buffer").Buffer;
          var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0];
          var W = new Array(80);
          function Sha1() {
            this.init();
            this._w = W;
            Hash.call(this, 64, 56);
          }
          inherits(Sha1, Hash);
          Sha1.prototype.init = function () {
            this._a = 0x67452301;
            this._b = 0xefcdab89;
            this._c = 0x98badcfe;
            this._d = 0x10325476;
            this._e = 0xc3d2e1f0;
            return this;
          };
          function rotl1(num) {
            return (num << 1) | (num >>> 31);
          }
          function rotl5(num) {
            return (num << 5) | (num >>> 27);
          }
          function rotl30(num) {
            return (num << 30) | (num >>> 2);
          }
          function ft(s, b, c, d) {
            if (s === 0) return (b & c) | (~b & d);
            if (s === 2) return (b & c) | (b & d) | (c & d);
            return b ^ c ^ d;
          }
          Sha1.prototype._update = function (M) {
            var W = this._w;
            var a = this._a | 0;
            var b = this._b | 0;
            var c = this._c | 0;
            var d = this._d | 0;
            var e = this._e | 0;
            for (var i = 0; i < 16; ++i) {
              W[i] = M.readInt32BE(i * 4);
            }
            for (; i < 80; ++i) {
              W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
            }
            for (var j = 0; j < 80; ++j) {
              var s = ~~(j / 20);
              var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0;
              e = d;
              d = c;
              c = rotl30(b);
              b = a;
              a = t;
            }
            this._a = (a + this._a) | 0;
            this._b = (b + this._b) | 0;
            this._c = (c + this._c) | 0;
            this._d = (d + this._d) | 0;
            this._e = (e + this._e) | 0;
          };
          Sha1.prototype._hash = function () {
            var H = Buffer.allocUnsafe(20);
            H.writeInt32BE(this._a | 0, 0);
            H.writeInt32BE(this._b | 0, 4);
            H.writeInt32BE(this._c | 0, 8);
            H.writeInt32BE(this._d | 0, 12);
            H.writeInt32BE(this._e | 0, 16);
            return H;
          };
          module.exports = Sha1;
        },
        {
          inherits: "cd61047e9289e4b62768390878fc0b01",
          "./hash": "5c314afcbcb8393dd3cd0fb4d5c1fd53",
          "safe-buffer": "4e0959a531d73b3690537fbc38856961"
        }
      ],
      "124ab0d84e305237c07eb5b872c0318d": [
        function (require, module, exports) {
          /**
           * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
           * in FIPS 180-2
           * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
           * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
           *
           */ var inherits = require("inherits");
          var Sha256 = require("./sha256");
          var Hash = require("./hash");
          var Buffer = require("safe-buffer").Buffer;
          var W = new Array(64);
          function Sha224() {
            this.init();
            this._w = W; // new Array(64)
            Hash.call(this, 64, 56);
          }
          inherits(Sha224, Sha256);
          Sha224.prototype.init = function () {
            this._a = 0xc1059ed8;
            this._b = 0x367cd507;
            this._c = 0x3070dd17;
            this._d = 0xf70e5939;
            this._e = 0xffc00b31;
            this._f = 0x68581511;
            this._g = 0x64f98fa7;
            this._h = 0xbefa4fa4;
            return this;
          };
          Sha224.prototype._hash = function () {
            var H = Buffer.allocUnsafe(28);
            H.writeInt32BE(this._a, 0);
            H.writeInt32BE(this._b, 4);
            H.writeInt32BE(this._c, 8);
            H.writeInt32BE(this._d, 12);
            H.writeInt32BE(this._e, 16);
            H.writeInt32BE(this._f, 20);
            H.writeInt32BE(this._g, 24);
            return H;
          };
          module.exports = Sha224;
        },
        {
          inherits: "cd61047e9289e4b62768390878fc0b01",
          "./sha256": "8206be5fb2060cb37197b2d104f2a6a2",
          "./hash": "5c314afcbcb8393dd3cd0fb4d5c1fd53",
          "safe-buffer": "4e0959a531d73b3690537fbc38856961"
        }
      ],
      "8206be5fb2060cb37197b2d104f2a6a2": [
        function (require, module, exports) {
          /**
           * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
           * in FIPS 180-2
           * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
           * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
           *
           */ var inherits = require("inherits");
          var Hash = require("./hash");
          var Buffer = require("safe-buffer").Buffer;
          var K = [
            0x428a2f98,
            0x71374491,
            0xb5c0fbcf,
            0xe9b5dba5,
            0x3956c25b,
            0x59f111f1,
            0x923f82a4,
            0xab1c5ed5,
            0xd807aa98,
            0x12835b01,
            0x243185be,
            0x550c7dc3,
            0x72be5d74,
            0x80deb1fe,
            0x9bdc06a7,
            0xc19bf174,
            0xe49b69c1,
            0xefbe4786,
            0x0fc19dc6,
            0x240ca1cc,
            0x2de92c6f,
            0x4a7484aa,
            0x5cb0a9dc,
            0x76f988da,
            0x983e5152,
            0xa831c66d,
            0xb00327c8,
            0xbf597fc7,
            0xc6e00bf3,
            0xd5a79147,
            0x06ca6351,
            0x14292967,
            0x27b70a85,
            0x2e1b2138,
            0x4d2c6dfc,
            0x53380d13,
            0x650a7354,
            0x766a0abb,
            0x81c2c92e,
            0x92722c85,
            0xa2bfe8a1,
            0xa81a664b,
            0xc24b8b70,
            0xc76c51a3,
            0xd192e819,
            0xd6990624,
            0xf40e3585,
            0x106aa070,
            0x19a4c116,
            0x1e376c08,
            0x2748774c,
            0x34b0bcb5,
            0x391c0cb3,
            0x4ed8aa4a,
            0x5b9cca4f,
            0x682e6ff3,
            0x748f82ee,
            0x78a5636f,
            0x84c87814,
            0x8cc70208,
            0x90befffa,
            0xa4506ceb,
            0xbef9a3f7,
            0xc67178f2
          ];
          var W = new Array(64);
          function Sha256() {
            this.init();
            this._w = W; // new Array(64)
            Hash.call(this, 64, 56);
          }
          inherits(Sha256, Hash);
          Sha256.prototype.init = function () {
            this._a = 0x6a09e667;
            this._b = 0xbb67ae85;
            this._c = 0x3c6ef372;
            this._d = 0xa54ff53a;
            this._e = 0x510e527f;
            this._f = 0x9b05688c;
            this._g = 0x1f83d9ab;
            this._h = 0x5be0cd19;
            return this;
          };
          function ch(x, y, z) {
            return z ^ (x & (y ^ z));
          }
          function maj(x, y, z) {
            return (x & y) | (z & (x | y));
          }
          function sigma0(x) {
            return (
              ((x >>> 2) | (x << 30)) ^
              ((x >>> 13) | (x << 19)) ^
              ((x >>> 22) | (x << 10))
            );
          }
          function sigma1(x) {
            return (
              ((x >>> 6) | (x << 26)) ^
              ((x >>> 11) | (x << 21)) ^
              ((x >>> 25) | (x << 7))
            );
          }
          function gamma0(x) {
            return ((x >>> 7) | (x << 25)) ^ ((x >>> 18) | (x << 14)) ^ (x >>> 3);
          }
          function gamma1(x) {
            return (
              ((x >>> 17) | (x << 15)) ^ ((x >>> 19) | (x << 13)) ^ (x >>> 10)
            );
          }
          Sha256.prototype._update = function (M) {
            var W = this._w;
            var a = this._a | 0;
            var b = this._b | 0;
            var c = this._c | 0;
            var d = this._d | 0;
            var e = this._e | 0;
            var f = this._f | 0;
            var g = this._g | 0;
            var h = this._h | 0;
            for (var i = 0; i < 16; ++i) {
              W[i] = M.readInt32BE(i * 4);
            }
            for (; i < 64; ++i) {
              W[i] =
                (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0;
            }
            for (var j = 0; j < 64; ++j) {
              var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0;
              var T2 = (sigma0(a) + maj(a, b, c)) | 0;
              h = g;
              g = f;
              f = e;
              e = (d + T1) | 0;
              d = c;
              c = b;
              b = a;
              a = (T1 + T2) | 0;
            }
            this._a = (a + this._a) | 0;
            this._b = (b + this._b) | 0;
            this._c = (c + this._c) | 0;
            this._d = (d + this._d) | 0;
            this._e = (e + this._e) | 0;
            this._f = (f + this._f) | 0;
            this._g = (g + this._g) | 0;
            this._h = (h + this._h) | 0;
          };
          Sha256.prototype._hash = function () {
            var H = Buffer.allocUnsafe(32);
            H.writeInt32BE(this._a, 0);
            H.writeInt32BE(this._b, 4);
            H.writeInt32BE(this._c, 8);
            H.writeInt32BE(this._d, 12);
            H.writeInt32BE(this._e, 16);
            H.writeInt32BE(this._f, 20);
            H.writeInt32BE(this._g, 24);
            H.writeInt32BE(this._h, 28);
            return H;
          };
          module.exports = Sha256;
        },
        {
          inherits: "cd61047e9289e4b62768390878fc0b01",
          "./hash": "5c314afcbcb8393dd3cd0fb4d5c1fd53",
          "safe-buffer": "4e0959a531d73b3690537fbc38856961"
        }
      ],
      "2c763fdc10db02ca92c1e7b58c874a81": [
        function (require, module, exports) {
          var inherits = require("inherits");
          var SHA512 = require("./sha512");
          var Hash = require("./hash");
          var Buffer = require("safe-buffer").Buffer;
          var W = new Array(160);
          function Sha384() {
            this.init();
            this._w = W;
            Hash.call(this, 128, 112);
          }
          inherits(Sha384, SHA512);
          Sha384.prototype.init = function () {
            this._ah = 0xcbbb9d5d;
            this._bh = 0x629a292a;
            this._ch = 0x9159015a;
            this._dh = 0x152fecd8;
            this._eh = 0x67332667;
            this._fh = 0x8eb44a87;
            this._gh = 0xdb0c2e0d;
            this._hh = 0x47b5481d;
            this._al = 0xc1059ed8;
            this._bl = 0x367cd507;
            this._cl = 0x3070dd17;
            this._dl = 0xf70e5939;
            this._el = 0xffc00b31;
            this._fl = 0x68581511;
            this._gl = 0x64f98fa7;
            this._hl = 0xbefa4fa4;
            return this;
          };
          Sha384.prototype._hash = function () {
            var H = Buffer.allocUnsafe(48);
            function writeInt64BE(h, l, offset) {
              H.writeInt32BE(h, offset);
              H.writeInt32BE(l, offset + 4);
            }
            writeInt64BE(this._ah, this._al, 0);
            writeInt64BE(this._bh, this._bl, 8);
            writeInt64BE(this._ch, this._cl, 16);
            writeInt64BE(this._dh, this._dl, 24);
            writeInt64BE(this._eh, this._el, 32);
            writeInt64BE(this._fh, this._fl, 40);
            return H;
          };
          module.exports = Sha384;
        },
        {
          inherits: "cd61047e9289e4b62768390878fc0b01",
          "./sha512": "56a99037953fd00fe06e3b0174067139",
          "./hash": "5c314afcbcb8393dd3cd0fb4d5c1fd53",
          "safe-buffer": "4e0959a531d73b3690537fbc38856961"
        }
      ],
      "56a99037953fd00fe06e3b0174067139": [
        function (require, module, exports) {
          var inherits = require("inherits");
          var Hash = require("./hash");
          var Buffer = require("safe-buffer").Buffer;
          var K = [
            0x428a2f98,
            0xd728ae22,
            0x71374491,
            0x23ef65cd,
            0xb5c0fbcf,
            0xec4d3b2f,
            0xe9b5dba5,
            0x8189dbbc,
            0x3956c25b,
            0xf348b538,
            0x59f111f1,
            0xb605d019,
            0x923f82a4,
            0xaf194f9b,
            0xab1c5ed5,
            0xda6d8118,
            0xd807aa98,
            0xa3030242,
            0x12835b01,
            0x45706fbe,
            0x243185be,
            0x4ee4b28c,
            0x550c7dc3,
            0xd5ffb4e2,
            0x72be5d74,
            0xf27b896f,
            0x80deb1fe,
            0x3b1696b1,
            0x9bdc06a7,
            0x25c71235,
            0xc19bf174,
            0xcf692694,
            0xe49b69c1,
            0x9ef14ad2,
            0xefbe4786,
            0x384f25e3,
            0x0fc19dc6,
            0x8b8cd5b5,
            0x240ca1cc,
            0x77ac9c65,
            0x2de92c6f,
            0x592b0275,
            0x4a7484aa,
            0x6ea6e483,
            0x5cb0a9dc,
            0xbd41fbd4,
            0x76f988da,
            0x831153b5,
            0x983e5152,
            0xee66dfab,
            0xa831c66d,
            0x2db43210,
            0xb00327c8,
            0x98fb213f,
            0xbf597fc7,
            0xbeef0ee4,
            0xc6e00bf3,
            0x3da88fc2,
            0xd5a79147,
            0x930aa725,
            0x06ca6351,
            0xe003826f,
            0x14292967,
            0x0a0e6e70,
            0x27b70a85,
            0x46d22ffc,
            0x2e1b2138,
            0x5c26c926,
            0x4d2c6dfc,
            0x5ac42aed,
            0x53380d13,
            0x9d95b3df,
            0x650a7354,
            0x8baf63de,
            0x766a0abb,
            0x3c77b2a8,
            0x81c2c92e,
            0x47edaee6,
            0x92722c85,
            0x1482353b,
            0xa2bfe8a1,
            0x4cf10364,
            0xa81a664b,
            0xbc423001,
            0xc24b8b70,
            0xd0f89791,
            0xc76c51a3,
            0x0654be30,
            0xd192e819,
            0xd6ef5218,
            0xd6990624,
            0x5565a910,
            0xf40e3585,
            0x5771202a,
            0x106aa070,
            0x32bbd1b8,
            0x19a4c116,
            0xb8d2d0c8,
            0x1e376c08,
            0x5141ab53,
            0x2748774c,
            0xdf8eeb99,
            0x34b0bcb5,
            0xe19b48a8,
            0x391c0cb3,
            0xc5c95a63,
            0x4ed8aa4a,
            0xe3418acb,
            0x5b9cca4f,
            0x7763e373,
            0x682e6ff3,
            0xd6b2b8a3,
            0x748f82ee,
            0x5defb2fc,
            0x78a5636f,
            0x43172f60,
            0x84c87814,
            0xa1f0ab72,
            0x8cc70208,
            0x1a6439ec,
            0x90befffa,
            0x23631e28,
            0xa4506ceb,
            0xde82bde9,
            0xbef9a3f7,
            0xb2c67915,
            0xc67178f2,
            0xe372532b,
            0xca273ece,
            0xea26619c,
            0xd186b8c7,
            0x21c0c207,
            0xeada7dd6,
            0xcde0eb1e,
            0xf57d4f7f,
            0xee6ed178,
            0x06f067aa,
            0x72176fba,
            0x0a637dc5,
            0xa2c898a6,
            0x113f9804,
            0xbef90dae,
            0x1b710b35,
            0x131c471b,
            0x28db77f5,
            0x23047d84,
            0x32caab7b,
            0x40c72493,
            0x3c9ebe0a,
            0x15c9bebc,
            0x431d67c4,
            0x9c100d4c,
            0x4cc5d4be,
            0xcb3e42b6,
            0x597f299c,
            0xfc657e2a,
            0x5fcb6fab,
            0x3ad6faec,
            0x6c44198c,
            0x4a475817
          ];
          var W = new Array(160);
          function Sha512() {
            this.init();
            this._w = W;
            Hash.call(this, 128, 112);
          }
          inherits(Sha512, Hash);
          Sha512.prototype.init = function () {
            this._ah = 0x6a09e667;
            this._bh = 0xbb67ae85;
            this._ch = 0x3c6ef372;
            this._dh = 0xa54ff53a;
            this._eh = 0x510e527f;
            this._fh = 0x9b05688c;
            this._gh = 0x1f83d9ab;
            this._hh = 0x5be0cd19;
            this._al = 0xf3bcc908;
            this._bl = 0x84caa73b;
            this._cl = 0xfe94f82b;
            this._dl = 0x5f1d36f1;
            this._el = 0xade682d1;
            this._fl = 0x2b3e6c1f;
            this._gl = 0xfb41bd6b;
            this._hl = 0x137e2179;
            return this;
          };
          function Ch(x, y, z) {
            return z ^ (x & (y ^ z));
          }
          function maj(x, y, z) {
            return (x & y) | (z & (x | y));
          }
          function sigma0(x, xl) {
            return (
              ((x >>> 28) | (xl << 4)) ^
              ((xl >>> 2) | (x << 30)) ^
              ((xl >>> 7) | (x << 25))
            );
          }
          function sigma1(x, xl) {
            return (
              ((x >>> 14) | (xl << 18)) ^
              ((x >>> 18) | (xl << 14)) ^
              ((xl >>> 9) | (x << 23))
            );
          }
          function Gamma0(x, xl) {
            return (
              ((x >>> 1) | (xl << 31)) ^ ((x >>> 8) | (xl << 24)) ^ (x >>> 7)
            );
          }
          function Gamma0l(x, xl) {
            return (
              ((x >>> 1) | (xl << 31)) ^
              ((x >>> 8) | (xl << 24)) ^
              ((x >>> 7) | (xl << 25))
            );
          }
          function Gamma1(x, xl) {
            return (
              ((x >>> 19) | (xl << 13)) ^ ((xl >>> 29) | (x << 3)) ^ (x >>> 6)
            );
          }
          function Gamma1l(x, xl) {
            return (
              ((x >>> 19) | (xl << 13)) ^
              ((xl >>> 29) | (x << 3)) ^
              ((x >>> 6) | (xl << 26))
            );
          }
          function getCarry(a, b) {
            return a >>> 0 < b >>> 0 ? 1 : 0;
          }
          Sha512.prototype._update = function (M) {
            var W = this._w;
            var ah = this._ah | 0;
            var bh = this._bh | 0;
            var ch = this._ch | 0;
            var dh = this._dh | 0;
            var eh = this._eh | 0;
            var fh = this._fh | 0;
            var gh = this._gh | 0;
            var hh = this._hh | 0;
            var al = this._al | 0;
            var bl = this._bl | 0;
            var cl = this._cl | 0;
            var dl = this._dl | 0;
            var el = this._el | 0;
            var fl = this._fl | 0;
            var gl = this._gl | 0;
            var hl = this._hl | 0;
            for (var i = 0; i < 32; i += 2) {
              W[i] = M.readInt32BE(i * 4);
              W[i + 1] = M.readInt32BE(i * 4 + 4);
            }
            for (; i < 160; i += 2) {
              var xh = W[i - 15 * 2];
              var xl = W[i - 15 * 2 + 1];
              var gamma0 = Gamma0(xh, xl);
              var gamma0l = Gamma0l(xl, xh);
              xh = W[i - 2 * 2];
              xl = W[i - 2 * 2 + 1];
              var gamma1 = Gamma1(xh, xl);
              var gamma1l = Gamma1l(xl, xh); // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
              var Wi7h = W[i - 7 * 2];
              var Wi7l = W[i - 7 * 2 + 1];
              var Wi16h = W[i - 16 * 2];
              var Wi16l = W[i - 16 * 2 + 1];
              var Wil = (gamma0l + Wi7l) | 0;
              var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0;
              Wil = (Wil + gamma1l) | 0;
              Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0;
              Wil = (Wil + Wi16l) | 0;
              Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0;
              W[i] = Wih;
              W[i + 1] = Wil;
            }
            for (var j = 0; j < 160; j += 2) {
              Wih = W[j];
              Wil = W[j + 1];
              var majh = maj(ah, bh, ch);
              var majl = maj(al, bl, cl);
              var sigma0h = sigma0(ah, al);
              var sigma0l = sigma0(al, ah);
              var sigma1h = sigma1(eh, el);
              var sigma1l = sigma1(el, eh); // t1 = h + sigma1 + ch + K[j] + W[j]
              var Kih = K[j];
              var Kil = K[j + 1];
              var chh = Ch(eh, fh, gh);
              var chl = Ch(el, fl, gl);
              var t1l = (hl + sigma1l) | 0;
              var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0;
              t1l = (t1l + chl) | 0;
              t1h = (t1h + chh + getCarry(t1l, chl)) | 0;
              t1l = (t1l + Kil) | 0;
              t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0;
              t1l = (t1l + Wil) | 0;
              t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0; // t2 = sigma0 + maj
              var t2l = (sigma0l + majl) | 0;
              var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0;
              hh = gh;
              hl = gl;
              gh = fh;
              gl = fl;
              fh = eh;
              fl = el;
              el = (dl + t1l) | 0;
              eh = (dh + t1h + getCarry(el, dl)) | 0;
              dh = ch;
              dl = cl;
              ch = bh;
              cl = bl;
              bh = ah;
              bl = al;
              al = (t1l + t2l) | 0;
              ah = (t1h + t2h + getCarry(al, t1l)) | 0;
            }
            this._al = (this._al + al) | 0;
            this._bl = (this._bl + bl) | 0;
            this._cl = (this._cl + cl) | 0;
            this._dl = (this._dl + dl) | 0;
            this._el = (this._el + el) | 0;
            this._fl = (this._fl + fl) | 0;
            this._gl = (this._gl + gl) | 0;
            this._hl = (this._hl + hl) | 0;
            this._ah = (this._ah + ah + getCarry(this._al, al)) | 0;
            this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0;
            this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0;
            this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0;
            this._eh = (this._eh + eh + getCarry(this._el, el)) | 0;
            this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0;
            this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0;
            this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0;
          };
          Sha512.prototype._hash = function () {
            var H = Buffer.allocUnsafe(64);
            function writeInt64BE(h, l, offset) {
              H.writeInt32BE(h, offset);
              H.writeInt32BE(l, offset + 4);
            }
            writeInt64BE(this._ah, this._al, 0);
            writeInt64BE(this._bh, this._bl, 8);
            writeInt64BE(this._ch, this._cl, 16);
            writeInt64BE(this._dh, this._dl, 24);
            writeInt64BE(this._eh, this._el, 32);
            writeInt64BE(this._fh, this._fl, 40);
            writeInt64BE(this._gh, this._gl, 48);
            writeInt64BE(this._hh, this._hl, 56);
            return H;
          };
          module.exports = Sha512;
        },
        {
          inherits: "cd61047e9289e4b62768390878fc0b01",
          "./hash": "5c314afcbcb8393dd3cd0fb4d5c1fd53",
          "safe-buffer": "4e0959a531d73b3690537fbc38856961"
        }
      ],
      "20b612331822224e6d245498f492db41": [
        function (require, module, exports) {
          var Buffer = require("safe-buffer").Buffer;
          var Transform = require("stream").Transform;
          var StringDecoder = require("string_decoder").StringDecoder;
          var inherits = require("inherits");
          function CipherBase(hashMode) {
            Transform.call(this);
            this.hashMode = typeof hashMode === "string";
            if (this.hashMode) {
              this[hashMode] = this._finalOrDigest;
            } else {
              this.final = this._finalOrDigest;
            }
            if (this._final) {
              this.__final = this._final;
              this._final = null;
            }
            this._decoder = null;
            this._encoding = null;
          }
          inherits(CipherBase, Transform);
          CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
            if (typeof data === "string") {
              data = Buffer.from(data, inputEnc);
            }
            var outData = this._update(data);
            if (this.hashMode) return this;
            if (outputEnc) {
              outData = this._toString(outData, outputEnc);
            }
            return outData;
          };
          CipherBase.prototype.setAutoPadding = function () {};
          CipherBase.prototype.getAuthTag = function () {
            throw new Error("trying to get auth tag in unsupported state");
          };
          CipherBase.prototype.setAuthTag = function () {
            throw new Error("trying to set auth tag in unsupported state");
          };
          CipherBase.prototype.setAAD = function () {
            throw new Error("trying to set aad in unsupported state");
          };
          CipherBase.prototype._transform = function (data, _, next) {
            var err;
            try {
              if (this.hashMode) {
                this._update(data);
              } else {
                this.push(this._update(data));
              }
            } catch (e) {
              err = e;
            } finally {
              next(err);
            }
          };
          CipherBase.prototype._flush = function (done) {
            var err;
            try {
              this.push(this.__final());
            } catch (e) {
              err = e;
            }
            done(err);
          };
          CipherBase.prototype._finalOrDigest = function (outputEnc) {
            var outData = this.__final() || Buffer.alloc(0);
            if (outputEnc) {
              outData = this._toString(outData, outputEnc, true);
            }
            return outData;
          };
          CipherBase.prototype._toString = function (value, enc, fin) {
            if (!this._decoder) {
              this._decoder = new StringDecoder(enc);
              this._encoding = enc;
            }
            if (this._encoding !== enc) throw new Error("can't switch encodings");
            var out = this._decoder.write(value);
            if (fin) {
              out += this._decoder.end();
            }
            return out;
          };
          module.exports = CipherBase;
        },
        {
          "safe-buffer": "4e0959a531d73b3690537fbc38856961",
          stream: "7c999dc31e58d4aba4be8b5e8768c165",
          string_decoder: "19f62334fa8f609f5137742f3fba9fc2",
          inherits: "cd61047e9289e4b62768390878fc0b01"
        }
      ],
      "7c999dc31e58d4aba4be8b5e8768c165": [
        function (require, module, exports) {
          exports = module.exports = require("./lib/_stream_readable.js");
          exports.Stream = exports;
          exports.Readable = exports;
          exports.Writable = require("./lib/_stream_writable.js");
          exports.Duplex = require("./lib/_stream_duplex.js");
          exports.Transform = require("./lib/_stream_transform.js");
          exports.PassThrough = require("./lib/_stream_passthrough.js");
          exports.finished = require("./lib/internal/streams/end-of-stream.js");
          exports.pipeline = require("./lib/internal/streams/pipeline.js");
        },
        {
          "./lib/_stream_readable.js": "1651b545c585f8a8557608d4a0e121d6",
          "./lib/_stream_writable.js": "a56d982b804ceee4a5b5b03c447bb5ad",
          "./lib/_stream_duplex.js": "6b667e5880fd1eed1d4a8b5ddb47b706",
          "./lib/_stream_transform.js": "344910f8ae2ab2cbf141d025605057e4",
          "./lib/_stream_passthrough.js": "63d26bea15cd05a885b9a4f84b61f47e",
          "./lib/internal/streams/end-of-stream.js":
            "8bb38b990984c421de0a9b6498783567",
          "./lib/internal/streams/pipeline.js": "5a264023f1e7a5b691a8ec9a8c9c68e7"
        }
      ],
      "1651b545c585f8a8557608d4a0e121d6": [
        function (require, module, exports) {
          // Copyright Joyent, Inc. and other Node contributors.
          //
          // Permission is hereby granted, free of charge, to any person obtaining a
          // copy of this software and associated documentation files (the
          // "Software"), to deal in the Software without restriction, including
          // without limitation the rights to use, copy, modify, merge, publish,
          // distribute, sublicense, and/or sell copies of the Software, and to permit
          // persons to whom the Software is furnished to do so, subject to the
          // following conditions:
          //
          // The above copyright notice and this permission notice shall be included
          // in all copies or substantial portions of the Software.
          //
          // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
          // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
          // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
          // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
          // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
          // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
          // USE OR OTHER DEALINGS IN THE SOFTWARE.
          "use strict";
          var global = arguments[3];
          var process = require("process");
          module.exports = Readable;
          /*<replacement>*/ var Duplex;
          /*</replacement>*/ Readable.ReadableState = ReadableState;
          /*<replacement>*/ var EE = require("events").EventEmitter;
          var EElistenerCount = function EElistenerCount(emitter, type) {
            return emitter.listeners(type).length;
          };
          /*</replacement>*/ /*<replacement>*/ var Stream = require("./internal/streams/stream");
          /*</replacement>*/ var Buffer = require("buffer").Buffer;
          var OurUint8Array = global.Uint8Array || function () {};
          function _uint8ArrayToBuffer(chunk) {
            return Buffer.from(chunk);
          }
          function _isUint8Array(obj) {
            return Buffer.isBuffer(obj) || _instanceof(obj, OurUint8Array);
          }
          /*<replacement>*/ var debugUtil = require("util");
          var debug;
          if (debugUtil && debugUtil.debuglog) {
            debug = debugUtil.debuglog("stream");
          } else {
            debug = function debug() {};
          }
          /*</replacement>*/ var BufferList = require("./internal/streams/buffer_list");
          var destroyImpl = require("./internal/streams/destroy");
          var _require = require("./internal/streams/state"),
            getHighWaterMark = _require.getHighWaterMark;
          var _require$codes = require("../errors").codes,
            ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
            ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
            ERR_METHOD_NOT_IMPLEMENTED =
              _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
            ERR_STREAM_UNSHIFT_AFTER_END_EVENT =
              _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT; // Lazy loaded to improve the startup performance.
          var StringDecoder;
          var createReadableStreamAsyncIterator;
          var from;
          require("inherits")(Readable, Stream);
          var errorOrDestroy = destroyImpl.errorOrDestroy;
          var kProxyEvents = ["error", "close", "destroy", "pause", "resume"];
          function prependListener(emitter, event, fn) {
            // Sadly this is not cacheable as some libraries bundle their own
            // event emitter implementation with them.
            if (typeof emitter.prependListener === "function")
              return emitter.prependListener(event, fn); // This is a hack to make sure that our error handler is attached before any
            // userland ones.  NEVER DO THIS. This is here only because this code needs
            // to continue to work with older versions of Node.js that do not include
            // the prependListener() method. The goal is to eventually remove this hack.
            if (!emitter._events || !emitter._events[event])
              emitter.on(event, fn);
            else if (Array.isArray(emitter._events[event]))
              emitter._events[event].unshift(fn);
            else emitter._events[event] = [fn, emitter._events[event]];
          }
          function ReadableState(options, stream, isDuplex) {
            Duplex = Duplex || require("./_stream_duplex");
            options = options || {}; // Duplex streams are both readable and writable, but share
            // the same options object.
            // However, some cases require setting options to different
            // values for the readable and the writable sides of the duplex stream.
            // These options can be provided separately as readableXXX and writableXXX.
            if (typeof isDuplex !== "boolean")
              isDuplex = _instanceof(stream, Duplex); // object stream flag. Used to make read(n) ignore n and to
            // make all the buffer merging and length checks go away
            this.objectMode = !!options.objectMode;
            if (isDuplex)
              this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
            // Note: 0 is a valid value, means "don't call _read preemptively ever"
            this.highWaterMark = getHighWaterMark(
              this,
              options,
              "readableHighWaterMark",
              isDuplex
            ); // A linked list is used to store data chunks instead of an array because the
            // linked list can remove elements from the beginning faster than
            // array.shift()
            this.buffer = new BufferList();
            this.length = 0;
            this.pipes = null;
            this.pipesCount = 0;
            this.flowing = null;
            this.ended = false;
            this.endEmitted = false;
            this.reading = false; // a flag to be able to tell if the event 'readable'/'data' is emitted
            // immediately, or on a later tick.  We set this to true at first, because
            // any actions that shouldn't happen until "later" should generally also
            // not happen before the first read call.
            this.sync = true; // whenever we return null, then we set a flag to say
            // that we're awaiting a 'readable' event emission.
            this.needReadable = false;
            this.emittedReadable = false;
            this.readableListening = false;
            this.resumeScheduled = false;
            this.paused = true; // Should close be emitted on destroy. Defaults to true.
            this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'end' (and potentially 'finish')
            this.autoDestroy = !!options.autoDestroy; // has it been destroyed
            this.destroyed = false; // Crypto is kind of old and crusty.  Historically, its default string
            // encoding is 'binary' so we have to make this configurable.
            // Everything else in the universe uses 'utf8', though.
            this.defaultEncoding = options.defaultEncoding || "utf8"; // the number of writers that are awaiting a drain event in .pipe()s
            this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled
            this.readingMore = false;
            this.decoder = null;
            this.encoding = null;
            if (options.encoding) {
              if (!StringDecoder)
                StringDecoder = require("string_decoder/").StringDecoder;
              this.decoder = new StringDecoder(options.encoding);
              this.encoding = options.encoding;
            }
          }
          function Readable(options) {
            Duplex = Duplex || require("./_stream_duplex");
            if (!_instanceof(this, Readable)) return new Readable(options); // Checking for a Stream.Duplex instance is faster here instead of inside
            // the ReadableState constructor, at least with V8 6.5
            var isDuplex = _instanceof(this, Duplex);
            this._readableState = new ReadableState(options, this, isDuplex); // legacy
            this.readable = true;
            if (options) {
              if (typeof options.read === "function") this._read = options.read;
              if (typeof options.destroy === "function")
                this._destroy = options.destroy;
            }
            Stream.call(this);
          }
          Object.defineProperty(Readable.prototype, "destroyed", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              if (this._readableState === undefined) {
                return false;
              }
              return this._readableState.destroyed;
            },
            set: function set(value) {
              // we ignore the value if the stream
              // has not been initialized yet
              if (!this._readableState) {
                return;
              } // backward compatibility, the user is explicitly
              // managing destroyed
              this._readableState.destroyed = value;
            }
          });
          Readable.prototype.destroy = destroyImpl.destroy;
          Readable.prototype._undestroy = destroyImpl.undestroy;
          Readable.prototype._destroy = function (err, cb) {
            cb(err);
          }; // Manually shove something into the read() buffer.
          // This returns true if the highWaterMark has not been hit yet,
          // similar to how Writable.write() returns true if you should
          // write() some more.
          Readable.prototype.push = function (chunk, encoding) {
            var state = this._readableState;
            var skipChunkCheck;
            if (!state.objectMode) {
              if (typeof chunk === "string") {
                encoding = encoding || state.defaultEncoding;
                if (encoding !== state.encoding) {
                  chunk = Buffer.from(chunk, encoding);
                  encoding = "";
                }
                skipChunkCheck = true;
              }
            } else {
              skipChunkCheck = true;
            }
            return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
          }; // Unshift should *always* be something directly out of read()
          Readable.prototype.unshift = function (chunk) {
            return readableAddChunk(this, chunk, null, true, false);
          };
          function readableAddChunk(
            stream,
            chunk,
            encoding,
            addToFront,
            skipChunkCheck
          ) {
            debug("readableAddChunk", chunk);
            var state = stream._readableState;
            if (chunk === null) {
              state.reading = false;
              onEofChunk(stream, state);
            } else {
              var er;
              if (!skipChunkCheck) er = chunkInvalid(state, chunk);
              if (er) {
                errorOrDestroy(stream, er);
              } else if (state.objectMode || (chunk && chunk.length > 0)) {
                if (
                  typeof chunk !== "string" &&
                  !state.objectMode &&
                  Object.getPrototypeOf(chunk) !== Buffer.prototype
                ) {
                  chunk = _uint8ArrayToBuffer(chunk);
                }
                if (addToFront) {
                  if (state.endEmitted)
                    errorOrDestroy(
                      stream,
                      new ERR_STREAM_UNSHIFT_AFTER_END_EVENT()
                    );
                  else addChunk(stream, state, chunk, true);
                } else if (state.ended) {
                  errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
                } else if (state.destroyed) {
                  return false;
                } else {
                  state.reading = false;
                  if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0)
                      addChunk(stream, state, chunk, false);
                    else maybeReadMore(stream, state);
                  } else {
                    addChunk(stream, state, chunk, false);
                  }
                }
              } else if (!addToFront) {
                state.reading = false;
                maybeReadMore(stream, state);
              }
            } // We can push more data if we are below the highWaterMark.
            // Also, if we have no data yet, we can stand some more bytes.
            // This is to work around cases where hwm=0, such as the repl.
            return (
              !state.ended &&
              (state.length < state.highWaterMark || state.length === 0)
            );
          }
          function addChunk(stream, state, chunk, addToFront) {
            if (state.flowing && state.length === 0 && !state.sync) {
              state.awaitDrain = 0;
              stream.emit("data", chunk);
            } else {
              // update the buffer info.
              state.length += state.objectMode ? 1 : chunk.length;
              if (addToFront) state.buffer.unshift(chunk);
              else state.buffer.push(chunk);
              if (state.needReadable) emitReadable(stream);
            }
            maybeReadMore(stream, state);
          }
          function chunkInvalid(state, chunk) {
            var er;
            if (
              !_isUint8Array(chunk) &&
              typeof chunk !== "string" &&
              chunk !== undefined &&
              !state.objectMode
            ) {
              er = new ERR_INVALID_ARG_TYPE(
                "chunk",
                ["string", "Buffer", "Uint8Array"],
                chunk
              );
            }
            return er;
          }
          Readable.prototype.isPaused = function () {
            return this._readableState.flowing === false;
          }; // backwards compatibility.
          Readable.prototype.setEncoding = function (enc) {
            if (!StringDecoder)
              StringDecoder = require("string_decoder/").StringDecoder;
            var decoder = new StringDecoder(enc);
            this._readableState.decoder = decoder; // If setEncoding(null), decoder.encoding equals utf8
            this._readableState.encoding = this._readableState.decoder.encoding; // Iterate over current buffer to convert already stored Buffers:
            var p = this._readableState.buffer.head;
            var content = "";
            while (p !== null) {
              content += decoder.write(p.data);
              p = p.next;
            }
            this._readableState.buffer.clear();
            if (content !== "") this._readableState.buffer.push(content);
            this._readableState.length = content.length;
            return this;
          }; // Don't raise the hwm > 1GB
          var MAX_HWM = 0x40000000;
          function computeNewHighWaterMark(n) {
            if (n >= MAX_HWM) {
              // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
              n = MAX_HWM;
            } else {
              // Get the next highest power of 2 to prevent increasing hwm excessively in
              // tiny amounts
              n--;
              n |= n >>> 1;
              n |= n >>> 2;
              n |= n >>> 4;
              n |= n >>> 8;
              n |= n >>> 16;
              n++;
            }
            return n;
          } // This function is designed to be inlinable, so please take care when making
          // changes to the function body.
          function howMuchToRead(n, state) {
            if (n <= 0 || (state.length === 0 && state.ended)) return 0;
            if (state.objectMode) return 1;
            if (n !== n) {
              // Only flow one buffer at a time
              if (state.flowing && state.length)
                return state.buffer.head.data.length;
              else return state.length;
            } // If we're asking for more than the current hwm, then raise the hwm.
            if (n > state.highWaterMark)
              state.highWaterMark = computeNewHighWaterMark(n);
            if (n <= state.length) return n; // Don't have enough
            if (!state.ended) {
              state.needReadable = true;
              return 0;
            }
            return state.length;
          } // you can override either this method, or the async _read(n) below.
          Readable.prototype.read = function (n) {
            debug("read", n);
            n = parseInt(n, 10);
            var state = this._readableState;
            var nOrig = n;
            if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
            // already have a bunch of data in the buffer, then just trigger
            // the 'readable' event and move on.
            if (
              n === 0 &&
              state.needReadable &&
              ((state.highWaterMark !== 0
                ? state.length >= state.highWaterMark
                : state.length > 0) ||
                state.ended)
            ) {
              debug("read: emitReadable", state.length, state.ended);
              if (state.length === 0 && state.ended) endReadable(this);
              else emitReadable(this);
              return null;
            }
            n = howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.
            if (n === 0 && state.ended) {
              if (state.length === 0) endReadable(this);
              return null;
            } // All the actual chunk generation logic needs to be
            // *below* the call to _read.  The reason is that in certain
            // synthetic stream cases, such as passthrough streams, _read
            // may be a completely synchronous operation which may change
            // the state of the read buffer, providing enough data when
            // before there was *not* enough.
            //
            // So, the steps are:
            // 1. Figure out what the state of things will be after we do
            // a read from the buffer.
            //
            // 2. If that resulting state will trigger a _read, then call _read.
            // Note that this may be asynchronous, or synchronous.  Yes, it is
            // deeply ugly to write APIs this way, but that still doesn't mean
            // that the Readable class should behave improperly, as streams are
            // designed to be sync/async agnostic.
            // Take note if the _read call is sync or async (ie, if the read call
            // has returned yet), so that we know whether or not it's safe to emit
            // 'readable' etc.
            //
            // 3. Actually pull the requested chunks out of the buffer and return.
            // if we need a readable event, then we need to do some reading.
            var doRead = state.needReadable;
            debug("need readable", doRead); // if we currently have less than the highWaterMark, then also read some
            if (state.length === 0 || state.length - n < state.highWaterMark) {
              doRead = true;
              debug("length less than watermark", doRead);
            } // however, if we've ended, then there's no point, and if we're already
            // reading, then it's unnecessary.
            if (state.ended || state.reading) {
              doRead = false;
              debug("reading or ended", doRead);
            } else if (doRead) {
              debug("do read");
              state.reading = true;
              state.sync = true; // if the length is currently zero, then we *need* a readable event.
              if (state.length === 0) state.needReadable = true; // call internal read method
              this._read(state.highWaterMark);
              state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
              // and we need to re-evaluate how much data we can return to the user.
              if (!state.reading) n = howMuchToRead(nOrig, state);
            }
            var ret;
            if (n > 0) ret = fromList(n, state);
            else ret = null;
            if (ret === null) {
              state.needReadable = state.length <= state.highWaterMark;
              n = 0;
            } else {
              state.length -= n;
              state.awaitDrain = 0;
            }
            if (state.length === 0) {
              // If we have nothing in the buffer, then we want to know
              // as soon as we *do* get something into the buffer.
              if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.
              if (nOrig !== n && state.ended) endReadable(this);
            }
            if (ret !== null) this.emit("data", ret);
            return ret;
          };
          function onEofChunk(stream, state) {
            debug("onEofChunk");
            if (state.ended) return;
            if (state.decoder) {
              var chunk = state.decoder.end();
              if (chunk && chunk.length) {
                state.buffer.push(chunk);
                state.length += state.objectMode ? 1 : chunk.length;
              }
            }
            state.ended = true;
            if (state.sync) {
              // if we are sync, wait until next tick to emit the data.
              // Otherwise we risk emitting data in the flow()
              // the readable code triggers during a read() call
              emitReadable(stream);
            } else {
              // emit 'readable' now to make sure it gets picked up.
              state.needReadable = false;
              if (!state.emittedReadable) {
                state.emittedReadable = true;
                emitReadable_(stream);
              }
            }
          } // Don't emit readable right away in sync mode, because this can trigger
          // another read() call => stack overflow.  This way, it might trigger
          // a nextTick recursion warning, but that's not so bad.
          function emitReadable(stream) {
            var state = stream._readableState;
            debug("emitReadable", state.needReadable, state.emittedReadable);
            state.needReadable = false;
            if (!state.emittedReadable) {
              debug("emitReadable", state.flowing);
              state.emittedReadable = true;
              process.nextTick(emitReadable_, stream);
            }
          }
          function emitReadable_(stream) {
            var state = stream._readableState;
            debug("emitReadable_", state.destroyed, state.length, state.ended);
            if (!state.destroyed && (state.length || state.ended)) {
              stream.emit("readable");
              state.emittedReadable = false;
            } // The stream needs another readable event if
            // 1. It is not flowing, as the flow mechanism will take
            //    care of it.
            // 2. It is not ended.
            // 3. It is below the highWaterMark, so we can schedule
            //    another readable later.
            state.needReadable =
              !state.flowing &&
              !state.ended &&
              state.length <= state.highWaterMark;
            flow(stream);
          } // at this point, the user has presumably seen the 'readable' event,
          // and called read() to consume some data.  that may have triggered
          // in turn another _read(n) call, in which case reading = true if
          // it's in progress.
          // However, if we're not ended, or reading, and the length < hwm,
          // then go ahead and try to read some more preemptively.
          function maybeReadMore(stream, state) {
            if (!state.readingMore) {
              state.readingMore = true;
              process.nextTick(maybeReadMore_, stream, state);
            }
          }
          function maybeReadMore_(stream, state) {
            // Attempt to read more data if we should.
            //
            // The conditions for reading more data are (one of):
            // - Not enough data buffered (state.length < state.highWaterMark). The loop
            //   is responsible for filling the buffer with enough data if such data
            //   is available. If highWaterMark is 0 and we are not in the flowing mode
            //   we should _not_ attempt to buffer any extra data. We'll get more data
            //   when the stream consumer calls read() instead.
            // - No data in the buffer, and the stream is in flowing mode. In this mode
            //   the loop below is responsible for ensuring read() is called. Failing to
            //   call read here would abort the flow and there's no other mechanism for
            //   continuing the flow if the stream consumer has just subscribed to the
            //   'data' event.
            //
            // In addition to the above conditions to keep reading data, the following
            // conditions prevent the data from being read:
            // - The stream has ended (state.ended).
            // - There is already a pending 'read' operation (state.reading). This is a
            //   case where the the stream has called the implementation defined _read()
            //   method, but they are processing the call asynchronously and have _not_
            //   called push() with new data. In this case we skip performing more
            //   read()s. The execution ends in this method again after the _read() ends
            //   up calling push() with more data.
            while (
              !state.reading &&
              !state.ended &&
              (state.length < state.highWaterMark ||
                (state.flowing && state.length === 0))
            ) {
              var len = state.length;
              debug("maybeReadMore read 0");
              stream.read(0);
              if (len === state.length)
                // didn't get any data, stop spinning.
                break;
            }
            state.readingMore = false;
          } // abstract method.  to be overridden in specific implementation classes.
          // call cb(er, data) where data is <= n in length.
          // for virtual (non-string, non-buffer) streams, "length" is somewhat
          // arbitrary, and perhaps not very meaningful.
          Readable.prototype._read = function (n) {
            errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED("_read()"));
          };
          Readable.prototype.pipe = function (dest, pipeOpts) {
            var src = this;
            var state = this._readableState;
            switch (state.pipesCount) {
              case 0:
                state.pipes = dest;
                break;
              case 1:
                state.pipes = [state.pipes, dest];
                break;
              default:
                state.pipes.push(dest);
                break;
            }
            state.pipesCount += 1;
            debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
            var doEnd =
              (!pipeOpts || pipeOpts.end !== false) &&
              dest !== process.stdout &&
              dest !== process.stderr;
            var endFn = doEnd ? onend : unpipe;
            if (state.endEmitted) process.nextTick(endFn);
            else src.once("end", endFn);
            dest.on("unpipe", onunpipe);
            function onunpipe(readable, unpipeInfo) {
              debug("onunpipe");
              if (readable === src) {
                if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                  unpipeInfo.hasUnpiped = true;
                  cleanup();
                }
              }
            }
            function onend() {
              debug("onend");
              dest.end();
            } // when the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            var ondrain = pipeOnDrain(src);
            dest.on("drain", ondrain);
            var cleanedUp = false;
            function cleanup() {
              debug("cleanup"); // cleanup event handlers once the pipe is broken
              dest.removeListener("close", onclose);
              dest.removeListener("finish", onfinish);
              dest.removeListener("drain", ondrain);
              dest.removeListener("error", onerror);
              dest.removeListener("unpipe", onunpipe);
              src.removeListener("end", onend);
              src.removeListener("end", unpipe);
              src.removeListener("data", ondata);
              cleanedUp = true; // if the reader is waiting for a drain event from this
              // specific writer, then it would cause it to never start
              // flowing again.
              // So, if this is awaiting a drain, then we just call it now.
              // If we don't know, then assume that we are waiting for one.
              if (
                state.awaitDrain &&
                (!dest._writableState || dest._writableState.needDrain)
              )
                ondrain();
            }
            src.on("data", ondata);
            function ondata(chunk) {
              debug("ondata");
              var ret = dest.write(chunk);
              debug("dest.write", ret);
              if (ret === false) {
                // If the user unpiped during `dest.write()`, it is possible
                // to get stuck in a permanently paused state if that write
                // also returned false.
                // => Check whether `dest` is still a piping destination.
                if (
                  ((state.pipesCount === 1 && state.pipes === dest) ||
                    (state.pipesCount > 1 &&
                      indexOf(state.pipes, dest) !== -1)) &&
                  !cleanedUp
                ) {
                  debug("false write response, pause", state.awaitDrain);
                  state.awaitDrain++;
                }
                src.pause();
              }
            } // if the dest has an error, then stop piping into it.
            // however, don't suppress the throwing behavior for this.
            function onerror(er) {
              debug("onerror", er);
              unpipe();
              dest.removeListener("error", onerror);
              if (EElistenerCount(dest, "error") === 0) errorOrDestroy(dest, er);
            } // Make sure our error handler is attached before userland ones.
            prependListener(dest, "error", onerror); // Both close and finish should trigger unpipe, but only once.
            function onclose() {
              dest.removeListener("finish", onfinish);
              unpipe();
            }
            dest.once("close", onclose);
            function onfinish() {
              debug("onfinish");
              dest.removeListener("close", onclose);
              unpipe();
            }
            dest.once("finish", onfinish);
            function unpipe() {
              debug("unpipe");
              src.unpipe(dest);
            } // tell the dest that it's being piped to
            dest.emit("pipe", src); // start the flow if it hasn't been started already.
            if (!state.flowing) {
              debug("pipe resume");
              src.resume();
            }
            return dest;
          };
          function pipeOnDrain(src) {
            return function pipeOnDrainFunctionResult() {
              var state = src._readableState;
              debug("pipeOnDrain", state.awaitDrain);
              if (state.awaitDrain) state.awaitDrain--;
              if (state.awaitDrain === 0 && EElistenerCount(src, "data")) {
                state.flowing = true;
                flow(src);
              }
            };
          }
          Readable.prototype.unpipe = function (dest) {
            var state = this._readableState;
            var unpipeInfo = { hasUnpiped: false }; // if we're not piping anywhere, then do nothing.
            if (state.pipesCount === 0) return this; // just one destination.  most common case.
            if (state.pipesCount === 1) {
              // passed in one, but it's not the right one.
              if (dest && dest !== state.pipes) return this;
              if (!dest) dest = state.pipes; // got a match.
              state.pipes = null;
              state.pipesCount = 0;
              state.flowing = false;
              if (dest) dest.emit("unpipe", this, unpipeInfo);
              return this;
            } // slow case. multiple pipe destinations.
            if (!dest) {
              // remove all.
              var dests = state.pipes;
              var len = state.pipesCount;
              state.pipes = null;
              state.pipesCount = 0;
              state.flowing = false;
              for (var i = 0; i < len; i++) {
                dests[i].emit("unpipe", this, { hasUnpiped: false });
              }
              return this;
            } // try to find the right one.
            var index = indexOf(state.pipes, dest);
            if (index === -1) return this;
            state.pipes.splice(index, 1);
            state.pipesCount -= 1;
            if (state.pipesCount === 1) state.pipes = state.pipes[0];
            dest.emit("unpipe", this, unpipeInfo);
            return this;
          }; // set up data events if they are asked for
          // Ensure readable listeners eventually get something
          Readable.prototype.on = function (ev, fn) {
            var res = Stream.prototype.on.call(this, ev, fn);
            var state = this._readableState;
            if (ev === "data") {
              // update readableListening so that resume() may be a no-op
              // a few lines down. This is needed to support once('readable').
              state.readableListening = this.listenerCount("readable") > 0; // Try start flowing on next tick if stream isn't explicitly paused
              if (state.flowing !== false) this.resume();
            } else if (ev === "readable") {
              if (!state.endEmitted && !state.readableListening) {
                state.readableListening = state.needReadable = true;
                state.flowing = false;
                state.emittedReadable = false;
                debug("on readable", state.length, state.reading);
                if (state.length) {
                  emitReadable(this);
                } else if (!state.reading) {
                  process.nextTick(nReadingNextTick, this);
                }
              }
            }
            return res;
          };
          Readable.prototype.addListener = Readable.prototype.on;
          Readable.prototype.removeListener = function (ev, fn) {
            var res = Stream.prototype.removeListener.call(this, ev, fn);
            if (ev === "readable") {
              // We need to check if there is someone still listening to
              // readable and reset the state. However this needs to happen
              // after readable has been emitted but before I/O (nextTick) to
              // support once('readable', fn) cycles. This means that calling
              // resume within the same tick will have no
              // effect.
              process.nextTick(updateReadableListening, this);
            }
            return res;
          };
          Readable.prototype.removeAllListeners = function (ev) {
            var res = Stream.prototype.removeAllListeners.apply(this, arguments);
            if (ev === "readable" || ev === undefined) {
              // We need to check if there is someone still listening to
              // readable and reset the state. However this needs to happen
              // after readable has been emitted but before I/O (nextTick) to
              // support once('readable', fn) cycles. This means that calling
              // resume within the same tick will have no
              // effect.
              process.nextTick(updateReadableListening, this);
            }
            return res;
          };
          function updateReadableListening(self) {
            var state = self._readableState;
            state.readableListening = self.listenerCount("readable") > 0;
            if (state.resumeScheduled && !state.paused) {
              // flowing needs to be set to true now, otherwise
              // the upcoming resume will not flow.
              state.flowing = true; // crude way to check if we should resume
            } else if (self.listenerCount("data") > 0) {
              self.resume();
            }
          }
          function nReadingNextTick(self) {
            debug("readable nexttick read 0");
            self.read(0);
          } // pause() and resume() are remnants of the legacy readable stream API
          // If the user uses them, then switch into old mode.
          Readable.prototype.resume = function () {
            var state = this._readableState;
            if (!state.flowing) {
              debug("resume"); // we flow only if there is no one listening
              // for readable, but we still have to call
              // resume()
              state.flowing = !state.readableListening;
              resume(this, state);
            }
            state.paused = false;
            return this;
          };
          function resume(stream, state) {
            if (!state.resumeScheduled) {
              state.resumeScheduled = true;
              process.nextTick(resume_, stream, state);
            }
          }
          function resume_(stream, state) {
            debug("resume", state.reading);
            if (!state.reading) {
              stream.read(0);
            }
            state.resumeScheduled = false;
            stream.emit("resume");
            flow(stream);
            if (state.flowing && !state.reading) stream.read(0);
          }
          Readable.prototype.pause = function () {
            debug("call pause flowing=%j", this._readableState.flowing);
            if (this._readableState.flowing !== false) {
              debug("pause");
              this._readableState.flowing = false;
              this.emit("pause");
            }
            this._readableState.paused = true;
            return this;
          };
          function flow(stream) {
            var state = stream._readableState;
            debug("flow", state.flowing);
            while (state.flowing && stream.read() !== null) {}
          } // wrap an old-style stream as the async data source.
          // This is *not* part of the readable stream interface.
          // It is an ugly unfortunate mess of history.
          Readable.prototype.wrap = function (stream) {
            var _this = this;
            var state = this._readableState;
            var paused = false;
            stream.on("end", function () {
              debug("wrapped end");
              if (state.decoder && !state.ended) {
                var chunk = state.decoder.end();
                if (chunk && chunk.length) _this.push(chunk);
              }
              _this.push(null);
            });
            stream.on("data", function (chunk) {
              debug("wrapped data");
              if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode
              if (state.objectMode && (chunk === null || chunk === undefined))
                return;
              else if (!state.objectMode && (!chunk || !chunk.length)) return;
              var ret = _this.push(chunk);
              if (!ret) {
                paused = true;
                stream.pause();
              }
            }); // proxy all the other methods.
            // important when wrapping filters and duplexes.
            for (var i in stream) {
              if (this[i] === undefined && typeof stream[i] === "function") {
                this[i] = (function methodWrap(method) {
                  return function methodWrapReturnFunction() {
                    return stream[method].apply(stream, arguments);
                  };
                })(i);
              }
            } // proxy certain important events.
            for (var n = 0; n < kProxyEvents.length; n++) {
              stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
            } // when we try to consume some more bytes, simply unpause the
            // underlying stream.
            this._read = function (n) {
              debug("wrapped _read", n);
              if (paused) {
                paused = false;
                stream.resume();
              }
            };
            return this;
          };
          if (typeof Symbol === "function") {
            Readable.prototype[Symbol.asyncIterator] = function () {
              if (createReadableStreamAsyncIterator === undefined) {
                createReadableStreamAsyncIterator = require("./internal/streams/async_iterator");
              }
              return createReadableStreamAsyncIterator(this);
            };
          }
          Object.defineProperty(Readable.prototype, "readableHighWaterMark", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._readableState.highWaterMark;
            }
          });
          Object.defineProperty(Readable.prototype, "readableBuffer", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._readableState && this._readableState.buffer;
            }
          });
          Object.defineProperty(Readable.prototype, "readableFlowing", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._readableState.flowing;
            },
            set: function set(state) {
              if (this._readableState) {
                this._readableState.flowing = state;
              }
            }
          }); // exposed for testing purposes only.
          Readable._fromList = fromList;
          Object.defineProperty(Readable.prototype, "readableLength", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._readableState.length;
            }
          }); // Pluck off n bytes from an array of buffers.
          // Length is the combined lengths of all the buffers in the list.
          // This function is designed to be inlinable, so please take care when making
          // changes to the function body.
          function fromList(n, state) {
            // nothing buffered
            if (state.length === 0) return null;
            var ret;
            if (state.objectMode) ret = state.buffer.shift();
            else if (!n || n >= state.length) {
              // read it all, truncate the list
              if (state.decoder) ret = state.buffer.join("");
              else if (state.buffer.length === 1) ret = state.buffer.first();
              else ret = state.buffer.concat(state.length);
              state.buffer.clear();
            } else {
              // read part of list
              ret = state.buffer.consume(n, state.decoder);
            }
            return ret;
          }
          function endReadable(stream) {
            var state = stream._readableState;
            debug("endReadable", state.endEmitted);
            if (!state.endEmitted) {
              state.ended = true;
              process.nextTick(endReadableNT, state, stream);
            }
          }
          function endReadableNT(state, stream) {
            debug("endReadableNT", state.endEmitted, state.length); // Check that we didn't get one last unshift.
            if (!state.endEmitted && state.length === 0) {
              state.endEmitted = true;
              stream.readable = false;
              stream.emit("end");
              if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the writable side is ready for autoDestroy as well
                var wState = stream._writableState;
                if (!wState || (wState.autoDestroy && wState.finished)) {
                  stream.destroy();
                }
              }
            }
          }
          if (typeof Symbol === "function") {
            Readable.from = function (iterable, opts) {
              if (from === undefined) {
                from = require("./internal/streams/from");
              }
              return from(Readable, iterable, opts);
            };
          }
          function indexOf(xs, x) {
            for (var i = 0, l = xs.length; i < l; i++) {
              if (xs[i] === x) return i;
            }
            return -1;
          }
        },
        {
          process: "ec0e1432c6522aad9b4b16c4b3b080f4",
          events: "b7e625dd36a8c733268400e6bdb0e234",
          "./internal/streams/stream": "5d35e9f012acc4319e35d8ff884e0bd4",
          buffer: "1948b2a05a083f82087512f711e79e4d",
          util: "83fb80501e6599b7f0cf455c47cd5c1a",
          "./internal/streams/buffer_list": "12ddb1fc53368b1402939b904cc1e3cd",
          "./internal/streams/destroy": "4288da1d0dc2bd7b6cf634941f70c552",
          "./internal/streams/state": "c8b3767486ba55d86d202c068c5ec530",
          "../errors": "22051e8467f556273ed5280585844add",
          inherits: "9a4ae5d8f832c8333ee4e7b933c46353",
          "./_stream_duplex": "6b667e5880fd1eed1d4a8b5ddb47b706",
          "string_decoder/": "19f62334fa8f609f5137742f3fba9fc2",
          "./internal/streams/async_iterator": "3428dcd916264d180fbf25757bd2fe80",
          "./internal/streams/from": "c18627540980b97942fae90d923cab14"
        }
      ],
      "5d35e9f012acc4319e35d8ff884e0bd4": [
        function (require, module, exports) {
          module.exports = require("events").EventEmitter;
        },
        { events: "b7e625dd36a8c733268400e6bdb0e234" }
      ],
      "12ddb1fc53368b1402939b904cc1e3cd": [
        function (require, module, exports) {
          "use strict";
          function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
              var symbols = Object.getOwnPropertySymbols(object);
              if (enumerableOnly)
                symbols = symbols.filter(function (sym) {
                  return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                });
              keys.push.apply(keys, symbols);
            }
            return keys;
          }
          function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i] != null ? arguments[i] : {};
              if (i % 2) {
                ownKeys(Object(source), true).forEach(function (key) {
                  _defineProperty(target, key, source[key]);
                });
              } else if (Object.getOwnPropertyDescriptors) {
                Object.defineProperties(
                  target,
                  Object.getOwnPropertyDescriptors(source)
                );
              } else {
                ownKeys(Object(source)).forEach(function (key) {
                  Object.defineProperty(
                    target,
                    key,
                    Object.getOwnPropertyDescriptor(source, key)
                  );
                });
              }
            }
            return target;
          }
          function _defineProperty(obj, key, value) {
            if (key in obj) {
              Object.defineProperty(obj, key, {
                value: value,
                enumerable: true,
                configurable: true,
                writable: true
              });
            } else {
              obj[key] = value;
            }
            return obj;
          }
          function _classCallCheck(instance, Constructor) {
            if (!_instanceof(instance, Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) _defineProperties(Constructor.prototype, protoProps);
            if (staticProps) _defineProperties(Constructor, staticProps);
            return Constructor;
          }
          var _require = require("buffer"),
            Buffer = _require.Buffer;
          var _require2 = require("util"),
            inspect = _require2.inspect;
          var custom = (inspect && inspect.custom) || "inspect";
          function copyBuffer(src, target, offset) {
            Buffer.prototype.copy.call(src, target, offset);
          }
          module.exports = /*#__PURE__*/ (function () {
            function BufferList() {
              _classCallCheck(this, BufferList);
              this.head = null;
              this.tail = null;
              this.length = 0;
            }
            _createClass(BufferList, [
              {
                key: "push",
                value: function push(v) {
                  var entry = { data: v, next: null };
                  if (this.length > 0) this.tail.next = entry;
                  else this.head = entry;
                  this.tail = entry;
                  ++this.length;
                }
              },
              {
                key: "unshift",
                value: function unshift(v) {
                  var entry = { data: v, next: this.head };
                  if (this.length === 0) this.tail = entry;
                  this.head = entry;
                  ++this.length;
                }
              },
              {
                key: "shift",
                value: function shift() {
                  if (this.length === 0) return;
                  var ret = this.head.data;
                  if (this.length === 1) this.head = this.tail = null;
                  else this.head = this.head.next;
                  --this.length;
                  return ret;
                }
              },
              {
                key: "clear",
                value: function clear() {
                  this.head = this.tail = null;
                  this.length = 0;
                }
              },
              {
                key: "join",
                value: function join(s) {
                  if (this.length === 0) return "";
                  var p = this.head;
                  var ret = "" + p.data;
                  while ((p = p.next)) {
                    ret += s + p.data;
                  }
                  return ret;
                }
              },
              {
                key: "concat",
                value: function concat(n) {
                  if (this.length === 0) return Buffer.alloc(0);
                  var ret = Buffer.allocUnsafe(n >>> 0);
                  var p = this.head;
                  var i = 0;
                  while (p) {
                    copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                  }
                  return ret;
                } // Consumes a specified amount of bytes or characters from the buffered data.
              },
              {
                key: "consume",
                value: function consume(n, hasStrings) {
                  var ret;
                  if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                  } else if (n === this.head.data.length) {
                    // First chunk is a perfect match.
                    ret = this.shift();
                  } else {
                    // Result spans more than one buffer.
                    ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                  }
                  return ret;
                }
              },
              {
                key: "first",
                value: function first() {
                  return this.head.data;
                } // Consumes a specified amount of characters from the buffered data.
              },
              {
                key: "_getString",
                value: function _getString(n) {
                  var p = this.head;
                  var c = 1;
                  var ret = p.data;
                  n -= ret.length;
                  while ((p = p.next)) {
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                      if (nb === str.length) {
                        ++c;
                        if (p.next) this.head = p.next;
                        else this.head = this.tail = null;
                      } else {
                        this.head = p;
                        p.data = str.slice(nb);
                      }
                      break;
                    }
                    ++c;
                  }
                  this.length -= c;
                  return ret;
                } // Consumes a specified amount of bytes from the buffered data.
              },
              {
                key: "_getBuffer",
                value: function _getBuffer(n) {
                  var ret = Buffer.allocUnsafe(n);
                  var p = this.head;
                  var c = 1;
                  p.data.copy(ret);
                  n -= p.data.length;
                  while ((p = p.next)) {
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                      if (nb === buf.length) {
                        ++c;
                        if (p.next) this.head = p.next;
                        else this.head = this.tail = null;
                      } else {
                        this.head = p;
                        p.data = buf.slice(nb);
                      }
                      break;
                    }
                    ++c;
                  }
                  this.length -= c;
                  return ret;
                } // Make sure the linked list only shows the minimal necessary information.
              },
              {
                key: custom,
                value: function value(_, options) {
                  return inspect(
                    this,
                    _objectSpread({}, options, {
                      // Only inspect one level.
                      depth: 0, // It should not recurse.
                      customInspect: false
                    })
                  );
                }
              }
            ]);
            return BufferList;
          })();
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          util: "83fb80501e6599b7f0cf455c47cd5c1a"
        }
      ],
      "4288da1d0dc2bd7b6cf634941f70c552": [
        function (require, module, exports) {
          "use strict"; // undocumented cb() API, needed for core, not for public API
          var process = require("process");
          function destroy(err, cb) {
            var _this = this;
            var readableDestroyed =
              this._readableState && this._readableState.destroyed;
            var writableDestroyed =
              this._writableState && this._writableState.destroyed;
            if (readableDestroyed || writableDestroyed) {
              if (cb) {
                cb(err);
              } else if (err) {
                if (!this._writableState) {
                  process.nextTick(emitErrorNT, this, err);
                } else if (!this._writableState.errorEmitted) {
                  this._writableState.errorEmitted = true;
                  process.nextTick(emitErrorNT, this, err);
                }
              }
              return this;
            } // we set destroyed to true before firing error callbacks in order
            // to make it re-entrance safe in case destroy() is called within callbacks
            if (this._readableState) {
              this._readableState.destroyed = true;
            } // if this is a duplex stream mark the writable part as destroyed as well
            if (this._writableState) {
              this._writableState.destroyed = true;
            }
            this._destroy(err || null, function (err) {
              if (!cb && err) {
                if (!_this._writableState) {
                  process.nextTick(emitErrorAndCloseNT, _this, err);
                } else if (!_this._writableState.errorEmitted) {
                  _this._writableState.errorEmitted = true;
                  process.nextTick(emitErrorAndCloseNT, _this, err);
                } else {
                  process.nextTick(emitCloseNT, _this);
                }
              } else if (cb) {
                process.nextTick(emitCloseNT, _this);
                cb(err);
              } else {
                process.nextTick(emitCloseNT, _this);
              }
            });
            return this;
          }
          function emitErrorAndCloseNT(self, err) {
            emitErrorNT(self, err);
            emitCloseNT(self);
          }
          function emitCloseNT(self) {
            if (self._writableState && !self._writableState.emitClose) return;
            if (self._readableState && !self._readableState.emitClose) return;
            self.emit("close");
          }
          function undestroy() {
            if (this._readableState) {
              this._readableState.destroyed = false;
              this._readableState.reading = false;
              this._readableState.ended = false;
              this._readableState.endEmitted = false;
            }
            if (this._writableState) {
              this._writableState.destroyed = false;
              this._writableState.ended = false;
              this._writableState.ending = false;
              this._writableState.finalCalled = false;
              this._writableState.prefinished = false;
              this._writableState.finished = false;
              this._writableState.errorEmitted = false;
            }
          }
          function emitErrorNT(self, err) {
            self.emit("error", err);
          }
          function errorOrDestroy(stream, err) {
            // We have tests that rely on errors being emitted
            // in the same tick, so changing this is semver major.
            // For now when you opt-in to autoDestroy we allow
            // the error to be emitted nextTick. In a future
            // semver major update we should change the default to this.
            var rState = stream._readableState;
            var wState = stream._writableState;
            if ((rState && rState.autoDestroy) || (wState && wState.autoDestroy))
              stream.destroy(err);
            else stream.emit("error", err);
          }
          module.exports = {
            destroy: destroy,
            undestroy: undestroy,
            errorOrDestroy: errorOrDestroy
          };
        },
        { process: "ec0e1432c6522aad9b4b16c4b3b080f4" }
      ],
      c8b3767486ba55d86d202c068c5ec530: [
        function (require, module, exports) {
          "use strict";
          var ERR_INVALID_OPT_VALUE = require("../../../errors").codes
            .ERR_INVALID_OPT_VALUE;
          function highWaterMarkFrom(options, isDuplex, duplexKey) {
            return options.highWaterMark != null
              ? options.highWaterMark
              : isDuplex
              ? options[duplexKey]
              : null;
          }
          function getHighWaterMark(state, options, duplexKey, isDuplex) {
            var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
            if (hwm != null) {
              if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
                var name = isDuplex ? duplexKey : "highWaterMark";
                throw new ERR_INVALID_OPT_VALUE(name, hwm);
              }
              return Math.floor(hwm);
            } // Default value
            return state.objectMode ? 16 : 16 * 1024;
          }
          module.exports = { getHighWaterMark: getHighWaterMark };
        },
        { "../../../errors": "22051e8467f556273ed5280585844add" }
      ],
      "22051e8467f556273ed5280585844add": [
        function (require, module, exports) {
          "use strict";
          function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            subClass.__proto__ = superClass;
          }
          var codes = {};
          function createErrorType(code, message, Base) {
            if (!Base) {
              Base = Error;
            }
            function getMessage(arg1, arg2, arg3) {
              if (typeof message === "string") {
                return message;
              } else {
                return message(arg1, arg2, arg3);
              }
            }
            var NodeError = /*#__PURE__*/ (function (_Base) {
              _inheritsLoose(NodeError, _Base);
              function NodeError(arg1, arg2, arg3) {
                return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
              }
              return NodeError;
            })(Base);
            NodeError.prototype.name = Base.name;
            NodeError.prototype.code = code;
            codes[code] = NodeError;
          } // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
          function oneOf(expected, thing) {
            if (Array.isArray(expected)) {
              var len = expected.length;
              expected = expected.map(function (i) {
                return String(i);
              });
              if (len > 2) {
                return (
                  "one of "
                    .concat(thing, " ")
                    .concat(expected.slice(0, len - 1).join(", "), ", or ") +
                  expected[len - 1]
                );
              } else if (len === 2) {
                return "one of "
                  .concat(thing, " ")
                  .concat(expected[0], " or ")
                  .concat(expected[1]);
              } else {
                return "of ".concat(thing, " ").concat(expected[0]);
              }
            } else {
              return "of ".concat(thing, " ").concat(String(expected));
            }
          } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
          function startsWith(str, search, pos) {
            return (
              str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search
            );
          } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
          function endsWith(str, search, this_len) {
            if (this_len === undefined || this_len > str.length) {
              this_len = str.length;
            }
            return str.substring(this_len - search.length, this_len) === search;
          } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
          function includes(str, search, start) {
            if (typeof start !== "number") {
              start = 0;
            }
            if (start + search.length > str.length) {
              return false;
            } else {
              return str.indexOf(search, start) !== -1;
            }
          }
          createErrorType(
            "ERR_INVALID_OPT_VALUE",
            function (name, value) {
              return (
                'The value "' + value + '" is invalid for option "' + name + '"'
              );
            },
            TypeError
          );
          createErrorType(
            "ERR_INVALID_ARG_TYPE",
            function (name, expected, actual) {
              // determiner: 'must be' or 'must not be'
              var determiner;
              if (typeof expected === "string" && startsWith(expected, "not ")) {
                determiner = "must not be";
                expected = expected.replace(/^not /, "");
              } else {
                determiner = "must be";
              }
              var msg;
              if (endsWith(name, " argument")) {
                // For cases like 'first argument'
                msg = "The "
                  .concat(name, " ")
                  .concat(determiner, " ")
                  .concat(oneOf(expected, "type"));
              } else {
                var type = includes(name, ".") ? "property" : "argument";
                msg = 'The "'
                  .concat(name, '" ')
                  .concat(type, " ")
                  .concat(determiner, " ")
                  .concat(oneOf(expected, "type"));
              }
              msg += ". Received type ".concat(_typeof2(actual));
              return msg;
            },
            TypeError
          );
          createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
          createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function (name) {
            return "The " + name + " method is not implemented";
          });
          createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
          createErrorType("ERR_STREAM_DESTROYED", function (name) {
            return "Cannot call " + name + " after a stream was destroyed";
          });
          createErrorType(
            "ERR_MULTIPLE_CALLBACK",
            "Callback called multiple times"
          );
          createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
          createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
          createErrorType(
            "ERR_STREAM_NULL_VALUES",
            "May not write null values to stream",
            TypeError
          );
          createErrorType(
            "ERR_UNKNOWN_ENCODING",
            function (arg) {
              return "Unknown encoding: " + arg;
            },
            TypeError
          );
          createErrorType(
            "ERR_STREAM_UNSHIFT_AFTER_END_EVENT",
            "stream.unshift() after end event"
          );
          module.exports.codes = codes;
        },
        {}
      ],
      "6b667e5880fd1eed1d4a8b5ddb47b706": [
        function (require, module, exports) {
          // Copyright Joyent, Inc. and other Node contributors.
          //
          // Permission is hereby granted, free of charge, to any person obtaining a
          // copy of this software and associated documentation files (the
          // "Software"), to deal in the Software without restriction, including
          // without limitation the rights to use, copy, modify, merge, publish,
          // distribute, sublicense, and/or sell copies of the Software, and to permit
          // persons to whom the Software is furnished to do so, subject to the
          // following conditions:
          //
          // The above copyright notice and this permission notice shall be included
          // in all copies or substantial portions of the Software.
          //
          // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
          // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
          // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
          // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
          // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
          // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
          // USE OR OTHER DEALINGS IN THE SOFTWARE.
          // a duplex stream is just a stream that is both readable and writable.
          // Since JS doesn't have multiple prototypal inheritance, this class
          // prototypally inherits from Readable, and then parasitically from
          // Writable.
          "use strict";
          /*<replacement>*/ var process = require("process");
          var objectKeys =
            Object.keys ||
            function (obj) {
              var keys = [];
              for (var key in obj) {
                keys.push(key);
              }
              return keys;
            };
          /*</replacement>*/ module.exports = Duplex;
          var Readable = require("./_stream_readable");
          var Writable = require("./_stream_writable");
          require("inherits")(Duplex, Readable);
          {
            // Allow the keys array to be GC'ed.
            var keys = objectKeys(Writable.prototype);
            for (var v = 0; v < keys.length; v++) {
              var method = keys[v];
              if (!Duplex.prototype[method])
                Duplex.prototype[method] = Writable.prototype[method];
            }
          }
          function Duplex(options) {
            if (!_instanceof(this, Duplex)) return new Duplex(options);
            Readable.call(this, options);
            Writable.call(this, options);
            this.allowHalfOpen = true;
            if (options) {
              if (options.readable === false) this.readable = false;
              if (options.writable === false) this.writable = false;
              if (options.allowHalfOpen === false) {
                this.allowHalfOpen = false;
                this.once("end", onend);
              }
            }
          }
          Object.defineProperty(Duplex.prototype, "writableHighWaterMark", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._writableState.highWaterMark;
            }
          });
          Object.defineProperty(Duplex.prototype, "writableBuffer", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._writableState && this._writableState.getBuffer();
            }
          });
          Object.defineProperty(Duplex.prototype, "writableLength", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._writableState.length;
            }
          }); // the no-half-open enforcer
          function onend() {
            // If the writable side ended, then we're ok.
            if (this._writableState.ended) return; // no more data can be written.
            // But allow more writes to happen in this tick.
            process.nextTick(onEndNT, this);
          }
          function onEndNT(self) {
            self.end();
          }
          Object.defineProperty(Duplex.prototype, "destroyed", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              if (
                this._readableState === undefined ||
                this._writableState === undefined
              ) {
                return false;
              }
              return (
                this._readableState.destroyed && this._writableState.destroyed
              );
            },
            set: function set(value) {
              // we ignore the value if the stream
              // has not been initialized yet
              if (
                this._readableState === undefined ||
                this._writableState === undefined
              ) {
                return;
              } // backward compatibility, the user is explicitly
              // managing destroyed
              this._readableState.destroyed = value;
              this._writableState.destroyed = value;
            }
          });
        },
        {
          process: "ec0e1432c6522aad9b4b16c4b3b080f4",
          "./_stream_readable": "1651b545c585f8a8557608d4a0e121d6",
          "./_stream_writable": "a56d982b804ceee4a5b5b03c447bb5ad",
          inherits: "9a4ae5d8f832c8333ee4e7b933c46353"
        }
      ],
      a56d982b804ceee4a5b5b03c447bb5ad: [
        function (require, module, exports) {
          // Copyright Joyent, Inc. and other Node contributors.
          //
          // Permission is hereby granted, free of charge, to any person obtaining a
          // copy of this software and associated documentation files (the
          // "Software"), to deal in the Software without restriction, including
          // without limitation the rights to use, copy, modify, merge, publish,
          // distribute, sublicense, and/or sell copies of the Software, and to permit
          // persons to whom the Software is furnished to do so, subject to the
          // following conditions:
          //
          // The above copyright notice and this permission notice shall be included
          // in all copies or substantial portions of the Software.
          //
          // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
          // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
          // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
          // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
          // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
          // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
          // USE OR OTHER DEALINGS IN THE SOFTWARE.
          // A bit simpler than readable streams.
          // Implement an async ._write(chunk, encoding, cb), and it'll handle all
          // the drain event emission and buffering.
          "use strict";
          var global = arguments[3];
          var process = require("process");
          module.exports = Writable;
          /* <replacement> */ function WriteReq(chunk, encoding, cb) {
            this.chunk = chunk;
            this.encoding = encoding;
            this.callback = cb;
            this.next = null;
          } // It seems a linked list but it is not
          // there will be only 2 of these for each stream
          function CorkedRequest(state) {
            var _this = this;
            this.next = null;
            this.entry = null;
            this.finish = function () {
              onCorkedFinish(_this, state);
            };
          }
          /* </replacement> */ /*<replacement>*/ var Duplex;
          /*</replacement>*/ Writable.WritableState = WritableState;
          /*<replacement>*/ var internalUtil = {
            deprecate: require("util-deprecate")
          };
          /*</replacement>*/ /*<replacement>*/ var Stream = require("./internal/streams/stream");
          /*</replacement>*/ var Buffer = require("buffer").Buffer;
          var OurUint8Array = global.Uint8Array || function () {};
          function _uint8ArrayToBuffer(chunk) {
            return Buffer.from(chunk);
          }
          function _isUint8Array(obj) {
            return Buffer.isBuffer(obj) || _instanceof(obj, OurUint8Array);
          }
          var destroyImpl = require("./internal/streams/destroy");
          var _require = require("./internal/streams/state"),
            getHighWaterMark = _require.getHighWaterMark;
          var _require$codes = require("../errors").codes,
            ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
            ERR_METHOD_NOT_IMPLEMENTED =
              _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
            ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
            ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
            ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
            ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
            ERR_STREAM_WRITE_AFTER_END =
              _require$codes.ERR_STREAM_WRITE_AFTER_END,
            ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
          var errorOrDestroy = destroyImpl.errorOrDestroy;
          require("inherits")(Writable, Stream);
          function nop() {}
          function WritableState(options, stream, isDuplex) {
            Duplex = Duplex || require("./_stream_duplex");
            options = options || {}; // Duplex streams are both readable and writable, but share
            // the same options object.
            // However, some cases require setting options to different
            // values for the readable and the writable sides of the duplex stream,
            // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
            if (typeof isDuplex !== "boolean")
              isDuplex = _instanceof(stream, Duplex); // object stream flag to indicate whether or not this stream
            // contains buffers or objects.
            this.objectMode = !!options.objectMode;
            if (isDuplex)
              this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
            // Note: 0 is a valid value, means that we always return false if
            // the entire buffer is not flushed immediately on write()
            this.highWaterMark = getHighWaterMark(
              this,
              options,
              "writableHighWaterMark",
              isDuplex
            ); // if _final has been called
            this.finalCalled = false; // drain event flag.
            this.needDrain = false; // at the start of calling end()
            this.ending = false; // when end() has been called, and returned
            this.ended = false; // when 'finish' is emitted
            this.finished = false; // has it been destroyed
            this.destroyed = false; // should we decode strings into buffers before passing to _write?
            // this is here so that some node-core streams can optimize string
            // handling at a lower level.
            var noDecode = options.decodeStrings === false;
            this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
            // encoding is 'binary' so we have to make this configurable.
            // Everything else in the universe uses 'utf8', though.
            this.defaultEncoding = options.defaultEncoding || "utf8"; // not an actual buffer we keep track of, but a measurement
            // of how much we're waiting to get pushed to some underlying
            // socket or file.
            this.length = 0; // a flag to see when we're in the middle of a write.
            this.writing = false; // when true all writes will be buffered until .uncork() call
            this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
            // or on a later tick.  We set this to true at first, because any
            // actions that shouldn't happen until "later" should generally also
            // not happen before the first write call.
            this.sync = true; // a flag to know if we're processing previously buffered items, which
            // may call the _write() callback in the same tick, so that we don't
            // end up in an overlapped onwrite situation.
            this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)
            this.onwrite = function (er) {
              onwrite(stream, er);
            }; // the callback that the user supplies to write(chunk,encoding,cb)
            this.writecb = null; // the amount that is being written when _write is called.
            this.writelen = 0;
            this.bufferedRequest = null;
            this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
            // this must be 0 before 'finish' can be emitted
            this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
            // This is relevant for synchronous Transform streams
            this.prefinished = false; // True if the error was already emitted and should not be thrown again
            this.errorEmitted = false; // Should close be emitted on destroy. Defaults to true.
            this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'finish' (and potentially 'end')
            this.autoDestroy = !!options.autoDestroy; // count buffered requests
            this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
            // one allocated and free to use, and we maintain at most two
            this.corkedRequestsFree = new CorkedRequest(this);
          }
          WritableState.prototype.getBuffer = function getBuffer() {
            var current = this.bufferedRequest;
            var out = [];
            while (current) {
              out.push(current);
              current = current.next;
            }
            return out;
          };
          (function () {
            try {
              Object.defineProperty(WritableState.prototype, "buffer", {
                get: internalUtil.deprecate(
                  function writableStateBufferGetter() {
                    return this.getBuffer();
                  },
                  "_writableState.buffer is deprecated. Use _writableState.getBuffer " +
                    "instead.",
                  "DEP0003"
                )
              });
            } catch (_) {}
          })(); // Test _writableState for inheritance to account for Duplex streams,
          // whose prototype chain only points to Readable.
          var realHasInstance;
          if (
            typeof Symbol === "function" &&
            Symbol.hasInstance &&
            typeof Function.prototype[Symbol.hasInstance] === "function"
          ) {
            realHasInstance = Function.prototype[Symbol.hasInstance];
            Object.defineProperty(Writable, Symbol.hasInstance, {
              value: function value(object) {
                if (realHasInstance.call(this, object)) return true;
                if (this !== Writable) return false;
                return (
                  object && _instanceof(object._writableState, WritableState)
                );
              }
            });
          } else {
            realHasInstance = function realHasInstance(object) {
              return _instanceof(object, this);
            };
          }
          function Writable(options) {
            Duplex = Duplex || require("./_stream_duplex"); // Writable ctor is applied to Duplexes, too.
            // `realHasInstance` is necessary because using plain `instanceof`
            // would return false, as no `_writableState` property is attached.
            // Trying to use the custom `instanceof` for Writable here will also break the
            // Node.js LazyTransform implementation, which has a non-trivial getter for
            // `_writableState` that would lead to infinite recursion.
            // Checking for a Stream.Duplex instance is faster here instead of inside
            // the WritableState constructor, at least with V8 6.5
            var isDuplex = _instanceof(this, Duplex);
            if (!isDuplex && !realHasInstance.call(Writable, this))
              return new Writable(options);
            this._writableState = new WritableState(options, this, isDuplex); // legacy.
            this.writable = true;
            if (options) {
              if (typeof options.write === "function")
                this._write = options.write;
              if (typeof options.writev === "function")
                this._writev = options.writev;
              if (typeof options.destroy === "function")
                this._destroy = options.destroy;
              if (typeof options.final === "function")
                this._final = options.final;
            }
            Stream.call(this);
          } // Otherwise people can pipe Writable streams, which is just wrong.
          Writable.prototype.pipe = function () {
            errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
          };
          function writeAfterEnd(stream, cb) {
            var er = new ERR_STREAM_WRITE_AFTER_END(); // TODO: defer error events consistently everywhere, not just the cb
            errorOrDestroy(stream, er);
            process.nextTick(cb, er);
          } // Checks that a user-supplied chunk is valid, especially for the particular
          // mode the stream is in. Currently this means that `null` is never accepted
          // and undefined/non-string values are only allowed in object mode.
          function validChunk(stream, state, chunk, cb) {
            var er;
            if (chunk === null) {
              er = new ERR_STREAM_NULL_VALUES();
            } else if (typeof chunk !== "string" && !state.objectMode) {
              er = new ERR_INVALID_ARG_TYPE("chunk", ["string", "Buffer"], chunk);
            }
            if (er) {
              errorOrDestroy(stream, er);
              process.nextTick(cb, er);
              return false;
            }
            return true;
          }
          Writable.prototype.write = function (chunk, encoding, cb) {
            var state = this._writableState;
            var ret = false;
            var isBuf = !state.objectMode && _isUint8Array(chunk);
            if (isBuf && !Buffer.isBuffer(chunk)) {
              chunk = _uint8ArrayToBuffer(chunk);
            }
            if (typeof encoding === "function") {
              cb = encoding;
              encoding = null;
            }
            if (isBuf) encoding = "buffer";
            else if (!encoding) encoding = state.defaultEncoding;
            if (typeof cb !== "function") cb = nop;
            if (state.ending) writeAfterEnd(this, cb);
            else if (isBuf || validChunk(this, state, chunk, cb)) {
              state.pendingcb++;
              ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
            }
            return ret;
          };
          Writable.prototype.cork = function () {
            this._writableState.corked++;
          };
          Writable.prototype.uncork = function () {
            var state = this._writableState;
            if (state.corked) {
              state.corked--;
              if (
                !state.writing &&
                !state.corked &&
                !state.bufferProcessing &&
                state.bufferedRequest
              )
                clearBuffer(this, state);
            }
          };
          Writable.prototype.setDefaultEncoding = function setDefaultEncoding(
            encoding
          ) {
            // node::ParseEncoding() requires lower case.
            if (typeof encoding === "string") encoding = encoding.toLowerCase();
            if (
              !(
                [
                  "hex",
                  "utf8",
                  "utf-8",
                  "ascii",
                  "binary",
                  "base64",
                  "ucs2",
                  "ucs-2",
                  "utf16le",
                  "utf-16le",
                  "raw"
                ].indexOf((encoding + "").toLowerCase()) > -1
              )
            )
              throw new ERR_UNKNOWN_ENCODING(encoding);
            this._writableState.defaultEncoding = encoding;
            return this;
          };
          Object.defineProperty(Writable.prototype, "writableBuffer", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._writableState && this._writableState.getBuffer();
            }
          });
          function decodeChunk(state, chunk, encoding) {
            if (
              !state.objectMode &&
              state.decodeStrings !== false &&
              typeof chunk === "string"
            ) {
              chunk = Buffer.from(chunk, encoding);
            }
            return chunk;
          }
          Object.defineProperty(Writable.prototype, "writableHighWaterMark", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._writableState.highWaterMark;
            }
          }); // if we're already writing something, then just put this
          // in the queue, and wait our turn.  Otherwise, call _write
          // If we return false, then we need a drain event, so set that flag.
          function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
            if (!isBuf) {
              var newChunk = decodeChunk(state, chunk, encoding);
              if (chunk !== newChunk) {
                isBuf = true;
                encoding = "buffer";
                chunk = newChunk;
              }
            }
            var len = state.objectMode ? 1 : chunk.length;
            state.length += len;
            var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.
            if (!ret) state.needDrain = true;
            if (state.writing || state.corked) {
              var last = state.lastBufferedRequest;
              state.lastBufferedRequest = {
                chunk: chunk,
                encoding: encoding,
                isBuf: isBuf,
                callback: cb,
                next: null
              };
              if (last) {
                last.next = state.lastBufferedRequest;
              } else {
                state.bufferedRequest = state.lastBufferedRequest;
              }
              state.bufferedRequestCount += 1;
            } else {
              doWrite(stream, state, false, len, chunk, encoding, cb);
            }
            return ret;
          }
          function doWrite(stream, state, writev, len, chunk, encoding, cb) {
            state.writelen = len;
            state.writecb = cb;
            state.writing = true;
            state.sync = true;
            if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED("write"));
            else if (writev) stream._writev(chunk, state.onwrite);
            else stream._write(chunk, encoding, state.onwrite);
            state.sync = false;
          }
          function onwriteError(stream, state, sync, er, cb) {
            --state.pendingcb;
            if (sync) {
              // defer the callback if we are being called synchronously
              // to avoid piling up things on the stack
              process.nextTick(cb, er); // this can emit finish, and it will always happen
              // after error
              process.nextTick(finishMaybe, stream, state);
              stream._writableState.errorEmitted = true;
              errorOrDestroy(stream, er);
            } else {
              // the caller expect this to happen before if
              // it is async
              cb(er);
              stream._writableState.errorEmitted = true;
              errorOrDestroy(stream, er); // this can emit finish, but finish must
              // always follow error
              finishMaybe(stream, state);
            }
          }
          function onwriteStateUpdate(state) {
            state.writing = false;
            state.writecb = null;
            state.length -= state.writelen;
            state.writelen = 0;
          }
          function onwrite(stream, er) {
            var state = stream._writableState;
            var sync = state.sync;
            var cb = state.writecb;
            if (typeof cb !== "function") throw new ERR_MULTIPLE_CALLBACK();
            onwriteStateUpdate(state);
            if (er) onwriteError(stream, state, sync, er, cb);
            else {
              // Check if we're actually ready to finish, but don't emit yet
              var finished = needFinish(state) || stream.destroyed;
              if (
                !finished &&
                !state.corked &&
                !state.bufferProcessing &&
                state.bufferedRequest
              ) {
                clearBuffer(stream, state);
              }
              if (sync) {
                process.nextTick(afterWrite, stream, state, finished, cb);
              } else {
                afterWrite(stream, state, finished, cb);
              }
            }
          }
          function afterWrite(stream, state, finished, cb) {
            if (!finished) onwriteDrain(stream, state);
            state.pendingcb--;
            cb();
            finishMaybe(stream, state);
          } // Must force callback to be called on nextTick, so that we don't
          // emit 'drain' before the write() consumer gets the 'false' return
          // value, and has a chance to attach a 'drain' listener.
          function onwriteDrain(stream, state) {
            if (state.length === 0 && state.needDrain) {
              state.needDrain = false;
              stream.emit("drain");
            }
          } // if there's something in the buffer waiting, then process it
          function clearBuffer(stream, state) {
            state.bufferProcessing = true;
            var entry = state.bufferedRequest;
            if (stream._writev && entry && entry.next) {
              // Fast case, write everything using _writev()
              var l = state.bufferedRequestCount;
              var buffer = new Array(l);
              var holder = state.corkedRequestsFree;
              holder.entry = entry;
              var count = 0;
              var allBuffers = true;
              while (entry) {
                buffer[count] = entry;
                if (!entry.isBuf) allBuffers = false;
                entry = entry.next;
                count += 1;
              }
              buffer.allBuffers = allBuffers;
              doWrite(
                stream,
                state,
                true,
                state.length,
                buffer,
                "",
                holder.finish
              ); // doWrite is almost always async, defer these to save a bit of time
              // as the hot path ends with doWrite
              state.pendingcb++;
              state.lastBufferedRequest = null;
              if (holder.next) {
                state.corkedRequestsFree = holder.next;
                holder.next = null;
              } else {
                state.corkedRequestsFree = new CorkedRequest(state);
              }
              state.bufferedRequestCount = 0;
            } else {
              // Slow case, write chunks one-by-one
              while (entry) {
                var chunk = entry.chunk;
                var encoding = entry.encoding;
                var cb = entry.callback;
                var len = state.objectMode ? 1 : chunk.length;
                doWrite(stream, state, false, len, chunk, encoding, cb);
                entry = entry.next;
                state.bufferedRequestCount--; // if we didn't call the onwrite immediately, then
                // it means that we need to wait until it does.
                // also, that means that the chunk and cb are currently
                // being processed, so move the buffer counter past them.
                if (state.writing) {
                  break;
                }
              }
              if (entry === null) state.lastBufferedRequest = null;
            }
            state.bufferedRequest = entry;
            state.bufferProcessing = false;
          }
          Writable.prototype._write = function (chunk, encoding, cb) {
            cb(new ERR_METHOD_NOT_IMPLEMENTED("_write()"));
          };
          Writable.prototype._writev = null;
          Writable.prototype.end = function (chunk, encoding, cb) {
            var state = this._writableState;
            if (typeof chunk === "function") {
              cb = chunk;
              chunk = null;
              encoding = null;
            } else if (typeof encoding === "function") {
              cb = encoding;
              encoding = null;
            }
            if (chunk !== null && chunk !== undefined)
              this.write(chunk, encoding); // .end() fully uncorks
            if (state.corked) {
              state.corked = 1;
              this.uncork();
            } // ignore unnecessary end() calls.
            if (!state.ending) endWritable(this, state, cb);
            return this;
          };
          Object.defineProperty(Writable.prototype, "writableLength", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._writableState.length;
            }
          });
          function needFinish(state) {
            return (
              state.ending &&
              state.length === 0 &&
              state.bufferedRequest === null &&
              !state.finished &&
              !state.writing
            );
          }
          function callFinal(stream, state) {
            stream._final(function (err) {
              state.pendingcb--;
              if (err) {
                errorOrDestroy(stream, err);
              }
              state.prefinished = true;
              stream.emit("prefinish");
              finishMaybe(stream, state);
            });
          }
          function prefinish(stream, state) {
            if (!state.prefinished && !state.finalCalled) {
              if (typeof stream._final === "function" && !state.destroyed) {
                state.pendingcb++;
                state.finalCalled = true;
                process.nextTick(callFinal, stream, state);
              } else {
                state.prefinished = true;
                stream.emit("prefinish");
              }
            }
          }
          function finishMaybe(stream, state) {
            var need = needFinish(state);
            if (need) {
              prefinish(stream, state);
              if (state.pendingcb === 0) {
                state.finished = true;
                stream.emit("finish");
                if (state.autoDestroy) {
                  // In case of duplex streams we need a way to detect
                  // if the readable side is ready for autoDestroy as well
                  var rState = stream._readableState;
                  if (!rState || (rState.autoDestroy && rState.endEmitted)) {
                    stream.destroy();
                  }
                }
              }
            }
            return need;
          }
          function endWritable(stream, state, cb) {
            state.ending = true;
            finishMaybe(stream, state);
            if (cb) {
              if (state.finished) process.nextTick(cb);
              else stream.once("finish", cb);
            }
            state.ended = true;
            stream.writable = false;
          }
          function onCorkedFinish(corkReq, state, err) {
            var entry = corkReq.entry;
            corkReq.entry = null;
            while (entry) {
              var cb = entry.callback;
              state.pendingcb--;
              cb(err);
              entry = entry.next;
            } // reuse the free corkReq.
            state.corkedRequestsFree.next = corkReq;
          }
          Object.defineProperty(Writable.prototype, "destroyed", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              if (this._writableState === undefined) {
                return false;
              }
              return this._writableState.destroyed;
            },
            set: function set(value) {
              // we ignore the value if the stream
              // has not been initialized yet
              if (!this._writableState) {
                return;
              } // backward compatibility, the user is explicitly
              // managing destroyed
              this._writableState.destroyed = value;
            }
          });
          Writable.prototype.destroy = destroyImpl.destroy;
          Writable.prototype._undestroy = destroyImpl.undestroy;
          Writable.prototype._destroy = function (err, cb) {
            cb(err);
          };
        },
        {
          process: "ec0e1432c6522aad9b4b16c4b3b080f4",
          "util-deprecate": "6aa7731ae98b6edc7557dc4d43efd91e",
          "./internal/streams/stream": "5d35e9f012acc4319e35d8ff884e0bd4",
          buffer: "1948b2a05a083f82087512f711e79e4d",
          "./internal/streams/destroy": "4288da1d0dc2bd7b6cf634941f70c552",
          "./internal/streams/state": "c8b3767486ba55d86d202c068c5ec530",
          "../errors": "22051e8467f556273ed5280585844add",
          inherits: "9a4ae5d8f832c8333ee4e7b933c46353",
          "./_stream_duplex": "6b667e5880fd1eed1d4a8b5ddb47b706"
        }
      ],
      "6aa7731ae98b6edc7557dc4d43efd91e": [
        function (require, module, exports) {
          var global = arguments[3];
          /**
           * Module exports.
           */ module.exports = deprecate;
          /**
           * Mark that a method should not be used.
           * Returns a modified function which warns once by default.
           *
           * If `localStorage.noDeprecation = true` is set, then it is a no-op.
           *
           * If `localStorage.throwDeprecation = true` is set, then deprecated functions
           * will throw an Error when invoked.
           *
           * If `localStorage.traceDeprecation = true` is set, then deprecated functions
           * will invoke `console.trace()` instead of `console.error()`.
           *
           * @param {Function} fn - the function to deprecate
           * @param {String} msg - the string to print to the console when `fn` is invoked
           * @returns {Function} a new "deprecated" version of `fn`
           * @api public
           */ function deprecate(fn, msg) {
            if (config("noDeprecation")) {
              return fn;
            }
            var warned = false;
            function deprecated() {
              if (!warned) {
                if (config("throwDeprecation")) {
                  throw new Error(msg);
                } else if (config("traceDeprecation")) {
                  console.trace(msg);
                } else {
                  console.warn(msg);
                }
                warned = true;
              }
              return fn.apply(this, arguments);
            }
            return deprecated;
          }
          /**
           * Checks `localStorage` for boolean values for the given `name`.
           *
           * @param {String} name
           * @returns {Boolean}
           * @api private
           */ function config(name) {
            // accessing global.localStorage can trigger a DOMException in sandboxed iframes
            try {
              if (!global.localStorage) return false;
            } catch (_) {
              return false;
            }
            var val = global.localStorage[name];
            if (null == val) return false;
            return String(val).toLowerCase() === "true";
          }
        },
        {}
      ],
      "19f62334fa8f609f5137742f3fba9fc2": [
        function (require, module, exports) {
          // Copyright Joyent, Inc. and other Node contributors.
          //
          // Permission is hereby granted, free of charge, to any person obtaining a
          // copy of this software and associated documentation files (the
          // "Software"), to deal in the Software without restriction, including
          // without limitation the rights to use, copy, modify, merge, publish,
          // distribute, sublicense, and/or sell copies of the Software, and to permit
          // persons to whom the Software is furnished to do so, subject to the
          // following conditions:
          //
          // The above copyright notice and this permission notice shall be included
          // in all copies or substantial portions of the Software.
          //
          // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
          // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
          // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
          // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
          // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
          // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
          // USE OR OTHER DEALINGS IN THE SOFTWARE.
          "use strict";
          /*<replacement>*/ var Buffer = require("safe-buffer").Buffer;
          /*</replacement>*/ var isEncoding =
            Buffer.isEncoding ||
            function (encoding) {
              encoding = "" + encoding;
              switch (encoding && encoding.toLowerCase()) {
                case "hex":
                case "utf8":
                case "utf-8":
                case "ascii":
                case "binary":
                case "base64":
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                case "raw":
                  return true;
                default:
                  return false;
              }
            };
          function _normalizeEncoding(enc) {
            if (!enc) return "utf8";
            var retried;
            while (true) {
              switch (enc) {
                case "utf8":
                case "utf-8":
                  return "utf8";
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return "utf16le";
                case "latin1":
                case "binary":
                  return "latin1";
                case "base64":
                case "ascii":
                case "hex":
                  return enc;
                default:
                  if (retried) return; // undefined
                  enc = ("" + enc).toLowerCase();
                  retried = true;
              }
            }
          } // Do not cache `Buffer.isEncoding` when checking encoding names as some
          // modules monkey-patch it to support additional encodings
          function normalizeEncoding(enc) {
            var nenc = _normalizeEncoding(enc);
            if (
              typeof nenc !== "string" &&
              (Buffer.isEncoding === isEncoding || !isEncoding(enc))
            )
              throw new Error("Unknown encoding: " + enc);
            return nenc || enc;
          } // StringDecoder provides an interface for efficiently splitting a series of
          // buffers into a series of JS strings without breaking apart multi-byte
          // characters.
          exports.StringDecoder = StringDecoder;
          function StringDecoder(encoding) {
            this.encoding = normalizeEncoding(encoding);
            var nb;
            switch (this.encoding) {
              case "utf16le":
                this.text = utf16Text;
                this.end = utf16End;
                nb = 4;
                break;
              case "utf8":
                this.fillLast = utf8FillLast;
                nb = 4;
                break;
              case "base64":
                this.text = base64Text;
                this.end = base64End;
                nb = 3;
                break;
              default:
                this.write = simpleWrite;
                this.end = simpleEnd;
                return;
            }
            this.lastNeed = 0;
            this.lastTotal = 0;
            this.lastChar = Buffer.allocUnsafe(nb);
          }
          StringDecoder.prototype.write = function (buf) {
            if (buf.length === 0) return "";
            var r;
            var i;
            if (this.lastNeed) {
              r = this.fillLast(buf);
              if (r === undefined) return "";
              i = this.lastNeed;
              this.lastNeed = 0;
            } else {
              i = 0;
            }
            if (i < buf.length)
              return r ? r + this.text(buf, i) : this.text(buf, i);
            return r || "";
          };
          StringDecoder.prototype.end = utf8End; // Returns only complete characters in a Buffer
          StringDecoder.prototype.text = utf8Text; // Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
          StringDecoder.prototype.fillLast = function (buf) {
            if (this.lastNeed <= buf.length) {
              buf.copy(
                this.lastChar,
                this.lastTotal - this.lastNeed,
                0,
                this.lastNeed
              );
              return this.lastChar.toString(this.encoding, 0, this.lastTotal);
            }
            buf.copy(
              this.lastChar,
              this.lastTotal - this.lastNeed,
              0,
              buf.length
            );
            this.lastNeed -= buf.length;
          }; // Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
          // continuation byte. If an invalid byte is detected, -2 is returned.
          function utf8CheckByte(byte) {
            if (byte <= 0x7f) return 0;
            else if (byte >> 5 === 0x06) return 2;
            else if (byte >> 4 === 0x0e) return 3;
            else if (byte >> 3 === 0x1e) return 4;
            return byte >> 6 === 0x02 ? -1 : -2;
          } // Checks at most 3 bytes at the end of a Buffer in order to detect an
          // incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
          // needed to complete the UTF-8 character (if applicable) are returned.
          function utf8CheckIncomplete(self, buf, i) {
            var j = buf.length - 1;
            if (j < i) return 0;
            var nb = utf8CheckByte(buf[j]);
            if (nb >= 0) {
              if (nb > 0) self.lastNeed = nb - 1;
              return nb;
            }
            if (--j < i || nb === -2) return 0;
            nb = utf8CheckByte(buf[j]);
            if (nb >= 0) {
              if (nb > 0) self.lastNeed = nb - 2;
              return nb;
            }
            if (--j < i || nb === -2) return 0;
            nb = utf8CheckByte(buf[j]);
            if (nb >= 0) {
              if (nb > 0) {
                if (nb === 2) nb = 0;
                else self.lastNeed = nb - 3;
              }
              return nb;
            }
            return 0;
          } // Validates as many continuation bytes for a multi-byte UTF-8 character as
          // needed or are available. If we see a non-continuation byte where we expect
          // one, we "replace" the validated continuation bytes we've seen so far with
          // a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
          // behavior. The continuation byte check is included three times in the case
          // where all of the continuation bytes for a character exist in the same buffer.
          // It is also done this way as a slight performance increase instead of using a
          // loop.
          function utf8CheckExtraBytes(self, buf, p) {
            if ((buf[0] & 0xc0) !== 0x80) {
              self.lastNeed = 0;
              return "\uFFFD";
            }
            if (self.lastNeed > 1 && buf.length > 1) {
              if ((buf[1] & 0xc0) !== 0x80) {
                self.lastNeed = 1;
                return "\uFFFD";
              }
              if (self.lastNeed > 2 && buf.length > 2) {
                if ((buf[2] & 0xc0) !== 0x80) {
                  self.lastNeed = 2;
                  return "\uFFFD";
                }
              }
            }
          } // Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
          function utf8FillLast(buf) {
            var p = this.lastTotal - this.lastNeed;
            var r = utf8CheckExtraBytes(this, buf, p);
            if (r !== undefined) return r;
            if (this.lastNeed <= buf.length) {
              buf.copy(this.lastChar, p, 0, this.lastNeed);
              return this.lastChar.toString(this.encoding, 0, this.lastTotal);
            }
            buf.copy(this.lastChar, p, 0, buf.length);
            this.lastNeed -= buf.length;
          } // Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
          // partial character, the character's bytes are buffered until the required
          // number of bytes are available.
          function utf8Text(buf, i) {
            var total = utf8CheckIncomplete(this, buf, i);
            if (!this.lastNeed) return buf.toString("utf8", i);
            this.lastTotal = total;
            var end = buf.length - (total - this.lastNeed);
            buf.copy(this.lastChar, 0, end);
            return buf.toString("utf8", i, end);
          } // For UTF-8, a replacement character is added when ending on a partial
          // character.
          function utf8End(buf) {
            var r = buf && buf.length ? this.write(buf) : "";
            if (this.lastNeed) return r + "\uFFFD";
            return r;
          } // UTF-16LE typically needs two bytes per character, but even if we have an even
          // number of bytes available, we need to check if we end on a leading/high
          // surrogate. In that case, we need to wait for the next two bytes in order to
          // decode the last character properly.
          function utf16Text(buf, i) {
            if ((buf.length - i) % 2 === 0) {
              var r = buf.toString("utf16le", i);
              if (r) {
                var c = r.charCodeAt(r.length - 1);
                if (c >= 0xd800 && c <= 0xdbff) {
                  this.lastNeed = 2;
                  this.lastTotal = 4;
                  this.lastChar[0] = buf[buf.length - 2];
                  this.lastChar[1] = buf[buf.length - 1];
                  return r.slice(0, -1);
                }
              }
              return r;
            }
            this.lastNeed = 1;
            this.lastTotal = 2;
            this.lastChar[0] = buf[buf.length - 1];
            return buf.toString("utf16le", i, buf.length - 1);
          } // For UTF-16LE we do not explicitly append special replacement characters if we
          // end on a partial character, we simply let v8 handle that.
          function utf16End(buf) {
            var r = buf && buf.length ? this.write(buf) : "";
            if (this.lastNeed) {
              var end = this.lastTotal - this.lastNeed;
              return r + this.lastChar.toString("utf16le", 0, end);
            }
            return r;
          }
          function base64Text(buf, i) {
            var n = (buf.length - i) % 3;
            if (n === 0) return buf.toString("base64", i);
            this.lastNeed = 3 - n;
            this.lastTotal = 3;
            if (n === 1) {
              this.lastChar[0] = buf[buf.length - 1];
            } else {
              this.lastChar[0] = buf[buf.length - 2];
              this.lastChar[1] = buf[buf.length - 1];
            }
            return buf.toString("base64", i, buf.length - n);
          }
          function base64End(buf) {
            var r = buf && buf.length ? this.write(buf) : "";
            if (this.lastNeed)
              return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
            return r;
          } // Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
          function simpleWrite(buf) {
            return buf.toString(this.encoding);
          }
          function simpleEnd(buf) {
            return buf && buf.length ? this.write(buf) : "";
          }
        },
        { "safe-buffer": "c12d19f19a36ed124fadf8fb25e36363" }
      ],
      c12d19f19a36ed124fadf8fb25e36363: [
        function (require, module, exports) {
          /* eslint-disable node/no-deprecated-api */ var buffer = require("buffer");
          var Buffer = buffer.Buffer; // alternative to using Object.keys for old browsers
          function copyProps(src, dst) {
            for (var key in src) {
              dst[key] = src[key];
            }
          }
          if (
            Buffer.from &&
            Buffer.alloc &&
            Buffer.allocUnsafe &&
            Buffer.allocUnsafeSlow
          ) {
            module.exports = buffer;
          } else {
            // Copy properties from require('buffer')
            copyProps(buffer, exports);
            exports.Buffer = SafeBuffer;
          }
          function SafeBuffer(arg, encodingOrOffset, length) {
            return Buffer(arg, encodingOrOffset, length);
          }
          SafeBuffer.prototype = Object.create(Buffer.prototype); // Copy static methods from Buffer
          copyProps(Buffer, SafeBuffer);
          SafeBuffer.from = function (arg, encodingOrOffset, length) {
            if (typeof arg === "number") {
              throw new TypeError("Argument must not be a number");
            }
            return Buffer(arg, encodingOrOffset, length);
          };
          SafeBuffer.alloc = function (size, fill, encoding) {
            if (typeof size !== "number") {
              throw new TypeError("Argument must be a number");
            }
            var buf = Buffer(size);
            if (fill !== undefined) {
              if (typeof encoding === "string") {
                buf.fill(fill, encoding);
              } else {
                buf.fill(fill);
              }
            } else {
              buf.fill(0);
            }
            return buf;
          };
          SafeBuffer.allocUnsafe = function (size) {
            if (typeof size !== "number") {
              throw new TypeError("Argument must be a number");
            }
            return Buffer(size);
          };
          SafeBuffer.allocUnsafeSlow = function (size) {
            if (typeof size !== "number") {
              throw new TypeError("Argument must be a number");
            }
            return buffer.SlowBuffer(size);
          };
        },
        { buffer: "1948b2a05a083f82087512f711e79e4d" }
      ],
      "3428dcd916264d180fbf25757bd2fe80": [
        function (require, module, exports) {
          "use strict";
          var process = require("process");
          var _Object$setPrototypeO;
          function _defineProperty(obj, key, value) {
            if (key in obj) {
              Object.defineProperty(obj, key, {
                value: value,
                enumerable: true,
                configurable: true,
                writable: true
              });
            } else {
              obj[key] = value;
            }
            return obj;
          }
          var finished = require("./end-of-stream");
          var kLastResolve = Symbol("lastResolve");
          var kLastReject = Symbol("lastReject");
          var kError = Symbol("error");
          var kEnded = Symbol("ended");
          var kLastPromise = Symbol("lastPromise");
          var kHandlePromise = Symbol("handlePromise");
          var kStream = Symbol("stream");
          function createIterResult(value, done) {
            return { value: value, done: done };
          }
          function readAndResolve(iter) {
            var resolve = iter[kLastResolve];
            if (resolve !== null) {
              var data = iter[kStream].read(); // we defer if data is null
              // we can be expecting either 'end' or
              // 'error'
              if (data !== null) {
                iter[kLastPromise] = null;
                iter[kLastResolve] = null;
                iter[kLastReject] = null;
                resolve(createIterResult(data, false));
              }
            }
          }
          function onReadable(iter) {
            // we wait for the next tick, because it might
            // emit an error with process.nextTick
            process.nextTick(readAndResolve, iter);
          }
          function wrapForNext(lastPromise, iter) {
            return function (resolve, reject) {
              lastPromise.then(function () {
                if (iter[kEnded]) {
                  resolve(createIterResult(undefined, true));
                  return;
                }
                iter[kHandlePromise](resolve, reject);
              }, reject);
            };
          }
          var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
          var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(
            ((_Object$setPrototypeO = {
              get stream() {
                return this[kStream];
              },
              next: function next() {
                var _this = this; // if we have detected an error in the meanwhile
                // reject straight away
                var error = this[kError];
                if (error !== null) {
                  return Promise.reject(error);
                }
                if (this[kEnded]) {
                  return Promise.resolve(createIterResult(undefined, true));
                }
                if (this[kStream].destroyed) {
                  // We need to defer via nextTick because if .destroy(err) is
                  // called, the error will be emitted via nextTick, and
                  // we cannot guarantee that there is no error lingering around
                  // waiting to be emitted.
                  return new Promise(function (resolve, reject) {
                    process.nextTick(function () {
                      if (_this[kError]) {
                        reject(_this[kError]);
                      } else {
                        resolve(createIterResult(undefined, true));
                      }
                    });
                  });
                } // if we have multiple next() calls
                // we will wait for the previous Promise to finish
                // this logic is optimized to support for await loops,
                // where next() is only called once at a time
                var lastPromise = this[kLastPromise];
                var promise;
                if (lastPromise) {
                  promise = new Promise(wrapForNext(lastPromise, this));
                } else {
                  // fast path needed to support multiple this.push()
                  // without triggering the next() queue
                  var data = this[kStream].read();
                  if (data !== null) {
                    return Promise.resolve(createIterResult(data, false));
                  }
                  promise = new Promise(this[kHandlePromise]);
                }
                this[kLastPromise] = promise;
                return promise;
              }
            }),
            _defineProperty(
              _Object$setPrototypeO,
              Symbol.asyncIterator,
              function () {
                return this;
              }
            ),
            _defineProperty(_Object$setPrototypeO, "return", function _return() {
              var _this2 = this; // destroy(err, cb) is a private API
              // we can guarantee we have that here, because we control the
              // Readable class this is attached to
              return new Promise(function (resolve, reject) {
                _this2[kStream].destroy(null, function (err) {
                  if (err) {
                    reject(err);
                    return;
                  }
                  resolve(createIterResult(undefined, true));
                });
              });
            }),
            _Object$setPrototypeO),
            AsyncIteratorPrototype
          );
          var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(
            stream
          ) {
            var _Object$create;
            var iterator = Object.create(
              ReadableStreamAsyncIteratorPrototype,
              ((_Object$create = {}),
              _defineProperty(_Object$create, kStream, {
                value: stream,
                writable: true
              }),
              _defineProperty(_Object$create, kLastResolve, {
                value: null,
                writable: true
              }),
              _defineProperty(_Object$create, kLastReject, {
                value: null,
                writable: true
              }),
              _defineProperty(_Object$create, kError, {
                value: null,
                writable: true
              }),
              _defineProperty(_Object$create, kEnded, {
                value: stream._readableState.endEmitted,
                writable: true
              }),
              _defineProperty(_Object$create, kHandlePromise, {
                value: function value(resolve, reject) {
                  var data = iterator[kStream].read();
                  if (data) {
                    iterator[kLastPromise] = null;
                    iterator[kLastResolve] = null;
                    iterator[kLastReject] = null;
                    resolve(createIterResult(data, false));
                  } else {
                    iterator[kLastResolve] = resolve;
                    iterator[kLastReject] = reject;
                  }
                },
                writable: true
              }),
              _Object$create)
            );
            iterator[kLastPromise] = null;
            finished(stream, function (err) {
              if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
                var reject = iterator[kLastReject]; // reject if we are waiting for data in the Promise
                // returned by next() and store the error
                if (reject !== null) {
                  iterator[kLastPromise] = null;
                  iterator[kLastResolve] = null;
                  iterator[kLastReject] = null;
                  reject(err);
                }
                iterator[kError] = err;
                return;
              }
              var resolve = iterator[kLastResolve];
              if (resolve !== null) {
                iterator[kLastPromise] = null;
                iterator[kLastResolve] = null;
                iterator[kLastReject] = null;
                resolve(createIterResult(undefined, true));
              }
              iterator[kEnded] = true;
            });
            stream.on("readable", onReadable.bind(null, iterator));
            return iterator;
          };
          module.exports = createReadableStreamAsyncIterator;
        },
        {
          process: "ec0e1432c6522aad9b4b16c4b3b080f4",
          "./end-of-stream": "8bb38b990984c421de0a9b6498783567"
        }
      ],
      "8bb38b990984c421de0a9b6498783567": [
        function (require, module, exports) {
          // Ported from https://github.com/mafintosh/end-of-stream with
          // permission from the author, Mathias Buus (@mafintosh).
          "use strict";
          var ERR_STREAM_PREMATURE_CLOSE = require("../../../errors").codes
            .ERR_STREAM_PREMATURE_CLOSE;
          function once(callback) {
            var called = false;
            return function () {
              if (called) return;
              called = true;
              for (
                var _len = arguments.length, args = new Array(_len), _key = 0;
                _key < _len;
                _key++
              ) {
                args[_key] = arguments[_key];
              }
              callback.apply(this, args);
            };
          }
          function noop() {}
          function isRequest(stream) {
            return stream.setHeader && typeof stream.abort === "function";
          }
          function eos(stream, opts, callback) {
            if (typeof opts === "function") return eos(stream, null, opts);
            if (!opts) opts = {};
            callback = once(callback || noop);
            var readable =
              opts.readable || (opts.readable !== false && stream.readable);
            var writable =
              opts.writable || (opts.writable !== false && stream.writable);
            var onlegacyfinish = function onlegacyfinish() {
              if (!stream.writable) onfinish();
            };
            var writableEnded =
              stream._writableState && stream._writableState.finished;
            var onfinish = function onfinish() {
              writable = false;
              writableEnded = true;
              if (!readable) callback.call(stream);
            };
            var readableEnded =
              stream._readableState && stream._readableState.endEmitted;
            var onend = function onend() {
              readable = false;
              readableEnded = true;
              if (!writable) callback.call(stream);
            };
            var onerror = function onerror(err) {
              callback.call(stream, err);
            };
            var onclose = function onclose() {
              var err;
              if (readable && !readableEnded) {
                if (!stream._readableState || !stream._readableState.ended)
                  err = new ERR_STREAM_PREMATURE_CLOSE();
                return callback.call(stream, err);
              }
              if (writable && !writableEnded) {
                if (!stream._writableState || !stream._writableState.ended)
                  err = new ERR_STREAM_PREMATURE_CLOSE();
                return callback.call(stream, err);
              }
            };
            var onrequest = function onrequest() {
              stream.req.on("finish", onfinish);
            };
            if (isRequest(stream)) {
              stream.on("complete", onfinish);
              stream.on("abort", onclose);
              if (stream.req) onrequest();
              else stream.on("request", onrequest);
            } else if (writable && !stream._writableState) {
              // legacy streams
              stream.on("end", onlegacyfinish);
              stream.on("close", onlegacyfinish);
            }
            stream.on("end", onend);
            stream.on("finish", onfinish);
            if (opts.error !== false) stream.on("error", onerror);
            stream.on("close", onclose);
            return function () {
              stream.removeListener("complete", onfinish);
              stream.removeListener("abort", onclose);
              stream.removeListener("request", onrequest);
              if (stream.req) stream.req.removeListener("finish", onfinish);
              stream.removeListener("end", onlegacyfinish);
              stream.removeListener("close", onlegacyfinish);
              stream.removeListener("finish", onfinish);
              stream.removeListener("end", onend);
              stream.removeListener("error", onerror);
              stream.removeListener("close", onclose);
            };
          }
          module.exports = eos;
        },
        { "../../../errors": "22051e8467f556273ed5280585844add" }
      ],
      c18627540980b97942fae90d923cab14: [
        function (require, module, exports) {
          module.exports = function () {
            throw new Error("Readable.from is not available in the browser");
          };
        },
        {}
      ],
      "344910f8ae2ab2cbf141d025605057e4": [
        function (require, module, exports) {
          // Copyright Joyent, Inc. and other Node contributors.
          //
          // Permission is hereby granted, free of charge, to any person obtaining a
          // copy of this software and associated documentation files (the
          // "Software"), to deal in the Software without restriction, including
          // without limitation the rights to use, copy, modify, merge, publish,
          // distribute, sublicense, and/or sell copies of the Software, and to permit
          // persons to whom the Software is furnished to do so, subject to the
          // following conditions:
          //
          // The above copyright notice and this permission notice shall be included
          // in all copies or substantial portions of the Software.
          //
          // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
          // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
          // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
          // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
          // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
          // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
          // USE OR OTHER DEALINGS IN THE SOFTWARE.
          // a transform stream is a readable/writable stream where you do
          // something with the data.  Sometimes it's called a "filter",
          // but that's not a great name for it, since that implies a thing where
          // some bits pass through, and others are simply ignored.  (That would
          // be a valid example of a transform, of course.)
          //
          // While the output is causally related to the input, it's not a
          // necessarily symmetric or synchronous transformation.  For example,
          // a zlib stream might take multiple plain-text writes(), and then
          // emit a single compressed chunk some time in the future.
          //
          // Here's how this works:
          //
          // The Transform stream has all the aspects of the readable and writable
          // stream classes.  When you write(chunk), that calls _write(chunk,cb)
          // internally, and returns false if there's a lot of pending writes
          // buffered up.  When you call read(), that calls _read(n) until
          // there's enough pending readable data buffered up.
          //
          // In a transform stream, the written data is placed in a buffer.  When
          // _read(n) is called, it transforms the queued up data, calling the
          // buffered _write cb's as it consumes chunks.  If consuming a single
          // written chunk would result in multiple output chunks, then the first
          // outputted bit calls the readcb, and subsequent chunks just go into
          // the read buffer, and will cause it to emit 'readable' if necessary.
          //
          // This way, back-pressure is actually determined by the reading side,
          // since _read has to be called to start processing a new chunk.  However,
          // a pathological inflate type of transform can cause excessive buffering
          // here.  For example, imagine a stream where every byte of input is
          // interpreted as an integer from 0-255, and then results in that many
          // bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
          // 1kb of data being output.  In this case, you could write a very small
          // amount of input, and end up with a very large amount of output.  In
          // such a pathological inflating mechanism, there'd be no way to tell
          // the system to stop doing the transform.  A single 4MB write could
          // cause the system to run out of memory.
          //
          // However, even in such a pathological case, only a single written chunk
          // would be consumed, and then the rest would wait (un-transformed) until
          // the results of the previous transformed chunk were consumed.
          "use strict";
          module.exports = Transform;
          var _require$codes = require("../errors").codes,
            ERR_METHOD_NOT_IMPLEMENTED =
              _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
            ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
            ERR_TRANSFORM_ALREADY_TRANSFORMING =
              _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
            ERR_TRANSFORM_WITH_LENGTH_0 =
              _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
          var Duplex = require("./_stream_duplex");
          require("inherits")(Transform, Duplex);
          function afterTransform(er, data) {
            var ts = this._transformState;
            ts.transforming = false;
            var cb = ts.writecb;
            if (cb === null) {
              return this.emit("error", new ERR_MULTIPLE_CALLBACK());
            }
            ts.writechunk = null;
            ts.writecb = null;
            if (data != null)
              // single equals check for both `null` and `undefined`
              this.push(data);
            cb(er);
            var rs = this._readableState;
            rs.reading = false;
            if (rs.needReadable || rs.length < rs.highWaterMark) {
              this._read(rs.highWaterMark);
            }
          }
          function Transform(options) {
            if (!_instanceof(this, Transform)) return new Transform(options);
            Duplex.call(this, options);
            this._transformState = {
              afterTransform: afterTransform.bind(this),
              needTransform: false,
              transforming: false,
              writecb: null,
              writechunk: null,
              writeencoding: null
            }; // start out asking for a readable event once data is transformed.
            this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
            // that Readable wants before the first _read call, so unset the
            // sync guard flag.
            this._readableState.sync = false;
            if (options) {
              if (typeof options.transform === "function")
                this._transform = options.transform;
              if (typeof options.flush === "function")
                this._flush = options.flush;
            } // When the writable side finishes, then flush out anything remaining.
            this.on("prefinish", prefinish);
          }
          function prefinish() {
            var _this = this;
            if (
              typeof this._flush === "function" &&
              !this._readableState.destroyed
            ) {
              this._flush(function (er, data) {
                done(_this, er, data);
              });
            } else {
              done(this, null, null);
            }
          }
          Transform.prototype.push = function (chunk, encoding) {
            this._transformState.needTransform = false;
            return Duplex.prototype.push.call(this, chunk, encoding);
          }; // This is the part where you do stuff!
          // override this function in implementation classes.
          // 'chunk' is an input chunk.
          //
          // Call `push(newChunk)` to pass along transformed output
          // to the readable side.  You may call 'push' zero or more times.
          //
          // Call `cb(err)` when you are done with this chunk.  If you pass
          // an error, then that'll put the hurt on the whole operation.  If you
          // never call cb(), then you'll never get another chunk.
          Transform.prototype._transform = function (chunk, encoding, cb) {
            cb(new ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
          };
          Transform.prototype._write = function (chunk, encoding, cb) {
            var ts = this._transformState;
            ts.writecb = cb;
            ts.writechunk = chunk;
            ts.writeencoding = encoding;
            if (!ts.transforming) {
              var rs = this._readableState;
              if (
                ts.needTransform ||
                rs.needReadable ||
                rs.length < rs.highWaterMark
              )
                this._read(rs.highWaterMark);
            }
          }; // Doesn't matter what the args are here.
          // _transform does all the work.
          // That we got here means that the readable side wants more data.
          Transform.prototype._read = function (n) {
            var ts = this._transformState;
            if (ts.writechunk !== null && !ts.transforming) {
              ts.transforming = true;
              this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
            } else {
              // mark that we need a transform, so that any data that comes in
              // will get processed, now that we've asked for it.
              ts.needTransform = true;
            }
          };
          Transform.prototype._destroy = function (err, cb) {
            Duplex.prototype._destroy.call(this, err, function (err2) {
              cb(err2);
            });
          };
          function done(stream, er, data) {
            if (er) return stream.emit("error", er);
            if (data != null)
              // single equals check for both `null` and `undefined`
              stream.push(data); // TODO(BridgeAR): Write a test for these two error cases
            // if there's nothing in the write buffer, then that means
            // that nothing more will ever be provided
            if (stream._writableState.length)
              throw new ERR_TRANSFORM_WITH_LENGTH_0();
            if (stream._transformState.transforming)
              throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
            return stream.push(null);
          }
        },
        {
          "../errors": "22051e8467f556273ed5280585844add",
          "./_stream_duplex": "6b667e5880fd1eed1d4a8b5ddb47b706",
          inherits: "9a4ae5d8f832c8333ee4e7b933c46353"
        }
      ],
      "63d26bea15cd05a885b9a4f84b61f47e": [
        function (require, module, exports) {
          // Copyright Joyent, Inc. and other Node contributors.
          //
          // Permission is hereby granted, free of charge, to any person obtaining a
          // copy of this software and associated documentation files (the
          // "Software"), to deal in the Software without restriction, including
          // without limitation the rights to use, copy, modify, merge, publish,
          // distribute, sublicense, and/or sell copies of the Software, and to permit
          // persons to whom the Software is furnished to do so, subject to the
          // following conditions:
          //
          // The above copyright notice and this permission notice shall be included
          // in all copies or substantial portions of the Software.
          //
          // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
          // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
          // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
          // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
          // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
          // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
          // USE OR OTHER DEALINGS IN THE SOFTWARE.
          // a passthrough stream.
          // basically just the most minimal sort of Transform stream.
          // Every written chunk gets output as-is.
          "use strict";
          module.exports = PassThrough;
          var Transform = require("./_stream_transform");
          require("inherits")(PassThrough, Transform);
          function PassThrough(options) {
            if (!_instanceof(this, PassThrough)) return new PassThrough(options);
            Transform.call(this, options);
          }
          PassThrough.prototype._transform = function (chunk, encoding, cb) {
            cb(null, chunk);
          };
        },
        {
          "./_stream_transform": "344910f8ae2ab2cbf141d025605057e4",
          inherits: "9a4ae5d8f832c8333ee4e7b933c46353"
        }
      ],
      "5a264023f1e7a5b691a8ec9a8c9c68e7": [
        function (require, module, exports) {
          // Ported from https://github.com/mafintosh/pump with
          // permission from the author, Mathias Buus (@mafintosh).
          "use strict";
          var eos;
          function once(callback) {
            var called = false;
            return function () {
              if (called) return;
              called = true;
              callback.apply(void 0, arguments);
            };
          }
          var _require$codes = require("../../../errors").codes,
            ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
            ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
          function noop(err) {
            // Rethrow the error if it exists to avoid swallowing it
            if (err) throw err;
          }
          function isRequest(stream) {
            return stream.setHeader && typeof stream.abort === "function";
          }
          function destroyer(stream, reading, writing, callback) {
            callback = once(callback);
            var closed = false;
            stream.on("close", function () {
              closed = true;
            });
            if (eos === undefined) eos = require("./end-of-stream");
            eos(stream, { readable: reading, writable: writing }, function (err) {
              if (err) return callback(err);
              closed = true;
              callback();
            });
            var destroyed = false;
            return function (err) {
              if (closed) return;
              if (destroyed) return;
              destroyed = true; // request.destroy just do .end - .abort is what we want
              if (isRequest(stream)) return stream.abort();
              if (typeof stream.destroy === "function") return stream.destroy();
              callback(err || new ERR_STREAM_DESTROYED("pipe"));
            };
          }
          function call(fn) {
            fn();
          }
          function pipe(from, to) {
            return from.pipe(to);
          }
          function popCallback(streams) {
            if (!streams.length) return noop;
            if (typeof streams[streams.length - 1] !== "function") return noop;
            return streams.pop();
          }
          function pipeline() {
            for (
              var _len = arguments.length, streams = new Array(_len), _key = 0;
              _key < _len;
              _key++
            ) {
              streams[_key] = arguments[_key];
            }
            var callback = popCallback(streams);
            if (Array.isArray(streams[0])) streams = streams[0];
            if (streams.length < 2) {
              throw new ERR_MISSING_ARGS("streams");
            }
            var error;
            var destroys = streams.map(function (stream, i) {
              var reading = i < streams.length - 1;
              var writing = i > 0;
              return destroyer(stream, reading, writing, function (err) {
                if (!error) error = err;
                if (err) destroys.forEach(call);
                if (reading) return;
                destroys.forEach(call);
                callback(error);
              });
            });
            return streams.reduce(pipe);
          }
          module.exports = pipeline;
        },
        {
          "../../../errors": "22051e8467f556273ed5280585844add",
          "./end-of-stream": "8bb38b990984c421de0a9b6498783567"
        }
      ],
      "002b66db5149e202a57ace584b1424aa": [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("buffer").Buffer;
          var __extends =
            (this && this.__extends) ||
            (function () {
              var _extendStatics3 = function extendStatics(d, b) {
                _extendStatics3 =
                  Object.setPrototypeOf ||
                  (_instanceof({ __proto__: [] }, Array) &&
                    function (d, b) {
                      d.__proto__ = b;
                    }) ||
                  function (d, b) {
                    for (var p in b) {
                      if (b.hasOwnProperty(p)) d[p] = b[p];
                    }
                  };
                return _extendStatics3(d, b);
              };
              return function (d, b) {
                _extendStatics3(d, b);
                function __() {
                  this.constructor = d;
                }
                d.prototype =
                  b === null
                    ? Object.create(b)
                    : ((__.prototype = b.prototype), new __());
              };
            })();
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.Hash160 = void 0;
          var hash_1 = require("./hash");
          /**
           * Hash with a width of 160 bits
           */ var Hash160 = /** @class */ (function (_super) {
            __extends(Hash160, _super);
            function Hash160(bytes) {
              var _this = this;
              if (bytes && bytes.byteLength === 0) {
                bytes = Hash160.ZERO_160.bytes;
              }
              _this =
                _super.call(
                  this,
                  bytes !== null && bytes !== void 0
                    ? bytes
                    : Hash160.ZERO_160.bytes
                ) || this;
              return _this;
            }
            Hash160.width = 20;
            Hash160.ZERO_160 = new Hash160(Buffer.alloc(Hash160.width));
            return Hash160;
          })(hash_1.Hash);
          exports.Hash160 = Hash160;
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          "./hash": "6162b6ebe73334b0782058d6ae83aba2"
        }
      ],
      "6162b6ebe73334b0782058d6ae83aba2": [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("buffer").Buffer;
          var __extends =
            (this && this.__extends) ||
            (function () {
              var _extendStatics4 = function extendStatics(d, b) {
                _extendStatics4 =
                  Object.setPrototypeOf ||
                  (_instanceof({ __proto__: [] }, Array) &&
                    function (d, b) {
                      d.__proto__ = b;
                    }) ||
                  function (d, b) {
                    for (var p in b) {
                      if (b.hasOwnProperty(p)) d[p] = b[p];
                    }
                  };
                return _extendStatics4(d, b);
              };
              return function (d, b) {
                _extendStatics4(d, b);
                function __() {
                  this.constructor = d;
                }
                d.prototype =
                  b === null
                    ? Object.create(b)
                    : ((__.prototype = b.prototype), new __());
              };
            })();
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.Hash = void 0;
          var serialized_type_1 = require("./serialized-type");
          /**
           * Base class defining how to encode and decode hashes
           */ var Hash = /** @class */ (function (_super) {
            __extends(Hash, _super);
            function Hash(bytes) {
              var _this = _super.call(this, bytes) || this;
              if (_this.bytes.byteLength !== _this.constructor.width) {
                throw new Error("Invalid Hash length " + _this.bytes.byteLength);
              }
              return _this;
            }
            /**
             * Construct a Hash object from an existing Hash object or a hex-string
             *
             * @param value A hash object or hex-string of a hash
             */ Hash.from = function (value) {
              if (_instanceof(value, this)) {
                return value;
              }
              if (typeof value === "string") {
                return new this(Buffer.from(value, "hex"));
              }
              throw new Error("Cannot construct Hash from given value");
            };
            /**
             * Read a Hash object from a BinaryParser
             *
             * @param parser BinaryParser to read the hash from
             * @param hint length of the bytes to read, optional
             */ Hash.fromParser = function (parser, hint) {
              return new this(
                parser.read(hint !== null && hint !== void 0 ? hint : this.width)
              );
            };
            /**
             * Overloaded operator for comparing two hash objects
             *
             * @param other The Hash to compare this to
             */ Hash.prototype.compareTo = function (other) {
              return Buffer.compare(
                this.bytes,
                this.constructor.from(other).bytes
              );
            };
            /**
             * @returns the hex-string representation of this Hash
             */ Hash.prototype.toString = function () {
              return this.toHex();
            };
            /**
             * Returns four bits at the specified depth within a hash
             *
             * @param depth The depth of the four bits
             * @returns The number represented by the four bits
             */ Hash.prototype.nibblet = function (depth) {
              var byteIx = depth > 0 ? (depth / 2) | 0 : 0;
              var b = this.bytes[byteIx];
              if (depth % 2 === 0) {
                b = (b & 0xf0) >>> 4;
              } else {
                b = b & 0x0f;
              }
              return b;
            };
            return Hash;
          })(serialized_type_1.Comparable);
          exports.Hash = Hash;
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          "./serialized-type": "0f0f786f836b5aa515dc3100a1d71ee2"
        }
      ],
      "8641feb12d5dad6f3709ef3fc068b428": [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("buffer").Buffer;
          var __extends =
            (this && this.__extends) ||
            (function () {
              var _extendStatics5 = function extendStatics(d, b) {
                _extendStatics5 =
                  Object.setPrototypeOf ||
                  (_instanceof({ __proto__: [] }, Array) &&
                    function (d, b) {
                      d.__proto__ = b;
                    }) ||
                  function (d, b) {
                    for (var p in b) {
                      if (b.hasOwnProperty(p)) d[p] = b[p];
                    }
                  };
                return _extendStatics5(d, b);
              };
              return function (d, b) {
                _extendStatics5(d, b);
                function __() {
                  this.constructor = d;
                }
                d.prototype =
                  b === null
                    ? Object.create(b)
                    : ((__.prototype = b.prototype), new __());
              };
            })();
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.Amount = void 0;
          var decimal_js_1 = require("decimal.js");
          var binary_parser_1 = require("../serdes/binary-parser");
          var account_id_1 = require("./account-id");
          var currency_1 = require("./currency");
          var serialized_type_1 = require("./serialized-type");
          /**
           * Constants for validating amounts
           */ var MIN_IOU_EXPONENT = -96;
          var MAX_IOU_EXPONENT = 80;
          var MAX_IOU_PRECISION = 16;
          var MAX_DROPS = new decimal_js_1.Decimal("1e17");
          var MIN_XRP = new decimal_js_1.Decimal("1e-6");
          /**
           * decimal.js configuration for Amount IOUs
           */ decimal_js_1.Decimal.config({
            toExpPos: MAX_IOU_EXPONENT + MAX_IOU_PRECISION,
            toExpNeg: MIN_IOU_EXPONENT - MAX_IOU_PRECISION
          });
          /**
           * Type guard for AmountObject
           */ function isAmountObject(arg) {
            var keys = Object.keys(arg).sort();
            return (
              keys.length === 3 &&
              keys[0] === "currency" &&
              keys[1] === "issuer" &&
              keys[2] === "value"
            );
          }
          /**
           * Class for serializing/Deserializing Amounts
           */ var Amount = /** @class */ (function (_super) {
            __extends(Amount, _super);
            function Amount(bytes) {
              return (
                _super.call(
                  this,
                  bytes !== null && bytes !== void 0
                    ? bytes
                    : Amount.defaultAmount.bytes
                ) || this
              );
            }
            /**
             * Construct an amount from an IOU or string amount
             *
             * @param value An Amount, object representing an IOU, or a string
             *     representing an integer amount
             * @returns An Amount object
             */ Amount.from = function (value) {
              if (_instanceof(value, Amount)) {
                return value;
              }
              var amount = Buffer.alloc(8);
              if (typeof value === "string") {
                Amount.assertXrpIsValid(value);
                var number = BigInt(value);
                amount.writeBigUInt64BE(number);
                amount[0] |= 0x40;
                return new Amount(amount);
              }
              if (isAmountObject(value)) {
                var number = new decimal_js_1.Decimal(value.value);
                Amount.assertIouIsValid(number);
                if (number.isZero()) {
                  amount[0] |= 0x80;
                } else {
                  var integerNumberString = number
                    .times("1e" + -(number.e - 15))
                    .abs()
                    .toString();
                  amount.writeBigUInt64BE(BigInt(integerNumberString));
                  amount[0] |= 0x80;
                  if (number.gt(new decimal_js_1.Decimal(0))) {
                    amount[0] |= 0x40;
                  }
                  var exponent = number.e - 15;
                  var exponentByte = 97 + exponent;
                  amount[0] |= exponentByte >>> 2;
                  amount[1] |= (exponentByte & 0x03) << 6;
                }
                var currency = currency_1.Currency.from(value.currency).toBytes();
                var issuer = account_id_1.AccountID.from(value.issuer).toBytes();
                return new Amount(Buffer.concat([amount, currency, issuer]));
              }
              throw new Error("Invalid type to construct an Amount");
            };
            /**
             * Read an amount from a BinaryParser
             *
             * @param parser BinaryParser to read the Amount from
             * @returns An Amount object
             */ Amount.fromParser = function (parser) {
              var isXRP = parser.peek() & 0x80;
              var numBytes = isXRP ? 48 : 8;
              return new Amount(parser.read(numBytes));
            };
            /**
             * Get the JSON representation of this Amount
             *
             * @returns the JSON interpretation of this.bytes
             */ Amount.prototype.toJSON = function () {
              if (this.isNative()) {
                var bytes = this.bytes;
                var isPositive = bytes[0] & 0x40;
                var sign = isPositive ? "" : "-";
                bytes[0] &= 0x3f;
                return "" + sign + bytes.readBigUInt64BE().toString();
              } else {
                var parser = new binary_parser_1.BinaryParser(this.toString());
                var mantissa = parser.read(8);
                var currency = currency_1.Currency.fromParser(parser);
                var issuer = account_id_1.AccountID.fromParser(parser);
                var b1 = mantissa[0];
                var b2 = mantissa[1];
                var isPositive = b1 & 0x40;
                var sign = isPositive ? "" : "-";
                var exponent = ((b1 & 0x3f) << 2) + ((b2 & 0xff) >> 6) - 97;
                mantissa[0] = 0;
                mantissa[1] &= 0x3f;
                var value = new decimal_js_1.Decimal(
                  sign + "0x" + mantissa.toString("hex")
                ).times("1e" + exponent);
                Amount.assertIouIsValid(value);
                return {
                  value: value.toString(),
                  currency: currency.toJSON(),
                  issuer: issuer.toJSON()
                };
              }
            };
            /**
             * Validate XRP amount
             *
             * @param amount String representing XRP amount
             * @returns void, but will throw if invalid amount
             */ Amount.assertXrpIsValid = function (amount) {
              if (amount.indexOf(".") !== -1) {
                throw new Error(amount.toString() + " is an illegal amount");
              }
              var decimal = new decimal_js_1.Decimal(amount);
              if (!decimal.isZero()) {
                if (decimal.lt(MIN_XRP) || decimal.gt(MAX_DROPS)) {
                  throw new Error(amount.toString() + " is an illegal amount");
                }
              }
            };
            /**
             * Validate IOU.value amount
             *
             * @param decimal Decimal.js object representing IOU.value
             * @returns void, but will throw if invalid amount
             */ Amount.assertIouIsValid = function (decimal) {
              if (!decimal.isZero()) {
                var p = decimal.precision();
                var e = decimal.e - 15;
                if (
                  p > MAX_IOU_PRECISION ||
                  e > MAX_IOU_EXPONENT ||
                  e < MIN_IOU_EXPONENT
                ) {
                  throw new Error("Decimal precision out of range");
                }
                this.verifyNoDecimal(decimal);
              }
            };
            /**
             * Ensure that the value after being multiplied by the exponent does not
             * contain a decimal.
             *
             * @param decimal a Decimal object
             * @returns a string of the object without a decimal
             */ Amount.verifyNoDecimal = function (decimal) {
              var integerNumberString = decimal
                .times("1e" + -(decimal.e - 15))
                .abs()
                .toString();
              if (integerNumberString.indexOf(".") !== -1) {
                throw new Error("Decimal place found in integerNumberString");
              }
            };
            /**
             * Test if this amount is in units of Native Currency(XRP)
             *
             * @returns true if Native (XRP)
             */ Amount.prototype.isNative = function () {
              return (this.bytes[0] & 0x80) === 0;
            };
            Amount.defaultAmount = new Amount(
              Buffer.from("4000000000000000", "hex")
            );
            return Amount;
          })(serialized_type_1.SerializedType);
          exports.Amount = Amount;
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          "decimal.js": "bb8d63dce57b0b8153f6eda922ddbc97",
          "../serdes/binary-parser": "b815b18e9842bed3b7f351e097aea11a",
          "./account-id": "eb20d852480fd223e8be71fa0e2c6b42",
          "./currency": "8027a02b1465ac283be1b684e5f1989b",
          "./serialized-type": "0f0f786f836b5aa515dc3100a1d71ee2"
        }
      ],
      bb8d63dce57b0b8153f6eda922ddbc97: [
        function (require, module, exports) {
          var define;
          (function (globalScope) {
            "use strict"
            /*
             *  decimal.js v10.2.1
             *  An arbitrary-precision Decimal type for JavaScript.
             *  https://github.com/MikeMcl/decimal.js
             *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
             *  MIT Licence
             */; // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
            // The maximum exponent magnitude.
            // The limit on the value of `toExpNeg`, `toExpPos`, `minE` and `maxE`.
            var EXP_LIMIT = 9e15, // 0 to 9e15
              // The limit on the value of `precision`, and on the value of the first argument to
              // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
              MAX_DIGITS = 1e9, // 0 to 1e9
              // Base conversion alphabet.
              NUMERALS = "0123456789abcdef", // The natural logarithm of 10 (1025 digits).
              LN10 =
                "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", // Pi (1025 digits).
              PI =
                "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", // The initial configuration properties of the Decimal constructor.
              DEFAULTS = {
                // These values must be integers within the stated ranges (inclusive).
                // Most of these values can be changed at run-time using the `Decimal.config` method.
                // The maximum number of significant digits of the result of a calculation or base conversion.
                // E.g. `Decimal.config({ precision: 20 });`
                precision: 20, // 1 to MAX_DIGITS
                // The rounding mode used when rounding to `precision`.
                //
                // ROUND_UP         0 Away from zero.
                // ROUND_DOWN       1 Towards zero.
                // ROUND_CEIL       2 Towards +Infinity.
                // ROUND_FLOOR      3 Towards -Infinity.
                // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
                // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
                // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
                // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
                // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
                //
                // E.g.
                // `Decimal.rounding = 4;`
                // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
                rounding: 4, // 0 to 8
                // The modulo mode used when calculating the modulus: a mod n.
                // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
                // The remainder (r) is calculated as: r = a - n * q.
                //
                // UP         0 The remainder is positive if the dividend is negative, else is negative.
                // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
                // FLOOR      3 The remainder has the same sign as the divisor (Python %).
                // HALF_EVEN  6 The IEEE 754 remainder function.
                // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
                //
                // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
                // division (9) are commonly used for the modulus operation. The other rounding modes can also
                // be used, but they may not give useful results.
                modulo: 1, // 0 to 9
                // The exponent value at and beneath which `toString` returns exponential notation.
                // JavaScript numbers: -7
                toExpNeg: -7, // 0 to -EXP_LIMIT
                // The exponent value at and above which `toString` returns exponential notation.
                // JavaScript numbers: 21
                toExpPos: 21, // 0 to EXP_LIMIT
                // The minimum exponent value, beneath which underflow to zero occurs.
                // JavaScript numbers: -324  (5e-324)
                minE: -EXP_LIMIT, // -1 to -EXP_LIMIT
                // The maximum exponent value, above which overflow to Infinity occurs.
                // JavaScript numbers: 308  (1.7976931348623157e+308)
                maxE: EXP_LIMIT, // 1 to EXP_LIMIT
                // Whether to use cryptographically-secure random number generation, if available.
                crypto: false // true/false
              }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
              Decimal,
              inexact,
              noConflict,
              quadrant,
              external = true,
              decimalError = "[DecimalError] ",
              invalidArgument = decimalError + "Invalid argument: ",
              precisionLimitExceeded = decimalError + "Precision limit exceeded",
              cryptoUnavailable = decimalError + "crypto unavailable",
              mathfloor = Math.floor,
              mathpow = Math.pow,
              isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i,
              isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i,
              isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i,
              isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,
              BASE = 1e7,
              LOG_BASE = 7,
              MAX_SAFE_INTEGER = 9007199254740991,
              LN10_PRECISION = LN10.length - 1,
              PI_PRECISION = PI.length - 1, // Decimal.prototype object
              P = { name: "[object Decimal]" }; // Decimal prototype methods
            /*
             *  absoluteValue             abs
             *  ceil
             *  comparedTo                cmp
             *  cosine                    cos
             *  cubeRoot                  cbrt
             *  decimalPlaces             dp
             *  dividedBy                 div
             *  dividedToIntegerBy        divToInt
             *  equals                    eq
             *  floor
             *  greaterThan               gt
             *  greaterThanOrEqualTo      gte
             *  hyperbolicCosine          cosh
             *  hyperbolicSine            sinh
             *  hyperbolicTangent         tanh
             *  inverseCosine             acos
             *  inverseHyperbolicCosine   acosh
             *  inverseHyperbolicSine     asinh
             *  inverseHyperbolicTangent  atanh
             *  inverseSine               asin
             *  inverseTangent            atan
             *  isFinite
             *  isInteger                 isInt
             *  isNaN
             *  isNegative                isNeg
             *  isPositive                isPos
             *  isZero
             *  lessThan                  lt
             *  lessThanOrEqualTo         lte
             *  logarithm                 log
             *  [maximum]                 [max]
             *  [minimum]                 [min]
             *  minus                     sub
             *  modulo                    mod
             *  naturalExponential        exp
             *  naturalLogarithm          ln
             *  negated                   neg
             *  plus                      add
             *  precision                 sd
             *  round
             *  sine                      sin
             *  squareRoot                sqrt
             *  tangent                   tan
             *  times                     mul
             *  toBinary
             *  toDecimalPlaces           toDP
             *  toExponential
             *  toFixed
             *  toFraction
             *  toHexadecimal             toHex
             *  toNearest
             *  toNumber
             *  toOctal
             *  toPower                   pow
             *  toPrecision
             *  toSignificantDigits       toSD
             *  toString
             *  truncated                 trunc
             *  valueOf                   toJSON
             */ /*
             * Return a new Decimal whose value is the absolute value of this Decimal.
             *
             */ P.absoluteValue = P.abs = function () {
              var x = new this.constructor(this);
              if (x.s < 0) x.s = 1;
              return finalise(x);
            };
            /*
             * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
             * direction of positive Infinity.
             *
             */ P.ceil = function () {
              return finalise(new this.constructor(this), this.e + 1, 2);
            };
            /*
             * Return
             *   1    if the value of this Decimal is greater than the value of `y`,
             *  -1    if the value of this Decimal is less than the value of `y`,
             *   0    if they have the same value,
             *   NaN  if the value of either Decimal is NaN.
             *
             */ P.comparedTo = P.cmp = function (y) {
              var i,
                j,
                xdL,
                ydL,
                x = this,
                xd = x.d,
                yd = (y = new x.constructor(y)).d,
                xs = x.s,
                ys = y.s; // Either NaN or ±Infinity?
              if (!xd || !yd) {
                return !xs || !ys
                  ? NaN
                  : xs !== ys
                  ? xs
                  : xd === yd
                  ? 0
                  : !xd ^ (xs < 0)
                  ? 1
                  : -1;
              } // Either zero?
              if (!xd[0] || !yd[0]) return xd[0] ? xs : yd[0] ? -ys : 0; // Signs differ?
              if (xs !== ys) return xs; // Compare exponents.
              if (x.e !== y.e) return (x.e > y.e) ^ (xs < 0) ? 1 : -1;
              xdL = xd.length;
              ydL = yd.length; // Compare digit by digit.
              for (i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i) {
                if (xd[i] !== yd[i]) return (xd[i] > yd[i]) ^ (xs < 0) ? 1 : -1;
              } // Compare lengths.
              return xdL === ydL ? 0 : (xdL > ydL) ^ (xs < 0) ? 1 : -1;
            };
            /*
             * Return a new Decimal whose value is the cosine of the value in radians of this Decimal.
             *
             * Domain: [-Infinity, Infinity]
             * Range: [-1, 1]
             *
             * cos(0)         = 1
             * cos(-0)        = 1
             * cos(Infinity)  = NaN
             * cos(-Infinity) = NaN
             * cos(NaN)       = NaN
             *
             */ P.cosine = P.cos = function () {
              var pr,
                rm,
                x = this,
                Ctor = x.constructor;
              if (!x.d) return new Ctor(NaN); // cos(0) = cos(-0) = 1
              if (!x.d[0]) return new Ctor(1);
              pr = Ctor.precision;
              rm = Ctor.rounding;
              Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
              Ctor.rounding = 1;
              x = cosine(Ctor, toLessThanHalfPi(Ctor, x));
              Ctor.precision = pr;
              Ctor.rounding = rm;
              return finalise(
                quadrant == 2 || quadrant == 3 ? x.neg() : x,
                pr,
                rm,
                true
              );
            };
            /*
             *
             * Return a new Decimal whose value is the cube root of the value of this Decimal, rounded to
             * `precision` significant digits using rounding mode `rounding`.
             *
             *  cbrt(0)  =  0
             *  cbrt(-0) = -0
             *  cbrt(1)  =  1
             *  cbrt(-1) = -1
             *  cbrt(N)  =  N
             *  cbrt(-I) = -I
             *  cbrt(I)  =  I
             *
             * Math.cbrt(x) = (x < 0 ? -Math.pow(-x, 1/3) : Math.pow(x, 1/3))
             *
             */ P.cubeRoot = P.cbrt = function () {
              var e,
                m,
                n,
                r,
                rep,
                s,
                sd,
                t,
                t3,
                t3plusx,
                x = this,
                Ctor = x.constructor;
              if (!x.isFinite() || x.isZero()) return new Ctor(x);
              external = false; // Initial estimate.
              s = x.s * mathpow(x.s * x, 1 / 3); // Math.cbrt underflow/overflow?
              // Pass x to Math.pow as integer, then adjust the exponent of the result.
              if (!s || Math.abs(s) == 1 / 0) {
                n = digitsToString(x.d);
                e = x.e; // Adjust n exponent so it is a multiple of 3 away from x exponent.
                if ((s = (e - n.length + 1) % 3))
                  n += s == 1 || s == -2 ? "0" : "00";
                s = mathpow(n, 1 / 3); // Rarely, e may be one less than the result exponent value.
                e = mathfloor((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2));
                if (s == 1 / 0) {
                  n = "5e" + e;
                } else {
                  n = s.toExponential();
                  n = n.slice(0, n.indexOf("e") + 1) + e;
                }
                r = new Ctor(n);
                r.s = x.s;
              } else {
                r = new Ctor(s.toString());
              }
              sd = (e = Ctor.precision) + 3; // Halley's method.
              // TODO? Compare Newton's method.
              for (;;) {
                t = r;
                t3 = t.times(t).times(t);
                t3plusx = t3.plus(x);
                r = divide(t3plusx.plus(x).times(t), t3plusx.plus(t3), sd + 2, 1); // TODO? Replace with for-loop and checkRoundingDigits.
                if (
                  digitsToString(t.d).slice(0, sd) ===
                  (n = digitsToString(r.d)).slice(0, sd)
                ) {
                  n = n.slice(sd - 3, sd + 1); // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or 4999
                  // , i.e. approaching a rounding boundary, continue the iteration.
                  if (n == "9999" || (!rep && n == "4999")) {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    if (!rep) {
                      finalise(t, e + 1, 0);
                      if (t.times(t).times(t).eq(x)) {
                        r = t;
                        break;
                      }
                    }
                    sd += 4;
                    rep = 1;
                  } else {
                    // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
                    // If not, then there are further digits and m will be truthy.
                    if (!+n || (!+n.slice(1) && n.charAt(0) == "5")) {
                      // Truncate to the first rounding digit.
                      finalise(r, e + 1, 1);
                      m = !r.times(r).times(r).eq(x);
                    }
                    break;
                  }
                }
              }
              external = true;
              return finalise(r, e, Ctor.rounding, m);
            };
            /*
             * Return the number of decimal places of the value of this Decimal.
             *
             */ P.decimalPlaces = P.dp = function () {
              var w,
                d = this.d,
                n = NaN;
              if (d) {
                w = d.length - 1;
                n = (w - mathfloor(this.e / LOG_BASE)) * LOG_BASE; // Subtract the number of trailing zeros of the last word.
                w = d[w];
                if (w)
                  for (; w % 10 == 0; w /= 10) {
                    n--;
                  }
                if (n < 0) n = 0;
              }
              return n;
            };
            /*
             *  n / 0 = I
             *  n / N = N
             *  n / I = 0
             *  0 / n = 0
             *  0 / 0 = N
             *  0 / N = N
             *  0 / I = 0
             *  N / n = N
             *  N / 0 = N
             *  N / N = N
             *  N / I = N
             *  I / n = I
             *  I / 0 = I
             *  I / N = N
             *  I / I = N
             *
             * Return a new Decimal whose value is the value of this Decimal divided by `y`, rounded to
             * `precision` significant digits using rounding mode `rounding`.
             *
             */ P.dividedBy = P.div = function (y) {
              return divide(this, new this.constructor(y));
            };
            /*
             * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
             * by the value of `y`, rounded to `precision` significant digits using rounding mode `rounding`.
             *
             */ P.dividedToIntegerBy = P.divToInt = function (y) {
              var x = this,
                Ctor = x.constructor;
              return finalise(
                divide(x, new Ctor(y), 0, 1, 1),
                Ctor.precision,
                Ctor.rounding
              );
            };
            /*
             * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
             *
             */ P.equals = P.eq = function (y) {
              return this.cmp(y) === 0;
            };
            /*
             * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
             * direction of negative Infinity.
             *
             */ P.floor = function () {
              return finalise(new this.constructor(this), this.e + 1, 3);
            };
            /*
             * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
             * false.
             *
             */ P.greaterThan = P.gt = function (y) {
              return this.cmp(y) > 0;
            };
            /*
             * Return true if the value of this Decimal is greater than or equal to the value of `y`,
             * otherwise return false.
             *
             */ P.greaterThanOrEqualTo = P.gte = function (y) {
              var k = this.cmp(y);
              return k == 1 || k === 0;
            };
            /*
             * Return a new Decimal whose value is the hyperbolic cosine of the value in radians of this
             * Decimal.
             *
             * Domain: [-Infinity, Infinity]
             * Range: [1, Infinity]
             *
             * cosh(x) = 1 + x^2/2! + x^4/4! + x^6/6! + ...
             *
             * cosh(0)         = 1
             * cosh(-0)        = 1
             * cosh(Infinity)  = Infinity
             * cosh(-Infinity) = Infinity
             * cosh(NaN)       = NaN
             *
             *  x        time taken (ms)   result
             * 1000      9                 9.8503555700852349694e+433
             * 10000     25                4.4034091128314607936e+4342
             * 100000    171               1.4033316802130615897e+43429
             * 1000000   3817              1.5166076984010437725e+434294
             * 10000000  abandoned after 2 minute wait
             *
             * TODO? Compare performance of cosh(x) = 0.5 * (exp(x) + exp(-x))
             *
             */ P.hyperbolicCosine = P.cosh = function () {
              var k,
                n,
                pr,
                rm,
                len,
                x = this,
                Ctor = x.constructor,
                one = new Ctor(1);
              if (!x.isFinite()) return new Ctor(x.s ? 1 / 0 : NaN);
              if (x.isZero()) return one;
              pr = Ctor.precision;
              rm = Ctor.rounding;
              Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
              Ctor.rounding = 1;
              len = x.d.length; // Argument reduction: cos(4x) = 1 - 8cos^2(x) + 8cos^4(x) + 1
              // i.e. cos(x) = 1 - cos^2(x/4)(8 - 8cos^2(x/4))
              // Estimate the optimum number of times to use the argument reduction.
              // TODO? Estimation reused from cosine() and may not be optimal here.
              if (len < 32) {
                k = Math.ceil(len / 3);
                n = (1 / tinyPow(4, k)).toString();
              } else {
                k = 16;
                n = "2.3283064365386962890625e-10";
              }
              x = taylorSeries(Ctor, 1, x.times(n), new Ctor(1), true); // Reverse argument reduction
              var cosh2_x,
                i = k,
                d8 = new Ctor(8);
              for (; i--; ) {
                cosh2_x = x.times(x);
                x = one.minus(cosh2_x.times(d8.minus(cosh2_x.times(d8))));
              }
              return finalise(
                x,
                (Ctor.precision = pr),
                (Ctor.rounding = rm),
                true
              );
            };
            /*
             * Return a new Decimal whose value is the hyperbolic sine of the value in radians of this
             * Decimal.
             *
             * Domain: [-Infinity, Infinity]
             * Range: [-Infinity, Infinity]
             *
             * sinh(x) = x + x^3/3! + x^5/5! + x^7/7! + ...
             *
             * sinh(0)         = 0
             * sinh(-0)        = -0
             * sinh(Infinity)  = Infinity
             * sinh(-Infinity) = -Infinity
             * sinh(NaN)       = NaN
             *
             * x        time taken (ms)
             * 10       2 ms
             * 100      5 ms
             * 1000     14 ms
             * 10000    82 ms
             * 100000   886 ms            1.4033316802130615897e+43429
             * 200000   2613 ms
             * 300000   5407 ms
             * 400000   8824 ms
             * 500000   13026 ms          8.7080643612718084129e+217146
             * 1000000  48543 ms
             *
             * TODO? Compare performance of sinh(x) = 0.5 * (exp(x) - exp(-x))
             *
             */ P.hyperbolicSine = P.sinh = function () {
              var k,
                pr,
                rm,
                len,
                x = this,
                Ctor = x.constructor;
              if (!x.isFinite() || x.isZero()) return new Ctor(x);
              pr = Ctor.precision;
              rm = Ctor.rounding;
              Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
              Ctor.rounding = 1;
              len = x.d.length;
              if (len < 3) {
                x = taylorSeries(Ctor, 2, x, x, true);
              } else {
                // Alternative argument reduction: sinh(3x) = sinh(x)(3 + 4sinh^2(x))
                // i.e. sinh(x) = sinh(x/3)(3 + 4sinh^2(x/3))
                // 3 multiplications and 1 addition
                // Argument reduction: sinh(5x) = sinh(x)(5 + sinh^2(x)(20 + 16sinh^2(x)))
                // i.e. sinh(x) = sinh(x/5)(5 + sinh^2(x/5)(20 + 16sinh^2(x/5)))
                // 4 multiplications and 2 additions
                // Estimate the optimum number of times to use the argument reduction.
                k = 1.4 * Math.sqrt(len);
                k = k > 16 ? 16 : k | 0;
                x = x.times(1 / tinyPow(5, k));
                x = taylorSeries(Ctor, 2, x, x, true); // Reverse argument reduction
                var sinh2_x,
                  d5 = new Ctor(5),
                  d16 = new Ctor(16),
                  d20 = new Ctor(20);
                for (; k--; ) {
                  sinh2_x = x.times(x);
                  x = x.times(
                    d5.plus(sinh2_x.times(d16.times(sinh2_x).plus(d20)))
                  );
                }
              }
              Ctor.precision = pr;
              Ctor.rounding = rm;
              return finalise(x, pr, rm, true);
            };
            /*
             * Return a new Decimal whose value is the hyperbolic tangent of the value in radians of this
             * Decimal.
             *
             * Domain: [-Infinity, Infinity]
             * Range: [-1, 1]
             *
             * tanh(x) = sinh(x) / cosh(x)
             *
             * tanh(0)         = 0
             * tanh(-0)        = -0
             * tanh(Infinity)  = 1
             * tanh(-Infinity) = -1
             * tanh(NaN)       = NaN
             *
             */ P.hyperbolicTangent = P.tanh = function () {
              var pr,
                rm,
                x = this,
                Ctor = x.constructor;
              if (!x.isFinite()) return new Ctor(x.s);
              if (x.isZero()) return new Ctor(x);
              pr = Ctor.precision;
              rm = Ctor.rounding;
              Ctor.precision = pr + 7;
              Ctor.rounding = 1;
              return divide(
                x.sinh(),
                x.cosh(),
                (Ctor.precision = pr),
                (Ctor.rounding = rm)
              );
            };
            /*
             * Return a new Decimal whose value is the arccosine (inverse cosine) in radians of the value of
             * this Decimal.
             *
             * Domain: [-1, 1]
             * Range: [0, pi]
             *
             * acos(x) = pi/2 - asin(x)
             *
             * acos(0)       = pi/2
             * acos(-0)      = pi/2
             * acos(1)       = 0
             * acos(-1)      = pi
             * acos(1/2)     = pi/3
             * acos(-1/2)    = 2*pi/3
             * acos(|x| > 1) = NaN
             * acos(NaN)     = NaN
             *
             */ P.inverseCosine = P.acos = function () {
              var halfPi,
                x = this,
                Ctor = x.constructor,
                k = x.abs().cmp(1),
                pr = Ctor.precision,
                rm = Ctor.rounding;
              if (k !== -1) {
                return k === 0 // |x| is 1
                  ? x.isNeg()
                    ? getPi(Ctor, pr, rm)
                    : new Ctor(0) // |x| > 1 or x is NaN
                  : new Ctor(NaN);
              }
              if (x.isZero()) return getPi(Ctor, pr + 4, rm).times(0.5); // TODO? Special case acos(0.5) = pi/3 and acos(-0.5) = 2*pi/3
              Ctor.precision = pr + 6;
              Ctor.rounding = 1;
              x = x.asin();
              halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
              Ctor.precision = pr;
              Ctor.rounding = rm;
              return halfPi.minus(x);
            };
            /*
             * Return a new Decimal whose value is the inverse of the hyperbolic cosine in radians of the
             * value of this Decimal.
             *
             * Domain: [1, Infinity]
             * Range: [0, Infinity]
             *
             * acosh(x) = ln(x + sqrt(x^2 - 1))
             *
             * acosh(x < 1)     = NaN
             * acosh(NaN)       = NaN
             * acosh(Infinity)  = Infinity
             * acosh(-Infinity) = NaN
             * acosh(0)         = NaN
             * acosh(-0)        = NaN
             * acosh(1)         = 0
             * acosh(-1)        = NaN
             *
             */ P.inverseHyperbolicCosine = P.acosh = function () {
              var pr,
                rm,
                x = this,
                Ctor = x.constructor;
              if (x.lte(1)) return new Ctor(x.eq(1) ? 0 : NaN);
              if (!x.isFinite()) return new Ctor(x);
              pr = Ctor.precision;
              rm = Ctor.rounding;
              Ctor.precision = pr + Math.max(Math.abs(x.e), x.sd()) + 4;
              Ctor.rounding = 1;
              external = false;
              x = x.times(x).minus(1).sqrt().plus(x);
              external = true;
              Ctor.precision = pr;
              Ctor.rounding = rm;
              return x.ln();
            };
            /*
             * Return a new Decimal whose value is the inverse of the hyperbolic sine in radians of the value
             * of this Decimal.
             *
             * Domain: [-Infinity, Infinity]
             * Range: [-Infinity, Infinity]
             *
             * asinh(x) = ln(x + sqrt(x^2 + 1))
             *
             * asinh(NaN)       = NaN
             * asinh(Infinity)  = Infinity
             * asinh(-Infinity) = -Infinity
             * asinh(0)         = 0
             * asinh(-0)        = -0
             *
             */ P.inverseHyperbolicSine = P.asinh = function () {
              var pr,
                rm,
                x = this,
                Ctor = x.constructor;
              if (!x.isFinite() || x.isZero()) return new Ctor(x);
              pr = Ctor.precision;
              rm = Ctor.rounding;
              Ctor.precision = pr + 2 * Math.max(Math.abs(x.e), x.sd()) + 6;
              Ctor.rounding = 1;
              external = false;
              x = x.times(x).plus(1).sqrt().plus(x);
              external = true;
              Ctor.precision = pr;
              Ctor.rounding = rm;
              return x.ln();
            };
            /*
             * Return a new Decimal whose value is the inverse of the hyperbolic tangent in radians of the
             * value of this Decimal.
             *
             * Domain: [-1, 1]
             * Range: [-Infinity, Infinity]
             *
             * atanh(x) = 0.5 * ln((1 + x) / (1 - x))
             *
             * atanh(|x| > 1)   = NaN
             * atanh(NaN)       = NaN
             * atanh(Infinity)  = NaN
             * atanh(-Infinity) = NaN
             * atanh(0)         = 0
             * atanh(-0)        = -0
             * atanh(1)         = Infinity
             * atanh(-1)        = -Infinity
             *
             */ P.inverseHyperbolicTangent = P.atanh = function () {
              var pr,
                rm,
                wpr,
                xsd,
                x = this,
                Ctor = x.constructor;
              if (!x.isFinite()) return new Ctor(NaN);
              if (x.e >= 0)
                return new Ctor(x.abs().eq(1) ? x.s / 0 : x.isZero() ? x : NaN);
              pr = Ctor.precision;
              rm = Ctor.rounding;
              xsd = x.sd();
              if (Math.max(xsd, pr) < 2 * -x.e - 1)
                return finalise(new Ctor(x), pr, rm, true);
              Ctor.precision = wpr = xsd - x.e;
              x = divide(x.plus(1), new Ctor(1).minus(x), wpr + pr, 1);
              Ctor.precision = pr + 4;
              Ctor.rounding = 1;
              x = x.ln();
              Ctor.precision = pr;
              Ctor.rounding = rm;
              return x.times(0.5);
            };
            /*
             * Return a new Decimal whose value is the arcsine (inverse sine) in radians of the value of this
             * Decimal.
             *
             * Domain: [-Infinity, Infinity]
             * Range: [-pi/2, pi/2]
             *
             * asin(x) = 2*atan(x/(1 + sqrt(1 - x^2)))
             *
             * asin(0)       = 0
             * asin(-0)      = -0
             * asin(1/2)     = pi/6
             * asin(-1/2)    = -pi/6
             * asin(1)       = pi/2
             * asin(-1)      = -pi/2
             * asin(|x| > 1) = NaN
             * asin(NaN)     = NaN
             *
             * TODO? Compare performance of Taylor series.
             *
             */ P.inverseSine = P.asin = function () {
              var halfPi,
                k,
                pr,
                rm,
                x = this,
                Ctor = x.constructor;
              if (x.isZero()) return new Ctor(x);
              k = x.abs().cmp(1);
              pr = Ctor.precision;
              rm = Ctor.rounding;
              if (k !== -1) {
                // |x| is 1
                if (k === 0) {
                  halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
                  halfPi.s = x.s;
                  return halfPi;
                } // |x| > 1 or x is NaN
                return new Ctor(NaN);
              } // TODO? Special case asin(1/2) = pi/6 and asin(-1/2) = -pi/6
              Ctor.precision = pr + 6;
              Ctor.rounding = 1;
              x = x.div(new Ctor(1).minus(x.times(x)).sqrt().plus(1)).atan();
              Ctor.precision = pr;
              Ctor.rounding = rm;
              return x.times(2);
            };
            /*
             * Return a new Decimal whose value is the arctangent (inverse tangent) in radians of the value
             * of this Decimal.
             *
             * Domain: [-Infinity, Infinity]
             * Range: [-pi/2, pi/2]
             *
             * atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
             *
             * atan(0)         = 0
             * atan(-0)        = -0
             * atan(1)         = pi/4
             * atan(-1)        = -pi/4
             * atan(Infinity)  = pi/2
             * atan(-Infinity) = -pi/2
             * atan(NaN)       = NaN
             *
             */ P.inverseTangent = P.atan = function () {
              var i,
                j,
                k,
                n,
                px,
                t,
                r,
                wpr,
                x2,
                x = this,
                Ctor = x.constructor,
                pr = Ctor.precision,
                rm = Ctor.rounding;
              if (!x.isFinite()) {
                if (!x.s) return new Ctor(NaN);
                if (pr + 4 <= PI_PRECISION) {
                  r = getPi(Ctor, pr + 4, rm).times(0.5);
                  r.s = x.s;
                  return r;
                }
              } else if (x.isZero()) {
                return new Ctor(x);
              } else if (x.abs().eq(1) && pr + 4 <= PI_PRECISION) {
                r = getPi(Ctor, pr + 4, rm).times(0.25);
                r.s = x.s;
                return r;
              }
              Ctor.precision = wpr = pr + 10;
              Ctor.rounding = 1; // TODO? if (x >= 1 && pr <= PI_PRECISION) atan(x) = halfPi * x.s - atan(1 / x);
              // Argument reduction
              // Ensure |x| < 0.42
              // atan(x) = 2 * atan(x / (1 + sqrt(1 + x^2)))
              k = Math.min(28, (wpr / LOG_BASE + 2) | 0);
              for (i = k; i; --i) {
                x = x.div(x.times(x).plus(1).sqrt().plus(1));
              }
              external = false;
              j = Math.ceil(wpr / LOG_BASE);
              n = 1;
              x2 = x.times(x);
              r = new Ctor(x);
              px = x; // atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
              for (; i !== -1; ) {
                px = px.times(x2);
                t = r.minus(px.div((n += 2)));
                px = px.times(x2);
                r = t.plus(px.div((n += 2)));
                if (r.d[j] !== void 0) for (i = j; r.d[i] === t.d[i] && i--; ) {}
              }
              if (k) r = r.times(2 << (k - 1));
              external = true;
              return finalise(
                r,
                (Ctor.precision = pr),
                (Ctor.rounding = rm),
                true
              );
            };
            /*
             * Return true if the value of this Decimal is a finite number, otherwise return false.
             *
             */ P.isFinite = function () {
              return !!this.d;
            };
            /*
             * Return true if the value of this Decimal is an integer, otherwise return false.
             *
             */ P.isInteger = P.isInt = function () {
              return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
            };
            /*
             * Return true if the value of this Decimal is NaN, otherwise return false.
             *
             */ P.isNaN = function () {
              return !this.s;
            };
            /*
             * Return true if the value of this Decimal is negative, otherwise return false.
             *
             */ P.isNegative = P.isNeg = function () {
              return this.s < 0;
            };
            /*
             * Return true if the value of this Decimal is positive, otherwise return false.
             *
             */ P.isPositive = P.isPos = function () {
              return this.s > 0;
            };
            /*
             * Return true if the value of this Decimal is 0 or -0, otherwise return false.
             *
             */ P.isZero = function () {
              return !!this.d && this.d[0] === 0;
            };
            /*
             * Return true if the value of this Decimal is less than `y`, otherwise return false.
             *
             */ P.lessThan = P.lt = function (y) {
              return this.cmp(y) < 0;
            };
            /*
             * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
             *
             */ P.lessThanOrEqualTo = P.lte = function (y) {
              return this.cmp(y) < 1;
            };
            /*
             * Return the logarithm of the value of this Decimal to the specified base, rounded to `precision`
             * significant digits using rounding mode `rounding`.
             *
             * If no base is specified, return log[10](arg).
             *
             * log[base](arg) = ln(arg) / ln(base)
             *
             * The result will always be correctly rounded if the base of the log is 10, and 'almost always'
             * otherwise:
             *
             * Depending on the rounding mode, the result may be incorrectly rounded if the first fifteen
             * rounding digits are [49]99999999999999 or [50]00000000000000. In that case, the maximum error
             * between the result and the correctly rounded result will be one ulp (unit in the last place).
             *
             * log[-b](a)       = NaN
             * log[0](a)        = NaN
             * log[1](a)        = NaN
             * log[NaN](a)      = NaN
             * log[Infinity](a) = NaN
             * log[b](0)        = -Infinity
             * log[b](-0)       = -Infinity
             * log[b](-a)       = NaN
             * log[b](1)        = 0
             * log[b](Infinity) = Infinity
             * log[b](NaN)      = NaN
             *
             * [base] {number|string|Decimal} The base of the logarithm.
             *
             */ P.logarithm = P.log = function (base) {
              var isBase10,
                d,
                denominator,
                k,
                inf,
                num,
                sd,
                r,
                arg = this,
                Ctor = arg.constructor,
                pr = Ctor.precision,
                rm = Ctor.rounding,
                guard = 5; // Default base is 10.
              if (base == null) {
                base = new Ctor(10);
                isBase10 = true;
              } else {
                base = new Ctor(base);
                d = base.d; // Return NaN if base is negative, or non-finite, or is 0 or 1.
                if (base.s < 0 || !d || !d[0] || base.eq(1)) return new Ctor(NaN);
                isBase10 = base.eq(10);
              }
              d = arg.d; // Is arg negative, non-finite, 0 or 1?
              if (arg.s < 0 || !d || !d[0] || arg.eq(1)) {
                return new Ctor(
                  d && !d[0] ? -1 / 0 : arg.s != 1 ? NaN : d ? 0 : 1 / 0
                );
              } // The result will have a non-terminating decimal expansion if base is 10 and arg is not an
              // integer power of 10.
              if (isBase10) {
                if (d.length > 1) {
                  inf = true;
                } else {
                  for (k = d[0]; k % 10 === 0; ) {
                    k /= 10;
                  }
                  inf = k !== 1;
                }
              }
              external = false;
              sd = pr + guard;
              num = naturalLogarithm(arg, sd);
              denominator = isBase10
                ? getLn10(Ctor, sd + 10)
                : naturalLogarithm(base, sd); // The result will have 5 rounding digits.
              r = divide(num, denominator, sd, 1); // If at a rounding boundary, i.e. the result's rounding digits are [49]9999 or [50]0000,
              // calculate 10 further digits.
              //
              // If the result is known to have an infinite decimal expansion, repeat this until it is clear
              // that the result is above or below the boundary. Otherwise, if after calculating the 10
              // further digits, the last 14 are nines, round up and assume the result is exact.
              // Also assume the result is exact if the last 14 are zero.
              //
              // Example of a result that will be incorrectly rounded:
              // log[1048576](4503599627370502) = 2.60000000000000009610279511444746...
              // The above result correctly rounded using ROUND_CEIL to 1 decimal place should be 2.7, but it
              // will be given as 2.6 as there are 15 zeros immediately after the requested decimal place, so
              // the exact result would be assumed to be 2.6, which rounded using ROUND_CEIL to 1 decimal
              // place is still 2.6.
              if (checkRoundingDigits(r.d, (k = pr), rm)) {
                do {
                  sd += 10;
                  num = naturalLogarithm(arg, sd);
                  denominator = isBase10
                    ? getLn10(Ctor, sd + 10)
                    : naturalLogarithm(base, sd);
                  r = divide(num, denominator, sd, 1);
                  if (!inf) {
                    // Check for 14 nines from the 2nd rounding digit, as the first may be 4.
                    if (+digitsToString(r.d).slice(k + 1, k + 15) + 1 == 1e14) {
                      r = finalise(r, pr + 1, 0);
                    }
                    break;
                  }
                } while (checkRoundingDigits(r.d, (k += 10), rm));
              }
              external = true;
              return finalise(r, pr, rm);
            };
            /*
       * Return a new Decimal whose value is the maximum of the arguments and the value of this Decimal.
       *
       * arguments {number|string|Decimal}
       *
      P.max = function () {
        Array.prototype.push.call(arguments, this);
        return maxOrMin(this.constructor, arguments, 'lt');
      };
       */ /*
       * Return a new Decimal whose value is the minimum of the arguments and the value of this Decimal.
       *
       * arguments {number|string|Decimal}
       *
      P.min = function () {
        Array.prototype.push.call(arguments, this);
        return maxOrMin(this.constructor, arguments, 'gt');
      };
       */ /*
             *  n - 0 = n
             *  n - N = N
             *  n - I = -I
             *  0 - n = -n
             *  0 - 0 = 0
             *  0 - N = N
             *  0 - I = -I
             *  N - n = N
             *  N - 0 = N
             *  N - N = N
             *  N - I = N
             *  I - n = I
             *  I - 0 = I
             *  I - N = N
             *  I - I = N
             *
             * Return a new Decimal whose value is the value of this Decimal minus `y`, rounded to `precision`
             * significant digits using rounding mode `rounding`.
             *
             */ P.minus = P.sub = function (y) {
              var d,
                e,
                i,
                j,
                k,
                len,
                pr,
                rm,
                xd,
                xe,
                xLTy,
                yd,
                x = this,
                Ctor = x.constructor;
              y = new Ctor(y); // If either is not finite...
              if (!x.d || !y.d) {
                // Return NaN if either is NaN.
                if (!x.s || !y.s) y = new Ctor(NaN);
                // Return y negated if x is finite and y is ±Infinity.
                else if (x.d) y.s = -y.s;
                // Return x if y is finite and x is ±Infinity.
                // Return x if both are ±Infinity with different signs.
                // Return NaN if both are ±Infinity with the same sign.
                else y = new Ctor(y.d || x.s !== y.s ? x : NaN);
                return y;
              } // If signs differ...
              if (x.s != y.s) {
                y.s = -y.s;
                return x.plus(y);
              }
              xd = x.d;
              yd = y.d;
              pr = Ctor.precision;
              rm = Ctor.rounding; // If either is zero...
              if (!xd[0] || !yd[0]) {
                // Return y negated if x is zero and y is non-zero.
                if (yd[0]) y.s = -y.s;
                // Return x if y is zero and x is non-zero.
                else if (xd[0]) y = new Ctor(x);
                // Return zero if both are zero.
                // From IEEE 754 (2008) 6.3: 0 - 0 = -0 - -0 = -0 when rounding to -Infinity.
                else return new Ctor(rm === 3 ? -0 : 0);
                return external ? finalise(y, pr, rm) : y;
              } // x and y are finite, non-zero numbers with the same sign.
              // Calculate base 1e7 exponents.
              e = mathfloor(y.e / LOG_BASE);
              xe = mathfloor(x.e / LOG_BASE);
              xd = xd.slice();
              k = xe - e; // If base 1e7 exponents differ...
              if (k) {
                xLTy = k < 0;
                if (xLTy) {
                  d = xd;
                  k = -k;
                  len = yd.length;
                } else {
                  d = yd;
                  e = xe;
                  len = xd.length;
                } // Numbers with massively different exponents would result in a very high number of
                // zeros needing to be prepended, but this can be avoided while still ensuring correct
                // rounding by limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
                i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
                if (k > i) {
                  k = i;
                  d.length = 1;
                } // Prepend zeros to equalise exponents.
                d.reverse();
                for (i = k; i--; ) {
                  d.push(0);
                }
                d.reverse(); // Base 1e7 exponents equal.
              } else {
                // Check digits to determine which is the bigger number.
                i = xd.length;
                len = yd.length;
                xLTy = i < len;
                if (xLTy) len = i;
                for (i = 0; i < len; i++) {
                  if (xd[i] != yd[i]) {
                    xLTy = xd[i] < yd[i];
                    break;
                  }
                }
                k = 0;
              }
              if (xLTy) {
                d = xd;
                xd = yd;
                yd = d;
                y.s = -y.s;
              }
              len = xd.length; // Append zeros to `xd` if shorter.
              // Don't add zeros to `yd` if shorter as subtraction only needs to start at `yd` length.
              for (i = yd.length - len; i > 0; --i) {
                xd[len++] = 0;
              } // Subtract yd from xd.
              for (i = yd.length; i > k; ) {
                if (xd[--i] < yd[i]) {
                  for (j = i; j && xd[--j] === 0; ) {
                    xd[j] = BASE - 1;
                  }
                  --xd[j];
                  xd[i] += BASE;
                }
                xd[i] -= yd[i];
              } // Remove trailing zeros.
              for (; xd[--len] === 0; ) {
                xd.pop();
              } // Remove leading zeros and adjust exponent accordingly.
              for (; xd[0] === 0; xd.shift()) {
                --e;
              } // Zero?
              if (!xd[0]) return new Ctor(rm === 3 ? -0 : 0);
              y.d = xd;
              y.e = getBase10Exponent(xd, e);
              return external ? finalise(y, pr, rm) : y;
            };
            /*
             *   n % 0 =  N
             *   n % N =  N
             *   n % I =  n
             *   0 % n =  0
             *  -0 % n = -0
             *   0 % 0 =  N
             *   0 % N =  N
             *   0 % I =  0
             *   N % n =  N
             *   N % 0 =  N
             *   N % N =  N
             *   N % I =  N
             *   I % n =  N
             *   I % 0 =  N
             *   I % N =  N
             *   I % I =  N
             *
             * Return a new Decimal whose value is the value of this Decimal modulo `y`, rounded to
             * `precision` significant digits using rounding mode `rounding`.
             *
             * The result depends on the modulo mode.
             *
             */ P.modulo = P.mod = function (y) {
              var q,
                x = this,
                Ctor = x.constructor;
              y = new Ctor(y); // Return NaN if x is ±Infinity or NaN, or y is NaN or ±0.
              if (!x.d || !y.s || (y.d && !y.d[0])) return new Ctor(NaN); // Return x if y is ±Infinity or x is ±0.
              if (!y.d || (x.d && !x.d[0])) {
                return finalise(new Ctor(x), Ctor.precision, Ctor.rounding);
              } // Prevent rounding of intermediate calculations.
              external = false;
              if (Ctor.modulo == 9) {
                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // result = x - q * y    where  0 <= result < abs(y)
                q = divide(x, y.abs(), 0, 3, 1);
                q.s *= y.s;
              } else {
                q = divide(x, y, 0, Ctor.modulo, 1);
              }
              q = q.times(y);
              external = true;
              return x.minus(q);
            };
            /*
             * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
             * i.e. the base e raised to the power the value of this Decimal, rounded to `precision`
             * significant digits using rounding mode `rounding`.
             *
             */ P.naturalExponential = P.exp = function () {
              return naturalExponential(this);
            };
            /*
             * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
             * rounded to `precision` significant digits using rounding mode `rounding`.
             *
             */ P.naturalLogarithm = P.ln = function () {
              return naturalLogarithm(this);
            };
            /*
             * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
             * -1.
             *
             */ P.negated = P.neg = function () {
              var x = new this.constructor(this);
              x.s = -x.s;
              return finalise(x);
            };
            /*
             *  n + 0 = n
             *  n + N = N
             *  n + I = I
             *  0 + n = n
             *  0 + 0 = 0
             *  0 + N = N
             *  0 + I = I
             *  N + n = N
             *  N + 0 = N
             *  N + N = N
             *  N + I = N
             *  I + n = I
             *  I + 0 = I
             *  I + N = N
             *  I + I = I
             *
             * Return a new Decimal whose value is the value of this Decimal plus `y`, rounded to `precision`
             * significant digits using rounding mode `rounding`.
             *
             */ P.plus = P.add = function (y) {
              var carry,
                d,
                e,
                i,
                k,
                len,
                pr,
                rm,
                xd,
                yd,
                x = this,
                Ctor = x.constructor;
              y = new Ctor(y); // If either is not finite...
              if (!x.d || !y.d) {
                // Return NaN if either is NaN.
                if (!x.s || !y.s) y = new Ctor(NaN);
                // Return x if y is finite and x is ±Infinity.
                // Return x if both are ±Infinity with the same sign.
                // Return NaN if both are ±Infinity with different signs.
                // Return y if x is finite and y is ±Infinity.
                else if (!x.d) y = new Ctor(y.d || x.s === y.s ? x : NaN);
                return y;
              } // If signs differ...
              if (x.s != y.s) {
                y.s = -y.s;
                return x.minus(y);
              }
              xd = x.d;
              yd = y.d;
              pr = Ctor.precision;
              rm = Ctor.rounding; // If either is zero...
              if (!xd[0] || !yd[0]) {
                // Return x if y is zero.
                // Return y if y is non-zero.
                if (!yd[0]) y = new Ctor(x);
                return external ? finalise(y, pr, rm) : y;
              } // x and y are finite, non-zero numbers with the same sign.
              // Calculate base 1e7 exponents.
              k = mathfloor(x.e / LOG_BASE);
              e = mathfloor(y.e / LOG_BASE);
              xd = xd.slice();
              i = k - e; // If base 1e7 exponents differ...
              if (i) {
                if (i < 0) {
                  d = xd;
                  i = -i;
                  len = yd.length;
                } else {
                  d = yd;
                  e = k;
                  len = xd.length;
                } // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
                k = Math.ceil(pr / LOG_BASE);
                len = k > len ? k + 1 : len + 1;
                if (i > len) {
                  i = len;
                  d.length = 1;
                } // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
                d.reverse();
                for (; i--; ) {
                  d.push(0);
                }
                d.reverse();
              }
              len = xd.length;
              i = yd.length; // If yd is longer than xd, swap xd and yd so xd points to the longer array.
              if (len - i < 0) {
                i = len;
                d = yd;
                yd = xd;
                xd = d;
              } // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
              for (carry = 0; i; ) {
                carry = ((xd[--i] = xd[i] + yd[i] + carry) / BASE) | 0;
                xd[i] %= BASE;
              }
              if (carry) {
                xd.unshift(carry);
                ++e;
              } // Remove trailing zeros.
              // No need to check for zero, as +x + +y != 0 && -x + -y != 0
              for (len = xd.length; xd[--len] == 0; ) {
                xd.pop();
              }
              y.d = xd;
              y.e = getBase10Exponent(xd, e);
              return external ? finalise(y, pr, rm) : y;
            };
            /*
             * Return the number of significant digits of the value of this Decimal.
             *
             * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
             *
             */ P.precision = P.sd = function (z) {
              var k,
                x = this;
              if (z !== void 0 && z !== !!z && z !== 1 && z !== 0)
                throw Error(invalidArgument + z);
              if (x.d) {
                k = getPrecision(x.d);
                if (z && x.e + 1 > k) k = x.e + 1;
              } else {
                k = NaN;
              }
              return k;
            };
            /*
             * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
             * rounding mode `rounding`.
             *
             */ P.round = function () {
              var x = this,
                Ctor = x.constructor;
              return finalise(new Ctor(x), x.e + 1, Ctor.rounding);
            };
            /*
             * Return a new Decimal whose value is the sine of the value in radians of this Decimal.
             *
             * Domain: [-Infinity, Infinity]
             * Range: [-1, 1]
             *
             * sin(x) = x - x^3/3! + x^5/5! - ...
             *
             * sin(0)         = 0
             * sin(-0)        = -0
             * sin(Infinity)  = NaN
             * sin(-Infinity) = NaN
             * sin(NaN)       = NaN
             *
             */ P.sine = P.sin = function () {
              var pr,
                rm,
                x = this,
                Ctor = x.constructor;
              if (!x.isFinite()) return new Ctor(NaN);
              if (x.isZero()) return new Ctor(x);
              pr = Ctor.precision;
              rm = Ctor.rounding;
              Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
              Ctor.rounding = 1;
              x = sine(Ctor, toLessThanHalfPi(Ctor, x));
              Ctor.precision = pr;
              Ctor.rounding = rm;
              return finalise(quadrant > 2 ? x.neg() : x, pr, rm, true);
            };
            /*
             * Return a new Decimal whose value is the square root of this Decimal, rounded to `precision`
             * significant digits using rounding mode `rounding`.
             *
             *  sqrt(-n) =  N
             *  sqrt(N)  =  N
             *  sqrt(-I) =  N
             *  sqrt(I)  =  I
             *  sqrt(0)  =  0
             *  sqrt(-0) = -0
             *
             */ P.squareRoot = P.sqrt = function () {
              var m,
                n,
                sd,
                r,
                rep,
                t,
                x = this,
                d = x.d,
                e = x.e,
                s = x.s,
                Ctor = x.constructor; // Negative/NaN/Infinity/zero?
              if (s !== 1 || !d || !d[0]) {
                return new Ctor(
                  !s || (s < 0 && (!d || d[0])) ? NaN : d ? x : 1 / 0
                );
              }
              external = false; // Initial estimate.
              s = Math.sqrt(+x); // Math.sqrt underflow/overflow?
              // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
              if (s == 0 || s == 1 / 0) {
                n = digitsToString(d);
                if ((n.length + e) % 2 == 0) n += "0";
                s = Math.sqrt(n);
                e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
                if (s == 1 / 0) {
                  n = "5e" + e;
                } else {
                  n = s.toExponential();
                  n = n.slice(0, n.indexOf("e") + 1) + e;
                }
                r = new Ctor(n);
              } else {
                r = new Ctor(s.toString());
              }
              sd = (e = Ctor.precision) + 3; // Newton-Raphson iteration.
              for (;;) {
                t = r;
                r = t.plus(divide(x, t, sd + 2, 1)).times(0.5); // TODO? Replace with for-loop and checkRoundingDigits.
                if (
                  digitsToString(t.d).slice(0, sd) ===
                  (n = digitsToString(r.d)).slice(0, sd)
                ) {
                  n = n.slice(sd - 3, sd + 1); // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                  // 4999, i.e. approaching a rounding boundary, continue the iteration.
                  if (n == "9999" || (!rep && n == "4999")) {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    if (!rep) {
                      finalise(t, e + 1, 0);
                      if (t.times(t).eq(x)) {
                        r = t;
                        break;
                      }
                    }
                    sd += 4;
                    rep = 1;
                  } else {
                    // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
                    // If not, then there are further digits and m will be truthy.
                    if (!+n || (!+n.slice(1) && n.charAt(0) == "5")) {
                      // Truncate to the first rounding digit.
                      finalise(r, e + 1, 1);
                      m = !r.times(r).eq(x);
                    }
                    break;
                  }
                }
              }
              external = true;
              return finalise(r, e, Ctor.rounding, m);
            };
            /*
             * Return a new Decimal whose value is the tangent of the value in radians of this Decimal.
             *
             * Domain: [-Infinity, Infinity]
             * Range: [-Infinity, Infinity]
             *
             * tan(0)         = 0
             * tan(-0)        = -0
             * tan(Infinity)  = NaN
             * tan(-Infinity) = NaN
             * tan(NaN)       = NaN
             *
             */ P.tangent = P.tan = function () {
              var pr,
                rm,
                x = this,
                Ctor = x.constructor;
              if (!x.isFinite()) return new Ctor(NaN);
              if (x.isZero()) return new Ctor(x);
              pr = Ctor.precision;
              rm = Ctor.rounding;
              Ctor.precision = pr + 10;
              Ctor.rounding = 1;
              x = x.sin();
              x.s = 1;
              x = divide(x, new Ctor(1).minus(x.times(x)).sqrt(), pr + 10, 0);
              Ctor.precision = pr;
              Ctor.rounding = rm;
              return finalise(
                quadrant == 2 || quadrant == 4 ? x.neg() : x,
                pr,
                rm,
                true
              );
            };
            /*
             *  n * 0 = 0
             *  n * N = N
             *  n * I = I
             *  0 * n = 0
             *  0 * 0 = 0
             *  0 * N = N
             *  0 * I = N
             *  N * n = N
             *  N * 0 = N
             *  N * N = N
             *  N * I = N
             *  I * n = I
             *  I * 0 = N
             *  I * N = N
             *  I * I = I
             *
             * Return a new Decimal whose value is this Decimal times `y`, rounded to `precision` significant
             * digits using rounding mode `rounding`.
             *
             */ P.times = P.mul = function (y) {
              var carry,
                e,
                i,
                k,
                r,
                rL,
                t,
                xdL,
                ydL,
                x = this,
                Ctor = x.constructor,
                xd = x.d,
                yd = (y = new Ctor(y)).d;
              y.s *= x.s; // If either is NaN, ±Infinity or ±0...
              if (!xd || !xd[0] || !yd || !yd[0]) {
                return new Ctor(
                  !y.s || (xd && !xd[0] && !yd) || (yd && !yd[0] && !xd) // Return NaN if either is NaN.
                    ? // Return NaN if x is ±0 and y is ±Infinity, or y is ±0 and x is ±Infinity.
                      NaN // Return ±Infinity if either is ±Infinity.
                    : // Return ±0 if either is ±0.
                    !xd || !yd
                    ? y.s / 0
                    : y.s * 0
                );
              }
              e = mathfloor(x.e / LOG_BASE) + mathfloor(y.e / LOG_BASE);
              xdL = xd.length;
              ydL = yd.length; // Ensure xd points to the longer array.
              if (xdL < ydL) {
                r = xd;
                xd = yd;
                yd = r;
                rL = xdL;
                xdL = ydL;
                ydL = rL;
              } // Initialise the result array with zeros.
              r = [];
              rL = xdL + ydL;
              for (i = rL; i--; ) {
                r.push(0);
              } // Multiply!
              for (i = ydL; --i >= 0; ) {
                carry = 0;
                for (k = xdL + i; k > i; ) {
                  t = r[k] + yd[i] * xd[k - i - 1] + carry;
                  r[k--] = t % BASE | 0;
                  carry = (t / BASE) | 0;
                }
                r[k] = (r[k] + carry) % BASE | 0;
              } // Remove trailing zeros.
              for (; !r[--rL]; ) {
                r.pop();
              }
              if (carry) ++e;
              else r.shift();
              y.d = r;
              y.e = getBase10Exponent(r, e);
              return external ? finalise(y, Ctor.precision, Ctor.rounding) : y;
            };
            /*
             * Return a string representing the value of this Decimal in base 2, round to `sd` significant
             * digits using rounding mode `rm`.
             *
             * If the optional `sd` argument is present then return binary exponential notation.
             *
             * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
             * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
             *
             */ P.toBinary = function (sd, rm) {
              return toStringBinary(this, 2, sd, rm);
            };
            /*
             * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
             * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
             *
             * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
             *
             * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
             * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
             *
             */ P.toDecimalPlaces = P.toDP = function (dp, rm) {
              var x = this,
                Ctor = x.constructor;
              x = new Ctor(x);
              if (dp === void 0) return x;
              checkInt32(dp, 0, MAX_DIGITS);
              if (rm === void 0) rm = Ctor.rounding;
              else checkInt32(rm, 0, 8);
              return finalise(x, dp + x.e + 1, rm);
            };
            /*
             * Return a string representing the value of this Decimal in exponential notation rounded to
             * `dp` fixed decimal places using rounding mode `rounding`.
             *
             * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
             * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
             *
             */ P.toExponential = function (dp, rm) {
              var str,
                x = this,
                Ctor = x.constructor;
              if (dp === void 0) {
                str = finiteToString(x, true);
              } else {
                checkInt32(dp, 0, MAX_DIGITS);
                if (rm === void 0) rm = Ctor.rounding;
                else checkInt32(rm, 0, 8);
                x = finalise(new Ctor(x), dp + 1, rm);
                str = finiteToString(x, true, dp + 1);
              }
              return x.isNeg() && !x.isZero() ? "-" + str : str;
            };
            /*
             * Return a string representing the value of this Decimal in normal (fixed-point) notation to
             * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
             * omitted.
             *
             * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
             *
             * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
             * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
             *
             * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
             * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
             * (-0).toFixed(3) is '0.000'.
             * (-0.5).toFixed(0) is '-0'.
             *
             */ P.toFixed = function (dp, rm) {
              var str,
                y,
                x = this,
                Ctor = x.constructor;
              if (dp === void 0) {
                str = finiteToString(x);
              } else {
                checkInt32(dp, 0, MAX_DIGITS);
                if (rm === void 0) rm = Ctor.rounding;
                else checkInt32(rm, 0, 8);
                y = finalise(new Ctor(x), dp + x.e + 1, rm);
                str = finiteToString(y, false, dp + y.e + 1);
              } // To determine whether to add the minus sign look at the value before it was rounded,
              // i.e. look at `x` rather than `y`.
              return x.isNeg() && !x.isZero() ? "-" + str : str;
            };
            /*
             * Return an array representing the value of this Decimal as a simple fraction with an integer
             * numerator and an integer denominator.
             *
             * The denominator will be a positive non-zero value less than or equal to the specified maximum
             * denominator. If a maximum denominator is not specified, the denominator will be the lowest
             * value necessary to represent the number exactly.
             *
             * [maxD] {number|string|Decimal} Maximum denominator. Integer >= 1 and < Infinity.
             *
             */ P.toFraction = function (maxD) {
              var d,
                d0,
                d1,
                d2,
                e,
                k,
                n,
                n0,
                n1,
                pr,
                q,
                r,
                x = this,
                xd = x.d,
                Ctor = x.constructor;
              if (!xd) return new Ctor(x);
              n1 = d0 = new Ctor(1);
              d1 = n0 = new Ctor(0);
              d = new Ctor(d1);
              e = d.e = getPrecision(xd) - x.e - 1;
              k = e % LOG_BASE;
              d.d[0] = mathpow(10, k < 0 ? LOG_BASE + k : k);
              if (maxD == null) {
                // d is 10**e, the minimum max-denominator needed.
                maxD = e > 0 ? d : n1;
              } else {
                n = new Ctor(maxD);
                if (!n.isInt() || n.lt(n1)) throw Error(invalidArgument + n);
                maxD = n.gt(d) ? (e > 0 ? d : n1) : n;
              }
              external = false;
              n = new Ctor(digitsToString(xd));
              pr = Ctor.precision;
              Ctor.precision = e = xd.length * LOG_BASE * 2;
              for (;;) {
                q = divide(n, d, 0, 1, 1);
                d2 = d0.plus(q.times(d1));
                if (d2.cmp(maxD) == 1) break;
                d0 = d1;
                d1 = d2;
                d2 = n1;
                n1 = n0.plus(q.times(d2));
                n0 = d2;
                d2 = d;
                d = n.minus(q.times(d2));
                n = d2;
              }
              d2 = divide(maxD.minus(d0), d1, 0, 1, 1);
              n0 = n0.plus(d2.times(n1));
              d0 = d0.plus(d2.times(d1));
              n0.s = n1.s = x.s; // Determine which fraction is closer to x, n0/d0 or n1/d1?
              r =
                divide(n1, d1, e, 1)
                  .minus(x)
                  .abs()
                  .cmp(divide(n0, d0, e, 1).minus(x).abs()) < 1
                  ? [n1, d1]
                  : [n0, d0];
              Ctor.precision = pr;
              external = true;
              return r;
            };
            /*
             * Return a string representing the value of this Decimal in base 16, round to `sd` significant
             * digits using rounding mode `rm`.
             *
             * If the optional `sd` argument is present then return binary exponential notation.
             *
             * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
             * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
             *
             */ P.toHexadecimal = P.toHex = function (sd, rm) {
              return toStringBinary(this, 16, sd, rm);
            };
            /*
             * Returns a new Decimal whose value is the nearest multiple of `y` in the direction of rounding
             * mode `rm`, or `Decimal.rounding` if `rm` is omitted, to the value of this Decimal.
             *
             * The return value will always have the same sign as this Decimal, unless either this Decimal
             * or `y` is NaN, in which case the return value will be also be NaN.
             *
             * The return value is not affected by the value of `precision`.
             *
             * y {number|string|Decimal} The magnitude to round to a multiple of.
             * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
             *
             * 'toNearest() rounding mode not an integer: {rm}'
             * 'toNearest() rounding mode out of range: {rm}'
             *
             */ P.toNearest = function (y, rm) {
              var x = this,
                Ctor = x.constructor;
              x = new Ctor(x);
              if (y == null) {
                // If x is not finite, return x.
                if (!x.d) return x;
                y = new Ctor(1);
                rm = Ctor.rounding;
              } else {
                y = new Ctor(y);
                if (rm === void 0) {
                  rm = Ctor.rounding;
                } else {
                  checkInt32(rm, 0, 8);
                } // If x is not finite, return x if y is not NaN, else NaN.
                if (!x.d) return y.s ? x : y; // If y is not finite, return Infinity with the sign of x if y is Infinity, else NaN.
                if (!y.d) {
                  if (y.s) y.s = x.s;
                  return y;
                }
              } // If y is not zero, calculate the nearest multiple of y to x.
              if (y.d[0]) {
                external = false;
                x = divide(x, y, 0, rm, 1).times(y);
                external = true;
                finalise(x); // If y is zero, return zero with the sign of x.
              } else {
                y.s = x.s;
                x = y;
              }
              return x;
            };
            /*
             * Return the value of this Decimal converted to a number primitive.
             * Zero keeps its sign.
             *
             */ P.toNumber = function () {
              return +this;
            };
            /*
             * Return a string representing the value of this Decimal in base 8, round to `sd` significant
             * digits using rounding mode `rm`.
             *
             * If the optional `sd` argument is present then return binary exponential notation.
             *
             * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
             * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
             *
             */ P.toOctal = function (sd, rm) {
              return toStringBinary(this, 8, sd, rm);
            };
            /*
             * Return a new Decimal whose value is the value of this Decimal raised to the power `y`, rounded
             * to `precision` significant digits using rounding mode `rounding`.
             *
             * ECMAScript compliant.
             *
             *   pow(x, NaN)                           = NaN
             *   pow(x, ±0)                            = 1
             *   pow(NaN, non-zero)                    = NaN
             *   pow(abs(x) > 1, +Infinity)            = +Infinity
             *   pow(abs(x) > 1, -Infinity)            = +0
             *   pow(abs(x) == 1, ±Infinity)           = NaN
             *   pow(abs(x) < 1, +Infinity)            = +0
             *   pow(abs(x) < 1, -Infinity)            = +Infinity
             *   pow(+Infinity, y > 0)                 = +Infinity
             *   pow(+Infinity, y < 0)                 = +0
             *   pow(-Infinity, odd integer > 0)       = -Infinity
             *   pow(-Infinity, even integer > 0)      = +Infinity
             *   pow(-Infinity, odd integer < 0)       = -0
             *   pow(-Infinity, even integer < 0)      = +0
             *   pow(+0, y > 0)                        = +0
             *   pow(+0, y < 0)                        = +Infinity
             *   pow(-0, odd integer > 0)              = -0
             *   pow(-0, even integer > 0)             = +0
             *   pow(-0, odd integer < 0)              = -Infinity
             *   pow(-0, even integer < 0)             = +Infinity
             *   pow(finite x < 0, finite non-integer) = NaN
             *
             * For non-integer or very large exponents pow(x, y) is calculated using
             *
             *   x^y = exp(y*ln(x))
             *
             * Assuming the first 15 rounding digits are each equally likely to be any digit 0-9, the
             * probability of an incorrectly rounded result
             * P([49]9{14} | [50]0{14}) = 2 * 0.2 * 10^-14 = 4e-15 = 1/2.5e+14
             * i.e. 1 in 250,000,000,000,000
             *
             * If a result is incorrectly rounded the maximum error will be 1 ulp (unit in last place).
             *
             * y {number|string|Decimal} The power to which to raise this Decimal.
             *
             */ P.toPower = P.pow = function (y) {
              var e,
                k,
                pr,
                r,
                rm,
                s,
                x = this,
                Ctor = x.constructor,
                yn = +(y = new Ctor(y)); // Either ±Infinity, NaN or ±0?
              if (!x.d || !y.d || !x.d[0] || !y.d[0])
                return new Ctor(mathpow(+x, yn));
              x = new Ctor(x);
              if (x.eq(1)) return x;
              pr = Ctor.precision;
              rm = Ctor.rounding;
              if (y.eq(1)) return finalise(x, pr, rm); // y exponent
              e = mathfloor(y.e / LOG_BASE); // If y is a small integer use the 'exponentiation by squaring' algorithm.
              if (
                e >= y.d.length - 1 &&
                (k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER
              ) {
                r = intPow(Ctor, x, k, pr);
                return y.s < 0 ? new Ctor(1).div(r) : finalise(r, pr, rm);
              }
              s = x.s; // if x is negative
              if (s < 0) {
                // if y is not an integer
                if (e < y.d.length - 1) return new Ctor(NaN); // Result is positive if x is negative and the last digit of integer y is even.
                if ((y.d[e] & 1) == 0) s = 1; // if x.eq(-1)
                if (x.e == 0 && x.d[0] == 1 && x.d.length == 1) {
                  x.s = s;
                  return x;
                }
              } // Estimate result exponent.
              // x^y = 10^e,  where e = y * log10(x)
              // log10(x) = log10(x_significand) + x_exponent
              // log10(x_significand) = ln(x_significand) / ln(10)
              k = mathpow(+x, yn);
              e =
                k == 0 || !isFinite(k)
                  ? mathfloor(
                      yn *
                        (Math.log("0." + digitsToString(x.d)) / Math.LN10 +
                          x.e +
                          1)
                    )
                  : new Ctor(k + "").e; // Exponent estimate may be incorrect e.g. x: 0.999999999999999999, y: 2.29, e: 0, r.e: -1.
              // Overflow/underflow?
              if (e > Ctor.maxE + 1 || e < Ctor.minE - 1)
                return new Ctor(e > 0 ? s / 0 : 0);
              external = false;
              Ctor.rounding = x.s = 1; // Estimate the extra guard digits needed to ensure five correct rounding digits from
              // naturalLogarithm(x). Example of failure without these extra digits (precision: 10):
              // new Decimal(2.32456).pow('2087987436534566.46411')
              // should be 1.162377823e+764914905173815, but is 1.162355823e+764914905173815
              k = Math.min(12, (e + "").length); // r = x^y = exp(y*ln(x))
              r = naturalExponential(y.times(naturalLogarithm(x, pr + k)), pr); // r may be Infinity, e.g. (0.9999999999999999).pow(-1e+40)
              if (r.d) {
                // Truncate to the required precision plus five rounding digits.
                r = finalise(r, pr + 5, 1); // If the rounding digits are [49]9999 or [50]0000 increase the precision by 10 and recalculate
                // the result.
                if (checkRoundingDigits(r.d, pr, rm)) {
                  e = pr + 10; // Truncate to the increased precision plus five rounding digits.
                  r = finalise(
                    naturalExponential(y.times(naturalLogarithm(x, e + k)), e),
                    e + 5,
                    1
                  ); // Check for 14 nines from the 2nd rounding digit (the first rounding digit may be 4 or 9).
                  if (+digitsToString(r.d).slice(pr + 1, pr + 15) + 1 == 1e14) {
                    r = finalise(r, pr + 1, 0);
                  }
                }
              }
              r.s = s;
              external = true;
              Ctor.rounding = rm;
              return finalise(r, pr, rm);
            };
            /*
             * Return a string representing the value of this Decimal rounded to `sd` significant digits
             * using rounding mode `rounding`.
             *
             * Return exponential notation if `sd` is less than the number of digits necessary to represent
             * the integer part of the value in normal notation.
             *
             * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
             * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
             *
             */ P.toPrecision = function (sd, rm) {
              var str,
                x = this,
                Ctor = x.constructor;
              if (sd === void 0) {
                str = finiteToString(
                  x,
                  x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos
                );
              } else {
                checkInt32(sd, 1, MAX_DIGITS);
                if (rm === void 0) rm = Ctor.rounding;
                else checkInt32(rm, 0, 8);
                x = finalise(new Ctor(x), sd, rm);
                str = finiteToString(x, sd <= x.e || x.e <= Ctor.toExpNeg, sd);
              }
              return x.isNeg() && !x.isZero() ? "-" + str : str;
            };
            /*
             * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
             * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
             * omitted.
             *
             * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
             * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
             *
             * 'toSD() digits out of range: {sd}'
             * 'toSD() digits not an integer: {sd}'
             * 'toSD() rounding mode not an integer: {rm}'
             * 'toSD() rounding mode out of range: {rm}'
             *
             */ P.toSignificantDigits = P.toSD = function (sd, rm) {
              var x = this,
                Ctor = x.constructor;
              if (sd === void 0) {
                sd = Ctor.precision;
                rm = Ctor.rounding;
              } else {
                checkInt32(sd, 1, MAX_DIGITS);
                if (rm === void 0) rm = Ctor.rounding;
                else checkInt32(rm, 0, 8);
              }
              return finalise(new Ctor(x), sd, rm);
            };
            /*
             * Return a string representing the value of this Decimal.
             *
             * Return exponential notation if this Decimal has a positive exponent equal to or greater than
             * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
             *
             */ P.toString = function () {
              var x = this,
                Ctor = x.constructor,
                str = finiteToString(
                  x,
                  x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos
                );
              return x.isNeg() && !x.isZero() ? "-" + str : str;
            };
            /*
             * Return a new Decimal whose value is the value of this Decimal truncated to a whole number.
             *
             */ P.truncated = P.trunc = function () {
              return finalise(new this.constructor(this), this.e + 1, 1);
            };
            /*
             * Return a string representing the value of this Decimal.
             * Unlike `toString`, negative zero will include the minus sign.
             *
             */ P.valueOf = P.toJSON = function () {
              var x = this,
                Ctor = x.constructor,
                str = finiteToString(
                  x,
                  x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos
                );
              return x.isNeg() ? "-" + str : str;
            }; /*
      // Add aliases to match BigDecimal method names.
      // P.add = P.plus;
      P.subtract = P.minus;
      P.multiply = P.times;
      P.divide = P.div;
      P.remainder = P.mod;
      P.compareTo = P.cmp;
      P.negate = P.neg;
       */ // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
            /*
             *  digitsToString           P.cubeRoot, P.logarithm, P.squareRoot, P.toFraction, P.toPower,
             *                           finiteToString, naturalExponential, naturalLogarithm
             *  checkInt32               P.toDecimalPlaces, P.toExponential, P.toFixed, P.toNearest,
             *                           P.toPrecision, P.toSignificantDigits, toStringBinary, random
             *  checkRoundingDigits      P.logarithm, P.toPower, naturalExponential, naturalLogarithm
             *  convertBase              toStringBinary, parseOther
             *  cos                      P.cos
             *  divide                   P.atanh, P.cubeRoot, P.dividedBy, P.dividedToIntegerBy,
             *                           P.logarithm, P.modulo, P.squareRoot, P.tan, P.tanh, P.toFraction,
             *                           P.toNearest, toStringBinary, naturalExponential, naturalLogarithm,
             *                           taylorSeries, atan2, parseOther
             *  finalise                 P.absoluteValue, P.atan, P.atanh, P.ceil, P.cos, P.cosh,
             *                           P.cubeRoot, P.dividedToIntegerBy, P.floor, P.logarithm, P.minus,
             *                           P.modulo, P.negated, P.plus, P.round, P.sin, P.sinh, P.squareRoot,
             *                           P.tan, P.times, P.toDecimalPlaces, P.toExponential, P.toFixed,
             *                           P.toNearest, P.toPower, P.toPrecision, P.toSignificantDigits,
             *                           P.truncated, divide, getLn10, getPi, naturalExponential,
             *                           naturalLogarithm, ceil, floor, round, trunc
             *  finiteToString           P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf,
             *                           toStringBinary
             *  getBase10Exponent        P.minus, P.plus, P.times, parseOther
             *  getLn10                  P.logarithm, naturalLogarithm
             *  getPi                    P.acos, P.asin, P.atan, toLessThanHalfPi, atan2
             *  getPrecision             P.precision, P.toFraction
             *  getZeroString            digitsToString, finiteToString
             *  intPow                   P.toPower, parseOther
             *  isOdd                    toLessThanHalfPi
             *  maxOrMin                 max, min
             *  naturalExponential       P.naturalExponential, P.toPower
             *  naturalLogarithm         P.acosh, P.asinh, P.atanh, P.logarithm, P.naturalLogarithm,
             *                           P.toPower, naturalExponential
             *  nonFiniteToString        finiteToString, toStringBinary
             *  parseDecimal             Decimal
             *  parseOther               Decimal
             *  sin                      P.sin
             *  taylorSeries             P.cosh, P.sinh, cos, sin
             *  toLessThanHalfPi         P.cos, P.sin
             *  toStringBinary           P.toBinary, P.toHexadecimal, P.toOctal
             *  truncate                 intPow
             *
             *  Throws:                  P.logarithm, P.precision, P.toFraction, checkInt32, getLn10, getPi,
             *                           naturalLogarithm, config, parseOther, random, Decimal
             */ function digitsToString(d) {
              var i,
                k,
                ws,
                indexOfLastWord = d.length - 1,
                str = "",
                w = d[0];
              if (indexOfLastWord > 0) {
                str += w;
                for (i = 1; i < indexOfLastWord; i++) {
                  ws = d[i] + "";
                  k = LOG_BASE - ws.length;
                  if (k) str += getZeroString(k);
                  str += ws;
                }
                w = d[i];
                ws = w + "";
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
              } else if (w === 0) {
                return "0";
              } // Remove trailing zeros of last w.
              for (; w % 10 === 0; ) {
                w /= 10;
              }
              return str + w;
            }
            function checkInt32(i, min, max) {
              if (i !== ~~i || i < min || i > max) {
                throw Error(invalidArgument + i);
              }
            }
            /*
             * Check 5 rounding digits if `repeating` is null, 4 otherwise.
             * `repeating == null` if caller is `log` or `pow`,
             * `repeating != null` if caller is `naturalLogarithm` or `naturalExponential`.
             */ function checkRoundingDigits(d, i, rm, repeating) {
              var di, k, r, rd; // Get the length of the first word of the array d.
              for (k = d[0]; k >= 10; k /= 10) {
                --i;
              } // Is the rounding digit in the first word of d?
              if (--i < 0) {
                i += LOG_BASE;
                di = 0;
              } else {
                di = Math.ceil((i + 1) / LOG_BASE);
                i %= LOG_BASE;
              } // i is the index (0 - 6) of the rounding digit.
              // E.g. if within the word 3487563 the first rounding digit is 5,
              // then i = 4, k = 1000, rd = 3487563 % 1000 = 563
              k = mathpow(10, LOG_BASE - i);
              rd = d[di] % k | 0;
              if (repeating == null) {
                if (i < 3) {
                  if (i == 0) rd = (rd / 100) | 0;
                  else if (i == 1) rd = (rd / 10) | 0;
                  r =
                    (rm < 4 && rd == 99999) ||
                    (rm > 3 && rd == 49999) ||
                    rd == 50000 ||
                    rd == 0;
                } else {
                  r =
                    (((rm < 4 && rd + 1 == k) || (rm > 3 && rd + 1 == k / 2)) &&
                      ((d[di + 1] / k / 100) | 0) == mathpow(10, i - 2) - 1) ||
                    ((rd == k / 2 || rd == 0) &&
                      ((d[di + 1] / k / 100) | 0) == 0);
                }
              } else {
                if (i < 4) {
                  if (i == 0) rd = (rd / 1000) | 0;
                  else if (i == 1) rd = (rd / 100) | 0;
                  else if (i == 2) rd = (rd / 10) | 0;
                  r =
                    ((repeating || rm < 4) && rd == 9999) ||
                    (!repeating && rm > 3 && rd == 4999);
                } else {
                  r =
                    (((repeating || rm < 4) && rd + 1 == k) ||
                      (!repeating && rm > 3 && rd + 1 == k / 2)) &&
                    ((d[di + 1] / k / 1000) | 0) == mathpow(10, i - 3) - 1;
                }
              }
              return r;
            } // Convert string of `baseIn` to an array of numbers of `baseOut`.
            // Eg. convertBase('255', 10, 16) returns [15, 15].
            // Eg. convertBase('ff', 16, 10) returns [2, 5, 5].
            function convertBase(str, baseIn, baseOut) {
              var j,
                arr = [0],
                arrL,
                i = 0,
                strL = str.length;
              for (; i < strL; ) {
                for (arrL = arr.length; arrL--; ) {
                  arr[arrL] *= baseIn;
                }
                arr[0] += NUMERALS.indexOf(str.charAt(i++));
                for (j = 0; j < arr.length; j++) {
                  if (arr[j] > baseOut - 1) {
                    if (arr[j + 1] === void 0) arr[j + 1] = 0;
                    arr[j + 1] += (arr[j] / baseOut) | 0;
                    arr[j] %= baseOut;
                  }
                }
              }
              return arr.reverse();
            }
            /*
             * cos(x) = 1 - x^2/2! + x^4/4! - ...
             * |x| < pi/2
             *
             */ function cosine(Ctor, x) {
              var k,
                y,
                len = x.d.length; // Argument reduction: cos(4x) = 8*(cos^4(x) - cos^2(x)) + 1
              // i.e. cos(x) = 8*(cos^4(x/4) - cos^2(x/4)) + 1
              // Estimate the optimum number of times to use the argument reduction.
              if (len < 32) {
                k = Math.ceil(len / 3);
                y = (1 / tinyPow(4, k)).toString();
              } else {
                k = 16;
                y = "2.3283064365386962890625e-10";
              }
              Ctor.precision += k;
              x = taylorSeries(Ctor, 1, x.times(y), new Ctor(1)); // Reverse argument reduction
              for (var i = k; i--; ) {
                var cos2x = x.times(x);
                x = cos2x.times(cos2x).minus(cos2x).times(8).plus(1);
              }
              Ctor.precision -= k;
              return x;
            }
            /*
             * Perform division in the specified base.
             */ var divide = (function () {
              // Assumes non-zero x and k, and hence non-zero result.
              function multiplyInteger(x, k, base) {
                var temp,
                  carry = 0,
                  i = x.length;
                for (x = x.slice(); i--; ) {
                  temp = x[i] * k + carry;
                  x[i] = temp % base | 0;
                  carry = (temp / base) | 0;
                }
                if (carry) x.unshift(carry);
                return x;
              }
              function compare(a, b, aL, bL) {
                var i, r;
                if (aL != bL) {
                  r = aL > bL ? 1 : -1;
                } else {
                  for (i = r = 0; i < aL; i++) {
                    if (a[i] != b[i]) {
                      r = a[i] > b[i] ? 1 : -1;
                      break;
                    }
                  }
                }
                return r;
              }
              function subtract(a, b, aL, base) {
                var i = 0; // Subtract b from a.
                for (; aL--; ) {
                  a[aL] -= i;
                  i = a[aL] < b[aL] ? 1 : 0;
                  a[aL] = i * base + a[aL] - b[aL];
                } // Remove leading zeros.
                for (; !a[0] && a.length > 1; ) {
                  a.shift();
                }
              }
              return function (x, y, pr, rm, dp, base) {
                var cmp,
                  e,
                  i,
                  k,
                  logBase,
                  more,
                  prod,
                  prodL,
                  q,
                  qd,
                  rem,
                  remL,
                  rem0,
                  sd,
                  t,
                  xi,
                  xL,
                  yd0,
                  yL,
                  yz,
                  Ctor = x.constructor,
                  sign = x.s == y.s ? 1 : -1,
                  xd = x.d,
                  yd = y.d; // Either NaN, Infinity or 0?
                if (!xd || !xd[0] || !yd || !yd[0]) {
                  return new Ctor( // Return NaN if either NaN, or both Infinity or 0.
                    !x.s || !y.s || (xd ? yd && xd[0] == yd[0] : !yd)
                      ? NaN // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
                      : (xd && xd[0] == 0) || !yd
                      ? sign * 0
                      : sign / 0
                  );
                }
                if (base) {
                  logBase = 1;
                  e = x.e - y.e;
                } else {
                  base = BASE;
                  logBase = LOG_BASE;
                  e = mathfloor(x.e / logBase) - mathfloor(y.e / logBase);
                }
                yL = yd.length;
                xL = xd.length;
                q = new Ctor(sign);
                qd = q.d = []; // Result exponent may be one less than e.
                // The digit array of a Decimal from toStringBinary may have trailing zeros.
                for (i = 0; yd[i] == (xd[i] || 0); i++) {}
                if (yd[i] > (xd[i] || 0)) e--;
                if (pr == null) {
                  sd = pr = Ctor.precision;
                  rm = Ctor.rounding;
                } else if (dp) {
                  sd = pr + (x.e - y.e) + 1;
                } else {
                  sd = pr;
                }
                if (sd < 0) {
                  qd.push(1);
                  more = true;
                } else {
                  // Convert precision in number of base 10 digits to base 1e7 digits.
                  sd = (sd / logBase + 2) | 0;
                  i = 0; // divisor < 1e7
                  if (yL == 1) {
                    k = 0;
                    yd = yd[0];
                    sd++; // k is the carry.
                    for (; (i < xL || k) && sd--; i++) {
                      t = k * base + (xd[i] || 0);
                      qd[i] = (t / yd) | 0;
                      k = t % yd | 0;
                    }
                    more = k || i < xL; // divisor >= 1e7
                  } else {
                    // Normalise xd and yd so highest order digit of yd is >= base/2
                    k = (base / (yd[0] + 1)) | 0;
                    if (k > 1) {
                      yd = multiplyInteger(yd, k, base);
                      xd = multiplyInteger(xd, k, base);
                      yL = yd.length;
                      xL = xd.length;
                    }
                    xi = yL;
                    rem = xd.slice(0, yL);
                    remL = rem.length; // Add zeros to make remainder as long as divisor.
                    for (; remL < yL; ) {
                      rem[remL++] = 0;
                    }
                    yz = yd.slice();
                    yz.unshift(0);
                    yd0 = yd[0];
                    if (yd[1] >= base / 2) ++yd0;
                    do {
                      k = 0; // Compare divisor and remainder.
                      cmp = compare(yd, rem, yL, remL); // If divisor < remainder.
                      if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * base + (rem[1] || 0); // k will be how many times the divisor goes into the current remainder.
                        k = (rem0 / yd0) | 0; //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                          if (k >= base) k = base - 1; // product = divisor * trial digit.
                          prod = multiplyInteger(yd, k, base);
                          prodL = prod.length;
                          remL = rem.length; // Compare product and remainder.
                          cmp = compare(prod, rem, prodL, remL); // product > remainder.
                          if (cmp == 1) {
                            k--; // Subtract divisor from product.
                            subtract(prod, yL < prodL ? yz : yd, prodL, base);
                          }
                        } else {
                          // cmp is -1.
                          // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                          // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                          if (k == 0) cmp = k = 1;
                          prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0); // Subtract product from remainder.
                        subtract(rem, prod, remL, base); // If product was < previous remainder.
                        if (cmp == -1) {
                          remL = rem.length; // Compare divisor and new remainder.
                          cmp = compare(yd, rem, yL, remL); // If divisor < new remainder, subtract divisor from remainder.
                          if (cmp < 1) {
                            k++; // Subtract divisor from remainder.
                            subtract(rem, yL < remL ? yz : yd, remL, base);
                          }
                        }
                        remL = rem.length;
                      } else if (cmp === 0) {
                        k++;
                        rem = [0];
                      } // if cmp === 1, k will be 0
                      // Add the next digit, k, to the result array.
                      qd[i++] = k; // Update the remainder.
                      if (cmp && rem[0]) {
                        rem[remL++] = xd[xi] || 0;
                      } else {
                        rem = [xd[xi]];
                        remL = 1;
                      }
                    } while ((xi++ < xL || rem[0] !== void 0) && sd--);
                    more = rem[0] !== void 0;
                  } // Leading zero?
                  if (!qd[0]) qd.shift();
                } // logBase is 1 when divide is being used for base conversion.
                if (logBase == 1) {
                  q.e = e;
                  inexact = more;
                } else {
                  // To calculate q.e, first get the number of digits of qd[0].
                  for (i = 1, k = qd[0]; k >= 10; k /= 10) {
                    i++;
                  }
                  q.e = i + e * logBase - 1;
                  finalise(q, dp ? pr + q.e + 1 : pr, rm, more);
                }
                return q;
              };
            })();
            /*
             * Round `x` to `sd` significant digits using rounding mode `rm`.
             * Check for over/under-flow.
             */ function finalise(x, sd, rm, isTruncated) {
              var digits,
                i,
                j,
                k,
                rd,
                roundUp,
                w,
                xd,
                xdi,
                Ctor = x.constructor; // Don't round if sd is null or undefined.
              out: if (sd != null) {
                xd = x.d; // Infinity/NaN.
                if (!xd) return x; // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
                // w: the word of xd containing rd, a base 1e7 number.
                // xdi: the index of w within xd.
                // digits: the number of digits of w.
                // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
                // they had leading zeros)
                // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
                // Get the length of the first word of the digits array xd.
                for (digits = 1, k = xd[0]; k >= 10; k /= 10) {
                  digits++;
                }
                i = sd - digits; // Is the rounding digit in the first word of xd?
                if (i < 0) {
                  i += LOG_BASE;
                  j = sd;
                  w = xd[(xdi = 0)]; // Get the rounding digit at index j of w.
                  rd = (w / mathpow(10, digits - j - 1)) % 10 | 0;
                } else {
                  xdi = Math.ceil((i + 1) / LOG_BASE);
                  k = xd.length;
                  if (xdi >= k) {
                    if (isTruncated) {
                      // Needed by `naturalExponential`, `naturalLogarithm` and `squareRoot`.
                      for (; k++ <= xdi; ) {
                        xd.push(0);
                      }
                      w = rd = 0;
                      digits = 1;
                      i %= LOG_BASE;
                      j = i - LOG_BASE + 1;
                    } else {
                      break out;
                    }
                  } else {
                    w = k = xd[xdi]; // Get the number of digits of w.
                    for (digits = 1; k >= 10; k /= 10) {
                      digits++;
                    } // Get the index of rd within w.
                    i %= LOG_BASE; // Get the index of rd within w, adjusted for leading zeros.
                    // The number of leading zeros of w is given by LOG_BASE - digits.
                    j = i - LOG_BASE + digits; // Get the rounding digit at index j of w.
                    rd = j < 0 ? 0 : (w / mathpow(10, digits - j - 1)) % 10 | 0;
                  }
                } // Are there any non-zero digits after the rounding digit?
                isTruncated =
                  isTruncated ||
                  sd < 0 ||
                  xd[xdi + 1] !== void 0 ||
                  (j < 0 ? w : w % mathpow(10, digits - j - 1)); // The expression `w % mathpow(10, digits - j - 1)` returns all the digits of w to the right
                // of the digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression
                // will give 714.
                roundUp =
                  rm < 4
                    ? (rd || isTruncated) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
                    : rd > 5 ||
                      (rd == 5 &&
                        (rm == 4 ||
                          isTruncated ||
                          (rm == 6 && // Check whether the digit to the left of the rounding digit is odd.
                            (i > 0
                              ? j > 0
                                ? w / mathpow(10, digits - j)
                                : 0
                              : xd[xdi - 1]) %
                              10 &
                              1) ||
                          rm == (x.s < 0 ? 8 : 7)));
                if (sd < 1 || !xd[0]) {
                  xd.length = 0;
                  if (roundUp) {
                    // Convert sd to decimal places.
                    sd -= x.e + 1; // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                    xd[0] = mathpow(10, (LOG_BASE - (sd % LOG_BASE)) % LOG_BASE);
                    x.e = -sd || 0;
                  } else {
                    // Zero.
                    xd[0] = x.e = 0;
                  }
                  return x;
                } // Remove excess digits.
                if (i == 0) {
                  xd.length = xdi;
                  k = 1;
                  xdi--;
                } else {
                  xd.length = xdi + 1;
                  k = mathpow(10, LOG_BASE - i); // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                  // j > 0 means i > number of leading zeros of w.
                  xd[xdi] =
                    j > 0
                      ? ((w / mathpow(10, digits - j)) % mathpow(10, j) | 0) * k
                      : 0;
                }
                if (roundUp) {
                  for (;;) {
                    // Is the digit to be rounded up in the first word of xd?
                    if (xdi == 0) {
                      // i will be the length of xd[0] before k is added.
                      for (i = 1, j = xd[0]; j >= 10; j /= 10) {
                        i++;
                      }
                      j = xd[0] += k;
                      for (k = 1; j >= 10; j /= 10) {
                        k++;
                      } // if i != k the length has increased.
                      if (i != k) {
                        x.e++;
                        if (xd[0] == BASE) xd[0] = 1;
                      }
                      break;
                    } else {
                      xd[xdi] += k;
                      if (xd[xdi] != BASE) break;
                      xd[xdi--] = 0;
                      k = 1;
                    }
                  }
                } // Remove trailing zeros.
                for (i = xd.length; xd[--i] === 0; ) {
                  xd.pop();
                }
              }
              if (external) {
                // Overflow?
                if (x.e > Ctor.maxE) {
                  // Infinity.
                  x.d = null;
                  x.e = NaN; // Underflow?
                } else if (x.e < Ctor.minE) {
                  // Zero.
                  x.e = 0;
                  x.d = [0]; // Ctor.underflow = true;
                } // else Ctor.underflow = false;
              }
              return x;
            }
            function finiteToString(x, isExp, sd) {
              if (!x.isFinite()) return nonFiniteToString(x);
              var k,
                e = x.e,
                str = digitsToString(x.d),
                len = str.length;
              if (isExp) {
                if (sd && (k = sd - len) > 0) {
                  str = str.charAt(0) + "." + str.slice(1) + getZeroString(k);
                } else if (len > 1) {
                  str = str.charAt(0) + "." + str.slice(1);
                }
                str = str + (x.e < 0 ? "e" : "e+") + x.e;
              } else if (e < 0) {
                str = "0." + getZeroString(-e - 1) + str;
                if (sd && (k = sd - len) > 0) str += getZeroString(k);
              } else if (e >= len) {
                str += getZeroString(e + 1 - len);
                if (sd && (k = sd - e - 1) > 0)
                  str = str + "." + getZeroString(k);
              } else {
                if ((k = e + 1) < len) str = str.slice(0, k) + "." + str.slice(k);
                if (sd && (k = sd - len) > 0) {
                  if (e + 1 === len) str += ".";
                  str += getZeroString(k);
                }
              }
              return str;
            } // Calculate the base 10 exponent from the base 1e7 exponent.
            function getBase10Exponent(digits, e) {
              var w = digits[0]; // Add the number of digits of the first word of the digits array.
              for (e *= LOG_BASE; w >= 10; w /= 10) {
                e++;
              }
              return e;
            }
            function getLn10(Ctor, sd, pr) {
              if (sd > LN10_PRECISION) {
                // Reset global state in case the exception is caught.
                external = true;
                if (pr) Ctor.precision = pr;
                throw Error(precisionLimitExceeded);
              }
              return finalise(new Ctor(LN10), sd, 1, true);
            }
            function getPi(Ctor, sd, rm) {
              if (sd > PI_PRECISION) throw Error(precisionLimitExceeded);
              return finalise(new Ctor(PI), sd, rm, true);
            }
            function getPrecision(digits) {
              var w = digits.length - 1,
                len = w * LOG_BASE + 1;
              w = digits[w]; // If non-zero...
              if (w) {
                // Subtract the number of trailing zeros of the last word.
                for (; w % 10 == 0; w /= 10) {
                  len--;
                } // Add the number of digits of the first word.
                for (w = digits[0]; w >= 10; w /= 10) {
                  len++;
                }
              }
              return len;
            }
            function getZeroString(k) {
              var zs = "";
              for (; k--; ) {
                zs += "0";
              }
              return zs;
            }
            /*
             * Return a new Decimal whose value is the value of Decimal `x` to the power `n`, where `n` is an
             * integer of type number.
             *
             * Implements 'exponentiation by squaring'. Called by `pow` and `parseOther`.
             *
             */ function intPow(Ctor, x, n, pr) {
              var isTruncated,
                r = new Ctor(1), // Max n of 9007199254740991 takes 53 loop iterations.
                // Maximum digits array length; leaves [28, 34] guard digits.
                k = Math.ceil(pr / LOG_BASE + 4);
              external = false;
              for (;;) {
                if (n % 2) {
                  r = r.times(x);
                  if (truncate(r.d, k)) isTruncated = true;
                }
                n = mathfloor(n / 2);
                if (n === 0) {
                  // To ensure correct rounding when r.d is truncated, increment the last word if it is zero.
                  n = r.d.length - 1;
                  if (isTruncated && r.d[n] === 0) ++r.d[n];
                  break;
                }
                x = x.times(x);
                truncate(x.d, k);
              }
              external = true;
              return r;
            }
            function isOdd(n) {
              return n.d[n.d.length - 1] & 1;
            }
            /*
             * Handle `max` and `min`. `ltgt` is 'lt' or 'gt'.
             */ function maxOrMin(Ctor, args, ltgt) {
              var y,
                x = new Ctor(args[0]),
                i = 0;
              for (; ++i < args.length; ) {
                y = new Ctor(args[i]);
                if (!y.s) {
                  x = y;
                  break;
                } else if (x[ltgt](y)) {
                  x = y;
                }
              }
              return x;
            }
            /*
             * Return a new Decimal whose value is the natural exponential of `x` rounded to `sd` significant
             * digits.
             *
             * Taylor/Maclaurin series.
             *
             * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
             *
             * Argument reduction:
             *   Repeat x = x / 32, k += 5, until |x| < 0.1
             *   exp(x) = exp(x / 2^k)^(2^k)
             *
             * Previously, the argument was initially reduced by
             * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
             * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
             * found to be slower than just dividing repeatedly by 32 as above.
             *
             * Max integer argument: exp('20723265836946413') = 6.3e+9000000000000000
             * Min integer argument: exp('-20723265836946411') = 1.2e-9000000000000000
             * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
             *
             *  exp(Infinity)  = Infinity
             *  exp(-Infinity) = 0
             *  exp(NaN)       = NaN
             *  exp(±0)        = 1
             *
             *  exp(x) is non-terminating for any finite, non-zero x.
             *
             *  The result will always be correctly rounded.
             *
             */ function naturalExponential(x, sd) {
              var denominator,
                guard,
                j,
                pow,
                sum,
                t,
                wpr,
                rep = 0,
                i = 0,
                k = 0,
                Ctor = x.constructor,
                rm = Ctor.rounding,
                pr = Ctor.precision; // 0/NaN/Infinity?
              if (!x.d || !x.d[0] || x.e > 17) {
                return new Ctor(
                  x.d
                    ? !x.d[0]
                      ? 1
                      : x.s < 0
                      ? 0
                      : 1 / 0
                    : x.s
                    ? x.s < 0
                      ? 0
                      : x
                    : 0 / 0
                );
              }
              if (sd == null) {
                external = false;
                wpr = pr;
              } else {
                wpr = sd;
              }
              t = new Ctor(0.03125); // while abs(x) >= 0.1
              while (x.e > -2) {
                // x = x / 2^5
                x = x.times(t);
                k += 5;
              } // Use 2 * log10(2^k) + 5 (empirically derived) to estimate the increase in precision
              // necessary to ensure the first 4 rounding digits are correct.
              guard = ((Math.log(mathpow(2, k)) / Math.LN10) * 2 + 5) | 0;
              wpr += guard;
              denominator = pow = sum = new Ctor(1);
              Ctor.precision = wpr;
              for (;;) {
                pow = finalise(pow.times(x), wpr, 1);
                denominator = denominator.times(++i);
                t = sum.plus(divide(pow, denominator, wpr, 1));
                if (
                  digitsToString(t.d).slice(0, wpr) ===
                  digitsToString(sum.d).slice(0, wpr)
                ) {
                  j = k;
                  while (j--) {
                    sum = finalise(sum.times(sum), wpr, 1);
                  } // Check to see if the first 4 rounding digits are [49]999.
                  // If so, repeat the summation with a higher precision, otherwise
                  // e.g. with precision: 18, rounding: 1
                  // exp(18.404272462595034083567793919843761) = 98372560.1229999999 (should be 98372560.123)
                  // `wpr - guard` is the index of first rounding digit.
                  if (sd == null) {
                    if (
                      rep < 3 &&
                      checkRoundingDigits(sum.d, wpr - guard, rm, rep)
                    ) {
                      Ctor.precision = wpr += 10;
                      denominator = pow = t = new Ctor(1);
                      i = 0;
                      rep++;
                    } else {
                      return finalise(
                        sum,
                        (Ctor.precision = pr),
                        rm,
                        (external = true)
                      );
                    }
                  } else {
                    Ctor.precision = pr;
                    return sum;
                  }
                }
                sum = t;
              }
            }
            /*
             * Return a new Decimal whose value is the natural logarithm of `x` rounded to `sd` significant
             * digits.
             *
             *  ln(-n)        = NaN
             *  ln(0)         = -Infinity
             *  ln(-0)        = -Infinity
             *  ln(1)         = 0
             *  ln(Infinity)  = Infinity
             *  ln(-Infinity) = NaN
             *  ln(NaN)       = NaN
             *
             *  ln(n) (n != 1) is non-terminating.
             *
             */ function naturalLogarithm(y, sd) {
              var c,
                c0,
                denominator,
                e,
                numerator,
                rep,
                sum,
                t,
                wpr,
                x1,
                x2,
                n = 1,
                guard = 10,
                x = y,
                xd = x.d,
                Ctor = x.constructor,
                rm = Ctor.rounding,
                pr = Ctor.precision; // Is x negative or Infinity, NaN, 0 or 1?
              if (
                x.s < 0 ||
                !xd ||
                !xd[0] ||
                (!x.e && xd[0] == 1 && xd.length == 1)
              ) {
                return new Ctor(
                  xd && !xd[0] ? -1 / 0 : x.s != 1 ? NaN : xd ? 0 : x
                );
              }
              if (sd == null) {
                external = false;
                wpr = pr;
              } else {
                wpr = sd;
              }
              Ctor.precision = wpr += guard;
              c = digitsToString(xd);
              c0 = c.charAt(0);
              if (Math.abs((e = x.e)) < 1.5e15) {
                // Argument reduction.
                // The series converges faster the closer the argument is to 1, so using
                // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
                // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
                // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
                // later be divided by this number, then separate out the power of 10 using
                // ln(a*10^b) = ln(a) + b*ln(10).
                // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
                //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
                // max n is 6 (gives 0.7 - 1.3)
                while ((c0 < 7 && c0 != 1) || (c0 == 1 && c.charAt(1) > 3)) {
                  x = x.times(y);
                  c = digitsToString(x.d);
                  c0 = c.charAt(0);
                  n++;
                }
                e = x.e;
                if (c0 > 1) {
                  x = new Ctor("0." + c);
                  e++;
                } else {
                  x = new Ctor(c0 + "." + c.slice(1));
                }
              } else {
                // The argument reduction method above may result in overflow if the argument y is a massive
                // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
                // function using ln(x*10^e) = ln(x) + e*ln(10).
                t = getLn10(Ctor, wpr + 2, pr).times(e + "");
                x = naturalLogarithm(
                  new Ctor(c0 + "." + c.slice(1)),
                  wpr - guard
                ).plus(t);
                Ctor.precision = pr;
                return sd == null ? finalise(x, pr, rm, (external = true)) : x;
              } // x1 is x reduced to a value near 1.
              x1 = x; // Taylor series.
              // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
              // where x = (y - 1)/(y + 1)    (|x| < 1)
              sum = numerator = x = divide(x.minus(1), x.plus(1), wpr, 1);
              x2 = finalise(x.times(x), wpr, 1);
              denominator = 3;
              for (;;) {
                numerator = finalise(numerator.times(x2), wpr, 1);
                t = sum.plus(divide(numerator, new Ctor(denominator), wpr, 1));
                if (
                  digitsToString(t.d).slice(0, wpr) ===
                  digitsToString(sum.d).slice(0, wpr)
                ) {
                  sum = sum.times(2); // Reverse the argument reduction. Check that e is not 0 because, besides preventing an
                  // unnecessary calculation, -0 + 0 = +0 and to ensure correct rounding -0 needs to stay -0.
                  if (e !== 0)
                    sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ""));
                  sum = divide(sum, new Ctor(n), wpr, 1); // Is rm > 3 and the first 4 rounding digits 4999, or rm < 4 (or the summation has
                  // been repeated previously) and the first 4 rounding digits 9999?
                  // If so, restart the summation with a higher precision, otherwise
                  // e.g. with precision: 12, rounding: 1
                  // ln(135520028.6126091714265381533) = 18.7246299999 when it should be 18.72463.
                  // `wpr - guard` is the index of first rounding digit.
                  if (sd == null) {
                    if (checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
                      Ctor.precision = wpr += guard;
                      t = numerator = x = divide(x1.minus(1), x1.plus(1), wpr, 1);
                      x2 = finalise(x.times(x), wpr, 1);
                      denominator = rep = 1;
                    } else {
                      return finalise(
                        sum,
                        (Ctor.precision = pr),
                        rm,
                        (external = true)
                      );
                    }
                  } else {
                    Ctor.precision = pr;
                    return sum;
                  }
                }
                sum = t;
                denominator += 2;
              }
            } // ±Infinity, NaN.
            function nonFiniteToString(x) {
              // Unsigned.
              return String((x.s * x.s) / 0);
            }
            /*
             * Parse the value of a new Decimal `x` from string `str`.
             */ function parseDecimal(x, str) {
              var e, i, len; // Decimal point?
              if ((e = str.indexOf(".")) > -1) str = str.replace(".", ""); // Exponential form?
              if ((i = str.search(/e/i)) > 0) {
                // Determine exponent.
                if (e < 0) e = i;
                e += +str.slice(i + 1);
                str = str.substring(0, i);
              } else if (e < 0) {
                // Integer.
                e = str.length;
              } // Determine leading zeros.
              for (i = 0; str.charCodeAt(i) === 48; i++) {} // Determine trailing zeros.
              for (len = str.length; str.charCodeAt(len - 1) === 48; --len) {}
              str = str.slice(i, len);
              if (str) {
                len -= i;
                x.e = e = e - i - 1;
                x.d = []; // Transform base
                // e is the base 10 exponent.
                // i is where to slice str to get the first word of the digits array.
                i = (e + 1) % LOG_BASE;
                if (e < 0) i += LOG_BASE;
                if (i < len) {
                  if (i) x.d.push(+str.slice(0, i));
                  for (len -= LOG_BASE; i < len; ) {
                    x.d.push(+str.slice(i, (i += LOG_BASE)));
                  }
                  str = str.slice(i);
                  i = LOG_BASE - str.length;
                } else {
                  i -= len;
                }
                for (; i--; ) {
                  str += "0";
                }
                x.d.push(+str);
                if (external) {
                  // Overflow?
                  if (x.e > x.constructor.maxE) {
                    // Infinity.
                    x.d = null;
                    x.e = NaN; // Underflow?
                  } else if (x.e < x.constructor.minE) {
                    // Zero.
                    x.e = 0;
                    x.d = [0]; // x.constructor.underflow = true;
                  } // else x.constructor.underflow = false;
                }
              } else {
                // Zero.
                x.e = 0;
                x.d = [0];
              }
              return x;
            }
            /*
             * Parse the value of a new Decimal `x` from a string `str`, which is not a decimal value.
             */ function parseOther(x, str) {
              var base, Ctor, divisor, i, isFloat, len, p, xd, xe;
              if (str === "Infinity" || str === "NaN") {
                if (!+str) x.s = NaN;
                x.e = NaN;
                x.d = null;
                return x;
              }
              if (isHex.test(str)) {
                base = 16;
                str = str.toLowerCase();
              } else if (isBinary.test(str)) {
                base = 2;
              } else if (isOctal.test(str)) {
                base = 8;
              } else {
                throw Error(invalidArgument + str);
              } // Is there a binary exponent part?
              i = str.search(/p/i);
              if (i > 0) {
                p = +str.slice(i + 1);
                str = str.substring(2, i);
              } else {
                str = str.slice(2);
              } // Convert `str` as an integer then divide the result by `base` raised to a power such that the
              // fraction part will be restored.
              i = str.indexOf(".");
              isFloat = i >= 0;
              Ctor = x.constructor;
              if (isFloat) {
                str = str.replace(".", "");
                len = str.length;
                i = len - i; // log[10](16) = 1.2041... , log[10](88) = 1.9444....
                divisor = intPow(Ctor, new Ctor(base), i, i * 2);
              }
              xd = convertBase(str, base, BASE);
              xe = xd.length - 1; // Remove trailing zeros.
              for (i = xe; xd[i] === 0; --i) {
                xd.pop();
              }
              if (i < 0) return new Ctor(x.s * 0);
              x.e = getBase10Exponent(xd, xe);
              x.d = xd;
              external = false; // At what precision to perform the division to ensure exact conversion?
              // maxDecimalIntegerPartDigitCount = ceil(log[10](b) * otherBaseIntegerPartDigitCount)
              // log[10](2) = 0.30103, log[10](8) = 0.90309, log[10](16) = 1.20412
              // E.g. ceil(1.2 * 3) = 4, so up to 4 decimal digits are needed to represent 3 hex int digits.
              // maxDecimalFractionPartDigitCount = {Hex:4|Oct:3|Bin:1} * otherBaseFractionPartDigitCount
              // Therefore using 4 * the number of digits of str will always be enough.
              if (isFloat) x = divide(x, divisor, len * 4); // Multiply by the binary exponent part if present.
              if (p)
                x = x.times(Math.abs(p) < 54 ? mathpow(2, p) : Decimal.pow(2, p));
              external = true;
              return x;
            }
            /*
             * sin(x) = x - x^3/3! + x^5/5! - ...
             * |x| < pi/2
             *
             */ function sine(Ctor, x) {
              var k,
                len = x.d.length;
              if (len < 3) return taylorSeries(Ctor, 2, x, x); // Argument reduction: sin(5x) = 16*sin^5(x) - 20*sin^3(x) + 5*sin(x)
              // i.e. sin(x) = 16*sin^5(x/5) - 20*sin^3(x/5) + 5*sin(x/5)
              // and  sin(x) = sin(x/5)(5 + sin^2(x/5)(16sin^2(x/5) - 20))
              // Estimate the optimum number of times to use the argument reduction.
              k = 1.4 * Math.sqrt(len);
              k = k > 16 ? 16 : k | 0;
              x = x.times(1 / tinyPow(5, k));
              x = taylorSeries(Ctor, 2, x, x); // Reverse argument reduction
              var sin2_x,
                d5 = new Ctor(5),
                d16 = new Ctor(16),
                d20 = new Ctor(20);
              for (; k--; ) {
                sin2_x = x.times(x);
                x = x.times(d5.plus(sin2_x.times(d16.times(sin2_x).minus(d20))));
              }
              return x;
            } // Calculate Taylor series for `cos`, `cosh`, `sin` and `sinh`.
            function taylorSeries(Ctor, n, x, y, isHyperbolic) {
              var j,
                t,
                u,
                x2,
                i = 1,
                pr = Ctor.precision,
                k = Math.ceil(pr / LOG_BASE);
              external = false;
              x2 = x.times(x);
              u = new Ctor(y);
              for (;;) {
                t = divide(u.times(x2), new Ctor(n++ * n++), pr, 1);
                u = isHyperbolic ? y.plus(t) : y.minus(t);
                y = divide(t.times(x2), new Ctor(n++ * n++), pr, 1);
                t = u.plus(y);
                if (t.d[k] !== void 0) {
                  for (j = k; t.d[j] === u.d[j] && j--; ) {}
                  if (j == -1) break;
                }
                j = u;
                u = y;
                y = t;
                t = j;
                i++;
              }
              external = true;
              t.d.length = k + 1;
              return t;
            } // Exponent e must be positive and non-zero.
            function tinyPow(b, e) {
              var n = b;
              while (--e) {
                n *= b;
              }
              return n;
            } // Return the absolute value of `x` reduced to less than or equal to half pi.
            function toLessThanHalfPi(Ctor, x) {
              var t,
                isNeg = x.s < 0,
                pi = getPi(Ctor, Ctor.precision, 1),
                halfPi = pi.times(0.5);
              x = x.abs();
              if (x.lte(halfPi)) {
                quadrant = isNeg ? 4 : 1;
                return x;
              }
              t = x.divToInt(pi);
              if (t.isZero()) {
                quadrant = isNeg ? 3 : 2;
              } else {
                x = x.minus(t.times(pi)); // 0 <= x < pi
                if (x.lte(halfPi)) {
                  quadrant = isOdd(t) ? (isNeg ? 2 : 3) : isNeg ? 4 : 1;
                  return x;
                }
                quadrant = isOdd(t) ? (isNeg ? 1 : 4) : isNeg ? 3 : 2;
              }
              return x.minus(pi).abs();
            }
            /*
             * Return the value of Decimal `x` as a string in base `baseOut`.
             *
             * If the optional `sd` argument is present include a binary exponent suffix.
             */ function toStringBinary(x, baseOut, sd, rm) {
              var base,
                e,
                i,
                k,
                len,
                roundUp,
                str,
                xd,
                y,
                Ctor = x.constructor,
                isExp = sd !== void 0;
              if (isExp) {
                checkInt32(sd, 1, MAX_DIGITS);
                if (rm === void 0) rm = Ctor.rounding;
                else checkInt32(rm, 0, 8);
              } else {
                sd = Ctor.precision;
                rm = Ctor.rounding;
              }
              if (!x.isFinite()) {
                str = nonFiniteToString(x);
              } else {
                str = finiteToString(x);
                i = str.indexOf("."); // Use exponential notation according to `toExpPos` and `toExpNeg`? No, but if required:
                // maxBinaryExponent = floor((decimalExponent + 1) * log[2](10))
                // minBinaryExponent = floor(decimalExponent * log[2](10))
                // log[2](10) = 3.321928094887362347870319429489390175864
                if (isExp) {
                  base = 2;
                  if (baseOut == 16) {
                    sd = sd * 4 - 3;
                  } else if (baseOut == 8) {
                    sd = sd * 3 - 2;
                  }
                } else {
                  base = baseOut;
                } // Convert the number as an integer then divide the result by its base raised to a power such
                // that the fraction part will be restored.
                // Non-integer.
                if (i >= 0) {
                  str = str.replace(".", "");
                  y = new Ctor(1);
                  y.e = str.length - i;
                  y.d = convertBase(finiteToString(y), 10, base);
                  y.e = y.d.length;
                }
                xd = convertBase(str, 10, base);
                e = len = xd.length; // Remove trailing zeros.
                for (; xd[--len] == 0; ) {
                  xd.pop();
                }
                if (!xd[0]) {
                  str = isExp ? "0p+0" : "0";
                } else {
                  if (i < 0) {
                    e--;
                  } else {
                    x = new Ctor(x);
                    x.d = xd;
                    x.e = e;
                    x = divide(x, y, sd, rm, 0, base);
                    xd = x.d;
                    e = x.e;
                    roundUp = inexact;
                  } // The rounding digit, i.e. the digit after the digit that may be rounded up.
                  i = xd[sd];
                  k = base / 2;
                  roundUp = roundUp || xd[sd + 1] !== void 0;
                  roundUp =
                    rm < 4
                      ? (i !== void 0 || roundUp) &&
                        (rm === 0 || rm === (x.s < 0 ? 3 : 2))
                      : i > k ||
                        (i === k &&
                          (rm === 4 ||
                            roundUp ||
                            (rm === 6 && xd[sd - 1] & 1) ||
                            rm === (x.s < 0 ? 8 : 7)));
                  xd.length = sd;
                  if (roundUp) {
                    // Rounding up may mean the previous digit has to be rounded up and so on.
                    for (; ++xd[--sd] > base - 1; ) {
                      xd[sd] = 0;
                      if (!sd) {
                        ++e;
                        xd.unshift(1);
                      }
                    }
                  } // Determine trailing zeros.
                  for (len = xd.length; !xd[len - 1]; --len) {} // E.g. [4, 11, 15] becomes 4bf.
                  for (i = 0, str = ""; i < len; i++) {
                    str += NUMERALS.charAt(xd[i]);
                  } // Add binary exponent suffix?
                  if (isExp) {
                    if (len > 1) {
                      if (baseOut == 16 || baseOut == 8) {
                        i = baseOut == 16 ? 4 : 3;
                        for (--len; len % i; len++) {
                          str += "0";
                        }
                        xd = convertBase(str, base, baseOut);
                        for (len = xd.length; !xd[len - 1]; --len) {} // xd[0] will always be be 1
                        for (i = 1, str = "1."; i < len; i++) {
                          str += NUMERALS.charAt(xd[i]);
                        }
                      } else {
                        str = str.charAt(0) + "." + str.slice(1);
                      }
                    }
                    str = str + (e < 0 ? "p" : "p+") + e;
                  } else if (e < 0) {
                    for (; ++e; ) {
                      str = "0" + str;
                    }
                    str = "0." + str;
                  } else {
                    if (++e > len)
                      for (e -= len; e--; ) {
                        str += "0";
                      }
                    else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
                  }
                }
                str =
                  (baseOut == 16
                    ? "0x"
                    : baseOut == 2
                    ? "0b"
                    : baseOut == 8
                    ? "0o"
                    : "") + str;
              }
              return x.s < 0 ? "-" + str : str;
            } // Does not strip trailing zeros.
            function truncate(arr, len) {
              if (arr.length > len) {
                arr.length = len;
                return true;
              }
            } // Decimal methods
            /*
             *  abs
             *  acos
             *  acosh
             *  add
             *  asin
             *  asinh
             *  atan
             *  atanh
             *  atan2
             *  cbrt
             *  ceil
             *  clone
             *  config
             *  cos
             *  cosh
             *  div
             *  exp
             *  floor
             *  hypot
             *  ln
             *  log
             *  log2
             *  log10
             *  max
             *  min
             *  mod
             *  mul
             *  pow
             *  random
             *  round
             *  set
             *  sign
             *  sin
             *  sinh
             *  sqrt
             *  sub
             *  tan
             *  tanh
             *  trunc
             */ /*
             * Return a new Decimal whose value is the absolute value of `x`.
             *
             * x {number|string|Decimal}
             *
             */ function abs(x) {
              return new this(x).abs();
            }
            /*
             * Return a new Decimal whose value is the arccosine in radians of `x`.
             *
             * x {number|string|Decimal}
             *
             */ function acos(x) {
              return new this(x).acos();
            }
            /*
             * Return a new Decimal whose value is the inverse of the hyperbolic cosine of `x`, rounded to
             * `precision` significant digits using rounding mode `rounding`.
             *
             * x {number|string|Decimal} A value in radians.
             *
             */ function acosh(x) {
              return new this(x).acosh();
            }
            /*
             * Return a new Decimal whose value is the sum of `x` and `y`, rounded to `precision` significant
             * digits using rounding mode `rounding`.
             *
             * x {number|string|Decimal}
             * y {number|string|Decimal}
             *
             */ function add(x, y) {
              return new this(x).plus(y);
            }
            /*
             * Return a new Decimal whose value is the arcsine in radians of `x`, rounded to `precision`
             * significant digits using rounding mode `rounding`.
             *
             * x {number|string|Decimal}
             *
             */ function asin(x) {
              return new this(x).asin();
            }
            /*
             * Return a new Decimal whose value is the inverse of the hyperbolic sine of `x`, rounded to
             * `precision` significant digits using rounding mode `rounding`.
             *
             * x {number|string|Decimal} A value in radians.
             *
             */ function asinh(x) {
              return new this(x).asinh();
            }
            /*
             * Return a new Decimal whose value is the arctangent in radians of `x`, rounded to `precision`
             * significant digits using rounding mode `rounding`.
             *
             * x {number|string|Decimal}
             *
             */ function atan(x) {
              return new this(x).atan();
            }
            /*
             * Return a new Decimal whose value is the inverse of the hyperbolic tangent of `x`, rounded to
             * `precision` significant digits using rounding mode `rounding`.
             *
             * x {number|string|Decimal} A value in radians.
             *
             */ function atanh(x) {
              return new this(x).atanh();
            }
            /*
             * Return a new Decimal whose value is the arctangent in radians of `y/x` in the range -pi to pi
             * (inclusive), rounded to `precision` significant digits using rounding mode `rounding`.
             *
             * Domain: [-Infinity, Infinity]
             * Range: [-pi, pi]
             *
             * y {number|string|Decimal} The y-coordinate.
             * x {number|string|Decimal} The x-coordinate.
             *
             * atan2(±0, -0)               = ±pi
             * atan2(±0, +0)               = ±0
             * atan2(±0, -x)               = ±pi for x > 0
             * atan2(±0, x)                = ±0 for x > 0
             * atan2(-y, ±0)               = -pi/2 for y > 0
             * atan2(y, ±0)                = pi/2 for y > 0
             * atan2(±y, -Infinity)        = ±pi for finite y > 0
             * atan2(±y, +Infinity)        = ±0 for finite y > 0
             * atan2(±Infinity, x)         = ±pi/2 for finite x
             * atan2(±Infinity, -Infinity) = ±3*pi/4
             * atan2(±Infinity, +Infinity) = ±pi/4
             * atan2(NaN, x) = NaN
             * atan2(y, NaN) = NaN
             *
             */ function atan2(y, x) {
              y = new this(y);
              x = new this(x);
              var r,
                pr = this.precision,
                rm = this.rounding,
                wpr = pr + 4; // Either NaN
              if (!y.s || !x.s) {
                r = new this(NaN); // Both ±Infinity
              } else if (!y.d && !x.d) {
                r = getPi(this, wpr, 1).times(x.s > 0 ? 0.25 : 0.75);
                r.s = y.s; // x is ±Infinity or y is ±0
              } else if (!x.d || y.isZero()) {
                r = x.s < 0 ? getPi(this, pr, rm) : new this(0);
                r.s = y.s; // y is ±Infinity or x is ±0
              } else if (!y.d || x.isZero()) {
                r = getPi(this, wpr, 1).times(0.5);
                r.s = y.s; // Both non-zero and finite
              } else if (x.s < 0) {
                this.precision = wpr;
                this.rounding = 1;
                r = this.atan(divide(y, x, wpr, 1));
                x = getPi(this, wpr, 1);
                this.precision = pr;
                this.rounding = rm;
                r = y.s < 0 ? r.minus(x) : r.plus(x);
              } else {
                r = this.atan(divide(y, x, wpr, 1));
              }
              return r;
            }
            /*
             * Return a new Decimal whose value is the cube root of `x`, rounded to `precision` significant
             * digits using rounding mode `rounding`.
             *
             * x {number|string|Decimal}
             *
             */ function cbrt(x) {
              return new this(x).cbrt();
            }
            /*
             * Return a new Decimal whose value is `x` rounded to an integer using `ROUND_CEIL`.
             *
             * x {number|string|Decimal}
             *
             */ function ceil(x) {
              return finalise((x = new this(x)), x.e + 1, 2);
            }
            /*
             * Configure global settings for a Decimal constructor.
             *
             * `obj` is an object with one or more of the following properties,
             *
             *   precision  {number}
             *   rounding   {number}
             *   toExpNeg   {number}
             *   toExpPos   {number}
             *   maxE       {number}
             *   minE       {number}
             *   modulo     {number}
             *   crypto     {boolean|number}
             *   defaults   {true}
             *
             * E.g. Decimal.config({ precision: 20, rounding: 4 })
             *
             */ function config(obj) {
              if (!obj || _typeof2(obj) !== "object")
                throw Error(decimalError + "Object expected");
              var i,
                p,
                v,
                useDefaults = obj.defaults === true,
                ps = [
                  "precision",
                  1,
                  MAX_DIGITS,
                  "rounding",
                  0,
                  8,
                  "toExpNeg",
                  -EXP_LIMIT,
                  0,
                  "toExpPos",
                  0,
                  EXP_LIMIT,
                  "maxE",
                  0,
                  EXP_LIMIT,
                  "minE",
                  -EXP_LIMIT,
                  0,
                  "modulo",
                  0,
                  9
                ];
              for (i = 0; i < ps.length; i += 3) {
                if (((p = ps[i]), useDefaults)) this[p] = DEFAULTS[p];
                if ((v = obj[p]) !== void 0) {
                  if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2])
                    this[p] = v;
                  else throw Error(invalidArgument + p + ": " + v);
                }
              }
              if (((p = "crypto"), useDefaults)) this[p] = DEFAULTS[p];
              if ((v = obj[p]) !== void 0) {
                if (v === true || v === false || v === 0 || v === 1) {
                  if (v) {
                    if (
                      typeof crypto != "undefined" &&
                      crypto &&
                      (crypto.getRandomValues || crypto.randomBytes)
                    ) {
                      this[p] = true;
                    } else {
                      throw Error(cryptoUnavailable);
                    }
                  } else {
                    this[p] = false;
                  }
                } else {
                  throw Error(invalidArgument + p + ": " + v);
                }
              }
              return this;
            }
            /*
             * Return a new Decimal whose value is the cosine of `x`, rounded to `precision` significant
             * digits using rounding mode `rounding`.
             *
             * x {number|string|Decimal} A value in radians.
             *
             */ function cos(x) {
              return new this(x).cos();
            }
            /*
             * Return a new Decimal whose value is the hyperbolic cosine of `x`, rounded to precision
             * significant digits using rounding mode `rounding`.
             *
             * x {number|string|Decimal} A value in radians.
             *
             */ function cosh(x) {
              return new this(x).cosh();
            }
            /*
             * Create and return a Decimal constructor with the same configuration properties as this Decimal
             * constructor.
             *
             */ function clone(obj) {
              var i, p, ps;
              /*
               * The Decimal constructor and exported function.
               * Return a new Decimal instance.
               *
               * v {number|string|Decimal} A numeric value.
               *
               */ function Decimal(v) {
                var e,
                  i,
                  t,
                  x = this; // Decimal called without new.
                if (!_instanceof(x, Decimal)) return new Decimal(v); // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
                // which points to Object.
                x.constructor = Decimal; // Duplicate.
                if (_instanceof(v, Decimal)) {
                  x.s = v.s;
                  if (external) {
                    if (!v.d || v.e > Decimal.maxE) {
                      // Infinity.
                      x.e = NaN;
                      x.d = null;
                    } else if (v.e < Decimal.minE) {
                      // Zero.
                      x.e = 0;
                      x.d = [0];
                    } else {
                      x.e = v.e;
                      x.d = v.d.slice();
                    }
                  } else {
                    x.e = v.e;
                    x.d = v.d ? v.d.slice() : v.d;
                  }
                  return;
                }
                t = _typeof2(v);
                if (t === "number") {
                  if (v === 0) {
                    x.s = 1 / v < 0 ? -1 : 1;
                    x.e = 0;
                    x.d = [0];
                    return;
                  }
                  if (v < 0) {
                    v = -v;
                    x.s = -1;
                  } else {
                    x.s = 1;
                  } // Fast path for small integers.
                  if (v === ~~v && v < 1e7) {
                    for (e = 0, i = v; i >= 10; i /= 10) {
                      e++;
                    }
                    if (external) {
                      if (e > Decimal.maxE) {
                        x.e = NaN;
                        x.d = null;
                      } else if (e < Decimal.minE) {
                        x.e = 0;
                        x.d = [0];
                      } else {
                        x.e = e;
                        x.d = [v];
                      }
                    } else {
                      x.e = e;
                      x.d = [v];
                    }
                    return; // Infinity, NaN.
                  } else if (v * 0 !== 0) {
                    if (!v) x.s = NaN;
                    x.e = NaN;
                    x.d = null;
                    return;
                  }
                  return parseDecimal(x, v.toString());
                } else if (t !== "string") {
                  throw Error(invalidArgument + v);
                } // Minus sign?
                if ((i = v.charCodeAt(0)) === 45) {
                  v = v.slice(1);
                  x.s = -1;
                } else {
                  // Plus sign?
                  if (i === 43) v = v.slice(1);
                  x.s = 1;
                }
                return isDecimal.test(v) ? parseDecimal(x, v) : parseOther(x, v);
              }
              Decimal.prototype = P;
              Decimal.ROUND_UP = 0;
              Decimal.ROUND_DOWN = 1;
              Decimal.ROUND_CEIL = 2;
              Decimal.ROUND_FLOOR = 3;
              Decimal.ROUND_HALF_UP = 4;
              Decimal.ROUND_HALF_DOWN = 5;
              Decimal.ROUND_HALF_EVEN = 6;
              Decimal.ROUND_HALF_CEIL = 7;
              Decimal.ROUND_HALF_FLOOR = 8;
              Decimal.EUCLID = 9;
              Decimal.config = Decimal.set = config;
              Decimal.clone = clone;
              Decimal.isDecimal = isDecimalInstance;
              Decimal.abs = abs;
              Decimal.acos = acos;
              Decimal.acosh = acosh; // ES6
              Decimal.add = add;
              Decimal.asin = asin;
              Decimal.asinh = asinh; // ES6
              Decimal.atan = atan;
              Decimal.atanh = atanh; // ES6
              Decimal.atan2 = atan2;
              Decimal.cbrt = cbrt; // ES6
              Decimal.ceil = ceil;
              Decimal.cos = cos;
              Decimal.cosh = cosh; // ES6
              Decimal.div = div;
              Decimal.exp = exp;
              Decimal.floor = floor;
              Decimal.hypot = hypot; // ES6
              Decimal.ln = ln;
              Decimal.log = log;
              Decimal.log10 = log10; // ES6
              Decimal.log2 = log2; // ES6
              Decimal.max = max;
              Decimal.min = min;
              Decimal.mod = mod;
              Decimal.mul = mul;
              Decimal.pow = pow;
              Decimal.random = random;
              Decimal.round = round;
              Decimal.sign = sign; // ES6
              Decimal.sin = sin;
              Decimal.sinh = sinh; // ES6
              Decimal.sqrt = sqrt;
              Decimal.sub = sub;
              Decimal.tan = tan;
              Decimal.tanh = tanh; // ES6
              Decimal.trunc = trunc; // ES6
              if (obj === void 0) obj = {};
              if (obj) {
                if (obj.defaults !== true) {
                  ps = [
                    "precision",
                    "rounding",
                    "toExpNeg",
                    "toExpPos",
                    "maxE",
                    "minE",
                    "modulo",
                    "crypto"
                  ];
                  for (i = 0; i < ps.length; ) {
                    if (!obj.hasOwnProperty((p = ps[i++]))) obj[p] = this[p];
                  }
                }
              }
              Decimal.config(obj);
              return Decimal;
            }
            /*
             * Return a new Decimal whose value is `x` divided by `y`, rounded to `precision` significant
             * digits using rounding mode `rounding`.
             *
             * x {number|string|Decimal}
             * y {number|string|Decimal}
             *
             */ function div(x, y) {
              return new this(x).div(y);
            }
            /*
             * Return a new Decimal whose value is the natural exponential of `x`, rounded to `precision`
             * significant digits using rounding mode `rounding`.
             *
             * x {number|string|Decimal} The power to which to raise the base of the natural log.
             *
             */ function exp(x) {
              return new this(x).exp();
            }
            /*
             * Return a new Decimal whose value is `x` round to an integer using `ROUND_FLOOR`.
             *
             * x {number|string|Decimal}
             *
             */ function floor(x) {
              return finalise((x = new this(x)), x.e + 1, 3);
            }
            /*
             * Return a new Decimal whose value is the square root of the sum of the squares of the arguments,
             * rounded to `precision` significant digits using rounding mode `rounding`.
             *
             * hypot(a, b, ...) = sqrt(a^2 + b^2 + ...)
             *
             * arguments {number|string|Decimal}
             *
             */ function hypot() {
              var i,
                n,
                t = new this(0);
              external = false;
              for (i = 0; i < arguments.length; ) {
                n = new this(arguments[i++]);
                if (!n.d) {
                  if (n.s) {
                    external = true;
                    return new this(1 / 0);
                  }
                  t = n;
                } else if (t.d) {
                  t = t.plus(n.times(n));
                }
              }
              external = true;
              return t.sqrt();
            }
            /*
             * Return true if object is a Decimal instance (where Decimal is any Decimal constructor),
             * otherwise return false.
             *
             */ function isDecimalInstance(obj) {
              return (
                _instanceof(obj, Decimal) ||
                (obj && obj.name === "[object Decimal]") ||
                false
              );
            }
            /*
             * Return a new Decimal whose value is the natural logarithm of `x`, rounded to `precision`
             * significant digits using rounding mode `rounding`.
             *
             * x {number|string|Decimal}
             *
             */ function ln(x) {
              return new this(x).ln();
            }
            /*
             * Return a new Decimal whose value is the log of `x` to the base `y`, or to base 10 if no base
             * is specified, rounded to `precision` significant digits using rounding mode `rounding`.
             *
             * log[y](x)
             *
             * x {number|string|Decimal} The argument of the logarithm.
             * y {number|string|Decimal} The base of the logarithm.
             *
             */ function log(x, y) {
              return new this(x).log(y);
            }
            /*
             * Return a new Decimal whose value is the base 2 logarithm of `x`, rounded to `precision`
             * significant digits using rounding mode `rounding`.
             *
             * x {number|string|Decimal}
             *
             */ function log2(x) {
              return new this(x).log(2);
            }
            /*
             * Return a new Decimal whose value is the base 10 logarithm of `x`, rounded to `precision`
             * significant digits using rounding mode `rounding`.
             *
             * x {number|string|Decimal}
             *
             */ function log10(x) {
              return new this(x).log(10);
            }
            /*
             * Return a new Decimal whose value is the maximum of the arguments.
             *
             * arguments {number|string|Decimal}
             *
             */ function max() {
              return maxOrMin(this, arguments, "lt");
            }
            /*
             * Return a new Decimal whose value is the minimum of the arguments.
             *
             * arguments {number|string|Decimal}
             *
             */ function min() {
              return maxOrMin(this, arguments, "gt");
            }
            /*
             * Return a new Decimal whose value is `x` modulo `y`, rounded to `precision` significant digits
             * using rounding mode `rounding`.
             *
             * x {number|string|Decimal}
             * y {number|string|Decimal}
             *
             */ function mod(x, y) {
              return new this(x).mod(y);
            }
            /*
             * Return a new Decimal whose value is `x` multiplied by `y`, rounded to `precision` significant
             * digits using rounding mode `rounding`.
             *
             * x {number|string|Decimal}
             * y {number|string|Decimal}
             *
             */ function mul(x, y) {
              return new this(x).mul(y);
            }
            /*
             * Return a new Decimal whose value is `x` raised to the power `y`, rounded to precision
             * significant digits using rounding mode `rounding`.
             *
             * x {number|string|Decimal} The base.
             * y {number|string|Decimal} The exponent.
             *
             */ function pow(x, y) {
              return new this(x).pow(y);
            }
            /*
             * Returns a new Decimal with a random value equal to or greater than 0 and less than 1, and with
             * `sd`, or `Decimal.precision` if `sd` is omitted, significant digits (or less if trailing zeros
             * are produced).
             *
             * [sd] {number} Significant digits. Integer, 0 to MAX_DIGITS inclusive.
             *
             */ function random(sd) {
              var d,
                e,
                k,
                n,
                i = 0,
                r = new this(1),
                rd = [];
              if (sd === void 0) sd = this.precision;
              else checkInt32(sd, 1, MAX_DIGITS);
              k = Math.ceil(sd / LOG_BASE);
              if (!this.crypto) {
                for (; i < k; ) {
                  rd[i++] = (Math.random() * 1e7) | 0;
                } // Browsers supporting crypto.getRandomValues.
              } else if (crypto.getRandomValues) {
                d = crypto.getRandomValues(new Uint32Array(k));
                for (; i < k; ) {
                  n = d[i]; // 0 <= n < 4294967296
                  // Probability n >= 4.29e9, is 4967296 / 4294967296 = 0.00116 (1 in 865).
                  if (n >= 4.29e9) {
                    d[i] = crypto.getRandomValues(new Uint32Array(1))[0];
                  } else {
                    // 0 <= n <= 4289999999
                    // 0 <= (n % 1e7) <= 9999999
                    rd[i++] = n % 1e7;
                  }
                } // Node.js supporting crypto.randomBytes.
              } else if (crypto.randomBytes) {
                // buffer
                d = crypto.randomBytes((k *= 4));
                for (; i < k; ) {
                  // 0 <= n < 2147483648
                  n =
                    d[i] +
                    (d[i + 1] << 8) +
                    (d[i + 2] << 16) +
                    ((d[i + 3] & 0x7f) << 24); // Probability n >= 2.14e9, is 7483648 / 2147483648 = 0.0035 (1 in 286).
                  if (n >= 2.14e9) {
                    crypto.randomBytes(4).copy(d, i);
                  } else {
                    // 0 <= n <= 2139999999
                    // 0 <= (n % 1e7) <= 9999999
                    rd.push(n % 1e7);
                    i += 4;
                  }
                }
                i = k / 4;
              } else {
                throw Error(cryptoUnavailable);
              }
              k = rd[--i];
              sd %= LOG_BASE; // Convert trailing digits to zeros according to sd.
              if (k && sd) {
                n = mathpow(10, LOG_BASE - sd);
                rd[i] = ((k / n) | 0) * n;
              } // Remove trailing words which are zero.
              for (; rd[i] === 0; i--) {
                rd.pop();
              } // Zero?
              if (i < 0) {
                e = 0;
                rd = [0];
              } else {
                e = -1; // Remove leading words which are zero and adjust exponent accordingly.
                for (; rd[0] === 0; e -= LOG_BASE) {
                  rd.shift();
                } // Count the digits of the first word of rd to determine leading zeros.
                for (k = 1, n = rd[0]; n >= 10; n /= 10) {
                  k++;
                } // Adjust the exponent for leading zeros of the first word of rd.
                if (k < LOG_BASE) e -= LOG_BASE - k;
              }
              r.e = e;
              r.d = rd;
              return r;
            }
            /*
             * Return a new Decimal whose value is `x` rounded to an integer using rounding mode `rounding`.
             *
             * To emulate `Math.round`, set rounding to 7 (ROUND_HALF_CEIL).
             *
             * x {number|string|Decimal}
             *
             */ function round(x) {
              return finalise((x = new this(x)), x.e + 1, this.rounding);
            }
            /*
             * Return
             *   1    if x > 0,
             *  -1    if x < 0,
             *   0    if x is 0,
             *  -0    if x is -0,
             *   NaN  otherwise
             *
             * x {number|string|Decimal}
             *
             */ function sign(x) {
              x = new this(x);
              return x.d ? (x.d[0] ? x.s : 0 * x.s) : x.s || NaN;
            }
            /*
             * Return a new Decimal whose value is the sine of `x`, rounded to `precision` significant digits
             * using rounding mode `rounding`.
             *
             * x {number|string|Decimal} A value in radians.
             *
             */ function sin(x) {
              return new this(x).sin();
            }
            /*
             * Return a new Decimal whose value is the hyperbolic sine of `x`, rounded to `precision`
             * significant digits using rounding mode `rounding`.
             *
             * x {number|string|Decimal} A value in radians.
             *
             */ function sinh(x) {
              return new this(x).sinh();
            }
            /*
             * Return a new Decimal whose value is the square root of `x`, rounded to `precision` significant
             * digits using rounding mode `rounding`.
             *
             * x {number|string|Decimal}
             *
             */ function sqrt(x) {
              return new this(x).sqrt();
            }
            /*
             * Return a new Decimal whose value is `x` minus `y`, rounded to `precision` significant digits
             * using rounding mode `rounding`.
             *
             * x {number|string|Decimal}
             * y {number|string|Decimal}
             *
             */ function sub(x, y) {
              return new this(x).sub(y);
            }
            /*
             * Return a new Decimal whose value is the tangent of `x`, rounded to `precision` significant
             * digits using rounding mode `rounding`.
             *
             * x {number|string|Decimal} A value in radians.
             *
             */ function tan(x) {
              return new this(x).tan();
            }
            /*
             * Return a new Decimal whose value is the hyperbolic tangent of `x`, rounded to `precision`
             * significant digits using rounding mode `rounding`.
             *
             * x {number|string|Decimal} A value in radians.
             *
             */ function tanh(x) {
              return new this(x).tanh();
            }
            /*
             * Return a new Decimal whose value is `x` truncated to an integer.
             *
             * x {number|string|Decimal}
             *
             */ function trunc(x) {
              return finalise((x = new this(x)), x.e + 1, 1);
            } // Create and configure initial Decimal constructor.
            Decimal = clone(DEFAULTS);
            Decimal["default"] = Decimal.Decimal = Decimal; // Create the internal constants from their string values.
            LN10 = new Decimal(LN10);
            PI = new Decimal(PI); // Export.
            // AMD.
            if (typeof define == "function" && define.amd) {
              define(function () {
                return Decimal;
              }); // Node and other environments that support module.exports.
            } else if (typeof module != "undefined" && module.exports) {
              if (
                typeof Symbol == "function" &&
                _typeof2(Symbol.iterator) == "symbol"
              ) {
                P[Symbol.for("nodejs.util.inspect.custom")] = P.toString;
                P[Symbol.toStringTag] = "Decimal";
              }
              module.exports = Decimal; // Browser.
            } else {
              if (!globalScope) {
                globalScope =
                  typeof self != "undefined" && self && self.self == self
                    ? self
                    : window;
              }
              noConflict = globalScope.Decimal;
              Decimal.noConflict = function () {
                globalScope.Decimal = noConflict;
                return Decimal;
              };
              globalScope.Decimal = Decimal;
            }
          })(this);
        },
        {}
      ],
      b815b18e9842bed3b7f351e097aea11a: [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("buffer").Buffer;
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.BinaryParser = void 0;
          var assert = require("assert");
          var enums_1 = require("../enums");
          /**
           * BinaryParser is used to compute fields and values from a HexString
           */ var BinaryParser = /** @class */ (function () {
            /**
             * Initialize bytes to a hex string
             *
             * @param hexBytes a hex string
             */ function BinaryParser(hexBytes) {
              this.bytes = Buffer.from(hexBytes, "hex");
            }
            /**
             * Peek the first byte of the BinaryParser
             *
             * @returns The first byte of the BinaryParser
             */ BinaryParser.prototype.peek = function () {
              assert(this.bytes.byteLength !== 0);
              return this.bytes[0];
            };
            /**
             * Consume the first n bytes of the BinaryParser
             *
             * @param n the number of bytes to skip
             */ BinaryParser.prototype.skip = function (n) {
              assert(n <= this.bytes.byteLength);
              this.bytes = this.bytes.slice(n);
            };
            /**
             * read the first n bytes from the BinaryParser
             *
             * @param n The number of bytes to read
             * @return The bytes
             */ BinaryParser.prototype.read = function (n) {
              assert(n <= this.bytes.byteLength);
              var slice = this.bytes.slice(0, n);
              this.skip(n);
              return slice;
            };
            /**
             * Read an integer of given size
             *
             * @param n The number of bytes to read
             * @return The number represented by those bytes
             */ BinaryParser.prototype.readUIntN = function (n) {
              assert(0 < n && n <= 4, "invalid n");
              return (
                this.read(n).reduce(function (a, b) {
                  return (a << 8) | b;
                }) >>> 0
              );
            };
            BinaryParser.prototype.readUInt8 = function () {
              return this.readUIntN(1);
            };
            BinaryParser.prototype.readUInt16 = function () {
              return this.readUIntN(2);
            };
            BinaryParser.prototype.readUInt32 = function () {
              return this.readUIntN(4);
            };
            BinaryParser.prototype.size = function () {
              return this.bytes.byteLength;
            };
            BinaryParser.prototype.end = function (customEnd) {
              var length = this.bytes.byteLength;
              return (
                length === 0 || (customEnd !== undefined && length <= customEnd)
              );
            };
            /**
             * Reads variable length encoded bytes
             *
             * @return The variable length bytes
             */ BinaryParser.prototype.readVariableLength = function () {
              return this.read(this.readVariableLengthLength());
            };
            /**
             * Reads the length of the variable length encoded bytes
             *
             * @return The length of the variable length encoded bytes
             */ BinaryParser.prototype.readVariableLengthLength = function () {
              var b1 = this.readUInt8();
              if (b1 <= 192) {
                return b1;
              } else if (b1 <= 240) {
                var b2 = this.readUInt8();
                return 193 + (b1 - 193) * 256 + b2;
              } else if (b1 <= 254) {
                var b2 = this.readUInt8();
                var b3 = this.readUInt8();
                return 12481 + (b1 - 241) * 65536 + b2 * 256 + b3;
              }
              throw new Error("Invalid variable length indicator");
            };
            /**
             * Reads the field ordinal from the BinaryParser
             *
             * @return Field ordinal
             */ BinaryParser.prototype.readFieldOrdinal = function () {
              var type = this.readUInt8();
              var nth = type & 15;
              type >>= 4;
              if (type === 0) {
                type = this.readUInt8();
                if (type === 0 || type < 16) {
                  throw new Error(
                    "Cannot read FieldOrdinal, type_code out of range"
                  );
                }
              }
              if (nth === 0) {
                nth = this.readUInt8();
                if (nth === 0 || nth < 16) {
                  throw new Error(
                    "Cannot read FieldOrdinal, field_code out of range"
                  );
                }
              }
              return (type << 16) | nth;
            };
            /**
             * Read the field from the BinaryParser
             *
             * @return The field represented by the bytes at the head of the BinaryParser
             */ BinaryParser.prototype.readField = function () {
              return enums_1.Field.fromString(this.readFieldOrdinal().toString());
            };
            /**
             * Read a given type from the BinaryParser
             *
             * @param type The type that you want to read from the BinaryParser
             * @return The instance of that type read from the BinaryParser
             */ BinaryParser.prototype.readType = function (type) {
              return type.fromParser(this);
            };
            /**
             * Get the type associated with a given field
             *
             * @param field The field that you wan to get the type of
             * @return The type associated with the given field
             */ BinaryParser.prototype.typeForField = function (field) {
              return field.associatedType;
            };
            /**
             * Read value of the type specified by field from the BinaryParser
             *
             * @param field The field that you want to get the associated value for
             * @return The value associated with the given field
             */ BinaryParser.prototype.readFieldValue = function (field) {
              var type = this.typeForField(field);
              if (!type) {
                throw new Error(
                  "unsupported: (" + field.name + ", " + field.type.name + ")"
                );
              }
              var sizeHint = field.isVariableLengthEncoded
                ? this.readVariableLengthLength()
                : undefined;
              var value = type.fromParser(this, sizeHint);
              if (value === undefined) {
                throw new Error(
                  "fromParser for (" +
                    field.name +
                    ", " +
                    field.type.name +
                    ") -> undefined "
                );
              }
              return value;
            };
            /**
             * Get the next field and value from the BinaryParser
             *
             * @return The field and value
             */ BinaryParser.prototype.readFieldAndValue = function () {
              var field = this.readField();
              return [field, this.readFieldValue(field)];
            };
            return BinaryParser;
          })();
          exports.BinaryParser = BinaryParser;
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          assert: "cdcb67ab5f6acbeabe6d878ee73d6e25",
          "../enums": "b4c7d31c276a9e273ef13c8edd1ea3c0"
        }
      ],
      "8027a02b1465ac283be1b684e5f1989b": [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("buffer").Buffer;
          var __extends =
            (this && this.__extends) ||
            (function () {
              var _extendStatics6 = function extendStatics(d, b) {
                _extendStatics6 =
                  Object.setPrototypeOf ||
                  (_instanceof({ __proto__: [] }, Array) &&
                    function (d, b) {
                      d.__proto__ = b;
                    }) ||
                  function (d, b) {
                    for (var p in b) {
                      if (b.hasOwnProperty(p)) d[p] = b[p];
                    }
                  };
                return _extendStatics6(d, b);
              };
              return function (d, b) {
                _extendStatics6(d, b);
                function __() {
                  this.constructor = d;
                }
                d.prototype =
                  b === null
                    ? Object.create(b)
                    : ((__.prototype = b.prototype), new __());
              };
            })();
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.Currency = void 0;
          var hash_160_1 = require("./hash-160");
          var ISO_REGEX = /^[A-Z0-9]{3}$/;
          var HEX_REGEX = /^[A-F0-9]{40}$/;
          /**
           * Convert an ISO code to a currency bytes representation
           */ function isoToBytes(iso) {
            var bytes = Buffer.alloc(20);
            if (iso !== "XRP") {
              var isoBytes = iso.split("").map(function (c) {
                return c.charCodeAt(0);
              });
              bytes.set(isoBytes, 12);
            }
            return bytes;
          }
          /**
           * Tests if ISO is a valid iso code
           */ function isIsoCode(iso) {
            return iso.length === 3;
          }
          /**
           * Tests if hex is a valid hex-string
           */ function isHex(hex) {
            return HEX_REGEX.test(hex);
          }
          /**
           * Tests if a string is a valid representation of a currency
           */ function isStringRepresentation(input) {
            return isIsoCode(input) || isHex(input);
          }
          /**
           * Tests if a Buffer is a valid representation of a currency
           */ function isBytesArray(bytes) {
            return bytes.byteLength === 20;
          }
          /**
           * Ensures that a value is a valid representation of a currency
           */ function isValidRepresentation(input) {
            return _instanceof(input, Buffer)
              ? isBytesArray(input)
              : isStringRepresentation(input);
          }
          /**
           * Generate bytes from a string or buffer representation of a currency
           */ function bytesFromRepresentation(input) {
            if (!isValidRepresentation(input)) {
              throw new Error("Unsupported Currency representation: " + input);
            }
            return input.length === 3
              ? isoToBytes(input)
              : Buffer.from(input, "hex");
          }
          /**
           * Class defining how to encode and decode Currencies
           */ var Currency = /** @class */ (function (_super) {
            __extends(Currency, _super);
            function Currency(byteBuf) {
              var _this =
                _super.call(
                  this,
                  byteBuf !== null && byteBuf !== void 0
                    ? byteBuf
                    : Currency.XRP.bytes
                ) || this;
              var onlyISO = true;
              var bytes = _this.bytes;
              var code = _this.bytes.slice(12, 15);
              var iso = code.toString();
              for (var i = bytes.length - 1; i >= 0; i--) {
                if (bytes[i] !== 0 && !(i === 12 || i === 13 || i === 14)) {
                  onlyISO = false;
                  break;
                }
              }
              var lossLessISO = onlyISO && iso !== "XRP" && ISO_REGEX.test(iso);
              _this._isNative = onlyISO && code.toString("hex") === "000000";
              _this._iso = _this._isNative
                ? "XRP"
                : lossLessISO
                ? iso
                : undefined;
              return _this;
            }
            /**
             * Tells if this currency is native
             *
             * @returns true if native, false if not
             */ Currency.prototype.isNative = function () {
              return this._isNative;
            };
            /**
             * Return the ISO code of this currency
             *
             * @returns ISO code if it exists, else undefined
             */ Currency.prototype.iso = function () {
              return this._iso;
            };
            /**
             * Constructs a Currency object
             *
             * @param val Currency object or a string representation of a currency
             */ Currency.from = function (value) {
              if (_instanceof(value, Currency)) {
                return value;
              }
              if (typeof value === "string") {
                return new Currency(bytesFromRepresentation(value));
              }
              throw new Error("Cannot construct Currency from value given");
            };
            /**
             * Gets the JSON representation of a currency
             *
             * @returns JSON representation
             */ Currency.prototype.toJSON = function () {
              var iso = this.iso();
              if (iso !== undefined) {
                return iso;
              }
              return this.bytes.toString("hex").toUpperCase();
            };
            Currency.XRP = new Currency(Buffer.alloc(20));
            return Currency;
          })(hash_160_1.Hash160);
          exports.Currency = Currency;
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          "./hash-160": "002b66db5149e202a57ace584b1424aa"
        }
      ],
      "7966fe1b0061af7f75aa26df61df6fe7": [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("buffer").Buffer;
          var __extends =
            (this && this.__extends) ||
            (function () {
              var _extendStatics7 = function extendStatics(d, b) {
                _extendStatics7 =
                  Object.setPrototypeOf ||
                  (_instanceof({ __proto__: [] }, Array) &&
                    function (d, b) {
                      d.__proto__ = b;
                    }) ||
                  function (d, b) {
                    for (var p in b) {
                      if (b.hasOwnProperty(p)) d[p] = b[p];
                    }
                  };
                return _extendStatics7(d, b);
              };
              return function (d, b) {
                _extendStatics7(d, b);
                function __() {
                  this.constructor = d;
                }
                d.prototype =
                  b === null
                    ? Object.create(b)
                    : ((__.prototype = b.prototype), new __());
              };
            })();
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.Blob = void 0;
          var serialized_type_1 = require("./serialized-type");
          /**
           * Variable length encoded type
           */ var Blob = /** @class */ (function (_super) {
            __extends(Blob, _super);
            function Blob(bytes) {
              return _super.call(this, bytes) || this;
            }
            /**
             * Defines how to read a Blob from a BinaryParser
             *
             * @param parser The binary parser to read the Blob from
             * @param hint The length of the blob, computed by readVariableLengthLength() and passed in
             * @returns A Blob object
             */ Blob.fromParser = function (parser, hint) {
              return new Blob(parser.read(hint));
            };
            /**
             * Create a Blob object from a hex-string
             *
             * @param value existing Blob object or a hex-string
             * @returns A Blob object
             */ Blob.from = function (value) {
              if (_instanceof(value, Blob)) {
                return value;
              }
              if (typeof value === "string") {
                return new Blob(Buffer.from(value, "hex"));
              }
              throw new Error("Cannot construct Blob from value given");
            };
            return Blob;
          })(serialized_type_1.SerializedType);
          exports.Blob = Blob;
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          "./serialized-type": "0f0f786f836b5aa515dc3100a1d71ee2"
        }
      ],
      e1656935a8c23443a267c1b42a85ecf6: [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("buffer").Buffer;
          var __extends =
            (this && this.__extends) ||
            (function () {
              var _extendStatics8 = function extendStatics(d, b) {
                _extendStatics8 =
                  Object.setPrototypeOf ||
                  (_instanceof({ __proto__: [] }, Array) &&
                    function (d, b) {
                      d.__proto__ = b;
                    }) ||
                  function (d, b) {
                    for (var p in b) {
                      if (b.hasOwnProperty(p)) d[p] = b[p];
                    }
                  };
                return _extendStatics8(d, b);
              };
              return function (d, b) {
                _extendStatics8(d, b);
                function __() {
                  this.constructor = d;
                }
                d.prototype =
                  b === null
                    ? Object.create(b)
                    : ((__.prototype = b.prototype), new __());
              };
            })();
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.Hash128 = void 0;
          var hash_1 = require("./hash");
          /**
           * Hash with a width of 128 bits
           */ var Hash128 = /** @class */ (function (_super) {
            __extends(Hash128, _super);
            function Hash128(bytes) {
              return (
                _super.call(
                  this,
                  bytes !== null && bytes !== void 0
                    ? bytes
                    : Hash128.ZERO_128.bytes
                ) || this
              );
            }
            Hash128.width = 16;
            Hash128.ZERO_128 = new Hash128(Buffer.alloc(Hash128.width));
            return Hash128;
          })(hash_1.Hash);
          exports.Hash128 = Hash128;
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          "./hash": "6162b6ebe73334b0782058d6ae83aba2"
        }
      ],
      "8dba9529a2980e9679fcb11337850744": [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("buffer").Buffer;
          var __extends =
            (this && this.__extends) ||
            (function () {
              var _extendStatics9 = function extendStatics(d, b) {
                _extendStatics9 =
                  Object.setPrototypeOf ||
                  (_instanceof({ __proto__: [] }, Array) &&
                    function (d, b) {
                      d.__proto__ = b;
                    }) ||
                  function (d, b) {
                    for (var p in b) {
                      if (b.hasOwnProperty(p)) d[p] = b[p];
                    }
                  };
                return _extendStatics9(d, b);
              };
              return function (d, b) {
                _extendStatics9(d, b);
                function __() {
                  this.constructor = d;
                }
                d.prototype =
                  b === null
                    ? Object.create(b)
                    : ((__.prototype = b.prototype), new __());
              };
            })();
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.Hash256 = void 0;
          var hash_1 = require("./hash");
          /**
           * Hash with a width of 256 bits
           */ var Hash256 = /** @class */ (function (_super) {
            __extends(Hash256, _super);
            function Hash256(bytes) {
              return (
                _super.call(
                  this,
                  bytes !== null && bytes !== void 0
                    ? bytes
                    : Hash256.ZERO_256.bytes
                ) || this
              );
            }
            Hash256.width = 32;
            Hash256.ZERO_256 = new Hash256(Buffer.alloc(Hash256.width));
            return Hash256;
          })(hash_1.Hash);
          exports.Hash256 = Hash256;
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          "./hash": "6162b6ebe73334b0782058d6ae83aba2"
        }
      ],
      b9d3700a099312e5265dd9a7f8da6d7b: [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("buffer").Buffer;
          var __extends =
            (this && this.__extends) ||
            (function () {
              var _extendStatics10 = function extendStatics(d, b) {
                _extendStatics10 =
                  Object.setPrototypeOf ||
                  (_instanceof({ __proto__: [] }, Array) &&
                    function (d, b) {
                      d.__proto__ = b;
                    }) ||
                  function (d, b) {
                    for (var p in b) {
                      if (b.hasOwnProperty(p)) d[p] = b[p];
                    }
                  };
                return _extendStatics10(d, b);
              };
              return function (d, b) {
                _extendStatics10(d, b);
                function __() {
                  this.constructor = d;
                }
                d.prototype =
                  b === null
                    ? Object.create(b)
                    : ((__.prototype = b.prototype), new __());
              };
            })();
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.PathSet = void 0;
          var account_id_1 = require("./account-id");
          var currency_1 = require("./currency");
          var binary_parser_1 = require("../serdes/binary-parser");
          var serialized_type_1 = require("./serialized-type");
          /**
           * Constants for separating Paths in a PathSet
           */ var PATHSET_END_BYTE = 0x00;
          var PATH_SEPARATOR_BYTE = 0xff;
          /**
           * Constant for masking types of a Hop
           */ var TYPE_ACCOUNT = 0x01;
          var TYPE_CURRENCY = 0x10;
          var TYPE_ISSUER = 0x20;
          /**
           * TypeGuard for HopObject
           */ function isHopObject(arg) {
            return (
              arg.issuer !== undefined ||
              arg.account !== undefined ||
              arg.currency !== undefined
            );
          }
          /**
           * TypeGuard for PathSet
           */ function isPathSet(arg) {
            return (
              (Array.isArray(arg) && arg.length === 0) ||
              (Array.isArray(arg) &&
                Array.isArray(arg[0]) &&
                arg[0].length === 0) ||
              (Array.isArray(arg) &&
                Array.isArray(arg[0]) &&
                isHopObject(arg[0][0]))
            );
          }
          /**
           * Serialize and Deserialize a Hop
           */ var Hop = /** @class */ (function (_super) {
            __extends(Hop, _super);
            function Hop() {
              return (_super !== null && _super.apply(this, arguments)) || this;
            }
            /**
             * Create a Hop from a HopObject
             *
             * @param value Either a hop or HopObject to create a hop with
             * @returns a Hop
             */ Hop.from = function (value) {
              if (_instanceof(value, Hop)) {
                return value;
              }
              var bytes = [Buffer.from([0])];
              if (value.account) {
                bytes.push(account_id_1.AccountID.from(value.account).toBytes());
                bytes[0][0] |= TYPE_ACCOUNT;
              }
              if (value.currency) {
                bytes.push(currency_1.Currency.from(value.currency).toBytes());
                bytes[0][0] |= TYPE_CURRENCY;
              }
              if (value.issuer) {
                bytes.push(account_id_1.AccountID.from(value.issuer).toBytes());
                bytes[0][0] |= TYPE_ISSUER;
              }
              return new Hop(Buffer.concat(bytes));
            };
            /**
             * Construct a Hop from a BinaryParser
             *
             * @param parser BinaryParser to read the Hop from
             * @returns a Hop
             */ Hop.fromParser = function (parser) {
              var type = parser.readUInt8();
              var bytes = [Buffer.from([type])];
              if (type & TYPE_ACCOUNT) {
                bytes.push(parser.read(account_id_1.AccountID.width));
              }
              if (type & TYPE_CURRENCY) {
                bytes.push(parser.read(currency_1.Currency.width));
              }
              if (type & TYPE_ISSUER) {
                bytes.push(parser.read(account_id_1.AccountID.width));
              }
              return new Hop(Buffer.concat(bytes));
            };
            /**
             * Get the JSON interpretation of this hop
             *
             * @returns a HopObject, an JS object with optional account, issuer, and currency
             */ Hop.prototype.toJSON = function () {
              var hopParser = new binary_parser_1.BinaryParser(
                this.bytes.toString("hex")
              );
              var type = hopParser.readUInt8();
              var _result = {};
              if (type & TYPE_ACCOUNT) {
                _result.account = account_id_1.AccountID.fromParser(hopParser).toJSON();
              }
              if (type & TYPE_CURRENCY) {
                _result.currency = currency_1.Currency.fromParser(hopParser).toJSON();
              }
              if (type & TYPE_ISSUER) {
                _result.issuer = account_id_1.AccountID.fromParser(hopParser).toJSON();
              }
              return _result;
            };
            /**
             * get a number representing the type of this hop
             *
             * @returns a number to be bitwise and-ed with TYPE_ constants to describe the types in the hop
             */ Hop.prototype.type = function () {
              return this.bytes[0];
            };
            return Hop;
          })(serialized_type_1.SerializedType);
          /**
           * Class for serializing/deserializing Paths
           */ var Path = /** @class */ (function (_super) {
            __extends(Path, _super);
            function Path() {
              return (_super !== null && _super.apply(this, arguments)) || this;
            }
            /**
             * construct a Path from an array of Hops
             *
             * @param value Path or array of HopObjects to construct a Path
             * @returns the Path
             */ Path.from = function (value) {
              if (_instanceof(value, Path)) {
                return value;
              }
              var bytes = [];
              value.forEach(function (hop) {
                bytes.push(Hop.from(hop).toBytes());
              });
              return new Path(Buffer.concat(bytes));
            };
            /**
             * Read a Path from a BinaryParser
             *
             * @param parser BinaryParser to read Path from
             * @returns the Path represented by the bytes read from the BinaryParser
             */ Path.fromParser = function (parser) {
              var bytes = [];
              while (!parser.end()) {
                bytes.push(Hop.fromParser(parser).toBytes());
                if (
                  parser.peek() === PATHSET_END_BYTE ||
                  parser.peek() === PATH_SEPARATOR_BYTE
                ) {
                  break;
                }
              }
              return new Path(Buffer.concat(bytes));
            };
            /**
             * Get the JSON representation of this Path
             *
             * @returns an Array of HopObject constructed from this.bytes
             */ Path.prototype.toJSON = function () {
              var json = [];
              var pathParser = new binary_parser_1.BinaryParser(this.toString());
              while (!pathParser.end()) {
                json.push(Hop.fromParser(pathParser).toJSON());
              }
              return json;
            };
            return Path;
          })(serialized_type_1.SerializedType);
          /**
           * Deserialize and Serialize the PathSet type
           */ var PathSet = /** @class */ (function (_super) {
            __extends(PathSet, _super);
            function PathSet() {
              return (_super !== null && _super.apply(this, arguments)) || this;
            }
            /**
             * Construct a PathSet from an Array of Arrays representing paths
             *
             * @param value A PathSet or Array of Array of HopObjects
             * @returns the PathSet constructed from value
             */ PathSet.from = function (value) {
              if (_instanceof(value, PathSet)) {
                return value;
              }
              if (isPathSet(value)) {
                var bytes_1 = [];
                value.forEach(function (path) {
                  bytes_1.push(Path.from(path).toBytes());
                  bytes_1.push(Buffer.from([PATH_SEPARATOR_BYTE]));
                });
                bytes_1[bytes_1.length - 1] = Buffer.from([PATHSET_END_BYTE]);
                return new PathSet(Buffer.concat(bytes_1));
              }
              throw new Error("Cannot construct PathSet from given value");
            };
            /**
             * Construct a PathSet from a BinaryParser
             *
             * @param parser A BinaryParser to read PathSet from
             * @returns the PathSet read from parser
             */ PathSet.fromParser = function (parser) {
              var bytes = [];
              while (!parser.end()) {
                bytes.push(Path.fromParser(parser).toBytes());
                bytes.push(parser.read(1));
                if (bytes[bytes.length - 1][0] == PATHSET_END_BYTE) {
                  break;
                }
              }
              return new PathSet(Buffer.concat(bytes));
            };
            /**
             * Get the JSON representation of this PathSet
             *
             * @returns an Array of Array of HopObjects, representing this PathSet
             */ PathSet.prototype.toJSON = function () {
              var json = [];
              var pathParser = new binary_parser_1.BinaryParser(this.toString());
              while (!pathParser.end()) {
                json.push(Path.fromParser(pathParser).toJSON());
                pathParser.skip(1);
              }
              return json;
            };
            return PathSet;
          })(serialized_type_1.SerializedType);
          exports.PathSet = PathSet;
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          "./account-id": "eb20d852480fd223e8be71fa0e2c6b42",
          "./currency": "8027a02b1465ac283be1b684e5f1989b",
          "../serdes/binary-parser": "b815b18e9842bed3b7f351e097aea11a",
          "./serialized-type": "0f0f786f836b5aa515dc3100a1d71ee2"
        }
      ],
      "72364fa2f3c32062ddb9e02d8b450544": [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("buffer").Buffer;
          var __extends =
            (this && this.__extends) ||
            (function () {
              var _extendStatics11 = function extendStatics(d, b) {
                _extendStatics11 =
                  Object.setPrototypeOf ||
                  (_instanceof({ __proto__: [] }, Array) &&
                    function (d, b) {
                      d.__proto__ = b;
                    }) ||
                  function (d, b) {
                    for (var p in b) {
                      if (b.hasOwnProperty(p)) d[p] = b[p];
                    }
                  };
                return _extendStatics11(d, b);
              };
              return function (d, b) {
                _extendStatics11(d, b);
                function __() {
                  this.constructor = d;
                }
                d.prototype =
                  b === null
                    ? Object.create(b)
                    : ((__.prototype = b.prototype), new __());
              };
            })();
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.STArray = void 0;
          var serialized_type_1 = require("./serialized-type");
          var st_object_1 = require("./st-object");
          var binary_parser_1 = require("../serdes/binary-parser");
          var ARRAY_END_MARKER = Buffer.from([0xf1]);
          var ARRAY_END_MARKER_NAME = "ArrayEndMarker";
          var OBJECT_END_MARKER = Buffer.from([0xe1]);
          /**
           * TypeGuard for Array<JsonObject>
           */ function isObjects(args) {
            return (
              Array.isArray(args) &&
              (args.length === 0 || _typeof2(args[0]) === "object")
            );
          }
          /**
           * Class for serializing and deserializing Arrays of Objects
           */ var STArray = /** @class */ (function (_super) {
            __extends(STArray, _super);
            function STArray() {
              return (_super !== null && _super.apply(this, arguments)) || this;
            }
            /**
             * Construct an STArray from a BinaryParser
             *
             * @param parser BinaryParser to parse an STArray from
             * @returns An STArray Object
             */ STArray.fromParser = function (parser) {
              var bytes = [];
              while (!parser.end()) {
                var field = parser.readField();
                if (field.name === ARRAY_END_MARKER_NAME) {
                  break;
                }
                bytes.push(
                  field.header,
                  parser.readFieldValue(field).toBytes(),
                  OBJECT_END_MARKER
                );
              }
              bytes.push(ARRAY_END_MARKER);
              return new STArray(Buffer.concat(bytes));
            };
            /**
             * Construct an STArray from an Array of JSON Objects
             *
             * @param value STArray or Array of Objects to parse into an STArray
             * @returns An STArray object
             */ STArray.from = function (value) {
              if (_instanceof(value, STArray)) {
                return value;
              }
              if (isObjects(value)) {
                var bytes_1 = [];
                value.forEach(function (obj) {
                  bytes_1.push(st_object_1.STObject.from(obj).toBytes());
                });
                bytes_1.push(ARRAY_END_MARKER);
                return new STArray(Buffer.concat(bytes_1));
              }
              throw new Error("Cannot construct Currency from value given");
            };
            /**
             * Return the JSON representation of this.bytes
             *
             * @returns An Array of JSON objects
             */ STArray.prototype.toJSON = function () {
              var result = [];
              var arrayParser = new binary_parser_1.BinaryParser(this.toString());
              while (!arrayParser.end()) {
                var field = arrayParser.readField();
                if (field.name === ARRAY_END_MARKER_NAME) {
                  break;
                }
                var outer = {};
                outer[field.name] = st_object_1.STObject.fromParser(
                  arrayParser
                ).toJSON();
                result.push(outer);
              }
              return result;
            };
            return STArray;
          })(serialized_type_1.SerializedType);
          exports.STArray = STArray;
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          "./serialized-type": "0f0f786f836b5aa515dc3100a1d71ee2",
          "./st-object": "448eadfe0b180c0a569a829367a9ee86",
          "../serdes/binary-parser": "b815b18e9842bed3b7f351e097aea11a"
        }
      ],
      "448eadfe0b180c0a569a829367a9ee86": [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("buffer").Buffer;
          var __extends =
            (this && this.__extends) ||
            (function () {
              var _extendStatics12 = function extendStatics(d, b) {
                _extendStatics12 =
                  Object.setPrototypeOf ||
                  (_instanceof({ __proto__: [] }, Array) &&
                    function (d, b) {
                      d.__proto__ = b;
                    }) ||
                  function (d, b) {
                    for (var p in b) {
                      if (b.hasOwnProperty(p)) d[p] = b[p];
                    }
                  };
                return _extendStatics12(d, b);
              };
              return function (d, b) {
                _extendStatics12(d, b);
                function __() {
                  this.constructor = d;
                }
                d.prototype =
                  b === null
                    ? Object.create(b)
                    : ((__.prototype = b.prototype), new __());
              };
            })();
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.STObject = void 0;
          var enums_1 = require("../enums");
          var serialized_type_1 = require("./serialized-type");
          var ripple_address_codec_1 = require("ripple-address-codec");
          var binary_parser_1 = require("../serdes/binary-parser");
          var binary_serializer_1 = require("../serdes/binary-serializer");
          var OBJECT_END_MARKER_BYTE = Buffer.from([0xe1]);
          var OBJECT_END_MARKER = "ObjectEndMarker";
          var ST_OBJECT = "STObject";
          var DESTINATION = "Destination";
          var ACCOUNT = "Account";
          var SOURCE_TAG = "SourceTag";
          var DEST_TAG = "DestinationTag";
          /**
           * Break down an X-Address into an account and a tag
           *
           * @param field Name of field
           * @param xAddress X-Address corresponding to the field
           */ function handleXAddress(field, xAddress) {
            var _a, _b;
            var decoded = ripple_address_codec_1.xAddressToClassicAddress(
              xAddress
            );
            var tagName;
            if (field === DESTINATION) tagName = DEST_TAG;
            else if (field === ACCOUNT) tagName = SOURCE_TAG;
            else if (decoded.tag !== false)
              throw new Error(field + " cannot have an associated tag");
            return decoded.tag !== false
              ? ((_a = {}),
                (_a[field] = decoded.classicAddress),
                (_a[tagName] = decoded.tag),
                _a)
              : ((_b = {}), (_b[field] = decoded.classicAddress), _b);
          }
          /**
           * Validate that two objects don't both have the same tag fields
           *
           * @param obj1 First object to check for tags
           * @param obj2 Second object to check for tags
           * @throws When both objects have SourceTag or DestinationTag
           */ function checkForDuplicateTags(obj1, obj2) {
            if (
              !(obj1[SOURCE_TAG] === undefined || obj2[SOURCE_TAG] === undefined)
            )
              throw new Error("Cannot have Account X-Address and SourceTag");
            if (!(obj1[DEST_TAG] === undefined || obj2[DEST_TAG] === undefined))
              throw new Error(
                "Cannot have Destination X-Address and DestinationTag"
              );
          }
          /**
           * Class for Serializing/Deserializing objects
           */ var STObject = /** @class */ (function (_super) {
            __extends(STObject, _super);
            function STObject() {
              return (_super !== null && _super.apply(this, arguments)) || this;
            }
            /**
             * Construct a STObject from a BinaryParser
             *
             * @param parser BinaryParser to read STObject from
             * @returns A STObject object
             */ STObject.fromParser = function (parser) {
              var list = new binary_serializer_1.BytesList();
              var bytes = new binary_serializer_1.BinarySerializer(list);
              while (!parser.end()) {
                var field = parser.readField();
                if (field.name === OBJECT_END_MARKER) {
                  break;
                }
                var associatedValue = parser.readFieldValue(field);
                bytes.writeFieldAndValue(field, associatedValue);
                if (field.type.name === ST_OBJECT) {
                  bytes.put(OBJECT_END_MARKER_BYTE);
                }
              }
              return new STObject(list.toBytes());
            };
            /**
             * Construct a STObject from a JSON object
             *
             * @param value An object to include
             * @param filter optional, denote which field to include in serialized object
             * @returns a STObject object
             */ STObject.from = function (value, filter) {
              if (_instanceof(value, STObject)) {
                return value;
              }
              var list = new binary_serializer_1.BytesList();
              var bytes = new binary_serializer_1.BinarySerializer(list);
              var xAddressDecoded = Object.entries(value).reduce(function (
                acc,
                _a
              ) {
                var _b;
                var key = _a[0],
                  val = _a[1];
                var handled = undefined;
                if (ripple_address_codec_1.isValidXAddress(val)) {
                  handled = handleXAddress(key, val);
                  checkForDuplicateTags(handled, value);
                }
                return Object.assign(
                  acc,
                  handled !== null && handled !== void 0
                    ? handled
                    : ((_b = {}), (_b[key] = val), _b)
                );
              },
              {});
              var sorted = Object.keys(xAddressDecoded)
                .map(function (f) {
                  return enums_1.Field[f];
                })
                .filter(function (f) {
                  return (
                    f !== undefined &&
                    xAddressDecoded[f.name] !== undefined &&
                    f.isSerialized
                  );
                })
                .sort(function (a, b) {
                  return a.ordinal - b.ordinal;
                });
              if (filter !== undefined) {
                sorted = sorted.filter(filter);
              }
              sorted.forEach(function (field) {
                var associatedValue = field.associatedType.from(
                  xAddressDecoded[field.name]
                );
                bytes.writeFieldAndValue(field, associatedValue);
                if (field.type.name === ST_OBJECT) {
                  bytes.put(OBJECT_END_MARKER_BYTE);
                }
              });
              return new STObject(list.toBytes());
            };
            /**
             * Get the JSON interpretation of this.bytes
             *
             * @returns a JSON object
             */ STObject.prototype.toJSON = function () {
              var objectParser = new binary_parser_1.BinaryParser(
                this.toString()
              );
              var accumulator = {};
              while (!objectParser.end()) {
                var field = objectParser.readField();
                if (field.name === OBJECT_END_MARKER) {
                  break;
                }
                accumulator[field.name] = objectParser
                  .readFieldValue(field)
                  .toJSON();
              }
              return accumulator;
            };
            return STObject;
          })(serialized_type_1.SerializedType);
          exports.STObject = STObject;
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          "../enums": "b4c7d31c276a9e273ef13c8edd1ea3c0",
          "./serialized-type": "0f0f786f836b5aa515dc3100a1d71ee2",
          "ripple-address-codec": "371ff8c84e04afd24921f37bc92aa65b",
          "../serdes/binary-parser": "b815b18e9842bed3b7f351e097aea11a",
          "../serdes/binary-serializer": "abc1426ad32b9cb626ea24d137d353ef"
        }
      ],
      "7235c20966e2926308f4c7393154f6d5": [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("buffer").Buffer;
          var __extends =
            (this && this.__extends) ||
            (function () {
              var _extendStatics13 = function extendStatics(d, b) {
                _extendStatics13 =
                  Object.setPrototypeOf ||
                  (_instanceof({ __proto__: [] }, Array) &&
                    function (d, b) {
                      d.__proto__ = b;
                    }) ||
                  function (d, b) {
                    for (var p in b) {
                      if (b.hasOwnProperty(p)) d[p] = b[p];
                    }
                  };
                return _extendStatics13(d, b);
              };
              return function (d, b) {
                _extendStatics13(d, b);
                function __() {
                  this.constructor = d;
                }
                d.prototype =
                  b === null
                    ? Object.create(b)
                    : ((__.prototype = b.prototype), new __());
              };
            })();
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.UInt16 = void 0;
          var uint_1 = require("./uint");
          /**
           * Derived UInt class for serializing/deserializing 16 bit UInt
           */ var UInt16 = /** @class */ (function (_super) {
            __extends(UInt16, _super);
            function UInt16(bytes) {
              return (
                _super.call(
                  this,
                  bytes !== null && bytes !== void 0
                    ? bytes
                    : UInt16.defaultUInt16.bytes
                ) || this
              );
            }
            UInt16.fromParser = function (parser) {
              return new UInt16(parser.read(UInt16.width));
            };
            /**
             * Construct a UInt16 object from a number
             *
             * @param val UInt16 object or number
             */ UInt16.from = function (val) {
              if (_instanceof(val, UInt16)) {
                return val;
              }
              if (typeof val === "number") {
                var buf = Buffer.alloc(UInt16.width);
                buf.writeUInt16BE(val);
                return new UInt16(buf);
              }
              throw new Error("Can not construct UInt16 with given value");
            };
            /**
             * get the value of a UInt16 object
             *
             * @returns the number represented by this.bytes
             */ UInt16.prototype.valueOf = function () {
              return this.bytes.readUInt16BE();
            };
            UInt16.width = 16 / 8; // 2
            UInt16.defaultUInt16 = new UInt16(Buffer.alloc(UInt16.width));
            return UInt16;
          })(uint_1.UInt);
          exports.UInt16 = UInt16;
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          "./uint": "cf0c96dbce08f026796864c0035bf86a"
        }
      ],
      cf0c96dbce08f026796864c0035bf86a: [
        function (require, module, exports) {
          "use strict";
          var __extends =
            (this && this.__extends) ||
            (function () {
              var _extendStatics14 = function extendStatics(d, b) {
                _extendStatics14 =
                  Object.setPrototypeOf ||
                  (_instanceof({ __proto__: [] }, Array) &&
                    function (d, b) {
                      d.__proto__ = b;
                    }) ||
                  function (d, b) {
                    for (var p in b) {
                      if (b.hasOwnProperty(p)) d[p] = b[p];
                    }
                  };
                return _extendStatics14(d, b);
              };
              return function (d, b) {
                _extendStatics14(d, b);
                function __() {
                  this.constructor = d;
                }
                d.prototype =
                  b === null
                    ? Object.create(b)
                    : ((__.prototype = b.prototype), new __());
              };
            })();
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.UInt = void 0;
          var serialized_type_1 = require("./serialized-type");
          /**
           * Compare numbers and bigints n1 and n2
           *
           * @param n1 First object to compare
           * @param n2 Second object to compare
           * @returns -1, 0, or 1, depending on how the two objects compare
           */ function compare(n1, n2) {
            return n1 < n2 ? -1 : n1 == n2 ? 0 : 1;
          }
          /**
           * Base class for serializing and deserializing unsigned integers.
           */ var UInt = /** @class */ (function (_super) {
            __extends(UInt, _super);
            function UInt(bytes) {
              return _super.call(this, bytes) || this;
            }
            /**
             * Overload of compareTo for Comparable
             *
             * @param other other UInt to compare this to
             * @returns -1, 0, or 1 depending on how the objects relate to each other
             */ UInt.prototype.compareTo = function (other) {
              return compare(this.valueOf(), other.valueOf());
            };
            /**
             * Convert a UInt object to JSON
             *
             * @returns number or string represented by this.bytes
             */ UInt.prototype.toJSON = function () {
              var val = this.valueOf();
              return typeof val === "number" ? val : val.toString();
            };
            return UInt;
          })(serialized_type_1.Comparable);
          exports.UInt = UInt;
        },
        { "./serialized-type": "0f0f786f836b5aa515dc3100a1d71ee2" }
      ],
      "3c53eeba0cbce1f6d03a34e1ea1cd745": [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("buffer").Buffer;
          var __extends =
            (this && this.__extends) ||
            (function () {
              var _extendStatics15 = function extendStatics(d, b) {
                _extendStatics15 =
                  Object.setPrototypeOf ||
                  (_instanceof({ __proto__: [] }, Array) &&
                    function (d, b) {
                      d.__proto__ = b;
                    }) ||
                  function (d, b) {
                    for (var p in b) {
                      if (b.hasOwnProperty(p)) d[p] = b[p];
                    }
                  };
                return _extendStatics15(d, b);
              };
              return function (d, b) {
                _extendStatics15(d, b);
                function __() {
                  this.constructor = d;
                }
                d.prototype =
                  b === null
                    ? Object.create(b)
                    : ((__.prototype = b.prototype), new __());
              };
            })();
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.UInt32 = void 0;
          var uint_1 = require("./uint");
          /**
           * Derived UInt class for serializing/deserializing 32 bit UInt
           */ var UInt32 = /** @class */ (function (_super) {
            __extends(UInt32, _super);
            function UInt32(bytes) {
              return (
                _super.call(
                  this,
                  bytes !== null && bytes !== void 0
                    ? bytes
                    : UInt32.defaultUInt32.bytes
                ) || this
              );
            }
            UInt32.fromParser = function (parser) {
              return new UInt32(parser.read(UInt32.width));
            };
            /**
             * Construct a UInt32 object from a number
             *
             * @param val UInt32 object or number
             */ UInt32.from = function (val) {
              if (_instanceof(val, UInt32)) {
                return val;
              }
              var buf = Buffer.alloc(UInt32.width);
              if (typeof val === "string") {
                var num = Number.parseInt(val);
                buf.writeUInt32BE(num);
                return new UInt32(buf);
              }
              if (typeof val === "number") {
                buf.writeUInt32BE(val);
                return new UInt32(buf);
              }
              throw new Error("Cannot construct UInt32 from given value");
            };
            /**
             * get the value of a UInt32 object
             *
             * @returns the number represented by this.bytes
             */ UInt32.prototype.valueOf = function () {
              return this.bytes.readUInt32BE();
            };
            UInt32.width = 32 / 8; // 4
            UInt32.defaultUInt32 = new UInt32(Buffer.alloc(UInt32.width));
            return UInt32;
          })(uint_1.UInt);
          exports.UInt32 = UInt32;
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          "./uint": "cf0c96dbce08f026796864c0035bf86a"
        }
      ],
      "90902fad86c60ac44e4a4d8edccf01e2": [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("buffer").Buffer;
          var __extends =
            (this && this.__extends) ||
            (function () {
              var _extendStatics16 = function extendStatics(d, b) {
                _extendStatics16 =
                  Object.setPrototypeOf ||
                  (_instanceof({ __proto__: [] }, Array) &&
                    function (d, b) {
                      d.__proto__ = b;
                    }) ||
                  function (d, b) {
                    for (var p in b) {
                      if (b.hasOwnProperty(p)) d[p] = b[p];
                    }
                  };
                return _extendStatics16(d, b);
              };
              return function (d, b) {
                _extendStatics16(d, b);
                function __() {
                  this.constructor = d;
                }
                d.prototype =
                  b === null
                    ? Object.create(b)
                    : ((__.prototype = b.prototype), new __());
              };
            })();
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.UInt64 = void 0;
          var uint_1 = require("./uint");
          var HEX_REGEX = /^[A-F0-9]{16}$/;
          /**
           * Derived UInt class for serializing/deserializing 64 bit UInt
           */ var UInt64 = /** @class */ (function (_super) {
            __extends(UInt64, _super);
            function UInt64(bytes) {
              return (
                _super.call(
                  this,
                  bytes !== null && bytes !== void 0
                    ? bytes
                    : UInt64.defaultUInt64.bytes
                ) || this
              );
            }
            UInt64.fromParser = function (parser) {
              return new UInt64(parser.read(UInt64.width));
            };
            /**
             * Construct a UInt64 object
             *
             * @param val A UInt64, hex-string, bigint, or number
             * @returns A UInt64 object
             */ UInt64.from = function (val) {
              if (_instanceof(val, UInt64)) {
                return val;
              }
              var buf = Buffer.alloc(UInt64.width);
              if (typeof val === "number") {
                if (val < 0) {
                  throw new Error("value must be an unsigned integer");
                }
                buf.writeBigUInt64BE(BigInt(val));
                return new UInt64(buf);
              }
              if (typeof val === "string") {
                if (!HEX_REGEX.test(val)) {
                  throw new Error(val + " is not a valid hex-string");
                }
                buf = Buffer.from(val, "hex");
                return new UInt64(buf);
              }
              if (typeof val === "bigint") {
                buf.writeBigUInt64BE(val);
                return new UInt64(buf);
              }
              throw new Error("Cannot construct UInt64 from given value");
            };
            /**
             * The JSON representation of a UInt64 object
             *
             * @returns a hex-string
             */ UInt64.prototype.toJSON = function () {
              return this.bytes.toString("hex").toUpperCase();
            };
            /**
             * Get the value of the UInt64
             *
             * @returns the number represented buy this.bytes
             */ UInt64.prototype.valueOf = function () {
              return this.bytes.readBigUInt64BE();
            };
            /**
             * Get the bytes representation of the UInt64 object
             *
             * @returns 8 bytes representing the UInt64
             */ UInt64.prototype.toBytes = function () {
              return this.bytes;
            };
            UInt64.width = 64 / 8; // 8
            UInt64.defaultUInt64 = new UInt64(Buffer.alloc(UInt64.width));
            return UInt64;
          })(uint_1.UInt);
          exports.UInt64 = UInt64;
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          "./uint": "cf0c96dbce08f026796864c0035bf86a"
        }
      ],
      "9bf579378d0e5d60f96209520092628b": [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("buffer").Buffer;
          var __extends =
            (this && this.__extends) ||
            (function () {
              var _extendStatics17 = function extendStatics(d, b) {
                _extendStatics17 =
                  Object.setPrototypeOf ||
                  (_instanceof({ __proto__: [] }, Array) &&
                    function (d, b) {
                      d.__proto__ = b;
                    }) ||
                  function (d, b) {
                    for (var p in b) {
                      if (b.hasOwnProperty(p)) d[p] = b[p];
                    }
                  };
                return _extendStatics17(d, b);
              };
              return function (d, b) {
                _extendStatics17(d, b);
                function __() {
                  this.constructor = d;
                }
                d.prototype =
                  b === null
                    ? Object.create(b)
                    : ((__.prototype = b.prototype), new __());
              };
            })();
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.UInt8 = void 0;
          var uint_1 = require("./uint");
          /**
           * Derived UInt class for serializing/deserializing 8 bit UInt
           */ var UInt8 = /** @class */ (function (_super) {
            __extends(UInt8, _super);
            function UInt8(bytes) {
              return (
                _super.call(
                  this,
                  bytes !== null && bytes !== void 0
                    ? bytes
                    : UInt8.defaultUInt8.bytes
                ) || this
              );
            }
            UInt8.fromParser = function (parser) {
              return new UInt8(parser.read(UInt8.width));
            };
            /**
             * Construct a UInt8 object from a number
             *
             * @param val UInt8 object or number
             */ UInt8.from = function (val) {
              if (_instanceof(val, UInt8)) {
                return val;
              }
              if (typeof val === "number") {
                var buf = Buffer.alloc(UInt8.width);
                buf.writeUInt8(val);
                return new UInt8(buf);
              }
              throw new Error("Cannot construct UInt8 from given value");
            };
            /**
             * get the value of a UInt8 object
             *
             * @returns the number represented by this.bytes
             */ UInt8.prototype.valueOf = function () {
              return this.bytes.readUInt8();
            };
            UInt8.width = 8 / 8; // 1
            UInt8.defaultUInt8 = new UInt8(Buffer.alloc(UInt8.width));
            return UInt8;
          })(uint_1.UInt);
          exports.UInt8 = UInt8;
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          "./uint": "cf0c96dbce08f026796864c0035bf86a"
        }
      ],
      "391c8b7a002cb7de229534282309addf": [
        function (require, module, exports) {
          "use strict";
          var __extends =
            (this && this.__extends) ||
            (function () {
              var _extendStatics18 = function extendStatics(d, b) {
                _extendStatics18 =
                  Object.setPrototypeOf ||
                  (_instanceof({ __proto__: [] }, Array) &&
                    function (d, b) {
                      d.__proto__ = b;
                    }) ||
                  function (d, b) {
                    for (var p in b) {
                      if (b.hasOwnProperty(p)) d[p] = b[p];
                    }
                  };
                return _extendStatics18(d, b);
              };
              return function (d, b) {
                _extendStatics18(d, b);
                function __() {
                  this.constructor = d;
                }
                d.prototype =
                  b === null
                    ? Object.create(b)
                    : ((__.prototype = b.prototype), new __());
              };
            })();
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.Vector256 = void 0;
          var serialized_type_1 = require("./serialized-type");
          var hash_256_1 = require("./hash-256");
          var binary_serializer_1 = require("../serdes/binary-serializer");
          /**
           * TypeGuard for Array<string>
           */ function isStrings(arg) {
            return (
              Array.isArray(arg) &&
              (arg.length === 0 || typeof arg[0] === "string")
            );
          }
          /**
           * Class for serializing and deserializing vectors of Hash256
           */ var Vector256 = /** @class */ (function (_super) {
            __extends(Vector256, _super);
            function Vector256(bytes) {
              return _super.call(this, bytes) || this;
            }
            /**
             * Construct a Vector256 from a BinaryParser
             *
             * @param parser BinaryParser to
             * @param hint length of the vector, in bytes, optional
             * @returns a Vector256 object
             */ Vector256.fromParser = function (parser, hint) {
              var bytesList = new binary_serializer_1.BytesList();
              var bytes = hint !== null && hint !== void 0 ? hint : parser.size();
              var hashes = bytes / 32;
              for (var i = 0; i < hashes; i++) {
                hash_256_1.Hash256.fromParser(parser).toBytesSink(bytesList);
              }
              return new Vector256(bytesList.toBytes());
            };
            /**
             * Construct a Vector256 object from an array of hashes
             *
             * @param value A Vector256 object or array of hex-strings representing Hash256's
             * @returns a Vector256 object
             */ Vector256.from = function (value) {
              if (_instanceof(value, Vector256)) {
                return value;
              }
              if (isStrings(value)) {
                var bytesList_1 = new binary_serializer_1.BytesList();
                value.forEach(function (hash) {
                  hash_256_1.Hash256.from(hash).toBytesSink(bytesList_1);
                });
                return new Vector256(bytesList_1.toBytes());
              }
              throw new Error("Cannot construct Vector256 from given value");
            };
            /**
             * Return an Array of hex-strings represented by this.bytes
             *
             * @returns An Array of strings representing the Hash256 objects
             */ Vector256.prototype.toJSON = function () {
              if (this.bytes.byteLength % 32 !== 0) {
                throw new Error("Invalid bytes for Vector256");
              }
              var result = [];
              for (var i = 0; i < this.bytes.byteLength; i += 32) {
                result.push(
                  this.bytes
                    .slice(i, i + 32)
                    .toString("hex")
                    .toUpperCase()
                );
              }
              return result;
            };
            return Vector256;
          })(serialized_type_1.SerializedType);
          exports.Vector256 = Vector256;
        },
        {
          "./serialized-type": "0f0f786f836b5aa515dc3100a1d71ee2",
          "./hash-256": "8dba9529a2980e9679fcb11337850744",
          "../serdes/binary-serializer": "abc1426ad32b9cb626ea24d137d353ef"
        }
      ],
      "235e4e3c6dabdad7fc149dc613c6a64d": [
        function (require, module, exports) {
          "use strict";
          /* eslint-disable func-style */ Object.defineProperty(
            exports,
            "__esModule",
            { value: true }
          );
          exports.transactionID = exports.sha512Half = exports.binaryToJSON = exports.signingClaimData = exports.signingData = exports.multiSigningData = exports.readJSON = exports.serializeObject = exports.makeParser = exports.BytesList = exports.BinarySerializer = exports.BinaryParser = void 0;
          var types_1 = require("./types");
          var binary_parser_1 = require("./serdes/binary-parser");
          Object.defineProperty(exports, "BinaryParser", {
            enumerable: true,
            get: function get() {
              return binary_parser_1.BinaryParser;
            }
          });
          var hash_prefixes_1 = require("./hash-prefixes");
          var binary_serializer_1 = require("./serdes/binary-serializer");
          Object.defineProperty(exports, "BinarySerializer", {
            enumerable: true,
            get: function get() {
              return binary_serializer_1.BinarySerializer;
            }
          });
          Object.defineProperty(exports, "BytesList", {
            enumerable: true,
            get: function get() {
              return binary_serializer_1.BytesList;
            }
          });
          var hashes_1 = require("./hashes");
          Object.defineProperty(exports, "sha512Half", {
            enumerable: true,
            get: function get() {
              return hashes_1.sha512Half;
            }
          });
          Object.defineProperty(exports, "transactionID", {
            enumerable: true,
            get: function get() {
              return hashes_1.transactionID;
            }
          });
          /**
           * Construct a BinaryParser
           *
           * @param bytes hex-string to construct BinaryParser from
           * @returns A BinaryParser
           */ var makeParser = function makeParser(bytes) {
            return new binary_parser_1.BinaryParser(bytes);
          };
          exports.makeParser = makeParser;
          /**
           * Parse BinaryParser into JSON
           *
           * @param parser BinaryParser object
           * @returns JSON for the bytes in the BinaryParser
           */ var readJSON = function readJSON(parser) {
            return parser.readType(types_1.coreTypes.STObject).toJSON();
          };
          exports.readJSON = readJSON;
          /**
           * Parse a hex-string into its JSON interpretation
           *
           * @param bytes hex-string to parse into JSON
           * @returns JSON
           */ var binaryToJSON = function binaryToJSON(bytes) {
            return readJSON(makeParser(bytes));
          };
          exports.binaryToJSON = binaryToJSON;
          /**
           * Function to serialize JSON object representing a transaction
           *
           * @param object JSON object to serialize
           * @param opts options for serializing, including optional prefix, suffix, and signingFieldOnly
           * @returns A Buffer containing the serialized object
           */ function serializeObject(object, opts) {
            if (opts === void 0) {
              opts = {};
            }
            var prefix = opts.prefix,
              suffix = opts.suffix,
              _a = opts.signingFieldsOnly,
              signingFieldsOnly = _a === void 0 ? false : _a;
            var bytesList = new binary_serializer_1.BytesList();
            if (prefix) {
              bytesList.put(prefix);
            }
            var filter = signingFieldsOnly
              ? function (f) {
                  return f.isSigningField;
                }
              : undefined;
            types_1.coreTypes.STObject.from(object, filter).toBytesSink(
              bytesList
            );
            if (suffix) {
              bytesList.put(suffix);
            }
            return bytesList.toBytes();
          }
          exports.serializeObject = serializeObject;
          /**
           * Serialize an object for signing
           *
           * @param transaction Transaction to serialize
           * @param prefix Prefix bytes to put before the serialized object
           * @returns A Buffer with the serialized object
           */ function signingData(transaction, prefix) {
            if (prefix === void 0) {
              prefix = hash_prefixes_1.HashPrefix.transactionSig;
            }
            return serializeObject(transaction, {
              prefix: prefix,
              signingFieldsOnly: true
            });
          }
          exports.signingData = signingData;
          /**
           * Serialize a signingClaim
           *
           * @param claim A claim object to serialize
           * @returns the serialized object with appropriate prefix
           */ function signingClaimData(claim) {
            var prefix = hash_prefixes_1.HashPrefix.paymentChannelClaim;
            var channel = types_1.coreTypes.Hash256.from(claim.channel).toBytes();
            var amount = types_1.coreTypes.UInt64.from(
              BigInt(claim.amount)
            ).toBytes();
            var bytesList = new binary_serializer_1.BytesList();
            bytesList.put(prefix);
            bytesList.put(channel);
            bytesList.put(amount);
            return bytesList.toBytes();
          }
          exports.signingClaimData = signingClaimData;
          /**
           * Serialize a transaction object for multiSigning
           *
           * @param transaction transaction to serialize
           * @param signingAccount Account to sign the transaction with
           * @returns serialized transaction with appropriate prefix and suffix
           */ function multiSigningData(transaction, signingAccount) {
            var prefix = hash_prefixes_1.HashPrefix.transactionMultiSig;
            var suffix = types_1.coreTypes.AccountID.from(
              signingAccount
            ).toBytes();
            return serializeObject(transaction, {
              prefix: prefix,
              suffix: suffix,
              signingFieldsOnly: true
            });
          }
          exports.multiSigningData = multiSigningData;
        },
        {
          "./types": "2f5058ac620289ba00afd2d63dec38ff",
          "./serdes/binary-parser": "b815b18e9842bed3b7f351e097aea11a",
          "./hash-prefixes": "278aa5cba36abaadc3cd0043382a9cc0",
          "./serdes/binary-serializer": "abc1426ad32b9cb626ea24d137d353ef",
          "./hashes": "591b92021ceaddc947db9b773fc52b5b"
        }
      ],
      "278aa5cba36abaadc3cd0043382a9cc0": [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("buffer").Buffer;
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.HashPrefix = void 0;
          /**
           * Write a 32 bit integer to a Buffer
           *
           * @param uint32 32 bit integer to write to buffer
           * @returns a buffer with the bytes representation of uint32
           */ function bytes(uint32) {
            var result = Buffer.alloc(4);
            result.writeUInt32BE(uint32);
            return result;
          }
          /**
           * Maps HashPrefix names to their byte representation
           */ var HashPrefix = {
            transactionID: bytes(0x54584e00), // transaction plus metadata
            transaction: bytes(0x534e4400), // account state
            accountStateEntry: bytes(0x4d4c4e00), // inner node in tree
            innerNode: bytes(0x4d494e00), // ledger master data for signing
            ledgerHeader: bytes(0x4c575200), // inner transaction to sign
            transactionSig: bytes(0x53545800), // inner transaction to sign
            transactionMultiSig: bytes(0x534d5400), // validation for signing
            validation: bytes(0x56414c00), // proposal for signing
            proposal: bytes(0x50525000), // payment channel claim
            paymentChannelClaim: bytes(0x434c4d00)
          };
          exports.HashPrefix = HashPrefix;
        },
        { buffer: "1948b2a05a083f82087512f711e79e4d" }
      ],
      "591b92021ceaddc947db9b773fc52b5b": [
        function (require, module, exports) {
          "use strict";
          var __extends =
            (this && this.__extends) ||
            (function () {
              var _extendStatics19 = function extendStatics(d, b) {
                _extendStatics19 =
                  Object.setPrototypeOf ||
                  (_instanceof({ __proto__: [] }, Array) &&
                    function (d, b) {
                      d.__proto__ = b;
                    }) ||
                  function (d, b) {
                    for (var p in b) {
                      if (b.hasOwnProperty(p)) d[p] = b[p];
                    }
                  };
                return _extendStatics19(d, b);
              };
              return function (d, b) {
                _extendStatics19(d, b);
                function __() {
                  this.constructor = d;
                }
                d.prototype =
                  b === null
                    ? Object.create(b)
                    : ((__.prototype = b.prototype), new __());
              };
            })();
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.transactionID = exports.sha512Half = exports.Sha512Half = void 0;
          var hash_prefixes_1 = require("./hash-prefixes");
          var createHash = require("create-hash");
          var hash_256_1 = require("./types/hash-256");
          var binary_serializer_1 = require("./serdes/binary-serializer");
          /**
           * Class for hashing with SHA512
           * @extends BytesList So SerializedTypes can write bytes to a Sha512Half
           */ var Sha512Half = /** @class */ (function (_super) {
            __extends(Sha512Half, _super);
            function Sha512Half() {
              var _this =
                (_super !== null && _super.apply(this, arguments)) || this;
              _this.hash = createHash("sha512");
              return _this;
            }
            /**
             * Construct a new Sha512Hash and write bytes this.hash
             *
             * @param bytes bytes to write to this.hash
             * @returns the new Sha512Hash object
             */ Sha512Half.put = function (bytes) {
              return new Sha512Half().put(bytes);
            };
            /**
             * Write bytes to an existing Sha512Hash
             *
             * @param bytes bytes to write to object
             * @returns the Sha512 object
             */ Sha512Half.prototype.put = function (bytes) {
              this.hash.update(bytes);
              return this;
            };
            /**
             * Compute SHA512 hash and slice in half
             *
             * @returns half of a SHA512 hash
             */ Sha512Half.prototype.finish256 = function () {
              var bytes = this.hash.digest();
              return bytes.slice(0, 32);
            };
            /**
             * Constructs a Hash256 from the Sha512Half object
             *
             * @returns a Hash256 object
             */ Sha512Half.prototype.finish = function () {
              return new hash_256_1.Hash256(this.finish256());
            };
            return Sha512Half;
          })(binary_serializer_1.BytesList);
          exports.Sha512Half = Sha512Half;
          /**
           * compute SHA512 hash of a list of bytes
           *
           * @param args zero or more arguments to hash
           * @returns the sha512half hash of the arguments.
           */ function sha512Half() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            var hash = new Sha512Half();
            args.forEach(function (a) {
              return hash.put(a);
            });
            return hash.finish256();
          }
          exports.sha512Half = sha512Half;
          /**
           * Construct a transactionID from a Serialized Transaction
           *
           * @param serialized bytes to hash
           * @returns a Hash256 object
           */ function transactionID(serialized) {
            return new hash_256_1.Hash256(
              sha512Half(hash_prefixes_1.HashPrefix.transactionID, serialized)
            );
          }
          exports.transactionID = transactionID;
        },
        {
          "./hash-prefixes": "278aa5cba36abaadc3cd0043382a9cc0",
          "create-hash": "b705fb93268134befc4305132ca33648",
          "./types/hash-256": "8dba9529a2980e9679fcb11337850744",
          "./serdes/binary-serializer": "abc1426ad32b9cb626ea24d137d353ef"
        }
      ],
      "6db0b113dbcf6a9e61cddb46f9d3cc2c": [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("buffer").Buffer;
          var __extends =
            (this && this.__extends) ||
            (function () {
              var _extendStatics20 = function extendStatics(d, b) {
                _extendStatics20 =
                  Object.setPrototypeOf ||
                  (_instanceof({ __proto__: [] }, Array) &&
                    function (d, b) {
                      d.__proto__ = b;
                    }) ||
                  function (d, b) {
                    for (var p in b) {
                      if (b.hasOwnProperty(p)) d[p] = b[p];
                    }
                  };
                return _extendStatics20(d, b);
              };
              return function (d, b) {
                _extendStatics20(d, b);
                function __() {
                  this.constructor = d;
                }
                d.prototype =
                  b === null
                    ? Object.create(b)
                    : ((__.prototype = b.prototype), new __());
              };
            })();
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.ShaMapLeaf = exports.ShaMapNode = exports.ShaMap = void 0;
          var assert_1 = require("assert");
          var types_1 = require("./types");
          var hash_prefixes_1 = require("./hash-prefixes");
          var hashes_1 = require("./hashes");
          /**
           * Abstract class describing a SHAMapNode
           */ var ShaMapNode = /** @class */ (function () {
            function ShaMapNode() {}
            return ShaMapNode;
          })();
          exports.ShaMapNode = ShaMapNode;
          /**
           * Class describing a Leaf of SHAMap
           */ var ShaMapLeaf = /** @class */ (function (_super) {
            __extends(ShaMapLeaf, _super);
            function ShaMapLeaf(index, item) {
              var _this = _super.call(this) || this;
              _this.index = index;
              _this.item = item;
              return _this;
            }
            /**
             * @returns true as ShaMapLeaf is a leaf node
             */ ShaMapLeaf.prototype.isLeaf = function () {
              return true;
            };
            /**
             * @returns false as ShaMapLeaf is not an inner node
             */ ShaMapLeaf.prototype.isInner = function () {
              return false;
            };
            /**
             * Get the prefix of the this.item
             *
             * @returns The hash prefix, unless this.item is undefined, then it returns an empty Buffer
             */ ShaMapLeaf.prototype.hashPrefix = function () {
              return this.item === undefined
                ? Buffer.alloc(0)
                : this.item.hashPrefix();
            };
            /**
             * Hash the bytes representation of this
             *
             * @returns hash of this.item concatenated with this.index
             */ ShaMapLeaf.prototype.hash = function () {
              var hash = hashes_1.Sha512Half.put(this.hashPrefix());
              this.toBytesSink(hash);
              return hash.finish();
            };
            /**
             * Write the bytes representation of this to a BytesList
             * @param list BytesList to write bytes to
             */ ShaMapLeaf.prototype.toBytesSink = function (list) {
              if (this.item !== undefined) {
                this.item.toBytesSink(list);
              }
              this.index.toBytesSink(list);
            };
            return ShaMapLeaf;
          })(ShaMapNode);
          exports.ShaMapLeaf = ShaMapLeaf;
          /**
           * Class defining an Inner Node of a SHAMap
           */ var ShaMapInner = /** @class */ (function (_super) {
            __extends(ShaMapInner, _super);
            function ShaMapInner(depth) {
              if (depth === void 0) {
                depth = 0;
              }
              var _this = _super.call(this) || this;
              _this.depth = depth;
              _this.slotBits = 0;
              _this.branches = Array(16);
              return _this;
            }
            /**
             * @returns true as ShaMapInner is an inner node
             */ ShaMapInner.prototype.isInner = function () {
              return true;
            };
            /**
             * @returns false as ShaMapInner is not a leaf node
             */ ShaMapInner.prototype.isLeaf = function () {
              return false;
            };
            /**
             * Get the hash prefix for this node
             *
             * @returns hash prefix describing an inner node
             */ ShaMapInner.prototype.hashPrefix = function () {
              return hash_prefixes_1.HashPrefix.innerNode;
            };
            /**
             * Set a branch of this node to be another node
             *
             * @param slot Slot to add branch to this.branches
             * @param branch Branch to add
             */ ShaMapInner.prototype.setBranch = function (slot, branch) {
              this.slotBits = this.slotBits | (1 << slot);
              this.branches[slot] = branch;
            };
            /**
             * @returns true if node is empty
             */ ShaMapInner.prototype.empty = function () {
              return this.slotBits === 0;
            };
            /**
             * Compute the hash of this node
             *
             * @returns The hash of this node
             */ ShaMapInner.prototype.hash = function () {
              if (this.empty()) {
                return types_1.coreTypes.Hash256.ZERO_256;
              }
              var hash = hashes_1.Sha512Half.put(this.hashPrefix());
              this.toBytesSink(hash);
              return hash.finish();
            };
            /**
             * Writes the bytes representation of this node to a BytesList
             *
             * @param list BytesList to write bytes to
             */ ShaMapInner.prototype.toBytesSink = function (list) {
              for (var i = 0; i < this.branches.length; i++) {
                var branch = this.branches[i];
                var hash = branch
                  ? branch.hash()
                  : types_1.coreTypes.Hash256.ZERO_256;
                hash.toBytesSink(list);
              }
            };
            /**
             * Add item to the SHAMap
             *
             * @param index Hash of the index of the item being inserted
             * @param item Item to insert in the map
             * @param leaf Leaf node to insert when branch doesn't exist
             */ ShaMapInner.prototype.addItem = function (index, item, leaf) {
              assert_1.strict(index !== undefined);
              var nibble = index.nibblet(this.depth);
              var existing = this.branches[nibble];
              if (existing === undefined) {
                this.setBranch(nibble, leaf || new ShaMapLeaf(index, item));
              } else if (_instanceof(existing, ShaMapLeaf)) {
                var newInner = new ShaMapInner(this.depth + 1);
                newInner.addItem(existing.index, undefined, existing);
                newInner.addItem(index, item, leaf);
                this.setBranch(nibble, newInner);
              } else if (_instanceof(existing, ShaMapInner)) {
                existing.addItem(index, item, leaf);
              } else {
                throw new Error("invalid ShaMap.addItem call");
              }
            };
            return ShaMapInner;
          })(ShaMapNode);
          var ShaMap = /** @class */ (function (_super) {
            __extends(ShaMap, _super);
            function ShaMap() {
              return (_super !== null && _super.apply(this, arguments)) || this;
            }
            return ShaMap;
          })(ShaMapInner);
          exports.ShaMap = ShaMap;
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          assert: "cdcb67ab5f6acbeabe6d878ee73d6e25",
          "./types": "2f5058ac620289ba00afd2d63dec38ff",
          "./hash-prefixes": "278aa5cba36abaadc3cd0043382a9cc0",
          "./hashes": "591b92021ceaddc947db9b773fc52b5b"
        }
      ],
      "8409c82d684e65900f24b69e56e3520e": [
        function (require, module, exports) {
          "use strict";
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.decodeLedgerData = exports.ledgerHash = exports.transactionTreeHash = exports.accountStateHash = void 0;
          var assert = require("assert");
          var shamap_1 = require("./shamap");
          var hash_prefixes_1 = require("./hash-prefixes");
          var hashes_1 = require("./hashes");
          var binary_1 = require("./binary");
          var hash_256_1 = require("./types/hash-256");
          var st_object_1 = require("./types/st-object");
          var uint_64_1 = require("./types/uint-64");
          var uint_32_1 = require("./types/uint-32");
          var uint_8_1 = require("./types/uint-8");
          var binary_parser_1 = require("./serdes/binary-parser");
          /**
           * Computes the hash of a list of objects
           *
           * @param itemizer Converts an item into a format that can be added to SHAMap
           * @param itemsJson Array of items to add to a SHAMap
           * @returns the hash of the SHAMap
           */ function computeHash(itemizer, itemsJson) {
            var map = new shamap_1.ShaMap();
            itemsJson.forEach(function (item) {
              return map.addItem.apply(map, itemizer(item));
            });
            return map.hash();
          }
          /**
           * Convert a transaction into an index and an item
           *
           * @param json transaction with metadata
           * @returns a tuple of index and item to be added to SHAMap
           */ function transactionItemizer(json) {
            assert(json.hash);
            var index = hash_256_1.Hash256.from(json.hash);
            var item = {
              hashPrefix: function hashPrefix() {
                return hash_prefixes_1.HashPrefix.transaction;
              },
              toBytesSink: function toBytesSink(sink) {
                var serializer = new binary_1.BinarySerializer(sink);
                serializer.writeLengthEncoded(st_object_1.STObject.from(json));
                serializer.writeLengthEncoded(
                  st_object_1.STObject.from(json.metaData)
                );
              }
            };
            return [index, item, undefined];
          }
          /**
           * Convert an entry to a pair Hash256 and ShaMapNode
           *
           * @param json JSON describing a ledger entry item
           * @returns a tuple of index and item to be added to SHAMap
           */ function entryItemizer(json) {
            var index = hash_256_1.Hash256.from(json.index);
            var bytes = binary_1.serializeObject(json);
            var item = {
              hashPrefix: function hashPrefix() {
                return hash_prefixes_1.HashPrefix.accountStateEntry;
              },
              toBytesSink: function toBytesSink(sink) {
                sink.put(bytes);
              }
            };
            return [index, item, undefined];
          }
          /**
           * Function computing the hash of a transaction tree
           *
           * @param param An array of transaction objects to hash
           * @returns A Hash256 object
           */ function transactionTreeHash(param) {
            var itemizer = transactionItemizer;
            return computeHash(itemizer, param);
          }
          exports.transactionTreeHash = transactionTreeHash;
          /**
           * Function computing the hash of accountState
           *
           * @param param A list of accountStates hash
           * @returns A Hash256 object
           */ function accountStateHash(param) {
            var itemizer = entryItemizer;
            return computeHash(itemizer, param);
          }
          exports.accountStateHash = accountStateHash;
          /**
           * Serialize and hash a ledger header
           *
           * @param header a ledger header
           * @returns the hash of header
           */ function ledgerHash(header) {
            var hash = new hashes_1.Sha512Half();
            hash.put(hash_prefixes_1.HashPrefix.ledgerHeader);
            assert(header.parent_close_time !== undefined);
            assert(header.close_flags !== undefined);
            uint_32_1.UInt32.from(header.ledger_index).toBytesSink(hash);
            uint_64_1.UInt64.from(BigInt(header.total_coins)).toBytesSink(hash);
            hash_256_1.Hash256.from(header.parent_hash).toBytesSink(hash);
            hash_256_1.Hash256.from(header.transaction_hash).toBytesSink(hash);
            hash_256_1.Hash256.from(header.account_hash).toBytesSink(hash);
            uint_32_1.UInt32.from(header.parent_close_time).toBytesSink(hash);
            uint_32_1.UInt32.from(header.close_time).toBytesSink(hash);
            uint_8_1.UInt8.from(header.close_time_resolution).toBytesSink(hash);
            uint_8_1.UInt8.from(header.close_flags).toBytesSink(hash);
            return hash.finish();
          }
          exports.ledgerHash = ledgerHash;
          /**
           * Decodes a serialized ledger header
           *
           * @param binary A serialized ledger header
           * @returns A JSON object describing a ledger header
           */ function decodeLedgerData(binary) {
            assert(typeof binary === "string", "binary must be a hex string");
            var parser = new binary_parser_1.BinaryParser(binary);
            return {
              ledger_index: parser.readUInt32(),
              total_coins: parser.readType(uint_64_1.UInt64).valueOf().toString(),
              parent_hash: parser.readType(hash_256_1.Hash256).toHex(),
              transaction_hash: parser.readType(hash_256_1.Hash256).toHex(),
              account_hash: parser.readType(hash_256_1.Hash256).toHex(),
              parent_close_time: parser.readUInt32(),
              close_time: parser.readUInt32(),
              close_time_resolution: parser.readUInt8(),
              close_flags: parser.readUInt8()
            };
          }
          exports.decodeLedgerData = decodeLedgerData;
        },
        {
          assert: "cdcb67ab5f6acbeabe6d878ee73d6e25",
          "./shamap": "6db0b113dbcf6a9e61cddb46f9d3cc2c",
          "./hash-prefixes": "278aa5cba36abaadc3cd0043382a9cc0",
          "./hashes": "591b92021ceaddc947db9b773fc52b5b",
          "./binary": "235e4e3c6dabdad7fc149dc613c6a64d",
          "./types/hash-256": "8dba9529a2980e9679fcb11337850744",
          "./types/st-object": "448eadfe0b180c0a569a829367a9ee86",
          "./types/uint-64": "90902fad86c60ac44e4a4d8edccf01e2",
          "./types/uint-32": "3c53eeba0cbce1f6d03a34e1ea1cd745",
          "./types/uint-8": "9bf579378d0e5d60f96209520092628b",
          "./serdes/binary-parser": "b815b18e9842bed3b7f351e097aea11a"
        }
      ],
      f51f94f12f45486b6b6bb709aef787a3: [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("buffer").Buffer;
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.quality = void 0;
          var types_1 = require("./types");
          var decimal_js_1 = require("decimal.js");
          /**
           * class for encoding and decoding quality
           */ var quality = /** @class */ (function () {
            function quality() {}
            /**
             * Encode quality amount
             *
             * @param arg string representation of an amount
             * @returns Serialized quality
             */ quality.encode = function (quality) {
              var decimal = new decimal_js_1.Decimal(quality);
              var exponent = decimal.e - 15;
              var qualityString = decimal
                .times("1e" + -exponent)
                .abs()
                .toString();
              var bytes = types_1.coreTypes.UInt64.from(
                BigInt(qualityString)
              ).toBytes();
              bytes[0] = exponent + 100;
              return bytes;
            };
            /**
             * Decode quality amount
             *
             * @param arg hex-string denoting serialized quality
             * @returns deserialized quality
             */ quality.decode = function (quality) {
              var bytes = Buffer.from(quality, "hex").slice(-8);
              var exponent = bytes[0] - 100;
              var mantissa = new decimal_js_1.Decimal(
                "0x" + bytes.slice(1).toString("hex")
              );
              return mantissa.times("1e" + exponent);
            };
            return quality;
          })();
          exports.quality = quality;
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          "./types": "2f5058ac620289ba00afd2d63dec38ff",
          "decimal.js": "bb8d63dce57b0b8153f6eda922ddbc97"
        }
      ],
      fd317075df46e2c62116d9e3725a3f9c: [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("buffer").Buffer;
          var assert = require("assert");
          var brorand = require("brorand");
          var hashjs = require("hash.js");
          var elliptic = require("elliptic");
          var addressCodec = require("ripple-address-codec");
          var secp256k1_1 = require("./secp256k1");
          var utils = require("./utils");
          var Ed25519 = elliptic.eddsa("ed25519");
          var Secp256k1 = elliptic.ec("secp256k1");
          var hexToBytes = utils.hexToBytes;
          var bytesToHex = utils.bytesToHex;
          function generateSeed() {
            var options =
              arguments.length > 0 && arguments[0] !== undefined
                ? arguments[0]
                : {};
            assert(
              !options.entropy || options.entropy.length >= 16,
              "entropy too short"
            );
            var entropy = options.entropy
              ? options.entropy.slice(0, 16)
              : brorand(16);
            var type = options.algorithm === "ed25519" ? "ed25519" : "secp256k1";
            return addressCodec.encodeSeed(entropy, type);
          }
          function hash(message) {
            return hashjs.sha512().update(message).digest().slice(0, 32);
          }
          var secp256k1 = {
            deriveKeypair: function deriveKeypair(entropy, options) {
              var prefix = "00";
              var privateKey =
                prefix +
                secp256k1_1
                  .derivePrivateKey(entropy, options)
                  .toString(16, 64)
                  .toUpperCase();
              var publicKey = bytesToHex(
                Secp256k1.keyFromPrivate(privateKey.slice(2))
                  .getPublic()
                  .encodeCompressed()
              );
              return { privateKey: privateKey, publicKey: publicKey };
            },
            sign: function sign(message, privateKey) {
              return bytesToHex(
                Secp256k1.sign(hash(message), hexToBytes(privateKey), {
                  canonical: true
                }).toDER()
              );
            },
            verify: function verify(message, signature, publicKey) {
              return Secp256k1.verify(
                hash(message),
                signature,
                hexToBytes(publicKey)
              );
            }
          };
          var ed25519 = {
            deriveKeypair: function deriveKeypair(entropy) {
              var prefix = "ED";
              var rawPrivateKey = hash(entropy);
              var privateKey = prefix + bytesToHex(rawPrivateKey);
              var publicKey =
                prefix +
                bytesToHex(Ed25519.keyFromSecret(rawPrivateKey).pubBytes());
              return { privateKey: privateKey, publicKey: publicKey };
            },
            sign: function sign(message, privateKey) {
              // caution: Ed25519.sign interprets all strings as hex, stripping
              // any non-hex characters without warning
              assert(Array.isArray(message), "message must be array of octets");
              return bytesToHex(
                Ed25519.sign(message, hexToBytes(privateKey).slice(1)).toBytes()
              );
            },
            verify: function verify(message, signature, publicKey) {
              return Ed25519.verify(
                message,
                hexToBytes(signature),
                hexToBytes(publicKey).slice(1)
              );
            }
          }; // eslint-disable-next-line @typescript-eslint/no-explicit-any
          function select(algorithm) {
            var methods = { "ecdsa-secp256k1": secp256k1, ed25519: ed25519 };
            return methods[algorithm];
          }
          function deriveKeypair(seed, options) {
            var decoded = addressCodec.decodeSeed(seed);
            var algorithm =
              decoded.type === "ed25519" ? "ed25519" : "ecdsa-secp256k1";
            var method = select(algorithm);
            var keypair = method.deriveKeypair(decoded.bytes, options);
            var messageToVerify = hash("This test message should verify.");
            var signature = method.sign(messageToVerify, keypair.privateKey);
            /* istanbul ignore if */ if (
              method.verify(messageToVerify, signature, keypair.publicKey) !==
              true
            ) {
              throw new Error(
                "derived keypair did not generate verifiable signature"
              );
            }
            return keypair;
          }
          function getAlgorithmFromKey(key) {
            var bytes = hexToBytes(key);
            return bytes.length === 33 && bytes[0] === 0xed
              ? "ed25519"
              : "ecdsa-secp256k1";
          }
          function sign(messageHex, privateKey) {
            var algorithm = getAlgorithmFromKey(privateKey);
            return select(algorithm).sign(hexToBytes(messageHex), privateKey);
          }
          function verify(messageHex, signature, publicKey) {
            var algorithm = getAlgorithmFromKey(publicKey);
            return select(algorithm).verify(
              hexToBytes(messageHex),
              signature,
              publicKey
            );
          }
          function deriveAddressFromBytes(publicKeyBytes) {
            return addressCodec.encodeAccountID(
              utils.computePublicKeyHash(publicKeyBytes)
            );
          }
          function deriveAddress(publicKey) {
            return deriveAddressFromBytes(Buffer.from(hexToBytes(publicKey)));
          }
          function deriveNodeAddress(publicKey) {
            var generatorBytes = addressCodec.decodeNodePublic(publicKey);
            var accountPublicBytes = secp256k1_1.accountPublicFromPublicGenerator(
              generatorBytes
            );
            return deriveAddressFromBytes(accountPublicBytes);
          }
          var decodeSeed = addressCodec.decodeSeed;
          module.exports = {
            generateSeed: generateSeed,
            deriveKeypair: deriveKeypair,
            sign: sign,
            verify: verify,
            deriveAddress: deriveAddress,
            deriveNodeAddress: deriveNodeAddress,
            decodeSeed: decodeSeed
          };
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          assert: "cdcb67ab5f6acbeabe6d878ee73d6e25",
          brorand: "46819616b5df61c964cabc43a2ab8054",
          "hash.js": "f3fe44fc9be3d13b9d8db7c3873f780d",
          elliptic: "03672d91cbe66f4a302b8d456a7d55ca",
          "ripple-address-codec": "371ff8c84e04afd24921f37bc92aa65b",
          "./secp256k1": "78db6cdcffd73f2e39fe879a4de609d0",
          "./utils": "efcfa6e673395ff8937c669c309d3b30"
        }
      ],
      "46819616b5df61c964cabc43a2ab8054": [
        function (require, module, exports) {
          var r;
          module.exports = function rand(len) {
            if (!r) r = new Rand(null);
            return r.generate(len);
          };
          function Rand(rand) {
            this.rand = rand;
          }
          module.exports.Rand = Rand;
          Rand.prototype.generate = function generate(len) {
            return this._rand(len);
          }; // Emulate crypto API using randy
          Rand.prototype._rand = function _rand(n) {
            if (this.rand.getBytes) return this.rand.getBytes(n);
            var res = new Uint8Array(n);
            for (var i = 0; i < res.length; i++) {
              res[i] = this.rand.getByte();
            }
            return res;
          };
          if (
            (typeof self === "undefined" ? "undefined" : _typeof2(self)) ===
            "object"
          ) {
            if (self.crypto && self.crypto.getRandomValues) {
              // Modern browsers
              Rand.prototype._rand = function _rand(n) {
                var arr = new Uint8Array(n);
                self.crypto.getRandomValues(arr);
                return arr;
              };
            } else if (self.msCrypto && self.msCrypto.getRandomValues) {
              // IE
              Rand.prototype._rand = function _rand(n) {
                var arr = new Uint8Array(n);
                self.msCrypto.getRandomValues(arr);
                return arr;
              }; // Safari's WebWorkers do not have `crypto`
            } else if (
              (typeof window === "undefined" ? "undefined" : _typeof2(window)) ===
              "object"
            ) {
              // Old junk
              Rand.prototype._rand = function () {
                throw new Error("Not implemented yet");
              };
            }
          } else {
            // Node.js or Web worker with no crypto support
            try {
              var crypto = require("crypto");
              if (typeof crypto.randomBytes !== "function")
                throw new Error("Not supported");
              Rand.prototype._rand = function _rand(n) {
                return crypto.randomBytes(n);
              };
            } catch (e) {}
          }
        },
        { crypto: "83fb80501e6599b7f0cf455c47cd5c1a" }
      ],
      f3fe44fc9be3d13b9d8db7c3873f780d: [
        function (require, module, exports) {
          var hash = exports;
          hash.utils = require("./hash/utils");
          hash.common = require("./hash/common");
          hash.sha = require("./hash/sha");
          hash.ripemd = require("./hash/ripemd");
          hash.hmac = require("./hash/hmac"); // Proxy hash functions to the main object
          hash.sha1 = hash.sha.sha1;
          hash.sha256 = hash.sha.sha256;
          hash.sha224 = hash.sha.sha224;
          hash.sha384 = hash.sha.sha384;
          hash.sha512 = hash.sha.sha512;
          hash.ripemd160 = hash.ripemd.ripemd160;
        },
        {
          "./hash/utils": "2f7a1cec0f9d16ad9388ae00bba0ed41",
          "./hash/common": "6bb17ce3c5d193b5628901cb672f702e",
          "./hash/sha": "5b1fdf52b7893f1731618620690fe8fd",
          "./hash/ripemd": "5791768b3ac26542c60769410206a75e",
          "./hash/hmac": "92a71c791fb06acc94ae9e1bb0103cac"
        }
      ],
      "2f7a1cec0f9d16ad9388ae00bba0ed41": [
        function (require, module, exports) {
          "use strict";
          var assert = require("minimalistic-assert");
          var inherits = require("inherits");
          exports.inherits = inherits;
          function isSurrogatePair(msg, i) {
            if ((msg.charCodeAt(i) & 0xfc00) !== 0xd800) {
              return false;
            }
            if (i < 0 || i + 1 >= msg.length) {
              return false;
            }
            return (msg.charCodeAt(i + 1) & 0xfc00) === 0xdc00;
          }
          function toArray(msg, enc) {
            if (Array.isArray(msg)) return msg.slice();
            if (!msg) return [];
            var res = [];
            if (typeof msg === "string") {
              if (!enc) {
                // Inspired by stringToUtf8ByteArray() in closure-library by Google
                // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
                // Apache License 2.0
                // https://github.com/google/closure-library/blob/master/LICENSE
                var p = 0;
                for (var i = 0; i < msg.length; i++) {
                  var c = msg.charCodeAt(i);
                  if (c < 128) {
                    res[p++] = c;
                  } else if (c < 2048) {
                    res[p++] = (c >> 6) | 192;
                    res[p++] = (c & 63) | 128;
                  } else if (isSurrogatePair(msg, i)) {
                    c =
                      0x10000 +
                      ((c & 0x03ff) << 10) +
                      (msg.charCodeAt(++i) & 0x03ff);
                    res[p++] = (c >> 18) | 240;
                    res[p++] = ((c >> 12) & 63) | 128;
                    res[p++] = ((c >> 6) & 63) | 128;
                    res[p++] = (c & 63) | 128;
                  } else {
                    res[p++] = (c >> 12) | 224;
                    res[p++] = ((c >> 6) & 63) | 128;
                    res[p++] = (c & 63) | 128;
                  }
                }
              } else if (enc === "hex") {
                msg = msg.replace(/[^a-z0-9]+/gi, "");
                if (msg.length % 2 !== 0) msg = "0" + msg;
                for (i = 0; i < msg.length; i += 2) {
                  res.push(parseInt(msg[i] + msg[i + 1], 16));
                }
              }
            } else {
              for (i = 0; i < msg.length; i++) {
                res[i] = msg[i] | 0;
              }
            }
            return res;
          }
          exports.toArray = toArray;
          function toHex(msg) {
            var res = "";
            for (var i = 0; i < msg.length; i++) {
              res += zero2(msg[i].toString(16));
            }
            return res;
          }
          exports.toHex = toHex;
          function htonl(w) {
            var res =
              (w >>> 24) |
              ((w >>> 8) & 0xff00) |
              ((w << 8) & 0xff0000) |
              ((w & 0xff) << 24);
            return res >>> 0;
          }
          exports.htonl = htonl;
          function toHex32(msg, endian) {
            var res = "";
            for (var i = 0; i < msg.length; i++) {
              var w = msg[i];
              if (endian === "little") w = htonl(w);
              res += zero8(w.toString(16));
            }
            return res;
          }
          exports.toHex32 = toHex32;
          function zero2(word) {
            if (word.length === 1) return "0" + word;
            else return word;
          }
          exports.zero2 = zero2;
          function zero8(word) {
            if (word.length === 7) return "0" + word;
            else if (word.length === 6) return "00" + word;
            else if (word.length === 5) return "000" + word;
            else if (word.length === 4) return "0000" + word;
            else if (word.length === 3) return "00000" + word;
            else if (word.length === 2) return "000000" + word;
            else if (word.length === 1) return "0000000" + word;
            else return word;
          }
          exports.zero8 = zero8;
          function join32(msg, start, end, endian) {
            var len = end - start;
            assert(len % 4 === 0);
            var res = new Array(len / 4);
            for (var i = 0, k = start; i < res.length; i++, k += 4) {
              var w;
              if (endian === "big")
                w =
                  (msg[k] << 24) |
                  (msg[k + 1] << 16) |
                  (msg[k + 2] << 8) |
                  msg[k + 3];
              else
                w =
                  (msg[k + 3] << 24) |
                  (msg[k + 2] << 16) |
                  (msg[k + 1] << 8) |
                  msg[k];
              res[i] = w >>> 0;
            }
            return res;
          }
          exports.join32 = join32;
          function split32(msg, endian) {
            var res = new Array(msg.length * 4);
            for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
              var m = msg[i];
              if (endian === "big") {
                res[k] = m >>> 24;
                res[k + 1] = (m >>> 16) & 0xff;
                res[k + 2] = (m >>> 8) & 0xff;
                res[k + 3] = m & 0xff;
              } else {
                res[k + 3] = m >>> 24;
                res[k + 2] = (m >>> 16) & 0xff;
                res[k + 1] = (m >>> 8) & 0xff;
                res[k] = m & 0xff;
              }
            }
            return res;
          }
          exports.split32 = split32;
          function rotr32(w, b) {
            return (w >>> b) | (w << (32 - b));
          }
          exports.rotr32 = rotr32;
          function rotl32(w, b) {
            return (w << b) | (w >>> (32 - b));
          }
          exports.rotl32 = rotl32;
          function sum32(a, b) {
            return (a + b) >>> 0;
          }
          exports.sum32 = sum32;
          function sum32_3(a, b, c) {
            return (a + b + c) >>> 0;
          }
          exports.sum32_3 = sum32_3;
          function sum32_4(a, b, c, d) {
            return (a + b + c + d) >>> 0;
          }
          exports.sum32_4 = sum32_4;
          function sum32_5(a, b, c, d, e) {
            return (a + b + c + d + e) >>> 0;
          }
          exports.sum32_5 = sum32_5;
          function sum64(buf, pos, ah, al) {
            var bh = buf[pos];
            var bl = buf[pos + 1];
            var lo = (al + bl) >>> 0;
            var hi = (lo < al ? 1 : 0) + ah + bh;
            buf[pos] = hi >>> 0;
            buf[pos + 1] = lo;
          }
          exports.sum64 = sum64;
          function sum64_hi(ah, al, bh, bl) {
            var lo = (al + bl) >>> 0;
            var hi = (lo < al ? 1 : 0) + ah + bh;
            return hi >>> 0;
          }
          exports.sum64_hi = sum64_hi;
          function sum64_lo(ah, al, bh, bl) {
            var lo = al + bl;
            return lo >>> 0;
          }
          exports.sum64_lo = sum64_lo;
          function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
            var carry = 0;
            var lo = al;
            lo = (lo + bl) >>> 0;
            carry += lo < al ? 1 : 0;
            lo = (lo + cl) >>> 0;
            carry += lo < cl ? 1 : 0;
            lo = (lo + dl) >>> 0;
            carry += lo < dl ? 1 : 0;
            var hi = ah + bh + ch + dh + carry;
            return hi >>> 0;
          }
          exports.sum64_4_hi = sum64_4_hi;
          function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
            var lo = al + bl + cl + dl;
            return lo >>> 0;
          }
          exports.sum64_4_lo = sum64_4_lo;
          function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
            var carry = 0;
            var lo = al;
            lo = (lo + bl) >>> 0;
            carry += lo < al ? 1 : 0;
            lo = (lo + cl) >>> 0;
            carry += lo < cl ? 1 : 0;
            lo = (lo + dl) >>> 0;
            carry += lo < dl ? 1 : 0;
            lo = (lo + el) >>> 0;
            carry += lo < el ? 1 : 0;
            var hi = ah + bh + ch + dh + eh + carry;
            return hi >>> 0;
          }
          exports.sum64_5_hi = sum64_5_hi;
          function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
            var lo = al + bl + cl + dl + el;
            return lo >>> 0;
          }
          exports.sum64_5_lo = sum64_5_lo;
          function rotr64_hi(ah, al, num) {
            var r = (al << (32 - num)) | (ah >>> num);
            return r >>> 0;
          }
          exports.rotr64_hi = rotr64_hi;
          function rotr64_lo(ah, al, num) {
            var r = (ah << (32 - num)) | (al >>> num);
            return r >>> 0;
          }
          exports.rotr64_lo = rotr64_lo;
          function shr64_hi(ah, al, num) {
            return ah >>> num;
          }
          exports.shr64_hi = shr64_hi;
          function shr64_lo(ah, al, num) {
            var r = (ah << (32 - num)) | (al >>> num);
            return r >>> 0;
          }
          exports.shr64_lo = shr64_lo;
        },
        {
          "minimalistic-assert": "820b72d8ed3e2ef613fe4c696f4f77d9",
          inherits: "cd61047e9289e4b62768390878fc0b01"
        }
      ],
      "820b72d8ed3e2ef613fe4c696f4f77d9": [
        function (require, module, exports) {
          module.exports = assert;
          function assert(val, msg) {
            if (!val) throw new Error(msg || "Assertion failed");
          }
          assert.equal = function assertEqual(l, r, msg) {
            if (l != r)
              throw new Error(msg || "Assertion failed: " + l + " != " + r);
          };
        },
        {}
      ],
      "6bb17ce3c5d193b5628901cb672f702e": [
        function (require, module, exports) {
          "use strict";
          var utils = require("./utils");
          var assert = require("minimalistic-assert");
          function BlockHash() {
            this.pending = null;
            this.pendingTotal = 0;
            this.blockSize = this.constructor.blockSize;
            this.outSize = this.constructor.outSize;
            this.hmacStrength = this.constructor.hmacStrength;
            this.padLength = this.constructor.padLength / 8;
            this.endian = "big";
            this._delta8 = this.blockSize / 8;
            this._delta32 = this.blockSize / 32;
          }
          exports.BlockHash = BlockHash;
          BlockHash.prototype.update = function update(msg, enc) {
            // Convert message to array, pad it, and join into 32bit blocks
            msg = utils.toArray(msg, enc);
            if (!this.pending) this.pending = msg;
            else this.pending = this.pending.concat(msg);
            this.pendingTotal += msg.length; // Enough data, try updating
            if (this.pending.length >= this._delta8) {
              msg = this.pending; // Process pending data in blocks
              var r = msg.length % this._delta8;
              this.pending = msg.slice(msg.length - r, msg.length);
              if (this.pending.length === 0) this.pending = null;
              msg = utils.join32(msg, 0, msg.length - r, this.endian);
              for (var i = 0; i < msg.length; i += this._delta32) {
                this._update(msg, i, i + this._delta32);
              }
            }
            return this;
          };
          BlockHash.prototype.digest = function digest(enc) {
            this.update(this._pad());
            assert(this.pending === null);
            return this._digest(enc);
          };
          BlockHash.prototype._pad = function pad() {
            var len = this.pendingTotal;
            var bytes = this._delta8;
            var k = bytes - ((len + this.padLength) % bytes);
            var res = new Array(k + this.padLength);
            res[0] = 0x80;
            for (var i = 1; i < k; i++) {
              res[i] = 0;
            } // Append length
            len <<= 3;
            if (this.endian === "big") {
              for (var t = 8; t < this.padLength; t++) {
                res[i++] = 0;
              }
              res[i++] = 0;
              res[i++] = 0;
              res[i++] = 0;
              res[i++] = 0;
              res[i++] = (len >>> 24) & 0xff;
              res[i++] = (len >>> 16) & 0xff;
              res[i++] = (len >>> 8) & 0xff;
              res[i++] = len & 0xff;
            } else {
              res[i++] = len & 0xff;
              res[i++] = (len >>> 8) & 0xff;
              res[i++] = (len >>> 16) & 0xff;
              res[i++] = (len >>> 24) & 0xff;
              res[i++] = 0;
              res[i++] = 0;
              res[i++] = 0;
              res[i++] = 0;
              for (t = 8; t < this.padLength; t++) {
                res[i++] = 0;
              }
            }
            return res;
          };
        },
        {
          "./utils": "2f7a1cec0f9d16ad9388ae00bba0ed41",
          "minimalistic-assert": "820b72d8ed3e2ef613fe4c696f4f77d9"
        }
      ],
      "5b1fdf52b7893f1731618620690fe8fd": [
        function (require, module, exports) {
          "use strict";
          exports.sha1 = require("./sha/1");
          exports.sha224 = require("./sha/224");
          exports.sha256 = require("./sha/256");
          exports.sha384 = require("./sha/384");
          exports.sha512 = require("./sha/512");
        },
        {
          "./sha/1": "d522cd83050d2f9818f5c491390867af",
          "./sha/224": "6da25c5627abb860b2692a5130792bc5",
          "./sha/256": "a090d9c043c37748bb321e6660044088",
          "./sha/384": "a067a1dd2ede984d3c2e3215c327ee29",
          "./sha/512": "8480ae954f9746897c4231505437f218"
        }
      ],
      d522cd83050d2f9818f5c491390867af: [
        function (require, module, exports) {
          "use strict";
          var utils = require("../utils");
          var common = require("../common");
          var shaCommon = require("./common");
          var rotl32 = utils.rotl32;
          var sum32 = utils.sum32;
          var sum32_5 = utils.sum32_5;
          var ft_1 = shaCommon.ft_1;
          var BlockHash = common.BlockHash;
          var sha1_K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
          function SHA1() {
            if (!_instanceof(this, SHA1)) return new SHA1();
            BlockHash.call(this);
            this.h = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];
            this.W = new Array(80);
          }
          utils.inherits(SHA1, BlockHash);
          module.exports = SHA1;
          SHA1.blockSize = 512;
          SHA1.outSize = 160;
          SHA1.hmacStrength = 80;
          SHA1.padLength = 64;
          SHA1.prototype._update = function _update(msg, start) {
            var W = this.W;
            for (var i = 0; i < 16; i++) {
              W[i] = msg[start + i];
            }
            for (; i < W.length; i++) {
              W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
            }
            var a = this.h[0];
            var b = this.h[1];
            var c = this.h[2];
            var d = this.h[3];
            var e = this.h[4];
            for (i = 0; i < W.length; i++) {
              var s = ~~(i / 20);
              var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
              e = d;
              d = c;
              c = rotl32(b, 30);
              b = a;
              a = t;
            }
            this.h[0] = sum32(this.h[0], a);
            this.h[1] = sum32(this.h[1], b);
            this.h[2] = sum32(this.h[2], c);
            this.h[3] = sum32(this.h[3], d);
            this.h[4] = sum32(this.h[4], e);
          };
          SHA1.prototype._digest = function digest(enc) {
            if (enc === "hex") return utils.toHex32(this.h, "big");
            else return utils.split32(this.h, "big");
          };
        },
        {
          "../utils": "2f7a1cec0f9d16ad9388ae00bba0ed41",
          "../common": "6bb17ce3c5d193b5628901cb672f702e",
          "./common": "4de9cf9ab2b1972f2cf45190422abd7b"
        }
      ],
      "4de9cf9ab2b1972f2cf45190422abd7b": [
        function (require, module, exports) {
          "use strict";
          var utils = require("../utils");
          var rotr32 = utils.rotr32;
          function ft_1(s, x, y, z) {
            if (s === 0) return ch32(x, y, z);
            if (s === 1 || s === 3) return p32(x, y, z);
            if (s === 2) return maj32(x, y, z);
          }
          exports.ft_1 = ft_1;
          function ch32(x, y, z) {
            return (x & y) ^ (~x & z);
          }
          exports.ch32 = ch32;
          function maj32(x, y, z) {
            return (x & y) ^ (x & z) ^ (y & z);
          }
          exports.maj32 = maj32;
          function p32(x, y, z) {
            return x ^ y ^ z;
          }
          exports.p32 = p32;
          function s0_256(x) {
            return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
          }
          exports.s0_256 = s0_256;
          function s1_256(x) {
            return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
          }
          exports.s1_256 = s1_256;
          function g0_256(x) {
            return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
          }
          exports.g0_256 = g0_256;
          function g1_256(x) {
            return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
          }
          exports.g1_256 = g1_256;
        },
        { "../utils": "2f7a1cec0f9d16ad9388ae00bba0ed41" }
      ],
      "6da25c5627abb860b2692a5130792bc5": [
        function (require, module, exports) {
          "use strict";
          var utils = require("../utils");
          var SHA256 = require("./256");
          function SHA224() {
            if (!_instanceof(this, SHA224)) return new SHA224();
            SHA256.call(this);
            this.h = [
              0xc1059ed8,
              0x367cd507,
              0x3070dd17,
              0xf70e5939,
              0xffc00b31,
              0x68581511,
              0x64f98fa7,
              0xbefa4fa4
            ];
          }
          utils.inherits(SHA224, SHA256);
          module.exports = SHA224;
          SHA224.blockSize = 512;
          SHA224.outSize = 224;
          SHA224.hmacStrength = 192;
          SHA224.padLength = 64;
          SHA224.prototype._digest = function digest(enc) {
            // Just truncate output
            if (enc === "hex") return utils.toHex32(this.h.slice(0, 7), "big");
            else return utils.split32(this.h.slice(0, 7), "big");
          };
        },
        {
          "../utils": "2f7a1cec0f9d16ad9388ae00bba0ed41",
          "./256": "a090d9c043c37748bb321e6660044088"
        }
      ],
      a090d9c043c37748bb321e6660044088: [
        function (require, module, exports) {
          "use strict";
          var utils = require("../utils");
          var common = require("../common");
          var shaCommon = require("./common");
          var assert = require("minimalistic-assert");
          var sum32 = utils.sum32;
          var sum32_4 = utils.sum32_4;
          var sum32_5 = utils.sum32_5;
          var ch32 = shaCommon.ch32;
          var maj32 = shaCommon.maj32;
          var s0_256 = shaCommon.s0_256;
          var s1_256 = shaCommon.s1_256;
          var g0_256 = shaCommon.g0_256;
          var g1_256 = shaCommon.g1_256;
          var BlockHash = common.BlockHash;
          var sha256_K = [
            0x428a2f98,
            0x71374491,
            0xb5c0fbcf,
            0xe9b5dba5,
            0x3956c25b,
            0x59f111f1,
            0x923f82a4,
            0xab1c5ed5,
            0xd807aa98,
            0x12835b01,
            0x243185be,
            0x550c7dc3,
            0x72be5d74,
            0x80deb1fe,
            0x9bdc06a7,
            0xc19bf174,
            0xe49b69c1,
            0xefbe4786,
            0x0fc19dc6,
            0x240ca1cc,
            0x2de92c6f,
            0x4a7484aa,
            0x5cb0a9dc,
            0x76f988da,
            0x983e5152,
            0xa831c66d,
            0xb00327c8,
            0xbf597fc7,
            0xc6e00bf3,
            0xd5a79147,
            0x06ca6351,
            0x14292967,
            0x27b70a85,
            0x2e1b2138,
            0x4d2c6dfc,
            0x53380d13,
            0x650a7354,
            0x766a0abb,
            0x81c2c92e,
            0x92722c85,
            0xa2bfe8a1,
            0xa81a664b,
            0xc24b8b70,
            0xc76c51a3,
            0xd192e819,
            0xd6990624,
            0xf40e3585,
            0x106aa070,
            0x19a4c116,
            0x1e376c08,
            0x2748774c,
            0x34b0bcb5,
            0x391c0cb3,
            0x4ed8aa4a,
            0x5b9cca4f,
            0x682e6ff3,
            0x748f82ee,
            0x78a5636f,
            0x84c87814,
            0x8cc70208,
            0x90befffa,
            0xa4506ceb,
            0xbef9a3f7,
            0xc67178f2
          ];
          function SHA256() {
            if (!_instanceof(this, SHA256)) return new SHA256();
            BlockHash.call(this);
            this.h = [
              0x6a09e667,
              0xbb67ae85,
              0x3c6ef372,
              0xa54ff53a,
              0x510e527f,
              0x9b05688c,
              0x1f83d9ab,
              0x5be0cd19
            ];
            this.k = sha256_K;
            this.W = new Array(64);
          }
          utils.inherits(SHA256, BlockHash);
          module.exports = SHA256;
          SHA256.blockSize = 512;
          SHA256.outSize = 256;
          SHA256.hmacStrength = 192;
          SHA256.padLength = 64;
          SHA256.prototype._update = function _update(msg, start) {
            var W = this.W;
            for (var i = 0; i < 16; i++) {
              W[i] = msg[start + i];
            }
            for (; i < W.length; i++) {
              W[i] = sum32_4(
                g1_256(W[i - 2]),
                W[i - 7],
                g0_256(W[i - 15]),
                W[i - 16]
              );
            }
            var a = this.h[0];
            var b = this.h[1];
            var c = this.h[2];
            var d = this.h[3];
            var e = this.h[4];
            var f = this.h[5];
            var g = this.h[6];
            var h = this.h[7];
            assert(this.k.length === W.length);
            for (i = 0; i < W.length; i++) {
              var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
              var T2 = sum32(s0_256(a), maj32(a, b, c));
              h = g;
              g = f;
              f = e;
              e = sum32(d, T1);
              d = c;
              c = b;
              b = a;
              a = sum32(T1, T2);
            }
            this.h[0] = sum32(this.h[0], a);
            this.h[1] = sum32(this.h[1], b);
            this.h[2] = sum32(this.h[2], c);
            this.h[3] = sum32(this.h[3], d);
            this.h[4] = sum32(this.h[4], e);
            this.h[5] = sum32(this.h[5], f);
            this.h[6] = sum32(this.h[6], g);
            this.h[7] = sum32(this.h[7], h);
          };
          SHA256.prototype._digest = function digest(enc) {
            if (enc === "hex") return utils.toHex32(this.h, "big");
            else return utils.split32(this.h, "big");
          };
        },
        {
          "../utils": "2f7a1cec0f9d16ad9388ae00bba0ed41",
          "../common": "6bb17ce3c5d193b5628901cb672f702e",
          "./common": "4de9cf9ab2b1972f2cf45190422abd7b",
          "minimalistic-assert": "820b72d8ed3e2ef613fe4c696f4f77d9"
        }
      ],
      a067a1dd2ede984d3c2e3215c327ee29: [
        function (require, module, exports) {
          "use strict";
          var utils = require("../utils");
          var SHA512 = require("./512");
          function SHA384() {
            if (!_instanceof(this, SHA384)) return new SHA384();
            SHA512.call(this);
            this.h = [
              0xcbbb9d5d,
              0xc1059ed8,
              0x629a292a,
              0x367cd507,
              0x9159015a,
              0x3070dd17,
              0x152fecd8,
              0xf70e5939,
              0x67332667,
              0xffc00b31,
              0x8eb44a87,
              0x68581511,
              0xdb0c2e0d,
              0x64f98fa7,
              0x47b5481d,
              0xbefa4fa4
            ];
          }
          utils.inherits(SHA384, SHA512);
          module.exports = SHA384;
          SHA384.blockSize = 1024;
          SHA384.outSize = 384;
          SHA384.hmacStrength = 192;
          SHA384.padLength = 128;
          SHA384.prototype._digest = function digest(enc) {
            if (enc === "hex") return utils.toHex32(this.h.slice(0, 12), "big");
            else return utils.split32(this.h.slice(0, 12), "big");
          };
        },
        {
          "../utils": "2f7a1cec0f9d16ad9388ae00bba0ed41",
          "./512": "8480ae954f9746897c4231505437f218"
        }
      ],
      "8480ae954f9746897c4231505437f218": [
        function (require, module, exports) {
          "use strict";
          var utils = require("../utils");
          var common = require("../common");
          var assert = require("minimalistic-assert");
          var rotr64_hi = utils.rotr64_hi;
          var rotr64_lo = utils.rotr64_lo;
          var shr64_hi = utils.shr64_hi;
          var shr64_lo = utils.shr64_lo;
          var sum64 = utils.sum64;
          var sum64_hi = utils.sum64_hi;
          var sum64_lo = utils.sum64_lo;
          var sum64_4_hi = utils.sum64_4_hi;
          var sum64_4_lo = utils.sum64_4_lo;
          var sum64_5_hi = utils.sum64_5_hi;
          var sum64_5_lo = utils.sum64_5_lo;
          var BlockHash = common.BlockHash;
          var sha512_K = [
            0x428a2f98,
            0xd728ae22,
            0x71374491,
            0x23ef65cd,
            0xb5c0fbcf,
            0xec4d3b2f,
            0xe9b5dba5,
            0x8189dbbc,
            0x3956c25b,
            0xf348b538,
            0x59f111f1,
            0xb605d019,
            0x923f82a4,
            0xaf194f9b,
            0xab1c5ed5,
            0xda6d8118,
            0xd807aa98,
            0xa3030242,
            0x12835b01,
            0x45706fbe,
            0x243185be,
            0x4ee4b28c,
            0x550c7dc3,
            0xd5ffb4e2,
            0x72be5d74,
            0xf27b896f,
            0x80deb1fe,
            0x3b1696b1,
            0x9bdc06a7,
            0x25c71235,
            0xc19bf174,
            0xcf692694,
            0xe49b69c1,
            0x9ef14ad2,
            0xefbe4786,
            0x384f25e3,
            0x0fc19dc6,
            0x8b8cd5b5,
            0x240ca1cc,
            0x77ac9c65,
            0x2de92c6f,
            0x592b0275,
            0x4a7484aa,
            0x6ea6e483,
            0x5cb0a9dc,
            0xbd41fbd4,
            0x76f988da,
            0x831153b5,
            0x983e5152,
            0xee66dfab,
            0xa831c66d,
            0x2db43210,
            0xb00327c8,
            0x98fb213f,
            0xbf597fc7,
            0xbeef0ee4,
            0xc6e00bf3,
            0x3da88fc2,
            0xd5a79147,
            0x930aa725,
            0x06ca6351,
            0xe003826f,
            0x14292967,
            0x0a0e6e70,
            0x27b70a85,
            0x46d22ffc,
            0x2e1b2138,
            0x5c26c926,
            0x4d2c6dfc,
            0x5ac42aed,
            0x53380d13,
            0x9d95b3df,
            0x650a7354,
            0x8baf63de,
            0x766a0abb,
            0x3c77b2a8,
            0x81c2c92e,
            0x47edaee6,
            0x92722c85,
            0x1482353b,
            0xa2bfe8a1,
            0x4cf10364,
            0xa81a664b,
            0xbc423001,
            0xc24b8b70,
            0xd0f89791,
            0xc76c51a3,
            0x0654be30,
            0xd192e819,
            0xd6ef5218,
            0xd6990624,
            0x5565a910,
            0xf40e3585,
            0x5771202a,
            0x106aa070,
            0x32bbd1b8,
            0x19a4c116,
            0xb8d2d0c8,
            0x1e376c08,
            0x5141ab53,
            0x2748774c,
            0xdf8eeb99,
            0x34b0bcb5,
            0xe19b48a8,
            0x391c0cb3,
            0xc5c95a63,
            0x4ed8aa4a,
            0xe3418acb,
            0x5b9cca4f,
            0x7763e373,
            0x682e6ff3,
            0xd6b2b8a3,
            0x748f82ee,
            0x5defb2fc,
            0x78a5636f,
            0x43172f60,
            0x84c87814,
            0xa1f0ab72,
            0x8cc70208,
            0x1a6439ec,
            0x90befffa,
            0x23631e28,
            0xa4506ceb,
            0xde82bde9,
            0xbef9a3f7,
            0xb2c67915,
            0xc67178f2,
            0xe372532b,
            0xca273ece,
            0xea26619c,
            0xd186b8c7,
            0x21c0c207,
            0xeada7dd6,
            0xcde0eb1e,
            0xf57d4f7f,
            0xee6ed178,
            0x06f067aa,
            0x72176fba,
            0x0a637dc5,
            0xa2c898a6,
            0x113f9804,
            0xbef90dae,
            0x1b710b35,
            0x131c471b,
            0x28db77f5,
            0x23047d84,
            0x32caab7b,
            0x40c72493,
            0x3c9ebe0a,
            0x15c9bebc,
            0x431d67c4,
            0x9c100d4c,
            0x4cc5d4be,
            0xcb3e42b6,
            0x597f299c,
            0xfc657e2a,
            0x5fcb6fab,
            0x3ad6faec,
            0x6c44198c,
            0x4a475817
          ];
          function SHA512() {
            if (!_instanceof(this, SHA512)) return new SHA512();
            BlockHash.call(this);
            this.h = [
              0x6a09e667,
              0xf3bcc908,
              0xbb67ae85,
              0x84caa73b,
              0x3c6ef372,
              0xfe94f82b,
              0xa54ff53a,
              0x5f1d36f1,
              0x510e527f,
              0xade682d1,
              0x9b05688c,
              0x2b3e6c1f,
              0x1f83d9ab,
              0xfb41bd6b,
              0x5be0cd19,
              0x137e2179
            ];
            this.k = sha512_K;
            this.W = new Array(160);
          }
          utils.inherits(SHA512, BlockHash);
          module.exports = SHA512;
          SHA512.blockSize = 1024;
          SHA512.outSize = 512;
          SHA512.hmacStrength = 192;
          SHA512.padLength = 128;
          SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
            var W = this.W; // 32 x 32bit words
            for (var i = 0; i < 32; i++) {
              W[i] = msg[start + i];
            }
            for (; i < W.length; i += 2) {
              var c0_hi = g1_512_hi(W[i - 4], W[i - 3]); // i - 2
              var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
              var c1_hi = W[i - 14]; // i - 7
              var c1_lo = W[i - 13];
              var c2_hi = g0_512_hi(W[i - 30], W[i - 29]); // i - 15
              var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
              var c3_hi = W[i - 32]; // i - 16
              var c3_lo = W[i - 31];
              W[i] = sum64_4_hi(
                c0_hi,
                c0_lo,
                c1_hi,
                c1_lo,
                c2_hi,
                c2_lo,
                c3_hi,
                c3_lo
              );
              W[i + 1] = sum64_4_lo(
                c0_hi,
                c0_lo,
                c1_hi,
                c1_lo,
                c2_hi,
                c2_lo,
                c3_hi,
                c3_lo
              );
            }
          };
          SHA512.prototype._update = function _update(msg, start) {
            this._prepareBlock(msg, start);
            var W = this.W;
            var ah = this.h[0];
            var al = this.h[1];
            var bh = this.h[2];
            var bl = this.h[3];
            var ch = this.h[4];
            var cl = this.h[5];
            var dh = this.h[6];
            var dl = this.h[7];
            var eh = this.h[8];
            var el = this.h[9];
            var fh = this.h[10];
            var fl = this.h[11];
            var gh = this.h[12];
            var gl = this.h[13];
            var hh = this.h[14];
            var hl = this.h[15];
            assert(this.k.length === W.length);
            for (var i = 0; i < W.length; i += 2) {
              var c0_hi = hh;
              var c0_lo = hl;
              var c1_hi = s1_512_hi(eh, el);
              var c1_lo = s1_512_lo(eh, el);
              var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
              var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
              var c3_hi = this.k[i];
              var c3_lo = this.k[i + 1];
              var c4_hi = W[i];
              var c4_lo = W[i + 1];
              var T1_hi = sum64_5_hi(
                c0_hi,
                c0_lo,
                c1_hi,
                c1_lo,
                c2_hi,
                c2_lo,
                c3_hi,
                c3_lo,
                c4_hi,
                c4_lo
              );
              var T1_lo = sum64_5_lo(
                c0_hi,
                c0_lo,
                c1_hi,
                c1_lo,
                c2_hi,
                c2_lo,
                c3_hi,
                c3_lo,
                c4_hi,
                c4_lo
              );
              c0_hi = s0_512_hi(ah, al);
              c0_lo = s0_512_lo(ah, al);
              c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
              c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);
              var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
              var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
              hh = gh;
              hl = gl;
              gh = fh;
              gl = fl;
              fh = eh;
              fl = el;
              eh = sum64_hi(dh, dl, T1_hi, T1_lo);
              el = sum64_lo(dl, dl, T1_hi, T1_lo);
              dh = ch;
              dl = cl;
              ch = bh;
              cl = bl;
              bh = ah;
              bl = al;
              ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
              al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
            }
            sum64(this.h, 0, ah, al);
            sum64(this.h, 2, bh, bl);
            sum64(this.h, 4, ch, cl);
            sum64(this.h, 6, dh, dl);
            sum64(this.h, 8, eh, el);
            sum64(this.h, 10, fh, fl);
            sum64(this.h, 12, gh, gl);
            sum64(this.h, 14, hh, hl);
          };
          SHA512.prototype._digest = function digest(enc) {
            if (enc === "hex") return utils.toHex32(this.h, "big");
            else return utils.split32(this.h, "big");
          };
          function ch64_hi(xh, xl, yh, yl, zh) {
            var r = (xh & yh) ^ (~xh & zh);
            if (r < 0) r += 0x100000000;
            return r;
          }
          function ch64_lo(xh, xl, yh, yl, zh, zl) {
            var r = (xl & yl) ^ (~xl & zl);
            if (r < 0) r += 0x100000000;
            return r;
          }
          function maj64_hi(xh, xl, yh, yl, zh) {
            var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
            if (r < 0) r += 0x100000000;
            return r;
          }
          function maj64_lo(xh, xl, yh, yl, zh, zl) {
            var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
            if (r < 0) r += 0x100000000;
            return r;
          }
          function s0_512_hi(xh, xl) {
            var c0_hi = rotr64_hi(xh, xl, 28);
            var c1_hi = rotr64_hi(xl, xh, 2); // 34
            var c2_hi = rotr64_hi(xl, xh, 7); // 39
            var r = c0_hi ^ c1_hi ^ c2_hi;
            if (r < 0) r += 0x100000000;
            return r;
          }
          function s0_512_lo(xh, xl) {
            var c0_lo = rotr64_lo(xh, xl, 28);
            var c1_lo = rotr64_lo(xl, xh, 2); // 34
            var c2_lo = rotr64_lo(xl, xh, 7); // 39
            var r = c0_lo ^ c1_lo ^ c2_lo;
            if (r < 0) r += 0x100000000;
            return r;
          }
          function s1_512_hi(xh, xl) {
            var c0_hi = rotr64_hi(xh, xl, 14);
            var c1_hi = rotr64_hi(xh, xl, 18);
            var c2_hi = rotr64_hi(xl, xh, 9); // 41
            var r = c0_hi ^ c1_hi ^ c2_hi;
            if (r < 0) r += 0x100000000;
            return r;
          }
          function s1_512_lo(xh, xl) {
            var c0_lo = rotr64_lo(xh, xl, 14);
            var c1_lo = rotr64_lo(xh, xl, 18);
            var c2_lo = rotr64_lo(xl, xh, 9); // 41
            var r = c0_lo ^ c1_lo ^ c2_lo;
            if (r < 0) r += 0x100000000;
            return r;
          }
          function g0_512_hi(xh, xl) {
            var c0_hi = rotr64_hi(xh, xl, 1);
            var c1_hi = rotr64_hi(xh, xl, 8);
            var c2_hi = shr64_hi(xh, xl, 7);
            var r = c0_hi ^ c1_hi ^ c2_hi;
            if (r < 0) r += 0x100000000;
            return r;
          }
          function g0_512_lo(xh, xl) {
            var c0_lo = rotr64_lo(xh, xl, 1);
            var c1_lo = rotr64_lo(xh, xl, 8);
            var c2_lo = shr64_lo(xh, xl, 7);
            var r = c0_lo ^ c1_lo ^ c2_lo;
            if (r < 0) r += 0x100000000;
            return r;
          }
          function g1_512_hi(xh, xl) {
            var c0_hi = rotr64_hi(xh, xl, 19);
            var c1_hi = rotr64_hi(xl, xh, 29); // 61
            var c2_hi = shr64_hi(xh, xl, 6);
            var r = c0_hi ^ c1_hi ^ c2_hi;
            if (r < 0) r += 0x100000000;
            return r;
          }
          function g1_512_lo(xh, xl) {
            var c0_lo = rotr64_lo(xh, xl, 19);
            var c1_lo = rotr64_lo(xl, xh, 29); // 61
            var c2_lo = shr64_lo(xh, xl, 6);
            var r = c0_lo ^ c1_lo ^ c2_lo;
            if (r < 0) r += 0x100000000;
            return r;
          }
        },
        {
          "../utils": "2f7a1cec0f9d16ad9388ae00bba0ed41",
          "../common": "6bb17ce3c5d193b5628901cb672f702e",
          "minimalistic-assert": "820b72d8ed3e2ef613fe4c696f4f77d9"
        }
      ],
      "5791768b3ac26542c60769410206a75e": [
        function (require, module, exports) {
          "use strict";
          var utils = require("./utils");
          var common = require("./common");
          var rotl32 = utils.rotl32;
          var sum32 = utils.sum32;
          var sum32_3 = utils.sum32_3;
          var sum32_4 = utils.sum32_4;
          var BlockHash = common.BlockHash;
          function RIPEMD160() {
            if (!_instanceof(this, RIPEMD160)) return new RIPEMD160();
            BlockHash.call(this);
            this.h = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];
            this.endian = "little";
          }
          utils.inherits(RIPEMD160, BlockHash);
          exports.ripemd160 = RIPEMD160;
          RIPEMD160.blockSize = 512;
          RIPEMD160.outSize = 160;
          RIPEMD160.hmacStrength = 192;
          RIPEMD160.padLength = 64;
          RIPEMD160.prototype._update = function update(msg, start) {
            var A = this.h[0];
            var B = this.h[1];
            var C = this.h[2];
            var D = this.h[3];
            var E = this.h[4];
            var Ah = A;
            var Bh = B;
            var Ch = C;
            var Dh = D;
            var Eh = E;
            for (var j = 0; j < 80; j++) {
              var T = sum32(
                rotl32(sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)), s[j]),
                E
              );
              A = E;
              E = D;
              D = rotl32(C, 10);
              C = B;
              B = T;
              T = sum32(
                rotl32(
                  sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
                  sh[j]
                ),
                Eh
              );
              Ah = Eh;
              Eh = Dh;
              Dh = rotl32(Ch, 10);
              Ch = Bh;
              Bh = T;
            }
            T = sum32_3(this.h[1], C, Dh);
            this.h[1] = sum32_3(this.h[2], D, Eh);
            this.h[2] = sum32_3(this.h[3], E, Ah);
            this.h[3] = sum32_3(this.h[4], A, Bh);
            this.h[4] = sum32_3(this.h[0], B, Ch);
            this.h[0] = T;
          };
          RIPEMD160.prototype._digest = function digest(enc) {
            if (enc === "hex") return utils.toHex32(this.h, "little");
            else return utils.split32(this.h, "little");
          };
          function f(j, x, y, z) {
            if (j <= 15) return x ^ y ^ z;
            else if (j <= 31) return (x & y) | (~x & z);
            else if (j <= 47) return (x | ~y) ^ z;
            else if (j <= 63) return (x & z) | (y & ~z);
            else return x ^ (y | ~z);
          }
          function K(j) {
            if (j <= 15) return 0x00000000;
            else if (j <= 31) return 0x5a827999;
            else if (j <= 47) return 0x6ed9eba1;
            else if (j <= 63) return 0x8f1bbcdc;
            else return 0xa953fd4e;
          }
          function Kh(j) {
            if (j <= 15) return 0x50a28be6;
            else if (j <= 31) return 0x5c4dd124;
            else if (j <= 47) return 0x6d703ef3;
            else if (j <= 63) return 0x7a6d76e9;
            else return 0x00000000;
          }
          var r = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            7,
            4,
            13,
            1,
            10,
            6,
            15,
            3,
            12,
            0,
            9,
            5,
            2,
            14,
            11,
            8,
            3,
            10,
            14,
            4,
            9,
            15,
            8,
            1,
            2,
            7,
            0,
            6,
            13,
            11,
            5,
            12,
            1,
            9,
            11,
            10,
            0,
            8,
            12,
            4,
            13,
            3,
            7,
            15,
            14,
            5,
            6,
            2,
            4,
            0,
            5,
            9,
            7,
            12,
            2,
            10,
            14,
            1,
            3,
            8,
            11,
            6,
            15,
            13
          ];
          var rh = [
            5,
            14,
            7,
            0,
            9,
            2,
            11,
            4,
            13,
            6,
            15,
            8,
            1,
            10,
            3,
            12,
            6,
            11,
            3,
            7,
            0,
            13,
            5,
            10,
            14,
            15,
            8,
            12,
            4,
            9,
            1,
            2,
            15,
            5,
            1,
            3,
            7,
            14,
            6,
            9,
            11,
            8,
            12,
            2,
            10,
            0,
            4,
            13,
            8,
            6,
            4,
            1,
            3,
            11,
            15,
            0,
            5,
            12,
            2,
            13,
            9,
            7,
            10,
            14,
            12,
            15,
            10,
            4,
            1,
            5,
            8,
            7,
            6,
            2,
            13,
            14,
            0,
            3,
            9,
            11
          ];
          var s = [
            11,
            14,
            15,
            12,
            5,
            8,
            7,
            9,
            11,
            13,
            14,
            15,
            6,
            7,
            9,
            8,
            7,
            6,
            8,
            13,
            11,
            9,
            7,
            15,
            7,
            12,
            15,
            9,
            11,
            7,
            13,
            12,
            11,
            13,
            6,
            7,
            14,
            9,
            13,
            15,
            14,
            8,
            13,
            6,
            5,
            12,
            7,
            5,
            11,
            12,
            14,
            15,
            14,
            15,
            9,
            8,
            9,
            14,
            5,
            6,
            8,
            6,
            5,
            12,
            9,
            15,
            5,
            11,
            6,
            8,
            13,
            12,
            5,
            12,
            13,
            14,
            11,
            8,
            5,
            6
          ];
          var sh = [
            8,
            9,
            9,
            11,
            13,
            15,
            15,
            5,
            7,
            7,
            8,
            11,
            14,
            14,
            12,
            6,
            9,
            13,
            15,
            7,
            12,
            8,
            9,
            11,
            7,
            7,
            12,
            7,
            6,
            15,
            13,
            11,
            9,
            7,
            15,
            11,
            8,
            6,
            6,
            14,
            12,
            13,
            5,
            14,
            13,
            13,
            7,
            5,
            15,
            5,
            8,
            11,
            14,
            14,
            6,
            14,
            6,
            9,
            12,
            9,
            12,
            5,
            15,
            8,
            8,
            5,
            12,
            9,
            12,
            5,
            14,
            6,
            8,
            13,
            6,
            5,
            15,
            13,
            11,
            11
          ];
        },
        {
          "./utils": "2f7a1cec0f9d16ad9388ae00bba0ed41",
          "./common": "6bb17ce3c5d193b5628901cb672f702e"
        }
      ],
      "92a71c791fb06acc94ae9e1bb0103cac": [
        function (require, module, exports) {
          "use strict";
          var utils = require("./utils");
          var assert = require("minimalistic-assert");
          function Hmac(hash, key, enc) {
            if (!_instanceof(this, Hmac)) return new Hmac(hash, key, enc);
            this.Hash = hash;
            this.blockSize = hash.blockSize / 8;
            this.outSize = hash.outSize / 8;
            this.inner = null;
            this.outer = null;
            this._init(utils.toArray(key, enc));
          }
          module.exports = Hmac;
          Hmac.prototype._init = function init(key) {
            // Shorten key, if needed
            if (key.length > this.blockSize)
              key = new this.Hash().update(key).digest();
            assert(key.length <= this.blockSize); // Add padding to key
            for (var i = key.length; i < this.blockSize; i++) {
              key.push(0);
            }
            for (i = 0; i < key.length; i++) {
              key[i] ^= 0x36;
            }
            this.inner = new this.Hash().update(key); // 0x36 ^ 0x5c = 0x6a
            for (i = 0; i < key.length; i++) {
              key[i] ^= 0x6a;
            }
            this.outer = new this.Hash().update(key);
          };
          Hmac.prototype.update = function update(msg, enc) {
            this.inner.update(msg, enc);
            return this;
          };
          Hmac.prototype.digest = function digest(enc) {
            this.outer.update(this.inner.digest());
            return this.outer.digest(enc);
          };
        },
        {
          "./utils": "2f7a1cec0f9d16ad9388ae00bba0ed41",
          "minimalistic-assert": "820b72d8ed3e2ef613fe4c696f4f77d9"
        }
      ],
      "03672d91cbe66f4a302b8d456a7d55ca": [
        function (require, module, exports) {
          "use strict";
          var elliptic = exports;
          elliptic.version = require("../package.json").version;
          elliptic.utils = require("./elliptic/utils");
          elliptic.rand = require("brorand");
          elliptic.curve = require("./elliptic/curve");
          elliptic.curves = require("./elliptic/curves"); // Protocols
          elliptic.ec = require("./elliptic/ec");
          elliptic.eddsa = require("./elliptic/eddsa");
        },
        {
          "../package.json": "ea4d1580b6af0d352141a33e00f0b5ae",
          "./elliptic/utils": "19cbc0e8eeaa80c7312d4080f426c995",
          brorand: "46819616b5df61c964cabc43a2ab8054",
          "./elliptic/curve": "29408169d16e6b476d0cacd15fab4cc6",
          "./elliptic/curves": "9ddb7a24a9cba70869027081f9150e33",
          "./elliptic/ec": "3696104af7c0bc5791ea2525bbf134e7",
          "./elliptic/eddsa": "f26522a3b207b6f3db4d524511173d3f"
        }
      ],
      ea4d1580b6af0d352141a33e00f0b5ae: [
        function (require, module, exports) {
          module.exports = JSON.parse(
            '{"_from":"elliptic@^6.5.2","_id":"elliptic@6.5.3","_inBundle":false,"_integrity":"sha512-IMqzv5wNQf+E6aHeIqATs0tOLeOTwj1QKbRcS3jBbYkl5oLAserA8yJTT7/VyHUYG91PRmPyeQDObKLPpeS4dw==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"elliptic@^6.5.2","name":"elliptic","escapedName":"elliptic","rawSpec":"^6.5.2","saveSpec":null,"fetchSpec":"^6.5.2"},"_requiredBy":["/ripple-keypairs"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.5.3.tgz","_shasum":"cb59eb2efdaf73a0bd78ccd7015a62ad6e0f93d6","_spec":"elliptic@^6.5.2","_where":"/home/rokpajnic/Desktop/ripple-lib-testing/node_modules/ripple-keypairs","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"bundleDependencies":false,"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"deprecated":false,"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^3.0.8","grunt":"^1.0.4","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.2","jscs":"^3.0.7","jshint":"^2.10.3","mocha":"^6.2.2"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.5.3"}'
          );
        },
        {}
      ],
      "19cbc0e8eeaa80c7312d4080f426c995": [
        function (require, module, exports) {
          "use strict";
          var utils = exports;
          var BN = require("bn.js");
          var minAssert = require("minimalistic-assert");
          var minUtils = require("minimalistic-crypto-utils");
          utils.assert = minAssert;
          utils.toArray = minUtils.toArray;
          utils.zero2 = minUtils.zero2;
          utils.toHex = minUtils.toHex;
          utils.encode = minUtils.encode; // Represent num in a w-NAF form
          function getNAF(num, w, bits) {
            var naf = new Array(Math.max(num.bitLength(), bits) + 1);
            naf.fill(0);
            var ws = 1 << (w + 1);
            var k = num.clone();
            for (var i = 0; i < naf.length; i++) {
              var z;
              var mod = k.andln(ws - 1);
              if (k.isOdd()) {
                if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
                else z = mod;
                k.isubn(z);
              } else {
                z = 0;
              }
              naf[i] = z;
              k.iushrn(1);
            }
            return naf;
          }
          utils.getNAF = getNAF; // Represent k1, k2 in a Joint Sparse Form
          function getJSF(k1, k2) {
            var jsf = [[], []];
            k1 = k1.clone();
            k2 = k2.clone();
            var d1 = 0;
            var d2 = 0;
            while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {
              // First phase
              var m14 = (k1.andln(3) + d1) & 3;
              var m24 = (k2.andln(3) + d2) & 3;
              if (m14 === 3) m14 = -1;
              if (m24 === 3) m24 = -1;
              var u1;
              if ((m14 & 1) === 0) {
                u1 = 0;
              } else {
                var m8 = (k1.andln(7) + d1) & 7;
                if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
                else u1 = m14;
              }
              jsf[0].push(u1);
              var u2;
              if ((m24 & 1) === 0) {
                u2 = 0;
              } else {
                var m8 = (k2.andln(7) + d2) & 7;
                if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
                else u2 = m24;
              }
              jsf[1].push(u2); // Second phase
              if (2 * d1 === u1 + 1) d1 = 1 - d1;
              if (2 * d2 === u2 + 1) d2 = 1 - d2;
              k1.iushrn(1);
              k2.iushrn(1);
            }
            return jsf;
          }
          utils.getJSF = getJSF;
          function cachedProperty(obj, name, computer) {
            var key = "_" + name;
            obj.prototype[name] = function cachedProperty() {
              return this[key] !== undefined
                ? this[key]
                : (this[key] = computer.call(this));
            };
          }
          utils.cachedProperty = cachedProperty;
          function parseBytes(bytes) {
            return typeof bytes === "string"
              ? utils.toArray(bytes, "hex")
              : bytes;
          }
          utils.parseBytes = parseBytes;
          function intFromLE(bytes) {
            return new BN(bytes, "hex", "le");
          }
          utils.intFromLE = intFromLE;
        },
        {
          "bn.js": "c067c95fc23ea4f3df8ca0f49aa28d8d",
          "minimalistic-assert": "820b72d8ed3e2ef613fe4c696f4f77d9",
          "minimalistic-crypto-utils": "baa8e23d083f0906729d32b8dd69719c"
        }
      ],
      c067c95fc23ea4f3df8ca0f49aa28d8d: [
        function (require, module, exports) {
          (function (module, exports) {
            "use strict"; // Utils
            function assert(val, msg) {
              if (!val) throw new Error(msg || "Assertion failed");
            } // Could use `inherits` module, but don't want to move from single file
            // architecture yet.
            function inherits(ctor, superCtor) {
              ctor.super_ = superCtor;
              var TempCtor = function TempCtor() {};
              TempCtor.prototype = superCtor.prototype;
              ctor.prototype = new TempCtor();
              ctor.prototype.constructor = ctor;
            } // BN
            function BN(number, base, endian) {
              if (BN.isBN(number)) {
                return number;
              }
              this.negative = 0;
              this.words = null;
              this.length = 0; // Reduction context
              this.red = null;
              if (number !== null) {
                if (base === "le" || base === "be") {
                  endian = base;
                  base = 10;
                }
                this._init(number || 0, base || 10, endian || "be");
              }
            }
            if (_typeof2(module) === "object") {
              module.exports = BN;
            } else {
              exports.BN = BN;
            }
            BN.BN = BN;
            BN.wordSize = 26;
            var Buffer;
            try {
              Buffer = require("buffer").Buffer;
            } catch (e) {}
            BN.isBN = function isBN(num) {
              if (_instanceof(num, BN)) {
                return true;
              }
              return (
                num !== null &&
                _typeof2(num) === "object" &&
                num.constructor.wordSize === BN.wordSize &&
                Array.isArray(num.words)
              );
            };
            BN.max = function max(left, right) {
              if (left.cmp(right) > 0) return left;
              return right;
            };
            BN.min = function min(left, right) {
              if (left.cmp(right) < 0) return left;
              return right;
            };
            BN.prototype._init = function init(number, base, endian) {
              if (typeof number === "number") {
                return this._initNumber(number, base, endian);
              }
              if (_typeof2(number) === "object") {
                return this._initArray(number, base, endian);
              }
              if (base === "hex") {
                base = 16;
              }
              assert(base === (base | 0) && base >= 2 && base <= 36);
              number = number.toString().replace(/\s+/g, "");
              var start = 0;
              if (number[0] === "-") {
                start++;
              }
              if (base === 16) {
                this._parseHex(number, start);
              } else {
                this._parseBase(number, base, start);
              }
              if (number[0] === "-") {
                this.negative = 1;
              }
              this.strip();
              if (endian !== "le") return;
              this._initArray(this.toArray(), base, endian);
            };
            BN.prototype._initNumber = function _initNumber(
              number,
              base,
              endian
            ) {
              if (number < 0) {
                this.negative = 1;
                number = -number;
              }
              if (number < 0x4000000) {
                this.words = [number & 0x3ffffff];
                this.length = 1;
              } else if (number < 0x10000000000000) {
                this.words = [
                  number & 0x3ffffff,
                  (number / 0x4000000) & 0x3ffffff
                ];
                this.length = 2;
              } else {
                assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
                this.words = [
                  number & 0x3ffffff,
                  (number / 0x4000000) & 0x3ffffff,
                  1
                ];
                this.length = 3;
              }
              if (endian !== "le") return; // Reverse the bytes
              this._initArray(this.toArray(), base, endian);
            };
            BN.prototype._initArray = function _initArray(number, base, endian) {
              // Perhaps a Uint8Array
              assert(typeof number.length === "number");
              if (number.length <= 0) {
                this.words = [0];
                this.length = 1;
                return this;
              }
              this.length = Math.ceil(number.length / 3);
              this.words = new Array(this.length);
              for (var i = 0; i < this.length; i++) {
                this.words[i] = 0;
              }
              var j, w;
              var off = 0;
              if (endian === "be") {
                for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
                  w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
                  this.words[j] |= (w << off) & 0x3ffffff;
                  this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
                  off += 24;
                  if (off >= 26) {
                    off -= 26;
                    j++;
                  }
                }
              } else if (endian === "le") {
                for (i = 0, j = 0; i < number.length; i += 3) {
                  w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
                  this.words[j] |= (w << off) & 0x3ffffff;
                  this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
                  off += 24;
                  if (off >= 26) {
                    off -= 26;
                    j++;
                  }
                }
              }
              return this.strip();
            };
            function parseHex(str, start, end) {
              var r = 0;
              var len = Math.min(str.length, end);
              for (var i = start; i < len; i++) {
                var c = str.charCodeAt(i) - 48;
                r <<= 4; // 'a' - 'f'
                if (c >= 49 && c <= 54) {
                  r |= c - 49 + 0xa; // 'A' - 'F'
                } else if (c >= 17 && c <= 22) {
                  r |= c - 17 + 0xa; // '0' - '9'
                } else {
                  r |= c & 0xf;
                }
              }
              return r;
            }
            BN.prototype._parseHex = function _parseHex(number, start) {
              // Create possibly bigger array to ensure that it fits the number
              this.length = Math.ceil((number.length - start) / 6);
              this.words = new Array(this.length);
              for (var i = 0; i < this.length; i++) {
                this.words[i] = 0;
              }
              var j, w; // Scan 24-bit chunks and add them to the number
              var off = 0;
              for (i = number.length - 6, j = 0; i >= start; i -= 6) {
                w = parseHex(number, i, i + 6);
                this.words[j] |= (w << off) & 0x3ffffff; // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
                this.words[j + 1] |= (w >>> (26 - off)) & 0x3fffff;
                off += 24;
                if (off >= 26) {
                  off -= 26;
                  j++;
                }
              }
              if (i + 6 !== start) {
                w = parseHex(number, start, i + 6);
                this.words[j] |= (w << off) & 0x3ffffff;
                this.words[j + 1] |= (w >>> (26 - off)) & 0x3fffff;
              }
              this.strip();
            };
            function parseBase(str, start, end, mul) {
              var r = 0;
              var len = Math.min(str.length, end);
              for (var i = start; i < len; i++) {
                var c = str.charCodeAt(i) - 48;
                r *= mul; // 'a'
                if (c >= 49) {
                  r += c - 49 + 0xa; // 'A'
                } else if (c >= 17) {
                  r += c - 17 + 0xa; // '0' - '9'
                } else {
                  r += c;
                }
              }
              return r;
            }
            BN.prototype._parseBase = function _parseBase(number, base, start) {
              // Initialize as zero
              this.words = [0];
              this.length = 1; // Find length of limb in base
              for (
                var limbLen = 0, limbPow = 1;
                limbPow <= 0x3ffffff;
                limbPow *= base
              ) {
                limbLen++;
              }
              limbLen--;
              limbPow = (limbPow / base) | 0;
              var total = number.length - start;
              var mod = total % limbLen;
              var end = Math.min(total, total - mod) + start;
              var word = 0;
              for (var i = start; i < end; i += limbLen) {
                word = parseBase(number, i, i + limbLen, base);
                this.imuln(limbPow);
                if (this.words[0] + word < 0x4000000) {
                  this.words[0] += word;
                } else {
                  this._iaddn(word);
                }
              }
              if (mod !== 0) {
                var pow = 1;
                word = parseBase(number, i, number.length, base);
                for (i = 0; i < mod; i++) {
                  pow *= base;
                }
                this.imuln(pow);
                if (this.words[0] + word < 0x4000000) {
                  this.words[0] += word;
                } else {
                  this._iaddn(word);
                }
              }
            };
            BN.prototype.copy = function copy(dest) {
              dest.words = new Array(this.length);
              for (var i = 0; i < this.length; i++) {
                dest.words[i] = this.words[i];
              }
              dest.length = this.length;
              dest.negative = this.negative;
              dest.red = this.red;
            };
            BN.prototype.clone = function clone() {
              var r = new BN(null);
              this.copy(r);
              return r;
            };
            BN.prototype._expand = function _expand(size) {
              while (this.length < size) {
                this.words[this.length++] = 0;
              }
              return this;
            }; // Remove leading `0` from `this`
            BN.prototype.strip = function strip() {
              while (this.length > 1 && this.words[this.length - 1] === 0) {
                this.length--;
              }
              return this._normSign();
            };
            BN.prototype._normSign = function _normSign() {
              // -0 = 0
              if (this.length === 1 && this.words[0] === 0) {
                this.negative = 0;
              }
              return this;
            };
            BN.prototype.inspect = function inspect() {
              return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
            };
            /*

      var zeros = [];
      var groupSizes = [];
      var groupBases = [];

      var s = '';
      var i = -1;
      while (++i < BN.wordSize) {
        zeros[i] = s;
        s += '0';
      }
      groupSizes[0] = 0;
      groupSizes[1] = 0;
      groupBases[0] = 0;
      groupBases[1] = 0;
      var base = 2 - 1;
      while (++base < 36 + 1) {
        var groupSize = 0;
        var groupBase = 1;
        while (groupBase < (1 << BN.wordSize) / base) {
          groupBase *= base;
          groupSize += 1;
        }
        groupSizes[base] = groupSize;
        groupBases[base] = groupBase;
      }

      */ var zeros = [
              "",
              "0",
              "00",
              "000",
              "0000",
              "00000",
              "000000",
              "0000000",
              "00000000",
              "000000000",
              "0000000000",
              "00000000000",
              "000000000000",
              "0000000000000",
              "00000000000000",
              "000000000000000",
              "0000000000000000",
              "00000000000000000",
              "000000000000000000",
              "0000000000000000000",
              "00000000000000000000",
              "000000000000000000000",
              "0000000000000000000000",
              "00000000000000000000000",
              "000000000000000000000000",
              "0000000000000000000000000"
            ];
            var groupSizes = [
              0,
              0,
              25,
              16,
              12,
              11,
              10,
              9,
              8,
              8,
              7,
              7,
              7,
              7,
              6,
              6,
              6,
              6,
              6,
              6,
              6,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5
            ];
            var groupBases = [
              0,
              0,
              33554432,
              43046721,
              16777216,
              48828125,
              60466176,
              40353607,
              16777216,
              43046721,
              10000000,
              19487171,
              35831808,
              62748517,
              7529536,
              11390625,
              16777216,
              24137569,
              34012224,
              47045881,
              64000000,
              4084101,
              5153632,
              6436343,
              7962624,
              9765625,
              11881376,
              14348907,
              17210368,
              20511149,
              24300000,
              28629151,
              33554432,
              39135393,
              45435424,
              52521875,
              60466176
            ];
            BN.prototype.toString = function toString(base, padding) {
              base = base || 10;
              padding = padding | 0 || 1;
              var out;
              if (base === 16 || base === "hex") {
                out = "";
                var off = 0;
                var carry = 0;
                for (var i = 0; i < this.length; i++) {
                  var w = this.words[i];
                  var word = (((w << off) | carry) & 0xffffff).toString(16);
                  carry = (w >>> (24 - off)) & 0xffffff;
                  if (carry !== 0 || i !== this.length - 1) {
                    out = zeros[6 - word.length] + word + out;
                  } else {
                    out = word + out;
                  }
                  off += 2;
                  if (off >= 26) {
                    off -= 26;
                    i--;
                  }
                }
                if (carry !== 0) {
                  out = carry.toString(16) + out;
                }
                while (out.length % padding !== 0) {
                  out = "0" + out;
                }
                if (this.negative !== 0) {
                  out = "-" + out;
                }
                return out;
              }
              if (base === (base | 0) && base >= 2 && base <= 36) {
                // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
                var groupSize = groupSizes[base]; // var groupBase = Math.pow(base, groupSize);
                var groupBase = groupBases[base];
                out = "";
                var c = this.clone();
                c.negative = 0;
                while (!c.isZero()) {
                  var r = c.modn(groupBase).toString(base);
                  c = c.idivn(groupBase);
                  if (!c.isZero()) {
                    out = zeros[groupSize - r.length] + r + out;
                  } else {
                    out = r + out;
                  }
                }
                if (this.isZero()) {
                  out = "0" + out;
                }
                while (out.length % padding !== 0) {
                  out = "0" + out;
                }
                if (this.negative !== 0) {
                  out = "-" + out;
                }
                return out;
              }
              assert(false, "Base should be between 2 and 36");
            };
            BN.prototype.toNumber = function toNumber() {
              var ret = this.words[0];
              if (this.length === 2) {
                ret += this.words[1] * 0x4000000;
              } else if (this.length === 3 && this.words[2] === 0x01) {
                // NOTE: at this stage it is known that the top bit is set
                ret += 0x10000000000000 + this.words[1] * 0x4000000;
              } else if (this.length > 2) {
                assert(false, "Number can only safely store up to 53 bits");
              }
              return this.negative !== 0 ? -ret : ret;
            };
            BN.prototype.toJSON = function toJSON() {
              return this.toString(16);
            };
            BN.prototype.toBuffer = function toBuffer(endian, length) {
              assert(typeof Buffer !== "undefined");
              return this.toArrayLike(Buffer, endian, length);
            };
            BN.prototype.toArray = function toArray(endian, length) {
              return this.toArrayLike(Array, endian, length);
            };
            BN.prototype.toArrayLike = function toArrayLike(
              ArrayType,
              endian,
              length
            ) {
              var byteLength = this.byteLength();
              var reqLength = length || Math.max(1, byteLength);
              assert(
                byteLength <= reqLength,
                "byte array longer than desired length"
              );
              assert(reqLength > 0, "Requested array length <= 0");
              this.strip();
              var littleEndian = endian === "le";
              var res = new ArrayType(reqLength);
              var b, i;
              var q = this.clone();
              if (!littleEndian) {
                // Assume big-endian
                for (i = 0; i < reqLength - byteLength; i++) {
                  res[i] = 0;
                }
                for (i = 0; !q.isZero(); i++) {
                  b = q.andln(0xff);
                  q.iushrn(8);
                  res[reqLength - i - 1] = b;
                }
              } else {
                for (i = 0; !q.isZero(); i++) {
                  b = q.andln(0xff);
                  q.iushrn(8);
                  res[i] = b;
                }
                for (; i < reqLength; i++) {
                  res[i] = 0;
                }
              }
              return res;
            };
            if (Math.clz32) {
              BN.prototype._countBits = function _countBits(w) {
                return 32 - Math.clz32(w);
              };
            } else {
              BN.prototype._countBits = function _countBits(w) {
                var t = w;
                var r = 0;
                if (t >= 0x1000) {
                  r += 13;
                  t >>>= 13;
                }
                if (t >= 0x40) {
                  r += 7;
                  t >>>= 7;
                }
                if (t >= 0x8) {
                  r += 4;
                  t >>>= 4;
                }
                if (t >= 0x02) {
                  r += 2;
                  t >>>= 2;
                }
                return r + t;
              };
            }
            BN.prototype._zeroBits = function _zeroBits(w) {
              // Short-cut
              if (w === 0) return 26;
              var t = w;
              var r = 0;
              if ((t & 0x1fff) === 0) {
                r += 13;
                t >>>= 13;
              }
              if ((t & 0x7f) === 0) {
                r += 7;
                t >>>= 7;
              }
              if ((t & 0xf) === 0) {
                r += 4;
                t >>>= 4;
              }
              if ((t & 0x3) === 0) {
                r += 2;
                t >>>= 2;
              }
              if ((t & 0x1) === 0) {
                r++;
              }
              return r;
            }; // Return number of used bits in a BN
            BN.prototype.bitLength = function bitLength() {
              var w = this.words[this.length - 1];
              var hi = this._countBits(w);
              return (this.length - 1) * 26 + hi;
            };
            function toBitArray(num) {
              var w = new Array(num.bitLength());
              for (var bit = 0; bit < w.length; bit++) {
                var off = (bit / 26) | 0;
                var wbit = bit % 26;
                w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
              }
              return w;
            } // Number of trailing zero bits
            BN.prototype.zeroBits = function zeroBits() {
              if (this.isZero()) return 0;
              var r = 0;
              for (var i = 0; i < this.length; i++) {
                var b = this._zeroBits(this.words[i]);
                r += b;
                if (b !== 26) break;
              }
              return r;
            };
            BN.prototype.byteLength = function byteLength() {
              return Math.ceil(this.bitLength() / 8);
            };
            BN.prototype.toTwos = function toTwos(width) {
              if (this.negative !== 0) {
                return this.abs().inotn(width).iaddn(1);
              }
              return this.clone();
            };
            BN.prototype.fromTwos = function fromTwos(width) {
              if (this.testn(width - 1)) {
                return this.notn(width).iaddn(1).ineg();
              }
              return this.clone();
            };
            BN.prototype.isNeg = function isNeg() {
              return this.negative !== 0;
            }; // Return negative clone of `this`
            BN.prototype.neg = function neg() {
              return this.clone().ineg();
            };
            BN.prototype.ineg = function ineg() {
              if (!this.isZero()) {
                this.negative ^= 1;
              }
              return this;
            }; // Or `num` with `this` in-place
            BN.prototype.iuor = function iuor(num) {
              while (this.length < num.length) {
                this.words[this.length++] = 0;
              }
              for (var i = 0; i < num.length; i++) {
                this.words[i] = this.words[i] | num.words[i];
              }
              return this.strip();
            };
            BN.prototype.ior = function ior(num) {
              assert((this.negative | num.negative) === 0);
              return this.iuor(num);
            }; // Or `num` with `this`
            BN.prototype.or = function or(num) {
              if (this.length > num.length) return this.clone().ior(num);
              return num.clone().ior(this);
            };
            BN.prototype.uor = function uor(num) {
              if (this.length > num.length) return this.clone().iuor(num);
              return num.clone().iuor(this);
            }; // And `num` with `this` in-place
            BN.prototype.iuand = function iuand(num) {
              // b = min-length(num, this)
              var b;
              if (this.length > num.length) {
                b = num;
              } else {
                b = this;
              }
              for (var i = 0; i < b.length; i++) {
                this.words[i] = this.words[i] & num.words[i];
              }
              this.length = b.length;
              return this.strip();
            };
            BN.prototype.iand = function iand(num) {
              assert((this.negative | num.negative) === 0);
              return this.iuand(num);
            }; // And `num` with `this`
            BN.prototype.and = function and(num) {
              if (this.length > num.length) return this.clone().iand(num);
              return num.clone().iand(this);
            };
            BN.prototype.uand = function uand(num) {
              if (this.length > num.length) return this.clone().iuand(num);
              return num.clone().iuand(this);
            }; // Xor `num` with `this` in-place
            BN.prototype.iuxor = function iuxor(num) {
              // a.length > b.length
              var a;
              var b;
              if (this.length > num.length) {
                a = this;
                b = num;
              } else {
                a = num;
                b = this;
              }
              for (var i = 0; i < b.length; i++) {
                this.words[i] = a.words[i] ^ b.words[i];
              }
              if (this !== a) {
                for (; i < a.length; i++) {
                  this.words[i] = a.words[i];
                }
              }
              this.length = a.length;
              return this.strip();
            };
            BN.prototype.ixor = function ixor(num) {
              assert((this.negative | num.negative) === 0);
              return this.iuxor(num);
            }; // Xor `num` with `this`
            BN.prototype.xor = function xor(num) {
              if (this.length > num.length) return this.clone().ixor(num);
              return num.clone().ixor(this);
            };
            BN.prototype.uxor = function uxor(num) {
              if (this.length > num.length) return this.clone().iuxor(num);
              return num.clone().iuxor(this);
            }; // Not ``this`` with ``width`` bitwidth
            BN.prototype.inotn = function inotn(width) {
              assert(typeof width === "number" && width >= 0);
              var bytesNeeded = Math.ceil(width / 26) | 0;
              var bitsLeft = width % 26; // Extend the buffer with leading zeroes
              this._expand(bytesNeeded);
              if (bitsLeft > 0) {
                bytesNeeded--;
              } // Handle complete words
              for (var i = 0; i < bytesNeeded; i++) {
                this.words[i] = ~this.words[i] & 0x3ffffff;
              } // Handle the residue
              if (bitsLeft > 0) {
                this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
              } // And remove leading zeroes
              return this.strip();
            };
            BN.prototype.notn = function notn(width) {
              return this.clone().inotn(width);
            }; // Set `bit` of `this`
            BN.prototype.setn = function setn(bit, val) {
              assert(typeof bit === "number" && bit >= 0);
              var off = (bit / 26) | 0;
              var wbit = bit % 26;
              this._expand(off + 1);
              if (val) {
                this.words[off] = this.words[off] | (1 << wbit);
              } else {
                this.words[off] = this.words[off] & ~(1 << wbit);
              }
              return this.strip();
            }; // Add `num` to `this` in-place
            BN.prototype.iadd = function iadd(num) {
              var r; // negative + positive
              if (this.negative !== 0 && num.negative === 0) {
                this.negative = 0;
                r = this.isub(num);
                this.negative ^= 1;
                return this._normSign(); // positive + negative
              } else if (this.negative === 0 && num.negative !== 0) {
                num.negative = 0;
                r = this.isub(num);
                num.negative = 1;
                return r._normSign();
              } // a.length > b.length
              var a, b;
              if (this.length > num.length) {
                a = this;
                b = num;
              } else {
                a = num;
                b = this;
              }
              var carry = 0;
              for (var i = 0; i < b.length; i++) {
                r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
                this.words[i] = r & 0x3ffffff;
                carry = r >>> 26;
              }
              for (; carry !== 0 && i < a.length; i++) {
                r = (a.words[i] | 0) + carry;
                this.words[i] = r & 0x3ffffff;
                carry = r >>> 26;
              }
              this.length = a.length;
              if (carry !== 0) {
                this.words[this.length] = carry;
                this.length++; // Copy the rest of the words
              } else if (a !== this) {
                for (; i < a.length; i++) {
                  this.words[i] = a.words[i];
                }
              }
              return this;
            }; // Add `num` to `this`
            BN.prototype.add = function add(num) {
              var res;
              if (num.negative !== 0 && this.negative === 0) {
                num.negative = 0;
                res = this.sub(num);
                num.negative ^= 1;
                return res;
              } else if (num.negative === 0 && this.negative !== 0) {
                this.negative = 0;
                res = num.sub(this);
                this.negative = 1;
                return res;
              }
              if (this.length > num.length) return this.clone().iadd(num);
              return num.clone().iadd(this);
            }; // Subtract `num` from `this` in-place
            BN.prototype.isub = function isub(num) {
              // this - (-num) = this + num
              if (num.negative !== 0) {
                num.negative = 0;
                var r = this.iadd(num);
                num.negative = 1;
                return r._normSign(); // -this - num = -(this + num)
              } else if (this.negative !== 0) {
                this.negative = 0;
                this.iadd(num);
                this.negative = 1;
                return this._normSign();
              } // At this point both numbers are positive
              var cmp = this.cmp(num); // Optimization - zeroify
              if (cmp === 0) {
                this.negative = 0;
                this.length = 1;
                this.words[0] = 0;
                return this;
              } // a > b
              var a, b;
              if (cmp > 0) {
                a = this;
                b = num;
              } else {
                a = num;
                b = this;
              }
              var carry = 0;
              for (var i = 0; i < b.length; i++) {
                r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
                carry = r >> 26;
                this.words[i] = r & 0x3ffffff;
              }
              for (; carry !== 0 && i < a.length; i++) {
                r = (a.words[i] | 0) + carry;
                carry = r >> 26;
                this.words[i] = r & 0x3ffffff;
              } // Copy rest of the words
              if (carry === 0 && i < a.length && a !== this) {
                for (; i < a.length; i++) {
                  this.words[i] = a.words[i];
                }
              }
              this.length = Math.max(this.length, i);
              if (a !== this) {
                this.negative = 1;
              }
              return this.strip();
            }; // Subtract `num` from `this`
            BN.prototype.sub = function sub(num) {
              return this.clone().isub(num);
            };
            function smallMulTo(self, num, out) {
              out.negative = num.negative ^ self.negative;
              var len = (self.length + num.length) | 0;
              out.length = len;
              len = (len - 1) | 0; // Peel one iteration (compiler can't do it, because of code complexity)
              var a = self.words[0] | 0;
              var b = num.words[0] | 0;
              var r = a * b;
              var lo = r & 0x3ffffff;
              var carry = (r / 0x4000000) | 0;
              out.words[0] = lo;
              for (var k = 1; k < len; k++) {
                // Sum all words with the same `i + j = k` and accumulate `ncarry`,
                // note that ncarry could be >= 0x3ffffff
                var ncarry = carry >>> 26;
                var rword = carry & 0x3ffffff;
                var maxJ = Math.min(k, num.length - 1);
                for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
                  var i = (k - j) | 0;
                  a = self.words[i] | 0;
                  b = num.words[j] | 0;
                  r = a * b + rword;
                  ncarry += (r / 0x4000000) | 0;
                  rword = r & 0x3ffffff;
                }
                out.words[k] = rword | 0;
                carry = ncarry | 0;
              }
              if (carry !== 0) {
                out.words[k] = carry | 0;
              } else {
                out.length--;
              }
              return out.strip();
            } // TODO(indutny): it may be reasonable to omit it for users who don't need
            // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
            // multiplication (like elliptic secp256k1).
            var comb10MulTo = function comb10MulTo(self, num, out) {
              var a = self.words;
              var b = num.words;
              var o = out.words;
              var c = 0;
              var lo;
              var mid;
              var hi;
              var a0 = a[0] | 0;
              var al0 = a0 & 0x1fff;
              var ah0 = a0 >>> 13;
              var a1 = a[1] | 0;
              var al1 = a1 & 0x1fff;
              var ah1 = a1 >>> 13;
              var a2 = a[2] | 0;
              var al2 = a2 & 0x1fff;
              var ah2 = a2 >>> 13;
              var a3 = a[3] | 0;
              var al3 = a3 & 0x1fff;
              var ah3 = a3 >>> 13;
              var a4 = a[4] | 0;
              var al4 = a4 & 0x1fff;
              var ah4 = a4 >>> 13;
              var a5 = a[5] | 0;
              var al5 = a5 & 0x1fff;
              var ah5 = a5 >>> 13;
              var a6 = a[6] | 0;
              var al6 = a6 & 0x1fff;
              var ah6 = a6 >>> 13;
              var a7 = a[7] | 0;
              var al7 = a7 & 0x1fff;
              var ah7 = a7 >>> 13;
              var a8 = a[8] | 0;
              var al8 = a8 & 0x1fff;
              var ah8 = a8 >>> 13;
              var a9 = a[9] | 0;
              var al9 = a9 & 0x1fff;
              var ah9 = a9 >>> 13;
              var b0 = b[0] | 0;
              var bl0 = b0 & 0x1fff;
              var bh0 = b0 >>> 13;
              var b1 = b[1] | 0;
              var bl1 = b1 & 0x1fff;
              var bh1 = b1 >>> 13;
              var b2 = b[2] | 0;
              var bl2 = b2 & 0x1fff;
              var bh2 = b2 >>> 13;
              var b3 = b[3] | 0;
              var bl3 = b3 & 0x1fff;
              var bh3 = b3 >>> 13;
              var b4 = b[4] | 0;
              var bl4 = b4 & 0x1fff;
              var bh4 = b4 >>> 13;
              var b5 = b[5] | 0;
              var bl5 = b5 & 0x1fff;
              var bh5 = b5 >>> 13;
              var b6 = b[6] | 0;
              var bl6 = b6 & 0x1fff;
              var bh6 = b6 >>> 13;
              var b7 = b[7] | 0;
              var bl7 = b7 & 0x1fff;
              var bh7 = b7 >>> 13;
              var b8 = b[8] | 0;
              var bl8 = b8 & 0x1fff;
              var bh8 = b8 >>> 13;
              var b9 = b[9] | 0;
              var bl9 = b9 & 0x1fff;
              var bh9 = b9 >>> 13;
              out.negative = self.negative ^ num.negative;
              out.length = 19;
              /* k = 0 */ lo = Math.imul(al0, bl0);
              mid = Math.imul(al0, bh0);
              mid = (mid + Math.imul(ah0, bl0)) | 0;
              hi = Math.imul(ah0, bh0);
              var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
              w0 &= 0x3ffffff;
              /* k = 1 */ lo = Math.imul(al1, bl0);
              mid = Math.imul(al1, bh0);
              mid = (mid + Math.imul(ah1, bl0)) | 0;
              hi = Math.imul(ah1, bh0);
              lo = (lo + Math.imul(al0, bl1)) | 0;
              mid = (mid + Math.imul(al0, bh1)) | 0;
              mid = (mid + Math.imul(ah0, bl1)) | 0;
              hi = (hi + Math.imul(ah0, bh1)) | 0;
              var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
              w1 &= 0x3ffffff;
              /* k = 2 */ lo = Math.imul(al2, bl0);
              mid = Math.imul(al2, bh0);
              mid = (mid + Math.imul(ah2, bl0)) | 0;
              hi = Math.imul(ah2, bh0);
              lo = (lo + Math.imul(al1, bl1)) | 0;
              mid = (mid + Math.imul(al1, bh1)) | 0;
              mid = (mid + Math.imul(ah1, bl1)) | 0;
              hi = (hi + Math.imul(ah1, bh1)) | 0;
              lo = (lo + Math.imul(al0, bl2)) | 0;
              mid = (mid + Math.imul(al0, bh2)) | 0;
              mid = (mid + Math.imul(ah0, bl2)) | 0;
              hi = (hi + Math.imul(ah0, bh2)) | 0;
              var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
              w2 &= 0x3ffffff;
              /* k = 3 */ lo = Math.imul(al3, bl0);
              mid = Math.imul(al3, bh0);
              mid = (mid + Math.imul(ah3, bl0)) | 0;
              hi = Math.imul(ah3, bh0);
              lo = (lo + Math.imul(al2, bl1)) | 0;
              mid = (mid + Math.imul(al2, bh1)) | 0;
              mid = (mid + Math.imul(ah2, bl1)) | 0;
              hi = (hi + Math.imul(ah2, bh1)) | 0;
              lo = (lo + Math.imul(al1, bl2)) | 0;
              mid = (mid + Math.imul(al1, bh2)) | 0;
              mid = (mid + Math.imul(ah1, bl2)) | 0;
              hi = (hi + Math.imul(ah1, bh2)) | 0;
              lo = (lo + Math.imul(al0, bl3)) | 0;
              mid = (mid + Math.imul(al0, bh3)) | 0;
              mid = (mid + Math.imul(ah0, bl3)) | 0;
              hi = (hi + Math.imul(ah0, bh3)) | 0;
              var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
              w3 &= 0x3ffffff;
              /* k = 4 */ lo = Math.imul(al4, bl0);
              mid = Math.imul(al4, bh0);
              mid = (mid + Math.imul(ah4, bl0)) | 0;
              hi = Math.imul(ah4, bh0);
              lo = (lo + Math.imul(al3, bl1)) | 0;
              mid = (mid + Math.imul(al3, bh1)) | 0;
              mid = (mid + Math.imul(ah3, bl1)) | 0;
              hi = (hi + Math.imul(ah3, bh1)) | 0;
              lo = (lo + Math.imul(al2, bl2)) | 0;
              mid = (mid + Math.imul(al2, bh2)) | 0;
              mid = (mid + Math.imul(ah2, bl2)) | 0;
              hi = (hi + Math.imul(ah2, bh2)) | 0;
              lo = (lo + Math.imul(al1, bl3)) | 0;
              mid = (mid + Math.imul(al1, bh3)) | 0;
              mid = (mid + Math.imul(ah1, bl3)) | 0;
              hi = (hi + Math.imul(ah1, bh3)) | 0;
              lo = (lo + Math.imul(al0, bl4)) | 0;
              mid = (mid + Math.imul(al0, bh4)) | 0;
              mid = (mid + Math.imul(ah0, bl4)) | 0;
              hi = (hi + Math.imul(ah0, bh4)) | 0;
              var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
              w4 &= 0x3ffffff;
              /* k = 5 */ lo = Math.imul(al5, bl0);
              mid = Math.imul(al5, bh0);
              mid = (mid + Math.imul(ah5, bl0)) | 0;
              hi = Math.imul(ah5, bh0);
              lo = (lo + Math.imul(al4, bl1)) | 0;
              mid = (mid + Math.imul(al4, bh1)) | 0;
              mid = (mid + Math.imul(ah4, bl1)) | 0;
              hi = (hi + Math.imul(ah4, bh1)) | 0;
              lo = (lo + Math.imul(al3, bl2)) | 0;
              mid = (mid + Math.imul(al3, bh2)) | 0;
              mid = (mid + Math.imul(ah3, bl2)) | 0;
              hi = (hi + Math.imul(ah3, bh2)) | 0;
              lo = (lo + Math.imul(al2, bl3)) | 0;
              mid = (mid + Math.imul(al2, bh3)) | 0;
              mid = (mid + Math.imul(ah2, bl3)) | 0;
              hi = (hi + Math.imul(ah2, bh3)) | 0;
              lo = (lo + Math.imul(al1, bl4)) | 0;
              mid = (mid + Math.imul(al1, bh4)) | 0;
              mid = (mid + Math.imul(ah1, bl4)) | 0;
              hi = (hi + Math.imul(ah1, bh4)) | 0;
              lo = (lo + Math.imul(al0, bl5)) | 0;
              mid = (mid + Math.imul(al0, bh5)) | 0;
              mid = (mid + Math.imul(ah0, bl5)) | 0;
              hi = (hi + Math.imul(ah0, bh5)) | 0;
              var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
              w5 &= 0x3ffffff;
              /* k = 6 */ lo = Math.imul(al6, bl0);
              mid = Math.imul(al6, bh0);
              mid = (mid + Math.imul(ah6, bl0)) | 0;
              hi = Math.imul(ah6, bh0);
              lo = (lo + Math.imul(al5, bl1)) | 0;
              mid = (mid + Math.imul(al5, bh1)) | 0;
              mid = (mid + Math.imul(ah5, bl1)) | 0;
              hi = (hi + Math.imul(ah5, bh1)) | 0;
              lo = (lo + Math.imul(al4, bl2)) | 0;
              mid = (mid + Math.imul(al4, bh2)) | 0;
              mid = (mid + Math.imul(ah4, bl2)) | 0;
              hi = (hi + Math.imul(ah4, bh2)) | 0;
              lo = (lo + Math.imul(al3, bl3)) | 0;
              mid = (mid + Math.imul(al3, bh3)) | 0;
              mid = (mid + Math.imul(ah3, bl3)) | 0;
              hi = (hi + Math.imul(ah3, bh3)) | 0;
              lo = (lo + Math.imul(al2, bl4)) | 0;
              mid = (mid + Math.imul(al2, bh4)) | 0;
              mid = (mid + Math.imul(ah2, bl4)) | 0;
              hi = (hi + Math.imul(ah2, bh4)) | 0;
              lo = (lo + Math.imul(al1, bl5)) | 0;
              mid = (mid + Math.imul(al1, bh5)) | 0;
              mid = (mid + Math.imul(ah1, bl5)) | 0;
              hi = (hi + Math.imul(ah1, bh5)) | 0;
              lo = (lo + Math.imul(al0, bl6)) | 0;
              mid = (mid + Math.imul(al0, bh6)) | 0;
              mid = (mid + Math.imul(ah0, bl6)) | 0;
              hi = (hi + Math.imul(ah0, bh6)) | 0;
              var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
              w6 &= 0x3ffffff;
              /* k = 7 */ lo = Math.imul(al7, bl0);
              mid = Math.imul(al7, bh0);
              mid = (mid + Math.imul(ah7, bl0)) | 0;
              hi = Math.imul(ah7, bh0);
              lo = (lo + Math.imul(al6, bl1)) | 0;
              mid = (mid + Math.imul(al6, bh1)) | 0;
              mid = (mid + Math.imul(ah6, bl1)) | 0;
              hi = (hi + Math.imul(ah6, bh1)) | 0;
              lo = (lo + Math.imul(al5, bl2)) | 0;
              mid = (mid + Math.imul(al5, bh2)) | 0;
              mid = (mid + Math.imul(ah5, bl2)) | 0;
              hi = (hi + Math.imul(ah5, bh2)) | 0;
              lo = (lo + Math.imul(al4, bl3)) | 0;
              mid = (mid + Math.imul(al4, bh3)) | 0;
              mid = (mid + Math.imul(ah4, bl3)) | 0;
              hi = (hi + Math.imul(ah4, bh3)) | 0;
              lo = (lo + Math.imul(al3, bl4)) | 0;
              mid = (mid + Math.imul(al3, bh4)) | 0;
              mid = (mid + Math.imul(ah3, bl4)) | 0;
              hi = (hi + Math.imul(ah3, bh4)) | 0;
              lo = (lo + Math.imul(al2, bl5)) | 0;
              mid = (mid + Math.imul(al2, bh5)) | 0;
              mid = (mid + Math.imul(ah2, bl5)) | 0;
              hi = (hi + Math.imul(ah2, bh5)) | 0;
              lo = (lo + Math.imul(al1, bl6)) | 0;
              mid = (mid + Math.imul(al1, bh6)) | 0;
              mid = (mid + Math.imul(ah1, bl6)) | 0;
              hi = (hi + Math.imul(ah1, bh6)) | 0;
              lo = (lo + Math.imul(al0, bl7)) | 0;
              mid = (mid + Math.imul(al0, bh7)) | 0;
              mid = (mid + Math.imul(ah0, bl7)) | 0;
              hi = (hi + Math.imul(ah0, bh7)) | 0;
              var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
              w7 &= 0x3ffffff;
              /* k = 8 */ lo = Math.imul(al8, bl0);
              mid = Math.imul(al8, bh0);
              mid = (mid + Math.imul(ah8, bl0)) | 0;
              hi = Math.imul(ah8, bh0);
              lo = (lo + Math.imul(al7, bl1)) | 0;
              mid = (mid + Math.imul(al7, bh1)) | 0;
              mid = (mid + Math.imul(ah7, bl1)) | 0;
              hi = (hi + Math.imul(ah7, bh1)) | 0;
              lo = (lo + Math.imul(al6, bl2)) | 0;
              mid = (mid + Math.imul(al6, bh2)) | 0;
              mid = (mid + Math.imul(ah6, bl2)) | 0;
              hi = (hi + Math.imul(ah6, bh2)) | 0;
              lo = (lo + Math.imul(al5, bl3)) | 0;
              mid = (mid + Math.imul(al5, bh3)) | 0;
              mid = (mid + Math.imul(ah5, bl3)) | 0;
              hi = (hi + Math.imul(ah5, bh3)) | 0;
              lo = (lo + Math.imul(al4, bl4)) | 0;
              mid = (mid + Math.imul(al4, bh4)) | 0;
              mid = (mid + Math.imul(ah4, bl4)) | 0;
              hi = (hi + Math.imul(ah4, bh4)) | 0;
              lo = (lo + Math.imul(al3, bl5)) | 0;
              mid = (mid + Math.imul(al3, bh5)) | 0;
              mid = (mid + Math.imul(ah3, bl5)) | 0;
              hi = (hi + Math.imul(ah3, bh5)) | 0;
              lo = (lo + Math.imul(al2, bl6)) | 0;
              mid = (mid + Math.imul(al2, bh6)) | 0;
              mid = (mid + Math.imul(ah2, bl6)) | 0;
              hi = (hi + Math.imul(ah2, bh6)) | 0;
              lo = (lo + Math.imul(al1, bl7)) | 0;
              mid = (mid + Math.imul(al1, bh7)) | 0;
              mid = (mid + Math.imul(ah1, bl7)) | 0;
              hi = (hi + Math.imul(ah1, bh7)) | 0;
              lo = (lo + Math.imul(al0, bl8)) | 0;
              mid = (mid + Math.imul(al0, bh8)) | 0;
              mid = (mid + Math.imul(ah0, bl8)) | 0;
              hi = (hi + Math.imul(ah0, bh8)) | 0;
              var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
              w8 &= 0x3ffffff;
              /* k = 9 */ lo = Math.imul(al9, bl0);
              mid = Math.imul(al9, bh0);
              mid = (mid + Math.imul(ah9, bl0)) | 0;
              hi = Math.imul(ah9, bh0);
              lo = (lo + Math.imul(al8, bl1)) | 0;
              mid = (mid + Math.imul(al8, bh1)) | 0;
              mid = (mid + Math.imul(ah8, bl1)) | 0;
              hi = (hi + Math.imul(ah8, bh1)) | 0;
              lo = (lo + Math.imul(al7, bl2)) | 0;
              mid = (mid + Math.imul(al7, bh2)) | 0;
              mid = (mid + Math.imul(ah7, bl2)) | 0;
              hi = (hi + Math.imul(ah7, bh2)) | 0;
              lo = (lo + Math.imul(al6, bl3)) | 0;
              mid = (mid + Math.imul(al6, bh3)) | 0;
              mid = (mid + Math.imul(ah6, bl3)) | 0;
              hi = (hi + Math.imul(ah6, bh3)) | 0;
              lo = (lo + Math.imul(al5, bl4)) | 0;
              mid = (mid + Math.imul(al5, bh4)) | 0;
              mid = (mid + Math.imul(ah5, bl4)) | 0;
              hi = (hi + Math.imul(ah5, bh4)) | 0;
              lo = (lo + Math.imul(al4, bl5)) | 0;
              mid = (mid + Math.imul(al4, bh5)) | 0;
              mid = (mid + Math.imul(ah4, bl5)) | 0;
              hi = (hi + Math.imul(ah4, bh5)) | 0;
              lo = (lo + Math.imul(al3, bl6)) | 0;
              mid = (mid + Math.imul(al3, bh6)) | 0;
              mid = (mid + Math.imul(ah3, bl6)) | 0;
              hi = (hi + Math.imul(ah3, bh6)) | 0;
              lo = (lo + Math.imul(al2, bl7)) | 0;
              mid = (mid + Math.imul(al2, bh7)) | 0;
              mid = (mid + Math.imul(ah2, bl7)) | 0;
              hi = (hi + Math.imul(ah2, bh7)) | 0;
              lo = (lo + Math.imul(al1, bl8)) | 0;
              mid = (mid + Math.imul(al1, bh8)) | 0;
              mid = (mid + Math.imul(ah1, bl8)) | 0;
              hi = (hi + Math.imul(ah1, bh8)) | 0;
              lo = (lo + Math.imul(al0, bl9)) | 0;
              mid = (mid + Math.imul(al0, bh9)) | 0;
              mid = (mid + Math.imul(ah0, bl9)) | 0;
              hi = (hi + Math.imul(ah0, bh9)) | 0;
              var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
              w9 &= 0x3ffffff;
              /* k = 10 */ lo = Math.imul(al9, bl1);
              mid = Math.imul(al9, bh1);
              mid = (mid + Math.imul(ah9, bl1)) | 0;
              hi = Math.imul(ah9, bh1);
              lo = (lo + Math.imul(al8, bl2)) | 0;
              mid = (mid + Math.imul(al8, bh2)) | 0;
              mid = (mid + Math.imul(ah8, bl2)) | 0;
              hi = (hi + Math.imul(ah8, bh2)) | 0;
              lo = (lo + Math.imul(al7, bl3)) | 0;
              mid = (mid + Math.imul(al7, bh3)) | 0;
              mid = (mid + Math.imul(ah7, bl3)) | 0;
              hi = (hi + Math.imul(ah7, bh3)) | 0;
              lo = (lo + Math.imul(al6, bl4)) | 0;
              mid = (mid + Math.imul(al6, bh4)) | 0;
              mid = (mid + Math.imul(ah6, bl4)) | 0;
              hi = (hi + Math.imul(ah6, bh4)) | 0;
              lo = (lo + Math.imul(al5, bl5)) | 0;
              mid = (mid + Math.imul(al5, bh5)) | 0;
              mid = (mid + Math.imul(ah5, bl5)) | 0;
              hi = (hi + Math.imul(ah5, bh5)) | 0;
              lo = (lo + Math.imul(al4, bl6)) | 0;
              mid = (mid + Math.imul(al4, bh6)) | 0;
              mid = (mid + Math.imul(ah4, bl6)) | 0;
              hi = (hi + Math.imul(ah4, bh6)) | 0;
              lo = (lo + Math.imul(al3, bl7)) | 0;
              mid = (mid + Math.imul(al3, bh7)) | 0;
              mid = (mid + Math.imul(ah3, bl7)) | 0;
              hi = (hi + Math.imul(ah3, bh7)) | 0;
              lo = (lo + Math.imul(al2, bl8)) | 0;
              mid = (mid + Math.imul(al2, bh8)) | 0;
              mid = (mid + Math.imul(ah2, bl8)) | 0;
              hi = (hi + Math.imul(ah2, bh8)) | 0;
              lo = (lo + Math.imul(al1, bl9)) | 0;
              mid = (mid + Math.imul(al1, bh9)) | 0;
              mid = (mid + Math.imul(ah1, bl9)) | 0;
              hi = (hi + Math.imul(ah1, bh9)) | 0;
              var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
              w10 &= 0x3ffffff;
              /* k = 11 */ lo = Math.imul(al9, bl2);
              mid = Math.imul(al9, bh2);
              mid = (mid + Math.imul(ah9, bl2)) | 0;
              hi = Math.imul(ah9, bh2);
              lo = (lo + Math.imul(al8, bl3)) | 0;
              mid = (mid + Math.imul(al8, bh3)) | 0;
              mid = (mid + Math.imul(ah8, bl3)) | 0;
              hi = (hi + Math.imul(ah8, bh3)) | 0;
              lo = (lo + Math.imul(al7, bl4)) | 0;
              mid = (mid + Math.imul(al7, bh4)) | 0;
              mid = (mid + Math.imul(ah7, bl4)) | 0;
              hi = (hi + Math.imul(ah7, bh4)) | 0;
              lo = (lo + Math.imul(al6, bl5)) | 0;
              mid = (mid + Math.imul(al6, bh5)) | 0;
              mid = (mid + Math.imul(ah6, bl5)) | 0;
              hi = (hi + Math.imul(ah6, bh5)) | 0;
              lo = (lo + Math.imul(al5, bl6)) | 0;
              mid = (mid + Math.imul(al5, bh6)) | 0;
              mid = (mid + Math.imul(ah5, bl6)) | 0;
              hi = (hi + Math.imul(ah5, bh6)) | 0;
              lo = (lo + Math.imul(al4, bl7)) | 0;
              mid = (mid + Math.imul(al4, bh7)) | 0;
              mid = (mid + Math.imul(ah4, bl7)) | 0;
              hi = (hi + Math.imul(ah4, bh7)) | 0;
              lo = (lo + Math.imul(al3, bl8)) | 0;
              mid = (mid + Math.imul(al3, bh8)) | 0;
              mid = (mid + Math.imul(ah3, bl8)) | 0;
              hi = (hi + Math.imul(ah3, bh8)) | 0;
              lo = (lo + Math.imul(al2, bl9)) | 0;
              mid = (mid + Math.imul(al2, bh9)) | 0;
              mid = (mid + Math.imul(ah2, bl9)) | 0;
              hi = (hi + Math.imul(ah2, bh9)) | 0;
              var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
              w11 &= 0x3ffffff;
              /* k = 12 */ lo = Math.imul(al9, bl3);
              mid = Math.imul(al9, bh3);
              mid = (mid + Math.imul(ah9, bl3)) | 0;
              hi = Math.imul(ah9, bh3);
              lo = (lo + Math.imul(al8, bl4)) | 0;
              mid = (mid + Math.imul(al8, bh4)) | 0;
              mid = (mid + Math.imul(ah8, bl4)) | 0;
              hi = (hi + Math.imul(ah8, bh4)) | 0;
              lo = (lo + Math.imul(al7, bl5)) | 0;
              mid = (mid + Math.imul(al7, bh5)) | 0;
              mid = (mid + Math.imul(ah7, bl5)) | 0;
              hi = (hi + Math.imul(ah7, bh5)) | 0;
              lo = (lo + Math.imul(al6, bl6)) | 0;
              mid = (mid + Math.imul(al6, bh6)) | 0;
              mid = (mid + Math.imul(ah6, bl6)) | 0;
              hi = (hi + Math.imul(ah6, bh6)) | 0;
              lo = (lo + Math.imul(al5, bl7)) | 0;
              mid = (mid + Math.imul(al5, bh7)) | 0;
              mid = (mid + Math.imul(ah5, bl7)) | 0;
              hi = (hi + Math.imul(ah5, bh7)) | 0;
              lo = (lo + Math.imul(al4, bl8)) | 0;
              mid = (mid + Math.imul(al4, bh8)) | 0;
              mid = (mid + Math.imul(ah4, bl8)) | 0;
              hi = (hi + Math.imul(ah4, bh8)) | 0;
              lo = (lo + Math.imul(al3, bl9)) | 0;
              mid = (mid + Math.imul(al3, bh9)) | 0;
              mid = (mid + Math.imul(ah3, bl9)) | 0;
              hi = (hi + Math.imul(ah3, bh9)) | 0;
              var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
              w12 &= 0x3ffffff;
              /* k = 13 */ lo = Math.imul(al9, bl4);
              mid = Math.imul(al9, bh4);
              mid = (mid + Math.imul(ah9, bl4)) | 0;
              hi = Math.imul(ah9, bh4);
              lo = (lo + Math.imul(al8, bl5)) | 0;
              mid = (mid + Math.imul(al8, bh5)) | 0;
              mid = (mid + Math.imul(ah8, bl5)) | 0;
              hi = (hi + Math.imul(ah8, bh5)) | 0;
              lo = (lo + Math.imul(al7, bl6)) | 0;
              mid = (mid + Math.imul(al7, bh6)) | 0;
              mid = (mid + Math.imul(ah7, bl6)) | 0;
              hi = (hi + Math.imul(ah7, bh6)) | 0;
              lo = (lo + Math.imul(al6, bl7)) | 0;
              mid = (mid + Math.imul(al6, bh7)) | 0;
              mid = (mid + Math.imul(ah6, bl7)) | 0;
              hi = (hi + Math.imul(ah6, bh7)) | 0;
              lo = (lo + Math.imul(al5, bl8)) | 0;
              mid = (mid + Math.imul(al5, bh8)) | 0;
              mid = (mid + Math.imul(ah5, bl8)) | 0;
              hi = (hi + Math.imul(ah5, bh8)) | 0;
              lo = (lo + Math.imul(al4, bl9)) | 0;
              mid = (mid + Math.imul(al4, bh9)) | 0;
              mid = (mid + Math.imul(ah4, bl9)) | 0;
              hi = (hi + Math.imul(ah4, bh9)) | 0;
              var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
              w13 &= 0x3ffffff;
              /* k = 14 */ lo = Math.imul(al9, bl5);
              mid = Math.imul(al9, bh5);
              mid = (mid + Math.imul(ah9, bl5)) | 0;
              hi = Math.imul(ah9, bh5);
              lo = (lo + Math.imul(al8, bl6)) | 0;
              mid = (mid + Math.imul(al8, bh6)) | 0;
              mid = (mid + Math.imul(ah8, bl6)) | 0;
              hi = (hi + Math.imul(ah8, bh6)) | 0;
              lo = (lo + Math.imul(al7, bl7)) | 0;
              mid = (mid + Math.imul(al7, bh7)) | 0;
              mid = (mid + Math.imul(ah7, bl7)) | 0;
              hi = (hi + Math.imul(ah7, bh7)) | 0;
              lo = (lo + Math.imul(al6, bl8)) | 0;
              mid = (mid + Math.imul(al6, bh8)) | 0;
              mid = (mid + Math.imul(ah6, bl8)) | 0;
              hi = (hi + Math.imul(ah6, bh8)) | 0;
              lo = (lo + Math.imul(al5, bl9)) | 0;
              mid = (mid + Math.imul(al5, bh9)) | 0;
              mid = (mid + Math.imul(ah5, bl9)) | 0;
              hi = (hi + Math.imul(ah5, bh9)) | 0;
              var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
              w14 &= 0x3ffffff;
              /* k = 15 */ lo = Math.imul(al9, bl6);
              mid = Math.imul(al9, bh6);
              mid = (mid + Math.imul(ah9, bl6)) | 0;
              hi = Math.imul(ah9, bh6);
              lo = (lo + Math.imul(al8, bl7)) | 0;
              mid = (mid + Math.imul(al8, bh7)) | 0;
              mid = (mid + Math.imul(ah8, bl7)) | 0;
              hi = (hi + Math.imul(ah8, bh7)) | 0;
              lo = (lo + Math.imul(al7, bl8)) | 0;
              mid = (mid + Math.imul(al7, bh8)) | 0;
              mid = (mid + Math.imul(ah7, bl8)) | 0;
              hi = (hi + Math.imul(ah7, bh8)) | 0;
              lo = (lo + Math.imul(al6, bl9)) | 0;
              mid = (mid + Math.imul(al6, bh9)) | 0;
              mid = (mid + Math.imul(ah6, bl9)) | 0;
              hi = (hi + Math.imul(ah6, bh9)) | 0;
              var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
              w15 &= 0x3ffffff;
              /* k = 16 */ lo = Math.imul(al9, bl7);
              mid = Math.imul(al9, bh7);
              mid = (mid + Math.imul(ah9, bl7)) | 0;
              hi = Math.imul(ah9, bh7);
              lo = (lo + Math.imul(al8, bl8)) | 0;
              mid = (mid + Math.imul(al8, bh8)) | 0;
              mid = (mid + Math.imul(ah8, bl8)) | 0;
              hi = (hi + Math.imul(ah8, bh8)) | 0;
              lo = (lo + Math.imul(al7, bl9)) | 0;
              mid = (mid + Math.imul(al7, bh9)) | 0;
              mid = (mid + Math.imul(ah7, bl9)) | 0;
              hi = (hi + Math.imul(ah7, bh9)) | 0;
              var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
              w16 &= 0x3ffffff;
              /* k = 17 */ lo = Math.imul(al9, bl8);
              mid = Math.imul(al9, bh8);
              mid = (mid + Math.imul(ah9, bl8)) | 0;
              hi = Math.imul(ah9, bh8);
              lo = (lo + Math.imul(al8, bl9)) | 0;
              mid = (mid + Math.imul(al8, bh9)) | 0;
              mid = (mid + Math.imul(ah8, bl9)) | 0;
              hi = (hi + Math.imul(ah8, bh9)) | 0;
              var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
              w17 &= 0x3ffffff;
              /* k = 18 */ lo = Math.imul(al9, bl9);
              mid = Math.imul(al9, bh9);
              mid = (mid + Math.imul(ah9, bl9)) | 0;
              hi = Math.imul(ah9, bh9);
              var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
              w18 &= 0x3ffffff;
              o[0] = w0;
              o[1] = w1;
              o[2] = w2;
              o[3] = w3;
              o[4] = w4;
              o[5] = w5;
              o[6] = w6;
              o[7] = w7;
              o[8] = w8;
              o[9] = w9;
              o[10] = w10;
              o[11] = w11;
              o[12] = w12;
              o[13] = w13;
              o[14] = w14;
              o[15] = w15;
              o[16] = w16;
              o[17] = w17;
              o[18] = w18;
              if (c !== 0) {
                o[19] = c;
                out.length++;
              }
              return out;
            }; // Polyfill comb
            if (!Math.imul) {
              comb10MulTo = smallMulTo;
            }
            function bigMulTo(self, num, out) {
              out.negative = num.negative ^ self.negative;
              out.length = self.length + num.length;
              var carry = 0;
              var hncarry = 0;
              for (var k = 0; k < out.length - 1; k++) {
                // Sum all words with the same `i + j = k` and accumulate `ncarry`,
                // note that ncarry could be >= 0x3ffffff
                var ncarry = hncarry;
                hncarry = 0;
                var rword = carry & 0x3ffffff;
                var maxJ = Math.min(k, num.length - 1);
                for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
                  var i = k - j;
                  var a = self.words[i] | 0;
                  var b = num.words[j] | 0;
                  var r = a * b;
                  var lo = r & 0x3ffffff;
                  ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
                  lo = (lo + rword) | 0;
                  rword = lo & 0x3ffffff;
                  ncarry = (ncarry + (lo >>> 26)) | 0;
                  hncarry += ncarry >>> 26;
                  ncarry &= 0x3ffffff;
                }
                out.words[k] = rword;
                carry = ncarry;
                ncarry = hncarry;
              }
              if (carry !== 0) {
                out.words[k] = carry;
              } else {
                out.length--;
              }
              return out.strip();
            }
            function jumboMulTo(self, num, out) {
              var fftm = new FFTM();
              return fftm.mulp(self, num, out);
            }
            BN.prototype.mulTo = function mulTo(num, out) {
              var res;
              var len = this.length + num.length;
              if (this.length === 10 && num.length === 10) {
                res = comb10MulTo(this, num, out);
              } else if (len < 63) {
                res = smallMulTo(this, num, out);
              } else if (len < 1024) {
                res = bigMulTo(this, num, out);
              } else {
                res = jumboMulTo(this, num, out);
              }
              return res;
            }; // Cooley-Tukey algorithm for FFT
            // slightly revisited to rely on looping instead of recursion
            function FFTM(x, y) {
              this.x = x;
              this.y = y;
            }
            FFTM.prototype.makeRBT = function makeRBT(N) {
              var t = new Array(N);
              var l = BN.prototype._countBits(N) - 1;
              for (var i = 0; i < N; i++) {
                t[i] = this.revBin(i, l, N);
              }
              return t;
            }; // Returns binary-reversed representation of `x`
            FFTM.prototype.revBin = function revBin(x, l, N) {
              if (x === 0 || x === N - 1) return x;
              var rb = 0;
              for (var i = 0; i < l; i++) {
                rb |= (x & 1) << (l - i - 1);
                x >>= 1;
              }
              return rb;
            }; // Performs "tweedling" phase, therefore 'emulating'
            // behaviour of the recursive algorithm
            FFTM.prototype.permute = function permute(
              rbt,
              rws,
              iws,
              rtws,
              itws,
              N
            ) {
              for (var i = 0; i < N; i++) {
                rtws[i] = rws[rbt[i]];
                itws[i] = iws[rbt[i]];
              }
            };
            FFTM.prototype.transform = function transform(
              rws,
              iws,
              rtws,
              itws,
              N,
              rbt
            ) {
              this.permute(rbt, rws, iws, rtws, itws, N);
              for (var s = 1; s < N; s <<= 1) {
                var l = s << 1;
                var rtwdf = Math.cos((2 * Math.PI) / l);
                var itwdf = Math.sin((2 * Math.PI) / l);
                for (var p = 0; p < N; p += l) {
                  var rtwdf_ = rtwdf;
                  var itwdf_ = itwdf;
                  for (var j = 0; j < s; j++) {
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                      rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                      itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                      rtwdf_ = rx;
                    }
                  }
                }
              }
            };
            FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
              var N = Math.max(m, n) | 1;
              var odd = N & 1;
              var i = 0;
              for (N = (N / 2) | 0; N; N = N >>> 1) {
                i++;
              }
              return 1 << (i + 1 + odd);
            };
            FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
              if (N <= 1) return;
              for (var i = 0; i < N / 2; i++) {
                var t = rws[i];
                rws[i] = rws[N - i - 1];
                rws[N - i - 1] = t;
                t = iws[i];
                iws[i] = -iws[N - i - 1];
                iws[N - i - 1] = -t;
              }
            };
            FFTM.prototype.normalize13b = function normalize13b(ws, N) {
              var carry = 0;
              for (var i = 0; i < N / 2; i++) {
                var w =
                  Math.round(ws[2 * i + 1] / N) * 0x2000 +
                  Math.round(ws[2 * i] / N) +
                  carry;
                ws[i] = w & 0x3ffffff;
                if (w < 0x4000000) {
                  carry = 0;
                } else {
                  carry = (w / 0x4000000) | 0;
                }
              }
              return ws;
            };
            FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
              var carry = 0;
              for (var i = 0; i < len; i++) {
                carry = carry + (ws[i] | 0);
                rws[2 * i] = carry & 0x1fff;
                carry = carry >>> 13;
                rws[2 * i + 1] = carry & 0x1fff;
                carry = carry >>> 13;
              } // Pad with zeroes
              for (i = 2 * len; i < N; ++i) {
                rws[i] = 0;
              }
              assert(carry === 0);
              assert((carry & ~0x1fff) === 0);
            };
            FFTM.prototype.stub = function stub(N) {
              var ph = new Array(N);
              for (var i = 0; i < N; i++) {
                ph[i] = 0;
              }
              return ph;
            };
            FFTM.prototype.mulp = function mulp(x, y, out) {
              var N = 2 * this.guessLen13b(x.length, y.length);
              var rbt = this.makeRBT(N);
              var _ = this.stub(N);
              var rws = new Array(N);
              var rwst = new Array(N);
              var iwst = new Array(N);
              var nrws = new Array(N);
              var nrwst = new Array(N);
              var niwst = new Array(N);
              var rmws = out.words;
              rmws.length = N;
              this.convert13b(x.words, x.length, rws, N);
              this.convert13b(y.words, y.length, nrws, N);
              this.transform(rws, _, rwst, iwst, N, rbt);
              this.transform(nrws, _, nrwst, niwst, N, rbt);
              for (var i = 0; i < N; i++) {
                var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
                iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
                rwst[i] = rx;
              }
              this.conjugate(rwst, iwst, N);
              this.transform(rwst, iwst, rmws, _, N, rbt);
              this.conjugate(rmws, _, N);
              this.normalize13b(rmws, N);
              out.negative = x.negative ^ y.negative;
              out.length = x.length + y.length;
              return out.strip();
            }; // Multiply `this` by `num`
            BN.prototype.mul = function mul(num) {
              var out = new BN(null);
              out.words = new Array(this.length + num.length);
              return this.mulTo(num, out);
            }; // Multiply employing FFT
            BN.prototype.mulf = function mulf(num) {
              var out = new BN(null);
              out.words = new Array(this.length + num.length);
              return jumboMulTo(this, num, out);
            }; // In-place Multiplication
            BN.prototype.imul = function imul(num) {
              return this.clone().mulTo(num, this);
            };
            BN.prototype.imuln = function imuln(num) {
              assert(typeof num === "number");
              assert(num < 0x4000000); // Carry
              var carry = 0;
              for (var i = 0; i < this.length; i++) {
                var w = (this.words[i] | 0) * num;
                var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
                carry >>= 26;
                carry += (w / 0x4000000) | 0; // NOTE: lo is 27bit maximum
                carry += lo >>> 26;
                this.words[i] = lo & 0x3ffffff;
              }
              if (carry !== 0) {
                this.words[i] = carry;
                this.length++;
              }
              return this;
            };
            BN.prototype.muln = function muln(num) {
              return this.clone().imuln(num);
            }; // `this` * `this`
            BN.prototype.sqr = function sqr() {
              return this.mul(this);
            }; // `this` * `this` in-place
            BN.prototype.isqr = function isqr() {
              return this.imul(this.clone());
            }; // Math.pow(`this`, `num`)
            BN.prototype.pow = function pow(num) {
              var w = toBitArray(num);
              if (w.length === 0) return new BN(1); // Skip leading zeroes
              var res = this;
              for (var i = 0; i < w.length; i++, res = res.sqr()) {
                if (w[i] !== 0) break;
              }
              if (++i < w.length) {
                for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
                  if (w[i] === 0) continue;
                  res = res.mul(q);
                }
              }
              return res;
            }; // Shift-left in-place
            BN.prototype.iushln = function iushln(bits) {
              assert(typeof bits === "number" && bits >= 0);
              var r = bits % 26;
              var s = (bits - r) / 26;
              var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
              var i;
              if (r !== 0) {
                var carry = 0;
                for (i = 0; i < this.length; i++) {
                  var newCarry = this.words[i] & carryMask;
                  var c = ((this.words[i] | 0) - newCarry) << r;
                  this.words[i] = c | carry;
                  carry = newCarry >>> (26 - r);
                }
                if (carry) {
                  this.words[i] = carry;
                  this.length++;
                }
              }
              if (s !== 0) {
                for (i = this.length - 1; i >= 0; i--) {
                  this.words[i + s] = this.words[i];
                }
                for (i = 0; i < s; i++) {
                  this.words[i] = 0;
                }
                this.length += s;
              }
              return this.strip();
            };
            BN.prototype.ishln = function ishln(bits) {
              // TODO(indutny): implement me
              assert(this.negative === 0);
              return this.iushln(bits);
            }; // Shift-right in-place
            // NOTE: `hint` is a lowest bit before trailing zeroes
            // NOTE: if `extended` is present - it will be filled with destroyed bits
            BN.prototype.iushrn = function iushrn(bits, hint, extended) {
              assert(typeof bits === "number" && bits >= 0);
              var h;
              if (hint) {
                h = (hint - (hint % 26)) / 26;
              } else {
                h = 0;
              }
              var r = bits % 26;
              var s = Math.min((bits - r) / 26, this.length);
              var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
              var maskedWords = extended;
              h -= s;
              h = Math.max(0, h); // Extended mode, copy masked part
              if (maskedWords) {
                for (var i = 0; i < s; i++) {
                  maskedWords.words[i] = this.words[i];
                }
                maskedWords.length = s;
              }
              if (s === 0) {
                // No-op, we should not move anything at all
              } else if (this.length > s) {
                this.length -= s;
                for (i = 0; i < this.length; i++) {
                  this.words[i] = this.words[i + s];
                }
              } else {
                this.words[0] = 0;
                this.length = 1;
              }
              var carry = 0;
              for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
                var word = this.words[i] | 0;
                this.words[i] = (carry << (26 - r)) | (word >>> r);
                carry = word & mask;
              } // Push carried bits as a mask
              if (maskedWords && carry !== 0) {
                maskedWords.words[maskedWords.length++] = carry;
              }
              if (this.length === 0) {
                this.words[0] = 0;
                this.length = 1;
              }
              return this.strip();
            };
            BN.prototype.ishrn = function ishrn(bits, hint, extended) {
              // TODO(indutny): implement me
              assert(this.negative === 0);
              return this.iushrn(bits, hint, extended);
            }; // Shift-left
            BN.prototype.shln = function shln(bits) {
              return this.clone().ishln(bits);
            };
            BN.prototype.ushln = function ushln(bits) {
              return this.clone().iushln(bits);
            }; // Shift-right
            BN.prototype.shrn = function shrn(bits) {
              return this.clone().ishrn(bits);
            };
            BN.prototype.ushrn = function ushrn(bits) {
              return this.clone().iushrn(bits);
            }; // Test if n bit is set
            BN.prototype.testn = function testn(bit) {
              assert(typeof bit === "number" && bit >= 0);
              var r = bit % 26;
              var s = (bit - r) / 26;
              var q = 1 << r; // Fast case: bit is much higher than all existing words
              if (this.length <= s) return false; // Check bit and return
              var w = this.words[s];
              return !!(w & q);
            }; // Return only lowers bits of number (in-place)
            BN.prototype.imaskn = function imaskn(bits) {
              assert(typeof bits === "number" && bits >= 0);
              var r = bits % 26;
              var s = (bits - r) / 26;
              assert(
                this.negative === 0,
                "imaskn works only with positive numbers"
              );
              if (this.length <= s) {
                return this;
              }
              if (r !== 0) {
                s++;
              }
              this.length = Math.min(s, this.length);
              if (r !== 0) {
                var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
                this.words[this.length - 1] &= mask;
              }
              return this.strip();
            }; // Return only lowers bits of number
            BN.prototype.maskn = function maskn(bits) {
              return this.clone().imaskn(bits);
            }; // Add plain number `num` to `this`
            BN.prototype.iaddn = function iaddn(num) {
              assert(typeof num === "number");
              assert(num < 0x4000000);
              if (num < 0) return this.isubn(-num); // Possible sign change
              if (this.negative !== 0) {
                if (this.length === 1 && (this.words[0] | 0) < num) {
                  this.words[0] = num - (this.words[0] | 0);
                  this.negative = 0;
                  return this;
                }
                this.negative = 0;
                this.isubn(num);
                this.negative = 1;
                return this;
              } // Add without checks
              return this._iaddn(num);
            };
            BN.prototype._iaddn = function _iaddn(num) {
              this.words[0] += num; // Carry
              for (
                var i = 0;
                i < this.length && this.words[i] >= 0x4000000;
                i++
              ) {
                this.words[i] -= 0x4000000;
                if (i === this.length - 1) {
                  this.words[i + 1] = 1;
                } else {
                  this.words[i + 1]++;
                }
              }
              this.length = Math.max(this.length, i + 1);
              return this;
            }; // Subtract plain number `num` from `this`
            BN.prototype.isubn = function isubn(num) {
              assert(typeof num === "number");
              assert(num < 0x4000000);
              if (num < 0) return this.iaddn(-num);
              if (this.negative !== 0) {
                this.negative = 0;
                this.iaddn(num);
                this.negative = 1;
                return this;
              }
              this.words[0] -= num;
              if (this.length === 1 && this.words[0] < 0) {
                this.words[0] = -this.words[0];
                this.negative = 1;
              } else {
                // Carry
                for (var i = 0; i < this.length && this.words[i] < 0; i++) {
                  this.words[i] += 0x4000000;
                  this.words[i + 1] -= 1;
                }
              }
              return this.strip();
            };
            BN.prototype.addn = function addn(num) {
              return this.clone().iaddn(num);
            };
            BN.prototype.subn = function subn(num) {
              return this.clone().isubn(num);
            };
            BN.prototype.iabs = function iabs() {
              this.negative = 0;
              return this;
            };
            BN.prototype.abs = function abs() {
              return this.clone().iabs();
            };
            BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
              var len = num.length + shift;
              var i;
              this._expand(len);
              var w;
              var carry = 0;
              for (i = 0; i < num.length; i++) {
                w = (this.words[i + shift] | 0) + carry;
                var right = (num.words[i] | 0) * mul;
                w -= right & 0x3ffffff;
                carry = (w >> 26) - ((right / 0x4000000) | 0);
                this.words[i + shift] = w & 0x3ffffff;
              }
              for (; i < this.length - shift; i++) {
                w = (this.words[i + shift] | 0) + carry;
                carry = w >> 26;
                this.words[i + shift] = w & 0x3ffffff;
              }
              if (carry === 0) return this.strip(); // Subtraction overflow
              assert(carry === -1);
              carry = 0;
              for (i = 0; i < this.length; i++) {
                w = -(this.words[i] | 0) + carry;
                carry = w >> 26;
                this.words[i] = w & 0x3ffffff;
              }
              this.negative = 1;
              return this.strip();
            };
            BN.prototype._wordDiv = function _wordDiv(num, mode) {
              var shift = this.length - num.length;
              var a = this.clone();
              var b = num; // Normalize
              var bhi = b.words[b.length - 1] | 0;
              var bhiBits = this._countBits(bhi);
              shift = 26 - bhiBits;
              if (shift !== 0) {
                b = b.ushln(shift);
                a.iushln(shift);
                bhi = b.words[b.length - 1] | 0;
              } // Initialize quotient
              var m = a.length - b.length;
              var q;
              if (mode !== "mod") {
                q = new BN(null);
                q.length = m + 1;
                q.words = new Array(q.length);
                for (var i = 0; i < q.length; i++) {
                  q.words[i] = 0;
                }
              }
              var diff = a.clone()._ishlnsubmul(b, 1, m);
              if (diff.negative === 0) {
                a = diff;
                if (q) {
                  q.words[m] = 1;
                }
              }
              for (var j = m - 1; j >= 0; j--) {
                var qj =
                  (a.words[b.length + j] | 0) * 0x4000000 +
                  (a.words[b.length + j - 1] | 0); // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
                // (0x7ffffff)
                qj = Math.min((qj / bhi) | 0, 0x3ffffff);
                a._ishlnsubmul(b, qj, j);
                while (a.negative !== 0) {
                  qj--;
                  a.negative = 0;
                  a._ishlnsubmul(b, 1, j);
                  if (!a.isZero()) {
                    a.negative ^= 1;
                  }
                }
                if (q) {
                  q.words[j] = qj;
                }
              }
              if (q) {
                q.strip();
              }
              a.strip(); // Denormalize
              if (mode !== "div" && shift !== 0) {
                a.iushrn(shift);
              }
              return { div: q || null, mod: a };
            }; // NOTE: 1) `mode` can be set to `mod` to request mod only,
            //       to `div` to request div only, or be absent to
            //       request both div & mod
            //       2) `positive` is true if unsigned mod is requested
            BN.prototype.divmod = function divmod(num, mode, positive) {
              assert(!num.isZero());
              if (this.isZero()) {
                return { div: new BN(0), mod: new BN(0) };
              }
              var div, mod, res;
              if (this.negative !== 0 && num.negative === 0) {
                res = this.neg().divmod(num, mode);
                if (mode !== "mod") {
                  div = res.div.neg();
                }
                if (mode !== "div") {
                  mod = res.mod.neg();
                  if (positive && mod.negative !== 0) {
                    mod.iadd(num);
                  }
                }
                return { div: div, mod: mod };
              }
              if (this.negative === 0 && num.negative !== 0) {
                res = this.divmod(num.neg(), mode);
                if (mode !== "mod") {
                  div = res.div.neg();
                }
                return { div: div, mod: res.mod };
              }
              if ((this.negative & num.negative) !== 0) {
                res = this.neg().divmod(num.neg(), mode);
                if (mode !== "div") {
                  mod = res.mod.neg();
                  if (positive && mod.negative !== 0) {
                    mod.isub(num);
                  }
                }
                return { div: res.div, mod: mod };
              } // Both numbers are positive at this point
              // Strip both numbers to approximate shift value
              if (num.length > this.length || this.cmp(num) < 0) {
                return { div: new BN(0), mod: this };
              } // Very short reduction
              if (num.length === 1) {
                if (mode === "div") {
                  return { div: this.divn(num.words[0]), mod: null };
                }
                if (mode === "mod") {
                  return { div: null, mod: new BN(this.modn(num.words[0])) };
                }
                return {
                  div: this.divn(num.words[0]),
                  mod: new BN(this.modn(num.words[0]))
                };
              }
              return this._wordDiv(num, mode);
            }; // Find `this` / `num`
            BN.prototype.div = function div(num) {
              return this.divmod(num, "div", false).div;
            }; // Find `this` % `num`
            BN.prototype.mod = function mod(num) {
              return this.divmod(num, "mod", false).mod;
            };
            BN.prototype.umod = function umod(num) {
              return this.divmod(num, "mod", true).mod;
            }; // Find Round(`this` / `num`)
            BN.prototype.divRound = function divRound(num) {
              var dm = this.divmod(num); // Fast case - exact division
              if (dm.mod.isZero()) return dm.div;
              var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
              var half = num.ushrn(1);
              var r2 = num.andln(1);
              var cmp = mod.cmp(half); // Round down
              if (cmp < 0 || (r2 === 1 && cmp === 0)) return dm.div; // Round up
              return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
            };
            BN.prototype.modn = function modn(num) {
              assert(num <= 0x3ffffff);
              var p = (1 << 26) % num;
              var acc = 0;
              for (var i = this.length - 1; i >= 0; i--) {
                acc = (p * acc + (this.words[i] | 0)) % num;
              }
              return acc;
            }; // In-place division by number
            BN.prototype.idivn = function idivn(num) {
              assert(num <= 0x3ffffff);
              var carry = 0;
              for (var i = this.length - 1; i >= 0; i--) {
                var w = (this.words[i] | 0) + carry * 0x4000000;
                this.words[i] = (w / num) | 0;
                carry = w % num;
              }
              return this.strip();
            };
            BN.prototype.divn = function divn(num) {
              return this.clone().idivn(num);
            };
            BN.prototype.egcd = function egcd(p) {
              assert(p.negative === 0);
              assert(!p.isZero());
              var x = this;
              var y = p.clone();
              if (x.negative !== 0) {
                x = x.umod(p);
              } else {
                x = x.clone();
              } // A * x + B * y = x
              var A = new BN(1);
              var B = new BN(0); // C * x + D * y = y
              var C = new BN(0);
              var D = new BN(1);
              var g = 0;
              while (x.isEven() && y.isEven()) {
                x.iushrn(1);
                y.iushrn(1);
                ++g;
              }
              var yp = y.clone();
              var xp = x.clone();
              while (!x.isZero()) {
                for (
                  var i = 0, im = 1;
                  (x.words[0] & im) === 0 && i < 26;
                  ++i, im <<= 1
                ) {}
                if (i > 0) {
                  x.iushrn(i);
                  while (i-- > 0) {
                    if (A.isOdd() || B.isOdd()) {
                      A.iadd(yp);
                      B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                  }
                }
                for (
                  var j = 0, jm = 1;
                  (y.words[0] & jm) === 0 && j < 26;
                  ++j, jm <<= 1
                ) {}
                if (j > 0) {
                  y.iushrn(j);
                  while (j-- > 0) {
                    if (C.isOdd() || D.isOdd()) {
                      C.iadd(yp);
                      D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                  }
                }
                if (x.cmp(y) >= 0) {
                  x.isub(y);
                  A.isub(C);
                  B.isub(D);
                } else {
                  y.isub(x);
                  C.isub(A);
                  D.isub(B);
                }
              }
              return { a: C, b: D, gcd: y.iushln(g) };
            }; // This is reduced incarnation of the binary EEA
            // above, designated to invert members of the
            // _prime_ fields F(p) at a maximal speed
            BN.prototype._invmp = function _invmp(p) {
              assert(p.negative === 0);
              assert(!p.isZero());
              var a = this;
              var b = p.clone();
              if (a.negative !== 0) {
                a = a.umod(p);
              } else {
                a = a.clone();
              }
              var x1 = new BN(1);
              var x2 = new BN(0);
              var delta = b.clone();
              while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
                for (
                  var i = 0, im = 1;
                  (a.words[0] & im) === 0 && i < 26;
                  ++i, im <<= 1
                ) {}
                if (i > 0) {
                  a.iushrn(i);
                  while (i-- > 0) {
                    if (x1.isOdd()) {
                      x1.iadd(delta);
                    }
                    x1.iushrn(1);
                  }
                }
                for (
                  var j = 0, jm = 1;
                  (b.words[0] & jm) === 0 && j < 26;
                  ++j, jm <<= 1
                ) {}
                if (j > 0) {
                  b.iushrn(j);
                  while (j-- > 0) {
                    if (x2.isOdd()) {
                      x2.iadd(delta);
                    }
                    x2.iushrn(1);
                  }
                }
                if (a.cmp(b) >= 0) {
                  a.isub(b);
                  x1.isub(x2);
                } else {
                  b.isub(a);
                  x2.isub(x1);
                }
              }
              var res;
              if (a.cmpn(1) === 0) {
                res = x1;
              } else {
                res = x2;
              }
              if (res.cmpn(0) < 0) {
                res.iadd(p);
              }
              return res;
            };
            BN.prototype.gcd = function gcd(num) {
              if (this.isZero()) return num.abs();
              if (num.isZero()) return this.abs();
              var a = this.clone();
              var b = num.clone();
              a.negative = 0;
              b.negative = 0; // Remove common factor of two
              for (var shift = 0; a.isEven() && b.isEven(); shift++) {
                a.iushrn(1);
                b.iushrn(1);
              }
              do {
                while (a.isEven()) {
                  a.iushrn(1);
                }
                while (b.isEven()) {
                  b.iushrn(1);
                }
                var r = a.cmp(b);
                if (r < 0) {
                  // Swap `a` and `b` to make `a` always bigger than `b`
                  var t = a;
                  a = b;
                  b = t;
                } else if (r === 0 || b.cmpn(1) === 0) {
                  break;
                }
                a.isub(b);
              } while (true);
              return b.iushln(shift);
            }; // Invert number in the field F(num)
            BN.prototype.invm = function invm(num) {
              return this.egcd(num).a.umod(num);
            };
            BN.prototype.isEven = function isEven() {
              return (this.words[0] & 1) === 0;
            };
            BN.prototype.isOdd = function isOdd() {
              return (this.words[0] & 1) === 1;
            }; // And first word and num
            BN.prototype.andln = function andln(num) {
              return this.words[0] & num;
            }; // Increment at the bit position in-line
            BN.prototype.bincn = function bincn(bit) {
              assert(typeof bit === "number");
              var r = bit % 26;
              var s = (bit - r) / 26;
              var q = 1 << r; // Fast case: bit is much higher than all existing words
              if (this.length <= s) {
                this._expand(s + 1);
                this.words[s] |= q;
                return this;
              } // Add bit and propagate, if needed
              var carry = q;
              for (var i = s; carry !== 0 && i < this.length; i++) {
                var w = this.words[i] | 0;
                w += carry;
                carry = w >>> 26;
                w &= 0x3ffffff;
                this.words[i] = w;
              }
              if (carry !== 0) {
                this.words[i] = carry;
                this.length++;
              }
              return this;
            };
            BN.prototype.isZero = function isZero() {
              return this.length === 1 && this.words[0] === 0;
            };
            BN.prototype.cmpn = function cmpn(num) {
              var negative = num < 0;
              if (this.negative !== 0 && !negative) return -1;
              if (this.negative === 0 && negative) return 1;
              this.strip();
              var res;
              if (this.length > 1) {
                res = 1;
              } else {
                if (negative) {
                  num = -num;
                }
                assert(num <= 0x3ffffff, "Number is too big");
                var w = this.words[0] | 0;
                res = w === num ? 0 : w < num ? -1 : 1;
              }
              if (this.negative !== 0) return -res | 0;
              return res;
            }; // Compare two numbers and return:
            // 1 - if `this` > `num`
            // 0 - if `this` == `num`
            // -1 - if `this` < `num`
            BN.prototype.cmp = function cmp(num) {
              if (this.negative !== 0 && num.negative === 0) return -1;
              if (this.negative === 0 && num.negative !== 0) return 1;
              var res = this.ucmp(num);
              if (this.negative !== 0) return -res | 0;
              return res;
            }; // Unsigned comparison
            BN.prototype.ucmp = function ucmp(num) {
              // At this point both numbers have the same sign
              if (this.length > num.length) return 1;
              if (this.length < num.length) return -1;
              var res = 0;
              for (var i = this.length - 1; i >= 0; i--) {
                var a = this.words[i] | 0;
                var b = num.words[i] | 0;
                if (a === b) continue;
                if (a < b) {
                  res = -1;
                } else if (a > b) {
                  res = 1;
                }
                break;
              }
              return res;
            };
            BN.prototype.gtn = function gtn(num) {
              return this.cmpn(num) === 1;
            };
            BN.prototype.gt = function gt(num) {
              return this.cmp(num) === 1;
            };
            BN.prototype.gten = function gten(num) {
              return this.cmpn(num) >= 0;
            };
            BN.prototype.gte = function gte(num) {
              return this.cmp(num) >= 0;
            };
            BN.prototype.ltn = function ltn(num) {
              return this.cmpn(num) === -1;
            };
            BN.prototype.lt = function lt(num) {
              return this.cmp(num) === -1;
            };
            BN.prototype.lten = function lten(num) {
              return this.cmpn(num) <= 0;
            };
            BN.prototype.lte = function lte(num) {
              return this.cmp(num) <= 0;
            };
            BN.prototype.eqn = function eqn(num) {
              return this.cmpn(num) === 0;
            };
            BN.prototype.eq = function eq(num) {
              return this.cmp(num) === 0;
            }; //
            // A reduce context, could be using montgomery or something better, depending
            // on the `m` itself.
            //
            BN.red = function red(num) {
              return new Red(num);
            };
            BN.prototype.toRed = function toRed(ctx) {
              assert(!this.red, "Already a number in reduction context");
              assert(this.negative === 0, "red works only with positives");
              return ctx.convertTo(this)._forceRed(ctx);
            };
            BN.prototype.fromRed = function fromRed() {
              assert(
                this.red,
                "fromRed works only with numbers in reduction context"
              );
              return this.red.convertFrom(this);
            };
            BN.prototype._forceRed = function _forceRed(ctx) {
              this.red = ctx;
              return this;
            };
            BN.prototype.forceRed = function forceRed(ctx) {
              assert(!this.red, "Already a number in reduction context");
              return this._forceRed(ctx);
            };
            BN.prototype.redAdd = function redAdd(num) {
              assert(this.red, "redAdd works only with red numbers");
              return this.red.add(this, num);
            };
            BN.prototype.redIAdd = function redIAdd(num) {
              assert(this.red, "redIAdd works only with red numbers");
              return this.red.iadd(this, num);
            };
            BN.prototype.redSub = function redSub(num) {
              assert(this.red, "redSub works only with red numbers");
              return this.red.sub(this, num);
            };
            BN.prototype.redISub = function redISub(num) {
              assert(this.red, "redISub works only with red numbers");
              return this.red.isub(this, num);
            };
            BN.prototype.redShl = function redShl(num) {
              assert(this.red, "redShl works only with red numbers");
              return this.red.shl(this, num);
            };
            BN.prototype.redMul = function redMul(num) {
              assert(this.red, "redMul works only with red numbers");
              this.red._verify2(this, num);
              return this.red.mul(this, num);
            };
            BN.prototype.redIMul = function redIMul(num) {
              assert(this.red, "redMul works only with red numbers");
              this.red._verify2(this, num);
              return this.red.imul(this, num);
            };
            BN.prototype.redSqr = function redSqr() {
              assert(this.red, "redSqr works only with red numbers");
              this.red._verify1(this);
              return this.red.sqr(this);
            };
            BN.prototype.redISqr = function redISqr() {
              assert(this.red, "redISqr works only with red numbers");
              this.red._verify1(this);
              return this.red.isqr(this);
            }; // Square root over p
            BN.prototype.redSqrt = function redSqrt() {
              assert(this.red, "redSqrt works only with red numbers");
              this.red._verify1(this);
              return this.red.sqrt(this);
            };
            BN.prototype.redInvm = function redInvm() {
              assert(this.red, "redInvm works only with red numbers");
              this.red._verify1(this);
              return this.red.invm(this);
            }; // Return negative clone of `this` % `red modulo`
            BN.prototype.redNeg = function redNeg() {
              assert(this.red, "redNeg works only with red numbers");
              this.red._verify1(this);
              return this.red.neg(this);
            };
            BN.prototype.redPow = function redPow(num) {
              assert(this.red && !num.red, "redPow(normalNum)");
              this.red._verify1(this);
              return this.red.pow(this, num);
            }; // Prime numbers with efficient reduction
            var primes = { k256: null, p224: null, p192: null, p25519: null }; // Pseudo-Mersenne prime
            function MPrime(name, p) {
              // P = 2 ^ N - K
              this.name = name;
              this.p = new BN(p, 16);
              this.n = this.p.bitLength();
              this.k = new BN(1).iushln(this.n).isub(this.p);
              this.tmp = this._tmp();
            }
            MPrime.prototype._tmp = function _tmp() {
              var tmp = new BN(null);
              tmp.words = new Array(Math.ceil(this.n / 13));
              return tmp;
            };
            MPrime.prototype.ireduce = function ireduce(num) {
              // Assumes that `num` is less than `P^2`
              // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
              var r = num;
              var rlen;
              do {
                this.split(r, this.tmp);
                r = this.imulK(r);
                r = r.iadd(this.tmp);
                rlen = r.bitLength();
              } while (rlen > this.n);
              var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
              if (cmp === 0) {
                r.words[0] = 0;
                r.length = 1;
              } else if (cmp > 0) {
                r.isub(this.p);
              } else {
                if (r.strip !== undefined) {
                  // r is BN v4 instance
                  r.strip();
                } else {
                  // r is BN v5 instance
                  r._strip();
                }
              }
              return r;
            };
            MPrime.prototype.split = function split(input, out) {
              input.iushrn(this.n, 0, out);
            };
            MPrime.prototype.imulK = function imulK(num) {
              return num.imul(this.k);
            };
            function K256() {
              MPrime.call(
                this,
                "k256",
                "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
              );
            }
            inherits(K256, MPrime);
            K256.prototype.split = function split(input, output) {
              // 256 = 9 * 26 + 22
              var mask = 0x3fffff;
              var outLen = Math.min(input.length, 9);
              for (var i = 0; i < outLen; i++) {
                output.words[i] = input.words[i];
              }
              output.length = outLen;
              if (input.length <= 9) {
                input.words[0] = 0;
                input.length = 1;
                return;
              } // Shift by 9 limbs
              var prev = input.words[9];
              output.words[output.length++] = prev & mask;
              for (i = 10; i < input.length; i++) {
                var next = input.words[i] | 0;
                input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
                prev = next;
              }
              prev >>>= 22;
              input.words[i - 10] = prev;
              if (prev === 0 && input.length > 10) {
                input.length -= 10;
              } else {
                input.length -= 9;
              }
            };
            K256.prototype.imulK = function imulK(num) {
              // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
              num.words[num.length] = 0;
              num.words[num.length + 1] = 0;
              num.length += 2; // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
              var lo = 0;
              for (var i = 0; i < num.length; i++) {
                var w = num.words[i] | 0;
                lo += w * 0x3d1;
                num.words[i] = lo & 0x3ffffff;
                lo = w * 0x40 + ((lo / 0x4000000) | 0);
              } // Fast length reduction
              if (num.words[num.length - 1] === 0) {
                num.length--;
                if (num.words[num.length - 1] === 0) {
                  num.length--;
                }
              }
              return num;
            };
            function P224() {
              MPrime.call(
                this,
                "p224",
                "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
              );
            }
            inherits(P224, MPrime);
            function P192() {
              MPrime.call(
                this,
                "p192",
                "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
              );
            }
            inherits(P192, MPrime);
            function P25519() {
              // 2 ^ 255 - 19
              MPrime.call(
                this,
                "25519",
                "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
              );
            }
            inherits(P25519, MPrime);
            P25519.prototype.imulK = function imulK(num) {
              // K = 0x13
              var carry = 0;
              for (var i = 0; i < num.length; i++) {
                var hi = (num.words[i] | 0) * 0x13 + carry;
                var lo = hi & 0x3ffffff;
                hi >>>= 26;
                num.words[i] = lo;
                carry = hi;
              }
              if (carry !== 0) {
                num.words[num.length++] = carry;
              }
              return num;
            }; // Exported mostly for testing purposes, use plain name instead
            BN._prime = function prime(name) {
              // Cached version of prime
              if (primes[name]) return primes[name];
              var prime;
              if (name === "k256") {
                prime = new K256();
              } else if (name === "p224") {
                prime = new P224();
              } else if (name === "p192") {
                prime = new P192();
              } else if (name === "p25519") {
                prime = new P25519();
              } else {
                throw new Error("Unknown prime " + name);
              }
              primes[name] = prime;
              return prime;
            }; //
            // Base reduction engine
            //
            function Red(m) {
              if (typeof m === "string") {
                var prime = BN._prime(m);
                this.m = prime.p;
                this.prime = prime;
              } else {
                assert(m.gtn(1), "modulus must be greater than 1");
                this.m = m;
                this.prime = null;
              }
            }
            Red.prototype._verify1 = function _verify1(a) {
              assert(a.negative === 0, "red works only with positives");
              assert(a.red, "red works only with red numbers");
            };
            Red.prototype._verify2 = function _verify2(a, b) {
              assert(
                (a.negative | b.negative) === 0,
                "red works only with positives"
              );
              assert(a.red && a.red === b.red, "red works only with red numbers");
            };
            Red.prototype.imod = function imod(a) {
              if (this.prime) return this.prime.ireduce(a)._forceRed(this);
              return a.umod(this.m)._forceRed(this);
            };
            Red.prototype.neg = function neg(a) {
              if (a.isZero()) {
                return a.clone();
              }
              return this.m.sub(a)._forceRed(this);
            };
            Red.prototype.add = function add(a, b) {
              this._verify2(a, b);
              var res = a.add(b);
              if (res.cmp(this.m) >= 0) {
                res.isub(this.m);
              }
              return res._forceRed(this);
            };
            Red.prototype.iadd = function iadd(a, b) {
              this._verify2(a, b);
              var res = a.iadd(b);
              if (res.cmp(this.m) >= 0) {
                res.isub(this.m);
              }
              return res;
            };
            Red.prototype.sub = function sub(a, b) {
              this._verify2(a, b);
              var res = a.sub(b);
              if (res.cmpn(0) < 0) {
                res.iadd(this.m);
              }
              return res._forceRed(this);
            };
            Red.prototype.isub = function isub(a, b) {
              this._verify2(a, b);
              var res = a.isub(b);
              if (res.cmpn(0) < 0) {
                res.iadd(this.m);
              }
              return res;
            };
            Red.prototype.shl = function shl(a, num) {
              this._verify1(a);
              return this.imod(a.ushln(num));
            };
            Red.prototype.imul = function imul(a, b) {
              this._verify2(a, b);
              return this.imod(a.imul(b));
            };
            Red.prototype.mul = function mul(a, b) {
              this._verify2(a, b);
              return this.imod(a.mul(b));
            };
            Red.prototype.isqr = function isqr(a) {
              return this.imul(a, a.clone());
            };
            Red.prototype.sqr = function sqr(a) {
              return this.mul(a, a);
            };
            Red.prototype.sqrt = function sqrt(a) {
              if (a.isZero()) return a.clone();
              var mod3 = this.m.andln(3);
              assert(mod3 % 2 === 1); // Fast case
              if (mod3 === 3) {
                var pow = this.m.add(new BN(1)).iushrn(2);
                return this.pow(a, pow);
              } // Tonelli-Shanks algorithm (Totally unoptimized and slow)
              //
              // Find Q and S, that Q * 2 ^ S = (P - 1)
              var q = this.m.subn(1);
              var s = 0;
              while (!q.isZero() && q.andln(1) === 0) {
                s++;
                q.iushrn(1);
              }
              assert(!q.isZero());
              var one = new BN(1).toRed(this);
              var nOne = one.redNeg(); // Find quadratic non-residue
              // NOTE: Max is such because of generalized Riemann hypothesis.
              var lpow = this.m.subn(1).iushrn(1);
              var z = this.m.bitLength();
              z = new BN(2 * z * z).toRed(this);
              while (this.pow(z, lpow).cmp(nOne) !== 0) {
                z.redIAdd(nOne);
              }
              var c = this.pow(z, q);
              var r = this.pow(a, q.addn(1).iushrn(1));
              var t = this.pow(a, q);
              var m = s;
              while (t.cmp(one) !== 0) {
                var tmp = t;
                for (var i = 0; tmp.cmp(one) !== 0; i++) {
                  tmp = tmp.redSqr();
                }
                assert(i < m);
                var b = this.pow(c, new BN(1).iushln(m - i - 1));
                r = r.redMul(b);
                c = b.redSqr();
                t = t.redMul(c);
                m = i;
              }
              return r;
            };
            Red.prototype.invm = function invm(a) {
              var inv = a._invmp(this.m);
              if (inv.negative !== 0) {
                inv.negative = 0;
                return this.imod(inv).redNeg();
              } else {
                return this.imod(inv);
              }
            };
            Red.prototype.pow = function pow(a, num) {
              if (num.isZero()) return new BN(1).toRed(this);
              if (num.cmpn(1) === 0) return a.clone();
              var windowSize = 4;
              var wnd = new Array(1 << windowSize);
              wnd[0] = new BN(1).toRed(this);
              wnd[1] = a;
              for (var i = 2; i < wnd.length; i++) {
                wnd[i] = this.mul(wnd[i - 1], a);
              }
              var res = wnd[0];
              var current = 0;
              var currentLen = 0;
              var start = num.bitLength() % 26;
              if (start === 0) {
                start = 26;
              }
              for (i = num.length - 1; i >= 0; i--) {
                var word = num.words[i];
                for (var j = start - 1; j >= 0; j--) {
                  var bit = (word >> j) & 1;
                  if (res !== wnd[0]) {
                    res = this.sqr(res);
                  }
                  if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                  }
                  current <<= 1;
                  current |= bit;
                  currentLen++;
                  if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                  res = this.mul(res, wnd[current]);
                  currentLen = 0;
                  current = 0;
                }
                start = 26;
              }
              return res;
            };
            Red.prototype.convertTo = function convertTo(num) {
              var r = num.umod(this.m);
              return r === num ? r.clone() : r;
            };
            Red.prototype.convertFrom = function convertFrom(num) {
              var res = num.clone();
              res.red = null;
              return res;
            }; //
            // Montgomery method engine
            //
            BN.mont = function mont(num) {
              return new Mont(num);
            };
            function Mont(m) {
              Red.call(this, m);
              this.shift = this.m.bitLength();
              if (this.shift % 26 !== 0) {
                this.shift += 26 - (this.shift % 26);
              }
              this.r = new BN(1).iushln(this.shift);
              this.r2 = this.imod(this.r.sqr());
              this.rinv = this.r._invmp(this.m);
              this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
              this.minv = this.minv.umod(this.r);
              this.minv = this.r.sub(this.minv);
            }
            inherits(Mont, Red);
            Mont.prototype.convertTo = function convertTo(num) {
              return this.imod(num.ushln(this.shift));
            };
            Mont.prototype.convertFrom = function convertFrom(num) {
              var r = this.imod(num.mul(this.rinv));
              r.red = null;
              return r;
            };
            Mont.prototype.imul = function imul(a, b) {
              if (a.isZero() || b.isZero()) {
                a.words[0] = 0;
                a.length = 1;
                return a;
              }
              var t = a.imul(b);
              var c = t
                .maskn(this.shift)
                .mul(this.minv)
                .imaskn(this.shift)
                .mul(this.m);
              var u = t.isub(c).iushrn(this.shift);
              var res = u;
              if (u.cmp(this.m) >= 0) {
                res = u.isub(this.m);
              } else if (u.cmpn(0) < 0) {
                res = u.iadd(this.m);
              }
              return res._forceRed(this);
            };
            Mont.prototype.mul = function mul(a, b) {
              if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
              var t = a.mul(b);
              var c = t
                .maskn(this.shift)
                .mul(this.minv)
                .imaskn(this.shift)
                .mul(this.m);
              var u = t.isub(c).iushrn(this.shift);
              var res = u;
              if (u.cmp(this.m) >= 0) {
                res = u.isub(this.m);
              } else if (u.cmpn(0) < 0) {
                res = u.iadd(this.m);
              }
              return res._forceRed(this);
            };
            Mont.prototype.invm = function invm(a) {
              // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
              var res = this.imod(a._invmp(this.m).mul(this.r2));
              return res._forceRed(this);
            };
          })(typeof module === "undefined" || module, this);
        },
        { buffer: "83fb80501e6599b7f0cf455c47cd5c1a" }
      ],
      baa8e23d083f0906729d32b8dd69719c: [
        function (require, module, exports) {
          "use strict";
          var utils = exports;
          function toArray(msg, enc) {
            if (Array.isArray(msg)) return msg.slice();
            if (!msg) return [];
            var res = [];
            if (typeof msg !== "string") {
              for (var i = 0; i < msg.length; i++) {
                res[i] = msg[i] | 0;
              }
              return res;
            }
            if (enc === "hex") {
              msg = msg.replace(/[^a-z0-9]+/gi, "");
              if (msg.length % 2 !== 0) msg = "0" + msg;
              for (var i = 0; i < msg.length; i += 2) {
                res.push(parseInt(msg[i] + msg[i + 1], 16));
              }
            } else {
              for (var i = 0; i < msg.length; i++) {
                var c = msg.charCodeAt(i);
                var hi = c >> 8;
                var lo = c & 0xff;
                if (hi) res.push(hi, lo);
                else res.push(lo);
              }
            }
            return res;
          }
          utils.toArray = toArray;
          function zero2(word) {
            if (word.length === 1) return "0" + word;
            else return word;
          }
          utils.zero2 = zero2;
          function toHex(msg) {
            var res = "";
            for (var i = 0; i < msg.length; i++) {
              res += zero2(msg[i].toString(16));
            }
            return res;
          }
          utils.toHex = toHex;
          utils.encode = function encode(arr, enc) {
            if (enc === "hex") return toHex(arr);
            else return arr;
          };
        },
        {}
      ],
      "29408169d16e6b476d0cacd15fab4cc6": [
        function (require, module, exports) {
          "use strict";
          var curve = exports;
          curve.base = require("./base");
          curve.short = require("./short");
          curve.mont = require("./mont");
          curve.edwards = require("./edwards");
        },
        {
          "./base": "7b4064fbeae57641ef7ca3a4f3cb17ea",
          "./short": "fff4590a37f910a3f74e8e8c95256bc5",
          "./mont": "c6f1c5f869bb308dd6bd7d5b462a93dd",
          "./edwards": "ae298cbc10ef33b80d61c8c2c9e5eacd"
        }
      ],
      "7b4064fbeae57641ef7ca3a4f3cb17ea": [
        function (require, module, exports) {
          "use strict";
          var BN = require("bn.js");
          var utils = require("../utils");
          var getNAF = utils.getNAF;
          var getJSF = utils.getJSF;
          var assert = utils.assert;
          function BaseCurve(type, conf) {
            this.type = type;
            this.p = new BN(conf.p, 16); // Use Montgomery, when there is no fast reduction for the prime
            this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p); // Useful for many curves
            this.zero = new BN(0).toRed(this.red);
            this.one = new BN(1).toRed(this.red);
            this.two = new BN(2).toRed(this.red); // Curve configuration, optional
            this.n = conf.n && new BN(conf.n, 16);
            this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed); // Temporary arrays
            this._wnafT1 = new Array(4);
            this._wnafT2 = new Array(4);
            this._wnafT3 = new Array(4);
            this._wnafT4 = new Array(4);
            this._bitLength = this.n ? this.n.bitLength() : 0; // Generalized Greg Maxwell's trick
            var adjustCount = this.n && this.p.div(this.n);
            if (!adjustCount || adjustCount.cmpn(100) > 0) {
              this.redN = null;
            } else {
              this._maxwellTrick = true;
              this.redN = this.n.toRed(this.red);
            }
          }
          module.exports = BaseCurve;
          BaseCurve.prototype.point = function point() {
            throw new Error("Not implemented");
          };
          BaseCurve.prototype.validate = function validate() {
            throw new Error("Not implemented");
          };
          BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
            assert(p.precomputed);
            var doubles = p._getDoubles();
            var naf = getNAF(k, 1, this._bitLength);
            var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
            I /= 3; // Translate into more windowed form
            var repr = [];
            for (var j = 0; j < naf.length; j += doubles.step) {
              var nafW = 0;
              for (var k = j + doubles.step - 1; k >= j; k--) {
                nafW = (nafW << 1) + naf[k];
              }
              repr.push(nafW);
            }
            var a = this.jpoint(null, null, null);
            var b = this.jpoint(null, null, null);
            for (var i = I; i > 0; i--) {
              for (var j = 0; j < repr.length; j++) {
                var nafW = repr[j];
                if (nafW === i) b = b.mixedAdd(doubles.points[j]);
                else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
              }
              a = a.add(b);
            }
            return a.toP();
          };
          BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
            var w = 4; // Precompute window
            var nafPoints = p._getNAFPoints(w);
            w = nafPoints.wnd;
            var wnd = nafPoints.points; // Get NAF form
            var naf = getNAF(k, w, this._bitLength); // Add `this`*(N+1) for every w-NAF index
            var acc = this.jpoint(null, null, null);
            for (var i = naf.length - 1; i >= 0; i--) {
              // Count zeroes
              for (var k = 0; i >= 0 && naf[i] === 0; i--) {
                k++;
              }
              if (i >= 0) k++;
              acc = acc.dblp(k);
              if (i < 0) break;
              var z = naf[i];
              assert(z !== 0);
              if (p.type === "affine") {
                // J +- P
                if (z > 0) acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
                else acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
              } else {
                // J +- J
                if (z > 0) acc = acc.add(wnd[(z - 1) >> 1]);
                else acc = acc.add(wnd[(-z - 1) >> 1].neg());
              }
            }
            return p.type === "affine" ? acc.toP() : acc;
          };
          BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(
            defW,
            points,
            coeffs,
            len,
            jacobianResult
          ) {
            var wndWidth = this._wnafT1;
            var wnd = this._wnafT2;
            var naf = this._wnafT3; // Fill all arrays
            var max = 0;
            for (var i = 0; i < len; i++) {
              var p = points[i];
              var nafPoints = p._getNAFPoints(defW);
              wndWidth[i] = nafPoints.wnd;
              wnd[i] = nafPoints.points;
            } // Comb small window NAFs
            for (var i = len - 1; i >= 1; i -= 2) {
              var a = i - 1;
              var b = i;
              if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
                naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
                naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
                max = Math.max(naf[a].length, max);
                max = Math.max(naf[b].length, max);
                continue;
              }
              var comb = [
                points[a],
                /* 1 */ null,
                /* 3 */ null,
                /* 5 */ points[b] /* 7 */
              ]; // Try to avoid Projective points, if possible
              if (points[a].y.cmp(points[b].y) === 0) {
                comb[1] = points[a].add(points[b]);
                comb[2] = points[a].toJ().mixedAdd(points[b].neg());
              } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
                comb[1] = points[a].toJ().mixedAdd(points[b]);
                comb[2] = points[a].add(points[b].neg());
              } else {
                comb[1] = points[a].toJ().mixedAdd(points[b]);
                comb[2] = points[a].toJ().mixedAdd(points[b].neg());
              }
              var index = [
                -3,
                /* -1 -1 */ -1,
                /* -1 0 */ -5,
                /* -1 1 */ -7,
                /* 0 -1 */ 0,
                /* 0 0 */ 7,
                /* 0 1 */ 5,
                /* 1 -1 */ 1,
                /* 1 0 */ 3 /* 1 1 */
              ];
              var jsf = getJSF(coeffs[a], coeffs[b]);
              max = Math.max(jsf[0].length, max);
              naf[a] = new Array(max);
              naf[b] = new Array(max);
              for (var j = 0; j < max; j++) {
                var ja = jsf[0][j] | 0;
                var jb = jsf[1][j] | 0;
                naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
                naf[b][j] = 0;
                wnd[a] = comb;
              }
            }
            var acc = this.jpoint(null, null, null);
            var tmp = this._wnafT4;
            for (var i = max; i >= 0; i--) {
              var k = 0;
              while (i >= 0) {
                var zero = true;
                for (var j = 0; j < len; j++) {
                  tmp[j] = naf[j][i] | 0;
                  if (tmp[j] !== 0) zero = false;
                }
                if (!zero) break;
                k++;
                i--;
              }
              if (i >= 0) k++;
              acc = acc.dblp(k);
              if (i < 0) break;
              for (var j = 0; j < len; j++) {
                var z = tmp[j];
                var p;
                if (z === 0) continue;
                else if (z > 0) p = wnd[j][(z - 1) >> 1];
                else if (z < 0) p = wnd[j][(-z - 1) >> 1].neg();
                if (p.type === "affine") acc = acc.mixedAdd(p);
                else acc = acc.add(p);
              }
            } // Zeroify references
            for (var i = 0; i < len; i++) {
              wnd[i] = null;
            }
            if (jacobianResult) return acc;
            else return acc.toP();
          };
          function BasePoint(curve, type) {
            this.curve = curve;
            this.type = type;
            this.precomputed = null;
          }
          BaseCurve.BasePoint = BasePoint;
          BasePoint.prototype.eq = function eq() /*other*/ {
            throw new Error("Not implemented");
          };
          BasePoint.prototype.validate = function validate() {
            return this.curve.validate(this);
          };
          BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
            bytes = utils.toArray(bytes, enc);
            var len = this.p.byteLength(); // uncompressed, hybrid-odd, hybrid-even
            if (
              (bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
              bytes.length - 1 === 2 * len
            ) {
              if (bytes[0] === 0x06) assert(bytes[bytes.length - 1] % 2 === 0);
              else if (bytes[0] === 0x07)
                assert(bytes[bytes.length - 1] % 2 === 1);
              var res = this.point(
                bytes.slice(1, 1 + len),
                bytes.slice(1 + len, 1 + 2 * len)
              );
              return res;
            } else if (
              (bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len
            ) {
              return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
            }
            throw new Error("Unknown point format");
          };
          BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
            return this.encode(enc, true);
          };
          BasePoint.prototype._encode = function _encode(compact) {
            var len = this.curve.p.byteLength();
            var x = this.getX().toArray("be", len);
            if (compact) return [this.getY().isEven() ? 0x02 : 0x03].concat(x);
            return [0x04].concat(x, this.getY().toArray("be", len));
          };
          BasePoint.prototype.encode = function encode(enc, compact) {
            return utils.encode(this._encode(compact), enc);
          };
          BasePoint.prototype.precompute = function precompute(power) {
            if (this.precomputed) return this;
            var precomputed = { doubles: null, naf: null, beta: null };
            precomputed.naf = this._getNAFPoints(8);
            precomputed.doubles = this._getDoubles(4, power);
            precomputed.beta = this._getBeta();
            this.precomputed = precomputed;
            return this;
          };
          BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
            if (!this.precomputed) return false;
            var doubles = this.precomputed.doubles;
            if (!doubles) return false;
            return (
              doubles.points.length >=
              Math.ceil((k.bitLength() + 1) / doubles.step)
            );
          };
          BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
            if (this.precomputed && this.precomputed.doubles)
              return this.precomputed.doubles;
            var doubles = [this];
            var acc = this;
            for (var i = 0; i < power; i += step) {
              for (var j = 0; j < step; j++) {
                acc = acc.dbl();
              }
              doubles.push(acc);
            }
            return { step: step, points: doubles };
          };
          BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
            if (this.precomputed && this.precomputed.naf)
              return this.precomputed.naf;
            var res = [this];
            var max = (1 << wnd) - 1;
            var dbl = max === 1 ? null : this.dbl();
            for (var i = 1; i < max; i++) {
              res[i] = res[i - 1].add(dbl);
            }
            return { wnd: wnd, points: res };
          };
          BasePoint.prototype._getBeta = function _getBeta() {
            return null;
          };
          BasePoint.prototype.dblp = function dblp(k) {
            var r = this;
            for (var i = 0; i < k; i++) {
              r = r.dbl();
            }
            return r;
          };
        },
        {
          "bn.js": "c067c95fc23ea4f3df8ca0f49aa28d8d",
          "../utils": "19cbc0e8eeaa80c7312d4080f426c995"
        }
      ],
      fff4590a37f910a3f74e8e8c95256bc5: [
        function (require, module, exports) {
          "use strict";
          var utils = require("../utils");
          var BN = require("bn.js");
          var inherits = require("inherits");
          var Base = require("./base");
          var assert = utils.assert;
          function ShortCurve(conf) {
            Base.call(this, "short", conf);
            this.a = new BN(conf.a, 16).toRed(this.red);
            this.b = new BN(conf.b, 16).toRed(this.red);
            this.tinv = this.two.redInvm();
            this.zeroA = this.a.fromRed().cmpn(0) === 0;
            this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0; // If the curve is endomorphic, precalculate beta and lambda
            this.endo = this._getEndomorphism(conf);
            this._endoWnafT1 = new Array(4);
            this._endoWnafT2 = new Array(4);
          }
          inherits(ShortCurve, Base);
          module.exports = ShortCurve;
          ShortCurve.prototype._getEndomorphism = function _getEndomorphism(
            conf
          ) {
            // No efficient endomorphism
            if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return; // Compute beta and lambda, that lambda * P = (beta * Px; Py)
            var beta;
            var lambda;
            if (conf.beta) {
              beta = new BN(conf.beta, 16).toRed(this.red);
            } else {
              var betas = this._getEndoRoots(this.p); // Choose the smallest beta
              beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
              beta = beta.toRed(this.red);
            }
            if (conf.lambda) {
              lambda = new BN(conf.lambda, 16);
            } else {
              // Choose the lambda that is matching selected beta
              var lambdas = this._getEndoRoots(this.n);
              if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
                lambda = lambdas[0];
              } else {
                lambda = lambdas[1];
                assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
              }
            } // Get basis vectors, used for balanced length-two representation
            var basis;
            if (conf.basis) {
              basis = conf.basis.map(function (vec) {
                return { a: new BN(vec.a, 16), b: new BN(vec.b, 16) };
              });
            } else {
              basis = this._getEndoBasis(lambda);
            }
            return { beta: beta, lambda: lambda, basis: basis };
          };
          ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
            // Find roots of for x^2 + x + 1 in F
            // Root = (-1 +- Sqrt(-3)) / 2
            //
            var red = num === this.p ? this.red : BN.mont(num);
            var tinv = new BN(2).toRed(red).redInvm();
            var ntinv = tinv.redNeg();
            var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);
            var l1 = ntinv.redAdd(s).fromRed();
            var l2 = ntinv.redSub(s).fromRed();
            return [l1, l2];
          };
          ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
            // aprxSqrt >= sqrt(this.n)
            var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2)); // 3.74
            // Run EGCD, until r(L + 1) < aprxSqrt
            var u = lambda;
            var v = this.n.clone();
            var x1 = new BN(1);
            var y1 = new BN(0);
            var x2 = new BN(0);
            var y2 = new BN(1); // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
            var a0;
            var b0; // First vector
            var a1;
            var b1; // Second vector
            var a2;
            var b2;
            var prevR;
            var i = 0;
            var r;
            var x;
            while (u.cmpn(0) !== 0) {
              var q = v.div(u);
              r = v.sub(q.mul(u));
              x = x2.sub(q.mul(x1));
              var y = y2.sub(q.mul(y1));
              if (!a1 && r.cmp(aprxSqrt) < 0) {
                a0 = prevR.neg();
                b0 = x1;
                a1 = r.neg();
                b1 = x;
              } else if (a1 && ++i === 2) {
                break;
              }
              prevR = r;
              v = u;
              u = r;
              x2 = x1;
              x1 = x;
              y2 = y1;
              y1 = y;
            }
            a2 = r.neg();
            b2 = x;
            var len1 = a1.sqr().add(b1.sqr());
            var len2 = a2.sqr().add(b2.sqr());
            if (len2.cmp(len1) >= 0) {
              a2 = a0;
              b2 = b0;
            } // Normalize signs
            if (a1.negative) {
              a1 = a1.neg();
              b1 = b1.neg();
            }
            if (a2.negative) {
              a2 = a2.neg();
              b2 = b2.neg();
            }
            return [
              { a: a1, b: b1 },
              { a: a2, b: b2 }
            ];
          };
          ShortCurve.prototype._endoSplit = function _endoSplit(k) {
            var basis = this.endo.basis;
            var v1 = basis[0];
            var v2 = basis[1];
            var c1 = v2.b.mul(k).divRound(this.n);
            var c2 = v1.b.neg().mul(k).divRound(this.n);
            var p1 = c1.mul(v1.a);
            var p2 = c2.mul(v2.a);
            var q1 = c1.mul(v1.b);
            var q2 = c2.mul(v2.b); // Calculate answer
            var k1 = k.sub(p1).sub(p2);
            var k2 = q1.add(q2).neg();
            return { k1: k1, k2: k2 };
          };
          ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
            x = new BN(x, 16);
            if (!x.red) x = x.toRed(this.red);
            var y2 = x
              .redSqr()
              .redMul(x)
              .redIAdd(x.redMul(this.a))
              .redIAdd(this.b);
            var y = y2.redSqrt();
            if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
              throw new Error("invalid point"); // XXX Is there any way to tell if the number is odd without converting it
            // to non-red form?
            var isOdd = y.fromRed().isOdd();
            if ((odd && !isOdd) || (!odd && isOdd)) y = y.redNeg();
            return this.point(x, y);
          };
          ShortCurve.prototype.validate = function validate(point) {
            if (point.inf) return true;
            var x = point.x;
            var y = point.y;
            var ax = this.a.redMul(x);
            var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
            return y.redSqr().redISub(rhs).cmpn(0) === 0;
          };
          ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(
            points,
            coeffs,
            jacobianResult
          ) {
            var npoints = this._endoWnafT1;
            var ncoeffs = this._endoWnafT2;
            for (var i = 0; i < points.length; i++) {
              var split = this._endoSplit(coeffs[i]);
              var p = points[i];
              var beta = p._getBeta();
              if (split.k1.negative) {
                split.k1.ineg();
                p = p.neg(true);
              }
              if (split.k2.negative) {
                split.k2.ineg();
                beta = beta.neg(true);
              }
              npoints[i * 2] = p;
              npoints[i * 2 + 1] = beta;
              ncoeffs[i * 2] = split.k1;
              ncoeffs[i * 2 + 1] = split.k2;
            }
            var res = this._wnafMulAdd(
              1,
              npoints,
              ncoeffs,
              i * 2,
              jacobianResult
            ); // Clean-up references to points and coefficients
            for (var j = 0; j < i * 2; j++) {
              npoints[j] = null;
              ncoeffs[j] = null;
            }
            return res;
          };
          function Point(curve, x, y, isRed) {
            Base.BasePoint.call(this, curve, "affine");
            if (x === null && y === null) {
              this.x = null;
              this.y = null;
              this.inf = true;
            } else {
              this.x = new BN(x, 16);
              this.y = new BN(y, 16); // Force redgomery representation when loading from JSON
              if (isRed) {
                this.x.forceRed(this.curve.red);
                this.y.forceRed(this.curve.red);
              }
              if (!this.x.red) this.x = this.x.toRed(this.curve.red);
              if (!this.y.red) this.y = this.y.toRed(this.curve.red);
              this.inf = false;
            }
          }
          inherits(Point, Base.BasePoint);
          ShortCurve.prototype.point = function point(x, y, isRed) {
            return new Point(this, x, y, isRed);
          };
          ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
            return Point.fromJSON(this, obj, red);
          };
          Point.prototype._getBeta = function _getBeta() {
            if (!this.curve.endo) return;
            var pre = this.precomputed;
            if (pre && pre.beta) return pre.beta;
            var beta = this.curve.point(
              this.x.redMul(this.curve.endo.beta),
              this.y
            );
            if (pre) {
              var curve = this.curve;
              var endoMul = function endoMul(p) {
                return curve.point(p.x.redMul(curve.endo.beta), p.y);
              };
              pre.beta = beta;
              beta.precomputed = {
                beta: null,
                naf: pre.naf && {
                  wnd: pre.naf.wnd,
                  points: pre.naf.points.map(endoMul)
                },
                doubles: pre.doubles && {
                  step: pre.doubles.step,
                  points: pre.doubles.points.map(endoMul)
                }
              };
            }
            return beta;
          };
          Point.prototype.toJSON = function toJSON() {
            if (!this.precomputed) return [this.x, this.y];
            return [
              this.x,
              this.y,
              this.precomputed && {
                doubles: this.precomputed.doubles && {
                  step: this.precomputed.doubles.step,
                  points: this.precomputed.doubles.points.slice(1)
                },
                naf: this.precomputed.naf && {
                  wnd: this.precomputed.naf.wnd,
                  points: this.precomputed.naf.points.slice(1)
                }
              }
            ];
          };
          Point.fromJSON = function fromJSON(curve, obj, red) {
            if (typeof obj === "string") obj = JSON.parse(obj);
            var res = curve.point(obj[0], obj[1], red);
            if (!obj[2]) return res;
            function obj2point(obj) {
              return curve.point(obj[0], obj[1], red);
            }
            var pre = obj[2];
            res.precomputed = {
              beta: null,
              doubles: pre.doubles && {
                step: pre.doubles.step,
                points: [res].concat(pre.doubles.points.map(obj2point))
              },
              naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: [res].concat(pre.naf.points.map(obj2point))
              }
            };
            return res;
          };
          Point.prototype.inspect = function inspect() {
            if (this.isInfinity()) return "<EC Point Infinity>";
            return (
              "<EC Point x: " +
              this.x.fromRed().toString(16, 2) +
              " y: " +
              this.y.fromRed().toString(16, 2) +
              ">"
            );
          };
          Point.prototype.isInfinity = function isInfinity() {
            return this.inf;
          };
          Point.prototype.add = function add(p) {
            // O + P = P
            if (this.inf) return p; // P + O = P
            if (p.inf) return this; // P + P = 2P
            if (this.eq(p)) return this.dbl(); // P + (-P) = O
            if (this.neg().eq(p)) return this.curve.point(null, null); // P + Q = O
            if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
            var c = this.y.redSub(p.y);
            if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
            var nx = c.redSqr().redISub(this.x).redISub(p.x);
            var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
            return this.curve.point(nx, ny);
          };
          Point.prototype.dbl = function dbl() {
            if (this.inf) return this; // 2P = O
            var ys1 = this.y.redAdd(this.y);
            if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
            var a = this.curve.a;
            var x2 = this.x.redSqr();
            var dyinv = ys1.redInvm();
            var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
            var nx = c.redSqr().redISub(this.x.redAdd(this.x));
            var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
            return this.curve.point(nx, ny);
          };
          Point.prototype.getX = function getX() {
            return this.x.fromRed();
          };
          Point.prototype.getY = function getY() {
            return this.y.fromRed();
          };
          Point.prototype.mul = function mul(k) {
            k = new BN(k, 16);
            if (this.isInfinity()) return this;
            else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
            else if (this.curve.endo)
              return this.curve._endoWnafMulAdd([this], [k]);
            else return this.curve._wnafMul(this, k);
          };
          Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
            var points = [this, p2];
            var coeffs = [k1, k2];
            if (this.curve.endo)
              return this.curve._endoWnafMulAdd(points, coeffs);
            else return this.curve._wnafMulAdd(1, points, coeffs, 2);
          };
          Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
            var points = [this, p2];
            var coeffs = [k1, k2];
            if (this.curve.endo)
              return this.curve._endoWnafMulAdd(points, coeffs, true);
            else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
          };
          Point.prototype.eq = function eq(p) {
            return (
              this === p ||
              (this.inf === p.inf &&
                (this.inf || (this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0)))
            );
          };
          Point.prototype.neg = function neg(_precompute) {
            if (this.inf) return this;
            var res = this.curve.point(this.x, this.y.redNeg());
            if (_precompute && this.precomputed) {
              var pre = this.precomputed;
              var negate = function negate(p) {
                return p.neg();
              };
              res.precomputed = {
                naf: pre.naf && {
                  wnd: pre.naf.wnd,
                  points: pre.naf.points.map(negate)
                },
                doubles: pre.doubles && {
                  step: pre.doubles.step,
                  points: pre.doubles.points.map(negate)
                }
              };
            }
            return res;
          };
          Point.prototype.toJ = function toJ() {
            if (this.inf) return this.curve.jpoint(null, null, null);
            var res = this.curve.jpoint(this.x, this.y, this.curve.one);
            return res;
          };
          function JPoint(curve, x, y, z) {
            Base.BasePoint.call(this, curve, "jacobian");
            if (x === null && y === null && z === null) {
              this.x = this.curve.one;
              this.y = this.curve.one;
              this.z = new BN(0);
            } else {
              this.x = new BN(x, 16);
              this.y = new BN(y, 16);
              this.z = new BN(z, 16);
            }
            if (!this.x.red) this.x = this.x.toRed(this.curve.red);
            if (!this.y.red) this.y = this.y.toRed(this.curve.red);
            if (!this.z.red) this.z = this.z.toRed(this.curve.red);
            this.zOne = this.z === this.curve.one;
          }
          inherits(JPoint, Base.BasePoint);
          ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
            return new JPoint(this, x, y, z);
          };
          JPoint.prototype.toP = function toP() {
            if (this.isInfinity()) return this.curve.point(null, null);
            var zinv = this.z.redInvm();
            var zinv2 = zinv.redSqr();
            var ax = this.x.redMul(zinv2);
            var ay = this.y.redMul(zinv2).redMul(zinv);
            return this.curve.point(ax, ay);
          };
          JPoint.prototype.neg = function neg() {
            return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
          };
          JPoint.prototype.add = function add(p) {
            // O + P = P
            if (this.isInfinity()) return p; // P + O = P
            if (p.isInfinity()) return this; // 12M + 4S + 7A
            var pz2 = p.z.redSqr();
            var z2 = this.z.redSqr();
            var u1 = this.x.redMul(pz2);
            var u2 = p.x.redMul(z2);
            var s1 = this.y.redMul(pz2.redMul(p.z));
            var s2 = p.y.redMul(z2.redMul(this.z));
            var h = u1.redSub(u2);
            var r = s1.redSub(s2);
            if (h.cmpn(0) === 0) {
              if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
              else return this.dbl();
            }
            var h2 = h.redSqr();
            var h3 = h2.redMul(h);
            var v = u1.redMul(h2);
            var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
            var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
            var nz = this.z.redMul(p.z).redMul(h);
            return this.curve.jpoint(nx, ny, nz);
          };
          JPoint.prototype.mixedAdd = function mixedAdd(p) {
            // O + P = P
            if (this.isInfinity()) return p.toJ(); // P + O = P
            if (p.isInfinity()) return this; // 8M + 3S + 7A
            var z2 = this.z.redSqr();
            var u1 = this.x;
            var u2 = p.x.redMul(z2);
            var s1 = this.y;
            var s2 = p.y.redMul(z2).redMul(this.z);
            var h = u1.redSub(u2);
            var r = s1.redSub(s2);
            if (h.cmpn(0) === 0) {
              if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
              else return this.dbl();
            }
            var h2 = h.redSqr();
            var h3 = h2.redMul(h);
            var v = u1.redMul(h2);
            var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
            var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
            var nz = this.z.redMul(h);
            return this.curve.jpoint(nx, ny, nz);
          };
          JPoint.prototype.dblp = function dblp(pow) {
            if (pow === 0) return this;
            if (this.isInfinity()) return this;
            if (!pow) return this.dbl();
            if (this.curve.zeroA || this.curve.threeA) {
              var r = this;
              for (var i = 0; i < pow; i++) {
                r = r.dbl();
              }
              return r;
            } // 1M + 2S + 1A + N * (4S + 5M + 8A)
            // N = 1 => 6M + 6S + 9A
            var a = this.curve.a;
            var tinv = this.curve.tinv;
            var jx = this.x;
            var jy = this.y;
            var jz = this.z;
            var jz4 = jz.redSqr().redSqr(); // Reuse results
            var jyd = jy.redAdd(jy);
            for (var i = 0; i < pow; i++) {
              var jx2 = jx.redSqr();
              var jyd2 = jyd.redSqr();
              var jyd4 = jyd2.redSqr();
              var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
              var t1 = jx.redMul(jyd2);
              var nx = c.redSqr().redISub(t1.redAdd(t1));
              var t2 = t1.redISub(nx);
              var dny = c.redMul(t2);
              dny = dny.redIAdd(dny).redISub(jyd4);
              var nz = jyd.redMul(jz);
              if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
              jx = nx;
              jz = nz;
              jyd = dny;
            }
            return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
          };
          JPoint.prototype.dbl = function dbl() {
            if (this.isInfinity()) return this;
            if (this.curve.zeroA) return this._zeroDbl();
            else if (this.curve.threeA) return this._threeDbl();
            else return this._dbl();
          };
          JPoint.prototype._zeroDbl = function _zeroDbl() {
            var nx;
            var ny;
            var nz; // Z = 1
            if (this.zOne) {
              // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
              //     #doubling-mdbl-2007-bl
              // 1M + 5S + 14A
              // XX = X1^2
              var xx = this.x.redSqr(); // YY = Y1^2
              var yy = this.y.redSqr(); // YYYY = YY^2
              var yyyy = yy.redSqr(); // S = 2 * ((X1 + YY)^2 - XX - YYYY)
              var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
              s = s.redIAdd(s); // M = 3 * XX + a; a = 0
              var m = xx.redAdd(xx).redIAdd(xx); // T = M ^ 2 - 2*S
              var t = m.redSqr().redISub(s).redISub(s); // 8 * YYYY
              var yyyy8 = yyyy.redIAdd(yyyy);
              yyyy8 = yyyy8.redIAdd(yyyy8);
              yyyy8 = yyyy8.redIAdd(yyyy8); // X3 = T
              nx = t; // Y3 = M * (S - T) - 8 * YYYY
              ny = m.redMul(s.redISub(t)).redISub(yyyy8); // Z3 = 2*Y1
              nz = this.y.redAdd(this.y);
            } else {
              // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
              //     #doubling-dbl-2009-l
              // 2M + 5S + 13A
              // A = X1^2
              var a = this.x.redSqr(); // B = Y1^2
              var b = this.y.redSqr(); // C = B^2
              var c = b.redSqr(); // D = 2 * ((X1 + B)^2 - A - C)
              var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
              d = d.redIAdd(d); // E = 3 * A
              var e = a.redAdd(a).redIAdd(a); // F = E^2
              var f = e.redSqr(); // 8 * C
              var c8 = c.redIAdd(c);
              c8 = c8.redIAdd(c8);
              c8 = c8.redIAdd(c8); // X3 = F - 2 * D
              nx = f.redISub(d).redISub(d); // Y3 = E * (D - X3) - 8 * C
              ny = e.redMul(d.redISub(nx)).redISub(c8); // Z3 = 2 * Y1 * Z1
              nz = this.y.redMul(this.z);
              nz = nz.redIAdd(nz);
            }
            return this.curve.jpoint(nx, ny, nz);
          };
          JPoint.prototype._threeDbl = function _threeDbl() {
            var nx;
            var ny;
            var nz; // Z = 1
            if (this.zOne) {
              // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
              //     #doubling-mdbl-2007-bl
              // 1M + 5S + 15A
              // XX = X1^2
              var xx = this.x.redSqr(); // YY = Y1^2
              var yy = this.y.redSqr(); // YYYY = YY^2
              var yyyy = yy.redSqr(); // S = 2 * ((X1 + YY)^2 - XX - YYYY)
              var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
              s = s.redIAdd(s); // M = 3 * XX + a
              var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a); // T = M^2 - 2 * S
              var t = m.redSqr().redISub(s).redISub(s); // X3 = T
              nx = t; // Y3 = M * (S - T) - 8 * YYYY
              var yyyy8 = yyyy.redIAdd(yyyy);
              yyyy8 = yyyy8.redIAdd(yyyy8);
              yyyy8 = yyyy8.redIAdd(yyyy8);
              ny = m.redMul(s.redISub(t)).redISub(yyyy8); // Z3 = 2 * Y1
              nz = this.y.redAdd(this.y);
            } else {
              // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
              // 3M + 5S
              // delta = Z1^2
              var delta = this.z.redSqr(); // gamma = Y1^2
              var gamma = this.y.redSqr(); // beta = X1 * gamma
              var beta = this.x.redMul(gamma); // alpha = 3 * (X1 - delta) * (X1 + delta)
              var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
              alpha = alpha.redAdd(alpha).redIAdd(alpha); // X3 = alpha^2 - 8 * beta
              var beta4 = beta.redIAdd(beta);
              beta4 = beta4.redIAdd(beta4);
              var beta8 = beta4.redAdd(beta4);
              nx = alpha.redSqr().redISub(beta8); // Z3 = (Y1 + Z1)^2 - gamma - delta
              nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta); // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
              var ggamma8 = gamma.redSqr();
              ggamma8 = ggamma8.redIAdd(ggamma8);
              ggamma8 = ggamma8.redIAdd(ggamma8);
              ggamma8 = ggamma8.redIAdd(ggamma8);
              ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
            }
            return this.curve.jpoint(nx, ny, nz);
          };
          JPoint.prototype._dbl = function _dbl() {
            var a = this.curve.a; // 4M + 6S + 10A
            var jx = this.x;
            var jy = this.y;
            var jz = this.z;
            var jz4 = jz.redSqr().redSqr();
            var jx2 = jx.redSqr();
            var jy2 = jy.redSqr();
            var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
            var jxd4 = jx.redAdd(jx);
            jxd4 = jxd4.redIAdd(jxd4);
            var t1 = jxd4.redMul(jy2);
            var nx = c.redSqr().redISub(t1.redAdd(t1));
            var t2 = t1.redISub(nx);
            var jyd8 = jy2.redSqr();
            jyd8 = jyd8.redIAdd(jyd8);
            jyd8 = jyd8.redIAdd(jyd8);
            jyd8 = jyd8.redIAdd(jyd8);
            var ny = c.redMul(t2).redISub(jyd8);
            var nz = jy.redAdd(jy).redMul(jz);
            return this.curve.jpoint(nx, ny, nz);
          };
          JPoint.prototype.trpl = function trpl() {
            if (!this.curve.zeroA) return this.dbl().add(this); // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
            // 5M + 10S + ...
            // XX = X1^2
            var xx = this.x.redSqr(); // YY = Y1^2
            var yy = this.y.redSqr(); // ZZ = Z1^2
            var zz = this.z.redSqr(); // YYYY = YY^2
            var yyyy = yy.redSqr(); // M = 3 * XX + a * ZZ2; a = 0
            var m = xx.redAdd(xx).redIAdd(xx); // MM = M^2
            var mm = m.redSqr(); // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
            var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
            e = e.redIAdd(e);
            e = e.redAdd(e).redIAdd(e);
            e = e.redISub(mm); // EE = E^2
            var ee = e.redSqr(); // T = 16*YYYY
            var t = yyyy.redIAdd(yyyy);
            t = t.redIAdd(t);
            t = t.redIAdd(t);
            t = t.redIAdd(t); // U = (M + E)^2 - MM - EE - T
            var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t); // X3 = 4 * (X1 * EE - 4 * YY * U)
            var yyu4 = yy.redMul(u);
            yyu4 = yyu4.redIAdd(yyu4);
            yyu4 = yyu4.redIAdd(yyu4);
            var nx = this.x.redMul(ee).redISub(yyu4);
            nx = nx.redIAdd(nx);
            nx = nx.redIAdd(nx); // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
            var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
            ny = ny.redIAdd(ny);
            ny = ny.redIAdd(ny);
            ny = ny.redIAdd(ny); // Z3 = (Z1 + E)^2 - ZZ - EE
            var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
            return this.curve.jpoint(nx, ny, nz);
          };
          JPoint.prototype.mul = function mul(k, kbase) {
            k = new BN(k, kbase);
            return this.curve._wnafMul(this, k);
          };
          JPoint.prototype.eq = function eq(p) {
            if (p.type === "affine") return this.eq(p.toJ());
            if (this === p) return true; // x1 * z2^2 == x2 * z1^2
            var z2 = this.z.redSqr();
            var pz2 = p.z.redSqr();
            if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
              return false; // y1 * z2^3 == y2 * z1^3
            var z3 = z2.redMul(this.z);
            var pz3 = pz2.redMul(p.z);
            return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
          };
          JPoint.prototype.eqXToP = function eqXToP(x) {
            var zs = this.z.redSqr();
            var rx = x.toRed(this.curve.red).redMul(zs);
            if (this.x.cmp(rx) === 0) return true;
            var xc = x.clone();
            var t = this.curve.redN.redMul(zs);
            for (;;) {
              xc.iadd(this.curve.n);
              if (xc.cmp(this.curve.p) >= 0) return false;
              rx.redIAdd(t);
              if (this.x.cmp(rx) === 0) return true;
            }
          };
          JPoint.prototype.inspect = function inspect() {
            if (this.isInfinity()) return "<EC JPoint Infinity>";
            return (
              "<EC JPoint x: " +
              this.x.toString(16, 2) +
              " y: " +
              this.y.toString(16, 2) +
              " z: " +
              this.z.toString(16, 2) +
              ">"
            );
          };
          JPoint.prototype.isInfinity = function isInfinity() {
            // XXX This code assumes that zero is always zero in red
            return this.z.cmpn(0) === 0;
          };
        },
        {
          "../utils": "19cbc0e8eeaa80c7312d4080f426c995",
          "bn.js": "c067c95fc23ea4f3df8ca0f49aa28d8d",
          inherits: "cd61047e9289e4b62768390878fc0b01",
          "./base": "7b4064fbeae57641ef7ca3a4f3cb17ea"
        }
      ],
      c6f1c5f869bb308dd6bd7d5b462a93dd: [
        function (require, module, exports) {
          "use strict";
          var BN = require("bn.js");
          var inherits = require("inherits");
          var Base = require("./base");
          var utils = require("../utils");
          function MontCurve(conf) {
            Base.call(this, "mont", conf);
            this.a = new BN(conf.a, 16).toRed(this.red);
            this.b = new BN(conf.b, 16).toRed(this.red);
            this.i4 = new BN(4).toRed(this.red).redInvm();
            this.two = new BN(2).toRed(this.red);
            this.a24 = this.i4.redMul(this.a.redAdd(this.two));
          }
          inherits(MontCurve, Base);
          module.exports = MontCurve;
          MontCurve.prototype.validate = function validate(point) {
            var x = point.normalize().x;
            var x2 = x.redSqr();
            var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
            var y = rhs.redSqrt();
            return y.redSqr().cmp(rhs) === 0;
          };
          function Point(curve, x, z) {
            Base.BasePoint.call(this, curve, "projective");
            if (x === null && z === null) {
              this.x = this.curve.one;
              this.z = this.curve.zero;
            } else {
              this.x = new BN(x, 16);
              this.z = new BN(z, 16);
              if (!this.x.red) this.x = this.x.toRed(this.curve.red);
              if (!this.z.red) this.z = this.z.toRed(this.curve.red);
            }
          }
          inherits(Point, Base.BasePoint);
          MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
            return this.point(utils.toArray(bytes, enc), 1);
          };
          MontCurve.prototype.point = function point(x, z) {
            return new Point(this, x, z);
          };
          MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
            return Point.fromJSON(this, obj);
          };
          Point.prototype.precompute = function precompute() {
            // No-op
          };
          Point.prototype._encode = function _encode() {
            return this.getX().toArray("be", this.curve.p.byteLength());
          };
          Point.fromJSON = function fromJSON(curve, obj) {
            return new Point(curve, obj[0], obj[1] || curve.one);
          };
          Point.prototype.inspect = function inspect() {
            if (this.isInfinity()) return "<EC Point Infinity>";
            return (
              "<EC Point x: " +
              this.x.fromRed().toString(16, 2) +
              " z: " +
              this.z.fromRed().toString(16, 2) +
              ">"
            );
          };
          Point.prototype.isInfinity = function isInfinity() {
            // XXX This code assumes that zero is always zero in red
            return this.z.cmpn(0) === 0;
          };
          Point.prototype.dbl = function dbl() {
            // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
            // 2M + 2S + 4A
            // A = X1 + Z1
            var a = this.x.redAdd(this.z); // AA = A^2
            var aa = a.redSqr(); // B = X1 - Z1
            var b = this.x.redSub(this.z); // BB = B^2
            var bb = b.redSqr(); // C = AA - BB
            var c = aa.redSub(bb); // X3 = AA * BB
            var nx = aa.redMul(bb); // Z3 = C * (BB + A24 * C)
            var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
            return this.curve.point(nx, nz);
          };
          Point.prototype.add = function add() {
            throw new Error("Not supported on Montgomery curve");
          };
          Point.prototype.diffAdd = function diffAdd(p, diff) {
            // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
            // 4M + 2S + 6A
            // A = X2 + Z2
            var a = this.x.redAdd(this.z); // B = X2 - Z2
            var b = this.x.redSub(this.z); // C = X3 + Z3
            var c = p.x.redAdd(p.z); // D = X3 - Z3
            var d = p.x.redSub(p.z); // DA = D * A
            var da = d.redMul(a); // CB = C * B
            var cb = c.redMul(b); // X5 = Z1 * (DA + CB)^2
            var nx = diff.z.redMul(da.redAdd(cb).redSqr()); // Z5 = X1 * (DA - CB)^2
            var nz = diff.x.redMul(da.redISub(cb).redSqr());
            return this.curve.point(nx, nz);
          };
          Point.prototype.mul = function mul(k) {
            var t = k.clone();
            var a = this; // (N / 2) * Q + Q
            var b = this.curve.point(null, null); // (N / 2) * Q
            var c = this; // Q
            for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1)) {
              bits.push(t.andln(1));
            }
            for (var i = bits.length - 1; i >= 0; i--) {
              if (bits[i] === 0) {
                // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
                a = a.diffAdd(b, c); // N * Q = 2 * ((N / 2) * Q + Q))
                b = b.dbl();
              } else {
                // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
                b = a.diffAdd(b, c); // N * Q + Q = 2 * ((N / 2) * Q + Q)
                a = a.dbl();
              }
            }
            return b;
          };
          Point.prototype.mulAdd = function mulAdd() {
            throw new Error("Not supported on Montgomery curve");
          };
          Point.prototype.jumlAdd = function jumlAdd() {
            throw new Error("Not supported on Montgomery curve");
          };
          Point.prototype.eq = function eq(other) {
            return this.getX().cmp(other.getX()) === 0;
          };
          Point.prototype.normalize = function normalize() {
            this.x = this.x.redMul(this.z.redInvm());
            this.z = this.curve.one;
            return this;
          };
          Point.prototype.getX = function getX() {
            // Normalize coordinates
            this.normalize();
            return this.x.fromRed();
          };
        },
        {
          "bn.js": "c067c95fc23ea4f3df8ca0f49aa28d8d",
          inherits: "cd61047e9289e4b62768390878fc0b01",
          "./base": "7b4064fbeae57641ef7ca3a4f3cb17ea",
          "../utils": "19cbc0e8eeaa80c7312d4080f426c995"
        }
      ],
      ae298cbc10ef33b80d61c8c2c9e5eacd: [
        function (require, module, exports) {
          "use strict";
          var utils = require("../utils");
          var BN = require("bn.js");
          var inherits = require("inherits");
          var Base = require("./base");
          var assert = utils.assert;
          function EdwardsCurve(conf) {
            // NOTE: Important as we are creating point in Base.call()
            this.twisted = (conf.a | 0) !== 1;
            this.mOneA = this.twisted && (conf.a | 0) === -1;
            this.extended = this.mOneA;
            Base.call(this, "edwards", conf);
            this.a = new BN(conf.a, 16).umod(this.red.m);
            this.a = this.a.toRed(this.red);
            this.c = new BN(conf.c, 16).toRed(this.red);
            this.c2 = this.c.redSqr();
            this.d = new BN(conf.d, 16).toRed(this.red);
            this.dd = this.d.redAdd(this.d);
            assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
            this.oneC = (conf.c | 0) === 1;
          }
          inherits(EdwardsCurve, Base);
          module.exports = EdwardsCurve;
          EdwardsCurve.prototype._mulA = function _mulA(num) {
            if (this.mOneA) return num.redNeg();
            else return this.a.redMul(num);
          };
          EdwardsCurve.prototype._mulC = function _mulC(num) {
            if (this.oneC) return num;
            else return this.c.redMul(num);
          }; // Just for compatibility with Short curve
          EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
            return this.point(x, y, z, t);
          };
          EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
            x = new BN(x, 16);
            if (!x.red) x = x.toRed(this.red);
            var x2 = x.redSqr();
            var rhs = this.c2.redSub(this.a.redMul(x2));
            var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
            var y2 = rhs.redMul(lhs.redInvm());
            var y = y2.redSqrt();
            if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
              throw new Error("invalid point");
            var isOdd = y.fromRed().isOdd();
            if ((odd && !isOdd) || (!odd && isOdd)) y = y.redNeg();
            return this.point(x, y);
          };
          EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
            y = new BN(y, 16);
            if (!y.red) y = y.toRed(this.red); // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
            var y2 = y.redSqr();
            var lhs = y2.redSub(this.c2);
            var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
            var x2 = lhs.redMul(rhs.redInvm());
            if (x2.cmp(this.zero) === 0) {
              if (odd) throw new Error("invalid point");
              else return this.point(this.zero, y);
            }
            var x = x2.redSqrt();
            if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
              throw new Error("invalid point");
            if (x.fromRed().isOdd() !== odd) x = x.redNeg();
            return this.point(x, y);
          };
          EdwardsCurve.prototype.validate = function validate(point) {
            if (point.isInfinity()) return true; // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
            point.normalize();
            var x2 = point.x.redSqr();
            var y2 = point.y.redSqr();
            var lhs = x2.redMul(this.a).redAdd(y2);
            var rhs = this.c2.redMul(
              this.one.redAdd(this.d.redMul(x2).redMul(y2))
            );
            return lhs.cmp(rhs) === 0;
          };
          function Point(curve, x, y, z, t) {
            Base.BasePoint.call(this, curve, "projective");
            if (x === null && y === null && z === null) {
              this.x = this.curve.zero;
              this.y = this.curve.one;
              this.z = this.curve.one;
              this.t = this.curve.zero;
              this.zOne = true;
            } else {
              this.x = new BN(x, 16);
              this.y = new BN(y, 16);
              this.z = z ? new BN(z, 16) : this.curve.one;
              this.t = t && new BN(t, 16);
              if (!this.x.red) this.x = this.x.toRed(this.curve.red);
              if (!this.y.red) this.y = this.y.toRed(this.curve.red);
              if (!this.z.red) this.z = this.z.toRed(this.curve.red);
              if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
              this.zOne = this.z === this.curve.one; // Use extended coordinates
              if (this.curve.extended && !this.t) {
                this.t = this.x.redMul(this.y);
                if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
              }
            }
          }
          inherits(Point, Base.BasePoint);
          EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
            return Point.fromJSON(this, obj);
          };
          EdwardsCurve.prototype.point = function point(x, y, z, t) {
            return new Point(this, x, y, z, t);
          };
          Point.fromJSON = function fromJSON(curve, obj) {
            return new Point(curve, obj[0], obj[1], obj[2]);
          };
          Point.prototype.inspect = function inspect() {
            if (this.isInfinity()) return "<EC Point Infinity>";
            return (
              "<EC Point x: " +
              this.x.fromRed().toString(16, 2) +
              " y: " +
              this.y.fromRed().toString(16, 2) +
              " z: " +
              this.z.fromRed().toString(16, 2) +
              ">"
            );
          };
          Point.prototype.isInfinity = function isInfinity() {
            // XXX This code assumes that zero is always zero in red
            return (
              this.x.cmpn(0) === 0 &&
              (this.y.cmp(this.z) === 0 ||
                (this.zOne && this.y.cmp(this.curve.c) === 0))
            );
          };
          Point.prototype._extDbl = function _extDbl() {
            // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
            //     #doubling-dbl-2008-hwcd
            // 4M + 4S
            // A = X1^2
            var a = this.x.redSqr(); // B = Y1^2
            var b = this.y.redSqr(); // C = 2 * Z1^2
            var c = this.z.redSqr();
            c = c.redIAdd(c); // D = a * A
            var d = this.curve._mulA(a); // E = (X1 + Y1)^2 - A - B
            var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b); // G = D + B
            var g = d.redAdd(b); // F = G - C
            var f = g.redSub(c); // H = D - B
            var h = d.redSub(b); // X3 = E * F
            var nx = e.redMul(f); // Y3 = G * H
            var ny = g.redMul(h); // T3 = E * H
            var nt = e.redMul(h); // Z3 = F * G
            var nz = f.redMul(g);
            return this.curve.point(nx, ny, nz, nt);
          };
          Point.prototype._projDbl = function _projDbl() {
            // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
            //     #doubling-dbl-2008-bbjlp
            //     #doubling-dbl-2007-bl
            // and others
            // Generally 3M + 4S or 2M + 4S
            // B = (X1 + Y1)^2
            var b = this.x.redAdd(this.y).redSqr(); // C = X1^2
            var c = this.x.redSqr(); // D = Y1^2
            var d = this.y.redSqr();
            var nx;
            var ny;
            var nz;
            if (this.curve.twisted) {
              // E = a * C
              var e = this.curve._mulA(c); // F = E + D
              var f = e.redAdd(d);
              if (this.zOne) {
                // X3 = (B - C - D) * (F - 2)
                nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two)); // Y3 = F * (E - D)
                ny = f.redMul(e.redSub(d)); // Z3 = F^2 - 2 * F
                nz = f.redSqr().redSub(f).redSub(f);
              } else {
                // H = Z1^2
                var h = this.z.redSqr(); // J = F - 2 * H
                var j = f.redSub(h).redISub(h); // X3 = (B-C-D)*J
                nx = b.redSub(c).redISub(d).redMul(j); // Y3 = F * (E - D)
                ny = f.redMul(e.redSub(d)); // Z3 = F * J
                nz = f.redMul(j);
              }
            } else {
              // E = C + D
              var e = c.redAdd(d); // H = (c * Z1)^2
              var h = this.curve._mulC(this.z).redSqr(); // J = E - 2 * H
              var j = e.redSub(h).redSub(h); // X3 = c * (B - E) * J
              nx = this.curve._mulC(b.redISub(e)).redMul(j); // Y3 = c * E * (C - D)
              ny = this.curve._mulC(e).redMul(c.redISub(d)); // Z3 = E * J
              nz = e.redMul(j);
            }
            return this.curve.point(nx, ny, nz);
          };
          Point.prototype.dbl = function dbl() {
            if (this.isInfinity()) return this; // Double in extended coordinates
            if (this.curve.extended) return this._extDbl();
            else return this._projDbl();
          };
          Point.prototype._extAdd = function _extAdd(p) {
            // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
            //     #addition-add-2008-hwcd-3
            // 8M
            // A = (Y1 - X1) * (Y2 - X2)
            var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x)); // B = (Y1 + X1) * (Y2 + X2)
            var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x)); // C = T1 * k * T2
            var c = this.t.redMul(this.curve.dd).redMul(p.t); // D = Z1 * 2 * Z2
            var d = this.z.redMul(p.z.redAdd(p.z)); // E = B - A
            var e = b.redSub(a); // F = D - C
            var f = d.redSub(c); // G = D + C
            var g = d.redAdd(c); // H = B + A
            var h = b.redAdd(a); // X3 = E * F
            var nx = e.redMul(f); // Y3 = G * H
            var ny = g.redMul(h); // T3 = E * H
            var nt = e.redMul(h); // Z3 = F * G
            var nz = f.redMul(g);
            return this.curve.point(nx, ny, nz, nt);
          };
          Point.prototype._projAdd = function _projAdd(p) {
            // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
            //     #addition-add-2008-bbjlp
            //     #addition-add-2007-bl
            // 10M + 1S
            // A = Z1 * Z2
            var a = this.z.redMul(p.z); // B = A^2
            var b = a.redSqr(); // C = X1 * X2
            var c = this.x.redMul(p.x); // D = Y1 * Y2
            var d = this.y.redMul(p.y); // E = d * C * D
            var e = this.curve.d.redMul(c).redMul(d); // F = B - E
            var f = b.redSub(e); // G = B + E
            var g = b.redAdd(e); // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
            var tmp = this.x
              .redAdd(this.y)
              .redMul(p.x.redAdd(p.y))
              .redISub(c)
              .redISub(d);
            var nx = a.redMul(f).redMul(tmp);
            var ny;
            var nz;
            if (this.curve.twisted) {
              // Y3 = A * G * (D - a * C)
              ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c))); // Z3 = F * G
              nz = f.redMul(g);
            } else {
              // Y3 = A * G * (D - C)
              ny = a.redMul(g).redMul(d.redSub(c)); // Z3 = c * F * G
              nz = this.curve._mulC(f).redMul(g);
            }
            return this.curve.point(nx, ny, nz);
          };
          Point.prototype.add = function add(p) {
            if (this.isInfinity()) return p;
            if (p.isInfinity()) return this;
            if (this.curve.extended) return this._extAdd(p);
            else return this._projAdd(p);
          };
          Point.prototype.mul = function mul(k) {
            if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
            else return this.curve._wnafMul(this, k);
          };
          Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
            return this.curve._wnafMulAdd(1, [this, p], [k1, k2], 2, false);
          };
          Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
            return this.curve._wnafMulAdd(1, [this, p], [k1, k2], 2, true);
          };
          Point.prototype.normalize = function normalize() {
            if (this.zOne) return this; // Normalize coordinates
            var zi = this.z.redInvm();
            this.x = this.x.redMul(zi);
            this.y = this.y.redMul(zi);
            if (this.t) this.t = this.t.redMul(zi);
            this.z = this.curve.one;
            this.zOne = true;
            return this;
          };
          Point.prototype.neg = function neg() {
            return this.curve.point(
              this.x.redNeg(),
              this.y,
              this.z,
              this.t && this.t.redNeg()
            );
          };
          Point.prototype.getX = function getX() {
            this.normalize();
            return this.x.fromRed();
          };
          Point.prototype.getY = function getY() {
            this.normalize();
            return this.y.fromRed();
          };
          Point.prototype.eq = function eq(other) {
            return (
              this === other ||
              (this.getX().cmp(other.getX()) === 0 &&
                this.getY().cmp(other.getY()) === 0)
            );
          };
          Point.prototype.eqXToP = function eqXToP(x) {
            var rx = x.toRed(this.curve.red).redMul(this.z);
            if (this.x.cmp(rx) === 0) return true;
            var xc = x.clone();
            var t = this.curve.redN.redMul(this.z);
            for (;;) {
              xc.iadd(this.curve.n);
              if (xc.cmp(this.curve.p) >= 0) return false;
              rx.redIAdd(t);
              if (this.x.cmp(rx) === 0) return true;
            }
          }; // Compatibility with BaseCurve
          Point.prototype.toP = Point.prototype.normalize;
          Point.prototype.mixedAdd = Point.prototype.add;
        },
        {
          "../utils": "19cbc0e8eeaa80c7312d4080f426c995",
          "bn.js": "c067c95fc23ea4f3df8ca0f49aa28d8d",
          inherits: "cd61047e9289e4b62768390878fc0b01",
          "./base": "7b4064fbeae57641ef7ca3a4f3cb17ea"
        }
      ],
      "9ddb7a24a9cba70869027081f9150e33": [
        function (require, module, exports) {
          "use strict";
          var curves = exports;
          var hash = require("hash.js");
          var curve = require("./curve");
          var utils = require("./utils");
          var assert = utils.assert;
          function PresetCurve(options) {
            if (options.type === "short") this.curve = new curve.short(options);
            else if (options.type === "edwards")
              this.curve = new curve.edwards(options);
            else this.curve = new curve.mont(options);
            this.g = this.curve.g;
            this.n = this.curve.n;
            this.hash = options.hash;
            assert(this.g.validate(), "Invalid curve");
            assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
          }
          curves.PresetCurve = PresetCurve;
          function defineCurve(name, options) {
            Object.defineProperty(curves, name, {
              configurable: true,
              enumerable: true,
              get: function get() {
                var curve = new PresetCurve(options);
                Object.defineProperty(curves, name, {
                  configurable: true,
                  enumerable: true,
                  value: curve
                });
                return curve;
              }
            });
          }
          defineCurve("p192", {
            type: "short",
            prime: "p192",
            p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
            a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
            b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
            n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
            hash: hash.sha256,
            gRed: false,
            g: [
              "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
              "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
            ]
          });
          defineCurve("p224", {
            type: "short",
            prime: "p224",
            p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
            a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
            b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
            n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
            hash: hash.sha256,
            gRed: false,
            g: [
              "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
              "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
            ]
          });
          defineCurve("p256", {
            type: "short",
            prime: null,
            p:
              "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
            a:
              "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
            b:
              "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
            n:
              "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
            hash: hash.sha256,
            gRed: false,
            g: [
              "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
              "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
            ]
          });
          defineCurve("p384", {
            type: "short",
            prime: null,
            p:
              "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff " +
              "fffffffe ffffffff 00000000 00000000 ffffffff",
            a:
              "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff " +
              "fffffffe ffffffff 00000000 00000000 fffffffc",
            b:
              "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f " +
              "5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
            n:
              "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 " +
              "f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
            hash: hash.sha384,
            gRed: false,
            g: [
              "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 " +
                "5502f25d bf55296c 3a545e38 72760ab7",
              "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 " +
                "0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
            ]
          });
          defineCurve("p521", {
            type: "short",
            prime: null,
            p:
              "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff " +
              "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff " +
              "ffffffff ffffffff ffffffff ffffffff ffffffff",
            a:
              "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff " +
              "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff " +
              "ffffffff ffffffff ffffffff ffffffff fffffffc",
            b:
              "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b " +
              "99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd " +
              "3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
            n:
              "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff " +
              "ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 " +
              "f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
            hash: hash.sha512,
            gRed: false,
            g: [
              "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 " +
                "053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 " +
                "a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
              "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 " +
                "579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 " +
                "3fad0761 353c7086 a272c240 88be9476 9fd16650"
            ]
          });
          defineCurve("curve25519", {
            type: "mont",
            prime: "p25519",
            p:
              "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
            a: "76d06",
            b: "1",
            n:
              "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
            hash: hash.sha256,
            gRed: false,
            g: ["9"]
          });
          defineCurve("ed25519", {
            type: "edwards",
            prime: "p25519",
            p:
              "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
            a: "-1",
            c: "1", // -121665 * (121666^(-1)) (mod P)
            d:
              "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
            n:
              "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
            hash: hash.sha256,
            gRed: false,
            g: [
              "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a", // 4/5
              "6666666666666666666666666666666666666666666666666666666666666658"
            ]
          });
          var pre;
          try {
            pre = require("./precomputed/secp256k1");
          } catch (e) {
            pre = undefined;
          }
          defineCurve("secp256k1", {
            type: "short",
            prime: "k256",
            p:
              "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
            a: "0",
            b: "7",
            n:
              "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
            h: "1",
            hash: hash.sha256, // Precomputed endomorphism
            beta:
              "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
            lambda:
              "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
            basis: [
              {
                a: "3086d221a7d46bcde86c90e49284eb15",
                b: "-e4437ed6010e88286f547fa90abfe4c3"
              },
              {
                a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                b: "3086d221a7d46bcde86c90e49284eb15"
              }
            ],
            gRed: false,
            g: [
              "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
              "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
              pre
            ]
          });
        },
        {
          "hash.js": "f3fe44fc9be3d13b9d8db7c3873f780d",
          "./curve": "29408169d16e6b476d0cacd15fab4cc6",
          "./utils": "19cbc0e8eeaa80c7312d4080f426c995",
          "./precomputed/secp256k1": "e14c05e058325fb9ae02b6240687f89f"
        }
      ],
      e14c05e058325fb9ae02b6240687f89f: [
        function (require, module, exports) {
          module.exports = {
            doubles: {
              step: 4,
              points: [
                [
                  "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                  "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
                ],
                [
                  "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                  "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
                ],
                [
                  "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                  "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
                ],
                [
                  "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                  "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
                ],
                [
                  "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                  "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
                ],
                [
                  "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                  "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
                ],
                [
                  "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                  "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
                ],
                [
                  "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                  "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
                ],
                [
                  "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                  "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
                ],
                [
                  "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                  "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
                ],
                [
                  "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                  "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
                ],
                [
                  "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                  "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
                ],
                [
                  "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                  "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
                ],
                [
                  "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                  "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
                ],
                [
                  "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                  "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
                ],
                [
                  "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                  "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
                ],
                [
                  "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                  "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
                ],
                [
                  "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                  "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
                ],
                [
                  "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                  "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
                ],
                [
                  "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                  "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
                ],
                [
                  "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                  "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
                ],
                [
                  "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                  "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
                ],
                [
                  "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                  "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
                ],
                [
                  "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                  "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
                ],
                [
                  "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                  "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
                ],
                [
                  "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                  "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
                ],
                [
                  "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                  "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
                ],
                [
                  "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                  "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
                ],
                [
                  "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                  "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
                ],
                [
                  "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                  "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
                ],
                [
                  "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                  "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
                ],
                [
                  "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                  "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
                ],
                [
                  "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                  "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
                ],
                [
                  "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                  "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
                ],
                [
                  "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                  "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
                ],
                [
                  "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                  "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
                ],
                [
                  "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                  "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
                ],
                [
                  "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                  "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
                ],
                [
                  "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                  "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
                ],
                [
                  "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                  "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
                ],
                [
                  "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                  "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
                ],
                [
                  "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                  "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
                ],
                [
                  "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                  "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
                ],
                [
                  "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                  "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
                ],
                [
                  "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                  "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
                ],
                [
                  "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                  "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
                ],
                [
                  "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                  "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
                ],
                [
                  "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                  "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
                ],
                [
                  "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                  "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
                ],
                [
                  "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                  "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
                ],
                [
                  "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                  "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
                ],
                [
                  "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                  "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
                ],
                [
                  "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                  "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
                ],
                [
                  "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                  "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
                ],
                [
                  "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                  "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
                ],
                [
                  "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                  "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
                ],
                [
                  "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                  "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
                ],
                [
                  "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                  "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
                ],
                [
                  "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                  "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
                ],
                [
                  "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                  "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
                ],
                [
                  "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                  "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
                ],
                [
                  "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                  "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
                ],
                [
                  "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                  "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
                ],
                [
                  "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                  "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
                ],
                [
                  "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                  "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
                ]
              ]
            },
            naf: {
              wnd: 7,
              points: [
                [
                  "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                  "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
                ],
                [
                  "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                  "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
                ],
                [
                  "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                  "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
                ],
                [
                  "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                  "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
                ],
                [
                  "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                  "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
                ],
                [
                  "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                  "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
                ],
                [
                  "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                  "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
                ],
                [
                  "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                  "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
                ],
                [
                  "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                  "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
                ],
                [
                  "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                  "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
                ],
                [
                  "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                  "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
                ],
                [
                  "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                  "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
                ],
                [
                  "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                  "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
                ],
                [
                  "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                  "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
                ],
                [
                  "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                  "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
                ],
                [
                  "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                  "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
                ],
                [
                  "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                  "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
                ],
                [
                  "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                  "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
                ],
                [
                  "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                  "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
                ],
                [
                  "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                  "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
                ],
                [
                  "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                  "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
                ],
                [
                  "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                  "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
                ],
                [
                  "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                  "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
                ],
                [
                  "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                  "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
                ],
                [
                  "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                  "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
                ],
                [
                  "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                  "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
                ],
                [
                  "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                  "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
                ],
                [
                  "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                  "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
                ],
                [
                  "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                  "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
                ],
                [
                  "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                  "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
                ],
                [
                  "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                  "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
                ],
                [
                  "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                  "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
                ],
                [
                  "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                  "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
                ],
                [
                  "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                  "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
                ],
                [
                  "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                  "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
                ],
                [
                  "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                  "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
                ],
                [
                  "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                  "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
                ],
                [
                  "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                  "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
                ],
                [
                  "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                  "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
                ],
                [
                  "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                  "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
                ],
                [
                  "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                  "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
                ],
                [
                  "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                  "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
                ],
                [
                  "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                  "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
                ],
                [
                  "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                  "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
                ],
                [
                  "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                  "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
                ],
                [
                  "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                  "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
                ],
                [
                  "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                  "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
                ],
                [
                  "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                  "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
                ],
                [
                  "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                  "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
                ],
                [
                  "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                  "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
                ],
                [
                  "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                  "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
                ],
                [
                  "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                  "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
                ],
                [
                  "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                  "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
                ],
                [
                  "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                  "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
                ],
                [
                  "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                  "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
                ],
                [
                  "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                  "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
                ],
                [
                  "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                  "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
                ],
                [
                  "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                  "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
                ],
                [
                  "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                  "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
                ],
                [
                  "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                  "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
                ],
                [
                  "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                  "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
                ],
                [
                  "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                  "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
                ],
                [
                  "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                  "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
                ],
                [
                  "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                  "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
                ],
                [
                  "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                  "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
                ],
                [
                  "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                  "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
                ],
                [
                  "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                  "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
                ],
                [
                  "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                  "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
                ],
                [
                  "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                  "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
                ],
                [
                  "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                  "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
                ],
                [
                  "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                  "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
                ],
                [
                  "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                  "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
                ],
                [
                  "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                  "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
                ],
                [
                  "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                  "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
                ],
                [
                  "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                  "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
                ],
                [
                  "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                  "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
                ],
                [
                  "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                  "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
                ],
                [
                  "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                  "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
                ],
                [
                  "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                  "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
                ],
                [
                  "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                  "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
                ],
                [
                  "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                  "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
                ],
                [
                  "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                  "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
                ],
                [
                  "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                  "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
                ],
                [
                  "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                  "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
                ],
                [
                  "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                  "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
                ],
                [
                  "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                  "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
                ],
                [
                  "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                  "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
                ],
                [
                  "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                  "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
                ],
                [
                  "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                  "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
                ],
                [
                  "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                  "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
                ],
                [
                  "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                  "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
                ],
                [
                  "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                  "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
                ],
                [
                  "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                  "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
                ],
                [
                  "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                  "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
                ],
                [
                  "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                  "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
                ],
                [
                  "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                  "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
                ],
                [
                  "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                  "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
                ],
                [
                  "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                  "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
                ],
                [
                  "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                  "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
                ],
                [
                  "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                  "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
                ],
                [
                  "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                  "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
                ],
                [
                  "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                  "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
                ],
                [
                  "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                  "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
                ],
                [
                  "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                  "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
                ],
                [
                  "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                  "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
                ],
                [
                  "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                  "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
                ],
                [
                  "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                  "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
                ],
                [
                  "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                  "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
                ],
                [
                  "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                  "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
                ],
                [
                  "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                  "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
                ],
                [
                  "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                  "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
                ],
                [
                  "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                  "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
                ],
                [
                  "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                  "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
                ],
                [
                  "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                  "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
                ],
                [
                  "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                  "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
                ],
                [
                  "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                  "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
                ],
                [
                  "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                  "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
                ],
                [
                  "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                  "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
                ],
                [
                  "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                  "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
                ],
                [
                  "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                  "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
                ],
                [
                  "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                  "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
                ],
                [
                  "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                  "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
                ],
                [
                  "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                  "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
                ],
                [
                  "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                  "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
                ],
                [
                  "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                  "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
                ],
                [
                  "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                  "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
                ],
                [
                  "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                  "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
                ]
              ]
            }
          };
        },
        {}
      ],
      "3696104af7c0bc5791ea2525bbf134e7": [
        function (require, module, exports) {
          "use strict";
          var BN = require("bn.js");
          var HmacDRBG = require("hmac-drbg");
          var utils = require("../utils");
          var curves = require("../curves");
          var rand = require("brorand");
          var assert = utils.assert;
          var KeyPair = require("./key");
          var Signature = require("./signature");
          function EC(options) {
            if (!_instanceof(this, EC)) return new EC(options); // Shortcut `elliptic.ec(curve-name)`
            if (typeof options === "string") {
              assert(curves.hasOwnProperty(options), "Unknown curve " + options);
              options = curves[options];
            } // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
            if (_instanceof(options, curves.PresetCurve))
              options = { curve: options };
            this.curve = options.curve.curve;
            this.n = this.curve.n;
            this.nh = this.n.ushrn(1);
            this.g = this.curve.g; // Point on curve
            this.g = options.curve.g;
            this.g.precompute(options.curve.n.bitLength() + 1); // Hash for function for DRBG
            this.hash = options.hash || options.curve.hash;
          }
          module.exports = EC;
          EC.prototype.keyPair = function keyPair(options) {
            return new KeyPair(this, options);
          };
          EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
            return KeyPair.fromPrivate(this, priv, enc);
          };
          EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
            return KeyPair.fromPublic(this, pub, enc);
          };
          EC.prototype.genKeyPair = function genKeyPair(options) {
            if (!options) options = {}; // Instantiate Hmac_DRBG
            var drbg = new HmacDRBG({
              hash: this.hash,
              pers: options.pers,
              persEnc: options.persEnc || "utf8",
              entropy: options.entropy || rand(this.hash.hmacStrength),
              entropyEnc: (options.entropy && options.entropyEnc) || "utf8",
              nonce: this.n.toArray()
            });
            var bytes = this.n.byteLength();
            var ns2 = this.n.sub(new BN(2));
            do {
              var priv = new BN(drbg.generate(bytes));
              if (priv.cmp(ns2) > 0) continue;
              priv.iaddn(1);
              return this.keyFromPrivate(priv);
            } while (true);
          };
          EC.prototype._truncateToN = function truncateToN(msg, truncOnly) {
            var delta = msg.byteLength() * 8 - this.n.bitLength();
            if (delta > 0) msg = msg.ushrn(delta);
            if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
            else return msg;
          };
          EC.prototype.sign = function sign(msg, key, enc, options) {
            if (_typeof2(enc) === "object") {
              options = enc;
              enc = null;
            }
            if (!options) options = {};
            key = this.keyFromPrivate(key, enc);
            msg = this._truncateToN(new BN(msg, 16)); // Zero-extend key to provide enough entropy
            var bytes = this.n.byteLength();
            var bkey = key.getPrivate().toArray("be", bytes); // Zero-extend nonce to have the same byte size as N
            var nonce = msg.toArray("be", bytes); // Instantiate Hmac_DRBG
            var drbg = new HmacDRBG({
              hash: this.hash,
              entropy: bkey,
              nonce: nonce,
              pers: options.pers,
              persEnc: options.persEnc || "utf8"
            }); // Number of bytes to generate
            var ns1 = this.n.sub(new BN(1));
            for (var iter = 0; true; iter++) {
              var k = options.k
                ? options.k(iter)
                : new BN(drbg.generate(this.n.byteLength()));
              k = this._truncateToN(k, true);
              if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
              var kp = this.g.mul(k);
              if (kp.isInfinity()) continue;
              var kpX = kp.getX();
              var r = kpX.umod(this.n);
              if (r.cmpn(0) === 0) continue;
              var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
              s = s.umod(this.n);
              if (s.cmpn(0) === 0) continue;
              var recoveryParam =
                (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0); // Use complement of `s`, if it is > `n / 2`
              if (options.canonical && s.cmp(this.nh) > 0) {
                s = this.n.sub(s);
                recoveryParam ^= 1;
              }
              return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
            }
          };
          EC.prototype.verify = function verify(msg, signature, key, enc) {
            msg = this._truncateToN(new BN(msg, 16));
            key = this.keyFromPublic(key, enc);
            signature = new Signature(signature, "hex"); // Perform primitive values validation
            var r = signature.r;
            var s = signature.s;
            if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
            if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false; // Validate signature
            var sinv = s.invm(this.n);
            var u1 = sinv.mul(msg).umod(this.n);
            var u2 = sinv.mul(r).umod(this.n);
            if (!this.curve._maxwellTrick) {
              var p = this.g.mulAdd(u1, key.getPublic(), u2);
              if (p.isInfinity()) return false;
              return p.getX().umod(this.n).cmp(r) === 0;
            } // NOTE: Greg Maxwell's trick, inspired by:
            // https://git.io/vad3K
            var p = this.g.jmulAdd(u1, key.getPublic(), u2);
            if (p.isInfinity()) return false; // Compare `p.x` of Jacobian point with `r`,
            // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
            // inverse of `p.z^2`
            return p.eqXToP(r);
          };
          EC.prototype.recoverPubKey = function (msg, signature, j, enc) {
            assert((3 & j) === j, "The recovery param is more than two bits");
            signature = new Signature(signature, enc);
            var n = this.n;
            var e = new BN(msg);
            var r = signature.r;
            var s = signature.s; // A set LSB signifies that the y-coordinate is odd
            var isYOdd = j & 1;
            var isSecondKey = j >> 1;
            if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
              throw new Error("Unable to find sencond key candinate"); // 1.1. Let x = r + jn.
            if (isSecondKey)
              r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
            else r = this.curve.pointFromX(r, isYOdd);
            var rInv = signature.r.invm(n);
            var s1 = n.sub(e).mul(rInv).umod(n);
            var s2 = s.mul(rInv).umod(n); // 1.6.1 Compute Q = r^-1 (sR -  eG)
            //               Q = r^-1 (sR + -eG)
            return this.g.mulAdd(s1, r, s2);
          };
          EC.prototype.getKeyRecoveryParam = function (e, signature, Q, enc) {
            signature = new Signature(signature, enc);
            if (signature.recoveryParam !== null) return signature.recoveryParam;
            for (var i = 0; i < 4; i++) {
              var Qprime;
              try {
                Qprime = this.recoverPubKey(e, signature, i);
              } catch (e) {
                continue;
              }
              if (Qprime.eq(Q)) return i;
            }
            throw new Error("Unable to find valid recovery factor");
          };
        },
        {
          "bn.js": "c067c95fc23ea4f3df8ca0f49aa28d8d",
          "hmac-drbg": "5cf2ef02cfa0f216aee60766d0c539ec",
          "../utils": "19cbc0e8eeaa80c7312d4080f426c995",
          "../curves": "9ddb7a24a9cba70869027081f9150e33",
          brorand: "46819616b5df61c964cabc43a2ab8054",
          "./key": "a4cafc868cab60dda9b0c4762186356b",
          "./signature": "8c9fe1e6be2aeae71294a5c80bb649b3"
        }
      ],
      "5cf2ef02cfa0f216aee60766d0c539ec": [
        function (require, module, exports) {
          "use strict";
          var hash = require("hash.js");
          var utils = require("minimalistic-crypto-utils");
          var assert = require("minimalistic-assert");
          function HmacDRBG(options) {
            if (!_instanceof(this, HmacDRBG)) return new HmacDRBG(options);
            this.hash = options.hash;
            this.predResist = !!options.predResist;
            this.outLen = this.hash.outSize;
            this.minEntropy = options.minEntropy || this.hash.hmacStrength;
            this._reseed = null;
            this.reseedInterval = null;
            this.K = null;
            this.V = null;
            var entropy = utils.toArray(
              options.entropy,
              options.entropyEnc || "hex"
            );
            var nonce = utils.toArray(options.nonce, options.nonceEnc || "hex");
            var pers = utils.toArray(options.pers, options.persEnc || "hex");
            assert(
              entropy.length >= this.minEntropy / 8,
              "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
            );
            this._init(entropy, nonce, pers);
          }
          module.exports = HmacDRBG;
          HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
            var seed = entropy.concat(nonce).concat(pers);
            this.K = new Array(this.outLen / 8);
            this.V = new Array(this.outLen / 8);
            for (var i = 0; i < this.V.length; i++) {
              this.K[i] = 0x00;
              this.V[i] = 0x01;
            }
            this._update(seed);
            this._reseed = 1;
            this.reseedInterval = 0x1000000000000; // 2^48
          };
          HmacDRBG.prototype._hmac = function hmac() {
            return new hash.hmac(this.hash, this.K);
          };
          HmacDRBG.prototype._update = function update(seed) {
            var kmac = this._hmac().update(this.V).update([0x00]);
            if (seed) kmac = kmac.update(seed);
            this.K = kmac.digest();
            this.V = this._hmac().update(this.V).digest();
            if (!seed) return;
            this.K = this._hmac()
              .update(this.V)
              .update([0x01])
              .update(seed)
              .digest();
            this.V = this._hmac().update(this.V).digest();
          };
          HmacDRBG.prototype.reseed = function reseed(
            entropy,
            entropyEnc,
            add,
            addEnc
          ) {
            // Optional entropy enc
            if (typeof entropyEnc !== "string") {
              addEnc = add;
              add = entropyEnc;
              entropyEnc = null;
            }
            entropy = utils.toArray(entropy, entropyEnc);
            add = utils.toArray(add, addEnc);
            assert(
              entropy.length >= this.minEntropy / 8,
              "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
            );
            this._update(entropy.concat(add || []));
            this._reseed = 1;
          };
          HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
            if (this._reseed > this.reseedInterval)
              throw new Error("Reseed is required"); // Optional encoding
            if (typeof enc !== "string") {
              addEnc = add;
              add = enc;
              enc = null;
            } // Optional additional data
            if (add) {
              add = utils.toArray(add, addEnc || "hex");
              this._update(add);
            }
            var temp = [];
            while (temp.length < len) {
              this.V = this._hmac().update(this.V).digest();
              temp = temp.concat(this.V);
            }
            var res = temp.slice(0, len);
            this._update(add);
            this._reseed++;
            return utils.encode(res, enc);
          };
        },
        {
          "hash.js": "f3fe44fc9be3d13b9d8db7c3873f780d",
          "minimalistic-crypto-utils": "baa8e23d083f0906729d32b8dd69719c",
          "minimalistic-assert": "820b72d8ed3e2ef613fe4c696f4f77d9"
        }
      ],
      a4cafc868cab60dda9b0c4762186356b: [
        function (require, module, exports) {
          "use strict";
          var BN = require("bn.js");
          var utils = require("../utils");
          var assert = utils.assert;
          function KeyPair(ec, options) {
            this.ec = ec;
            this.priv = null;
            this.pub = null; // KeyPair(ec, { priv: ..., pub: ... })
            if (options.priv) this._importPrivate(options.priv, options.privEnc);
            if (options.pub) this._importPublic(options.pub, options.pubEnc);
          }
          module.exports = KeyPair;
          KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
            if (_instanceof(pub, KeyPair)) return pub;
            return new KeyPair(ec, { pub: pub, pubEnc: enc });
          };
          KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
            if (_instanceof(priv, KeyPair)) return priv;
            return new KeyPair(ec, { priv: priv, privEnc: enc });
          };
          KeyPair.prototype.validate = function validate() {
            var pub = this.getPublic();
            if (pub.isInfinity())
              return { result: false, reason: "Invalid public key" };
            if (!pub.validate())
              return { result: false, reason: "Public key is not a point" };
            if (!pub.mul(this.ec.curve.n).isInfinity())
              return { result: false, reason: "Public key * N != O" };
            return { result: true, reason: null };
          };
          KeyPair.prototype.getPublic = function getPublic(compact, enc) {
            // compact is optional argument
            if (typeof compact === "string") {
              enc = compact;
              compact = null;
            }
            if (!this.pub) this.pub = this.ec.g.mul(this.priv);
            if (!enc) return this.pub;
            return this.pub.encode(enc, compact);
          };
          KeyPair.prototype.getPrivate = function getPrivate(enc) {
            if (enc === "hex") return this.priv.toString(16, 2);
            else return this.priv;
          };
          KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
            this.priv = new BN(key, enc || 16); // Ensure that the priv won't be bigger than n, otherwise we may fail
            // in fixed multiplication method
            this.priv = this.priv.umod(this.ec.curve.n);
          };
          KeyPair.prototype._importPublic = function _importPublic(key, enc) {
            if (key.x || key.y) {
              // Montgomery points only have an `x` coordinate.
              // Weierstrass/Edwards points on the other hand have both `x` and
              // `y` coordinates.
              if (this.ec.curve.type === "mont") {
                assert(key.x, "Need x coordinate");
              } else if (
                this.ec.curve.type === "short" ||
                this.ec.curve.type === "edwards"
              ) {
                assert(key.x && key.y, "Need both x and y coordinate");
              }
              this.pub = this.ec.curve.point(key.x, key.y);
              return;
            }
            this.pub = this.ec.curve.decodePoint(key, enc);
          }; // ECDH
          KeyPair.prototype.derive = function derive(pub) {
            return pub.mul(this.priv).getX();
          }; // ECDSA
          KeyPair.prototype.sign = function sign(msg, enc, options) {
            return this.ec.sign(msg, this, enc, options);
          };
          KeyPair.prototype.verify = function verify(msg, signature) {
            return this.ec.verify(msg, signature, this);
          };
          KeyPair.prototype.inspect = function inspect() {
            return (
              "<Key priv: " +
              (this.priv && this.priv.toString(16, 2)) +
              " pub: " +
              (this.pub && this.pub.inspect()) +
              " >"
            );
          };
        },
        {
          "bn.js": "c067c95fc23ea4f3df8ca0f49aa28d8d",
          "../utils": "19cbc0e8eeaa80c7312d4080f426c995"
        }
      ],
      "8c9fe1e6be2aeae71294a5c80bb649b3": [
        function (require, module, exports) {
          "use strict";
          var BN = require("bn.js");
          var utils = require("../utils");
          var assert = utils.assert;
          function Signature(options, enc) {
            if (_instanceof(options, Signature)) return options;
            if (this._importDER(options, enc)) return;
            assert(options.r && options.s, "Signature without r or s");
            this.r = new BN(options.r, 16);
            this.s = new BN(options.s, 16);
            if (options.recoveryParam === undefined) this.recoveryParam = null;
            else this.recoveryParam = options.recoveryParam;
          }
          module.exports = Signature;
          function Position() {
            this.place = 0;
          }
          function getLength(buf, p) {
            var initial = buf[p.place++];
            if (!(initial & 0x80)) {
              return initial;
            }
            var octetLen = initial & 0xf; // Indefinite length or overflow
            if (octetLen === 0 || octetLen > 4) {
              return false;
            }
            var val = 0;
            for (var i = 0, off = p.place; i < octetLen; i++, off++) {
              val <<= 8;
              val |= buf[off];
              val >>>= 0;
            } // Leading zeroes
            if (val <= 0x7f) {
              return false;
            }
            p.place = off;
            return val;
          }
          function rmPadding(buf) {
            var i = 0;
            var len = buf.length - 1;
            while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
              i++;
            }
            if (i === 0) {
              return buf;
            }
            return buf.slice(i);
          }
          Signature.prototype._importDER = function _importDER(data, enc) {
            data = utils.toArray(data, enc);
            var p = new Position();
            if (data[p.place++] !== 0x30) {
              return false;
            }
            var len = getLength(data, p);
            if (len === false) {
              return false;
            }
            if (len + p.place !== data.length) {
              return false;
            }
            if (data[p.place++] !== 0x02) {
              return false;
            }
            var rlen = getLength(data, p);
            if (rlen === false) {
              return false;
            }
            var r = data.slice(p.place, rlen + p.place);
            p.place += rlen;
            if (data[p.place++] !== 0x02) {
              return false;
            }
            var slen = getLength(data, p);
            if (slen === false) {
              return false;
            }
            if (data.length !== slen + p.place) {
              return false;
            }
            var s = data.slice(p.place, slen + p.place);
            if (r[0] === 0) {
              if (r[1] & 0x80) {
                r = r.slice(1);
              } else {
                // Leading zeroes
                return false;
              }
            }
            if (s[0] === 0) {
              if (s[1] & 0x80) {
                s = s.slice(1);
              } else {
                // Leading zeroes
                return false;
              }
            }
            this.r = new BN(r);
            this.s = new BN(s);
            this.recoveryParam = null;
            return true;
          };
          function constructLength(arr, len) {
            if (len < 0x80) {
              arr.push(len);
              return;
            }
            var octets = 1 + ((Math.log(len) / Math.LN2) >>> 3);
            arr.push(octets | 0x80);
            while (--octets) {
              arr.push((len >>> (octets << 3)) & 0xff);
            }
            arr.push(len);
          }
          Signature.prototype.toDER = function toDER(enc) {
            var r = this.r.toArray();
            var s = this.s.toArray(); // Pad values
            if (r[0] & 0x80) r = [0].concat(r); // Pad values
            if (s[0] & 0x80) s = [0].concat(s);
            r = rmPadding(r);
            s = rmPadding(s);
            while (!s[0] && !(s[1] & 0x80)) {
              s = s.slice(1);
            }
            var arr = [0x02];
            constructLength(arr, r.length);
            arr = arr.concat(r);
            arr.push(0x02);
            constructLength(arr, s.length);
            var backHalf = arr.concat(s);
            var res = [0x30];
            constructLength(res, backHalf.length);
            res = res.concat(backHalf);
            return utils.encode(res, enc);
          };
        },
        {
          "bn.js": "c067c95fc23ea4f3df8ca0f49aa28d8d",
          "../utils": "19cbc0e8eeaa80c7312d4080f426c995"
        }
      ],
      f26522a3b207b6f3db4d524511173d3f: [
        function (require, module, exports) {
          "use strict";
          var hash = require("hash.js");
          var curves = require("../curves");
          var utils = require("../utils");
          var assert = utils.assert;
          var parseBytes = utils.parseBytes;
          var KeyPair = require("./key");
          var Signature = require("./signature");
          function EDDSA(curve) {
            assert(curve === "ed25519", "only tested with ed25519 so far");
            if (!_instanceof(this, EDDSA)) return new EDDSA(curve);
            var curve = curves[curve].curve;
            this.curve = curve;
            this.g = curve.g;
            this.g.precompute(curve.n.bitLength() + 1);
            this.pointClass = curve.point().constructor;
            this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
            this.hash = hash.sha512;
          }
          module.exports = EDDSA;
          /**
           * @param {Array|String} message - message bytes
           * @param {Array|String|KeyPair} secret - secret bytes or a keypair
           * @returns {Signature} - signature
           */ EDDSA.prototype.sign = function sign(message, secret) {
            message = parseBytes(message);
            var key = this.keyFromSecret(secret);
            var r = this.hashInt(key.messagePrefix(), message);
            var R = this.g.mul(r);
            var Rencoded = this.encodePoint(R);
            var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(
              key.priv()
            );
            var S = r.add(s_).umod(this.curve.n);
            return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
          };
          /**
           * @param {Array} message - message bytes
           * @param {Array|String|Signature} sig - sig bytes
           * @param {Array|String|Point|KeyPair} pub - public key
           * @returns {Boolean} - true if public key matches sig of message
           */ EDDSA.prototype.verify = function verify(message, sig, pub) {
            message = parseBytes(message);
            sig = this.makeSignature(sig);
            var key = this.keyFromPublic(pub);
            var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
            var SG = this.g.mul(sig.S());
            var RplusAh = sig.R().add(key.pub().mul(h));
            return RplusAh.eq(SG);
          };
          EDDSA.prototype.hashInt = function hashInt() {
            var hash = this.hash();
            for (var i = 0; i < arguments.length; i++) {
              hash.update(arguments[i]);
            }
            return utils.intFromLE(hash.digest()).umod(this.curve.n);
          };
          EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
            return KeyPair.fromPublic(this, pub);
          };
          EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
            return KeyPair.fromSecret(this, secret);
          };
          EDDSA.prototype.makeSignature = function makeSignature(sig) {
            if (_instanceof(sig, Signature)) return sig;
            return new Signature(this, sig);
          };
          /**
           * * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
           *
           * EDDSA defines methods for encoding and decoding points and integers. These are
           * helper convenience methods, that pass along to utility functions implied
           * parameters.
           *
           */ EDDSA.prototype.encodePoint = function encodePoint(point) {
            var enc = point.getY().toArray("le", this.encodingLength);
            enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
            return enc;
          };
          EDDSA.prototype.decodePoint = function decodePoint(bytes) {
            bytes = utils.parseBytes(bytes);
            var lastIx = bytes.length - 1;
            var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
            var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
            var y = utils.intFromLE(normed);
            return this.curve.pointFromY(y, xIsOdd);
          };
          EDDSA.prototype.encodeInt = function encodeInt(num) {
            return num.toArray("le", this.encodingLength);
          };
          EDDSA.prototype.decodeInt = function decodeInt(bytes) {
            return utils.intFromLE(bytes);
          };
          EDDSA.prototype.isPoint = function isPoint(val) {
            return _instanceof(val, this.pointClass);
          };
        },
        {
          "hash.js": "f3fe44fc9be3d13b9d8db7c3873f780d",
          "../curves": "9ddb7a24a9cba70869027081f9150e33",
          "../utils": "19cbc0e8eeaa80c7312d4080f426c995",
          "./key": "d01be704db3641ee3ad7c84dc88f0cdd",
          "./signature": "bffa1f64e3998e25c82a80f5323c17a6"
        }
      ],
      d01be704db3641ee3ad7c84dc88f0cdd: [
        function (require, module, exports) {
          "use strict";
          var utils = require("../utils");
          var assert = utils.assert;
          var parseBytes = utils.parseBytes;
          var cachedProperty = utils.cachedProperty;
          /**
           * @param {EDDSA} eddsa - instance
           * @param {Object} params - public/private key parameters
           *
           * @param {Array<Byte>} [params.secret] - secret seed bytes
           * @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
           * @param {Array<Byte>} [params.pub] - public key point encoded as bytes
           *
           */ function KeyPair(eddsa, params) {
            this.eddsa = eddsa;
            this._secret = parseBytes(params.secret);
            if (eddsa.isPoint(params.pub)) this._pub = params.pub;
            else this._pubBytes = parseBytes(params.pub);
          }
          KeyPair.fromPublic = function fromPublic(eddsa, pub) {
            if (_instanceof(pub, KeyPair)) return pub;
            return new KeyPair(eddsa, { pub: pub });
          };
          KeyPair.fromSecret = function fromSecret(eddsa, secret) {
            if (_instanceof(secret, KeyPair)) return secret;
            return new KeyPair(eddsa, { secret: secret });
          };
          KeyPair.prototype.secret = function secret() {
            return this._secret;
          };
          cachedProperty(KeyPair, "pubBytes", function pubBytes() {
            return this.eddsa.encodePoint(this.pub());
          });
          cachedProperty(KeyPair, "pub", function pub() {
            if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
            return this.eddsa.g.mul(this.priv());
          });
          cachedProperty(KeyPair, "privBytes", function privBytes() {
            var eddsa = this.eddsa;
            var hash = this.hash();
            var lastIx = eddsa.encodingLength - 1;
            var a = hash.slice(0, eddsa.encodingLength);
            a[0] &= 248;
            a[lastIx] &= 127;
            a[lastIx] |= 64;
            return a;
          });
          cachedProperty(KeyPair, "priv", function priv() {
            return this.eddsa.decodeInt(this.privBytes());
          });
          cachedProperty(KeyPair, "hash", function hash() {
            return this.eddsa.hash().update(this.secret()).digest();
          });
          cachedProperty(KeyPair, "messagePrefix", function messagePrefix() {
            return this.hash().slice(this.eddsa.encodingLength);
          });
          KeyPair.prototype.sign = function sign(message) {
            assert(this._secret, "KeyPair can only verify");
            return this.eddsa.sign(message, this);
          };
          KeyPair.prototype.verify = function verify(message, sig) {
            return this.eddsa.verify(message, sig, this);
          };
          KeyPair.prototype.getSecret = function getSecret(enc) {
            assert(this._secret, "KeyPair is public only");
            return utils.encode(this.secret(), enc);
          };
          KeyPair.prototype.getPublic = function getPublic(enc) {
            return utils.encode(this.pubBytes(), enc);
          };
          module.exports = KeyPair;
        },
        { "../utils": "19cbc0e8eeaa80c7312d4080f426c995" }
      ],
      bffa1f64e3998e25c82a80f5323c17a6: [
        function (require, module, exports) {
          "use strict";
          var BN = require("bn.js");
          var utils = require("../utils");
          var assert = utils.assert;
          var cachedProperty = utils.cachedProperty;
          var parseBytes = utils.parseBytes;
          /**
           * @param {EDDSA} eddsa - eddsa instance
           * @param {Array<Bytes>|Object} sig -
           * @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
           * @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
           * @param {Array<Bytes>} [sig.Rencoded] - R point encoded
           * @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
           */ function Signature(eddsa, sig) {
            this.eddsa = eddsa;
            if (_typeof2(sig) !== "object") sig = parseBytes(sig);
            if (Array.isArray(sig)) {
              sig = {
                R: sig.slice(0, eddsa.encodingLength),
                S: sig.slice(eddsa.encodingLength)
              };
            }
            assert(sig.R && sig.S, "Signature without R or S");
            if (eddsa.isPoint(sig.R)) this._R = sig.R;
            if (_instanceof(sig.S, BN)) this._S = sig.S;
            this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
            this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
          }
          cachedProperty(Signature, "S", function S() {
            return this.eddsa.decodeInt(this.Sencoded());
          });
          cachedProperty(Signature, "R", function R() {
            return this.eddsa.decodePoint(this.Rencoded());
          });
          cachedProperty(Signature, "Rencoded", function Rencoded() {
            return this.eddsa.encodePoint(this.R());
          });
          cachedProperty(Signature, "Sencoded", function Sencoded() {
            return this.eddsa.encodeInt(this.S());
          });
          Signature.prototype.toBytes = function toBytes() {
            return this.Rencoded().concat(this.Sencoded());
          };
          Signature.prototype.toHex = function toHex() {
            return utils.encode(this.toBytes(), "hex").toUpperCase();
          };
          module.exports = Signature;
        },
        {
          "bn.js": "c067c95fc23ea4f3df8ca0f49aa28d8d",
          "../utils": "19cbc0e8eeaa80c7312d4080f426c995"
        }
      ],
      "78db6cdcffd73f2e39fe879a4de609d0": [
        function (require, module, exports) {
          "use strict";
          /* eslint-disable */ Object.defineProperty(exports, "__esModule", {
            value: true
          });
          exports.accountPublicFromPublicGenerator = exports.derivePrivateKey = void 0;
          var elliptic = require("elliptic");
          var sha512_1 = require("./sha512");
          var secp256k1 = elliptic.ec("secp256k1");
          function deriveScalar(bytes, discrim) {
            var order = secp256k1.curve.n;
            for (var i = 0; i <= 0xffffffff; i++) {
              // We hash the bytes to find a 256 bit number, looping until we are sure it
              // is less than the order of the curve.
              var hasher = new sha512_1.default().add(bytes); // If the optional discriminator index was passed in, update the hash.
              if (discrim !== undefined) {
                hasher.addU32(discrim);
              }
              hasher.addU32(i);
              var key = hasher.first256BN();
              /* istanbul ignore else */ if (
                key.cmpn(0) > 0 &&
                key.cmp(order) < 0
              ) {
                return key;
              }
            }
            /* This error is practically impossible to reach.
             * The order of the curve describes the (finite) amount of points on the curve
             * https://github.com/indutny/elliptic/blob/master/lib/elliptic/curves.js#L182
             * How often will an (essentially) random number generated by Sha512 be larger than that?
             * There's 2^32 chances (the for loop) to get a number smaller than the order,
             * and it's rare that you'll even get past the first loop iteration.
             * Note that in TypeScript we actually need the throw, otherwise the function signature would be BN | undefined
             */ /* istanbul ignore next */ throw new Error(
              "impossible unicorn ;)"
            );
          }
          /**
           * @param {Array} seed - bytes
           * @param {Object} [opts] - object
           * @param {Number} [opts.accountIndex=0] - the account number to generate
           * @param {Boolean} [opts.validator=false] - generate root key-pair,
           *                                              as used by validators.
           * @return {bn.js} - 256 bit scalar value
           *
           */ function derivePrivateKey(seed) {
            var opts =
              arguments.length > 1 && arguments[1] !== undefined
                ? arguments[1]
                : {};
            var root = opts.validator;
            var order = secp256k1.curve.n; // This private generator represents the `root` private key, and is what's
            // used by validators for signing when a keypair is generated from a seed.
            var privateGen = deriveScalar(seed);
            if (root) {
              // As returned by validation_create for a given seed
              return privateGen;
            }
            var publicGen = secp256k1.g.mul(privateGen); // A seed can generate many keypairs as a function of the seed and a uint32.
            // Almost everyone just uses the first account, `0`.
            var accountIndex = opts.accountIndex || 0;
            return deriveScalar(publicGen.encodeCompressed(), accountIndex)
              .add(privateGen)
              .mod(order);
          }
          exports.derivePrivateKey = derivePrivateKey;
          function accountPublicFromPublicGenerator(publicGenBytes) {
            var rootPubPoint = secp256k1.curve.decodePoint(publicGenBytes);
            var scalar = deriveScalar(publicGenBytes, 0);
            var point = secp256k1.g.mul(scalar);
            var offset = rootPubPoint.add(point);
            return offset.encodeCompressed();
          }
          exports.accountPublicFromPublicGenerator = accountPublicFromPublicGenerator;
        },
        {
          elliptic: "03672d91cbe66f4a302b8d456a7d55ca",
          "./sha512": "cdd60fbc5c5725577f9f83ed520a31dd"
        }
      ],
      cdd60fbc5c5725577f9f83ed520a31dd: [
        function (require, module, exports) {
          "use strict";
          /* eslint-disable */ Object.defineProperty(exports, "__esModule", {
            value: true
          });
          var hashjs = require("hash.js");
          var BigNum = require("bn.js");
          var Sha512 = /*#__PURE__*/ (function () {
            function Sha512() {
              _classCallCheck2(this, Sha512);
              this.hash = hashjs.sha512();
            }
            _createClass2(Sha512, [
              {
                key: "add",
                value: function add(bytes) {
                  this.hash.update(bytes);
                  return this;
                }
              },
              {
                key: "addU32",
                value: function addU32(i) {
                  return this.add([
                    (i >>> 24) & 0xff,
                    (i >>> 16) & 0xff,
                    (i >>> 8) & 0xff,
                    i & 0xff
                  ]);
                }
              },
              {
                key: "finish",
                value: function finish() {
                  return this.hash.digest();
                }
              },
              {
                key: "first256",
                value: function first256() {
                  return this.finish().slice(0, 32);
                }
              },
              {
                key: "first256BN",
                value: function first256BN() {
                  return new BigNum(this.first256());
                }
              }
            ]);
            return Sha512;
          })();
          exports.default = Sha512;
        },
        {
          "hash.js": "f3fe44fc9be3d13b9d8db7c3873f780d",
          "bn.js": "2f602e32936ee0126d6915550c7108a7"
        }
      ],
      "2f602e32936ee0126d6915550c7108a7": [
        function (require, module, exports) {
          (function (module, exports) {
            "use strict"; // Utils
            function assert(val, msg) {
              if (!val) throw new Error(msg || "Assertion failed");
            } // Could use `inherits` module, but don't want to move from single file
            // architecture yet.
            function inherits(ctor, superCtor) {
              ctor.super_ = superCtor;
              var TempCtor = function TempCtor() {};
              TempCtor.prototype = superCtor.prototype;
              ctor.prototype = new TempCtor();
              ctor.prototype.constructor = ctor;
            } // BN
            function BN(number, base, endian) {
              if (BN.isBN(number)) {
                return number;
              }
              this.negative = 0;
              this.words = null;
              this.length = 0; // Reduction context
              this.red = null;
              if (number !== null) {
                if (base === "le" || base === "be") {
                  endian = base;
                  base = 10;
                }
                this._init(number || 0, base || 10, endian || "be");
              }
            }
            if (_typeof2(module) === "object") {
              module.exports = BN;
            } else {
              exports.BN = BN;
            }
            BN.BN = BN;
            BN.wordSize = 26;
            var Buffer;
            try {
              Buffer = require("buffer").Buffer;
            } catch (e) {}
            BN.isBN = function isBN(num) {
              if (_instanceof(num, BN)) {
                return true;
              }
              return (
                num !== null &&
                _typeof2(num) === "object" &&
                num.constructor.wordSize === BN.wordSize &&
                Array.isArray(num.words)
              );
            };
            BN.max = function max(left, right) {
              if (left.cmp(right) > 0) return left;
              return right;
            };
            BN.min = function min(left, right) {
              if (left.cmp(right) < 0) return left;
              return right;
            };
            BN.prototype._init = function init(number, base, endian) {
              if (typeof number === "number") {
                return this._initNumber(number, base, endian);
              }
              if (_typeof2(number) === "object") {
                return this._initArray(number, base, endian);
              }
              if (base === "hex") {
                base = 16;
              }
              assert(base === (base | 0) && base >= 2 && base <= 36);
              number = number.toString().replace(/\s+/g, "");
              var start = 0;
              if (number[0] === "-") {
                start++;
              }
              if (base === 16) {
                this._parseHex(number, start);
              } else {
                this._parseBase(number, base, start);
              }
              if (number[0] === "-") {
                this.negative = 1;
              }
              this._strip();
              if (endian !== "le") return;
              this._initArray(this.toArray(), base, endian);
            };
            BN.prototype._initNumber = function _initNumber(
              number,
              base,
              endian
            ) {
              if (number < 0) {
                this.negative = 1;
                number = -number;
              }
              if (number < 0x4000000) {
                this.words = [number & 0x3ffffff];
                this.length = 1;
              } else if (number < 0x10000000000000) {
                this.words = [
                  number & 0x3ffffff,
                  (number / 0x4000000) & 0x3ffffff
                ];
                this.length = 2;
              } else {
                assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
                this.words = [
                  number & 0x3ffffff,
                  (number / 0x4000000) & 0x3ffffff,
                  1
                ];
                this.length = 3;
              }
              if (endian !== "le") return; // Reverse the bytes
              this._initArray(this.toArray(), base, endian);
            };
            BN.prototype._initArray = function _initArray(number, base, endian) {
              // Perhaps a Uint8Array
              assert(typeof number.length === "number");
              if (number.length <= 0) {
                this.words = [0];
                this.length = 1;
                return this;
              }
              this.length = Math.ceil(number.length / 3);
              this.words = new Array(this.length);
              for (var i = 0; i < this.length; i++) {
                this.words[i] = 0;
              }
              var j, w;
              var off = 0;
              if (endian === "be") {
                for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
                  w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
                  this.words[j] |= (w << off) & 0x3ffffff;
                  this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
                  off += 24;
                  if (off >= 26) {
                    off -= 26;
                    j++;
                  }
                }
              } else if (endian === "le") {
                for (i = 0, j = 0; i < number.length; i += 3) {
                  w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
                  this.words[j] |= (w << off) & 0x3ffffff;
                  this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
                  off += 24;
                  if (off >= 26) {
                    off -= 26;
                    j++;
                  }
                }
              }
              return this._strip();
            };
            function parseHex(str, start, end) {
              var r = 0;
              var len = Math.min(str.length, end);
              var z = 0;
              for (var i = start; i < len; i++) {
                var c = str.charCodeAt(i) - 48;
                r <<= 4;
                var b; // 'a' - 'f'
                if (c >= 49 && c <= 54) {
                  b = c - 49 + 0xa; // 'A' - 'F'
                } else if (c >= 17 && c <= 22) {
                  b = c - 17 + 0xa; // '0' - '9'
                } else {
                  b = c;
                }
                r |= b;
                z |= b;
              }
              assert(!(z & 0xf0), "Invalid character in " + str);
              return r;
            }
            BN.prototype._parseHex = function _parseHex(number, start) {
              // Create possibly bigger array to ensure that it fits the number
              this.length = Math.ceil((number.length - start) / 6);
              this.words = new Array(this.length);
              for (var i = 0; i < this.length; i++) {
                this.words[i] = 0;
              }
              var j, w; // Scan 24-bit chunks and add them to the number
              var off = 0;
              for (i = number.length - 6, j = 0; i >= start; i -= 6) {
                w = parseHex(number, i, i + 6);
                this.words[j] |= (w << off) & 0x3ffffff; // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
                this.words[j + 1] |= (w >>> (26 - off)) & 0x3fffff;
                off += 24;
                if (off >= 26) {
                  off -= 26;
                  j++;
                }
              }
              if (i + 6 !== start) {
                w = parseHex(number, start, i + 6);
                this.words[j] |= (w << off) & 0x3ffffff;
                this.words[j + 1] |= (w >>> (26 - off)) & 0x3fffff;
              }
              this._strip();
            };
            function parseBase(str, start, end, mul) {
              var r = 0;
              var b = 0;
              var len = Math.min(str.length, end);
              for (var i = start; i < len; i++) {
                var c = str.charCodeAt(i) - 48;
                r *= mul; // 'a'
                if (c >= 49) {
                  b = c - 49 + 0xa; // 'A'
                } else if (c >= 17) {
                  b = c - 17 + 0xa; // '0' - '9'
                } else {
                  b = c;
                }
                assert(c >= 0 && b < mul, "Invalid character");
                r += b;
              }
              return r;
            }
            BN.prototype._parseBase = function _parseBase(number, base, start) {
              // Initialize as zero
              this.words = [0];
              this.length = 1; // Find length of limb in base
              for (
                var limbLen = 0, limbPow = 1;
                limbPow <= 0x3ffffff;
                limbPow *= base
              ) {
                limbLen++;
              }
              limbLen--;
              limbPow = (limbPow / base) | 0;
              var total = number.length - start;
              var mod = total % limbLen;
              var end = Math.min(total, total - mod) + start;
              var word = 0;
              for (var i = start; i < end; i += limbLen) {
                word = parseBase(number, i, i + limbLen, base);
                this.imuln(limbPow);
                if (this.words[0] + word < 0x4000000) {
                  this.words[0] += word;
                } else {
                  this._iaddn(word);
                }
              }
              if (mod !== 0) {
                var pow = 1;
                word = parseBase(number, i, number.length, base);
                for (i = 0; i < mod; i++) {
                  pow *= base;
                }
                this.imuln(pow);
                if (this.words[0] + word < 0x4000000) {
                  this.words[0] += word;
                } else {
                  this._iaddn(word);
                }
              }
            };
            BN.prototype.copy = function copy(dest) {
              dest.words = new Array(this.length);
              for (var i = 0; i < this.length; i++) {
                dest.words[i] = this.words[i];
              }
              dest.length = this.length;
              dest.negative = this.negative;
              dest.red = this.red;
            };
            function move(dest, src) {
              dest.words = src.words;
              dest.length = src.length;
              dest.negative = src.negative;
              dest.red = src.red;
            }
            BN.prototype._move = function _move(dest) {
              move(dest, this);
            };
            BN.prototype.clone = function clone() {
              var r = new BN(null);
              this.copy(r);
              return r;
            };
            BN.prototype._expand = function _expand(size) {
              while (this.length < size) {
                this.words[this.length++] = 0;
              }
              return this;
            }; // Remove leading `0` from `this`
            BN.prototype._strip = function strip() {
              while (this.length > 1 && this.words[this.length - 1] === 0) {
                this.length--;
              }
              return this._normSign();
            };
            BN.prototype._normSign = function _normSign() {
              // -0 = 0
              if (this.length === 1 && this.words[0] === 0) {
                this.negative = 0;
              }
              return this;
            }; // Check Symbol.for because not everywhere where Symbol defined
            // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
            if (
              typeof Symbol !== "undefined" &&
              typeof Symbol.for === "function"
            ) {
              try {
                BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
              } catch (e) {
                BN.prototype.inspect = inspect;
              }
            } else {
              BN.prototype.inspect = inspect;
            }
            function inspect() {
              return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
            }
            /*

      var zeros = [];
      var groupSizes = [];
      var groupBases = [];

      var s = '';
      var i = -1;
      while (++i < BN.wordSize) {
        zeros[i] = s;
        s += '0';
      }
      groupSizes[0] = 0;
      groupSizes[1] = 0;
      groupBases[0] = 0;
      groupBases[1] = 0;
      var base = 2 - 1;
      while (++base < 36 + 1) {
        var groupSize = 0;
        var groupBase = 1;
        while (groupBase < (1 << BN.wordSize) / base) {
          groupBase *= base;
          groupSize += 1;
        }
        groupSizes[base] = groupSize;
        groupBases[base] = groupBase;
      }

      */ var zeros = [
              "",
              "0",
              "00",
              "000",
              "0000",
              "00000",
              "000000",
              "0000000",
              "00000000",
              "000000000",
              "0000000000",
              "00000000000",
              "000000000000",
              "0000000000000",
              "00000000000000",
              "000000000000000",
              "0000000000000000",
              "00000000000000000",
              "000000000000000000",
              "0000000000000000000",
              "00000000000000000000",
              "000000000000000000000",
              "0000000000000000000000",
              "00000000000000000000000",
              "000000000000000000000000",
              "0000000000000000000000000"
            ];
            var groupSizes = [
              0,
              0,
              25,
              16,
              12,
              11,
              10,
              9,
              8,
              8,
              7,
              7,
              7,
              7,
              6,
              6,
              6,
              6,
              6,
              6,
              6,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5
            ];
            var groupBases = [
              0,
              0,
              33554432,
              43046721,
              16777216,
              48828125,
              60466176,
              40353607,
              16777216,
              43046721,
              10000000,
              19487171,
              35831808,
              62748517,
              7529536,
              11390625,
              16777216,
              24137569,
              34012224,
              47045881,
              64000000,
              4084101,
              5153632,
              6436343,
              7962624,
              9765625,
              11881376,
              14348907,
              17210368,
              20511149,
              24300000,
              28629151,
              33554432,
              39135393,
              45435424,
              52521875,
              60466176
            ];
            BN.prototype.toString = function toString(base, padding) {
              base = base || 10;
              padding = padding | 0 || 1;
              var out;
              if (base === 16 || base === "hex") {
                out = "";
                var off = 0;
                var carry = 0;
                for (var i = 0; i < this.length; i++) {
                  var w = this.words[i];
                  var word = (((w << off) | carry) & 0xffffff).toString(16);
                  carry = (w >>> (24 - off)) & 0xffffff;
                  if (carry !== 0 || i !== this.length - 1) {
                    out = zeros[6 - word.length] + word + out;
                  } else {
                    out = word + out;
                  }
                  off += 2;
                  if (off >= 26) {
                    off -= 26;
                    i--;
                  }
                }
                if (carry !== 0) {
                  out = carry.toString(16) + out;
                }
                while (out.length % padding !== 0) {
                  out = "0" + out;
                }
                if (this.negative !== 0) {
                  out = "-" + out;
                }
                return out;
              }
              if (base === (base | 0) && base >= 2 && base <= 36) {
                // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
                var groupSize = groupSizes[base]; // var groupBase = Math.pow(base, groupSize);
                var groupBase = groupBases[base];
                out = "";
                var c = this.clone();
                c.negative = 0;
                while (!c.isZero()) {
                  var r = c.modrn(groupBase).toString(base);
                  c = c.idivn(groupBase);
                  if (!c.isZero()) {
                    out = zeros[groupSize - r.length] + r + out;
                  } else {
                    out = r + out;
                  }
                }
                if (this.isZero()) {
                  out = "0" + out;
                }
                while (out.length % padding !== 0) {
                  out = "0" + out;
                }
                if (this.negative !== 0) {
                  out = "-" + out;
                }
                return out;
              }
              assert(false, "Base should be between 2 and 36");
            };
            BN.prototype.toNumber = function toNumber() {
              var ret = this.words[0];
              if (this.length === 2) {
                ret += this.words[1] * 0x4000000;
              } else if (this.length === 3 && this.words[2] === 0x01) {
                // NOTE: at this stage it is known that the top bit is set
                ret += 0x10000000000000 + this.words[1] * 0x4000000;
              } else if (this.length > 2) {
                assert(false, "Number can only safely store up to 53 bits");
              }
              return this.negative !== 0 ? -ret : ret;
            };
            BN.prototype.toJSON = function toJSON() {
              return this.toString(16, 2);
            };
            if (Buffer) {
              BN.prototype.toBuffer = function toBuffer(endian, length) {
                return this.toArrayLike(Buffer, endian, length);
              };
            }
            BN.prototype.toArray = function toArray(endian, length) {
              return this.toArrayLike(Array, endian, length);
            };
            var allocate = function allocate(ArrayType, size) {
              if (ArrayType.allocUnsafe) {
                return ArrayType.allocUnsafe(size);
              }
              return new ArrayType(size);
            };
            BN.prototype.toArrayLike = function toArrayLike(
              ArrayType,
              endian,
              length
            ) {
              this._strip();
              var byteLength = this.byteLength();
              var reqLength = length || Math.max(1, byteLength);
              assert(
                byteLength <= reqLength,
                "byte array longer than desired length"
              );
              assert(reqLength > 0, "Requested array length <= 0");
              var res = allocate(ArrayType, reqLength);
              var postfix = endian === "le" ? "LE" : "BE";
              this["_toArrayLike" + postfix](res, byteLength);
              return res;
            };
            BN.prototype._toArrayLikeLE = function _toArrayLikeLE(
              res,
              byteLength
            ) {
              var position = 0;
              var carry = 0;
              for (var i = 0, shift = 0; i < this.length; i++) {
                var word = (this.words[i] << shift) | carry;
                res[position++] = word & 0xff;
                if (position < res.length) {
                  res[position++] = (word >> 8) & 0xff;
                }
                if (position < res.length) {
                  res[position++] = (word >> 16) & 0xff;
                }
                if (shift === 6) {
                  if (position < res.length) {
                    res[position++] = (word >> 24) & 0xff;
                  }
                  carry = 0;
                  shift = 0;
                } else {
                  carry = word >>> 24;
                  shift += 2;
                }
              }
              if (position < res.length) {
                res[position++] = carry;
                while (position < res.length) {
                  res[position++] = 0;
                }
              }
            };
            BN.prototype._toArrayLikeBE = function _toArrayLikeBE(
              res,
              byteLength
            ) {
              var position = res.length - 1;
              var carry = 0;
              for (var i = 0, shift = 0; i < this.length; i++) {
                var word = (this.words[i] << shift) | carry;
                res[position--] = word & 0xff;
                if (position >= 0) {
                  res[position--] = (word >> 8) & 0xff;
                }
                if (position >= 0) {
                  res[position--] = (word >> 16) & 0xff;
                }
                if (shift === 6) {
                  if (position >= 0) {
                    res[position--] = (word >> 24) & 0xff;
                  }
                  carry = 0;
                  shift = 0;
                } else {
                  carry = word >>> 24;
                  shift += 2;
                }
              }
              if (position >= 0) {
                res[position--] = carry;
                while (position >= 0) {
                  res[position--] = 0;
                }
              }
            };
            if (Math.clz32) {
              BN.prototype._countBits = function _countBits(w) {
                return 32 - Math.clz32(w);
              };
            } else {
              BN.prototype._countBits = function _countBits(w) {
                var t = w;
                var r = 0;
                if (t >= 0x1000) {
                  r += 13;
                  t >>>= 13;
                }
                if (t >= 0x40) {
                  r += 7;
                  t >>>= 7;
                }
                if (t >= 0x8) {
                  r += 4;
                  t >>>= 4;
                }
                if (t >= 0x02) {
                  r += 2;
                  t >>>= 2;
                }
                return r + t;
              };
            }
            BN.prototype._zeroBits = function _zeroBits(w) {
              // Short-cut
              if (w === 0) return 26;
              var t = w;
              var r = 0;
              if ((t & 0x1fff) === 0) {
                r += 13;
                t >>>= 13;
              }
              if ((t & 0x7f) === 0) {
                r += 7;
                t >>>= 7;
              }
              if ((t & 0xf) === 0) {
                r += 4;
                t >>>= 4;
              }
              if ((t & 0x3) === 0) {
                r += 2;
                t >>>= 2;
              }
              if ((t & 0x1) === 0) {
                r++;
              }
              return r;
            }; // Return number of used bits in a BN
            BN.prototype.bitLength = function bitLength() {
              var w = this.words[this.length - 1];
              var hi = this._countBits(w);
              return (this.length - 1) * 26 + hi;
            };
            function toBitArray(num) {
              var w = new Array(num.bitLength());
              for (var bit = 0; bit < w.length; bit++) {
                var off = (bit / 26) | 0;
                var wbit = bit % 26;
                w[bit] = (num.words[off] >>> wbit) & 0x01;
              }
              return w;
            } // Number of trailing zero bits
            BN.prototype.zeroBits = function zeroBits() {
              if (this.isZero()) return 0;
              var r = 0;
              for (var i = 0; i < this.length; i++) {
                var b = this._zeroBits(this.words[i]);
                r += b;
                if (b !== 26) break;
              }
              return r;
            };
            BN.prototype.byteLength = function byteLength() {
              return Math.ceil(this.bitLength() / 8);
            };
            BN.prototype.toTwos = function toTwos(width) {
              if (this.negative !== 0) {
                return this.abs().inotn(width).iaddn(1);
              }
              return this.clone();
            };
            BN.prototype.fromTwos = function fromTwos(width) {
              if (this.testn(width - 1)) {
                return this.notn(width).iaddn(1).ineg();
              }
              return this.clone();
            };
            BN.prototype.isNeg = function isNeg() {
              return this.negative !== 0;
            }; // Return negative clone of `this`
            BN.prototype.neg = function neg() {
              return this.clone().ineg();
            };
            BN.prototype.ineg = function ineg() {
              if (!this.isZero()) {
                this.negative ^= 1;
              }
              return this;
            }; // Or `num` with `this` in-place
            BN.prototype.iuor = function iuor(num) {
              while (this.length < num.length) {
                this.words[this.length++] = 0;
              }
              for (var i = 0; i < num.length; i++) {
                this.words[i] = this.words[i] | num.words[i];
              }
              return this._strip();
            };
            BN.prototype.ior = function ior(num) {
              assert((this.negative | num.negative) === 0);
              return this.iuor(num);
            }; // Or `num` with `this`
            BN.prototype.or = function or(num) {
              if (this.length > num.length) return this.clone().ior(num);
              return num.clone().ior(this);
            };
            BN.prototype.uor = function uor(num) {
              if (this.length > num.length) return this.clone().iuor(num);
              return num.clone().iuor(this);
            }; // And `num` with `this` in-place
            BN.prototype.iuand = function iuand(num) {
              // b = min-length(num, this)
              var b;
              if (this.length > num.length) {
                b = num;
              } else {
                b = this;
              }
              for (var i = 0; i < b.length; i++) {
                this.words[i] = this.words[i] & num.words[i];
              }
              this.length = b.length;
              return this._strip();
            };
            BN.prototype.iand = function iand(num) {
              assert((this.negative | num.negative) === 0);
              return this.iuand(num);
            }; // And `num` with `this`
            BN.prototype.and = function and(num) {
              if (this.length > num.length) return this.clone().iand(num);
              return num.clone().iand(this);
            };
            BN.prototype.uand = function uand(num) {
              if (this.length > num.length) return this.clone().iuand(num);
              return num.clone().iuand(this);
            }; // Xor `num` with `this` in-place
            BN.prototype.iuxor = function iuxor(num) {
              // a.length > b.length
              var a;
              var b;
              if (this.length > num.length) {
                a = this;
                b = num;
              } else {
                a = num;
                b = this;
              }
              for (var i = 0; i < b.length; i++) {
                this.words[i] = a.words[i] ^ b.words[i];
              }
              if (this !== a) {
                for (; i < a.length; i++) {
                  this.words[i] = a.words[i];
                }
              }
              this.length = a.length;
              return this._strip();
            };
            BN.prototype.ixor = function ixor(num) {
              assert((this.negative | num.negative) === 0);
              return this.iuxor(num);
            }; // Xor `num` with `this`
            BN.prototype.xor = function xor(num) {
              if (this.length > num.length) return this.clone().ixor(num);
              return num.clone().ixor(this);
            };
            BN.prototype.uxor = function uxor(num) {
              if (this.length > num.length) return this.clone().iuxor(num);
              return num.clone().iuxor(this);
            }; // Not ``this`` with ``width`` bitwidth
            BN.prototype.inotn = function inotn(width) {
              assert(typeof width === "number" && width >= 0);
              var bytesNeeded = Math.ceil(width / 26) | 0;
              var bitsLeft = width % 26; // Extend the buffer with leading zeroes
              this._expand(bytesNeeded);
              if (bitsLeft > 0) {
                bytesNeeded--;
              } // Handle complete words
              for (var i = 0; i < bytesNeeded; i++) {
                this.words[i] = ~this.words[i] & 0x3ffffff;
              } // Handle the residue
              if (bitsLeft > 0) {
                this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
              } // And remove leading zeroes
              return this._strip();
            };
            BN.prototype.notn = function notn(width) {
              return this.clone().inotn(width);
            }; // Set `bit` of `this`
            BN.prototype.setn = function setn(bit, val) {
              assert(typeof bit === "number" && bit >= 0);
              var off = (bit / 26) | 0;
              var wbit = bit % 26;
              this._expand(off + 1);
              if (val) {
                this.words[off] = this.words[off] | (1 << wbit);
              } else {
                this.words[off] = this.words[off] & ~(1 << wbit);
              }
              return this._strip();
            }; // Add `num` to `this` in-place
            BN.prototype.iadd = function iadd(num) {
              var r; // negative + positive
              if (this.negative !== 0 && num.negative === 0) {
                this.negative = 0;
                r = this.isub(num);
                this.negative ^= 1;
                return this._normSign(); // positive + negative
              } else if (this.negative === 0 && num.negative !== 0) {
                num.negative = 0;
                r = this.isub(num);
                num.negative = 1;
                return r._normSign();
              } // a.length > b.length
              var a, b;
              if (this.length > num.length) {
                a = this;
                b = num;
              } else {
                a = num;
                b = this;
              }
              var carry = 0;
              for (var i = 0; i < b.length; i++) {
                r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
                this.words[i] = r & 0x3ffffff;
                carry = r >>> 26;
              }
              for (; carry !== 0 && i < a.length; i++) {
                r = (a.words[i] | 0) + carry;
                this.words[i] = r & 0x3ffffff;
                carry = r >>> 26;
              }
              this.length = a.length;
              if (carry !== 0) {
                this.words[this.length] = carry;
                this.length++; // Copy the rest of the words
              } else if (a !== this) {
                for (; i < a.length; i++) {
                  this.words[i] = a.words[i];
                }
              }
              return this;
            }; // Add `num` to `this`
            BN.prototype.add = function add(num) {
              var res;
              if (num.negative !== 0 && this.negative === 0) {
                num.negative = 0;
                res = this.sub(num);
                num.negative ^= 1;
                return res;
              } else if (num.negative === 0 && this.negative !== 0) {
                this.negative = 0;
                res = num.sub(this);
                this.negative = 1;
                return res;
              }
              if (this.length > num.length) return this.clone().iadd(num);
              return num.clone().iadd(this);
            }; // Subtract `num` from `this` in-place
            BN.prototype.isub = function isub(num) {
              // this - (-num) = this + num
              if (num.negative !== 0) {
                num.negative = 0;
                var r = this.iadd(num);
                num.negative = 1;
                return r._normSign(); // -this - num = -(this + num)
              } else if (this.negative !== 0) {
                this.negative = 0;
                this.iadd(num);
                this.negative = 1;
                return this._normSign();
              } // At this point both numbers are positive
              var cmp = this.cmp(num); // Optimization - zeroify
              if (cmp === 0) {
                this.negative = 0;
                this.length = 1;
                this.words[0] = 0;
                return this;
              } // a > b
              var a, b;
              if (cmp > 0) {
                a = this;
                b = num;
              } else {
                a = num;
                b = this;
              }
              var carry = 0;
              for (var i = 0; i < b.length; i++) {
                r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
                carry = r >> 26;
                this.words[i] = r & 0x3ffffff;
              }
              for (; carry !== 0 && i < a.length; i++) {
                r = (a.words[i] | 0) + carry;
                carry = r >> 26;
                this.words[i] = r & 0x3ffffff;
              } // Copy rest of the words
              if (carry === 0 && i < a.length && a !== this) {
                for (; i < a.length; i++) {
                  this.words[i] = a.words[i];
                }
              }
              this.length = Math.max(this.length, i);
              if (a !== this) {
                this.negative = 1;
              }
              return this._strip();
            }; // Subtract `num` from `this`
            BN.prototype.sub = function sub(num) {
              return this.clone().isub(num);
            };
            function smallMulTo(self, num, out) {
              out.negative = num.negative ^ self.negative;
              var len = (self.length + num.length) | 0;
              out.length = len;
              len = (len - 1) | 0; // Peel one iteration (compiler can't do it, because of code complexity)
              var a = self.words[0] | 0;
              var b = num.words[0] | 0;
              var r = a * b;
              var lo = r & 0x3ffffff;
              var carry = (r / 0x4000000) | 0;
              out.words[0] = lo;
              for (var k = 1; k < len; k++) {
                // Sum all words with the same `i + j = k` and accumulate `ncarry`,
                // note that ncarry could be >= 0x3ffffff
                var ncarry = carry >>> 26;
                var rword = carry & 0x3ffffff;
                var maxJ = Math.min(k, num.length - 1);
                for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
                  var i = (k - j) | 0;
                  a = self.words[i] | 0;
                  b = num.words[j] | 0;
                  r = a * b + rword;
                  ncarry += (r / 0x4000000) | 0;
                  rword = r & 0x3ffffff;
                }
                out.words[k] = rword | 0;
                carry = ncarry | 0;
              }
              if (carry !== 0) {
                out.words[k] = carry | 0;
              } else {
                out.length--;
              }
              return out._strip();
            } // TODO(indutny): it may be reasonable to omit it for users who don't need
            // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
            // multiplication (like elliptic secp256k1).
            var comb10MulTo = function comb10MulTo(self, num, out) {
              var a = self.words;
              var b = num.words;
              var o = out.words;
              var c = 0;
              var lo;
              var mid;
              var hi;
              var a0 = a[0] | 0;
              var al0 = a0 & 0x1fff;
              var ah0 = a0 >>> 13;
              var a1 = a[1] | 0;
              var al1 = a1 & 0x1fff;
              var ah1 = a1 >>> 13;
              var a2 = a[2] | 0;
              var al2 = a2 & 0x1fff;
              var ah2 = a2 >>> 13;
              var a3 = a[3] | 0;
              var al3 = a3 & 0x1fff;
              var ah3 = a3 >>> 13;
              var a4 = a[4] | 0;
              var al4 = a4 & 0x1fff;
              var ah4 = a4 >>> 13;
              var a5 = a[5] | 0;
              var al5 = a5 & 0x1fff;
              var ah5 = a5 >>> 13;
              var a6 = a[6] | 0;
              var al6 = a6 & 0x1fff;
              var ah6 = a6 >>> 13;
              var a7 = a[7] | 0;
              var al7 = a7 & 0x1fff;
              var ah7 = a7 >>> 13;
              var a8 = a[8] | 0;
              var al8 = a8 & 0x1fff;
              var ah8 = a8 >>> 13;
              var a9 = a[9] | 0;
              var al9 = a9 & 0x1fff;
              var ah9 = a9 >>> 13;
              var b0 = b[0] | 0;
              var bl0 = b0 & 0x1fff;
              var bh0 = b0 >>> 13;
              var b1 = b[1] | 0;
              var bl1 = b1 & 0x1fff;
              var bh1 = b1 >>> 13;
              var b2 = b[2] | 0;
              var bl2 = b2 & 0x1fff;
              var bh2 = b2 >>> 13;
              var b3 = b[3] | 0;
              var bl3 = b3 & 0x1fff;
              var bh3 = b3 >>> 13;
              var b4 = b[4] | 0;
              var bl4 = b4 & 0x1fff;
              var bh4 = b4 >>> 13;
              var b5 = b[5] | 0;
              var bl5 = b5 & 0x1fff;
              var bh5 = b5 >>> 13;
              var b6 = b[6] | 0;
              var bl6 = b6 & 0x1fff;
              var bh6 = b6 >>> 13;
              var b7 = b[7] | 0;
              var bl7 = b7 & 0x1fff;
              var bh7 = b7 >>> 13;
              var b8 = b[8] | 0;
              var bl8 = b8 & 0x1fff;
              var bh8 = b8 >>> 13;
              var b9 = b[9] | 0;
              var bl9 = b9 & 0x1fff;
              var bh9 = b9 >>> 13;
              out.negative = self.negative ^ num.negative;
              out.length = 19;
              /* k = 0 */ lo = Math.imul(al0, bl0);
              mid = Math.imul(al0, bh0);
              mid = (mid + Math.imul(ah0, bl0)) | 0;
              hi = Math.imul(ah0, bh0);
              var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
              w0 &= 0x3ffffff;
              /* k = 1 */ lo = Math.imul(al1, bl0);
              mid = Math.imul(al1, bh0);
              mid = (mid + Math.imul(ah1, bl0)) | 0;
              hi = Math.imul(ah1, bh0);
              lo = (lo + Math.imul(al0, bl1)) | 0;
              mid = (mid + Math.imul(al0, bh1)) | 0;
              mid = (mid + Math.imul(ah0, bl1)) | 0;
              hi = (hi + Math.imul(ah0, bh1)) | 0;
              var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
              w1 &= 0x3ffffff;
              /* k = 2 */ lo = Math.imul(al2, bl0);
              mid = Math.imul(al2, bh0);
              mid = (mid + Math.imul(ah2, bl0)) | 0;
              hi = Math.imul(ah2, bh0);
              lo = (lo + Math.imul(al1, bl1)) | 0;
              mid = (mid + Math.imul(al1, bh1)) | 0;
              mid = (mid + Math.imul(ah1, bl1)) | 0;
              hi = (hi + Math.imul(ah1, bh1)) | 0;
              lo = (lo + Math.imul(al0, bl2)) | 0;
              mid = (mid + Math.imul(al0, bh2)) | 0;
              mid = (mid + Math.imul(ah0, bl2)) | 0;
              hi = (hi + Math.imul(ah0, bh2)) | 0;
              var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
              w2 &= 0x3ffffff;
              /* k = 3 */ lo = Math.imul(al3, bl0);
              mid = Math.imul(al3, bh0);
              mid = (mid + Math.imul(ah3, bl0)) | 0;
              hi = Math.imul(ah3, bh0);
              lo = (lo + Math.imul(al2, bl1)) | 0;
              mid = (mid + Math.imul(al2, bh1)) | 0;
              mid = (mid + Math.imul(ah2, bl1)) | 0;
              hi = (hi + Math.imul(ah2, bh1)) | 0;
              lo = (lo + Math.imul(al1, bl2)) | 0;
              mid = (mid + Math.imul(al1, bh2)) | 0;
              mid = (mid + Math.imul(ah1, bl2)) | 0;
              hi = (hi + Math.imul(ah1, bh2)) | 0;
              lo = (lo + Math.imul(al0, bl3)) | 0;
              mid = (mid + Math.imul(al0, bh3)) | 0;
              mid = (mid + Math.imul(ah0, bl3)) | 0;
              hi = (hi + Math.imul(ah0, bh3)) | 0;
              var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
              w3 &= 0x3ffffff;
              /* k = 4 */ lo = Math.imul(al4, bl0);
              mid = Math.imul(al4, bh0);
              mid = (mid + Math.imul(ah4, bl0)) | 0;
              hi = Math.imul(ah4, bh0);
              lo = (lo + Math.imul(al3, bl1)) | 0;
              mid = (mid + Math.imul(al3, bh1)) | 0;
              mid = (mid + Math.imul(ah3, bl1)) | 0;
              hi = (hi + Math.imul(ah3, bh1)) | 0;
              lo = (lo + Math.imul(al2, bl2)) | 0;
              mid = (mid + Math.imul(al2, bh2)) | 0;
              mid = (mid + Math.imul(ah2, bl2)) | 0;
              hi = (hi + Math.imul(ah2, bh2)) | 0;
              lo = (lo + Math.imul(al1, bl3)) | 0;
              mid = (mid + Math.imul(al1, bh3)) | 0;
              mid = (mid + Math.imul(ah1, bl3)) | 0;
              hi = (hi + Math.imul(ah1, bh3)) | 0;
              lo = (lo + Math.imul(al0, bl4)) | 0;
              mid = (mid + Math.imul(al0, bh4)) | 0;
              mid = (mid + Math.imul(ah0, bl4)) | 0;
              hi = (hi + Math.imul(ah0, bh4)) | 0;
              var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
              w4 &= 0x3ffffff;
              /* k = 5 */ lo = Math.imul(al5, bl0);
              mid = Math.imul(al5, bh0);
              mid = (mid + Math.imul(ah5, bl0)) | 0;
              hi = Math.imul(ah5, bh0);
              lo = (lo + Math.imul(al4, bl1)) | 0;
              mid = (mid + Math.imul(al4, bh1)) | 0;
              mid = (mid + Math.imul(ah4, bl1)) | 0;
              hi = (hi + Math.imul(ah4, bh1)) | 0;
              lo = (lo + Math.imul(al3, bl2)) | 0;
              mid = (mid + Math.imul(al3, bh2)) | 0;
              mid = (mid + Math.imul(ah3, bl2)) | 0;
              hi = (hi + Math.imul(ah3, bh2)) | 0;
              lo = (lo + Math.imul(al2, bl3)) | 0;
              mid = (mid + Math.imul(al2, bh3)) | 0;
              mid = (mid + Math.imul(ah2, bl3)) | 0;
              hi = (hi + Math.imul(ah2, bh3)) | 0;
              lo = (lo + Math.imul(al1, bl4)) | 0;
              mid = (mid + Math.imul(al1, bh4)) | 0;
              mid = (mid + Math.imul(ah1, bl4)) | 0;
              hi = (hi + Math.imul(ah1, bh4)) | 0;
              lo = (lo + Math.imul(al0, bl5)) | 0;
              mid = (mid + Math.imul(al0, bh5)) | 0;
              mid = (mid + Math.imul(ah0, bl5)) | 0;
              hi = (hi + Math.imul(ah0, bh5)) | 0;
              var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
              w5 &= 0x3ffffff;
              /* k = 6 */ lo = Math.imul(al6, bl0);
              mid = Math.imul(al6, bh0);
              mid = (mid + Math.imul(ah6, bl0)) | 0;
              hi = Math.imul(ah6, bh0);
              lo = (lo + Math.imul(al5, bl1)) | 0;
              mid = (mid + Math.imul(al5, bh1)) | 0;
              mid = (mid + Math.imul(ah5, bl1)) | 0;
              hi = (hi + Math.imul(ah5, bh1)) | 0;
              lo = (lo + Math.imul(al4, bl2)) | 0;
              mid = (mid + Math.imul(al4, bh2)) | 0;
              mid = (mid + Math.imul(ah4, bl2)) | 0;
              hi = (hi + Math.imul(ah4, bh2)) | 0;
              lo = (lo + Math.imul(al3, bl3)) | 0;
              mid = (mid + Math.imul(al3, bh3)) | 0;
              mid = (mid + Math.imul(ah3, bl3)) | 0;
              hi = (hi + Math.imul(ah3, bh3)) | 0;
              lo = (lo + Math.imul(al2, bl4)) | 0;
              mid = (mid + Math.imul(al2, bh4)) | 0;
              mid = (mid + Math.imul(ah2, bl4)) | 0;
              hi = (hi + Math.imul(ah2, bh4)) | 0;
              lo = (lo + Math.imul(al1, bl5)) | 0;
              mid = (mid + Math.imul(al1, bh5)) | 0;
              mid = (mid + Math.imul(ah1, bl5)) | 0;
              hi = (hi + Math.imul(ah1, bh5)) | 0;
              lo = (lo + Math.imul(al0, bl6)) | 0;
              mid = (mid + Math.imul(al0, bh6)) | 0;
              mid = (mid + Math.imul(ah0, bl6)) | 0;
              hi = (hi + Math.imul(ah0, bh6)) | 0;
              var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
              w6 &= 0x3ffffff;
              /* k = 7 */ lo = Math.imul(al7, bl0);
              mid = Math.imul(al7, bh0);
              mid = (mid + Math.imul(ah7, bl0)) | 0;
              hi = Math.imul(ah7, bh0);
              lo = (lo + Math.imul(al6, bl1)) | 0;
              mid = (mid + Math.imul(al6, bh1)) | 0;
              mid = (mid + Math.imul(ah6, bl1)) | 0;
              hi = (hi + Math.imul(ah6, bh1)) | 0;
              lo = (lo + Math.imul(al5, bl2)) | 0;
              mid = (mid + Math.imul(al5, bh2)) | 0;
              mid = (mid + Math.imul(ah5, bl2)) | 0;
              hi = (hi + Math.imul(ah5, bh2)) | 0;
              lo = (lo + Math.imul(al4, bl3)) | 0;
              mid = (mid + Math.imul(al4, bh3)) | 0;
              mid = (mid + Math.imul(ah4, bl3)) | 0;
              hi = (hi + Math.imul(ah4, bh3)) | 0;
              lo = (lo + Math.imul(al3, bl4)) | 0;
              mid = (mid + Math.imul(al3, bh4)) | 0;
              mid = (mid + Math.imul(ah3, bl4)) | 0;
              hi = (hi + Math.imul(ah3, bh4)) | 0;
              lo = (lo + Math.imul(al2, bl5)) | 0;
              mid = (mid + Math.imul(al2, bh5)) | 0;
              mid = (mid + Math.imul(ah2, bl5)) | 0;
              hi = (hi + Math.imul(ah2, bh5)) | 0;
              lo = (lo + Math.imul(al1, bl6)) | 0;
              mid = (mid + Math.imul(al1, bh6)) | 0;
              mid = (mid + Math.imul(ah1, bl6)) | 0;
              hi = (hi + Math.imul(ah1, bh6)) | 0;
              lo = (lo + Math.imul(al0, bl7)) | 0;
              mid = (mid + Math.imul(al0, bh7)) | 0;
              mid = (mid + Math.imul(ah0, bl7)) | 0;
              hi = (hi + Math.imul(ah0, bh7)) | 0;
              var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
              w7 &= 0x3ffffff;
              /* k = 8 */ lo = Math.imul(al8, bl0);
              mid = Math.imul(al8, bh0);
              mid = (mid + Math.imul(ah8, bl0)) | 0;
              hi = Math.imul(ah8, bh0);
              lo = (lo + Math.imul(al7, bl1)) | 0;
              mid = (mid + Math.imul(al7, bh1)) | 0;
              mid = (mid + Math.imul(ah7, bl1)) | 0;
              hi = (hi + Math.imul(ah7, bh1)) | 0;
              lo = (lo + Math.imul(al6, bl2)) | 0;
              mid = (mid + Math.imul(al6, bh2)) | 0;
              mid = (mid + Math.imul(ah6, bl2)) | 0;
              hi = (hi + Math.imul(ah6, bh2)) | 0;
              lo = (lo + Math.imul(al5, bl3)) | 0;
              mid = (mid + Math.imul(al5, bh3)) | 0;
              mid = (mid + Math.imul(ah5, bl3)) | 0;
              hi = (hi + Math.imul(ah5, bh3)) | 0;
              lo = (lo + Math.imul(al4, bl4)) | 0;
              mid = (mid + Math.imul(al4, bh4)) | 0;
              mid = (mid + Math.imul(ah4, bl4)) | 0;
              hi = (hi + Math.imul(ah4, bh4)) | 0;
              lo = (lo + Math.imul(al3, bl5)) | 0;
              mid = (mid + Math.imul(al3, bh5)) | 0;
              mid = (mid + Math.imul(ah3, bl5)) | 0;
              hi = (hi + Math.imul(ah3, bh5)) | 0;
              lo = (lo + Math.imul(al2, bl6)) | 0;
              mid = (mid + Math.imul(al2, bh6)) | 0;
              mid = (mid + Math.imul(ah2, bl6)) | 0;
              hi = (hi + Math.imul(ah2, bh6)) | 0;
              lo = (lo + Math.imul(al1, bl7)) | 0;
              mid = (mid + Math.imul(al1, bh7)) | 0;
              mid = (mid + Math.imul(ah1, bl7)) | 0;
              hi = (hi + Math.imul(ah1, bh7)) | 0;
              lo = (lo + Math.imul(al0, bl8)) | 0;
              mid = (mid + Math.imul(al0, bh8)) | 0;
              mid = (mid + Math.imul(ah0, bl8)) | 0;
              hi = (hi + Math.imul(ah0, bh8)) | 0;
              var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
              w8 &= 0x3ffffff;
              /* k = 9 */ lo = Math.imul(al9, bl0);
              mid = Math.imul(al9, bh0);
              mid = (mid + Math.imul(ah9, bl0)) | 0;
              hi = Math.imul(ah9, bh0);
              lo = (lo + Math.imul(al8, bl1)) | 0;
              mid = (mid + Math.imul(al8, bh1)) | 0;
              mid = (mid + Math.imul(ah8, bl1)) | 0;
              hi = (hi + Math.imul(ah8, bh1)) | 0;
              lo = (lo + Math.imul(al7, bl2)) | 0;
              mid = (mid + Math.imul(al7, bh2)) | 0;
              mid = (mid + Math.imul(ah7, bl2)) | 0;
              hi = (hi + Math.imul(ah7, bh2)) | 0;
              lo = (lo + Math.imul(al6, bl3)) | 0;
              mid = (mid + Math.imul(al6, bh3)) | 0;
              mid = (mid + Math.imul(ah6, bl3)) | 0;
              hi = (hi + Math.imul(ah6, bh3)) | 0;
              lo = (lo + Math.imul(al5, bl4)) | 0;
              mid = (mid + Math.imul(al5, bh4)) | 0;
              mid = (mid + Math.imul(ah5, bl4)) | 0;
              hi = (hi + Math.imul(ah5, bh4)) | 0;
              lo = (lo + Math.imul(al4, bl5)) | 0;
              mid = (mid + Math.imul(al4, bh5)) | 0;
              mid = (mid + Math.imul(ah4, bl5)) | 0;
              hi = (hi + Math.imul(ah4, bh5)) | 0;
              lo = (lo + Math.imul(al3, bl6)) | 0;
              mid = (mid + Math.imul(al3, bh6)) | 0;
              mid = (mid + Math.imul(ah3, bl6)) | 0;
              hi = (hi + Math.imul(ah3, bh6)) | 0;
              lo = (lo + Math.imul(al2, bl7)) | 0;
              mid = (mid + Math.imul(al2, bh7)) | 0;
              mid = (mid + Math.imul(ah2, bl7)) | 0;
              hi = (hi + Math.imul(ah2, bh7)) | 0;
              lo = (lo + Math.imul(al1, bl8)) | 0;
              mid = (mid + Math.imul(al1, bh8)) | 0;
              mid = (mid + Math.imul(ah1, bl8)) | 0;
              hi = (hi + Math.imul(ah1, bh8)) | 0;
              lo = (lo + Math.imul(al0, bl9)) | 0;
              mid = (mid + Math.imul(al0, bh9)) | 0;
              mid = (mid + Math.imul(ah0, bl9)) | 0;
              hi = (hi + Math.imul(ah0, bh9)) | 0;
              var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
              w9 &= 0x3ffffff;
              /* k = 10 */ lo = Math.imul(al9, bl1);
              mid = Math.imul(al9, bh1);
              mid = (mid + Math.imul(ah9, bl1)) | 0;
              hi = Math.imul(ah9, bh1);
              lo = (lo + Math.imul(al8, bl2)) | 0;
              mid = (mid + Math.imul(al8, bh2)) | 0;
              mid = (mid + Math.imul(ah8, bl2)) | 0;
              hi = (hi + Math.imul(ah8, bh2)) | 0;
              lo = (lo + Math.imul(al7, bl3)) | 0;
              mid = (mid + Math.imul(al7, bh3)) | 0;
              mid = (mid + Math.imul(ah7, bl3)) | 0;
              hi = (hi + Math.imul(ah7, bh3)) | 0;
              lo = (lo + Math.imul(al6, bl4)) | 0;
              mid = (mid + Math.imul(al6, bh4)) | 0;
              mid = (mid + Math.imul(ah6, bl4)) | 0;
              hi = (hi + Math.imul(ah6, bh4)) | 0;
              lo = (lo + Math.imul(al5, bl5)) | 0;
              mid = (mid + Math.imul(al5, bh5)) | 0;
              mid = (mid + Math.imul(ah5, bl5)) | 0;
              hi = (hi + Math.imul(ah5, bh5)) | 0;
              lo = (lo + Math.imul(al4, bl6)) | 0;
              mid = (mid + Math.imul(al4, bh6)) | 0;
              mid = (mid + Math.imul(ah4, bl6)) | 0;
              hi = (hi + Math.imul(ah4, bh6)) | 0;
              lo = (lo + Math.imul(al3, bl7)) | 0;
              mid = (mid + Math.imul(al3, bh7)) | 0;
              mid = (mid + Math.imul(ah3, bl7)) | 0;
              hi = (hi + Math.imul(ah3, bh7)) | 0;
              lo = (lo + Math.imul(al2, bl8)) | 0;
              mid = (mid + Math.imul(al2, bh8)) | 0;
              mid = (mid + Math.imul(ah2, bl8)) | 0;
              hi = (hi + Math.imul(ah2, bh8)) | 0;
              lo = (lo + Math.imul(al1, bl9)) | 0;
              mid = (mid + Math.imul(al1, bh9)) | 0;
              mid = (mid + Math.imul(ah1, bl9)) | 0;
              hi = (hi + Math.imul(ah1, bh9)) | 0;
              var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
              w10 &= 0x3ffffff;
              /* k = 11 */ lo = Math.imul(al9, bl2);
              mid = Math.imul(al9, bh2);
              mid = (mid + Math.imul(ah9, bl2)) | 0;
              hi = Math.imul(ah9, bh2);
              lo = (lo + Math.imul(al8, bl3)) | 0;
              mid = (mid + Math.imul(al8, bh3)) | 0;
              mid = (mid + Math.imul(ah8, bl3)) | 0;
              hi = (hi + Math.imul(ah8, bh3)) | 0;
              lo = (lo + Math.imul(al7, bl4)) | 0;
              mid = (mid + Math.imul(al7, bh4)) | 0;
              mid = (mid + Math.imul(ah7, bl4)) | 0;
              hi = (hi + Math.imul(ah7, bh4)) | 0;
              lo = (lo + Math.imul(al6, bl5)) | 0;
              mid = (mid + Math.imul(al6, bh5)) | 0;
              mid = (mid + Math.imul(ah6, bl5)) | 0;
              hi = (hi + Math.imul(ah6, bh5)) | 0;
              lo = (lo + Math.imul(al5, bl6)) | 0;
              mid = (mid + Math.imul(al5, bh6)) | 0;
              mid = (mid + Math.imul(ah5, bl6)) | 0;
              hi = (hi + Math.imul(ah5, bh6)) | 0;
              lo = (lo + Math.imul(al4, bl7)) | 0;
              mid = (mid + Math.imul(al4, bh7)) | 0;
              mid = (mid + Math.imul(ah4, bl7)) | 0;
              hi = (hi + Math.imul(ah4, bh7)) | 0;
              lo = (lo + Math.imul(al3, bl8)) | 0;
              mid = (mid + Math.imul(al3, bh8)) | 0;
              mid = (mid + Math.imul(ah3, bl8)) | 0;
              hi = (hi + Math.imul(ah3, bh8)) | 0;
              lo = (lo + Math.imul(al2, bl9)) | 0;
              mid = (mid + Math.imul(al2, bh9)) | 0;
              mid = (mid + Math.imul(ah2, bl9)) | 0;
              hi = (hi + Math.imul(ah2, bh9)) | 0;
              var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
              w11 &= 0x3ffffff;
              /* k = 12 */ lo = Math.imul(al9, bl3);
              mid = Math.imul(al9, bh3);
              mid = (mid + Math.imul(ah9, bl3)) | 0;
              hi = Math.imul(ah9, bh3);
              lo = (lo + Math.imul(al8, bl4)) | 0;
              mid = (mid + Math.imul(al8, bh4)) | 0;
              mid = (mid + Math.imul(ah8, bl4)) | 0;
              hi = (hi + Math.imul(ah8, bh4)) | 0;
              lo = (lo + Math.imul(al7, bl5)) | 0;
              mid = (mid + Math.imul(al7, bh5)) | 0;
              mid = (mid + Math.imul(ah7, bl5)) | 0;
              hi = (hi + Math.imul(ah7, bh5)) | 0;
              lo = (lo + Math.imul(al6, bl6)) | 0;
              mid = (mid + Math.imul(al6, bh6)) | 0;
              mid = (mid + Math.imul(ah6, bl6)) | 0;
              hi = (hi + Math.imul(ah6, bh6)) | 0;
              lo = (lo + Math.imul(al5, bl7)) | 0;
              mid = (mid + Math.imul(al5, bh7)) | 0;
              mid = (mid + Math.imul(ah5, bl7)) | 0;
              hi = (hi + Math.imul(ah5, bh7)) | 0;
              lo = (lo + Math.imul(al4, bl8)) | 0;
              mid = (mid + Math.imul(al4, bh8)) | 0;
              mid = (mid + Math.imul(ah4, bl8)) | 0;
              hi = (hi + Math.imul(ah4, bh8)) | 0;
              lo = (lo + Math.imul(al3, bl9)) | 0;
              mid = (mid + Math.imul(al3, bh9)) | 0;
              mid = (mid + Math.imul(ah3, bl9)) | 0;
              hi = (hi + Math.imul(ah3, bh9)) | 0;
              var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
              w12 &= 0x3ffffff;
              /* k = 13 */ lo = Math.imul(al9, bl4);
              mid = Math.imul(al9, bh4);
              mid = (mid + Math.imul(ah9, bl4)) | 0;
              hi = Math.imul(ah9, bh4);
              lo = (lo + Math.imul(al8, bl5)) | 0;
              mid = (mid + Math.imul(al8, bh5)) | 0;
              mid = (mid + Math.imul(ah8, bl5)) | 0;
              hi = (hi + Math.imul(ah8, bh5)) | 0;
              lo = (lo + Math.imul(al7, bl6)) | 0;
              mid = (mid + Math.imul(al7, bh6)) | 0;
              mid = (mid + Math.imul(ah7, bl6)) | 0;
              hi = (hi + Math.imul(ah7, bh6)) | 0;
              lo = (lo + Math.imul(al6, bl7)) | 0;
              mid = (mid + Math.imul(al6, bh7)) | 0;
              mid = (mid + Math.imul(ah6, bl7)) | 0;
              hi = (hi + Math.imul(ah6, bh7)) | 0;
              lo = (lo + Math.imul(al5, bl8)) | 0;
              mid = (mid + Math.imul(al5, bh8)) | 0;
              mid = (mid + Math.imul(ah5, bl8)) | 0;
              hi = (hi + Math.imul(ah5, bh8)) | 0;
              lo = (lo + Math.imul(al4, bl9)) | 0;
              mid = (mid + Math.imul(al4, bh9)) | 0;
              mid = (mid + Math.imul(ah4, bl9)) | 0;
              hi = (hi + Math.imul(ah4, bh9)) | 0;
              var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
              w13 &= 0x3ffffff;
              /* k = 14 */ lo = Math.imul(al9, bl5);
              mid = Math.imul(al9, bh5);
              mid = (mid + Math.imul(ah9, bl5)) | 0;
              hi = Math.imul(ah9, bh5);
              lo = (lo + Math.imul(al8, bl6)) | 0;
              mid = (mid + Math.imul(al8, bh6)) | 0;
              mid = (mid + Math.imul(ah8, bl6)) | 0;
              hi = (hi + Math.imul(ah8, bh6)) | 0;
              lo = (lo + Math.imul(al7, bl7)) | 0;
              mid = (mid + Math.imul(al7, bh7)) | 0;
              mid = (mid + Math.imul(ah7, bl7)) | 0;
              hi = (hi + Math.imul(ah7, bh7)) | 0;
              lo = (lo + Math.imul(al6, bl8)) | 0;
              mid = (mid + Math.imul(al6, bh8)) | 0;
              mid = (mid + Math.imul(ah6, bl8)) | 0;
              hi = (hi + Math.imul(ah6, bh8)) | 0;
              lo = (lo + Math.imul(al5, bl9)) | 0;
              mid = (mid + Math.imul(al5, bh9)) | 0;
              mid = (mid + Math.imul(ah5, bl9)) | 0;
              hi = (hi + Math.imul(ah5, bh9)) | 0;
              var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
              w14 &= 0x3ffffff;
              /* k = 15 */ lo = Math.imul(al9, bl6);
              mid = Math.imul(al9, bh6);
              mid = (mid + Math.imul(ah9, bl6)) | 0;
              hi = Math.imul(ah9, bh6);
              lo = (lo + Math.imul(al8, bl7)) | 0;
              mid = (mid + Math.imul(al8, bh7)) | 0;
              mid = (mid + Math.imul(ah8, bl7)) | 0;
              hi = (hi + Math.imul(ah8, bh7)) | 0;
              lo = (lo + Math.imul(al7, bl8)) | 0;
              mid = (mid + Math.imul(al7, bh8)) | 0;
              mid = (mid + Math.imul(ah7, bl8)) | 0;
              hi = (hi + Math.imul(ah7, bh8)) | 0;
              lo = (lo + Math.imul(al6, bl9)) | 0;
              mid = (mid + Math.imul(al6, bh9)) | 0;
              mid = (mid + Math.imul(ah6, bl9)) | 0;
              hi = (hi + Math.imul(ah6, bh9)) | 0;
              var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
              w15 &= 0x3ffffff;
              /* k = 16 */ lo = Math.imul(al9, bl7);
              mid = Math.imul(al9, bh7);
              mid = (mid + Math.imul(ah9, bl7)) | 0;
              hi = Math.imul(ah9, bh7);
              lo = (lo + Math.imul(al8, bl8)) | 0;
              mid = (mid + Math.imul(al8, bh8)) | 0;
              mid = (mid + Math.imul(ah8, bl8)) | 0;
              hi = (hi + Math.imul(ah8, bh8)) | 0;
              lo = (lo + Math.imul(al7, bl9)) | 0;
              mid = (mid + Math.imul(al7, bh9)) | 0;
              mid = (mid + Math.imul(ah7, bl9)) | 0;
              hi = (hi + Math.imul(ah7, bh9)) | 0;
              var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
              w16 &= 0x3ffffff;
              /* k = 17 */ lo = Math.imul(al9, bl8);
              mid = Math.imul(al9, bh8);
              mid = (mid + Math.imul(ah9, bl8)) | 0;
              hi = Math.imul(ah9, bh8);
              lo = (lo + Math.imul(al8, bl9)) | 0;
              mid = (mid + Math.imul(al8, bh9)) | 0;
              mid = (mid + Math.imul(ah8, bl9)) | 0;
              hi = (hi + Math.imul(ah8, bh9)) | 0;
              var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
              w17 &= 0x3ffffff;
              /* k = 18 */ lo = Math.imul(al9, bl9);
              mid = Math.imul(al9, bh9);
              mid = (mid + Math.imul(ah9, bl9)) | 0;
              hi = Math.imul(ah9, bh9);
              var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
              c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
              w18 &= 0x3ffffff;
              o[0] = w0;
              o[1] = w1;
              o[2] = w2;
              o[3] = w3;
              o[4] = w4;
              o[5] = w5;
              o[6] = w6;
              o[7] = w7;
              o[8] = w8;
              o[9] = w9;
              o[10] = w10;
              o[11] = w11;
              o[12] = w12;
              o[13] = w13;
              o[14] = w14;
              o[15] = w15;
              o[16] = w16;
              o[17] = w17;
              o[18] = w18;
              if (c !== 0) {
                o[19] = c;
                out.length++;
              }
              return out;
            }; // Polyfill comb
            if (!Math.imul) {
              comb10MulTo = smallMulTo;
            }
            function bigMulTo(self, num, out) {
              out.negative = num.negative ^ self.negative;
              out.length = self.length + num.length;
              var carry = 0;
              var hncarry = 0;
              for (var k = 0; k < out.length - 1; k++) {
                // Sum all words with the same `i + j = k` and accumulate `ncarry`,
                // note that ncarry could be >= 0x3ffffff
                var ncarry = hncarry;
                hncarry = 0;
                var rword = carry & 0x3ffffff;
                var maxJ = Math.min(k, num.length - 1);
                for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
                  var i = k - j;
                  var a = self.words[i] | 0;
                  var b = num.words[j] | 0;
                  var r = a * b;
                  var lo = r & 0x3ffffff;
                  ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
                  lo = (lo + rword) | 0;
                  rword = lo & 0x3ffffff;
                  ncarry = (ncarry + (lo >>> 26)) | 0;
                  hncarry += ncarry >>> 26;
                  ncarry &= 0x3ffffff;
                }
                out.words[k] = rword;
                carry = ncarry;
                ncarry = hncarry;
              }
              if (carry !== 0) {
                out.words[k] = carry;
              } else {
                out.length--;
              }
              return out._strip();
            }
            function jumboMulTo(self, num, out) {
              // Temporary disable, see https://github.com/indutny/bn.js/issues/211
              // var fftm = new FFTM();
              // return fftm.mulp(self, num, out);
              return bigMulTo(self, num, out);
            }
            BN.prototype.mulTo = function mulTo(num, out) {
              var res;
              var len = this.length + num.length;
              if (this.length === 10 && num.length === 10) {
                res = comb10MulTo(this, num, out);
              } else if (len < 63) {
                res = smallMulTo(this, num, out);
              } else if (len < 1024) {
                res = bigMulTo(this, num, out);
              } else {
                res = jumboMulTo(this, num, out);
              }
              return res;
            }; // Cooley-Tukey algorithm for FFT
            // slightly revisited to rely on looping instead of recursion
            function FFTM(x, y) {
              this.x = x;
              this.y = y;
            }
            FFTM.prototype.makeRBT = function makeRBT(N) {
              var t = new Array(N);
              var l = BN.prototype._countBits(N) - 1;
              for (var i = 0; i < N; i++) {
                t[i] = this.revBin(i, l, N);
              }
              return t;
            }; // Returns binary-reversed representation of `x`
            FFTM.prototype.revBin = function revBin(x, l, N) {
              if (x === 0 || x === N - 1) return x;
              var rb = 0;
              for (var i = 0; i < l; i++) {
                rb |= (x & 1) << (l - i - 1);
                x >>= 1;
              }
              return rb;
            }; // Performs "tweedling" phase, therefore 'emulating'
            // behaviour of the recursive algorithm
            FFTM.prototype.permute = function permute(
              rbt,
              rws,
              iws,
              rtws,
              itws,
              N
            ) {
              for (var i = 0; i < N; i++) {
                rtws[i] = rws[rbt[i]];
                itws[i] = iws[rbt[i]];
              }
            };
            FFTM.prototype.transform = function transform(
              rws,
              iws,
              rtws,
              itws,
              N,
              rbt
            ) {
              this.permute(rbt, rws, iws, rtws, itws, N);
              for (var s = 1; s < N; s <<= 1) {
                var l = s << 1;
                var rtwdf = Math.cos((2 * Math.PI) / l);
                var itwdf = Math.sin((2 * Math.PI) / l);
                for (var p = 0; p < N; p += l) {
                  var rtwdf_ = rtwdf;
                  var itwdf_ = itwdf;
                  for (var j = 0; j < s; j++) {
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                      rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                      itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                      rtwdf_ = rx;
                    }
                  }
                }
              }
            };
            FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
              var N = Math.max(m, n) | 1;
              var odd = N & 1;
              var i = 0;
              for (N = (N / 2) | 0; N; N = N >>> 1) {
                i++;
              }
              return 1 << (i + 1 + odd);
            };
            FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
              if (N <= 1) return;
              for (var i = 0; i < N / 2; i++) {
                var t = rws[i];
                rws[i] = rws[N - i - 1];
                rws[N - i - 1] = t;
                t = iws[i];
                iws[i] = -iws[N - i - 1];
                iws[N - i - 1] = -t;
              }
            };
            FFTM.prototype.normalize13b = function normalize13b(ws, N) {
              var carry = 0;
              for (var i = 0; i < N / 2; i++) {
                var w =
                  Math.round(ws[2 * i + 1] / N) * 0x2000 +
                  Math.round(ws[2 * i] / N) +
                  carry;
                ws[i] = w & 0x3ffffff;
                if (w < 0x4000000) {
                  carry = 0;
                } else {
                  carry = (w / 0x4000000) | 0;
                }
              }
              return ws;
            };
            FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
              var carry = 0;
              for (var i = 0; i < len; i++) {
                carry = carry + (ws[i] | 0);
                rws[2 * i] = carry & 0x1fff;
                carry = carry >>> 13;
                rws[2 * i + 1] = carry & 0x1fff;
                carry = carry >>> 13;
              } // Pad with zeroes
              for (i = 2 * len; i < N; ++i) {
                rws[i] = 0;
              }
              assert(carry === 0);
              assert((carry & ~0x1fff) === 0);
            };
            FFTM.prototype.stub = function stub(N) {
              var ph = new Array(N);
              for (var i = 0; i < N; i++) {
                ph[i] = 0;
              }
              return ph;
            };
            FFTM.prototype.mulp = function mulp(x, y, out) {
              var N = 2 * this.guessLen13b(x.length, y.length);
              var rbt = this.makeRBT(N);
              var _ = this.stub(N);
              var rws = new Array(N);
              var rwst = new Array(N);
              var iwst = new Array(N);
              var nrws = new Array(N);
              var nrwst = new Array(N);
              var niwst = new Array(N);
              var rmws = out.words;
              rmws.length = N;
              this.convert13b(x.words, x.length, rws, N);
              this.convert13b(y.words, y.length, nrws, N);
              this.transform(rws, _, rwst, iwst, N, rbt);
              this.transform(nrws, _, nrwst, niwst, N, rbt);
              for (var i = 0; i < N; i++) {
                var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
                iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
                rwst[i] = rx;
              }
              this.conjugate(rwst, iwst, N);
              this.transform(rwst, iwst, rmws, _, N, rbt);
              this.conjugate(rmws, _, N);
              this.normalize13b(rmws, N);
              out.negative = x.negative ^ y.negative;
              out.length = x.length + y.length;
              return out._strip();
            }; // Multiply `this` by `num`
            BN.prototype.mul = function mul(num) {
              var out = new BN(null);
              out.words = new Array(this.length + num.length);
              return this.mulTo(num, out);
            }; // Multiply employing FFT
            BN.prototype.mulf = function mulf(num) {
              var out = new BN(null);
              out.words = new Array(this.length + num.length);
              return jumboMulTo(this, num, out);
            }; // In-place Multiplication
            BN.prototype.imul = function imul(num) {
              return this.clone().mulTo(num, this);
            };
            BN.prototype.imuln = function imuln(num) {
              var isNegNum = num < 0;
              if (isNegNum) num = -num;
              assert(typeof num === "number");
              assert(num < 0x4000000); // Carry
              var carry = 0;
              for (var i = 0; i < this.length; i++) {
                var w = (this.words[i] | 0) * num;
                var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
                carry >>= 26;
                carry += (w / 0x4000000) | 0; // NOTE: lo is 27bit maximum
                carry += lo >>> 26;
                this.words[i] = lo & 0x3ffffff;
              }
              if (carry !== 0) {
                this.words[i] = carry;
                this.length++;
              }
              return isNegNum ? this.ineg() : this;
            };
            BN.prototype.muln = function muln(num) {
              return this.clone().imuln(num);
            }; // `this` * `this`
            BN.prototype.sqr = function sqr() {
              return this.mul(this);
            }; // `this` * `this` in-place
            BN.prototype.isqr = function isqr() {
              return this.imul(this.clone());
            }; // Math.pow(`this`, `num`)
            BN.prototype.pow = function pow(num) {
              var w = toBitArray(num);
              if (w.length === 0) return new BN(1); // Skip leading zeroes
              var res = this;
              for (var i = 0; i < w.length; i++, res = res.sqr()) {
                if (w[i] !== 0) break;
              }
              if (++i < w.length) {
                for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
                  if (w[i] === 0) continue;
                  res = res.mul(q);
                }
              }
              return res;
            }; // Shift-left in-place
            BN.prototype.iushln = function iushln(bits) {
              assert(typeof bits === "number" && bits >= 0);
              var r = bits % 26;
              var s = (bits - r) / 26;
              var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
              var i;
              if (r !== 0) {
                var carry = 0;
                for (i = 0; i < this.length; i++) {
                  var newCarry = this.words[i] & carryMask;
                  var c = ((this.words[i] | 0) - newCarry) << r;
                  this.words[i] = c | carry;
                  carry = newCarry >>> (26 - r);
                }
                if (carry) {
                  this.words[i] = carry;
                  this.length++;
                }
              }
              if (s !== 0) {
                for (i = this.length - 1; i >= 0; i--) {
                  this.words[i + s] = this.words[i];
                }
                for (i = 0; i < s; i++) {
                  this.words[i] = 0;
                }
                this.length += s;
              }
              return this._strip();
            };
            BN.prototype.ishln = function ishln(bits) {
              // TODO(indutny): implement me
              assert(this.negative === 0);
              return this.iushln(bits);
            }; // Shift-right in-place
            // NOTE: `hint` is a lowest bit before trailing zeroes
            // NOTE: if `extended` is present - it will be filled with destroyed bits
            BN.prototype.iushrn = function iushrn(bits, hint, extended) {
              assert(typeof bits === "number" && bits >= 0);
              var h;
              if (hint) {
                h = (hint - (hint % 26)) / 26;
              } else {
                h = 0;
              }
              var r = bits % 26;
              var s = Math.min((bits - r) / 26, this.length);
              var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
              var maskedWords = extended;
              h -= s;
              h = Math.max(0, h); // Extended mode, copy masked part
              if (maskedWords) {
                for (var i = 0; i < s; i++) {
                  maskedWords.words[i] = this.words[i];
                }
                maskedWords.length = s;
              }
              if (s === 0) {
                // No-op, we should not move anything at all
              } else if (this.length > s) {
                this.length -= s;
                for (i = 0; i < this.length; i++) {
                  this.words[i] = this.words[i + s];
                }
              } else {
                this.words[0] = 0;
                this.length = 1;
              }
              var carry = 0;
              for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
                var word = this.words[i] | 0;
                this.words[i] = (carry << (26 - r)) | (word >>> r);
                carry = word & mask;
              } // Push carried bits as a mask
              if (maskedWords && carry !== 0) {
                maskedWords.words[maskedWords.length++] = carry;
              }
              if (this.length === 0) {
                this.words[0] = 0;
                this.length = 1;
              }
              return this._strip();
            };
            BN.prototype.ishrn = function ishrn(bits, hint, extended) {
              // TODO(indutny): implement me
              assert(this.negative === 0);
              return this.iushrn(bits, hint, extended);
            }; // Shift-left
            BN.prototype.shln = function shln(bits) {
              return this.clone().ishln(bits);
            };
            BN.prototype.ushln = function ushln(bits) {
              return this.clone().iushln(bits);
            }; // Shift-right
            BN.prototype.shrn = function shrn(bits) {
              return this.clone().ishrn(bits);
            };
            BN.prototype.ushrn = function ushrn(bits) {
              return this.clone().iushrn(bits);
            }; // Test if n bit is set
            BN.prototype.testn = function testn(bit) {
              assert(typeof bit === "number" && bit >= 0);
              var r = bit % 26;
              var s = (bit - r) / 26;
              var q = 1 << r; // Fast case: bit is much higher than all existing words
              if (this.length <= s) return false; // Check bit and return
              var w = this.words[s];
              return !!(w & q);
            }; // Return only lowers bits of number (in-place)
            BN.prototype.imaskn = function imaskn(bits) {
              assert(typeof bits === "number" && bits >= 0);
              var r = bits % 26;
              var s = (bits - r) / 26;
              assert(
                this.negative === 0,
                "imaskn works only with positive numbers"
              );
              if (this.length <= s) {
                return this;
              }
              if (r !== 0) {
                s++;
              }
              this.length = Math.min(s, this.length);
              if (r !== 0) {
                var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
                this.words[this.length - 1] &= mask;
              }
              return this._strip();
            }; // Return only lowers bits of number
            BN.prototype.maskn = function maskn(bits) {
              return this.clone().imaskn(bits);
            }; // Add plain number `num` to `this`
            BN.prototype.iaddn = function iaddn(num) {
              assert(typeof num === "number");
              assert(num < 0x4000000);
              if (num < 0) return this.isubn(-num); // Possible sign change
              if (this.negative !== 0) {
                if (this.length === 1 && (this.words[0] | 0) <= num) {
                  this.words[0] = num - (this.words[0] | 0);
                  this.negative = 0;
                  return this;
                }
                this.negative = 0;
                this.isubn(num);
                this.negative = 1;
                return this;
              } // Add without checks
              return this._iaddn(num);
            };
            BN.prototype._iaddn = function _iaddn(num) {
              this.words[0] += num; // Carry
              for (
                var i = 0;
                i < this.length && this.words[i] >= 0x4000000;
                i++
              ) {
                this.words[i] -= 0x4000000;
                if (i === this.length - 1) {
                  this.words[i + 1] = 1;
                } else {
                  this.words[i + 1]++;
                }
              }
              this.length = Math.max(this.length, i + 1);
              return this;
            }; // Subtract plain number `num` from `this`
            BN.prototype.isubn = function isubn(num) {
              assert(typeof num === "number");
              assert(num < 0x4000000);
              if (num < 0) return this.iaddn(-num);
              if (this.negative !== 0) {
                this.negative = 0;
                this.iaddn(num);
                this.negative = 1;
                return this;
              }
              this.words[0] -= num;
              if (this.length === 1 && this.words[0] < 0) {
                this.words[0] = -this.words[0];
                this.negative = 1;
              } else {
                // Carry
                for (var i = 0; i < this.length && this.words[i] < 0; i++) {
                  this.words[i] += 0x4000000;
                  this.words[i + 1] -= 1;
                }
              }
              return this._strip();
            };
            BN.prototype.addn = function addn(num) {
              return this.clone().iaddn(num);
            };
            BN.prototype.subn = function subn(num) {
              return this.clone().isubn(num);
            };
            BN.prototype.iabs = function iabs() {
              this.negative = 0;
              return this;
            };
            BN.prototype.abs = function abs() {
              return this.clone().iabs();
            };
            BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
              var len = num.length + shift;
              var i;
              this._expand(len);
              var w;
              var carry = 0;
              for (i = 0; i < num.length; i++) {
                w = (this.words[i + shift] | 0) + carry;
                var right = (num.words[i] | 0) * mul;
                w -= right & 0x3ffffff;
                carry = (w >> 26) - ((right / 0x4000000) | 0);
                this.words[i + shift] = w & 0x3ffffff;
              }
              for (; i < this.length - shift; i++) {
                w = (this.words[i + shift] | 0) + carry;
                carry = w >> 26;
                this.words[i + shift] = w & 0x3ffffff;
              }
              if (carry === 0) return this._strip(); // Subtraction overflow
              assert(carry === -1);
              carry = 0;
              for (i = 0; i < this.length; i++) {
                w = -(this.words[i] | 0) + carry;
                carry = w >> 26;
                this.words[i] = w & 0x3ffffff;
              }
              this.negative = 1;
              return this._strip();
            };
            BN.prototype._wordDiv = function _wordDiv(num, mode) {
              var shift = this.length - num.length;
              var a = this.clone();
              var b = num; // Normalize
              var bhi = b.words[b.length - 1] | 0;
              var bhiBits = this._countBits(bhi);
              shift = 26 - bhiBits;
              if (shift !== 0) {
                b = b.ushln(shift);
                a.iushln(shift);
                bhi = b.words[b.length - 1] | 0;
              } // Initialize quotient
              var m = a.length - b.length;
              var q;
              if (mode !== "mod") {
                q = new BN(null);
                q.length = m + 1;
                q.words = new Array(q.length);
                for (var i = 0; i < q.length; i++) {
                  q.words[i] = 0;
                }
              }
              var diff = a.clone()._ishlnsubmul(b, 1, m);
              if (diff.negative === 0) {
                a = diff;
                if (q) {
                  q.words[m] = 1;
                }
              }
              for (var j = m - 1; j >= 0; j--) {
                var qj =
                  (a.words[b.length + j] | 0) * 0x4000000 +
                  (a.words[b.length + j - 1] | 0); // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
                // (0x7ffffff)
                qj = Math.min((qj / bhi) | 0, 0x3ffffff);
                a._ishlnsubmul(b, qj, j);
                while (a.negative !== 0) {
                  qj--;
                  a.negative = 0;
                  a._ishlnsubmul(b, 1, j);
                  if (!a.isZero()) {
                    a.negative ^= 1;
                  }
                }
                if (q) {
                  q.words[j] = qj;
                }
              }
              if (q) {
                q._strip();
              }
              a._strip(); // Denormalize
              if (mode !== "div" && shift !== 0) {
                a.iushrn(shift);
              }
              return { div: q || null, mod: a };
            }; // NOTE: 1) `mode` can be set to `mod` to request mod only,
            //       to `div` to request div only, or be absent to
            //       request both div & mod
            //       2) `positive` is true if unsigned mod is requested
            BN.prototype.divmod = function divmod(num, mode, positive) {
              assert(!num.isZero());
              if (this.isZero()) {
                return { div: new BN(0), mod: new BN(0) };
              }
              var div, mod, res;
              if (this.negative !== 0 && num.negative === 0) {
                res = this.neg().divmod(num, mode);
                if (mode !== "mod") {
                  div = res.div.neg();
                }
                if (mode !== "div") {
                  mod = res.mod.neg();
                  if (positive && mod.negative !== 0) {
                    mod.iadd(num);
                  }
                }
                return { div: div, mod: mod };
              }
              if (this.negative === 0 && num.negative !== 0) {
                res = this.divmod(num.neg(), mode);
                if (mode !== "mod") {
                  div = res.div.neg();
                }
                return { div: div, mod: res.mod };
              }
              if ((this.negative & num.negative) !== 0) {
                res = this.neg().divmod(num.neg(), mode);
                if (mode !== "div") {
                  mod = res.mod.neg();
                  if (positive && mod.negative !== 0) {
                    mod.isub(num);
                  }
                }
                return { div: res.div, mod: mod };
              } // Both numbers are positive at this point
              // Strip both numbers to approximate shift value
              if (num.length > this.length || this.cmp(num) < 0) {
                return { div: new BN(0), mod: this };
              } // Very short reduction
              if (num.length === 1) {
                if (mode === "div") {
                  return { div: this.divn(num.words[0]), mod: null };
                }
                if (mode === "mod") {
                  return { div: null, mod: new BN(this.modrn(num.words[0])) };
                }
                return {
                  div: this.divn(num.words[0]),
                  mod: new BN(this.modrn(num.words[0]))
                };
              }
              return this._wordDiv(num, mode);
            }; // Find `this` / `num`
            BN.prototype.div = function div(num) {
              return this.divmod(num, "div", false).div;
            }; // Find `this` % `num`
            BN.prototype.mod = function mod(num) {
              return this.divmod(num, "mod", false).mod;
            };
            BN.prototype.umod = function umod(num) {
              return this.divmod(num, "mod", true).mod;
            }; // Find Round(`this` / `num`)
            BN.prototype.divRound = function divRound(num) {
              var dm = this.divmod(num); // Fast case - exact division
              if (dm.mod.isZero()) return dm.div;
              var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
              var half = num.ushrn(1);
              var r2 = num.andln(1);
              var cmp = mod.cmp(half); // Round down
              if (cmp < 0 || (r2 === 1 && cmp === 0)) return dm.div; // Round up
              return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
            };
            BN.prototype.modrn = function modrn(num) {
              var isNegNum = num < 0;
              if (isNegNum) num = -num;
              assert(num <= 0x3ffffff);
              var p = (1 << 26) % num;
              var acc = 0;
              for (var i = this.length - 1; i >= 0; i--) {
                acc = (p * acc + (this.words[i] | 0)) % num;
              }
              return isNegNum ? -acc : acc;
            }; // WARNING: DEPRECATED
            BN.prototype.modn = function modn(num) {
              return this.modrn(num);
            }; // In-place division by number
            BN.prototype.idivn = function idivn(num) {
              var isNegNum = num < 0;
              if (isNegNum) num = -num;
              assert(num <= 0x3ffffff);
              var carry = 0;
              for (var i = this.length - 1; i >= 0; i--) {
                var w = (this.words[i] | 0) + carry * 0x4000000;
                this.words[i] = (w / num) | 0;
                carry = w % num;
              }
              this._strip();
              return isNegNum ? this.ineg() : this;
            };
            BN.prototype.divn = function divn(num) {
              return this.clone().idivn(num);
            };
            BN.prototype.egcd = function egcd(p) {
              assert(p.negative === 0);
              assert(!p.isZero());
              var x = this;
              var y = p.clone();
              if (x.negative !== 0) {
                x = x.umod(p);
              } else {
                x = x.clone();
              } // A * x + B * y = x
              var A = new BN(1);
              var B = new BN(0); // C * x + D * y = y
              var C = new BN(0);
              var D = new BN(1);
              var g = 0;
              while (x.isEven() && y.isEven()) {
                x.iushrn(1);
                y.iushrn(1);
                ++g;
              }
              var yp = y.clone();
              var xp = x.clone();
              while (!x.isZero()) {
                for (
                  var i = 0, im = 1;
                  (x.words[0] & im) === 0 && i < 26;
                  ++i, im <<= 1
                ) {}
                if (i > 0) {
                  x.iushrn(i);
                  while (i-- > 0) {
                    if (A.isOdd() || B.isOdd()) {
                      A.iadd(yp);
                      B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                  }
                }
                for (
                  var j = 0, jm = 1;
                  (y.words[0] & jm) === 0 && j < 26;
                  ++j, jm <<= 1
                ) {}
                if (j > 0) {
                  y.iushrn(j);
                  while (j-- > 0) {
                    if (C.isOdd() || D.isOdd()) {
                      C.iadd(yp);
                      D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                  }
                }
                if (x.cmp(y) >= 0) {
                  x.isub(y);
                  A.isub(C);
                  B.isub(D);
                } else {
                  y.isub(x);
                  C.isub(A);
                  D.isub(B);
                }
              }
              return { a: C, b: D, gcd: y.iushln(g) };
            }; // This is reduced incarnation of the binary EEA
            // above, designated to invert members of the
            // _prime_ fields F(p) at a maximal speed
            BN.prototype._invmp = function _invmp(p) {
              assert(p.negative === 0);
              assert(!p.isZero());
              var a = this;
              var b = p.clone();
              if (a.negative !== 0) {
                a = a.umod(p);
              } else {
                a = a.clone();
              }
              var x1 = new BN(1);
              var x2 = new BN(0);
              var delta = b.clone();
              while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
                for (
                  var i = 0, im = 1;
                  (a.words[0] & im) === 0 && i < 26;
                  ++i, im <<= 1
                ) {}
                if (i > 0) {
                  a.iushrn(i);
                  while (i-- > 0) {
                    if (x1.isOdd()) {
                      x1.iadd(delta);
                    }
                    x1.iushrn(1);
                  }
                }
                for (
                  var j = 0, jm = 1;
                  (b.words[0] & jm) === 0 && j < 26;
                  ++j, jm <<= 1
                ) {}
                if (j > 0) {
                  b.iushrn(j);
                  while (j-- > 0) {
                    if (x2.isOdd()) {
                      x2.iadd(delta);
                    }
                    x2.iushrn(1);
                  }
                }
                if (a.cmp(b) >= 0) {
                  a.isub(b);
                  x1.isub(x2);
                } else {
                  b.isub(a);
                  x2.isub(x1);
                }
              }
              var res;
              if (a.cmpn(1) === 0) {
                res = x1;
              } else {
                res = x2;
              }
              if (res.cmpn(0) < 0) {
                res.iadd(p);
              }
              return res;
            };
            BN.prototype.gcd = function gcd(num) {
              if (this.isZero()) return num.abs();
              if (num.isZero()) return this.abs();
              var a = this.clone();
              var b = num.clone();
              a.negative = 0;
              b.negative = 0; // Remove common factor of two
              for (var shift = 0; a.isEven() && b.isEven(); shift++) {
                a.iushrn(1);
                b.iushrn(1);
              }
              do {
                while (a.isEven()) {
                  a.iushrn(1);
                }
                while (b.isEven()) {
                  b.iushrn(1);
                }
                var r = a.cmp(b);
                if (r < 0) {
                  // Swap `a` and `b` to make `a` always bigger than `b`
                  var t = a;
                  a = b;
                  b = t;
                } else if (r === 0 || b.cmpn(1) === 0) {
                  break;
                }
                a.isub(b);
              } while (true);
              return b.iushln(shift);
            }; // Invert number in the field F(num)
            BN.prototype.invm = function invm(num) {
              return this.egcd(num).a.umod(num);
            };
            BN.prototype.isEven = function isEven() {
              return (this.words[0] & 1) === 0;
            };
            BN.prototype.isOdd = function isOdd() {
              return (this.words[0] & 1) === 1;
            }; // And first word and num
            BN.prototype.andln = function andln(num) {
              return this.words[0] & num;
            }; // Increment at the bit position in-line
            BN.prototype.bincn = function bincn(bit) {
              assert(typeof bit === "number");
              var r = bit % 26;
              var s = (bit - r) / 26;
              var q = 1 << r; // Fast case: bit is much higher than all existing words
              if (this.length <= s) {
                this._expand(s + 1);
                this.words[s] |= q;
                return this;
              } // Add bit and propagate, if needed
              var carry = q;
              for (var i = s; carry !== 0 && i < this.length; i++) {
                var w = this.words[i] | 0;
                w += carry;
                carry = w >>> 26;
                w &= 0x3ffffff;
                this.words[i] = w;
              }
              if (carry !== 0) {
                this.words[i] = carry;
                this.length++;
              }
              return this;
            };
            BN.prototype.isZero = function isZero() {
              return this.length === 1 && this.words[0] === 0;
            };
            BN.prototype.cmpn = function cmpn(num) {
              var negative = num < 0;
              if (this.negative !== 0 && !negative) return -1;
              if (this.negative === 0 && negative) return 1;
              this._strip();
              var res;
              if (this.length > 1) {
                res = 1;
              } else {
                if (negative) {
                  num = -num;
                }
                assert(num <= 0x3ffffff, "Number is too big");
                var w = this.words[0] | 0;
                res = w === num ? 0 : w < num ? -1 : 1;
              }
              if (this.negative !== 0) return -res | 0;
              return res;
            }; // Compare two numbers and return:
            // 1 - if `this` > `num`
            // 0 - if `this` == `num`
            // -1 - if `this` < `num`
            BN.prototype.cmp = function cmp(num) {
              if (this.negative !== 0 && num.negative === 0) return -1;
              if (this.negative === 0 && num.negative !== 0) return 1;
              var res = this.ucmp(num);
              if (this.negative !== 0) return -res | 0;
              return res;
            }; // Unsigned comparison
            BN.prototype.ucmp = function ucmp(num) {
              // At this point both numbers have the same sign
              if (this.length > num.length) return 1;
              if (this.length < num.length) return -1;
              var res = 0;
              for (var i = this.length - 1; i >= 0; i--) {
                var a = this.words[i] | 0;
                var b = num.words[i] | 0;
                if (a === b) continue;
                if (a < b) {
                  res = -1;
                } else if (a > b) {
                  res = 1;
                }
                break;
              }
              return res;
            };
            BN.prototype.gtn = function gtn(num) {
              return this.cmpn(num) === 1;
            };
            BN.prototype.gt = function gt(num) {
              return this.cmp(num) === 1;
            };
            BN.prototype.gten = function gten(num) {
              return this.cmpn(num) >= 0;
            };
            BN.prototype.gte = function gte(num) {
              return this.cmp(num) >= 0;
            };
            BN.prototype.ltn = function ltn(num) {
              return this.cmpn(num) === -1;
            };
            BN.prototype.lt = function lt(num) {
              return this.cmp(num) === -1;
            };
            BN.prototype.lten = function lten(num) {
              return this.cmpn(num) <= 0;
            };
            BN.prototype.lte = function lte(num) {
              return this.cmp(num) <= 0;
            };
            BN.prototype.eqn = function eqn(num) {
              return this.cmpn(num) === 0;
            };
            BN.prototype.eq = function eq(num) {
              return this.cmp(num) === 0;
            }; //
            // A reduce context, could be using montgomery or something better, depending
            // on the `m` itself.
            //
            BN.red = function red(num) {
              return new Red(num);
            };
            BN.prototype.toRed = function toRed(ctx) {
              assert(!this.red, "Already a number in reduction context");
              assert(this.negative === 0, "red works only with positives");
              return ctx.convertTo(this)._forceRed(ctx);
            };
            BN.prototype.fromRed = function fromRed() {
              assert(
                this.red,
                "fromRed works only with numbers in reduction context"
              );
              return this.red.convertFrom(this);
            };
            BN.prototype._forceRed = function _forceRed(ctx) {
              this.red = ctx;
              return this;
            };
            BN.prototype.forceRed = function forceRed(ctx) {
              assert(!this.red, "Already a number in reduction context");
              return this._forceRed(ctx);
            };
            BN.prototype.redAdd = function redAdd(num) {
              assert(this.red, "redAdd works only with red numbers");
              return this.red.add(this, num);
            };
            BN.prototype.redIAdd = function redIAdd(num) {
              assert(this.red, "redIAdd works only with red numbers");
              return this.red.iadd(this, num);
            };
            BN.prototype.redSub = function redSub(num) {
              assert(this.red, "redSub works only with red numbers");
              return this.red.sub(this, num);
            };
            BN.prototype.redISub = function redISub(num) {
              assert(this.red, "redISub works only with red numbers");
              return this.red.isub(this, num);
            };
            BN.prototype.redShl = function redShl(num) {
              assert(this.red, "redShl works only with red numbers");
              return this.red.shl(this, num);
            };
            BN.prototype.redMul = function redMul(num) {
              assert(this.red, "redMul works only with red numbers");
              this.red._verify2(this, num);
              return this.red.mul(this, num);
            };
            BN.prototype.redIMul = function redIMul(num) {
              assert(this.red, "redMul works only with red numbers");
              this.red._verify2(this, num);
              return this.red.imul(this, num);
            };
            BN.prototype.redSqr = function redSqr() {
              assert(this.red, "redSqr works only with red numbers");
              this.red._verify1(this);
              return this.red.sqr(this);
            };
            BN.prototype.redISqr = function redISqr() {
              assert(this.red, "redISqr works only with red numbers");
              this.red._verify1(this);
              return this.red.isqr(this);
            }; // Square root over p
            BN.prototype.redSqrt = function redSqrt() {
              assert(this.red, "redSqrt works only with red numbers");
              this.red._verify1(this);
              return this.red.sqrt(this);
            };
            BN.prototype.redInvm = function redInvm() {
              assert(this.red, "redInvm works only with red numbers");
              this.red._verify1(this);
              return this.red.invm(this);
            }; // Return negative clone of `this` % `red modulo`
            BN.prototype.redNeg = function redNeg() {
              assert(this.red, "redNeg works only with red numbers");
              this.red._verify1(this);
              return this.red.neg(this);
            };
            BN.prototype.redPow = function redPow(num) {
              assert(this.red && !num.red, "redPow(normalNum)");
              this.red._verify1(this);
              return this.red.pow(this, num);
            }; // Prime numbers with efficient reduction
            var primes = { k256: null, p224: null, p192: null, p25519: null }; // Pseudo-Mersenne prime
            function MPrime(name, p) {
              // P = 2 ^ N - K
              this.name = name;
              this.p = new BN(p, 16);
              this.n = this.p.bitLength();
              this.k = new BN(1).iushln(this.n).isub(this.p);
              this.tmp = this._tmp();
            }
            MPrime.prototype._tmp = function _tmp() {
              var tmp = new BN(null);
              tmp.words = new Array(Math.ceil(this.n / 13));
              return tmp;
            };
            MPrime.prototype.ireduce = function ireduce(num) {
              // Assumes that `num` is less than `P^2`
              // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
              var r = num;
              var rlen;
              do {
                this.split(r, this.tmp);
                r = this.imulK(r);
                r = r.iadd(this.tmp);
                rlen = r.bitLength();
              } while (rlen > this.n);
              var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
              if (cmp === 0) {
                r.words[0] = 0;
                r.length = 1;
              } else if (cmp > 0) {
                r.isub(this.p);
              } else {
                if (r.strip !== undefined) {
                  // r is a BN v4 instance
                  r.strip();
                } else {
                  // r is a BN v5 instance
                  r._strip();
                }
              }
              return r;
            };
            MPrime.prototype.split = function split(input, out) {
              input.iushrn(this.n, 0, out);
            };
            MPrime.prototype.imulK = function imulK(num) {
              return num.imul(this.k);
            };
            function K256() {
              MPrime.call(
                this,
                "k256",
                "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
              );
            }
            inherits(K256, MPrime);
            K256.prototype.split = function split(input, output) {
              // 256 = 9 * 26 + 22
              var mask = 0x3fffff;
              var outLen = Math.min(input.length, 9);
              for (var i = 0; i < outLen; i++) {
                output.words[i] = input.words[i];
              }
              output.length = outLen;
              if (input.length <= 9) {
                input.words[0] = 0;
                input.length = 1;
                return;
              } // Shift by 9 limbs
              var prev = input.words[9];
              output.words[output.length++] = prev & mask;
              for (i = 10; i < input.length; i++) {
                var next = input.words[i] | 0;
                input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
                prev = next;
              }
              prev >>>= 22;
              input.words[i - 10] = prev;
              if (prev === 0 && input.length > 10) {
                input.length -= 10;
              } else {
                input.length -= 9;
              }
            };
            K256.prototype.imulK = function imulK(num) {
              // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
              num.words[num.length] = 0;
              num.words[num.length + 1] = 0;
              num.length += 2; // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
              var lo = 0;
              for (var i = 0; i < num.length; i++) {
                var w = num.words[i] | 0;
                lo += w * 0x3d1;
                num.words[i] = lo & 0x3ffffff;
                lo = w * 0x40 + ((lo / 0x4000000) | 0);
              } // Fast length reduction
              if (num.words[num.length - 1] === 0) {
                num.length--;
                if (num.words[num.length - 1] === 0) {
                  num.length--;
                }
              }
              return num;
            };
            function P224() {
              MPrime.call(
                this,
                "p224",
                "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
              );
            }
            inherits(P224, MPrime);
            function P192() {
              MPrime.call(
                this,
                "p192",
                "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
              );
            }
            inherits(P192, MPrime);
            function P25519() {
              // 2 ^ 255 - 19
              MPrime.call(
                this,
                "25519",
                "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
              );
            }
            inherits(P25519, MPrime);
            P25519.prototype.imulK = function imulK(num) {
              // K = 0x13
              var carry = 0;
              for (var i = 0; i < num.length; i++) {
                var hi = (num.words[i] | 0) * 0x13 + carry;
                var lo = hi & 0x3ffffff;
                hi >>>= 26;
                num.words[i] = lo;
                carry = hi;
              }
              if (carry !== 0) {
                num.words[num.length++] = carry;
              }
              return num;
            }; // Exported mostly for testing purposes, use plain name instead
            BN._prime = function prime(name) {
              // Cached version of prime
              if (primes[name]) return primes[name];
              var prime;
              if (name === "k256") {
                prime = new K256();
              } else if (name === "p224") {
                prime = new P224();
              } else if (name === "p192") {
                prime = new P192();
              } else if (name === "p25519") {
                prime = new P25519();
              } else {
                throw new Error("Unknown prime " + name);
              }
              primes[name] = prime;
              return prime;
            }; //
            // Base reduction engine
            //
            function Red(m) {
              if (typeof m === "string") {
                var prime = BN._prime(m);
                this.m = prime.p;
                this.prime = prime;
              } else {
                assert(m.gtn(1), "modulus must be greater than 1");
                this.m = m;
                this.prime = null;
              }
            }
            Red.prototype._verify1 = function _verify1(a) {
              assert(a.negative === 0, "red works only with positives");
              assert(a.red, "red works only with red numbers");
            };
            Red.prototype._verify2 = function _verify2(a, b) {
              assert(
                (a.negative | b.negative) === 0,
                "red works only with positives"
              );
              assert(a.red && a.red === b.red, "red works only with red numbers");
            };
            Red.prototype.imod = function imod(a) {
              if (this.prime) return this.prime.ireduce(a)._forceRed(this);
              move(a, a.umod(this.m)._forceRed(this));
              return a;
            };
            Red.prototype.neg = function neg(a) {
              if (a.isZero()) {
                return a.clone();
              }
              return this.m.sub(a)._forceRed(this);
            };
            Red.prototype.add = function add(a, b) {
              this._verify2(a, b);
              var res = a.add(b);
              if (res.cmp(this.m) >= 0) {
                res.isub(this.m);
              }
              return res._forceRed(this);
            };
            Red.prototype.iadd = function iadd(a, b) {
              this._verify2(a, b);
              var res = a.iadd(b);
              if (res.cmp(this.m) >= 0) {
                res.isub(this.m);
              }
              return res;
            };
            Red.prototype.sub = function sub(a, b) {
              this._verify2(a, b);
              var res = a.sub(b);
              if (res.cmpn(0) < 0) {
                res.iadd(this.m);
              }
              return res._forceRed(this);
            };
            Red.prototype.isub = function isub(a, b) {
              this._verify2(a, b);
              var res = a.isub(b);
              if (res.cmpn(0) < 0) {
                res.iadd(this.m);
              }
              return res;
            };
            Red.prototype.shl = function shl(a, num) {
              this._verify1(a);
              return this.imod(a.ushln(num));
            };
            Red.prototype.imul = function imul(a, b) {
              this._verify2(a, b);
              return this.imod(a.imul(b));
            };
            Red.prototype.mul = function mul(a, b) {
              this._verify2(a, b);
              return this.imod(a.mul(b));
            };
            Red.prototype.isqr = function isqr(a) {
              return this.imul(a, a.clone());
            };
            Red.prototype.sqr = function sqr(a) {
              return this.mul(a, a);
            };
            Red.prototype.sqrt = function sqrt(a) {
              if (a.isZero()) return a.clone();
              var mod3 = this.m.andln(3);
              assert(mod3 % 2 === 1); // Fast case
              if (mod3 === 3) {
                var pow = this.m.add(new BN(1)).iushrn(2);
                return this.pow(a, pow);
              } // Tonelli-Shanks algorithm (Totally unoptimized and slow)
              //
              // Find Q and S, that Q * 2 ^ S = (P - 1)
              var q = this.m.subn(1);
              var s = 0;
              while (!q.isZero() && q.andln(1) === 0) {
                s++;
                q.iushrn(1);
              }
              assert(!q.isZero());
              var one = new BN(1).toRed(this);
              var nOne = one.redNeg(); // Find quadratic non-residue
              // NOTE: Max is such because of generalized Riemann hypothesis.
              var lpow = this.m.subn(1).iushrn(1);
              var z = this.m.bitLength();
              z = new BN(2 * z * z).toRed(this);
              while (this.pow(z, lpow).cmp(nOne) !== 0) {
                z.redIAdd(nOne);
              }
              var c = this.pow(z, q);
              var r = this.pow(a, q.addn(1).iushrn(1));
              var t = this.pow(a, q);
              var m = s;
              while (t.cmp(one) !== 0) {
                var tmp = t;
                for (var i = 0; tmp.cmp(one) !== 0; i++) {
                  tmp = tmp.redSqr();
                }
                assert(i < m);
                var b = this.pow(c, new BN(1).iushln(m - i - 1));
                r = r.redMul(b);
                c = b.redSqr();
                t = t.redMul(c);
                m = i;
              }
              return r;
            };
            Red.prototype.invm = function invm(a) {
              var inv = a._invmp(this.m);
              if (inv.negative !== 0) {
                inv.negative = 0;
                return this.imod(inv).redNeg();
              } else {
                return this.imod(inv);
              }
            };
            Red.prototype.pow = function pow(a, num) {
              if (num.isZero()) return new BN(1).toRed(this);
              if (num.cmpn(1) === 0) return a.clone();
              var windowSize = 4;
              var wnd = new Array(1 << windowSize);
              wnd[0] = new BN(1).toRed(this);
              wnd[1] = a;
              for (var i = 2; i < wnd.length; i++) {
                wnd[i] = this.mul(wnd[i - 1], a);
              }
              var res = wnd[0];
              var current = 0;
              var currentLen = 0;
              var start = num.bitLength() % 26;
              if (start === 0) {
                start = 26;
              }
              for (i = num.length - 1; i >= 0; i--) {
                var word = num.words[i];
                for (var j = start - 1; j >= 0; j--) {
                  var bit = (word >> j) & 1;
                  if (res !== wnd[0]) {
                    res = this.sqr(res);
                  }
                  if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                  }
                  current <<= 1;
                  current |= bit;
                  currentLen++;
                  if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                  res = this.mul(res, wnd[current]);
                  currentLen = 0;
                  current = 0;
                }
                start = 26;
              }
              return res;
            };
            Red.prototype.convertTo = function convertTo(num) {
              var r = num.umod(this.m);
              return r === num ? r.clone() : r;
            };
            Red.prototype.convertFrom = function convertFrom(num) {
              var res = num.clone();
              res.red = null;
              return res;
            }; //
            // Montgomery method engine
            //
            BN.mont = function mont(num) {
              return new Mont(num);
            };
            function Mont(m) {
              Red.call(this, m);
              this.shift = this.m.bitLength();
              if (this.shift % 26 !== 0) {
                this.shift += 26 - (this.shift % 26);
              }
              this.r = new BN(1).iushln(this.shift);
              this.r2 = this.imod(this.r.sqr());
              this.rinv = this.r._invmp(this.m);
              this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
              this.minv = this.minv.umod(this.r);
              this.minv = this.r.sub(this.minv);
            }
            inherits(Mont, Red);
            Mont.prototype.convertTo = function convertTo(num) {
              return this.imod(num.ushln(this.shift));
            };
            Mont.prototype.convertFrom = function convertFrom(num) {
              var r = this.imod(num.mul(this.rinv));
              r.red = null;
              return r;
            };
            Mont.prototype.imul = function imul(a, b) {
              if (a.isZero() || b.isZero()) {
                a.words[0] = 0;
                a.length = 1;
                return a;
              }
              var t = a.imul(b);
              var c = t
                .maskn(this.shift)
                .mul(this.minv)
                .imaskn(this.shift)
                .mul(this.m);
              var u = t.isub(c).iushrn(this.shift);
              var res = u;
              if (u.cmp(this.m) >= 0) {
                res = u.isub(this.m);
              } else if (u.cmpn(0) < 0) {
                res = u.iadd(this.m);
              }
              return res._forceRed(this);
            };
            Mont.prototype.mul = function mul(a, b) {
              if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
              var t = a.mul(b);
              var c = t
                .maskn(this.shift)
                .mul(this.minv)
                .imaskn(this.shift)
                .mul(this.m);
              var u = t.isub(c).iushrn(this.shift);
              var res = u;
              if (u.cmp(this.m) >= 0) {
                res = u.isub(this.m);
              } else if (u.cmpn(0) < 0) {
                res = u.iadd(this.m);
              }
              return res._forceRed(this);
            };
            Mont.prototype.invm = function invm(a) {
              // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
              var res = this.imod(a._invmp(this.m).mul(this.r2));
              return res._forceRed(this);
            };
          })(typeof module === "undefined" || module, this);
        },
        { buffer: "83fb80501e6599b7f0cf455c47cd5c1a" }
      ],
      efcfa6e673395ff8937c669c309d3b30: [
        function (require, module, exports) {
          "use strict";
          var Buffer = require("buffer").Buffer;
          Object.defineProperty(exports, "__esModule", { value: true });
          exports.computePublicKeyHash = exports.hexToBytes = exports.bytesToHex = void 0;
          var assert = require("assert");
          var hashjs = require("hash.js");
          var BN = require("bn.js");
          function bytesToHex(a) {
            return a
              .map(function (byteValue) {
                var hex = byteValue.toString(16).toUpperCase();
                return hex.length > 1 ? hex : "0".concat(hex);
              })
              .join("");
          }
          exports.bytesToHex = bytesToHex;
          function hexToBytes(a) {
            assert(a.length % 2 === 0);
            return new BN(a, 16).toArray(null, a.length / 2);
          }
          exports.hexToBytes = hexToBytes;
          function computePublicKeyHash(publicKeyBytes) {
            var hash256 = hashjs.sha256().update(publicKeyBytes).digest();
            var hash160 = hashjs.ripemd160().update(hash256).digest();
            return Buffer.from(hash160);
          }
          exports.computePublicKeyHash = computePublicKeyHash;
        },
        {
          buffer: "1948b2a05a083f82087512f711e79e4d",
          assert: "cdcb67ab5f6acbeabe6d878ee73d6e25",
          "hash.js": "f3fe44fc9be3d13b9d8db7c3873f780d",
          "bn.js": "2f602e32936ee0126d6915550c7108a7"
        }
      ],
      d7ef83308b42a154558e199779d37f7d: [
        function (require, module, exports) {
          var global = arguments[3];
          /**
           * Lodash (Custom Build) <https://lodash.com/>
           * Build: `lodash modularize exports="npm" -o ./`
           * Copyright JS Foundation and other contributors <https://js.foundation/>
           * Released under MIT license <https://lodash.com/license>
           * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
           * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
           */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
          /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED =
            "__lodash_hash_undefined__";
          /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1,
            COMPARE_UNORDERED_FLAG = 2;
          /** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
          /** `Object#toString` result references. */ var argsTag =
              "[object Arguments]",
            arrayTag = "[object Array]",
            asyncTag = "[object AsyncFunction]",
            boolTag = "[object Boolean]",
            dateTag = "[object Date]",
            errorTag = "[object Error]",
            funcTag = "[object Function]",
            genTag = "[object GeneratorFunction]",
            mapTag = "[object Map]",
            numberTag = "[object Number]",
            nullTag = "[object Null]",
            objectTag = "[object Object]",
            promiseTag = "[object Promise]",
            proxyTag = "[object Proxy]",
            regexpTag = "[object RegExp]",
            setTag = "[object Set]",
            stringTag = "[object String]",
            symbolTag = "[object Symbol]",
            undefinedTag = "[object Undefined]",
            weakMapTag = "[object WeakMap]";
          var arrayBufferTag = "[object ArrayBuffer]",
            dataViewTag = "[object DataView]",
            float32Tag = "[object Float32Array]",
            float64Tag = "[object Float64Array]",
            int8Tag = "[object Int8Array]",
            int16Tag = "[object Int16Array]",
            int32Tag = "[object Int32Array]",
            uint8Tag = "[object Uint8Array]",
            uint8ClampedTag = "[object Uint8ClampedArray]",
            uint16Tag = "[object Uint16Array]",
            uint32Tag = "[object Uint32Array]";
          /**
           * Used to match `RegExp`
           * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
           */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
          /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
          /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
          /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
          typedArrayTags[float32Tag] = typedArrayTags[
            float64Tag
          ] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[
            int32Tag
          ] = typedArrayTags[uint8Tag] = typedArrayTags[
            uint8ClampedTag
          ] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
          typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[
            arrayBufferTag
          ] = typedArrayTags[boolTag] = typedArrayTags[
            dataViewTag
          ] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[
            funcTag
          ] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[
            objectTag
          ] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[
            stringTag
          ] = typedArrayTags[weakMapTag] = false;
          /** Detect free variable `global` from Node.js. */ var freeGlobal =
            _typeof2(global) == "object" &&
            global &&
            global.Object === Object &&
            global;
          /** Detect free variable `self`. */ var freeSelf =
            (typeof self === "undefined" ? "undefined" : _typeof2(self)) ==
              "object" &&
            self &&
            self.Object === Object &&
            self;
          /** Used as a reference to the global object. */ var root =
            freeGlobal || freeSelf || Function("return this")();
          /** Detect free variable `exports`. */ var freeExports =
            _typeof2(exports) == "object" &&
            exports &&
            !exports.nodeType &&
            exports;
          /** Detect free variable `module`. */ var freeModule =
            freeExports &&
            _typeof2(module) == "object" &&
            module &&
            !module.nodeType &&
            module;
          /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports =
            freeModule && freeModule.exports === freeExports;
          /** Detect free variable `process` from Node.js. */ var freeProcess =
            moduleExports && freeGlobal.process;
          /** Used to access faster Node.js helpers. */ var nodeUtil = (function () {
            try {
              return (
                freeProcess && freeProcess.binding && freeProcess.binding("util")
              );
            } catch (e) {}
          })();
          /* Node.js helper references. */ var nodeIsTypedArray =
            nodeUtil && nodeUtil.isTypedArray;
          /**
           * A specialized version of `_.filter` for arrays without support for
           * iteratee shorthands.
           *
           * @private
           * @param {Array} [array] The array to iterate over.
           * @param {Function} predicate The function invoked per iteration.
           * @returns {Array} Returns the new filtered array.
           */ function arrayFilter(array, predicate) {
            var index = -1,
              length = array == null ? 0 : array.length,
              resIndex = 0,
              result = [];
            while (++index < length) {
              var value = array[index];
              if (predicate(value, index, array)) {
                result[resIndex++] = value;
              }
            }
            return result;
          }
          /**
           * Appends the elements of `values` to `array`.
           *
           * @private
           * @param {Array} array The array to modify.
           * @param {Array} values The values to append.
           * @returns {Array} Returns `array`.
           */ function arrayPush(array, values) {
            var index = -1,
              length = values.length,
              offset = array.length;
            while (++index < length) {
              array[offset + index] = values[index];
            }
            return array;
          }
          /**
           * A specialized version of `_.some` for arrays without support for iteratee
           * shorthands.
           *
           * @private
           * @param {Array} [array] The array to iterate over.
           * @param {Function} predicate The function invoked per iteration.
           * @returns {boolean} Returns `true` if any element passes the predicate check,
           *  else `false`.
           */ function arraySome(array, predicate) {
            var index = -1,
              length = array == null ? 0 : array.length;
            while (++index < length) {
              if (predicate(array[index], index, array)) {
                return true;
              }
            }
            return false;
          }
          /**
           * The base implementation of `_.times` without support for iteratee shorthands
           * or max array length checks.
           *
           * @private
           * @param {number} n The number of times to invoke `iteratee`.
           * @param {Function} iteratee The function invoked per iteration.
           * @returns {Array} Returns the array of results.
           */ function baseTimes(n, iteratee) {
            var index = -1,
              result = Array(n);
            while (++index < n) {
              result[index] = iteratee(index);
            }
            return result;
          }
          /**
           * The base implementation of `_.unary` without support for storing metadata.
           *
           * @private
           * @param {Function} func The function to cap arguments for.
           * @returns {Function} Returns the new capped function.
           */ function baseUnary(func) {
            return function (value) {
              return func(value);
            };
          }
          /**
           * Checks if a `cache` value for `key` exists.
           *
           * @private
           * @param {Object} cache The cache to query.
           * @param {string} key The key of the entry to check.
           * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
           */ function cacheHas(cache, key) {
            return cache.has(key);
          }
          /**
           * Gets the value at `key` of `object`.
           *
           * @private
           * @param {Object} [object] The object to query.
           * @param {string} key The key of the property to get.
           * @returns {*} Returns the property value.
           */ function getValue(object, key) {
            return object == null ? undefined : object[key];
          }
          /**
           * Converts `map` to its key-value pairs.
           *
           * @private
           * @param {Object} map The map to convert.
           * @returns {Array} Returns the key-value pairs.
           */ function mapToArray(map) {
            var index = -1,
              result = Array(map.size);
            map.forEach(function (value, key) {
              result[++index] = [key, value];
            });
            return result;
          }
          /**
           * Creates a unary function that invokes `func` with its argument transformed.
           *
           * @private
           * @param {Function} func The function to wrap.
           * @param {Function} transform The argument transform.
           * @returns {Function} Returns the new function.
           */ function overArg(func, transform) {
            return function (arg) {
              return func(transform(arg));
            };
          }
          /**
           * Converts `set` to an array of its values.
           *
           * @private
           * @param {Object} set The set to convert.
           * @returns {Array} Returns the values.
           */ function setToArray(set) {
            var index = -1,
              result = Array(set.size);
            set.forEach(function (value) {
              result[++index] = value;
            });
            return result;
          }
          /** Used for built-in method references. */ var arrayProto =
              Array.prototype,
            funcProto = Function.prototype,
            objectProto = Object.prototype;
          /** Used to detect overreaching core-js shims. */ var coreJsData =
            root["__core-js_shared__"];
          /** Used to resolve the decompiled source of functions. */ var funcToString =
            funcProto.toString;
          /** Used to check objects for own properties. */ var hasOwnProperty =
            objectProto.hasOwnProperty;
          /** Used to detect methods masquerading as native. */ var maskSrcKey = (function () {
            var uid = /[^.]+$/.exec(
              (coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO) || ""
            );
            return uid ? "Symbol(src)_1." + uid : "";
          })();
          /**
           * Used to resolve the
           * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
           * of values.
           */ var nativeObjectToString = objectProto.toString;
          /** Used to detect if a method is native. */ var reIsNative = RegExp(
            "^" +
              funcToString
                .call(hasOwnProperty)
                .replace(reRegExpChar, "\\$&")
                .replace(
                  /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
                  "$1.*?"
                ) +
              "$"
          );
          /** Built-in value references. */ var Buffer = moduleExports
              ? root.Buffer
              : undefined,
            _Symbol = root.Symbol,
            Uint8Array = root.Uint8Array,
            propertyIsEnumerable = objectProto.propertyIsEnumerable,
            splice = arrayProto.splice,
            symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
          /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols =
              Object.getOwnPropertySymbols,
            nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
            nativeKeys = overArg(Object.keys, Object);
          /* Built-in method references that are verified to be native. */ var DataView = getNative(
              root,
              "DataView"
            ),
            Map = getNative(root, "Map"),
            Promise = getNative(root, "Promise"),
            Set = getNative(root, "Set"),
            WeakMap = getNative(root, "WeakMap"),
            nativeCreate = getNative(Object, "create");
          /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(
              DataView
            ),
            mapCtorString = toSource(Map),
            promiseCtorString = toSource(Promise),
            setCtorString = toSource(Set),
            weakMapCtorString = toSource(WeakMap);
          /** Used to convert symbols to primitives and strings. */ var symbolProto = _Symbol
              ? _Symbol.prototype
              : undefined,
            symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
          /**
           * Creates a hash object.
           *
           * @private
           * @constructor
           * @param {Array} [entries] The key-value pairs to cache.
           */ function Hash(entries) {
            var index = -1,
              length = entries == null ? 0 : entries.length;
            this.clear();
            while (++index < length) {
              var entry = entries[index];
              this.set(entry[0], entry[1]);
            }
          }
          /**
           * Removes all key-value entries from the hash.
           *
           * @private
           * @name clear
           * @memberOf Hash
           */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
          }
          /**
           * Removes `key` and its value from the hash.
           *
           * @private
           * @name delete
           * @memberOf Hash
           * @param {Object} hash The hash to modify.
           * @param {string} key The key of the value to remove.
           * @returns {boolean} Returns `true` if the entry was removed, else `false`.
           */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
          }
          /**
           * Gets the hash value for `key`.
           *
           * @private
           * @name get
           * @memberOf Hash
           * @param {string} key The key of the value to get.
           * @returns {*} Returns the entry value.
           */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
              var result = data[key];
              return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
          }
          /**
           * Checks if a hash value for `key` exists.
           *
           * @private
           * @name has
           * @memberOf Hash
           * @param {string} key The key of the entry to check.
           * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
           */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate
              ? data[key] !== undefined
              : hasOwnProperty.call(data, key);
          }
          /**
           * Sets the hash `key` to `value`.
           *
           * @private
           * @name set
           * @memberOf Hash
           * @param {string} key The key of the value to set.
           * @param {*} value The value to set.
           * @returns {Object} Returns the hash instance.
           */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] =
              nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
          } // Add methods to `Hash`.
          Hash.prototype.clear = hashClear;
          Hash.prototype["delete"] = hashDelete;
          Hash.prototype.get = hashGet;
          Hash.prototype.has = hashHas;
          Hash.prototype.set = hashSet;
          /**
           * Creates an list cache object.
           *
           * @private
           * @constructor
           * @param {Array} [entries] The key-value pairs to cache.
           */ function ListCache(entries) {
            var index = -1,
              length = entries == null ? 0 : entries.length;
            this.clear();
            while (++index < length) {
              var entry = entries[index];
              this.set(entry[0], entry[1]);
            }
          }
          /**
           * Removes all key-value entries from the list cache.
           *
           * @private
           * @name clear
           * @memberOf ListCache
           */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
          }
          /**
           * Removes `key` and its value from the list cache.
           *
           * @private
           * @name delete
           * @memberOf ListCache
           * @param {string} key The key of the value to remove.
           * @returns {boolean} Returns `true` if the entry was removed, else `false`.
           */ function listCacheDelete(key) {
            var data = this.__data__,
              index = assocIndexOf(data, key);
            if (index < 0) {
              return false;
            }
            var lastIndex = data.length - 1;
            if (index == lastIndex) {
              data.pop();
            } else {
              splice.call(data, index, 1);
            }
            --this.size;
            return true;
          }
          /**
           * Gets the list cache value for `key`.
           *
           * @private
           * @name get
           * @memberOf ListCache
           * @param {string} key The key of the value to get.
           * @returns {*} Returns the entry value.
           */ function listCacheGet(key) {
            var data = this.__data__,
              index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
          }
          /**
           * Checks if a list cache value for `key` exists.
           *
           * @private
           * @name has
           * @memberOf ListCache
           * @param {string} key The key of the entry to check.
           * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
           */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
          }
          /**
           * Sets the list cache `key` to `value`.
           *
           * @private
           * @name set
           * @memberOf ListCache
           * @param {string} key The key of the value to set.
           * @param {*} value The value to set.
           * @returns {Object} Returns the list cache instance.
           */ function listCacheSet(key, value) {
            var data = this.__data__,
              index = assocIndexOf(data, key);
            if (index < 0) {
              ++this.size;
              data.push([key, value]);
            } else {
              data[index][1] = value;
            }
            return this;
          } // Add methods to `ListCache`.
          ListCache.prototype.clear = listCacheClear;
          ListCache.prototype["delete"] = listCacheDelete;
          ListCache.prototype.get = listCacheGet;
          ListCache.prototype.has = listCacheHas;
          ListCache.prototype.set = listCacheSet;
          /**
           * Creates a map cache object to store key-value pairs.
           *
           * @private
           * @constructor
           * @param {Array} [entries] The key-value pairs to cache.
           */ function MapCache(entries) {
            var index = -1,
              length = entries == null ? 0 : entries.length;
            this.clear();
            while (++index < length) {
              var entry = entries[index];
              this.set(entry[0], entry[1]);
            }
          }
          /**
           * Removes all key-value entries from the map.
           *
           * @private
           * @name clear
           * @memberOf MapCache
           */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
              hash: new Hash(),
              map: new (Map || ListCache)(),
              string: new Hash()
            };
          }
          /**
           * Removes `key` and its value from the map.
           *
           * @private
           * @name delete
           * @memberOf MapCache
           * @param {string} key The key of the value to remove.
           * @returns {boolean} Returns `true` if the entry was removed, else `false`.
           */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
          }
          /**
           * Gets the map value for `key`.
           *
           * @private
           * @name get
           * @memberOf MapCache
           * @param {string} key The key of the value to get.
           * @returns {*} Returns the entry value.
           */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
          }
          /**
           * Checks if a map value for `key` exists.
           *
           * @private
           * @name has
           * @memberOf MapCache
           * @param {string} key The key of the entry to check.
           * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
           */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
          }
          /**
           * Sets the map `key` to `value`.
           *
           * @private
           * @name set
           * @memberOf MapCache
           * @param {string} key The key of the value to set.
           * @param {*} value The value to set.
           * @returns {Object} Returns the map cache instance.
           */ function mapCacheSet(key, value) {
            var data = getMapData(this, key),
              size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
          } // Add methods to `MapCache`.
          MapCache.prototype.clear = mapCacheClear;
          MapCache.prototype["delete"] = mapCacheDelete;
          MapCache.prototype.get = mapCacheGet;
          MapCache.prototype.has = mapCacheHas;
          MapCache.prototype.set = mapCacheSet;
          /**
           *
           * Creates an array cache object to store unique values.
           *
           * @private
           * @constructor
           * @param {Array} [values] The values to cache.
           */ function SetCache(values) {
            var index = -1,
              length = values == null ? 0 : values.length;
            this.__data__ = new MapCache();
            while (++index < length) {
              this.add(values[index]);
            }
          }
          /**
           * Adds `value` to the array cache.
           *
           * @private
           * @name add
           * @memberOf SetCache
           * @alias push
           * @param {*} value The value to cache.
           * @returns {Object} Returns the cache instance.
           */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
          }
          /**
           * Checks if `value` is in the array cache.
           *
           * @private
           * @name has
           * @memberOf SetCache
           * @param {*} value The value to search for.
           * @returns {number} Returns `true` if `value` is found, else `false`.
           */ function setCacheHas(value) {
            return this.__data__.has(value);
          } // Add methods to `SetCache`.
          SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
          SetCache.prototype.has = setCacheHas;
          /**
           * Creates a stack cache object to store key-value pairs.
           *
           * @private
           * @constructor
           * @param {Array} [entries] The key-value pairs to cache.
           */ function Stack(entries) {
            var data = (this.__data__ = new ListCache(entries));
            this.size = data.size;
          }
          /**
           * Removes all key-value entries from the stack.
           *
           * @private
           * @name clear
           * @memberOf Stack
           */ function stackClear() {
            this.__data__ = new ListCache();
            this.size = 0;
          }
          /**
           * Removes `key` and its value from the stack.
           *
           * @private
           * @name delete
           * @memberOf Stack
           * @param {string} key The key of the value to remove.
           * @returns {boolean} Returns `true` if the entry was removed, else `false`.
           */ function stackDelete(key) {
            var data = this.__data__,
              result = data["delete"](key);
            this.size = data.size;
            return result;
          }
          /**
           * Gets the stack value for `key`.
           *
           * @private
           * @name get
           * @memberOf Stack
           * @param {string} key The key of the value to get.
           * @returns {*} Returns the entry value.
           */ function stackGet(key) {
            return this.__data__.get(key);
          }
          /**
           * Checks if a stack value for `key` exists.
           *
           * @private
           * @name has
           * @memberOf Stack
           * @param {string} key The key of the entry to check.
           * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
           */ function stackHas(key) {
            return this.__data__.has(key);
          }
          /**
           * Sets the stack `key` to `value`.
           *
           * @private
           * @name set
           * @memberOf Stack
           * @param {string} key The key of the value to set.
           * @param {*} value The value to set.
           * @returns {Object} Returns the stack cache instance.
           */ function stackSet(key, value) {
            var data = this.__data__;
            if (_instanceof(data, ListCache)) {
              var pairs = data.__data__;
              if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                pairs.push([key, value]);
                this.size = ++data.size;
                return this;
              }
              data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
          } // Add methods to `Stack`.
          Stack.prototype.clear = stackClear;
          Stack.prototype["delete"] = stackDelete;
          Stack.prototype.get = stackGet;
          Stack.prototype.has = stackHas;
          Stack.prototype.set = stackSet;
          /**
           * Creates an array of the enumerable property names of the array-like `value`.
           *
           * @private
           * @param {*} value The value to query.
           * @param {boolean} inherited Specify returning inherited property names.
           * @returns {Array} Returns the array of property names.
           */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value),
              isArg = !isArr && isArguments(value),
              isBuff = !isArr && !isArg && isBuffer(value),
              isType = !isArr && !isArg && !isBuff && isTypedArray(value),
              skipIndexes = isArr || isArg || isBuff || isType,
              result = skipIndexes ? baseTimes(value.length, String) : [],
              length = result.length;
            for (var key in value) {
              if (
                (inherited || hasOwnProperty.call(value, key)) &&
                !(
                  skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
                  (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
                    (isBuff && (key == "offset" || key == "parent")) || // PhantomJS 2 has enumerable non-index properties on typed arrays.
                    (isType &&
                      (key == "buffer" ||
                        key == "byteLength" ||
                        key == "byteOffset")) || // Skip index properties.
                    isIndex(key, length))
                )
              ) {
                result.push(key);
              }
            }
            return result;
          }
          /**
           * Gets the index at which the `key` is found in `array` of key-value pairs.
           *
           * @private
           * @param {Array} array The array to inspect.
           * @param {*} key The key to search for.
           * @returns {number} Returns the index of the matched value, else `-1`.
           */ function assocIndexOf(array, key) {
            var length = array.length;
            while (length--) {
              if (eq(array[length][0], key)) {
                return length;
              }
            }
            return -1;
          }
          /**
           * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
           * `keysFunc` and `symbolsFunc` to get the enumerable property names and
           * symbols of `object`.
           *
           * @private
           * @param {Object} object The object to query.
           * @param {Function} keysFunc The function to get the keys of `object`.
           * @param {Function} symbolsFunc The function to get the symbols of `object`.
           * @returns {Array} Returns the array of property names and symbols.
           */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object)
              ? result
              : arrayPush(result, symbolsFunc(object));
          }
          /**
           * The base implementation of `getTag` without fallbacks for buggy environments.
           *
           * @private
           * @param {*} value The value to query.
           * @returns {string} Returns the `toStringTag`.
           */ function baseGetTag(value) {
            if (value == null) {
              return value === undefined ? undefinedTag : nullTag;
            }
            return symToStringTag && symToStringTag in Object(value)
              ? getRawTag(value)
              : objectToString(value);
          }
          /**
           * The base implementation of `_.isArguments`.
           *
           * @private
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is an `arguments` object,
           */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
          }
          /**
           * The base implementation of `_.isEqual` which supports partial comparisons
           * and tracks traversed objects.
           *
           * @private
           * @param {*} value The value to compare.
           * @param {*} other The other value to compare.
           * @param {boolean} bitmask The bitmask flags.
           *  1 - Unordered comparison
           *  2 - Partial comparison
           * @param {Function} [customizer] The function to customize comparisons.
           * @param {Object} [stack] Tracks traversed `value` and `other` objects.
           * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
           */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) {
              return true;
            }
            if (
              value == null ||
              other == null ||
              (!isObjectLike(value) && !isObjectLike(other))
            ) {
              return value !== value && other !== other;
            }
            return baseIsEqualDeep(
              value,
              other,
              bitmask,
              customizer,
              baseIsEqual,
              stack
            );
          }
          /**
           * A specialized version of `baseIsEqual` for arrays and objects which performs
           * deep comparisons and tracks traversed objects enabling objects with circular
           * references to be compared.
           *
           * @private
           * @param {Object} object The object to compare.
           * @param {Object} other The other object to compare.
           * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
           * @param {Function} customizer The function to customize comparisons.
           * @param {Function} equalFunc The function to determine equivalents of values.
           * @param {Object} [stack] Tracks traversed `object` and `other` objects.
           * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
           */ function baseIsEqualDeep(
            object,
            other,
            bitmask,
            customizer,
            equalFunc,
            stack
          ) {
            var objIsArr = isArray(object),
              othIsArr = isArray(other),
              objTag = objIsArr ? arrayTag : getTag(object),
              othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag,
              othIsObj = othTag == objectTag,
              isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
              if (!isBuffer(other)) {
                return false;
              }
              objIsArr = true;
              objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
              stack || (stack = new Stack());
              return objIsArr || isTypedArray(object)
                ? equalArrays(
                    object,
                    other,
                    bitmask,
                    customizer,
                    equalFunc,
                    stack
                  )
                : equalByTag(
                    object,
                    other,
                    objTag,
                    bitmask,
                    customizer,
                    equalFunc,
                    stack
                  );
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
              var objIsWrapped =
                  objIsObj && hasOwnProperty.call(object, "__wrapped__"),
                othIsWrapped =
                  othIsObj && hasOwnProperty.call(other, "__wrapped__");
              if (objIsWrapped || othIsWrapped) {
                var objUnwrapped = objIsWrapped ? object.value() : object,
                  othUnwrapped = othIsWrapped ? other.value() : other;
                stack || (stack = new Stack());
                return equalFunc(
                  objUnwrapped,
                  othUnwrapped,
                  bitmask,
                  customizer,
                  stack
                );
              }
            }
            if (!isSameTag) {
              return false;
            }
            stack || (stack = new Stack());
            return equalObjects(
              object,
              other,
              bitmask,
              customizer,
              equalFunc,
              stack
            );
          }
          /**
           * The base implementation of `_.isNative` without bad shim checks.
           *
           * @private
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is a native function,
           *  else `false`.
           */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) {
              return false;
            }
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
          }
          /**
           * The base implementation of `_.isTypedArray` without Node.js optimizations.
           *
           * @private
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
           */ function baseIsTypedArray(value) {
            return (
              isObjectLike(value) &&
              isLength(value.length) &&
              !!typedArrayTags[baseGetTag(value)]
            );
          }
          /**
           * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
           *
           * @private
           * @param {Object} object The object to query.
           * @returns {Array} Returns the array of property names.
           */ function baseKeys(object) {
            if (!isPrototype(object)) {
              return nativeKeys(object);
            }
            var result = [];
            for (var key in Object(object)) {
              if (hasOwnProperty.call(object, key) && key != "constructor") {
                result.push(key);
              }
            }
            return result;
          }
          /**
           * A specialized version of `baseIsEqualDeep` for arrays with support for
           * partial deep comparisons.
           *
           * @private
           * @param {Array} array The array to compare.
           * @param {Array} other The other array to compare.
           * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
           * @param {Function} customizer The function to customize comparisons.
           * @param {Function} equalFunc The function to determine equivalents of values.
           * @param {Object} stack Tracks traversed `array` and `other` objects.
           * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
           */ function equalArrays(
            array,
            other,
            bitmask,
            customizer,
            equalFunc,
            stack
          ) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
              arrLength = array.length,
              othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
              return false;
            } // Assume cyclic values are equal.
            var stacked = stack.get(array);
            if (stacked && stack.get(other)) {
              return stacked == other;
            }
            var index = -1,
              result = true,
              seen =
                bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;
            stack.set(array, other);
            stack.set(other, array); // Ignore non-index properties.
            while (++index < arrLength) {
              var arrValue = array[index],
                othValue = other[index];
              if (customizer) {
                var compared = isPartial
                  ? customizer(othValue, arrValue, index, other, array, stack)
                  : customizer(arrValue, othValue, index, array, other, stack);
              }
              if (compared !== undefined) {
                if (compared) {
                  continue;
                }
                result = false;
                break;
              } // Recursively compare arrays (susceptible to call stack limits).
              if (seen) {
                if (
                  !arraySome(other, function (othValue, othIndex) {
                    if (
                      !cacheHas(seen, othIndex) &&
                      (arrValue === othValue ||
                        equalFunc(arrValue, othValue, bitmask, customizer, stack))
                    ) {
                      return seen.push(othIndex);
                    }
                  })
                ) {
                  result = false;
                  break;
                }
              } else if (
                !(
                  arrValue === othValue ||
                  equalFunc(arrValue, othValue, bitmask, customizer, stack)
                )
              ) {
                result = false;
                break;
              }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
          }
          /**
           * A specialized version of `baseIsEqualDeep` for comparing objects of
           * the same `toStringTag`.
           *
           * **Note:** This function only supports comparing values with tags of
           * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
           *
           * @private
           * @param {Object} object The object to compare.
           * @param {Object} other The other object to compare.
           * @param {string} tag The `toStringTag` of the objects to compare.
           * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
           * @param {Function} customizer The function to customize comparisons.
           * @param {Function} equalFunc The function to determine equivalents of values.
           * @param {Object} stack Tracks traversed `object` and `other` objects.
           * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
           */ function equalByTag(
            object,
            other,
            tag,
            bitmask,
            customizer,
            equalFunc,
            stack
          ) {
            switch (tag) {
              case dataViewTag:
                if (
                  object.byteLength != other.byteLength ||
                  object.byteOffset != other.byteOffset
                ) {
                  return false;
                }
                object = object.buffer;
                other = other.buffer;
              case arrayBufferTag:
                if (
                  object.byteLength != other.byteLength ||
                  !equalFunc(new Uint8Array(object), new Uint8Array(other))
                ) {
                  return false;
                }
                return true;
              case boolTag:
              case dateTag:
              case numberTag: // Coerce booleans to `1` or `0` and dates to milliseconds.
                // Invalid dates are coerced to `NaN`.
                return eq(+object, +other);
              case errorTag:
                return (
                  object.name == other.name && object.message == other.message
                );
              case regexpTag:
              case stringTag: // Coerce regexes to strings and treat strings, primitives and objects,
                // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                // for more details.
                return object == other + "";
              case mapTag:
                var convert = mapToArray;
              case setTag:
                var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                convert || (convert = setToArray);
                if (object.size != other.size && !isPartial) {
                  return false;
                } // Assume cyclic values are equal.
                var stacked = stack.get(object);
                if (stacked) {
                  return stacked == other;
                }
                bitmask |= COMPARE_UNORDERED_FLAG; // Recursively compare objects (susceptible to call stack limits).
                stack.set(object, other);
                var result = equalArrays(
                  convert(object),
                  convert(other),
                  bitmask,
                  customizer,
                  equalFunc,
                  stack
                );
                stack["delete"](object);
                return result;
              case symbolTag:
                if (symbolValueOf) {
                  return symbolValueOf.call(object) == symbolValueOf.call(other);
                }
            }
            return false;
          }
          /**
           * A specialized version of `baseIsEqualDeep` for objects with support for
           * partial deep comparisons.
           *
           * @private
           * @param {Object} object The object to compare.
           * @param {Object} other The other object to compare.
           * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
           * @param {Function} customizer The function to customize comparisons.
           * @param {Function} equalFunc The function to determine equivalents of values.
           * @param {Object} stack Tracks traversed `object` and `other` objects.
           * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
           */ function equalObjects(
            object,
            other,
            bitmask,
            customizer,
            equalFunc,
            stack
          ) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
              objProps = getAllKeys(object),
              objLength = objProps.length,
              othProps = getAllKeys(other),
              othLength = othProps.length;
            if (objLength != othLength && !isPartial) {
              return false;
            }
            var index = objLength;
            while (index--) {
              var key = objProps[index];
              if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
                return false;
              }
            } // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked && stack.get(other)) {
              return stacked == other;
            }
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while (++index < objLength) {
              key = objProps[index];
              var objValue = object[key],
                othValue = other[key];
              if (customizer) {
                var compared = isPartial
                  ? customizer(othValue, objValue, key, other, object, stack)
                  : customizer(objValue, othValue, key, object, other, stack);
              } // Recursively compare objects (susceptible to call stack limits).
              if (
                !(compared === undefined
                  ? objValue === othValue ||
                    equalFunc(objValue, othValue, bitmask, customizer, stack)
                  : compared)
              ) {
                result = false;
                break;
              }
              skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
              var objCtor = object.constructor,
                othCtor = other.constructor; // Non `Object` object instances with different constructors are not equal.
              if (
                objCtor != othCtor &&
                "constructor" in object &&
                "constructor" in other &&
                !(
                  typeof objCtor == "function" &&
                  _instanceof(objCtor, objCtor) &&
                  typeof othCtor == "function" &&
                  _instanceof(othCtor, othCtor)
                )
              ) {
                result = false;
              }
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
          }
          /**
           * Creates an array of own enumerable property names and symbols of `object`.
           *
           * @private
           * @param {Object} object The object to query.
           * @returns {Array} Returns the array of property names and symbols.
           */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
          }
          /**
           * Gets the data for `map`.
           *
           * @private
           * @param {Object} map The map to query.
           * @param {string} key The reference key.
           * @returns {*} Returns the map data.
           */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key)
              ? data[typeof key == "string" ? "string" : "hash"]
              : data.map;
          }
          /**
           * Gets the native function at `key` of `object`.
           *
           * @private
           * @param {Object} object The object to query.
           * @param {string} key The key of the method to get.
           * @returns {*} Returns the function if it's native, else `undefined`.
           */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
          }
          /**
           * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
           *
           * @private
           * @param {*} value The value to query.
           * @returns {string} Returns the raw `toStringTag`.
           */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag),
              tag = value[symToStringTag];
            try {
              value[symToStringTag] = undefined;
              var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
              if (isOwn) {
                value[symToStringTag] = tag;
              } else {
                delete value[symToStringTag];
              }
            }
            return result;
          }
          /**
           * Creates an array of the own enumerable symbols of `object`.
           *
           * @private
           * @param {Object} object The object to query.
           * @returns {Array} Returns the array of symbols.
           */ var getSymbols = !nativeGetSymbols
            ? stubArray
            : function (object) {
                if (object == null) {
                  return [];
                }
                object = Object(object);
                return arrayFilter(nativeGetSymbols(object), function (symbol) {
                  return propertyIsEnumerable.call(object, symbol);
                });
              };
          /**
           * Gets the `toStringTag` of `value`.
           *
           * @private
           * @param {*} value The value to query.
           * @returns {string} Returns the `toStringTag`.
           */ var getTag = baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
          if (
            (DataView &&
              getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
            (Map && getTag(new Map()) != mapTag) ||
            (Promise && getTag(Promise.resolve()) != promiseTag) ||
            (Set && getTag(new Set()) != setTag) ||
            (WeakMap && getTag(new WeakMap()) != weakMapTag)
          ) {
            getTag = function getTag(value) {
              var result = baseGetTag(value),
                Ctor = result == objectTag ? value.constructor : undefined,
                ctorString = Ctor ? toSource(Ctor) : "";
              if (ctorString) {
                switch (ctorString) {
                  case dataViewCtorString:
                    return dataViewTag;
                  case mapCtorString:
                    return mapTag;
                  case promiseCtorString:
                    return promiseTag;
                  case setCtorString:
                    return setTag;
                  case weakMapCtorString:
                    return weakMapTag;
                }
              }
              return result;
            };
          }
          /**
           * Checks if `value` is a valid array-like index.
           *
           * @private
           * @param {*} value The value to check.
           * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
           * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
           */ function isIndex(value, length) {
            length = length == null ? MAX_SAFE_INTEGER : length;
            return (
              !!length &&
              (typeof value == "number" || reIsUint.test(value)) &&
              value > -1 &&
              value % 1 == 0 &&
              value < length
            );
          }
          /**
           * Checks if `value` is suitable for use as unique object key.
           *
           * @private
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
           */ function isKeyable(value) {
            var type = _typeof2(value);
            return type == "string" ||
              type == "number" ||
              type == "symbol" ||
              type == "boolean"
              ? value !== "__proto__"
              : value === null;
          }
          /**
           * Checks if `func` has its source masked.
           *
           * @private
           * @param {Function} func The function to check.
           * @returns {boolean} Returns `true` if `func` is masked, else `false`.
           */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
          }
          /**
           * Checks if `value` is likely a prototype object.
           *
           * @private
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
           */ function isPrototype(value) {
            var Ctor = value && value.constructor,
              proto =
                (typeof Ctor == "function" && Ctor.prototype) || objectProto;
            return value === proto;
          }
          /**
           * Converts `value` to a string using `Object.prototype.toString`.
           *
           * @private
           * @param {*} value The value to convert.
           * @returns {string} Returns the converted string.
           */ function objectToString(value) {
            return nativeObjectToString.call(value);
          }
          /**
           * Converts `func` to its source code.
           *
           * @private
           * @param {Function} func The function to convert.
           * @returns {string} Returns the source code.
           */ function toSource(func) {
            if (func != null) {
              try {
                return funcToString.call(func);
              } catch (e) {}
              try {
                return func + "";
              } catch (e) {}
            }
            return "";
          }
          /**
           * Performs a
           * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
           * comparison between two values to determine if they are equivalent.
           *
           * @static
           * @memberOf _
           * @since 4.0.0
           * @category Lang
           * @param {*} value The value to compare.
           * @param {*} other The other value to compare.
           * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
           * @example
           *
           * var object = { 'a': 1 };
           * var other = { 'a': 1 };
           *
           * _.eq(object, object);
           * // => true
           *
           * _.eq(object, other);
           * // => false
           *
           * _.eq('a', 'a');
           * // => true
           *
           * _.eq('a', Object('a'));
           * // => false
           *
           * _.eq(NaN, NaN);
           * // => true
           */ function eq(value, other) {
            return value === other || (value !== value && other !== other);
          }
          /**
           * Checks if `value` is likely an `arguments` object.
           *
           * @static
           * @memberOf _
           * @since 0.1.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is an `arguments` object,
           *  else `false`.
           * @example
           *
           * _.isArguments(function() { return arguments; }());
           * // => true
           *
           * _.isArguments([1, 2, 3]);
           * // => false
           */ var isArguments = baseIsArguments(
            (function () {
              return arguments;
            })()
          )
            ? baseIsArguments
            : function (value) {
                return (
                  isObjectLike(value) &&
                  hasOwnProperty.call(value, "callee") &&
                  !propertyIsEnumerable.call(value, "callee")
                );
              };
          /**
           * Checks if `value` is classified as an `Array` object.
           *
           * @static
           * @memberOf _
           * @since 0.1.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is an array, else `false`.
           * @example
           *
           * _.isArray([1, 2, 3]);
           * // => true
           *
           * _.isArray(document.body.children);
           * // => false
           *
           * _.isArray('abc');
           * // => false
           *
           * _.isArray(_.noop);
           * // => false
           */ var isArray = Array.isArray;
          /**
           * Checks if `value` is array-like. A value is considered array-like if it's
           * not a function and has a `value.length` that's an integer greater than or
           * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
           *
           * @static
           * @memberOf _
           * @since 4.0.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
           * @example
           *
           * _.isArrayLike([1, 2, 3]);
           * // => true
           *
           * _.isArrayLike(document.body.children);
           * // => true
           *
           * _.isArrayLike('abc');
           * // => true
           *
           * _.isArrayLike(_.noop);
           * // => false
           */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
          }
          /**
           * Checks if `value` is a buffer.
           *
           * @static
           * @memberOf _
           * @since 4.3.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
           * @example
           *
           * _.isBuffer(new Buffer(2));
           * // => true
           *
           * _.isBuffer(new Uint8Array(2));
           * // => false
           */ var isBuffer = nativeIsBuffer || stubFalse;
          /**
           * Performs a deep comparison between two values to determine if they are
           * equivalent.
           *
           * **Note:** This method supports comparing arrays, array buffers, booleans,
           * date objects, error objects, maps, numbers, `Object` objects, regexes,
           * sets, strings, symbols, and typed arrays. `Object` objects are compared
           * by their own, not inherited, enumerable properties. Functions and DOM
           * nodes are compared by strict equality, i.e. `===`.
           *
           * @static
           * @memberOf _
           * @since 0.1.0
           * @category Lang
           * @param {*} value The value to compare.
           * @param {*} other The other value to compare.
           * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
           * @example
           *
           * var object = { 'a': 1 };
           * var other = { 'a': 1 };
           *
           * _.isEqual(object, other);
           * // => true
           *
           * object === other;
           * // => false
           */ function isEqual(value, other) {
            return baseIsEqual(value, other);
          }
          /**
           * Checks if `value` is classified as a `Function` object.
           *
           * @static
           * @memberOf _
           * @since 0.1.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is a function, else `false`.
           * @example
           *
           * _.isFunction(_);
           * // => true
           *
           * _.isFunction(/abc/);
           * // => false
           */ function isFunction(value) {
            if (!isObject(value)) {
              return false;
            } // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return (
              tag == funcTag ||
              tag == genTag ||
              tag == asyncTag ||
              tag == proxyTag
            );
          }
          /**
           * Checks if `value` is a valid array-like length.
           *
           * **Note:** This method is loosely based on
           * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
           *
           * @static
           * @memberOf _
           * @since 4.0.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
           * @example
           *
           * _.isLength(3);
           * // => true
           *
           * _.isLength(Number.MIN_VALUE);
           * // => false
           *
           * _.isLength(Infinity);
           * // => false
           *
           * _.isLength('3');
           * // => false
           */ function isLength(value) {
            return (
              typeof value == "number" &&
              value > -1 &&
              value % 1 == 0 &&
              value <= MAX_SAFE_INTEGER
            );
          }
          /**
           * Checks if `value` is the
           * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
           * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
           *
           * @static
           * @memberOf _
           * @since 0.1.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is an object, else `false`.
           * @example
           *
           * _.isObject({});
           * // => true
           *
           * _.isObject([1, 2, 3]);
           * // => true
           *
           * _.isObject(_.noop);
           * // => true
           *
           * _.isObject(null);
           * // => false
           */ function isObject(value) {
            var type = _typeof2(value);
            return value != null && (type == "object" || type == "function");
          }
          /**
           * Checks if `value` is object-like. A value is object-like if it's not `null`
           * and has a `typeof` result of "object".
           *
           * @static
           * @memberOf _
           * @since 4.0.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
           * @example
           *
           * _.isObjectLike({});
           * // => true
           *
           * _.isObjectLike([1, 2, 3]);
           * // => true
           *
           * _.isObjectLike(_.noop);
           * // => false
           *
           * _.isObjectLike(null);
           * // => false
           */ function isObjectLike(value) {
            return value != null && _typeof2(value) == "object";
          }
          /**
           * Checks if `value` is classified as a typed array.
           *
           * @static
           * @memberOf _
           * @since 3.0.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
           * @example
           *
           * _.isTypedArray(new Uint8Array);
           * // => true
           *
           * _.isTypedArray([]);
           * // => false
           */ var isTypedArray = nodeIsTypedArray
            ? baseUnary(nodeIsTypedArray)
            : baseIsTypedArray;
          /**
           * Creates an array of the own enumerable property names of `object`.
           *
           * **Note:** Non-object values are coerced to objects. See the
           * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
           * for more details.
           *
           * @static
           * @since 0.1.0
           * @memberOf _
           * @category Object
           * @param {Object} object The object to query.
           * @returns {Array} Returns the array of property names.
           * @example
           *
           * function Foo() {
           *   this.a = 1;
           *   this.b = 2;
           * }
           *
           * Foo.prototype.c = 3;
           *
           * _.keys(new Foo);
           * // => ['a', 'b'] (iteration order is not guaranteed)
           *
           * _.keys('hi');
           * // => ['0', '1']
           */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
          }
          /**
           * This method returns a new empty array.
           *
           * @static
           * @memberOf _
           * @since 4.13.0
           * @category Util
           * @returns {Array} Returns the new empty array.
           * @example
           *
           * var arrays = _.times(2, _.stubArray);
           *
           * console.log(arrays);
           * // => [[], []]
           *
           * console.log(arrays[0] === arrays[1]);
           * // => false
           */ function stubArray() {
            return [];
          }
          /**
           * This method returns `false`.
           *
           * @static
           * @memberOf _
           * @since 4.13.0
           * @category Util
           * @returns {boolean} Returns `false`.
           * @example
           *
           * _.times(2, _.stubFalse);
           * // => [false, false]
           */ function stubFalse() {
            return false;
          }
          module.exports = isEqual;
        },
        {}
      ]
    },
    {},
    ["ef408730b35eee5b4412d2e31169913a"],
    null
  );

/* FileSaver.js
 *  A saveAs() & saveTextAs() FileSaver implementation.
 *  2014-06-24
 *
 *  Modify by Brian Chen
 *  Author: Eli Grey, http://eligrey.com
 *  License: X11/MIT
 *    See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs
  // IE 10+ (native saveAs)
  || (typeof navigator !== "undefined" &&
      navigator.msSaveOrOpenBlob && navigator.msSaveOrOpenBlob.bind(navigator))
  // Everyone else
  || (function (view) {
      "use strict";
      // IE <10 is explicitly unsupported
      if (typeof navigator !== "undefined" &&
          /MSIE [1-9]\./.test(navigator.userAgent)) {
          return;
      }
      var
            doc = view.document
            // only get URL when necessary in case Blob.js hasn't overridden it yet
          , get_URL = function () {
              return view.URL || view.webkitURL || view;
          }
          , save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
          , can_use_save_link = !view.externalHost && "download" in save_link
          , click = function (node) {
              var event = doc.createEvent("MouseEvents");
              event.initMouseEvent(
                  "click", true, false, view, 0, 0, 0, 0, 0
                  , false, false, false, false, 0, null
              );
              node.dispatchEvent(event);
          }
          , webkit_req_fs = view.webkitRequestFileSystem
          , req_fs = view.requestFileSystem || webkit_req_fs || view.mozRequestFileSystem
          , throw_outside = function (ex) {
              (view.setImmediate || view.setTimeout)(function () {
                  throw ex;
              }, 0);
          }
          , force_saveable_type = "application/octet-stream"
          , fs_min_size = 0
          , deletion_queue = []
          , process_deletion_queue = function () {
              var i = deletion_queue.length;
              while (i--) {
                  var file = deletion_queue[i];
                  if (typeof file === "string") { // file is an object URL
                      get_URL().revokeObjectURL(file);
                  } else { // file is a File
                      file.remove();
                  }
              }
              deletion_queue.length = 0; // clear queue
          }
          , dispatch = function (filesaver, event_types, event) {
              event_types = [].concat(event_types);
              var i = event_types.length;
              while (i--) {
                  var listener = filesaver["on" + event_types[i]];
                  if (typeof listener === "function") {
                      try {
                          listener.call(filesaver, event || filesaver);
                      } catch (ex) {
                          throw_outside(ex);
                      }
                  }
              }
          }
          , FileSaver = function (blob, name) {
              // First try a.download, then web filesystem, then object URLs
              var
                    filesaver = this
                  , type = blob.type
                  , blob_changed = false
                  , object_url
                  , target_view
                  , get_object_url = function () {
                      var object_url = get_URL().createObjectURL(blob);
                      deletion_queue.push(object_url);
                      return object_url;
                  }
                  , dispatch_all = function () {
                      dispatch(filesaver, "writestart progress write writeend".split(" "));
                  }
                  // on any filesys errors revert to saving with object URLs
                  , fs_error = function () {
                      // don't create more object URLs than needed
                      if (blob_changed || !object_url) {
                          object_url = get_object_url(blob);
                      }
                      if (target_view) {
                          target_view.location.href = object_url;
                      } else {
                          window.open(object_url, "_blank");
                      }
                      filesaver.readyState = filesaver.DONE;
                      dispatch_all();
                  }
                  , abortable = function (func) {
                      return function () {
                          if (filesaver.readyState !== filesaver.DONE) {
                              return func.apply(this, arguments);
                          }
                      };
                  }
                  , create_if_not_found = { create: true, exclusive: false }
                  , slice
              ;
              filesaver.readyState = filesaver.INIT;
              if (!name) {
                  name = "download";
              }
              if (can_use_save_link) {
                  object_url = get_object_url(blob);
                  save_link.href = object_url;
                  save_link.download = name;
                  click(save_link);
                  filesaver.readyState = filesaver.DONE;
                  dispatch_all();
                  return;
              }
              // Object and web filesystem URLs have a problem saving in Google Chrome when
              // viewed in a tab, so I force save with application/octet-stream
              // http://code.google.com/p/chromium/issues/detail?id=91158
              if (view.chrome && type && type !== force_saveable_type) {
                  slice = blob.slice || blob.webkitSlice;
                  blob = slice.call(blob, 0, blob.size, force_saveable_type);
                  blob_changed = true;
              }
              // Since I can't be sure that the guessed media type will trigger a download
              // in WebKit, I append .download to the filename.
              // https://bugs.webkit.org/show_bug.cgi?id=65440
              if (webkit_req_fs && name !== "download") {
                  name += ".download";
              }
              if (type === force_saveable_type || webkit_req_fs) {
                  target_view = view;
              }
              if (!req_fs) {
                  fs_error();
                  return;
              }
              fs_min_size += blob.size;
              req_fs(view.TEMPORARY, fs_min_size, abortable(function (fs) {
                  fs.root.getDirectory("saved", create_if_not_found, abortable(function (dir) {
                      var save = function () {
                          dir.getFile(name, create_if_not_found, abortable(function (file) {
                              file.createWriter(abortable(function (writer) {
                                  writer.onwriteend = function (event) {
                                      target_view.location.href = file.toURL();
                                      deletion_queue.push(file);
                                      filesaver.readyState = filesaver.DONE;
                                      dispatch(filesaver, "writeend", event);
                                  };
                                  writer.onerror = function () {
                                      var error = writer.error;
                                      if (error.code !== error.ABORT_ERR) {
                                          fs_error();
                                      }
                                  };
                                  "writestart progress write abort".split(" ").forEach(function (event) {
                                      writer["on" + event] = filesaver["on" + event];
                                  });
                                  writer.write(blob);
                                  filesaver.abort = function () {
                                      writer.abort();
                                      filesaver.readyState = filesaver.DONE;
                                  };
                                  filesaver.readyState = filesaver.WRITING;
                              }), fs_error);
                          }), fs_error);
                      };
                      dir.getFile(name, { create: false }, abortable(function (file) {
                          // delete file if it already exists
                          file.remove();
                          save();
                      }), abortable(function (ex) {
                          if (ex.code === ex.NOT_FOUND_ERR) {
                              save();
                          } else {
                              fs_error();
                          }
                      }));
                  }), fs_error);
              }), fs_error);
          }
          , FS_proto = FileSaver.prototype
          , saveAs = function (blob, name) {
              return new FileSaver(blob, name);
          }
      ;
      FS_proto.abort = function () {
          var filesaver = this;
          filesaver.readyState = filesaver.DONE;
          dispatch(filesaver, "abort");
      };
      FS_proto.readyState = FS_proto.INIT = 0;
      FS_proto.WRITING = 1;
      FS_proto.DONE = 2;

      FS_proto.error =
      FS_proto.onwritestart =
      FS_proto.onprogress =
      FS_proto.onwrite =
      FS_proto.onabort =
      FS_proto.onerror =
      FS_proto.onwriteend =
          null;

      view.addEventListener("unload", process_deletion_queue, false);
      saveAs.unload = function () {
          process_deletion_queue();
          view.removeEventListener("unload", process_deletion_queue, false);
      };
      return saveAs;
  }(
	   typeof self !== "undefined" && self
	|| typeof window !== "undefined" && window
	|| this.content
));
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

String.prototype.endsWithAny = function () {
    var strArray = Array.prototype.slice.call(arguments),
        $this = this.toLowerCase().toString();
    for (var i = 0; i < strArray.length; i++) {
        if ($this.indexOf(strArray[i], $this.length - strArray[i].length) !== -1) return true;
    }
    return false;
};

var saveTextAs = saveTextAs
|| (function (textContent, fileName, charset) {
    fileName = fileName || 'download.txt';
    charset = charset || 'utf-8';
    textContent = (textContent || '').replace(/\r?\n/g, "\r\n");
    if (saveAs && Blob) {
        var blob = new Blob([textContent], { type: "text/plain;charset=" + charset });
        saveAs(blob, fileName);
        return true;
    } else {//IE9-
        var saveTxtWindow = window.frames.saveTxtWindow;
        if (!saveTxtWindow) {
            saveTxtWindow = document.createElement('iframe');
            saveTxtWindow.id = 'saveTxtWindow';
            saveTxtWindow.style.display = 'none';
            document.body.insertBefore(saveTxtWindow, null);
            saveTxtWindow = window.frames.saveTxtWindow;
            if (!saveTxtWindow) {
                saveTxtWindow = window.open('', '_temp', 'width=100,height=100');
                if (!saveTxtWindow) {
                    window.alert('Sorry, download file could not be created.');
                    return false;
                }
            }
        }

        var doc = saveTxtWindow.document;
        doc.open('text/html', 'replace');
        doc.charset = charset;
        if (fileName.endsWithAny('.htm', '.html')) {
            doc.close();
            doc.body.innerHTML = '\r\n' + textContent + '\r\n';
        } else {
            if (!fileName.endsWithAny('.txt')) fileName += '.txt';
            doc.write(textContent);
            doc.close();
        }

        var retValue = doc.execCommand('SaveAs', null, fileName);
        saveTxtWindow.close();
        return retValue;
    }
})

if (typeof module !== "undefined" && module !== null) {
    module.exports = saveTextAs;
} else if ((typeof define !== "undefined" && define !== null) && (define.amd != null)) {
    define([], function () {
        return saveTextAs;
    });
}
require=(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
    'use strict';
    var __importStar = (this && this.__importStar) || function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result["default"] = mod;
        return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    var utils = __importStar(require("../utils"));
    var CodecOutputLength = 29;
    var IsTest = function (destination) {
        if (typeof destination === 'string' && destination.match(/^T/)) {
            return true;
        }
        if (typeof destination === 'object' && destination.test === true) {
            return true;
        }
        return false;
    };
    exports.IsTest = IsTest;
    var CodecOptions = function (destination) {
        var char = IsTest(destination)
            ? 'T'
            : 'X';
        return {
            version: utils.findPrefix(char, CodecOutputLength),
            expectedLength: CodecOutputLength
        };
    };
    exports.CodecOptions = CodecOptions;

    },{"../utils":4}],2:[function(require,module,exports){
    "use strict";
    var __importDefault = (this && this.__importDefault) || function (mod) {
        return (mod && mod.__esModule) ? mod : { "default": mod };
    };
    var __importStar = (this && this.__importStar) || function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result["default"] = mod;
        return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    var ripple_address_codec_1 = __importDefault(require("ripple-address-codec"));
    var utils = __importStar(require("../utils"));
    var computed = __importStar(require("../computed"));
    function Decode(encodedDestination) {
        var codecOptions = computed.CodecOptions(encodedDestination);
        var decoded = ripple_address_codec_1.default.codecs.ripple.decode(encodedDestination, codecOptions);
        var hex = utils.toHex(decoded);
        var accountHex = hex.slice(0, 40);
        var tagTypeHex = hex.slice(40, 42);
        var tagHex = hex.slice(42, 58);
        return {
            account: ripple_address_codec_1.default.encodeAddress(utils.toBytes(accountHex)),
            tag: tagTypeHex === '01'
                ? String(utils.uInt32LE_ToUInt32(tagHex))
                : null,
            test: computed.IsTest(encodedDestination)
        };
    }
    exports.default = Decode;

    },{"../computed":1,"../utils":4,"ripple-address-codec":29}],3:[function(require,module,exports){
    "use strict";
    var __importDefault = (this && this.__importDefault) || function (mod) {
        return (mod && mod.__esModule) ? mod : { "default": mod };
    };
    var __importStar = (this && this.__importStar) || function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result["default"] = mod;
        return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    var assert_1 = __importDefault(require("assert"));
    var ripple_address_codec_1 = __importDefault(require("ripple-address-codec"));
    var utils = __importStar(require("../utils"));
    var computed = __importStar(require("../computed"));
    function Encode(destination) {
        assert_1.default.equal(typeof destination, 'object', 'Input should contain object');
        assert_1.default.notEqual(destination, null, 'Input should contain object');
        assert_1.default.strictEqual(Object.keys(destination).indexOf('account') > -1, true, 'Input should contain `account`');
        var account = destination.account;
        var tag = destination.tag === null || destination.tag === undefined
            ? null
            : Number(destination.tag);
        var accountHex = utils.toHex(ripple_address_codec_1.default.decodeAddress(account));
        var tagTypeHex = tag === null
            ? '00'
            : '01';
        var tagHex = utils.uInt32_ToUInt32LE(tag || 0);
        var bytes = utils.toBytes(accountHex + tagTypeHex + tagHex);
        return ripple_address_codec_1.default.codecs.ripple.encode(bytes, computed.CodecOptions(destination));
    }
    exports.default = Encode;

    },{"../computed":1,"../utils":4,"assert":5,"ripple-address-codec":29}],4:[function(require,module,exports){
    (function (Buffer){
    'use strict';
    var __importDefault = (this && this.__importDefault) || function (mod) {
        return (mod && mod.__esModule) ? mod : { "default": mod };
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    var ripple_address_codec_1 = __importDefault(require("ripple-address-codec"));
    function toHex(bytes) {
        return Buffer.from(bytes).toString('hex').toUpperCase();
    }
    exports.toHex = toHex;
    function toBytes(hex) {
        return new Uint32Array(Buffer.from(hex, 'hex').toJSON().data);
    }
    exports.toBytes = toBytes;
    function uInt32_ToUInt32LE(integer) {
        var buf = Buffer.alloc(8);
        buf.writeUInt32LE(integer, 0);
        return buf.toString('hex').toUpperCase();
    }
    exports.uInt32_ToUInt32LE = uInt32_ToUInt32LE;
    function uInt32LE_ToUInt32(hex) {
        return Buffer.from(hex, 'hex').readUInt32LE(0);
    }
    exports.uInt32LE_ToUInt32 = uInt32LE_ToUInt32;
    function findPrefix(desiredPrefix, payloadLength) {
        // Thanks @sublimator
        var rippleCodec = ripple_address_codec_1.default.codecs.ripple;
        if (rippleCodec.base !== 58) {
            throw new Error('Only works for base58');
        }
        var factor = Math.log(256) / Math.log(rippleCodec.base);
        var totalLength = payloadLength + 4; // for checksum
        var chars = totalLength * factor;
        var requiredChars = Math.ceil(chars + 0.2);
        var alphabetPosition = Math.floor((rippleCodec.alphabet.length) / 2) - 1;
        var padding = rippleCodec.alphabet[alphabetPosition];
        var rcPad = new Array(requiredChars + 1).join(padding);
        var template = desiredPrefix + rcPad;
        var bytes = rippleCodec.decodeRaw(template);
        var version = bytes.slice(0, -totalLength);
        return version;
    }
    exports.findPrefix = findPrefix;

    }).call(this,require("buffer").Buffer)
    },{"buffer":11,"ripple-address-codec":29}],5:[function(require,module,exports){
    (function (global){
    'use strict';

    var objectAssign = require('object-assign');

    // compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
    // original notice:

    /*!
     * The buffer module from node.js, for the browser.
     *
     * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
     * @license  MIT
     */
    function compare(a, b) {
      if (a === b) {
        return 0;
      }

      var x = a.length;
      var y = b.length;

      for (var i = 0, len = Math.min(x, y); i < len; ++i) {
        if (a[i] !== b[i]) {
          x = a[i];
          y = b[i];
          break;
        }
      }

      if (x < y) {
        return -1;
      }
      if (y < x) {
        return 1;
      }
      return 0;
    }
    function isBuffer(b) {
      if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
        return global.Buffer.isBuffer(b);
      }
      return !!(b != null && b._isBuffer);
    }

    // based on node assert, original notice:
    // NB: The URL to the CommonJS spec is kept just for tradition.
    //     node-assert has evolved a lot since then, both in API and behavior.

    // http://wiki.commonjs.org/wiki/Unit_Testing/1.0
    //
    // THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
    //
    // Originally from narwhal.js (http://narwhaljs.org)
    // Copyright (c) 2009 Thomas Robinson <280north.com>
    //
    // Permission is hereby granted, free of charge, to any person obtaining a copy
    // of this software and associated documentation files (the 'Software'), to
    // deal in the Software without restriction, including without limitation the
    // rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
    // sell copies of the Software, and to permit persons to whom the Software is
    // furnished to do so, subject to the following conditions:
    //
    // The above copyright notice and this permission notice shall be included in
    // all copies or substantial portions of the Software.
    //
    // THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    // AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
    // ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
    // WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

    var util = require('util/');
    var hasOwn = Object.prototype.hasOwnProperty;
    var pSlice = Array.prototype.slice;
    var functionsHaveNames = (function () {
      return function foo() {}.name === 'foo';
    }());
    function pToString (obj) {
      return Object.prototype.toString.call(obj);
    }
    function isView(arrbuf) {
      if (isBuffer(arrbuf)) {
        return false;
      }
      if (typeof global.ArrayBuffer !== 'function') {
        return false;
      }
      if (typeof ArrayBuffer.isView === 'function') {
        return ArrayBuffer.isView(arrbuf);
      }
      if (!arrbuf) {
        return false;
      }
      if (arrbuf instanceof DataView) {
        return true;
      }
      if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
        return true;
      }
      return false;
    }
    // 1. The assert module provides functions that throw
    // AssertionError's when particular conditions are not met. The
    // assert module must conform to the following interface.

    var assert = module.exports = ok;

    // 2. The AssertionError is defined in assert.
    // new assert.AssertionError({ message: message,
    //                             actual: actual,
    //                             expected: expected })

    var regex = /\s*function\s+([^\(\s]*)\s*/;
    // based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
    function getName(func) {
      if (!util.isFunction(func)) {
        return;
      }
      if (functionsHaveNames) {
        return func.name;
      }
      var str = func.toString();
      var match = str.match(regex);
      return match && match[1];
    }
    assert.AssertionError = function AssertionError(options) {
      this.name = 'AssertionError';
      this.actual = options.actual;
      this.expected = options.expected;
      this.operator = options.operator;
      if (options.message) {
        this.message = options.message;
        this.generatedMessage = false;
      } else {
        this.message = getMessage(this);
        this.generatedMessage = true;
      }
      var stackStartFunction = options.stackStartFunction || fail;
      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, stackStartFunction);
      } else {
        // non v8 browsers so we can have a stacktrace
        var err = new Error();
        if (err.stack) {
          var out = err.stack;

          // try to strip useless frames
          var fn_name = getName(stackStartFunction);
          var idx = out.indexOf('\n' + fn_name);
          if (idx >= 0) {
            // once we have located the function frame
            // we need to strip out everything before it (and its line)
            var next_line = out.indexOf('\n', idx + 1);
            out = out.substring(next_line + 1);
          }

          this.stack = out;
        }
      }
    };

    // assert.AssertionError instanceof Error
    util.inherits(assert.AssertionError, Error);

    function truncate(s, n) {
      if (typeof s === 'string') {
        return s.length < n ? s : s.slice(0, n);
      } else {
        return s;
      }
    }
    function inspect(something) {
      if (functionsHaveNames || !util.isFunction(something)) {
        return util.inspect(something);
      }
      var rawname = getName(something);
      var name = rawname ? ': ' + rawname : '';
      return '[Function' +  name + ']';
    }
    function getMessage(self) {
      return truncate(inspect(self.actual), 128) + ' ' +
             self.operator + ' ' +
             truncate(inspect(self.expected), 128);
    }

    // At present only the three keys mentioned above are used and
    // understood by the spec. Implementations or sub modules can pass
    // other keys to the AssertionError's constructor - they will be
    // ignored.

    // 3. All of the following functions must throw an AssertionError
    // when a corresponding condition is not met, with a message that
    // may be undefined if not provided.  All assertion methods provide
    // both the actual and expected values to the assertion error for
    // display purposes.

    function fail(actual, expected, message, operator, stackStartFunction) {
      throw new assert.AssertionError({
        message: message,
        actual: actual,
        expected: expected,
        operator: operator,
        stackStartFunction: stackStartFunction
      });
    }

    // EXTENSION! allows for well behaved errors defined elsewhere.
    assert.fail = fail;

    // 4. Pure assertion tests whether a value is truthy, as determined
    // by !!guard.
    // assert.ok(guard, message_opt);
    // This statement is equivalent to assert.equal(true, !!guard,
    // message_opt);. To test strictly for the value true, use
    // assert.strictEqual(true, guard, message_opt);.

    function ok(value, message) {
      if (!value) fail(value, true, message, '==', assert.ok);
    }
    assert.ok = ok;

    // 5. The equality assertion tests shallow, coercive equality with
    // ==.
    // assert.equal(actual, expected, message_opt);

    assert.equal = function equal(actual, expected, message) {
      if (actual != expected) fail(actual, expected, message, '==', assert.equal);
    };

    // 6. The non-equality assertion tests for whether two objects are not equal
    // with != assert.notEqual(actual, expected, message_opt);

    assert.notEqual = function notEqual(actual, expected, message) {
      if (actual == expected) {
        fail(actual, expected, message, '!=', assert.notEqual);
      }
    };

    // 7. The equivalence assertion tests a deep equality relation.
    // assert.deepEqual(actual, expected, message_opt);

    assert.deepEqual = function deepEqual(actual, expected, message) {
      if (!_deepEqual(actual, expected, false)) {
        fail(actual, expected, message, 'deepEqual', assert.deepEqual);
      }
    };

    assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
      if (!_deepEqual(actual, expected, true)) {
        fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
      }
    };

    function _deepEqual(actual, expected, strict, memos) {
      // 7.1. All identical values are equivalent, as determined by ===.
      if (actual === expected) {
        return true;
      } else if (isBuffer(actual) && isBuffer(expected)) {
        return compare(actual, expected) === 0;

      // 7.2. If the expected value is a Date object, the actual value is
      // equivalent if it is also a Date object that refers to the same time.
      } else if (util.isDate(actual) && util.isDate(expected)) {
        return actual.getTime() === expected.getTime();

      // 7.3 If the expected value is a RegExp object, the actual value is
      // equivalent if it is also a RegExp object with the same source and
      // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
      } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
        return actual.source === expected.source &&
               actual.global === expected.global &&
               actual.multiline === expected.multiline &&
               actual.lastIndex === expected.lastIndex &&
               actual.ignoreCase === expected.ignoreCase;

      // 7.4. Other pairs that do not both pass typeof value == 'object',
      // equivalence is determined by ==.
      } else if ((actual === null || typeof actual !== 'object') &&
                 (expected === null || typeof expected !== 'object')) {
        return strict ? actual === expected : actual == expected;

      // If both values are instances of typed arrays, wrap their underlying
      // ArrayBuffers in a Buffer each to increase performance
      // This optimization requires the arrays to have the same type as checked by
      // Object.prototype.toString (aka pToString). Never perform binary
      // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
      // bit patterns are not identical.
      } else if (isView(actual) && isView(expected) &&
                 pToString(actual) === pToString(expected) &&
                 !(actual instanceof Float32Array ||
                   actual instanceof Float64Array)) {
        return compare(new Uint8Array(actual.buffer),
                       new Uint8Array(expected.buffer)) === 0;

      // 7.5 For all other Object pairs, including Array objects, equivalence is
      // determined by having the same number of owned properties (as verified
      // with Object.prototype.hasOwnProperty.call), the same set of keys
      // (although not necessarily the same order), equivalent values for every
      // corresponding key, and an identical 'prototype' property. Note: this
      // accounts for both named and indexed properties on Arrays.
      } else if (isBuffer(actual) !== isBuffer(expected)) {
        return false;
      } else {
        memos = memos || {actual: [], expected: []};

        var actualIndex = memos.actual.indexOf(actual);
        if (actualIndex !== -1) {
          if (actualIndex === memos.expected.indexOf(expected)) {
            return true;
          }
        }

        memos.actual.push(actual);
        memos.expected.push(expected);

        return objEquiv(actual, expected, strict, memos);
      }
    }

    function isArguments(object) {
      return Object.prototype.toString.call(object) == '[object Arguments]';
    }

    function objEquiv(a, b, strict, actualVisitedObjects) {
      if (a === null || a === undefined || b === null || b === undefined)
        return false;
      // if one is a primitive, the other must be same
      if (util.isPrimitive(a) || util.isPrimitive(b))
        return a === b;
      if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
        return false;
      var aIsArgs = isArguments(a);
      var bIsArgs = isArguments(b);
      if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
        return false;
      if (aIsArgs) {
        a = pSlice.call(a);
        b = pSlice.call(b);
        return _deepEqual(a, b, strict);
      }
      var ka = objectKeys(a);
      var kb = objectKeys(b);
      var key, i;
      // having the same number of owned properties (keys incorporates
      // hasOwnProperty)
      if (ka.length !== kb.length)
        return false;
      //the same set of keys (although not necessarily the same order),
      ka.sort();
      kb.sort();
      //~~~cheap key test
      for (i = ka.length - 1; i >= 0; i--) {
        if (ka[i] !== kb[i])
          return false;
      }
      //equivalent values for every corresponding key, and
      //~~~possibly expensive deep test
      for (i = ka.length - 1; i >= 0; i--) {
        key = ka[i];
        if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
          return false;
      }
      return true;
    }

    // 8. The non-equivalence assertion tests for any deep inequality.
    // assert.notDeepEqual(actual, expected, message_opt);

    assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
      if (_deepEqual(actual, expected, false)) {
        fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
      }
    };

    assert.notDeepStrictEqual = notDeepStrictEqual;
    function notDeepStrictEqual(actual, expected, message) {
      if (_deepEqual(actual, expected, true)) {
        fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
      }
    }


    // 9. The strict equality assertion tests strict equality, as determined by ===.
    // assert.strictEqual(actual, expected, message_opt);

    assert.strictEqual = function strictEqual(actual, expected, message) {
      if (actual !== expected) {
        fail(actual, expected, message, '===', assert.strictEqual);
      }
    };

    // 10. The strict non-equality assertion tests for strict inequality, as
    // determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

    assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
      if (actual === expected) {
        fail(actual, expected, message, '!==', assert.notStrictEqual);
      }
    };

    function expectedException(actual, expected) {
      if (!actual || !expected) {
        return false;
      }

      if (Object.prototype.toString.call(expected) == '[object RegExp]') {
        return expected.test(actual);
      }

      try {
        if (actual instanceof expected) {
          return true;
        }
      } catch (e) {
        // Ignore.  The instanceof check doesn't work for arrow functions.
      }

      if (Error.isPrototypeOf(expected)) {
        return false;
      }

      return expected.call({}, actual) === true;
    }

    function _tryBlock(block) {
      var error;
      try {
        block();
      } catch (e) {
        error = e;
      }
      return error;
    }

    function _throws(shouldThrow, block, expected, message) {
      var actual;

      if (typeof block !== 'function') {
        throw new TypeError('"block" argument must be a function');
      }

      if (typeof expected === 'string') {
        message = expected;
        expected = null;
      }

      actual = _tryBlock(block);

      message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
                (message ? ' ' + message : '.');

      if (shouldThrow && !actual) {
        fail(actual, expected, 'Missing expected exception' + message);
      }

      var userProvidedMessage = typeof message === 'string';
      var isUnwantedException = !shouldThrow && util.isError(actual);
      var isUnexpectedException = !shouldThrow && actual && !expected;

      if ((isUnwantedException &&
          userProvidedMessage &&
          expectedException(actual, expected)) ||
          isUnexpectedException) {
        fail(actual, expected, 'Got unwanted exception' + message);
      }

      if ((shouldThrow && actual && expected &&
          !expectedException(actual, expected)) || (!shouldThrow && actual)) {
        throw actual;
      }
    }

    // 11. Expected to throw an error:
    // assert.throws(block, Error_opt, message_opt);

    assert.throws = function(block, /*optional*/error, /*optional*/message) {
      _throws(true, block, error, message);
    };

    // EXTENSION! This is annoying to write outside this module.
    assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
      _throws(false, block, error, message);
    };

    assert.ifError = function(err) { if (err) throw err; };

    // Expose a strict only variant of assert
    function strict(value, message) {
      if (!value) fail(value, true, message, '==', strict);
    }
    assert.strict = objectAssign(strict, assert, {
      equal: assert.strictEqual,
      deepEqual: assert.deepStrictEqual,
      notEqual: assert.notStrictEqual,
      notDeepEqual: assert.notDeepStrictEqual
    });
    assert.strict.strict = assert.strict;

    var objectKeys = Object.keys || function (obj) {
      var keys = [];
      for (var key in obj) {
        if (hasOwn.call(obj, key)) keys.push(key);
      }
      return keys;
    };

    }).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
    },{"object-assign":27,"util/":8}],6:[function(require,module,exports){
    if (typeof Object.create === 'function') {
      // implementation from standard node.js 'util' module
      module.exports = function inherits(ctor, superCtor) {
        ctor.super_ = superCtor
        ctor.prototype = Object.create(superCtor.prototype, {
          constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
      };
    } else {
      // old school shim for old browsers
      module.exports = function inherits(ctor, superCtor) {
        ctor.super_ = superCtor
        var TempCtor = function () {}
        TempCtor.prototype = superCtor.prototype
        ctor.prototype = new TempCtor()
        ctor.prototype.constructor = ctor
      }
    }

    },{}],7:[function(require,module,exports){
    module.exports = function isBuffer(arg) {
      return arg && typeof arg === 'object'
        && typeof arg.copy === 'function'
        && typeof arg.fill === 'function'
        && typeof arg.readUInt8 === 'function';
    }
    },{}],8:[function(require,module,exports){
    (function (process,global){
    // Copyright Joyent, Inc. and other Node contributors.
    //
    // Permission is hereby granted, free of charge, to any person obtaining a
    // copy of this software and associated documentation files (the
    // "Software"), to deal in the Software without restriction, including
    // without limitation the rights to use, copy, modify, merge, publish,
    // distribute, sublicense, and/or sell copies of the Software, and to permit
    // persons to whom the Software is furnished to do so, subject to the
    // following conditions:
    //
    // The above copyright notice and this permission notice shall be included
    // in all copies or substantial portions of the Software.
    //
    // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
    // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
    // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
    // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
    // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
    // USE OR OTHER DEALINGS IN THE SOFTWARE.

    var formatRegExp = /%[sdj%]/g;
    exports.format = function(f) {
      if (!isString(f)) {
        var objects = [];
        for (var i = 0; i < arguments.length; i++) {
          objects.push(inspect(arguments[i]));
        }
        return objects.join(' ');
      }

      var i = 1;
      var args = arguments;
      var len = args.length;
      var str = String(f).replace(formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch (x) {
          case '%s': return String(args[i++]);
          case '%d': return Number(args[i++]);
          case '%j':
            try {
              return JSON.stringify(args[i++]);
            } catch (_) {
              return '[Circular]';
            }
          default:
            return x;
        }
      });
      for (var x = args[i]; i < len; x = args[++i]) {
        if (isNull(x) || !isObject(x)) {
          str += ' ' + x;
        } else {
          str += ' ' + inspect(x);
        }
      }
      return str;
    };


    // Mark that a method should not be used.
    // Returns a modified function which warns once by default.
    // If --no-deprecation is set, then it is a no-op.
    exports.deprecate = function(fn, msg) {
      // Allow for deprecating things in the process of starting up.
      if (isUndefined(global.process)) {
        return function() {
          return exports.deprecate(fn, msg).apply(this, arguments);
        };
      }

      if (process.noDeprecation === true) {
        return fn;
      }

      var warned = false;
      function deprecated() {
        if (!warned) {
          if (process.throwDeprecation) {
            throw new Error(msg);
          } else if (process.traceDeprecation) {
            console.trace(msg);
          } else {
            console.error(msg);
          }
          warned = true;
        }
        return fn.apply(this, arguments);
      }

      return deprecated;
    };


    var debugs = {};
    var debugEnviron;
    exports.debuglog = function(set) {
      if (isUndefined(debugEnviron))
        debugEnviron = process.env.NODE_DEBUG || '';
      set = set.toUpperCase();
      if (!debugs[set]) {
        if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
          var pid = process.pid;
          debugs[set] = function() {
            var msg = exports.format.apply(exports, arguments);
            console.error('%s %d: %s', set, pid, msg);
          };
        } else {
          debugs[set] = function() {};
        }
      }
      return debugs[set];
    };


    /**
     * Echos the value of a value. Trys to print the value out
     * in the best way possible given the different types.
     *
     * @param {Object} obj The object to print out.
     * @param {Object} opts Optional options object that alters the output.
     */
    /* legacy: obj, showHidden, depth, colors*/
    function inspect(obj, opts) {
      // default options
      var ctx = {
        seen: [],
        stylize: stylizeNoColor
      };
      // legacy...
      if (arguments.length >= 3) ctx.depth = arguments[2];
      if (arguments.length >= 4) ctx.colors = arguments[3];
      if (isBoolean(opts)) {
        // legacy...
        ctx.showHidden = opts;
      } else if (opts) {
        // got an "options" object
        exports._extend(ctx, opts);
      }
      // set default options
      if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
      if (isUndefined(ctx.depth)) ctx.depth = 2;
      if (isUndefined(ctx.colors)) ctx.colors = false;
      if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
      if (ctx.colors) ctx.stylize = stylizeWithColor;
      return formatValue(ctx, obj, ctx.depth);
    }
    exports.inspect = inspect;


    // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
    inspect.colors = {
      'bold' : [1, 22],
      'italic' : [3, 23],
      'underline' : [4, 24],
      'inverse' : [7, 27],
      'white' : [37, 39],
      'grey' : [90, 39],
      'black' : [30, 39],
      'blue' : [34, 39],
      'cyan' : [36, 39],
      'green' : [32, 39],
      'magenta' : [35, 39],
      'red' : [31, 39],
      'yellow' : [33, 39]
    };

    // Don't use 'blue' not visible on cmd.exe
    inspect.styles = {
      'special': 'cyan',
      'number': 'yellow',
      'boolean': 'yellow',
      'undefined': 'grey',
      'null': 'bold',
      'string': 'green',
      'date': 'magenta',
      // "name": intentionally not styling
      'regexp': 'red'
    };


    function stylizeWithColor(str, styleType) {
      var style = inspect.styles[styleType];

      if (style) {
        return '\u001b[' + inspect.colors[style][0] + 'm' + str +
               '\u001b[' + inspect.colors[style][1] + 'm';
      } else {
        return str;
      }
    }


    function stylizeNoColor(str, styleType) {
      return str;
    }


    function arrayToHash(array) {
      var hash = {};

      array.forEach(function(val, idx) {
        hash[val] = true;
      });

      return hash;
    }


    function formatValue(ctx, value, recurseTimes) {
      // Provide a hook for user-specified inspect functions.
      // Check that value is an object with an inspect function on it
      if (ctx.customInspect &&
          value &&
          isFunction(value.inspect) &&
          // Filter out the util module, it's inspect function is special
          value.inspect !== exports.inspect &&
          // Also filter out any prototype objects using the circular check.
          !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!isString(ret)) {
          ret = formatValue(ctx, ret, recurseTimes);
        }
        return ret;
      }

      // Primitive types cannot have properties
      var primitive = formatPrimitive(ctx, value);
      if (primitive) {
        return primitive;
      }

      // Look up the keys of the object.
      var keys = Object.keys(value);
      var visibleKeys = arrayToHash(keys);

      if (ctx.showHidden) {
        keys = Object.getOwnPropertyNames(value);
      }

      // IE doesn't make error fields non-enumerable
      // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
      if (isError(value)
          && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
        return formatError(value);
      }

      // Some type of object without properties can be shortcutted.
      if (keys.length === 0) {
        if (isFunction(value)) {
          var name = value.name ? ': ' + value.name : '';
          return ctx.stylize('[Function' + name + ']', 'special');
        }
        if (isRegExp(value)) {
          return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        }
        if (isDate(value)) {
          return ctx.stylize(Date.prototype.toString.call(value), 'date');
        }
        if (isError(value)) {
          return formatError(value);
        }
      }

      var base = '', array = false, braces = ['{', '}'];

      // Make Array say that they are Array
      if (isArray(value)) {
        array = true;
        braces = ['[', ']'];
      }

      // Make functions say that they are functions
      if (isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
      }

      // Make RegExps say that they are RegExps
      if (isRegExp(value)) {
        base = ' ' + RegExp.prototype.toString.call(value);
      }

      // Make dates with properties first say the date
      if (isDate(value)) {
        base = ' ' + Date.prototype.toUTCString.call(value);
      }

      // Make error with message first say the error
      if (isError(value)) {
        base = ' ' + formatError(value);
      }

      if (keys.length === 0 && (!array || value.length == 0)) {
        return braces[0] + base + braces[1];
      }

      if (recurseTimes < 0) {
        if (isRegExp(value)) {
          return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        } else {
          return ctx.stylize('[Object]', 'special');
        }
      }

      ctx.seen.push(value);

      var output;
      if (array) {
        output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
      } else {
        output = keys.map(function(key) {
          return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
        });
      }

      ctx.seen.pop();

      return reduceToSingleString(output, base, braces);
    }


    function formatPrimitive(ctx, value) {
      if (isUndefined(value))
        return ctx.stylize('undefined', 'undefined');
      if (isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                                 .replace(/'/g, "\\'")
                                                 .replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
      }
      if (isNumber(value))
        return ctx.stylize('' + value, 'number');
      if (isBoolean(value))
        return ctx.stylize('' + value, 'boolean');
      // For some reason typeof null is "object", so special case here.
      if (isNull(value))
        return ctx.stylize('null', 'null');
    }


    function formatError(value) {
      return '[' + Error.prototype.toString.call(value) + ']';
    }


    function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
      var output = [];
      for (var i = 0, l = value.length; i < l; ++i) {
        if (hasOwnProperty(value, String(i))) {
          output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
              String(i), true));
        } else {
          output.push('');
        }
      }
      keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) {
          output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
              key, true));
        }
      });
      return output;
    }


    function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
      var name, str, desc;
      desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
      if (desc.get) {
        if (desc.set) {
          str = ctx.stylize('[Getter/Setter]', 'special');
        } else {
          str = ctx.stylize('[Getter]', 'special');
        }
      } else {
        if (desc.set) {
          str = ctx.stylize('[Setter]', 'special');
        }
      }
      if (!hasOwnProperty(visibleKeys, key)) {
        name = '[' + key + ']';
      }
      if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
          if (isNull(recurseTimes)) {
            str = formatValue(ctx, desc.value, null);
          } else {
            str = formatValue(ctx, desc.value, recurseTimes - 1);
          }
          if (str.indexOf('\n') > -1) {
            if (array) {
              str = str.split('\n').map(function(line) {
                return '  ' + line;
              }).join('\n').substr(2);
            } else {
              str = '\n' + str.split('\n').map(function(line) {
                return '   ' + line;
              }).join('\n');
            }
          }
        } else {
          str = ctx.stylize('[Circular]', 'special');
        }
      }
      if (isUndefined(name)) {
        if (array && key.match(/^\d+$/)) {
          return str;
        }
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
          name = name.substr(1, name.length - 2);
          name = ctx.stylize(name, 'name');
        } else {
          name = name.replace(/'/g, "\\'")
                     .replace(/\\"/g, '"')
                     .replace(/(^"|"$)/g, "'");
          name = ctx.stylize(name, 'string');
        }
      }

      return name + ': ' + str;
    }


    function reduceToSingleString(output, base, braces) {
      var numLinesEst = 0;
      var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
      }, 0);

      if (length > 60) {
        return braces[0] +
               (base === '' ? '' : base + '\n ') +
               ' ' +
               output.join(',\n  ') +
               ' ' +
               braces[1];
      }

      return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
    }


    // NOTE: These type checking functions intentionally don't use `instanceof`
    // because it is fragile and can be easily faked with `Object.create()`.
    function isArray(ar) {
      return Array.isArray(ar);
    }
    exports.isArray = isArray;

    function isBoolean(arg) {
      return typeof arg === 'boolean';
    }
    exports.isBoolean = isBoolean;

    function isNull(arg) {
      return arg === null;
    }
    exports.isNull = isNull;

    function isNullOrUndefined(arg) {
      return arg == null;
    }
    exports.isNullOrUndefined = isNullOrUndefined;

    function isNumber(arg) {
      return typeof arg === 'number';
    }
    exports.isNumber = isNumber;

    function isString(arg) {
      return typeof arg === 'string';
    }
    exports.isString = isString;

    function isSymbol(arg) {
      return typeof arg === 'symbol';
    }
    exports.isSymbol = isSymbol;

    function isUndefined(arg) {
      return arg === void 0;
    }
    exports.isUndefined = isUndefined;

    function isRegExp(re) {
      return isObject(re) && objectToString(re) === '[object RegExp]';
    }
    exports.isRegExp = isRegExp;

    function isObject(arg) {
      return typeof arg === 'object' && arg !== null;
    }
    exports.isObject = isObject;

    function isDate(d) {
      return isObject(d) && objectToString(d) === '[object Date]';
    }
    exports.isDate = isDate;

    function isError(e) {
      return isObject(e) &&
          (objectToString(e) === '[object Error]' || e instanceof Error);
    }
    exports.isError = isError;

    function isFunction(arg) {
      return typeof arg === 'function';
    }
    exports.isFunction = isFunction;

    function isPrimitive(arg) {
      return arg === null ||
             typeof arg === 'boolean' ||
             typeof arg === 'number' ||
             typeof arg === 'string' ||
             typeof arg === 'symbol' ||  // ES6 symbol
             typeof arg === 'undefined';
    }
    exports.isPrimitive = isPrimitive;

    exports.isBuffer = require('./support/isBuffer');

    function objectToString(o) {
      return Object.prototype.toString.call(o);
    }


    function pad(n) {
      return n < 10 ? '0' + n.toString(10) : n.toString(10);
    }


    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
                  'Oct', 'Nov', 'Dec'];

    // 26 Feb 16:19:34
    function timestamp() {
      var d = new Date();
      var time = [pad(d.getHours()),
                  pad(d.getMinutes()),
                  pad(d.getSeconds())].join(':');
      return [d.getDate(), months[d.getMonth()], time].join(' ');
    }


    // log is just a thin wrapper to console.log that prepends a timestamp
    exports.log = function() {
      console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
    };


    /**
     * Inherit the prototype methods from one constructor into another.
     *
     * The Function.prototype.inherits from lang.js rewritten as a standalone
     * function (not on Function.prototype). NOTE: If this file is to be loaded
     * during bootstrapping this function needs to be rewritten using some native
     * functions as prototype setup using normal JavaScript does not work as
     * expected during bootstrapping (see mirror.js in r114903).
     *
     * @param {function} ctor Constructor function which needs to inherit the
     *     prototype.
     * @param {function} superCtor Constructor function to inherit prototype from.
     */
    exports.inherits = require('inherits');

    exports._extend = function(origin, add) {
      // Don't do anything if add isn't an object
      if (!add || !isObject(add)) return origin;

      var keys = Object.keys(add);
      var i = keys.length;
      while (i--) {
        origin[keys[i]] = add[keys[i]];
      }
      return origin;
    };

    function hasOwnProperty(obj, prop) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    }

    }).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
    },{"./support/isBuffer":7,"_process":28,"inherits":6}],9:[function(require,module,exports){
    // base-x encoding
    // Forked from https://github.com/cryptocoinjs/bs58
    // Originally written by Mike Hearn for BitcoinJ
    // Copyright (c) 2011 Google Inc
    // Ported to JavaScript by Stefan Thomas
    // Merged Buffer refactorings from base58-native by Stephen Pair
    // Copyright (c) 2013 BitPay Inc

    module.exports = function base (ALPHABET) {
      var ALPHABET_MAP = {}
      var BASE = ALPHABET.length
      var LEADER = ALPHABET.charAt(0)

      // pre-compute lookup table
      for (var i = 0; i < ALPHABET.length; i++) {
        ALPHABET_MAP[ALPHABET.charAt(i)] = i
      }

      function encode (source) {
        if (source.length === 0) return ''

        var digits = [0]
        for (var i = 0; i < source.length; ++i) {
          for (var j = 0, carry = source[i]; j < digits.length; ++j) {
            carry += digits[j] << 8
            digits[j] = carry % BASE
            carry = (carry / BASE) | 0
          }

          while (carry > 0) {
            digits.push(carry % BASE)
            carry = (carry / BASE) | 0
          }
        }

        var string = ''

        // deal with leading zeros
        for (var k = 0; source[k] === 0 && k < source.length - 1; ++k) string += ALPHABET[0]
        // convert digits to a string
        for (var q = digits.length - 1; q >= 0; --q) string += ALPHABET[digits[q]]

        return string
      }

      function decodeUnsafe (string) {
        if (string.length === 0) return []

        var bytes = [0]
        for (var i = 0; i < string.length; i++) {
          var value = ALPHABET_MAP[string[i]]
          if (value === undefined) return

          for (var j = 0, carry = value; j < bytes.length; ++j) {
            carry += bytes[j] * BASE
            bytes[j] = carry & 0xff
            carry >>= 8
          }

          while (carry > 0) {
            bytes.push(carry & 0xff)
            carry >>= 8
          }
        }

        // deal with leading zeros
        for (var k = 0; string[k] === LEADER && k < string.length - 1; ++k) {
          bytes.push(0)
        }

        return bytes.reverse()
      }

      function decode (string) {
        var array = decodeUnsafe(string)
        if (array) return array

        throw new Error('Non-base' + BASE + ' character')
      }

      return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
      }
    }

    },{}],10:[function(require,module,exports){
    'use strict'

    exports.byteLength = byteLength
    exports.toByteArray = toByteArray
    exports.fromByteArray = fromByteArray

    var lookup = []
    var revLookup = []
    var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

    var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
    for (var i = 0, len = code.length; i < len; ++i) {
      lookup[i] = code[i]
      revLookup[code.charCodeAt(i)] = i
    }

    // Support decoding URL-safe base64 strings, as Node.js does.
    // See: https://en.wikipedia.org/wiki/Base64#URL_applications
    revLookup['-'.charCodeAt(0)] = 62
    revLookup['_'.charCodeAt(0)] = 63

    function getLens (b64) {
      var len = b64.length

      if (len % 4 > 0) {
        throw new Error('Invalid string. Length must be a multiple of 4')
      }

      // Trim off extra bytes after placeholder bytes are found
      // See: https://github.com/beatgammit/base64-js/issues/42
      var validLen = b64.indexOf('=')
      if (validLen === -1) validLen = len

      var placeHoldersLen = validLen === len
        ? 0
        : 4 - (validLen % 4)

      return [validLen, placeHoldersLen]
    }

    // base64 is 4/3 + up to two characters of the original data
    function byteLength (b64) {
      var lens = getLens(b64)
      var validLen = lens[0]
      var placeHoldersLen = lens[1]
      return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
    }

    function _byteLength (b64, validLen, placeHoldersLen) {
      return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
    }

    function toByteArray (b64) {
      var tmp
      var lens = getLens(b64)
      var validLen = lens[0]
      var placeHoldersLen = lens[1]

      var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

      var curByte = 0

      // if there are placeholders, only get up to the last complete 4 chars
      var len = placeHoldersLen > 0
        ? validLen - 4
        : validLen

      var i
      for (i = 0; i < len; i += 4) {
        tmp =
          (revLookup[b64.charCodeAt(i)] << 18) |
          (revLookup[b64.charCodeAt(i + 1)] << 12) |
          (revLookup[b64.charCodeAt(i + 2)] << 6) |
          revLookup[b64.charCodeAt(i + 3)]
        arr[curByte++] = (tmp >> 16) & 0xFF
        arr[curByte++] = (tmp >> 8) & 0xFF
        arr[curByte++] = tmp & 0xFF
      }

      if (placeHoldersLen === 2) {
        tmp =
          (revLookup[b64.charCodeAt(i)] << 2) |
          (revLookup[b64.charCodeAt(i + 1)] >> 4)
        arr[curByte++] = tmp & 0xFF
      }

      if (placeHoldersLen === 1) {
        tmp =
          (revLookup[b64.charCodeAt(i)] << 10) |
          (revLookup[b64.charCodeAt(i + 1)] << 4) |
          (revLookup[b64.charCodeAt(i + 2)] >> 2)
        arr[curByte++] = (tmp >> 8) & 0xFF
        arr[curByte++] = tmp & 0xFF
      }

      return arr
    }

    function tripletToBase64 (num) {
      return lookup[num >> 18 & 0x3F] +
        lookup[num >> 12 & 0x3F] +
        lookup[num >> 6 & 0x3F] +
        lookup[num & 0x3F]
    }

    function encodeChunk (uint8, start, end) {
      var tmp
      var output = []
      for (var i = start; i < end; i += 3) {
        tmp =
          ((uint8[i] << 16) & 0xFF0000) +
          ((uint8[i + 1] << 8) & 0xFF00) +
          (uint8[i + 2] & 0xFF)
        output.push(tripletToBase64(tmp))
      }
      return output.join('')
    }

    function fromByteArray (uint8) {
      var tmp
      var len = uint8.length
      var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
      var parts = []
      var maxChunkLength = 16383 // must be multiple of 3

      // go through the array every three bytes, we'll deal with trailing stuff later
      for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
        parts.push(encodeChunk(
          uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
        ))
      }

      // pad the end with zeros, but make sure to not forget the extra bytes
      if (extraBytes === 1) {
        tmp = uint8[len - 1]
        parts.push(
          lookup[tmp >> 2] +
          lookup[(tmp << 4) & 0x3F] +
          '=='
        )
      } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1]
        parts.push(
          lookup[tmp >> 10] +
          lookup[(tmp >> 4) & 0x3F] +
          lookup[(tmp << 2) & 0x3F] +
          '='
        )
      }

      return parts.join('')
    }

    },{}],11:[function(require,module,exports){
    (function (Buffer){
    /*!
     * The buffer module from node.js, for the browser.
     *
     * @author   Feross Aboukhadijeh <https://feross.org>
     * @license  MIT
     */
    /* eslint-disable no-proto */

    'use strict'

    var base64 = require('base64-js')
    var ieee754 = require('ieee754')
    var customInspectSymbol =
      (typeof Symbol === 'function' && typeof Symbol.for === 'function')
        ? Symbol.for('nodejs.util.inspect.custom')
        : null

    exports.Buffer = Buffer
    exports.SlowBuffer = SlowBuffer
    exports.INSPECT_MAX_BYTES = 50

    var K_MAX_LENGTH = 0x7fffffff
    exports.kMaxLength = K_MAX_LENGTH

    /**
     * If `Buffer.TYPED_ARRAY_SUPPORT`:
     *   === true    Use Uint8Array implementation (fastest)
     *   === false   Print warning and recommend using `buffer` v4.x which has an Object
     *               implementation (most compatible, even IE6)
     *
     * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
     * Opera 11.6+, iOS 4.2+.
     *
     * We report that the browser does not support typed arrays if the are not subclassable
     * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
     * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
     * for __proto__ and has a buggy typed array implementation.
     */
    Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

    if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
        typeof console.error === 'function') {
      console.error(
        'This browser lacks typed array (Uint8Array) support which is required by ' +
        '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
      )
    }

    function typedArraySupport () {
      // Can typed array instances can be augmented?
      try {
        var arr = new Uint8Array(1)
        var proto = { foo: function () { return 42 } }
        Object.setPrototypeOf(proto, Uint8Array.prototype)
        Object.setPrototypeOf(arr, proto)
        return arr.foo() === 42
      } catch (e) {
        return false
      }
    }

    Object.defineProperty(Buffer.prototype, 'parent', {
      enumerable: true,
      get: function () {
        if (!Buffer.isBuffer(this)) return undefined
        return this.buffer
      }
    })

    Object.defineProperty(Buffer.prototype, 'offset', {
      enumerable: true,
      get: function () {
        if (!Buffer.isBuffer(this)) return undefined
        return this.byteOffset
      }
    })

    function createBuffer (length) {
      if (length > K_MAX_LENGTH) {
        throw new RangeError('The value "' + length + '" is invalid for option "size"')
      }
      // Return an augmented `Uint8Array` instance
      var buf = new Uint8Array(length)
      Object.setPrototypeOf(buf, Buffer.prototype)
      return buf
    }

    /**
     * The Buffer constructor returns instances of `Uint8Array` that have their
     * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
     * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
     * and the `Uint8Array` methods. Square bracket notation works as expected -- it
     * returns a single octet.
     *
     * The `Uint8Array` prototype remains unmodified.
     */

    function Buffer (arg, encodingOrOffset, length) {
      // Common case.
      if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') {
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          )
        }
        return allocUnsafe(arg)
      }
      return from(arg, encodingOrOffset, length)
    }

    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    if (typeof Symbol !== 'undefined' && Symbol.species != null &&
        Buffer[Symbol.species] === Buffer) {
      Object.defineProperty(Buffer, Symbol.species, {
        value: null,
        configurable: true,
        enumerable: false,
        writable: false
      })
    }

    Buffer.poolSize = 8192 // not used by this implementation

    function from (value, encodingOrOffset, length) {
      if (typeof value === 'string') {
        return fromString(value, encodingOrOffset)
      }

      if (ArrayBuffer.isView(value)) {
        return fromArrayLike(value)
      }

      if (value == null) {
        throw new TypeError(
          'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
          'or Array-like Object. Received type ' + (typeof value)
        )
      }

      if (isInstance(value, ArrayBuffer) ||
          (value && isInstance(value.buffer, ArrayBuffer))) {
        return fromArrayBuffer(value, encodingOrOffset, length)
      }

      if (typeof value === 'number') {
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        )
      }

      var valueOf = value.valueOf && value.valueOf()
      if (valueOf != null && valueOf !== value) {
        return Buffer.from(valueOf, encodingOrOffset, length)
      }

      var b = fromObject(value)
      if (b) return b

      if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
          typeof value[Symbol.toPrimitive] === 'function') {
        return Buffer.from(
          value[Symbol.toPrimitive]('string'), encodingOrOffset, length
        )
      }

      throw new TypeError(
        'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
        'or Array-like Object. Received type ' + (typeof value)
      )
    }

    /**
     * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
     * if value is a number.
     * Buffer.from(str[, encoding])
     * Buffer.from(array)
     * Buffer.from(buffer)
     * Buffer.from(arrayBuffer[, byteOffset[, length]])
     **/
    Buffer.from = function (value, encodingOrOffset, length) {
      return from(value, encodingOrOffset, length)
    }

    // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
    // https://github.com/feross/buffer/pull/148
    Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
    Object.setPrototypeOf(Buffer, Uint8Array)

    function assertSize (size) {
      if (typeof size !== 'number') {
        throw new TypeError('"size" argument must be of type number')
      } else if (size < 0) {
        throw new RangeError('The value "' + size + '" is invalid for option "size"')
      }
    }

    function alloc (size, fill, encoding) {
      assertSize(size)
      if (size <= 0) {
        return createBuffer(size)
      }
      if (fill !== undefined) {
        // Only pay attention to encoding if it's a string. This
        // prevents accidentally sending in a number that would
        // be interpretted as a start offset.
        return typeof encoding === 'string'
          ? createBuffer(size).fill(fill, encoding)
          : createBuffer(size).fill(fill)
      }
      return createBuffer(size)
    }

    /**
     * Creates a new filled Buffer instance.
     * alloc(size[, fill[, encoding]])
     **/
    Buffer.alloc = function (size, fill, encoding) {
      return alloc(size, fill, encoding)
    }

    function allocUnsafe (size) {
      assertSize(size)
      return createBuffer(size < 0 ? 0 : checked(size) | 0)
    }

    /**
     * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
     * */
    Buffer.allocUnsafe = function (size) {
      return allocUnsafe(size)
    }
    /**
     * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
     */
    Buffer.allocUnsafeSlow = function (size) {
      return allocUnsafe(size)
    }

    function fromString (string, encoding) {
      if (typeof encoding !== 'string' || encoding === '') {
        encoding = 'utf8'
      }

      if (!Buffer.isEncoding(encoding)) {
        throw new TypeError('Unknown encoding: ' + encoding)
      }

      var length = byteLength(string, encoding) | 0
      var buf = createBuffer(length)

      var actual = buf.write(string, encoding)

      if (actual !== length) {
        // Writing a hex string, for example, that contains invalid characters will
        // cause everything after the first invalid character to be ignored. (e.g.
        // 'abxxcd' will be treated as 'ab')
        buf = buf.slice(0, actual)
      }

      return buf
    }

    function fromArrayLike (array) {
      var length = array.length < 0 ? 0 : checked(array.length) | 0
      var buf = createBuffer(length)
      for (var i = 0; i < length; i += 1) {
        buf[i] = array[i] & 255
      }
      return buf
    }

    function fromArrayBuffer (array, byteOffset, length) {
      if (byteOffset < 0 || array.byteLength < byteOffset) {
        throw new RangeError('"offset" is outside of buffer bounds')
      }

      if (array.byteLength < byteOffset + (length || 0)) {
        throw new RangeError('"length" is outside of buffer bounds')
      }

      var buf
      if (byteOffset === undefined && length === undefined) {
        buf = new Uint8Array(array)
      } else if (length === undefined) {
        buf = new Uint8Array(array, byteOffset)
      } else {
        buf = new Uint8Array(array, byteOffset, length)
      }

      // Return an augmented `Uint8Array` instance
      Object.setPrototypeOf(buf, Buffer.prototype)

      return buf
    }

    function fromObject (obj) {
      if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0
        var buf = createBuffer(len)

        if (buf.length === 0) {
          return buf
        }

        obj.copy(buf, 0, 0, len)
        return buf
      }

      if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
          return createBuffer(0)
        }
        return fromArrayLike(obj)
      }

      if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
        return fromArrayLike(obj.data)
      }
    }

    function checked (length) {
      // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
      // length is NaN (which is otherwise coerced to zero.)
      if (length >= K_MAX_LENGTH) {
        throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                             'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
      }
      return length | 0
    }

    function SlowBuffer (length) {
      if (+length != length) { // eslint-disable-line eqeqeq
        length = 0
      }
      return Buffer.alloc(+length)
    }

    Buffer.isBuffer = function isBuffer (b) {
      return b != null && b._isBuffer === true &&
        b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    }

    Buffer.compare = function compare (a, b) {
      if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
      if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
      if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        )
      }

      if (a === b) return 0

      var x = a.length
      var y = b.length

      for (var i = 0, len = Math.min(x, y); i < len; ++i) {
        if (a[i] !== b[i]) {
          x = a[i]
          y = b[i]
          break
        }
      }

      if (x < y) return -1
      if (y < x) return 1
      return 0
    }

    Buffer.isEncoding = function isEncoding (encoding) {
      switch (String(encoding).toLowerCase()) {
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return true
        default:
          return false
      }
    }

    Buffer.concat = function concat (list, length) {
      if (!Array.isArray(list)) {
        throw new TypeError('"list" argument must be an Array of Buffers')
      }

      if (list.length === 0) {
        return Buffer.alloc(0)
      }

      var i
      if (length === undefined) {
        length = 0
        for (i = 0; i < list.length; ++i) {
          length += list[i].length
        }
      }

      var buffer = Buffer.allocUnsafe(length)
      var pos = 0
      for (i = 0; i < list.length; ++i) {
        var buf = list[i]
        if (isInstance(buf, Uint8Array)) {
          buf = Buffer.from(buf)
        }
        if (!Buffer.isBuffer(buf)) {
          throw new TypeError('"list" argument must be an Array of Buffers')
        }
        buf.copy(buffer, pos)
        pos += buf.length
      }
      return buffer
    }

    function byteLength (string, encoding) {
      if (Buffer.isBuffer(string)) {
        return string.length
      }
      if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
        return string.byteLength
      }
      if (typeof string !== 'string') {
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
          'Received type ' + typeof string
        )
      }

      var len = string.length
      var mustMatch = (arguments.length > 2 && arguments[2] === true)
      if (!mustMatch && len === 0) return 0

      // Use a for loop to avoid recursion
      var loweredCase = false
      for (;;) {
        switch (encoding) {
          case 'ascii':
          case 'latin1':
          case 'binary':
            return len
          case 'utf8':
          case 'utf-8':
            return utf8ToBytes(string).length
          case 'ucs2':
          case 'ucs-2':
          case 'utf16le':
          case 'utf-16le':
            return len * 2
          case 'hex':
            return len >>> 1
          case 'base64':
            return base64ToBytes(string).length
          default:
            if (loweredCase) {
              return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            }
            encoding = ('' + encoding).toLowerCase()
            loweredCase = true
        }
      }
    }
    Buffer.byteLength = byteLength

    function slowToString (encoding, start, end) {
      var loweredCase = false

      // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
      // property of a typed array.

      // This behaves neither like String nor Uint8Array in that we set start/end
      // to their upper/lower bounds if the value passed is out of range.
      // undefined is handled specially as per ECMA-262 6th Edition,
      // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
      if (start === undefined || start < 0) {
        start = 0
      }
      // Return early if start > this.length. Done here to prevent potential uint32
      // coercion fail below.
      if (start > this.length) {
        return ''
      }

      if (end === undefined || end > this.length) {
        end = this.length
      }

      if (end <= 0) {
        return ''
      }

      // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
      end >>>= 0
      start >>>= 0

      if (end <= start) {
        return ''
      }

      if (!encoding) encoding = 'utf8'

      while (true) {
        switch (encoding) {
          case 'hex':
            return hexSlice(this, start, end)

          case 'utf8':
          case 'utf-8':
            return utf8Slice(this, start, end)

          case 'ascii':
            return asciiSlice(this, start, end)

          case 'latin1':
          case 'binary':
            return latin1Slice(this, start, end)

          case 'base64':
            return base64Slice(this, start, end)

          case 'ucs2':
          case 'ucs-2':
          case 'utf16le':
          case 'utf-16le':
            return utf16leSlice(this, start, end)

          default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
            encoding = (encoding + '').toLowerCase()
            loweredCase = true
        }
      }
    }

    // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
    // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
    // reliably in a browserify context because there could be multiple different
    // copies of the 'buffer' package in use. This method works even for Buffer
    // instances that were created from another copy of the `buffer` package.
    // See: https://github.com/feross/buffer/issues/154
    Buffer.prototype._isBuffer = true

    function swap (b, n, m) {
      var i = b[n]
      b[n] = b[m]
      b[m] = i
    }

    Buffer.prototype.swap16 = function swap16 () {
      var len = this.length
      if (len % 2 !== 0) {
        throw new RangeError('Buffer size must be a multiple of 16-bits')
      }
      for (var i = 0; i < len; i += 2) {
        swap(this, i, i + 1)
      }
      return this
    }

    Buffer.prototype.swap32 = function swap32 () {
      var len = this.length
      if (len % 4 !== 0) {
        throw new RangeError('Buffer size must be a multiple of 32-bits')
      }
      for (var i = 0; i < len; i += 4) {
        swap(this, i, i + 3)
        swap(this, i + 1, i + 2)
      }
      return this
    }

    Buffer.prototype.swap64 = function swap64 () {
      var len = this.length
      if (len % 8 !== 0) {
        throw new RangeError('Buffer size must be a multiple of 64-bits')
      }
      for (var i = 0; i < len; i += 8) {
        swap(this, i, i + 7)
        swap(this, i + 1, i + 6)
        swap(this, i + 2, i + 5)
        swap(this, i + 3, i + 4)
      }
      return this
    }

    Buffer.prototype.toString = function toString () {
      var length = this.length
      if (length === 0) return ''
      if (arguments.length === 0) return utf8Slice(this, 0, length)
      return slowToString.apply(this, arguments)
    }

    Buffer.prototype.toLocaleString = Buffer.prototype.toString

    Buffer.prototype.equals = function equals (b) {
      if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
      if (this === b) return true
      return Buffer.compare(this, b) === 0
    }

    Buffer.prototype.inspect = function inspect () {
      var str = ''
      var max = exports.INSPECT_MAX_BYTES
      str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
      if (this.length > max) str += ' ... '
      return '<Buffer ' + str + '>'
    }
    if (customInspectSymbol) {
      Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
    }

    Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
      if (isInstance(target, Uint8Array)) {
        target = Buffer.from(target, target.offset, target.byteLength)
      }
      if (!Buffer.isBuffer(target)) {
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. ' +
          'Received type ' + (typeof target)
        )
      }

      if (start === undefined) {
        start = 0
      }
      if (end === undefined) {
        end = target ? target.length : 0
      }
      if (thisStart === undefined) {
        thisStart = 0
      }
      if (thisEnd === undefined) {
        thisEnd = this.length
      }

      if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
        throw new RangeError('out of range index')
      }

      if (thisStart >= thisEnd && start >= end) {
        return 0
      }
      if (thisStart >= thisEnd) {
        return -1
      }
      if (start >= end) {
        return 1
      }

      start >>>= 0
      end >>>= 0
      thisStart >>>= 0
      thisEnd >>>= 0

      if (this === target) return 0

      var x = thisEnd - thisStart
      var y = end - start
      var len = Math.min(x, y)

      var thisCopy = this.slice(thisStart, thisEnd)
      var targetCopy = target.slice(start, end)

      for (var i = 0; i < len; ++i) {
        if (thisCopy[i] !== targetCopy[i]) {
          x = thisCopy[i]
          y = targetCopy[i]
          break
        }
      }

      if (x < y) return -1
      if (y < x) return 1
      return 0
    }

    // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
    // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
    //
    // Arguments:
    // - buffer - a Buffer to search
    // - val - a string, Buffer, or number
    // - byteOffset - an index into `buffer`; will be clamped to an int32
    // - encoding - an optional encoding, relevant is val is a string
    // - dir - true for indexOf, false for lastIndexOf
    function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
      // Empty buffer means no match
      if (buffer.length === 0) return -1

      // Normalize byteOffset
      if (typeof byteOffset === 'string') {
        encoding = byteOffset
        byteOffset = 0
      } else if (byteOffset > 0x7fffffff) {
        byteOffset = 0x7fffffff
      } else if (byteOffset < -0x80000000) {
        byteOffset = -0x80000000
      }
      byteOffset = +byteOffset // Coerce to Number.
      if (numberIsNaN(byteOffset)) {
        // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
        byteOffset = dir ? 0 : (buffer.length - 1)
      }

      // Normalize byteOffset: negative offsets start from the end of the buffer
      if (byteOffset < 0) byteOffset = buffer.length + byteOffset
      if (byteOffset >= buffer.length) {
        if (dir) return -1
        else byteOffset = buffer.length - 1
      } else if (byteOffset < 0) {
        if (dir) byteOffset = 0
        else return -1
      }

      // Normalize val
      if (typeof val === 'string') {
        val = Buffer.from(val, encoding)
      }

      // Finally, search either indexOf (if dir is true) or lastIndexOf
      if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) {
          return -1
        }
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
      } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        if (typeof Uint8Array.prototype.indexOf === 'function') {
          if (dir) {
            return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
          } else {
            return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
          }
        }
        return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
      }

      throw new TypeError('val must be string, number or Buffer')
    }

    function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
      var indexSize = 1
      var arrLength = arr.length
      var valLength = val.length

      if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase()
        if (encoding === 'ucs2' || encoding === 'ucs-2' ||
            encoding === 'utf16le' || encoding === 'utf-16le') {
          if (arr.length < 2 || val.length < 2) {
            return -1
          }
          indexSize = 2
          arrLength /= 2
          valLength /= 2
          byteOffset /= 2
        }
      }

      function read (buf, i) {
        if (indexSize === 1) {
          return buf[i]
        } else {
          return buf.readUInt16BE(i * indexSize)
        }
      }

      var i
      if (dir) {
        var foundIndex = -1
        for (i = byteOffset; i < arrLength; i++) {
          if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
          } else {
            if (foundIndex !== -1) i -= i - foundIndex
            foundIndex = -1
          }
        }
      } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
        for (i = byteOffset; i >= 0; i--) {
          var found = true
          for (var j = 0; j < valLength; j++) {
            if (read(arr, i + j) !== read(val, j)) {
              found = false
              break
            }
          }
          if (found) return i
        }
      }

      return -1
    }

    Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
      return this.indexOf(val, byteOffset, encoding) !== -1
    }

    Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
    }

    Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
    }

    function hexWrite (buf, string, offset, length) {
      offset = Number(offset) || 0
      var remaining = buf.length - offset
      if (!length) {
        length = remaining
      } else {
        length = Number(length)
        if (length > remaining) {
          length = remaining
        }
      }

      var strLen = string.length

      if (length > strLen / 2) {
        length = strLen / 2
      }
      for (var i = 0; i < length; ++i) {
        var parsed = parseInt(string.substr(i * 2, 2), 16)
        if (numberIsNaN(parsed)) return i
        buf[offset + i] = parsed
      }
      return i
    }

    function utf8Write (buf, string, offset, length) {
      return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
    }

    function asciiWrite (buf, string, offset, length) {
      return blitBuffer(asciiToBytes(string), buf, offset, length)
    }

    function latin1Write (buf, string, offset, length) {
      return asciiWrite(buf, string, offset, length)
    }

    function base64Write (buf, string, offset, length) {
      return blitBuffer(base64ToBytes(string), buf, offset, length)
    }

    function ucs2Write (buf, string, offset, length) {
      return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
    }

    Buffer.prototype.write = function write (string, offset, length, encoding) {
      // Buffer#write(string)
      if (offset === undefined) {
        encoding = 'utf8'
        length = this.length
        offset = 0
      // Buffer#write(string, encoding)
      } else if (length === undefined && typeof offset === 'string') {
        encoding = offset
        length = this.length
        offset = 0
      // Buffer#write(string, offset[, length][, encoding])
      } else if (isFinite(offset)) {
        offset = offset >>> 0
        if (isFinite(length)) {
          length = length >>> 0
          if (encoding === undefined) encoding = 'utf8'
        } else {
          encoding = length
          length = undefined
        }
      } else {
        throw new Error(
          'Buffer.write(string, encoding, offset[, length]) is no longer supported'
        )
      }

      var remaining = this.length - offset
      if (length === undefined || length > remaining) length = remaining

      if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
        throw new RangeError('Attempt to write outside buffer bounds')
      }

      if (!encoding) encoding = 'utf8'

      var loweredCase = false
      for (;;) {
        switch (encoding) {
          case 'hex':
            return hexWrite(this, string, offset, length)

          case 'utf8':
          case 'utf-8':
            return utf8Write(this, string, offset, length)

          case 'ascii':
            return asciiWrite(this, string, offset, length)

          case 'latin1':
          case 'binary':
            return latin1Write(this, string, offset, length)

          case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length)

          case 'ucs2':
          case 'ucs-2':
          case 'utf16le':
          case 'utf-16le':
            return ucs2Write(this, string, offset, length)

          default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
            encoding = ('' + encoding).toLowerCase()
            loweredCase = true
        }
      }
    }

    Buffer.prototype.toJSON = function toJSON () {
      return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
      }
    }

    function base64Slice (buf, start, end) {
      if (start === 0 && end === buf.length) {
        return base64.fromByteArray(buf)
      } else {
        return base64.fromByteArray(buf.slice(start, end))
      }
    }

    function utf8Slice (buf, start, end) {
      end = Math.min(buf.length, end)
      var res = []

      var i = start
      while (i < end) {
        var firstByte = buf[i]
        var codePoint = null
        var bytesPerSequence = (firstByte > 0xEF) ? 4
          : (firstByte > 0xDF) ? 3
            : (firstByte > 0xBF) ? 2
              : 1

        if (i + bytesPerSequence <= end) {
          var secondByte, thirdByte, fourthByte, tempCodePoint

          switch (bytesPerSequence) {
            case 1:
              if (firstByte < 0x80) {
                codePoint = firstByte
              }
              break
            case 2:
              secondByte = buf[i + 1]
              if ((secondByte & 0xC0) === 0x80) {
                tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
                if (tempCodePoint > 0x7F) {
                  codePoint = tempCodePoint
                }
              }
              break
            case 3:
              secondByte = buf[i + 1]
              thirdByte = buf[i + 2]
              if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
                if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
                  codePoint = tempCodePoint
                }
              }
              break
            case 4:
              secondByte = buf[i + 1]
              thirdByte = buf[i + 2]
              fourthByte = buf[i + 3]
              if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
                if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
                  codePoint = tempCodePoint
                }
              }
          }
        }

        if (codePoint === null) {
          // we did not generate a valid codePoint so insert a
          // replacement char (U+FFFD) and advance only 1 byte
          codePoint = 0xFFFD
          bytesPerSequence = 1
        } else if (codePoint > 0xFFFF) {
          // encode to utf16 (surrogate pair dance)
          codePoint -= 0x10000
          res.push(codePoint >>> 10 & 0x3FF | 0xD800)
          codePoint = 0xDC00 | codePoint & 0x3FF
        }

        res.push(codePoint)
        i += bytesPerSequence
      }

      return decodeCodePointsArray(res)
    }

    // Based on http://stackoverflow.com/a/22747272/680742, the browser with
    // the lowest limit is Chrome, with 0x10000 args.
    // We go 1 magnitude less, for safety
    var MAX_ARGUMENTS_LENGTH = 0x1000

    function decodeCodePointsArray (codePoints) {
      var len = codePoints.length
      if (len <= MAX_ARGUMENTS_LENGTH) {
        return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
      }

      // Decode in chunks to avoid "call stack size exceeded".
      var res = ''
      var i = 0
      while (i < len) {
        res += String.fromCharCode.apply(
          String,
          codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
        )
      }
      return res
    }

    function asciiSlice (buf, start, end) {
      var ret = ''
      end = Math.min(buf.length, end)

      for (var i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i] & 0x7F)
      }
      return ret
    }

    function latin1Slice (buf, start, end) {
      var ret = ''
      end = Math.min(buf.length, end)

      for (var i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i])
      }
      return ret
    }

    function hexSlice (buf, start, end) {
      var len = buf.length

      if (!start || start < 0) start = 0
      if (!end || end < 0 || end > len) end = len

      var out = ''
      for (var i = start; i < end; ++i) {
        out += hexSliceLookupTable[buf[i]]
      }
      return out
    }

    function utf16leSlice (buf, start, end) {
      var bytes = buf.slice(start, end)
      var res = ''
      for (var i = 0; i < bytes.length; i += 2) {
        res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
      }
      return res
    }

    Buffer.prototype.slice = function slice (start, end) {
      var len = this.length
      start = ~~start
      end = end === undefined ? len : ~~end

      if (start < 0) {
        start += len
        if (start < 0) start = 0
      } else if (start > len) {
        start = len
      }

      if (end < 0) {
        end += len
        if (end < 0) end = 0
      } else if (end > len) {
        end = len
      }

      if (end < start) end = start

      var newBuf = this.subarray(start, end)
      // Return an augmented `Uint8Array` instance
      Object.setPrototypeOf(newBuf, Buffer.prototype)

      return newBuf
    }

    /*
     * Need to make sure that buffer isn't trying to write out of bounds.
     */
    function checkOffset (offset, ext, length) {
      if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
      if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
    }

    Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
      offset = offset >>> 0
      byteLength = byteLength >>> 0
      if (!noAssert) checkOffset(offset, byteLength, this.length)

      var val = this[offset]
      var mul = 1
      var i = 0
      while (++i < byteLength && (mul *= 0x100)) {
        val += this[offset + i] * mul
      }

      return val
    }

    Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
      offset = offset >>> 0
      byteLength = byteLength >>> 0
      if (!noAssert) {
        checkOffset(offset, byteLength, this.length)
      }

      var val = this[offset + --byteLength]
      var mul = 1
      while (byteLength > 0 && (mul *= 0x100)) {
        val += this[offset + --byteLength] * mul
      }

      return val
    }

    Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
      offset = offset >>> 0
      if (!noAssert) checkOffset(offset, 1, this.length)
      return this[offset]
    }

    Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
      offset = offset >>> 0
      if (!noAssert) checkOffset(offset, 2, this.length)
      return this[offset] | (this[offset + 1] << 8)
    }

    Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
      offset = offset >>> 0
      if (!noAssert) checkOffset(offset, 2, this.length)
      return (this[offset] << 8) | this[offset + 1]
    }

    Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
      offset = offset >>> 0
      if (!noAssert) checkOffset(offset, 4, this.length)

      return ((this[offset]) |
          (this[offset + 1] << 8) |
          (this[offset + 2] << 16)) +
          (this[offset + 3] * 0x1000000)
    }

    Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
      offset = offset >>> 0
      if (!noAssert) checkOffset(offset, 4, this.length)

      return (this[offset] * 0x1000000) +
        ((this[offset + 1] << 16) |
        (this[offset + 2] << 8) |
        this[offset + 3])
    }

    Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
      offset = offset >>> 0
      byteLength = byteLength >>> 0
      if (!noAssert) checkOffset(offset, byteLength, this.length)

      var val = this[offset]
      var mul = 1
      var i = 0
      while (++i < byteLength && (mul *= 0x100)) {
        val += this[offset + i] * mul
      }
      mul *= 0x80

      if (val >= mul) val -= Math.pow(2, 8 * byteLength)

      return val
    }

    Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
      offset = offset >>> 0
      byteLength = byteLength >>> 0
      if (!noAssert) checkOffset(offset, byteLength, this.length)

      var i = byteLength
      var mul = 1
      var val = this[offset + --i]
      while (i > 0 && (mul *= 0x100)) {
        val += this[offset + --i] * mul
      }
      mul *= 0x80

      if (val >= mul) val -= Math.pow(2, 8 * byteLength)

      return val
    }

    Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
      offset = offset >>> 0
      if (!noAssert) checkOffset(offset, 1, this.length)
      if (!(this[offset] & 0x80)) return (this[offset])
      return ((0xff - this[offset] + 1) * -1)
    }

    Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
      offset = offset >>> 0
      if (!noAssert) checkOffset(offset, 2, this.length)
      var val = this[offset] | (this[offset + 1] << 8)
      return (val & 0x8000) ? val | 0xFFFF0000 : val
    }

    Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
      offset = offset >>> 0
      if (!noAssert) checkOffset(offset, 2, this.length)
      var val = this[offset + 1] | (this[offset] << 8)
      return (val & 0x8000) ? val | 0xFFFF0000 : val
    }

    Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
      offset = offset >>> 0
      if (!noAssert) checkOffset(offset, 4, this.length)

      return (this[offset]) |
        (this[offset + 1] << 8) |
        (this[offset + 2] << 16) |
        (this[offset + 3] << 24)
    }

    Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
      offset = offset >>> 0
      if (!noAssert) checkOffset(offset, 4, this.length)

      return (this[offset] << 24) |
        (this[offset + 1] << 16) |
        (this[offset + 2] << 8) |
        (this[offset + 3])
    }

    Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
      offset = offset >>> 0
      if (!noAssert) checkOffset(offset, 4, this.length)
      return ieee754.read(this, offset, true, 23, 4)
    }

    Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
      offset = offset >>> 0
      if (!noAssert) checkOffset(offset, 4, this.length)
      return ieee754.read(this, offset, false, 23, 4)
    }

    Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
      offset = offset >>> 0
      if (!noAssert) checkOffset(offset, 8, this.length)
      return ieee754.read(this, offset, true, 52, 8)
    }

    Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
      offset = offset >>> 0
      if (!noAssert) checkOffset(offset, 8, this.length)
      return ieee754.read(this, offset, false, 52, 8)
    }

    function checkInt (buf, value, offset, ext, max, min) {
      if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
      if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
      if (offset + ext > buf.length) throw new RangeError('Index out of range')
    }

    Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
      value = +value
      offset = offset >>> 0
      byteLength = byteLength >>> 0
      if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1
        checkInt(this, value, offset, byteLength, maxBytes, 0)
      }

      var mul = 1
      var i = 0
      this[offset] = value & 0xFF
      while (++i < byteLength && (mul *= 0x100)) {
        this[offset + i] = (value / mul) & 0xFF
      }

      return offset + byteLength
    }

    Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
      value = +value
      offset = offset >>> 0
      byteLength = byteLength >>> 0
      if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1
        checkInt(this, value, offset, byteLength, maxBytes, 0)
      }

      var i = byteLength - 1
      var mul = 1
      this[offset + i] = value & 0xFF
      while (--i >= 0 && (mul *= 0x100)) {
        this[offset + i] = (value / mul) & 0xFF
      }

      return offset + byteLength
    }

    Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
      value = +value
      offset = offset >>> 0
      if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
      this[offset] = (value & 0xff)
      return offset + 1
    }

    Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
      value = +value
      offset = offset >>> 0
      if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
      this[offset] = (value & 0xff)
      this[offset + 1] = (value >>> 8)
      return offset + 2
    }

    Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
      value = +value
      offset = offset >>> 0
      if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
      this[offset] = (value >>> 8)
      this[offset + 1] = (value & 0xff)
      return offset + 2
    }

    Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
      value = +value
      offset = offset >>> 0
      if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
      this[offset + 3] = (value >>> 24)
      this[offset + 2] = (value >>> 16)
      this[offset + 1] = (value >>> 8)
      this[offset] = (value & 0xff)
      return offset + 4
    }

    Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
      value = +value
      offset = offset >>> 0
      if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
      this[offset] = (value >>> 24)
      this[offset + 1] = (value >>> 16)
      this[offset + 2] = (value >>> 8)
      this[offset + 3] = (value & 0xff)
      return offset + 4
    }

    Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
      value = +value
      offset = offset >>> 0
      if (!noAssert) {
        var limit = Math.pow(2, (8 * byteLength) - 1)

        checkInt(this, value, offset, byteLength, limit - 1, -limit)
      }

      var i = 0
      var mul = 1
      var sub = 0
      this[offset] = value & 0xFF
      while (++i < byteLength && (mul *= 0x100)) {
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
          sub = 1
        }
        this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
      }

      return offset + byteLength
    }

    Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
      value = +value
      offset = offset >>> 0
      if (!noAssert) {
        var limit = Math.pow(2, (8 * byteLength) - 1)

        checkInt(this, value, offset, byteLength, limit - 1, -limit)
      }

      var i = byteLength - 1
      var mul = 1
      var sub = 0
      this[offset + i] = value & 0xFF
      while (--i >= 0 && (mul *= 0x100)) {
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
          sub = 1
        }
        this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
      }

      return offset + byteLength
    }

    Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
      value = +value
      offset = offset >>> 0
      if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
      if (value < 0) value = 0xff + value + 1
      this[offset] = (value & 0xff)
      return offset + 1
    }

    Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
      value = +value
      offset = offset >>> 0
      if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
      this[offset] = (value & 0xff)
      this[offset + 1] = (value >>> 8)
      return offset + 2
    }

    Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
      value = +value
      offset = offset >>> 0
      if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
      this[offset] = (value >>> 8)
      this[offset + 1] = (value & 0xff)
      return offset + 2
    }

    Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
      value = +value
      offset = offset >>> 0
      if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
      this[offset] = (value & 0xff)
      this[offset + 1] = (value >>> 8)
      this[offset + 2] = (value >>> 16)
      this[offset + 3] = (value >>> 24)
      return offset + 4
    }

    Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
      value = +value
      offset = offset >>> 0
      if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
      if (value < 0) value = 0xffffffff + value + 1
      this[offset] = (value >>> 24)
      this[offset + 1] = (value >>> 16)
      this[offset + 2] = (value >>> 8)
      this[offset + 3] = (value & 0xff)
      return offset + 4
    }

    function checkIEEE754 (buf, value, offset, ext, max, min) {
      if (offset + ext > buf.length) throw new RangeError('Index out of range')
      if (offset < 0) throw new RangeError('Index out of range')
    }

    function writeFloat (buf, value, offset, littleEndian, noAssert) {
      value = +value
      offset = offset >>> 0
      if (!noAssert) {
        checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
      }
      ieee754.write(buf, value, offset, littleEndian, 23, 4)
      return offset + 4
    }

    Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
      return writeFloat(this, value, offset, true, noAssert)
    }

    Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
      return writeFloat(this, value, offset, false, noAssert)
    }

    function writeDouble (buf, value, offset, littleEndian, noAssert) {
      value = +value
      offset = offset >>> 0
      if (!noAssert) {
        checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
      }
      ieee754.write(buf, value, offset, littleEndian, 52, 8)
      return offset + 8
    }

    Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
      return writeDouble(this, value, offset, true, noAssert)
    }

    Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
      return writeDouble(this, value, offset, false, noAssert)
    }

    // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
    Buffer.prototype.copy = function copy (target, targetStart, start, end) {
      if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
      if (!start) start = 0
      if (!end && end !== 0) end = this.length
      if (targetStart >= target.length) targetStart = target.length
      if (!targetStart) targetStart = 0
      if (end > 0 && end < start) end = start

      // Copy 0 bytes; we're done
      if (end === start) return 0
      if (target.length === 0 || this.length === 0) return 0

      // Fatal error conditions
      if (targetStart < 0) {
        throw new RangeError('targetStart out of bounds')
      }
      if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
      if (end < 0) throw new RangeError('sourceEnd out of bounds')

      // Are we oob?
      if (end > this.length) end = this.length
      if (target.length - targetStart < end - start) {
        end = target.length - targetStart + start
      }

      var len = end - start

      if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
        // Use built-in when available, missing from IE11
        this.copyWithin(targetStart, start, end)
      } else if (this === target && start < targetStart && targetStart < end) {
        // descending copy from end
        for (var i = len - 1; i >= 0; --i) {
          target[i + targetStart] = this[i + start]
        }
      } else {
        Uint8Array.prototype.set.call(
          target,
          this.subarray(start, end),
          targetStart
        )
      }

      return len
    }

    // Usage:
    //    buffer.fill(number[, offset[, end]])
    //    buffer.fill(buffer[, offset[, end]])
    //    buffer.fill(string[, offset[, end]][, encoding])
    Buffer.prototype.fill = function fill (val, start, end, encoding) {
      // Handle string cases:
      if (typeof val === 'string') {
        if (typeof start === 'string') {
          encoding = start
          start = 0
          end = this.length
        } else if (typeof end === 'string') {
          encoding = end
          end = this.length
        }
        if (encoding !== undefined && typeof encoding !== 'string') {
          throw new TypeError('encoding must be a string')
        }
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
          throw new TypeError('Unknown encoding: ' + encoding)
        }
        if (val.length === 1) {
          var code = val.charCodeAt(0)
          if ((encoding === 'utf8' && code < 128) ||
              encoding === 'latin1') {
            // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code
          }
        }
      } else if (typeof val === 'number') {
        val = val & 255
      } else if (typeof val === 'boolean') {
        val = Number(val)
      }

      // Invalid ranges are not set to a default, so can range check early.
      if (start < 0 || this.length < start || this.length < end) {
        throw new RangeError('Out of range index')
      }

      if (end <= start) {
        return this
      }

      start = start >>> 0
      end = end === undefined ? this.length : end >>> 0

      if (!val) val = 0

      var i
      if (typeof val === 'number') {
        for (i = start; i < end; ++i) {
          this[i] = val
        }
      } else {
        var bytes = Buffer.isBuffer(val)
          ? val
          : Buffer.from(val, encoding)
        var len = bytes.length
        if (len === 0) {
          throw new TypeError('The value "' + val +
            '" is invalid for argument "value"')
        }
        for (i = 0; i < end - start; ++i) {
          this[i + start] = bytes[i % len]
        }
      }

      return this
    }

    // HELPER FUNCTIONS
    // ================

    var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

    function base64clean (str) {
      // Node takes equal signs as end of the Base64 encoding
      str = str.split('=')[0]
      // Node strips out invalid characters like \n and \t from the string, base64-js does not
      str = str.trim().replace(INVALID_BASE64_RE, '')
      // Node converts strings with length < 2 to ''
      if (str.length < 2) return ''
      // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
      while (str.length % 4 !== 0) {
        str = str + '='
      }
      return str
    }

    function utf8ToBytes (string, units) {
      units = units || Infinity
      var codePoint
      var length = string.length
      var leadSurrogate = null
      var bytes = []

      for (var i = 0; i < length; ++i) {
        codePoint = string.charCodeAt(i)

        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
          // last char was a lead
          if (!leadSurrogate) {
            // no lead yet
            if (codePoint > 0xDBFF) {
              // unexpected trail
              if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
              continue
            } else if (i + 1 === length) {
              // unpaired lead
              if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
              continue
            }

            // valid lead
            leadSurrogate = codePoint

            continue
          }

          // 2 leads in a row
          if (codePoint < 0xDC00) {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
            leadSurrogate = codePoint
            continue
          }

          // valid surrogate pair
          codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
        } else if (leadSurrogate) {
          // valid bmp char, but last char was a lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        }

        leadSurrogate = null

        // encode utf8
        if (codePoint < 0x80) {
          if ((units -= 1) < 0) break
          bytes.push(codePoint)
        } else if (codePoint < 0x800) {
          if ((units -= 2) < 0) break
          bytes.push(
            codePoint >> 0x6 | 0xC0,
            codePoint & 0x3F | 0x80
          )
        } else if (codePoint < 0x10000) {
          if ((units -= 3) < 0) break
          bytes.push(
            codePoint >> 0xC | 0xE0,
            codePoint >> 0x6 & 0x3F | 0x80,
            codePoint & 0x3F | 0x80
          )
        } else if (codePoint < 0x110000) {
          if ((units -= 4) < 0) break
          bytes.push(
            codePoint >> 0x12 | 0xF0,
            codePoint >> 0xC & 0x3F | 0x80,
            codePoint >> 0x6 & 0x3F | 0x80,
            codePoint & 0x3F | 0x80
          )
        } else {
          throw new Error('Invalid code point')
        }
      }

      return bytes
    }

    function asciiToBytes (str) {
      var byteArray = []
      for (var i = 0; i < str.length; ++i) {
        // Node's code seems to be doing this and not & 0x7F..
        byteArray.push(str.charCodeAt(i) & 0xFF)
      }
      return byteArray
    }

    function utf16leToBytes (str, units) {
      var c, hi, lo
      var byteArray = []
      for (var i = 0; i < str.length; ++i) {
        if ((units -= 2) < 0) break

        c = str.charCodeAt(i)
        hi = c >> 8
        lo = c % 256
        byteArray.push(lo)
        byteArray.push(hi)
      }

      return byteArray
    }

    function base64ToBytes (str) {
      return base64.toByteArray(base64clean(str))
    }

    function blitBuffer (src, dst, offset, length) {
      for (var i = 0; i < length; ++i) {
        if ((i + offset >= dst.length) || (i >= src.length)) break
        dst[i + offset] = src[i]
      }
      return i
    }

    // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
    // the `instanceof` check but they should be treated as of that type.
    // See: https://github.com/feross/buffer/issues/166
    function isInstance (obj, type) {
      return obj instanceof type ||
        (obj != null && obj.constructor != null && obj.constructor.name != null &&
          obj.constructor.name === type.name)
    }
    function numberIsNaN (obj) {
      // For IE11 support
      return obj !== obj // eslint-disable-line no-self-compare
    }

    // Create lookup table for `toString('hex')`
    // See: https://github.com/feross/buffer/issues/219
    var hexSliceLookupTable = (function () {
      var alphabet = '0123456789abcdef'
      var table = new Array(256)
      for (var i = 0; i < 16; ++i) {
        var i16 = i * 16
        for (var j = 0; j < 16; ++j) {
          table[i16 + j] = alphabet[i] + alphabet[j]
        }
      }
      return table
    })()

    }).call(this,require("buffer").Buffer)
    },{"base64-js":10,"buffer":11,"ieee754":24}],12:[function(require,module,exports){
    var hash = exports;

    hash.utils = require('./hash/utils');
    hash.common = require('./hash/common');
    hash.sha = require('./hash/sha');
    hash.ripemd = require('./hash/ripemd');
    hash.hmac = require('./hash/hmac');

    // Proxy hash functions to the main object
    hash.sha1 = hash.sha.sha1;
    hash.sha256 = hash.sha.sha256;
    hash.sha224 = hash.sha.sha224;
    hash.sha384 = hash.sha.sha384;
    hash.sha512 = hash.sha.sha512;
    hash.ripemd160 = hash.ripemd.ripemd160;

    },{"./hash/common":13,"./hash/hmac":14,"./hash/ripemd":15,"./hash/sha":16,"./hash/utils":23}],13:[function(require,module,exports){
    'use strict';

    var utils = require('./utils');
    var assert = require('minimalistic-assert');

    function BlockHash() {
      this.pending = null;
      this.pendingTotal = 0;
      this.blockSize = this.constructor.blockSize;
      this.outSize = this.constructor.outSize;
      this.hmacStrength = this.constructor.hmacStrength;
      this.padLength = this.constructor.padLength / 8;
      this.endian = 'big';

      this._delta8 = this.blockSize / 8;
      this._delta32 = this.blockSize / 32;
    }
    exports.BlockHash = BlockHash;

    BlockHash.prototype.update = function update(msg, enc) {
      // Convert message to array, pad it, and join into 32bit blocks
      msg = utils.toArray(msg, enc);
      if (!this.pending)
        this.pending = msg;
      else
        this.pending = this.pending.concat(msg);
      this.pendingTotal += msg.length;

      // Enough data, try updating
      if (this.pending.length >= this._delta8) {
        msg = this.pending;

        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0)
          this.pending = null;

        msg = utils.join32(msg, 0, msg.length - r, this.endian);
        for (var i = 0; i < msg.length; i += this._delta32)
          this._update(msg, i, i + this._delta32);
      }

      return this;
    };

    BlockHash.prototype.digest = function digest(enc) {
      this.update(this._pad());
      assert(this.pending === null);

      return this._digest(enc);
    };

    BlockHash.prototype._pad = function pad() {
      var len = this.pendingTotal;
      var bytes = this._delta8;
      var k = bytes - ((len + this.padLength) % bytes);
      var res = new Array(k + this.padLength);
      res[0] = 0x80;
      for (var i = 1; i < k; i++)
        res[i] = 0;

      // Append length
      len <<= 3;
      if (this.endian === 'big') {
        for (var t = 8; t < this.padLength; t++)
          res[i++] = 0;

        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = (len >>> 24) & 0xff;
        res[i++] = (len >>> 16) & 0xff;
        res[i++] = (len >>> 8) & 0xff;
        res[i++] = len & 0xff;
      } else {
        res[i++] = len & 0xff;
        res[i++] = (len >>> 8) & 0xff;
        res[i++] = (len >>> 16) & 0xff;
        res[i++] = (len >>> 24) & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;

        for (t = 8; t < this.padLength; t++)
          res[i++] = 0;
      }

      return res;
    };

    },{"./utils":23,"minimalistic-assert":26}],14:[function(require,module,exports){
    'use strict';

    var utils = require('./utils');
    var assert = require('minimalistic-assert');

    function Hmac(hash, key, enc) {
      if (!(this instanceof Hmac))
        return new Hmac(hash, key, enc);
      this.Hash = hash;
      this.blockSize = hash.blockSize / 8;
      this.outSize = hash.outSize / 8;
      this.inner = null;
      this.outer = null;

      this._init(utils.toArray(key, enc));
    }
    module.exports = Hmac;

    Hmac.prototype._init = function init(key) {
      // Shorten key, if needed
      if (key.length > this.blockSize)
        key = new this.Hash().update(key).digest();
      assert(key.length <= this.blockSize);

      // Add padding to key
      for (var i = key.length; i < this.blockSize; i++)
        key.push(0);

      for (i = 0; i < key.length; i++)
        key[i] ^= 0x36;
      this.inner = new this.Hash().update(key);

      // 0x36 ^ 0x5c = 0x6a
      for (i = 0; i < key.length; i++)
        key[i] ^= 0x6a;
      this.outer = new this.Hash().update(key);
    };

    Hmac.prototype.update = function update(msg, enc) {
      this.inner.update(msg, enc);
      return this;
    };

    Hmac.prototype.digest = function digest(enc) {
      this.outer.update(this.inner.digest());
      return this.outer.digest(enc);
    };

    },{"./utils":23,"minimalistic-assert":26}],15:[function(require,module,exports){
    'use strict';

    var utils = require('./utils');
    var common = require('./common');

    var rotl32 = utils.rotl32;
    var sum32 = utils.sum32;
    var sum32_3 = utils.sum32_3;
    var sum32_4 = utils.sum32_4;
    var BlockHash = common.BlockHash;

    function RIPEMD160() {
      if (!(this instanceof RIPEMD160))
        return new RIPEMD160();

      BlockHash.call(this);

      this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
      this.endian = 'little';
    }
    utils.inherits(RIPEMD160, BlockHash);
    exports.ripemd160 = RIPEMD160;

    RIPEMD160.blockSize = 512;
    RIPEMD160.outSize = 160;
    RIPEMD160.hmacStrength = 192;
    RIPEMD160.padLength = 64;

    RIPEMD160.prototype._update = function update(msg, start) {
      var A = this.h[0];
      var B = this.h[1];
      var C = this.h[2];
      var D = this.h[3];
      var E = this.h[4];
      var Ah = A;
      var Bh = B;
      var Ch = C;
      var Dh = D;
      var Eh = E;
      for (var j = 0; j < 80; j++) {
        var T = sum32(
          rotl32(
            sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
            s[j]),
          E);
        A = E;
        E = D;
        D = rotl32(C, 10);
        C = B;
        B = T;
        T = sum32(
          rotl32(
            sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
            sh[j]),
          Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
      }
      T = sum32_3(this.h[1], C, Dh);
      this.h[1] = sum32_3(this.h[2], D, Eh);
      this.h[2] = sum32_3(this.h[3], E, Ah);
      this.h[3] = sum32_3(this.h[4], A, Bh);
      this.h[4] = sum32_3(this.h[0], B, Ch);
      this.h[0] = T;
    };

    RIPEMD160.prototype._digest = function digest(enc) {
      if (enc === 'hex')
        return utils.toHex32(this.h, 'little');
      else
        return utils.split32(this.h, 'little');
    };

    function f(j, x, y, z) {
      if (j <= 15)
        return x ^ y ^ z;
      else if (j <= 31)
        return (x & y) | ((~x) & z);
      else if (j <= 47)
        return (x | (~y)) ^ z;
      else if (j <= 63)
        return (x & z) | (y & (~z));
      else
        return x ^ (y | (~z));
    }

    function K(j) {
      if (j <= 15)
        return 0x00000000;
      else if (j <= 31)
        return 0x5a827999;
      else if (j <= 47)
        return 0x6ed9eba1;
      else if (j <= 63)
        return 0x8f1bbcdc;
      else
        return 0xa953fd4e;
    }

    function Kh(j) {
      if (j <= 15)
        return 0x50a28be6;
      else if (j <= 31)
        return 0x5c4dd124;
      else if (j <= 47)
        return 0x6d703ef3;
      else if (j <= 63)
        return 0x7a6d76e9;
      else
        return 0x00000000;
    }

    var r = [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
      7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
      3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
      1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
      4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
    ];

    var rh = [
      5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
      6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
      15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
      8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
      12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
    ];

    var s = [
      11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
      7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
      11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
      11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
      9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
    ];

    var sh = [
      8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
      9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
      9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
      15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
      8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
    ];

    },{"./common":13,"./utils":23}],16:[function(require,module,exports){
    'use strict';

    exports.sha1 = require('./sha/1');
    exports.sha224 = require('./sha/224');
    exports.sha256 = require('./sha/256');
    exports.sha384 = require('./sha/384');
    exports.sha512 = require('./sha/512');

    },{"./sha/1":17,"./sha/224":18,"./sha/256":19,"./sha/384":20,"./sha/512":21}],17:[function(require,module,exports){
    'use strict';

    var utils = require('../utils');
    var common = require('../common');
    var shaCommon = require('./common');

    var rotl32 = utils.rotl32;
    var sum32 = utils.sum32;
    var sum32_5 = utils.sum32_5;
    var ft_1 = shaCommon.ft_1;
    var BlockHash = common.BlockHash;

    var sha1_K = [
      0x5A827999, 0x6ED9EBA1,
      0x8F1BBCDC, 0xCA62C1D6
    ];

    function SHA1() {
      if (!(this instanceof SHA1))
        return new SHA1();

      BlockHash.call(this);
      this.h = [
        0x67452301, 0xefcdab89, 0x98badcfe,
        0x10325476, 0xc3d2e1f0 ];
      this.W = new Array(80);
    }

    utils.inherits(SHA1, BlockHash);
    module.exports = SHA1;

    SHA1.blockSize = 512;
    SHA1.outSize = 160;
    SHA1.hmacStrength = 80;
    SHA1.padLength = 64;

    SHA1.prototype._update = function _update(msg, start) {
      var W = this.W;

      for (var i = 0; i < 16; i++)
        W[i] = msg[start + i];

      for(; i < W.length; i++)
        W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

      var a = this.h[0];
      var b = this.h[1];
      var c = this.h[2];
      var d = this.h[3];
      var e = this.h[4];

      for (i = 0; i < W.length; i++) {
        var s = ~~(i / 20);
        var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
        e = d;
        d = c;
        c = rotl32(b, 30);
        b = a;
        a = t;
      }

      this.h[0] = sum32(this.h[0], a);
      this.h[1] = sum32(this.h[1], b);
      this.h[2] = sum32(this.h[2], c);
      this.h[3] = sum32(this.h[3], d);
      this.h[4] = sum32(this.h[4], e);
    };

    SHA1.prototype._digest = function digest(enc) {
      if (enc === 'hex')
        return utils.toHex32(this.h, 'big');
      else
        return utils.split32(this.h, 'big');
    };

    },{"../common":13,"../utils":23,"./common":22}],18:[function(require,module,exports){
    'use strict';

    var utils = require('../utils');
    var SHA256 = require('./256');

    function SHA224() {
      if (!(this instanceof SHA224))
        return new SHA224();

      SHA256.call(this);
      this.h = [
        0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
        0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
    }
    utils.inherits(SHA224, SHA256);
    module.exports = SHA224;

    SHA224.blockSize = 512;
    SHA224.outSize = 224;
    SHA224.hmacStrength = 192;
    SHA224.padLength = 64;

    SHA224.prototype._digest = function digest(enc) {
      // Just truncate output
      if (enc === 'hex')
        return utils.toHex32(this.h.slice(0, 7), 'big');
      else
        return utils.split32(this.h.slice(0, 7), 'big');
    };


    },{"../utils":23,"./256":19}],19:[function(require,module,exports){
    'use strict';

    var utils = require('../utils');
    var common = require('../common');
    var shaCommon = require('./common');
    var assert = require('minimalistic-assert');

    var sum32 = utils.sum32;
    var sum32_4 = utils.sum32_4;
    var sum32_5 = utils.sum32_5;
    var ch32 = shaCommon.ch32;
    var maj32 = shaCommon.maj32;
    var s0_256 = shaCommon.s0_256;
    var s1_256 = shaCommon.s1_256;
    var g0_256 = shaCommon.g0_256;
    var g1_256 = shaCommon.g1_256;

    var BlockHash = common.BlockHash;

    var sha256_K = [
      0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
      0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
      0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
      0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
      0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
      0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
      0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
      0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
      0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
      0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
      0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
      0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
      0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
      0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
      0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
      0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
    ];

    function SHA256() {
      if (!(this instanceof SHA256))
        return new SHA256();

      BlockHash.call(this);
      this.h = [
        0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
        0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
      ];
      this.k = sha256_K;
      this.W = new Array(64);
    }
    utils.inherits(SHA256, BlockHash);
    module.exports = SHA256;

    SHA256.blockSize = 512;
    SHA256.outSize = 256;
    SHA256.hmacStrength = 192;
    SHA256.padLength = 64;

    SHA256.prototype._update = function _update(msg, start) {
      var W = this.W;

      for (var i = 0; i < 16; i++)
        W[i] = msg[start + i];
      for (; i < W.length; i++)
        W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

      var a = this.h[0];
      var b = this.h[1];
      var c = this.h[2];
      var d = this.h[3];
      var e = this.h[4];
      var f = this.h[5];
      var g = this.h[6];
      var h = this.h[7];

      assert(this.k.length === W.length);
      for (i = 0; i < W.length; i++) {
        var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
        var T2 = sum32(s0_256(a), maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = sum32(T1, T2);
      }

      this.h[0] = sum32(this.h[0], a);
      this.h[1] = sum32(this.h[1], b);
      this.h[2] = sum32(this.h[2], c);
      this.h[3] = sum32(this.h[3], d);
      this.h[4] = sum32(this.h[4], e);
      this.h[5] = sum32(this.h[5], f);
      this.h[6] = sum32(this.h[6], g);
      this.h[7] = sum32(this.h[7], h);
    };

    SHA256.prototype._digest = function digest(enc) {
      if (enc === 'hex')
        return utils.toHex32(this.h, 'big');
      else
        return utils.split32(this.h, 'big');
    };

    },{"../common":13,"../utils":23,"./common":22,"minimalistic-assert":26}],20:[function(require,module,exports){
    'use strict';

    var utils = require('../utils');

    var SHA512 = require('./512');

    function SHA384() {
      if (!(this instanceof SHA384))
        return new SHA384();

      SHA512.call(this);
      this.h = [
        0xcbbb9d5d, 0xc1059ed8,
        0x629a292a, 0x367cd507,
        0x9159015a, 0x3070dd17,
        0x152fecd8, 0xf70e5939,
        0x67332667, 0xffc00b31,
        0x8eb44a87, 0x68581511,
        0xdb0c2e0d, 0x64f98fa7,
        0x47b5481d, 0xbefa4fa4 ];
    }
    utils.inherits(SHA384, SHA512);
    module.exports = SHA384;

    SHA384.blockSize = 1024;
    SHA384.outSize = 384;
    SHA384.hmacStrength = 192;
    SHA384.padLength = 128;

    SHA384.prototype._digest = function digest(enc) {
      if (enc === 'hex')
        return utils.toHex32(this.h.slice(0, 12), 'big');
      else
        return utils.split32(this.h.slice(0, 12), 'big');
    };

    },{"../utils":23,"./512":21}],21:[function(require,module,exports){
    'use strict';

    var utils = require('../utils');
    var common = require('../common');
    var assert = require('minimalistic-assert');

    var rotr64_hi = utils.rotr64_hi;
    var rotr64_lo = utils.rotr64_lo;
    var shr64_hi = utils.shr64_hi;
    var shr64_lo = utils.shr64_lo;
    var sum64 = utils.sum64;
    var sum64_hi = utils.sum64_hi;
    var sum64_lo = utils.sum64_lo;
    var sum64_4_hi = utils.sum64_4_hi;
    var sum64_4_lo = utils.sum64_4_lo;
    var sum64_5_hi = utils.sum64_5_hi;
    var sum64_5_lo = utils.sum64_5_lo;

    var BlockHash = common.BlockHash;

    var sha512_K = [
      0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
      0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
      0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
      0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
      0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
      0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
      0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
      0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
      0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
      0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
      0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
      0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
      0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
      0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
      0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
      0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
      0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
      0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
      0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
      0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
      0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
      0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
      0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
      0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
      0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
      0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
      0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
      0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
      0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
      0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
      0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
      0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
      0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
      0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
      0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
      0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
      0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
      0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
      0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
      0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
    ];

    function SHA512() {
      if (!(this instanceof SHA512))
        return new SHA512();

      BlockHash.call(this);
      this.h = [
        0x6a09e667, 0xf3bcc908,
        0xbb67ae85, 0x84caa73b,
        0x3c6ef372, 0xfe94f82b,
        0xa54ff53a, 0x5f1d36f1,
        0x510e527f, 0xade682d1,
        0x9b05688c, 0x2b3e6c1f,
        0x1f83d9ab, 0xfb41bd6b,
        0x5be0cd19, 0x137e2179 ];
      this.k = sha512_K;
      this.W = new Array(160);
    }
    utils.inherits(SHA512, BlockHash);
    module.exports = SHA512;

    SHA512.blockSize = 1024;
    SHA512.outSize = 512;
    SHA512.hmacStrength = 192;
    SHA512.padLength = 128;

    SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
      var W = this.W;

      // 32 x 32bit words
      for (var i = 0; i < 32; i++)
        W[i] = msg[start + i];
      for (; i < W.length; i += 2) {
        var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
        var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14];  // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
        var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32];  // i - 16
        var c3_lo = W[i - 31];

        W[i] = sum64_4_hi(
          c0_hi, c0_lo,
          c1_hi, c1_lo,
          c2_hi, c2_lo,
          c3_hi, c3_lo);
        W[i + 1] = sum64_4_lo(
          c0_hi, c0_lo,
          c1_hi, c1_lo,
          c2_hi, c2_lo,
          c3_hi, c3_lo);
      }
    };

    SHA512.prototype._update = function _update(msg, start) {
      this._prepareBlock(msg, start);

      var W = this.W;

      var ah = this.h[0];
      var al = this.h[1];
      var bh = this.h[2];
      var bl = this.h[3];
      var ch = this.h[4];
      var cl = this.h[5];
      var dh = this.h[6];
      var dl = this.h[7];
      var eh = this.h[8];
      var el = this.h[9];
      var fh = this.h[10];
      var fl = this.h[11];
      var gh = this.h[12];
      var gl = this.h[13];
      var hh = this.h[14];
      var hl = this.h[15];

      assert(this.k.length === W.length);
      for (var i = 0; i < W.length; i += 2) {
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = s1_512_hi(eh, el);
        var c1_lo = s1_512_lo(eh, el);
        var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];

        var T1_hi = sum64_5_hi(
          c0_hi, c0_lo,
          c1_hi, c1_lo,
          c2_hi, c2_lo,
          c3_hi, c3_lo,
          c4_hi, c4_lo);
        var T1_lo = sum64_5_lo(
          c0_hi, c0_lo,
          c1_hi, c1_lo,
          c2_hi, c2_lo,
          c3_hi, c3_lo,
          c4_hi, c4_lo);

        c0_hi = s0_512_hi(ah, al);
        c0_lo = s0_512_lo(ah, al);
        c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

        var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

        hh = gh;
        hl = gl;

        gh = fh;
        gl = fl;

        fh = eh;
        fl = el;

        eh = sum64_hi(dh, dl, T1_hi, T1_lo);
        el = sum64_lo(dl, dl, T1_hi, T1_lo);

        dh = ch;
        dl = cl;

        ch = bh;
        cl = bl;

        bh = ah;
        bl = al;

        ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
      }

      sum64(this.h, 0, ah, al);
      sum64(this.h, 2, bh, bl);
      sum64(this.h, 4, ch, cl);
      sum64(this.h, 6, dh, dl);
      sum64(this.h, 8, eh, el);
      sum64(this.h, 10, fh, fl);
      sum64(this.h, 12, gh, gl);
      sum64(this.h, 14, hh, hl);
    };

    SHA512.prototype._digest = function digest(enc) {
      if (enc === 'hex')
        return utils.toHex32(this.h, 'big');
      else
        return utils.split32(this.h, 'big');
    };

    function ch64_hi(xh, xl, yh, yl, zh) {
      var r = (xh & yh) ^ ((~xh) & zh);
      if (r < 0)
        r += 0x100000000;
      return r;
    }

    function ch64_lo(xh, xl, yh, yl, zh, zl) {
      var r = (xl & yl) ^ ((~xl) & zl);
      if (r < 0)
        r += 0x100000000;
      return r;
    }

    function maj64_hi(xh, xl, yh, yl, zh) {
      var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
      if (r < 0)
        r += 0x100000000;
      return r;
    }

    function maj64_lo(xh, xl, yh, yl, zh, zl) {
      var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
      if (r < 0)
        r += 0x100000000;
      return r;
    }

    function s0_512_hi(xh, xl) {
      var c0_hi = rotr64_hi(xh, xl, 28);
      var c1_hi = rotr64_hi(xl, xh, 2);  // 34
      var c2_hi = rotr64_hi(xl, xh, 7);  // 39

      var r = c0_hi ^ c1_hi ^ c2_hi;
      if (r < 0)
        r += 0x100000000;
      return r;
    }

    function s0_512_lo(xh, xl) {
      var c0_lo = rotr64_lo(xh, xl, 28);
      var c1_lo = rotr64_lo(xl, xh, 2);  // 34
      var c2_lo = rotr64_lo(xl, xh, 7);  // 39

      var r = c0_lo ^ c1_lo ^ c2_lo;
      if (r < 0)
        r += 0x100000000;
      return r;
    }

    function s1_512_hi(xh, xl) {
      var c0_hi = rotr64_hi(xh, xl, 14);
      var c1_hi = rotr64_hi(xh, xl, 18);
      var c2_hi = rotr64_hi(xl, xh, 9);  // 41

      var r = c0_hi ^ c1_hi ^ c2_hi;
      if (r < 0)
        r += 0x100000000;
      return r;
    }

    function s1_512_lo(xh, xl) {
      var c0_lo = rotr64_lo(xh, xl, 14);
      var c1_lo = rotr64_lo(xh, xl, 18);
      var c2_lo = rotr64_lo(xl, xh, 9);  // 41

      var r = c0_lo ^ c1_lo ^ c2_lo;
      if (r < 0)
        r += 0x100000000;
      return r;
    }

    function g0_512_hi(xh, xl) {
      var c0_hi = rotr64_hi(xh, xl, 1);
      var c1_hi = rotr64_hi(xh, xl, 8);
      var c2_hi = shr64_hi(xh, xl, 7);

      var r = c0_hi ^ c1_hi ^ c2_hi;
      if (r < 0)
        r += 0x100000000;
      return r;
    }

    function g0_512_lo(xh, xl) {
      var c0_lo = rotr64_lo(xh, xl, 1);
      var c1_lo = rotr64_lo(xh, xl, 8);
      var c2_lo = shr64_lo(xh, xl, 7);

      var r = c0_lo ^ c1_lo ^ c2_lo;
      if (r < 0)
        r += 0x100000000;
      return r;
    }

    function g1_512_hi(xh, xl) {
      var c0_hi = rotr64_hi(xh, xl, 19);
      var c1_hi = rotr64_hi(xl, xh, 29);  // 61
      var c2_hi = shr64_hi(xh, xl, 6);

      var r = c0_hi ^ c1_hi ^ c2_hi;
      if (r < 0)
        r += 0x100000000;
      return r;
    }

    function g1_512_lo(xh, xl) {
      var c0_lo = rotr64_lo(xh, xl, 19);
      var c1_lo = rotr64_lo(xl, xh, 29);  // 61
      var c2_lo = shr64_lo(xh, xl, 6);

      var r = c0_lo ^ c1_lo ^ c2_lo;
      if (r < 0)
        r += 0x100000000;
      return r;
    }

    },{"../common":13,"../utils":23,"minimalistic-assert":26}],22:[function(require,module,exports){
    'use strict';

    var utils = require('../utils');
    var rotr32 = utils.rotr32;

    function ft_1(s, x, y, z) {
      if (s === 0)
        return ch32(x, y, z);
      if (s === 1 || s === 3)
        return p32(x, y, z);
      if (s === 2)
        return maj32(x, y, z);
    }
    exports.ft_1 = ft_1;

    function ch32(x, y, z) {
      return (x & y) ^ ((~x) & z);
    }
    exports.ch32 = ch32;

    function maj32(x, y, z) {
      return (x & y) ^ (x & z) ^ (y & z);
    }
    exports.maj32 = maj32;

    function p32(x, y, z) {
      return x ^ y ^ z;
    }
    exports.p32 = p32;

    function s0_256(x) {
      return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
    }
    exports.s0_256 = s0_256;

    function s1_256(x) {
      return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
    }
    exports.s1_256 = s1_256;

    function g0_256(x) {
      return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
    }
    exports.g0_256 = g0_256;

    function g1_256(x) {
      return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
    }
    exports.g1_256 = g1_256;

    },{"../utils":23}],23:[function(require,module,exports){
    'use strict';

    var assert = require('minimalistic-assert');
    var inherits = require('inherits');

    exports.inherits = inherits;

    function isSurrogatePair(msg, i) {
      if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
        return false;
      }
      if (i < 0 || i + 1 >= msg.length) {
        return false;
      }
      return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
    }

    function toArray(msg, enc) {
      if (Array.isArray(msg))
        return msg.slice();
      if (!msg)
        return [];
      var res = [];
      if (typeof msg === 'string') {
        if (!enc) {
          // Inspired by stringToUtf8ByteArray() in closure-library by Google
          // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
          // Apache License 2.0
          // https://github.com/google/closure-library/blob/master/LICENSE
          var p = 0;
          for (var i = 0; i < msg.length; i++) {
            var c = msg.charCodeAt(i);
            if (c < 128) {
              res[p++] = c;
            } else if (c < 2048) {
              res[p++] = (c >> 6) | 192;
              res[p++] = (c & 63) | 128;
            } else if (isSurrogatePair(msg, i)) {
              c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
              res[p++] = (c >> 18) | 240;
              res[p++] = ((c >> 12) & 63) | 128;
              res[p++] = ((c >> 6) & 63) | 128;
              res[p++] = (c & 63) | 128;
            } else {
              res[p++] = (c >> 12) | 224;
              res[p++] = ((c >> 6) & 63) | 128;
              res[p++] = (c & 63) | 128;
            }
          }
        } else if (enc === 'hex') {
          msg = msg.replace(/[^a-z0-9]+/ig, '');
          if (msg.length % 2 !== 0)
            msg = '0' + msg;
          for (i = 0; i < msg.length; i += 2)
            res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
      } else {
        for (i = 0; i < msg.length; i++)
          res[i] = msg[i] | 0;
      }
      return res;
    }
    exports.toArray = toArray;

    function toHex(msg) {
      var res = '';
      for (var i = 0; i < msg.length; i++)
        res += zero2(msg[i].toString(16));
      return res;
    }
    exports.toHex = toHex;

    function htonl(w) {
      var res = (w >>> 24) |
                ((w >>> 8) & 0xff00) |
                ((w << 8) & 0xff0000) |
                ((w & 0xff) << 24);
      return res >>> 0;
    }
    exports.htonl = htonl;

    function toHex32(msg, endian) {
      var res = '';
      for (var i = 0; i < msg.length; i++) {
        var w = msg[i];
        if (endian === 'little')
          w = htonl(w);
        res += zero8(w.toString(16));
      }
      return res;
    }
    exports.toHex32 = toHex32;

    function zero2(word) {
      if (word.length === 1)
        return '0' + word;
      else
        return word;
    }
    exports.zero2 = zero2;

    function zero8(word) {
      if (word.length === 7)
        return '0' + word;
      else if (word.length === 6)
        return '00' + word;
      else if (word.length === 5)
        return '000' + word;
      else if (word.length === 4)
        return '0000' + word;
      else if (word.length === 3)
        return '00000' + word;
      else if (word.length === 2)
        return '000000' + word;
      else if (word.length === 1)
        return '0000000' + word;
      else
        return word;
    }
    exports.zero8 = zero8;

    function join32(msg, start, end, endian) {
      var len = end - start;
      assert(len % 4 === 0);
      var res = new Array(len / 4);
      for (var i = 0, k = start; i < res.length; i++, k += 4) {
        var w;
        if (endian === 'big')
          w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
        else
          w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
        res[i] = w >>> 0;
      }
      return res;
    }
    exports.join32 = join32;

    function split32(msg, endian) {
      var res = new Array(msg.length * 4);
      for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
        var m = msg[i];
        if (endian === 'big') {
          res[k] = m >>> 24;
          res[k + 1] = (m >>> 16) & 0xff;
          res[k + 2] = (m >>> 8) & 0xff;
          res[k + 3] = m & 0xff;
        } else {
          res[k + 3] = m >>> 24;
          res[k + 2] = (m >>> 16) & 0xff;
          res[k + 1] = (m >>> 8) & 0xff;
          res[k] = m & 0xff;
        }
      }
      return res;
    }
    exports.split32 = split32;

    function rotr32(w, b) {
      return (w >>> b) | (w << (32 - b));
    }
    exports.rotr32 = rotr32;

    function rotl32(w, b) {
      return (w << b) | (w >>> (32 - b));
    }
    exports.rotl32 = rotl32;

    function sum32(a, b) {
      return (a + b) >>> 0;
    }
    exports.sum32 = sum32;

    function sum32_3(a, b, c) {
      return (a + b + c) >>> 0;
    }
    exports.sum32_3 = sum32_3;

    function sum32_4(a, b, c, d) {
      return (a + b + c + d) >>> 0;
    }
    exports.sum32_4 = sum32_4;

    function sum32_5(a, b, c, d, e) {
      return (a + b + c + d + e) >>> 0;
    }
    exports.sum32_5 = sum32_5;

    function sum64(buf, pos, ah, al) {
      var bh = buf[pos];
      var bl = buf[pos + 1];

      var lo = (al + bl) >>> 0;
      var hi = (lo < al ? 1 : 0) + ah + bh;
      buf[pos] = hi >>> 0;
      buf[pos + 1] = lo;
    }
    exports.sum64 = sum64;

    function sum64_hi(ah, al, bh, bl) {
      var lo = (al + bl) >>> 0;
      var hi = (lo < al ? 1 : 0) + ah + bh;
      return hi >>> 0;
    }
    exports.sum64_hi = sum64_hi;

    function sum64_lo(ah, al, bh, bl) {
      var lo = al + bl;
      return lo >>> 0;
    }
    exports.sum64_lo = sum64_lo;

    function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
      var carry = 0;
      var lo = al;
      lo = (lo + bl) >>> 0;
      carry += lo < al ? 1 : 0;
      lo = (lo + cl) >>> 0;
      carry += lo < cl ? 1 : 0;
      lo = (lo + dl) >>> 0;
      carry += lo < dl ? 1 : 0;

      var hi = ah + bh + ch + dh + carry;
      return hi >>> 0;
    }
    exports.sum64_4_hi = sum64_4_hi;

    function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
      var lo = al + bl + cl + dl;
      return lo >>> 0;
    }
    exports.sum64_4_lo = sum64_4_lo;

    function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
      var carry = 0;
      var lo = al;
      lo = (lo + bl) >>> 0;
      carry += lo < al ? 1 : 0;
      lo = (lo + cl) >>> 0;
      carry += lo < cl ? 1 : 0;
      lo = (lo + dl) >>> 0;
      carry += lo < dl ? 1 : 0;
      lo = (lo + el) >>> 0;
      carry += lo < el ? 1 : 0;

      var hi = ah + bh + ch + dh + eh + carry;
      return hi >>> 0;
    }
    exports.sum64_5_hi = sum64_5_hi;

    function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
      var lo = al + bl + cl + dl + el;

      return lo >>> 0;
    }
    exports.sum64_5_lo = sum64_5_lo;

    function rotr64_hi(ah, al, num) {
      var r = (al << (32 - num)) | (ah >>> num);
      return r >>> 0;
    }
    exports.rotr64_hi = rotr64_hi;

    function rotr64_lo(ah, al, num) {
      var r = (ah << (32 - num)) | (al >>> num);
      return r >>> 0;
    }
    exports.rotr64_lo = rotr64_lo;

    function shr64_hi(ah, al, num) {
      return ah >>> num;
    }
    exports.shr64_hi = shr64_hi;

    function shr64_lo(ah, al, num) {
      var r = (ah << (32 - num)) | (al >>> num);
      return r >>> 0;
    }
    exports.shr64_lo = shr64_lo;

    },{"inherits":25,"minimalistic-assert":26}],24:[function(require,module,exports){
    exports.read = function (buffer, offset, isLE, mLen, nBytes) {
      var e, m
      var eLen = (nBytes * 8) - mLen - 1
      var eMax = (1 << eLen) - 1
      var eBias = eMax >> 1
      var nBits = -7
      var i = isLE ? (nBytes - 1) : 0
      var d = isLE ? -1 : 1
      var s = buffer[offset + i]

      i += d

      e = s & ((1 << (-nBits)) - 1)
      s >>= (-nBits)
      nBits += eLen
      for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

      m = e & ((1 << (-nBits)) - 1)
      e >>= (-nBits)
      nBits += mLen
      for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

      if (e === 0) {
        e = 1 - eBias
      } else if (e === eMax) {
        return m ? NaN : ((s ? -1 : 1) * Infinity)
      } else {
        m = m + Math.pow(2, mLen)
        e = e - eBias
      }
      return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
    }

    exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
      var e, m, c
      var eLen = (nBytes * 8) - mLen - 1
      var eMax = (1 << eLen) - 1
      var eBias = eMax >> 1
      var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
      var i = isLE ? 0 : (nBytes - 1)
      var d = isLE ? 1 : -1
      var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

      value = Math.abs(value)

      if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0
        e = eMax
      } else {
        e = Math.floor(Math.log(value) / Math.LN2)
        if (value * (c = Math.pow(2, -e)) < 1) {
          e--
          c *= 2
        }
        if (e + eBias >= 1) {
          value += rt / c
        } else {
          value += rt * Math.pow(2, 1 - eBias)
        }
        if (value * c >= 2) {
          e++
          c /= 2
        }

        if (e + eBias >= eMax) {
          m = 0
          e = eMax
        } else if (e + eBias >= 1) {
          m = ((value * c) - 1) * Math.pow(2, mLen)
          e = e + eBias
        } else {
          m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
          e = 0
        }
      }

      for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

      e = (e << mLen) | m
      eLen += mLen
      for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

      buffer[offset + i - d] |= s * 128
    }

    },{}],25:[function(require,module,exports){
    if (typeof Object.create === 'function') {
      // implementation from standard node.js 'util' module
      module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
          ctor.super_ = superCtor
          ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
              value: ctor,
              enumerable: false,
              writable: true,
              configurable: true
            }
          })
        }
      };
    } else {
      // old school shim for old browsers
      module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
          ctor.super_ = superCtor
          var TempCtor = function () {}
          TempCtor.prototype = superCtor.prototype
          ctor.prototype = new TempCtor()
          ctor.prototype.constructor = ctor
        }
      }
    }

    },{}],26:[function(require,module,exports){
    module.exports = assert;

    function assert(val, msg) {
      if (!val)
        throw new Error(msg || 'Assertion failed');
    }

    assert.equal = function assertEqual(l, r, msg) {
      if (l != r)
        throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
    };

    },{}],27:[function(require,module,exports){
    /*
    object-assign
    (c) Sindre Sorhus
    @license MIT
    */

    'use strict';
    /* eslint-disable no-unused-vars */
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;

    function toObject(val) {
        if (val === null || val === undefined) {
            throw new TypeError('Object.assign cannot be called with null or undefined');
        }

        return Object(val);
    }

    function shouldUseNative() {
        try {
            if (!Object.assign) {
                return false;
            }

            // Detect buggy property enumeration order in older V8 versions.

            // https://bugs.chromium.org/p/v8/issues/detail?id=4118
            var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
            test1[5] = 'de';
            if (Object.getOwnPropertyNames(test1)[0] === '5') {
                return false;
            }

            // https://bugs.chromium.org/p/v8/issues/detail?id=3056
            var test2 = {};
            for (var i = 0; i < 10; i++) {
                test2['_' + String.fromCharCode(i)] = i;
            }
            var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
                return test2[n];
            });
            if (order2.join('') !== '0123456789') {
                return false;
            }

            // https://bugs.chromium.org/p/v8/issues/detail?id=3056
            var test3 = {};
            'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
                test3[letter] = letter;
            });
            if (Object.keys(Object.assign({}, test3)).join('') !==
                    'abcdefghijklmnopqrst') {
                return false;
            }

            return true;
        } catch (err) {
            // We don't expect any of the above to throw, but better to be safe.
            return false;
        }
    }

    module.exports = shouldUseNative() ? Object.assign : function (target, source) {
        var from;
        var to = toObject(target);
        var symbols;

        for (var s = 1; s < arguments.length; s++) {
            from = Object(arguments[s]);

            for (var key in from) {
                if (hasOwnProperty.call(from, key)) {
                    to[key] = from[key];
                }
            }

            if (getOwnPropertySymbols) {
                symbols = getOwnPropertySymbols(from);
                for (var i = 0; i < symbols.length; i++) {
                    if (propIsEnumerable.call(from, symbols[i])) {
                        to[symbols[i]] = from[symbols[i]];
                    }
                }
            }
        }

        return to;
    };

    },{}],28:[function(require,module,exports){
    // shim for using process in browser
    var process = module.exports = {};

    // cached from whatever global is present so that test runners that stub it
    // don't break things.  But we need to wrap it in a try catch in case it is
    // wrapped in strict mode code which doesn't define any globals.  It's inside a
    // function because try/catches deoptimize in certain engines.

    var cachedSetTimeout;
    var cachedClearTimeout;

    function defaultSetTimout() {
        throw new Error('setTimeout has not been defined');
    }
    function defaultClearTimeout () {
        throw new Error('clearTimeout has not been defined');
    }
    (function () {
        try {
            if (typeof setTimeout === 'function') {
                cachedSetTimeout = setTimeout;
            } else {
                cachedSetTimeout = defaultSetTimout;
            }
        } catch (e) {
            cachedSetTimeout = defaultSetTimout;
        }
        try {
            if (typeof clearTimeout === 'function') {
                cachedClearTimeout = clearTimeout;
            } else {
                cachedClearTimeout = defaultClearTimeout;
            }
        } catch (e) {
            cachedClearTimeout = defaultClearTimeout;
        }
    } ())
    function runTimeout(fun) {
        if (cachedSetTimeout === setTimeout) {
            //normal enviroments in sane situations
            return setTimeout(fun, 0);
        }
        // if setTimeout wasn't available but was latter defined
        if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
            cachedSetTimeout = setTimeout;
            return setTimeout(fun, 0);
        }
        try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedSetTimeout(fun, 0);
        } catch(e){
            try {
                // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                return cachedSetTimeout.call(null, fun, 0);
            } catch(e){
                // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                return cachedSetTimeout.call(this, fun, 0);
            }
        }


    }
    function runClearTimeout(marker) {
        if (cachedClearTimeout === clearTimeout) {
            //normal enviroments in sane situations
            return clearTimeout(marker);
        }
        // if clearTimeout wasn't available but was latter defined
        if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
            cachedClearTimeout = clearTimeout;
            return clearTimeout(marker);
        }
        try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedClearTimeout(marker);
        } catch (e){
            try {
                // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                return cachedClearTimeout.call(null, marker);
            } catch (e){
                // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                return cachedClearTimeout.call(this, marker);
            }
        }



    }
    var queue = [];
    var draining = false;
    var currentQueue;
    var queueIndex = -1;

    function cleanUpNextTick() {
        if (!draining || !currentQueue) {
            return;
        }
        draining = false;
        if (currentQueue.length) {
            queue = currentQueue.concat(queue);
        } else {
            queueIndex = -1;
        }
        if (queue.length) {
            drainQueue();
        }
    }

    function drainQueue() {
        if (draining) {
            return;
        }
        var timeout = runTimeout(cleanUpNextTick);
        draining = true;

        var len = queue.length;
        while(len) {
            currentQueue = queue;
            queue = [];
            while (++queueIndex < len) {
                if (currentQueue) {
                    currentQueue[queueIndex].run();
                }
            }
            queueIndex = -1;
            len = queue.length;
        }
        currentQueue = null;
        draining = false;
        runClearTimeout(timeout);
    }

    process.nextTick = function (fun) {
        var args = new Array(arguments.length - 1);
        if (arguments.length > 1) {
            for (var i = 1; i < arguments.length; i++) {
                args[i - 1] = arguments[i];
            }
        }
        queue.push(new Item(fun, args));
        if (queue.length === 1 && !draining) {
            runTimeout(drainQueue);
        }
    };

    // v8 likes predictible objects
    function Item(fun, array) {
        this.fun = fun;
        this.array = array;
    }
    Item.prototype.run = function () {
        this.fun.apply(null, this.array);
    };
    process.title = 'browser';
    process.browser = true;
    process.env = {};
    process.argv = [];
    process.version = ''; // empty string to avoid regexp issues
    process.versions = {};

    function noop() {}

    process.on = noop;
    process.addListener = noop;
    process.once = noop;
    process.off = noop;
    process.removeListener = noop;
    process.removeAllListeners = noop;
    process.emit = noop;
    process.prependListener = noop;
    process.prependOnceListener = noop;

    process.listeners = function (name) { return [] }

    process.binding = function (name) {
        throw new Error('process.binding is not supported');
    };

    process.cwd = function () { return '/' };
    process.chdir = function (dir) {
        throw new Error('process.chdir is not supported');
    };
    process.umask = function() { return 0; };

    },{}],29:[function(require,module,exports){
    'use strict';

    var hashjs = require('hash.js');
    var apiFactory = require('x-address-codec');

    var NODE_PUBLIC = 28;
    var NODE_PRIVATE = 32;
    var ACCOUNT_ID = 0;
    var FAMILY_SEED = 33;
    var ED25519_SEED = [0x01, 0xE1, 0x4B];

    module.exports = apiFactory({
      sha256: function(bytes) {
        return hashjs.sha256().update(bytes).digest();
      },
      defaultAlphabet: 'ripple',
      codecMethods: {
        EdSeed: {
          expectedLength: 16,
          version: ED25519_SEED
        },
        Seed: {
          // TODO: Use a map, not a parallel array
          versionTypes: ['ed25519', 'secp256k1'],
          versions: [ED25519_SEED, FAMILY_SEED],
          expectedLength: 16
        },
        AccountID: {version: ACCOUNT_ID, expectedLength: 20},
        Address: {version: ACCOUNT_ID, expectedLength: 20},
        NodePublic: {version: NODE_PUBLIC, expectedLength: 33},
        NodePrivate: {version: NODE_PRIVATE, expectedLength: 32},
        K256Seed: {version: FAMILY_SEED, expectedLength: 16}}
    });

    },{"hash.js":12,"x-address-codec":31}],30:[function(require,module,exports){
    'use strict';

    var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

    var baseCodec = require('base-x');

    var _require = require('./utils');

    var seqEqual = _require.seqEqual;
    var concatArgs = _require.concatArgs;
    var isSet = _require.isSet;

    /* --------------------------------- ENCODER -------------------------------- */

    function codecFactory(injected) {

      /* eslint-disable indent */
      var sha256 = injected.sha256;

      var AddressCodec = (function () {
        /* eslint-enable indent */

        function AddressCodec(alphabet) {
          _classCallCheck(this, AddressCodec);

          this.alphabet = alphabet;
          this.codec = baseCodec(alphabet);
          this.base = alphabet.length;
        }

        /* eslint-disable indent */

        _createClass(AddressCodec, [{
          key: 'encode',
          value: function encode(bytes) {
            var opts = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
            var version = opts.version;

            return isSet(version) ? this.encodeVersioned(bytes, version, opts.expectedLength) : opts.checked ? this.encodeChecked(bytes) : this.encodeRaw(bytes);
          }
        }, {
          key: 'decode',
          value: function decode(string) {
            var opts = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
            var version = opts.version;
            var versions = opts.versions;

            return isSet(versions) ? this.decodeMultiVersioned(string, versions, opts.expectedLength, opts.versionTypes) : isSet(version) ? this.decodeVersioned(string, version, opts.expectedLength) : opts.checked ? this.decodeChecked(string) : this.decodeRaw(string);
          }
        }, {
          key: 'encodeRaw',
          value: function encodeRaw(bytes) {
            return this.codec.encode(bytes);
          }
        }, {
          key: 'decodeRaw',
          value: function decodeRaw(string) {
            return this.codec.decode(string);
          }
        }, {
          key: 'encodeChecked',
          value: function encodeChecked(buffer) {
            var check = sha256(sha256(buffer)).slice(0, 4);
            return this.encodeRaw(concatArgs(buffer, check));
          }
        }, {
          key: 'decodeChecked',
          value: function decodeChecked(encoded) {
            var buf = this.decodeRaw(encoded);
            if (buf.length < 5) {
              throw new Error('invalid_input_size');
            }
            if (!this.verifyCheckSum(buf)) {
              throw new Error('checksum_invalid');
            }
            return buf.slice(0, -4);
          }
        }, {
          key: 'encodeVersioned',
          value: function encodeVersioned(bytes, version, expectedLength) {
            if (expectedLength && bytes.length !== expectedLength) {
              throw new Error('unexpected_payload_length');
            }
            return this.encodeChecked(concatArgs(version, bytes));
          }
        }, {
          key: 'decodeVersioned',
          value: function decodeVersioned(string, version, expectedLength) {
            return this.decodeMultiVersioned(string, [version], expectedLength).bytes;
          }

          /**
          * @param {String} encoded - base58 checksum encoded data string
          * @param {Array} possibleVersions - array of possible versions.
          *                                   Each element could be a single byte or an
          *                                   array of bytes.
          * @param {Number} [expectedLength] - of decoded bytes minus checksum
          *
          * @param {Array} [types] - parrallel array of names matching possibleVersions
          *
          * @return {Object} -
          */
        }, {
          key: 'decodeMultiVersioned',
          value: function decodeMultiVersioned(encoded, possibleVersions, expectedLength, types) {
            var withoutSum = this.decodeChecked(encoded);
            var ret = { version: null, bytes: null };

            if (possibleVersions.length > 1 && !expectedLength) {
              throw new Error('must pass expectedLengthgth > 1 possibleVersions');
            }

            var versionLenGuess = possibleVersions[0].length || 1; // Number.length
            var payloadLength = expectedLength || withoutSum.length - versionLenGuess;
            var versionBytes = withoutSum.slice(0, -payloadLength);
            var payload = withoutSum.slice(-payloadLength);

            var foundVersion = possibleVersions.some(function (version, i) {
              var asArray = Array.isArray(version) ? version : [version];
              if (seqEqual(versionBytes, asArray)) {
                ret.version = version;
                ret.bytes = payload;
                if (types) {
                  ret.type = types[i];
                }
                return true;
              }
            });

            if (!foundVersion) {
              throw new Error('version_invalid');
            }
            if (expectedLength && ret.bytes.length !== expectedLength) {
              throw new Error('unexpected_payload_length');
            }

            return ret;
          }
        }, {
          key: 'verifyCheckSum',
          value: function verifyCheckSum(bytes) {
            var computed = sha256(sha256(bytes.slice(0, -4))).slice(0, 4);
            var checksum = bytes.slice(-4);
            return seqEqual(computed, checksum);
          }

          /**
          * @param {String} desiredPrefix - desired prefix when base58 encoded with
          *                                 checksum
          * @param {Number} payloadLength - number of bytes encoded not incl checksum
          * @return {Array} version
          */
        }, {
          key: 'findPrefix',
          value: function findPrefix(desiredPrefix, payloadLength) {
            if (this.base !== 58) {
              throw new Error('Only works for base58');
            }
            var totalLength = payloadLength + 4; // for checksum
            var chars = Math.log(Math.pow(256, totalLength)) / Math.log(this.base);
            // (x, x.8] -> x+1, (x.8, x+1) -> x+2
            var requiredChars = Math.ceil(chars + 0.2);
            var padding = this.alphabet[Math.floor(this.alphabet.length / 2) - 1];
            var template = desiredPrefix + new Array(requiredChars + 1).join(padding);
            var bytes = this.decodeRaw(template);
            var version = bytes.slice(0, -totalLength);
            return version;
          }
        }]);

        return AddressCodec;
      })();

      return AddressCodec;
      /* eslint-enable indent */
    }
    /* ------------------------------- END ENCODER ------------------------------ */

    module.exports = codecFactory;
    },{"./utils":32,"base-x":9}],31:[function(require,module,exports){
    'use strict';

    var codecFactory = require('./address-codec');

    var ALPHABETS = {
      bitcoin: '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz',
      ripple: 'rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz',
      tipple: 'RPShNAF39wBUDnEGHJKLM4pQrsT7VWXYZ2bcdeCg65jkm8ofqi1tuvaxyz',
      stellar: 'gsphnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCr65jkm8oFqi1tuvAxyz'
    };

    function addMethods(codecMethods, api) {
      function addVersion(name, opts) {
        function add(operation) {
          var encode = operation === 'encode';
          var func = api[operation + name] = function (arg, arg2) {
            var params = opts;
            if (arg2 && encode) {
              params = {
                expectedLength: opts.expectedLength,
                version: opts.versions[opts.versionTypes.indexOf(arg2)]
              };
            }
            return api[operation](arg, params);
          };
          return func;
        }
        var decode = add('decode');
        add('encode');
        api['isValid' + name] = function (arg) {
          try {
            decode(arg);
          } catch (e) {
            return false;
          }
          return true;
        };
      }
      for (var k in codecMethods) {
        addVersion(k, codecMethods[k]);
      }
      return api;
    }

    function buildCodecsMap(alphabets, Codec) {
      var codecs = {};
      for (var _name in ALPHABETS) {
        codecs[_name] = new Codec(ALPHABETS[_name]);
      }if (alphabets !== ALPHABETS) {
        for (var _name2 in alphabets) {
          codecs[_name2] = new Codec(alphabets[_name2]);
        }
      }
      return codecs;
    }

    function apiFactory(options) {
      var _options$alphabets = options.alphabets;
      var alphabets = _options$alphabets === undefined ? ALPHABETS : _options$alphabets;
      var _options$codecMethods = options.codecMethods;
      var codecMethods = _options$codecMethods === undefined ? {} : _options$codecMethods;
      var _options$defaultAlphabet = options.defaultAlphabet;
      var defaultAlphabet = _options$defaultAlphabet === undefined ? Object.keys(alphabets)[0] : _options$defaultAlphabet;

      var Codec = codecFactory(options);
      var codecs = buildCodecsMap(alphabets, Codec);

      return addMethods(codecMethods, {
        Codec: Codec,
        codecs: codecs,
        decode: function decode(string) {
          var opts = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
          var _opts$alphabet = opts.alphabet;
          var alphabet = _opts$alphabet === undefined ? defaultAlphabet : _opts$alphabet;

          return codecs[alphabet].decode(string, opts);
        },
        encode: function encode(bytes) {
          var opts = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
          var _opts$alphabet2 = opts.alphabet;
          var alphabet = _opts$alphabet2 === undefined ? defaultAlphabet : _opts$alphabet2;

          return codecs[alphabet].encode(bytes, opts);
        }
      });
    }

    module.exports = apiFactory;
    },{"./address-codec":30}],32:[function(require,module,exports){
    'use strict';

    function seqEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) {
        return false;
      }

      for (var i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      }
      return true;
    }

    function isSequence(val) {
      return val.length !== undefined;
    }

    /**
    * Concatenates all `arguments` into a single array. Each argument can be either
    * a single element or a sequence, which has a `length` property and supports
    * element retrieval via sequence[ix].
    *
    * > concatArgs(1, [2, 3], new Buffer([4,5]), new Uint8Array([6, 7]));
    *  [1,2,3,4,5,6,7]
    *
    * @return {Array} - concatenated arguments
    */
    function concatArgs() {
      var ret = [];

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      args.forEach(function (arg) {
        if (isSequence(arg)) {
          for (var j = 0; j < arg.length; j++) {
            ret.push(arg[j]);
          }
        } else {
          ret.push(arg);
        }
      });
      return ret;
    }

    function isSet(o) {
      return o !== null && o !== undefined;
    }

    module.exports = {
      seqEqual: seqEqual,
      concatArgs: concatArgs,
      isSet: isSet
    };
    },{}],"xrpl-tagged-address-codec":[function(require,module,exports){
    "use strict";
    var __importDefault = (this && this.__importDefault) || function (mod) {
        return (mod && mod.__esModule) ? mod : { "default": mod };
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    var encode_1 = __importDefault(require("./methods/encode"));
    exports.Encode = encode_1.default;
    var decode_1 = __importDefault(require("./methods/decode"));
    exports.Decode = decode_1.default;

    },{"./methods/decode":2,"./methods/encode":3}]},{},[]);

/**
 * @license
 * https://github.com/ealmansi/bchaddrjs
 * Copyright (c) 2018-2020 Emilio Almansi
 * Distributed under the MIT software license, see the accompanying
 * file LICENSE or http://www.opensource.org/licenses/mit-license.php.
 */
!function(f){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=f();else if("function"==typeof define&&define.amd)define([],f);else{("undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this).bchaddr=f()}}(function(){return function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){return o(e[i][1][r]||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}({1:[function(require,module,exports){var Buffer=require("safe-buffer").Buffer;module.exports=function(ALPHABET){for(var ALPHABET_MAP={},BASE=ALPHABET.length,LEADER=ALPHABET.charAt(0),z=0;z<ALPHABET.length;z++){var x=ALPHABET.charAt(z);if(void 0!==ALPHABET_MAP[x])throw new TypeError(x+" is ambiguous");ALPHABET_MAP[x]=z}function decodeUnsafe(string){if("string"!=typeof string)throw new TypeError("Expected String");if(0===string.length)return Buffer.allocUnsafe(0);for(var bytes=[0],i=0;i<string.length;i++){var value=ALPHABET_MAP[string[i]];if(void 0===value)return;for(var j=0,carry=value;j<bytes.length;++j)carry+=bytes[j]*BASE,bytes[j]=255&carry,carry>>=8;for(;0<carry;)bytes.push(255&carry),carry>>=8}for(var k=0;string[k]===LEADER&&k<string.length-1;++k)bytes.push(0);return Buffer.from(bytes.reverse())}return{encode:function(source){if(0===source.length)return"";for(var digits=[0],i=0;i<source.length;++i){for(var j=0,carry=source[i];j<digits.length;++j)carry+=digits[j]<<8,digits[j]=carry%BASE,carry=carry/BASE|0;for(;0<carry;)digits.push(carry%BASE),carry=carry/BASE|0}for(var string="",k=0;0===source[k]&&k<source.length-1;++k)string+=LEADER;for(var q=digits.length-1;0<=q;--q)string+=ALPHABET[digits[q]];return string},decodeUnsafe:decodeUnsafe,decode:function(string){var buffer=decodeUnsafe(string);if(buffer)return buffer;throw new Error("Non-base"+BASE+" character")}}}},{"safe-buffer":42}],2:[function(require,module,exports){"use strict";exports.byteLength=function(b64){var lens=getLens(b64),validLen=lens[0],placeHoldersLen=lens[1];return 3*(validLen+placeHoldersLen)/4-placeHoldersLen},exports.toByteArray=function(b64){var tmp,i,lens=getLens(b64),validLen=lens[0],placeHoldersLen=lens[1],arr=new Arr(function(validLen,placeHoldersLen){return 3*(validLen+placeHoldersLen)/4-placeHoldersLen}(validLen,placeHoldersLen)),curByte=0,len=0<placeHoldersLen?validLen-4:validLen;for(i=0;i<len;i+=4)tmp=revLookup[b64.charCodeAt(i)]<<18|revLookup[b64.charCodeAt(i+1)]<<12|revLookup[b64.charCodeAt(i+2)]<<6|revLookup[b64.charCodeAt(i+3)],arr[curByte++]=tmp>>16&255,arr[curByte++]=tmp>>8&255,arr[curByte++]=255&tmp;2===placeHoldersLen&&(tmp=revLookup[b64.charCodeAt(i)]<<2|revLookup[b64.charCodeAt(i+1)]>>4,arr[curByte++]=255&tmp);1===placeHoldersLen&&(tmp=revLookup[b64.charCodeAt(i)]<<10|revLookup[b64.charCodeAt(i+1)]<<4|revLookup[b64.charCodeAt(i+2)]>>2,arr[curByte++]=tmp>>8&255,arr[curByte++]=255&tmp);return arr},exports.fromByteArray=function(uint8){for(var tmp,len=uint8.length,extraBytes=len%3,parts=[],i=0,len2=len-extraBytes;i<len2;i+=16383)parts.push(encodeChunk(uint8,i,len2<i+16383?len2:i+16383));1==extraBytes?(tmp=uint8[len-1],parts.push(lookup[tmp>>2]+lookup[tmp<<4&63]+"==")):2==extraBytes&&(tmp=(uint8[len-2]<<8)+uint8[len-1],parts.push(lookup[tmp>>10]+lookup[tmp>>4&63]+lookup[tmp<<2&63]+"="));return parts.join("")};for(var lookup=[],revLookup=[],Arr="undefined"!=typeof Uint8Array?Uint8Array:Array,code="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",i=0,len=code.length;i<len;++i)lookup[i]=code[i],revLookup[code.charCodeAt(i)]=i;function getLens(b64){var len=b64.length;if(0<len%4)throw new Error("Invalid string. Length must be a multiple of 4");var validLen=b64.indexOf("=");return-1===validLen&&(validLen=len),[validLen,validLen===len?0:4-validLen%4]}function encodeChunk(uint8,start,end){for(var tmp,num,output=[],i=start;i<end;i+=3)tmp=(uint8[i]<<16&16711680)+(uint8[i+1]<<8&65280)+(255&uint8[i+2]),output.push(lookup[(num=tmp)>>18&63]+lookup[num>>12&63]+lookup[num>>6&63]+lookup[63&num]);return output.join("")}revLookup["-".charCodeAt(0)]=62,revLookup["_".charCodeAt(0)]=63},{}],3:[function(require,module,exports){var bigInt=function(){"use strict";var BASE=1e7,LOG_BASE=7,MAX_INT=9007199254740992,MAX_INT_ARR=smallToArray(MAX_INT),LOG_MAX_INT=Math.log(MAX_INT);function Integer(v,radix){return void 0===v?Integer[0]:void 0===radix||10==+radix?parseValue(v):parseBase(v,radix)}function BigInteger(value,sign){this.value=value,this.sign=sign,this.isSmall=!1}function SmallInteger(value){this.value=value,this.sign=value<0,this.isSmall=!0}function isPrecise(n){return-MAX_INT<n&&n<MAX_INT}function smallToArray(n){return n<1e7?[n]:n<1e14?[n%1e7,Math.floor(n/1e7)]:[n%1e7,Math.floor(n/1e7)%1e7,Math.floor(n/1e14)]}function arrayToSmall(arr){trim(arr);var length=arr.length;if(length<4&&compareAbs(arr,MAX_INT_ARR)<0)switch(length){case 0:return 0;case 1:return arr[0];case 2:return arr[0]+arr[1]*BASE;default:return arr[0]+(arr[1]+arr[2]*BASE)*BASE}return arr}function trim(v){for(var i=v.length;0===v[--i];);v.length=i+1}function createArray(length){for(var x=new Array(length),i=-1;++i<length;)x[i]=0;return x}function truncate(n){return 0<n?Math.floor(n):Math.ceil(n)}function add(a,b){var sum,i,l_a=a.length,l_b=b.length,r=new Array(l_a),carry=0,base=BASE;for(i=0;i<l_b;i++)carry=base<=(sum=a[i]+b[i]+carry)?1:0,r[i]=sum-carry*base;for(;i<l_a;)carry=(sum=a[i]+carry)===base?1:0,r[i++]=sum-carry*base;return 0<carry&&r.push(carry),r}function addAny(a,b){return a.length>=b.length?add(a,b):add(b,a)}function addSmall(a,carry){var sum,i,l=a.length,r=new Array(l),base=BASE;for(i=0;i<l;i++)sum=a[i]-base+carry,carry=Math.floor(sum/base),r[i]=sum-carry*base,carry+=1;for(;0<carry;)r[i++]=carry%base,carry=Math.floor(carry/base);return r}function subtract(a,b){var i,difference,a_l=a.length,b_l=b.length,r=new Array(a_l),borrow=0,base=BASE;for(i=0;i<b_l;i++)borrow=(difference=a[i]-borrow-b[i])<0?(difference+=base,1):0,r[i]=difference;for(i=b_l;i<a_l;i++){if(!((difference=a[i]-borrow)<0)){r[i++]=difference;break}difference+=base,r[i]=difference}for(;i<a_l;i++)r[i]=a[i];return trim(r),r}function subtractSmall(a,b,sign){var i,difference,l=a.length,r=new Array(l),carry=-b,base=BASE;for(i=0;i<l;i++)difference=a[i]+carry,carry=Math.floor(difference/base),difference%=base,r[i]=difference<0?difference+base:difference;return"number"==typeof(r=arrayToSmall(r))?(sign&&(r=-r),new SmallInteger(r)):new BigInteger(r,sign)}function multiplyLong(a,b){var product,carry,i,a_i,a_l=a.length,b_l=b.length,r=createArray(a_l+b_l),base=BASE;for(i=0;i<a_l;++i){a_i=a[i];for(var j=0;j<b_l;++j)product=a_i*b[j]+r[i+j],carry=Math.floor(product/base),r[i+j]=product-carry*base,r[i+j+1]+=carry}return trim(r),r}function multiplySmall(a,b){var product,i,l=a.length,r=new Array(l),base=BASE,carry=0;for(i=0;i<l;i++)product=a[i]*b+carry,carry=Math.floor(product/base),r[i]=product-carry*base;for(;0<carry;)r[i++]=carry%base,carry=Math.floor(carry/base);return r}function shiftLeft(x,n){for(var r=[];0<n--;)r.push(0);return r.concat(x)}function multiplySmallAndArray(a,b,sign){return new BigInteger(a<BASE?multiplySmall(b,a):multiplyLong(b,smallToArray(a)),sign)}function square(a){var product,carry,i,a_i,l=a.length,r=createArray(l+l),base=BASE;for(i=0;i<l;i++){carry=0-(a_i=a[i])*a_i;for(var j=i;j<l;j++)product=a_i*a[j]*2+r[i+j]+carry,carry=Math.floor(product/base),r[i+j]=product-carry*base;r[i+l]=carry}return trim(r),r}function divModSmall(value,lambda){var i,q,remainder,divisor,length=value.length,quotient=createArray(length),base=BASE;for(remainder=0,i=length-1;0<=i;--i)remainder=(divisor=remainder*base+value[i])-(q=truncate(divisor/lambda))*lambda,quotient[i]=0|q;return[quotient,0|remainder]}function divModAny(self,v){var value,quotient,n=parseValue(v),a=self.value,b=n.value;if(0===b)throw new Error("Cannot divide by zero");if(self.isSmall)return n.isSmall?[new SmallInteger(truncate(a/b)),new SmallInteger(a%b)]:[Integer[0],self];if(n.isSmall){if(1===b)return[self,Integer[0]];if(-1==b)return[self.negate(),Integer[0]];var abs=Math.abs(b);if(abs<BASE){quotient=arrayToSmall((value=divModSmall(a,abs))[0]);var remainder=value[1];return self.sign&&(remainder=-remainder),"number"==typeof quotient?(self.sign!==n.sign&&(quotient=-quotient),[new SmallInteger(quotient),new SmallInteger(remainder)]):[new BigInteger(quotient,self.sign!==n.sign),new SmallInteger(remainder)]}b=smallToArray(abs)}var comparison=compareAbs(a,b);if(-1===comparison)return[Integer[0],self];if(0===comparison)return[Integer[self.sign===n.sign?1:-1],Integer[0]];quotient=(value=(a.length+b.length<=200?function(a,b){var quotientDigit,shift,carry,borrow,i,l,q,a_l=a.length,b_l=b.length,base=BASE,result=createArray(b.length),divisorMostSignificantDigit=b[b_l-1],lambda=Math.ceil(base/(2*divisorMostSignificantDigit)),remainder=multiplySmall(a,lambda),divisor=multiplySmall(b,lambda);for(remainder.length<=a_l&&remainder.push(0),divisor.push(0),divisorMostSignificantDigit=divisor[b_l-1],shift=a_l-b_l;0<=shift;shift--){for(quotientDigit=base-1,remainder[shift+b_l]!==divisorMostSignificantDigit&&(quotientDigit=Math.floor((remainder[shift+b_l]*base+remainder[shift+b_l-1])/divisorMostSignificantDigit)),borrow=carry=0,l=divisor.length,i=0;i<l;i++)carry+=quotientDigit*divisor[i],q=Math.floor(carry/base),borrow+=remainder[shift+i]-(carry-q*base),carry=q,borrow=borrow<0?(remainder[shift+i]=borrow+base,-1):(remainder[shift+i]=borrow,0);for(;0!==borrow;){for(--quotientDigit,i=carry=0;i<l;i++)carry=(carry+=remainder[shift+i]-base+divisor[i])<0?(remainder[shift+i]=carry+base,0):(remainder[shift+i]=carry,1);borrow+=carry}result[shift]=quotientDigit}return remainder=divModSmall(remainder,lambda)[0],[arrayToSmall(result),arrayToSmall(remainder)]}:function(a,b){for(var guess,xlen,highx,highy,check,a_l=a.length,b_l=b.length,result=[],part=[],base=BASE;a_l;)if(part.unshift(a[--a_l]),trim(part),compareAbs(part,b)<0)result.push(0);else{highx=part[(xlen=part.length)-1]*base+part[xlen-2],highy=b[b_l-1]*base+b[b_l-2],b_l<xlen&&(highx=(highx+1)*base),guess=Math.ceil(highx/highy);do{if(compareAbs(check=multiplySmall(b,guess),part)<=0)break;guess--}while(guess);result.push(guess),part=subtract(part,check)}return result.reverse(),[arrayToSmall(result),arrayToSmall(part)]})(a,b))[0];var qSign=self.sign!==n.sign,mod=value[1],mSign=self.sign;return[quotient="number"==typeof quotient?(qSign&&(quotient=-quotient),new SmallInteger(quotient)):new BigInteger(quotient,qSign),mod="number"==typeof mod?(mSign&&(mod=-mod),new SmallInteger(mod)):new BigInteger(mod,mSign)]}function compareAbs(a,b){if(a.length!==b.length)return a.length>b.length?1:-1;for(var i=a.length-1;0<=i;i--)if(a[i]!==b[i])return a[i]>b[i]?1:-1;return 0}function isBasicPrime(v){var n=v.abs();return!n.isUnit()&&(!!(n.equals(2)||n.equals(3)||n.equals(5))||!(n.isEven()||n.isDivisibleBy(3)||n.isDivisibleBy(5))&&(!!n.lesser(49)||void 0))}function millerRabinTest(n,a){for(var d,i,x,nPrev=n.prev(),b=nPrev,r=0;b.isEven();)b=b.divide(2),r++;next:for(i=0;i<a.length;i++)if(!n.lesser(a[i])&&!(x=bigInt(a[i]).modPow(b,n)).equals(Integer[1])&&!x.equals(nPrev)){for(d=r-1;0!=d;d--){if((x=x.square().mod(n)).isUnit())return!1;if(x.equals(nPrev))continue next}return!1}return!0}BigInteger.prototype=Object.create(Integer.prototype),SmallInteger.prototype=Object.create(Integer.prototype),BigInteger.prototype.plus=BigInteger.prototype.add=function(v){var n=parseValue(v);if(this.sign!==n.sign)return this.subtract(n.negate());var a=this.value,b=n.value;return n.isSmall?new BigInteger(addSmall(a,Math.abs(b)),this.sign):new BigInteger(addAny(a,b),this.sign)},SmallInteger.prototype.plus=SmallInteger.prototype.add=function(v){var n=parseValue(v),a=this.value;if(a<0!==n.sign)return this.subtract(n.negate());var b=n.value;if(n.isSmall){if(isPrecise(a+b))return new SmallInteger(a+b);b=smallToArray(Math.abs(b))}return new BigInteger(addSmall(b,Math.abs(a)),a<0)},BigInteger.prototype.minus=BigInteger.prototype.subtract=function(v){var n=parseValue(v);if(this.sign!==n.sign)return this.add(n.negate());var a=this.value,b=n.value;return n.isSmall?subtractSmall(a,Math.abs(b),this.sign):function(a,b,sign){var value;return 0<=compareAbs(a,b)?value=subtract(a,b):(value=subtract(b,a),sign=!sign),"number"==typeof(value=arrayToSmall(value))?(sign&&(value=-value),new SmallInteger(value)):new BigInteger(value,sign)}(a,b,this.sign)},SmallInteger.prototype.minus=SmallInteger.prototype.subtract=function(v){var n=parseValue(v),a=this.value;if(a<0!==n.sign)return this.add(n.negate());var b=n.value;return n.isSmall?new SmallInteger(a-b):subtractSmall(b,Math.abs(a),0<=a)},BigInteger.prototype.negate=function(){return new BigInteger(this.value,!this.sign)},SmallInteger.prototype.negate=function(){var sign=this.sign,small=new SmallInteger(-this.value);return small.sign=!sign,small},BigInteger.prototype.abs=function(){return new BigInteger(this.value,!1)},SmallInteger.prototype.abs=function(){return new SmallInteger(Math.abs(this.value))},BigInteger.prototype.times=BigInteger.prototype.multiply=function(v){var abs,l1,l2,n=parseValue(v),a=this.value,b=n.value,sign=this.sign!==n.sign;if(n.isSmall){if(0===b)return Integer[0];if(1===b)return this;if(-1===b)return this.negate();if((abs=Math.abs(b))<BASE)return new BigInteger(multiplySmall(a,abs),sign);b=smallToArray(abs)}return l1=a.length,l2=b.length,new BigInteger((0<-.012*l1-.012*l2+15e-6*l1*l2?function multiplyKaratsuba(x,y){var n=Math.max(x.length,y.length);if(n<=30)return multiplyLong(x,y);n=Math.ceil(n/2);var b=x.slice(n),a=x.slice(0,n),d=y.slice(n),c=y.slice(0,n),ac=multiplyKaratsuba(a,c),bd=multiplyKaratsuba(b,d),abcd=multiplyKaratsuba(addAny(a,b),addAny(c,d)),product=addAny(addAny(ac,shiftLeft(subtract(subtract(abcd,ac),bd),n)),shiftLeft(bd,2*n));return trim(product),product}:multiplyLong)(a,b),sign)},SmallInteger.prototype._multiplyBySmall=function(a){return isPrecise(a.value*this.value)?new SmallInteger(a.value*this.value):multiplySmallAndArray(Math.abs(a.value),smallToArray(Math.abs(this.value)),this.sign!==a.sign)},BigInteger.prototype._multiplyBySmall=function(a){return 0===a.value?Integer[0]:1===a.value?this:-1===a.value?this.negate():multiplySmallAndArray(Math.abs(a.value),this.value,this.sign!==a.sign)},SmallInteger.prototype.times=SmallInteger.prototype.multiply=function(v){return parseValue(v)._multiplyBySmall(this)},BigInteger.prototype.square=function(){return new BigInteger(square(this.value),!1)},SmallInteger.prototype.square=function(){var value=this.value*this.value;return isPrecise(value)?new SmallInteger(value):new BigInteger(square(smallToArray(Math.abs(this.value))),!1)},SmallInteger.prototype.divmod=BigInteger.prototype.divmod=function(v){var result=divModAny(this,v);return{quotient:result[0],remainder:result[1]}},SmallInteger.prototype.over=SmallInteger.prototype.divide=BigInteger.prototype.over=BigInteger.prototype.divide=function(v){return divModAny(this,v)[0]},SmallInteger.prototype.remainder=SmallInteger.prototype.mod=BigInteger.prototype.remainder=BigInteger.prototype.mod=function(v){return divModAny(this,v)[1]},BigInteger.prototype.pow=function(v){var value,x,y,n=parseValue(v),a=this.value,b=n.value;if(0===b)return Integer[1];if(0===a)return Integer[0];if(1===a)return Integer[1];if(-1===a)return n.isEven()?Integer[1]:Integer[-1];if(n.sign)return Integer[0];if(!n.isSmall)throw new Error("The exponent "+n.toString()+" is too large.");if(this.isSmall&&isPrecise(value=Math.pow(a,b)))return new SmallInteger(truncate(value));for(x=this,y=Integer[1];!0&b&&(y=y.times(x),--b),0!==b;)b/=2,x=x.square();return y},SmallInteger.prototype.pow=BigInteger.prototype.pow,SmallInteger.prototype.modPow=BigInteger.prototype.modPow=function(exp,mod){if(exp=parseValue(exp),(mod=parseValue(mod)).isZero())throw new Error("Cannot take modPow with modulus 0");for(var r=Integer[1],base=this.mod(mod);exp.isPositive();){if(base.isZero())return Integer[0];exp.isOdd()&&(r=r.multiply(base).mod(mod)),exp=exp.divide(2),base=base.square().mod(mod)}return r},BigInteger.prototype.compareAbs=function(v){var n=parseValue(v),a=this.value,b=n.value;return n.isSmall?1:compareAbs(a,b)},SmallInteger.prototype.compareAbs=function(v){var n=parseValue(v),a=Math.abs(this.value),b=n.value;return n.isSmall?a===(b=Math.abs(b))?0:b<a?1:-1:-1},BigInteger.prototype.compareTo=BigInteger.prototype.compare=function(v){if(v===1/0)return-1;if(v===-1/0)return 1;var n=parseValue(v),a=this.value,b=n.value;return this.sign!==n.sign?n.sign?1:-1:n.isSmall?this.sign?-1:1:compareAbs(a,b)*(this.sign?-1:1)},SmallInteger.prototype.compareTo=SmallInteger.prototype.compare=function(v){if(v===1/0)return-1;if(v===-1/0)return 1;var n=parseValue(v),a=this.value,b=n.value;return n.isSmall?a==b?0:b<a?1:-1:a<0!==n.sign?a<0?-1:1:a<0?1:-1},SmallInteger.prototype.eq=SmallInteger.prototype.equals=BigInteger.prototype.eq=BigInteger.prototype.equals=function(v){return 0===this.compare(v)},SmallInteger.prototype.neq=SmallInteger.prototype.notEquals=BigInteger.prototype.neq=BigInteger.prototype.notEquals=function(v){return 0!==this.compare(v)},SmallInteger.prototype.gt=SmallInteger.prototype.greater=BigInteger.prototype.gt=BigInteger.prototype.greater=function(v){return 0<this.compare(v)},SmallInteger.prototype.lt=SmallInteger.prototype.lesser=BigInteger.prototype.lt=BigInteger.prototype.lesser=function(v){return this.compare(v)<0},SmallInteger.prototype.geq=SmallInteger.prototype.greaterOrEquals=BigInteger.prototype.geq=BigInteger.prototype.greaterOrEquals=function(v){return 0<=this.compare(v)},SmallInteger.prototype.leq=SmallInteger.prototype.lesserOrEquals=BigInteger.prototype.leq=BigInteger.prototype.lesserOrEquals=function(v){return this.compare(v)<=0},BigInteger.prototype.isEven=function(){return 0==(1&this.value[0])},SmallInteger.prototype.isEven=function(){return 0==(1&this.value)},BigInteger.prototype.isOdd=function(){return 1==(1&this.value[0])},SmallInteger.prototype.isOdd=function(){return 1==(1&this.value)},BigInteger.prototype.isPositive=function(){return!this.sign},SmallInteger.prototype.isPositive=function(){return 0<this.value},BigInteger.prototype.isNegative=function(){return this.sign},SmallInteger.prototype.isNegative=function(){return this.value<0},BigInteger.prototype.isUnit=function(){return!1},SmallInteger.prototype.isUnit=function(){return 1===Math.abs(this.value)},BigInteger.prototype.isZero=function(){return!1},SmallInteger.prototype.isZero=function(){return 0===this.value},SmallInteger.prototype.isDivisibleBy=BigInteger.prototype.isDivisibleBy=function(v){var n=parseValue(v),value=n.value;return 0!==value&&(1===value||(2===value?this.isEven():this.mod(n).equals(Integer[0])))},SmallInteger.prototype.isPrime=BigInteger.prototype.isPrime=function(strict){var isPrime=isBasicPrime(this);if(void 0!==isPrime)return isPrime;var n=this.abs(),bits=n.bitLength();if(bits<=64)return millerRabinTest(n,[2,325,9375,28178,450775,9780504,1795265022]);for(var logN=Math.log(2)*bits,t=Math.ceil(!0===strict?2*Math.pow(logN,2):logN),a=[],i=0;i<t;i++)a.push(bigInt(i+2));return millerRabinTest(n,a)},SmallInteger.prototype.isProbablePrime=BigInteger.prototype.isProbablePrime=function(iterations){var isPrime=isBasicPrime(this);if(void 0!==isPrime)return isPrime;for(var n=this.abs(),t=void 0===iterations?5:iterations,a=[],i=0;i<t;i++)a.push(bigInt.randBetween(2,n.minus(2)));return millerRabinTest(n,a)},SmallInteger.prototype.modInv=BigInteger.prototype.modInv=function(n){for(var q,lastT,lastR,t=bigInt.zero,newT=bigInt.one,r=parseValue(n),newR=this.abs();!newR.equals(bigInt.zero);)q=r.divide(newR),lastT=t,lastR=r,t=newT,r=newR,newT=lastT.subtract(q.multiply(newT)),newR=lastR.subtract(q.multiply(newR));if(!r.equals(1))throw new Error(this.toString()+" and "+n.toString()+" are not co-prime");return-1===t.compare(0)&&(t=t.add(n)),this.isNegative()?t.negate():t},BigInteger.prototype.next=function(){var value=this.value;return this.sign?subtractSmall(value,1,this.sign):new BigInteger(addSmall(value,1),this.sign)},SmallInteger.prototype.next=function(){var value=this.value;return value+1<MAX_INT?new SmallInteger(value+1):new BigInteger(MAX_INT_ARR,!1)},BigInteger.prototype.prev=function(){var value=this.value;return this.sign?new BigInteger(addSmall(value,1),!0):subtractSmall(value,1,this.sign)},SmallInteger.prototype.prev=function(){var value=this.value;return-MAX_INT<value-1?new SmallInteger(value-1):new BigInteger(MAX_INT_ARR,!0)};for(var powersOfTwo=[1];2*powersOfTwo[powersOfTwo.length-1]<=BASE;)powersOfTwo.push(2*powersOfTwo[powersOfTwo.length-1]);var powers2Length=powersOfTwo.length,highestPower2=powersOfTwo[powers2Length-1];function shift_isSmall(n){return("number"==typeof n||"string"==typeof n)&&+Math.abs(n)<=BASE||n instanceof BigInteger&&n.value.length<=1}function bitwise(x,y,fn){y=parseValue(y);for(var xSign=x.isNegative(),ySign=y.isNegative(),xRem=xSign?x.not():x,yRem=ySign?y.not():y,xDigit=0,yDigit=0,xDivMod=null,yDivMod=null,result=[];!xRem.isZero()||!yRem.isZero();)xDigit=(xDivMod=divModAny(xRem,highestPower2))[1].toJSNumber(),xSign&&(xDigit=highestPower2-1-xDigit),yDigit=(yDivMod=divModAny(yRem,highestPower2))[1].toJSNumber(),ySign&&(yDigit=highestPower2-1-yDigit),xRem=xDivMod[0],yRem=yDivMod[0],result.push(fn(xDigit,yDigit));for(var sum=0!==fn(xSign?1:0,ySign?1:0)?bigInt(-1):bigInt(0),i=result.length-1;0<=i;--i)sum=sum.multiply(highestPower2).add(bigInt(result[i]));return sum}SmallInteger.prototype.shiftLeft=BigInteger.prototype.shiftLeft=function(n){if(!shift_isSmall(n))throw new Error(String(n)+" is too large for shifting.");if((n=+n)<0)return this.shiftRight(-n);var result=this;if(result.isZero())return result;for(;powers2Length<=n;)result=result.multiply(highestPower2),n-=powers2Length-1;return result.multiply(powersOfTwo[n])},SmallInteger.prototype.shiftRight=BigInteger.prototype.shiftRight=function(n){var remQuo;if(!shift_isSmall(n))throw new Error(String(n)+" is too large for shifting.");if((n=+n)<0)return this.shiftLeft(-n);for(var result=this;powers2Length<=n;){if(result.isZero()||result.isNegative()&&result.isUnit())return result;result=(remQuo=divModAny(result,highestPower2))[1].isNegative()?remQuo[0].prev():remQuo[0],n-=powers2Length-1}return(remQuo=divModAny(result,powersOfTwo[n]))[1].isNegative()?remQuo[0].prev():remQuo[0]},SmallInteger.prototype.not=BigInteger.prototype.not=function(){return this.negate().prev()},SmallInteger.prototype.and=BigInteger.prototype.and=function(n){return bitwise(this,n,function(a,b){return a&b})},SmallInteger.prototype.or=BigInteger.prototype.or=function(n){return bitwise(this,n,function(a,b){return a|b})},SmallInteger.prototype.xor=BigInteger.prototype.xor=function(n){return bitwise(this,n,function(a,b){return a^b})};var LOBMASK_I=1<<30,LOBMASK_BI=(BASE&-BASE)*(BASE&-BASE)|LOBMASK_I;function roughLOB(n){var v=n.value,x="number"==typeof v?v|LOBMASK_I:v[0]+v[1]*BASE|LOBMASK_BI;return x&-x}function max(a,b){return a=parseValue(a),b=parseValue(b),a.greater(b)?a:b}function min(a,b){return a=parseValue(a),b=parseValue(b),a.lesser(b)?a:b}function gcd(a,b){if(a=parseValue(a).abs(),b=parseValue(b).abs(),a.equals(b))return a;if(a.isZero())return b;if(b.isZero())return a;for(var d,t,c=Integer[1];a.isEven()&&b.isEven();)d=Math.min(roughLOB(a),roughLOB(b)),a=a.divide(d),b=b.divide(d),c=c.multiply(d);for(;a.isEven();)a=a.divide(roughLOB(a));do{for(;b.isEven();)b=b.divide(roughLOB(b));a.greater(b)&&(t=b,b=a,a=t),b=b.subtract(a)}while(!b.isZero());return c.isUnit()?a:a.multiply(c)}SmallInteger.prototype.bitLength=BigInteger.prototype.bitLength=function(){var n=this;return n.compareTo(bigInt(0))<0&&(n=n.negate().subtract(bigInt(1))),0===n.compareTo(bigInt(0))?bigInt(0):bigInt(function integerLogarithm(value,base){if(base.compareTo(value)<=0){var tmp=integerLogarithm(value,base.square(base)),p=tmp.p,e=tmp.e,t=p.multiply(base);return t.compareTo(value)<=0?{p:t,e:2*e+1}:{p:p,e:2*e}}return{p:bigInt(1),e:0}}(n,bigInt(2)).e).add(bigInt(1))};var parseBase=function(text,base){for(var length=text.length,absBase=Math.abs(base),i=0;i<length;i++){if("-"!==(c=text[i].toLowerCase())&&/[a-z0-9]/.test(c)){if(/[0-9]/.test(c)&&absBase<=+c){if("1"===c&&1===absBase)continue;throw new Error(c+" is not a valid digit in base "+base+".")}if(c.charCodeAt(0)-87>=absBase)throw new Error(c+" is not a valid digit in base "+base+".")}}if(2<=base&&base<=36&&length<=LOG_MAX_INT/Math.log(base)){var result=parseInt(text,base);if(isNaN(result))throw new Error(c+" is not a valid digit in base "+base+".");return new SmallInteger(parseInt(text,base))}base=parseValue(base);var digits=[],isNegative="-"===text[0];for(i=isNegative?1:0;i<text.length;i++){var c,charCode=(c=text[i].toLowerCase()).charCodeAt(0);if(48<=charCode&&charCode<=57)digits.push(parseValue(c));else if(97<=charCode&&charCode<=122)digits.push(parseValue(c.charCodeAt(0)-87));else{if("<"!==c)throw new Error(c+" is not a valid character");for(var start=i;">"!==text[++i];);digits.push(parseValue(text.slice(start+1,i)))}}return parseBaseFromArray(digits,base,isNegative)};function parseBaseFromArray(digits,base,isNegative){var i,val=Integer[0],pow=Integer[1];for(i=digits.length-1;0<=i;i--)val=val.add(digits[i].times(pow)),pow=pow.times(base);return isNegative?val.negate():val}function stringify(digit){return digit<=35?"0123456789abcdefghijklmnopqrstuvwxyz".charAt(digit):"<"+digit+">"}function toBase(n,base){if((base=bigInt(base)).isZero()){if(n.isZero())return{value:[0],isNegative:!1};throw new Error("Cannot convert nonzero numbers to base 0.")}if(base.equals(-1)){if(n.isZero())return{value:[0],isNegative:!1};if(n.isNegative())return{value:[].concat.apply([],Array.apply(null,Array(-n)).map(Array.prototype.valueOf,[1,0])),isNegative:!1};var arr=Array.apply(null,Array(n-1)).map(Array.prototype.valueOf,[0,1]);return arr.unshift([1]),{value:[].concat.apply([],arr),isNegative:!1}}var neg=!1;if(n.isNegative()&&base.isPositive()&&(neg=!0,n=n.abs()),base.equals(1))return n.isZero()?{value:[0],isNegative:!1}:{value:Array.apply(null,Array(+n)).map(Number.prototype.valueOf,1),isNegative:neg};for(var divmod,out=[],left=n;left.isNegative()||0<=left.compareAbs(base);){left=(divmod=left.divmod(base)).quotient;var digit=divmod.remainder;digit.isNegative()&&(digit=base.minus(digit).abs(),left=left.next()),out.push(digit.toJSNumber())}return out.push(left.toJSNumber()),{value:out.reverse(),isNegative:neg}}function toBaseString(n,base){var arr=toBase(n,base);return(arr.isNegative?"-":"")+arr.value.map(stringify).join("")}function parseStringValue(v){if(isPrecise(+v)){var x=+v;if(x===truncate(x))return new SmallInteger(x);throw new Error("Invalid integer: "+v)}var sign="-"===v[0];sign&&(v=v.slice(1));var split=v.split(/e/i);if(2<split.length)throw new Error("Invalid integer: "+split.join("e"));if(2===split.length){var exp=split[1];if("+"===exp[0]&&(exp=exp.slice(1)),(exp=+exp)!==truncate(exp)||!isPrecise(exp))throw new Error("Invalid integer: "+exp+" is not a valid exponent.");var text=split[0],decimalPlace=text.indexOf(".");if(0<=decimalPlace&&(exp-=text.length-decimalPlace-1,text=text.slice(0,decimalPlace)+text.slice(decimalPlace+1)),exp<0)throw new Error("Cannot include negative exponent part for integers");v=text+=new Array(exp+1).join("0")}if(!/^([0-9][0-9]*)$/.test(v))throw new Error("Invalid integer: "+v);for(var r=[],max=v.length,l=LOG_BASE,min=max-l;0<max;)r.push(+v.slice(min,max)),(min-=l)<0&&(min=0),max-=l;return trim(r),new BigInteger(r,sign)}function parseValue(v){return"number"==typeof v?function(v){if(isPrecise(v)){if(v!==truncate(v))throw new Error(v+" is not an integer.");return new SmallInteger(v)}return parseStringValue(v.toString())}(v):"string"==typeof v?parseStringValue(v):v}BigInteger.prototype.toArray=function(radix){return toBase(this,radix)},SmallInteger.prototype.toArray=function(radix){return toBase(this,radix)},BigInteger.prototype.toString=function(radix){if(void 0===radix&&(radix=10),10!==radix)return toBaseString(this,radix);for(var digit,v=this.value,l=v.length,str=String(v[--l]);0<=--l;)digit=String(v[l]),str+="0000000".slice(digit.length)+digit;return(this.sign?"-":"")+str},SmallInteger.prototype.toString=function(radix){return void 0===radix&&(radix=10),10!=radix?toBaseString(this,radix):String(this.value)},BigInteger.prototype.toJSON=SmallInteger.prototype.toJSON=function(){return this.toString()},BigInteger.prototype.toJSNumber=BigInteger.prototype.valueOf=function(){return parseInt(this.toString(),10)},SmallInteger.prototype.toJSNumber=SmallInteger.prototype.valueOf=function(){return this.value};for(var i=0;i<1e3;i++)Integer[i]=new SmallInteger(i),0<i&&(Integer[-i]=new SmallInteger(-i));return Integer.one=Integer[1],Integer.zero=Integer[0],Integer.minusOne=Integer[-1],Integer.max=max,Integer.min=min,Integer.gcd=gcd,Integer.lcm=function(a,b){return a=parseValue(a).abs(),b=parseValue(b).abs(),a.divide(gcd(a,b)).multiply(b)},Integer.isInstance=function(x){return x instanceof BigInteger||x instanceof SmallInteger},Integer.randBetween=function(a,b){var low=min(a=parseValue(a),b=parseValue(b)),range=max(a,b).subtract(low).add(1);if(range.isSmall)return low.add(Math.floor(Math.random()*range));for(var result=[],restricted=!0,i=range.value.length-1;0<=i;i--){var top=restricted?range.value[i]:BASE,digit=truncate(Math.random()*top);result.unshift(digit),digit<top&&(restricted=!1)}return result=arrayToSmall(result),low.add("number"==typeof result?new SmallInteger(result):new BigInteger(result,!1))},Integer.fromArray=function(digits,base,isNegative){return parseBaseFromArray(digits.map(parseValue),parseValue(base||10),isNegative)},Integer}();void 0!==module&&module.hasOwnProperty("exports")&&(module.exports=bigInt)},{}],4:[function(require,module,exports){},{}],5:[function(require,module,exports){var basex=require("base-x");module.exports=basex("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz")},{"base-x":1}],6:[function(require,module,exports){"use strict";var base58=require("bs58"),Buffer=require("safe-buffer").Buffer;module.exports=function(checksumFn){function decodeRaw(buffer){var payload=buffer.slice(0,-4),checksum=buffer.slice(-4),newChecksum=checksumFn(payload);if(!(checksum[0]^newChecksum[0]|checksum[1]^newChecksum[1]|checksum[2]^newChecksum[2]|checksum[3]^newChecksum[3]))return payload}return{encode:function(payload){var checksum=checksumFn(payload);return base58.encode(Buffer.concat([payload,checksum],payload.length+4))},decode:function(string){var payload=decodeRaw(base58.decode(string));if(!payload)throw new Error("Invalid checksum");return payload},decodeUnsafe:function(string){var buffer=base58.decodeUnsafe(string);if(buffer)return decodeRaw(buffer)}}}},{bs58:5,"safe-buffer":8}],7:[function(require,module,exports){"use strict";var createHash=require("create-hash"),bs58checkBase=require("./base");module.exports=bs58checkBase(function(buffer){var tmp=createHash("sha256").update(buffer).digest();return createHash("sha256").update(tmp).digest()})},{"./base":6,"create-hash":16}],8:[function(require,module,exports){var buffer=require("buffer"),Buffer=buffer.Buffer;function copyProps(src,dst){for(var key in src)dst[key]=src[key]}function SafeBuffer(arg,encodingOrOffset,length){return Buffer(arg,encodingOrOffset,length)}Buffer.from&&Buffer.alloc&&Buffer.allocUnsafe&&Buffer.allocUnsafeSlow?module.exports=buffer:(copyProps(buffer,exports),exports.Buffer=SafeBuffer),copyProps(Buffer,SafeBuffer),SafeBuffer.from=function(arg,encodingOrOffset,length){if("number"==typeof arg)throw new TypeError("Argument must not be a number");return Buffer(arg,encodingOrOffset,length)},SafeBuffer.alloc=function(size,fill,encoding){if("number"!=typeof size)throw new TypeError("Argument must be a number");var buf=Buffer(size);return void 0!==fill?"string"==typeof encoding?buf.fill(fill,encoding):buf.fill(fill):buf.fill(0),buf},SafeBuffer.allocUnsafe=function(size){if("number"!=typeof size)throw new TypeError("Argument must be a number");return Buffer(size)},SafeBuffer.allocUnsafeSlow=function(size){if("number"!=typeof size)throw new TypeError("Argument must be a number");return buffer.SlowBuffer(size)}},{buffer:9}],9:[function(require,module,exports){(function(Buffer){"use strict";var base64=require("base64-js"),ieee754=require("ieee754"),customInspectSymbol="function"==typeof Symbol&&"function"==typeof Symbol.for?Symbol.for("nodejs.util.inspect.custom"):null;exports.Buffer=Buffer,exports.SlowBuffer=function(length){+length!=length&&(length=0);return Buffer.alloc(+length)},exports.INSPECT_MAX_BYTES=50;var K_MAX_LENGTH=2147483647;function createBuffer(length){if(K_MAX_LENGTH<length)throw new RangeError('The value "'+length+'" is invalid for option "size"');var buf=new Uint8Array(length);return Object.setPrototypeOf(buf,Buffer.prototype),buf}function Buffer(arg,encodingOrOffset,length){if("number"!=typeof arg)return from(arg,encodingOrOffset,length);if("string"==typeof encodingOrOffset)throw new TypeError('The "string" argument must be of type string. Received type number');return allocUnsafe(arg)}function from(value,encodingOrOffset,length){if("string"==typeof value)return function(string,encoding){"string"==typeof encoding&&""!==encoding||(encoding="utf8");if(!Buffer.isEncoding(encoding))throw new TypeError("Unknown encoding: "+encoding);var length=0|byteLength(string,encoding),buf=createBuffer(length),actual=buf.write(string,encoding);actual!==length&&(buf=buf.slice(0,actual));return buf}(value,encodingOrOffset);if(ArrayBuffer.isView(value))return fromArrayLike(value);if(null==value)throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type "+typeof value);if(isInstance(value,ArrayBuffer)||value&&isInstance(value.buffer,ArrayBuffer))return fromArrayBuffer(value,encodingOrOffset,length);if("undefined"!=typeof SharedArrayBuffer&&(isInstance(value,SharedArrayBuffer)||value&&isInstance(value.buffer,SharedArrayBuffer)))return fromArrayBuffer(value,encodingOrOffset,length);if("number"==typeof value)throw new TypeError('The "value" argument must not be of type number. Received type number');var valueOf=value.valueOf&&value.valueOf();if(null!=valueOf&&valueOf!==value)return Buffer.from(valueOf,encodingOrOffset,length);var b=function(obj){if(Buffer.isBuffer(obj)){var len=0|checked(obj.length),buf=createBuffer(len);return 0===buf.length?buf:(obj.copy(buf,0,0,len),buf)}if(void 0!==obj.length)return"number"!=typeof obj.length||numberIsNaN(obj.length)?createBuffer(0):fromArrayLike(obj);if("Buffer"===obj.type&&Array.isArray(obj.data))return fromArrayLike(obj.data)}(value);if(b)return b;if("undefined"!=typeof Symbol&&null!=Symbol.toPrimitive&&"function"==typeof value[Symbol.toPrimitive])return Buffer.from(value[Symbol.toPrimitive]("string"),encodingOrOffset,length);throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type "+typeof value)}function assertSize(size){if("number"!=typeof size)throw new TypeError('"size" argument must be of type number');if(size<0)throw new RangeError('The value "'+size+'" is invalid for option "size"')}function allocUnsafe(size){return assertSize(size),createBuffer(size<0?0:0|checked(size))}function fromArrayLike(array){for(var length=array.length<0?0:0|checked(array.length),buf=createBuffer(length),i=0;i<length;i+=1)buf[i]=255&array[i];return buf}function fromArrayBuffer(array,byteOffset,length){if(byteOffset<0||array.byteLength<byteOffset)throw new RangeError('"offset" is outside of buffer bounds');if(array.byteLength<byteOffset+(length||0))throw new RangeError('"length" is outside of buffer bounds');var buf;return buf=void 0===byteOffset&&void 0===length?new Uint8Array(array):void 0===length?new Uint8Array(array,byteOffset):new Uint8Array(array,byteOffset,length),Object.setPrototypeOf(buf,Buffer.prototype),buf}function checked(length){if(K_MAX_LENGTH<=length)throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+K_MAX_LENGTH.toString(16)+" bytes");return 0|length}function byteLength(string,encoding){if(Buffer.isBuffer(string))return string.length;if(ArrayBuffer.isView(string)||isInstance(string,ArrayBuffer))return string.byteLength;if("string"!=typeof string)throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type '+typeof string);var len=string.length,mustMatch=2<arguments.length&&!0===arguments[2];if(!mustMatch&&0===len)return 0;for(var loweredCase=!1;;)switch(encoding){case"ascii":case"latin1":case"binary":return len;case"utf8":case"utf-8":return utf8ToBytes(string).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*len;case"hex":return len>>>1;case"base64":return base64ToBytes(string).length;default:if(loweredCase)return mustMatch?-1:utf8ToBytes(string).length;encoding=(""+encoding).toLowerCase(),loweredCase=!0}}function swap(b,n,m){var i=b[n];b[n]=b[m],b[m]=i}function bidirectionalIndexOf(buffer,val,byteOffset,encoding,dir){if(0===buffer.length)return-1;if("string"==typeof byteOffset?(encoding=byteOffset,byteOffset=0):2147483647<byteOffset?byteOffset=2147483647:byteOffset<-2147483648&&(byteOffset=-2147483648),numberIsNaN(byteOffset=+byteOffset)&&(byteOffset=dir?0:buffer.length-1),byteOffset<0&&(byteOffset=buffer.length+byteOffset),byteOffset>=buffer.length){if(dir)return-1;byteOffset=buffer.length-1}else if(byteOffset<0){if(!dir)return-1;byteOffset=0}if("string"==typeof val&&(val=Buffer.from(val,encoding)),Buffer.isBuffer(val))return 0===val.length?-1:arrayIndexOf(buffer,val,byteOffset,encoding,dir);if("number"==typeof val)return val&=255,"function"==typeof Uint8Array.prototype.indexOf?dir?Uint8Array.prototype.indexOf.call(buffer,val,byteOffset):Uint8Array.prototype.lastIndexOf.call(buffer,val,byteOffset):arrayIndexOf(buffer,[val],byteOffset,encoding,dir);throw new TypeError("val must be string, number or Buffer")}function arrayIndexOf(arr,val,byteOffset,encoding,dir){var i,indexSize=1,arrLength=arr.length,valLength=val.length;if(void 0!==encoding&&("ucs2"===(encoding=String(encoding).toLowerCase())||"ucs-2"===encoding||"utf16le"===encoding||"utf-16le"===encoding)){if(arr.length<2||val.length<2)return-1;arrLength/=indexSize=2,valLength/=2,byteOffset/=2}function read(buf,i){return 1===indexSize?buf[i]:buf.readUInt16BE(i*indexSize)}if(dir){var foundIndex=-1;for(i=byteOffset;i<arrLength;i++)if(read(arr,i)===read(val,-1===foundIndex?0:i-foundIndex)){if(-1===foundIndex&&(foundIndex=i),i-foundIndex+1===valLength)return foundIndex*indexSize}else-1!==foundIndex&&(i-=i-foundIndex),foundIndex=-1}else for(arrLength<byteOffset+valLength&&(byteOffset=arrLength-valLength),i=byteOffset;0<=i;i--){for(var found=!0,j=0;j<valLength;j++)if(read(arr,i+j)!==read(val,j)){found=!1;break}if(found)return i}return-1}function hexWrite(buf,string,offset,length){offset=Number(offset)||0;var remaining=buf.length-offset;(!length||remaining<(length=Number(length)))&&(length=remaining);var strLen=string.length;strLen/2<length&&(length=strLen/2);for(var i=0;i<length;++i){var parsed=parseInt(string.substr(2*i,2),16);if(numberIsNaN(parsed))return i;buf[offset+i]=parsed}return i}function utf8Write(buf,string,offset,length){return blitBuffer(utf8ToBytes(string,buf.length-offset),buf,offset,length)}function asciiWrite(buf,string,offset,length){return blitBuffer(function(str){for(var byteArray=[],i=0;i<str.length;++i)byteArray.push(255&str.charCodeAt(i));return byteArray}(string),buf,offset,length)}function latin1Write(buf,string,offset,length){return asciiWrite(buf,string,offset,length)}function base64Write(buf,string,offset,length){return blitBuffer(base64ToBytes(string),buf,offset,length)}function ucs2Write(buf,string,offset,length){return blitBuffer(function(str,units){for(var c,hi,lo,byteArray=[],i=0;i<str.length&&!((units-=2)<0);++i)c=str.charCodeAt(i),hi=c>>8,lo=c%256,byteArray.push(lo),byteArray.push(hi);return byteArray}(string,buf.length-offset),buf,offset,length)}function base64Slice(buf,start,end){return 0===start&&end===buf.length?base64.fromByteArray(buf):base64.fromByteArray(buf.slice(start,end))}function utf8Slice(buf,start,end){end=Math.min(buf.length,end);for(var res=[],i=start;i<end;){var secondByte,thirdByte,fourthByte,tempCodePoint,firstByte=buf[i],codePoint=null,bytesPerSequence=239<firstByte?4:223<firstByte?3:191<firstByte?2:1;if(i+bytesPerSequence<=end)switch(bytesPerSequence){case 1:firstByte<128&&(codePoint=firstByte);break;case 2:128==(192&(secondByte=buf[i+1]))&&127<(tempCodePoint=(31&firstByte)<<6|63&secondByte)&&(codePoint=tempCodePoint);break;case 3:secondByte=buf[i+1],thirdByte=buf[i+2],128==(192&secondByte)&&128==(192&thirdByte)&&2047<(tempCodePoint=(15&firstByte)<<12|(63&secondByte)<<6|63&thirdByte)&&(tempCodePoint<55296||57343<tempCodePoint)&&(codePoint=tempCodePoint);break;case 4:secondByte=buf[i+1],thirdByte=buf[i+2],fourthByte=buf[i+3],128==(192&secondByte)&&128==(192&thirdByte)&&128==(192&fourthByte)&&65535<(tempCodePoint=(15&firstByte)<<18|(63&secondByte)<<12|(63&thirdByte)<<6|63&fourthByte)&&tempCodePoint<1114112&&(codePoint=tempCodePoint)}null===codePoint?(codePoint=65533,bytesPerSequence=1):65535<codePoint&&(codePoint-=65536,res.push(codePoint>>>10&1023|55296),codePoint=56320|1023&codePoint),res.push(codePoint),i+=bytesPerSequence}return function(codePoints){var len=codePoints.length;if(len<=MAX_ARGUMENTS_LENGTH)return String.fromCharCode.apply(String,codePoints);var res="",i=0;for(;i<len;)res+=String.fromCharCode.apply(String,codePoints.slice(i,i+=MAX_ARGUMENTS_LENGTH));return res}(res)}exports.kMaxLength=K_MAX_LENGTH,(Buffer.TYPED_ARRAY_SUPPORT=function(){try{var arr=new Uint8Array(1),proto={foo:function(){return 42}};return Object.setPrototypeOf(proto,Uint8Array.prototype),Object.setPrototypeOf(arr,proto),42===arr.foo()}catch(e){return!1}}())||"undefined"==typeof console||"function"!=typeof console.error||console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."),Object.defineProperty(Buffer.prototype,"parent",{enumerable:!0,get:function(){if(Buffer.isBuffer(this))return this.buffer}}),Object.defineProperty(Buffer.prototype,"offset",{enumerable:!0,get:function(){if(Buffer.isBuffer(this))return this.byteOffset}}),"undefined"!=typeof Symbol&&null!=Symbol.species&&Buffer[Symbol.species]===Buffer&&Object.defineProperty(Buffer,Symbol.species,{value:null,configurable:!0,enumerable:!1,writable:!1}),Buffer.poolSize=8192,Buffer.from=function(value,encodingOrOffset,length){return from(value,encodingOrOffset,length)},Object.setPrototypeOf(Buffer.prototype,Uint8Array.prototype),Object.setPrototypeOf(Buffer,Uint8Array),Buffer.alloc=function(size,fill,encoding){return function(size,fill,encoding){return assertSize(size),!(size<=0)&&void 0!==fill?"string"==typeof encoding?createBuffer(size).fill(fill,encoding):createBuffer(size).fill(fill):createBuffer(size)}(size,fill,encoding)},Buffer.allocUnsafe=function(size){return allocUnsafe(size)},Buffer.allocUnsafeSlow=function(size){return allocUnsafe(size)},Buffer.isBuffer=function(b){return null!=b&&!0===b._isBuffer&&b!==Buffer.prototype},Buffer.compare=function(a,b){if(isInstance(a,Uint8Array)&&(a=Buffer.from(a,a.offset,a.byteLength)),isInstance(b,Uint8Array)&&(b=Buffer.from(b,b.offset,b.byteLength)),!Buffer.isBuffer(a)||!Buffer.isBuffer(b))throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');if(a===b)return 0;for(var x=a.length,y=b.length,i=0,len=Math.min(x,y);i<len;++i)if(a[i]!==b[i]){x=a[i],y=b[i];break}return x<y?-1:y<x?1:0},Buffer.isEncoding=function(encoding){switch(String(encoding).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},Buffer.concat=function(list,length){if(!Array.isArray(list))throw new TypeError('"list" argument must be an Array of Buffers');if(0===list.length)return Buffer.alloc(0);var i;if(void 0===length)for(i=length=0;i<list.length;++i)length+=list[i].length;var buffer=Buffer.allocUnsafe(length),pos=0;for(i=0;i<list.length;++i){var buf=list[i];if(isInstance(buf,Uint8Array)&&(buf=Buffer.from(buf)),!Buffer.isBuffer(buf))throw new TypeError('"list" argument must be an Array of Buffers');buf.copy(buffer,pos),pos+=buf.length}return buffer},Buffer.byteLength=byteLength,Buffer.prototype._isBuffer=!0,Buffer.prototype.swap16=function(){var len=this.length;if(len%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var i=0;i<len;i+=2)swap(this,i,i+1);return this},Buffer.prototype.swap32=function(){var len=this.length;if(len%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var i=0;i<len;i+=4)swap(this,i,i+3),swap(this,i+1,i+2);return this},Buffer.prototype.swap64=function(){var len=this.length;if(len%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var i=0;i<len;i+=8)swap(this,i,i+7),swap(this,i+1,i+6),swap(this,i+2,i+5),swap(this,i+3,i+4);return this},Buffer.prototype.toLocaleString=Buffer.prototype.toString=function(){var length=this.length;return 0===length?"":0===arguments.length?utf8Slice(this,0,length):function(encoding,start,end){var loweredCase=!1;if((void 0===start||start<0)&&(start=0),start>this.length)return"";if((void 0===end||end>this.length)&&(end=this.length),end<=0)return"";if((end>>>=0)<=(start>>>=0))return"";for(encoding=encoding||"utf8";;)switch(encoding){case"hex":return hexSlice(this,start,end);case"utf8":case"utf-8":return utf8Slice(this,start,end);case"ascii":return asciiSlice(this,start,end);case"latin1":case"binary":return latin1Slice(this,start,end);case"base64":return base64Slice(this,start,end);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return utf16leSlice(this,start,end);default:if(loweredCase)throw new TypeError("Unknown encoding: "+encoding);encoding=(encoding+"").toLowerCase(),loweredCase=!0}}.apply(this,arguments)},Buffer.prototype.equals=function(b){if(!Buffer.isBuffer(b))throw new TypeError("Argument must be a Buffer");return this===b||0===Buffer.compare(this,b)},Buffer.prototype.inspect=function(){var str="",max=exports.INSPECT_MAX_BYTES;return str=this.toString("hex",0,max).replace(/(.{2})/g,"$1 ").trim(),this.length>max&&(str+=" ... "),"<Buffer "+str+">"},customInspectSymbol&&(Buffer.prototype[customInspectSymbol]=Buffer.prototype.inspect),Buffer.prototype.compare=function(target,start,end,thisStart,thisEnd){if(isInstance(target,Uint8Array)&&(target=Buffer.from(target,target.offset,target.byteLength)),!Buffer.isBuffer(target))throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type '+typeof target);if(void 0===start&&(start=0),void 0===end&&(end=target?target.length:0),void 0===thisStart&&(thisStart=0),void 0===thisEnd&&(thisEnd=this.length),start<0||end>target.length||thisStart<0||thisEnd>this.length)throw new RangeError("out of range index");if(thisEnd<=thisStart&&end<=start)return 0;if(thisEnd<=thisStart)return-1;if(end<=start)return 1;if(this===target)return 0;for(var x=(thisEnd>>>=0)-(thisStart>>>=0),y=(end>>>=0)-(start>>>=0),len=Math.min(x,y),thisCopy=this.slice(thisStart,thisEnd),targetCopy=target.slice(start,end),i=0;i<len;++i)if(thisCopy[i]!==targetCopy[i]){x=thisCopy[i],y=targetCopy[i];break}return x<y?-1:y<x?1:0},Buffer.prototype.includes=function(val,byteOffset,encoding){return-1!==this.indexOf(val,byteOffset,encoding)},Buffer.prototype.indexOf=function(val,byteOffset,encoding){return bidirectionalIndexOf(this,val,byteOffset,encoding,!0)},Buffer.prototype.lastIndexOf=function(val,byteOffset,encoding){return bidirectionalIndexOf(this,val,byteOffset,encoding,!1)},Buffer.prototype.write=function(string,offset,length,encoding){if(void 0===offset)encoding="utf8",length=this.length,offset=0;else if(void 0===length&&"string"==typeof offset)encoding=offset,length=this.length,offset=0;else{if(!isFinite(offset))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");offset>>>=0,isFinite(length)?(length>>>=0,void 0===encoding&&(encoding="utf8")):(encoding=length,length=void 0)}var remaining=this.length-offset;if((void 0===length||remaining<length)&&(length=remaining),0<string.length&&(length<0||offset<0)||offset>this.length)throw new RangeError("Attempt to write outside buffer bounds");encoding=encoding||"utf8";for(var loweredCase=!1;;)switch(encoding){case"hex":return hexWrite(this,string,offset,length);case"utf8":case"utf-8":return utf8Write(this,string,offset,length);case"ascii":return asciiWrite(this,string,offset,length);case"latin1":case"binary":return latin1Write(this,string,offset,length);case"base64":return base64Write(this,string,offset,length);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return ucs2Write(this,string,offset,length);default:if(loweredCase)throw new TypeError("Unknown encoding: "+encoding);encoding=(""+encoding).toLowerCase(),loweredCase=!0}},Buffer.prototype.toJSON=function(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};var MAX_ARGUMENTS_LENGTH=4096;function asciiSlice(buf,start,end){var ret="";end=Math.min(buf.length,end);for(var i=start;i<end;++i)ret+=String.fromCharCode(127&buf[i]);return ret}function latin1Slice(buf,start,end){var ret="";end=Math.min(buf.length,end);for(var i=start;i<end;++i)ret+=String.fromCharCode(buf[i]);return ret}function hexSlice(buf,start,end){var len=buf.length;(!start||start<0)&&(start=0),(!end||end<0||len<end)&&(end=len);for(var out="",i=start;i<end;++i)out+=hexSliceLookupTable[buf[i]];return out}function utf16leSlice(buf,start,end){for(var bytes=buf.slice(start,end),res="",i=0;i<bytes.length;i+=2)res+=String.fromCharCode(bytes[i]+256*bytes[i+1]);return res}function checkOffset(offset,ext,length){if(offset%1!=0||offset<0)throw new RangeError("offset is not uint");if(length<offset+ext)throw new RangeError("Trying to access beyond buffer length")}function checkInt(buf,value,offset,ext,max,min){if(!Buffer.isBuffer(buf))throw new TypeError('"buffer" argument must be a Buffer instance');if(max<value||value<min)throw new RangeError('"value" argument is out of bounds');if(offset+ext>buf.length)throw new RangeError("Index out of range")}function checkIEEE754(buf,value,offset,ext){if(offset+ext>buf.length)throw new RangeError("Index out of range");if(offset<0)throw new RangeError("Index out of range")}function writeFloat(buf,value,offset,littleEndian,noAssert){return value=+value,offset>>>=0,noAssert||checkIEEE754(buf,0,offset,4),ieee754.write(buf,value,offset,littleEndian,23,4),offset+4}function writeDouble(buf,value,offset,littleEndian,noAssert){return value=+value,offset>>>=0,noAssert||checkIEEE754(buf,0,offset,8),ieee754.write(buf,value,offset,littleEndian,52,8),offset+8}Buffer.prototype.slice=function(start,end){var len=this.length;(start=~~start)<0?(start+=len)<0&&(start=0):len<start&&(start=len),(end=void 0===end?len:~~end)<0?(end+=len)<0&&(end=0):len<end&&(end=len),end<start&&(end=start);var newBuf=this.subarray(start,end);return Object.setPrototypeOf(newBuf,Buffer.prototype),newBuf},Buffer.prototype.readUIntLE=function(offset,byteLength,noAssert){offset>>>=0,byteLength>>>=0,noAssert||checkOffset(offset,byteLength,this.length);for(var val=this[offset],mul=1,i=0;++i<byteLength&&(mul*=256);)val+=this[offset+i]*mul;return val},Buffer.prototype.readUIntBE=function(offset,byteLength,noAssert){offset>>>=0,byteLength>>>=0,noAssert||checkOffset(offset,byteLength,this.length);for(var val=this[offset+--byteLength],mul=1;0<byteLength&&(mul*=256);)val+=this[offset+--byteLength]*mul;return val},Buffer.prototype.readUInt8=function(offset,noAssert){return offset>>>=0,noAssert||checkOffset(offset,1,this.length),this[offset]},Buffer.prototype.readUInt16LE=function(offset,noAssert){return offset>>>=0,noAssert||checkOffset(offset,2,this.length),this[offset]|this[offset+1]<<8},Buffer.prototype.readUInt16BE=function(offset,noAssert){return offset>>>=0,noAssert||checkOffset(offset,2,this.length),this[offset]<<8|this[offset+1]},Buffer.prototype.readUInt32LE=function(offset,noAssert){return offset>>>=0,noAssert||checkOffset(offset,4,this.length),(this[offset]|this[offset+1]<<8|this[offset+2]<<16)+16777216*this[offset+3]},Buffer.prototype.readUInt32BE=function(offset,noAssert){return offset>>>=0,noAssert||checkOffset(offset,4,this.length),16777216*this[offset]+(this[offset+1]<<16|this[offset+2]<<8|this[offset+3])},Buffer.prototype.readIntLE=function(offset,byteLength,noAssert){offset>>>=0,byteLength>>>=0,noAssert||checkOffset(offset,byteLength,this.length);for(var val=this[offset],mul=1,i=0;++i<byteLength&&(mul*=256);)val+=this[offset+i]*mul;return(mul*=128)<=val&&(val-=Math.pow(2,8*byteLength)),val},Buffer.prototype.readIntBE=function(offset,byteLength,noAssert){offset>>>=0,byteLength>>>=0,noAssert||checkOffset(offset,byteLength,this.length);for(var i=byteLength,mul=1,val=this[offset+--i];0<i&&(mul*=256);)val+=this[offset+--i]*mul;return(mul*=128)<=val&&(val-=Math.pow(2,8*byteLength)),val},Buffer.prototype.readInt8=function(offset,noAssert){return offset>>>=0,noAssert||checkOffset(offset,1,this.length),128&this[offset]?-1*(255-this[offset]+1):this[offset]},Buffer.prototype.readInt16LE=function(offset,noAssert){offset>>>=0,noAssert||checkOffset(offset,2,this.length);var val=this[offset]|this[offset+1]<<8;return 32768&val?4294901760|val:val},Buffer.prototype.readInt16BE=function(offset,noAssert){offset>>>=0,noAssert||checkOffset(offset,2,this.length);var val=this[offset+1]|this[offset]<<8;return 32768&val?4294901760|val:val},Buffer.prototype.readInt32LE=function(offset,noAssert){return offset>>>=0,noAssert||checkOffset(offset,4,this.length),this[offset]|this[offset+1]<<8|this[offset+2]<<16|this[offset+3]<<24},Buffer.prototype.readInt32BE=function(offset,noAssert){return offset>>>=0,noAssert||checkOffset(offset,4,this.length),this[offset]<<24|this[offset+1]<<16|this[offset+2]<<8|this[offset+3]},Buffer.prototype.readFloatLE=function(offset,noAssert){return offset>>>=0,noAssert||checkOffset(offset,4,this.length),ieee754.read(this,offset,!0,23,4)},Buffer.prototype.readFloatBE=function(offset,noAssert){return offset>>>=0,noAssert||checkOffset(offset,4,this.length),ieee754.read(this,offset,!1,23,4)},Buffer.prototype.readDoubleLE=function(offset,noAssert){return offset>>>=0,noAssert||checkOffset(offset,8,this.length),ieee754.read(this,offset,!0,52,8)},Buffer.prototype.readDoubleBE=function(offset,noAssert){return offset>>>=0,noAssert||checkOffset(offset,8,this.length),ieee754.read(this,offset,!1,52,8)},Buffer.prototype.writeUIntLE=function(value,offset,byteLength,noAssert){value=+value,offset>>>=0,byteLength>>>=0,noAssert||checkInt(this,value,offset,byteLength,Math.pow(2,8*byteLength)-1,0);var mul=1,i=0;for(this[offset]=255&value;++i<byteLength&&(mul*=256);)this[offset+i]=value/mul&255;return offset+byteLength},Buffer.prototype.writeUIntBE=function(value,offset,byteLength,noAssert){value=+value,offset>>>=0,byteLength>>>=0,noAssert||checkInt(this,value,offset,byteLength,Math.pow(2,8*byteLength)-1,0);var i=byteLength-1,mul=1;for(this[offset+i]=255&value;0<=--i&&(mul*=256);)this[offset+i]=value/mul&255;return offset+byteLength},Buffer.prototype.writeUInt8=function(value,offset,noAssert){return value=+value,offset>>>=0,noAssert||checkInt(this,value,offset,1,255,0),this[offset]=255&value,offset+1},Buffer.prototype.writeUInt16LE=function(value,offset,noAssert){return value=+value,offset>>>=0,noAssert||checkInt(this,value,offset,2,65535,0),this[offset]=255&value,this[offset+1]=value>>>8,offset+2},Buffer.prototype.writeUInt16BE=function(value,offset,noAssert){return value=+value,offset>>>=0,noAssert||checkInt(this,value,offset,2,65535,0),this[offset]=value>>>8,this[offset+1]=255&value,offset+2},Buffer.prototype.writeUInt32LE=function(value,offset,noAssert){return value=+value,offset>>>=0,noAssert||checkInt(this,value,offset,4,4294967295,0),this[offset+3]=value>>>24,this[offset+2]=value>>>16,this[offset+1]=value>>>8,this[offset]=255&value,offset+4},Buffer.prototype.writeUInt32BE=function(value,offset,noAssert){return value=+value,offset>>>=0,noAssert||checkInt(this,value,offset,4,4294967295,0),this[offset]=value>>>24,this[offset+1]=value>>>16,this[offset+2]=value>>>8,this[offset+3]=255&value,offset+4},Buffer.prototype.writeIntLE=function(value,offset,byteLength,noAssert){if(value=+value,offset>>>=0,!noAssert){var limit=Math.pow(2,8*byteLength-1);checkInt(this,value,offset,byteLength,limit-1,-limit)}var i=0,mul=1,sub=0;for(this[offset]=255&value;++i<byteLength&&(mul*=256);)value<0&&0===sub&&0!==this[offset+i-1]&&(sub=1),this[offset+i]=(value/mul>>0)-sub&255;return offset+byteLength},Buffer.prototype.writeIntBE=function(value,offset,byteLength,noAssert){if(value=+value,offset>>>=0,!noAssert){var limit=Math.pow(2,8*byteLength-1);checkInt(this,value,offset,byteLength,limit-1,-limit)}var i=byteLength-1,mul=1,sub=0;for(this[offset+i]=255&value;0<=--i&&(mul*=256);)value<0&&0===sub&&0!==this[offset+i+1]&&(sub=1),this[offset+i]=(value/mul>>0)-sub&255;return offset+byteLength},Buffer.prototype.writeInt8=function(value,offset,noAssert){return value=+value,offset>>>=0,noAssert||checkInt(this,value,offset,1,127,-128),value<0&&(value=255+value+1),this[offset]=255&value,offset+1},Buffer.prototype.writeInt16LE=function(value,offset,noAssert){return value=+value,offset>>>=0,noAssert||checkInt(this,value,offset,2,32767,-32768),this[offset]=255&value,this[offset+1]=value>>>8,offset+2},Buffer.prototype.writeInt16BE=function(value,offset,noAssert){return value=+value,offset>>>=0,noAssert||checkInt(this,value,offset,2,32767,-32768),this[offset]=value>>>8,this[offset+1]=255&value,offset+2},Buffer.prototype.writeInt32LE=function(value,offset,noAssert){return value=+value,offset>>>=0,noAssert||checkInt(this,value,offset,4,2147483647,-2147483648),this[offset]=255&value,this[offset+1]=value>>>8,this[offset+2]=value>>>16,this[offset+3]=value>>>24,offset+4},Buffer.prototype.writeInt32BE=function(value,offset,noAssert){return value=+value,offset>>>=0,noAssert||checkInt(this,value,offset,4,2147483647,-2147483648),value<0&&(value=4294967295+value+1),this[offset]=value>>>24,this[offset+1]=value>>>16,this[offset+2]=value>>>8,this[offset+3]=255&value,offset+4},Buffer.prototype.writeFloatLE=function(value,offset,noAssert){return writeFloat(this,value,offset,!0,noAssert)},Buffer.prototype.writeFloatBE=function(value,offset,noAssert){return writeFloat(this,value,offset,!1,noAssert)},Buffer.prototype.writeDoubleLE=function(value,offset,noAssert){return writeDouble(this,value,offset,!0,noAssert)},Buffer.prototype.writeDoubleBE=function(value,offset,noAssert){return writeDouble(this,value,offset,!1,noAssert)},Buffer.prototype.copy=function(target,targetStart,start,end){if(!Buffer.isBuffer(target))throw new TypeError("argument should be a Buffer");if(start=start||0,end||0===end||(end=this.length),targetStart>=target.length&&(targetStart=target.length),targetStart=targetStart||0,0<end&&end<start&&(end=start),end===start)return 0;if(0===target.length||0===this.length)return 0;if(targetStart<0)throw new RangeError("targetStart out of bounds");if(start<0||start>=this.length)throw new RangeError("Index out of range");if(end<0)throw new RangeError("sourceEnd out of bounds");end>this.length&&(end=this.length),target.length-targetStart<end-start&&(end=target.length-targetStart+start);var len=end-start;if(this===target&&"function"==typeof Uint8Array.prototype.copyWithin)this.copyWithin(targetStart,start,end);else if(this===target&&start<targetStart&&targetStart<end)for(var i=len-1;0<=i;--i)target[i+targetStart]=this[i+start];else Uint8Array.prototype.set.call(target,this.subarray(start,end),targetStart);return len},Buffer.prototype.fill=function(val,start,end,encoding){if("string"==typeof val){if("string"==typeof start?(encoding=start,start=0,end=this.length):"string"==typeof end&&(encoding=end,end=this.length),void 0!==encoding&&"string"!=typeof encoding)throw new TypeError("encoding must be a string");if("string"==typeof encoding&&!Buffer.isEncoding(encoding))throw new TypeError("Unknown encoding: "+encoding);if(1===val.length){var code=val.charCodeAt(0);("utf8"===encoding&&code<128||"latin1"===encoding)&&(val=code)}}else"number"==typeof val?val&=255:"boolean"==typeof val&&(val=Number(val));if(start<0||this.length<start||this.length<end)throw new RangeError("Out of range index");if(end<=start)return this;var i;if(start>>>=0,end=void 0===end?this.length:end>>>0,"number"==typeof(val=val||0))for(i=start;i<end;++i)this[i]=val;else{var bytes=Buffer.isBuffer(val)?val:Buffer.from(val,encoding),len=bytes.length;if(0===len)throw new TypeError('The value "'+val+'" is invalid for argument "value"');for(i=0;i<end-start;++i)this[i+start]=bytes[i%len]}return this};var INVALID_BASE64_RE=/[^+/0-9A-Za-z-_]/g;function utf8ToBytes(string,units){var codePoint;units=units||1/0;for(var length=string.length,leadSurrogate=null,bytes=[],i=0;i<length;++i){if(55295<(codePoint=string.charCodeAt(i))&&codePoint<57344){if(!leadSurrogate){if(56319<codePoint){-1<(units-=3)&&bytes.push(239,191,189);continue}if(i+1===length){-1<(units-=3)&&bytes.push(239,191,189);continue}leadSurrogate=codePoint;continue}if(codePoint<56320){-1<(units-=3)&&bytes.push(239,191,189),leadSurrogate=codePoint;continue}codePoint=65536+(leadSurrogate-55296<<10|codePoint-56320)}else leadSurrogate&&-1<(units-=3)&&bytes.push(239,191,189);if(leadSurrogate=null,codePoint<128){if(--units<0)break;bytes.push(codePoint)}else if(codePoint<2048){if((units-=2)<0)break;bytes.push(codePoint>>6|192,63&codePoint|128)}else if(codePoint<65536){if((units-=3)<0)break;bytes.push(codePoint>>12|224,codePoint>>6&63|128,63&codePoint|128)}else{if(!(codePoint<1114112))throw new Error("Invalid code point");if((units-=4)<0)break;bytes.push(codePoint>>18|240,codePoint>>12&63|128,codePoint>>6&63|128,63&codePoint|128)}}return bytes}function base64ToBytes(str){return base64.toByteArray(function(str){if((str=(str=str.split("=")[0]).trim().replace(INVALID_BASE64_RE,"")).length<2)return"";for(;str.length%4!=0;)str+="=";return str}(str))}function blitBuffer(src,dst,offset,length){for(var i=0;i<length&&!(i+offset>=dst.length||i>=src.length);++i)dst[i+offset]=src[i];return i}function isInstance(obj,type){return obj instanceof type||null!=obj&&null!=obj.constructor&&null!=obj.constructor.name&&obj.constructor.name===type.name}function numberIsNaN(obj){return obj!=obj}var hexSliceLookupTable=function(){for(var table=new Array(256),i=0;i<16;++i)for(var i16=16*i,j=0;j<16;++j)table[i16+j]="0123456789abcdef"[i]+"0123456789abcdef"[j];return table}()}).call(this,require("buffer").Buffer)},{"base64-js":2,buffer:9,ieee754:21}],10:[function(require,module,exports){"use strict";var validate=require("./validation").validate,CHARSET_INVERSE_INDEX={q:0,p:1,z:2,r:3,y:4,9:5,x:6,8:7,g:8,f:9,2:10,t:11,v:12,d:13,w:14,0:15,s:16,3:17,j:18,n:19,5:20,4:21,k:22,h:23,c:24,e:25,6:26,m:27,u:28,a:29,7:30,l:31};module.exports={encode:function(data){validate(data instanceof Uint8Array,"Invalid data: "+data+".");for(var base32="",i=0;i<data.length;++i){var value=data[i];validate(0<=value&&value<32,"Invalid value: "+value+"."),base32+="qpzry9x8gf2tvdw0s3jn54khce6mua7l"[value]}return base32},decode:function(string){validate("string"==typeof string,"Invalid base32-encoded string: "+string+".");for(var data=new Uint8Array(string.length),i=0;i<string.length;++i){var value=string[i];validate(value in CHARSET_INVERSE_INDEX,"Invalid value: "+value+"."),data[i]=CHARSET_INVERSE_INDEX[value]}return data}}},{"./validation":13}],11:[function(require,module,exports){"use strict";var base32=require("./base32"),bigInt=require("big-integer"),convertBits=require("./convertBits"),validation=require("./validation"),validate=validation.validate;var ValidationError=validation.ValidationError,VALID_PREFIXES=["bitcoincash","bchtest","bchreg"];function prefixToUint5Array(prefix){for(var result=new Uint8Array(prefix.length),i=0;i<prefix.length;++i)result[i]=31&prefix[i].charCodeAt(0);return result}function concat(a,b){var ab=new Uint8Array(a.length+b.length);return ab.set(a),ab.set(b,a.length),ab}function polymod(data){for(var GENERATOR=[656907472481,522768456162,0xf33e5fb3c4,748107326120,130178868336],checksum=bigInt(1),i=0;i<data.length;++i){var value=data[i],topBits=checksum.shiftRight(35);checksum=checksum.and(34359738367).shiftLeft(5).xor(value);for(var j=0;j<GENERATOR.length;++j)topBits.shiftRight(j).and(1).equals(1)&&(checksum=checksum.xor(GENERATOR[j]))}return checksum.xor(1)}function hasSingleCase(string){return string===string.toLowerCase()||string===string.toUpperCase()}module.exports={encode:function(prefix,type,hash){validate("string"==typeof prefix&&function(prefix){return hasSingleCase(prefix)&&-1!==VALID_PREFIXES.indexOf(prefix.toLowerCase())}(prefix),"Invalid prefix: "+prefix+"."),validate("string"==typeof type,"Invalid type: "+type+"."),validate(hash instanceof Uint8Array,"Invalid hash: "+hash+".");var data,prefixData=concat(prefixToUint5Array(prefix),new Uint8Array(1)),versionByte=function(type){switch(type){case"P2PKH":return 0;case"P2SH":return 8;default:throw new ValidationError("Invalid type: "+type+".")}}(type)+function(hash){switch(8*hash.length){case 160:return 0;case 192:return 1;case 224:return 2;case 256:return 3;case 320:return 4;case 384:return 5;case 448:return 6;case 512:return 7;default:throw new ValidationError("Invalid hash size: "+hash.length+".")}}(hash),payloadData=(data=concat(new Uint8Array([versionByte]),hash),convertBits(data,8,5)),checksumData=concat(concat(prefixData,payloadData),new Uint8Array(8)),payload=concat(payloadData,function(checksum){for(var result=new Uint8Array(8),i=0;i<8;++i)result[7-i]=checksum.and(31).toJSNumber(),checksum=checksum.shiftRight(5);return result}(polymod(checksumData)));return prefix+":"+base32.encode(payload)},decode:function(address){validate("string"==typeof address&&hasSingleCase(address),"Invalid address: "+address+".");var pieces=address.toLowerCase().split(":");validate(2===pieces.length,"Missing prefix: "+address+".");var prefix=pieces[0],payload=base32.decode(pieces[1]);validate(function(prefix,payload){var prefixData=concat(prefixToUint5Array(prefix),new Uint8Array(1));return polymod(concat(prefixData,payload)).equals(0)}(prefix,payload),"Invalid checksum: "+address+".");var data,payloadData=(data=payload.subarray(0,-8),convertBits(data,5,8,!0)),versionByte=payloadData[0],hash=payloadData.subarray(1);return validate(function(versionByte){switch(7&versionByte){case 0:return 160;case 1:return 192;case 2:return 224;case 3:return 256;case 4:return 320;case 5:return 384;case 6:return 448;case 7:return 512}}(versionByte)===8*hash.length,"Invalid hash size: "+address+"."),{prefix:prefix,type:function(versionByte){switch(120&versionByte){case 0:return"P2PKH";case 8:return"P2SH";default:throw new ValidationError("Invalid address type in version byte: "+versionByte+".")}}(versionByte),hash:hash}},ValidationError:ValidationError}},{"./base32":10,"./convertBits":12,"./validation":13,"big-integer":3}],12:[function(require,module,exports){"use strict";var validate=require("./validation").validate;module.exports=function(data,from,to,strictMode){for(var length=strictMode?Math.floor(data.length*from/to):Math.ceil(data.length*from/to),mask=(1<<to)-1,result=new Uint8Array(length),index=0,accumulator=0,bits=0,i=0;i<data.length;++i){var value=data[i];for(validate(0<=value&&value>>from==0,"Invalid value: "+value+"."),accumulator=accumulator<<from|value,bits+=from;to<=bits;)bits-=to,result[index]=accumulator>>bits&mask,++index}return strictMode?validate(bits<from&&0==(accumulator<<to-bits&mask),"Input cannot be converted to "+to+" bits without padding, but strict mode was used."):0<bits&&(result[index]=accumulator<<to-bits&mask,++index),result}},{"./validation":13}],13:[function(require,module,exports){"use strict";function ValidationError(message){var error=new Error;this.name=error.name="ValidationError",this.message=error.message=message,this.stack=error.stack}ValidationError.prototype=Object.create(Error.prototype),module.exports={ValidationError:ValidationError,validate:function(condition,message){if(!condition)throw new ValidationError(message)}}},{}],14:[function(require,module,exports){var Buffer=require("safe-buffer").Buffer,Transform=require("stream").Transform,StringDecoder=require("string_decoder").StringDecoder;function CipherBase(hashMode){Transform.call(this),this.hashMode="string"==typeof hashMode,this.hashMode?this[hashMode]=this._finalOrDigest:this.final=this._finalOrDigest,this._final&&(this.__final=this._final,this._final=null),this._decoder=null,this._encoding=null}require("inherits")(CipherBase,Transform),CipherBase.prototype.update=function(data,inputEnc,outputEnc){"string"==typeof data&&(data=Buffer.from(data,inputEnc));var outData=this._update(data);return this.hashMode?this:(outputEnc&&(outData=this._toString(outData,outputEnc)),outData)},CipherBase.prototype.setAutoPadding=function(){},CipherBase.prototype.getAuthTag=function(){throw new Error("trying to get auth tag in unsupported state")},CipherBase.prototype.setAuthTag=function(){throw new Error("trying to set auth tag in unsupported state")},CipherBase.prototype.setAAD=function(){throw new Error("trying to set aad in unsupported state")},CipherBase.prototype._transform=function(data,_,next){var err;try{this.hashMode?this._update(data):this.push(this._update(data))}catch(e){err=e}finally{next(err)}},CipherBase.prototype._flush=function(done){var err;try{this.push(this.__final())}catch(e){err=e}done(err)},CipherBase.prototype._finalOrDigest=function(outputEnc){var outData=this.__final()||Buffer.alloc(0);return outputEnc&&(outData=this._toString(outData,outputEnc,!0)),outData},CipherBase.prototype._toString=function(value,enc,fin){if(this._decoder||(this._decoder=new StringDecoder(enc),this._encoding=enc),this._encoding!==enc)throw new Error("can't switch encodings");var out=this._decoder.write(value);return fin&&(out+=this._decoder.end()),out},module.exports=CipherBase},{inherits:22,"safe-buffer":42,stream:51,string_decoder:52}],15:[function(require,module,exports){(function(Buffer){function objectToString(o){return Object.prototype.toString.call(o)}exports.isArray=function(arg){return Array.isArray?Array.isArray(arg):"[object Array]"===objectToString(arg)},exports.isBoolean=function(arg){return"boolean"==typeof arg},exports.isNull=function(arg){return null===arg},exports.isNullOrUndefined=function(arg){return null==arg},exports.isNumber=function(arg){return"number"==typeof arg},exports.isString=function(arg){return"string"==typeof arg},exports.isSymbol=function(arg){return"symbol"==typeof arg},exports.isUndefined=function(arg){return void 0===arg},exports.isRegExp=function(re){return"[object RegExp]"===objectToString(re)},exports.isObject=function(arg){return"object"==typeof arg&&null!==arg},exports.isDate=function(d){return"[object Date]"===objectToString(d)},exports.isError=function(e){return"[object Error]"===objectToString(e)||e instanceof Error},exports.isFunction=function(arg){return"function"==typeof arg},exports.isPrimitive=function(arg){return null===arg||"boolean"==typeof arg||"number"==typeof arg||"string"==typeof arg||"symbol"==typeof arg||void 0===arg},exports.isBuffer=Buffer.isBuffer}).call(this,{isBuffer:require("../../is-buffer/index.js")})},{"../../is-buffer/index.js":23}],16:[function(require,module,exports){(function(Buffer){"use strict";var inherits=require("inherits"),md5=require("./md5"),RIPEMD160=require("ripemd160"),sha=require("sha.js"),Base=require("cipher-base");function HashNoConstructor(hash){Base.call(this,"digest"),this._hash=hash,this.buffers=[]}function Hash(hash){Base.call(this,"digest"),this._hash=hash}inherits(HashNoConstructor,Base),HashNoConstructor.prototype._update=function(data){this.buffers.push(data)},HashNoConstructor.prototype._final=function(){var buf=Buffer.concat(this.buffers),r=this._hash(buf);return this.buffers=null,r},inherits(Hash,Base),Hash.prototype._update=function(data){this._hash.update(data)},Hash.prototype._final=function(){return this._hash.digest()},module.exports=function(alg){return"md5"===(alg=alg.toLowerCase())?new HashNoConstructor(md5):new Hash("rmd160"===alg||"ripemd160"===alg?new RIPEMD160:sha(alg))}}).call(this,require("buffer").Buffer)},{"./md5":18,buffer:9,"cipher-base":14,inherits:22,ripemd160:41,"sha.js":44}],17:[function(require,module,exports){(function(Buffer){"use strict";var zeroBuffer=new Buffer(4);zeroBuffer.fill(0);module.exports=function(buf,fn){var arr=fn(function(buf){if(buf.length%4!=0){var len=buf.length+(4-buf.length%4);buf=Buffer.concat([buf,zeroBuffer],len)}for(var arr=new Array(buf.length>>>2),i=0,j=0;i<buf.length;i+=4,j++)arr[j]=buf.readInt32LE(i);return arr}(buf),8*buf.length);buf=new Buffer(16);for(var i=0;i<arr.length;i++)buf.writeInt32LE(arr[i],i<<2,!0);return buf}}).call(this,require("buffer").Buffer)},{buffer:9}],18:[function(require,module,exports){"use strict";var makeHash=require("./make-hash");function core_md5(x,len){x[len>>5]|=128<<len%32,x[14+(len+64>>>9<<4)]=len;for(var a=1732584193,b=-271733879,c=-1732584194,d=271733878,i=0;i<x.length;i+=16){var olda=a,oldb=b,oldc=c,oldd=d;a=md5_ff(a,b,c,d,x[i+0],7,-680876936),d=md5_ff(d,a,b,c,x[i+1],12,-389564586),c=md5_ff(c,d,a,b,x[i+2],17,606105819),b=md5_ff(b,c,d,a,x[i+3],22,-1044525330),a=md5_ff(a,b,c,d,x[i+4],7,-176418897),d=md5_ff(d,a,b,c,x[i+5],12,1200080426),c=md5_ff(c,d,a,b,x[i+6],17,-1473231341),b=md5_ff(b,c,d,a,x[i+7],22,-45705983),a=md5_ff(a,b,c,d,x[i+8],7,1770035416),d=md5_ff(d,a,b,c,x[i+9],12,-1958414417),c=md5_ff(c,d,a,b,x[i+10],17,-42063),b=md5_ff(b,c,d,a,x[i+11],22,-1990404162),a=md5_ff(a,b,c,d,x[i+12],7,1804603682),d=md5_ff(d,a,b,c,x[i+13],12,-40341101),c=md5_ff(c,d,a,b,x[i+14],17,-1502002290),a=md5_gg(a,b=md5_ff(b,c,d,a,x[i+15],22,1236535329),c,d,x[i+1],5,-165796510),d=md5_gg(d,a,b,c,x[i+6],9,-1069501632),c=md5_gg(c,d,a,b,x[i+11],14,643717713),b=md5_gg(b,c,d,a,x[i+0],20,-373897302),a=md5_gg(a,b,c,d,x[i+5],5,-701558691),d=md5_gg(d,a,b,c,x[i+10],9,38016083),c=md5_gg(c,d,a,b,x[i+15],14,-660478335),b=md5_gg(b,c,d,a,x[i+4],20,-405537848),a=md5_gg(a,b,c,d,x[i+9],5,568446438),d=md5_gg(d,a,b,c,x[i+14],9,-1019803690),c=md5_gg(c,d,a,b,x[i+3],14,-187363961),b=md5_gg(b,c,d,a,x[i+8],20,1163531501),a=md5_gg(a,b,c,d,x[i+13],5,-1444681467),d=md5_gg(d,a,b,c,x[i+2],9,-51403784),c=md5_gg(c,d,a,b,x[i+7],14,1735328473),a=md5_hh(a,b=md5_gg(b,c,d,a,x[i+12],20,-1926607734),c,d,x[i+5],4,-378558),d=md5_hh(d,a,b,c,x[i+8],11,-2022574463),c=md5_hh(c,d,a,b,x[i+11],16,1839030562),b=md5_hh(b,c,d,a,x[i+14],23,-35309556),a=md5_hh(a,b,c,d,x[i+1],4,-1530992060),d=md5_hh(d,a,b,c,x[i+4],11,1272893353),c=md5_hh(c,d,a,b,x[i+7],16,-155497632),b=md5_hh(b,c,d,a,x[i+10],23,-1094730640),a=md5_hh(a,b,c,d,x[i+13],4,681279174),d=md5_hh(d,a,b,c,x[i+0],11,-358537222),c=md5_hh(c,d,a,b,x[i+3],16,-722521979),b=md5_hh(b,c,d,a,x[i+6],23,76029189),a=md5_hh(a,b,c,d,x[i+9],4,-640364487),d=md5_hh(d,a,b,c,x[i+12],11,-421815835),c=md5_hh(c,d,a,b,x[i+15],16,530742520),a=md5_ii(a,b=md5_hh(b,c,d,a,x[i+2],23,-995338651),c,d,x[i+0],6,-198630844),d=md5_ii(d,a,b,c,x[i+7],10,1126891415),c=md5_ii(c,d,a,b,x[i+14],15,-1416354905),b=md5_ii(b,c,d,a,x[i+5],21,-57434055),a=md5_ii(a,b,c,d,x[i+12],6,1700485571),d=md5_ii(d,a,b,c,x[i+3],10,-1894986606),c=md5_ii(c,d,a,b,x[i+10],15,-1051523),b=md5_ii(b,c,d,a,x[i+1],21,-2054922799),a=md5_ii(a,b,c,d,x[i+8],6,1873313359),d=md5_ii(d,a,b,c,x[i+15],10,-30611744),c=md5_ii(c,d,a,b,x[i+6],15,-1560198380),b=md5_ii(b,c,d,a,x[i+13],21,1309151649),a=md5_ii(a,b,c,d,x[i+4],6,-145523070),d=md5_ii(d,a,b,c,x[i+11],10,-1120210379),c=md5_ii(c,d,a,b,x[i+2],15,718787259),b=md5_ii(b,c,d,a,x[i+9],21,-343485551),a=safe_add(a,olda),b=safe_add(b,oldb),c=safe_add(c,oldc),d=safe_add(d,oldd)}return[a,b,c,d]}function md5_cmn(q,a,b,x,s,t){return safe_add((num=safe_add(safe_add(a,q),safe_add(x,t)))<<(cnt=s)|num>>>32-cnt,b);var num,cnt}function md5_ff(a,b,c,d,x,s,t){return md5_cmn(b&c|~b&d,a,b,x,s,t)}function md5_gg(a,b,c,d,x,s,t){return md5_cmn(b&d|c&~d,a,b,x,s,t)}function md5_hh(a,b,c,d,x,s,t){return md5_cmn(b^c^d,a,b,x,s,t)}function md5_ii(a,b,c,d,x,s,t){return md5_cmn(c^(b|~d),a,b,x,s,t)}function safe_add(x,y){var lsw=(65535&x)+(65535&y);return(x>>16)+(y>>16)+(lsw>>16)<<16|65535&lsw}module.exports=function(buf){return makeHash(buf,core_md5)}},{"./make-hash":17}],19:[function(require,module,exports){var objectCreate=Object.create||function(proto){function F(){}return F.prototype=proto,new F},objectKeys=Object.keys||function(obj){var keys=[];for(var k in obj)Object.prototype.hasOwnProperty.call(obj,k)&&keys.push(k);return k},bind=Function.prototype.bind||function(context){var fn=this;return function(){return fn.apply(context,arguments)}};function EventEmitter(){this._events&&Object.prototype.hasOwnProperty.call(this,"_events")||(this._events=objectCreate(null),this._eventsCount=0),this._maxListeners=this._maxListeners||void 0}((module.exports=EventEmitter).EventEmitter=EventEmitter).prototype._events=void 0,EventEmitter.prototype._maxListeners=void 0;var hasDefineProperty,defaultMaxListeners=10;try{var o={};Object.defineProperty&&Object.defineProperty(o,"x",{value:0}),hasDefineProperty=0===o.x}catch(err){hasDefineProperty=!1}function $getMaxListeners(that){return void 0===that._maxListeners?EventEmitter.defaultMaxListeners:that._maxListeners}function _addListener(target,type,listener,prepend){var m,events,existing;if("function"!=typeof listener)throw new TypeError('"listener" argument must be a function');if((events=target._events)?(events.newListener&&(target.emit("newListener",type,listener.listener?listener.listener:listener),events=target._events),existing=events[type]):(events=target._events=objectCreate(null),target._eventsCount=0),existing){if("function"==typeof existing?existing=events[type]=prepend?[listener,existing]:[existing,listener]:prepend?existing.unshift(listener):existing.push(listener),!existing.warned&&(m=$getMaxListeners(target))&&0<m&&existing.length>m){existing.warned=!0;var w=new Error("Possible EventEmitter memory leak detected. "+existing.length+' "'+String(type)+'" listeners added. Use emitter.setMaxListeners() to increase limit.');w.name="MaxListenersExceededWarning",w.emitter=target,w.type=type,w.count=existing.length,"object"==typeof console&&console.warn&&console.warn("%s: %s",w.name,w.message)}}else existing=events[type]=listener,++target._eventsCount;return target}function onceWrapper(){if(!this.fired)switch(this.target.removeListener(this.type,this.wrapFn),this.fired=!0,arguments.length){case 0:return this.listener.call(this.target);case 1:return this.listener.call(this.target,arguments[0]);case 2:return this.listener.call(this.target,arguments[0],arguments[1]);case 3:return this.listener.call(this.target,arguments[0],arguments[1],arguments[2]);default:for(var args=new Array(arguments.length),i=0;i<args.length;++i)args[i]=arguments[i];this.listener.apply(this.target,args)}}function _onceWrap(target,type,listener){var state={fired:!1,wrapFn:void 0,target:target,type:type,listener:listener},wrapped=bind.call(onceWrapper,state);return wrapped.listener=listener,state.wrapFn=wrapped}function _listeners(target,type,unwrap){var events=target._events;if(!events)return[];var evlistener=events[type];return evlistener?"function"==typeof evlistener?unwrap?[evlistener.listener||evlistener]:[evlistener]:unwrap?function(arr){for(var ret=new Array(arr.length),i=0;i<ret.length;++i)ret[i]=arr[i].listener||arr[i];return ret}(evlistener):arrayClone(evlistener,evlistener.length):[]}function listenerCount(type){var events=this._events;if(events){var evlistener=events[type];if("function"==typeof evlistener)return 1;if(evlistener)return evlistener.length}return 0}function arrayClone(arr,n){for(var copy=new Array(n),i=0;i<n;++i)copy[i]=arr[i];return copy}hasDefineProperty?Object.defineProperty(EventEmitter,"defaultMaxListeners",{enumerable:!0,get:function(){return defaultMaxListeners},set:function(arg){if("number"!=typeof arg||arg<0||arg!=arg)throw new TypeError('"defaultMaxListeners" must be a positive number');defaultMaxListeners=arg}}):EventEmitter.defaultMaxListeners=defaultMaxListeners,EventEmitter.prototype.setMaxListeners=function(n){if("number"!=typeof n||n<0||isNaN(n))throw new TypeError('"n" argument must be a positive number');return this._maxListeners=n,this},EventEmitter.prototype.getMaxListeners=function(){return $getMaxListeners(this)},EventEmitter.prototype.emit=function(type,argument_1,argument_2,argument_3){var er,handler,len,args,i,events,doError="error"===type;if(events=this._events)doError=doError&&null==events.error;else if(!doError)return!1;if(doError){if(1<arguments.length&&(er=argument_1),er instanceof Error)throw er;var err=new Error('Unhandled "error" event. ('+er+")");throw err.context=er,err}if(!(handler=events[type]))return!1;var isFn="function"==typeof handler;switch(len=arguments.length){case 1:!function(handler,isFn,self){if(isFn)handler.call(self);else for(var len=handler.length,listeners=arrayClone(handler,len),i=0;i<len;++i)listeners[i].call(self)}(handler,isFn,this);break;case 2:!function(handler,isFn,self,arg1){if(isFn)handler.call(self,arg1);else for(var len=handler.length,listeners=arrayClone(handler,len),i=0;i<len;++i)listeners[i].call(self,arg1)}(handler,isFn,this,argument_1);break;case 3:!function(handler,isFn,self,arg1,arg2){if(isFn)handler.call(self,arg1,arg2);else for(var len=handler.length,listeners=arrayClone(handler,len),i=0;i<len;++i)listeners[i].call(self,arg1,arg2)}(handler,isFn,this,argument_1,argument_2);break;case 4:!function(handler,isFn,self,arg1,arg2,arg3){if(isFn)handler.call(self,arg1,arg2,arg3);else for(var len=handler.length,listeners=arrayClone(handler,len),i=0;i<len;++i)listeners[i].call(self,arg1,arg2,arg3)}(handler,isFn,this,argument_1,argument_2,argument_3);break;default:for(args=new Array(len-1),i=1;i<len;i++)args[i-1]=arguments[i];!function(handler,isFn,self,args){if(isFn)handler.apply(self,args);else for(var len=handler.length,listeners=arrayClone(handler,len),i=0;i<len;++i)listeners[i].apply(self,args)}(handler,isFn,this,args)}return!0},EventEmitter.prototype.on=EventEmitter.prototype.addListener=function(type,listener){return _addListener(this,type,listener,!1)},EventEmitter.prototype.prependListener=function(type,listener){return _addListener(this,type,listener,!0)},EventEmitter.prototype.once=function(type,listener){if("function"!=typeof listener)throw new TypeError('"listener" argument must be a function');return this.on(type,_onceWrap(this,type,listener)),this},EventEmitter.prototype.prependOnceListener=function(type,listener){if("function"!=typeof listener)throw new TypeError('"listener" argument must be a function');return this.prependListener(type,_onceWrap(this,type,listener)),this},EventEmitter.prototype.removeListener=function(type,listener){var list,events,position,i,originalListener;if("function"!=typeof listener)throw new TypeError('"listener" argument must be a function');if(!(events=this._events))return this;if(!(list=events[type]))return this;if(list===listener||list.listener===listener)0==--this._eventsCount?this._events=objectCreate(null):(delete events[type],events.removeListener&&this.emit("removeListener",type,list.listener||listener));else if("function"!=typeof list){for(position=-1,i=list.length-1;0<=i;i--)if(list[i]===listener||list[i].listener===listener){originalListener=list[i].listener,position=i;break}if(position<0)return this;0===position?list.shift():function(list,index){for(var i=index,k=i+1,n=list.length;k<n;i+=1,k+=1)list[i]=list[k];list.pop()}(list,position),1===list.length&&(events[type]=list[0]),events.removeListener&&this.emit("removeListener",type,originalListener||listener)}return this},EventEmitter.prototype.removeAllListeners=function(type){var listeners,events,i;if(!(events=this._events))return this;if(!events.removeListener)return 0===arguments.length?(this._events=objectCreate(null),this._eventsCount=0):events[type]&&(0==--this._eventsCount?this._events=objectCreate(null):delete events[type]),this;if(0===arguments.length){var key,keys=objectKeys(events);for(i=0;i<keys.length;++i)"removeListener"!==(key=keys[i])&&this.removeAllListeners(key);return this.removeAllListeners("removeListener"),this._events=objectCreate(null),this._eventsCount=0,this}if("function"==typeof(listeners=events[type]))this.removeListener(type,listeners);else if(listeners)for(i=listeners.length-1;0<=i;i--)this.removeListener(type,listeners[i]);return this},EventEmitter.prototype.listeners=function(type){return _listeners(this,type,!0)},EventEmitter.prototype.rawListeners=function(type){return _listeners(this,type,!1)},EventEmitter.listenerCount=function(emitter,type){return"function"==typeof emitter.listenerCount?emitter.listenerCount(type):listenerCount.call(emitter,type)},EventEmitter.prototype.listenerCount=listenerCount,EventEmitter.prototype.eventNames=function(){return 0<this._eventsCount?Reflect.ownKeys(this._events):[]}},{}],20:[function(require,module,exports){(function(Buffer){"use strict";var Transform=require("stream").Transform;function HashBase(blockSize){Transform.call(this),this._block=new Buffer(blockSize),this._blockSize=blockSize,this._blockOffset=0,this._length=[0,0,0,0],this._finalized=!1}require("inherits")(HashBase,Transform),HashBase.prototype._transform=function(chunk,encoding,callback){var error=null;try{"buffer"!==encoding&&(chunk=new Buffer(chunk,encoding)),this.update(chunk)}catch(err){error=err}callback(error)},HashBase.prototype._flush=function(callback){var error=null;try{this.push(this._digest())}catch(err){error=err}callback(error)},HashBase.prototype.update=function(data,encoding){if(!Buffer.isBuffer(data)&&"string"!=typeof data)throw new TypeError("Data must be a string or a buffer");if(this._finalized)throw new Error("Digest already called");Buffer.isBuffer(data)||(data=new Buffer(data,encoding||"binary"));for(var block=this._block,offset=0;this._blockOffset+data.length-offset>=this._blockSize;){for(var i=this._blockOffset;i<this._blockSize;)block[i++]=data[offset++];this._update(),this._blockOffset=0}for(;offset<data.length;)block[this._blockOffset++]=data[offset++];for(var j=0,carry=8*data.length;0<carry;++j)this._length[j]+=carry,0<(carry=this._length[j]/4294967296|0)&&(this._length[j]-=4294967296*carry);return this},HashBase.prototype._update=function(data){throw new Error("_update is not implemented")},HashBase.prototype.digest=function(encoding){if(this._finalized)throw new Error("Digest already called");this._finalized=!0;var digest=this._digest();return void 0!==encoding&&(digest=digest.toString(encoding)),digest},HashBase.prototype._digest=function(){throw new Error("_digest is not implemented")},module.exports=HashBase}).call(this,require("buffer").Buffer)},{buffer:9,inherits:22,stream:51}],21:[function(require,module,exports){exports.read=function(buffer,offset,isLE,mLen,nBytes){var e,m,eLen=8*nBytes-mLen-1,eMax=(1<<eLen)-1,eBias=eMax>>1,nBits=-7,i=isLE?nBytes-1:0,d=isLE?-1:1,s=buffer[offset+i];for(i+=d,e=s&(1<<-nBits)-1,s>>=-nBits,nBits+=eLen;0<nBits;e=256*e+buffer[offset+i],i+=d,nBits-=8);for(m=e&(1<<-nBits)-1,e>>=-nBits,nBits+=mLen;0<nBits;m=256*m+buffer[offset+i],i+=d,nBits-=8);if(0===e)e=1-eBias;else{if(e===eMax)return m?NaN:1/0*(s?-1:1);m+=Math.pow(2,mLen),e-=eBias}return(s?-1:1)*m*Math.pow(2,e-mLen)},exports.write=function(buffer,value,offset,isLE,mLen,nBytes){var e,m,c,eLen=8*nBytes-mLen-1,eMax=(1<<eLen)-1,eBias=eMax>>1,rt=23===mLen?Math.pow(2,-24)-Math.pow(2,-77):0,i=isLE?0:nBytes-1,d=isLE?1:-1,s=value<0||0===value&&1/value<0?1:0;for(value=Math.abs(value),isNaN(value)||value===1/0?(m=isNaN(value)?1:0,e=eMax):(e=Math.floor(Math.log(value)/Math.LN2),value*(c=Math.pow(2,-e))<1&&(e--,c*=2),2<=(value+=1<=e+eBias?rt/c:rt*Math.pow(2,1-eBias))*c&&(e++,c/=2),eMax<=e+eBias?(m=0,e=eMax):1<=e+eBias?(m=(value*c-1)*Math.pow(2,mLen),e+=eBias):(m=value*Math.pow(2,eBias-1)*Math.pow(2,mLen),e=0));8<=mLen;buffer[offset+i]=255&m,i+=d,m/=256,mLen-=8);for(e=e<<mLen|m,eLen+=mLen;0<eLen;buffer[offset+i]=255&e,i+=d,e/=256,eLen-=8);buffer[offset+i-d]|=128*s}},{}],22:[function(require,module,exports){"function"==typeof Object.create?module.exports=function(ctor,superCtor){ctor.super_=superCtor,ctor.prototype=Object.create(superCtor.prototype,{constructor:{value:ctor,enumerable:!1,writable:!0,configurable:!0}})}:module.exports=function(ctor,superCtor){ctor.super_=superCtor;function TempCtor(){}TempCtor.prototype=superCtor.prototype,ctor.prototype=new TempCtor,ctor.prototype.constructor=ctor}},{}],23:[function(require,module,exports){function isBuffer(obj){return!!obj.constructor&&"function"==typeof obj.constructor.isBuffer&&obj.constructor.isBuffer(obj)}module.exports=function(obj){return null!=obj&&(isBuffer(obj)||function(obj){return"function"==typeof obj.readFloatLE&&"function"==typeof obj.slice&&isBuffer(obj.slice(0,0))}(obj)||!!obj._isBuffer)}},{}],24:[function(require,module,exports){var toString={}.toString;module.exports=Array.isArray||function(arr){return"[object Array]"==toString.call(arr)}},{}],25:[function(require,module,exports){(function(process){"use strict";void 0===process||!process.version||0===process.version.indexOf("v0.")||0===process.version.indexOf("v1.")&&0!==process.version.indexOf("v1.8.")?module.exports={nextTick:function(fn,arg1,arg2,arg3){if("function"!=typeof fn)throw new TypeError('"callback" argument must be a function');var args,i,len=arguments.length;switch(len){case 0:case 1:return process.nextTick(fn);case 2:return process.nextTick(function(){fn.call(null,arg1)});case 3:return process.nextTick(function(){fn.call(null,arg1,arg2)});case 4:return process.nextTick(function(){fn.call(null,arg1,arg2,arg3)});default:for(args=new Array(len-1),i=0;i<args.length;)args[i++]=arguments[i];return process.nextTick(function(){fn.apply(null,args)})}}}:module.exports=process}).call(this,require("_process"))},{_process:26}],26:[function(require,module,exports){var cachedSetTimeout,cachedClearTimeout,process=module.exports={};function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}function runTimeout(fun){if(cachedSetTimeout===setTimeout)return setTimeout(fun,0);if((cachedSetTimeout===defaultSetTimout||!cachedSetTimeout)&&setTimeout)return cachedSetTimeout=setTimeout,setTimeout(fun,0);try{return cachedSetTimeout(fun,0)}catch(e){try{return cachedSetTimeout.call(null,fun,0)}catch(e){return cachedSetTimeout.call(this,fun,0)}}}!function(){try{cachedSetTimeout="function"==typeof setTimeout?setTimeout:defaultSetTimout}catch(e){cachedSetTimeout=defaultSetTimout}try{cachedClearTimeout="function"==typeof clearTimeout?clearTimeout:defaultClearTimeout}catch(e){cachedClearTimeout=defaultClearTimeout}}();var currentQueue,queue=[],draining=!1,queueIndex=-1;function cleanUpNextTick(){draining&&currentQueue&&(draining=!1,currentQueue.length?queue=currentQueue.concat(queue):queueIndex=-1,queue.length&&drainQueue())}function drainQueue(){if(!draining){var timeout=runTimeout(cleanUpNextTick);draining=!0;for(var len=queue.length;len;){for(currentQueue=queue,queue=[];++queueIndex<len;)currentQueue&&currentQueue[queueIndex].run();queueIndex=-1,len=queue.length}currentQueue=null,draining=!1,function(marker){if(cachedClearTimeout===clearTimeout)return clearTimeout(marker);if((cachedClearTimeout===defaultClearTimeout||!cachedClearTimeout)&&clearTimeout)return cachedClearTimeout=clearTimeout,clearTimeout(marker);try{cachedClearTimeout(marker)}catch(e){try{return cachedClearTimeout.call(null,marker)}catch(e){return cachedClearTimeout.call(this,marker)}}}(timeout)}}function Item(fun,array){this.fun=fun,this.array=array}function noop(){}process.nextTick=function(fun){var args=new Array(arguments.length-1);if(1<arguments.length)for(var i=1;i<arguments.length;i++)args[i-1]=arguments[i];queue.push(new Item(fun,args)),1!==queue.length||draining||runTimeout(drainQueue)},Item.prototype.run=function(){this.fun.apply(null,this.array)},process.title="browser",process.browser=!0,process.env={},process.argv=[],process.version="",process.versions={},process.on=noop,process.addListener=noop,process.once=noop,process.off=noop,process.removeListener=noop,process.removeAllListeners=noop,process.emit=noop,process.prependListener=noop,process.prependOnceListener=noop,process.listeners=function(name){return[]},process.binding=function(name){throw new Error("process.binding is not supported")},process.cwd=function(){return"/"},process.chdir=function(dir){throw new Error("process.chdir is not supported")},process.umask=function(){return 0}},{}],27:[function(require,module,exports){module.exports=require("./lib/_stream_duplex.js")},{"./lib/_stream_duplex.js":28}],28:[function(require,module,exports){"use strict";var pna=require("process-nextick-args"),objectKeys=Object.keys||function(obj){var keys=[];for(var key in obj)keys.push(key);return keys};module.exports=Duplex;var util=Object.create(require("core-util-is"));util.inherits=require("inherits");var Readable=require("./_stream_readable"),Writable=require("./_stream_writable");util.inherits(Duplex,Readable);for(var keys=objectKeys(Writable.prototype),v=0;v<keys.length;v++){var method=keys[v];Duplex.prototype[method]||(Duplex.prototype[method]=Writable.prototype[method])}function Duplex(options){if(!(this instanceof Duplex))return new Duplex(options);Readable.call(this,options),Writable.call(this,options),options&&!1===options.readable&&(this.readable=!1),options&&!1===options.writable&&(this.writable=!1),this.allowHalfOpen=!0,options&&!1===options.allowHalfOpen&&(this.allowHalfOpen=!1),this.once("end",onend)}function onend(){this.allowHalfOpen||this._writableState.ended||pna.nextTick(onEndNT,this)}function onEndNT(self){self.end()}Object.defineProperty(Duplex.prototype,"writableHighWaterMark",{enumerable:!1,get:function(){return this._writableState.highWaterMark}}),Object.defineProperty(Duplex.prototype,"destroyed",{get:function(){return void 0!==this._readableState&&void 0!==this._writableState&&(this._readableState.destroyed&&this._writableState.destroyed)},set:function(value){void 0!==this._readableState&&void 0!==this._writableState&&(this._readableState.destroyed=value,this._writableState.destroyed=value)}}),Duplex.prototype._destroy=function(err,cb){this.push(null),this.end(),pna.nextTick(cb,err)}},{"./_stream_readable":30,"./_stream_writable":32,"core-util-is":15,inherits:22,"process-nextick-args":25}],29:[function(require,module,exports){"use strict";module.exports=PassThrough;var Transform=require("./_stream_transform"),util=Object.create(require("core-util-is"));function PassThrough(options){if(!(this instanceof PassThrough))return new PassThrough(options);Transform.call(this,options)}util.inherits=require("inherits"),util.inherits(PassThrough,Transform),PassThrough.prototype._transform=function(chunk,encoding,cb){cb(null,chunk)}},{"./_stream_transform":31,"core-util-is":15,inherits:22}],30:[function(require,module,exports){(function(process,global){"use strict";var pna=require("process-nextick-args");module.exports=Readable;var Duplex,isArray=require("isarray");Readable.ReadableState=ReadableState;function EElistenerCount(emitter,type){return emitter.listeners(type).length}require("events").EventEmitter;var Stream=require("./internal/streams/stream"),Buffer=require("safe-buffer").Buffer,OurUint8Array=global.Uint8Array||function(){};var util=Object.create(require("core-util-is"));util.inherits=require("inherits");var debugUtil=require("util"),debug=void 0;debug=debugUtil&&debugUtil.debuglog?debugUtil.debuglog("stream"):function(){};var StringDecoder,BufferList=require("./internal/streams/BufferList"),destroyImpl=require("./internal/streams/destroy");util.inherits(Readable,Stream);var kProxyEvents=["error","close","destroy","pause","resume"];function ReadableState(options,stream){options=options||{};var isDuplex=stream instanceof(Duplex=Duplex||require("./_stream_duplex"));this.objectMode=!!options.objectMode,isDuplex&&(this.objectMode=this.objectMode||!!options.readableObjectMode);var hwm=options.highWaterMark,readableHwm=options.readableHighWaterMark,defaultHwm=this.objectMode?16:16384;this.highWaterMark=hwm||0===hwm?hwm:isDuplex&&(readableHwm||0===readableHwm)?readableHwm:defaultHwm,this.highWaterMark=Math.floor(this.highWaterMark),this.buffer=new BufferList,this.length=0,this.pipes=null,this.pipesCount=0,this.flowing=null,this.ended=!1,this.endEmitted=!1,this.reading=!1,this.sync=!0,this.needReadable=!1,this.emittedReadable=!1,this.readableListening=!1,this.resumeScheduled=!1,this.destroyed=!1,this.defaultEncoding=options.defaultEncoding||"utf8",this.awaitDrain=0,this.readingMore=!1,this.decoder=null,this.encoding=null,options.encoding&&(StringDecoder=StringDecoder||require("string_decoder/").StringDecoder,this.decoder=new StringDecoder(options.encoding),this.encoding=options.encoding)}function Readable(options){if(Duplex=Duplex||require("./_stream_duplex"),!(this instanceof Readable))return new Readable(options);this._readableState=new ReadableState(options,this),this.readable=!0,options&&("function"==typeof options.read&&(this._read=options.read),"function"==typeof options.destroy&&(this._destroy=options.destroy)),Stream.call(this)}function readableAddChunk(stream,chunk,encoding,addToFront,skipChunkCheck){var er,state=stream._readableState;null===chunk?(state.reading=!1,function(stream,state){if(state.ended)return;if(state.decoder){var chunk=state.decoder.end();chunk&&chunk.length&&(state.buffer.push(chunk),state.length+=state.objectMode?1:chunk.length)}state.ended=!0,emitReadable(stream)}(stream,state)):(skipChunkCheck||(er=function(state,chunk){var er;(function(obj){return Buffer.isBuffer(obj)||obj instanceof OurUint8Array})(chunk)||"string"==typeof chunk||void 0===chunk||state.objectMode||(er=new TypeError("Invalid non-string/buffer chunk"));return er}(state,chunk)),er?stream.emit("error",er):state.objectMode||chunk&&0<chunk.length?("string"==typeof chunk||state.objectMode||Object.getPrototypeOf(chunk)===Buffer.prototype||(chunk=function(chunk){return Buffer.from(chunk)}(chunk)),addToFront?state.endEmitted?stream.emit("error",new Error("stream.unshift() after end event")):addChunk(stream,state,chunk,!0):state.ended?stream.emit("error",new Error("stream.push() after EOF")):(state.reading=!1,state.decoder&&!encoding?(chunk=state.decoder.write(chunk),state.objectMode||0!==chunk.length?addChunk(stream,state,chunk,!1):maybeReadMore(stream,state)):addChunk(stream,state,chunk,!1))):addToFront||(state.reading=!1));return function(state){return!state.ended&&(state.needReadable||state.length<state.highWaterMark||0===state.length)}(state)}function addChunk(stream,state,chunk,addToFront){state.flowing&&0===state.length&&!state.sync?(stream.emit("data",chunk),stream.read(0)):(state.length+=state.objectMode?1:chunk.length,addToFront?state.buffer.unshift(chunk):state.buffer.push(chunk),state.needReadable&&emitReadable(stream)),maybeReadMore(stream,state)}Object.defineProperty(Readable.prototype,"destroyed",{get:function(){return void 0!==this._readableState&&this._readableState.destroyed},set:function(value){this._readableState&&(this._readableState.destroyed=value)}}),Readable.prototype.destroy=destroyImpl.destroy,Readable.prototype._undestroy=destroyImpl.undestroy,Readable.prototype._destroy=function(err,cb){this.push(null),cb(err)},Readable.prototype.push=function(chunk,encoding){var skipChunkCheck,state=this._readableState;return state.objectMode?skipChunkCheck=!0:"string"==typeof chunk&&((encoding=encoding||state.defaultEncoding)!==state.encoding&&(chunk=Buffer.from(chunk,encoding),encoding=""),skipChunkCheck=!0),readableAddChunk(this,chunk,encoding,!1,skipChunkCheck)},Readable.prototype.unshift=function(chunk){return readableAddChunk(this,chunk,null,!0,!1)},Readable.prototype.isPaused=function(){return!1===this._readableState.flowing},Readable.prototype.setEncoding=function(enc){return StringDecoder=StringDecoder||require("string_decoder/").StringDecoder,this._readableState.decoder=new StringDecoder(enc),this._readableState.encoding=enc,this};var MAX_HWM=8388608;function howMuchToRead(n,state){return n<=0||0===state.length&&state.ended?0:state.objectMode?1:n!=n?state.flowing&&state.length?state.buffer.head.data.length:state.length:(n>state.highWaterMark&&(state.highWaterMark=function(n){return MAX_HWM<=n?n=MAX_HWM:(n--,n|=n>>>1,n|=n>>>2,n|=n>>>4,n|=n>>>8,n|=n>>>16,n++),n}(n)),n<=state.length?n:state.ended?state.length:(state.needReadable=!0,0))}function emitReadable(stream){var state=stream._readableState;state.needReadable=!1,state.emittedReadable||(debug("emitReadable",state.flowing),state.emittedReadable=!0,state.sync?pna.nextTick(emitReadable_,stream):emitReadable_(stream))}function emitReadable_(stream){debug("emit readable"),stream.emit("readable"),flow(stream)}function maybeReadMore(stream,state){state.readingMore||(state.readingMore=!0,pna.nextTick(maybeReadMore_,stream,state))}function maybeReadMore_(stream,state){for(var len=state.length;!state.reading&&!state.flowing&&!state.ended&&state.length<state.highWaterMark&&(debug("maybeReadMore read 0"),stream.read(0),len!==state.length);)len=state.length;state.readingMore=!1}function nReadingNextTick(self){debug("readable nexttick read 0"),self.read(0)}function resume_(stream,state){state.reading||(debug("resume read 0"),stream.read(0)),state.resumeScheduled=!1,state.awaitDrain=0,stream.emit("resume"),flow(stream),state.flowing&&!state.reading&&stream.read(0)}function flow(stream){var state=stream._readableState;for(debug("flow",state.flowing);state.flowing&&null!==stream.read(););}function fromList(n,state){return 0===state.length?null:(state.objectMode?ret=state.buffer.shift():!n||n>=state.length?(ret=state.decoder?state.buffer.join(""):1===state.buffer.length?state.buffer.head.data:state.buffer.concat(state.length),state.buffer.clear()):ret=function(n,list,hasStrings){var ret;n<list.head.data.length?(ret=list.head.data.slice(0,n),list.head.data=list.head.data.slice(n)):ret=n===list.head.data.length?list.shift():(hasStrings?function(n,list){var p=list.head,c=1,ret=p.data;n-=ret.length;for(;p=p.next;){var str=p.data,nb=n>str.length?str.length:n;if(nb===str.length?ret+=str:ret+=str.slice(0,n),0===(n-=nb)){nb===str.length?(++c,p.next?list.head=p.next:list.head=list.tail=null):(list.head=p).data=str.slice(nb);break}++c}return list.length-=c,ret}:function(n,list){var ret=Buffer.allocUnsafe(n),p=list.head,c=1;p.data.copy(ret),n-=p.data.length;for(;p=p.next;){var buf=p.data,nb=n>buf.length?buf.length:n;if(buf.copy(ret,ret.length-n,0,nb),0===(n-=nb)){nb===buf.length?(++c,p.next?list.head=p.next:list.head=list.tail=null):(list.head=p).data=buf.slice(nb);break}++c}return list.length-=c,ret})(n,list);return ret}(n,state.buffer,state.decoder),ret);var ret}function endReadable(stream){var state=stream._readableState;if(0<state.length)throw new Error('"endReadable()" called on non-empty stream');state.endEmitted||(state.ended=!0,pna.nextTick(endReadableNT,state,stream))}function endReadableNT(state,stream){state.endEmitted||0!==state.length||(state.endEmitted=!0,stream.readable=!1,stream.emit("end"))}function indexOf(xs,x){for(var i=0,l=xs.length;i<l;i++)if(xs[i]===x)return i;return-1}Readable.prototype.read=function(n){debug("read",n),n=parseInt(n,10);var state=this._readableState,nOrig=n;if(0!==n&&(state.emittedReadable=!1),0===n&&state.needReadable&&(state.length>=state.highWaterMark||state.ended))return debug("read: emitReadable",state.length,state.ended),(0===state.length&&state.ended?endReadable:emitReadable)(this),null;if(0===(n=howMuchToRead(n,state))&&state.ended)return 0===state.length&&endReadable(this),null;var ret,doRead=state.needReadable;return debug("need readable",doRead),(0===state.length||state.length-n<state.highWaterMark)&&debug("length less than watermark",doRead=!0),state.ended||state.reading?debug("reading or ended",doRead=!1):doRead&&(debug("do read"),state.reading=!0,state.sync=!0,0===state.length&&(state.needReadable=!0),this._read(state.highWaterMark),state.sync=!1,state.reading||(n=howMuchToRead(nOrig,state))),null===(ret=0<n?fromList(n,state):null)?(state.needReadable=!0,n=0):state.length-=n,0===state.length&&(state.ended||(state.needReadable=!0),nOrig!==n&&state.ended&&endReadable(this)),null!==ret&&this.emit("data",ret),ret},Readable.prototype._read=function(n){this.emit("error",new Error("_read() is not implemented"))},Readable.prototype.pipe=function(dest,pipeOpts){var src=this,state=this._readableState;switch(state.pipesCount){case 0:state.pipes=dest;break;case 1:state.pipes=[state.pipes,dest];break;default:state.pipes.push(dest)}state.pipesCount+=1,debug("pipe count=%d opts=%j",state.pipesCount,pipeOpts);var endFn=(!pipeOpts||!1!==pipeOpts.end)&&dest!==process.stdout&&dest!==process.stderr?onend:unpipe;function onunpipe(readable,unpipeInfo){debug("onunpipe"),readable===src&&unpipeInfo&&!1===unpipeInfo.hasUnpiped&&(unpipeInfo.hasUnpiped=!0,debug("cleanup"),dest.removeListener("close",onclose),dest.removeListener("finish",onfinish),dest.removeListener("drain",ondrain),dest.removeListener("error",onerror),dest.removeListener("unpipe",onunpipe),src.removeListener("end",onend),src.removeListener("end",unpipe),src.removeListener("data",ondata),cleanedUp=!0,!state.awaitDrain||dest._writableState&&!dest._writableState.needDrain||ondrain())}function onend(){debug("onend"),dest.end()}state.endEmitted?pna.nextTick(endFn):src.once("end",endFn),dest.on("unpipe",onunpipe);var ondrain=function(src){return function(){var state=src._readableState;debug("pipeOnDrain",state.awaitDrain),state.awaitDrain&&state.awaitDrain--,0===state.awaitDrain&&EElistenerCount(src,"data")&&(state.flowing=!0,flow(src))}}(src);dest.on("drain",ondrain);var cleanedUp=!1;var increasedAwaitDrain=!1;function ondata(chunk){debug("ondata"),(increasedAwaitDrain=!1)!==dest.write(chunk)||increasedAwaitDrain||((1===state.pipesCount&&state.pipes===dest||1<state.pipesCount&&-1!==indexOf(state.pipes,dest))&&!cleanedUp&&(debug("false write response, pause",src._readableState.awaitDrain),src._readableState.awaitDrain++,increasedAwaitDrain=!0),src.pause())}function onerror(er){debug("onerror",er),unpipe(),dest.removeListener("error",onerror),0===EElistenerCount(dest,"error")&&dest.emit("error",er)}function onclose(){dest.removeListener("finish",onfinish),unpipe()}function onfinish(){debug("onfinish"),dest.removeListener("close",onclose),unpipe()}function unpipe(){debug("unpipe"),src.unpipe(dest)}return src.on("data",ondata),function(emitter,event,fn){if("function"==typeof emitter.prependListener)return emitter.prependListener(event,fn);emitter._events&&emitter._events[event]?isArray(emitter._events[event])?emitter._events[event].unshift(fn):emitter._events[event]=[fn,emitter._events[event]]:emitter.on(event,fn)}(dest,"error",onerror),dest.once("close",onclose),dest.once("finish",onfinish),dest.emit("pipe",src),state.flowing||(debug("pipe resume"),src.resume()),dest},Readable.prototype.unpipe=function(dest){var state=this._readableState,unpipeInfo={hasUnpiped:!1};if(0===state.pipesCount)return this;if(1===state.pipesCount)return dest&&dest!==state.pipes||(dest=dest||state.pipes,state.pipes=null,state.pipesCount=0,state.flowing=!1,dest&&dest.emit("unpipe",this,unpipeInfo)),this;if(!dest){var dests=state.pipes,len=state.pipesCount;state.pipes=null,state.pipesCount=0,state.flowing=!1;for(var i=0;i<len;i++)dests[i].emit("unpipe",this,unpipeInfo);return this}var index=indexOf(state.pipes,dest);return-1===index||(state.pipes.splice(index,1),--state.pipesCount,1===state.pipesCount&&(state.pipes=state.pipes[0]),dest.emit("unpipe",this,unpipeInfo)),this},Readable.prototype.addListener=Readable.prototype.on=function(ev,fn){var res=Stream.prototype.on.call(this,ev,fn);if("data"===ev)!1!==this._readableState.flowing&&this.resume();else if("readable"===ev){var state=this._readableState;state.endEmitted||state.readableListening||(state.readableListening=state.needReadable=!0,state.emittedReadable=!1,state.reading?state.length&&emitReadable(this):pna.nextTick(nReadingNextTick,this))}return res},Readable.prototype.resume=function(){var state=this._readableState;return state.flowing||(debug("resume"),state.flowing=!0,function(stream,state){state.resumeScheduled||(state.resumeScheduled=!0,pna.nextTick(resume_,stream,state))}(this,state)),this},Readable.prototype.pause=function(){return debug("call pause flowing=%j",this._readableState.flowing),!1!==this._readableState.flowing&&(debug("pause"),this._readableState.flowing=!1,this.emit("pause")),this},Readable.prototype.wrap=function(stream){var _this=this,state=this._readableState,paused=!1;for(var i in stream.on("end",function(){if(debug("wrapped end"),state.decoder&&!state.ended){var chunk=state.decoder.end();chunk&&chunk.length&&_this.push(chunk)}_this.push(null)}),stream.on("data",function(chunk){debug("wrapped data"),state.decoder&&(chunk=state.decoder.write(chunk)),state.objectMode&&null==chunk||(state.objectMode||chunk&&chunk.length)&&(_this.push(chunk)||(paused=!0,stream.pause()))}),stream)void 0===this[i]&&"function"==typeof stream[i]&&(this[i]=function(method){return function(){return stream[method].apply(stream,arguments)}}(i));for(var n=0;n<kProxyEvents.length;n++)stream.on(kProxyEvents[n],this.emit.bind(this,kProxyEvents[n]));return this._read=function(n){debug("wrapped _read",n),paused&&(paused=!1,stream.resume())},this},Object.defineProperty(Readable.prototype,"readableHighWaterMark",{enumerable:!1,get:function(){return this._readableState.highWaterMark}}),Readable._fromList=fromList}).call(this,require("_process"),"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./_stream_duplex":28,"./internal/streams/BufferList":33,"./internal/streams/destroy":34,"./internal/streams/stream":35,_process:26,"core-util-is":15,events:19,inherits:22,isarray:24,"process-nextick-args":25,"safe-buffer":42,"string_decoder/":36,util:4}],31:[function(require,module,exports){"use strict";module.exports=Transform;var Duplex=require("./_stream_duplex"),util=Object.create(require("core-util-is"));function Transform(options){if(!(this instanceof Transform))return new Transform(options);Duplex.call(this,options),this._transformState={afterTransform:function(er,data){var ts=this._transformState;ts.transforming=!1;var cb=ts.writecb;if(!cb)return this.emit("error",new Error("write callback called multiple times"));ts.writechunk=null,(ts.writecb=null)!=data&&this.push(data),cb(er);var rs=this._readableState;rs.reading=!1,(rs.needReadable||rs.length<rs.highWaterMark)&&this._read(rs.highWaterMark)}.bind(this),needTransform:!1,transforming:!1,writecb:null,writechunk:null,writeencoding:null},this._readableState.needReadable=!0,this._readableState.sync=!1,options&&("function"==typeof options.transform&&(this._transform=options.transform),"function"==typeof options.flush&&(this._flush=options.flush)),this.on("prefinish",prefinish)}function prefinish(){var _this=this;"function"==typeof this._flush?this._flush(function(er,data){done(_this,er,data)}):done(this,null,null)}function done(stream,er,data){if(er)return stream.emit("error",er);if(null!=data&&stream.push(data),stream._writableState.length)throw new Error("Calling transform done when ws.length != 0");if(stream._transformState.transforming)throw new Error("Calling transform done when still transforming");return stream.push(null)}util.inherits=require("inherits"),util.inherits(Transform,Duplex),Transform.prototype.push=function(chunk,encoding){return this._transformState.needTransform=!1,Duplex.prototype.push.call(this,chunk,encoding)},Transform.prototype._transform=function(chunk,encoding,cb){throw new Error("_transform() is not implemented")},Transform.prototype._write=function(chunk,encoding,cb){var ts=this._transformState;if(ts.writecb=cb,ts.writechunk=chunk,ts.writeencoding=encoding,!ts.transforming){var rs=this._readableState;(ts.needTransform||rs.needReadable||rs.length<rs.highWaterMark)&&this._read(rs.highWaterMark)}},Transform.prototype._read=function(n){var ts=this._transformState;null!==ts.writechunk&&ts.writecb&&!ts.transforming?(ts.transforming=!0,this._transform(ts.writechunk,ts.writeencoding,ts.afterTransform)):ts.needTransform=!0},Transform.prototype._destroy=function(err,cb){var _this2=this;Duplex.prototype._destroy.call(this,err,function(err2){cb(err2),_this2.emit("close")})}},{"./_stream_duplex":28,"core-util-is":15,inherits:22}],32:[function(require,module,exports){(function(process,global,setImmediate){"use strict";var pna=require("process-nextick-args");function CorkedRequest(state){var _this=this;this.next=null,this.entry=null,this.finish=function(){!function(corkReq,state,err){var entry=corkReq.entry;corkReq.entry=null;for(;entry;){var cb=entry.callback;state.pendingcb--,cb(err),entry=entry.next}state.corkedRequestsFree?state.corkedRequestsFree.next=corkReq:state.corkedRequestsFree=corkReq}(_this,state)}}module.exports=Writable;var Duplex,asyncWrite=!process.browser&&-1<["v0.10","v0.9."].indexOf(process.version.slice(0,5))?setImmediate:pna.nextTick;Writable.WritableState=WritableState;var util=Object.create(require("core-util-is"));util.inherits=require("inherits");var internalUtil={deprecate:require("util-deprecate")},Stream=require("./internal/streams/stream"),Buffer=require("safe-buffer").Buffer,OurUint8Array=global.Uint8Array||function(){};var realHasInstance,destroyImpl=require("./internal/streams/destroy");function nop(){}function WritableState(options,stream){Duplex=Duplex||require("./_stream_duplex"),options=options||{};var isDuplex=stream instanceof Duplex;this.objectMode=!!options.objectMode,isDuplex&&(this.objectMode=this.objectMode||!!options.writableObjectMode);var hwm=options.highWaterMark,writableHwm=options.writableHighWaterMark,defaultHwm=this.objectMode?16:16384;this.highWaterMark=hwm||0===hwm?hwm:isDuplex&&(writableHwm||0===writableHwm)?writableHwm:defaultHwm,this.highWaterMark=Math.floor(this.highWaterMark),this.finalCalled=!1,this.needDrain=!1,this.ending=!1,this.ended=!1,this.finished=!1;var noDecode=(this.destroyed=!1)===options.decodeStrings;this.decodeStrings=!noDecode,this.defaultEncoding=options.defaultEncoding||"utf8",this.length=0,this.writing=!1,this.corked=0,this.sync=!0,this.bufferProcessing=!1,this.onwrite=function(er){!function(stream,er){var state=stream._writableState,sync=state.sync,cb=state.writecb;if(function(state){state.writing=!1,state.writecb=null,state.length-=state.writelen,state.writelen=0}(state),er)!function(stream,state,sync,er,cb){--state.pendingcb,sync?(pna.nextTick(cb,er),pna.nextTick(finishMaybe,stream,state),stream._writableState.errorEmitted=!0,stream.emit("error",er)):(cb(er),stream._writableState.errorEmitted=!0,stream.emit("error",er),finishMaybe(stream,state))}(stream,state,sync,er,cb);else{var finished=needFinish(state);finished||state.corked||state.bufferProcessing||!state.bufferedRequest||clearBuffer(stream,state),sync?asyncWrite(afterWrite,stream,state,finished,cb):afterWrite(stream,state,finished,cb)}}(stream,er)},this.writecb=null,this.writelen=0,this.bufferedRequest=null,this.lastBufferedRequest=null,this.pendingcb=0,this.prefinished=!1,this.errorEmitted=!1,this.bufferedRequestCount=0,this.corkedRequestsFree=new CorkedRequest(this)}function Writable(options){if(Duplex=Duplex||require("./_stream_duplex"),!(realHasInstance.call(Writable,this)||this instanceof Duplex))return new Writable(options);this._writableState=new WritableState(options,this),this.writable=!0,options&&("function"==typeof options.write&&(this._write=options.write),"function"==typeof options.writev&&(this._writev=options.writev),"function"==typeof options.destroy&&(this._destroy=options.destroy),"function"==typeof options.final&&(this._final=options.final)),Stream.call(this)}function doWrite(stream,state,writev,len,chunk,encoding,cb){state.writelen=len,state.writecb=cb,state.writing=!0,state.sync=!0,writev?stream._writev(chunk,state.onwrite):stream._write(chunk,encoding,state.onwrite),state.sync=!1}function afterWrite(stream,state,finished,cb){finished||function(stream,state){0===state.length&&state.needDrain&&(state.needDrain=!1,stream.emit("drain"))}(stream,state),state.pendingcb--,cb(),finishMaybe(stream,state)}function clearBuffer(stream,state){state.bufferProcessing=!0;var entry=state.bufferedRequest;if(stream._writev&&entry&&entry.next){var l=state.bufferedRequestCount,buffer=new Array(l),holder=state.corkedRequestsFree;holder.entry=entry;for(var count=0,allBuffers=!0;entry;)(buffer[count]=entry).isBuf||(allBuffers=!1),entry=entry.next,count+=1;buffer.allBuffers=allBuffers,doWrite(stream,state,!0,state.length,buffer,"",holder.finish),state.pendingcb++,state.lastBufferedRequest=null,holder.next?(state.corkedRequestsFree=holder.next,holder.next=null):state.corkedRequestsFree=new CorkedRequest(state),state.bufferedRequestCount=0}else{for(;entry;){var chunk=entry.chunk,encoding=entry.encoding,cb=entry.callback;if(doWrite(stream,state,!1,state.objectMode?1:chunk.length,chunk,encoding,cb),entry=entry.next,state.bufferedRequestCount--,state.writing)break}null===entry&&(state.lastBufferedRequest=null)}state.bufferedRequest=entry,state.bufferProcessing=!1}function needFinish(state){return state.ending&&0===state.length&&null===state.bufferedRequest&&!state.finished&&!state.writing}function callFinal(stream,state){stream._final(function(err){state.pendingcb--,err&&stream.emit("error",err),state.prefinished=!0,stream.emit("prefinish"),finishMaybe(stream,state)})}function finishMaybe(stream,state){var need=needFinish(state);return need&&(function(stream,state){state.prefinished||state.finalCalled||("function"==typeof stream._final?(state.pendingcb++,state.finalCalled=!0,pna.nextTick(callFinal,stream,state)):(state.prefinished=!0,stream.emit("prefinish")))}(stream,state),0===state.pendingcb&&(state.finished=!0,stream.emit("finish"))),need}util.inherits(Writable,Stream),WritableState.prototype.getBuffer=function(){for(var current=this.bufferedRequest,out=[];current;)out.push(current),current=current.next;return out},function(){try{Object.defineProperty(WritableState.prototype,"buffer",{get:internalUtil.deprecate(function(){return this.getBuffer()},"_writableState.buffer is deprecated. Use _writableState.getBuffer instead.","DEP0003")})}catch(_){}}(),"function"==typeof Symbol&&Symbol.hasInstance&&"function"==typeof Function.prototype[Symbol.hasInstance]?(realHasInstance=Function.prototype[Symbol.hasInstance],Object.defineProperty(Writable,Symbol.hasInstance,{value:function(object){return!!realHasInstance.call(this,object)||this===Writable&&(object&&object._writableState instanceof WritableState)}})):realHasInstance=function(object){return object instanceof this},Writable.prototype.pipe=function(){this.emit("error",new Error("Cannot pipe, not readable"))},Writable.prototype.write=function(chunk,encoding,cb){var obj,state=this._writableState,ret=!1,isBuf=!state.objectMode&&(obj=chunk,Buffer.isBuffer(obj)||obj instanceof OurUint8Array);return isBuf&&!Buffer.isBuffer(chunk)&&(chunk=function(chunk){return Buffer.from(chunk)}(chunk)),"function"==typeof encoding&&(cb=encoding,encoding=null),encoding=isBuf?"buffer":encoding||state.defaultEncoding,"function"!=typeof cb&&(cb=nop),state.ended?function(stream,cb){var er=new Error("write after end");stream.emit("error",er),pna.nextTick(cb,er)}(this,cb):(isBuf||function(stream,state,chunk,cb){var valid=!0,er=!1;return null===chunk?er=new TypeError("May not write null values to stream"):"string"==typeof chunk||void 0===chunk||state.objectMode||(er=new TypeError("Invalid non-string/buffer chunk")),er&&(stream.emit("error",er),pna.nextTick(cb,er),valid=!1),valid}(this,state,chunk,cb))&&(state.pendingcb++,ret=function(stream,state,isBuf,chunk,encoding,cb){if(!isBuf){var newChunk=function(state,chunk,encoding){state.objectMode||!1===state.decodeStrings||"string"!=typeof chunk||(chunk=Buffer.from(chunk,encoding));return chunk}(state,chunk,encoding);chunk!==newChunk&&(isBuf=!0,encoding="buffer",chunk=newChunk)}var len=state.objectMode?1:chunk.length;state.length+=len;var ret=state.length<state.highWaterMark;ret||(state.needDrain=!0);if(state.writing||state.corked){var last=state.lastBufferedRequest;state.lastBufferedRequest={chunk:chunk,encoding:encoding,isBuf:isBuf,callback:cb,next:null},last?last.next=state.lastBufferedRequest:state.bufferedRequest=state.lastBufferedRequest,state.bufferedRequestCount+=1}else doWrite(stream,state,!1,len,chunk,encoding,cb);return ret}(this,state,isBuf,chunk,encoding,cb)),ret},Writable.prototype.cork=function(){this._writableState.corked++},Writable.prototype.uncork=function(){var state=this._writableState;state.corked&&(state.corked--,state.writing||state.corked||state.finished||state.bufferProcessing||!state.bufferedRequest||clearBuffer(this,state))},Writable.prototype.setDefaultEncoding=function(encoding){if("string"==typeof encoding&&(encoding=encoding.toLowerCase()),!(-1<["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((encoding+"").toLowerCase())))throw new TypeError("Unknown encoding: "+encoding);return this._writableState.defaultEncoding=encoding,this},Object.defineProperty(Writable.prototype,"writableHighWaterMark",{enumerable:!1,get:function(){return this._writableState.highWaterMark}}),Writable.prototype._write=function(chunk,encoding,cb){cb(new Error("_write() is not implemented"))},Writable.prototype._writev=null,Writable.prototype.end=function(chunk,encoding,cb){var state=this._writableState;"function"==typeof chunk?(cb=chunk,encoding=chunk=null):"function"==typeof encoding&&(cb=encoding,encoding=null),null!=chunk&&this.write(chunk,encoding),state.corked&&(state.corked=1,this.uncork()),state.ending||state.finished||function(stream,state,cb){state.ending=!0,finishMaybe(stream,state),cb&&(state.finished?pna.nextTick(cb):stream.once("finish",cb));state.ended=!0,stream.writable=!1}(this,state,cb)},Object.defineProperty(Writable.prototype,"destroyed",{get:function(){return void 0!==this._writableState&&this._writableState.destroyed},set:function(value){this._writableState&&(this._writableState.destroyed=value)}}),Writable.prototype.destroy=destroyImpl.destroy,Writable.prototype._undestroy=destroyImpl.undestroy,Writable.prototype._destroy=function(err,cb){this.end(),cb(err)}}).call(this,require("_process"),"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{},require("timers").setImmediate)},{"./_stream_duplex":28,"./internal/streams/destroy":34,"./internal/streams/stream":35,_process:26,"core-util-is":15,inherits:22,"process-nextick-args":25,"safe-buffer":42,timers:54,"util-deprecate":55}],33:[function(require,module,exports){"use strict";var Buffer=require("safe-buffer").Buffer,util=require("util");function BufferList(){!function(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError("Cannot call a class as a function")}(this,BufferList),this.head=null,this.tail=null,this.length=0}module.exports=(BufferList.prototype.push=function(v){var entry={data:v,next:null};0<this.length?this.tail.next=entry:this.head=entry,this.tail=entry,++this.length},BufferList.prototype.unshift=function(v){var entry={data:v,next:this.head};0===this.length&&(this.tail=entry),this.head=entry,++this.length},BufferList.prototype.shift=function(){if(0!==this.length){var ret=this.head.data;return 1===this.length?this.head=this.tail=null:this.head=this.head.next,--this.length,ret}},BufferList.prototype.clear=function(){this.head=this.tail=null,this.length=0},BufferList.prototype.join=function(s){if(0===this.length)return"";for(var p=this.head,ret=""+p.data;p=p.next;)ret+=s+p.data;return ret},BufferList.prototype.concat=function(n){if(0===this.length)return Buffer.alloc(0);if(1===this.length)return this.head.data;for(var src,target,offset,ret=Buffer.allocUnsafe(n>>>0),p=this.head,i=0;p;)src=p.data,target=ret,offset=i,src.copy(target,offset),i+=p.data.length,p=p.next;return ret},BufferList),util&&util.inspect&&util.inspect.custom&&(module.exports.prototype[util.inspect.custom]=function(){var obj=util.inspect({length:this.length});return this.constructor.name+" "+obj})},{"safe-buffer":42,util:4}],34:[function(require,module,exports){"use strict";var pna=require("process-nextick-args");function emitErrorNT(self,err){self.emit("error",err)}module.exports={destroy:function(err,cb){var _this=this,readableDestroyed=this._readableState&&this._readableState.destroyed,writableDestroyed=this._writableState&&this._writableState.destroyed;return readableDestroyed||writableDestroyed?cb?cb(err):!err||this._writableState&&this._writableState.errorEmitted||pna.nextTick(emitErrorNT,this,err):(this._readableState&&(this._readableState.destroyed=!0),this._writableState&&(this._writableState.destroyed=!0),this._destroy(err||null,function(err){!cb&&err?(pna.nextTick(emitErrorNT,_this,err),_this._writableState&&(_this._writableState.errorEmitted=!0)):cb&&cb(err)})),this},undestroy:function(){this._readableState&&(this._readableState.destroyed=!1,this._readableState.reading=!1,this._readableState.ended=!1,this._readableState.endEmitted=!1),this._writableState&&(this._writableState.destroyed=!1,this._writableState.ended=!1,this._writableState.ending=!1,this._writableState.finished=!1,this._writableState.errorEmitted=!1)}}},{"process-nextick-args":25}],35:[function(require,module,exports){module.exports=require("events").EventEmitter},{events:19}],36:[function(require,module,exports){"use strict";var Buffer=require("safe-buffer").Buffer,isEncoding=Buffer.isEncoding||function(encoding){switch((encoding=""+encoding)&&encoding.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return!0;default:return!1}};function normalizeEncoding(enc){var nenc=function(enc){if(!enc)return"utf8";for(var retried;;)switch(enc){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return enc;default:if(retried)return;enc=(""+enc).toLowerCase(),retried=!0}}(enc);if("string"!=typeof nenc&&(Buffer.isEncoding===isEncoding||!isEncoding(enc)))throw new Error("Unknown encoding: "+enc);return nenc||enc}function StringDecoder(encoding){var nb;switch(this.encoding=normalizeEncoding(encoding),this.encoding){case"utf16le":this.text=utf16Text,this.end=utf16End,nb=4;break;case"utf8":this.fillLast=utf8FillLast,nb=4;break;case"base64":this.text=base64Text,this.end=base64End,nb=3;break;default:return this.write=simpleWrite,void(this.end=simpleEnd)}this.lastNeed=0,this.lastTotal=0,this.lastChar=Buffer.allocUnsafe(nb)}function utf8CheckByte(byte){return byte<=127?0:byte>>5==6?2:byte>>4==14?3:byte>>3==30?4:byte>>6==2?-1:-2}function utf8FillLast(buf){var p=this.lastTotal-this.lastNeed,r=function(self,buf){if(128!=(192&buf[0]))return self.lastNeed=0,"�";if(1<self.lastNeed&&1<buf.length){if(128!=(192&buf[1]))return self.lastNeed=1,"�";if(2<self.lastNeed&&2<buf.length&&128!=(192&buf[2]))return self.lastNeed=2,"�"}}(this,buf);return void 0!==r?r:this.lastNeed<=buf.length?(buf.copy(this.lastChar,p,0,this.lastNeed),this.lastChar.toString(this.encoding,0,this.lastTotal)):(buf.copy(this.lastChar,p,0,buf.length),void(this.lastNeed-=buf.length))}function utf16Text(buf,i){if((buf.length-i)%2!=0)return this.lastNeed=1,this.lastTotal=2,this.lastChar[0]=buf[buf.length-1],buf.toString("utf16le",i,buf.length-1);var r=buf.toString("utf16le",i);if(r){var c=r.charCodeAt(r.length-1);if(55296<=c&&c<=56319)return this.lastNeed=2,this.lastTotal=4,this.lastChar[0]=buf[buf.length-2],this.lastChar[1]=buf[buf.length-1],r.slice(0,-1)}return r}function utf16End(buf){var r=buf&&buf.length?this.write(buf):"";if(this.lastNeed){var end=this.lastTotal-this.lastNeed;return r+this.lastChar.toString("utf16le",0,end)}return r}function base64Text(buf,i){var n=(buf.length-i)%3;return 0==n?buf.toString("base64",i):(this.lastNeed=3-n,this.lastTotal=3,1==n?this.lastChar[0]=buf[buf.length-1]:(this.lastChar[0]=buf[buf.length-2],this.lastChar[1]=buf[buf.length-1]),buf.toString("base64",i,buf.length-n))}function base64End(buf){var r=buf&&buf.length?this.write(buf):"";return this.lastNeed?r+this.lastChar.toString("base64",0,3-this.lastNeed):r}function simpleWrite(buf){return buf.toString(this.encoding)}function simpleEnd(buf){return buf&&buf.length?this.write(buf):""}(exports.StringDecoder=StringDecoder).prototype.write=function(buf){if(0===buf.length)return"";var r,i;if(this.lastNeed){if(void 0===(r=this.fillLast(buf)))return"";i=this.lastNeed,this.lastNeed=0}else i=0;return i<buf.length?r?r+this.text(buf,i):this.text(buf,i):r||""},StringDecoder.prototype.end=function(buf){var r=buf&&buf.length?this.write(buf):"";return this.lastNeed?r+"�":r},StringDecoder.prototype.text=function(buf,i){var total=function(self,buf,i){var j=buf.length-1;if(j<i)return 0;var nb=utf8CheckByte(buf[j]);if(0<=nb)return 0<nb&&(self.lastNeed=nb-1),nb;if(--j<i||-2===nb)return 0;if(0<=(nb=utf8CheckByte(buf[j])))return 0<nb&&(self.lastNeed=nb-2),nb;if(--j<i||-2===nb)return 0;if(0<=(nb=utf8CheckByte(buf[j])))return 0<nb&&(2===nb?nb=0:self.lastNeed=nb-3),nb;return 0}(this,buf,i);if(!this.lastNeed)return buf.toString("utf8",i);this.lastTotal=total;var end=buf.length-(total-this.lastNeed);return buf.copy(this.lastChar,0,end),buf.toString("utf8",i,end)},StringDecoder.prototype.fillLast=function(buf){if(this.lastNeed<=buf.length)return buf.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed),this.lastChar.toString(this.encoding,0,this.lastTotal);buf.copy(this.lastChar,this.lastTotal-this.lastNeed,0,buf.length),this.lastNeed-=buf.length}},{"safe-buffer":42}],37:[function(require,module,exports){module.exports=require("./readable").PassThrough},{"./readable":38}],38:[function(require,module,exports){(((exports=module.exports=require("./lib/_stream_readable.js")).Stream=exports).Readable=exports).Writable=require("./lib/_stream_writable.js"),exports.Duplex=require("./lib/_stream_duplex.js"),exports.Transform=require("./lib/_stream_transform.js"),exports.PassThrough=require("./lib/_stream_passthrough.js")},{"./lib/_stream_duplex.js":28,"./lib/_stream_passthrough.js":29,"./lib/_stream_readable.js":30,"./lib/_stream_transform.js":31,"./lib/_stream_writable.js":32}],39:[function(require,module,exports){module.exports=require("./readable").Transform},{"./readable":38}],40:[function(require,module,exports){module.exports=require("./lib/_stream_writable.js")},{"./lib/_stream_writable.js":32}],41:[function(require,module,exports){(function(Buffer){"use strict";var inherits=require("inherits"),HashBase=require("hash-base");function RIPEMD160(){HashBase.call(this,64),this._a=1732584193,this._b=4023233417,this._c=2562383102,this._d=271733878,this._e=3285377520}function rotl(x,n){return x<<n|x>>>32-n}function fn1(a,b,c,d,e,m,k,s){return rotl(a+(b^c^d)+m+k|0,s)+e|0}function fn2(a,b,c,d,e,m,k,s){return rotl(a+(b&c|~b&d)+m+k|0,s)+e|0}function fn3(a,b,c,d,e,m,k,s){return rotl(a+((b|~c)^d)+m+k|0,s)+e|0}function fn4(a,b,c,d,e,m,k,s){return rotl(a+(b&d|c&~d)+m+k|0,s)+e|0}function fn5(a,b,c,d,e,m,k,s){return rotl(a+(b^(c|~d))+m+k|0,s)+e|0}inherits(RIPEMD160,HashBase),RIPEMD160.prototype._update=function(){for(var m=new Array(16),i=0;i<16;++i)m[i]=this._block.readInt32LE(4*i);var al=this._a,bl=this._b,cl=this._c,dl=this._d,el=this._e;al=fn1(al,bl,cl,dl,el,m[0],0,11),el=fn1(el,al,bl,cl=rotl(cl,10),dl,m[1],0,14),dl=fn1(dl,el,al,bl=rotl(bl,10),cl,m[2],0,15),cl=fn1(cl,dl,el,al=rotl(al,10),bl,m[3],0,12),bl=fn1(bl,cl,dl,el=rotl(el,10),al,m[4],0,5),al=fn1(al,bl,cl,dl=rotl(dl,10),el,m[5],0,8),el=fn1(el,al,bl,cl=rotl(cl,10),dl,m[6],0,7),dl=fn1(dl,el,al,bl=rotl(bl,10),cl,m[7],0,9),cl=fn1(cl,dl,el,al=rotl(al,10),bl,m[8],0,11),bl=fn1(bl,cl,dl,el=rotl(el,10),al,m[9],0,13),al=fn1(al,bl,cl,dl=rotl(dl,10),el,m[10],0,14),el=fn1(el,al,bl,cl=rotl(cl,10),dl,m[11],0,15),dl=fn1(dl,el,al,bl=rotl(bl,10),cl,m[12],0,6),cl=fn1(cl,dl,el,al=rotl(al,10),bl,m[13],0,7),bl=fn1(bl,cl,dl,el=rotl(el,10),al,m[14],0,9),el=fn2(el,al=fn1(al,bl,cl,dl=rotl(dl,10),el,m[15],0,8),bl,cl=rotl(cl,10),dl,m[7],1518500249,7),dl=fn2(dl,el,al,bl=rotl(bl,10),cl,m[4],1518500249,6),cl=fn2(cl,dl,el,al=rotl(al,10),bl,m[13],1518500249,8),bl=fn2(bl,cl,dl,el=rotl(el,10),al,m[1],1518500249,13),al=fn2(al,bl,cl,dl=rotl(dl,10),el,m[10],1518500249,11),el=fn2(el,al,bl,cl=rotl(cl,10),dl,m[6],1518500249,9),dl=fn2(dl,el,al,bl=rotl(bl,10),cl,m[15],1518500249,7),cl=fn2(cl,dl,el,al=rotl(al,10),bl,m[3],1518500249,15),bl=fn2(bl,cl,dl,el=rotl(el,10),al,m[12],1518500249,7),al=fn2(al,bl,cl,dl=rotl(dl,10),el,m[0],1518500249,12),el=fn2(el,al,bl,cl=rotl(cl,10),dl,m[9],1518500249,15),dl=fn2(dl,el,al,bl=rotl(bl,10),cl,m[5],1518500249,9),cl=fn2(cl,dl,el,al=rotl(al,10),bl,m[2],1518500249,11),bl=fn2(bl,cl,dl,el=rotl(el,10),al,m[14],1518500249,7),al=fn2(al,bl,cl,dl=rotl(dl,10),el,m[11],1518500249,13),dl=fn3(dl,el=fn2(el,al,bl,cl=rotl(cl,10),dl,m[8],1518500249,12),al,bl=rotl(bl,10),cl,m[3],1859775393,11),cl=fn3(cl,dl,el,al=rotl(al,10),bl,m[10],1859775393,13),bl=fn3(bl,cl,dl,el=rotl(el,10),al,m[14],1859775393,6),al=fn3(al,bl,cl,dl=rotl(dl,10),el,m[4],1859775393,7),el=fn3(el,al,bl,cl=rotl(cl,10),dl,m[9],1859775393,14),dl=fn3(dl,el,al,bl=rotl(bl,10),cl,m[15],1859775393,9),cl=fn3(cl,dl,el,al=rotl(al,10),bl,m[8],1859775393,13),bl=fn3(bl,cl,dl,el=rotl(el,10),al,m[1],1859775393,15),al=fn3(al,bl,cl,dl=rotl(dl,10),el,m[2],1859775393,14),el=fn3(el,al,bl,cl=rotl(cl,10),dl,m[7],1859775393,8),dl=fn3(dl,el,al,bl=rotl(bl,10),cl,m[0],1859775393,13),cl=fn3(cl,dl,el,al=rotl(al,10),bl,m[6],1859775393,6),bl=fn3(bl,cl,dl,el=rotl(el,10),al,m[13],1859775393,5),al=fn3(al,bl,cl,dl=rotl(dl,10),el,m[11],1859775393,12),el=fn3(el,al,bl,cl=rotl(cl,10),dl,m[5],1859775393,7),cl=fn4(cl,dl=fn3(dl,el,al,bl=rotl(bl,10),cl,m[12],1859775393,5),el,al=rotl(al,10),bl,m[1],2400959708,11),bl=fn4(bl,cl,dl,el=rotl(el,10),al,m[9],2400959708,12),al=fn4(al,bl,cl,dl=rotl(dl,10),el,m[11],2400959708,14),el=fn4(el,al,bl,cl=rotl(cl,10),dl,m[10],2400959708,15),dl=fn4(dl,el,al,bl=rotl(bl,10),cl,m[0],2400959708,14),cl=fn4(cl,dl,el,al=rotl(al,10),bl,m[8],2400959708,15),bl=fn4(bl,cl,dl,el=rotl(el,10),al,m[12],2400959708,9),al=fn4(al,bl,cl,dl=rotl(dl,10),el,m[4],2400959708,8),el=fn4(el,al,bl,cl=rotl(cl,10),dl,m[13],2400959708,9),dl=fn4(dl,el,al,bl=rotl(bl,10),cl,m[3],2400959708,14),cl=fn4(cl,dl,el,al=rotl(al,10),bl,m[7],2400959708,5),bl=fn4(bl,cl,dl,el=rotl(el,10),al,m[15],2400959708,6),al=fn4(al,bl,cl,dl=rotl(dl,10),el,m[14],2400959708,8),el=fn4(el,al,bl,cl=rotl(cl,10),dl,m[5],2400959708,6),dl=fn4(dl,el,al,bl=rotl(bl,10),cl,m[6],2400959708,5),bl=fn5(bl,cl=fn4(cl,dl,el,al=rotl(al,10),bl,m[2],2400959708,12),dl,el=rotl(el,10),al,m[4],2840853838,9),al=fn5(al,bl,cl,dl=rotl(dl,10),el,m[0],2840853838,15),el=fn5(el,al,bl,cl=rotl(cl,10),dl,m[5],2840853838,5),dl=fn5(dl,el,al,bl=rotl(bl,10),cl,m[9],2840853838,11),cl=fn5(cl,dl,el,al=rotl(al,10),bl,m[7],2840853838,6),bl=fn5(bl,cl,dl,el=rotl(el,10),al,m[12],2840853838,8),al=fn5(al,bl,cl,dl=rotl(dl,10),el,m[2],2840853838,13),el=fn5(el,al,bl,cl=rotl(cl,10),dl,m[10],2840853838,12),dl=fn5(dl,el,al,bl=rotl(bl,10),cl,m[14],2840853838,5),cl=fn5(cl,dl,el,al=rotl(al,10),bl,m[1],2840853838,12),bl=fn5(bl,cl,dl,el=rotl(el,10),al,m[3],2840853838,13),al=fn5(al,bl,cl,dl=rotl(dl,10),el,m[8],2840853838,14),el=fn5(el,al,bl,cl=rotl(cl,10),dl,m[11],2840853838,11),dl=fn5(dl,el,al,bl=rotl(bl,10),cl,m[6],2840853838,8),cl=fn5(cl,dl,el,al=rotl(al,10),bl,m[15],2840853838,5),bl=fn5(bl,cl,dl,el=rotl(el,10),al,m[13],2840853838,6),dl=rotl(dl,10);var ar=this._a,br=this._b,cr=this._c,dr=this._d,er=this._e;ar=fn5(ar,br,cr,dr,er,m[5],1352829926,8),er=fn5(er,ar,br,cr=rotl(cr,10),dr,m[14],1352829926,9),dr=fn5(dr,er,ar,br=rotl(br,10),cr,m[7],1352829926,9),cr=fn5(cr,dr,er,ar=rotl(ar,10),br,m[0],1352829926,11),br=fn5(br,cr,dr,er=rotl(er,10),ar,m[9],1352829926,13),ar=fn5(ar,br,cr,dr=rotl(dr,10),er,m[2],1352829926,15),er=fn5(er,ar,br,cr=rotl(cr,10),dr,m[11],1352829926,15),dr=fn5(dr,er,ar,br=rotl(br,10),cr,m[4],1352829926,5),cr=fn5(cr,dr,er,ar=rotl(ar,10),br,m[13],1352829926,7),br=fn5(br,cr,dr,er=rotl(er,10),ar,m[6],1352829926,7),ar=fn5(ar,br,cr,dr=rotl(dr,10),er,m[15],1352829926,8),er=fn5(er,ar,br,cr=rotl(cr,10),dr,m[8],1352829926,11),dr=fn5(dr,er,ar,br=rotl(br,10),cr,m[1],1352829926,14),cr=fn5(cr,dr,er,ar=rotl(ar,10),br,m[10],1352829926,14),br=fn5(br,cr,dr,er=rotl(er,10),ar,m[3],1352829926,12),er=fn4(er,ar=fn5(ar,br,cr,dr=rotl(dr,10),er,m[12],1352829926,6),br,cr=rotl(cr,10),dr,m[6],1548603684,9),dr=fn4(dr,er,ar,br=rotl(br,10),cr,m[11],1548603684,13),cr=fn4(cr,dr,er,ar=rotl(ar,10),br,m[3],1548603684,15),br=fn4(br,cr,dr,er=rotl(er,10),ar,m[7],1548603684,7),ar=fn4(ar,br,cr,dr=rotl(dr,10),er,m[0],1548603684,12),er=fn4(er,ar,br,cr=rotl(cr,10),dr,m[13],1548603684,8),dr=fn4(dr,er,ar,br=rotl(br,10),cr,m[5],1548603684,9),cr=fn4(cr,dr,er,ar=rotl(ar,10),br,m[10],1548603684,11),br=fn4(br,cr,dr,er=rotl(er,10),ar,m[14],1548603684,7),ar=fn4(ar,br,cr,dr=rotl(dr,10),er,m[15],1548603684,7),er=fn4(er,ar,br,cr=rotl(cr,10),dr,m[8],1548603684,12),dr=fn4(dr,er,ar,br=rotl(br,10),cr,m[12],1548603684,7),cr=fn4(cr,dr,er,ar=rotl(ar,10),br,m[4],1548603684,6),br=fn4(br,cr,dr,er=rotl(er,10),ar,m[9],1548603684,15),ar=fn4(ar,br,cr,dr=rotl(dr,10),er,m[1],1548603684,13),dr=fn3(dr,er=fn4(er,ar,br,cr=rotl(cr,10),dr,m[2],1548603684,11),ar,br=rotl(br,10),cr,m[15],1836072691,9),cr=fn3(cr,dr,er,ar=rotl(ar,10),br,m[5],1836072691,7),br=fn3(br,cr,dr,er=rotl(er,10),ar,m[1],1836072691,15),ar=fn3(ar,br,cr,dr=rotl(dr,10),er,m[3],1836072691,11),er=fn3(er,ar,br,cr=rotl(cr,10),dr,m[7],1836072691,8),dr=fn3(dr,er,ar,br=rotl(br,10),cr,m[14],1836072691,6),cr=fn3(cr,dr,er,ar=rotl(ar,10),br,m[6],1836072691,6),br=fn3(br,cr,dr,er=rotl(er,10),ar,m[9],1836072691,14),ar=fn3(ar,br,cr,dr=rotl(dr,10),er,m[11],1836072691,12),er=fn3(er,ar,br,cr=rotl(cr,10),dr,m[8],1836072691,13),dr=fn3(dr,er,ar,br=rotl(br,10),cr,m[12],1836072691,5),cr=fn3(cr,dr,er,ar=rotl(ar,10),br,m[2],1836072691,14),br=fn3(br,cr,dr,er=rotl(er,10),ar,m[10],1836072691,13),ar=fn3(ar,br,cr,dr=rotl(dr,10),er,m[0],1836072691,13),er=fn3(er,ar,br,cr=rotl(cr,10),dr,m[4],1836072691,7),cr=fn2(cr,dr=fn3(dr,er,ar,br=rotl(br,10),cr,m[13],1836072691,5),er,ar=rotl(ar,10),br,m[8],2053994217,15),br=fn2(br,cr,dr,er=rotl(er,10),ar,m[6],2053994217,5),ar=fn2(ar,br,cr,dr=rotl(dr,10),er,m[4],2053994217,8),er=fn2(er,ar,br,cr=rotl(cr,10),dr,m[1],2053994217,11),dr=fn2(dr,er,ar,br=rotl(br,10),cr,m[3],2053994217,14),cr=fn2(cr,dr,er,ar=rotl(ar,10),br,m[11],2053994217,14),br=fn2(br,cr,dr,er=rotl(er,10),ar,m[15],2053994217,6),ar=fn2(ar,br,cr,dr=rotl(dr,10),er,m[0],2053994217,14),er=fn2(er,ar,br,cr=rotl(cr,10),dr,m[5],2053994217,6),dr=fn2(dr,er,ar,br=rotl(br,10),cr,m[12],2053994217,9),cr=fn2(cr,dr,er,ar=rotl(ar,10),br,m[2],2053994217,12),br=fn2(br,cr,dr,er=rotl(er,10),ar,m[13],2053994217,9),ar=fn2(ar,br,cr,dr=rotl(dr,10),er,m[9],2053994217,12),er=fn2(er,ar,br,cr=rotl(cr,10),dr,m[7],2053994217,5),dr=fn2(dr,er,ar,br=rotl(br,10),cr,m[10],2053994217,15),br=fn1(br,cr=fn2(cr,dr,er,ar=rotl(ar,10),br,m[14],2053994217,8),dr,er=rotl(er,10),ar,m[12],0,8),ar=fn1(ar,br,cr,dr=rotl(dr,10),er,m[15],0,5),er=fn1(er,ar,br,cr=rotl(cr,10),dr,m[10],0,12),dr=fn1(dr,er,ar,br=rotl(br,10),cr,m[4],0,9),cr=fn1(cr,dr,er,ar=rotl(ar,10),br,m[1],0,12),br=fn1(br,cr,dr,er=rotl(er,10),ar,m[5],0,5),ar=fn1(ar,br,cr,dr=rotl(dr,10),er,m[8],0,14),er=fn1(er,ar,br,cr=rotl(cr,10),dr,m[7],0,6),dr=fn1(dr,er,ar,br=rotl(br,10),cr,m[6],0,8),cr=fn1(cr,dr,er,ar=rotl(ar,10),br,m[2],0,13),br=fn1(br,cr,dr,er=rotl(er,10),ar,m[13],0,6),ar=fn1(ar,br,cr,dr=rotl(dr,10),er,m[14],0,5),er=fn1(er,ar,br,cr=rotl(cr,10),dr,m[0],0,15),dr=fn1(dr,er,ar,br=rotl(br,10),cr,m[3],0,13),cr=fn1(cr,dr,er,ar=rotl(ar,10),br,m[9],0,11),br=fn1(br,cr,dr,er=rotl(er,10),ar,m[11],0,11),dr=rotl(dr,10);var t=this._b+cl+dr|0;this._b=this._c+dl+er|0,this._c=this._d+el+ar|0,this._d=this._e+al+br|0,this._e=this._a+bl+cr|0,this._a=t},RIPEMD160.prototype._digest=function(){this._block[this._blockOffset++]=128,56<this._blockOffset&&(this._block.fill(0,this._blockOffset,64),this._update(),this._blockOffset=0),this._block.fill(0,this._blockOffset,56),this._block.writeUInt32LE(this._length[0],56),this._block.writeUInt32LE(this._length[1],60),this._update();var buffer=new Buffer(20);return buffer.writeInt32LE(this._a,0),buffer.writeInt32LE(this._b,4),buffer.writeInt32LE(this._c,8),buffer.writeInt32LE(this._d,12),buffer.writeInt32LE(this._e,16),buffer},module.exports=RIPEMD160}).call(this,require("buffer").Buffer)},{buffer:9,"hash-base":20,inherits:22}],42:[function(require,module,exports){arguments[4][8][0].apply(exports,arguments)},{buffer:9,dup:8}],43:[function(require,module,exports){var Buffer=require("safe-buffer").Buffer;function Hash(blockSize,finalSize){this._block=Buffer.alloc(blockSize),this._finalSize=finalSize,this._blockSize=blockSize,this._len=0}Hash.prototype.update=function(data,enc){"string"==typeof data&&(enc=enc||"utf8",data=Buffer.from(data,enc));for(var block=this._block,blockSize=this._blockSize,length=data.length,accum=this._len,offset=0;offset<length;){for(var assigned=accum%blockSize,remainder=Math.min(length-offset,blockSize-assigned),i=0;i<remainder;i++)block[assigned+i]=data[offset+i];offset+=remainder,(accum+=remainder)%blockSize==0&&this._update(block)}return this._len+=length,this},Hash.prototype.digest=function(enc){var rem=this._len%this._blockSize;this._block[rem]=128,this._block.fill(0,1+rem),rem>=this._finalSize&&(this._update(this._block),this._block.fill(0));var bits=8*this._len;if(bits<=4294967295)this._block.writeUInt32BE(bits,this._blockSize-4);else{var lowBits=4294967295&bits,highBits=(bits-lowBits)/4294967296;this._block.writeUInt32BE(highBits,this._blockSize-8),this._block.writeUInt32BE(lowBits,this._blockSize-4)}this._update(this._block);var hash=this._hash();return enc?hash.toString(enc):hash},Hash.prototype._update=function(){throw new Error("_update must be implemented by subclass")},module.exports=Hash},{"safe-buffer":42}],44:[function(require,module,exports){(exports=module.exports=function(algorithm){algorithm=algorithm.toLowerCase();var Algorithm=exports[algorithm];if(!Algorithm)throw new Error(algorithm+" is not supported (we accept pull requests)");return new Algorithm}).sha=require("./sha"),exports.sha1=require("./sha1"),exports.sha224=require("./sha224"),exports.sha256=require("./sha256"),exports.sha384=require("./sha384"),exports.sha512=require("./sha512")},{"./sha":45,"./sha1":46,"./sha224":47,"./sha256":48,"./sha384":49,"./sha512":50}],45:[function(require,module,exports){var inherits=require("inherits"),Hash=require("./hash"),Buffer=require("safe-buffer").Buffer,K=[1518500249,1859775393,-1894007588,-899497514],W=new Array(80);function Sha(){this.init(),this._w=W,Hash.call(this,64,56)}function rotl30(num){return num<<30|num>>>2}function ft(s,b,c,d){return 0===s?b&c|~b&d:2===s?b&c|b&d|c&d:b^c^d}inherits(Sha,Hash),Sha.prototype.init=function(){return this._a=1732584193,this._b=4023233417,this._c=2562383102,this._d=271733878,this._e=3285377520,this},Sha.prototype._update=function(M){for(var num,W=this._w,a=0|this._a,b=0|this._b,c=0|this._c,d=0|this._d,e=0|this._e,i=0;i<16;++i)W[i]=M.readInt32BE(4*i);for(;i<80;++i)W[i]=W[i-3]^W[i-8]^W[i-14]^W[i-16];for(var j=0;j<80;++j){var s=~~(j/20),t=0|((num=a)<<5|num>>>27)+ft(s,b,c,d)+e+W[j]+K[s];e=d,d=c,c=rotl30(b),b=a,a=t}this._a=a+this._a|0,this._b=b+this._b|0,this._c=c+this._c|0,this._d=d+this._d|0,this._e=e+this._e|0},Sha.prototype._hash=function(){var H=Buffer.allocUnsafe(20);return H.writeInt32BE(0|this._a,0),H.writeInt32BE(0|this._b,4),H.writeInt32BE(0|this._c,8),H.writeInt32BE(0|this._d,12),H.writeInt32BE(0|this._e,16),H},module.exports=Sha},{"./hash":43,inherits:22,"safe-buffer":42}],46:[function(require,module,exports){var inherits=require("inherits"),Hash=require("./hash"),Buffer=require("safe-buffer").Buffer,K=[1518500249,1859775393,-1894007588,-899497514],W=new Array(80);function Sha1(){this.init(),this._w=W,Hash.call(this,64,56)}function rotl5(num){return num<<5|num>>>27}function rotl30(num){return num<<30|num>>>2}function ft(s,b,c,d){return 0===s?b&c|~b&d:2===s?b&c|b&d|c&d:b^c^d}inherits(Sha1,Hash),Sha1.prototype.init=function(){return this._a=1732584193,this._b=4023233417,this._c=2562383102,this._d=271733878,this._e=3285377520,this},Sha1.prototype._update=function(M){for(var num,W=this._w,a=0|this._a,b=0|this._b,c=0|this._c,d=0|this._d,e=0|this._e,i=0;i<16;++i)W[i]=M.readInt32BE(4*i);for(;i<80;++i)W[i]=(num=W[i-3]^W[i-8]^W[i-14]^W[i-16])<<1|num>>>31;for(var j=0;j<80;++j){var s=~~(j/20),t=rotl5(a)+ft(s,b,c,d)+e+W[j]+K[s]|0;e=d,d=c,c=rotl30(b),b=a,a=t}this._a=a+this._a|0,this._b=b+this._b|0,this._c=c+this._c|0,this._d=d+this._d|0,this._e=e+this._e|0},Sha1.prototype._hash=function(){var H=Buffer.allocUnsafe(20);return H.writeInt32BE(0|this._a,0),H.writeInt32BE(0|this._b,4),H.writeInt32BE(0|this._c,8),H.writeInt32BE(0|this._d,12),H.writeInt32BE(0|this._e,16),H},module.exports=Sha1},{"./hash":43,inherits:22,"safe-buffer":42}],47:[function(require,module,exports){var inherits=require("inherits"),Sha256=require("./sha256"),Hash=require("./hash"),Buffer=require("safe-buffer").Buffer,W=new Array(64);function Sha224(){this.init(),this._w=W,Hash.call(this,64,56)}inherits(Sha224,Sha256),Sha224.prototype.init=function(){return this._a=3238371032,this._b=914150663,this._c=812702999,this._d=4144912697,this._e=4290775857,this._f=1750603025,this._g=1694076839,this._h=3204075428,this},Sha224.prototype._hash=function(){var H=Buffer.allocUnsafe(28);return H.writeInt32BE(this._a,0),H.writeInt32BE(this._b,4),H.writeInt32BE(this._c,8),H.writeInt32BE(this._d,12),H.writeInt32BE(this._e,16),H.writeInt32BE(this._f,20),H.writeInt32BE(this._g,24),H},module.exports=Sha224},{"./hash":43,"./sha256":48,inherits:22,"safe-buffer":42}],48:[function(require,module,exports){var inherits=require("inherits"),Hash=require("./hash"),Buffer=require("safe-buffer").Buffer,K=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298],W=new Array(64);function Sha256(){this.init(),this._w=W,Hash.call(this,64,56)}function ch(x,y,z){return z^x&(y^z)}function maj(x,y,z){return x&y|z&(x|y)}function sigma0(x){return(x>>>2|x<<30)^(x>>>13|x<<19)^(x>>>22|x<<10)}function sigma1(x){return(x>>>6|x<<26)^(x>>>11|x<<21)^(x>>>25|x<<7)}function gamma0(x){return(x>>>7|x<<25)^(x>>>18|x<<14)^x>>>3}inherits(Sha256,Hash),Sha256.prototype.init=function(){return this._a=1779033703,this._b=3144134277,this._c=1013904242,this._d=2773480762,this._e=1359893119,this._f=2600822924,this._g=528734635,this._h=1541459225,this},Sha256.prototype._update=function(M){for(var x,W=this._w,a=0|this._a,b=0|this._b,c=0|this._c,d=0|this._d,e=0|this._e,f=0|this._f,g=0|this._g,h=0|this._h,i=0;i<16;++i)W[i]=M.readInt32BE(4*i);for(;i<64;++i)W[i]=0|(((x=W[i-2])>>>17|x<<15)^(x>>>19|x<<13)^x>>>10)+W[i-7]+gamma0(W[i-15])+W[i-16];for(var j=0;j<64;++j){var T1=h+sigma1(e)+ch(e,f,g)+K[j]+W[j]|0,T2=sigma0(a)+maj(a,b,c)|0;h=g,g=f,f=e,e=d+T1|0,d=c,c=b,b=a,a=T1+T2|0}this._a=a+this._a|0,this._b=b+this._b|0,this._c=c+this._c|0,this._d=d+this._d|0,this._e=e+this._e|0,this._f=f+this._f|0,this._g=g+this._g|0,this._h=h+this._h|0},Sha256.prototype._hash=function(){var H=Buffer.allocUnsafe(32);return H.writeInt32BE(this._a,0),H.writeInt32BE(this._b,4),H.writeInt32BE(this._c,8),H.writeInt32BE(this._d,12),H.writeInt32BE(this._e,16),H.writeInt32BE(this._f,20),H.writeInt32BE(this._g,24),H.writeInt32BE(this._h,28),H},module.exports=Sha256},{"./hash":43,inherits:22,"safe-buffer":42}],49:[function(require,module,exports){var inherits=require("inherits"),SHA512=require("./sha512"),Hash=require("./hash"),Buffer=require("safe-buffer").Buffer,W=new Array(160);function Sha384(){this.init(),this._w=W,Hash.call(this,128,112)}inherits(Sha384,SHA512),Sha384.prototype.init=function(){return this._ah=3418070365,this._bh=1654270250,this._ch=2438529370,this._dh=355462360,this._eh=1731405415,this._fh=2394180231,this._gh=3675008525,this._hh=1203062813,this._al=3238371032,this._bl=914150663,this._cl=812702999,this._dl=4144912697,this._el=4290775857,this._fl=1750603025,this._gl=1694076839,this._hl=3204075428,this},Sha384.prototype._hash=function(){var H=Buffer.allocUnsafe(48);function writeInt64BE(h,l,offset){H.writeInt32BE(h,offset),H.writeInt32BE(l,offset+4)}return writeInt64BE(this._ah,this._al,0),writeInt64BE(this._bh,this._bl,8),writeInt64BE(this._ch,this._cl,16),writeInt64BE(this._dh,this._dl,24),writeInt64BE(this._eh,this._el,32),writeInt64BE(this._fh,this._fl,40),H},module.exports=Sha384},{"./hash":43,"./sha512":50,inherits:22,"safe-buffer":42}],50:[function(require,module,exports){var inherits=require("inherits"),Hash=require("./hash"),Buffer=require("safe-buffer").Buffer,K=[1116352408,3609767458,1899447441,602891725,3049323471,3964484399,3921009573,2173295548,961987163,4081628472,1508970993,3053834265,2453635748,2937671579,2870763221,3664609560,3624381080,2734883394,310598401,1164996542,607225278,1323610764,1426881987,3590304994,1925078388,4068182383,2162078206,991336113,2614888103,633803317,3248222580,3479774868,3835390401,2666613458,4022224774,944711139,264347078,2341262773,604807628,2007800933,770255983,1495990901,1249150122,1856431235,1555081692,3175218132,1996064986,2198950837,2554220882,3999719339,2821834349,766784016,2952996808,2566594879,3210313671,3203337956,3336571891,1034457026,3584528711,2466948901,113926993,3758326383,338241895,168717936,666307205,1188179964,773529912,1546045734,1294757372,1522805485,1396182291,2643833823,1695183700,2343527390,1986661051,1014477480,2177026350,1206759142,2456956037,344077627,2730485921,1290863460,2820302411,3158454273,3259730800,3505952657,3345764771,106217008,3516065817,3606008344,3600352804,1432725776,4094571909,1467031594,275423344,851169720,430227734,3100823752,506948616,1363258195,659060556,3750685593,883997877,3785050280,958139571,3318307427,1322822218,3812723403,1537002063,2003034995,1747873779,3602036899,1955562222,1575990012,2024104815,1125592928,2227730452,2716904306,2361852424,442776044,2428436474,593698344,2756734187,3733110249,3204031479,2999351573,3329325298,3815920427,3391569614,3928383900,3515267271,566280711,3940187606,3454069534,4118630271,4000239992,116418474,1914138554,174292421,2731055270,289380356,3203993006,460393269,320620315,685471733,587496836,852142971,1086792851,1017036298,365543100,1126000580,2618297676,1288033470,3409855158,1501505948,4234509866,1607167915,987167468,1816402316,1246189591],W=new Array(160);function Sha512(){this.init(),this._w=W,Hash.call(this,128,112)}function Ch(x,y,z){return z^x&(y^z)}function maj(x,y,z){return x&y|z&(x|y)}function sigma0(x,xl){return(x>>>28|xl<<4)^(xl>>>2|x<<30)^(xl>>>7|x<<25)}function sigma1(x,xl){return(x>>>14|xl<<18)^(x>>>18|xl<<14)^(xl>>>9|x<<23)}function Gamma0(x,xl){return(x>>>1|xl<<31)^(x>>>8|xl<<24)^x>>>7}function Gamma0l(x,xl){return(x>>>1|xl<<31)^(x>>>8|xl<<24)^(x>>>7|xl<<25)}function Gamma1(x,xl){return(x>>>19|xl<<13)^(xl>>>29|x<<3)^x>>>6}function Gamma1l(x,xl){return(x>>>19|xl<<13)^(xl>>>29|x<<3)^(x>>>6|xl<<26)}function getCarry(a,b){return a>>>0<b>>>0?1:0}inherits(Sha512,Hash),Sha512.prototype.init=function(){return this._ah=1779033703,this._bh=3144134277,this._ch=1013904242,this._dh=2773480762,this._eh=1359893119,this._fh=2600822924,this._gh=528734635,this._hh=1541459225,this._al=4089235720,this._bl=2227873595,this._cl=4271175723,this._dl=1595750129,this._el=2917565137,this._fl=725511199,this._gl=4215389547,this._hl=327033209,this},Sha512.prototype._update=function(M){for(var W=this._w,ah=0|this._ah,bh=0|this._bh,ch=0|this._ch,dh=0|this._dh,eh=0|this._eh,fh=0|this._fh,gh=0|this._gh,hh=0|this._hh,al=0|this._al,bl=0|this._bl,cl=0|this._cl,dl=0|this._dl,el=0|this._el,fl=0|this._fl,gl=0|this._gl,hl=0|this._hl,i=0;i<32;i+=2)W[i]=M.readInt32BE(4*i),W[i+1]=M.readInt32BE(4*i+4);for(;i<160;i+=2){var xh=W[i-30],xl=W[i-30+1],gamma0=Gamma0(xh,xl),gamma0l=Gamma0l(xl,xh),gamma1=Gamma1(xh=W[i-4],xl=W[i-4+1]),gamma1l=Gamma1l(xl,xh),Wi7h=W[i-14],Wi7l=W[i-14+1],Wi16h=W[i-32],Wi16l=W[i-32+1],Wil=gamma0l+Wi7l|0,Wih=gamma0+Wi7h+getCarry(Wil,gamma0l)|0;Wih=(Wih=Wih+gamma1+getCarry(Wil=Wil+gamma1l|0,gamma1l)|0)+Wi16h+getCarry(Wil=Wil+Wi16l|0,Wi16l)|0,W[i]=Wih,W[i+1]=Wil}for(var j=0;j<160;j+=2){Wih=W[j],Wil=W[j+1];var majh=maj(ah,bh,ch),majl=maj(al,bl,cl),sigma0h=sigma0(ah,al),sigma0l=sigma0(al,ah),sigma1h=sigma1(eh,el),sigma1l=sigma1(el,eh),Kil=K[j+1],chh=Ch(eh,fh,gh),chl=Ch(el,fl,gl),t1l=hl+sigma1l|0,t1h=hh+sigma1h+getCarry(t1l,hl)|0;t1h=(t1h=(t1h=t1h+chh+getCarry(t1l=t1l+chl|0,chl)|0)+K[j]+getCarry(t1l=t1l+Kil|0,Kil)|0)+Wih+getCarry(t1l=t1l+Wil|0,Wil)|0;var t2l=sigma0l+majl|0,t2h=sigma0h+majh+getCarry(t2l,sigma0l)|0;hh=gh,hl=gl,gh=fh,gl=fl,fh=eh,fl=el,eh=dh+t1h+getCarry(el=dl+t1l|0,dl)|0,dh=ch,dl=cl,ch=bh,cl=bl,bh=ah,bl=al,ah=t1h+t2h+getCarry(al=t1l+t2l|0,t1l)|0}this._al=this._al+al|0,this._bl=this._bl+bl|0,this._cl=this._cl+cl|0,this._dl=this._dl+dl|0,this._el=this._el+el|0,this._fl=this._fl+fl|0,this._gl=this._gl+gl|0,this._hl=this._hl+hl|0,this._ah=this._ah+ah+getCarry(this._al,al)|0,this._bh=this._bh+bh+getCarry(this._bl,bl)|0,this._ch=this._ch+ch+getCarry(this._cl,cl)|0,this._dh=this._dh+dh+getCarry(this._dl,dl)|0,this._eh=this._eh+eh+getCarry(this._el,el)|0,this._fh=this._fh+fh+getCarry(this._fl,fl)|0,this._gh=this._gh+gh+getCarry(this._gl,gl)|0,this._hh=this._hh+hh+getCarry(this._hl,hl)|0},Sha512.prototype._hash=function(){var H=Buffer.allocUnsafe(64);function writeInt64BE(h,l,offset){H.writeInt32BE(h,offset),H.writeInt32BE(l,offset+4)}return writeInt64BE(this._ah,this._al,0),writeInt64BE(this._bh,this._bl,8),writeInt64BE(this._ch,this._cl,16),writeInt64BE(this._dh,this._dl,24),writeInt64BE(this._eh,this._el,32),writeInt64BE(this._fh,this._fl,40),writeInt64BE(this._gh,this._gl,48),writeInt64BE(this._hh,this._hl,56),H},module.exports=Sha512},{"./hash":43,inherits:22,"safe-buffer":42}],51:[function(require,module,exports){module.exports=Stream;var EE=require("events").EventEmitter;function Stream(){EE.call(this)}require("inherits")(Stream,EE),Stream.Readable=require("readable-stream/readable.js"),Stream.Writable=require("readable-stream/writable.js"),Stream.Duplex=require("readable-stream/duplex.js"),Stream.Transform=require("readable-stream/transform.js"),Stream.PassThrough=require("readable-stream/passthrough.js"),(Stream.Stream=Stream).prototype.pipe=function(dest,options){var source=this;function ondata(chunk){dest.writable&&!1===dest.write(chunk)&&source.pause&&source.pause()}function ondrain(){source.readable&&source.resume&&source.resume()}source.on("data",ondata),dest.on("drain",ondrain),dest._isStdio||options&&!1===options.end||(source.on("end",onend),source.on("close",onclose));var didOnEnd=!1;function onend(){didOnEnd||(didOnEnd=!0,dest.end())}function onclose(){didOnEnd||(didOnEnd=!0,"function"==typeof dest.destroy&&dest.destroy())}function onerror(er){if(cleanup(),0===EE.listenerCount(this,"error"))throw er}function cleanup(){source.removeListener("data",ondata),dest.removeListener("drain",ondrain),source.removeListener("end",onend),source.removeListener("close",onclose),source.removeListener("error",onerror),dest.removeListener("error",onerror),source.removeListener("end",cleanup),source.removeListener("close",cleanup),dest.removeListener("close",cleanup)}return source.on("error",onerror),dest.on("error",onerror),source.on("end",cleanup),source.on("close",cleanup),dest.on("close",cleanup),dest.emit("pipe",source),dest}},{events:19,inherits:22,"readable-stream/duplex.js":27,"readable-stream/passthrough.js":37,"readable-stream/readable.js":38,"readable-stream/transform.js":39,"readable-stream/writable.js":40}],52:[function(require,module,exports){arguments[4][36][0].apply(exports,arguments)},{dup:36,"safe-buffer":53}],53:[function(require,module,exports){var buffer=require("buffer"),Buffer=buffer.Buffer;function copyProps(src,dst){for(var key in src)dst[key]=src[key]}function SafeBuffer(arg,encodingOrOffset,length){return Buffer(arg,encodingOrOffset,length)}Buffer.from&&Buffer.alloc&&Buffer.allocUnsafe&&Buffer.allocUnsafeSlow?module.exports=buffer:(copyProps(buffer,exports),exports.Buffer=SafeBuffer),SafeBuffer.prototype=Object.create(Buffer.prototype),copyProps(Buffer,SafeBuffer),SafeBuffer.from=function(arg,encodingOrOffset,length){if("number"==typeof arg)throw new TypeError("Argument must not be a number");return Buffer(arg,encodingOrOffset,length)},SafeBuffer.alloc=function(size,fill,encoding){if("number"!=typeof size)throw new TypeError("Argument must be a number");var buf=Buffer(size);return void 0!==fill?"string"==typeof encoding?buf.fill(fill,encoding):buf.fill(fill):buf.fill(0),buf},SafeBuffer.allocUnsafe=function(size){if("number"!=typeof size)throw new TypeError("Argument must be a number");return Buffer(size)},SafeBuffer.allocUnsafeSlow=function(size){if("number"!=typeof size)throw new TypeError("Argument must be a number");return buffer.SlowBuffer(size)}},{buffer:9}],54:[function(require,module,exports){(function(setImmediate,clearImmediate){var nextTick=require("process/browser.js").nextTick,apply=Function.prototype.apply,slice=Array.prototype.slice,immediateIds={},nextImmediateId=0;function Timeout(id,clearFn){this._id=id,this._clearFn=clearFn}exports.setTimeout=function(){return new Timeout(apply.call(setTimeout,window,arguments),clearTimeout)},exports.setInterval=function(){return new Timeout(apply.call(setInterval,window,arguments),clearInterval)},exports.clearTimeout=exports.clearInterval=function(timeout){timeout.close()},Timeout.prototype.unref=Timeout.prototype.ref=function(){},Timeout.prototype.close=function(){this._clearFn.call(window,this._id)},exports.enroll=function(item,msecs){clearTimeout(item._idleTimeoutId),item._idleTimeout=msecs},exports.unenroll=function(item){clearTimeout(item._idleTimeoutId),item._idleTimeout=-1},exports._unrefActive=exports.active=function(item){clearTimeout(item._idleTimeoutId);var msecs=item._idleTimeout;0<=msecs&&(item._idleTimeoutId=setTimeout(function(){item._onTimeout&&item._onTimeout()},msecs))},exports.setImmediate="function"==typeof setImmediate?setImmediate:function(fn){var id=nextImmediateId++,args=!(arguments.length<2)&&slice.call(arguments,1);return immediateIds[id]=!0,nextTick(function(){immediateIds[id]&&(args?fn.apply(null,args):fn.call(null),exports.clearImmediate(id))}),id},exports.clearImmediate="function"==typeof clearImmediate?clearImmediate:function(id){delete immediateIds[id]}}).call(this,require("timers").setImmediate,require("timers").clearImmediate)},{"process/browser.js":26,timers:54}],55:[function(require,module,exports){(function(global){function config(name){try{if(!global.localStorage)return}catch(_){return}var val=global.localStorage[name];return null!=val&&"true"===String(val).toLowerCase()}module.exports=function(fn,msg){if(config("noDeprecation"))return fn;var warned=!1;return function(){if(!warned){if(config("throwDeprecation"))throw new Error(msg);config("traceDeprecation")?console.trace(msg):console.warn(msg),warned=!0}return fn.apply(this,arguments)}}}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],56:[function(require,module,exports){(function(Buffer){var bs58check=require("bs58check"),cashaddr=require("cashaddrjs"),Format={Legacy:"legacy",Bitpay:"bitpay",Cashaddr:"cashaddr"},Network={Mainnet:"mainnet",Testnet:"testnet"},Type={};function detectAddressFormat(address){return decodeAddress(address).format}function detectAddressNetwork(address){return decodeAddress(address).network}function detectAddressType(address){return decodeAddress(address).type}Type.P2PKH="p2pkh",Type.P2SH="p2sh";var VERSION_BYTE={};function decodeAddress(address){try{return function(address){try{var payload=bs58check.decode(address);if(payload.length!==BASE_58_CHECK_PAYLOAD_LENGTH)throw new InvalidAddressError;var versionByte=payload[0],hash=Array.prototype.slice.call(payload,1);switch(versionByte){case VERSION_BYTE[Format.Legacy][Network.Mainnet][Type.P2PKH]:return{hash:hash,format:Format.Legacy,network:Network.Mainnet,type:Type.P2PKH};case VERSION_BYTE[Format.Legacy][Network.Mainnet][Type.P2SH]:return{hash:hash,format:Format.Legacy,network:Network.Mainnet,type:Type.P2SH};case VERSION_BYTE[Format.Legacy][Network.Testnet][Type.P2PKH]:return{hash:hash,format:Format.Legacy,network:Network.Testnet,type:Type.P2PKH};case VERSION_BYTE[Format.Legacy][Network.Testnet][Type.P2SH]:return{hash:hash,format:Format.Legacy,network:Network.Testnet,type:Type.P2SH};case VERSION_BYTE[Format.Bitpay][Network.Mainnet][Type.P2PKH]:return{hash:hash,format:Format.Bitpay,network:Network.Mainnet,type:Type.P2PKH};case VERSION_BYTE[Format.Bitpay][Network.Mainnet][Type.P2SH]:return{hash:hash,format:Format.Bitpay,network:Network.Mainnet,type:Type.P2SH}}}catch(error){}throw new InvalidAddressError}(address)}catch(error){}try{return function(address){if(-1!==address.indexOf(":"))try{return decodeCashAddressWithPrefix(address)}catch(error){}else for(var prefixes=["bitcoincash","bchtest","bchreg"],i=0;i<prefixes.length;++i)try{return decodeCashAddressWithPrefix(prefixes[i]+":"+address)}catch(error){}throw new InvalidAddressError}(address)}catch(error){}throw new InvalidAddressError}VERSION_BYTE[Format.Legacy]={},VERSION_BYTE[Format.Legacy][Network.Mainnet]={},VERSION_BYTE[Format.Legacy][Network.Mainnet][Type.P2PKH]=0,VERSION_BYTE[Format.Legacy][Network.Mainnet][Type.P2SH]=5,VERSION_BYTE[Format.Legacy][Network.Testnet]={},VERSION_BYTE[Format.Legacy][Network.Testnet][Type.P2PKH]=111,VERSION_BYTE[Format.Legacy][Network.Testnet][Type.P2SH]=196,VERSION_BYTE[Format.Bitpay]={},VERSION_BYTE[Format.Bitpay][Network.Mainnet]={},VERSION_BYTE[Format.Bitpay][Network.Mainnet][Type.P2PKH]=28,VERSION_BYTE[Format.Bitpay][Network.Mainnet][Type.P2SH]=40,VERSION_BYTE[Format.Bitpay][Network.Testnet]={},VERSION_BYTE[Format.Bitpay][Network.Testnet][Type.P2PKH]=111,VERSION_BYTE[Format.Bitpay][Network.Testnet][Type.P2SH]=196;var BASE_58_CHECK_PAYLOAD_LENGTH=21;function decodeCashAddressWithPrefix(address){try{var decoded=cashaddr.decode(address),hash=Array.prototype.slice.call(decoded.hash,0),type="P2PKH"===decoded.type?Type.P2PKH:Type.P2SH;switch(decoded.prefix){case"bitcoincash":return{hash:hash,format:Format.Cashaddr,network:Network.Mainnet,type:type};case"bchtest":case"bchreg":return{hash:hash,format:Format.Cashaddr,network:Network.Testnet,type:type}}}catch(error){}throw new InvalidAddressError}function InvalidAddressError(){var error=new Error;this.name=error.name="InvalidAddressError",this.message=error.message="Received an invalid Bitcoin Cash address as input.",this.stack=error.stack}InvalidAddressError.prototype=Object.create(Error.prototype),module.exports={Format:Format,Network:Network,Type:Type,isValidAddress:function(input){try{return decodeAddress(input),!0}catch(error){return!1}},detectAddressFormat:detectAddressFormat,detectAddressNetwork:detectAddressNetwork,detectAddressType:detectAddressType,toLegacyAddress:function(address){var decoded=decodeAddress(address);return decoded.format===Format.Legacy?address:function(decoded){var versionByte=VERSION_BYTE[Format.Legacy][decoded.network][decoded.type],buffer=Buffer.alloc(1+decoded.hash.length);return buffer[0]=versionByte,buffer.set(decoded.hash,1),bs58check.encode(buffer)}(decoded)},toBitpayAddress:function(address){var decoded=decodeAddress(address);return decoded.format===Format.Bitpay?address:function(decoded){var versionByte=VERSION_BYTE[Format.Bitpay][decoded.network][decoded.type],buffer=Buffer.alloc(1+decoded.hash.length);return buffer[0]=versionByte,buffer.set(decoded.hash,1),bs58check.encode(buffer)}(decoded)},toCashAddress:function(address){return function(decoded){var prefix=decoded.network===Network.Mainnet?"bitcoincash":"bchtest",type=decoded.type===Type.P2PKH?"P2PKH":"P2SH",hash=new Uint8Array(decoded.hash);return cashaddr.encode(prefix,type,hash)}(decodeAddress(address))},isLegacyAddress:function(address){return detectAddressFormat(address)===Format.Legacy},isBitpayAddress:function(address){return detectAddressFormat(address)===Format.Bitpay},isCashAddress:function(address){return detectAddressFormat(address)===Format.Cashaddr},isMainnetAddress:function(address){return detectAddressNetwork(address)===Network.Mainnet},isTestnetAddress:function(address){return detectAddressNetwork(address)===Network.Testnet},isP2PKHAddress:function(address){return detectAddressType(address)===Type.P2PKH},isP2SHAddress:function(address){return detectAddressType(address)===Type.P2SH},InvalidAddressError:InvalidAddressError}}).call(this,require("buffer").Buffer)},{bs58check:7,buffer:9,cashaddrjs:11}]},{},[56])(56)});

const MODULE_NAME = 'infinite-scroll';

angular.module(MODULE_NAME, [])
    .value('THROTTLE_MILLISECONDS', null)
    .directive('infiniteScroll', [
        '$rootScope', '$window', '$interval', 'THROTTLE_MILLISECONDS',
        ($rootScope, $window, $interval, THROTTLE_MILLISECONDS) =>
            ({
                scope: {
                    infiniteScroll: '&',
                    infiniteScrollContainer: '=',
                    infiniteScrollDistance: '=',
                    infiniteScrollDisabled: '=',
                    infiniteScrollUseDocumentBottom: '=',
                    infiniteScrollListenForEvent: '@',
                },

                link(scope, elem, attrs) {
                    const windowElement = angular.element($window);

                    let scrollDistance = null;
                    let scrollEnabled = null;
                    let checkWhenEnabled = null;
                    let container = null;
                    let immediateCheck = true;
                    let useDocumentBottom = false;
                    let unregisterEventListener = null;
                    let checkInterval = false;

                    function height(element) {
                        const el = element[0] || element;

                        if (isNaN(el.offsetHeight)) {
                            return el.document.documentElement.clientHeight;
                        }
                        return el.offsetHeight;
                    }

                    function pageYOffset(element) {
                        const el = element[0] || element;

                        if (isNaN(window.pageYOffset)) {
                            return el.document.documentElement.scrollTop;
                        }
                        return el.ownerDocument.defaultView.pageYOffset;
                    }

                    function offsetTop(element) {
                        if (!(!element[0].getBoundingClientRect || element.css('none'))) {
                            return element[0].getBoundingClientRect().top + pageYOffset(element);
                        }
                        return undefined;
                    }

                    // infinite-scroll specifies a function to call when the window,
                    // or some other container specified by infinite-scroll-container,
                    // is scrolled within a certain range from the bottom of the
                    // document. It is recommended to use infinite-scroll-disabled
                    // with a boolean that is set to true when the function is
                    // called in order to throttle the function call.
                    function defaultHandler() {
                        let containerBottom;
                        let elementBottom;
                        if (container === windowElement) {
                            containerBottom = height(container) + pageYOffset(container[0].document.documentElement);
                            elementBottom = offsetTop(elem) + height(elem);
                        } else {
                            containerBottom = height(container);
                            let containerTopOffset = 0;
                            if (offsetTop(container) !== undefined) {
                                containerTopOffset = offsetTop(container);
                            }
                            elementBottom = (offsetTop(elem) - containerTopOffset) + height(elem);
                        }

                        if (useDocumentBottom) {
                            elementBottom = height((elem[0].ownerDocument || elem[0].document).documentElement);
                        }

                        const remaining = elementBottom - containerBottom;
                        const shouldScroll = remaining <= (height(container) * scrollDistance) + 1;

                        if (shouldScroll) {
                            checkWhenEnabled = true;

                            if (scrollEnabled) {
                                if (scope.$$phase || $rootScope.$$phase) {
                                    scope.infiniteScroll();
                                } else {
                                    scope.$apply(scope.infiniteScroll);
                                }
                            }
                        } else {
                            if (checkInterval) { $interval.cancel(checkInterval); }
                            checkWhenEnabled = false;
                        }
                    }

                    // The optional THROTTLE_MILLISECONDS configuration value specifies
                    // a minimum time that should elapse between each call to the
                    // handler. N.b. the first call the handler will be run
                    // immediately, and the final call will always result in the
                    // handler being called after the `wait` period elapses.
                    // A slimmed down version of underscore's implementation.
                    function throttle(func, wait) {
                        let timeout = null;
                        let previous = 0;

                        function later() {
                            previous = new Date().getTime();
                            $interval.cancel(timeout);
                            timeout = null;
                            return func.call();
                        }

                        function throttled() {
                            const now = new Date().getTime();
                            const remaining = wait - (now - previous);
                            if (remaining <= 0) {
                                $interval.cancel(timeout);
                                timeout = null;
                                previous = now;
                                func.call();
                            } else if (!timeout) {
                                timeout = $interval(later, remaining, 1);
                            }
                        }

                        return throttled;
                    }

                    const handler = (THROTTLE_MILLISECONDS != null) ?
                        throttle(defaultHandler, THROTTLE_MILLISECONDS) :
                        defaultHandler;

                    function handleDestroy() {
                        container.unbind('scroll', handler);
                        if (unregisterEventListener != null) {
                            unregisterEventListener();
                            unregisterEventListener = null;
                        }
                        if (checkInterval) {
                            $interval.cancel(checkInterval);
                        }
                    }

                    scope.$on('$destroy', handleDestroy);

                    // infinite-scroll-distance specifies how close to the bottom of the page
                    // the window is allowed to be before we trigger a new scroll. The value
                    // provided is multiplied by the container height; for example, to load
                    // more when the bottom of the page is less than 3 container heights away,
                    // specify a value of 3. Defaults to 0.
                    function handleInfiniteScrollDistance(v) {
                        scrollDistance = parseFloat(v) || 0;
                    }

                    scope.$watch('infiniteScrollDistance', handleInfiniteScrollDistance);
                    // If I don't explicitly call the handler here, tests fail. Don't know why yet.
                    handleInfiniteScrollDistance(scope.infiniteScrollDistance);

                    // infinite-scroll-disabled specifies a boolean that will keep the
                    // infnite scroll function from being called; this is useful for
                    // debouncing or throttling the function call. If an infinite
                    // scroll is triggered but this value evaluates to true, then
                    // once it switches back to false the infinite scroll function
                    // will be triggered again.
                    function handleInfiniteScrollDisabled(v) {
                        scrollEnabled = !v;
                        if (scrollEnabled && checkWhenEnabled) {
                            checkWhenEnabled = false;
                            handler();
                        }
                    }

                    scope.$watch('infiniteScrollDisabled', handleInfiniteScrollDisabled);
                    // If I don't explicitly call the handler here, tests fail. Don't know why yet.
                    handleInfiniteScrollDisabled(scope.infiniteScrollDisabled);

                    // use the bottom of the document instead of the element's bottom.
                    // This useful when the element does not have a height due to its
                    // children being absolute positioned.
                    function handleInfiniteScrollUseDocumentBottom(v) {
                        useDocumentBottom = v;
                    }

                    scope.$watch('infiniteScrollUseDocumentBottom', handleInfiniteScrollUseDocumentBottom);
                    handleInfiniteScrollUseDocumentBottom(scope.infiniteScrollUseDocumentBottom);

                    // infinite-scroll-container sets the container which we want to be
                    // infinte scrolled, instead of the whole window. Must be an
                    // Angular or jQuery element, or, if jQuery is loaded,
                    // a jQuery selector as a string.
                    function changeContainer(newContainer) {
                        if (container != null) {
                            container.unbind('scroll', handler);
                        }

                        container = newContainer;
                        if (newContainer != null) {
                            container.bind('scroll', handler);
                        }
                    }

                    changeContainer(windowElement);

                    if (scope.infiniteScrollListenForEvent) {
                        unregisterEventListener = $rootScope.$on(scope.infiniteScrollListenForEvent, handler);
                    }

                    function handleInfiniteScrollContainer(newContainer) {
                        // TODO: For some reason newContainer is sometimes null instead
                        // of the empty array, which Angular is supposed to pass when the
                        // element is not defined
                        // (https://github.com/sroze/ngInfiniteScroll/pull/7#commitcomment-5748431).
                        // So I leave both checks.
                        if ((!(newContainer != null)) || newContainer.length === 0) {
                            return;
                        }

                        let newerContainer;

                        if (newContainer.nodeType && newContainer.nodeType === 1) {
                            newerContainer = angular.element(newContainer);
                        } else if (typeof newContainer.append === 'function') {
                            newerContainer = angular.element(newContainer[newContainer.length - 1]);
                        } else if (typeof newContainer === 'string') {
                            newerContainer = angular.element(document.querySelector(newContainer));
                        } else {
                            newerContainer = newContainer;
                        }

                        if (newerContainer == null) {
                            throw new Error('invalid infinite-scroll-container attribute.');
                        }
                        changeContainer(newerContainer);
                    }

                    scope.$watch('infiniteScrollContainer', handleInfiniteScrollContainer);
                    handleInfiniteScrollContainer(scope.infiniteScrollContainer || []);

                    // infinite-scroll-parent establishes this element's parent as the
                    // container infinitely scrolled instead of the whole window.
                    if (attrs.infiniteScrollParent != null) {
                        changeContainer(angular.element(elem.parent()));
                    }

                    // infinte-scoll-immediate-check sets whether or not run the
                    // expression passed on infinite-scroll for the first time when the
                    // directive first loads, before any actual scroll.
                    if (attrs.infiniteScrollImmediateCheck != null) {
                        immediateCheck = scope.$eval(attrs.infiniteScrollImmediateCheck);
                    }

                    function intervalCheck() {
                        if (immediateCheck) {
                            handler();
                        }
                        return $interval.cancel(checkInterval);
                    }

                    checkInterval = $interval(intervalCheck);
                    return checkInterval;
                },
            }),

    ]);

!function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var r;r="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,r.QRCode=t()}}(function(){return function(){function t(r,e,n){function o(u,a){if(!e[u]){if(!r[u]){var f="function"==typeof require&&require;if(!a&&f)return f(u,!0);if(i)return i(u,!0);var s=new Error("Cannot find module '"+u+"'");throw s.code="MODULE_NOT_FOUND",s}var h=e[u]={exports:{}};r[u][0].call(h.exports,function(t){return o(r[u][1][t]||t)},h,h.exports,t,r,e,n)}return e[u].exports}for(var i="function"==typeof require&&require,u=0;u<n.length;u++)o(n[u]);return o}return t}()({1:[function(t,r,e){r.exports=function(){return"function"==typeof Promise&&Promise.prototype&&Promise.prototype.then}},{}],2:[function(t,r,e){var n=t("./utils").getSymbolSize;e.getRowColCoords=function(t){if(1===t)return[];for(var r=Math.floor(t/7)+2,e=n(t),o=145===e?26:2*Math.ceil((e-13)/(2*r-2)),i=[e-7],u=1;u<r-1;u++)i[u]=i[u-1]-o;return i.push(6),i.reverse()},e.getPositions=function(t){for(var r=[],n=e.getRowColCoords(t),o=n.length,i=0;i<o;i++)for(var u=0;u<o;u++)0===i&&0===u||0===i&&u===o-1||i===o-1&&0===u||r.push([n[i],n[u]]);return r}},{"./utils":21}],3:[function(t,r,e){function n(t){this.mode=o.ALPHANUMERIC,this.data=t}var o=t("./mode"),i=["0","1","2","3","4","5","6","7","8","9","A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"," ","$","%","*","+","-",".","/",":"];n.getBitsLength=function(t){return 11*Math.floor(t/2)+t%2*6},n.prototype.getLength=function(){return this.data.length},n.prototype.getBitsLength=function(){return n.getBitsLength(this.data.length)},n.prototype.write=function(t){var r;for(r=0;r+2<=this.data.length;r+=2){var e=45*i.indexOf(this.data[r]);e+=i.indexOf(this.data[r+1]),t.put(e,11)}this.data.length%2&&t.put(i.indexOf(this.data[r]),6)},r.exports=n},{"./mode":14}],4:[function(t,r,e){function n(){this.buffer=[],this.length=0}n.prototype={get:function(t){var r=Math.floor(t/8);return 1==(this.buffer[r]>>>7-t%8&1)},put:function(t,r){for(var e=0;e<r;e++)this.putBit(1==(t>>>r-e-1&1))},getLengthInBits:function(){return this.length},putBit:function(t){var r=Math.floor(this.length/8);this.buffer.length<=r&&this.buffer.push(0),t&&(this.buffer[r]|=128>>>this.length%8),this.length++}},r.exports=n},{}],5:[function(t,r,e){function n(t){if(!t||t<1)throw new Error("BitMatrix size must be defined and greater than 0");this.size=t,this.data=o.alloc(t*t),this.reservedBit=o.alloc(t*t)}var o=t("../utils/buffer");n.prototype.set=function(t,r,e,n){var o=t*this.size+r;this.data[o]=e,n&&(this.reservedBit[o]=!0)},n.prototype.get=function(t,r){return this.data[t*this.size+r]},n.prototype.xor=function(t,r,e){this.data[t*this.size+r]^=e},n.prototype.isReserved=function(t,r){return this.reservedBit[t*this.size+r]},r.exports=n},{"../utils/buffer":28}],6:[function(t,r,e){function n(t){this.mode=i.BYTE,this.data=o.from(t)}var o=t("../utils/buffer"),i=t("./mode");n.getBitsLength=function(t){return 8*t},n.prototype.getLength=function(){return this.data.length},n.prototype.getBitsLength=function(){return n.getBitsLength(this.data.length)},n.prototype.write=function(t){for(var r=0,e=this.data.length;r<e;r++)t.put(this.data[r],8)},r.exports=n},{"../utils/buffer":28,"./mode":14}],7:[function(t,r,e){var n=t("./error-correction-level"),o=[1,1,1,1,1,1,1,1,1,1,2,2,1,2,2,4,1,2,4,4,2,4,4,4,2,4,6,5,2,4,6,6,2,5,8,8,4,5,8,8,4,5,8,11,4,8,10,11,4,9,12,16,4,9,16,16,6,10,12,18,6,10,17,16,6,11,16,19,6,13,18,21,7,14,21,25,8,16,20,25,8,17,23,25,9,17,23,34,9,18,25,30,10,20,27,32,12,21,29,35,12,23,34,37,12,25,34,40,13,26,35,42,14,28,38,45,15,29,40,48,16,31,43,51,17,33,45,54,18,35,48,57,19,37,51,60,19,38,53,63,20,40,56,66,21,43,59,70,22,45,62,74,24,47,65,77,25,49,68,81],i=[7,10,13,17,10,16,22,28,15,26,36,44,20,36,52,64,26,48,72,88,36,64,96,112,40,72,108,130,48,88,132,156,60,110,160,192,72,130,192,224,80,150,224,264,96,176,260,308,104,198,288,352,120,216,320,384,132,240,360,432,144,280,408,480,168,308,448,532,180,338,504,588,196,364,546,650,224,416,600,700,224,442,644,750,252,476,690,816,270,504,750,900,300,560,810,960,312,588,870,1050,336,644,952,1110,360,700,1020,1200,390,728,1050,1260,420,784,1140,1350,450,812,1200,1440,480,868,1290,1530,510,924,1350,1620,540,980,1440,1710,570,1036,1530,1800,570,1064,1590,1890,600,1120,1680,1980,630,1204,1770,2100,660,1260,1860,2220,720,1316,1950,2310,750,1372,2040,2430];e.getBlocksCount=function(t,r){switch(r){case n.L:return o[4*(t-1)+0];case n.M:return o[4*(t-1)+1];case n.Q:return o[4*(t-1)+2];case n.H:return o[4*(t-1)+3];default:return}},e.getTotalCodewordsCount=function(t,r){switch(r){case n.L:return i[4*(t-1)+0];case n.M:return i[4*(t-1)+1];case n.Q:return i[4*(t-1)+2];case n.H:return i[4*(t-1)+3];default:return}}},{"./error-correction-level":8}],8:[function(t,r,e){function n(t){if("string"!=typeof t)throw new Error("Param is not a string");switch(t.toLowerCase()){case"l":case"low":return e.L;case"m":case"medium":return e.M;case"q":case"quartile":return e.Q;case"h":case"high":return e.H;default:throw new Error("Unknown EC Level: "+t)}}e.L={bit:1},e.M={bit:0},e.Q={bit:3},e.H={bit:2},e.isValid=function(t){return t&&void 0!==t.bit&&t.bit>=0&&t.bit<4},e.from=function(t,r){if(e.isValid(t))return t;try{return n(t)}catch(t){return r}}},{}],9:[function(t,r,e){var n=t("./utils").getSymbolSize;e.getPositions=function(t){var r=n(t);return[[0,0],[r-7,0],[0,r-7]]}},{"./utils":21}],10:[function(t,r,e){var n=t("./utils"),o=n.getBCHDigit(1335);e.getEncodedBits=function(t,r){for(var e=t.bit<<3|r,i=e<<10;n.getBCHDigit(i)-o>=0;)i^=1335<<n.getBCHDigit(i)-o;return 21522^(e<<10|i)}},{"./utils":21}],11:[function(t,r,e){var n=t("../utils/buffer"),o=n.alloc(512),i=n.alloc(256);!function(){for(var t=1,r=0;r<255;r++)o[r]=t,i[t]=r,256&(t<<=1)&&(t^=285);for(r=255;r<512;r++)o[r]=o[r-255]}(),e.log=function(t){if(t<1)throw new Error("log("+t+")");return i[t]},e.exp=function(t){return o[t]},e.mul=function(t,r){return 0===t||0===r?0:o[i[t]+i[r]]}},{"../utils/buffer":28}],12:[function(t,r,e){function n(t){this.mode=o.KANJI,this.data=t}var o=t("./mode"),i=t("./utils");n.getBitsLength=function(t){return 13*t},n.prototype.getLength=function(){return this.data.length},n.prototype.getBitsLength=function(){return n.getBitsLength(this.data.length)},n.prototype.write=function(t){var r;for(r=0;r<this.data.length;r++){var e=i.toSJIS(this.data[r]);if(e>=33088&&e<=40956)e-=33088;else{if(!(e>=57408&&e<=60351))throw new Error("Invalid SJIS character: "+this.data[r]+"\nMake sure your charset is UTF-8");e-=49472}e=192*(e>>>8&255)+(255&e),t.put(e,13)}},r.exports=n},{"./mode":14,"./utils":21}],13:[function(t,r,e){function n(t,r,n){switch(t){case e.Patterns.PATTERN000:return(r+n)%2==0;case e.Patterns.PATTERN001:return r%2==0;case e.Patterns.PATTERN010:return n%3==0;case e.Patterns.PATTERN011:return(r+n)%3==0;case e.Patterns.PATTERN100:return(Math.floor(r/2)+Math.floor(n/3))%2==0;case e.Patterns.PATTERN101:return r*n%2+r*n%3==0;case e.Patterns.PATTERN110:return(r*n%2+r*n%3)%2==0;case e.Patterns.PATTERN111:return(r*n%3+(r+n)%2)%2==0;default:throw new Error("bad maskPattern:"+t)}}e.Patterns={PATTERN000:0,PATTERN001:1,PATTERN010:2,PATTERN011:3,PATTERN100:4,PATTERN101:5,PATTERN110:6,PATTERN111:7};var o={N1:3,N2:3,N3:40,N4:10};e.isValid=function(t){return null!=t&&""!==t&&!isNaN(t)&&t>=0&&t<=7},e.from=function(t){return e.isValid(t)?parseInt(t,10):void 0},e.getPenaltyN1=function(t){for(var r=t.size,e=0,n=0,i=0,u=null,a=null,f=0;f<r;f++){n=i=0,u=a=null;for(var s=0;s<r;s++){var h=t.get(f,s);h===u?n++:(n>=5&&(e+=o.N1+(n-5)),u=h,n=1),h=t.get(s,f),h===a?i++:(i>=5&&(e+=o.N1+(i-5)),a=h,i=1)}n>=5&&(e+=o.N1+(n-5)),i>=5&&(e+=o.N1+(i-5))}return e},e.getPenaltyN2=function(t){for(var r=t.size,e=0,n=0;n<r-1;n++)for(var i=0;i<r-1;i++){var u=t.get(n,i)+t.get(n,i+1)+t.get(n+1,i)+t.get(n+1,i+1);4!==u&&0!==u||e++}return e*o.N2},e.getPenaltyN3=function(t){for(var r=t.size,e=0,n=0,i=0,u=0;u<r;u++){n=i=0;for(var a=0;a<r;a++)n=n<<1&2047|t.get(u,a),a>=10&&(1488===n||93===n)&&e++,i=i<<1&2047|t.get(a,u),a>=10&&(1488===i||93===i)&&e++}return e*o.N3},e.getPenaltyN4=function(t){for(var r=0,e=t.data.length,n=0;n<e;n++)r+=t.data[n];return Math.abs(Math.ceil(100*r/e/5)-10)*o.N4},e.applyMask=function(t,r){for(var e=r.size,o=0;o<e;o++)for(var i=0;i<e;i++)r.isReserved(i,o)||r.xor(i,o,n(t,i,o))},e.getBestMask=function(t,r){for(var n=Object.keys(e.Patterns).length,o=0,i=1/0,u=0;u<n;u++){r(u),e.applyMask(u,t);var a=e.getPenaltyN1(t)+e.getPenaltyN2(t)+e.getPenaltyN3(t)+e.getPenaltyN4(t);e.applyMask(u,t),a<i&&(i=a,o=u)}return o}},{}],14:[function(t,r,e){function n(t){if("string"!=typeof t)throw new Error("Param is not a string");switch(t.toLowerCase()){case"numeric":return e.NUMERIC;case"alphanumeric":return e.ALPHANUMERIC;case"kanji":return e.KANJI;case"byte":return e.BYTE;default:throw new Error("Unknown mode: "+t)}}var o=t("./version-check"),i=t("./regex");e.NUMERIC={id:"Numeric",bit:1,ccBits:[10,12,14]},e.ALPHANUMERIC={id:"Alphanumeric",bit:2,ccBits:[9,11,13]},e.BYTE={id:"Byte",bit:4,ccBits:[8,16,16]},e.KANJI={id:"Kanji",bit:8,ccBits:[8,10,12]},e.MIXED={bit:-1},e.getCharCountIndicator=function(t,r){if(!t.ccBits)throw new Error("Invalid mode: "+t);if(!o.isValid(r))throw new Error("Invalid version: "+r);return r>=1&&r<10?t.ccBits[0]:r<27?t.ccBits[1]:t.ccBits[2]},e.getBestModeForData=function(t){return i.testNumeric(t)?e.NUMERIC:i.testAlphanumeric(t)?e.ALPHANUMERIC:i.testKanji(t)?e.KANJI:e.BYTE},e.toString=function(t){if(t&&t.id)return t.id;throw new Error("Invalid mode")},e.isValid=function(t){return t&&t.bit&&t.ccBits},e.from=function(t,r){if(e.isValid(t))return t;try{return n(t)}catch(t){return r}}},{"./regex":19,"./version-check":22}],15:[function(t,r,e){function n(t){this.mode=o.NUMERIC,this.data=t.toString()}var o=t("./mode");n.getBitsLength=function(t){return 10*Math.floor(t/3)+(t%3?t%3*3+1:0)},n.prototype.getLength=function(){return this.data.length},n.prototype.getBitsLength=function(){return n.getBitsLength(this.data.length)},n.prototype.write=function(t){var r,e,n;for(r=0;r+3<=this.data.length;r+=3)e=this.data.substr(r,3),n=parseInt(e,10),t.put(n,10);var o=this.data.length-r;o>0&&(e=this.data.substr(r),n=parseInt(e,10),t.put(n,3*o+1))},r.exports=n},{"./mode":14}],16:[function(t,r,e){var n=t("../utils/buffer"),o=t("./galois-field");e.mul=function(t,r){for(var e=n.alloc(t.length+r.length-1),i=0;i<t.length;i++)for(var u=0;u<r.length;u++)e[i+u]^=o.mul(t[i],r[u]);return e},e.mod=function(t,r){for(var e=n.from(t);e.length-r.length>=0;){for(var i=e[0],u=0;u<r.length;u++)e[u]^=o.mul(r[u],i);for(var a=0;a<e.length&&0===e[a];)a++;e=e.slice(a)}return e},e.generateECPolynomial=function(t){for(var r=n.from([1]),i=0;i<t;i++)r=e.mul(r,[1,o.exp(i)]);return r}},{"../utils/buffer":28,"./galois-field":11}],17:[function(t,r,e){function n(t,r){for(var e=t.size,n=w.getPositions(r),o=0;o<n.length;o++)for(var i=n[o][0],u=n[o][1],a=-1;a<=7;a++)if(!(i+a<=-1||e<=i+a))for(var f=-1;f<=7;f++)u+f<=-1||e<=u+f||(a>=0&&a<=6&&(0===f||6===f)||f>=0&&f<=6&&(0===a||6===a)||a>=2&&a<=4&&f>=2&&f<=4?t.set(i+a,u+f,!0,!0):t.set(i+a,u+f,!1,!0))}function o(t){for(var r=t.size,e=8;e<r-8;e++){var n=e%2==0;t.set(e,6,n,!0),t.set(6,e,n,!0)}}function i(t,r){for(var e=v.getPositions(r),n=0;n<e.length;n++)for(var o=e[n][0],i=e[n][1],u=-2;u<=2;u++)for(var a=-2;a<=2;a++)-2===u||2===u||-2===a||2===a||0===u&&0===a?t.set(o+u,i+a,!0,!0):t.set(o+u,i+a,!1,!0)}function u(t,r){for(var e,n,o,i=t.size,u=A.getEncodedBits(r),a=0;a<18;a++)e=Math.floor(a/3),n=a%3+i-8-3,o=1==(u>>a&1),t.set(e,n,o,!0),t.set(n,e,o,!0)}function a(t,r,e){var n,o,i=t.size,u=B.getEncodedBits(r,e);for(n=0;n<15;n++)o=1==(u>>n&1),n<6?t.set(n,8,o,!0):n<8?t.set(n+1,8,o,!0):t.set(i-15+n,8,o,!0),n<8?t.set(8,i-n-1,o,!0):n<9?t.set(8,15-n-1+1,o,!0):t.set(8,15-n-1,o,!0);t.set(i-8,8,1,!0)}function f(t,r){for(var e=t.size,n=-1,o=e-1,i=7,u=0,a=e-1;a>0;a-=2)for(6===a&&a--;;){for(var f=0;f<2;f++)if(!t.isReserved(o,a-f)){var s=!1;u<r.length&&(s=1==(r[u]>>>i&1)),t.set(o,a-f,s),i--,-1===i&&(u++,i=7)}if((o+=n)<0||e<=o){o-=n,n=-n;break}}}function s(t,r,e){var n=new d;e.forEach(function(r){n.put(r.mode.bit,4),n.put(r.getLength(),T.getCharCountIndicator(r.mode,t)),r.write(n)});var o=g.getSymbolTotalCodewords(t),i=b.getTotalCodewordsCount(t,r),u=8*(o-i);for(n.getLengthInBits()+4<=u&&n.put(0,4);n.getLengthInBits()%8!=0;)n.putBit(0);for(var a=(u-n.getLengthInBits())/8,f=0;f<a;f++)n.put(f%2?17:236,8);return h(n,t,r)}function h(t,r,e){for(var n=g.getSymbolTotalCodewords(r),o=b.getTotalCodewordsCount(r,e),i=n-o,u=b.getBlocksCount(r,e),a=n%u,f=u-a,s=Math.floor(n/u),h=Math.floor(i/u),c=h+1,p=s-h,d=new E(p),y=0,v=new Array(u),w=new Array(u),m=0,A=l.from(t.buffer),B=0;B<u;B++){var T=B<f?h:c;v[B]=A.slice(y,y+T),w[B]=d.encode(v[B]),y+=T,m=Math.max(m,T)}var R,C,P=l.alloc(n),I=0;for(R=0;R<m;R++)for(C=0;C<u;C++)R<v[C].length&&(P[I++]=v[C][R]);for(R=0;R<p;R++)for(C=0;C<u;C++)P[I++]=w[C][R];return P}function c(t,r,e,h){var c;if(C(t))c=R.fromArray(t);else{if("string"!=typeof t)throw new Error("Invalid data");var l=r;if(!l){var p=R.rawSplit(t);l=A.getBestVersionForData(p,e)}c=R.fromString(t,l||40)}var d=A.getBestVersionForData(c,e);if(!d)throw new Error("The amount of data is too big to be stored in a QR Code");if(r){if(r<d)throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: "+d+".\n")}else r=d;var v=s(r,e,c),w=g.getSymbolSize(r),b=new y(w);return n(b,r),o(b),i(b,r),a(b,e,0),r>=7&&u(b,r),f(b,v),isNaN(h)&&(h=m.getBestMask(b,a.bind(null,b,e))),m.applyMask(h,b),a(b,e,h),{modules:b,version:r,errorCorrectionLevel:e,maskPattern:h,segments:c}}var l=t("../utils/buffer"),g=t("./utils"),p=t("./error-correction-level"),d=t("./bit-buffer"),y=t("./bit-matrix"),v=t("./alignment-pattern"),w=t("./finder-pattern"),m=t("./mask-pattern"),b=t("./error-correction-code"),E=t("./reed-solomon-encoder"),A=t("./version"),B=t("./format-info"),T=t("./mode"),R=t("./segments"),C=t("isarray");e.create=function(t,r){if(void 0===t||""===t)throw new Error("No input text");var e,n,o=p.M;return void 0!==r&&(o=p.from(r.errorCorrectionLevel,p.M),e=A.from(r.version),n=m.from(r.maskPattern),r.toSJISFunc&&g.setToSJISFunction(r.toSJISFunc)),c(t,e,o,n)}},{"../utils/buffer":28,"./alignment-pattern":2,"./bit-buffer":4,"./bit-matrix":5,"./error-correction-code":7,"./error-correction-level":8,"./finder-pattern":9,"./format-info":10,"./mask-pattern":13,"./mode":14,"./reed-solomon-encoder":18,"./segments":20,"./utils":21,"./version":23,isarray:33}],18:[function(t,r,e){function n(t){this.genPoly=void 0,this.degree=t,this.degree&&this.initialize(this.degree)}var o=t("../utils/buffer"),i=t("./polynomial"),u=t("buffer").Buffer;n.prototype.initialize=function(t){this.degree=t,this.genPoly=i.generateECPolynomial(this.degree)},n.prototype.encode=function(t){if(!this.genPoly)throw new Error("Encoder not initialized");var r=o.alloc(this.degree),e=u.concat([t,r],t.length+this.degree),n=i.mod(e,this.genPoly),a=this.degree-n.length;if(a>0){var f=o.alloc(this.degree);return n.copy(f,a),f}return n},r.exports=n},{"../utils/buffer":28,"./polynomial":16,buffer:30}],19:[function(t,r,e){var n="(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";n=n.replace(/u/g,"\\u");var o="(?:(?![A-Z0-9 $%*+\\-./:]|"+n+")(?:.|[\r\n]))+";e.KANJI=new RegExp(n,"g"),e.BYTE_KANJI=new RegExp("[^A-Z0-9 $%*+\\-./:]+","g"),e.BYTE=new RegExp(o,"g"),e.NUMERIC=new RegExp("[0-9]+","g"),e.ALPHANUMERIC=new RegExp("[A-Z $%*+\\-./:]+","g");var i=new RegExp("^"+n+"$"),u=new RegExp("^[0-9]+$"),a=new RegExp("^[A-Z0-9 $%*+\\-./:]+$");e.testKanji=function(t){return i.test(t)},e.testNumeric=function(t){return u.test(t)},e.testAlphanumeric=function(t){return a.test(t)}},{}],20:[function(t,r,e){function n(t){return unescape(encodeURIComponent(t)).length}function o(t,r,e){for(var n,o=[];null!==(n=t.exec(e));)o.push({data:n[0],index:n.index,mode:r,length:n[0].length});return o}function i(t){var r,e,n=o(y.NUMERIC,c.NUMERIC,t),i=o(y.ALPHANUMERIC,c.ALPHANUMERIC,t);return v.isKanjiModeEnabled()?(r=o(y.BYTE,c.BYTE,t),e=o(y.KANJI,c.KANJI,t)):(r=o(y.BYTE_KANJI,c.BYTE,t),e=[]),n.concat(i,r,e).sort(function(t,r){return t.index-r.index}).map(function(t){return{data:t.data,mode:t.mode,length:t.length}})}function u(t,r){switch(r){case c.NUMERIC:return l.getBitsLength(t);case c.ALPHANUMERIC:return g.getBitsLength(t);case c.KANJI:return d.getBitsLength(t);case c.BYTE:return p.getBitsLength(t)}}function a(t){return t.reduce(function(t,r){var e=t.length-1>=0?t[t.length-1]:null;return e&&e.mode===r.mode?(t[t.length-1].data+=r.data,t):(t.push(r),t)},[])}function f(t){for(var r=[],e=0;e<t.length;e++){var o=t[e];switch(o.mode){case c.NUMERIC:r.push([o,{data:o.data,mode:c.ALPHANUMERIC,length:o.length},{data:o.data,mode:c.BYTE,length:o.length}]);break;case c.ALPHANUMERIC:r.push([o,{data:o.data,mode:c.BYTE,length:o.length}]);break;case c.KANJI:r.push([o,{data:o.data,mode:c.BYTE,length:n(o.data)}]);break;case c.BYTE:r.push([{data:o.data,mode:c.BYTE,length:n(o.data)}])}}return r}function s(t,r){for(var e={},n={start:{}},o=["start"],i=0;i<t.length;i++){for(var a=t[i],f=[],s=0;s<a.length;s++){var h=a[s],l=""+i+s;f.push(l),e[l]={node:h,lastCount:0},n[l]={};for(var g=0;g<o.length;g++){var p=o[g];e[p]&&e[p].node.mode===h.mode?(n[p][l]=u(e[p].lastCount+h.length,h.mode)-u(e[p].lastCount,h.mode),e[p].lastCount+=h.length):(e[p]&&(e[p].lastCount=h.length),n[p][l]=u(h.length,h.mode)+4+c.getCharCountIndicator(h.mode,r))}}o=f}for(g=0;g<o.length;g++)n[o[g]].end=0;return{map:n,table:e}}function h(t,r){var e,n=c.getBestModeForData(t);if((e=c.from(r,n))!==c.BYTE&&e.bit<n.bit)throw new Error('"'+t+'" cannot be encoded with mode '+c.toString(e)+".\n Suggested mode is: "+c.toString(n));switch(e!==c.KANJI||v.isKanjiModeEnabled()||(e=c.BYTE),e){case c.NUMERIC:return new l(t);case c.ALPHANUMERIC:return new g(t);case c.KANJI:return new d(t);case c.BYTE:return new p(t)}}var c=t("./mode"),l=t("./numeric-data"),g=t("./alphanumeric-data"),p=t("./byte-data"),d=t("./kanji-data"),y=t("./regex"),v=t("./utils"),w=t("dijkstrajs");e.fromArray=function(t){return t.reduce(function(t,r){return"string"==typeof r?t.push(h(r,null)):r.data&&t.push(h(r.data,r.mode)),t},[])},e.fromString=function(t,r){for(var n=i(t,v.isKanjiModeEnabled()),o=f(n),u=s(o,r),h=w.find_path(u.map,"start","end"),c=[],l=1;l<h.length-1;l++)c.push(u.table[h[l]].node);return e.fromArray(a(c))},e.rawSplit=function(t){return e.fromArray(i(t,v.isKanjiModeEnabled()))}},{"./alphanumeric-data":3,"./byte-data":6,"./kanji-data":12,"./mode":14,"./numeric-data":15,"./regex":19,"./utils":21,dijkstrajs:31}],21:[function(t,r,e){var n,o=[0,26,44,70,100,134,172,196,242,292,346,404,466,532,581,655,733,815,901,991,1085,1156,1258,1364,1474,1588,1706,1828,1921,2051,2185,2323,2465,2611,2761,2876,3034,3196,3362,3532,3706];e.getSymbolSize=function(t){if(!t)throw new Error('"version" cannot be null or undefined');if(t<1||t>40)throw new Error('"version" should be in range from 1 to 40');return 4*t+17},e.getSymbolTotalCodewords=function(t){return o[t]},e.getBCHDigit=function(t){for(var r=0;0!==t;)r++,t>>>=1;return r},e.setToSJISFunction=function(t){if("function"!=typeof t)throw new Error('"toSJISFunc" is not a valid function.');n=t},e.isKanjiModeEnabled=function(){return void 0!==n},e.toSJIS=function(t){return n(t)}},{}],22:[function(t,r,e){e.isValid=function(t){return!isNaN(t)&&t>=1&&t<=40}},{}],23:[function(t,r,e){function n(t,r,n){for(var o=1;o<=40;o++)if(r<=e.getCapacity(o,n,t))return o}function o(t,r){return h.getCharCountIndicator(t,r)+4}function i(t,r){var e=0;return t.forEach(function(t){var n=o(t.mode,r);e+=n+t.getBitsLength()}),e}function u(t,r){for(var n=1;n<=40;n++){if(i(t,n)<=e.getCapacity(n,r,h.MIXED))return n}}var a=t("./utils"),f=t("./error-correction-code"),s=t("./error-correction-level"),h=t("./mode"),c=t("./version-check"),l=t("isarray"),g=a.getBCHDigit(7973);e.from=function(t,r){return c.isValid(t)?parseInt(t,10):r},e.getCapacity=function(t,r,e){if(!c.isValid(t))throw new Error("Invalid QR Code version");void 0===e&&(e=h.BYTE);var n=a.getSymbolTotalCodewords(t),i=f.getTotalCodewordsCount(t,r),u=8*(n-i);if(e===h.MIXED)return u;var s=u-o(e,t);switch(e){case h.NUMERIC:return Math.floor(s/10*3);case h.ALPHANUMERIC:return Math.floor(s/11*2);case h.KANJI:return Math.floor(s/13);case h.BYTE:default:return Math.floor(s/8)}},e.getBestVersionForData=function(t,r){var e,o=s.from(r,s.M);if(l(t)){if(t.length>1)return u(t,o);if(0===t.length)return 1;e=t[0]}else e=t;return n(e.mode,e.getLength(),o)},e.getEncodedBits=function(t){if(!c.isValid(t)||t<7)throw new Error("Invalid QR Code version");for(var r=t<<12;a.getBCHDigit(r)-g>=0;)r^=7973<<a.getBCHDigit(r)-g;return t<<12|r}},{"./error-correction-code":7,"./error-correction-level":8,"./mode":14,"./utils":21,"./version-check":22,isarray:33}],24:[function(t,r,e){function n(t,r,e,n,u){var a=[].slice.call(arguments,1),f=a.length,s="function"==typeof a[f-1];if(!s&&!o())throw new Error("Callback required as last argument");if(!s){if(f<1)throw new Error("Too few arguments provided");return 1===f?(e=r,r=n=void 0):2!==f||r.getContext||(n=e,e=r,r=void 0),new Promise(function(o,u){try{var a=i.create(e,n);o(t(a,r,n))}catch(t){u(t)}})}if(f<2)throw new Error("Too few arguments provided");2===f?(u=e,e=r,r=n=void 0):3===f&&(r.getContext&&void 0===u?(u=n,n=void 0):(u=n,n=e,e=r,r=void 0));try{var h=i.create(e,n);u(null,t(h,r,n))}catch(t){u(t)}}var o=t("./can-promise"),i=t("./core/qrcode"),u=t("./renderer/canvas"),a=t("./renderer/svg-tag.js");e.create=i.create,e.toCanvas=n.bind(null,u.render),e.toDataURL=n.bind(null,u.renderToDataURL),e.toString=n.bind(null,function(t,r,e){return a.render(t,e)})},{"./can-promise":1,"./core/qrcode":17,"./renderer/canvas":25,"./renderer/svg-tag.js":26}],25:[function(t,r,e){function n(t,r,e){t.clearRect(0,0,r.width,r.height),r.style||(r.style={}),r.height=e,r.width=e,r.style.height=e+"px",r.style.width=e+"px"}function o(){try{return document.createElement("canvas")}catch(t){throw new Error("You need to specify a canvas element")}}var i=t("./utils");e.render=function(t,r,e){var u=e,a=r;void 0!==u||r&&r.getContext||(u=r,r=void 0),r||(a=o()),u=i.getOptions(u);var f=i.getImageWidth(t.modules.size,u),s=a.getContext("2d"),h=s.createImageData(f,f);return i.qrToImageData(h.data,t,u),n(s,a,f),s.putImageData(h,0,0),a},e.renderToDataURL=function(t,r,n){var o=n;void 0!==o||r&&r.getContext||(o=r,r=void 0),o||(o={});var i=e.render(t,r,o),u=o.type||"image/png",a=o.rendererOpts||{};return i.toDataURL(u,a.quality)}},{"./utils":27}],26:[function(t,r,e){function n(t,r){var e=t.a/255,n=r+'="'+t.hex+'"';return e<1?n+" "+r+'-opacity="'+e.toFixed(2).slice(1)+'"':n}function o(t,r,e){var n=t+r;return void 0!==e&&(n+=" "+e),n}function i(t,r,e){for(var n="",i=0,u=!1,a=0,f=0;f<t.length;f++){var s=Math.floor(f%r),h=Math.floor(f/r);s||u||(u=!0),t[f]?(a++,f>0&&s>0&&t[f-1]||(n+=u?o("M",s+e,.5+h+e):o("m",i,0),i=0,u=!1),s+1<r&&t[f+1]||(n+=o("h",a),a=0)):i++}return n}var u=t("./utils");e.render=function(t,r,e){var o=u.getOptions(r),a=t.modules.size,f=t.modules.data,s=a+2*o.margin,h=o.color.light.a?"<path "+n(o.color.light,"fill")+' d="M0 0h'+s+"v"+s+'H0z"/>':"",c="<path "+n(o.color.dark,"stroke")+' d="'+i(f,a,o.margin)+'"/>',l='viewBox="0 0 '+s+" "+s+'"',g=o.width?'width="'+o.width+'" height="'+o.width+'" ':"",p='<svg xmlns="http://www.w3.org/2000/svg" '+g+l+' shape-rendering="crispEdges">'+h+c+"</svg>\n";return"function"==typeof e&&e(null,p),p}},{"./utils":27}],27:[function(t,r,e){function n(t){if("number"==typeof t&&(t=t.toString()),"string"!=typeof t)throw new Error("Color should be defined as hex string");var r=t.slice().replace("#","").split("");if(r.length<3||5===r.length||r.length>8)throw new Error("Invalid hex color: "+t);3!==r.length&&4!==r.length||(r=Array.prototype.concat.apply([],r.map(function(t){return[t,t]}))),6===r.length&&r.push("F","F");var e=parseInt(r.join(""),16);return{r:e>>24&255,g:e>>16&255,b:e>>8&255,a:255&e,hex:"#"+r.slice(0,6).join("")}}e.getOptions=function(t){t||(t={}),t.color||(t.color={});var r=void 0===t.margin||null===t.margin||t.margin<0?4:t.margin,e=t.width&&t.width>=21?t.width:void 0,o=t.scale||4;return{width:e,scale:e?4:o,margin:r,color:{dark:n(t.color.dark||"#000000ff"),light:n(t.color.light||"#ffffffff")},type:t.type,rendererOpts:t.rendererOpts||{}}},e.getScale=function(t,r){return r.width&&r.width>=t+2*r.margin?r.width/(t+2*r.margin):r.scale},e.getImageWidth=function(t,r){var n=e.getScale(t,r);return Math.floor((t+2*r.margin)*n)},e.qrToImageData=function(t,r,n){for(var o=r.modules.size,i=r.modules.data,u=e.getScale(o,n),a=Math.floor((o+2*n.margin)*u),f=n.margin*u,s=[n.color.light,n.color.dark],h=0;h<a;h++)for(var c=0;c<a;c++){var l=4*(h*a+c),g=n.color.light;if(h>=f&&c>=f&&h<a-f&&c<a-f){var p=Math.floor((h-f)/u),d=Math.floor((c-f)/u);g=s[i[p*o+d]?1:0]}t[l++]=g.r,t[l++]=g.g,t[l++]=g.b,t[l]=g.a}}},{}],28:[function(t,r,e){"use strict";function n(t,r,e){return n.TYPED_ARRAY_SUPPORT||this instanceof n?"number"==typeof t?a(this,t):y(this,t,r,e):new n(t,r,e)}function o(t){if(t>=w)throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+w.toString(16)+" bytes");return 0|t}function i(t){return t!==t}function u(t,r){var e;return n.TYPED_ARRAY_SUPPORT?(e=new Uint8Array(r),e.__proto__=n.prototype):(e=t,null===e&&(e=new n(r)),e.length=r),e}function a(t,r){var e=u(t,r<0?0:0|o(r));if(!n.TYPED_ARRAY_SUPPORT)for(var i=0;i<r;++i)e[i]=0;return e}function f(t,r){var e=0|g(r),n=u(t,e),o=n.write(r);return o!==e&&(n=n.slice(0,o)),n}function s(t,r){for(var e=r.length<0?0:0|o(r.length),n=u(t,e),i=0;i<e;i+=1)n[i]=255&r[i];return n}function h(t,r,e,o){if(e<0||r.byteLength<e)throw new RangeError("'offset' is out of bounds");if(r.byteLength<e+(o||0))throw new RangeError("'length' is out of bounds");var i;return i=void 0===e&&void 0===o?new Uint8Array(r):void 0===o?new Uint8Array(r,e):new Uint8Array(r,e,o),n.TYPED_ARRAY_SUPPORT?i.__proto__=n.prototype:i=s(t,i),i}function c(t,r){if(n.isBuffer(r)){var e=0|o(r.length),a=u(t,e);return 0===a.length?a:(r.copy(a,0,0,e),a)}if(r){if("undefined"!=typeof ArrayBuffer&&r.buffer instanceof ArrayBuffer||"length"in r)return"number"!=typeof r.length||i(r.length)?u(t,0):s(t,r);if("Buffer"===r.type&&Array.isArray(r.data))return s(t,r.data)}throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")}function l(t,r){r=r||1/0;for(var e,n=t.length,o=null,i=[],u=0;u<n;++u){if((e=t.charCodeAt(u))>55295&&e<57344){if(!o){if(e>56319){(r-=3)>-1&&i.push(239,191,189);continue}if(u+1===n){(r-=3)>-1&&i.push(239,191,189);continue}o=e;continue}if(e<56320){(r-=3)>-1&&i.push(239,191,189),o=e;continue}e=65536+(o-55296<<10|e-56320)}else o&&(r-=3)>-1&&i.push(239,191,189);if(o=null,e<128){if((r-=1)<0)break;i.push(e)}else if(e<2048){if((r-=2)<0)break;i.push(e>>6|192,63&e|128)}else if(e<65536){if((r-=3)<0)break;i.push(e>>12|224,e>>6&63|128,63&e|128)}else{if(!(e<1114112))throw new Error("Invalid code point");if((r-=4)<0)break;i.push(e>>18|240,e>>12&63|128,e>>6&63|128,63&e|128)}}return i}function g(t){return n.isBuffer(t)?t.length:"undefined"!=typeof ArrayBuffer&&"function"==typeof ArrayBuffer.isView&&(ArrayBuffer.isView(t)||t instanceof ArrayBuffer)?t.byteLength:("string"!=typeof t&&(t=""+t),0===t.length?0:l(t).length)}function p(t,r,e,n){for(var o=0;o<n&&!(o+e>=r.length||o>=t.length);++o)r[o+e]=t[o];return o}function d(t,r,e,n){return p(l(r,t.length-e),t,e,n)}function y(t,r,e,n){if("number"==typeof r)throw new TypeError('"value" argument must not be a number');return"undefined"!=typeof ArrayBuffer&&r instanceof ArrayBuffer?h(t,r,e,n):"string"==typeof r?f(t,r,e):c(t,r)}var v=t("isarray");n.TYPED_ARRAY_SUPPORT=function(){try{var t=new Uint8Array(1);return t.__proto__={__proto__:Uint8Array.prototype,foo:function(){return 42}},42===t.foo()}catch(t){return!1}}();var w=n.TYPED_ARRAY_SUPPORT?2147483647:1073741823;n.TYPED_ARRAY_SUPPORT&&(n.prototype.__proto__=Uint8Array.prototype,n.__proto__=Uint8Array,"undefined"!=typeof Symbol&&Symbol.species&&n[Symbol.species]===n&&Object.defineProperty(n,Symbol.species,{value:null,configurable:!0,enumerable:!1,writable:!1})),n.prototype.write=function(t,r,e){void 0===r?(e=this.length,r=0):void 0===e&&"string"==typeof r?(e=this.length,r=0):isFinite(r)&&(r|=0,isFinite(e)?e|=0:e=void 0);var n=this.length-r;if((void 0===e||e>n)&&(e=n),t.length>0&&(e<0||r<0)||r>this.length)throw new RangeError("Attempt to write outside buffer bounds");return d(this,t,r,e)},n.prototype.slice=function(t,r){var e=this.length;t=~~t,r=void 0===r?e:~~r,t<0?(t+=e)<0&&(t=0):t>e&&(t=e),r<0?(r+=e)<0&&(r=0):r>e&&(r=e),r<t&&(r=t);var o;if(n.TYPED_ARRAY_SUPPORT)o=this.subarray(t,r),o.__proto__=n.prototype;else{var i=r-t;o=new n(i,void 0);for(var u=0;u<i;++u)o[u]=this[u+t]}return o},n.prototype.copy=function(t,r,e,o){if(e||(e=0),o||0===o||(o=this.length),r>=t.length&&(r=t.length),r||(r=0),o>0&&o<e&&(o=e),o===e)return 0;if(0===t.length||0===this.length)return 0;if(r<0)throw new RangeError("targetStart out of bounds");if(e<0||e>=this.length)throw new RangeError("sourceStart out of bounds");if(o<0)throw new RangeError("sourceEnd out of bounds");o>this.length&&(o=this.length),t.length-r<o-e&&(o=t.length-r+e);var i,u=o-e;if(this===t&&e<r&&r<o)for(i=u-1;i>=0;--i)t[i+r]=this[i+e];else if(u<1e3||!n.TYPED_ARRAY_SUPPORT)for(i=0;i<u;++i)t[i+r]=this[i+e];else Uint8Array.prototype.set.call(t,this.subarray(e,e+u),r);return u},n.prototype.fill=function(t,r,e){if("string"==typeof t){if("string"==typeof r?(r=0,e=this.length):"string"==typeof e&&(e=this.length),1===t.length){var o=t.charCodeAt(0);o<256&&(t=o)}}else"number"==typeof t&&(t&=255);if(r<0||this.length<r||this.length<e)throw new RangeError("Out of range index");if(e<=r)return this;r>>>=0,e=void 0===e?this.length:e>>>0,t||(t=0);var i;if("number"==typeof t)for(i=r;i<e;++i)this[i]=t;else{var u=n.isBuffer(t)?t:new n(t),a=u.length;for(i=0;i<e-r;++i)this[i+r]=u[i%a]}return this},n.concat=function(t,r){if(!v(t))throw new TypeError('"list" argument must be an Array of Buffers');if(0===t.length)return u(null,0);var e;if(void 0===r)for(r=0,e=0;e<t.length;++e)r+=t[e].length;var o=a(null,r),i=0;for(e=0;e<t.length;++e){var f=t[e];if(!n.isBuffer(f))throw new TypeError('"list" argument must be an Array of Buffers');f.copy(o,i),i+=f.length}return o},n.byteLength=g,n.prototype._isBuffer=!0,n.isBuffer=function(t){return!(null==t||!t._isBuffer)},r.exports.alloc=function(t){var r=new n(t);return r.fill(0),r},r.exports.from=function(t){return new n(t)}},{isarray:33}],29:[function(t,r,e){"use strict";function n(t){var r=t.length;if(r%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var e=t.indexOf("=");return-1===e&&(e=r),[e,e===r?0:4-e%4]}function o(t){var r=n(t),e=r[0],o=r[1];return 3*(e+o)/4-o}function i(t,r,e){return 3*(r+e)/4-e}function u(t){var r,e,o=n(t),u=o[0],a=o[1],f=new l(i(t,u,a)),s=0,h=a>0?u-4:u;for(e=0;e<h;e+=4)r=c[t.charCodeAt(e)]<<18|c[t.charCodeAt(e+1)]<<12|c[t.charCodeAt(e+2)]<<6|c[t.charCodeAt(e+3)],f[s++]=r>>16&255,f[s++]=r>>8&255,f[s++]=255&r;return 2===a&&(r=c[t.charCodeAt(e)]<<2|c[t.charCodeAt(e+1)]>>4,f[s++]=255&r),1===a&&(r=c[t.charCodeAt(e)]<<10|c[t.charCodeAt(e+1)]<<4|c[t.charCodeAt(e+2)]>>2,f[s++]=r>>8&255,f[s++]=255&r),f}function a(t){return h[t>>18&63]+h[t>>12&63]+h[t>>6&63]+h[63&t]}function f(t,r,e){for(var n,o=[],i=r;i<e;i+=3)n=(t[i]<<16&16711680)+(t[i+1]<<8&65280)+(255&t[i+2]),o.push(a(n));return o.join("")}function s(t){for(var r,e=t.length,n=e%3,o=[],i=0,u=e-n;i<u;i+=16383)o.push(f(t,i,i+16383>u?u:i+16383));return 1===n?(r=t[e-1],o.push(h[r>>2]+h[r<<4&63]+"==")):2===n&&(r=(t[e-2]<<8)+t[e-1],o.push(h[r>>10]+h[r>>4&63]+h[r<<2&63]+"=")),o.join("")}e.byteLength=o,e.toByteArray=u,e.fromByteArray=s
;for(var h=[],c=[],l="undefined"!=typeof Uint8Array?Uint8Array:Array,g="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",p=0,d=g.length;p<d;++p)h[p]=g[p],c[g.charCodeAt(p)]=p;c["-".charCodeAt(0)]=62,c["_".charCodeAt(0)]=63},{}],30:[function(t,r,e){"use strict";function n(t){if(t>$)throw new RangeError('The value "'+t+'" is invalid for option "size"');var r=new Uint8Array(t);return Object.setPrototypeOf(r,o.prototype),r}function o(t,r,e){if("number"==typeof t){if("string"==typeof r)throw new TypeError('The "string" argument must be of type string. Received type number');return f(t)}return i(t,r,e)}function i(t,r,e){if("string"==typeof t)return s(t,r);if(ArrayBuffer.isView(t))return h(t);if(null==t)throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type "+typeof t);if(J(t,ArrayBuffer)||t&&J(t.buffer,ArrayBuffer))return c(t,r,e);if("number"==typeof t)throw new TypeError('The "value" argument must not be of type number. Received type number');var n=t.valueOf&&t.valueOf();if(null!=n&&n!==t)return o.from(n,r,e);var i=l(t);if(i)return i;if("undefined"!=typeof Symbol&&null!=Symbol.toPrimitive&&"function"==typeof t[Symbol.toPrimitive])return o.from(t[Symbol.toPrimitive]("string"),r,e);throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type "+typeof t)}function u(t){if("number"!=typeof t)throw new TypeError('"size" argument must be of type number');if(t<0)throw new RangeError('The value "'+t+'" is invalid for option "size"')}function a(t,r,e){return u(t),t<=0?n(t):void 0!==r?"string"==typeof e?n(t).fill(r,e):n(t).fill(r):n(t)}function f(t){return u(t),n(t<0?0:0|g(t))}function s(t,r){if("string"==typeof r&&""!==r||(r="utf8"),!o.isEncoding(r))throw new TypeError("Unknown encoding: "+r);var e=0|d(t,r),i=n(e),u=i.write(t,r);return u!==e&&(i=i.slice(0,u)),i}function h(t){for(var r=t.length<0?0:0|g(t.length),e=n(r),o=0;o<r;o+=1)e[o]=255&t[o];return e}function c(t,r,e){if(r<0||t.byteLength<r)throw new RangeError('"offset" is outside of buffer bounds');if(t.byteLength<r+(e||0))throw new RangeError('"length" is outside of buffer bounds');var n;return n=void 0===r&&void 0===e?new Uint8Array(t):void 0===e?new Uint8Array(t,r):new Uint8Array(t,r,e),Object.setPrototypeOf(n,o.prototype),n}function l(t){if(o.isBuffer(t)){var r=0|g(t.length),e=n(r);return 0===e.length?e:(t.copy(e,0,0,r),e)}return void 0!==t.length?"number"!=typeof t.length||K(t.length)?n(0):h(t):"Buffer"===t.type&&Array.isArray(t.data)?h(t.data):void 0}function g(t){if(t>=$)throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+$.toString(16)+" bytes");return 0|t}function p(t){return+t!=t&&(t=0),o.alloc(+t)}function d(t,r){if(o.isBuffer(t))return t.length;if(ArrayBuffer.isView(t)||J(t,ArrayBuffer))return t.byteLength;if("string"!=typeof t)throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type '+typeof t);var e=t.length,n=arguments.length>2&&!0===arguments[2];if(!n&&0===e)return 0;for(var i=!1;;)switch(r){case"ascii":case"latin1":case"binary":return e;case"utf8":case"utf-8":return D(t).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*e;case"hex":return e>>>1;case"base64":return z(t).length;default:if(i)return n?-1:D(t).length;r=(""+r).toLowerCase(),i=!0}}function y(t,r,e){var n=!1;if((void 0===r||r<0)&&(r=0),r>this.length)return"";if((void 0===e||e>this.length)&&(e=this.length),e<=0)return"";if(e>>>=0,r>>>=0,e<=r)return"";for(t||(t="utf8");;)switch(t){case"hex":return N(this,r,e);case"utf8":case"utf-8":return P(this,r,e);case"ascii":return M(this,r,e);case"latin1":case"binary":return U(this,r,e);case"base64":return C(this,r,e);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return S(this,r,e);default:if(n)throw new TypeError("Unknown encoding: "+t);t=(t+"").toLowerCase(),n=!0}}function v(t,r,e){var n=t[r];t[r]=t[e],t[e]=n}function w(t,r,e,n,i){if(0===t.length)return-1;if("string"==typeof e?(n=e,e=0):e>2147483647?e=2147483647:e<-2147483648&&(e=-2147483648),e=+e,K(e)&&(e=i?0:t.length-1),e<0&&(e=t.length+e),e>=t.length){if(i)return-1;e=t.length-1}else if(e<0){if(!i)return-1;e=0}if("string"==typeof r&&(r=o.from(r,n)),o.isBuffer(r))return 0===r.length?-1:m(t,r,e,n,i);if("number"==typeof r)return r&=255,"function"==typeof Uint8Array.prototype.indexOf?i?Uint8Array.prototype.indexOf.call(t,r,e):Uint8Array.prototype.lastIndexOf.call(t,r,e):m(t,[r],e,n,i);throw new TypeError("val must be string, number or Buffer")}function m(t,r,e,n,o){function i(t,r){return 1===u?t[r]:t.readUInt16BE(r*u)}var u=1,a=t.length,f=r.length;if(void 0!==n&&("ucs2"===(n=String(n).toLowerCase())||"ucs-2"===n||"utf16le"===n||"utf-16le"===n)){if(t.length<2||r.length<2)return-1;u=2,a/=2,f/=2,e/=2}var s;if(o){var h=-1;for(s=e;s<a;s++)if(i(t,s)===i(r,-1===h?0:s-h)){if(-1===h&&(h=s),s-h+1===f)return h*u}else-1!==h&&(s-=s-h),h=-1}else for(e+f>a&&(e=a-f),s=e;s>=0;s--){for(var c=!0,l=0;l<f;l++)if(i(t,s+l)!==i(r,l)){c=!1;break}if(c)return s}return-1}function b(t,r,e,n){e=Number(e)||0;var o=t.length-e;n?(n=Number(n))>o&&(n=o):n=o;var i=r.length;n>i/2&&(n=i/2);for(var u=0;u<n;++u){var a=parseInt(r.substr(2*u,2),16);if(K(a))return u;t[e+u]=a}return u}function E(t,r,e,n){return H(D(r,t.length-e),t,e,n)}function A(t,r,e,n){return H(j(r),t,e,n)}function B(t,r,e,n){return A(t,r,e,n)}function T(t,r,e,n){return H(z(r),t,e,n)}function R(t,r,e,n){return H(F(r,t.length-e),t,e,n)}function C(t,r,e){return 0===r&&e===t.length?q.fromByteArray(t):q.fromByteArray(t.slice(r,e))}function P(t,r,e){e=Math.min(t.length,e);for(var n=[],o=r;o<e;){var i=t[o],u=null,a=i>239?4:i>223?3:i>191?2:1;if(o+a<=e){var f,s,h,c;switch(a){case 1:i<128&&(u=i);break;case 2:f=t[o+1],128==(192&f)&&(c=(31&i)<<6|63&f)>127&&(u=c);break;case 3:f=t[o+1],s=t[o+2],128==(192&f)&&128==(192&s)&&(c=(15&i)<<12|(63&f)<<6|63&s)>2047&&(c<55296||c>57343)&&(u=c);break;case 4:f=t[o+1],s=t[o+2],h=t[o+3],128==(192&f)&&128==(192&s)&&128==(192&h)&&(c=(15&i)<<18|(63&f)<<12|(63&s)<<6|63&h)>65535&&c<1114112&&(u=c)}}null===u?(u=65533,a=1):u>65535&&(u-=65536,n.push(u>>>10&1023|55296),u=56320|1023&u),n.push(u),o+=a}return I(n)}function I(t){var r=t.length;if(r<=X)return String.fromCharCode.apply(String,t);for(var e="",n=0;n<r;)e+=String.fromCharCode.apply(String,t.slice(n,n+=X));return e}function M(t,r,e){var n="";e=Math.min(t.length,e);for(var o=r;o<e;++o)n+=String.fromCharCode(127&t[o]);return n}function U(t,r,e){var n="";e=Math.min(t.length,e);for(var o=r;o<e;++o)n+=String.fromCharCode(t[o]);return n}function N(t,r,e){var n=t.length;(!r||r<0)&&(r=0),(!e||e<0||e>n)&&(e=n);for(var o="",i=r;i<e;++i)o+=W[t[i]];return o}function S(t,r,e){for(var n=t.slice(r,e),o="",i=0;i<n.length;i+=2)o+=String.fromCharCode(n[i]+256*n[i+1]);return o}function L(t,r,e){if(t%1!=0||t<0)throw new RangeError("offset is not uint");if(t+r>e)throw new RangeError("Trying to access beyond buffer length")}function x(t,r,e,n,i,u){if(!o.isBuffer(t))throw new TypeError('"buffer" argument must be a Buffer instance');if(r>i||r<u)throw new RangeError('"value" argument is out of bounds');if(e+n>t.length)throw new RangeError("Index out of range")}function _(t,r,e,n,o,i){if(e+n>t.length)throw new RangeError("Index out of range");if(e<0)throw new RangeError("Index out of range")}function k(t,r,e,n,o){return r=+r,e>>>=0,o||_(t,r,e,4,3.4028234663852886e38,-3.4028234663852886e38),V.write(t,r,e,n,23,4),e+4}function O(t,r,e,n,o){return r=+r,e>>>=0,o||_(t,r,e,8,1.7976931348623157e308,-1.7976931348623157e308),V.write(t,r,e,n,52,8),e+8}function Y(t){if(t=t.split("=")[0],t=t.trim().replace(Z,""),t.length<2)return"";for(;t.length%4!=0;)t+="=";return t}function D(t,r){r=r||1/0;for(var e,n=t.length,o=null,i=[],u=0;u<n;++u){if((e=t.charCodeAt(u))>55295&&e<57344){if(!o){if(e>56319){(r-=3)>-1&&i.push(239,191,189);continue}if(u+1===n){(r-=3)>-1&&i.push(239,191,189);continue}o=e;continue}if(e<56320){(r-=3)>-1&&i.push(239,191,189),o=e;continue}e=65536+(o-55296<<10|e-56320)}else o&&(r-=3)>-1&&i.push(239,191,189);if(o=null,e<128){if((r-=1)<0)break;i.push(e)}else if(e<2048){if((r-=2)<0)break;i.push(e>>6|192,63&e|128)}else if(e<65536){if((r-=3)<0)break;i.push(e>>12|224,e>>6&63|128,63&e|128)}else{if(!(e<1114112))throw new Error("Invalid code point");if((r-=4)<0)break;i.push(e>>18|240,e>>12&63|128,e>>6&63|128,63&e|128)}}return i}function j(t){for(var r=[],e=0;e<t.length;++e)r.push(255&t.charCodeAt(e));return r}function F(t,r){for(var e,n,o,i=[],u=0;u<t.length&&!((r-=2)<0);++u)e=t.charCodeAt(u),n=e>>8,o=e%256,i.push(o),i.push(n);return i}function z(t){return q.toByteArray(Y(t))}function H(t,r,e,n){for(var o=0;o<n&&!(o+e>=r.length||o>=t.length);++o)r[o+e]=t[o];return o}function J(t,r){return t instanceof r||null!=t&&null!=t.constructor&&null!=t.constructor.name&&t.constructor.name===r.name}function K(t){return t!==t}var q=t("base64-js"),V=t("ieee754"),Q="function"==typeof Symbol&&"function"==typeof Symbol.for?Symbol.for("nodejs.util.inspect.custom"):null;e.Buffer=o,e.SlowBuffer=p,e.INSPECT_MAX_BYTES=50;var $=2147483647;e.kMaxLength=$,o.TYPED_ARRAY_SUPPORT=function(){try{var t=new Uint8Array(1),r={foo:function(){return 42}};return Object.setPrototypeOf(r,Uint8Array.prototype),Object.setPrototypeOf(t,r),42===t.foo()}catch(t){return!1}}(),o.TYPED_ARRAY_SUPPORT||"undefined"==typeof console||"function"!=typeof console.error||console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."),Object.defineProperty(o.prototype,"parent",{enumerable:!0,get:function(){if(o.isBuffer(this))return this.buffer}}),Object.defineProperty(o.prototype,"offset",{enumerable:!0,get:function(){if(o.isBuffer(this))return this.byteOffset}}),"undefined"!=typeof Symbol&&null!=Symbol.species&&o[Symbol.species]===o&&Object.defineProperty(o,Symbol.species,{value:null,configurable:!0,enumerable:!1,writable:!1}),o.poolSize=8192,o.from=function(t,r,e){return i(t,r,e)},Object.setPrototypeOf(o.prototype,Uint8Array.prototype),Object.setPrototypeOf(o,Uint8Array),o.alloc=function(t,r,e){return a(t,r,e)},o.allocUnsafe=function(t){return f(t)},o.allocUnsafeSlow=function(t){return f(t)},o.isBuffer=function(t){return null!=t&&!0===t._isBuffer&&t!==o.prototype},o.compare=function(t,r){if(J(t,Uint8Array)&&(t=o.from(t,t.offset,t.byteLength)),J(r,Uint8Array)&&(r=o.from(r,r.offset,r.byteLength)),!o.isBuffer(t)||!o.isBuffer(r))throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');if(t===r)return 0;for(var e=t.length,n=r.length,i=0,u=Math.min(e,n);i<u;++i)if(t[i]!==r[i]){e=t[i],n=r[i];break}return e<n?-1:n<e?1:0},o.isEncoding=function(t){switch(String(t).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},o.concat=function(t,r){if(!Array.isArray(t))throw new TypeError('"list" argument must be an Array of Buffers');if(0===t.length)return o.alloc(0);var e;if(void 0===r)for(r=0,e=0;e<t.length;++e)r+=t[e].length;var n=o.allocUnsafe(r),i=0;for(e=0;e<t.length;++e){var u=t[e];if(J(u,Uint8Array)&&(u=o.from(u)),!o.isBuffer(u))throw new TypeError('"list" argument must be an Array of Buffers');u.copy(n,i),i+=u.length}return n},o.byteLength=d,o.prototype._isBuffer=!0,o.prototype.swap16=function(){var t=this.length;if(t%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var r=0;r<t;r+=2)v(this,r,r+1);return this},o.prototype.swap32=function(){var t=this.length;if(t%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var r=0;r<t;r+=4)v(this,r,r+3),v(this,r+1,r+2);return this},o.prototype.swap64=function(){var t=this.length;if(t%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var r=0;r<t;r+=8)v(this,r,r+7),v(this,r+1,r+6),v(this,r+2,r+5),v(this,r+3,r+4);return this},o.prototype.toString=function(){var t=this.length;return 0===t?"":0===arguments.length?P(this,0,t):y.apply(this,arguments)},o.prototype.toLocaleString=o.prototype.toString,o.prototype.equals=function(t){if(!o.isBuffer(t))throw new TypeError("Argument must be a Buffer");return this===t||0===o.compare(this,t)},o.prototype.inspect=function(){var t="",r=e.INSPECT_MAX_BYTES;return t=this.toString("hex",0,r).replace(/(.{2})/g,"$1 ").trim(),this.length>r&&(t+=" ... "),"<Buffer "+t+">"},Q&&(o.prototype[Q]=o.prototype.inspect),o.prototype.compare=function(t,r,e,n,i){if(J(t,Uint8Array)&&(t=o.from(t,t.offset,t.byteLength)),!o.isBuffer(t))throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type '+typeof t);if(void 0===r&&(r=0),void 0===e&&(e=t?t.length:0),void 0===n&&(n=0),void 0===i&&(i=this.length),r<0||e>t.length||n<0||i>this.length)throw new RangeError("out of range index");if(n>=i&&r>=e)return 0;if(n>=i)return-1;if(r>=e)return 1;if(r>>>=0,e>>>=0,n>>>=0,i>>>=0,this===t)return 0;for(var u=i-n,a=e-r,f=Math.min(u,a),s=this.slice(n,i),h=t.slice(r,e),c=0;c<f;++c)if(s[c]!==h[c]){u=s[c],a=h[c];break}return u<a?-1:a<u?1:0},o.prototype.includes=function(t,r,e){return-1!==this.indexOf(t,r,e)},o.prototype.indexOf=function(t,r,e){return w(this,t,r,e,!0)},o.prototype.lastIndexOf=function(t,r,e){return w(this,t,r,e,!1)},o.prototype.write=function(t,r,e,n){if(void 0===r)n="utf8",e=this.length,r=0;else if(void 0===e&&"string"==typeof r)n=r,e=this.length,r=0;else{if(!isFinite(r))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");r>>>=0,isFinite(e)?(e>>>=0,void 0===n&&(n="utf8")):(n=e,e=void 0)}var o=this.length-r;if((void 0===e||e>o)&&(e=o),t.length>0&&(e<0||r<0)||r>this.length)throw new RangeError("Attempt to write outside buffer bounds");n||(n="utf8");for(var i=!1;;)switch(n){case"hex":return b(this,t,r,e);case"utf8":case"utf-8":return E(this,t,r,e);case"ascii":return A(this,t,r,e);case"latin1":case"binary":return B(this,t,r,e);case"base64":return T(this,t,r,e);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return R(this,t,r,e);default:if(i)throw new TypeError("Unknown encoding: "+n);n=(""+n).toLowerCase(),i=!0}},o.prototype.toJSON=function(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};var X=4096;o.prototype.slice=function(t,r){var e=this.length;t=~~t,r=void 0===r?e:~~r,t<0?(t+=e)<0&&(t=0):t>e&&(t=e),r<0?(r+=e)<0&&(r=0):r>e&&(r=e),r<t&&(r=t);var n=this.subarray(t,r);return Object.setPrototypeOf(n,o.prototype),n},o.prototype.readUIntLE=function(t,r,e){t>>>=0,r>>>=0,e||L(t,r,this.length);for(var n=this[t],o=1,i=0;++i<r&&(o*=256);)n+=this[t+i]*o;return n},o.prototype.readUIntBE=function(t,r,e){t>>>=0,r>>>=0,e||L(t,r,this.length);for(var n=this[t+--r],o=1;r>0&&(o*=256);)n+=this[t+--r]*o;return n},o.prototype.readUInt8=function(t,r){return t>>>=0,r||L(t,1,this.length),this[t]},o.prototype.readUInt16LE=function(t,r){return t>>>=0,r||L(t,2,this.length),this[t]|this[t+1]<<8},o.prototype.readUInt16BE=function(t,r){return t>>>=0,r||L(t,2,this.length),this[t]<<8|this[t+1]},o.prototype.readUInt32LE=function(t,r){return t>>>=0,r||L(t,4,this.length),(this[t]|this[t+1]<<8|this[t+2]<<16)+16777216*this[t+3]},o.prototype.readUInt32BE=function(t,r){return t>>>=0,r||L(t,4,this.length),16777216*this[t]+(this[t+1]<<16|this[t+2]<<8|this[t+3])},o.prototype.readIntLE=function(t,r,e){t>>>=0,r>>>=0,e||L(t,r,this.length);for(var n=this[t],o=1,i=0;++i<r&&(o*=256);)n+=this[t+i]*o;return o*=128,n>=o&&(n-=Math.pow(2,8*r)),n},o.prototype.readIntBE=function(t,r,e){t>>>=0,r>>>=0,e||L(t,r,this.length);for(var n=r,o=1,i=this[t+--n];n>0&&(o*=256);)i+=this[t+--n]*o;return o*=128,i>=o&&(i-=Math.pow(2,8*r)),i},o.prototype.readInt8=function(t,r){return t>>>=0,r||L(t,1,this.length),128&this[t]?-1*(255-this[t]+1):this[t]},o.prototype.readInt16LE=function(t,r){t>>>=0,r||L(t,2,this.length);var e=this[t]|this[t+1]<<8;return 32768&e?4294901760|e:e},o.prototype.readInt16BE=function(t,r){t>>>=0,r||L(t,2,this.length);var e=this[t+1]|this[t]<<8;return 32768&e?4294901760|e:e},o.prototype.readInt32LE=function(t,r){return t>>>=0,r||L(t,4,this.length),this[t]|this[t+1]<<8|this[t+2]<<16|this[t+3]<<24},o.prototype.readInt32BE=function(t,r){return t>>>=0,r||L(t,4,this.length),this[t]<<24|this[t+1]<<16|this[t+2]<<8|this[t+3]},o.prototype.readFloatLE=function(t,r){return t>>>=0,r||L(t,4,this.length),V.read(this,t,!0,23,4)},o.prototype.readFloatBE=function(t,r){return t>>>=0,r||L(t,4,this.length),V.read(this,t,!1,23,4)},o.prototype.readDoubleLE=function(t,r){return t>>>=0,r||L(t,8,this.length),V.read(this,t,!0,52,8)},o.prototype.readDoubleBE=function(t,r){return t>>>=0,r||L(t,8,this.length),V.read(this,t,!1,52,8)},o.prototype.writeUIntLE=function(t,r,e,n){if(t=+t,r>>>=0,e>>>=0,!n){x(this,t,r,e,Math.pow(2,8*e)-1,0)}var o=1,i=0;for(this[r]=255&t;++i<e&&(o*=256);)this[r+i]=t/o&255;return r+e},o.prototype.writeUIntBE=function(t,r,e,n){if(t=+t,r>>>=0,e>>>=0,!n){x(this,t,r,e,Math.pow(2,8*e)-1,0)}var o=e-1,i=1;for(this[r+o]=255&t;--o>=0&&(i*=256);)this[r+o]=t/i&255;return r+e},o.prototype.writeUInt8=function(t,r,e){return t=+t,r>>>=0,e||x(this,t,r,1,255,0),this[r]=255&t,r+1},o.prototype.writeUInt16LE=function(t,r,e){return t=+t,r>>>=0,e||x(this,t,r,2,65535,0),this[r]=255&t,this[r+1]=t>>>8,r+2},o.prototype.writeUInt16BE=function(t,r,e){return t=+t,r>>>=0,e||x(this,t,r,2,65535,0),this[r]=t>>>8,this[r+1]=255&t,r+2},o.prototype.writeUInt32LE=function(t,r,e){return t=+t,r>>>=0,e||x(this,t,r,4,4294967295,0),this[r+3]=t>>>24,this[r+2]=t>>>16,this[r+1]=t>>>8,this[r]=255&t,r+4},o.prototype.writeUInt32BE=function(t,r,e){return t=+t,r>>>=0,e||x(this,t,r,4,4294967295,0),this[r]=t>>>24,this[r+1]=t>>>16,this[r+2]=t>>>8,this[r+3]=255&t,r+4},o.prototype.writeIntLE=function(t,r,e,n){if(t=+t,r>>>=0,!n){var o=Math.pow(2,8*e-1);x(this,t,r,e,o-1,-o)}var i=0,u=1,a=0;for(this[r]=255&t;++i<e&&(u*=256);)t<0&&0===a&&0!==this[r+i-1]&&(a=1),this[r+i]=(t/u>>0)-a&255;return r+e},o.prototype.writeIntBE=function(t,r,e,n){if(t=+t,r>>>=0,!n){var o=Math.pow(2,8*e-1);x(this,t,r,e,o-1,-o)}var i=e-1,u=1,a=0;for(this[r+i]=255&t;--i>=0&&(u*=256);)t<0&&0===a&&0!==this[r+i+1]&&(a=1),this[r+i]=(t/u>>0)-a&255;return r+e},o.prototype.writeInt8=function(t,r,e){return t=+t,r>>>=0,e||x(this,t,r,1,127,-128),t<0&&(t=255+t+1),this[r]=255&t,r+1},o.prototype.writeInt16LE=function(t,r,e){return t=+t,r>>>=0,e||x(this,t,r,2,32767,-32768),this[r]=255&t,this[r+1]=t>>>8,r+2},o.prototype.writeInt16BE=function(t,r,e){return t=+t,r>>>=0,e||x(this,t,r,2,32767,-32768),this[r]=t>>>8,this[r+1]=255&t,r+2},o.prototype.writeInt32LE=function(t,r,e){return t=+t,r>>>=0,e||x(this,t,r,4,2147483647,-2147483648),this[r]=255&t,this[r+1]=t>>>8,this[r+2]=t>>>16,this[r+3]=t>>>24,r+4},o.prototype.writeInt32BE=function(t,r,e){return t=+t,r>>>=0,e||x(this,t,r,4,2147483647,-2147483648),t<0&&(t=4294967295+t+1),this[r]=t>>>24,this[r+1]=t>>>16,this[r+2]=t>>>8,this[r+3]=255&t,r+4},o.prototype.writeFloatLE=function(t,r,e){return k(this,t,r,!0,e)},o.prototype.writeFloatBE=function(t,r,e){return k(this,t,r,!1,e)},o.prototype.writeDoubleLE=function(t,r,e){return O(this,t,r,!0,e)},o.prototype.writeDoubleBE=function(t,r,e){return O(this,t,r,!1,e)},o.prototype.copy=function(t,r,e,n){if(!o.isBuffer(t))throw new TypeError("argument should be a Buffer");if(e||(e=0),n||0===n||(n=this.length),r>=t.length&&(r=t.length),r||(r=0),n>0&&n<e&&(n=e),n===e)return 0;if(0===t.length||0===this.length)return 0;if(r<0)throw new RangeError("targetStart out of bounds");if(e<0||e>=this.length)throw new RangeError("Index out of range");if(n<0)throw new RangeError("sourceEnd out of bounds");n>this.length&&(n=this.length),t.length-r<n-e&&(n=t.length-r+e);var i=n-e;if(this===t&&"function"==typeof Uint8Array.prototype.copyWithin)this.copyWithin(r,e,n);else if(this===t&&e<r&&r<n)for(var u=i-1;u>=0;--u)t[u+r]=this[u+e];else Uint8Array.prototype.set.call(t,this.subarray(e,n),r);return i},o.prototype.fill=function(t,r,e,n){if("string"==typeof t){if("string"==typeof r?(n=r,r=0,e=this.length):"string"==typeof e&&(n=e,e=this.length),void 0!==n&&"string"!=typeof n)throw new TypeError("encoding must be a string");if("string"==typeof n&&!o.isEncoding(n))throw new TypeError("Unknown encoding: "+n);if(1===t.length){var i=t.charCodeAt(0);("utf8"===n&&i<128||"latin1"===n)&&(t=i)}}else"number"==typeof t?t&=255:"boolean"==typeof t&&(t=Number(t));if(r<0||this.length<r||this.length<e)throw new RangeError("Out of range index");if(e<=r)return this;r>>>=0,e=void 0===e?this.length:e>>>0,t||(t=0);var u;if("number"==typeof t)for(u=r;u<e;++u)this[u]=t;else{var a=o.isBuffer(t)?t:o.from(t,n),f=a.length;if(0===f)throw new TypeError('The value "'+t+'" is invalid for argument "value"');for(u=0;u<e-r;++u)this[u+r]=a[u%f]}return this};var Z=/[^+\/0-9A-Za-z-_]/g,W=function(){for(var t=new Array(256),r=0;r<16;++r)for(var e=16*r,n=0;n<16;++n)t[e+n]="0123456789abcdef"[r]+"0123456789abcdef"[n];return t}()},{"base64-js":29,ieee754:32}],31:[function(t,r,e){"use strict";var n={single_source_shortest_paths:function(t,r,e){var o={},i={};i[r]=0;var u=n.PriorityQueue.make();u.push(r,0);for(var a,f,s,h,c,l,g,p;!u.empty();){a=u.pop(),f=a.value,h=a.cost,c=t[f]||{};for(s in c)c.hasOwnProperty(s)&&(l=c[s],g=h+l,p=i[s],(void 0===i[s]||p>g)&&(i[s]=g,u.push(s,g),o[s]=f))}if(void 0!==e&&void 0===i[e]){var d=["Could not find a path from ",r," to ",e,"."].join("");throw new Error(d)}return o},extract_shortest_path_from_predecessor_list:function(t,r){for(var e=[],n=r;n;)e.push(n),t[n],n=t[n];return e.reverse(),e},find_path:function(t,r,e){var o=n.single_source_shortest_paths(t,r,e);return n.extract_shortest_path_from_predecessor_list(o,e)},PriorityQueue:{make:function(t){var r,e=n.PriorityQueue,o={};t=t||{};for(r in e)e.hasOwnProperty(r)&&(o[r]=e[r]);return o.queue=[],o.sorter=t.sorter||e.default_sorter,o},default_sorter:function(t,r){return t.cost-r.cost},push:function(t,r){var e={value:t,cost:r};this.queue.push(e),this.queue.sort(this.sorter)},pop:function(){return this.queue.shift()},empty:function(){return 0===this.queue.length}}};void 0!==r&&(r.exports=n)},{}],32:[function(t,r,e){e.read=function(t,r,e,n,o){var i,u,a=8*o-n-1,f=(1<<a)-1,s=f>>1,h=-7,c=e?o-1:0,l=e?-1:1,g=t[r+c];for(c+=l,i=g&(1<<-h)-1,g>>=-h,h+=a;h>0;i=256*i+t[r+c],c+=l,h-=8);for(u=i&(1<<-h)-1,i>>=-h,h+=n;h>0;u=256*u+t[r+c],c+=l,h-=8);if(0===i)i=1-s;else{if(i===f)return u?NaN:1/0*(g?-1:1);u+=Math.pow(2,n),i-=s}return(g?-1:1)*u*Math.pow(2,i-n)},e.write=function(t,r,e,n,o,i){var u,a,f,s=8*i-o-1,h=(1<<s)-1,c=h>>1,l=23===o?Math.pow(2,-24)-Math.pow(2,-77):0,g=n?0:i-1,p=n?1:-1,d=r<0||0===r&&1/r<0?1:0;for(r=Math.abs(r),isNaN(r)||r===1/0?(a=isNaN(r)?1:0,u=h):(u=Math.floor(Math.log(r)/Math.LN2),r*(f=Math.pow(2,-u))<1&&(u--,f*=2),r+=u+c>=1?l/f:l*Math.pow(2,1-c),r*f>=2&&(u++,f/=2),u+c>=h?(a=0,u=h):u+c>=1?(a=(r*f-1)*Math.pow(2,o),u+=c):(a=r*Math.pow(2,c-1)*Math.pow(2,o),u=0));o>=8;t[e+g]=255&a,g+=p,a/=256,o-=8);for(u=u<<o|a,s+=o;s>0;t[e+g]=255&u,g+=p,u/=256,s-=8);t[e+g-p]|=128*d}},{}],33:[function(t,r,e){var n={}.toString;r.exports=Array.isArray||function(t){return"[object Array]"==n.call(t)}},{}]},{},[24])(24)});
//# sourceMappingURL=qrcode.min.js.map

'use strict';

/**
 * @ngdoc overview
 * @name gatehubClientApp
 * @description
 * # gatehubClientApp
 *
 * Main module of the application.
 */
angular
	.module('gatehubClientApp', [
		'angular-iscroll',
		'ngAnimate',
		'ngCookies',
		'ngResource',
		'ngRoute',
		'ngSanitize',
		'ngTouch',
		'highcharts-ng',
		'ui.bootstrap',
		'ui.router',
		'restangular',
		'ngFileUpload',
		'ngStorage',
		'config',
		'angularMoment',
		'oauth',
		'ngIdle',
		'ngMessages',
		'monospaced.qrcode',
		'ui.validate',
		'mm.iban',
		'infinite-scroll',
		'ui.sortable',
		'ngclipboard',
		'betsol.intlTelInput',
		'moment-picker',
		'ngCsv',
		'ngWebSocket',
		'daterangepicker',
		'zxcvbn'
	])
	.config(["$stateProvider", "$urlRouterProvider", "ENV", function ($stateProvider, $urlRouterProvider, ENV) {
		$urlRouterProvider.otherwise('/wallets');

		// Default redirects
		$urlRouterProvider.when('/identity/form', '/identity/form/photo');
		$urlRouterProvider.when('/walets/:id', '/walets/:id/balance');
		$urlRouterProvider.when('/settings', '/settings/identity');
		$urlRouterProvider.when('/tools', '/tools/export');
		$urlRouterProvider.when('/security', '/security/overview');
		$urlRouterProvider.when('/help', '/help/faq');
		$urlRouterProvider.when('/exchange', '/exchange/currencies');
		$urlRouterProvider.when('/analytics', '/analytics/wallets');

		// Now set up the states
		$stateProvider

			.state('auth', {
				url: '/authentication',
				views: {
					'navtop': {
						template: '',
						controller: 'AuthCtrl'
					}
				}

			})
			.state('access_token', {
				url: '/token?access_token&refresh_token&token_type&error&error_description&expired_in&state',
				template: '',
				controllerProvider: ["$stateParams", "$location", "Auth", "$sessionStorage", function ($stateParams, $location, Auth, $sessionStorage) {
					Auth.setToken($stateParams, $location);

					var path = ($sessionStorage.previousState && $sessionStorage.previousState !== "/token") ? $sessionStorage.previousState : "/wallets";
					$location.url(path);
				}]
			})

			// Identity
			.state('identity', {
				url: '/identity',
				views: {
					'content': {
						templateUrl: 'views/identity/welcome.html',
						controller: 'IdentityProfileCtrl'
					},
				},
			})
			.state('identity.form', {
				url: '/form',
				views: {
					'content@': {
						templateUrl: 'views/identity/form.html',
						controller: ["$state", "$scope", function ($state, $scope) {
							$scope.state = $state.current.name;
						}]
					},
				},
			})
			.state('identity.form.phone', {
				url: '/phone',
				templateUrl: 'views/identity/form_phone.html',
				controller: 'IdentityPhoneCtrl',
			})
			.state('identity.form.profile', {
				url: '/profile',
				templateUrl: 'views/identity/form_profile.html',
				controller: 'IdentityProfileCtrl',
			})
			.state('identity.form.documents', {
				url: '/documents',
				templateUrl: 'views/identity/form_documents.html',
				controller: 'IdentityDocumentsCtrl'
			})

			// Wallets
			.state('wallets', {
				url: '/wallets',
				views: {
					'content': {
						templateUrl: 'views/wallets/wallet.html',
						controller: 'WalletCtrl',
					},
				},
			})
			.state('wallets.item', {
				url: '/:id',
				views: {
					'content@': {
						templateUrl: 'views/wallets/wallet.html',
						controller: 'WalletCtrl',
					},
				},
			})
			.state('wallets.item.advanced', {
				url: '/advanced',
				templateUrl: 'views/wallets/wallet_advanced.html',
				controller: 'WalletAdvancedCtrl',
				controllerAs: 'vm'
			})
			.state('wallets.item.balance.sgbclaim', {
				url: '/sgbclaim',
				onEnter: ['$state', '$uibModal', function ($state, $uibModal) {
					$uibModal.open({
						templateUrl: 'views/settings/modal_songbird.html',
						controller: 'SongbirdCtrl',
						controllerAs: 'vm'
					})
						.result.then(function (params) {
							if (params === 'setTrust') {
								// do NOT redirect, we're opening trust modal
							} else if (params === 'goToDepositSGB') {
								$state.go('wallets.item.deposit.songbird');
							} else {
								$state.go('wallets.item.balance');
							}
						}, function () {
							$state.go('wallets.item.balance');
						});
				}]
			})
			.state('wallets.item.protect', {
				url: '/advanced/protect',
				templateUrl: 'views/wallets/wallet_protect.html',
				controller: 'WalletProtectCtrl',
				controllerAs: 'vm'
			})
			.state('wallets.item.balance', {
				url: '/balance',
				templateUrl: 'views/wallets/wallet_balance.html',
			})
			.state('wallets.item.history', {
				url: '/history',
				templateUrl: 'views/wallets/wallet_history.html',
			})
			.state('wallets.item.lines', {
				url: '/lines',
				templateUrl: 'views/wallets/wallet_lines.html',
			})
			.state('wallets.item.history.tx', {
				url: '/tx/:xid',
				onEnter: ['$state', '$uibModal', function ($state, $uibModal) {
					$uibModal.open({
						templateUrl: 'views/wallets/modal_tx.html',
						controller: 'WalletTxCtrl'
					})
						.result.finally(function () {
							$state.go('wallets.item.history');
						});
				}],
				onExit: ['$uibModalStack', function ($uibModalStack) {
					$uibModalStack.dismissAll();
				}],
				params: {
					hostedExchange: false
				}
			})
			.state('wallets.item.orders', {
				url: '/orders',
				templateUrl: 'views/wallets/wallet_orders.html',
			})
			.state('wallets.item.send', {
				url: '/send',
				onEnter: ['$state', '$uibModal', function ($state, $uibModal) {
					$uibModal.open({
						backdrop: 'static',
						templateUrl: 'views/wallets/modal_send.html',
						controller: 'ModalCtrl',
					})
						.result.finally(function () {
							$state.go('wallets.item.balance');
						});
				}],
				onExit: ['$uibModalStack', function ($uibModalStack) {
					$uibModalStack.dismissAll();
				}],
				views: {
					'modal@': {
						templateUrl: 'views/wallets/modal_send_currency_picker.html',
						controller: 'CurrencyPickerCtrl',
						controllerAs: 'vm'
					}
				}
			})
			.state('wallets.item.send.ripple', {
				url: '/ripple?to&amount&dt',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/form_send_ripple.html',
						controller: 'SendRippleCtrl',
					},
				},
			})
			.state('wallets.item.send.sepa', {
				url: '/sepa',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/form_send_ripple.html',
						controller: 'SendRippleCtrl',
					},
				},
			})
			.state('wallets.item.send.interledger', {
				url: '/interledger',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/form_send_interledger.html',
						controller: 'SendInterledgerCtrl',
					},
				},
			})
			.state('wallets.item.send.wire', {
				url: '/wire',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/form_send_ripple.html',
						controller: 'SendRippleCtrl',
					},
				},
			})
			.state('wallets.item.send.wire_gbp', {
				url: '/wire_gbp',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/form_send_ripple.html',
						controller: 'SendRippleCtrl',
					},
				},
			})
			.state('wallets.item.send.gbp', {
				url: '/gbp',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/form_send_ripple.html',
						controller: 'SendRippleCtrl',
					},
				},
			})
			.state('wallets.item.send.bitcoin', {
				url: '/bitcoin',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/form_send_ripple.html',
						controller: 'SendRippleCtrl',
					},
				},
			})
			.state('wallets.item.send.bitcoincash', {
				url: '/bitcoincash',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/form_send_ripple.html',
						controller: 'SendRippleCtrl',
					},
				},
			})
			.state('wallets.item.send.dash', {
				url: '/dash',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/form_send_ripple.html',
						controller: 'SendRippleCtrl',
					},
				},
			})
			.state('wallets.item.send.rep', {
				url: '/rep',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/form_send_ripple.html',
						controller: 'SendRippleCtrl',
					},
				},
			})
			.state('wallets.item.send.ethereum', {
				url: '/ethereum',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/form_send_ripple.html',
						controller: 'SendRippleCtrl',
					},
				},
			})
			.state('wallets.item.send.ethereum_classic', {
				url: '/ethereum_classic',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/form_send_ripple.html',
						controller: 'SendRippleCtrl',
					},
				},
			})
			.state('wallets.item.send.gold', {
				url: '/gold',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/form_send_ripple.html',
						controller: 'SendRippleCtrl',
					},
				},
			})
			.state('wallets.item.send.litecoin', {
				url: '/litecoin',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/form_send_ripple.html',
						controller: 'SendRippleCtrl',
					},
				},
				data: {
					enabledForUser: { flag: 'ltc', redirectTo: 'wallets.item.send' }
				}
			})
			.state('wallets.item.send.flare', {
				url: '/flare',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/form_send_ripple.html',
						controller: 'SendRippleCtrl',
					},
				},
				data: {
					enabledForUser: { flag: 'FlareWithdrawal', redirectTo: 'wallets.item.send' }
				}
			})
			.state('wallets.item.send.songbird', {
				url: '/songbird',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/form_send_ripple.html',
						controller: 'SendRippleCtrl',
					},
				}
			})
			.state('wallets.item.send.usdt', {
				url: '/usdt',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/form_send_ripple.html',
						controller: 'SendRippleCtrl',
					},
				}
			})
			.state('wallets.item.send.usdc', {
				url: '/usdc',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/form_send_ripple.html',
						controller: 'SendRippleCtrl',
					},
				}
			})
			.state('wallets.item.send.wxrp', {
				url: '/wxrp',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/form_send_ripple.html',
						controller: 'SendRippleCtrl',
					},
				}
			})
			.state('wallets.item.send.gala', {
				url: '/gala',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/form_send_ripple.html',
						controller: 'SendRippleCtrl',
					},
				}
			})
			.state('wallets.item.add', {
				url: '/add',
				onEnter: ['$state', '$uibModal', function ($state, $uibModal) {
					$uibModal.open({
						backdrop: 'static',
						templateUrl: 'views/wallets/modal_add.html',
						controller: 'ModalCtrl',
					})
						.result.then(function (wallet) {
							$state.go('wallets.item.balance', { id: wallet[0].address });
						}, function () {
							$state.go('wallets.item.balance');
						});
				}],
				onExit: ['$uibModalStack', function ($uibModalStack) {
					$uibModalStack.dismissAll();
				}],
				views: {
					'modal@': {
						templateUrl: 'views/wallets/add_wallet_type_picker.html',
						controller: 'CurrencyPickerCtrl',
						controllerAs: 'vm'
					}
				}
			})
			.state('wallets.item.add.hosted', {
				url: '/hosted',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/form_add_new.html',
						controller: 'WalletAddCtrl'
					},
				}
			})
			.state('wallets.item.add.xrp', {
				url: '/xrp',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/form_add_new.html',
						controller: 'WalletAddCtrl'
					},
				}
			})
			.state('wallets.item.add.import', {
				url: '/import',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/form_add_import.html',
						controller: 'WalletImportCtrl',
					},
				},
			})
			.state('wallets.item.add.bank', {
				url: '/bank',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/form_add_bank.html',
						controller: 'WalletBankCtrl'
					},
				},
				data: {
					enabledForUser: { flag: 'psd-processor', redirectTo: 'wallets.item.add' }
				}
			})
			.state('wallets.item.add.ripple', {
				url: '/ripple',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/form_add_ripple.html',
					},
				},
			})
			.state('wallets.item.delete', {
				url: '/delete',
				onEnter: ['$state', '$uibModal', function ($state, $uibModal) {
					$uibModal.open({
						templateUrl: 'views/wallets/modal_delete_wallet.html',
						controller: 'WalletDeleteCtrl'
					})
						.result.finally(function () {
							$state.go('wallets');
						});
				}],
				onExit: ['$uibModalStack', function ($uibModalStack) {
					$uibModalStack.dismissAll();
				}]
			})
			.state('wallets.item.primary', {
				url: '/primary',
				onEnter: ['$state', '$uibModal', function ($state, $uibModal) {
					$uibModal.open({
						templateUrl: 'views/wallets/modal_set_primary_wallet.html',
						controller: 'WalletSetPrimaryCtrl',
						controllerAs: 'vm'
					})
						.result.finally(function () {
							$state.go('wallets.item.advanced', {}, { reload: true });
						});
				}],
				onExit: ['$uibModalStack', function ($uibModalStack) {
					$uibModalStack.dismissAll();
				}]
			})
			.state('wallets.item.edit', {
				url: '/edit',
				onEnter: ['$state', '$uibModal', function ($state, $uibModal) {
					$uibModal.open({
						templateUrl: 'views/wallets/modal_edit_wallet.html',
						controller: 'WalletEditCtrl'
					})
						.result.finally(function () {
							$state.go('wallets.item.advanced', {}, { reload: true });
						});
				}],
				onExit: ['$uibModalStack', function ($uibModalStack) {
					$uibModalStack.dismissAll();
				}]
			})
			.state('wallets.item.trust', {
				url: '/trust/:issuer/:currency/:option/:redirect',
				onEnter: ['$state', '$uibModal', function ($state, $uibModal) {
					$uibModal.open({
						templateUrl: 'views/wallets/modal_set_trust.html',
						controller: 'WalletSetTrustCtrl'
					})
						.result.then(function (URL) {
							if (URL) {
								$state.go(URL, {}, { reload: true });
							}
							else {
								$state.go('wallets.item.lines', {}, { reload: true });
							}
						}, function () {
							$state.go('wallets.item.lines', {}, { reload: true });
						});
				}],
				onExit: ['$uibModalStack', function ($uibModalStack) {
					$uibModalStack.dismissAll();
				}]
			})
			.state('wallets.item.deposit', {
				url: '/deposit',
				onEnter: ['$state', '$uibModal', function ($state, $uibModal) {
					$uibModal.open({
						templateUrl: 'views/wallets/modal_deposit.html',
						controller: 'ModalCtrl',
					})
						.result.then(function (params) {
							if (params) {
								$state.go('wallets.item.trust', params, { reload: true });
							}
							else {
								$state.go('wallets.item.balance');
							}
						}, function () {
							$state.go('wallets.item.balance');
						});
				}],
				onExit: ['$uibModalStack', function ($uibModalStack) {
					$uibModalStack.dismissAll();
				}],
				views: {
					'modal@': {
						templateUrl: 'views/wallets/modal_deposit_currency_picker.html',
						controller: 'CurrencyPickerCtrl',
						controllerAs: 'vm'
					}
				}
			})
			.state('wallets.item.deposit.ripple', {
				url: '/ripple',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/modal_deposit_ripple.html',
						controller: 'WalletDepositRippleCtrl',
					},
				},
			})
			.state('wallets.item.deposit.gateway', {
				url: '/gateway',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/modal_deposit_gateway.html',
						controller: 'WalletDepositGatewayCtrl',
					},
				},
			})
			.state('wallets.item.deposit.bitcoin', {
				url: '/bitcoin',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/modal_deposit_gateway.html',
						controller: 'WalletDepositGatewayCtrl',
					},
				},
			})
			.state('wallets.item.deposit.bitcoincash', {
				url: '/bitcoincash',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/modal_deposit_gateway.html',
						controller: 'WalletDepositGatewayCtrl',
					},
				},
			})
			.state('wallets.item.deposit.dash', {
				url: '/dash',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/modal_deposit_gateway.html',
						controller: 'WalletDepositGatewayCtrl',
					},
				},
			})
			.state('wallets.item.deposit.sepa', {
				url: '/sepa',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/modal_deposit_gateway.html',
						controller: 'WalletDepositGatewayCtrl',
					},
				},
			})
			.state('wallets.item.deposit.wire', {
				url: '/wire',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/modal_deposit_gateway.html',
						controller: 'WalletDepositGatewayCtrl',
					},
				},
			})
			.state('wallets.item.deposit.gbp', {
				url: '/gbp',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/modal_deposit_gateway.html',
						controller: 'WalletDepositGatewayCtrl',
					},
				},
			})
			.state('wallets.item.deposit.rep', {
				url: '/rep',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/modal_deposit_gateway.html',
						controller: 'WalletDepositGatewayCtrl',
					},
				},
			})
			.state('wallets.item.deposit.ethereum', {
				url: '/ethereum',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/modal_deposit_gateway.html',
						controller: 'WalletDepositGatewayCtrl',
					},
				},
			})
			.state('wallets.item.deposit.ethereum_classic', {
				url: '/ethereum_classic',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/modal_deposit_gateway.html',
						controller: 'WalletDepositGatewayCtrl',
					},
				},
			})
			.state('wallets.item.deposit.interledger', {
				url: '/interledger',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/modal_deposit_gateway.html',
						controller: 'WalletDepositGatewayCtrl',
					},
				},
			})
			.state('wallets.item.deposit.paystring', {
				url: '/paystring',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/modal_deposit_paystring.html',
						controller: 'WalletDepositPayStringCtrl',
						controllerAs: 'vm'
					},
				},
			})
			.state('wallets.item.deposit.flare', {
				url: '/flare',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/modal_deposit_gateway.html',
						controller: 'WalletDepositGatewayCtrl',
						controllerAs: 'vm'
					},
				}
			})
			.state('wallets.item.deposit.litecoin', {
				url: '/litecoin',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/modal_deposit_gateway.html',
						controller: 'WalletDepositGatewayCtrl',
						controllerAs: 'vm'
					},
				},
				data: {
					enabledForUser: { flag: 'ltc', redirectTo: 'wallets.item.deposit' }
				}
			})
			.state('wallets.item.deposit.songbird', {
				url: '/songbird',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/modal_deposit_gateway.html',
						controller: 'WalletDepositGatewayCtrl',
						controllerAs: 'vm'
					},
				}
			})
			.state('wallets.item.deposit.usdt', {
				url: '/usdt',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/modal_deposit_gateway.html',
						controller: 'WalletDepositGatewayCtrl',
						controllerAs: 'vm'
					},
				}
			})
			.state('wallets.item.deposit.usdc', {
				url: '/usdc',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/modal_deposit_gateway.html',
						controller: 'WalletDepositGatewayCtrl',
						controllerAs: 'vm'
					},
				}
			})
			.state('wallets.item.deposit.wxrp', {
				url: '/wxrp',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/modal_deposit_gateway.html',
						controller: 'WalletDepositGatewayCtrl',
						controllerAs: 'vm'
					},
				}
			})
			.state('wallets.item.deposit.gala', {
				url: '/gala',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/modal_deposit_gateway.html',
						controller: 'WalletDepositGatewayCtrl',
						controllerAs: 'vm'
					},
				}
			})
			.state('wallets.item.deposit.card', {
				url: '/card',
				views: {
					'modal@': {
						templateUrl: 'views/wallets/modal_deposit_gateway.html',
						controller: 'WalletDepositGatewayCtrl',
					},
				},
			})

			// Trade
			.state('trade', {
				url: '/trade/:base/:counter/:type',
				views: {
					'content': {
						templateUrl: 'views/trade/trade.html',
						controller: 'TradeCtrl',
					},
				},
			})

			// Exchange
			.state('exchange', {
				url: '/exchange',
				views: {
					'navtop': {
						templateUrl: 'views/exchange/exchange_nav_top.html',
						controller: 'WalletSelectorCtrl',
						controllerAs: 'vm'
					}
				},
			})
			.state('exchange.currencies', {
				url: '/currencies',
				views: {
					'content@': {
						templateUrl: 'views/exchange/exchange.html',
						controller: 'ExchangeCtrl',
					}
				},
			})

			.state('exchange.rates', {
				url: '/rates',
				views: {
					'content@': {
						templateUrl: 'views/exchange/rates.html',
						controller: 'RatesCtrl',
						controllerAs: 'vm'
					},
				}
			})

			// Analytics
			.state('analytics', {
				url: '/analytics',
				views: {
					'navtop': {
						templateUrl: 'views/partials/navAnalytics.html',
					}
				},
			})
			.state('analytics.assets', {
				url: '/assets',
				views: {
					'content@': {
						templateUrl: 'views/analytics/assets.html',
						controller: 'AnalyticsCtrl',
						controllerAs: 'vm'
					}
				}
			})
			.state('analytics.cashflow', {
				url: '/cashflow',
				views: {
					'content@': {
						templateUrl: 'views/analytics/cash-flow.html',
						controller: 'CashflowCtrl',
						controllerAs: 'vm'
					}
				}
			})
			.state('analytics.wallets', {
				url: '/wallets',
				views: {
					'content@': {
						templateUrl: 'views/analytics/wallets.html',
						controller: 'AnalyticsCtrl',
						controllerAs: 'vm'
					},
				}
			})
			.state('analytics.transactions', {
				url: '/transactions',
				views: {
					'content@': {
						templateUrl: 'views/wallets/wallet_history.html',
						controller: 'AnalyticsTransactionsCtrl',
						controllerAs: 'vm'
					}
				}
			})

			// Help
			.state('help', {
				url: '/help',
				views: {
					'navtop': {
						templateUrl: 'views/partials/navHelp.html',
					},
				},
			})
			.state('help.faq', {
				url: '/faq',
				views: {
					'content@': {
						templateUrl: 'views/help/faq.html',
						controller: 'FaqCtrl',
						controllerAs: 'vm'
					},
				}
			})
			.state('help.supportcenter', {
				url: '/support-center',
				views: {
					'content@': {
						templateUrl: 'views/help/support-center.html',
					},
				}
			})
			.state('help.about', {
				url: '/about',
				views: {
					'content@': {
						templateUrl: 'views/help/about.html',
					},
				}
			})

			// Settings
			.state('settings', {
				url: '/settings',
				views: {
					'navtop': {
						templateUrl: 'views/settings/nav_top.html'
					},
					'content': {
						templateUrl: 'views/settings/settings.html'
					}
				},
			})
			.state('settings.notifications', {
				url: '/notifications?gdpr',
				templateUrl: 'views/settings/settings_notifications.html',
				controller: 'PrivacyCtrl',
				controllerAs: 'vm'
			})
			.state('settings.identity', {
				url: '/identity',
				templateUrl: 'views/settings/settings_identity.html',
				controller: 'IdentityOverviewCtrl',
				controllerAs: "vm"
			})
			.state('settings.gateways', {
				url: '/gateways',
				templateUrl: 'views/settings/settings_gateways.html',
				controller: 'GatewaysCtrl',
				controllerAs: 'vm'
			})
            .state('settings.api', {
				url: '/api',
				templateUrl: 'views/settings/settings_api_keys.html',
				controller: 'ApiKeyCtrl',
				controllerAs: 'vm',
                data: {
					enabledForUser: { flag: 'apikeys', redirectTo: 'wallets' }
				}
			})
			.state('settings.applications', {
				url: '/applications',
				templateUrl: 'views/settings/settings_applications.html',
				controller: 'ApplicationsCtrl',
				controllerAs: 'vm'
			})

			// Contacts
			.state('contacts', {
				url: '/contacts',
				views: {
					'navtop': {
						templateUrl: 'views/settings/nav_top.html'
					},
					'content': {
						templateUrl: 'views/settings/contacts.html',
						controller: 'AccountsCtrl',
						controllerAs: 'vm'
					}
				}
			})
			.state('contacts.add', {
				url: '/add',
				onEnter: ['$state', '$uibModal', function ($state, $uibModal) {
					$uibModal.open({
						templateUrl: 'views/settings/modal_add.html',
						controller: 'ModalCtrl',
					})
						.result.finally(function () {
							console.log('Exit');
							$state.go('contacts', {}, { reload: true });
						});
				}],
				views: {
					'modal@': {
						templateUrl: 'views/settings/modal_add_contact_currency_picker.html',
						controller: 'CurrencyPickerCtrl',
						controllerAs: 'vm'
					}
				},
				onExit: ['$uibModalStack', function ($uibModalStack) {
					$uibModalStack.dismissAll();
				}]
			})
			.state('contacts.contact', {
				url: '/:id',
				onEnter: ['$state', '$uibModal', function ($state, $uibModal) {
					$uibModal.open({
						templateUrl: 'views/settings/contact_modal.html',
						controller: 'AccountCtrl'
					})
						.result.finally(function () {
							$state.go('contacts');
						});
				}],
				onExit: ['$uibModalStack', function ($uibModalStack) {
					$uibModalStack.dismissAll();
				}]
			})
			.state('contacts.add.network', {
				url: '/:network',
				views: {
					'modal@': {
						templateUrl: 'views/settings/form_add_contact.html',
						controller: 'AccountAddCtrl',
					},
				},
			})

			// Security
			.state('security', {
				url: '/security',
				views: {
					'navtop': {
						templateUrl: 'views/settings/nav_top.html'
					},
					'content': {
						templateUrl: 'views/settings/security.html',
					}
				}
			})
			.state('security.overview', {
				url: '/overview',
				templateUrl: 'views/settings/settings_security_overview.html',
				controller: "SecurityOverviewCtrl",
				controllerAs: "vm"
			})
			.state('security.password', {
				url: '/password',
				templateUrl: 'views/settings/security_password.html',
				controller: "ChangePasswordCtrl",
				controllerAs: "vm"
			})
			.state('security.twostep', {
				url: '/twostep',
				templateUrl: 'views/settings/security_twostep.html',
				controller: 'Security2fa',
			})
			.state('security.history', {
				url: '/history',
				templateUrl: 'views/settings/security_history.html',
				controller: 'HistoryCtrl',
			})
			.state('security.events', {
				url: '/events',
				templateUrl: 'views/settings/security_events.html',
				controller: 'EventCtrl',
			})
			.state('security.devices', {
				url: '/devices',
				templateUrl: 'views/settings/security_devices.html',
				controller: 'DevicesCtrl',
			})
			.state('security.devices.remove', {
				url: '/remove/:id',
				onEnter: ['$state', '$uibModal', function ($state, $uibModal) {
					$uibModal.open({
						templateUrl: 'views/settings/modal_remove_device.html',
						controller: 'DeviceRemoveCtrl'
					})
						.result.finally(function () {
							$state.go('security.devices', {}, { reload: true });
						});
				}],
				onExit: ['$uibModalStack', function ($uibModalStack) {
					$uibModalStack.dismissAll();
				}]
			})
			.state('security.apps', {
				url: '/apps',
				templateUrl: 'views/settings/security_apps.html',
			})
			.state('security.rekey', {
				url: '/rekey',
				templateUrl: 'views/settings/security_rekey.html',
				controller: 'RekeyCtrl',
			})
			.state('security.rekeyfix', {
				url: '/rekeyfix',
				templateUrl: 'views/settings/security_rekey_fix.html',
				controller: 'RekeyFixCtrl',
				controllerAs: 'vm'
			})
			.state('security.antiphishing', {
				url: '/antiphishing',
				templateUrl: 'views/settings/security_antiphishing.html',
				controller: 'AntiPhishingCtrl',
				controllerAs: 'vm'
			})

			.state('tools', {
				url: '/tools',
				views: {
					'navtop': {
						templateUrl: 'views/settings/nav_top.html'
					},
					'content': {
						templateUrl: 'views/settings/settings_wallets.html'
					}
				}
			})
			// Exports
			.state('tools.export', {
				url: '/export',
				templateUrl: 'views/settings/settings_wallets_export.html',
				controller: 'WalletSettingsCtrl',
				controllerAs: 'vm'
			});

		if (ENV.name !== 'production') {
			console.log('enable development controller');
			$stateProvider.state('dev', {
				url: '/dev',
				views: {
					'content': {
						templateUrl: 'views/_dev/elements.html',
						controller: 'DevCtrl',
						controllerAs: 'vm'
					}
				}
			});
		}
	}])
	// implement restangular caching (for GET requests only) and add credentials
	.run(["Restangular", "$cacheFactory", function (Restangular, $cacheFactory) {
		var http_ttl_cache = {};
		var cache = $cacheFactory('http');
		Restangular.setDefaultHttpFields({ cache: cache, withCredentials: true });

		Restangular.setResponseInterceptor(function (response, operation) {
			if (http_ttl_cache[response.url] == undefined || Date.now() - http_ttl_cache[response.url] > 2000 || operation === 'put' || operation === 'post' || operation === 'remove') {
				cache.removeAll();
				http_ttl_cache[response.url] = Date.now();
			}

			return response;
		})
	}])
	.run(["$rootScope", "$state", "$localStorage", "ENV", function ($rootScope, $state, $localStorage, ENV) {

		console.log('GateHub Wallet starting');

		// Set Version
		$rootScope.version = ENV.version;

		$rootScope.sidebarOpened = false;
		$rootScope.toggleSidebar = function () {
			$rootScope.sidebarOpened = !$rootScope.sidebarOpened;
		}
		$rootScope.isTogglerDark = function () {
			if ($rootScope.sidebarOpened) {
				return false;
			}
			var element = document.querySelector('.rc-navbar-static-top');
			if (!element) {
				return false;
			}

			return !element.attributes.class.value.includes('bg-primary');
		}

		// Scroll to top and Stop loader
		$rootScope.$on('$stateChangeSuccess', function () {
			// Exclude some routes
			if ($state.current.name !== 'wallets.item.history.tx' && $state.current.name !== 'wallets.item.history') {
				document.body.scrollTop = document.documentElement.scrollTop = 0;
			}
		});

		// Initial setup
		if (typeof $localStorage.activeMetricCode === 'undefined') {
			$localStorage.activeMetricCode = 'XRP';
		}
		if (typeof $localStorage.exchangeRates === 'undefined') {
			$localStorage.exchangeRates = { XRP: 1 };
		}
		if (typeof $localStorage.hideLines === 'undefined') {
			$localStorage.hideLines = [];
		}

		// Logout button
		$rootScope.ENV = ENV;

		// Stop spam of asmCrypto
		asmCrypto.random.skipSystemRNGWarning = true;

		// Helper for detecting empty object enumerations
		$rootScope.isEmpty = function (obj) {
			return angular.equals({}, obj);
		};

	}])
	.config(["RestangularProvider", "ENV", function (RestangularProvider, ENV) {
		RestangularProvider.setBaseUrl(ENV.apiAuth);
	}])
	.config(["iScrollServiceProvider", function (iScrollServiceProvider) {
		// Supply a default configuration object for iScroll
		iScrollServiceProvider.configureDefaults({
			iScroll: {
				// Passed through to the iScroll library
				scrollbars: true,
				fadeScrollbars: true,
				interactiveScrollbars: true,
				mouseWheel: true,
				momentum: true,
				disablePointer: false,
				disableTouch: false,
				disableMouse: true
			},
			directive: {
				// Interpreted by the directive
				refreshInterval: 1000
			}
		});
	}])
	.directive('autofocus', ['$timeout',
		function ($timeout) {
			return {
				restrict: 'A',
				link: function ($scope, $element) {
					$timeout(function () {
						$element[0].focus();
					});
				}
			};
		}
	])
	.directive('scroll', ["$window", function ($window) {
		return function (scope, element, attrs) {
			angular.element($window).bind('scroll', function () {

				// On Top
				if (this.pageYOffset >= 10) {
					scope.boolChangeTop = true;
				} else {
					scope.boolChangeTop = false;
				}

				// Hidden
				if (!scope.scrollPosition) {
					scope.scrollPosition = 0;
				}
				if ((this.pageYOffset > scope.scrollPosition) && this.pageYOffset >= 50) {
					scope.boolChangeHidden = true;
				} else {
					scope.boolChangeHidden = false;
				}
				scope.scrollPosition = this.pageYOffset;

				scope.$apply();

			});
		};
	}])
	.run(['$rootScope', '$location', '$window', function ($rootScope, $location, $window) {
		// GTM (Google Tag Manager)
		var dataLayer = $window.dataLayer || [];
		$rootScope.$on('$stateChangeSuccess',
			function (event) {
				dataLayer.push({
					event: 'ngRouteChange',
					attributes: {
						route: $location.path()
					}
				});
			});
	}])
	.run(['$rootScope', '$location', function ($rootScope, $location) {

		// Zendesk Widget - show only on help pages!
		$rootScope.$on('$locationChangeSuccess', function (event, next, current) {

			var isCurrentHelpPage = current.match("\/help");
			var isNextHelpPage = next.match("\/help");
			var firstLoadedIsHelpPage = current == next && isCurrentHelpPage;

			if (!window.zE) {
				return;
			}

			if (!isCurrentHelpPage && isNextHelpPage || firstLoadedIsHelpPage) {
				zE('webWidget', 'show');
			} else if (isCurrentHelpPage && !isNextHelpPage) {
				zE('webWidget', 'hide');
			}

		});

	}])
	.run(['iScrollService', function (iScrollService) {
		// disable number scrolling on inputs of type 'number'
		$(document).on("wheel", "input[type=number]", function (e) {
			$(this).trigger('blur');
		});

		iScrollService.enable();
	}])
	// remove console logs on production
	.run(['Auth', 'ENV', function (Auth, ENV) {
		if (ENV.name === 'production') {
			Auth.getProfile().then(function (data) {
				if (data.email && data.email.indexOf('@gatehub.net') !== -1 ||
					location.hostname === "localhost" || location.hostname === "127.0.0.1") {
					// don't hide console logs on localhost production and for gatehub users
				} else {
					window.console.log = function () { };
				}
			});
		}

	}])
	// initialize data from backend
	.run(['Auth', 'Countries', function (Auth, Countries) {
		Auth.getProfile().then(function () {
			Countries.init();
		});
	}])
	.run(['Auth', '$rootScope', '$state', 'Documents', 'Countries', function (Auth, $rootScope, $state, Documents, Countries) {

		function walletRekeyRequired(data) {
			var wallets = angular.copy(data.core.wallets);

			// Remove non-ripple wallets
			_.remove(wallets, function (wallet) {
				return wallet.type !== 10 && wallet.type !== 11;
			});

			for (var i = wallets.length - 1; i >= 0; i--) {
				if (wallets[i].migration_status == 1 || wallets[i].migration_status == 2 || wallets[i].migration_status == 3) {
					// Bypass if auth migration status is not completed
					if (data.migration_status === 'completed') {
						return true;
					}
				}
			}
			return false;
		}

		$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
			//console.log('GOING FROM...', fromState.name, '-->', toState.name);
			Auth.getProfile().then(function (authUser) {
				let verificationLevel = authUser.identity.verification_level;
				let identity = authUser.identity.plain();
				if (verificationLevel === 0) { // no phone yet or phone not verified
					if (toState.name !== 'identity' && toState.name !== 'identity.form.phone') {
						event.preventDefault();
						if (authUser.identity.phone_number || identity.user_type === 1) {
							$state.go('identity.form.phone'); // phone exists, but not yet verified OR is company profile
							return;
						} else {
							$state.go("identity"); // no phone yet, not verified: go to individual/company selection
							return;
						}
					}
				} else if (verificationLevel > 0) { // phone already verified, check profile and documents.
					let profileCompleted = true; // is profile completed?
					let LEGACY_USER = (identity.labels && identity.labels.indexOf("KYC_LEGACY") > -1) ? true : false;
					if (!LEGACY_USER) {
						if (identity.user_type !== 1) { // individual profile
							if (!identity.profile.first_name) {
								profileCompleted = false;
								if (toState.name !== 'identity.form.profile' && toState.name !== 'identity.form.documents') {
									event.preventDefault();
									$state.go("identity.form.profile");
									return;
								}
							} else if (!Documents.hasEidVerification(identity.verifications) && !Documents.requiredDocumentsUploaded(identity.documents)) {
								// if is NOT an eID user, then require that (at least 2) documents are uploaded (manually)!
								profileCompleted = false;
								if (toState.name !== 'identity.form.profile' && toState.name !== 'identity.form.documents') {
									event.preventDefault();
									$state.go("identity.form.documents");
									return;
								}
							}
						} else { // company profile
							if (!identity.companyProfile.legal_name) {
								profileCompleted = false;
								if (toState.name !== 'identity.form.profile' && toState.name !== 'identity.form.documents') {
									event.preventDefault();
									$state.go("identity.form.profile");
									return;
								}
							} else if (!Documents.requiredCompanyDocumentsUploaded(identity.documents)) {
								profileCompleted = false;
								if (toState.name !== 'identity.form.profile' && toState.name !== 'identity.form.documents') {
									event.preventDefault();
									$state.go("identity.form.documents");
									return;
								}
							}
						}
					}

					if (profileCompleted) {

						if (toState.name === 'security.rekey' || toState.name === 'security.rekeyfix') {
							return;
						}
						if (toState.name === 'identity.form.profile' || toState.name === 'identity.form.documents') {
							return;
						}
						if (toState.name === 'security.password') {
							return;
						}
						if (toState.name === 'security.twostep') {
							return;
						}

						// check if rekey required
						if (walletRekeyRequired(authUser)) {
							event.preventDefault();
							if (authUser.type2fa !== 'totp') {
								$state.go('security.twostep');
							} else {
								$state.go('security.rekey');
							}
							return;
						}

						// check if password change required
						if (typeof authUser.lastPasswordChange === 'undefined' && toState.name !== 'security.password') {
							$state.go('security.password');
							return;
						}

						// check if 2FA is not set yet
						if (authUser.type2fa !== 'totp' && toState.name !== 'security.twostep') {
							$state.go('security.twostep');
							return;
						}

					}
				}
				if (toState.data && toState.data.enabledForUser) {
					const requestedFeature = toState.data.enabledForUser;
					if (!(Array.isArray(authUser.features) && authUser.features.indexOf(requestedFeature.flag) > -1)) {
						const redirectTo = toState.data.enabledForUser.redirectTo || fromState.name;
						$state.go(redirectTo);
						return;
					}
				}
			});
		});

	}]);

"use strict";

 angular.module('config', [])

.constant('ENV', {name:'production',rippleServers:['wss://xrpl.ws:443','wss://api.gatehub.net:443/rippled'],apiEventstore:'https://api.gatehub.net/eventstore/v0',apiILP:'https://api.gatehub.net/ilp/',apiInterledger:'https://api.gatehub.net/ilp',apiCurrencyConverter:'https://api.gatehub.net/currencyconverter/api/',apiRates:'https://api.gatehub.net/rates/v1',ethApi:'https://api.gatehub.net/fifth/eth',etcApi:'https://api.gatehub.net/fifth/etc',repApi:'https://api.gatehub.net/fifth/rep',dshApi:'https://api.gatehub.net/fifth/dsh',btcApi:'https://api.gatehub.net/fifth/btc',bchApi:'https://api.gatehub.net/fifth/bch',ltcApi:'https://api.gatehub.net/fifth/ltc',sgbApi:'https://api.gatehub.net/fifth/sgb',flrApi:'https://api.gatehub.net/fifth/flr',usdcApi:'https://api.gatehub.net/fifth/usdc',usdtApi:'https://api.gatehub.net/fifth/usdt',wxrpApi:'https://api.gatehub.net/fifth/wxrp',galaApi:'https://api.gatehub.net/fifth/gala',rippleChartsEndpoint:'https://api.ripplecharts.com/api/',rippleDataApi:'https://api.gatehub.net/rippledata/v2',xrpfApi:'https://api.gatehub.net/xrplorer',apiSignin:'https://signin.gatehub.net',apiAuth:'https://api.gatehub.net/auth/v1',apiAuthV2:'https://api.gatehub.net/auth/v2',apiOAuth:'https://api.gatehub.net/auth/v2/oauth',apiIdV1:'https://api.gatehub.net/id/v1',apiStripe:'https://api.gatehub.net/stripe',apiStorage:'https://api.gatehub.net/storage',apiCoreV1:'https://api.gatehub.net/core/v1',apiMultisig:'https://api.gatehub.net/multisig',search:'https://api.gatehub.net/search/search',clientID:'6e7f0384-2fa1-4ec2-92ea-cfe5f3725c79',clientSecret:'86738093ec86c35c7463fdc45808c6f8c981fd3f',migrationAPI:'https://api.gatehub.net/migration',migrationAPIripple:'https://id.ripple.com',shadowApi:'https://api.gatehub.net/shadow',paystringApi:'https://api.gatehub.net/paystring',version:'rel-24.12',vaults:[{id:1,gateway_name:'GateHub Crypto d.o.o.',country:'Slovenia',location:'Ljubljana',currency:'XRP',logo:'logo_gatehub.png',logo_color:'#057EEF',gateway_uid:'5d91678a-b1fc-452e-b442-c29184ebdcb0',vault_id:'3c11bacd-60fc-4182-988d-272b35eda558',cold:'rhub8VRN55s94qWKDv6jmDy1pUykJzF3wq',firstParty:true},{id:2,gateway_name:'GateHub Crypto d.o.o.',country:'Slovenia',location:'Ljubljana',currency:'USD',logo:'logo_gatehub.png',logo_color:'#057EEF',gateway_uid:'5d91678a-b1fc-452e-b442-c29184ebdcb0',vault_id:'5e1ff913-96d4-45ab-b7a3-04197a59fe06',cold:'rhub8VRN55s94qWKDv6jmDy1pUykJzF3wq',firstParty:true},{id:3,gateway_name:'GateHub Crypto d.o.o.',country:'Slovenia',location:'Ljubljana',currency:'EUR',logo:'logo_gatehub.png',logo_color:'#057EEF',gateway_uid:'5d91678a-b1fc-452e-b442-c29184ebdcb0',vault_id:'546ac540-4362-49cb-b639-afc5d4280d03',cold:'rhub8VRN55s94qWKDv6jmDy1pUykJzF3wq',firstParty:true},{id:4,gateway_name:'GateHub Crypto d.o.o.',country:'Slovenia',location:'Ljubljana',currency:'ETH',logo:'logo_gatehub.png',logo_color:'#057EEF',gateway_uid:'6cffd216-f80c-4685-a7dc-16fcb7bce6e5',vault_id:'dbf81182-93f7-4ae1-b1b8-ba7016d6e546',cold:'rcA8X3TVMST1n3CJeAdGk1RdRCHii7N2h',firstParty:true},{id:5,gateway_name:'GateHub Crypto d.o.o.',country:'Slovenia',location:'Ljubljana',currency:'REP',logo:'logo_gatehub.png',logo_color:'#057EEF',gateway_uid:'6cffd216-f80c-4685-a7dc-16fcb7bce6e5',vault_id:'4a0cc0eb-7c1d-4f39-8114-440a594df6d6',cold:'rckzVpTnKpP4TJ1puQe827bV3X4oYtdTP',firstParty:true},{admin_only:true,id:6,gateway_name:'Global iD',country:'United-states',location:'San Francisco',currency:'PTT',logo:'logo_gatehub.png',logo_color:'#057EEF',gateway_uid:'875946a2-f1fe-44c2-8a0f-9f5264f290cb',vault_id:'e87d4d41-6795-4ee5-bc51-dc1fdb0e0dca',cold:'',firstParty:false},{id:7,gateway_name:'BPG Kovine',country:'Slovenia',location:'Ljubljana',currency:'XAU',logo:'logo_bpg.png',logo_color:'#057EEF',gateway_uid:'b8f96b58-3528-49d2-9d02-81dbacc0abb6',vault_id:'dc96d659-0929-4477-8028-25588e1f880a',cold:'rcoef87SYMJ58NAFx7fNM5frVknmvHsvJ',firstParty:true},{id:8,gateway_name:'GateHub Crypto d.o.o.',country:'Slovenia',location:'Ljubljana',currency:'ETC',logo:'logo_gatehub.png',logo_color:'#057EEF',gateway_uid:'6cffd216-f80c-4685-a7dc-16fcb7bce6e5',vault_id:'6b1efef3-f6bc-44fd-86d7-5f30c7cd87a6',cold:'rDAN8tzydyNfnNf2bfUQY6iR96UbpvNsze',firstParty:true},{id:9,gateway_name:'GateHub Crypto d.o.o.',country:'Slovenia',location:'Ljubljana',currency:'BTC',logo:'logo_gatehub.png',logo_color:'#057EEF',gateway_uid:'6cffd216-f80c-4685-a7dc-16fcb7bce6e5',vault_id:'f5a5ff14-40b7-48b0-8127-68cab0d415bd',cold:'rchGBxcD1A1C2tdxF6papQYZ8kjRKMYcL',firstParty:true},{id:11,gateway_name:'GateHub Crypto d.o.o.',country:'Slovenia',location:'Ljubljana',currency:'BCH',logo:'logo_gatehub.png',logo_color:'#057EEF',gateway_uid:'6cffd216-f80c-4685-a7dc-16fcb7bce6e5',vault_id:'610ef32f-a523-4bdc-94e9-ec0b21653a88',cold:'rcyS4CeCZVYvTiKcxj6Sx32ibKwcDHLds',firstParty:true},{id:12,gateway_name:'GateHub Crypto d.o.o.',country:'Slovenia',location:'Ljubljana',currency:'DSH',logo:'logo_gatehub.png',logo_color:'#057EEF',gateway_uid:'6cffd216-f80c-4685-a7dc-16fcb7bce6e5',vault_id:'2c7b50ec-f9db-4a19-b282-e568c99912d9',cold:'rcXY84C4g14iFp6taFXjjQGVeHqSCh9RX',firstParty:true},{admin_only:true,id:13,gateway_name:'(OLD) GateHub Synthetic',country:'United States',location:'San Francisco',currency:'AED',logo:'logo_gatehub.png',logo_color:'#057EEF',gateway_uid:'f0d86039-98d6-478a-9ee7-84985a56bae4',vault_id:'c926c086-7ce0-44b7-8214-8d0eaea1c167',cold:'',firstParty:false},{admin_only:true,id:14,gateway_name:'Geni',country:'Slovenia',location:'Ljubljana',currency:'EUX',logo:'logo_gatehub.png',logo_color:'#057EEF',gateway_uid:'172a7684-4d68-42ce-8e84-5b892e19b9e9',vault_id:'b5192ef6-529d-4e35-bcf0-9b32386973ca',cold:'',firstParty:false},{admin_only:true,id:15,gateway_name:'GateHub Synthetic',country:'United States',location:'San Francisco',currency:'USD',logo:'logo_gatehub.png',logo_color:'#057EEF',gateway_uid:'c85007e9-9f8b-4340-9e8c-69434515b799',vault_id:'129ec6d7-8146-4b3a-b5dd-3d3e5b106038',cold:'',firstParty:false},{id:16,gateway_name:'GateHub Crypto d.o.o.',country:'Slovenia',location:'Ljubljana',currency:'FLR',logo:'logo_gatehub.png',logo_color:'#057EEF',gateway_uid:'6cffd216-f80c-4685-a7dc-16fcb7bce6e5',vault_id:'9f06a156-ead5-486a-8bee-65727f84aa24',cold:'rcxJwVnftZzXqyH9YheB8TgeiZUhNo1Eu',firstParty:true},{id:17,gateway_name:'GateHub Crypto d.o.o.',country:'Slovenia',location:'Ljubljana',currency:'LTC',logo:'logo_gatehub.png',logo_color:'#057EEF',gateway_uid:'6cffd216-f80c-4685-a7dc-16fcb7bce6e5',vault_id:'711de6f4-4ef4-4015-8f49-0a090ebdf963',cold:'rcRzGWq6Ng3jeYhqnmM4zcWcUh69hrQ8V',firstParty:true},{id:18,gateway_name:'GateHub Crypto d.o.o.',country:'Slovenia',location:'Ljubljana',currency:'SGB',logo:'logo_gatehub.png',logo_color:'#057EEF',gateway_uid:'6cffd216-f80c-4685-a7dc-16fcb7bce6e5',vault_id:'e8b74de1-5ff7-4f3a-890d-5f0f3c1bae3b',cold:'rctArjqVvTHihekzDeecKo6mkTYTUSBNc',firstParty:false},{id:19,gateway_name:'GateHub Crypto d.o.o.',country:'Slovenia',location:'Ljubljana',currency:'USDC',logo:'logo_gatehub.png',logo_color:'#057EEF',gateway_uid:'6cffd216-f80c-4685-a7dc-16fcb7bce6e5',vault_id:'a5673683-6781-48fc-931f-2e0407333672',cold:'rcEGREd8NmkKRE8GE424sksyt1tJVFZwu',firstParty:true},{id:20,gateway_name:'GateHub Crypto d.o.o.',country:'Slovenia',location:'Ljubljana',currency:'USDT',logo:'logo_gatehub.png',logo_color:'#057EEF',gateway_uid:'6cffd216-f80c-4685-a7dc-16fcb7bce6e5',vault_id:'d028639b-b669-48f6-b3e1-535f79fe21b3',cold:'rcvxE9PS9YBwxtGg1qNeewV6ZB3wGubZq',firstParty:true},{id:21,gateway_name:'GateHub Crypto d.o.o.',country:'Slovenia',location:'Ljubljana',currency:'WXRP',logo:'logo_gatehub.png',logo_color:'#057EEF',gateway_uid:'6cffd216-f80c-4685-a7dc-16fcb7bce6e5',vault_id:'57377aee-c8a2-4cdf-8250-af87ee99f992',cold:'rEa5QY8tdbjgitLyfKF1E5Qx3VGgvbUhB3',firstParty:true},{id:22,gateway_name:'GateHub Crypto d.o.o.',country:'Slovenia',location:'Ljubljana',currency:'GALA',logo:'logo_gatehub.png',logo_color:'#057EEF',gateway_uid:'6cffd216-f80c-4685-a7dc-16fcb7bce6e5',vault_id:'5b964a9c-7ef0-4605-b1e3-2459e37213fe',cold:'rf5YPb9y9P3fTjhxNaZqmrwaj5ar8PG1gM',firstParty:true},{id:23,gateway_name:'GateHub Crypto d.o.o.',country:'Slovenia',location:'Ljubljana',currency:'GBP',logo:'logo_gatehub.png',logo_color:'#057EEF',gateway_uid:'6cffd216-f80c-4685-a7dc-16fcb7bce6e5',vault_id:'7139d6ee-296a-4780-832f-479902ee412d',cold:'r4GN9eEoz9K4BhMQXe4H1eYNtvtkwGdt8g',firstParty:true}],exchangeChoices:[{name:'Ripple',currency:'XRP',issuer:'rhub8VRN55s94qWKDv6jmDy1pUykJzF3wq'},{name:'GateHub Crypto',currency:'USD',issuer:'rhub8VRN55s94qWKDv6jmDy1pUykJzF3wq'},{name:'GateHub Crypto',currency:'EUR',issuer:'rhub8VRN55s94qWKDv6jmDy1pUykJzF3wq'},{name:'GateHub Crypto',currency:'GBP',issuer:'r4GN9eEoz9K4BhMQXe4H1eYNtvtkwGdt8g'},{name:'GateHub Crypto',currency:'BTC',issuer:'rchGBxcD1A1C2tdxF6papQYZ8kjRKMYcL'},{name:'GateHub Crypto',currency:'BCH',issuer:'rcyS4CeCZVYvTiKcxj6Sx32ibKwcDHLds'},{name:'GateHub Crypto',currency:'ETH',issuer:'rcA8X3TVMST1n3CJeAdGk1RdRCHii7N2h'},{name:'GateHub Crypto',currency:'REP',issuer:'rckzVpTnKpP4TJ1puQe827bV3X4oYtdTP'},{name:'GateHub Crypto',currency:'ETC',issuer:'rDAN8tzydyNfnNf2bfUQY6iR96UbpvNsze'},{name:'GateHub Crypto',currency:'DSH',issuer:'rcXY84C4g14iFp6taFXjjQGVeHqSCh9RX'},{name:'GateHub Crypto',currency:'LTC',issuer:'rcRzGWq6Ng3jeYhqnmM4zcWcUh69hrQ8V'},{name:'GateHub Crypto',currency:'SGB',issuer:'rctArjqVvTHihekzDeecKo6mkTYTUSBNc'},{name:'GateHub Crypto',currency:'USDC',issuer:'rcEGREd8NmkKRE8GE424sksyt1tJVFZwu'},{name:'GateHub Crypto',currency:'USDT',issuer:'rcvxE9PS9YBwxtGg1qNeewV6ZB3wGubZq'},{name:'GateHub Crypto',currency:'WXRP',issuer:'rEa5QY8tdbjgitLyfKF1E5Qx3VGgvbUhB3'},{name:'GateHub Crypto',currency:'GALA',issuer:'rf5YPb9y9P3fTjhxNaZqmrwaj5ar8PG1gM'},{name:'BPG Kovine',currency:'XAU',issuer:'rcoef87SYMJ58NAFx7fNM5frVknmvHsvJ'}],defaultExchangeBase:{currency:'XRP',issuer:'rhub8VRN55s94qWKDv6jmDy1pUykJzF3wq'},defaultExchangeCounter:{currency:'USD',issuer:'rhub8VRN55s94qWKDv6jmDy1pUykJzF3wq'},featureFlags:{},eidPortalUrl:'https://kyc.gatehub.net'})

;
'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.errorCollector
 * @description
 * # errorCollector
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
    .factory("$exceptionHandler", errorCollector)
    .run(runErrorCollector);

function errorCollector(ENV) {
    var isDevelop = _.includes(['development', 'staging'], ENV.name);
    var isLocalhost = location.hostname === "localhost" || location.hostname === "127.0.0.1";

    return function (exception, context) {

        if (isDevelop || isLocalhost || !window.Sentry) {
            console.error(exception, context);
            return;
        }

        if (context) {
            Sentry.configureScope(function(scope) {
                scope.setExtra("context", context);
            });
        } else {
            Sentry.configureScope(function(scope) {
                scope.setExtra("context", null);
            });
        }

        // Try to handle different error instances
        if (!exception) {
            Sentry.captureException('Undefined Error');
        }
        else if (exception instanceof Error) {
            Sentry.captureException(exception);
        }
        else if (typeof exception === "string") {
            Sentry.captureException(new Error(exception));
        }
        else if (exception.data) {
            if (exception.data.error) {
                Sentry.captureException(new Error(exception.data.error));
            }
            else if (exception.data.message) {
                Sentry.captureException(new Error(exception.data.message));
            }
        }
        else if (exception.engine_result_message) {
            Sentry.captureException(new Error(exception.engine_result_message));
        }
        else if (exception.error && typeof exception.error === "string") {
            Sentry.captureException(new Error(exception.error));
        }
        else {
            // Dismiss aborted requests
            if (exception.status == -1) {
                return;
            }
            else {
                Sentry.configureScope(function(scope) {
                    scope.setExtra("context", exception);
                });
                Sentry.captureException('Undefined Error');
            }
        }
    };
}
errorCollector.$inject = ["ENV"];

function runErrorCollector(ENV, Auth) {
    var isDevelop = _.includes(['development','staging'], ENV.name);
    var isLocalhost = location.hostname === "localhost" || location.hostname === "127.0.0.1";

    if (window.Sentry) {
        Sentry.init({
            dsn: 'https://1ddd2180bda4413da39fed98d5fa6b21@sentry.io/1528123',
            integrations: [
              new Sentry.Integrations.Angular(),
              new Sentry.Integrations.Breadcrumbs({ console: false })
            ],
            environment: ENV.name,
            release: ENV.version,
            ignoreErrors: [
                "$digest already in progress",
                "$digest",
                "$rootScopeMinErr(concat/scripts/vendor)",
                "[$rootScope:inprog] null already in progress",
                "[$rootScope:inprog] null already in progress http://errors.angularjs.org/1.4.14/$rootScope/inprog?p0=null",
                "Native amounts must be specified in integer drops",
                "BigNumber Error: new BigNumber() not a number",
                "QuotaExceededError: QuotaExceededError: DOM Exception 22",
                // Random plugins/extensions
                'top.GLOBALS',
                // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error. html
                'originalCreateNotification',
                'canvas.contentDocument',
                'MyApp_RemoveAllHighlights',
                'http://tt.epicplay.com',
                'Can\'t find variable: ZiteReader',
                'jigsaw is not defined',
                'ComboSearch is not defined',
                'http://loading.retry.widdit.com/',
                'atomicFindClose',
                // Facebook borked
                'fb_xd_fragment',
                // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
                // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
                'bmi_SafeAddOnload',
                'EBCallBackMessageReceived',
                // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
                'conduitPage',
                'XDR encoding failure' // a firefox specific error
            ],
            blacklistUrls: [
                // Facebook flakiness
                /graph\.facebook\.com/i,
                // Facebook blocked
                /connect\.facebook\.net\/en_US\/all\.js/i,
                // Woopra flakiness
                /eatdifferent\.com\.woopra-ns\.com/i,
                /static\.woopra\.com\/js\/woopra\.js/i,
                // Chrome extensions
                /extensions\//i,
                /^chrome:\/\//i,
                // Other plugins
                /127\.0\.0\.1:4001\/isrunning/i,  // Cacaoweb
                /webappstoolbarba\.texthelp\.com\//i,
                /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
            ],
            beforeSend: function(event) {
                if (isDevelop || isLocalhost) {
                    console.error("Sentry: ", event.exception.values);
                    return null;
                }

                return event;
            }
        });

        Auth.getProfile().then(function (user) {
            Sentry.configureScope(function(scope) {
                scope.setUser({ id: (!angular.isUndefined(user)) ? user.id : "" });
            });
        }, function () {
            console.log("User not defined");
        });


        angular.module("gatehubClientApp").requires.push('ngSentry');
    }
    else {
        console.log("Sentry not defined");
    }


}
runErrorCollector.$inject = ["ENV", "Auth"];


'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:SidebarCtrl
 * @description
 * # SidebarCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('SidebarCtrl', ["$scope", "$rootScope", "WalletsService", "AccountsService", "$timeout", "$state", "$filter", "$exceptionHandler", function ($scope, $rootScope, WalletsService, AccountsService, $timeout, $state, $filter, $exceptionHandler) {

        $scope.loading = false;
        $scope.wallet = false;

        $scope.txUuidFilter = $filter('txUuidFilter');

        $scope.getState = getState;

        var wallet;

        var activeWalletWatcher;
        var balancesUpdateListener;

        // Init
        init();


        ///////////////////////////////////////////////////////////

        function init() {

            AccountsService.getAccounts();

            // Wait untill wallets are fully loaded
            WalletsService.getWallets().then(function(data) {

                // Get active wallet
                wallet = WalletsService.getActive();

                $scope.loading = false;

                // Something went wrong, let's stop before it gets even worse
                if(!wallet) {
                    $exceptionHandler('wallet_not_found');
                    return;
                };

                $scope.wallet = wallet[0];

                activeWalletWatcher = $rootScope.$watch('activeWallet', function () {
                    wallet = WalletsService.getActive();
                    loadWallet();
                });

                balancesUpdateListener = $rootScope.$on('$balancesUpdate', function() {
                    loadWallet();
                });

                if (_.isEmpty(wallet[0].history) && !wallet[0].loadingHistory) {
                    WalletsService.getHistory(wallet[0]);
                }

            }, function(error) {
                $exceptionHandler(error);
                $scope.loading = false;
            });

        };

        function loadWallet() {
            $timeout(function(){
                var wallet = WalletsService.getActive();
                $scope.wallet = wallet[0];
            }, 0);
        };

        function getState(){
            return $state.current.name;
        }

        function unsubscribeListeners() {
            if (activeWalletWatcher) {
                activeWalletWatcher();
            }
            if (balancesUpdateListener) {
                balancesUpdateListener();
            }
        }

        $scope.$on('$destroy', function() {
            unsubscribeListeners();
        });

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:ConnectGatewayCtrl
 * @description
 * # ConnectGatewayCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('ConnectGatewayCtrl', ["$scope", "$stateParams", "Auth", "$timeout", "VaultsService", "$sessionStorage", "data", "IDRestangular", "$exceptionHandler", function($scope, $stateParams, Auth, $timeout, VaultsService, $sessionStorage, data, IDRestangular, $exceptionHandler) {

        var URL = 'identity.form.profile';

        // hack - ng-model wont bind to primitive
        $scope.agreeWithToc = { value: false };
        $scope.incomplete = false;
        $scope.incompletePhone = false;

        var user = $sessionStorage.user;

        $scope.selectedHub = [];
        $scope.company = false;
        $scope.loading = true;
        $scope.selectedHub = data.hub;

        // Init
        resetForm();
        $scope.errorMessage = false;

        Auth.getProfile(true).then(function (data) {

            data = data.identity;

            $scope.loading = false;


            // Check phone
            if(data.verification_level < 1) {
                $scope.incompletePhone = true;
                URL = 'identity.form.phone';
                return;
            }
            else {
                $scope.incompletePhone = false;
            };

            // Check documents
            if(data.user_type != 1) {

                var profileEmpty = !Object.keys(data.profile).filter(function(e) {
                    return !!data.profile[e] && !~[ 'uuid', 'created_at', 'documents' ].indexOf(e);
                }).length;


                // Profile
                if (profileEmpty) {
                    $scope.incomplete = true;
                    URL = 'identity.form.profile';
                    return;
                }

                // Documents
                if (data.profile.documents.length < 2) {
                    $scope.incomplete = true;
                    URL = 'identity.form.documents';
                }

                // console.log(profileEmpty, data.profile.documents);

            }
            else {
                $scope.company = true;
                if (!Object.keys(data.companyProfile).length || (data.companyProfile.documents != null && data.companyProfile.documents.length < 1 )) {
                    $scope.incomplete = true;
                }
            };



        }, function (error) {
            // $scope.loading = false;
        });

        function resetForm() {
            $scope.errorMessage = false;
            $scope.loading = false;
            $scope.mode = false;
        };

        $scope.submitForm = function() {
            connectIdentity($scope.selectedHub.gateway_uuid);
        };

        function connectIdentity(gateway_uid) {
            $scope.loading = true;

            IDRestangular.one('users', user.uid).all('hubs').all(gateway_uid).post().then(function () {
                $scope.mode = 'success';

                $timeout(function() {
                    $scope.$close({ redirect: null });
                }, 4000);

            }, function(error) {
                $timeout(function() {
                    $scope.$close({ redirect: null });
                }, 4000);

                $exceptionHandler(error);
                $scope.mode = 'error';
                $scope.errorMessage = error.data.developerMessage;

            })
            .finally(function() {
                $scope.loading = false;
                $timeout(function() {
                    // Close modal
                    $scope.$close({ redirect: null });
                }, 4000);
            });

        };


        $scope.cancel = function() {
            $scope.$dismiss({ redirect: null });
        };

        $scope.verify = function() {
            $scope.$close({ redirect: URL });
        };

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:MarketsAddCtrl
 * @description
 * # MarketsAddCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('MarketsAddCtrl', ["$scope", "MarketsService", "$stateParams", "$timeout", "$filter", "ThirdPartyService", "NonstandardCurrencies", function ($scope, MarketsService, $stateParams, $timeout, $filter, ThirdPartyService, NonstandardCurrencies) {

        $scope.xrplCurrencyCodeRegex = NonstandardCurrencies.xrplCurrencyCodeRegex;

        $scope.baseIndex = -1;
        $scope.counterIndex = -1;

        // Gateways
        $scope.gateways = MarketsService.list_gateways();

        $scope.realCurrencyCode = $filter('realCurrencyCode');

        resetForm();

        // Watch these guys
        $scope.$watch('sendCurrency.address', function (data) {
            update_destination_amount();
        }, true);
        $scope.$watch('sendCurrency.currency', function (data) {
            update_destination_currency();
        }, true);


        ///////////////////////////////////////////////////////////


        $scope.setBase = function(index) {
            $scope.baseIndex = index;
        }
        $scope.setCounter = function(index) {
            $scope.counterIndex = index;
        }
        $scope.flipMarket = function() {
            var temp = $scope.baseIndex;
            $scope.baseIndex = $scope.counterIndex;
            $scope.counterIndex = temp;
        }

        function resetForm() {

            $scope.form = {};
            $scope.errorMessage = false;
            $scope.sending = false;

            $scope.sendCurrency = {
                name: '',
                address: '',
                currency: '',
            };

        }

        $scope.submitForm = function(isValid) {
            $scope.errorMessage = false;

            // Make sure the form is completely valid - should be!
            if (!isValid) {
                $scope.errorMessage = "One or more required fields are invalid";
                return;
            }

            $scope.sending = true;

            if($scope.baseIndex == $scope.counterIndex) {
                $scope.errorMessage = "Select different markets";
                $scope.sending = true;
                return;
            }

            var pair = {
                base: $scope.gateways[$scope.baseIndex],
                counter: $scope.gateways[$scope.counterIndex]
            };

            MarketsService.addCustomMarket(pair);

            //close modal
            $scope.$close();

        };

        $scope.submitFormCurrency = function(isValid) {

            // Make sure the form is completely valid - should be!
            if (!isValid) {
                return;
            }

            // Validate
            if (!ripple.UInt160.is_valid($scope.sendCurrency.address)) {
                $scope.form.sendCurrency.address.$setValidity('notRipple', false);
                return;
            }

            var currency = {
                name: $scope.sendCurrency.name,
                issuer: $scope.sendCurrency.address,
                currency: $scope.sendCurrency.currency,
            };

            MarketsService.addCurrency(currency);

            $scope.sendCurrency = {
                name: '',
                address: '',
                currency: '',
            };

            $scope.showadvanced = false;

            // Set base to newly created market
            $scope.currency_added = true;

            $timeout(function() {
                $scope.currency_added = false;
            }, 5000)

        };

        $scope.cancel = function() {
            $scope.$dismiss();
        };

        function update_destination_amount() {

            var send = $scope.sendCurrency;
            var recipient = send.address;

            if($scope.form.sendCurrency) {
                $scope.form.sendCurrency.address.$setValidity('notRipple', true);
                $scope.form.sendCurrency.address.$setValidity('self', true);
            }
            else {
                return;
            }

            if (!ripple.UInt160.is_valid(recipient)) {
                $scope.form.sendCurrency.address.$setValidity('notRipple', false);
                return;
            }

            // Sending to self
            if (recipient === $stateParams.id) {
                $scope.form.sendCurrency.address.$setValidity('self', false);
                return;
            }

        };

        function update_destination_currency() {

            var send = $scope.sendCurrency;
            var currency = send.currency;

            if (!$scope.form.send || !currency) {
                return;
            }


            $scope.form.sendCurrency.currency.$setValidity('currencyCode', true);
            if(currency.toUpperCase() === 'XRP') {
                $scope.form.sendCurrency.currency.$setValidity('currencyCode', false);
                return;
            }

        };

        $scope.isThirdPartyWithoutConsent = function(currency, issuer) {
            return ThirdPartyService.isThirdPartyWithoutConsent({
                currency,
                issuer
            });
        }

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:AuthCtrl
 * @description
 * # AuthCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('AuthCtrl', ["AccessToken", "$sessionStorage", "Auth", "$state", "$location", "WalletsService", function (AccessToken, $sessionStorage, Auth, $state, $location, WalletsService) {

        if (angular.isUndefined($sessionStorage.token)) {

            AccessToken.destroy();
            Auth.redirect();

        }
        else {

            // Need to set Restangular header
            Auth.setRestangularToken($sessionStorage.token.access_token);

            // Start WalletsService
            WalletsService.getWallets();

            // console.log("This is state", $sessionStorage.previousState);
            if (!angular.isUndefined($sessionStorage.previousState) && $sessionStorage.previousState != "/authentication") {
                $location.path($sessionStorage.previousState);
            }
            else {
                $state.go("wallets");
            };

        };

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:ModalCtrl
 * @description
 * # ModalCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
  .controller('ModalCtrl', ["$scope", "Auth", "Settings", "Restangular", "$window", "FeatureService", function ($scope, Auth, Settings, Restangular, $window, FeatureService) {

    $scope.settings = Settings;
    $scope.addWalletTitle = "Add Wallet";

    FeatureService.isEnabledForUser({ flag: 'psd-processor' }).then(function(isEnabled) {
      if (isEnabled) {
        $scope.addWalletTitle = "Add Wallet or Bank";
      }
    });

    Auth.getProfile().then(function (data) {
      $scope.user = data;
    });

    $scope.cancel = function () {
      $scope.$dismiss();
    };

    $scope.closeAccountViaModal = function () {
      Restangular.one('user').remove().then(function () {
        console.log('Account closed!');
        $window.location.href = 'https://signin.gatehub.net/';
      });
    }
  }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:CurrencyPickerCtrl
 * @description
 * # CurrencyPickerCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
.controller('CurrencyPickerCtrl', ["WalletsService", "FeatureService", "Auth", function (WalletsService, FeatureService, Auth) {
    var vm = this;
    vm.activeWallet = null;

    WalletsService.getWallets().then(function() {
        var wallet = WalletsService.getActive();
        vm.activeWallet = wallet[0];
    });

    vm.depositCurrencies = [
        //{ header: 'Card', subtitle: 'Instant', route: 'card', icon: 'credit-card' }, // UNDER FEATURE FLAG
        { header: 'EU Bank', subtitle: 'SEPA transfer', route: 'sepa', icon: 'bank' },
        { header: 'Bank', subtitle: 'Wire transfer', route: 'wire', icon: 'bank' },
        { header: 'UK Bank', subtitle: 'Faster Payments', route: 'gbp', icon: 'bank' },
        { header: 'XRP Ledger', subtitle: 'XRPL transfer', route: 'ripple', icon: 'xrp-dark' },
        { header: 'Dash', subtitle: 'DSH transfer', route: 'dash', icon: 'dsh-dark' },
        { header: 'Bitcoin', subtitle: 'BTC transfer', route: 'bitcoin', icon: 'btc-dark' },
        { header: 'Bitcoin Cash', subtitle: 'BCH transfer', route: 'bitcoincash', icon: 'bch-dark' },
        { header: 'Ethereum', subtitle: 'ETH transfer', route: 'ethereum', icon: 'eth-dark' },
        { header: 'Ethereum Classic', subtitle: 'ETC transfer', route: 'ethereum_classic', icon: 'eth-dark' },
        { header: 'Litecoin', subtitle: 'LTC transfer', route: 'litecoin', icon: 'ltc-dark' },
        { header: 'Flare', subtitle: 'FLR transfer', route: 'flare', icon: 'flr-dark' },
        { header: 'PayString', subtitle: 'PayString transfer', route: 'paystring', icon: 'paystring' },
        { header: 'Songbird', subtitle: 'SGB transfer', route: 'songbird', icon: 'sgb-dark' },
        { header: 'Tether', subtitle: 'USDT transfer', route: 'usdt', icon: 'usdt-dark' },
        { header: 'USD Coin', subtitle: 'USDC transfer', route: 'usdc', icon: 'usdc-dark' },
        { header: 'Gala', subtitle: 'GALA transfer', route: 'gala', icon: 'gala-dark' },
        { header: 'Wrapped XRP', subtitle: 'WXRP transfer', route: 'wxrp', icon: 'wxrp-dark' },
        // { header: 'Interledger', subtitle: 'Payment pointer', route: 'interledger', icon: 'ilp' },
    ];

    FeatureService.isEnabledForUser({ flag: 'stripe' }).then(function(isEnabled) {
        if (isEnabled) {
            Auth.getProfile().then(function(user) {
                if (user.identity && user.identity.profile) {
                    const userCountryCode = user.identity.profile.address_country_code;
                    const countryCodesEU = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE'];
                    if (countryCodesEU.indexOf(userCountryCode) > -1) {
                        vm.depositCurrencies.unshift(
                            { header: 'Card', subtitle: 'Instant', route: 'card', icon: 'credit-card' }
                        );
                    }
                }
            }, function(error) {
                console.log('Error getting auth user', error);
            });
        }
    });

    vm.sendCurrencies = [
        { header: 'Wallet', subtitle: 'Wallet transfer', route: 'ripple', icon: 'wallet' },
        { header: 'XRP Ledger', subtitle: 'XRPL transfer', route: 'ripple', icon: 'xrp-dark' },
        { header: 'EU Bank', subtitle: 'SEPA transfer', route: 'sepa', icon: 'bank' },
        { header: 'Bank USD', subtitle: 'Wire transfer', route: 'wire', icon: 'bank' },
        { header: 'Bank GBP', subtitle: 'Wire transfer', route: 'wire_gbp', icon: 'bank' },
        { header: 'UK Bank', subtitle: 'Faster Payments', route: 'gbp', icon: 'bank' },
        { header: 'PayString', subtitle: 'PayString transfer', route: 'ripple', icon: 'paystring' },
        { header: 'Dash', subtitle: 'DSH transfer', route: 'dash', icon: 'dsh-dark' },
        { header: 'Bitcoin', subtitle: 'BTC transfer', route: 'bitcoin', icon: 'btc-dark' },
        { header: 'Bitcoin Cash', subtitle: 'BCH transfer', route: 'bitcoincash', icon: 'bch-dark' },
        { header: 'Ethereum', subtitle: 'ETH transfer', route: 'ethereum', icon: 'eth-dark' },
        { header: 'Ethereum Classic', subtitle: 'ETC transfer', route: 'ethereum_classic', icon: 'eth-dark' },
        { header: 'Litecoin', subtitle: 'LTC transfer', route: 'litecoin',  icon: 'ltc-dark' },
        { header: 'Gold', subtitle: 'XAU transfer', route: 'gold',  icon: 'gold' },
        // UNDER FEATURE FLAG { header: 'Flare', subtitle: 'FLR transfer', route: 'flare', icon: 'flr-dark' },
        { header: 'Songbird', subtitle: 'SGB transfer', route: 'songbird', icon: 'sgb-dark' },
        { header: 'Tether', subtitle: 'USDT transfer', route: 'usdt', icon: 'usdt-dark' },
        { header: 'USD Coin', subtitle: 'USDC transfer', route: 'usdc', icon: 'usdc-dark' },
        { header: 'Gala', subtitle: 'GALA transfer', route: 'gala', icon: 'gala-dark' },
        { header: 'Wrapped XRP', subtitle: 'WXRP transfer', route: 'wxrp', icon: 'wxrp-dark' }
        // { header: 'Interledger', subtitle: 'Payment pointer', route: 'interledger', icon: 'ilp' },
    ];

    FeatureService.isEnabledForUser({ flag: 'FlareWithdrawal' }).then(function(isEnabled) {
        if (isEnabled) {
            vm.sendCurrencies.push(
                { header: 'Flare', subtitle: 'FLR transfer', route: 'flare', icon: 'flr-dark' }
            );
        }
    });

    vm.contactTypes = [
        { header: 'XRP Ledger', subtitle: 'XRPL transfer', route: 'ripple', icon: 'xrp-dark' },
        { header: 'EU Bank', subtitle: 'SEPA transfer', route: 'eubank', icon: 'bank' },
        { header: 'Bank USD', subtitle: 'Wire transfer', route: 'bank', icon: 'bank' },
        { header: 'Bank GBP', subtitle: 'Wire transfer', route: 'bank', icon: 'bank' }, // todo-gbp: check if routes are ok
        { header: 'UK Bank', subtitle: 'Faster Payments', route: 'gbp', icon: 'bank' }, // todo-gbp: check if routes are ok
        { header: 'Dash', subtitle: 'DSH transfer', route: 'dash', icon: 'dsh-dark' },
        { header: 'Bitcoin', subtitle: 'BTC transfer', route: 'bitcoin', icon: 'btc-dark' },
        { header: 'Bitcoin Cash', subtitle: 'BCH transfer', route: 'bitcoincash', icon: 'bch-dark' },
        { header: 'Ethereum', subtitle: 'ETH transfer', route: 'ethereum', icon: 'eth-dark' },
        { header: 'Ethereum Classic', subtitle: 'ETC transfer', route: 'ethereum_classic', icon: 'eth-dark' },
        { header: 'Litecoin', subtitle: 'LTC transfer', route: 'litecoin', icon: 'ltc-dark' },
        { header: 'Flare', subtitle: 'FLR transfer', route: 'flare', icon: 'flr-dark' },
        { header: 'Mail', subtitle: 'Mailing address', route: 'mail',  icon: 'gold' },
        { header: 'Songbird', subtitle: 'SGB transfer', route: 'songbird', icon: 'sgb-dark' },
        { header: 'Tether', subtitle: 'USDT transfer', route: 'usdt', icon: 'usdt-dark' },
        { header: 'USD Coin', subtitle: 'USDC transfer', route: 'usdc', icon: 'usdc-dark' },
        { header: 'Gala', subtitle: 'GALA transfer', route: 'gala', icon: 'gala-dark' },
        { header: 'Wrapped XRP', subtitle: 'WXRP transfer', route: 'wxrp', icon: 'wxrp-dark' },
    ];

    vm.walletTypes = [
        { header: 'Create Wallet', subtitle: 'Hosted', route: 'hosted', icon: 'wallet' },
        { header: 'Create Wallet', subtitle: 'XRP Ledger', route: 'xrp', icon: 'xrp-dark' },
        { header: 'Import Wallet', subtitle: 'XRP Ledger', route: 'import', icon: 'xrp-dark' }
    ];

    vm.psdFeatureFlag = false;
    FeatureService.isEnabledForUser({ flag: 'psd-processor' }).then(function(isEnabled) {
        if (isEnabled) {
            vm.walletTypes.push(
                { header: 'Connect Bank', subtitle: 'Bank Account', route: 'bank', icon: 'bank' }
            );
            vm.psdFeatureFlag = true;
        }
    });
}]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:IdentityPhoneCtrl
 * @description
 * # IdentityPhoneCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('IdentityPhoneCtrl', ["$scope", "$state", "IDRestangular", "Auth", "Countries", function ($scope, $state, IDRestangular, Auth, Countries) {

        var User = null;
        var verification_uuid = false;

        $scope.loading = true;
        $scope.step = 1;

        $scope.profileForm = {};
        $scope.verificationForm = {};

        $scope.profile = {};
        $scope.verification = {};

        $scope.sending = false;
        $scope.errorMessage = false;
        $scope.success_message = false;


        Auth.getProfile(true).then(function (data) {

            if(typeof data.identity != 'undefined') {

                User = IDRestangular.one('users', data.identity.uuid);

                $scope.loading = false;
                $scope.profile.phone_number = data.identity.phone_number;

            };

        }, function (error) {
            $scope.loading = false;
        });


        // Form submit (if valid)
        $scope.submitPhoneForm = function (isValid) {

            $scope.errorMessage = false;
            $scope.success_message = false;
            $scope.sending = true;

            // Make sure the form is completely valid
            if (!isValid) {
                $scope.errorMessage = "One or more required fields are invalid";
                $scope.sending = false;
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                return;
            };

            var payload = {
                phone_number: $scope.profile.phone_number,
            };


            User.one('requestPhoneNumber').customPOST(payload).then(function(data) {
                $scope.sending = false;
                verification_uuid = data.uuid;
                $scope.verification.pin = '';
                $scope.step = 2;
            }, function (error) {

                if(error.data && error.data.developerMessage.toLowerCase() === 'blocked key') {
                    $scope.errorMessage = "Phone verification is temporarily blocked due to too many failed attempts. Please try again in 3 hours.";
                }
                else if (error.data && error.data.developerMessage.toLowerCase() === 'phone number already verified.') {
                    $scope.errorMessage = 'This mobile phone number has already been verified';
                }
                else {
                    $scope.errorMessage = 'Phone verification error. Please see our <a href="https://support.gatehub.net/hc/en-us/articles/360021130494-GHV-troubleshooting-guide" target="_blank" rel="noopener noreferrer" class="white_link_underline">support article</a>';
                }

                $scope.sending = false;
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                return;

            });

        };

        // Form submit (if valid)
        $scope.submitVerificationForm = function (isValid) {
            $scope.errorMessage = false;
            $scope.success_message = false;
            $scope.sending = true;

            // Make sure the form is completely valid
            if (!isValid) {
                $scope.errorMessage = "One or more required fields are invalid";
                $scope.sending = false;
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                return;
            };

            if (verification_uuid == false) {
                $scope.errorMessage = 'Phone verification error. Please see our <a href="https://support.gatehub.net/hc/en-us/articles/360021130494-GHV-troubleshooting-guide" target="_blank" rel="noopener noreferrer" class="white_link_underline">support article</a>.';
                $scope.sending = false;
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                return;
            };

            var payload = {
                verification_code: $scope.verification.pin,
            };

            User.one('verifications', verification_uuid).one('verifyPhoneNumber').customPOST(payload).then(function() {

                Auth.getProfile(true).then(function() {
                    $scope.sending = false;
                    $state.go("identity.form.profile");
                });

            }, function (error) {

                console.error(error);
                if (error.data && error.data.id === 'err_invalid') {
                    $scope.errorMessage = "Invalid GHV PIN";
                }
                else {
                    $scope.errorMessage = "Error validating PIN";
                }
                $scope.sending = false;
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                return;

            });

        };

        $scope.setStep = function(value) {
            $scope.errorMessage = null;
            $scope.step = value;
        };

        var excludedCountriesArray = [];
        for(var i = 0; i < Countries.bannedCountries.length; i++){
          excludedCountriesArray.push( Countries.bannedCountries[i].code.toLowerCase() );
        }

        $scope.intlTelInputOptions = {
            autoFormat:true,
            autoPlaceholder:true,
            defaultCountry: 'auto',
            excludeCountries: excludedCountriesArray,
            nationalMode: false
        };

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:IdentityProfileCtrl
 * @description
 * # IdentityProfileCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('IdentityOverviewCtrl', ["Auth", "$uibModal", "$exceptionHandler", "$sessionStorage", "ENV", function (Auth, $uibModal, $exceptionHandler, $sessionStorage, ENV) {

        var vm = this;

        vm.authUser = null;
        vm.user = null;
        vm.profile = null;
        vm.companyProfile = null;
        vm.loading = true;

        vm.closeAccountModal = closeAccountModal;
        vm.editEmailModal = editEmailModal;
        vm.editPhoneModal = editPhoneModal;
        vm.uploadAdditionalDocsModal = uploadAdditionalDocsModal;


        Auth.getProfile(true).then(function (data) {
            vm.loading = false;
            vm.authUser = data;
            vm.user = data.identity;

            vm.profile = data.identity.profile;
            vm.companyProfile = data.identity.companyProfile;

            // check if profile exists
            if(vm.profile.address_country_code || vm.companyProfile.legal_name) {
                vm.profile_exists = true;
            }

            var incorporated_on = moment(data.identity.companyProfile.incorporated_on);

            vm.companyProfile.incorporated_year = parseInt(incorporated_on.format('YYYY'));
            vm.companyProfile.incorporated_month = parseInt(incorporated_on.format('M'));
            vm.companyProfile.incorporated_day = parseInt(incorporated_on.format('D'));
        },
        function(error){
            $exceptionHandler(error);
        })
        .finally(function() {
            vm.loading = false;
        });

        function closeAccountModal(name) {
            var modalInstance = $uibModal.open({
                templateUrl: 'views/identity/modal_close_account.html',
                controller: 'ModalCtrl',
                resolve: {
                    data: function () {
                        return name;
                    }
                }
            });
        };

        function editEmailModal() {
            var modalInstance = $uibModal.open({
                templateUrl: 'views/identity/modal_edit_email.html',
                controller: 'ChangeEmailCtrl',
                controllerAs: 'vm'
            });
        };

        function editPhoneModal() {
            var modalInstance = $uibModal.open({
                templateUrl: 'views/identity/modal_edit_phone.html',
                controller: 'ChangePhoneCtrl',
                controllerAs: 'vm'
            });
        };

        function uploadAdditionalDocsModal() {
            var modalInstance = $uibModal.open({
                templateUrl: 'views/identity/modal_upload_additional_docs.html',
                controller: 'UploadAdditionalDocsCtrl',
                controllerAs: 'vm'
            });
        }

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:PrivacyCtrl
 * @description
 * # PrivacyCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
.controller('PrivacyCtrl', ["$stateParams", "Auth", "IDRestangular", "$exceptionHandler", function ($stateParams, Auth, IDRestangular, $exceptionHandler) {

    var vm = this;

    vm.loading = true;
    vm.error = false;
    vm.emailNotifications = false;

    var user = null;

    vm.updateNotifications = updateNotifications;

    Auth.getProfile(true).then(function (data) {

        user = data.identity;

        // if user clicked NO on GDRP homepage notification, save GDPR as false
        if ($stateParams.gdpr === 'no'){
            vm.emailNotifications = false;
            updateNotifications(false);
            vm.loading = false;
        } else {
            // else read from databse
            IDRestangular.one('users', user.uuid).get().then(function(response){
                vm.emailNotifications = !!response.mail_subs;
            })
            .finally(function() {
                vm.loading = false;
            });
        }
    }, function(error) {
        vm.error = 'Error fetching preferences.';
        vm.loading = false;
    });


    function updateNotifications(value) {
        vm.error = null;
        vm.emailNotifications = value;

        var User = IDRestangular.one('users', user.uuid);
        User.mail_subs = value;
        User.put().then(
            function(){ },
            function(error){
                vm.error = 'Error saving email notifications preference.';
                $exceptionHandler("Error saving email notifications preference.", error);
            }
        );
    }
}]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:IdentityProfileCtrl
 * @description
 * # IdentityProfileCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('IdentityProfileCtrl', ["$scope", "$state", "$stateParams", "$sessionStorage", "Countries", "IDRestangular", "Auth", "CoreRestangular", "IdentityService", "$uibModal", "Documents", "$exceptionHandler", function ($scope, $state, $stateParams, $sessionStorage, Countries, IDRestangular, Auth, CoreRestangular, IdentityService, $uibModal, Documents, $exceptionHandler) {

        var authUser = null;

        var profile = null; // User UUID
        var User = null; // Auth

        $scope.latinAllow = "^[A-Za-z0-9\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u017F\-' ]+$";
        $scope.latinAllowNoNumbers = "^[A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u017F\-' ]+$";
        $scope.latinDotCommaAllow = "^[A-Za-z0-9\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u017F\-\.,' ]+$";

        $scope.poBoxNotifications = {};
        var po_box_pattern = /^p\.?\s*o\.?\s*box/i;
        $scope.checkForPOBox = function(el, val){
            if(po_box_pattern.test(val)){
                $scope.poBoxNotifications[el] = true;
            } else {
                $scope.poBoxNotifications[el] = false;
            }
        }

        $scope.selectedShareholderIndex = -1;
        $scope.selectedShareholder = null;

        $scope.displayTypeSelector = false;

        $scope.profile_exists = false;
        $scope.documents_exist = false;

        $scope.hasActionRequiredGateway = null;

        $scope.loading = true;

        $scope.addShareholder = addShareholder;
        $scope.profileTab = 'corporate';
        $scope.setProfileTab = setProfileTab;

        Auth.getProfile(true).then(function (data) {

            $scope.loading = false;

            $scope.user = data.identity;
            authUser = data;

            profile = data.identity.profile; // User UUID
            User = IDRestangular.one('users', authUser.uid); // Auth

            if($state.current.name == 'identity' && authUser.identity){
                if(authUser.identity.verification_level > 0){
                    $state.go('settings.identity'); // don't allow user type change if identity already exists - redirect!
                } else if (authUser.identity.phone_number && authUser.identity.verification_level < 1){
                    $state.go('identity.form.phone'); // if phone is entered, but not confirmed yet, still redirect user to phone form
                } else {
                    $scope.displayTypeSelector = true;
                }
            } else {
                $scope.displayTypeSelector = true;
            }

            $scope.profile = angular.copy(profile);

            $scope.checkMiddleName = function() {
                if ($scope.middle_name_checked && $scope.profile.middle_name) {
                    $scope.profile.middle_name = null;
                }
            };

            $scope.companyProfile = data.identity.companyProfile;

            if(!$scope.companyProfile.profiles || $scope.companyProfile.profiles.length == 0){
                $scope.companyProfile.profiles = [];
            }

            if (data.identity.user_type === 0) {
                setProfileCheckboxes($scope.profile);
            }
            else if (data.identity.user_type === 1) {
                setProfileCheckboxes($scope.companyProfile);
            }


            // check if profile exists
            if($scope.profile.address_country_code || $scope.companyProfile.legal_name){
                $scope.profile_exists = true;
            }

            // check if documents exist
            if(data.identity.user_type != 1){ // individual profile
              $scope.documents_exist = Documents.requiredDocumentsUploaded(data.identity.profile.documents);
            } else { // company profile
              $scope.documents_exist = Documents.requiredCompanyDocumentsUploaded(data.identity.companyProfile.documents);
            }


            if($scope.profile.documents && $scope.profile.documents > 0){
                $scope.documents_exist = true;
            }

            var incorporated_on = moment(data.identity.companyProfile.incorporated_on);

            $scope.companyProfile.incorporated_year = incorporated_on.year();
            $scope.companyProfile.incorporated_month = incorporated_on.month() + 1;
            $scope.companyProfile.incorporated_day = incorporated_on.date();


            $scope.baseUser = $sessionStorage.user;

            $scope.show_close_warning = false;

            // Connected gateways (note: even inactive ones like Fifth are included here)
            CoreRestangular.one('users', authUser.uid).all('gateways').getList().then(function (data) {

                var gateways = data.plain();

                // User either connected to a gateway or pending
                if (gateways.length == 0) {
                    $scope.profile_edit_allowed = true;
                    return;
                };

                // User has a gateway with "Action required" status
                $scope.hasActionRequiredGateway = false;
                for (var i = 0; i < gateways.length; i++) {
                    if (gateways[i].status === 3) {
                        $scope.hasActionRequiredGateway = true;
                    }
                }
            });

        }, function(error){
            $exceptionHandler(error);
        });

        function setProfileCheckboxes(profile) {
            if (_.isEmpty(profile)) {
                console.error('Empty profile');
                return;
            }
            // Middle Name
            $scope.middle_name_checked = ($scope.profile.first_name || $scope.profile.last_name) && !$scope.profile.middle_name;

            // Source of Funds
            if (!Array.isArray(profile.source_of_funds)) {
                profile.source_of_funds = [];
            }
            $scope.source_of_funds.forEach(function(item) {
                if (profile.source_of_funds.indexOf(item.key) > -1) {
                    item.checked = true;
                } else {
                    item.checked = false;
                }
            });


            // Reason for opening account
            if (!Array.isArray(profile.opening_reason)) {
                profile.opening_reason = [];
            }
            if (profile.opening_reason) {
                $scope.opening_reason.forEach(function(item) {
                    if(profile.opening_reason.indexOf(item.key) > -1) {
                        item.checked = true;
                    } else {
                        item.checked = false;
                    }
                });
            }

            if (profile.is_vat_registered !== undefined) {
                profile.is_vat_registered = profile.is_vat_registered || false;
            }
        }

        // Reset
        $scope.profileForm = {};
        $scope.sending = false;
        $scope.errorMessage = false;
        $scope.success_message = false;
        $scope.profile_edit_allowed = false;

        // Fill out form data
        var thisYear = new Date().getFullYear();
        var years = [];
        var days = [];

        for (var i = thisYear; i >= (thisYear - 100); i--) {
            years.push(i);
        };
        for (var i = 1; i < 32; i++) {
            days.push(i);
        };

        $scope.countries = Countries.filteredCountries;
        $scope.allCountries = Countries.allCountries;
        $scope.years = years;
        $scope.days = days;

        $scope.months = [
            { k: 1, l: "Jan" },
            { k: 2, l: "Feb" },
            { k: 3, l: "Mar" },
            { k: 4, l: "Apr" },
            { k: 5, l: "May" },
            { k: 6, l: "Jun" },
            { k: 7, l: "Jul" },
            { k: 8, l: "Aug" },
            { k: 9, l: "Sep" },
            { k: 10, l: "Oct" },
            { k: 11, l: "Nov" },
            { k: 12, l: "Dec" }
        ];

        $scope.source_of_funds = [
            { checked: false, key: "SALARY", label: "Salary" },
            { checked: false, key: "SAVINGS", label: "Savings" },
            { checked: false, key: "TRADING_PROFITS", label: "Trading profits" },
            { checked: false, key: "OTHER", label: "Other (Inheritance, gift, loan, sale of real estate, grants, lottery winnings, etc.)" }
        ];

        $scope.source_of_funds_company = [
            { checked: false, key: "BUSINESS_PROFITS", label: "Business profits" },
            { checked: false, key: "BUSINESS_CAPITAL", label: "Business capital" },
            { checked: false, key: "TRADING_ACTIVITY", label: "Trading activity" },
            { checked: false, key: "INVESTMENTS", label: "Investments" },
            { checked: false, key: "ACCEPTING_PAYMENT", label: "Accepted payments from customers" },
            { checked: false, key: "OTHER", label: "Other (Issue of additional shares, etc.)" }
        ];

        $scope.expected_volume = [
            { k: '10k', l: "0 - $10,000.00 per year" },
            { k: '25k', l: "$10,000.00 - $25,000.00 per year" },
            { k: '50k', l: "$25,000.00 - $50,000.00 per year" },
            { k: '100k', l: "$50,000.00 - $100,000.00 per year" },
            { k: '100k+', l: "$100,000.00 per year or more" },
        ];

        // warning before you change: opening_reason is used both on individual and company forms
        $scope.opening_reason = [
            { checked: false, key: "TRADING", label: "Trading" },
            { checked: false, key: "SENDING_OR_RECEIVING_CRYPTO", label: "Sending or receiving crypto payments" },
            { checked: false, key: "PURCHASING_CRYPTO", label: "Purchasing crypto assets" },
            { checked: false, key: "HOLDING_CRYPTO", label: "Holding crypto assets" },
            { checked: false, key: "RECEIVING_MINING_PROFITS", label: "Receiving mining profits" }
        ];

        $scope.companyTypes = [
            { k: 0, l: "PLC, AG, SA, Spa, K.K or equivalent" },
            { k: 1, l: "LTD, GmBH, SARL, Srl, G.K. or equivalent" },
            { k: 2, l: "Partnership, LLC, KG, SNC, Ss, GMK or equivalent" },
            { k: 3, l: "Trusts, Funds, Associations or equivalent" },
            { k: 4, l: "Other, not specified" }
        ];

        $scope.purposes = [
            { k: 0, l: "Merchant" },
            { k: 1, l: "Broker" },
            { k: 2, l: "Arbitrage" },
            { k: 3, l: "Trading" },
            { k: 4, l: "Hedging" },
            { k: 5, l: "Other" }
        ];

        $scope.sourceOfFundsTouched = false;
        $scope.updateSourceOfFunds = function() {
            $scope.sourceOfFundsTouched = true;
            $scope.profile.source_of_funds = $scope.source_of_funds
                .filter(function(filter) { return filter.checked })
                .map(function(item) { return item.key });
        }

        $scope.openingReasonTouched = false;
        $scope.updateOpeningReason = function() {
            $scope.openingReasonTouched = true;
            $scope.profile.opening_reason = $scope.opening_reason
                .filter(function(filter) { return filter.checked })
                .map(function(item) { return item.key });
        }

        // COMPANY //

        $scope.sourceOfFundsCompanyTouched = false;
        $scope.updateSourceOfFundsCompany = function() {
            $scope.sourceOfFundsCompanyTouched = true;
            $scope.companyProfile.source_of_funds = $scope.source_of_funds_company
                .filter(function(filter) { return filter.checked })
                .map(function(item) { return item.key });
        }

        $scope.openingReasonCompanyTouched = false;
        $scope.updateOpeningReasonCompany = function() {
            $scope.openingReasonCompanyTouched = true;
            $scope.companyProfile.opening_reason = $scope.opening_reason
                .filter(function(filter) { return filter.checked })
                .map(function(item) { return item.key });
        }

        ///////////////////////////////////////////////////////////

        $scope.isProfileFormValid = function(isValid) {
            return isValid && $scope.profile
                && $scope.profile.source_of_funds && $scope.profile.source_of_funds.length
                && $scope.profile.opening_reason && $scope.profile.opening_reason.length;
        }

        $scope.isCompanyProfileFormValid = function(isValid) {
            return isValid &&
                $scope.companyProfile.profiles.length &&
                $scope.companyProfile.source_of_funds.length &&
                $scope.companyProfile.opening_reason.length;
        }

        // Form submit (if valid)
        $scope.submitForm = function (isValid) {

            $scope.errorMessage = false;
            $scope.success_message = false;

            // Make sure the form is completely valid
            if (!isValid) {
                $scope.errorMessage = "One or more required fields are invalid";
                $scope.sending = false;
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                return;
            }

            // Check for birth date
            if ($scope.verifyDate($scope.profile.birth_year, $scope.profile.birth_month, $scope.profile.birth_day) !== "error") {

                $scope.sending = true;
                //$scope.profile.address_country_code = $scope.profile.address_country_code.code;

                delete $scope.profile.uuid;
                delete $scope.profile.created_at;
                delete $scope.profile.photoURL;
                delete $scope.profile.birth_date;
                delete $scope.profile.documents_uploaded;
                delete $scope.profile.address_street2;

                var _profile = angular.copy($scope.profile);

                clearEmptyStrings(_profile);

                // Get international phone number
                //$scope.profile.phone_number = "+"+$scope.profile.phone_number;

                User.post('profiles', _profile).then(function (data) {

                    if (angular.isArray(data)) {
                        $scope.messages = data;
                    };

                    $state.go('identity.form.documents');

                }, function (error) {

                    if (!angular.isUndefined(error) && error.data != null) {
                        if (error.data.developerMessage) {
                            if (Array.isArray(error.data.developerMessage)) {
                                $scope.errorMessage = error.data.developerMessage[0].message;
                            }
                            else if (typeof error.data.developerMessage == 'string') {
                                $scope.errorMessage = error.data.developerMessage;
                            }
                            else {
                                $scope.errorMessage = "Identity error.";
                            }

                            // from now on ignore 'No difference from last profile' errors and proceed to documents upload
                            if ($scope.errorMessage === 'No difference from last profile') {
                                $state.go('identity.form.documents');
                                return;
                            }
                        }
                        $exceptionHandler(error);
                    }
                    else {
                        $scope.errorMessage = "Error creating profile.";
                        $exceptionHandler("Error creating profile", error);
                    };

                    $scope.sending = false;

                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                    return;
                });
            }
        };

        // Form submit (if valid)
        $scope.submitCompanyForm = function (isValid) {

            $scope.errorMessage = false;
            $scope.success_message = false;

            // Make sure the form is completely valid
            if (!isValid) {
                $scope.errorMessage = "One or more required fields are invalid";
                $scope.sending = false;
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                return;
            }

            // Check date
            if ($scope.isValidDate($scope.companyProfile.incorporated_year, $scope.companyProfile.incorporated_month, $scope.companyProfile.incorporated_day) === false) {
                $scope.errorMessage = "Incorporation date is invalid";
                $scope.sending = false;
                setProfileTab('corporate', true);
                return;
            }

            // Also check all profile dates
            var allDatesValid = true;
            var allPersonsOfLegalAge = true;
            for(var i in $scope.companyProfile.profiles){
                if($scope.companyProfile.profiles[i] !== null && typeof $scope.companyProfile.profiles[i] === 'object'){
                    if ($scope.isValidDate($scope.companyProfile.profiles[i].birth_year, $scope.companyProfile.profiles[i].birth_month, $scope.companyProfile.profiles[i].birth_day) === false) {
                        allDatesValid = false;
                        break;
                    }
                    if ($scope.verifyDate($scope.companyProfile.profiles[i].birth_year, $scope.companyProfile.profiles[i].birth_month, $scope.companyProfile.profiles[i].birth_day) === "error") {
                        allPersonsOfLegalAge = false;
                        break;
                    }
                }
            }
            if(!allDatesValid){
                $scope.errorMessage = "At least one person with significant control has an invalid birth date";
                $scope.sending = false;
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                return;
            }
            if(!allPersonsOfLegalAge){
                $scope.errorMessage = "All persons with significant control must be 18+.";
                $scope.sending = false;
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                return;
            }

            var companyProfileFormData = angular.copy($scope.companyProfile);

            companyProfileFormData.incorporated_on = moment($scope.companyProfile.incorporated_day + "." + $scope.companyProfile.incorporated_month + "." + $scope.companyProfile.incorporated_year, "D.M.YYYY").toISOString();

            // convert profiles object to array
            var profiles_array = [];
            for(var i in companyProfileFormData.profiles){
                if(companyProfileFormData.profiles[i] !== null && typeof companyProfileFormData.profiles[i] === 'object'){
                    delete companyProfileFormData.profiles[i].uuid;

                    clearEmptyStrings(companyProfileFormData.profiles[i]);

                    profiles_array.push(companyProfileFormData.profiles[i]);

                    //TODO: validate individual birthdays
                }
            }
            companyProfileFormData.profiles = profiles_array;

            delete companyProfileFormData.uuid;
            delete companyProfileFormData.created_at;
            delete companyProfileFormData.documents;
            delete companyProfileFormData.incorporated_day;
            delete companyProfileFormData.incorporated_month;
            delete companyProfileFormData.incorporated_year;

            var _companyProfile = angular.copy(companyProfileFormData);

            clearEmptyStrings(_companyProfile);


            $scope.sending = true;

            User.post('companyProfiles', _companyProfile).then(function (data) {

                if (angular.isArray(data)) {
                    $scope.messages = data;
                };

                $state.go('identity.form.documents');

            }, function (error) {
                if (!angular.isUndefined(error) && error.data != null) {
                    if (error.data.developerMessage) {
                        if (Array.isArray(error.data.developerMessage)) {
                            $scope.errorMessage = error.data.developerMessage[0].message;
                        }
                        else if (typeof error.data.developerMessage == 'string') {
                            $scope.errorMessage = error.data.developerMessage;
                        }
                        else {
                            $scope.errorMessage = "Identity error.";
                        }
                    }
                    $exceptionHandler("Identity error", error.data);
                }
                else {
                    $scope.errorMessage = "Error on creating profile.";
                    $exceptionHandler("Error on creating company profile", error);
                };

                $scope.sending = false;

                document.body.scrollTop = document.documentElement.scrollTop = 0;
                return;

            });
        };

        $scope.setUserType = function (type) {
            User.customPUT({ user_type: type }).then(function (res) {
                $state.go('identity.form.phone');
            }, function (error) {
                $exceptionHandler(error);
                $state.go('identity.form.phone');
            });

        };

        $scope.verifyDate = function (year, month, day) {

            var date = new Date(year, month - 1, day);

            if (moment().diff(moment(date), 'years') < 18) {
                $scope.errorMessage = "You must be 18+";
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                return "error";
            } else
                return true;

        };

        $scope.isValidDate = function (year, month, day){
            return moment(year+'-'+month+'-'+day, 'YYYY-MM-DD').isValid();
        }

        $scope.closeAccountModal = function (name) {
            var modalInstance = $uibModal.open({
                templateUrl: 'views/identity/modal_close_account.html',
                controller: 'ModalCtrl',
                resolve: {
                    data: function () {
                        return name;
                    }
                }
            });
        };

        $scope.showCloseAccWarning = function(show){
            if(show){
                $scope.show_close_warning = true;
            } else {
                $scope.show_close_warning = false;
            }
        }

        $scope.editShareholder = function(index) {
            console.log('Edit shareholder', index);
            if(isNaN(index) || index < 0){
                $scope.selectedShareholderIndex = -1;
                $scope.selectedShareholder = {};
                setProfileTab('shareholders', true);
            }
            else if (index < $scope.companyProfile.profiles.length ) {
                $scope.selectedShareholderIndex = index;
                $scope.selectedShareholder = Object.assign({}, $scope.companyProfile.profiles[index]);
                setProfileTab('shareholders', true);
            }
            else {
                $scope.selectedShareholderIndex = -1;
                $scope.selectedShareholder = null;
                console.error('Shareholder index out of range');
            }
        }

        $scope.deleteShareholder = function(index) {
            if(index < $scope.companyProfile.profiles.length){
                $scope.companyProfile.profiles.splice(index,1);
            }
        }
        $scope.saveShareholder = function(form) {
            var index = $scope.selectedShareholderIndex;
            if(isNaN(index) || index < 0){
                $scope.companyProfile.profiles.push($scope.selectedShareholder);
            }
            else {
                $scope.companyProfile.profiles[index] = $scope.selectedShareholder;
            }
            $scope.selectedShareholderIndex = -1;
            $scope.selectedShareholder = null;
            form.$setPristine();
            form.$setUntouched();

            setProfileTab('corporate');
        }

        function addShareholder() {
            $scope.companyProfile.profiles = $scope.companyProfile.profiles || [];
            $scope.companyProfile.profiles.push({});
            $scope.selectedShareholder = $scope.companyProfile.profiles.length - 1;
        }

        function setProfileTab(profileTab, scrollToTop){
            $scope.profileTab = profileTab;
            if(scrollToTop){
                document.body.scrollTop = document.documentElement.scrollTop = 0;
            }
        }

        // id does not like empty strings, clear them
        function clearEmptyStrings(object) {
            for (var key in object) {
                if (object.hasOwnProperty(key)) {
                    var value = object[key];
                    if (value === undefined || value === '') {
                        object[key] = null;
                    }
                }
            }

            return object;
        }
    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:IdentityDocumentsCtrl
 * @description
 * # IdentityDocumentsCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('IdentityDocumentsCtrl', ["$uibModal", "$uibModalStack", "$scope", "$state", "$sessionStorage", "ENV", "IDRestangular", "Auth", "Documents", "$q", "$exceptionHandler", "$window", "Countries", "$sce", "$timeout", "$interval", function ($uibModal, $uibModalStack, $scope, $state, $sessionStorage, ENV, IDRestangular, Auth, Documents, $q, $exceptionHandler, $window, Countries, $sce, $timeout, $interval) {

        var authUser = null;
        var eidOcrAuthorizationFailCounter = 0;

        $scope.loading = true;
        $scope.docsTab = 'corporate';
        $scope.setDocsTab = setDocsTab;
        $scope.latinAllow = "^[A-Za-z0-9\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u017F\-' ]+$";

        $scope.documents = [];
        $scope.uploadingForm = false;

        // Fill out form data
        var thisYear = new Date().getFullYear();
        var years = [];
        var days = [];
        for (var i = thisYear; i <= (thisYear + 100); i++) {
            years.push(i);
        };
        for (var i = 1; i < 32; i++) {
            days.push( ("0"+i).slice(-2) ); // pad with zeros, always display as 'DD' (required by backend)
        };
        $scope.years = years;
        $scope.days = days;
        $scope.months = [
            { k: "01", l: "Jan" },
            { k: "02", l: "Feb" },
            { k: "03", l: "Mar" },
            { k: "04", l: "Apr" },
            { k: "05", l: "May" },
            { k: "06", l: "Jun" },
            { k: "07", l: "Jul" },
            { k: "08", l: "Aug" },
            { k: "09", l: "Sep" },
            { k: "10", l: "Oct" },
            { k: "11", l: "Nov" },
            { k: "12", l: "Dec" }
        ];

        $scope.documentStatus = {
            certificate: { uploaded: false, opened: false },
            structure: { uploaded: false, opened: false },
            annualreturn: { uploaded: false, opened: false },
            resolution: { uploaded: false, opened: false },
            bankstatement: { uploaded: false, opened: false },
            additional: { uploaded: false, opened: false }
        }
        $scope.selectedShareholderIndex = 0;
        $scope.documentTypeChanged = function() {
            this.documentsForm.pidValue.$setDirty();
        }

        var _files = {
            personal: createPersonalDocuments(),
            corporate: {
                certificate: [],
                structure: [],
                annualreturn: [],
                resolution: [],
                bankstatement: [],
                additional: []
            },
            shareholders: [] // gets filled with createPersonalDocuments() for each shareholder profile
        };

        function createPersonalDocuments(){
            return {
                pid: {
                    personal_identification_front: [],
                    personal_identification: [],
                    drivers_license_front: [],
                    drivers_license: [],
                    passport: []
                },
                por: {
                    bank_statement: [],
                    government_statement: [],
                    utility_bill: []
                },
            };
        }

        Auth.getProfile(true).then(function (data) {
            $scope.user = data.identity.plain();

            // if individual user, check eID eligibility!
            if($scope.user.user_type === 0 || $scope.user.user_type === null) {
                checkEidEligibilty();
            }

            if(typeof data.identity != 'undefined') {
                $scope.user.allowedAllDocuments = Documents.allowedAllDocuments(data.identity.profile.address_country_code);
            }
            authUser = data;

            if(data.identity.companyProfile && data.identity.companyProfile.profiles && data.identity.companyProfile.profiles.length > 0) {
                var profiles = data.identity.companyProfile.profiles;

                for(var i = 0; i < profiles.length; i++){
                    $scope.documents.push({
                        pidType: null,
                        porType: null
                    });
                    _files.shareholders.push( createPersonalDocuments() );

                }
            } else {
                $scope.documents = {
                    pidType: null,
                    porType: null
                };
            }

            $scope.loading = false;
        }, function(error){
            $exceptionHandler(error);
        });

        // Reset
        $scope.documentsForm = {};

        $scope.sending = false;
        $scope.errorMessage = false;
        $scope.success_message = false;


         // Form submit (if valid)
        $scope.submitForm = function (isValid) {

            $scope.errorMessage = false;
            $scope.success_message = false;
            $scope.uploadingForm = true;

            // Make sure the form is completely valid
            if (!isValid) {
                $scope.errorMessage = "One or more required fields are invalid";
                $scope.sending = false;
                // Scroll to top
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                return;
            }

            $scope.sending = true;

            var uploads = [];

            for(var type in _files.personal) {
                for(var subtype in _files.personal[type]) {
                    if(_files.personal[type][subtype].length) {
                        for(var i in _files.personal[type][subtype]) {
                            var serialNumber = (type === 'pid') ? $scope.documents.pidValue : undefined;
                            var expiryDate = (type === 'pid') ?
                                $scope.documents.expiry_year + "-" + $scope.documents.expiry_month + "-" + $scope.documents.expiry_day : undefined;
                            var postData = {
                                type: type,
                                subtype: subtype,
                                value: serialNumber,
                                uuid: _files.personal[type][subtype][i].data.id,
                                expiry_date: expiryDate
                            };
                            uploads.push(postData);
                        }
                    }
                }
            }

           var uuidUnique = {};
           uploads = uploads.filter(function(item) {
             if (uuidUnique[item.uuid]) {
               return false;
             }
             return uuidUnique[item.uuid] = true;
           });

            IDRestangular.one('profiles', authUser.identity.profile.uuid).all('documents').post(uploads).then(function () {
                Auth.getProfile(true).then(function (data) {
                    if (!data.identity.hubs || !data.identity.hubs.length) {
                        // AUTO CONNECT GATEWAYS
                        /*
                        autoConnectGateways(authUser.id).then(responses => {
                            $state.go('wallets');
                        })
                        .catch(error => {
                            $exceptionHandler('Auto-connect gateways failed', error);
                            $state.go('settings.gateways');
                        });
                        */

                        // MANUALLY CONNECT GATEWAYS
                        $state.go('settings.gateways');
                    } else {
                        $state.go('wallets');
                    }
                    $scope.uploadingForm = false;
                }, function(error) {
                    $scope.uploadingForm = false;
                    $exceptionHandler(error);
                    $state.go('settings.gateways');
                });
            }, function (error) {
                $scope.uploadingForm = false;
                if (error.data && error.data.developerMessage) {
                    $scope.errorMessage = error.data.developerMessage;
                } else {
                    $scope.errorMessage = "Identity error";
                }
                // Scroll to top
                document.body.scrollTop = document.documentElement.scrollTop = 0;

                $scope.sending = false;
                $exceptionHandler(error);
            });
        };

        $scope.submitCompanyForm = function(isValid) {

            $scope.uploadingForm = true;
            $scope.errorMessage = false;
            $scope.success_message = false;

            // Make sure the form is completely valid
            if (!isValid) {
                $scope.errorMessage = "One or more required fields are invalid";
                $scope.sending = false;
                document.body.scrollTop = document.documentElement.scrollTop = 0; // Scroll to top
                return;
            }

            $scope.sending = true;

            var uploads = [];
            for(var subtype in _files.corporate){
                if( _files.corporate[subtype].length ){
                    for(var i = 0; i < _files.corporate[subtype].length; i++){
                        var postData = {
                            type: "corporate",
                            subtype: subtype,
                            uuid: _files.corporate[subtype][i].data.id
                        };
                        uploads.push(postData);
                    }
                }
            }
            for(var shareholderIndex in _files.shareholders){
                for(var type in _files.shareholders[shareholderIndex]){
                    for(var subtype in _files.shareholders[shareholderIndex][type]){
                        if(_files.shareholders[shareholderIndex][type][subtype].length){
                            for(var i in _files.shareholders[shareholderIndex][type][subtype]){
                                var serialNumber = (type === 'pid') ? $scope.documents[shareholderIndex].pidValue : undefined;
                                var expiryDate = (type === 'pid') ?
                                $scope.documents[shareholderIndex].expiry_year + "-" + $scope.documents[shareholderIndex].expiry_month + "-" + $scope.documents[shareholderIndex].expiry_day : undefined;
                                var postData = {
                                    type: type,
                                    subtype: subtype,
                                    value: serialNumber,
                                    uuid: _files.shareholders[shareholderIndex][type][subtype][i].data.id,
                                    company_profiles_profile: authUser.identity.companyProfile.profiles[shareholderIndex].uuid,
                                    expiry_date: expiryDate
                                };
                                uploads.push(postData);
                            }
                        }
                    }
                }
            }
            var uuidUnique = {};
            uploads = uploads.filter(function(item) {
              if (uuidUnique[item.uuid]) {
                return false;
              }
              return uuidUnique[item.uuid] = true;
            });


            if (!authUser.identity.companyProfile.uuid) {
                console.error('No company profile uuid')
            }
            IDRestangular.one('companyProfiles', authUser.identity.companyProfile.uuid).all('documents').post(uploads).then(function () {
                // force user refresh to load documents, else you get redirected back to documents page
                Auth.getProfile(true).finally(function () {
                    $scope.uploadingForm = false;
                    $state.go('settings.gateways');
                })
            }, function (error) {
                $scope.sending = false;

                if (error.data && error.data.developerMessage) {
                    $scope.errorMessage = error.data.developerMessage;
                } else {
                    $scope.errorMessage = "Error saving files";
                }

                // Scroll to top
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                $scope.uploadingForm = false;
                $exceptionHandler(error);
            });
        }

        $scope.removeFile = function (index, id) {

            var keys = id.split(".");
            var category = keys[0] || null;
            var key1 = keys[1] || null;
            var key2 = keys[2] || null;
            var key3 = keys[3] || null;

            switch(category){
                case 'corporate':
                    var type = key1;
                    _files['corporate'][type].splice(index, 1);
                    break;
                case 'personal':
                    var type = key1;
                    var subtype = key2;
                    _files['personal'][type][subtype].splice(index, 1);
                    break;
                case 'shareholders':
                    var shareholderIndex = key1;
                    var type = key2;
                    var subtype = key3;
                    _files['shareholders'][shareholderIndex][type][subtype].splice(index, 1);
                    break;
            }
        }


        $scope.open = function (name) {
            var modalInstance = $uibModal.open({
                templateUrl: 'views/identity/modal.html',
                controller: 'ModalCtrl',
                resolve: {
                    data: function () {
                        return name;
                    }
                }
            });
        };

        $scope.formValid = function(type) {
            var v = _files.por.length > 0;
            switch(type) {
                case "passport":
                    return v && !!_files.passport;
                default:
                    return v && !!_files[type].front && !!_files[type].back;
            }
        };

        $scope.setPidType = function(type, index) {
            console.log(type, index);
            if(typeof index === "undefined"){
                $scope.documents.pidType = type;
            } else {
                $scope.documents[index].pidType = type;
            }
        };

        $scope.setPorType = function(type, index){
            if(typeof index === "undefined"){
                $scope.documents.porType = type;
            } else {
                $scope.documents[index].porType = type;
            }
        };

        /***************** AF - start ***********************/
        $scope.dlFiles = _files;
        $scope.getFileUploadOptions = function() {
            return {
                url: ENV.apiStorage + "/verification",
                file: undefined,
                headers: { 'Authorization': 'Bearer ' + getLatestAccessToken() }, // only for html5
            }
        };
        $scope.uploadSuccess = function(id, documentId) {
            console.log('upload success', id, $scope.dlFiles, documentId);
            if (documentId && $scope.documentStatus[documentId]) {
                $scope.documentStatus[documentId].uploaded = true;
            }
        };
        $scope.uploadError = function(id, error) {
            console.log('uploadError', id, error);
            if (error) {
                document.body.scrollTop = document.documentElement.scrollTop = 0;
            }
        };
        $scope.showError = function(error) {
            $scope.errorMessage = error;
            if (error) {
                document.body.scrollTop = document.documentElement.scrollTop = 0;
            }
        };
        /***************** AF - end ***********************/
        function getLatestAccessToken(){
            var latestToken = $sessionStorage.token.access_token;
            return latestToken;
        }

        $scope.uploadRequirementsMet = function( type ){

            // UNTIL WE HAVE A BETTER FLOW, ALWAYS ALLOW COMPANIES TO CONTINUE --- pre 29.05.2019
            /*
            if(type == 'corporate' || type == 'shareholders'){
                return true;
            }
            */

            // UNTIL WE HAVE A BETTER FLOW, ALWAYS ALLOW SHAREHOLDERS TO CONTINUE --- post 29.05.2019
            if(type == 'shareholders'){
              return true;
            }

            // from 29.05.2019 do require certificate of incorporation for companies
            if(type == 'corporate'){
                if( corporateOK( _files.corporate ) ){
                    return true;
                }
            }
            /*
            if(type == 'shareholders'){
                if( shareholdersOK( _files.shareholders ) ){
                    return true;
                }
            }
            */

            if(type == 'individual'){
                // if profile already exists and selected POR is Bank Statement, require only the latter
                if(isBankStatementSpecialCase()){
                    return porOK( _files.personal.por);
                }

                // else check both
                if( pidOK( _files.personal.pid ) && porOK( _files.personal.por ) ){
                    return true;
                }
            }

            return false;
        }

        $scope.isBankStatementSpecialCase = isBankStatementSpecialCase;
        function isBankStatementSpecialCase(){
            var isBankStatement = $scope.documents.porType === "bank_statement"
            var isVerified = authUser.identity.verification_level > 1; // required: 2 (Fourstop verified) or 3 (manually verified)
            return isBankStatement && isVerified;
        }

        // require at least one PID document (both sides if not passport)
        function pidOK(pidFiles){
            if( (pidFiles.personal_identification.length && pidFiles.personal_identification_front.length)
             || (pidFiles.drivers_license.length && pidFiles.drivers_license_front.length)
             || (pidFiles.passport.length) ){
                return true;
            }
            return false;
        }

        // require at least one POR document
        function porOK(porFiles){
            if( porFiles.bank_statement.length || porFiles.government_statement.length || porFiles.utility_bill.length ){
                return true;
            }
            return false;
        }

        // require at least one certificate of incorporation - from 29.05.2019 bank statement not required immediately anymore
        function corporateOK(corporateFiles){
            if( corporateFiles.certificate.length ){
                return true;
            }
            return false;
        }

        // require at least one PID document (both sides if not passport) for each shareholder
        function shareholdersOK( shareholderFiles ){
            for(var shareholderIndex in shareholderFiles){
                if( (shareholderFiles[shareholderIndex].pid.personal_identification.length && shareholderFiles[shareholderIndex].pid.personal_identification_front.length)
                || (shareholderFiles[shareholderIndex].pid.drivers_license.length && shareholderFiles[shareholderIndex].pid.drivers_license_front.length)
                || (shareholderFiles[shareholderIndex].pid.passport.length) ){
                    // PID found for shareholder - OK
                } else {
                    return false;
                }
            }
            return true;
        }


        function setDocsTab(docsTab, scrollToTop) {
            scrollToTop = scrollToTop || false;
            $scope.docsTab = docsTab;
            if(scrollToTop){
                document.body.scrollTop = document.documentElement.scrollTop = 0;
            }
        }

        $scope.toggleSection = function(id) {
            $scope.documentStatus[id].opened = !$scope.documentStatus[id].opened;
        }

        $scope.editShareholder = function(index) {
            $scope.selectedShareholderIndex = index;
            setDocsTab('shareholders', true)
        }

        function autoConnectGateways(userId) {
            var gatehubUabGw = ENV.vaults.find(vault => vault.gateway_name === 'GateHub UAB');
            if (gatehubUabGw) {
                return IDRestangular.one('users', userId).all('hubs').all(gatehubUabGw.gateway_uid).post();
            } else {
                $exceptionHandler('GateHub UAB gateway not found');
            }
        }

        // -------------------------- eID -------------------------- //
        $scope.eidState = 'start';
        $scope.isEidSupportedCountry = null;
        let statePollingInterval; // is eid flow completed and pending result?
        let resultPollingInterval; // result of video verification (success / rejected)
        let stream;
        let cameraConstraints = {
            audio: false,
            video: true
        };

        function checkCamera() {
            $scope.hasCamera = null; // (null|true|false)
            try {
                $window.navigator.mediaDevices.getUserMedia(cameraConstraints)
                    .then(function(userMedia) {
                        stream = userMedia;
                        $scope.$apply(function(){
                            $scope.hasCamera = !!stream.id;
                        });
                    })
                    .catch(function(err) {
                        $scope.$apply(function(){
                            $scope.hasCamera = false;
                        });
                    })
                    .finally(function() {
                        if (stream) {
                            stopStream(stream);
                        }
                    });
            } catch(error) {
                $scope.$apply(function(){
                    $scope.hasCamera = false;
                });
            }
        }

        // Listen to camera permission changes
        if($window.navigator && $window.navigator.permissions) {
            $window.navigator.permissions.query({name: "camera"}).then(
                (cameraStatus) => {
                    cameraStatus.addEventListener("change", (evt) => {
                        checkCamera();
                    });
                },
                (error) => {
                    console.log('Camera Permissions API is not supported in this browser.');
                }
            );
        }

        function stopStream(mediaStream) {
            mediaStream.getAudioTracks().forEach((track) => {
                track.stop();
            });
            mediaStream.getVideoTracks().forEach((track) => {
                track.stop();
            });
            mediaStream = null;
        }

        function setVerificationUrl(hostname, authorization) {
            const url = new URL(hostname);
            url.searchParams.set('authorization', authorization);
            return $sce.trustAsResourceUrl(url.toString());
        }

        function checkEidEligibilty() {
            Countries.isEidSupported($scope.user.profile.citizenship).then(function(isSupported) {
                $scope.isEidSupportedCountry = isSupported;
                if(isSupported) {
                    const verifications = $scope.user.verifications;
                    const isPending = checkIfVideoVerificationPending(verifications);
                    if (isPending) {
                        $scope.eidState = 'pending';
                        startPollingVideoVerificationState(); // start polling for verification result, if user is already pending when he opens this page
                    } else {
                        checkCamera();
                        $window.addEventListener("message", handleEidEvent, false); // Listen to eID events
                        eidOcrAuthorizationFailCounter = 0;
                        requestEidOcrAuthorization();
                    }
                }
            }, function(error) {
                $scope.isEidSupportedCountry = false;
                $exceptionHandler('Error checking if country is eid supported', error);
            });
        }

        function requestEidOcrAuthorization() {
            IDRestangular.one('users/requestEidOcrAuthorization').post().then(handleEidOcrAuthorization, handleEidOcrAuthorizationError);
        }

        function handleEidOcrAuthorization(eidData) {
            const authorization = eidData.access_token_metadata.authorization;
            if (authorization) {
                $scope.eidUrl = setVerificationUrl(ENV.eidPortalUrl, authorization);
            } else {
                console.log('Bad requestEidOcrAuthorization response!');
            }
        }
        
        function handleEidOcrAuthorizationError(error) {
            eidOcrAuthorizationFailCounter++;
            if (eidOcrAuthorizationFailCounter >= 5) {
                console.log('5 failed requestEidOcrAuthorization attempts!');
                $scope.errorMessage = 'Failed getting video verification authorisation. Please try again later.';
                $exceptionHandler(error);
            } else {
                let retryTime = 2000 * eidOcrAuthorizationFailCounter; // gradually increase retry interval
                $timeout(requestEidOcrAuthorization, retryTime);
            }
        }

        // runs via directive on iframe
        $scope.initIframeResizer = function(iframeId) {
            iFrameResize({
                autoResize: true,
                checkOrigin: false,
                resizeFrom: 'child',
                heightCalculationMethod: 'lowestElement'
            }, '#'+iframeId);
        }

        function handleEidEvent(event) {
            if(event.origin !== ENV.eidPortalUrl) {
                return;
            }
            switch(event.data.type) {
                case 'MissingParamsError':
                    break;
                case 'VerificationSuccess': // event triggered when user finishes eid UI flow (doesn't mean they're already verified!)
                    $scope.eidState = 'pending';
                    refreshAuthUser();
                    startPollingVideoVerificationState(); // start polling for verification result, if user just completed the eid UI flow
                    break;
                case 'VerificationError':
                    break;
                case 'DisplayQRCodeCommand':
                    openQRCodeModal();
                    break;
                default:
                    if (typeof event.data === 'string' && event.data.indexOf('iFrameSizer')) {
                        // ignore IframeSizer events
                    } else {
                        console.log('eID: unknown event:', event);
                    }
                    break;
            }
        }

        $scope.waitingForCamera = waitingForCamera;
        function waitingForCamera() {
            return isIndividual() && $scope.isEidSupportedCountry && $scope.hasCamera === null;
        }

        $scope.isIndividual = isIndividual;
        function isIndividual() {
            if (!$scope.user) {
                return;
            }
            return $scope.user.user_type === 0 || $scope.user.user_type === null;
        }

        function refreshAuthUser() {
            // just refresh by passing true to getProfile,
            // we need it for router guards in app.js
            Auth.getProfile(true).then(function() {});
        }

        $scope.openQRCodeModal = openQRCodeModal;
        function openQRCodeModal() {
            if($scope.eidUrl) {
                $uibModal.open({
                    templateUrl: 'views/identity/modal_eid_qr.html',
                    controller: 'EidQrModalCtrl',
                    controllerAs: 'vm',
                    resolve: {
                        data: function () {
                            return {
                                eidUrl: $scope.eidUrl
                            }
                        }
                    }
                });
                startPollingVideoVerificationState(); // start polling for verification result - when user opens QR modal (to continue on phone)
            } else {
                console.log('Still waiting for eID URL...');
            }
        }

        function checkIfVideoVerificationPending(verifications) {
            for (let i = 0; i < verifications.length; i++) {
                if (verifications[i].provider_type === 'user-video-ocr') {
                    return verifications[i].state === 10;
                }
            }
            return false;
        }

        function startPollingVideoVerificationState() {
            if (!statePollingInterval) {
                statePollingInterval = $interval(function() {
                    IDRestangular.one('users', $scope.user.uuid).one('verifications').get().then(function(data){
                        const verifications = data.items;
                        const isPending = checkIfVideoVerificationPending(verifications);
                        if (isPending) {
                            $scope.eidState = 'pending';
                            $uibModalStack.dismissAll();
                        } else {
                            let verificationResult = checkForVideoVerificationResult(verifications);
                            if (verificationResult !== null) {
                                $uibModalStack.dismissAll();
                                if (statePollingInterval) {
                                    $interval.cancel(statePollingInterval);
                                }
                                if (verificationResult) {
                                    $scope.eidState = 'completed';
                                } else {
                                    $scope.eidState = 'rejected';
                                    if(!$scope.eidUrl) { // If user opens page while verification is already pending, re-fetch URL!
                                        eidOcrAuthorizationFailCounter = 0;
                                        requestEidOcrAuthorization();
                                    }
                                }
                            }
                        }
                    }, function(error) {
                        $exceptionHandler(error);
                    });
                }, 5000);
            }
        }

        function checkForVideoVerificationResult(verifications) {
            for (var i = 0; i < verifications.length; i++) {
                if (verifications[i].provider_type === "user-video-ocr") {
                    let verification = verifications[i];
                    if (verification.state === 1 /* completed */ && verification.status === 1 /* valid */) {
                        return true;
                    } else if (verification.state === 1 /* completed */ && verification.status === 2 /* rejected */) {
                        return false;
                    } else {
                        return null;
                    }
                }
            }
            console.log('Something went wrong - no video verification found.');
            return null;
        }

        $scope.$on('$destroy', function () {
            $window.removeEventListener("message", handleEidEvent, false);
            if(statePollingInterval) {
                $interval.cancel(statePollingInterval);
            }
            if (resultPollingInterval) {
                $interval.cancel(resultPollingInterval);
            }
        });
        // -------------------------- eID END -------------------------- //

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:GatewaysCtrl
 * @description
 * # GatewaysCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('GatewaysCtrl', ["VaultsService", "$uibModal", "$q", "$state", "$exceptionHandler", function (VaultsService, $uibModal, $q, $state, $exceptionHandler) {
        var vm = this;

        vm.gateways = [];
        vm.hubs = [];
        vm.gatewaysLoading = true;
        vm.hubsLoading = true;
        vm.gatewaysError = null;
        vm.hubsError = null;

        vm.openGatewayConnectModal = openGatewayConnectModal;

        $q.all([
            getConnectedGateways(),
            getAvailableGateways()
        ])
        .then(function() {
            filterConnectedGws();
        });

        function getConnectedGateways() {
            return VaultsService.getUserGateways().then(function (data) {

                vm.gateways = _.filter(data, (g) => g.gateway.status === 1);

            }, function(error) {
                $exceptionHandler(error);
                vm.gatewaysError = error;
            })
            .finally(function() {
                vm.gatewaysLoading = false;
            });
        }

        function getAvailableGateways() {
            return VaultsService.getAllGateways().then(function(data) {
                vm.hubs = data.filter(hub => hub.is_shown_in_wallet);

            }, function(error) {
                $exceptionHandler(error);
                vm.hubsError = error;
            })
            .finally(function() {
                vm.hubsLoading = false;
            });
        }

        function filterConnectedGws() {
            var connectedGws = vm.gateways.map(function(gw) { return gw.gateway.uuid });
            vm.hubs = vm.hubs.filter(function(hub) {
                return connectedGws.indexOf(hub.gateway_uuid) === -1;
            });
        }

        function openGatewayConnectModal(hub) {
            $uibModal.open({
                templateUrl: 'views/home/modal_connect_gateway.html',
                controller: 'ConnectGatewayCtrl',
                resolve: {
                    data: function () {
                        return { hub: hub };
                    }
                }
            })
            .result.then(function (response) {
                if (response.redirect) {
                    $state.go(response.redirect, {}, { reload: true });
                }
                else {
                    getConnectedGateways().then(function() {
                        filterConnectedGws();
                    });
                }
            }, function () {
                getConnectedGateways().then(function() {
                    filterConnectedGws();
                });
            });
        }

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:UploadAdditionalDocsCtrl
 * @description
 * # UploadAdditionalDocsCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
.controller('UploadAdditionalDocsCtrl', UploadAdditionalDocsCtrl);
function UploadAdditionalDocsCtrl(ENV, $sessionStorage, $scope) {

    var vm = this;

    vm.files = {
        additionalDocs: []
    };
    vm.upload_error = null;

    vm.getFileUploadOptions = getFileUploadOptions;
    vm.uploadSuccess = uploadSuccess;
    vm.showError = showError;
    vm.closeModal = closeModal;

    function getFileUploadOptions() {
        return {
            url: ENV.apiStorage + "/user-additional",
            file: undefined,
            headers: { 'Authorization': 'Bearer ' + $sessionStorage.token.access_token },
        }
    };
    function uploadSuccess(id) {
        vm.upload_error = null;
    };
    function showError(error) {
        vm.upload_error = error;
    };

    function closeModal () {
        $scope.$close();
    }
}
UploadAdditionalDocsCtrl.$inject = ["ENV", "$sessionStorage", "$scope"];

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:UploadProfilePictureController
 * @description
 * # UploadProfilePictureController
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
.controller('UploadProfilePictureController', UploadProfilePictureController);
function UploadProfilePictureController(data, ENV, $sessionStorage, $scope, $rootScope, IDRestangular, $timeout, $exceptionHandler) {

    var vm = this;
    var userId = data.userId;

    vm.files = {
        profilePicture: []
    };
    vm.photoId = null;
    vm.upload_error = null;
    vm.selectedFileBlob = null;
    vm.isDone = false;
    vm.existingPhotoId = data.existingPhotoId;

    vm.getFileUploadOptions = getFileUploadOptions;
    vm.onUploadStart = onUploadStart;
    vm.uploadSuccess = uploadSuccess;
    vm.showError = showError;
    vm.clearPhoto = clearPhoto;
    vm.closeModal = closeModal;


    function getFileUploadOptions() {
        return {
            url: ENV.apiStorage + "/cover",
            file: undefined,
            headers: { 'Authorization': 'Bearer ' + $sessionStorage.token.access_token },
        }
    };
    function onUploadStart(file) {
        vm.selectedFileBlob = file.$ngfBlobUrl;
    }
    function uploadSuccess(id) {
        var uploadedFile = vm.files.profilePicture.pop();

        if (!uploadedFile) {
            vm.upload_error = 'Bad upload file id.';
            return;
        }
        vm.photoId = uploadedFile.data.id;

        IDRestangular.one('users', userId).customPUT({ photo: vm.photoId }).then(function(data) {
            // Update profile
            vm.upload_error = null;
            vm.isDone = true;
            $rootScope.$broadcast('profilePictureChange', vm.photoId);
            $timeout(function() {
                closeModal()
            }, 2000);
        }, $exceptionHandler);

    };
    function showError(error) {
        vm.upload_error = error;
    };

    function clearPhoto() {
        vm.isDone = true;
        $rootScope.$broadcast('profilePictureChange', null);
        $timeout(function() {
            closeModal()
        }, 2000);
        IDRestangular.one('users', userId).customPUT({ photo: null })
            .then(function(data) { })
            .catch($exceptionHandler);
    }

    function closeModal() {
        $scope.$close();
    }
}
UploadProfilePictureController.$inject = ["data", "ENV", "$sessionStorage", "$scope", "$rootScope", "IDRestangular", "$timeout", "$exceptionHandler"];

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:ApiKeyCtrl
 * @description
 * # ApiKeyCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('ApiKeyCtrl', ["AuthRestangular", "coreSecurity", "$scope", "$uibModal", "$exceptionHandler", function (AuthRestangular, coreSecurity, $scope, $uibModal, $exceptionHandler) {
        var vm = this;

        // overview, new-key, key-details
        vm.viewMode = 'overview';
        vm.apiKeys = [];
        vm.loading = false;
        vm.error = null;
        vm.isUnlocked = coreSecurity.unlockStatus;

        vm.activeApiKey = null;

        vm.backToOverview = backToOverview;
        vm.openNeyKeyPage = openNeyKeyPage;
        vm.openEditKeyPage = openEditKeyPage;
        vm.openDeleteModal = openDeleteModal;
        vm.createNewKey = createNewKey;


        if (vm.isUnlocked.unlocked) {
            fetchApiKeys();
        } else {
            var listener = $scope.$on('2fa_authorized', function () {
                fetchApiKeys();
                listener();
            });
        }

        function fetchApiKeys() {
            vm.error = null;
            vm.loading = true;

            AuthRestangular.one('user/keys').get().then(function(data) {
                vm.apiKeys = data.plain();
            })
            .catch(function(error) {
                console.error(error);
                if (error.data  && error.data.error_description) {
                    vm.error = error.data.error_description;
                }
                else {
                    vm.error = 'Something went wrong. Please try again.'
                }
            })
            .finally(function() {
                vm.loading = false;
            });
        }

        function createNewKey(keyData) {
            if (!keyData) {
                backToOverview();
                return;
            }

            vm.loading = true;
            vm.error = null;

            AuthRestangular.one('keys').customPOST(keyData).then(function(data) {
                openEditKeyPage(data, true);
                fetchApiKeys();
            })
            .catch(function(error) {
                console.error(error);
                if (error.data  && error.data.error_description) {
                    vm.error = error.data.error_description;
                }
                else {
                    vm.error = 'Something went wrong. Please try again.'
                }
            })
            .finally(function() {
                vm.loading = false;
            });
        }

        function openDeleteModal(key) {
            $uibModal.open({
                templateUrl: 'views/settings/modal_remove_api_key.html',
                controller: 'ApiKeyRemoveCtrl',
                controllerAs: 'vm',
                resolve: { data: { apiKey: key } }
            })
            .result.finally(function () {
                fetchApiKeys();
            });
        }

        function backToOverview() {
            vm.viewMode = 'overview';
        }

        function openNeyKeyPage() {
            vm.viewMode = 'new-key';
        }

        function openEditKeyPage(apiKey, isNewKey) {
            vm.activeApiKey = apiKey;
            vm.activeApiKey.isNewKey = isNewKey;
            vm.viewMode = 'key-details';
        }

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:ApiKeyRemoveCtrl
 * @description
 * # ApiKeyRemoveCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('ApiKeyRemoveCtrl', ["$scope", "data", "AuthRestangular", "$timeout", "$exceptionHandler", function ($scope, data, AuthRestangular, $timeout, $exceptionHandler) {
        var vm = this;

        vm.apiKey = data.apiKey;

        vm.loading = false;
        vm.error = null;
        vm.done = false;

        vm.cancel = cancel;
        vm.deleteKey = deleteKey;

        function deleteKey() {
            vm.loading = true;
            vm.error = null;

            AuthRestangular.one('keys').one(vm.apiKey.id).remove().then(function(res) {
                vm.done = true;
                $timeout(function() {
                    $scope.$close(vm.apiKey.id);
                }, 1000);
            })
            .catch(function(error) {
                console.error(error);
                if (error.data  && error.data.error_description) {
                    vm.error = error.data.error_description;
                }
                else {
                    vm.error = 'Something went wrong. Please try again.'
                }
            })
            .finally(function() {
                vm.loading = false;
            })
        }

        function cancel() {
            $scope.$dismiss();
        };

    }]);

'use strict';

angular.module('gatehubClientApp')
    .controller('ApplicationsCtrl', ["coreSecurity", "$scope", "Auth", "AuthRestangularV2", "$exceptionHandler", "$uibModal", function (coreSecurity, $scope, Auth, AuthRestangularV2, $exceptionHandler, $uibModal) {
        var vm = this;
        vm.applications = [];
        vm.deleteUserApplication = deleteUserApplication;

        vm.isUnlocked = coreSecurity.unlockStatus;
        if (vm.isUnlocked.unlocked) {
            init();
        } else {
            var listener = $scope.$on('2fa_authorized', function() {
                init();
                listener();
            });
        }

        function init() {
            vm.error = null;
            vm.loading = true;

            Auth.getProfile().then(function (data) {
                var userUuid = data.id;

                AuthRestangularV2.one('users', userUuid).one('consents').get().then(function(response){
                    vm.applications = response.plain();
                }).catch(function(error) {
                    vm.error = 'Error getting user applications.';
                    console.log('Error getting user applications:', error);
                }).finally(function() {
                    vm.loading = false;
                });

            }, function(error) {
                console.log('Error getting auth user:', error);
                $exceptionHandler(error);
            });
        }

        function deleteUserApplication(application) {
            $uibModal.open({
                templateUrl: 'views/settings/modal_remove_application.html',
                controller: 'ApplicationRemoveCtrl',
                controllerAs: 'vm',
                resolve: { data: { application: application } }
            })
            .result.finally(function () {
                init();
            });
        }

        $scope.$on('$destroy', function () {
            if (listener) {
                listener();
            }
        });

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:ApplicationRemoveCtrl
 * @description
 * # ApplicationRemoveCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('ApplicationRemoveCtrl', ["$scope", "data", "OAuthRestangular", "$timeout", function ($scope, data, OAuthRestangular, $timeout) {
        var vm = this;

        vm.application = data.application;

        vm.loading = false;
        vm.error = null;
        vm.done = false;

        vm.cancel = cancel;
        vm.deleteApplication = deleteApplication;

        function deleteApplication() {
            vm.loading = true;
            vm.error = null;

            OAuthRestangular.one('clients', vm.application.client.id).one('consent').remove().then(function() {
                vm.done = true;
                $timeout(function() {
                    $scope.$close(vm.application.client_id);
                }, 1000);
            })
            .catch(function(error) {
                console.error(error);
                if (error.data  && error.data.error_description) {
                    vm.error = error.data.error_description;
                }
                else {
                    vm.error = 'Something went wrong. Please try again.'
                }
            })
            .finally(function() {
                vm.loading = false;
            })
        }

        function cancel() {
            $scope.$dismiss();
        };

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:SendRippleCtrl
 * @description
 * # SendRippleCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('SendRippleCtrl', ["$scope", "$state", "$stateParams", "Auth", "$timeout", "WalletsService", "RippleNetwork", "CoreRestangular", "VaultsService", "IdService", "Settings", "$sessionStorage", "AccountsService", "Gateways", "$exceptionHandler", "XrpForensicsRestangular", "RippleTx", "PayStringService", "StorageCore", "Countries", "coreSecurity", "NonstandardCurrencies", function ($scope, $state, $stateParams, Auth, $timeout, WalletsService, RippleNetwork, CoreRestangular, VaultsService, IdService, Settings, $sessionStorage, AccountsService, Gateways, $exceptionHandler, XrpForensicsRestangular, RippleTx, PayStringService, StorageCore, Countries, coreSecurity, NonstandardCurrencies) {

        $scope.loading = true;

        // Lock
        $scope.isUnlocked = coreSecurity.is2FaAuthorized();
        if (!$scope.isUnlocked) {
            var listener = $scope.$on('2fa_authorized', function() {
                $scope.isUnlocked = true;
                listener();
            });
        }

        var wallets;
        var wallet;
        var address;
        var user;
        var User;
        var prefered_cold = (VaultsService.getVaultByCurrency('XRP') != false) ? VaultsService.getVaultByCurrency('XRP').cold : '';

        var network_type;
        var vault;
        var active = $state.current.name.split('.');

        var walletsLoaded = false;

        $scope.latinTxMessageAllow = "^[\u0020-\u007E\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u017F]+$";

        $scope.countries = Countries.filteredCountries; // needed for WIRE/SEPA withdrawals

        $scope.wallets = [];

        $scope.goldLimit = 100;
        $scope.getNumber = function (num) {
            return new Array(num);
        };
        $scope.showAlternatives = false;
        $scope.pathFindingInProgress = false;

        $scope.destinationCover = null;

        // Determine network and vault
        if (active[3] == 'sepa') {
            network_type = 0;
            vault = VaultsService.getVaultByCurrency('EUR');
        }
        else if (active[3] == 'wire') {
            network_type = 1;
            vault = VaultsService.getVaultByCurrency('USD');
        }
        else if (active[3] == 'ripple') {
            network_type = 2;
            vault = VaultsService.getVaultByCurrency('XRP');
        }
        else if (active[3] == 'bitcoin') {
            network_type = 3;
            vault = VaultsService.getVaultByCurrency('BTC');
        }
        // 4 = gatehub (hosted)
        else if (active[3] == 'ethereum') {
            network_type = 5;
            vault = VaultsService.getVaultByCurrency('ETH');
        }
        else if (active[3] == 'rep') {
            network_type = 6;
            vault = VaultsService.getVaultByCurrency('REP');
        }
        else if (active[3] == 'gold') {
            network_type = 7;
            vault = VaultsService.getVaultByCurrency('XAU');
        }
        // 8 = manual
        else if (active[3] == 'ethereum_classic') {
            network_type = 9;
            vault = VaultsService.getVaultByCurrency('ETC');
        }
        else if (active[3] == 'dash') {
            network_type = 10;
            vault = VaultsService.getVaultByCurrency('DSH');
        }
        // 11 = quantum (deprecated)
        // 12 = geni (deprecated)
        else if (active[3] == 'litecoin') {
            network_type = 13;
            vault = VaultsService.getVaultByCurrency('LTC');
        }
        else if (active[3] == 'bitcoincash'){
            network_type = 14;
            vault = VaultsService.getVaultByCurrency('BCH');
        }
        else if (active[3] == 'flare') {
            network_type = 15;
            vault = VaultsService.getVaultByCurrency('FLR');
        }
        else if (active[3] == 'songbird') {
            network_type = 16;
            vault = VaultsService.getVaultByCurrency('SGB');
        }
        else if (active[3] == 'gala') {
            network_type = 18;
            vault = VaultsService.getVaultByCurrency('GALA');
        }
        else if (active[3] == 'usdt') {
            network_type = 19;
            vault = VaultsService.getVaultByCurrency('USDT');
        }
        else if (active[3] == 'usdc') {
            network_type = 20;
            vault = VaultsService.getVaultByCurrency('USDC');
        }
        else if (active[3] == 'wxrp') {
            network_type = 21;
            vault = VaultsService.getVaultByCurrency('WXRP');
        }
        else if (active[3] == 'gbp') {
            network_type = 22;
            vault = VaultsService.getVaultByCurrency('GBP');
        }
        else if (active[3] == 'wire_gbp') {
            network_type = 1; // wire, same as for USD
            vault = VaultsService.getVaultByCurrency('GBP');
        }

        else {
            return false;
        }

        $scope.network_type = network_type;
        $scope.vault = vault;

        // Init
        resetForm();
        init();

        var pathUpdateTimeout;
        var timer;

        $scope.step = 1;
        $scope.available = 0;

        // Watch these guys
        $scope.$watch('send.account_id', function (data) {
            update_destination_gatehub();
        }, true);

        $scope.$watch('send.name', function (data) {
            update_destination();
        }, true);

        $scope.$watch('send.amount', function (data) {
            // cancel pathfinding if already in progress (if triggered 2x, displayed fee is also doubled!)
            if ($scope.send.pathfind) {
                $scope.send.pathfind.close();
                delete $scope.send.pathfind;
            }
            if (pathUpdateTimeout) {
                $timeout.cancel(pathUpdateTimeout);
                pathUpdateTimeout = null;
            }
            reset_paths();
            
            update_amount();
        }, true);

        $scope.$watch('send.currency', function (data) {
            update_currency();
        }, true);

        // When the send form is invalid, path finding won't trigger. So if the form
        // is changed by one of the update_* handlers and becomes valid during the
        // next digest, we need to manually trigger another update_amount.
        $scope.$watch('form.send.$valid', function (valid) {
            // cancel pathfinding if already in progress (if triggered 2x, displayed fee is also doubled!)
            if ($scope.send.pathfind) {
                $scope.send.pathfind.close();
                delete $scope.send.pathfind;
            }
            if (pathUpdateTimeout) {
                $timeout.cancel(pathUpdateTimeout);
                pathUpdateTimeout = null;
            }
            reset_paths();

            if (valid) {
                update_amount();
            } else {
                $scope.send.last_recipient = null;
                $scope.send.path_status = 'waiting';
                $scope.send.fund_status = 'none';
            }
        });

        $scope.$on('$destroy', function () {
            // Stop pathfinding if the user leaves
            if ($scope.send.pathfind) {
                $scope.send.pathfind.close();
                delete $scope.send.pathfind;
            }
            delete $scope.send;
            clearInterval(timer);
        });


        ///////////////////////////////////////////////////////////

        function init() {

            var removeWalletsLoadedListener1 = $scope.$on('walletsLoaded', function () {
                walletsLoaded = true;
                removeWalletsLoadedListener1();
            });

            // Wait untill wallets are fully loaded
            WalletsService.getWallets().then(function (data) {

                // Get active wallet (if exists)
                var id = $stateParams.id;

                if (id) {

                    // Save new active wallet
                    WalletsService.setActive(id);

                    // Load all wallets, filter out psd wallets
                    wallets = data.filter((wallet) => wallet.type !== 24);

                    $scope.wallets = wallets;

                    // Load active wallet
                    loadWallet();

                }
                else {

                    // Load active wallet
                    wallet = WalletsService.getActive();

                    // Something went wrong, let's stop before it gets even worse
                    if (!wallet) {
                        $exceptionHandler('wallet_not_found');
                        return;
                    };

                    // Redirect to it
                    $state.go('wallets.item.balance', { id: wallet[0].address });
                    return;

                }

                $scope.$broadcast('walletsLoaded', true);

            }, function (error) {
                $exceptionHandler(error);
                return;
            })

        };

        function loadWallet() {

            // Load active wallet
            wallet = WalletsService.getActive();

            // Something went wrong, let's stop before it gets even worse
            if (!wallet) {
                $exceptionHandler('wallet_not_found');
                return;
            };

            $scope.active_wallet = wallet[0];

            address = wallet[0].address;

            $scope.currentWalletAddress = address; // to remove from recipient list

            if (network_type == 2) {
                $scope.loading = false;
            }
            else {
                initAccounts();
            };

            user = $sessionStorage.user;
            User = CoreRestangular.one('users', user.uid);
        };

        function initAccounts() {

            // Check if shadow wallet exists
            // If it doesn't, bridge payments are not possible
            if (typeof wallet[0].shadow_address == 'undefined' && (wallet[0].type == 10 || wallet[0].type == 10)) {
                $scope.mode = 'network-not-available';
                $scope.loading = false;
                return;
            };

            Auth.getProfile().then(function (_data) {

                // Check if shadow gateway is connected
                if (network_type != 2) {
                    VaultsService.getConnectedVaults().then(function (data) {

                        var vaults = data;
                        var connected = false;

                        for (var i = vaults.length - 1; i >= 0; i--) {

                            if (vaults[i].uuid == vault.vault_id) {
                                var connected = true;

                                // Merge real vault data with config data
                                vault = _.merge(vaults[i], vault);

                                // Fix min withdrawal amount
                                var _amount = new Decimal(vault.min_withdrawal_amount);

                                var _total_fee = calculateTotalFee(vault.min_withdrawal_amount, vault);
                                var _total_amount = _amount.plus(_total_fee);

                                vault.min_withdrawal_amount = _total_amount.toFixed(vault.scale);

                                // Hosted wallets don't have to add fee into calc
                                if (wallet[0].type == 0) {
                                    vault.min_withdrawal_amount = _amount.toFixed(vault.scale);
                                }

                                $timeout(function () {
                                    $scope.vault = vault;
                                })

                            }
                        }

                        if (!connected) {
                            $timeout(function () {
                                $scope.mode = 'gateway-not-connected';
                                $scope.loading = false;
                            });
                            return;
                        };

                        // Get all accounts
                        CoreRestangular.one('users', _data.uid).all('accounts').getList().then(function (data) {

                            var data = data.plain();

                            // Filter correct network
                            var _accounts = _(data).filter({ network: network_type }).value();


                            // Add empty entry for dropdown
                            if (network_type == 0 || network_type == 1 || network_type == 22) {
                                var empty = {
                                    uuid: 'new',
                                    name: 'Add new',
                                    legal_name: 'Add new',
                                    iban: '',
                                };
                            }
                            else if (network_type == 7) {
                                var empty = {
                                    uuid: 'new',
                                    name: '',
                                    display_address: 'Add new',
                                };
                            }
                            else {
                                var empty = {
                                    uuid: 'new',
                                    name: 'Add new',
                                    address: '',
                                };
                            };

                            // Add display
                            if (network_type == 7) {
                                _accounts.map(function (obj) {
                                    obj['display_address'] = obj.street + ', ' + obj.postcode + ' ' + obj.city + ', ' + obj.country;
                                    return obj;
                                });
                            };

                            _accounts.unshift(empty);

                            $timeout(function () {
                                if (typeof $scope.send == 'undefined') return;

                                if (_accounts.length == 1) {
                                    $scope.send.account_id = 'new'
                                };
                                $scope.accounts = _accounts;
                                $scope.mode = false;
                                $scope.loading = false;
                            });

                        })
                            .catch(function (error) {
                                $exceptionHandler(error);
                            });

                    }).catch(function (error) {
                        $exceptionHandler(error);
                    });
                };

            });

        };

        function resetForm() {

            $scope.form = {};
            $scope.errorMessage = false;

            $scope.mode = false;

            $scope.send = {
                name: '',
                display_name: '',
                amount: '',
                currency: 'XRP',
                currency_code: 'XRP',
                currency_choices: [],
                hosted_choices: [],
                message: null,

                ripple_address: false,
                dt: '',
                recipient_info: {},
                last_recipient: '',
                self: false,
                hosted: false,
                user_id: false,
            };

            $scope.pay = {};

        };

        function reset_amount_deps() {
            var send = $scope.send;
            send.sender_insufficient_xrp = false;

            reset_paths();
        };

        function update_amount() {

            // console.log('Update amount');

            var send = $scope.send;
            var recipient = send.ripple_address;

            if (!send.currency_choices || send.currency_choices.length === 0) {
                return;
            }

            var currency = ripple.Currency.from_human(send.currency);

            var matchedCurrency;
            var matchHex = /^([A-Fa-f0-9]{40})\b/.exec(send.currency);
            if (matchHex) {
                matchedCurrency = send.currency.toUpperCase(); // Nonstandard (40-HEX) XRPL currency code
            } else if (send.currency.length > 3) {
                matchedCurrency = NonstandardCurrencies.encodeAssetCode(send.currency); // Nonstandard, but not 40-HEX (e.g. 'USDT') - convert to HEX
            } else {
                matchedCurrency = currency.has_interest() ? currency.to_hex() : currency.get_iso(); // Either 40-HEX, or standard ISO currency code
            }

            var match = NonstandardCurrencies.xrplCurrencyCodeRegex.exec(matchedCurrency);

            if (!match) { // Currency code not recognized
                console.error('Currency code ('+send.currency+') not recognized! Must be standard 3-char code or nonstandard 40-char hex code!');
                return;
            }

            if (send.amount > 100000000000) return;

            // Demurrage: Get a reference date five minutes in the future
            //
            // Normally, when using demurrage currencies, we would immediately round
            // down (e.g. 0.99999 instead of 1) as demurrage occurs continuously. Not
            // a good user experience.
            //
            // By choosing a date in the future, this gives us a time window before
            // this rounding down occurs. Note that for positive interest currencies
            // this actually *causes* the same odd rounding problem, so in the future
            // we'll want a better solution, but for right now this does what we need.
            var refDate = new Date(new Date().getTime() + 5 * 60000);
            send.ripple_amount = ripple.Amount.from_human(send.amount + ' ' + matchedCurrency, { reference_date: refDate });

            reset_amount_deps();
            send.path_status = 'waiting';

            // If the form is invalid, we won't be able to submit anyway, so no point
            // in calculating paths.
            if ($scope.form.send && $scope.form.send.$invalid) return;

            /*
            if (!ripple.UInt160.is_valid(recipient) || !ripple.Amount.is_valid(amount)) {
                // XXX Error?
                return;
            }
            */

            // Create Amount object
            if (!send.ripple_amount.is_native()) {
                send.ripple_amount.set_issuer(recipient);
            }

            // If we don't have recipient info yet, then don't search for paths
            if (!send.recipient_info) {
                return;
            }

            // Check min. withdrawal amount
            // TODO include fee
            if (network_type != 2 && send.amount < vault.min_withdrawal_amount) {
                send.path_status = 'min-withdrawal-amount';
                return;
            }

            // Get withdrawal fee
            if (network_type != 2) {

                var _amount = new Decimal(send.amount);
                var _total_fee = calculateTotalFee(send.amount, vault);

                // hosted withdraw total should be amount + fee
                if (wallet[0].type == 0) {
                    send.total_amount = _amount.plus(_total_fee);
                }
                else {
                    send.total_amount = _amount.toFixed(10);
                }

                send.total_fee = _total_fee.toFixed(10);

            }
            else {
                send.total_amount = send.amount; // Add fee
            }

            send.insufficient = false;
            send.fund_status = 'none';

            // If sending from hosted wallet, set path status 'done'
            if (wallet[0].type == 0) {
                send.path_status = 'done';
            }
            else {

                // Check if destination account is funded
                var total = send.ripple_amount.add(send.recipient_info.Balance);
                var reserve_base = Amount.from_json(Settings.client.xrp_reserve);

                if (total.compareTo(reserve_base) < 0) {
                    send.fund_status = 'insufficient-xrp';
                    send.xrp_reserve = Settings.client.xrp_reserve;
                    send.insufficient = true;
                    return;
                }

                send.path_status = 'pending';
                pathUpdateTimeout = $timeout(update_paths, 500);
            }

        };

        // Generate an array of source currencies for path finding.
        // This will generate currencies for every issuers.
        // It will also generate a self-issue currency for currencies which have multi issuers.
        //
        // Example balances for account rEXAMPLE:
        //   CNY: rCNY1
        //        rCNY2
        //   BTC: rBTC
        // Will generate:
        //   CNY/rEXAMPLE
        //   CNY/rCNY1
        //   CNY/rCNY2
        //   BTC/rBTC
        function generate_src_currencies() {
            var src_currencies = [];
            var balances = wallet[0].balances;
            var isIssuer = generate_issuer_currencies();

            src_currencies.push({ currency: "XRP" });

            for (var currency_name in balances) {

                if (!balances.hasOwnProperty(currency_name)) continue;

                var currency = balances[currency_name];
                var currency_hex = currency.total.currency().to_hex();
                var result = [];

                // Fix for demurrage currencies - currently not supported.
                if (currency.total.currency()._type == 1) continue;

                for (var issuer_name in currency.components) {

                    if (!currency.components.hasOwnProperty(issuer_name)) continue;

                    var component = currency.components[issuer_name];
                    if (component.is_positive()) {
                        result.push({ currency: currency_hex, issuer: issuer_name });
                    }

                }

                if (result.length === 0) // result.length > 1 || isIssuer[currency_hex] - Removing this might break something :)
                    result.unshift({ currency: currency_hex });

                src_currencies = src_currencies.concat(result);
            }

            // Rearrange so that selected currency is on top
            var result = [];
            for (var i = src_currencies.length - 1; i >= 0; i--) {
                if (ripple.Currency.from_human(src_currencies[i].currency).get_iso() == $scope.send.currency) {
                    result.unshift(src_currencies[i]);
                }
                else {
                    result.push(src_currencies[i]);
                }
            }

            // Fix for max. number of source currencies allowed in a path find request.
            var _src_currencies = result.slice(0, 17);

            return _src_currencies;
        };

        function generate_issuer_currencies() {
            var isIssuer = {};
            _.each(wallet[0].lines, function (line) {
                if (typeof line.limit_peer != 'undefined' && line.limit_peer.is_positive()) {
                    isIssuer[line.balance.currency().to_hex()] = true;
                }
                else if (typeof line.limit_peer == 'undefined') {
                    isIssuer[line.balance.currency().to_hex()] = true;
                }
            });
            return isIssuer;
        };

        function reset_paths() {
            var send = $scope.send;
            send.alternatives = [];
        };

        function update_paths() {
            if (typeof $scope.send == 'undefined') return;

            var send = $scope.send;
            var recipient = send.ripple_address;
            var amount = send.ripple_amount;

            // for native withdraws add fee to pathinding
            if (network_type != 2) {
                amount._set_value(amount._value.add(calculateTotalFee(send.amount, vault).toNumber()));
            }

            reset_paths();

            send.path_status = 'pending';

            // Start path find
            var pf = RippleNetwork.remote.path_find(address,
                recipient,
                amount,
                generate_src_currencies());

            var isIssuer = generate_issuer_currencies();

            send.pathfind = pf;
            $scope.pathFindingInProgress = true;

            var lastUpdate;

            pf.on('update', function (upd) {
                if (upd.full_reply === true) {
                    $scope.pathFindingInProgress = false;
                }

                $scope.$apply(function () {

                    lastUpdate = new Date();
                    clearInterval(timer);

                    timer = setInterval(function () {
                        $scope.$apply(function () {
                            var seconds = Math.round((new Date() - lastUpdate) / 1000);
                            $scope.lastUpdate = seconds || 0;
                        });
                    }, 1000);

                    // Check if this request is still current, exit if not
                    var now_recipient = send.ripple_address;
                    if (recipient !== now_recipient) return;

                    var now_amount = send.ripple_amount;
                    if (!now_amount.equals(amount)) return;

                    if (!upd.alternatives || !upd.alternatives.length) {
                        $scope.send.path_status = 'no-path';
                        $scope.send.alternatives = [];
                    }
                    else {
                        var currencies = {};
                        var currentAlternatives = [];

                        $scope.send.path_status = 'done';
                        $scope.send.alternatives = _.map(upd.alternatives, function (raw, key) {
                            var alt = {};
                            var sendMaxDeviation = 0.1;

                            alt.amount = Amount.from_json(raw.source_amount);
                            alt.rate = alt.amount.ratio_human(amount);
                            alt.send_max = alt.amount.scale(1 + sendMaxDeviation / 100);
                            alt.paths = raw.paths_computed || raw.paths_canonical;

                            // Selected currency should be the first option
                            if (raw.source_amount.currency) {
                                if (raw.source_amount.currency === $scope.send.currency)
                                    currentAlternatives.push(alt);
                            } else if ($scope.send.currency === 'XRP') {
                                currentAlternatives.push(alt);
                            }

                            if (alt.amount.issuer().to_json() != address && !isIssuer[alt.amount.currency().to_hex()]) {
                                currencies[alt.amount.currency().to_hex()] = true;
                            }

                            return alt;
                        }).filter(function (alt) { return currentAlternatives.indexOf(alt) == -1; });
                        Array.prototype.unshift.apply($scope.send.alternatives, currentAlternatives);
                        /*
                                        $scope.send.alternatives = $scope.send.alternatives.filter(function(alt) {
                                          // XXX: Roll back pathfinding changes temporarily
                                          if (currencies[alt.amount.currency().to_hex()]) {
                                            return alt.amount.issuer().to_json() != address;
                                          }
                                          return true;
                                        });
                        */
                        // Open pay with options if not XRP
                        if ($scope.send.currency !== 'XRP') {
                            $scope.showAlternatives = true;
                        };

                    }
                });
            });

            pf.on('error', function (res) {
                $exceptionHandler(res);
                $scope.$apply(function () {
                    send.path_status = 'error';
                });
            });

            var pathFindTime = new Date();
        };

        // Destination tag - some ripple addresses require dt to be specified
        function check_dt_visibility() {
            var send = $scope.send;
            send.show_dt_field =
                ($stateParams.dt
                    || send.dt
                    || (send.recipient_info &&
                        'object' === typeof send.recipient_info &&
                        send.recipient_info.dest_tag_required))
                && (!send.federation || (send.federation_record && !send.federation_record.dt))
                && !send.disable_dt_editing;
        };

        function update_destination_gatehub() {

            // console.log('Update dest gatehub');

            var send = $scope.send;
            var recipient_account = send.account_id;

            // Reset dest address
            send.ripple_address = false;
            send.wallet_type = false;
            send.path_status = false;
            send.user_id = false;
            $scope.destinationCover = null;

            // console.log(recipient_account);

            // Check last recipient
            if (recipient_account === send.recipient_account) return;
            send.recipient_account = recipient_account;

            // Check if shadow wallet exists
            if (typeof wallet[0].shadow_address != 'undefined') {
                send.hosted_address = wallet[0].shadow_address;
                send.wallet_type = 0;
            }

            check_destination();

        };

        function update_destination() {

            // Bypass if sending to an account
            if (network_type != 2) {
                return;
            }

            var send = $scope.send;
            var recipient = send.name;



            // Reset dest address
            send.ripple_address = false;
            send.wallet_type = false;
            send.path_status = false;
            send.user_id = false;
            send.my_wallet = false;
            //send.dt = '';
            send.show_dt_field = false;
            send.hosted_choices = [];
            send.disable_dt_editing = false; // editing of dt with paystring hsould be disabled
            $scope.destinationCover = null;


            if ($scope.form.send) {
                $scope.form.send.name.$setValidity('notGatehubName', true);
                $scope.form.send.name.$setValidity('notRippleName', true);
                $scope.form.send.name.$setValidity('notRipple', true);
                $scope.form.send.name.$setValidity('notEmail', true);
                $scope.form.send.name.$setValidity('self', true);
                $scope.form.send.name.$setValidity('notB2R', true);
                $scope.form.send.name.$setValidity('notAvailable', true);
                $scope.form.send.name.$setValidity('notBitcoin', true);
                $scope.form.send.name.$setValidity('notPayString', true);
            }

            // Check last recipient
            if (recipient === send.last_recipient) return;
            send.last_recipient = recipient;

            // Name selected from dropdown
            if (typeof recipient === 'object') {

                send.ripple_address = (recipient.ripple_address) ? stripRippleAddress(recipient.ripple_address) : false;
                send.hosted_address = recipient.hosted_address;
                send.my_wallet = recipient.my_wallet;

                send.identity_name = recipient.name;
                send.display_name = recipient.gatehub_name;
                send.user_id = recipient.user_id;
                send.wallet_type = recipient.wallet_type;
                fetchUserCover(send.user_id);

                recipient = recipient.name;

                check_destination();
                return;
            } else {
                // reset display name when unknown wallet
                send.identity_name = '';
                send.display_name = '';

                // check if pasted address exists in wallet list
                if(wallets.length){
                    var walletInAddressBook = _.filter(wallets, function (wal) {
                        return wal.address === recipient;
                    });
                    if(walletInAddressBook.length){
                        $scope.setRecipient(walletInAddressBook[0]);
                    }
                }
            }

            // Strip name
            if (send.dt == '') {
                send.dt = getDestTagFromAddress(recipient);
            };

            send.ripple_address = stripRippleAddress(recipient);

            // Sending to gatehub name
            if (isGatehubName(recipient)) {
                IdService.getGatehubRippleAddress(recipient)
                    .success(handleGatehubName)
                    .error(handleGatehubNameError);
                return;
            }

            // Sending to ripple name
            if (isRippleName(recipient)) {
                IdService.getRippleAddress(recipient)
                    .success(handleRippleName)
                    .error(handleRippleNameError);
                return;
            }

            // Sending to email
            else if (isPayString(recipient)) {
                PayStringService.resolvePayString(recipient).then(function (response) {
                    if (response && response.addresses.length) {
                        var payStringAddresses = response.addresses;

                        // todo: add support for multiple addresses
                        var xrpAddress = payStringAddresses[0].addressDetails;
                        handlePayString(recipient, xrpAddress)
                    }
                    else {
                        handlePayStringError()
                    }

                }, handlePayStringError);

            }

            // Sending to email
            else if (isEmail(recipient)) {

                // Warning for ripple2btc
                if (recipient.indexOf('@btc2ripple.com') > -1) {
                    $scope.form.send.name.$setValidity('notB2R', false);
                    return;
                };

                CoreRestangular.one('search/email', recipient).getList().then(function (data) {

                    var data = data.plain();

                    if (data.length) {
                        handleEmail(recipient, data[0].address, data[0].type);
                    } else {
                        handleEmailError();
                    }

                }, handleEmailError);

            }
            // Sending to gatehub wallet
            else if (isGatehubWallet(recipient)) {
                handleGatehubWallet(recipient);
                return;
            }
            // Sending to bitcoin address
            else if (!isNaN(ripple.Base.decode_check([0, 5], send.ripple_address, 'bitcoin'))) {
                if ($scope.form.send) {
                    $scope.form.send.name.$setValidity('notBitcoin', false);
                }
                return;
            }
            // Sending to ripple address
            else if (!ripple.UInt160.is_valid(send.ripple_address)) {
                if ($scope.form.send) {
                    $scope.form.send.name.$setValidity('notRipple', false);
                }
                return;
            }

            // Sending to self
            if (send.ripple_address === address) {
                if ($scope.form.send) {
                    $scope.form.send.name.$setValidity('self', false);
                }
                return;
            }

            check_destination();

        };

        function handleGatehubWallet(_addresss) {
            var send = $scope.send;
            send.wallet_type = 0;
            send.hosted_address = _addresss;

            check_destination();
        };

        function handleEmail(email, address, type) {
            var send = $scope.send;

            // Check if hosted wallet hiding behind email
            if (isGatehubWallet(address)) {
                send.hosted_address = address;
                send.wallet_type = 0;
            }
            else {
                send.ripple_address = address;
                send.wallet_type = false;
                send.hosted_address = false;
            }

            send.dt = '';
            send.identity_name = email;

            check_destination();
        };

        function handleEmailError(error) {
            if (error) {
                $exceptionHandler(error);
            }
            $timeout(function () {
                $scope.form.send.name.$setValidity('notEmail', false);
            });
        };

        function handlePayString(recipient, addressInfo) {
            var send = $scope.send;

            var decodedAddress = PayStringService.decodeXrpAddress(addressInfo);

            if (!decodedAddress) {
                $exceptionHandler('Could not decode address', addressInfo);
                handlePayStringError();
                return;
            }

            send.ripple_address = decodedAddress.account;
            send.dt = decodedAddress.tag;
            send.identity_name = recipient;
            send.disable_dt_editing = true;

            var matchedVault = VaultsService.list().findIndex(function(vault) {
                return vault.cold === decodedAddress.account;
            })
            // check if destination is our hosted wallet
            if (isGatehubWallet(send.dt) && matchedVault > -1) {
                send.hosted_address = decodedAddress.tag;
                send.wallet_type = 0;
            }
            else {
                send.wallet_type = false;
                send.hosted_address = false;
            }

            check_destination();
        };

        function handlePayStringError(error) {
            // filter not found and unresolved url errors
            if (error && error.status !== 404 && error.status !== -1) {
                $exceptionHandler('PayString error', error);
            }
            $timeout(function () {
                $scope.form.send.name.$setValidity('notPayString', false);
            });
        };

        function handleGatehubName(response) {

            var send = $scope.send;
            var names = response.hits;

            if (names.length == 0) {
                $timeout(function () {
                    $scope.form.send.name.$setValidity('notGatehubName', false);
                });
            }
            else {

                var xnames = [];

                xnames = names.map(function (obj) {
                    return {
                        user_id: obj._id,
                        name: (obj._source.first_name !== null) ? obj._source.first_name + ' ' + obj._source.last_name : false,
                        gatehub_name: obj._source.name,
                        address: obj._source.address,
                        ripple_address: (obj._source.type == 10 || obj._source.type == 11) ? obj._source.address : false,
                        hosted_address: (obj._source.type == 0) ? obj._source.address : false,
                        wallet_type: obj._source.type,
                    }
                });

                // Remove those without address
                _.remove(xnames, function (name) {
                    return !name.address
                });

                if (xnames.length == 0) {
                    $timeout(function () {
                        $scope.form.send.name.$setValidity('notGatehubName', false);
                    });
                }
                else {
                    send.identity_name = xnames[0].name;
                    send.display_name = '+' + xnames[0].gatehub_name;
                    send.ripple_address = xnames[0].ripple_address;
                    send.hosted_address = xnames[0].hosted_address;
                    send.user_id = xnames[0].user_id;
                    fetchUserCover(send.user_id);

                    send.my_wallet = false;

                    check_destination();
                };

            };

        };

        function handleGatehubNameError(error) {
            $exceptionHandler(error);
            $timeout(function () {
                $scope.form.send.name.$setValidity('notGatehubName', false);
            });
        };

        function handleRippleName(data) {
            var send = $scope.send;

            send.display_name = '~' + data.username;
            send.ripple_address = data.address;

            check_destination();
        };

        function handleRippleNameError(error) {
            $timeout(function () {
                $scope.form.send.name.$setValidity('notRippleName', false);
            });
        };

        function check_destination(bypass) {

            if (typeof $scope.send == 'undefined') return;

            var send = $scope.send;
            var recipient = send.ripple_address;

            send.recipient_resolved = false;
            send.hosted_withdrawal = false;

            // Check if wallet is mine
            var found = WalletsService.getByAddress(recipient);
            send.my_wallet = (typeof found == 'undefined') ? false : true;

            // Don't forget to check if hosted wallet is mine
            if (send.my_wallet == false) {
                var found = WalletsService.getByAddress(send.dt);
                send.my_wallet = (typeof found == 'undefined') ? false : true;
            };

            // if hosted -> hosted, there is no ripple fee, so hide it
            $scope.is_hosted_to_hosted = wallet[0].type == 0 && send.wallet_type == 0;

            if ($scope.is_hosted_to_hosted && wallet[0].address === send.hosted_address) {
                $scope.form.send.name.$setValidity('self', false);
                return;
            }

            // if hosted -> ripple, GateHub pays for ripple fee, so hide it
            $scope.is_hosted_to_ripple = wallet[0].type == 0 && send.wallet_type == 10 || send.wallet_type == 11;

            // Hosted withdrawal
            if (wallet[0].type == 0 && network_type != 2) {

                console.log('Hosted withdrawal');
                send.recipient_resolved = true;
                send.hosted_withdrawal = true;
                update_currency_choices();

            };

            // Sending to Hosted wallet
            // console.log(send.wallet_type);
            if (send.wallet_type !== false && send.wallet_type == 0 && send.hosted_address && bypass != true) {

                // Do not show DT if sending to hosted wallet
                send.show_dt_field = false;

                // Reset choices
                send.hosted_choices = [];

                WalletsService.getGatehubWallet(send.hosted_address).getList('?limit=1000').then(function (data) {

                    var _data = data.plain();
                    var _vaults = [];

                    for (var i = _data.length - 1; i >= 0; i--) {

                        var _line = _data[i];

                        if (_line.issuer_address == null) continue;

                        var vault = {
                            uuid: _line.vault_uuid,
                            cold: _line.issuer_address,
                            currency: _line.asset_code,
                        }
                        _vaults.push(vault);

                    }

                    if (_vaults.length != 0) {

                        send.hosted_choices = _vaults;

                        for (var i = _vaults.length - 1; i >= 0; i--) {

                            // Prefer GateHub
                            if (_vaults[i].cold == prefered_cold) {
                                var xaddress = _vaults[i].cold + '?dt=' + send.hosted_address;
                                break;
                            }
                            else {
                                var xaddress = _vaults[0].cold + '?dt=' + send.hosted_address;
                            }

                        };

                        // Set ripple address
                        send.dt = getDestTagFromAddress(xaddress);
                        send.ripple_address = stripRippleAddress(xaddress);

                        recipient = send.ripple_address;

                    }
                    else {
                        send.path_status = 'no-connected-vaults';
                        if ($scope.form.send) {
                            $scope.form.send.name.$setValidity('notAvailable', false);
                        };
                        return;
                    };

                    check_destination(true);

                }, function (error) {
                    $exceptionHandler(error);
                    send.path_status = 'no-connected-vaults';
                    if ($scope.form.send) {
                        $scope.form.send.name.$setValidity('notAvailable', false);
                    };
                    return;
                });

            }
            else {
                if (send.wallet_type != 0) {
                    check_dt_visibility();
                };
            };


            if (!ripple.UInt160.is_valid(recipient)) return;

            var account = RippleNetwork.remote.account(recipient);

            send.path_status = 'checking';
            send.recipient_info = null;

            account.entry(function (error, data) {
                $scope.$apply(function () {

                    // Check if this request is still current, exit if not
                    var now_recipient = send.ripple_address;
                    if (recipient !== now_recipient) return;

                    // If we get this far, we have a Ripple address resolved
                    send.recipient_resolved = true;

                    send.known_destination = null;
                    XrpForensicsRestangular.one('identify').get({ address: recipient }).then(function(data){
                        send.known_destination = data.plain();
                    }, function(error) { });

                    send.blacklisted = false;
                    XrpForensicsRestangular.one('verify',recipient).get().then(function(data){
                        send.blacklisted = data.plain();
                    }, function(error) {
                        // 404: not blacklisted
                    });

                    if (error) {
                        if (error.remote.error === 'actNotFound') {
                            send.recipient_info = {
                                loaded: true,
                                exists: false,
                                Balance: '0'
                            };
                            update_currency_constraints();
                        }
                        else {
                            // XXX Actual error
                            $exceptionHandler(error);
                        }
                    }
                    else {
                        send.recipient_info = {
                            loaded: true,
                            exists: true,
                            Balance: data.account_data.Balance,

                            // Flags
                            disallow_xrp: data.account_data.Flags & ripple.Remote.flags.account_root.DisallowXRP,
                            dest_tag_required: data.account_data.Flags & ripple.Remote.flags.account_root.RequireDestTag
                        };

                        // Check destination tag visibility if ripple wallet
                        if (send.wallet_type !== 0) {
                            check_dt_visibility();
                        }

                        //if (!$scope.account || !$scope.account.reserve_base) return;

                        //var reserve_base = $scope.account.reserve_base;
                        //send.xrp_deficiency = reserve_base.subtract(data.account_data.Balance);

                        send.recipient_lines = false;
                        update_currency_constraints();
                    }

                });
            });

            // If no identity name, check gateways list and diplay that name instead (if exists)
            if (!send.identity_name) {
                var _gateways = Gateways;
                var _gateway = _.find(_gateways, function (gateway) {
                    var found = false;
                    _.each(gateway['accounts'], function (account) {
                        if (account['address'] === send.ripple_address) {
                            found = true;
                            return false; // lodash break
                        }
                    });
                    return found;
                });
                if (typeof _gateway !== 'undefined' && _gateway.name) {
                    send.gateway_name = _gateway.name;
                }
            }

        };

        /**
         * Update any constraints on what currencies the user can select.
         *
         * In many modes, the user is restricted in terms of what they can send.
         * For example, when sending to a Bitcoin address, they can only send BTC.
         *
         * This function checks those conditions and updates the UI.
         */
        function update_currency_constraints() {

            var send = $scope.send;

            // Reset constraints
            send.currency_choices_constraints = {};

            // If we don't have information about the recipient Ripple account yet,
            // we'll just return. We'll get back here once we have that information.
            if (!send.recipient_info.loaded) return;

            if (send.recipient_info.exists) {

                // Check allowed currencies for this address
                var requestedRecipientAddress = send.ripple_address;
                send.currency_choices_constraints.accountLines = 'pending';

                RippleNetwork.remote.requestAccountCurrencies({ account: requestedRecipientAddress })
                    .on('success', function (data) {
                        $scope.$apply(function () {
                            if (data.receive_currencies &&
                                // We need to make sure the destination account hasn't changed
                                send.ripple_address === requestedRecipientAddress) {

                                send.currency_choices_constraints.accountLines = data.receive_currencies;

                                // Add XRP if it's allowed or GateHub's Cold
                                if (send.recipient_info != null && (!send.recipient_info.disallow_xrp || requestedRecipientAddress == prefered_cold)) {
                                    send.currency_choices_constraints.accountLines.unshift('XRP');
                                };

                                // Check if hosted is sending and ripple receiving
                                // console.log('Sending wallet type', wallet[0].type);
                                // console.log('Receiving wallet type', $scope.send.wallet_type);

                                if (wallet[0].type == 0 && ($scope.send.wallet_type == false || $scope.send.wallet_type == 10 || $scope.send.wallet_type == 11)) {

                                    /*
                                    for (var i = send.currency_choices_constraints.accountLines.length - 1; i >= 0; i--) {
                                      console.log(send.currency_choices_constraints.accountLines[i]);
                                    }
                                    */

                                    console.log('Receivable', send.currency_choices_constraints);
                                    console.log('Available balances', wallet[0].lines);

                                    /*
                                    // Keep if vault matches and balance > 0;
                                    VaultsService.getConnectedVaults().then(function(data) {
                                      console.log('Connected vaults', data);
                                    }, function(error) {
                                      console.error('Get connected vaults error', error);
                                    });
                                    */

                                    // Warning if hot is empty
                                    // $scope.send.currency_choices_constraints = [];

                                };

                                update_currency_choices();
                            }
                        });
                    })
                    .on('error', function (err) {
                        $exceptionHandler('request_account_currencies');
                    })
                    .request();

            }
            else {

                // If the account doesn't exist, we can only send XRP
                send.currency_choices_constraints.accountLines = ['XRP'];

            }

            update_currency_choices();

        };

        // Generate list of accepted currencies - Select non-XRP by default (if available)
        function update_currency_choices() {
            var send = $scope.send;

            var currencies = [];

            // Make sure none of the currency_choices_constraints are pending
            if (_.values(send.currency_choices_constraints).indexOf('pending') !== -1) {
                send.path_status = 'account-currencies';
                send.currency_choices = [];
                return;
            }
            else {
                // The possible currencies are the intersection of all provided currency
                // constraints.
                currencies = _.values(send.currency_choices_constraints);

                if (currencies.length == 1) {
                    currencies = currencies[0];
                }
                else {
                    currencies = _.intersection.apply(_, currencies);
                }
                currencies = _.compact(currencies);

                // If sending to hosted, add other available gateways as well
                if (send.wallet_type == 0) {
                    var currencies_hosted = _(send.hosted_choices).uniq('currency').pluck('currency').value();
                    currencies = _.union(currencies_hosted, currencies);
                }

                // If sending to hosted and network is not ripple, lock currency
                if (network_type != 2) {
                    currencies = [vault.currency];
                };

                currencies = _.uniq(currencies);

            }

            if (currencies.length === 1) {
                send.currency = send.currency_force = currencies[0];
            }
            else if (currencies.length === 0) {
                send.path_status = 'error-no-currency';
                send.currency = '';
            }
            else {
                send.currency_force = false;

                if (currencies.indexOf(send.currency) === -1) {
                    send.currency = currencies[0];
                }
            };

            $scope.send.currency_choices = currencies;
            update_currency();
        };

        function update_currency() {
            var send = $scope.send;
            var recipient = send.ripple_address;
            var currency = send.currency;

            reset_amount_deps();

            if (wallet) {

                // Update XRP available if ripple wallet
                if (currency == 'XRP' && (wallet[0].type == 10 || wallet[0].type == 11)) {
                    $timeout(function () {
                        $scope.available = wallet[0].xrp;
                    })
                }
                else {
                    // Update available amount
                    _.each(wallet[0].lines, function (line) {
                        if (line.currency == currency) {
                            $timeout(function () {
                                $scope.available = line.available;
                            })
                            return;
                        }
                    });
                };

                $scope.available = 0;

            };


            // Sending to hosted wallet can change recipient
            if (send.wallet_type === 0 || send.wallet_type === '0') {

                var vault = VaultsService.getVaultByCurrency(currency);

                if (vault == false) return;

                if (vault.cold != recipient) {
                    recipient = vault.cold;
                    send.ripple_address = vault.cold;
                };

            }

            // We should have a valid recipient
            if (!ripple.UInt160.is_valid(recipient)) {
                return;
            }

            if (!send.currency_choices || send.currency_choices.length === 0) {
                return;
            }

            update_amount();

        };

        function onTransactionProposed(res, tx) {
            setEngineStatus(res, false);
            if ($scope.mode === 'status') {
                sent(tx.hash);
            }
        };

        function onTransactionSuccess(res, tx) {
            setEngineStatus(res, true);
            $timeout(function () {
                $scope.$close();
            }, 1000);
        };

        function onTransactionError(res, tx) {
            $timeout(function () {
                $scope.mode = 'error';
                $exceptionHandler('transaction_error', res);

                if (res.engine_result) {
                    setEngineStatus(res, false);
                } else if (res.error === 'remoteError') {
                    $scope.error_type = res.remote.error;
                    $scope.errorMessage = res.remote.error_exception || '';
                } else {
                    $scope.error_type = 'unknown';
                }
            });
        };


        function sent(hash) {
            $scope.mode = 'status';
            RippleNetwork.remote.on('transaction', handleAccountEvent);

            function handleAccountEvent(e) {
                $scope.$apply(function () {
                    if (e.transaction.hash === hash) {
                        $scope.setEngineStatus(e, true);
                        RippleNetwork.remote.removeListener('transaction', handleAccountEvent);
                    }
                });
            }
        };

        function setEngineStatus(res, accepted) {
            $scope.engine_result = res.engine_result;
            $scope.engine_result_message = res.engine_result_message;
            $scope.engine_status_accepted = !!accepted;
            $scope.mode = 'status';
            $scope.tx_result = 'partial';

            switch (res.engine_result.slice(0, 3)) {
                case 'tes':
                    $scope.mode = 'status';
                    $scope.tx_result = accepted ? 'cleared' : 'pending';
                    break;
                case 'tep':
                    $scope.mode = 'status';
                    $scope.tx_result = 'partial';
                    break;
                default:
                    $scope.mode = 'rippleerror';
            }

        };

        function send_prepared() {

            var send = $scope.send;

            // Check if paths are available, if not then it is a direct send
            $scope.send.indirect = $scope.send.alt ? $scope.send.alt.paths.length : false;

            $scope.confirm_wait = true;
            $timeout(function () {
                $scope.confirm_wait = false;
            }, 1000, true);


            // Compute network fee
            $scope.networkFee = RippleNetwork.remote.transaction()._computeFee();

            $scope.sendMaxDeviation = 0.1;

            // Stop the pathfind - once we're on the confirmation page, we'll freeze
            // the last state we had so the user doesn't get surprises when
            // submitting.
            if ($scope.send.pathfind) {
                $scope.send.pathfind.close();
                delete $scope.send.pathfind;
            };

            // Account data
            // Filter correct account data depending on network
            if (network_type != 2) {

                switch (network_type) {

                    // SEPA
                    case 0:
                        if ((!send.account_id || send.account_id == 'new')) {
                            send.account_name = send.name;
                            send.account_address = send.iban;
                        }
                        else {
                            var account = _($scope.accounts).filter({ uuid: send.account_id }).value();
                            send.account_name = (typeof account[0] != 'undefined') ? account[0].legal_name : send.name;
                            send.account_address = (typeof account[0] != 'undefined') ? account[0].iban : send.iban;
                        }
                        break;

                    // Wire
                    case 1: // USD or GBP
                        if ((!send.account_id || send.account_id == 'new')) {
                            send.account_name = send.name;
                            send.account_address = send.iban;
                        }
                        else {
                            var account = _($scope.accounts).filter({ uuid: send.account_id }).value();
                            send.account_name = (typeof account[0] != 'undefined') ? account[0].legal_name : send.name;
                            send.account_address = (typeof account[0] != 'undefined') ? account[0].iban : send.iban;
                        }
                        break;

                    // Mail
                    case 7:
                        if ((!send.account_id || send.account_id == 'new')) {
                            send.account_name = send.name;
                            send.account_address = send.address;
                        }
                        else {
                            var account = _($scope.accounts).filter({ uuid: send.account_id }).value();
                            send.account_name = (typeof account[0] != 'undefined') ? account[0].name : send.name;
                            send.account_address = (typeof account[0] != 'undefined') ? account[0].display_address : send.address;
                        }
                        break;

                    // Other:
                    case 3: // Bitcoin
                    case 5: // Ethereum
                    case 6: // Reputation
                    case 9: // Ethereum Classic
                    case 10: // Dash
                    case 11: // Quantum
                    case 13: // Litecoin
                    case 14: // Bitcoin Cash
                    case 15: // Flare
                    case 16: // Songbird
                    case 18: // GALA
                    case 19: // USDT
                    case 20: // USDC
                    case 21: // WXRP
                        if ((!send.account_id || send.account_id == 'new')) {
                            send.account_name = send.name;
                            send.account_address = send.address;
                        }
                        else {
                            var account = _($scope.accounts).filter({ uuid: send.account_id }).value();
                            send.account_name = (typeof account[0] != 'undefined') ? account[0].name : send.name;
                            send.account_address = (typeof account[0] != 'undefined') ? account[0].address : send.address;
                        }
                        break;

                    // Faster Payments
                    case 22: // GBP only
                        if ((!send.account_id || send.account_id == 'new')) {
                            send.account_name = send.name;
                            send.account_address = send.bank_account_number;
                        }
                        else {
                            var account = _($scope.accounts).filter({ uuid: send.account_id }).value();
                            send.account_name = (typeof account[0] != 'undefined') ? account[0].legal_name : send.name;
                            send.account_address = (typeof account[0] != 'undefined') ? account[0].bank_account_number : send.bank_account_number;
                        }
                        break;
                }

            }

        };

        function send_confirmed() {

            console.log('Send confirmed');

            var send = $scope.send;

            $scope.mode = 'sending';

            // Save account if new
            if (network_type != 2 && (!send.account_id || send.account_id == 'new')) {

                var _send = {};

                // Filter correct account data depending on network
                switch (network_type) {

                    // SEPA
                    case 0:
                        _send = {
                            name: send.name,
                            legal_name: send.name,
                            iban: send.iban,
                            bic: send.bic,
                            street: send.street,
                            postcode: send.postcode,
                            city: send.city,
                            country: send.country,
                        }
                        break;

                    // Wire
                    case 1: // USD or GBP
                        _send = {
                            name: send.name,
                            legal_name: send.name,
                            iban: send.iban,
                            bic: send.bic,
                            street: send.street,
                            postcode: send.postcode,
                            city: send.city,
                            country: send.country,

                            bank_name: send.bank_name,
                            bank_street: send.bank_street,
                            bank_postcode: send.bank_postcode,
                            bank_city: send.bank_city,
                            bank_country: send.bank_country,
                        }
                        break;

                    // Mail
                    case 7:
                        _send = {
                            name: send.name,
                            street: send.street,
                            postcode: send.postcode,
                            city: send.city,
                            country: send.country,
                        }
                        break;

                    // Other:
                    case 3: // Bitcoin
                    case 5: // Ethereum
                    case 6: // Reputation
                    case 9: // Ethereum Classic
                    case 10: // Dash
                    case 11: // Quantum
                    case 13: // Litecoin
                    case 14: // Bitcoin Cash
                    case 15: // Flare
                    case 16: // Songbird
                    case 18: // GALA
                    case 19: // USDT
                    case 20: // USDC
                    case 21: // WXRP
                        _send = {
                            name: send.name,
                            address: send.address,
                        }
                        break;
                    case 22: // Faster Payments - GBP
                        _send = {
                            name: send.name,
                            legal_name: send.name,
                            street: send.street,
                            postcode: send.postcode,
                            city: send.city,
                            country: send.country,
                            sort_code: send.sort_code,
                            bank_account_number: send.bank_account_number
                        }
                        break;

                    // Error
                    default:
                        $scope.mode = 'error';
                        $scope.errorMessage = 'Account not supported';
                        $exceptionHandler('Account not supported');
                        return;
                }

                _send.network = network_type;

                var postData = JSON.stringify(_send);

                // Save new account
                User.post('accounts', postData).then(function (data) {

                    send.account_id = data.uuid;
                    send_confirmed_continue();

                }, function (error) {

                    $scope.mode = 'error';
                    $scope.errorMessage = error.data.message;
                    $exceptionHandler(error.data.message);
                    return;

                });

            }
            else {
                send_confirmed_continue();
            };

        };

        function send_confirmed_continue() {

            var send = $scope.send;
            var recipient = send.ripple_address;
            var currency = send.currency.trim().toUpperCase();
            var amount = send.ripple_amount;

            $scope.mode = 'sending';

            var vault = VaultsService.getVaultByCurrency(currency);

            // Sending from Hosted Wallet
            if (wallet[0].type == 0) {

                // console.log('Hosted wallet send');

                if (typeof vault == 'undefined') {
                    $scope.mode = 'error';
                    return;
                }

                var vault_id = vault.vault_id;
                var cold = vault.cold;

                // Check if withdrawal
                if (send.hosted_withdrawal) {
                    sendTX(send.account_id, send.amount, vault_id, wallet[0].address, send.message);
                    return;
                }

                // If cold == recipient we are sending hosted to hosted
                if (cold == recipient) {

                    var tx = {
                        amount: send.amount,
                        vault_uuid: vault_id,
                        message: send.message,

                        sending_address: parseInt(wallet[0].address),
                        receiving_address: parseInt(send.dt),

                        type: 2,    // Hosted
                    };

                    // Send
                    CoreRestangular.one('transactions').post('', tx).then(function (data) {

                        $scope.sending = false;
                        $scope.mode = 'sent';

                        // Refresh Wallet
                        WalletsService.refreshWallet(wallet[0]);

                        $timeout(function () {
                            $scope.$close();
                        }, 1000);

                    }, handleError);

                }
                else { // Sending from Ripple Wallet

                    // TODO CHECK IF IN CONTACTS ALREADY
                    var xaccounts = AccountsService.getByAddress(recipient);

                    if (typeof xaccounts !== 'undefined' && xaccounts.destination_tag && xaccounts.destination_tag == send.dt) {
                        sendTX(xaccounts.uuid, send.amount, vault_id, wallet[0].address, send.message);
                    } else {
                        // Create new account
                        var postData = {
                            network: 2,
                            name: (send.display_name) ? send.display_name : 'Unknown', // TODO - Ask for input
                            address: recipient,
                            destination_tag: parseInt(send.dt),
                        };

                        // Destination tag fix (server doesn't allow empty string DT)
                        if (!postData.destination_tag) {
                            delete postData.destination_tag;
                        }

                        // Save new account
                        User.post('accounts', postData).then(function (data) {
                            // console.log('Saved new account');
                            sendTX(data.uuid, send.amount, vault_id, wallet[0].address, send.message);

                        }, handleError);

                    };

                };

            }
            else {  // Sending from Ripple Wallet

                var tx = RippleNetwork.remote.transaction();

                // Source tag
                if (send.st) {
                    tx.source_tag(send.st);
                }

                // Destination tag
                if (send.dt) {
                    tx.destination_tag(parseInt(send.dt));
                }

                // Invoice ID if bridge network
                if (network_type != 2) {

                    // console.log(send.account_id);
                    var invoice_id = UUID.parse(send.account_id);

                    invoice_id = invoice_id.hexNoDelim + _.repeat('0', 32);
                    invoice_id = invoice_id.toUpperCase();

                    tx.invoiceID(invoice_id);
                }


                tx.payment(address, recipient, amount.to_json());


                if ($scope.send.alt) {
                    tx.send_max($scope.send.alt.send_max);
                    if (!$scope.send.alt.paths.length) {
                        tx.build_path(true);
                    }
                    else {
                        tx.paths($scope.send.alt.paths);
                    }
                }
                else {
                    if (!amount.is_native()) {
                        tx.build_path(true);
                    }
                }

                var maxLedger = Settings.client.tx_last_ledger || 5;

                tx.lastLedger(RippleNetwork.remote._ledger_current_index + maxLedger);

                tx.on('success', function (res) {
                    onTransactionSuccess(res, tx);
                });

                tx.on('proposed', function (res) {
                    onTransactionProposed(res, tx);
                });

                tx.on('error', function (res) {
                    onTransactionError(res, tx);
                });

                RippleTx.submitTransaction(tx, wallet[0], vault.vault_id)
                    .then(function(response) {
                        console.log('Transaction processed', response);
                    })
                    .catch(function (error) {
                        if (error.status === 403 && error.data.message && error.data.message.toLowerCase() === '2fa required') {
                            $scope.mode = false;
                            $scope.isUnlocked = false;
                            var listener = $scope.$on('2fa_authorized', function() {
                                $scope.isUnlocked = true;
                                $scope.wallet_error = false;
                                $scope.submitPayForm();
                                listener();
                            });
                        } else {
                            console.error(error);
                            $scope.sending = false;
                            $scope.mode = 'error';
                            // $scope.wallet_error = 'secret';
                            $scope.errorMessage = error.message;
                        }
                    });
            };
        };

        // Submit GateHub TX
        function sendTX(accountID, amount, vault_id, sending_address, message) {

            var tx = {
                amount: amount,
                vault_uuid: vault_id,
                sending_address: sending_address,
                account_uuid: accountID,
                network: network_type,
                type: 0, // Withdrawal
                message: message,
            };

            // Send
            CoreRestangular.one('transactions').post('', tx).then(function (data) {

                $scope.sending = false;
                $scope.mode = 'sent';

                // Refresh Wallet
                WalletsService.refreshWallet(wallet[0]);

                $timeout(function () {
                    $scope.$close();
                }, 1000);

            }, handleError);

        };

        function handleError(error) {
            if (error.status === 403 && error.data.message && error.data.message.toLowerCase() === '2fa required') {
                $scope.mode = false;

                $scope.isUnlocked = false;
                var listener = $scope.$on('2fa_authorized', function() {
                    $scope.isUnlocked = true;
                    $scope.submitPayForm();
                    listener();
                });
            }
            else {
                $scope.mode = 'error';
                $scope.errorMessage = error.data.message;
                $exceptionHandler(error);
            }
            $scope.sending = false;
        };

        $scope.handle2faError = handle2faError;
        function handle2faError(error) {
            if(error && error.data){
                if (error.data.error === '2fa_wrong_token') {
                    $scope.errorMessage = "Provided verification code is not valid.";
                } else if (error.data.error === '2fa_expired_token') {
                    $scope.errorMessage = "Provided verification code has expired.";
                } else if (error.data.error === 'code_already_used') {
                    $scope.errorMessage = "Entered 2FA code was already used.";
                } else {
                    $scope.errorMessage = "2fa authentication error.";
                    $exceptionHandler(error);
                }
            } else {
                $scope.errorMessage = "2fa authentication error.";
                $exceptionHandler("OTHER_2FA_ERROR", error);
            }
        }

        // Form submit (if valid)
        $scope.submitForm = function (isValid) {

            $scope.errorMessage = false;

            // Make sure the form is completely valid - should be!
            if (!isValid) {
                $scope.errorMessage = "One or more required fields are invalid";
                return;
            }

            send_prepared();

            $scope.setStep(2);

        };

        // Form confirm
        $scope.submitPayForm = function () {
            send_confirmed();
        };

        $scope.setStep = function (step) {
            $scope.step = step;
        };

        $scope.reset = function () {

            $scope.setStep(1);
            $scope.mode = false;
            $scope.sending = false;
            $scope.errorMessage = false;

            reset_amount_deps();

        };

        $scope.setRecipient = function (wallet) {

            $scope.send.dt = ''; // reset destination tag on recipient change

            var _recipient = {
                user_id: user.uid,
                name: wallet.name,
                gatehub_name: false,
                address: wallet.address,
                ripple_address: (wallet.type == 10 || wallet.type == 11) ? wallet.address : false,
                hosted_address: (wallet.type == 0) ? wallet.address : false,
                wallet_type: wallet.type,
                my_wallet: true,
            };

            $scope.send.name = _recipient;

        };

        // Search Names
        $scope.queryNames = function ($query) {

            return formatGatehubNames(false, $query);

            /*
            return $http.get(Settings.id.gatehub_name_server + '?query='+$query+'*', { cache: false, timeout: 2000 }).then(function(response) {

                var names = response.data.hits;
                return formatGatehubNames(names, $query);

            }, function(error) {
                console.error(error);
                return formatGatehubNames(false, $query);
            });
            */

        };

        // Format GateHub names
        function formatGatehubNames(names, query) {

            var xnames = [];

            if (names.length) {
                xnames = names.map(function (obj) {
                    return {
                        user_id: obj._id,
                        name: (obj._source.first_name !== null) ? obj._source.first_name + ' ' + obj._source.last_name : false,
                        gatehub_name: obj._source.name,
                        address: obj._source.address,
                        ripple_address: (obj._source.type == 10 || obj._source.type == 11) ? obj._source.address : false,
                        hosted_address: (obj._source.type == 0) ? obj._source.address : false,
                        wallet_type: obj._source.type,
                    }
                });

                // Remove me
                _.remove(xnames, function (name) {
                    return name.user_id == user.uid;
                });

                // Remove those without address
                _.remove(xnames, function (name) {
                    return !name.address
                });

                // Remove those without first name
                _.remove(xnames, function (name) {
                    return !name.name
                });

                // Filter Names
                if (query) {
                    xnames = _.filter(xnames, function (x) {
                        var name = x.name.toLowerCase();
                        query = query.toLowerCase();
                        return (name.indexOf(query) > -1);
                    });
                };

            }

            // Prepare all wallets
            var xwallets = wallets.filter(function (obj) {
                if (typeof obj !== 'undefined' && obj.address != address) {
                    return true;
                }
                else {
                    return false;
                }
            })
                .map(function (obj) {
                    return {
                        user_id: user.uid,
                        name: obj.name,
                        gatehub_name: false,
                        address: obj.address,
                        ripple_address: (obj.type == 10 || obj.type == 11) ? obj.address : false,
                        hosted_address: (obj.type == 0) ? obj.address : false,
                        wallet_type: obj.type,
                        my_wallet: true,
                    }
                });

            // Filter Wallets
            if (query) {
                xwallets = _.filter(xwallets, function (x) {
                    var name = x.name.toLowerCase();
                    query = query.toLowerCase();
                    return (name.indexOf(query) > -1);
                });
            };

            // TODO add contacts

            // Combine - only if searching and not GateHub name
            var response = _.union(xwallets, xnames);


            // Add wallets to the list and return
            return response;

        };

        function fetchUserCover(userId) {
            StorageCore.getCoverByUserId(userId).then(data => {
                $scope.destinationCover = data;
            });
        }

        $scope.cancel = function() {
          $scope.$dismiss();
        };

        // Remote receiver and amount
        if ($stateParams.to) {

            $timeout(function () {

                if (typeof $scope.send == 'undefined') return;

                $scope.send.name = $stateParams.to;

                // DT
                if ($stateParams.dt && typeof $stateParams.dt === "string") {
                    $scope.send.dt = parseInt($stateParams.dt);
                }

                // Amount
                if ($stateParams.amount) {

                    var amountValue = decodeURIComponent($stateParams.amount);
                    var amount = ripple.Amount.from_json(amountValue);
                    var currency = amount.currency();

                    var _amount = (currency.to_human() == 'XRP') ? amount.to_human() * 1000000 : amount.to_human();
                    var _currency = currency.to_human();

                    $scope.send.amount = parseFloat(_amount);
                    $scope.send.currency_choices = [_currency];
                    $scope.send.currency = _currency;

                };

            });

        };
    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:SendInterledgerCtrl
 * @description
 * # SendInterledgerCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
.controller('SendInterledgerCtrl', ["$scope", "$rootScope", "$timeout", "WalletsService", "VaultsService", "Interledger", "CurrencyConverterRestangular", "$exceptionHandler", function ($scope, $rootScope, $timeout, WalletsService, VaultsService, Interledger, CurrencyConverterRestangular, $exceptionHandler) {

        // Init
        resetForm();
        init();

        $scope.mode = 'loading';
        $scope.loading = true;
        $scope.step = 1;
        $scope.sending_choices = [];
        
        var wallet;
        var rate_uuid;

        ///////////////////////////////////////////////////////////


        function init() {

            // Wait untill wallets are fully loaded
            WalletsService.getWallets().then(function() {

                // Get active wallet
                wallet = WalletsService.getActive();

                // Something went wrong, let's stop before it gets even worse
                if(!wallet) {
                    $exceptionHandler('wallet_not_found');
                    return;
                };

                VaultsService.getAllVaults().then(function(data) {

                    $timeout(function(){
                        $scope.wallet = wallet[0];
                        $scope.mode = false;
                        $scope.loading = false;

                        $scope.vaults = data;
                    }, 0);

                }, function(error) {
                    $exceptionHandler(error);
                    return;
                });

                // Update data on change
                $rootScope.$on('$balancesUpdate', function() {
                    $timeout(function() {
                        var wallet = wallet = WalletsService.getActive();
                        $scope.wallet = wallet[0];
                    });
                });

            }, function(error) {
                $exceptionHandler(error);
                return;
            })

        };

        function resetForm() {

            $scope.errorMessage = false;
            $scope.sending = false;
            $scope.mode = false,

            $scope.form = {};
            $scope.send = {};

        };

        $scope.updateName = function() {

            console.log('Update name');

            var name = $scope.send.name;

            if($scope.form.send) {
                $scope.form.send.name.$setValidity('notInterledger', true);
                $scope.form.send.name.$setValidity('nameError', true);
                $scope.form.send.name.$setValidity('notEmail', true);
            }

            if(isEmail(name)) {

                Interledger.getName(name).then(function(data) {

                    if(data.length) {
                        if(data[0].walletId){
                            $scope.send.receiving_wallet = data[0].walletId;
                            updateReceivingWallet();
                        }
                        else {

                            // Get any hosted if there is no primary hosted
                            var receiving_wallet = _(data).filter({primary: 0, type: 0}).value();

                            if(receiving_wallet.length) {
                                $scope.send.receiving_wallet = receiving_wallet[0].address;

                                // Update receiving wallet
                                updateReceivingWallet();
                            }
                            else {
                                // No wallet hosted found
                                $scope.form.send.name.$setValidity('notInterledger', false);
                            }

                        }

                    } else {
                        $scope.form.send.name.$setValidity('notInterledger', false);
                    }

                }, function(error){
                        $scope.form.send.name.$setValidity('nameError', false);
                });

            }
            // Sending to gatehub wallet
            else if(isGatehubWallet(name)) {

                $scope.send.receiving_wallet = name;
                updateReceivingWallet();
            }
            else {
                // $scope.form.send.name.$setValidity('notEmail', false);
            };

        };

        $scope.updateAmount = function() {

            console.log('Update amount');

            // Update sending choices
            updateSendingChoices();

        };

        function updateReceivingWallet() {

            console.log('Update receiving wallet');

            if(!$scope.send.receiving_wallet) return;

            // Check if it's mine
            var found = WalletsService.getByAddress($scope.send.receiving_wallet);
            $scope.send.my_wallet = (typeof found == 'undefined') ? false : true;

            // Reset choices
            $scope.receiving_choices = [];

            // Get recipient wallet vaults
            WalletsService.getGatehubWallet($scope.send.receiving_wallet).getList().then(function(data) {

                $scope.form.send.name.$setValidity('walletNotFound', true);

                var _data = data.plain();

                var _vaults = [];

                for (var i = _data.length - 1; i >= 0; i--) {

                    var _line = _data[i];

                    // Skip synthetic vaults
                    // if(_line.issuer_address == null) continue;

                    var vault = {
                        vault_uuid: _line.vault_uuid,
                        currency: _line.asset_code,
                        user_uuid: _line.user_uuid,
                    }

                    _vaults.push(vault);

                }

                if(_vaults.length != 0) {
                    $scope.form.send.name.$setValidity('noVaultsConnected', true);
                    updateReceivingChoices(_vaults);


                }
                else {
                    $scope.form.send.name.$setValidity('noVaultsConnected', false);
                };

            }, function(error) {
                $exceptionHandler(error);
                $scope.form.send.name.$setValidity('walletNotFound', false);
            });

        };

        function updateReceivingChoices(receiving_vaults) { // receiving_vaults

            console.log('Update receiving choices');

            $scope.form.send.name.$setValidity('noConnector', true);

            var _vaults = [];

            // Get LP vaults
            Interledger.getLiquidityProvider().then(function(liquidity_provider_vaults) {

                for (var i = receiving_vaults.length - 1; i >= 0; i--) {

                    for (var j = liquidity_provider_vaults.vaults.length - 1; j >= 0; j--) {

                        if(receiving_vaults[i].vault_uuid == liquidity_provider_vaults.vaults[j].vault_uuid) {
                            _vaults.push(receiving_vaults[i]);
                        }

                    }

                }

                if(_vaults.length != 0) {

                    $scope.form.send.name.$setValidity('noConnector', true);

                    // Sort by currency alphabetically
                    var _sortedVaults = _.sortBy(_vaults, 'currency');

                    $scope.send.receiving_choices = _sortedVaults;
                    $scope.send.receiving_vault = _sortedVaults[0];

                }
                else {
                    $scope.form.send.name.$setValidity('noConnector', false);
                };

            }, function(error) {
                $scope.form.send.name.$setValidity('noConnector', false);
            });

        };

        function updateSendingChoices() {

            console.log('Updating sending choices');

            $scope.loading_sending_choices = true;
            $scope.sending_choices = [];
            $scope.send.sending_vault = false;
            // matej route
            Interledger.getBasesByCounter($scope.send.receiving_vault.vault_uuid).then(function(liquidity_bases){

                var amount = $scope.send.amount;
                if(!amount) return;

                var sender_bases = Object.values($scope.wallet.lines).map(function(x){
                    return x.vault.uuid;
                });
                var available_bases = _.intersection(sender_bases, liquidity_bases);

                var counter = $scope.send.receiving_vault.vault_uuid;

                var len = available_bases.length;
                var processed = 0;

                if(len > 0){
                    $scope.no_pairs_found = false;
                    _.each(available_bases, function(base) {
                        CurrencyConverterRestangular.one('best').one('counter').get({
                            sending_vault: base,
                            receiving_vault: counter,
                            amount: amount
                        }).then(function (data) {

                            processed++;
                            var rate = data.rate;
                            var sending_amount = data.amount;
                            rate_uuid = data.rate_uuid;

                            var line = _.find( Object.values($scope.wallet.lines), function(el){
                                return el.vault.uuid == base;
                            });

                            if( new Decimal(line.available).gte( new Decimal(sending_amount) ) ) {
                                line.sending_amount = sending_amount;
                                $scope.sending_choices.push(line);
                            }
                            if(processed == len) $scope.loading_sending_choices = false;
                        }, function(error){
                            processed++;
                            $exceptionHandler(error);
                            console.log('Liquidity provider for pair does not exist:', base, counter); // ignore
                            if(processed == len) $scope.loading_sending_choices = false;
                            return;
                        });
                    });

                } else {
                    $scope.no_pairs_found = true;
                    $scope.loading_sending_choices = false;
                }

            });

        };

        $scope.submitForm = function(isValid) {

            $scope.errorMessage = false;

            if (!isValid) {
                $scope.errorMessage = "One or more required fields are invalid";
                return;
            }

            if ($scope.available === 0) {
                $scope.errorMessage = "You don't have enough funds";
                return;
            }

            $scope.sending = true;
            $scope.mode = 'sending';

            var params = {
                sending_vault: $scope.send.sending_vault.vault.uuid,
                receiving_vault: $scope.send.receiving_vault.vault_uuid,
                sending_wallet: $scope.wallet.address,
                receiving_wallet: $scope.send.receiving_wallet,
                amount: $scope.send.amount,
                rate: rate_uuid // if it fails, I get an expired error (rate invalid or expired)
            }

            CurrencyConverterRestangular.one('convert').post('counter', params).then(function(data) {

                $scope.sending = false;
                $scope.mode = 'success';

                // Refresh Wallet
                WalletsService.refreshWallet($scope.wallet);

                $timeout(function() {
                    $scope.$close();
                }, 2000);

            }, function(error) {
                $exceptionHandler(error);
                $timeout(function() {
                    $scope.sending = false;
                    $scope.mode = 'error';
                    // Display error message
                    $scope.errorMessage = error.data.message;
                    if(error.data.message == 'RATE_INVALID_OR_EXPIRED'){
                        $scope.errorMessage = 'Rate expired (you have 60 seconds to confirm payment). Please try again.';
                    }
                }, 0);
                // RATE_INVALID_OR_EXPIRED
            });

        };

        $scope.setStep = function(value) {
            $scope.step = value;

            if(value == 2) calculate();
        };

        function calculate() {

            $scope.calculate = true;
            $scope.exchange = true;

            var base = $scope.send.sending_vault.vault.uuid;
            var counter = $scope.send.receiving_vault.vault_uuid;

            // Check if local ILP transaction within same vault (no fee)
            if(base === counter) {
                $scope.exchange = false;
                $timeout(function() {
                    $scope.send.rate = 1;
                    $scope.send.sending_amount = $scope.send.amount;
                    $scope.calculate = false;
                }, 300);
                return;
            };

            // Check if local ILP transaction within different vaults
            Interledger.getRate(base, counter).then(function(data) {
                var _data = data.plain();

                // Dest amonut
                var index = 0;

                for (var i = 0; i < _data.rate_curve.length; i++) {
                    if(_data.rate_curve[i][1] < $scope.send.amount) {
                        continue;
                    } else {
                        index = i;
                        break;
                    };
                }

                if(index == _data.rate_curve.length || index == 0) {
                    // Error
                    $exceptionHandler('max_limit_exceeded');
                }

                $scope.send.rate = _data.rate_curve[index][1] / _data.rate_curve[index][0];
                $scope.send.sending_amount = $scope.send.amount / $scope.send.rate;

                $scope.calculate = false;

            }, function(error) {
                $exceptionHandler(error);
            });

        };

    }]);



'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:WalletCtrl
 * @description
 * # WalletCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('WalletCtrl', ["$scope", "$timeout", "$rootScope", "$exceptionHandler", "VaultsService", "$stateParams", "$state", "$localStorage", "WalletsService", "RippleNetwork", "RippleCharts", "coreSecurity", "$sessionStorage", "$filter", "IlpRestangular", "$websocket", "ENV", "ExportService", "RippleTx", "$uibModal", "BalanceSorting", "CoreRestangular", "$window", "$interval", "NonstandardCurrencies", function ($scope, $timeout, $rootScope, $exceptionHandler, VaultsService, $stateParams, $state, $localStorage, WalletsService, RippleNetwork, RippleCharts, coreSecurity, $sessionStorage, $filter, IlpRestangular, $websocket, ENV, ExportService, RippleTx, $uibModal, BalanceSorting, CoreRestangular, $window, $interval, NonstandardCurrencies) {

        $scope.state = $state;

        $scope.loading = true;
        $scope.wallet = false;
        $scope.wallets = [];
        $scope.balanceLines = [];

        $scope.isWalletSelectorActive = false;

        var unconnected_lines = [];
        var unconnected_lines_all = [];

        var wallet;
        var master_key;
        var address;
        var secret_encrypted;
        var regular_encrypted;
        var secret;
        var regular_secret;
        var vaults;

        $scope.aggregateValueAsMetric = 0;
        $scope.activeMetricCode = $localStorage.activeMetricCode;

        $scope.txUuidFilter = $filter('txUuidFilter');
        var nameAddress = $filter('nameAddress');

        var walletsLoaded = false;
        var bixbyWS; // payment streams
        $scope.amountsToClaim = [];
        $scope.claims_data = [];

        $scope.orderSortBy = 'seq';
        $scope.orderSortReverse = true; // latest first

        $scope.wpBannerShown = false;
        $scope.multisigStatus = { };

        $scope.transactionsPageTitle = "Wallet Transactions";

        var balanceUpdateListener;
        var offerUpdateListener;

        $scope.reconnectPSDWallet = reconnectPSDWallet;
        $scope.refreshPSDWallet = refreshPSDWallet;

        $scope.psdRefreshErrorMessage = null;

        // Init
        init();

        ///////////////////////////////////////////////////////////

        function init() {

            // Lock
            $scope.isUnlocked = coreSecurity.isMasterUnlocked();
            if (!$scope.isUnlocked) {
                var listener = $scope.$on('2fa_authorized', function() {
                    $scope.isUnlocked = true;
                    listener();
                });
            }

            $scope.txHistoryFilters = WalletsService.getTxHistoryFilters();

            if (!wallet) {
                wallet = WalletsService.getActive();
            }
            // gid
            var removeWalletsLoadedListener1 = $scope.$on('walletsLoaded', function () {
                walletsLoaded = true;

                if (!wallet) {
                    wallet = WalletsService.getActive();
                }

                IlpRestangular.one('balances').one(wallet[0].address).get().then(function(ilpBalances){
                    // transform amount from string to float
                    $scope.amountsToClaim = _.map(ilpBalances.plain(), function(balance){
                        balance.amount = parseInt(balance.amount);
                        return balance;
                    });

                    // updateAggregateValueAsXrp(); // add ILP balances to NET worth

                    // we don't want to add this to net worth as this is not a part of wallet balances
                    // updateNetWorth();

                    IlpRestangular.one('vaults').get().then(function (response) {
                        var ilp_vaults = response.plain();
                        for (var i = 0; i < ilp_vaults.length; i++) {
                            (function(i){ // need IIFE here because using "var" (ES5)
                            $scope.claims_data[ilp_vaults[i].vault_uuid] = {};
                            $scope.claims_data[ilp_vaults[i].vault_uuid].min_claim_amount = parseInt(ilp_vaults[i].min_claim_amount);
                            $scope.claims_data[ilp_vaults[i].vault_uuid].min_amount_unit = Math.pow(10, -(ilp_vaults[i].asset_scale));
                            VaultsService.checkIfGatewayConnectedByVaultId(ilp_vaults[i].vault_uuid).then(function(result){
                                $scope.claims_data[ilp_vaults[i].vault_uuid].gateway_connected = result;

                            });
                            }(i));
                        }
                    }, function (error) {
                        $exceptionHandler(error);
                        console.log('Error getting minimum claims', error);
                    });

                    // START BIXBY WEBSOCKET
                    if(wallet[0].type == 0){
                        startPaymentStreams();
                    }

                }, function(error){
                    $exceptionHandler(error);
                    console.log('ILP not enabled', error);
                });

                removeWalletsLoadedListener1();
            });

            VaultsService.getVaults().then(function (_vaults) {

                vaults = _vaults;

                $scope.filterableVaults = _vaults.filter(function(v){
                    return v.gateway_operational_status === 1 && v.status === 1;
                }).map(function(v) {
                    return {
                        uuid: v.uuid,
                        asset_code: v.asset_code
                    }
                });

                // Wait untill wallets are fully loaded
                WalletsService.getWallets().then(function (data) {

                    // Get active wallet (if exists)
                    var id = $stateParams.id;

                    if (id) {

                        // Save new active wallet
                        loadWallet(WalletsService.setActive(id), data);

                    }
                    else {

                        // Load active wallet
                        wallet = WalletsService.getActive();

                        // Something went wrong, let's stop before it gets even worse
                        if (!wallet) {
                            $exceptionHandler('wallet_not_found');
                            return;
                        };

                        // Redirect to it
                        $state.go('wallets.item.balance', { id: wallet[0].address });

                    }

                    $scope.$broadcast('walletsLoaded', true);

                }, function (error) {
                    $exceptionHandler(error);
                    $scope.loading = false;
                    return;
                })

            }, function (error) {
                $exceptionHandler(error);
                $scope.loading = false;
                return;
            });

        };

        function loadWallet(xwallet, data) {
            // Get active wallet
            wallet = xwallet;

            // Something went wrong, let's stop before it gets even worse
            if (!wallet) {
                $exceptionHandler('wallet_not_found');
                $state.go('wallets');
                return;
            };

            WalletsService.getHistory(wallet[0]);

            // Update rates
            updateExchangeRates();

            $scope.loading = false;
            $scope.wallet = wallet[0];
            $scope.wallets = data;

            BalanceSorting.getBalanceOrder($scope.wallet.address)
                .then(function(balances) {
                    $scope.lineSortOrder = balances;
                    $scope.updateBalanceLines();
                })
                .catch(function(error) {
                    $exceptionHandler(error);
                    $scope.lineSortOrder = [];
                });
            $scope.updateBalanceLines();

            var first_load = true;

            // Update data on change
            balanceUpdateListener = $rootScope.$on('$balancesUpdate', function () {

                var wallet = WalletsService.getActive();
                $scope.wallet = wallet[0];
                $scope.updateBalanceLines();

                if (first_load) {
                    updateExchangeRates();
                    first_load = false;
                }

                updateNetWorth();

                updateTrustLines();
            });

            offerUpdateListener = $rootScope.$on('$offersUpdate', function () {
                $timeout(function () {
                    $scope.wallet = wallet[0];
                    $scope.updateBalanceLines();
                });
            });

            updateTrustLines();
            checkMultisigStatus();
        };

        /****** Cancelling orders ******/
        $scope.currentOrderNum = 0;

        $scope.cancelOrder = function (seq, $event) {
            if ($event !== false) {
                $event.stopPropagation();
            }
            cancelOrderPromise(seq).then(function (response) {
                console.log('[ripple cancel order] success', response);
            }, function (error) {
                $exceptionHandler(error);
                console.log('[ripple cancel order] error', error);
            });
        }

        $scope.cancelAllOrders = function () {
            $scope.cancellingAll = true;
            var orderSequences = _.map($scope.wallet.offers, function (order) { return order.seq; });
            $scope.allOrdersCount = orderSequences.length;
            $scope.currentOrderNum = 0;
            return cancelAllOrdersPromisified(orderSequences);
        };

        function cancelOrderPromise(seq) {
            return new Promise(function (resolve, reject) {
                if (!seq) {
                    reject("Sequence number missing");
                }

                $scope.currentOrderNum++;
                var cancelOrder = $scope.wallet.offers[seq];
                cancelOrder.cancelling = true;

                var tx = RippleNetwork.remote.transaction();
                tx.offer_cancel($scope.wallet.address, seq);

                tx.on('success', function (res) {
                    resolve(res);
                });

                tx.on('error', function (err) {
                    cancelOrder.cancelling = false;
                    $exceptionHandler(err);
                    reject(err);
                });

                RippleTx.submitTransaction(tx, $scope.wallet)
                    .catch(function (error) {
                        $scope.currentOrderNum--; // undo counter increase
                        if (error.status === 403 && error.data.message && error.data.message.toLowerCase() === '2fa required') {
                            $scope.isUnlocked = false;
                            var listener = $scope.$on('2fa_authorized', function() {
                                $scope.isUnlocked = true;
                                cancelOrderPromise(seq);
                                listener();
                            });
                        } else {
                            $exceptionHandler(error);
                            reject(error.message);
                        }
                    });

            });
        }

        function cancelAllOrdersPromisified(orderSequences) {
            console.log('cancelling all orders:', orderSequences);
            if (orderSequences.length === 0) {
                $scope.cancellingAll = false;
                return Promise.resolve();
            }
            var orderSequence = orderSequences.pop();
            return cancelOrderPromise(orderSequence).then(function () {
                cancelAllOrdersPromisified(orderSequences);
            }).catch(function() {
                $scope.cancellingAll = false;
            });
        }

        /******* End of order cancelling ******/

        function updateExchangeRates() {

            for (var line in wallet[0].lines) {

                (function () {

                    var _currency = wallet[0].lines[line].currency;
                    var _issuer = wallet[0].lines[line].account;
                    var _base = _currency + '+' + _issuer;

                    if (_currency == 'XRP' || !_issuer || !_base) return;

                    RippleCharts.getExchangeRates(_base, 'XRP')
                        .success(function (data) {
                            if (data.result == 'success' && data.rate > 0) {
                                $localStorage.exchangeRates[_currency + ':' + _issuer] = data.rate;
                            }
                        });

                })();

            };

        };

        $scope.$watch('wallet.xrp', updateNetWorth);
        $scope.$watch('wallet.balances', updateNetWorth, true)


        function updateTrustLines() {
            // Check gateways trust lines for every vault
            for (var i = vaults.length - 1; i >= 0; i--) {

                var vault = vaults[i];
                if (vault.asset_code === 'XRP') continue; // Skip XRP
                if (vault.status !== 1) continue; // Skip non-active vaults

                //var env_vault = VaultsService.getVaultByCurrency(vault.asset_code); // NOT OK WHEN MULTIPLE VAULTS HAVE SAME ASSET CODE!
                var env_vault = VaultsService.getVaultByVaultId(vault.uuid);

                // Skip synthetic
                if (typeof env_vault.cold == 'undefined' || env_vault.cold == '') continue;

                var id = env_vault.cold + NonstandardCurrencies.encodeAssetCode(vault.asset_code);
                var connected = isVaultConnected(id);
                var connectedAll = isVaultConnectedAll(id);

                var obj = {
                    currency: vault.asset_code,
                    issuer: env_vault.cold,
                    name: env_vault.gateway_name,
                    id: id
                }

                // Unconnected lines
                if (connected) {
                    // Remove from unconnected
                    _.remove(unconnected_lines, function (line) {
                        return line.id === id
                    });
                }
                else {
                    // Add to unconnected
                    if (_(unconnected_lines).filter({ id: id }).value().length == 0) {
                        // Filter hidden ones
                        if (obj.currency != 'PTT' && typeof obj.issuer != 'undefined') {
                            unconnected_lines.push(obj);
                        };
                    };
                }

                // Unconnected lines - Including hidden
                if (connectedAll) {
                    // Remove from unconnected
                    _.remove(unconnected_lines_all, function (line) {
                        return line.id === id
                    });
                }
                else {
                    // Add to unconnected
                    if (_(unconnected_lines_all).filter({ id: id }).value().length == 0) {
                        unconnected_lines_all.push(obj);
                    };
                }

            };

            $scope.unconnected_lines = unconnected_lines;
            $scope.unconnected_lines_all = unconnected_lines_all;
        }

        function isVaultConnected(id) {
            // Hide hidden lines
            if (_($localStorage.hideLines).filter({ id: id }).value().length != 0) {
                return true;
            }

            for (var line in $scope.wallet.lines) {
                if (line == id) {
                    return true;
                }
            }
            return false;

        };

        function isVaultConnectedAll(id) {
            for (var line in $scope.wallet.lines) {
                if (line == id) {
                    return true;
                }
            }

            return false;
        };

        $scope.hideConnectLine = function (line) {

            // Add to hidden lined
            if (_($localStorage.hideLines).filter({ id: line.id }).value().length == 0) {
                $localStorage.hideLines.push(line);
            };

            // Remove from unconnected
            _.remove(unconnected_lines, function (_line) {
                return _line.id === line.id
            });

            $scope.unconnected_lines = unconnected_lines;

        };


        $scope.changeMetric = function (currency) {
            // Update last selected in storage
            $localStorage.activeMetricCode = currency;

            // Update view
            $scope.activeMetricCode = currency;

            // updateAggregateValueDisplayed();
            updateNetWorth();

            updateNetWorthAllWallets();
        };

        // History
        $scope.loadMore = function () {
            if (wallet[0].loadingHistory !== true && wallet[0].endHistory !== true) {
                console.log('loading more...');
                WalletsService.loadMore(wallet[0]);
            };
        };

        // CSV export
        $scope.rippleExportHeader = ExportService.getRippleExportHeader();
        $scope.hostedExportHeader = ExportService.getHostedExportHeader();

        $scope.startRippleExport = startRippleExport;
        function startRippleExport(account, from, to) {

            $scope.exporting = true;
            $scope.errorMessage = "";

            return ExportService.rippleExport(account, from, to).then(function(result){
                $scope.exporting = false;
                return result;
            }, function(error) {
                    $scope.exporting = false;
                    $scope.errorMessage = "There was an error exporting transactions from wallet " + account + ".";

                    $exceptionHandler(error);
                    console.log("Error exporting ripple transactions: ", error);
            });
        }

        $scope.startHostedExport = startHostedExport;
        function startHostedExport(account, from, to) {

            $scope.exporting = true;
            $scope.errorMessage = "";

            return ExportService.hostedExport(account, from, to).then(function(result){
                $scope.exporting = false;
                return result;
            }, function(error){
                $scope.exporting = false;
                $scope.errorMessage = "There was an error exporting transactions from wallet " + account + ".";

                $exceptionHandler(error);
                console.log("Error exporting hosted transactions: ", error);
            });
        }


        // end of CSV export

        // Interledger start ---------------------------------------- //

        var retryWebsocketOnClose = true;

        function startPaymentStreams() {
            wallet = WalletsService.getActive();
            // Something went wrong, let's stop before it gets even worse
            if (!wallet) {
                $exceptionHandler('wallet_not_found');
                return false;
            };

            bixbyWS = $websocket("wss://" + ENV.apiILP.replace("https://", "") + "balances/subscribe", ["access_token_" + getAccessToken()]);

            bixbyWS.onOpen(function () {
                console.log("Bixby websocket open.");
                if (bixbyWS) {
                    bixbyWS.send(JSON.stringify({
                        method: "subscribe",
                        params: wallet[0].address,
                    }));
                }
            });

            bixbyWS.onError(function () {
                console.log("Bixby websocket error");
                $exceptionHandler('bixby_ws_error');
            });

            bixbyWS.onClose(function () {
                if (retryWebsocketOnClose) {
                    console.log("Bixby websocket closed, retrying in 3s...");
                    $timeout(function () {
                        bixbyWS = startPaymentStreams();
                    }, 3000);
                } else {
                    console.log("Bixby websocket closed successfuly.");
                }
            });

            bixbyWS.onMessage(function (event) {
                console.log("Received Bixby websocket message.");
                $scope.claim_error = "";
                try {
                    var balance = JSON.parse(event.data);

                    // Check if vault exists in the scope already
                    for (var i = 0; i < $scope.amountsToClaim.length; i++) {
                        if ($scope.amountsToClaim[i].vault_uuid === balance.vault_uuid) {
                            // We have it, change the amount
                            $scope.amountsToClaim[i].amount = parseInt(balance.amount);
                            $scope.amountsToClaim[i].amount_base = parseInt(balance.amount_base);
                            $scope.amountsToClaim[i].amount_fee = parseInt(balance.amount_fee);

                            // If less then treshold (for example after claiming funds), remove from displayed streams
                            var treshold = $scope.amountsToClaim[i].min_amount_unit;

                            if ($scope.amountsToClaim[i].amount < treshold) {
                                $scope.amountsToClaim[i].amount = false; // if false, fronted displays 0.00, if 0, frontend displays 0.0000000000000...
                                // animated
                                $scope.amountsToClaim[i].hidden = true;
                                $timeout(function () {
                                    $scope.amountsToClaim.splice(i, 1);
                                }, 500);
                            }
                            return;
                        }
                    }

                    // We don't have it, so we add
                    var vault = VaultsService.getVaultByVaultId(balance.vault_uuid);
                    var currency = vault.currency || "N/A";
                    $scope.amountsToClaim.push({
                        currency: currency,
                        amount: parseInt(balance.amount),
                        vault_uuid: balance.vault_uuid
                    });


                    // updateAggregateValueAsXrp();
                    // updateNetWorth();

                } catch (e) {
                    $exceptionHandler(e);
                    console.log("Error handling Bixby websocket message:", e);
                }
            });

        }

        function getAccessToken() {
            return $sessionStorage.token.access_token;
        }

        $scope.claimCoilIncomingAmount = function (claim) {
            $uibModal.open({
                templateUrl: 'views/wallets/modal_claim_funds.html',
                controller: 'ClaimFundsCtrl',
                controllerAs: 'vm',
                resolve: {
                    data: function () {
                        return {
                            wallet: wallet[0],
                            toClaim: $scope.amountsToClaim.filter(v => v.vault_uuid === claim.vault_uuid)[0],
                        };
                    }
                }
            }).result.finally(function () {
                IlpRestangular.one('balances').one(wallet[0].address).get().then(function(ilpBalances){
                    $scope.amountsToClaim = _.map(ilpBalances.plain(), function(balance){
                        balance.amount = parseInt(balance.amount);
                        return balance;
                    });
                    $rootScope.$broadcast('$balancesUpdate'); // trigger update
                }, function(error){
                    $exceptionHandler(error);
                    console.log('ILP not enabled anymore', error);
                });
            });
        }

        $scope.$on("$destroy", function () {
            retryWebsocketOnClose = false;
            if (bixbyWS && bixbyWS.readyState == 1) {
                console.log('Closing Bixby websocket...');
                bixbyWS.close(true); // true = force close
            }
        });
        // Interledger end ---------------------------------------- //

        // Sorting orders start ----------------------------------- //
        $scope.offersArray = [];
        $scope.$watch('wallet.offers', function () {
            refreshOffersArray();
        }, true);

        function refreshOffersArray() {
            if ($scope.wallet && $scope.wallet.offers) {

                var offers = $scope.wallet.offers;

                // transform to array
                var offersArray = [];
                var key;
                for (var key in offers) {
                    if (offers.hasOwnProperty(key)){
                        offersArray.push(offers[key]);
                    }
                }

                var sortedOffersArray = _.sortBy(offersArray, function (offer) {
                  var newOrderBy;
                  switch($scope.orderSortBy){
                    case 'price':
                      newOrderBy = parseFloat(offer.price);
                      break;
                    case 'first':
                      newOrderBy = parseFloat($filter('rpamount')(offer.first));
                      break;
                    case 'second':
                      newOrderBy = parseFloat($filter('rpamount')(offer.second));
                      break;
                    case 'type':
                      newOrderBy = (offer.type == 'sell') ? 1 : 0;
                      break;
                    case 'seq':
                    default:
                      newOrderBy = offer.seq;
                  }
                  return $scope.orderSortReverse ? -(newOrderBy) : newOrderBy;
                });

                $scope.offersArray = sortedOffersArray;
            }
        }

        $scope.setOrderSort = function(property){
          $scope.orderSortReverse = ($scope.orderSortBy === property) ? !$scope.orderSortReverse : false;
          $scope.orderSortBy = property;
          refreshOffersArray();
        }

        $scope.getSortArrowClass = function(type){
          if(type == $scope.orderSortBy){
            if($scope.orderSortReverse){
              return "sort_desc";
            } else {
              return "sort_asc";
            }
          } else {
            return "sortable";
          }
        }
        // Sorting orders end ------------------------------------- //

        $scope.copyFullAmount = function(amount, isXRP){
          if(isXRP){
            var fullAmount = amount;
          } else {
            var fullAmount = ($filter('rpamount')(amount, { abs_precision: 15 })).replace(/,|(\.?0*)$/g, '');
          }

          $scope.copyValue(fullAmount);
        }

        $scope.copyValue = function(value) {
            var body = angular.element(document.body);
            var textarea = angular.element("<textarea/>");
            textarea.css({
                position: "fixed",
                opacity: "0"
            });
            textarea.val(value);
            body.append(textarea);
            textarea[0].select();
            document.execCommand("copy");
            textarea.remove();
        }

        $scope.setTxFilter = function(filter, value, refreshOnly){
            if(!refreshOnly){
                WalletsService.setTxHistoryFilter(filter, value);
            }
            $scope.txHistoryFilters = WalletsService.getTxHistoryFilters();

            wallet[0].loadingHistory = false;
            wallet[0].endHistory = false;
            wallet[0].history = [];

            if(wallet[0].type == 0){
                WalletsService.refreshWallet(wallet[0]);
            } else {
                WalletsService.getHistory(wallet[0], true);
            }
        }

        $scope.sortableOptions = {
            'ui-preserve-size': true,
            handle: '.drag-handle',
            cancel: '.unsortable',
            stop: function(e, ui) {
                $scope.lineSortOrder = $scope.balanceLines.map(function(line) {
                    return line._issuer;
                });
                BalanceSorting.setBalanceOrder($scope.wallet.address, $scope.lineSortOrder);
            },
        };

        $scope.customBalanceOrder = function (item) {
            var id = item._issuer;
            if ($scope.lineSortOrder) {
                var index = $scope.lineSortOrder.indexOf(id);
                return index > -1 ? index : Number.MAX_SAFE_INTEGER;
            }
            else {
                return 1;
            }
        };

        $scope.updateBalanceLines = function() {
            if ($scope.wallet && $scope.wallet.lines) {
                var lineArray = _.map(Object.values($scope.wallet.lines), function(line) {
                    return {
                        balances: line,
                        _issuer: line.currency + '+' + line.account,
                        _balanceId: line.account + line.currency
                    };
                });
                $scope.balanceLines = $filter('orderBy')(lineArray, $scope.customBalanceOrder);
            }
        }

        // multisig
        $scope.enableMultiSign = enableMultiSign;
        function enableMultiSign(isRenewal) {
            var user = $sessionStorage.user;

            var modalInstance = $uibModal.open({
                templateUrl: 'views/settings/modal_multisig_setup.html',
                backdrop: 'static', // specific to multisign modal
                controller: 'MultisigSetupCtrl',
                controllerAs: 'vm',
                resolve: {
                    data: function () {
                        return {
                            user: user,
                            address: wallet[0].address,
                            wallet: wallet[0],
                            isRenewal: isRenewal
                        };
                    }
                }
            });
            // catch close events with a isEnabled flag
            modalInstance.result.then(function (isEnabled) {
                if (isEnabled) {
                    $scope.multisigStatus.isEnabled = true;
                    $scope.multisigStatus.canRenew = false;
                }
            });
            // catch dismiss events (backdrop) clicks, and manually trigger refresh
            modalInstance.closed.then(function (reason) {
                checkMultisigStatus();
            });
        }

        function checkMultisigStatus() {
            const isXrplWallet = wallet[0].type === 10 || wallet[0].type === 11;

            if (!isXrplWallet) {
                $scope.wpBannerShown = false;
                return;
            }

            const acknowledgedWP = $localStorage['ghMultisignAck'] || [];
            RippleTx.isMultisigWallet(wallet[0]).then(function(status) {
                $scope.multisigStatus = status;
                if (status.isEnabled || !status.isEligible) {
                    $scope.wpBannerShown = false;
                }

                // setup started and payed the plan, but not completed
                else if (status.multisignInfo) {
                    if (
                        status.multisignInfo.status !== 'SIGNERS_TRANSACTION' &&
                        status.multisignInfo.status !== 'TEST_TRANSACTION' &&
                        status.multisignInfo.status !== 'DISABLED'
                    )
                    $scope.wpBannerShown = true;
                }

                // setup dismissed
                else if (acknowledgedWP.includes(wallet[0].address)) {
                    $scope.wpBannerShown = false;
                }

                else {
                    $scope.wpBannerShown = true;
                }
            });
        }

        $scope.getTxStatusColor = getTxStatusColor;
        function getTxStatusColor(status) {

            // Hosted statuses
            switch(status){
                case 100:
                case 107:
                case 106:
                case 'tesSUCCESS':
                    return 'bg-success';
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    return 'bg-warning';
                case 101:
                case 102:
                case 103:
                case 104:
                case 105:
                    return 'bg-danger';
            }

            // XRPL statuses
            if(isNaN(status) && typeof status === 'string') {
                var resultcodePrefix = status.substr(0, 3);
                switch(resultcodePrefix){
                    case 'tes':
                        return 'bg-success';
                    case 'tec':
                    case 'tef':
                    case 'tel':
                    case 'tem':
                        return 'bg-danger';
                    case 'ter':
                        return 'bg-gray-light';
                }
            }

            // Unknown status
            return 'bg-gray-light';
        }

        $scope.switchWallet = function (address) {
            $state.go( 'wallets.item.balance', { id: address } );
            $scope.toggleWalletSelector(false);
        };

        $scope.toggleWalletSelector = function(value) {
            $scope.isWalletSelectorActive = value;
        }

        function updateNetWorth() {
            if ($scope.wallet) {
                WalletsService.updateWalletNetWorth($scope.wallet)
                    .then(function(netWorth) {
                        $scope.wallet.netWorth = netWorth;
                        $scope.aggregateValueAsMetric = netWorth.total;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        }

        function updateNetWorthAllWallets() {
            $scope.wallets.forEach(function(wallet) {
                WalletsService.updateWalletNetWorth(wallet)
                    .then(function(netWorth) {
                        wallet.netWorth = netWorth;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            });
        }

        $scope.getNetWorth = function(lineId) {
            if ($scope.wallet && $scope.wallet.netWorth) {
                return $scope.wallet.netWorth[lineId] || 0;
            }
            return 0;
        }

        $scope.abs = x => Math.abs(x);

        $scope.openExportModal = openExportModal;
        function openExportModal(wallet) {
            $uibModal.open({
                templateUrl: 'views/settings/modal_export_wallets.html',
                controller: 'ExportCtrl',
                controllerAs: 'vm',
                resolve: {
                    data: function () {
                        return {
                            wallet: wallet
                        };
                    }
                }
            });
        }

        $scope.openDatepickerModal = openDatepickerModal;
        function openDatepickerModal() {
            var filters = WalletsService.getTxHistoryFilters();

            var datepickerModalInstance = $uibModal.open({
                templateUrl: 'views/wallets/modal_history_datepicker.html',
                controller: 'DateFilterCtrl',
                controllerAs: 'vm',
                resolve: {
                    data: function () {
                        return {
                            from: filters['date_from'],
                            to: filters['date_to']
                        };
                    }
                }
            }).result.then(function(dateRange){
                if(dateRange){
                    WalletsService.setTxHistoryFilter('date_from', dateRange.startDate);
                    WalletsService.setTxHistoryFilter('date_to', dateRange.endDate);
                    $scope.setTxFilter(null, null, true); // refresh only
                }
            }, function () {
                // dismissed
            });
        }

        $scope.resetDateFilter = function() {
            WalletsService.setTxHistoryFilter('date_from', null);
            WalletsService.setTxHistoryFilter('date_to', null);
            $scope.setTxFilter(null, null, true); // refresh only
        }

        $scope.getVaultAsset = function(vaultId) {
            return $scope.filterableVaults.find(vault => {
                return vault.uuid === vaultId;
            }).asset_code;
        }

        /** RECONNECT START **/
        var saltedgeReconnectWindowReference;
        function reconnectPSDWallet() {
            var userId = $sessionStorage.user.id;
            var walletAddress = wallet[0].address;
            if(!walletAddress || !userId) {
                console.log('Something went wrong - no wallet address / user id found!');
                return;
            }
            CoreRestangular.one('users', userId).one('psdWallets/reconnect', walletAddress).customPOST({})
                .then(function (response) {
                    $window.addEventListener("message", handleReconnectSaltedgeEvent); // Listen to SaltEdge events
                    saltedgeReconnectWindowReference = $window.open(response.data.redirectURI);
                }, function(error) {
                    console.log('Error reconnecting wallet:', error);
                });
        }

        function handleReconnectSaltedgeEvent(event) {
            if(event.origin !== "https://www.saltedge.com") {
                return;
            }
            try {
                var message = JSON.parse(event.data);
                var data = message.data;
                if (data.stage === 'success') {
                    $scope.reconnectSuccessful = true;
                    $timeout(closeReconnectSaltedgeTab, 1000);
                }
            } catch(error) {
                console.log('SALTEDGE EVENT WITHOUT DATA:', event);
            }
        }


        function closeReconnectSaltedgeTab() {
            if(saltedgeReconnectWindowReference) {
                saltedgeReconnectWindowReference.close();
            }
        }
        /** RECONNECT END **/

        /** REFRESH START **/
        var saltedgeRefreshWindowReference;
        var psdUpdatedAt;
        function refreshPSDWallet() {
            var userId = $sessionStorage.user.id;
            var walletAddress = wallet[0].address;
            if(!walletAddress || !userId) {
                console.log('Something went wrong - no wallet address / user id found!');
                return;
            }

            $scope.psdRefreshErrorMessage = null;
            psdUpdatedAt = wallet[0].updated_at; // last update before refresh
            CoreRestangular.one('users', userId).one('psdWallets/refresh', walletAddress).customPOST({})
                .then(function (response) {
                    if (response.data && response.data.redirectURI) {
                        $window.addEventListener("message", handleRefreshSaltedgeEvent); // Listen to SaltEdge events
                        saltedgeRefreshWindowReference = $window.open(response.data.redirectURI);
                    }
                }).catch(function(error) {
                    if (error.status === 403) {
                        $scope.psdRefreshErrorMessage = error.data.message || 'Error refreshing bank wallet';
                    } else {
                        $scope.psdRefreshErrorMessage = 'Error refreshing';
                    }
                    $timeout(function(){
                        $scope.psdRefreshErrorMessage = null;
                    }, 8000);
                });
        }

        function handleRefreshSaltedgeEvent(event) {
            if(event.origin !== "https://www.saltedge.com") {
                return;
            }
            try {
                var message = JSON.parse(event.data);
                var data = message.data;
                if (data.stage === 'success') {
                    $scope.psdRefreshErrorMessage = null;
                    startPollingUpdateTime();
                    $timeout(closeRefreshSaltedgeTab, 1000);
                }
            } catch(error) {
                // console.log('SALTEDGE EVENT WITHOUT DATA:', event);
            }
        }

        var pollingInterval;
        function startPollingUpdateTime() {
            var updated = false;
            var pollCounter = 0;
            pollingInterval = $interval(function() {
                pollCounter += 1;
                if (pollCounter > 10) {
                    $interval.cancel(pollingInterval);
                } else if (!updated) {
                    WalletsService.getWallets(true).then(function () {
                        var _wallet = WalletsService.getActive();
                        if (_wallet[0].updated_at !== psdUpdatedAt) {
                            $scope.wallet.updated_at = _wallet[0].updated_at;
                            updated = true;
                            $interval.cancel(pollingInterval);
                            init(); // refresh all balances and transactions
                        }
                    });
                }
            }, 2000);
        }

        function closeRefreshSaltedgeTab() {
            if(saltedgeRefreshWindowReference) {
                saltedgeRefreshWindowReference.close();
            }
        }
        /** REFRESH END **/

        $scope.$on('$destroy', function() {
            if (balanceUpdateListener) {
                balanceUpdateListener();
            }
            if (offerUpdateListener) {
                offerUpdateListener();
            }
            if (pollingInterval) {
                $interval.cancel(pollingInterval);
            }
            $window.removeEventListener("message", handleReconnectSaltedgeEvent);
            $window.removeEventListener("message", handleRefreshSaltedgeEvent);
            closeReconnectSaltedgeTab();
            closeRefreshSaltedgeTab();
        });
    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:WalletAddCtrl
 * @description
 * # WalletAddCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('WalletAddCtrl', ["$scope", "$timeout", "$sessionStorage", "WalletsService", "CoreRestangular", "instantMemory", "coreSecurity", "$state", "$exceptionHandler", function ($scope, $timeout, $sessionStorage, WalletsService, CoreRestangular, instantMemory, coreSecurity, $state, $exceptionHandler) {

        // Lock
        $scope.isUnlocked = coreSecurity.isMasterUnlocked(); // only master unlock required. no need to unlock existing wallets.
        var listener = $scope.$on('master_unlocked', function() {
            $scope.isUnlocked = true;
            listener();
        });

        // Init
        resetForm();
        $scope.errorMessage = false;

        // User
        var user = $sessionStorage.user;
        var User = CoreRestangular.one('users', user.uid);

        ///////////////////////////////////////////////////////////

        function resetForm() {

            $scope.errorMessage = false;
            $scope.sending = false;
            $scope.mode = false,

            $scope.send = {
                type: 0
            };

            if ($state.includes('wallets.item.add.xrp')) {
                $scope.send.type = 10;
            }

        };

        $scope.submitForm = function(isValid) {

            $scope.errorMessage = false;

            // Make sure the form is completely valid - should be!
            if (!isValid) {
                $scope.errorMessage = "One or more required fields are invalid";
                return;
            }

            $scope.sending = true;
            $scope.mode = 'sending';

            // If ripple, generate new wallet and encrypt secret
            if($scope.send.type == 10) {

                var wallet = ripple.Wallet.generate();
                var address = wallet.address;
                var secret = wallet.secret;

                // Test Secret
                try {
                    !ripple.Seed.from_json(secret).get_key(address);
                }
                catch (error) {
                    $exceptionHandler(error);
                    $scope.sending = false;
                    $scope.errorMessage = "Wallet create error";
                    $scope.mode = 'error';
                    return;
                }

                var base_security = ($scope.isUnlocked) ? instantMemory.getValue('base_security') : null;
                var master_key = ($scope.isUnlocked) ? base_security.master_key : null;

                var secret_encrypted = coreSecurity.AESEncrypt(secret, master_key);
                var decrypted = coreSecurity.AESDecrypt(secret_encrypted, master_key, 2);

                // Check encryption
                if(secret !== decrypted) {
                    $exceptionHandler('encryption_error');
                    $scope.sending = false;
                    $scope.errorMessage = 'Encryption error';
                    $scope.mode = 'error';
                    return;
                };

                $scope.send.address = address;
                $scope.send.secret = secret_encrypted;

            }

            User.post('wallets', $scope.send).then(function(data) {

                $scope.sending = false;
                $scope.mode = 'success';

                var _data = data.plain();

                // Add to UI
                WalletsService.saveWallet(_data);
                WalletsService.findShadowAddress(data.address);

                $timeout(function() {

                    // Go to new wallet
                    var wallet = WalletsService.getActive();
                    $scope.$close(wallet);

                }, 1000);

            }, function(error){
                $exceptionHandler(error);
                $scope.sending = false;
                $scope.mode = 'error';
                $scope.errorMessage = (error.data) ? error.data.message : '';

            });

        };

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:WalletImportCtrl
 * @description
 * # WalletImportCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('WalletImportCtrl', ["$scope", "$timeout", "$sessionStorage", "WalletsService", "CoreRestangular", "instantMemory", "coreSecurity", "$exceptionHandler", function ($scope, $timeout, $sessionStorage, WalletsService, CoreRestangular, instantMemory, coreSecurity, $exceptionHandler) {

        // Lock
        $scope.isUnlocked = coreSecurity.isMasterUnlocked();
        var listener = $scope.$on('master_unlocked', function() {
            $scope.isUnlocked = true;
            listener();
        });

        // Init
        resetForm();
        $scope.errorMessage = false;

        var user = $sessionStorage.user;
        var User = CoreRestangular.one('users', user.uid);

        ///////////////////////////////////////////////////////////

        function resetForm() {

            $scope.errorMessage = false;
            $scope.sending = false;
            $scope.mode = false,

            $scope.send = {
                type: 11,
            };

        };

        $scope.submitForm = function(isValid) {

            $scope.errorMessage = false;

            // Make sure the form is completely valid - should be!
            if (!isValid) {
                $scope.errorMessage = "One or more required fields are invalid";
                return;
            }

            $scope.sending = true;
            $scope.mode = 'sending';

            var secret = $scope.send.secret;
            // Derive address from secret (seed)
            var address = ripple.Seed.from_json(secret).get_key().get_address().to_json();


            var base_security = ($scope.isUnlocked) ? instantMemory.getValue('base_security') : null;
            var master_key = ($scope.isUnlocked) ? base_security.master_key : null;

            var secret_encrypted = coreSecurity.AESEncrypt(secret, master_key);
            var decrypted = coreSecurity.AESDecrypt(secret_encrypted, master_key, 2);

            // Check encryption
            if(secret !== decrypted) {
                $exceptionHandler('encryption_error');
                $scope.sending = false;
                $scope.errorMessage = 'Encryption error';
                $scope.mode = 'error';
                return;
            };

            $scope.send.address = address;
            $scope.send.secret = secret_encrypted;


            User.post('wallets', $scope.send).then(function(data) {

                $scope.sending = false;
                $scope.mode = 'success';

                // Add to UI
                WalletsService.saveWallet(data.plain());
                WalletsService.findShadowAddress(data.address);

                $timeout(function() {

                    // Go to new wallet
                    var wallet = WalletsService.getActive();
                    $scope.$close(wallet);

                }, 1000);

            }, function(error) {
                if (error.data && error.data.message.toLowerCase() === 'wallet with same name exists'){
                    // ignore this error
                } else {
                    $exceptionHandler(error, error);
                }
                $scope.sending = false;
                $scope.mode = 'error';
                $scope.errorMessage = (error.data) ? error.data.message : '';

            });

        };

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:WalletBankCtrl
 * @description
 * # WalletBankCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('WalletBankCtrl', ["$scope", "$sessionStorage", "CoreRestangular", "IDRestangular", "WalletsService", "$window", "$state", "$interval", "$timeout", "FeatureService", "$exceptionHandler", function ($scope, $sessionStorage, CoreRestangular, IDRestangular, WalletsService, $window, $state, $interval, $timeout, FeatureService, $exceptionHandler) {

        FeatureService.isEnabledForUser({ flag: 'psd-processor', redirectTo: 'wallets.item.add' }); // checks if enabled and automatically redirects if not

        // Init
        $scope.mode = 'loading';
        $scope.startedFetching = false;
        $scope.connectionAlreadyExists = null; // null == not checked yet | true | false
        var saltedgeWindowReference;
        var tabStatusCheckInterval;
        var requestPending = false;
        var existingWallet = null; // used when updating existing connection

        var user = $sessionStorage.user;
        IDRestangular.one('users', user.uid).one('aispCustomerId').customPOST({}).then(function () {
            CoreRestangular.one('users', user.uid).one('psdWallets').customPOST({}).then(function (response) {

                // check if modal is dismissed before this callback
                if (!$scope.$parent) {
                    return;
                }

                WalletsService.getWallets().then(function (wallets) {
                    $scope.wallets = wallets;
                }, function(error) {
                    $scope.wallets = [];
                    $exceptionHandler(error);
                });

                // Listen to SaltEdge events
                $window.addEventListener("message", handleSaltedgeEvent);

                // Open SaltEdge in new tab
                saltedgeWindowReference = $window.open(response.data.redirectURI);
                tabStatusCheckInterval = $interval(() => {
                    if (saltedgeWindowReference.closed) {
                        $scope.errorMessage = 'Could not create Bank wallet. Please try again later.';
                        $scope.mode = 'error';
                        $interval.cancel(tabStatusCheckInterval);
                    }
                }, 1000);

            }, function (error) {
                $scope.errorMessage = 'Currently unable to connect bank accounts. Please try again later.';
                $scope.mode = 'error';
                $exceptionHandler(error);
            });
        }, function(error) {
            $scope.errorMessage = 'Currently unable to connect bank accounts. Please try again later.';
            $scope.mode = 'error';
            $exceptionHandler(error);
        });

        function handleSaltedgeEvent(event) {
            if(event.origin !== "https://www.saltedge.com") {
                console.log('Not a SaltEdge event!');
                return;
            }

            if(event.data === "cancel") {
                $scope.goBack();
            }

            try {
                var message = JSON.parse(event.data);
                var data = message.data;
                console.log('SALTEDGE EVENT DATA:', data);

                if (data.connection_id) {
                    $scope.connectionAlreadyExists = checkIfConnectionAlreadyExists(data.connection_id);
                }
                if (data.stage === 'fetching') {
                    $scope.startedFetching = true;
                }
                if (data.stage === 'success') {
                    if (!$scope.connectionAlreadyExists) {
                        $scope.mode = 'creating';
                        startPollingForNewWallets();
                    } else {
                        $scope.mode = 'updating';
                        $timeout(function(){
                            if (existingWallet) {
                                $state.go('wallets.item.balance', { id: existingWallet.address }, { reload: true });
                            } else {
                                $scope.closeModal();
                            }
                        }, 3000);
                    }
                    closeSaltedgeTab();
                }
                $scope.$apply();
            } catch(error) {
                console.log('SALTEDGE EVENT WITHOUT DATA:', event);
            }
        }

        var pollingInterval;
        var pollingCounter;
        function startPollingForNewWallets() {
            pollingCounter = 0;
            pollingInterval = $interval(checkForNewWallets, 3000);
        }

        function checkForNewWallets() {
            if (requestPending) {
                return;
            }

            pollingCounter += 1;
            if (pollingCounter >= 10) {
                $interval.cancel(pollingInterval);
                $scope.errorMessage = 'Could not create Bank wallet. Please try again later.';
                $scope.mode = 'error';
            }
            requestPending = true;
            WalletsService.getWallets(true).then(function (wallets) {
                if (wallets.length > $scope.wallets.length) { // new wallet found!
                    $interval.cancel(pollingInterval);
                    $scope.mode = 'success';
                    $timeout(function() {
                        var latestWallet = wallets[wallets.length - 1];
                        $state.go('wallets.item.balance', { id: latestWallet.address });
                    }, 3000);
                }
            })
            .finally(function() {
                requestPending = false;
            });
        }

        function checkIfConnectionAlreadyExists(connection_id) {
            if ($scope.connectionAlreadyExists !== null) {
                return $scope.connectionAlreadyExists;
            }

            var psdWallets = _.filter($scope.wallets, function (wal) {
                return wal.type === 24;
            });

            var i;
            for(i = 0; i < psdWallets.length; i++) {
                if(psdWallets[i].meta.connection_id === connection_id) {
                    existingWallet = psdWallets[i];
                    return true;
                }
            }
            return false;
        }

        function closeSaltedgeTab() {
            if(saltedgeWindowReference) {
                $interval.cancel(tabStatusCheckInterval);
                saltedgeWindowReference.close();
            }
        }

        $scope.goBack = function() {
            closeSaltedgeTab();
            $state.go('wallets.item.add');
        }

        $scope.closeModal = function() {
            $scope.$dismiss();
        }

        $scope.$on('$destroy', function () {
            closeSaltedgeTab();
            $window.removeEventListener("message", handleSaltedgeEvent);
            if (angular.isDefined(pollingInterval)) {
                $interval.cancel(pollingInterval);
            }

            if (angular.isDefined(tabStatusCheckInterval)) {
                $interval.cancel(tabStatusCheckInterval);
            }
        });

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:WalletTxCtrl
 * @description
 * # WalletTxCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('WalletTxCtrl', ["$scope", "$stateParams", "WalletsService", "CoreRestangular", "StorageCore", "$filter", "$exceptionHandler", function ($scope, $stateParams, WalletsService, CoreRestangular, StorageCore, $filter, $exceptionHandler) {

        $scope.loading = true;

        $scope.tx = null;
        var id = $stateParams.xid;
        $scope.hostedExchange = $stateParams.hostedExchange;
        var wallet;

        // Init
        init();

        ///////////////////////////////////////////////////////////


        function init() {

            // Wait until wallets are fully loaded
            WalletsService.getWallets().then(function(data) {

                // Get active wallet
                wallet = WalletsService.getActive();

                // Something went wrong, let's stop before it gets even worse
                if (!wallet) {
                    $exceptionHandler('wallet_not_found');
                    return;
                };

                $scope.wallet = wallet[0];
                loadTx();

            }, function(error) {
                $scope.loading = false;
                $exceptionHandler(error);
            })

        };

        function loadTx() {
            if (wallet[0].type == 10 || wallet[0].type == 11) {
                if (typeof wallet[0].history === 'undefined' || wallet[0].loadingHistory === true) return;
                for (var i = wallet[0].history.length - 1; i >= 0; i--) {

                    var tx = wallet[0].history[i];

                    if (tx.hash == id) {
                        $scope.tx = tx;
                    };

                };

                $scope.loading = false;

            }
            else if (wallet[0].type == 0) {
                CoreRestangular.one('transactions', id).get().then(function(data) {
                    var tx = data.plain();

                    if (tx.uuid == id) {
                        $scope.tx = tx;

                        if (tx.type == 1) {
                            tx.amount_total = parseFloat(tx.amount) - parseFloat(tx.fee);
                        }
                        else if (tx.type == 0) {
                            tx.amount_total = parseFloat(tx.amount) + parseFloat(tx.fee);
                        }
                        else {
                            tx.amount_total = 0;
                        }
                    };

                    resolveAddress(tx);
                    fetchUserCover(tx);

                    $scope.loading = false;

                }, function(error) {
                    $scope.loading = false;
                    $exceptionHandler(error);
                });

            }
            else if (wallet[0].type === 24) {
                CoreRestangular.one('psd-transactions', id).get().then(function(data) {
                    var tx = data.plain();

                    if (tx.uuid == id) {
                        $scope.tx = tx;
                    };
                    $scope.loading = false;

                }, function(error) {
                    $scope.loading = false;
                    $exceptionHandler(error);
                });
            }

        };

        function fetchUserCover(tx) {
            var user = tx.sending_wallet.address === wallet.address
                ? tx.receiving_user
                : tx.sending_user;

            if (user) {
                StorageCore.getCoverByUserId(user.uuid).then(data => {
                    tx.userCover = data;
                });
            }
        }

        $scope.cancel = function() {
            $scope.$dismiss();
        };

        function resolveAddress(tx) {
            var counterpartyAddress = tx.sending_wallet.address === wallet.address
                ? tx.receiving_wallet.address
                : tx.sending_wallet.address;

            tx.resolvedAddress = $filter('nameAddress')(counterpartyAddress);

            if (tx.resolvedAddress === 'Unknown') {
                tx.resolvedAddress = counterpartyAddress;
            }
        }

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:WalletDeleteCtrl
 * @description
 * # WalletDeleteCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('WalletDeleteCtrl', ["$scope", "$stateParams", "$timeout", "$sessionStorage", "WalletsService", "CoreRestangular", "coreSecurity", "$exceptionHandler", function ($scope, $stateParams, $timeout, $sessionStorage, WalletsService, CoreRestangular, coreSecurity, $exceptionHandler) {

        // Init
        var wallet = WalletsService.getById($stateParams.id);
        $scope.wallet = wallet[0];

        // Lock
        $scope.isUnlocked = coreSecurity.isMasterUnlocked();
        var listener = $scope.$on('master_unlocked', function() {
            $scope.isUnlocked = true;
            listener();
        });

        resetForm();
        $scope.errorMessage = false;
        $scope.address = $stateParams.id;

        if(!wallet.length) {
            $timeout(function() {
                $scope.$dismiss();
            });
            return;
        }

        $scope.name = wallet[0].name;
        $scope.type = wallet[0].type;

        // Something went wrog
        var authUser = $sessionStorage.user;
        if (typeof authUser === 'undefined') {
            var Wallet = false;
        }
        else {
            var Wallet = CoreRestangular.one('users', authUser.uid).one('wallets', $scope.address); // Auth
        }

        ///////////////////////////////////////////////////////////

        function resetForm() {

            $scope.errorMessage = false;
            $scope.sending = false;
            $scope.mode = false;

            $scope.send = {};
            $scope.send.confirm = false;

        };

        $scope.submitForm = function(isValid) {

            $scope.errorMessage = false;

            // Make sure the form is completely valid - should be!
            if (!isValid) {
                $scope.errorMessage = "One or more required fields are invalid";
                return;
            }

            $scope.sending = true;
            $scope.mode = 'sending';

            Wallet.remove().then(function(data) {

                $scope.sending = false;
                $scope.mode = 'success';

                // Remove from UI
                WalletsService.deleteWallet($scope.address);

                $timeout(function() {
                    $scope.$dismiss();
                }, 1000);

            }, function(error){

                // console.error(data);
                $scope.sending = false;
                $scope.mode = 'error';
                $scope.errorMessage = error.data.message;
                $exceptionHandler(error);
                return;

            });

        };

        $scope.cancel = function() {
            $scope.$dismiss();
        };

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:WalletEditCtrl
 * @description
 * # WalletEditCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('WalletEditCtrl', ["$scope", "Auth", "$stateParams", "$timeout", "WalletsService", "CoreRestangular", "$exceptionHandler", function ($scope, Auth, $stateParams, $timeout, WalletsService, CoreRestangular, $exceptionHandler) {

        // Init
        var wallet;
        var Wallet;

        init();
        resetForm();

        $scope.errorMessage = false;
        $scope.address = $stateParams.id;
        $scope.loading = true;

        ///////////////////////////////////////////////////////////

        function init() {

            Auth.getProfile().then(function (data) {

                var user = data;

                Wallet = CoreRestangular.one('users', data.uid).one('wallets', $scope.address);

                wallet = WalletsService.getById($stateParams.id);

                $scope.loading = false;

            });

        };

        function resetForm() {

            $scope.errorMessage = false;
            $scope.sending = false;
            $scope.mode = false;

        };

        $scope.submitForm = function(isValid) {

            $scope.errorMessage = false;

            // Make sure the form is completely valid - should be!
            if (!isValid) {
                $scope.errorMessage = "One or more required fields are invalid";
                return;
            }

            $scope.sending = true;
            $scope.mode = 'sending';

            var postData = {
                name: $scope.send.name,
            };

            Wallet.customPUT(postData).then(function(data) {

                $scope.sending = false;
                $scope.mode = 'success';

                // Rename wallet
                WalletsService.renameWallet(wallet[0], $scope.send.name);

                $timeout(function() {
                    $scope.$dismiss();
                }, 1000);

            }, function(error) {
                $exceptionHandler(error);
                $scope.sending = false;
                $scope.mode = 'error';
                if (error.data &&  error.data.message) {
                    $scope.errorMessage = error.data.message;
                }
                else {
                    $scope.errorMessage = "Unknown error"
                }
                return;

            });

        };

        $scope.cancel = function() {
            $scope.$dismiss();
        };

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:WalletSetTrustCtrl
 * @description
 * # WalletSetTrustCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('WalletSetTrustCtrl', ["$scope", "$state", "$stateParams", "$timeout", "$exceptionHandler", "WalletsService", "coreSecurity", "RippleNetwork", "Settings", "VaultsService", "ShadowRestangular", "RippleTx", "ThirdPartyService", "NonstandardCurrencies", function ($scope, $state, $stateParams, $timeout, $exceptionHandler, WalletsService, coreSecurity, RippleNetwork, Settings, VaultsService, ShadowRestangular, RippleTx, ThirdPartyService, NonstandardCurrencies) {

        $scope.xrplCurrencyCodeRegex = NonstandardCurrencies.xrplCurrencyCodeRegex;

        // Lock
        $scope.isUnlocked = coreSecurity.is2FaAuthorized();
        if (!$scope.isUnlocked) {
            var listener = $scope.$on('2fa_authorized', function() {
                $scope.isUnlocked = true;
                listener();
            });
        }

        var walletsLoaded = false;

        // Init
        resetForm();
        init();

        var wallet;
        var address;
        var Currency = ripple.Currency;

        // Watch these guys
        $scope.$watch('send.name', function (data) {
            update_destination_amount();
        }, true);
        $scope.$watch('send.currency', function (data) {
            update_destination_currency();
        }, true);

        $scope.manual = true;

        // Check if manual
        var issuer = $stateParams.issuer;
        var currency = $stateParams.currency;
        if (currency.length > 3 && currency.length < 40) {
            currency = NonstandardCurrencies.encodeAssetCode(currency);
        }
        var option = $stateParams.option;
        var redirect = $stateParams.redirect;

        if(typeof issuer !== 'undefined' && typeof currency !== 'undefined') {

            // Check if valid address
            if(!ripple.UInt160.is_valid(issuer) || $stateParams.id == issuer) {
                $scope.$dismiss();
            }
            else {

                // TODO Check currency
                $scope.manual = false;
                $scope.currency = currency;
                $scope.issuer = issuer;

                if(typeof option !== 'undefined' && option === 'remove') {
                    $scope.option = 'remove';
                }
                else if(typeof option !== 'undefined' && option === 'removeRipple') {
                    $scope.option = 'removeRipple';
                }
                else if(typeof option !== 'undefined' && option === 'edit') {
                    $scope.manual = true;
                    $scope.option = 'edit';

                    $scope.send.currency = currency;
                    $scope.send.name = issuer;
                }

            }

        }

        ///////////////////////////////////////////////////////////

        function init() {

            // Wait untill wallets are fully loaded
            WalletsService.getWallets().then(function(data) {

                // Get active wallet (if exists)
                var id = $stateParams.id;

                if(id) {

                    // Save new active wallet
                    WalletsService.setActive(id);

                    // Load active wallet
                    loadWallet();

                }
                else {

                    // Load active wallet
                    wallet = WalletsService.getActive();

                    // Something went wrong, let's stop before it gets even worse
                    if(!wallet) {
                        $exceptionHandler('wallet_not_found');
                        return;
                    };

                    // Redirect to it
                    $state.go('wallets.item.balance', {id: wallet[0].address});
                    return;

                }

                $scope.$broadcast('walletsLoaded', true);

            }, function(error) {
                $scope.loading = false;
                $exceptionHandler(error);
                return;
            })

        };
        function loadWallet() {

            // Load active wallet
            wallet = WalletsService.getActive();
            $scope.wallet = wallet[0];

            // Something went wrong, let's stop before it gets even worse
            if(!wallet) {
                $exceptionHandler('wallet_not_found');
                return;
            };

            address = wallet[0].address;

            // locking logic moved from loadWallet to init

        };

        function update_destination_amount() {

            var send = $scope.send;
            var recipient = send.name;

            send.ripple_address = recipient;

            if($scope.form.send) {
                $scope.form.send.name.$setValidity('notRipple', true);
                $scope.form.send.name.$setValidity('self', true);
            }
            else {
                return;
            }

            if (!ripple.UInt160.is_valid(send.ripple_address)) {
                $scope.form.send.name.$setValidity('notRipple', false);
                return;
            }

            // Sending to self
            if (send.ripple_address === $stateParams.id) {
                $scope.form.send.name.$setValidity('self', false);
                return;
            }

        };

        function update_destination_currency() {

            var send = $scope.send;
            var currency = send.currency;

            if (!$scope.form.send || !currency) {
                return;
            }

            $scope.form.send.currency.$setValidity('currencyCode', true);

           var isValidAssetCode = NonstandardCurrencies.xrplCurrencyCodeRegex.test(currency);
           if (!isValidAssetCode) {
               $scope.form.send.currency.$setValidity('currencyCode', false);
               return;
           }

            if(currency.toUpperCase() === 'XRP') { // XRP is reserved
                $scope.form.send.currency.$setValidity('currencyCode', false);
                return;
            }

        };

        function resetForm() {

            $scope.errorMessage = false;
            $scope.sending = false;
            $scope.mode = false;

            $scope.form = {};

            $scope.send = {
                name: '',
                ripple_address: false,
                currency: '',
                disable_rippling: true,
                limit: 1000000000,
                quality_out: 0,
            };

        };

        $scope.submitFormDirect = function() {

            $scope.errorMessage = false;

            $scope.sending = true;
            $scope.mode = 'sending';

            var limit = 1000000000;

            if(option == 'remove') {
                limit = 0;
            }
            else if (option == 'removeRipple') {
                limit = 1000000000;
            }

            // Ripple Transaction
            var tx = RippleNetwork.remote.createTransaction('TrustSet',
            {
                account: address,
                limit: limit+'/'+currency+'/'+issuer,
            });

            // Set rippling off
            tx.setFlags(ripple.Transaction.flags.TrustSet.SetNoRipple);

            var maxLedger = Settings.client.tx_last_ledger || 3;
            tx.lastLedger(RippleNetwork.remote._ledger_current_index + maxLedger);

            tx.on('success', function (res) {
                onTransactionSuccess(res, tx, currency, address, limit);
            });

            tx.on('error', function (res) {
                onTransactionError(res, tx);
            });

            RippleTx.submitTransaction(tx, wallet[0])
                .catch(function (error) {
                    if (error.status === 403 && error.data.message && error.data.message.toLowerCase() === '2fa required') {
                        $scope.isUnlocked = false;
                        var listener = $scope.$on('2fa_authorized', function() {
                            $scope.isUnlocked = true;
                            $scope.submitFormDirect();
                            listener();
                        });
                    } else {
                        console.error(error);
                        $scope.sending = false;
                        $scope.mode = 'error';
                        $scope.errorMessage = error.message;
                    }
                });
        };

        $scope.submitForm = function(isValid) {

            ThirdPartyService.addConsent({
                issuer: $scope.send.ripple_address,
                currency: $scope.send.currency
            }).then(function() {
                $scope.thirdPartyWarning = null;
            }, function(error) {
                $exceptionHandler(error);
            });

            $scope.errorMessage = false;

            // Make sure the form is completely valid - should be!
            if (!isValid) {
                $scope.errorMessage = "One or more required fields are invalid";
                return;
            }

            $scope.sending = true;
            $scope.mode = 'sending';

            var send = $scope.send;
            var recipient = send.ripple_address;
            var currency = send.currency;
            var disable_rippling = send.disable_rippling;

            var limit = send.limit;
            var quality_out = send.quality_out;

            // Ripple Transaction
            var tx = RippleNetwork.remote.createTransaction('TrustSet',
            {
                account: address,
                limit: limit+'/'+currency+'/'+recipient,
                quality_out: quality_out
            });

            // Set rippling off
            if(disable_rippling) {
                // Set rippling off
                tx.setFlags(ripple.Transaction.flags.TrustSet.SetNoRipple);
            }
            else {
                // Set rippling on
                tx.setFlags(ripple.Transaction.flags.TrustSet.ClearNoRipple);
            }


            var maxLedger = Settings.client.tx_last_ledger || 3;
            tx.lastLedger(RippleNetwork.remote._ledger_current_index + maxLedger);

            tx.on('success', function (res) {
                onTransactionSuccess(res, tx);
            });

            tx.on('error', function (res) {
                onTransactionError(res, tx);
            });

            RippleTx.submitTransaction(tx, wallet[0])
                .catch(function (error) {
                    if (error.status === 403 && error.data.message && error.data.message.toLowerCase() === '2fa required') {
                        $scope.isUnlocked = false;
                        var listener = $scope.$on('2fa_authorized', function() {
                            $scope.isUnlocked = true;
                            $scope.submitForm(isValid);
                            listener();
                        });
                    } else {
                        $scope.sending = false;
                        $scope.mode = 'error';
                        $scope.errorMessage = error.message;
                    }
                });

        };

        function onTransactionSuccess(res, tx, currency, address, limit) {

            $timeout(function() {
                $scope.sending = false;
                $scope.mode = 'success';

                $timeout(function() {
                    WalletsService.getWallets(true).then(function(data) {

                        if( limit > 0) { // SET TRUST ==> CLEAR SHADOW
                            clearShadowWallet(data, currency, address);
                        }

                        if(typeof redirect != 'undefined') {
                            $scope.$close(redirect);
                        }
                        else {
                            $scope.$close();
                        }
                    }, function(error) {
                        if(typeof redirect != 'undefined') {
                            $scope.$close(redirect);
                        }
                        else {
                            $scope.$close();
                        }
                    });
                }, 2000);
            });

        };

        function onTransactionError(res, tx) {


            $timeout(function() {
                $scope.sending = false;
                $scope.mode = 'error';

                if(res.engine_result_code == 126) {
                    $scope.errorMessage = "Insufficient XRP to enable another trust line. Please remove an existing trust line or cancel an open order.<br><br><span class='error-extra-info'>Read more: <a target='_blank' href='https://support.gatehub.net/hc/en-us/articles/360021238254-XRP-reserve'>XRP Reserves</a></span>";
                }
                else {
                    $exceptionHandler(res);
                    if (res.engine_result_message) {
                        $scope.errorMessage = res.engine_result_message;
                    }
                    else {
                        $scope.errorMessage = 'Unknown error'; // IVAN TODO: RESEARCH & MAKE BETTER!
                    }
                }
            });

        };

        function clearShadowWallet(wallets, currency, address){

            var _shadow_address = _.filter(wallets, function(wallet) {
                return wallet.address == address;
            })[0].shadow_address;

            var _vault_uuid = VaultsService.getVaultByCurrency(currency).vault_id;

            var postData = {
              wallet: _shadow_address,
              vaultUuid: _vault_uuid
            };

            ShadowRestangular.one('clearForVault').post('', postData).then(function(data) {
              console.log('Success clearing shadow', data);
            }, function(error){
              console.log('Error clearing shadow', error);
              $exceptionHandler(error);
            });

        }

        $scope.songbirdConsent = false;
        $scope.toggleSongbirdConsent = function() {
            $scope.songbirdConsent = !$scope.songbirdConsent;
        }

        $scope.cancel = function() {
            $scope.$dismiss();
        };

        $scope.isThirdPartyWithoutConsent = function(currency, issuer) {
            return ThirdPartyService.isThirdPartyWithoutConsent({
                currency,
                issuer
            });
        }

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:WalletSetPrimaryCtrl
 * @description
 * # WalletSetPrimaryCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('WalletSetPrimaryCtrl', ["$scope", "Auth", "$stateParams", "$timeout", "WalletsService", "CoreRestangular", "$exceptionHandler", function ($scope, Auth, $stateParams, $timeout, WalletsService, CoreRestangular, $exceptionHandler) {

        var vm = this;
        // Init
        var wallet;
        var Wallet;

        vm.confirmed = false;
        vm.mode = '';
        vm.errorMessage = false;
        vm.address = $stateParams.id;
        vm.loading = true;

        resetForm();
        init();

        ///////////////////////////////////////////////////////////

        function init() {

            Auth.getProfile().then(function (data) {
                Wallet = CoreRestangular.one('users', data.uid).one('wallets', vm.address);

                wallet = WalletsService.getById($stateParams.id);

                vm.name = wallet[0].name;
                if (wallet[0].primary) {
                    vm.mode = 'is-primary';
                    $timeout(function() {
                        $scope.$dismiss();
                    }, 2000);
                }

            })
            .finally(function() {
                vm.loading = false;
            });

        };

        function resetForm() {

            vm.errorMessage = false;
            vm.sending = false;
            vm.mode = '';

        };

        vm.submitForm = function(isValid) {

            vm.errorMessage = false;

            // Make sure the form is completely valid - should be!
            if (!isValid) {
                vm.errorMessage = "One or more required fields are invalid";
                return;
            }

            vm.sending = true;
            vm.mode = 'sending';

            var postData = {
                primary: 1,
            };

            Wallet.customPUT(postData).then(function(data) {

                vm.sending = false;
                vm.mode = 'success';

                // Update primary wallet
                WalletsService.setGatehubPrimary(wallet[0]);

                $timeout(function() {
                    $scope.$dismiss();
                }, 1000);

            }, function(error){
                $exceptionHandler(error);

                vm.sending = false;
                vm.mode = 'error';
                return;

            });

        };

        vm.cancel = function() {
            $scope.$dismiss();
        };

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:WalletAdvancedCtrl
 * @description
 * # WalletAdvancedCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('WalletAdvancedCtrl', ["WalletsService", "$stateParams", "$sessionStorage", "$uibModal", function (WalletsService, $stateParams, $sessionStorage, $uibModal) {

    	var vm = this;
        vm.loading = true;
        vm.errorMessage = null;

        vm.wallet = null;
        vm.walletAddress = $stateParams.id;
        vm.multisignStatus = { };

        vm.openMultisigModal = openMultisigModal;
        vm.openSecretModal = openSecretModal;

        WalletsService.getWallets()
            .then(function() {
                vm.wallet = WalletsService.getByAddress(vm.walletAddress);

                if (vm.wallet.type === 10 || vm.wallet.type === 11) {
                    WalletsService.isMultisigWallet(vm.wallet)
                        .then(function(status) { vm.multisignStatus = status; });
                }
            })
            .catch(function(error) {
                vm.errorMessage = error;
            })
            .finally(function() {
                vm.loading = false;
            });

        function openMultisigModal() {
            if (!vm.wallet) {
                return;
            }
            var modalInstance = $uibModal.open({
                templateUrl: 'views/settings/modal_multisig_setup.html',
                backdrop: 'static', // specific to multisign modal
                controller: 'MultisigSetupCtrl',
                controllerAs: 'vm',
                resolve: {
                    data: function () {
                        return {
                            user: $sessionStorage.user,
                            address: vm.walletAddress,
                            wallet: vm.wallet
                        };
                    }
                }
            }).result.then(function (isEnabled) {
                WalletsService.isMultisigWallet(vm.wallet)
                    .then(function(status) { vm.multisignStatus = status; });
            });

        }

        function openSecretModal(secretToDisplay) {
            if (secretToDisplay !== 'secret' && secretToDisplay !== 'regular') {
                console.error('Invalid secret type requested');
                return;
            }

            var modalInstance = $uibModal.open({
                templateUrl: 'views/wallets/modal_show_secret.html',
                controller: 'WalletShowSecretCtrl',
                controllerAs: 'vm',
                resolve: {
                    data: function () {
                        return {
                            wallet: vm.wallet,
                            secretToDisplay: secretToDisplay
                        };
                    }
                }
            });
        }

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:WalletShowSecretCtrl
 * @description
 * # WalletShowSecretCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('WalletShowSecretCtrl', ["$scope", "instantMemory", "coreSecurity", "data", "RippleTx", function ($scope, instantMemory, coreSecurity, data, RippleTx) {

        var vm = this;

        vm.wallet = data.wallet;
        
        vm.isUnlocked = coreSecurity.isMasterUnlocked(); // DONE
        var listener = $scope.$on('master_unlocked', function() {
            vm.isUnlocked = true;
            listener();
        });

        vm.displaySecret = '';
        vm.isDisplayed = false;

        vm.secretToDisplay = data.secretToDisplay;

        vm.closeModal = closeModal;

        function prepareSecretDisplay(apiSecrets) {
            var base_security = instantMemory.getValue('base_security');
            var master_key = base_security.master_key;

            // Unlock secret
            var secret_encrypted = apiSecrets.secret;
            var regular_encrypted = apiSecrets.regular_secret;

            var secret = coreSecurity.AESDecrypt(secret_encrypted, master_key, vm.wallet.version);
            var regular_secret = coreSecurity.AESDecrypt(regular_encrypted, master_key, 2);

            switch (vm.secretToDisplay) {
                case 'secret':
                    vm.displaySecret = secret;
                    break;
                case 'regular':
                    vm.displaySecret = regular_secret;
                    break;
                default:
                    vm.displaySecret = '/';
                    break;
            }

            vm.isDisplayed = true;
        }

        vm.displaySecretFn = function() {
            RippleTx.getSecrets(vm.wallet).then(function(secrets) {
                prepareSecretDisplay(secrets);
            }, function (error) {
                if (error.status === 403 && error.data.message && error.data.message.toLowerCase() === '2fa required') {
                    vm.isUnlocked = false;
                    var listener = $scope.$on('2fa_authorized', function(event, secrets) {
                        vm.isUnlocked = true;
                        prepareSecretDisplay(secrets);
                        listener();
                    });
                } else {
                    $exceptionHandler(error);
                }
            });
        };

        function closeModal() {
            $scope.$dismiss();
        };

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:ClaimFundsCtrl
 * @description
 * # ClaimFundsCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
  .controller('ClaimFundsCtrl', ["$scope", "data", "IlpRestangular", "$exceptionHandler", function ($scope, data, IlpRestangular, $exceptionHandler) {

    var vm = this;
    vm.loading = false;
    vm.error = '';

    vm.wallet = data.wallet;
    vm.amount = data.amount;
    vm.toClaim = data.toClaim;

    vm.closeModal = closeModal;
    vm.claimFunds = claimFunds;

    function claimFunds() {
        vm.error = '';

        vm.loading = true;
        IlpRestangular
            .one('balances')
            .one(vm.wallet.address)
            .one('claim')
            .post('', {
                origin_vault_uuid: vm.toClaim.vault_uuid
            })
            .then(function (response) {
                vm.done = true;
                setTimeout(function() {
                    closeModal();
                }, 4000);
            }, function (error) {
                vm.error = error.data.description;
                $exceptionHandler(error);
            })
            .finally(function() {
                vm.loading = false;
            });
    }

    function closeModal () {
      $scope.$dismiss();
    };

  }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:WalletSelectorCtrl
 * @description
 * # WalletSelectorCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('WalletSelectorCtrl', ["WalletsService", function (WalletsService) {

        var vm = this;

        vm.wallets = [];
        vm.activeWallet = null;
        vm.isWalletSelectorActive = false;

        vm.changeWallet = changeWallet;

        WalletsService.getWallets()
            .then(function (data) {
                vm.wallets = data;
                vm.activeWallet = WalletsService.getActive()[0];
            },
            function(error) {
                console.error('Error loading wallets', error);
            });

        function changeWallet(id) {
            vm.activeWallet = WalletsService.setActive(id)[0];
            vm.isWalletSelectorActive = false;
        }
    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:DateFilterCtrl
 * @description
 * # DateFilterCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('DateFilterCtrl', ["$scope", "data", function ($scope, data) {

        var vm = this;

        vm.datePickerOpts = {
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Apply",
                fromLabel: "From",
                format: "MMM D, YYYY",
                toLabel: "To",
                cancelLabel: 'Cancel',
                customRangeLabel: 'Custom range',
                autoApply: 'true'
            },
            ranges: {
                Today: [new Date, new Date],
                Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
                "Last 7 Days": [moment().subtract(6, "days"), new Date],
                "Last 30 Days": [moment().subtract(29, "days"), new Date],
                "This Month": [moment().startOf("month"), moment().endOf("month")],
                "Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")],
                "This Year": [moment().startOf("year"), moment().endOf("year")],
                "Last Year": [moment().subtract(1, "year").startOf("year"), moment().subtract(1, "year").endOf("year")],
                "All Time": [moment().year(2012).startOf("year"), new Date()]
            },
            drops: 'down'
        };

        vm.historyRange = { startDate: null, endDate: null };
        if (data.from) {
            vm.historyRange.startDate = data.from;
        }
        if (data.to) {
            vm.historyRange.endDate = data.to;
        }
        // vm methods
        vm.confirmRange = confirmRange;
        vm.closeModal = closeModal;

        function confirmRange(range) {
            closeModal(range);
        }

        function closeModal(result) {
            $scope.$close(result || false);
        }

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:WalletProtectCtrl
 * @description
 * # WalletProtectCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('WalletProtectCtrl', ["WalletsService", "$sessionStorage", "$stateParams", "MultisigRestangular", "$exceptionHandler", "$uibModal", "$q", function (WalletsService, $sessionStorage, $stateParams, MultisigRestangular, $exceptionHandler, $uibModal, $q) {

    	var vm = this;
        vm.loading = true;
        vm.errorMessage = null;

        vm.wallet = null;
        vm.walletAddress = $stateParams.id;
        vm.multisignStatus = null;
        vm.protectEnabled = false;

        vm.upgradeAvailable = false;

        vm.openDisableProtectModal = openDisableProtectModal;
        vm.openMultisigModal = openMultisigModal;
        vm.openInvoiceModal = openInvoiceModal;
        vm.getCertificate = getCertificate;
        vm.viewTerms = viewTerms;

        init();

        function init() {
            var getWalletPromise = WalletsService.getWallets()
                .then(function() {
                    vm.wallet = WalletsService.getByAddress(vm.walletAddress);
                }).catch(function(error) {
                    vm.errorMessage = error;
                    $exceptionHandler(error);
                });

            var getStatusPromise = getMultisigStatus();

            $q.all([
                getWalletPromise,
                getStatusPromise
            ])
            .catch(console.error)
            .finally(function() {
                vm.loading = false;
            });
        }

        function getMultisigStatus() {
            return MultisigRestangular.one("wallet", vm.walletAddress)
            .get()
            .then(function(response) {
                vm.multisignStatus = response.info;
                vm.protectEnabled = response.info.status === "ENABLED";

                if (vm.protectEnabled && !vm.multisignStatus.isExpired) {
                    findPlanUpgrades();
                }
            })
            .catch(function(error) {
                if (error.status !== 404) {
                    vm.errorMessage = error.data.message;
                }
                else {
                    $exceptionHandler(error);
                }
                vm.protectEnabled = false;
            });
        }

        function openDisableProtectModal() {
            var modalInstance = $uibModal.open({
                templateUrl: 'views/wallets/modal_protect_disable.html',
                controller: 'WalletProtectDisableCtrl',
                backdrop: 'static', // specific to multisign modals
                controllerAs: 'vm',
                resolve: {
                    data: function () {
                        return {
                            wallet: vm.wallet,
                        };
                    }
                }
            });
            modalInstance.result.then(function (isDisabled) {
                if (isDisabled) {
                    vm.multisignStatus = null;
                    vm.protectEnabled = false;
                };
            });
            modalInstance.closed.then(function () {
                getMultisigStatus();
            });
        }

        function openMultisigModal(isRenewal) {
            var modalInstance = $uibModal.open({
                templateUrl: 'views/settings/modal_multisig_setup.html',
                backdrop: 'static', // specific to multisign modals
                controller: 'MultisigSetupCtrl',
                controllerAs: 'vm',
                resolve: {
                    data: function () {
                        return {
                            user: $sessionStorage.user,
                            address: vm.walletAddress,
                            wallet: vm.wallet,
                            isRenewal: isRenewal
                        };
                    }
                }
            });
            modalInstance.result.then(function (isEnabled) {
                if (isEnabled) {
                    getMultisigStatus();
                }
            });
            modalInstance.closed.then(function (reason) {
                getMultisigStatus();
            });

        }

        function openInvoiceModal() {
            var modalInstance = $uibModal.open({
                templateUrl: 'views/wallets/modal_protect_invoice.html',
                controller: 'WalletProtectInvoiceCtrl',
                controllerAs: 'vm',
                resolve: {
                    data: function () {
                        return {
                            walletAddress: vm.wallet.address,
                            unsuredUpTo: vm.multisignStatus.plan.insurance.value,
                            validUntil: vm.multisignStatus.insurances.endDate
                        };
                    }
                }
            });
        }

        function getCertificate() {
            // restangular will incorrectly decode response as text. use $http to define responseType
            MultisigRestangular.one('wallet', vm.walletAddress).one('certificate')
                .customGET('')
                .then(function (response) {
                    downloadPDF(response, 'wallet-protect-certificate.pdf');
                })
                .catch(function(error) {
                    vm.errorMessage = error.data.message;
                    $exceptionHandler(error);
                });
        }

        function viewTerms() {
            window.open("https://cdn.gatehub.net/docs/Coincover_Theft_Cover_PID_Gatehub_202012.pdf",
                '_blank',
                'noopener'
            );
        }

        function findPlanUpgrades() {
            MultisigRestangular.one("wallet", vm.walletAddress).one("upgrade").get()
                .then(function(response) {
                    vm.upgradeAvailable = response.data && response.data.length;
                })
                .catch(function(error) {
                    $exceptionHandler(error);
                });
        }
    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:WalletProtectInvoiceCtrl
 * @description
 * # WalletProtectInvoiceCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('WalletProtectInvoiceCtrl', ["$scope", "data", "MultisigRestangular", "$exceptionHandler", function ($scope, data, MultisigRestangular, $exceptionHandler) {

        var vm = this;

        vm.loading = true;
        vm.error = null;

        vm.invoice = null;
        var address = data.walletAddress;
        vm.insuredUpTo = data.insuredUpTo;
        vm.validUntil = data.validUntil;
        vm.amountPayed = 0;

        vm.downloadInvoice = downloadInvoice;
        vm.closeModal = closeModal;


        MultisigRestangular.one('wallet', address).one('invoice').get()
            .then(function (response) {
                console.log(response);
                vm.invoice = response.plain();
                vm.amountPayed = +vm.invoice.payment || +vm.invoice.total;
            })
            .catch(function (error) {
                vm.error = error.data ? error.data.message : 'Something went wrong retrieving your invoice.'
                $exceptionHandler(error);
            })
            .finally(function() {
                vm.loading = false;
            });


        function downloadInvoice() {
            MultisigRestangular.one('wallet', address).one('invoice/pdf')
                .customGET('')
                .then(function (response) {
                    downloadPDF(response, 'wallet-protect-invoice.pdf');
                })
                .catch(function(error) {
                    vm.error = error.data ? error.data.message : 'Something went wrong retrieving your invoice.'
                    $exceptionHandler(error);
                })

        }

        function closeModal() {
            $scope.$dismiss();
        };

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:WalletProtectDisableCtrl
 * @description
 * # WalletProtectDisableCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('WalletProtectDisableCtrl', ["$scope", "data", "MultisigRestangular", "$q", "$timeout", "coreSecurity", "$sessionStorage", "RippleTx", "$exceptionHandler", function ($scope, data, MultisigRestangular, $q, $timeout, coreSecurity, $sessionStorage, RippleTx, $exceptionHandler) {
        var vm = this;

        vm.loading = false;
        vm.done = false;
        vm.errorMessage = null;

        vm.wallet = data.wallet;
        var allowPolling = true;
        var user = $sessionStorage.user;

        // user should has multisig "ENABLED" on this point
        var DISABLE_SIGNERS_STATUS = 'DISABLE_SIGNERS_LIST';
        var DISABLED_STATUS = 'DISABLED';

        // the next expected status. used for polling the async mutlisig status
        var targetState = DISABLE_SIGNERS_STATUS;

        var secrets = null;
        vm.isUnlocked = false;
        vm.confirmDisable = false;

        vm.disableProtect = disableProtect;
        vm.closeModal = closeModal;

        // Lock
        vm.isUnlocked = coreSecurity.is2FaAuthorized();
        if(vm.isUnlocked) {
            vm.errorMessage = false;
        } else {
            var listener = $scope.$on('2fa_authorized', function() {
                vm.isUnlocked = true;
                vm.errorMessage = false;
                listener();
            });
        }

        function disableProtect() {
            vm.errorMessage = null;

            RippleTx.getSecrets(vm.wallet).then(function(secrets) {
                processDisable(secrets);
            }, function (error) {
                if (error.status === 403 && error.data.message && error.data.message.toLowerCase() === '2fa required') {
                    vm.isUnlocked = false;
                    vm.loading = false;
                    var listener = $scope.$on('2fa_authorized', function(event, secrets) {
                        vm.isUnlocked = true;
                        processDisable(secrets);
                        listener();
                    });
                } else {
                    $exceptionHandler(error);
                }
            });
        }

        function processDisable(_secrets) {
            vm.loading = true;
            vm.errorMessage = null;

            secrets = _secrets;

            reenableKey().then(function() {
                disableSignersList().then(function() {
                    // clear secrets for session
                    secrets.multisign_address = null;
                    secrets.multisign_secret = null;

                    RippleTx.setMultisigStatus(vm.wallet.address, false);

                    vm.done = true;

                    $timeout(function() {
                        closeModal();
                    }, 4000);
                });
            });
        }

        function reenableKey() {
            var deferred = $q.defer();
            MultisigRestangular.one('wallet', vm.wallet.address).one('reenable_key_tx').get()
                .then(function(reenableTx) {
                    var signedTx = window.sign(reenableTx.txJSON, secrets.multisign_secret_decoded, { signAs: secrets.multisign_address }).signedTransaction;
                    postSetupTX(reenableTx.txJSON, signedTx, 'reenable_key_tx')
                        .then(function() {
                            targetState = DISABLED_STATUS;
                            deferred.resolve();
                        })
                        .catch(function(error) {
                            vm.loading = false;
                            vm.errorMessage = error.data ? error.data.message : 'Something went wrong.';
                        });
                })
                .catch(function(error) {
                    // if this step is already done, continue normally
                    if (error.data && error.data.status === DISABLE_SIGNERS_STATUS) {
                        deferred.resolve();
                    }
                    else {
                        vm.loading = false;
                        vm.errorMessage = error.data ? error.data.message : 'Something went wrong.';
                        $exceptionHandler(error.data)
                    }
                });

            return deferred.promise;
        }

        function disableSignersList() {
            return MultisigRestangular.one('wallet', vm.wallet.address).one('disable_signers_tx').get()
                .then(function(disableSignersTx) {
                    var signedTx = window.sign(disableSignersTx.txJSON, secrets.secret_decoded).signedTransaction;
                    return postSetupTX(disableSignersTx.txJSON, signedTx, 'disable_signers_tx')
                        .catch(function(error) {
                            vm.loading = false;
                            vm.errorMessage = error.data ? error.data.message : 'Something went wrong.';
                        });
                })
                .catch(function(error) {
                    vm.loading = false;
                    vm.errorMessage = error.data ? error.data.message : 'Something went wrong.';
                    $exceptionHandler(error.data)
                });
        }

        function postSetupTX(txJSON, signedTx, tx) {
            var deferred = $q.defer();

            MultisigRestangular.one('wallet', vm.wallet.address).one(tx)
                .customPUT({
                    txJSON: txJSON,
                    signedTransaction: signedTx
                })
                .then(function(tx) {
                    (function pollSetupStatus() {
                        MultisigRestangular.one("wallet", vm.wallet.address).get().then(function(setupStatus) {
                            var activeState = setupStatus.info.status;
                            console.log('Setup status', activeState, 'waiting for', targetState);
                            if (!activeState) {
                                deferred.reject('No setup status');
                                return;
                            }
                            // check if status has progressed
                            if (activeState === targetState) {
                                deferred.resolve(setupStatus);
                            }
                            else {
                                if (!allowPolling) {
                                    deferred.reject('Setup process canceled');
                                    return;
                                }
                                $timeout(function() {
                                    pollSetupStatus();
                                }, 1000);
                            }
                        })
                        .catch(function(error) {
                            // in the last ste wallet will be deleted and not found for regular users
                            if (error.status === 404) {
                                deferred.resolve();
                            }
                            deferred.reject(error);
                        });
                    })();
                })
                .catch(function(error) {
                    console.log(error);
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        function closeModal() {
            $scope.$close(vm.done);
        };


        $scope.$on("$destroy", function() {
            allowPolling = false;
        });
    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:WalletDepositRippleCtrl
 * @description
 * # WalletDepositRippleCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('WalletDepositRippleCtrl', ["$scope", "$exceptionHandler", "$timeout", "WalletsService", "VaultsService", function ($scope, $exceptionHandler, $timeout, WalletsService, VaultsService) {

        $scope.loading = true;
        $scope.vault = false;

        var wallet;

        // Init
        init();


        ///////////////////////////////////////////////////////////

        function init() {

            // Wait untill wallets are fully loaded
            WalletsService.getWallets().then(function(data) {

                // Get active wallet
                wallet = WalletsService.getActive();

                // Something went wrong, let's stop before it gets even worse
                if(!wallet) {
                    $exceptionHandler('wallet_not_found');
                    return;
                };

                // $scope.loading = false;
                $scope.wallet = wallet[0];

                // Get vault
                var vaults = VaultsService.list();
                if(vaults.length) {
                   $scope.vault = vaults[0].cold;
                };

                if(wallet[0].type != 0) {
                    $scope.loading = false;
                }

                checkGateways();


            }, function(error) {
                //$scope.loading = false;
                $exceptionHandler(error);
                return;
            })

        };

        function checkGateways() {

            VaultsService.getVaults().then(function(vaults) {

                for (var i = vaults.length - 1; i >= 0; i--) {
                    if(vaults[i].asset_code == 'XRP') {
                        // 1 = active, 3 = action required
                        if(vaults[i].gateway_connection_status === 1 || vaults[i].gateway_connection_status === 3) {
                            $timeout(function(){
                                $scope.gatewayConnected = true;
                                $scope.loading = false;
                            }, 0);
                        }
                        else {
                            $timeout(function(){
                                $scope.gatewayConnected = false;
                                $scope.loading = false;
                            }, 0);
                        }
                        return;

                    }
                }

            });

        };

        $scope.cancel = function() {
            $scope.$dismiss();
        };
    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:WalletDepositGatewayCtrl
 * @description
 * # WalletDepositGatewayCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('WalletDepositGatewayCtrl', ["$scope", "$rootScope", "$state", "$timeout", "WalletsService", "VaultsService", "EthRestangular", "RepRestangular", "BtcRestangular", "BchRestangular", "EtcRestangular", "DshRestangular", "LtcRestangular", "SgbRestangular", "FlrRestangular", "ENV", "$exceptionHandler", "RippleNetwork", "GalaRestangular", "UsdcRestangular", "UsdtRestangular", "WxrpRestangular", "NonstandardCurrencies", "StripeRestangular", function ($scope, $rootScope, $state, $timeout, WalletsService, VaultsService, EthRestangular, RepRestangular, BtcRestangular, BchRestangular, EtcRestangular, DshRestangular, LtcRestangular, SgbRestangular, FlrRestangular, ENV, $exceptionHandler, RippleNetwork, GalaRestangular, UsdcRestangular, UsdtRestangular, WxrpRestangular, NonstandardCurrencies, StripeRestangular) {

        $scope.loading = true;

        $scope.currencies = VaultsService.listCurrencies();

        $scope.selected_vault = false;
        $scope.selected_vault_connected = false;
        $scope.rippleDeposit = false;

        $scope.bridge_loading = false;
        $scope.bridge_error = null;

        var vault;

        if ($state.includes('wallets.item.deposit.sepa')) {
            $scope.direct = true;
            $scope.selected_vault = 'EUR';
            $scope.currentState = 'wallets.item.deposit.sepa';
            $scope.sepa = {
                receiver: {
                    iban: 'GB95SAPY60838227571239',
                    bic: 'SAPYGB2L',
                    name: 'GateHub Crypto d.o.o.',
                    address: 'Zaloska cesta 1',
                    postcode: '1000',
                    city: 'Ljubljana',
                    country: 'Slovenia',
                },
                sender: {
                    name: null,
                    address: null,
                    city: null,
                },
                type: (new EcbFormats()).type,
                currency: $scope.selected_vault,
                value: 10,
                purposeCode: null,
                purpose: null,
                reference: `SI99`,
                text: null,
            };
        }
        else if ($state.includes('wallets.item.deposit.wire')) {
            $scope.direct = true;
            $scope.selected_vault = 'USD';
            $scope.currentState = 'wallets.item.deposit.wire';
            $scope.wire = {
                receiver: {
                    iban: 'GB95SAPY60838227571239',
                    bic: 'SAPYGB2L',
                    name: 'GateHub Crypto d.o.o.',
                    address: 'Zaloska cesta 1',
                    postcode: '1000',
                    city: 'Ljubljana',
                    country: 'Slovenia',
                    account: '27571239',
                },
                bank: {
                    name: 'Banking Circle Denmark',
                    address: 'Amerika Plads 38',
                    postcode: '2100',
                    city: 'Copenhagen',
                    country: 'Denmark',
                },
            };
        }
        else if ($state.includes('wallets.item.deposit.gbp')) {
            $scope.direct = true;
            $scope.selected_vault = 'GBP';
            $scope.currentState = 'wallets.item.deposit.gbp';
            $scope.wire = {
                receiver: {
                    iban: 'GB95SAPY60838227571239',
                    bic: 'SAPYGB2L',
                    name: 'GateHub Crypto d.o.o.',
                    address: 'Zaloska cesta 1',
                    postcode: '1000',
                    city: 'Ljubljana',
                    country: 'Slovenia',
                    account: '27571239',
                    sortcode: '60 83 82'
                },
                bank: {
                    name: 'Banking Circle Denmark',
                    address: 'Amerika Plads 38',
                    postcode: '2100',
                    city: 'Copenhagen',
                    country: 'Denmark',
                },
            };
        }
        else if ($state.includes('wallets.item.deposit.ethereum_classic')) {
            $scope.direct = true;
            $scope.selected_vault = 'ETC';
            $scope.currentState = 'wallets.item.deposit.ethereum_classic';
        }
        else if ($state.includes('wallets.item.deposit.ethereum')) {
            $scope.direct = true;
            $scope.selected_vault = 'ETH';
            $scope.currentState = 'wallets.item.deposit.ethereum';
        }
        else if ($state.includes('wallets.item.deposit.rep')) {
            $scope.direct = true;
            $scope.selected_vault = 'REP';
            $scope.currentState = 'wallets.item.deposit.rep';
        }
        else if ($state.includes('wallets.item.deposit.dash')) {
            $scope.direct = true;
            $scope.selected_vault = 'DSH';
            $scope.currentState = 'wallets.item.deposit.dash';
        }
        else if ($state.includes('wallets.item.deposit.bitcoincash')) {
            $scope.direct = true;
            $scope.selected_vault = 'BCH';
            $scope.currentState = 'wallets.item.deposit.bitcoincash';
        }
        else if ($state.includes('wallets.item.deposit.bitcoin')) {
            $scope.direct = true;
            $scope.selected_vault = 'BTC';
            $scope.currentState = 'wallets.item.deposit.bitcoin';
        }
        else if ($state.includes('wallets.item.deposit.litecoin')) {
            $scope.direct = true;
            $scope.selected_vault = 'LTC';
            $scope.currentState = 'wallets.item.deposit.litecoin';
        }
        else if ($state.includes('wallets.item.deposit.interledger')) {
            $scope.direct = true;
            $scope.selected_vault = 'XRP';
            $scope.currentState = 'wallets.item.deposit.interledger';
        }
        else if ($state.includes('wallets.item.deposit.flare')) {
            $scope.direct = true;
            $scope.selected_vault = 'FLR';
            $scope.currentState = 'wallets.item.deposit.flare';
        }
        else if ($state.includes('wallets.item.deposit.songbird')) {
            $scope.direct = true;
            $scope.selected_vault = 'SGB';
            $scope.currentState = 'wallets.item.deposit.songbird';
        }
        else if ($state.includes('wallets.item.deposit.gala')) {
            $scope.direct = true;
            $scope.selected_vault = 'GALA';
            $scope.currentState = 'wallets.item.deposit.gala';
        }
        else if ($state.includes('wallets.item.deposit.usdt')) {
            $scope.direct = true;
            $scope.selected_vault = 'USDT';
            $scope.currentState = 'wallets.item.deposit.usdt';
        }
        else if ($state.includes('wallets.item.deposit.usdc')) {
            $scope.direct = true;
            $scope.selected_vault = 'USDC';
            $scope.currentState = 'wallets.item.deposit.usdc';
        }
        else if ($state.includes('wallets.item.deposit.wxrp')) {
            $scope.direct = true;
            $scope.selected_vault = 'WXRP';
            $scope.currentState = 'wallets.item.deposit.wxrp';
        }
        else if ($state.includes('wallets.item.deposit.card')) {
            $scope.direct = true;
            $scope.selected_vault = 'CARD';
            $scope.currentState = 'wallets.item.deposit.card';
            $rootScope.CARD_DEPOSIT = 'Card Deposit';
            initStripe();
        }

        var wallet;
        var wallet_address;


        // Init
        init();


        ///////////////////////////////////////////////////////////

        function init() {

            // Wait until wallets are fully loaded
            WalletsService.getWallets().then(function(data) {

                // Get active wallet
                wallet = WalletsService.getActive();

                // Something went wrong, let's stop before it gets even worse
                if(!wallet) {
                    $exceptionHandler('wallet_not_found');
                    return;
                };

                // Get shadow address if deposit is to Ripple wallet
                if(wallet[0].type == 10 || wallet[0].type == 11) {

                    if(typeof wallet[0].shadow_address != 'undefined') {
                        $scope.wallet = wallet[0];
                        wallet_address = wallet[0].shadow_address;
                    }
                    else {
                        $scope.wallet = WalletsService.getHosted();
                        $scope.rippleDeposit = true;
                        wallet_address = $scope.wallet.address;
                    };

                }
                else {
                    $scope.wallet = wallet[0];
                    wallet_address = wallet[0].address;
                };

                // Ethereum Classic Address
                if($state.includes('wallets.item.deposit.ethereum_classic')) {
                    getEtcAddress(wallet_address);
                };

                // REP Address
                if($state.includes('wallets.item.deposit.rep')) {
                    getRepAddress(wallet_address);
                };

                // Dash Address
                if($state.includes('wallets.item.deposit.dash')) {
                    getDashAddress(wallet_address);
                };

                // Ethereum Address
                if($state.includes('wallets.item.deposit.ethereum')) {
                    getEthereumAddress(wallet_address);
                };

                // Bitcoin Address
                if($state.includes('wallets.item.deposit.bitcoin')) {
                    getBitcoinAddress(wallet_address);
                };

                // Bitcoin Cash Address
                if($state.includes('wallets.item.deposit.bitcoincash')) {
                    getBitcoinCashAddress(wallet_address);
                };

                // Litecoin Address
                if($state.includes('wallets.item.deposit.litecoin')) {
                    getLitecoinAddress(wallet_address);
                };

                // ILP Address
                if($state.includes('wallets.item.deposit.interledger')) {
                    getILPAddress(wallet_address);
                };

                // Flare Address
                if($state.includes('wallets.item.deposit.flare')) {
                    getFlareAddress(wallet_address);
                };

                // Songbird Address
                if($state.includes('wallets.item.deposit.songbird')) {
                    getSongbirdAddress(wallet_address);
                };

                // GALA Address
                if($state.includes('wallets.item.deposit.gala')) {
                    getGalaAddress(wallet_address);
                };

                // USDT Address
                if($state.includes('wallets.item.deposit.usdt')) {
                    getUsdtAddress(wallet_address);
                };

                // USDC Address
                if($state.includes('wallets.item.deposit.usdc')) {
                    getUsdcAddress(wallet_address);
                };

                // WXRP Address
                if($state.includes('wallets.item.deposit.wxrp')) {
                    getWxrpAddress(wallet_address);
                };

                // CARD
                if($state.includes('wallets.item.deposit.card')) {
                    if ($scope.user && $scope.user.identity && $scope.user.identity.profile) {
                        const UP = $scope.user.identity.profile;
                        $scope.userFullName = [UP.first_name, UP.middle_name, UP.last_name].filter(n => !!n).join(' ');
                    }
                };

                $scope.wallet_address = wallet_address;

                //sepa init
                if ($scope.sepa) {
                    $scope.sepa.receiver.walletAddress = wallet_address;
                    if ($scope.user && $scope.user.identity && $scope.user.identity.profile) {
                        const UP = $scope.user.identity.profile;
                        $scope.sepa.sender.name = UP.first_name + ' ' + UP.last_name;
                        $scope.sepa.sender.address = UP.address_street1;
                        $scope.sepa.sender.address = UP.address_postal_code + ' ' + UP.address_city;
                        $scope.sepa.purpose = `Deposit to ${wallet_address}`;
                    }
                }

                checkVault();

            });

        }

        // BTC
        function getBitcoinAddress(address) {
            $scope.bridge_loading = true;
            $scope.bridge_error = false;
            BtcRestangular.one('address', address).get().then(function(data) {
                $timeout(function() {
                    $scope.bridge_address = data;
                    $scope.bridge_loading = false;
                }, 0);
            }, function(error) {
                if(error.status == 404) {
                    $scope.generateBitcoinAddress(address);
                }
                else {
                    $exceptionHandler(error);
                    $timeout(function() {
                        $scope.bridge_loading = false;
                        $scope.bridge_error = true;
                    }, 0);
                };
            });
        };

        $scope.generateBitcoinAddress = function (address) {
            BtcRestangular.one('address', address).post().then(function(data) {
                $timeout(function() {
                    $scope.bridge_address = data;
                    $scope.bridge_loading = false;
                }, 0);
            }, function(error) {
                $exceptionHandler(error);
                $timeout(function() {
                    $scope.bridge_loading = false;
                    $scope.bridge_error = true;
                }, 0);
            });
        };

        // BCH
        function getBitcoinCashAddress(address) {
            $scope.bridge_loading = true;
            $scope.bridge_error = false;
            BchRestangular.one('address', address).get().then(function(data) {
                $timeout(function() {
                    $scope.bridge_address = data;
                    $scope.bridge_loading = false;
                }, 0);
            }, function(error) {
                if(error.status == 404) {
                    $scope.generateBitcoinCashAddress(address);
                }
                else {
                    $exceptionHandler(error);
                    $timeout(function() {
                        $scope.bridge_loading = false;
                        $scope.bridge_error = true;
                    }, 0);
                };
            });
        };

        $scope.generateBitcoinCashAddress = function (address) {
            BchRestangular.one('address', address).post().then(function(data) {
                $timeout(function() {
                    $scope.bridge_address = data;
                    $scope.bridge_loading = false;
                }, 0);
            }, function(error) {
                $exceptionHandler(error);
                $timeout(function() {
                    $scope.bridge_loading = false;
                    $scope.bridge_error = true;
                }, 0);
            });
        };

        // ETH
        function getEthereumAddress(address) {
            $scope.bridge_loading = true;
            $scope.bridge_error = false;
            EthRestangular.one('address', address).get().then(function(data) {
                $timeout(function() {
                    $scope.bridge_address = data.ethereum_address;
                    $scope.bridge_loading = false;
                }, 0);
            }, function(error) {
                if(error.status == 404) {
                    $scope.generateEthereumAddress(address);
                }
                else {
                    $exceptionHandler(error);
                    $timeout(function() {
                        $scope.bridge_loading = false;
                        $scope.bridge_error = true;
                    }, 0);
                };
            });
        };

        $scope.generateEthereumAddress = function (address) {
            EthRestangular.one('address', address).post().then(function(data) {
                $timeout(function() {
                    $scope.bridge_address = data.ethereum_address;
                    $scope.bridge_loading = false;
                }, 0);
            }, function(error) {
                if(error.status == 404) {
                    $scope.bridge_loading = false;
                    $scope.bridge_error = true;
                }
                else {
                    $exceptionHandler(error);
                    $timeout(function() {
                        $scope.bridge_loading = false;
                        $scope.bridge_error = true;
                    }, 0);
                };
            });
        };

        // ETC
        function getEtcAddress(address) {
            $scope.bridge_loading = true;
            $scope.bridge_error = false;
            EtcRestangular.one('address', address).get().then(function(data) {
                $timeout(function() {
                    $scope.bridge_address = data.ethereum_address;
                    $scope.bridge_loading = false;
                }, 0);
            }, function(error) {
                if(error.status == 404) {
                    $scope.generateEtcAddress(address);
                }
                else {
                    $exceptionHandler(error);
                    $timeout(function() {
                        $scope.bridge_loading = false;
                        $scope.bridge_error = true;
                    }, 0);
                };
            });
        };

        $scope.generateEtcAddress = function (address) {
            EtcRestangular.one('address', address).post().then(function(data) {
                $timeout(function() {
                    $scope.bridge_address = data.ethereum_address;
                    $scope.bridge_loading = false;
                }, 0);
            }, function(error) {
                if(error.status == 404) {
                    $scope.bridge_loading = false;
                    $scope.bridge_error = true;
                }
                else {
                    $exceptionHandler(error);
                    $timeout(function() {
                        $scope.bridge_loading = false;
                        $scope.bridge_error = true;
                    }, 0);
                };
            });
        };

        // LTC
        function getLitecoinAddress(address) {
            $scope.bridge_loading = true;
            $scope.bridge_error = false;
            LtcRestangular.one('address', address).get().then(function(data) {
                $timeout(function() {
                    $scope.bridge_address = data;
                    $scope.bridge_loading = false;
                }, 0);
            }, function(error) {
                if(error.status == 404) {
                    $scope.generateLitecoinAddress(address);
                }
                else {
                    $exceptionHandler(error);
                    $timeout(function() {
                        $scope.bridge_loading = false;
                        $scope.bridge_error = true;
                    }, 0);
                };
            });
        };

        $scope.generateLitecoinAddress = function (address) {
            LtcRestangular.one('address', address).post().then(function(data) {
                $timeout(function() {
                    $scope.bridge_address = data;
                    $scope.bridge_loading = false;
                }, 0);
            }, function(error) {
                $exceptionHandler(error);
                $timeout(function() {
                    $scope.bridge_loading = false;
                    $scope.bridge_error = true;
                }, 0);
            });
        };

        // ILP
        function getILPAddress(address){

            var prefix = "";
            switch(ENV.name){
                case 'staging':
                case 'development':
                    prefix = ".staging";
                    break;
                case 'sandbox':
                    prefix = ".sandbox";
                    break;
            }

            $scope.bridge_address = "$ilp" + prefix + ".gatehub.net/" + address;
        }

        // DASH
        function getDashAddress(address) {
            $scope.bridge_loading = true;
            $scope.bridge_error = false;
            DshRestangular.one('address', address).get().then(function(data) {
                $timeout(function() {
                    $scope.bridge_address = data;
                    $scope.bridge_loading = false;
                }, 0);
            }, function(error) {
                if(error.status == 404) {
                    $scope.generateDashAddress(address);
                }
                else {
                    $exceptionHandler(error);
                    $timeout(function() {
                        $scope.bridge_loading = false;
                        $scope.bridge_error = true;
                    }, 0);
                };
            });
        };

        $scope.generateDashAddress = function (address) {
            DshRestangular.one('address', address).post().then(function(data) {
                $timeout(function() {
                    $scope.bridge_address = data;
                    $scope.bridge_loading = false;
                }, 0);
            }, function(error) {
                $exceptionHandler(error);
                $timeout(function() {
                    $scope.bridge_loading = false;
                    $scope.bridge_error = true;
                }, 0);
            });
        };

        // REP
        function getRepAddress(address) {
            $scope.bridge_loading = true;
            $scope.bridge_error = false;
            RepRestangular.one('address', address).get().then(function(data) {
                $timeout(function() {
                    $scope.bridge_address = data.ethereum_address;
                    $scope.bridge_loading = false;
                }, 0);
            }, function(error) {
                if(error.status == 404) {
                    $scope.generateRepAddress(address);
                }
                else {
                    $exceptionHandler(error);
                    $timeout(function() {
                        $scope.bridge_loading = false;
                        $scope.bridge_error = true;
                    }, 0);
                };
            });
        };

        $scope.generateRepAddress = function (address) {
            RepRestangular.one('address', address).post().then(function(data) {
                $timeout(function() {
                    $scope.bridge_address = data.ethereum_address;
                    $scope.bridge_loading = false;
                }, 0);
            }, function(error) {
                if(error.status == 404) {
                    $scope.bridge_loading = false;
                    $scope.bridge_error = true;
                }
                else {
                    $exceptionHandler(error);
                    $timeout(function() {
                        $scope.bridge_loading = false;
                        $scope.bridge_error = true;
                    }, 0);
                };
            });
        };

        // SONGBIRD START
        function getSongbirdAddress(address) {
            $scope.bridge_loading = true;
            $scope.bridge_error = false;
            SgbRestangular.one('address', address).get().then(function(data) {
                checkSgbConsent(address, data);
            }, function(error) {
                if(error.status == 404) {
                    $scope.generateSongbirdAddress(address);
                }
                else {
                    $exceptionHandler(error);
                    $timeout(function() {
                        $scope.bridge_loading = false;
                        $scope.bridge_error = true;
                    }, 0);
                };
            });
        };

        $scope.generateSongbirdAddress = function (address) {
            SgbRestangular.one('address', address).post().then(function(data) {
                checkSgbConsent(address, data);
            }, function(error) {
                if(error.status == 404) {
                    $scope.bridge_loading = false;
                    $scope.bridge_error = true;
                }
                else {
                    $exceptionHandler(error);
                    $timeout(function() {
                        $scope.bridge_loading = false;
                        $scope.bridge_error = true;
                    }, 0);
                };
            });
        };

        function checkSgbConsent(address, data) {
            SgbRestangular.one('account', address).get().then(function (response) {
                if (response.consented) {
                    $scope.bridge_address = data.ethereum_address;
                    $scope.bridge_loading = false;
                } else {
                    $state.go('wallets.item.balance.sgbclaim');
                }
            }, function() {
                $state.go('wallets.item.balance.sgbclaim');
            });
        }
        // SONGBIRD END

        // FLARE FUNCTIONS START
        function getFlareAddress(address) {
            $scope.bridge_loading = true;
            $scope.bridge_error = false;
            FlrRestangular.one('address', address).get().then(function(data) {
                $timeout(function() {
                    $scope.bridge_address = data.ethereum_address;
                    $scope.bridge_loading = false;
                    if(wallet[0].type == 10 || wallet[0].type == 11) {
                        checkFlareMessageKey(data.ethereum_address);
                    }
                }, 0);
            }, function(error) {
                if(error.status == 404) {
                    $scope.generateFlareAddress(address);
                }
                else {
                    $exceptionHandler(error);
                    $timeout(function() {
                        $scope.bridge_loading = false;
                        $scope.bridge_error = true;
                    }, 0);
                };
            });
        };

        $scope.generateFlareAddress = function (address) {
            FlrRestangular.one('address', address).post().then(function(data) {
                $timeout(function() {
                    $scope.bridge_address = data.ethereum_address;
                    $scope.bridge_loading = false;
                }, 0);
            }, function(error) {
                if(error.status == 404) {
                    $scope.bridge_loading = false;
                    $scope.bridge_error = true;
                }
                else {
                    $exceptionHandler(error);
                    $timeout(function() {
                        $scope.bridge_loading = false;
                        $scope.bridge_error = true;
                    }, 0);
                };
            });
        };

        function checkFlareMessageKey(flare_address) {
            $scope.messageKeyOk = false;
            getAccountInfo($scope.wallet.address).then(function(info){
                $scope.messageKeyOk = info.account_data && info.account_data.MessageKey === getFlareMessageKey(flare_address);
            }, function(error){
                console.log("Couldn't get account info", error);
            });
        }

        function getFlareMessageKey(address) {
            if (!address) {
                return '';
            }
            return address.replace('0x', '02000000000000000000000000').toUpperCase();
        }

        function getAccountInfo(address) {
            return new Promise(function(resolve, reject) {
                RippleNetwork.remote.account(address).entry(function(error, account) {
                    if (error) {
                        reject(error);
                    }
                    else {
                        resolve(account);
                    }
                });
            }).catch($exceptionHandler)
        }
        // FLARE FUNCTIONS END

        // GALA
        function getGalaAddress(address) {
            $scope.bridge_loading = true;
            $scope.bridge_error = false;
            GalaRestangular.one('address', address).get().then(function(data) {
                $timeout(function() {
                    $scope.bridge_address = data.ethereum_address;
                    $scope.bridge_loading = false;
                }, 0);
            }, function(error) {
                if(error.status == 404) {
                    $scope.generateGalaAddress(address);
                }
                else {
                    $exceptionHandler(error);
                    $timeout(function() {
                        $scope.bridge_loading = false;
                        $scope.bridge_error = true;
                    }, 0);
                };
            });
        };

        $scope.generateGalaAddress = function (address) {
            GalaRestangular.one('address', address).post().then(function(data) {
                $timeout(function() {
                    $scope.bridge_address = data.ethereum_address;
                    $scope.bridge_loading = false;
                }, 0);
            }, function(error) {
                if(error.status == 404) {
                    $scope.bridge_loading = false;
                    $scope.bridge_error = true;
                }
                else {
                    $exceptionHandler(error);
                    $timeout(function() {
                        $scope.bridge_loading = false;
                        $scope.bridge_error = true;
                    }, 0);
                };
            });
        };

        // USDT
        function getUsdtAddress(address) {
            $scope.bridge_loading = true;
            $scope.bridge_error = false;
            UsdtRestangular.one('address', address).get().then(function(data) {
                $timeout(function() {
                    $scope.bridge_address = data.ethereum_address;
                    $scope.bridge_loading = false;
                }, 0);
            }, function(error) {
                if(error.status == 404) {
                    $scope.generateUsdtAddress(address);
                }
                else {
                    $exceptionHandler(error);
                    $timeout(function() {
                        $scope.bridge_loading = false;
                        $scope.bridge_error = true;
                    }, 0);
                };
            });
        };

        $scope.generateUsdtAddress = function (address) {
            UsdtRestangular.one('address', address).post().then(function(data) {
                $timeout(function() {
                    $scope.bridge_address = data.ethereum_address;
                    $scope.bridge_loading = false;
                }, 0);
            }, function(error) {
                if(error.status == 404) {
                    $scope.bridge_loading = false;
                    $scope.bridge_error = true;
                }
                else {
                    $exceptionHandler(error);
                    $timeout(function() {
                        $scope.bridge_loading = false;
                        $scope.bridge_error = true;
                    }, 0);
                };
            });
        };

        // USDC
        function getUsdcAddress(address) {
            $scope.bridge_loading = true;
            $scope.bridge_error = false;
            UsdcRestangular.one('address', address).get().then(function(data) {
                $timeout(function() {
                    $scope.bridge_address = data.ethereum_address;
                    $scope.bridge_loading = false;
                }, 0);
            }, function(error) {
                if(error.status == 404) {
                    $scope.generateUsdcAddress(address);
                }
                else {
                    $exceptionHandler(error);
                    $timeout(function() {
                        $scope.bridge_loading = false;
                        $scope.bridge_error = true;
                    }, 0);
                };
            });
        };

        $scope.generateUsdcAddress = function (address) {
            UsdcRestangular.one('address', address).post().then(function(data) {
                $timeout(function() {
                    $scope.bridge_address = data.ethereum_address;
                    $scope.bridge_loading = false;
                }, 0);
            }, function(error) {
                if(error.status == 404) {
                    $scope.bridge_loading = false;
                    $scope.bridge_error = true;
                }
                else {
                    $exceptionHandler(error);
                    $timeout(function() {
                        $scope.bridge_loading = false;
                        $scope.bridge_error = true;
                    }, 0);
                };
            });
        };

        // WXRP
        function getWxrpAddress(address) {
            $scope.bridge_loading = true;
            $scope.bridge_error = false;
            WxrpRestangular.one('address', address).get().then(function(data) {
                $timeout(function() {
                    $scope.bridge_address = data.ethereum_address;
                    $scope.bridge_loading = false;
                }, 0);
            }, function(error) {
                if(error.status == 404) {
                    $scope.generateWxrpAddress(address);
                }
                else {
                    $exceptionHandler(error);
                    $timeout(function() {
                        $scope.bridge_loading = false;
                        $scope.bridge_error = true;
                    }, 0);
                };
            });
        };

        $scope.generateWxrpAddress = function (address) {
            WxrpRestangular.one('address', address).post().then(function(data) {
                $timeout(function() {
                    $scope.bridge_address = data.ethereum_address;
                    $scope.bridge_loading = false;
                }, 0);
            }, function(error) {
                if(error.status == 404) {
                    $scope.bridge_loading = false;
                    $scope.bridge_error = true;
                }
                else {
                    $exceptionHandler(error);
                    $timeout(function() {
                        $scope.bridge_loading = false;
                        $scope.bridge_error = true;
                    }, 0);
                };
            });
        };

        function checkVault() {

            VaultsService.getConnectedVaults().then(function(vaults) {
                for (var i = vaults.length - 1; i >= 0; i--) {
                    if (vaults[i].asset_code == $scope.selected_vault ||
                        vaults[i].asset_code === 'EUR' && $scope.selected_vault === 'CARD') {
                        // 1 = active, 3 = action required
                        if(vaults[i].gateway_connection_status === 1 || vaults[i].gateway_connection_status === 3) {

                            vault = vaults[i];

                            $timeout(function() {
                                $scope.vault = vault;
                            }, 0);

                            if(wallet[0].type == 10 || wallet[0].type == 11) {

                                // Check trust line
                                checkTrustline();
                                $scope.$watch('wallet.lines', function() {
                                    checkTrustline();
                                });

                            }
                            else {
                                $timeout(function() {
                                    $scope.loading = false;
                                    $scope.selected_vault_connected = true;
                                }, 0);
                            };
                        }
                        else {
                            $timeout(function() {
                                $scope.loading = false;
                                $scope.selected_vault_connected = false;
                                $scope.selected_vault_status = 'pending';
                            }, 0);
                        }
                        return;
                    }
                }

                $timeout(function() {
                    $scope.loading = false;
                    $scope.selected_vault_connected = false;
                    $scope.selected_vault_status = 'no-connection';
                }, 0);

            });

        };

        function checkTrustline() {

            // TODO - get cold from vault data
            var _vault = VaultsService.getVaultByCurrency(vault.asset_code);

            $timeout(function() {
                $scope._vault = _vault;
            }, 0);

            // Allow deposit for unfunded wallets

            if($scope.wallet.unfunded == true) {
                $timeout(function() {
                    $scope._vault = _vault;
                    $scope.selected_vault_connected = true;
                    $scope.loading = false;
                }, 0);
                return;
            };


            if(typeof $scope.wallet.lines == 'undefined') {
                $timeout(function() {
                    $scope.selected_vault_status = 'no-trustline';
                    $scope.loading = false;
                }, 0);
                return;
            };
            var vaultXrplCurrencyCode = _vault.currency;
            if(vaultXrplCurrencyCode.length > 3 && vaultXrplCurrencyCode.length < 40) {
                vaultXrplCurrencyCode = NonstandardCurrencies.encodeAssetCode(vaultXrplCurrencyCode);
            }
            if(typeof $scope.wallet.lines[_vault.cold + vaultXrplCurrencyCode] != 'undefined') {

                // Check line
                var _line = $scope.wallet.lines[_vault.cold + vaultXrplCurrencyCode];

                $timeout(function() {
                    if(_line._limit != 0) {
                        $scope.selected_vault_connected = true;
                    }
                    else {
                        $scope.selected_vault_status = 'no-trustline';
                    }
                }, 0);

            }
            else {
                $timeout(function() {
                    $scope.selected_vault_status = 'no-trustline';
                }, 0);
            }

            $timeout(function() {
                $scope.loading = false;
            }, 0);

        };

        $scope.selectVault = function (vault) {
            $scope.selected_vault = vault;
        };

        $scope.cancel = function() {
            $scope.$dismiss();
        };

        $scope.setTrust = function(params) {
            $scope.$close(params);
        };

        /// STRIPE START ///
        var stripe, elements, paymentElement;
        $scope.stripeSubmitDisabled = true;
        $scope.topupForm = null;
        $scope.stripeStep = 1;
        $scope.goToStripeStep = function(num) {
            $scope.stripeStep = num;
        }

        function initStripe() {
            StripeRestangular.one('config').get().then(function(response) {
                var publishableKey = response.data.publishableKey;
                var initOptions = {
                    locale: 'en'
                }
                stripe = Stripe(publishableKey, initOptions);
            }, function(error) {
                $scope.topupStatus = 'unavailable';
                console.log('stripe error', error);
            });
        }

        $scope.prepareIntent = prepareIntent;
        function prepareIntent(userAmount) {
            if (!userAmount) {
                console.error('Amount missing!');
                return false;
            }
            let stripeAmount = Math.round(userAmount * 100); // convert to smallest units - cents

            if (!wallet_address) { // This is either HOSTED or SHADOW address.
                console.error('Wallet Address not found');
                return false;
            }

            let intentData = {
                amount: stripeAmount,
                currency: 'EUR',
                walletAddress: wallet_address
            }

            StripeRestangular.one('create-payment-intent').customPOST(intentData).then(function(response) {
                $scope.stripeStep = 2;
                const clientSecret = response.data.clientSecret;
                const appearance = {
                    theme: 'stripe',
                    variables: {
                        colorPrimary: '#0A6CF1',
                        colorBackground: '#ffffff',
                        colorText: '#30313d',
                        colorDanger: '#EE0066',
                        fontFamily: '\'Roboto\', sans-serif'
                    }
                };
                elements = stripe.elements({ appearance, clientSecret });
                const paymentElementOptions = {
                    layout: "tabs" // default anyway
                };

                paymentElement = elements.create("payment", paymentElementOptions);

                paymentElement.mount("#payment-element");

                paymentElement.on('change', function(event) {
                    console.log('payment element change:', event);
                    if (event.complete) {
                        $scope.stripeSubmitDisabled = false;
                    } else {
                        $scope.stripeSubmitDisabled = true;
                    }
                    $scope.$apply();
                  });
            }, function(error){
                if (error.data && error.data.message && error.data.message.length) {
                    let errorMessage = error.data.message[0];
                    errorMessage = errorMessage.charAt(0).toUpperCase() + errorMessage.slice(1);
                    showMessage(errorMessage)
                } else {
                    showMessage("An unexpected error occurred. Please try again later.");
                }
            });

        }

        $scope.calculateStripeFee = function(amount) {
            const minDepositEur = 10;
            const feeRelativeStripe = 0.01;
            const feeFixedStripe = 0;

            $scope.enteredAmount = amount;
            $scope.stripeFee = amount * feeRelativeStripe + feeFixedStripe;
            $scope.amountToBeReceived = amount - $scope.stripeFee;

            $scope.minDepositCard = Math.ceil(minDepositEur + (minDepositEur * feeRelativeStripe / 100) + feeFixedStripe);
        }

        $scope.handleSubmitTopupForm = function(event) {
            event.preventDefault();
            $scope.stripeSubmitDisabled = true;
            $scope.mode = 'loading';

            stripe.confirmPayment({
                elements,
                redirect: 'if_required',
                confirmParams: {
                  // Make sure to change this to your payment completion page
                  return_url: document.URL,
                  payment_method_data: {
                    billing_details: {
                      name: $scope.userFullName
                    }
                  }
                }
            }).then(function(response) { // successful request redirects to return url, otherwise it contains error response
                if (response.error) {
                    $scope.mode = false;
                    var error = response.error;
                    if (error.message) {
                        showMessage(error.message);
                    } else {
                        showMessage("An unexpected error occurred.");
                    }
                    $scope.stripeSubmitDisabled = false;
                    $scope.apply();
                } else {
                    if (response.paymentIntent) { // this resolves only when no redirect was made (because of redirect:'if_required')
                        const resultClientSecret = response.paymentIntent.client_secret;
                        stripe.retrievePaymentIntent(resultClientSecret).then(function(data) {
                            const paymentIntent = data.paymentIntent;
                            switch (paymentIntent.status) {
                                case "succeeded":
                                    $scope.mode = 'success';
                                    $scope.$apply();
                                    $timeout(function() {
                                        $state.go('wallets.item.balance');
                                    }, 6000);
                                    break;
                                case "processing":
                                    $scope.mode = 'processing';
                                    $scope.apply();
                                    $timeout(function() {
                                        $state.go('wallets.item.balance');
                                    }, 6000);
                                    break;
                                case "requires_payment_method":
                                    showMessage("Your payment was not successful, please try again.");
                                    $scope.mode = 'false';
                                    $scope.stripeSubmitDisabled = false;
                                    $scope.$apply();
                                    break;
                                default:
                                    showMessage("Something went wrong.");
                                    $scope.mode = 'false';
                                    $scope.stripeSubmitDisabled = false;
                                    $scope.apply();
                                    break;
                            }
                        }, function(error) {
                            $scope.mode = false;
                            $scope.stripeSubmitDisabled = false;
                            $scope.$apply();
                        });
                    } else {
                        $scope.mode = false;
                    }
                }
            }, function (error) {
                $scope.mode = false;
            });
        }

        function showMessage(paymentMessage) {
            $scope.paymentMessage = paymentMessage;
            setTimeout(function () {
                $scope.paymentMessage = false;
            }, 10000);
        }

        $scope.$on('$destroy', function() {
            $rootScope.CARD_DEPOSIT = null; // resets modal title
        });

        /* STRIPE END */

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:WalletDepositPayStringCtrl
 * @description
 * # WalletDepositPayStringCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('WalletDepositPayStringCtrl', ["$scope", "$exceptionHandler", "Auth", "WalletsService", "CoreRestangular", "PayStringService", "$timeout", "VaultsService", "$q", function ($scope, $exceptionHandler,  Auth, WalletsService, CoreRestangular, PayStringService, $timeout, VaultsService, $q) {
        var vm = this;

        vm.user = null;
        vm.payString = null;
        vm.newPayString = '';
        vm.primaryWallet = null;

        vm.loading = true;
        vm.gatewayConnected = false;
        vm.payStringRegex = "^[a-z0-9][a-z0-9\.\-]{0,62}[a-z0-9]$";
        vm.showDelete = false;
        vm.gatehubPayStringDomain = PayStringService.getPayStringDomain();

        vm.createNewPayString = createNewPayString;
        vm.removePayString = removePayString;
        vm.closeModal = closeModal;

        $q.all([
            Auth.getProfile(),
            checkGateways()
        ]).then(function(results){
            vm.user = results[0].plain();
            vm.payString = results[0].core.paystring;
            vm.loading = false;
            init();
        }, function(error) {
            vm.loading = false;
            vm.error = "An error occured. Please try again later.";
            $exceptionHandler(error);
        });

        ///////////////////////////////////////////////////////////

        function init() {

            // Wait untill wallets are fully loaded
            WalletsService.getWallets().then(function(data) {

                // Get active wallet
                var address = WalletsService.getPrimary();
                vm.primaryWallet = WalletsService.getById(address)[0];

            }, function(error) {
                $exceptionHandler(error);
                return;
            })

        };

        function checkGateways() {
            return VaultsService.getVaults().then(function(vaults) {
                for (var i = vaults.length - 1; i >= 0; i--) {
                    if(vaults[i].asset_code == 'XRP') {
                        // 1 = active, 3 = action required
                        if(vaults[i].gateway_connection_status === 1 || vaults[i].gateway_connection_status === 3) {
                            vm.gatewayConnected = true;
                        } else {
                            vm.gatewayConnected = false;
                        }
                        return;
                    }
                }
            });
        };

        function createNewPayString() {
            vm.loading = true;
            vm.error = null;
            CoreRestangular.one('users', vm.user.id).one('paystring')
                .customPOST({ paystring: vm.newPayString })
                .then(function(response) {
                    vm.user.core.paystring = response.paystring;
                    vm.payString = response.paystring;
                })
                .catch(function(error) {
                    $exceptionHandler(error);
                    vm.error = error.data.message;
                })
                .finally(function() {
                    vm.loading = false;
                });
        }

        function removePayString() {
            vm.loading = true;
            vm.error = null;

            CoreRestangular.one('users', vm.user.id).one('paystring')
                .remove()
                .then(function(response) {
                    vm.user.core.paystring = null;
                    vm.payString = null;
                    $timeout(function()  {
                        closeModal();
                    }, 1500)
                })
                .catch(function(error) {
                    $exceptionHandler(error);
                    vm.error = error.data.message || 'Failed to remove your PayString. Please try again.';
                })
                .finally(function() {
                    vm.loading = false;
                });
        }


        function closeModal() {
            $scope.$dismiss();
        };

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:TradeCtrl
 * @description
 * # TradeCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('TradeCtrl', ["$scope", "$rootScope", "$timeout", "$stateParams", "$state", "$localStorage", "$interval", "$filter", "MarketsService", "WalletsService", "RippleNetwork", "$uibModal", "RippleBook", "coreSecurity", "ENV", "$exceptionHandler", "RippleTx", "FeatureService", "ThirdPartyService", "NonstandardCurrencies", function ($scope, $rootScope, $timeout, $stateParams, $state, $localStorage, $interval, $filter, MarketsService, WalletsService, RippleNetwork, $uibModal, RippleBook, coreSecurity, ENV, $exceptionHandler, RippleTx, FeatureService, ThirdPartyService, NonstandardCurrencies) {

        // Lock
        $scope.isUnlocked = coreSecurity.is2FaAuthorized();
        if (!$scope.isUnlocked) {
            var listener = $scope.$on('2fa_authorized', function() {
                $scope.isUnlocked = true;
                listener();
            });
        }

        $rootScope.isTradePageActive = true;

        $scope.state = $state;

        $scope.forms = {
            buyForm: {},
            sellForm: {}
        }

        $scope.loading = true;
        $scope.wallet = false;
        $scope.wallets = [];
        $scope.show_markets = false;
        $scope.showTvChart = false;

        $scope.bookShow = {
            asks: [],
            bids: []
        };

        $scope.balance = [];
        $scope.balance.base = 0;
        $scope.balance.counter = 0;
        $scope.balance.base_ratio = 0;
        $scope.balance.counter_ratio = 0;
        $scope.balance.base_xrp = 0;
        $scope.balance.counter_xrp = 0;

        $scope.offersCount = 0;
        $scope.offersBuys = 0;
        $scope.offersSells = 0;

        $scope.bookLimit = 28;

        $scope.panelToDisplay = 'order-book';

        $scope.isWalletSelectorActive = false;

        var wallet;
        var address;

        var base;
        var counter;

        var lastUpdate;
        var timer;
        var rpamountFilter = $filter('rpamount');

        var balancesUpdateListener;
        var offersUpdateListener;

        var max_trade = 1;

        var OrderbookFilterOpts = {
            abs_precision: 10,
        };

        $scope.runShowMoreOrders = runShowMoreOrders;
        $scope.showMoreOrders = false;

        $scope.runShowMoreTrades = runShowMoreTrades;
        $scope.showMoreTrades = false;
        $scope.lastTradesLimit = 80;

        // Route includes currency pair
        if ($stateParams.base && $stateParams.counter && ($stateParams.base !== $stateParams.counter)) {

            var xbase = $stateParams.base.split(':');
            var xcounter = $stateParams.counter.split(":");

            var xbaseCurrency = (xbase[0].length === 3 || xbase[0].length === 40) ? xbase[0] : NonstandardCurrencies.encodeAssetCode(xbase[0]);
            var xcounterCurrency = (xcounter[0].length === 3 || xcounter[0].length === 40) ? xcounter[0] : NonstandardCurrencies.encodeAssetCode(xcounter[0]);

            base = {
                currency: xbaseCurrency,
                issuer: xbase[1] ? xbase[1] : ''
            };
            counter = {
                currency: xcounterCurrency,
                issuer: xcounter[1] ? xcounter[1] : ''
            };

            $localStorage.activeMarket = {
                base: base,
                counter: counter,
            };
        }
        else {

            // Try localStorage
            var xmarket = $localStorage.activeMarket;
            if(typeof xmarket !== 'undefined') {
                base = xmarket.base;
                counter = xmarket.counter;
            }
            else {
                var defaultEnvCounter = ENV.defaultExchangeCounter;
                base = {
                    currency: 'XRP',
                    issuer: '',
                };
                counter = {
                    currency: defaultEnvCounter.currency || 'USD',
                    issuer: defaultEnvCounter.issuer || 'rhub8VRN55s94qWKDv6jmDy1pUykJzF3wq',
                };

            }

            var xbase = base.currency + (base.issuer ? ':' + base.issuer : '');
            var xcounter = counter.currency + (counter.issuer ? ':' + counter.issuer : '');

            $state.go('trade', {base: xbase, counter: xcounter});
        };

        $scope.thirdPartyWarning = null;
        ThirdPartyService.getThirdPartyWarning(base, counter).then(function(result){
            $scope.thirdPartyWarning = result;
        });
        $scope.addThirdPartyConsent = function(base, counter) {
            ThirdPartyService.addConsent(base, counter).then(function() {
                $scope.thirdPartyWarning = null;
            }, function(error) {
                $exceptionHandler(error);
            });
        }

        // Route includes type
        if($stateParams.type == 'buy' || $stateParams.type == 'sell') {
            $timeout(function(){
                $scope.active_form = $stateParams.type;
                resetForm();
            });
        };

        // Init
        $scope.loadingBook = true;
        $scope.lastUpdate = 0;
        $scope.active_form = 'buy';

        resetForm();

        $scope.base = base;
        $scope.counter = counter;

        // Charts
        $scope.chart_depth = depthChart();

        // Start Markets
        var markets = [];
        initMarkets();

        $scope.gateways = ENV.name === 'production' ? MarketsService.list_gateways() : ENV.exchangeChoices;
        // $scope.markets = markets;

        $scope.initTime = Math.round((new Date()).getTime() / 1000);

        // Update Books
        $scope.$watch('book.asksLastUpdate', function () {
            updateBook('asks');
        });

        $scope.$watch('book.bidsLastUpdate', function () {
            updateBook('bids');
        });

        // Force orderbook update
        $scope.$watch('lastUpdate', function () {
            if ($scope.lastUpdate > 60) {
                console.log('Force update orderbook')
                $scope.book.requestOffers();
            }
            if ($scope.lastUpdate === 55) {
                MarketsService.refreshHistoricMarketsData();
            }
        }, true);

        // Watch fields
        $scope.$watch('buy.price', function() {
            addOrderLine($scope.buy.price);
        });

        $scope.$watch('sell.price', function() {
            addOrderLine($scope.sell.price);
        });

        // Start Wallet
        init();

        // Don't forget to clear timers on exit!!!
        $scope.$on('$destroy', function() {
            $rootScope.isTradePageActive = false;
            stopTimer();
            if(typeof $scope.book !== 'undefined') {
                $scope.book.unsubscribe();
            }

            unsubscribeListeners();
        });

        function stopTimer() {
            if (angular.isDefined(timer)) {
                $interval.cancel(timer);
                timer = undefined;
            }
        };

        ///////////////////////////////////////////////////////////

        function init() {

            // Wait until wallets are fully loaded
            WalletsService.getWallets().then(function(data) {
                $scope.wallets = data;
                loadWallet(data);

                $scope.$broadcast('walletsLoaded', true);

            }, function(error) {
                $exceptionHandler(error);
                $scope.loading = false;
                return;
            })

            $scope.baseFee = '';
            $scope.counterFee = '';
            if (base.issuer){
                getAccountInfo(base.issuer).then(function(res){
                    if(res.account_data && res.account_data.TransferRate){
                        var transferRate = res.account_data.TransferRate;
                        var XRP_TO_DROPS = 1000000000;
                        $scope.baseFee = (transferRate - XRP_TO_DROPS) / XRP_TO_DROPS * 100;
                    }
                }).catch(error => {
                    $scope.baseFee = '';
                })
            } else {
                $scope.baseFee = 0;
            }
            if (counter.issuer){
                getAccountInfo(counter.issuer).then(function(res){
                    if(res.account_data && res.account_data.TransferRate){
                        var transferRate = res.account_data.TransferRate;
                        var XRP_TO_DROPS = 1000000000;
                        $scope.counterFee = (transferRate - XRP_TO_DROPS) / XRP_TO_DROPS * 100;
                    }
                }).catch(error => {
                    $scope.counterFee = '';
                })
            } else {
                $scope.counterFee = 0;
            }

            reflowHighcharts();
        };

        function getAccountInfo(address) {
            return new Promise(function(resolve, reject) {
                RippleNetwork.remote.account(address).entry(function(error, account) {
                    if (error) {
                        reject(error);
                        // $exceptionHandler(error);  // Handled in invoker
                    }
                    else {
                        resolve(account);
                    }
                });
            })
        }

        function loadWallet(data) {

            // Get active wallet
            wallet = WalletsService.getActive();

            // Something went wrong, let's stop before it gets even worse
            if(!wallet) {
                $exceptionHandler('wallet_not_found');
                return;
            };

            WalletsService.getHistory(wallet[0]);

            address = wallet[0].address;

            $scope.loading = false;
            $scope.wallet = wallet[0];
            $scope.wallets = data;

            // Start Book
            loadBook();
            updateBalance();
            updateOffers();

            // unsub first
            unsubscribeListeners();
            // Update data on change
            balancesUpdateListener = $rootScope.$on('$balancesUpdate', function() {
                $scope.wallet = wallet[0];
                updateBalance();
                updateOffers();
            });

            offersUpdateListener = $rootScope.$on('$offersUpdate', function() {
                $scope.wallet = wallet[0];
                updateOffers();
            });

            // lock removed from loadwallet to init
        };

        function initMarkets() {
            markets = MarketsService.list();

            var market = MarketsService.getMarket(base, counter);
            if (!market) {
                var pair = {
                    base: base,
                    counter: counter
                };
                market = MarketsService.addMarket(pair, 'onDemand');
            }
            MarketsService.subscribeToMarket(market);

            $scope.market = market;

            $scope.markets_usd = _.filter(markets.default, (e) => e.listIn === 'USD');
            $scope.markets_eur = _.filter(markets.default, (e) => e.listIn === 'EUR');
            $scope.markets_xrp = _.filter(markets.default, (e) => e.listIn === 'XRP');
            FeatureService.isEnabledForUser({flag: 'FlareLaunch'}).then(function (isEnabled) {
                if (isEnabled) {
                    const defMarkets = MarketsService.updateConfigArray(
                        [
                            { base: 'FLR', counter: 'USD', listIn: 'USD' },
                            { base: 'FLR', counter: 'EUR', listIn: 'EUR' },
                            { base: 'XRP', counter: 'FLR', listIn: 'XRP' },
                        ]
                    );
                    $scope.markets_usd.push(..._.filter(defMarkets, (e) => e.listIn === 'USD'));
                    $scope.markets_eur.push(..._.filter(defMarkets, (e) => e.listIn === 'EUR'));
                    $scope.markets_xrp.push(..._.filter(defMarkets, (e) => e.listIn === 'XRP'));
                }
            });
            $scope.markets_other = markets.custom;
        }

        $scope.switchWallet = function (id) {
            // Save active wallet
            WalletsService.setActive(id);
            $scope.isWalletSelectorActive = false;

            init();
        };

        $scope.calculateTradesBar = function (amount) {

            // Get max
            if(max_trade == 1) {
                var max = _.max($scope.market.trades, function(o){return o.amount;});
                max_trade = max.amount;
            }

            var ratio = amount / max_trade;
            return 30 * ratio;
        };

        $scope.calculate = function (focused) {

            // Check active form
            var active = $scope.active_form;

            if (active == 'buy') {
                var scope = $scope.buy;
            }
            else if (active == 'sell') {
                var scope = $scope.sell;
            }
            else {
                return;
            }

            switch (focused) {
                case 'price':
                    var price = scope.price;
                    if(isNaN(price))
                        return;
                    else {
                        if(price == '')
                            return;
                    }

                    var amount = scope.amount;
                    if(isNaN(amount))
                        return;
                    else {
                        if(amount == '')
                            return;
                        else
                        {
                            var value = price*amount;
                            scope.value = Math.ceil(value*100000000)/100000000
                        }
                    }
                break
                case 'amount':
                    var amount = scope.amount;
                    if(isNaN(amount))
                        return;
                    else {
                        if(amount == '')
                            return;
                    }

                    var price = scope.price;
                    if(isNaN(price))
                        return;
                    else {
                        if(price == '')
                            return;
                        else {
                            var value = price*amount;
                            scope.value = Math.ceil(value*100000000)/100000000;
                        }
                    }
                break
                case 'value':
                    var value = scope.value;

                    if(isNaN(value))
                        return;
                    else {
                        if(value == '')
                            return;
                    }

                    var price = scope.price;
                    if(isNaN(price))
                        return;
                    else {
                        if(price == '')
                            return;
                        else
                        {
                            value = Math.ceil(value*100000000)/100000000
                            var amount = Math.ceil(value/price*100000000)/100000000
                            scope.amount = Math.ceil(amount*100000000)/100000000
                        }
                    }

                break
            }

        };

        function handleClick(event) {

            var price = Math.ceil(event.xAxis[0].value*1000000)/1000000;

            if(isNaN(price))
                return;

            if($scope.sending)
                return;

            // Check active form
            var active = $scope.active_form;

            if (active == 'buy') {
                $scope.buy.price = price;
                addOrderLine($scope.buy.price);
            }
            else if (active == 'sell') {
                $scope.sell.price = price;
                addOrderLine($scope.sell.price);
            }

            $scope.calculate('price');

        };

        function handleClickPoint() {

            var price = Math.ceil(this.x*1000000)/1000000;

            if(isNaN(price))
                return;

            if($scope.sending)
                return;

            // Check active form
            var active = $scope.active_form;

            if (active == 'buy') {
                $scope.buy.price = price;
                addOrderLine($scope.buy.price);
            }
            else if (active == 'sell') {
                $scope.sell.price = price;
                addOrderLine($scope.sell.price);
            }

            $scope.calculate('price');

        };

        function addOrderLine(price) {

            if (typeof $scope.chart_depth === 'undefined' || !$scope.chart_depth.getHighcharts)
                return;

            if (isNaN(price))
                return;

            var color = '#7CEE00';

            if ($scope.active_form == 'sell') {
                color = '#EE0066';
            }

            var depthChart = $scope.chart_depth.getHighcharts();

            depthChart.xAxis[0].removePlotLine('new-order');
            depthChart.xAxis[0].addPlotLine({
                value: price,
                color: color,
                width: 2,
                dashStyle: 'solid',
                id: 'new-order'
            });

        };

        function clearOrderLines() {

            if (typeof $scope.chart_depth === 'undefined' || !$scope.chart_depth.getHighcharts)
                return;

            var depthChart = $scope.chart_depth.getHighcharts();
            if(!angular.isUndefined(depthChart.xAxis))
                depthChart.xAxis[0].removePlotLine('new-order');

        };

        function addOpenOrderLine(price, seq, type) {

            if(typeof $scope.chart_depth === 'undefined' || !$scope.chart_depth.getHighcharts)
                return;

            if (isNaN(price))
                return;

            var color = 'rgba(166,205,67,0.5)';

            if (type == 'asks') color = 'rgba(252,39,104,0.4)';

            var depthChart = $scope.chart_depth.getHighcharts();

            if (typeof depthChart.xAxis === 'undefined') return;

            depthChart.xAxis[0].addPlotLine({
                value: price,
                color: color,
                width: 1,
                dashStyle: 'dash',
                id: seq,
            });

        };

        function clearOpenOrderLine() {

            if (typeof $scope.chart_depth === 'undefined' || !$scope.chart_depth.getHighcharts) return;
            var depthChart = $scope.chart_depth.getHighcharts();

            if(typeof depthChart.xAxis === 'undefined') return;

            var plotlines = depthChart.xAxis[0].plotLinesAndBands;

            if($scope.wallet.loadingOffers) return;

            $.each(plotlines, function () {
                var line = this;

                if(typeof line == 'undefined') return;

                var found = false;
                var offers = $scope.wallet.offers;

                if(typeof offers == 'undefined') return;

                $.each(offers, function () {
                    var offer = this;

                    if (offer.seq == line.id) {
                        found = true;
                        return;
                    }

                });

                // Remove plotline if order was not found
                if (!found && line.id != 'new-order') {
                    if(typeof depthChart.xAxis === 'undefined') return;
                    depthChart.xAxis[0].removePlotLine(line.id);
                }

            });

        };

        $scope.changeForm = function(active) {
            $scope.active_form = active;
            resetForm();
        };

        $scope.clickPrice = function(xprice, type) {

            if($scope.sending)
                return;

            var price = parseFloat(xprice);

            // Check active form
            var active = $scope.active_form;

            if (active == 'buy') {
                $scope.buy.price = price;
            }
            else if (active == 'sell') {
                $scope.sell.price = price;
            }

            $scope.calculate('price');

        };

        $scope.submitForm = function(isValid, type) {

            // Make sure the form is completely valid - should be!
            if (!isValid) {
                console.error('One or more required fields are invalid');
                return;
            }

            if (type == 'buy') {
                var scope = $scope.buy;
            }
            else if (type == 'sell') {
                var scope = $scope.sell;
            }
            else {
                return;
            }

            scope.mode = 'status';
            $scope.sending = true;

            var gets = parseFloat(scope.amount);
            var price = parseFloat(scope.price);

            // Also check balance!


            // Calculate pay amount
            var pays = gets * price;
            var TakerGets = 0;
            var TakerPays = 0;

            if (counter.currency != 'XRP')
                TakerGets = pays + '/' + counter.currency + '/' + counter.issuer;
            else
                TakerGets = (parseFloat(pays) * 1000000).toFixed(0);

            if (base.currency != 'XRP')
                TakerPays = gets + '/' + base.currency + '/' + base.issuer;
            else
                TakerPays = (parseFloat(gets) * 1000000).toFixed(0);


            // Switch if SELL
            if (type == 'sell') {

                var sell_gets = TakerPays;
                var sell_pays = TakerGets;

                TakerGets = sell_gets;
                TakerPays = sell_pays;

            }

            // Catch ripple-lib ty parsing errors
            try {
                var tx = RippleNetwork.remote.createTransaction('OfferCreate', {
                    account: address,
                    taker_pays: TakerPays,
                    taker_gets: TakerGets
                });
            }
            catch (error) {
                scope.mode = 'error';
                scope.errorMessage = error;
                $timeout(function() {
                    resetForm();
                }, 4000)

                return;
            }

            // Set Sell
            if (type == 'sell')
                tx.set_flags('Sell');

            tx.on('error', function (error) {
                scope.mode = 'error';

                if(error.result == 'tecINSUF_RESERVE_OFFER' || error.engine_result == 'tecINSUF_RESERVE_OFFER') {
                    scope.errorMessage = "Insufficient XRP to create a market offer. Please remove a trust line or cancel an open order.<br><span>Read more: <a target='_blank' href='https://support.gatehub.net/hc/en-us/articles/360021238254-XRP-reserve'>XRP Reserves</a></span>"
                }
                else {
                    scope.errorMessage = error.engine_result_message;
                    $exceptionHandler(error);
                }

                $timeout(function() {
                    resetForm();
                }, 4000)
            });

            tx.on('success', function (res) {
                // console.log('Submit success', res);
                scope.mode = 'success';

                $scope.book.requestOffers();

                $timeout(function() {
                    resetForm();
                }, 1000)
            });

            RippleTx.submitTransaction(tx, $scope.wallet)
                .catch(function (error) {
                    if (error.status === 403 && error.data.message && error.data.message.toLowerCase() === '2fa required') {
                        $scope.isUnlocked = false;
                        var listener = $scope.$on('2fa_authorized', function() {
                            $scope.isUnlocked = true;
                            $scope.submitForm(isValid, type);
                            listener();
                        });
                    } else {
                        scope.mode = 'error';
                        $scope.errorMessage = error.message;
                        $timeout(function() {
                            resetForm();
                        }, 4000)
                    }
                });
        };

        function resetForm() {

            $scope.sending = false;

            var defaultForm = {
                amount: '',
                name: '',
                value: '',
                mode: false,
                errorMessage: false,
            }

            $scope.buy = angular.copy(defaultForm);
            $scope.sell = angular.copy(defaultForm);

            if (!angular.equals($scope.forms.sellForm, {})) {
                $scope.forms.sellForm.$setPristine();
            }
            if (!angular.equals($scope.forms.buyForm, {})) {
                $scope.forms.buyForm.$setPristine();
            }

            clearOrderLines();

        };

        // Offers
        function updateOffers() {

            $timeout(function() {

                var offers = $scope.wallet.offers;
                var buys = [];
                var sells = [];

                var market_base =  base.currency + (base.issuer ? base.issuer : '');
                var market_counter = counter.currency + (counter.issuer ? counter.issuer : '');

                if (typeof offers === 'undefined') return;

                $.each(offers, function () {

                    var offer = this;

                    var gets_currency = offer.gets.currency().to_human();
                    var gets_issuer = offer.gets.issuer().is_valid() ? offer.gets.issuer().to_json() : '';

                    var pays_currency = offer.pays.currency().to_human();
                    var pays_issuer = offer.pays.issuer().is_valid() ? offer.pays.issuer().to_json() : '';

                    var offer_base = gets_currency + gets_issuer;
                    var offer_counter = pays_currency + pays_issuer;

                    var price = $filter('rpamountratio')(offer.second, offer.first);

                    price = rpamountFilter(price, OrderbookFilterOpts).replace(/,/g, '');

                    if (offer_counter == market_base && offer_base == market_counter) {
                        buys.push(offer);
                        addOpenOrderLine(price, offer.seq, 'bids');
                    }

                    if (offer_counter == market_counter && offer_base == market_base) {
                        sells.push(offer);
                        addOpenOrderLine(price, offer.seq, 'asks');
                    }

                });

                $scope.offersBuys = buys;
                $scope.offersSells = sells;

                $scope.offersBuysCount = _.size(buys);
                $scope.offersSellsCount = _.size(sells);

                // All -  including other markets
                $scope.offersCountAll = _.size($scope.wallet.offers);

                // Ratio and chart
                var sum = _.size(buys) + _.size(sells);

                var buys_ratio;
                var sells_ratio;

                if(sum == 0) {
                    buys_ratio = 0;
                    sells_ratio = 0;
                }
                else {
                    buys_ratio = (_.size(buys) / sum)*100;
                    sells_ratio = (_.size(sells) / sum)*100;
                }

                if (buys_ratio == 0 && sells_ratio == 0)
                    var chart_data = [['Base', 0], ['Counter', 1]]
                else
                    var chart_data = [['Base', buys_ratio], ['Counter', sells_ratio]];

                // // Update chart
                // $timeout(function(){
                //     $scope.chart_orders.series[0].data = chart_data;
                // });

            });

            clearOpenOrderLine();
        };

        // Balance
        function updateBalance() {

            // Reset
            $scope.balance.base = 0;
            $scope.balance.base_xrp = 0;
            $scope.balance.counter = 0;
            $scope.balance.counter_xrp = 0;

            // Base
            if (base.currency == 'XRP' && typeof $scope.wallet.xrp !== 'undefined') {
                $scope.balance.base = parseInt($scope.wallet.xrp * 1000000);
                $scope.balance.base_xrp = $scope.wallet.xrp;
            }
            else if (typeof $scope.wallet.lines !== 'undefined') {
                if($scope.wallet.lines.hasOwnProperty(base.issuer+base.currency)) {
                    $scope.balance.base = $scope.wallet.lines[base.issuer+base.currency].balance;

                    var rate = ( $localStorage.exchangeRates[base.currency + ':' + base.issuer] || 0);
                    var xrp = $scope.wallet.lines[base.issuer+base.currency].balance.to_number() * rate;

                    $scope.balance.base_xrp = xrp;
                }
            };

            // Counter
            if (counter.currency == 'XRP' && typeof $scope.wallet.xrp !== 'undefined') {
                $scope.balance.counter = parseInt($scope.wallet.xrp * 1000000);
                $scope.balance.counter_xrp = $scope.wallet.xrp;
            }
            else if (typeof $scope.wallet.lines !== 'undefined') {
                if($scope.wallet.lines.hasOwnProperty(counter.issuer+counter.currency)) {
                    $scope.balance.counter = $scope.wallet.lines[counter.issuer+counter.currency].balance;

                    var rate = ( $localStorage.exchangeRates[counter.currency + ':' + counter.issuer] || 0);
                    var xrp = $scope.wallet.lines[counter.issuer+counter.currency].balance.to_number() * rate;

                    $scope.balance.counter_xrp = xrp;
                }
            };

            // Ratios
            var sum = $scope.balance.base_xrp + $scope.balance.counter_xrp;

            if(sum == 0) {
                $scope.balance.base_ratio = 0;
                $scope.balance.counter_ratio = 0;
            }
            else {
                $scope.balance.base_ratio = ($scope.balance.base_xrp / sum)*100;
                $scope.balance.counter_ratio = ($scope.balance.counter_xrp / sum)*100;
            }

            if ($scope.balance.base_ratio == 0 && $scope.balance.counter_ratio == 0)
                var chart_data = [['Base', 0], ['Counter', 1]]
            else
                var chart_data = [['Base', $scope.balance.counter_ratio], ['Counter', $scope.balance.base_ratio]];

            /* $timeout(function(){
                // Update chart
                $scope.chart_distribution.series[0].data = chart_data;
            }); */

        };

        // Book
        function updateBook(type) {

            if (!$scope.book || !$scope.book[type] || !$scope.book[type].length) return;

            var oldBookShow = $scope.bookShow[type];

            $scope.bookShow[type] = jQuery.extend(true, [], $scope.book[type]);

            lastUpdate = new Date();

            stopTimer();

            timer = $interval(function() {
                var seconds = Math.round((new Date() - lastUpdate) / 1000);
                $scope.lastUpdate = seconds || 0;
            }, 1000);

            var newValuesLength = $scope.bookShow[type].length;

            var oldBookShowIndex = _.indexBy(oldBookShow, 'BookDirectory');
            var isUpdate = oldBookShow.length > 0;

            for (var i = 0; i < newValuesLength; i++) {

                var order = $scope.bookShow[type][i];
                order.showSum = rpamountFilter(order.sum, {abs_precision: 2});
                order.showPrice = rpamountFilter(order.price, OrderbookFilterOpts).replace(/,/g, '');
                order.orderPrice = rpamountFilter(order.price, OrderbookFilterOpts).replace(/,/g, '');

                var showValue = type === 'bids' ? 'TakerPays' : 'TakerGets';
                var showAmount = type === 'bids' ? 'TakerGets' : 'TakerPays';

                order['show' + showValue] = rpamountFilter(order[showValue], {abs_precision: 4});
                order['show' + showAmount] = rpamountFilter(order[showAmount], {abs_precision: 2});

                order.isNew = isUpdate && !oldBookShowIndex[order.BookDirectory];

                // Draw chart line if order is mine
                /*
                if (order.my) {
                    addOpenOrderLine(order.orderPrice, order.Sequence, type);
                }
                */

                if (isUpdate && !order.isNew) {
                    order.isChanged = order['show' + showValue] !== oldBookShowIndex[order.BookDirectory]['show' + showValue] ||
                    order.showPrice !== oldBookShowIndex[order.BookDirectory].showPrice;
                }
            }

            // Clean old
            // clearOpenOrderLine();

            if ($scope.book.ready) {
                if ($scope.book.asks[0] && $scope.book.bids[0]) {

                    // Stop loader once we have both sides
                    $scope.loadingBook = false;

                    //$scope.priceTicker.spread = rpamountFilter($scope.book.asks[0].price.subtract($scope.book.bids[0].price), OrderbookTickerFilterOpts);

                    var bidData = [];
                    var askData = [];
                    var previousBid = Infinity;
                    var previousAsk = 0;
                    var bidChartExtreme = Infinity;
                    var askChartExtreme = 0;

                    var opts = { group_sep: false };

                    var price = parseFloat(Amount.from_json($scope.book.asks[0].price).to_human(opts));
                    var limitBid = price - (price * 0.4);  // Show - 40% off the current bid price
                    var limitAsk = price + (price * 0.4);  // Show + 40% off the current ask price

                    // BIDS
                    for (var i = 0; i < $scope.book.bids.length; i++) {

                        var bid = $scope.book.bids[i];

                        var price = parseFloat(Amount.from_json($scope.book.bids[i].price).to_human(opts));
                        var sum = parseFloat(Amount.from_json($scope.book.bids[i].sum).to_human(opts));

                        if (previousBid > price && price > limitBid) {
                            bidData.push([price, sum]);
                            previousBid = price;

                            if(price < bidChartExtreme){
                                bidChartExtreme = price;
                            }
                        }
                    };

                    // ASKS
                    for (var i = 0; i < $scope.book.asks.length; i++) {

                        var ask = $scope.book.asks[i];

                        var price = parseFloat(Amount.from_json($scope.book.asks[i].price).to_human(opts));
                        var sum = parseFloat(Amount.from_json($scope.book.asks[i].sum).to_human(opts));

                        if (previousAsk < price && price < limitAsk) {
                            askData.push([price, sum]);
                            previousAsk = price;

                            if(price > askChartExtreme){
                                askChartExtreme = price;
                            }
                        }
                    };

                    if (bidData.length > 0) {
                        bidData.reverse();
                        bidData.push([bidData[bidData.length-1][0], 0]);    // Add line to the bottom
                    };

                    if (askData.length > 0)
                        askData.unshift([askData[0][0], 0]);    // Add line to the bottom

                    $scope.chart_depth.series[0].data = bidData;
                    $scope.chart_depth.series[1].data = askData;

                    if (typeof $scope.chart_depth === 'undefined' || !$scope.chart_depth.getHighcharts) return;
                    $scope.chart_depth.getHighcharts().xAxis[0].setExtremes(bidChartExtreme, askChartExtreme);

                }
            }
            else {
                $scope.book.requestOffers();
            }
        };

        function loadBook() {
            // Make sure we unsubscribe from any previously loaded orderbook
            if ($scope.book && 'function' === typeof $scope.book.unsubscribe) {
                $scope.book.unsubscribe();
            }

            $scope.book = RippleBook.get({
                currency: $scope.base.currency,
                issuer: $scope.base.issuer
            }, {
                currency: $scope.counter.currency,
                issuer: $scope.counter.issuer
            }, address);

        };

        $scope.removeMarket = function (id) {
            MarketsService.deleteMarket(id);
        };

        $scope.go = function (base, counter, type, $event) {
            if($event !== false) {
                $event.stopPropagation();
            };

            var _base =  base.currency + (base.issuer ? ':' + base.issuer : '');
            var _counter = counter.currency + (counter.issuer ? ':' + counter.issuer : '');

            $state.go('trade', {base: _base, counter: _counter, type: type});
        };

        $scope.sortableOptions = {
            cancel: '.unsortable',
            stop: function(e, ui) {
                // todo: Update custpm market sorting
                // MarketsService.updatePairs($scope.markets);
            }
        };

        $scope.showMarkets = function () {
            if($scope.show_markets == false) {
                reflowHighcharts();
                $scope.show_markets = true;
            }
            else {
                $scope.show_markets = false;
            }
        };

        $scope.hideMarkets = function () {
            $scope.show_markets = false;
        }

        function runShowMoreOrders() {
            $scope.showMoreOrders = true;
            $scope.bookLimit = 100;
        }

        $scope.firstTimeRunningShowMoreTrades = true;
        function runShowMoreTrades() {
            if ($scope.loadingLastTrades) {
                return;
            }

            $scope.loadingLastTrades = true;
            if($scope.firstTimeRunningShowMoreTrades) {
                $scope.firstTimeRunningShowMoreTrades = false;
                MarketsService.updateLastTrades($scope.market, showMoreTradesSuccessCallback, showMoreTradesErrorCallback);
            } else {
                showMoreTradesSuccessCallback();
            }
        }

        function showMoreTradesSuccessCallback() {
            $scope.lastTradesLimit += 50;
            $scope.loadingLastTrades = false;
        }

        function showMoreTradesErrorCallback() {
            $scope.loadingLastTrades = false;
        }

        $scope.cancelOrder = function (offer, $event) {
            var seq = offer.seq;
            if(offer.cancelling){
                return;
            }
            offer.cancelling = true;
            if ($event !== false) {
                $event.stopPropagation();
            }
            cancelOrderPromise(seq).then(function (response) {
                console.log('[ripple cancel order] success', response);
            }, function (error) {
                offer.cancelling = false;
                console.log('[ripple cancel order] error', error);
                $exceptionHandler(error);
            });
        }

        function cancelOrderPromise(seq) {
            return new Promise(function (resolve, reject) {
                if (!seq) {
                    reject("Sequence number missing");
                }

                var tx = RippleNetwork.remote.transaction();
                tx.offer_cancel($scope.wallet.address, seq);

                tx.on('success', function (res) {
                    resolve(res);
                });

                tx.on('error', function (err) {
                    $exceptionHandler(err);
                    reject(err);
                });

                RippleTx.submitTransaction(tx, $scope.wallet)
                    .catch(function (error) {
                        if (error.status === 403 && error.data.message && error.data.message.toLowerCase() === '2fa required') {
                            $scope.isUnlocked = false;
                            var listener = $scope.$on('2fa_authorized', function() {
                                $scope.isUnlocked = true;
                                cancelOrderPromise(seq);
                                listener();
                            });
                        } else {
                            $exceptionHandler(error);
                            reject(error.message);
                        }
                    });
            });
        }

        function depthChart() {

            var config = {

                options: {
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        borderWidth: 0,
                        plotShadow: false,
                        backgroundColor:'rgba(255, 255, 255, 0)',
                        type: 'area',
                        margin: [0,0,20,0],
                        spacing: [0,0,0,0],
                        events: {
                            click: handleClick
                        },
                        animation: false
                    },
                    legend: {
                        enabled: false
                    },
                    plotOptions: {
                        series: {
                            animation: false,
                            states: {
                                inactive: {
                                    enabled: false
                                }
                            }
                        },
                    },
                    exporting: {
                        enabled: false
                    },
                    tooltip: {
                        borderRadius: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.3)',
                        borderWidth: 0,
                        shadow: false,
                        valueDecimals : 2,
                        style: {
                            color: '#e6e6e6',
                            fontSize: '14px',
                        },
                        crosshairs: {
                            color: 'rgba(255, 255, 255, 0.3)',
                            dashStyle: 'solid'
                        },
                    },
                },
                xAxis: {
                    tickLength: 5,
                    tickWidth: 1,
                    tickColor: 'rgba(255,255,255, 0.3)',
                    lineWidth: 0,
                    labels: {
                        y: 15,
                        style: {
                            color: 'rgba(255,255,255, 0.3)',
                            fontSize: '11px',
                            fontWeight: '400',
                        }
                    },
                    offset: 0,
                    startOnTick: false,
                    endOnTick: false,
                    showFirstLabel: false,
                },
                yAxis: {
                    title: false,
                    tickLength: 0,
                    tickWidth: 1,
                    lineWidth: 0,
                    gridLineWidth: 0,
                    gridLineColor: '#9E06BE',
                    showFirstLabel: true,
                    showLastLabel: false,
                    tickColor: 'rgba(255,255,255, 0.3)',
                    labels: {
                        x: 15,
                        y: -5,
                        align: 'left',
                        style: {
                            color: 'rgba(255,255,255, 0.3)',
                            fontSize: '11px',
                            fontWeight: '400',
                        }
                    },
                },
                title: {
                    text: undefined
                },
                series : [{
                    name: 'Bid',
                    fillColor: 'rgba(117,177,3, 0.1)',
                    color: '#7CEE00',
                    data: [],
                    marker : {
                        enabled: false,
                    },
                    step: 'right',
                    point: {
                        events: {
                            click: handleClickPoint
                        }
                    }
                }, {
                    name: 'Ask',
                    fillColor: 'rgba(243,49,113, 0.1)',
                    color: '#EE0066',
                    data: [],
                    marker: {
                        enabled: false,
                    },
                    step: 'left',
                    point: {
                        events: {
                            click: handleClickPoint
                        }
                    }
                }],
                func: function(chart) {
                    $timeout(function() {
                        if(chart.index != undefined) {
                            chart.reflow();
                        }
                    }, 2000);
                }
            };
            return config;

        };

        function marketsCharts() {

            var config = {
                options: {
                    chart: {
                        type: 'line',
                        backgroundColor:'rgba(255, 255, 255, 0)',
                        plotBackgroundColor: 'rgba(255, 255, 255, 0)',
                        margin: [0,0,0,0],
                        spacing: [0,0,0,0],
                        style: {
                            fontFamily: '"Roboto", sans-serif;', // default font
                        },
                        animation: false,
                        height: 90
                    },
                    legend: {
                        enabled: false
                    },
                    plotOptions: {
                        line: {
                            marker: {
                                enabled: false
                            },
                            states: {
                                hover: {
                                    enabled: false
                                }
                            }
                        },
                        series: {
                            animation: false
                        }
                    },
                    exporting: { enabled: false },
                    tooltip: { enabled: false },
                    marker: { enabled: false },
                },
                yAxis: {
                    title: false,
                    lineWidth: 0,
                    gridLineWidth: 0,
                    labels: { enabled: false },
                },
                xAxis: {
                    type: 'datetime',
                    lineWidth: 0,
                    tickLength: 0,
                    labels: { enabled: false },
                },
                series: [],
                title: { text: undefined },
                func: function(chart) {
                    $timeout(function() {
                        if(chart.index != undefined) {
                            chart.reflow();
                        }
                    }, 0);
                }
            };
            return config;
        };

        // INIT TRADINGVIEW WIDGET
        var color = {
            WHITE: "#ffffff",
            GREEN: "#75B103",
            GREEN_TRANSPARENT: "rgba(117,117,3,0.05)",
            PINK: "#ee0066",
            PINK_TRANSPARENT: "rgba(238,0,102,0.05)",
            PAGE_BG: "#121317",
            CHART_BG: "#121317"
        }

        var LINESTYLE_SOLID = 0;
        var LINESTYLE_DOTTED = 1;
        var LINESTYLE_DASHED = 2;
        var LINESTYLE_LARGE_DASHED = 3;

        $scope.tradingViewInit = function() {
            window.tvWidget = new window.TradingView.widget({

                debug: false,

                symbol: base.currency + (base.issuer ? "+" + base.issuer : "") + "/" +
                        counter.currency + (counter.issuer ? "+" + counter.issuer : ""),
                //symbol: 'XRP/EUR+rhub8VRN55s94qWKDv6jmDy1pUykJzF3wq',
                custom_css_url: '../../style.css',
                interval: '1D', // default interval,
                timeframe: '1Y',
                fullscreen: false, // displays the chart in the fullscreen mode
                container_id: 'tv_chart_container',
                datafeed: window.Datafeed,
                library_path: 'scripts/tradingview/charting_library/',
                autosize: true,
                chart_property_page_style: 'off',
                border_around_the_chart: false,

                // gatehub settings
                enabled_features: ['hide_left_toolbar_by_default', 'hide_last_na_study_output', 'side_toolbar_in_fullscreen_mode', 'create_volume_indicator_by_default'],
                disabled_features: ['use_localstorage_for_settings', 'header_symbol_search', 'header_settings', 'header_compare', 'context_menus', 'edit_buttons_in_legend'],

                theme: 'Dark',
                toolbar_bg: color.PAGE_BG,
                overrides: {
                    // General chart styles
                    "paneProperties.background": color.CHART_BG,
                    "scalesProperties.textColor" : "#cccccc",
                    "scalesProperties.lineColor" : "#555555", // axis color
                    "paneProperties.vertGridProperties.color": "#2b2e3a",
                    "paneProperties.horzGridProperties.color": "#2b2e3a",
                    "paneProperties.crossHairProperties.color": "#2b2e3a",


                    // Candles styles
                    "mainSeriesProperties.candleStyle.upColor": color.GREEN,
                    "mainSeriesProperties.candleStyle.downColor": color.PINK,
                    "mainSeriesProperties.candleStyle.wickUpColor": color.GREEN,
                    "mainSeriesProperties.candleStyle.wickDownColor": color.PINK,
                    "mainSeriesProperties.candleStyle.borderUpColor": color.GREEN,
                    "mainSeriesProperties.candleStyle.borderDownColor": color.PINK,

                    // Hollow Candles styles
                    "mainSeriesProperties.hollowCandleStyle.upColor": color.GREEN,
                    "mainSeriesProperties.hollowCandleStyle.downColor": color.PINK,
                    "mainSeriesProperties.hollowCandleStyle.drawWick": true,
                    "mainSeriesProperties.hollowCandleStyle.drawBorder": true,
                    "mainSeriesProperties.hollowCandleStyle.borderUpColor": color.GREEN,
                    "mainSeriesProperties.hollowCandleStyle.borderDownColor": color.PINK,
                    "mainSeriesProperties.hollowCandleStyle.wickUpColor": color.GREEN,
                    "mainSeriesProperties.hollowCandleStyle.wickDownColor": color.PINK,

                    // Heikin Ashi styles
                    "mainSeriesProperties.haStyle.upColor": color.GREEN,
                    "mainSeriesProperties.haStyle.downColor": color.PINK,
                    "mainSeriesProperties.haStyle.drawWick": true,
                    "mainSeriesProperties.haStyle.drawBorder": true,
                    "mainSeriesProperties.haStyle.borderUpColor": color.GREEN,
                    "mainSeriesProperties.haStyle.borderDownColor": color.PINK,
                    "mainSeriesProperties.haStyle.wickUpColor": color.GREEN,
                    "mainSeriesProperties.haStyle.wickDownColor": color.PINK,
                    "mainSeriesProperties.haStyle.barColorsOnPrevClose": false,

                    // Bar styles
                    "mainSeriesProperties.barStyle.upColor": color.GREEN,
                    "mainSeriesProperties.barStyle.downColor": color.PINK,
                    "mainSeriesProperties.barStyle.barColorsOnPrevClose": false,
                    "mainSeriesProperties.barStyle.dontDrawOpen": false,

                    // Line styles
                    "mainSeriesProperties.lineStyle.color": color.WHITE,
                    "mainSeriesProperties.lineStyle.linestyle": LINESTYLE_SOLID,
                    "mainSeriesProperties.lineStyle.linewidth": 2,
                    "mainSeriesProperties.lineStyle.priceSource": "close",

                    // Area styles
                    "mainSeriesProperties.areaStyle.color1": color.WHITE,
                    "mainSeriesProperties.areaStyle.color2": color.WHITE,
                    "mainSeriesProperties.areaStyle.linecolor": color.WHITE,
                    "mainSeriesProperties.areaStyle.linestyle": LINESTYLE_SOLID,
                    "mainSeriesProperties.areaStyle.linewidth": 1,
                    "mainSeriesProperties.areaStyle.priceSource": "close",

                    // Baseline styles
                    "mainSeriesProperties.baselineStyle.baselineColor": color.WHITE,
                    "mainSeriesProperties.baselineStyle.topFillColor1": color.GREEN_TRANSPARENT,
                    "mainSeriesProperties.baselineStyle.topFillColor2": color.GREEN_TRANSPARENT,
                    "mainSeriesProperties.baselineStyle.bottomFillColor1": color.PINK_TRANSPARENT,
                    "mainSeriesProperties.baselineStyle.bottomFillColor2": color.PINK_TRANSPARENT,
                    "mainSeriesProperties.baselineStyle.topLineColor": color.GREEN,
                    "mainSeriesProperties.baselineStyle.bottomLineColor": color.PINK,
                    "mainSeriesProperties.baselineStyle.topLineWidth": 2,
                    "mainSeriesProperties.baselineStyle.bottomLineWidth": 2,
                    "mainSeriesProperties.baselineStyle.priceSource": "close",
                    "mainSeriesProperties.baselineStyle.transparency": 50,
                    "mainSeriesProperties.baselineStyle.baseLevelPercentage": 50,
                },
                studies_overrides: {
                    "volume.volume.color.0": color.PINK,
                    "volume.volume.color.1": color.GREEN,
                    "volume.volume.transparency": 50,
                },
                favorites: {
                    intervals: ["1D", "1W", "1M"],
                    chartTypes: ["Candle", "Line"]
                },
                time_frames: [
                    {
                        text: "1d",
                        resolution: "15",
                        description: "1 Day",
                        title: "1D"
                    }, {
                        text: "7d",
                        resolution: "120",
                        description: "7 Days",
                        title: "7D"
                    }, {
                        text: "1m",
                        resolution: "240",
                        description: "1 Month",
                        title: "1M"
                    }, {
                        text: "1y",
                        resolution: "1D",
                        description: "1 Year",
                        title: "1Y"
                    }, {
                        text: "5y",
                        resolution: "1W",
                        description: "5 Years",
                        title: "5Y"
                    }
                ],
                loading_screen: {
                    backgroundColor: color.CHART_BG,
                    foregroundColor: color.CHART_BG,
                },

            });

            window.tvWidget.onChartReady(function(){
                $scope.showTvChart = true;
            });

        };


        $scope.toggleSelector = function(value)  {
            $scope.isWalletSelectorActive = value;
        }

        $scope.changePanel = function(panel) {
            $scope.panelToDisplay = panel;
            if(panel === 'depth-chart'){
                $timeout(function() {
                    $scope.chart_depth.getHighcharts().reflow();
                }, 0);
            }
        }

        $scope.openAddMarketModal = function() {
            // ! leave this! grunt usemin for some reason skips the first occurrence of this html file
            console.info('views/analytics/modal_add_market.html');

            $uibModal.open({
                templateUrl: 'views/analytics/modal_add_market.html',
                controller: 'MarketsAddCtrl'
            });
        }

        $scope.loadChartData = function(market) {
            if (!market.chart) {
                market.chart = marketsCharts();

                var color = '#7CEE00';
                if(market.red == true) {
                    color = '#EE0066';
                }
                // Render chart data
                var series = market.chart.series;
                if (typeof series[0] == 'undefined') {
                    series.push({
                        data: market.data,
                        color: color,
                    })
                }
                else {
                    series[0].data = market.data;
                    series[0].color = color;
                }

                if (series[0].data && series[0].data.length) {
                    // Add plot line - baseline on 1st tick
                    market.chart.yAxis.plotLines = [{
                        color: '#707070',
                        width: 1,
                        dashStyle: 'dash',
                        value: series[0].data[0][1]
                    }];
                }
            }

            return market.chart;
        }

        $scope.fillSellAmount = function() {
            $scope.changeForm('sell');
            var price = rpamountFilter($scope.balance.base).replace(/,/g, '');
            if (price) {
                $scope.sell.amount = +price;
            }
        }
        $scope.fillBuyAmount = function() {
            $scope.changeForm('buy');
            var price = rpamountFilter($scope.balance.counter).replace(/,/g, '');
            if (price) {
                $scope.buy.value = +price;
            }
        }

        function unsubscribeListeners() {
            if (balancesUpdateListener) {
                balancesUpdateListener();
            }
            if (offersUpdateListener) {
                offersUpdateListener();
            }
        }

        function reflowHighcharts() {
            if (Highcharts) {
                $timeout(function () {
                    Highcharts.charts.map(chart => {
                        if (chart) {
                            chart.reflow();
                        }
                    });
                }, 0);
            }
        }
    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:ExchangeCtrl
 * @description
 * # ExchangeCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('ExchangeCtrl', ["$scope", "WalletsService", "$exceptionHandler", function ($scope, WalletsService, $exceptionHandler) {

        $scope.wallet_type = false;
        updateWalletType();

        function updateWalletType(){
            return WalletsService.getWallets().then(function() {
                var wallet = WalletsService.getActive();

                // Something went wrong, let's stop before it gets even worse
                if(!wallet) {
                    $exceptionHandler('wallet_not_found');
                    return;
                };

                $scope.wallet_type = wallet[0].type;
            }, function(error){
                $exceptionHandler(error);
            });
        }

        $scope.updateWalletType = updateWalletType;

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:ExchangeRippleCtrl
 * @description
 * # ExchangeRippleCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('ExchangeRippleCtrl', ["ENV", "$scope", "$rootScope", "$timeout", "$state", "WalletsService", "RippleNetwork", "RippleCharts", "$exceptionHandler", "RippleTx", "$filter", "coreSecurity", "FeatureService", function (ENV, $scope, $rootScope, $timeout, $state, WalletsService, RippleNetwork, RippleCharts, $exceptionHandler, RippleTx, $filter, coreSecurity, FeatureService) {

        $scope.state = $state;
        $scope.wallet = false;
        $scope.wallets = [];
        $scope.loading = true;
        $scope.mode = 'ready';
        $scope.fee = 0;

        $scope.counterFocus = false;
        $scope.baseFocus = false;

        var FIAT_PRECISION = 2;
        var CRYPTO_PRECISION = 6;
        var FIAT_PRECISION_DIVISOR = Math.pow(10, FIAT_PRECISION);
        var CRYPTO_PRECISION_DIVISOR = Math.pow(10, CRYPTO_PRECISION);
        $scope.FIAT_PRECISION = FIAT_PRECISION;
        $scope.CRYPTO_PRECISION = CRYPTO_PRECISION;

        var choices = [...ENV.exchangeChoices];
        FeatureService.isEnabledForUser({flag: 'FlareLaunch'}).then(function (isEnabled) {
            if (isEnabled) {
                const flrVault = _.find(ENV.vaults, {currency: 'FLR'});
                if (flrVault) {
                    choices.push(
                        {name: 'GateHub UAB', currency: 'FLR', issuer: flrVault.cold}
                    );
                }
            }
        });
        $scope.choices = choices;

        var wallet;
        var master_key;
        var address;

        var balanceUpdateListener;
        var offerUpdateListener;
        var walletChangeListener;

        var counter = ENV.defaultExchangeCounter;
        var base = ENV.defaultExchangeBase;

        $scope.base = base;
        $scope.counter = counter;
        $scope.balance = {
            base: 0,
            counter: 0,
            base_human: 0,
            counter_human: 0
        };

        $scope.lock = false;

        $scope.form = {};


        var walletsLoaded = false;


        // Start Wallet
        init();


        ///////////////////////////////////////////////////////////

        function init() {

            // Lock
            $scope.isUnlocked = coreSecurity.is2FaAuthorized();
            if (!$scope.isUnlocked) {
                var listener = $scope.$on('2fa_authorized', function() {
                    $scope.isUnlocked = true;
                    listener();
                });
            }

            getExchanges();
            resetForm();

            var removeWalletsLoadedListener1 = $scope.$on('walletsLoaded', function(){
                walletsLoaded = true;
                removeWalletsLoadedListener1();
            });

            // Wait until wallets are fully loaded
            WalletsService.getWallets().then(function(data) {
                loadWallet(data);
                $scope.$broadcast('walletsLoaded', true);

            }, function(error) {
                $scope.loading = false;
                $exceptionHandler(error);
                return;
            })

        };

        function loadWallet(data) {

            // Get active wallet
            wallet = WalletsService.getActive();

            // Something went wrong, let's stop before it gets even worse
            if(!wallet) {
                $exceptionHandler('wallet_not_found');
                return;
            };

            WalletsService.getHistory(wallet[0]);

            address = wallet[0].address;

            $scope.loading = false;
            $scope.wallet = wallet[0];
            $scope.wallets = data;

            updateBalance();

            // Update data on change
            balanceUpdateListener = $rootScope.$on('$balancesUpdate', function() {
                $timeout(function(){
                    $scope.wallet = wallet[0];
                    updateBalance();
                }, 0);
            });

            offerUpdateListener = $rootScope.$on('$offersUpdate', function() {
                $timeout(function(){
                    $scope.wallet = wallet[0];
                    updateBalance();
                }, 0);
            });

            // Lock check moved to init
        };

        function getExchanges() {

            $scope.loading = true;
            $scope.changeUnknown = true;
            $scope.price = '?';

            var _base = (base.currency != 'XRP') ? base.currency + '+' + base.issuer : 'XRP';
            var _counter = (counter.currency != 'XRP') ? counter.currency + '+' + counter.issuer : 'XRP';

            var params = {
                interval: '1day',
                limit: 1,
                descending: true,
            };


            RippleCharts.getExchanges(_base, _counter, params)
            .success(function(data) {
                $scope.loading = false;

                if(data.exchanges.length == 0) {
                    $scope.changeUnknown = true;
                    $scope.price = '?';
                    return;
                };

                var rate = parseFloat(data.exchanges[0].close);
                if (isNaN(rate) || rate === 0) {
                    $scope.changeUnknown = true;
                    $scope.price = '?';
                }
                else {
                    $scope.changeUnknown = false;
                    $scope.price = rate;
                }
                calculate();

            })
            .error(function(error) {
                $scope.loading = false;
                $scope.changeUnknown = true;
                $scope.price = '?';
                $exceptionHandler(error);
            });
        };

        function updateBalance() {

            wallet = WalletsService.getActive();

            // Reset
            $scope.balance.base = 0;
            $scope.balance.base_human = 0;
            $scope.balance.counter = 0;
            $scope.balance.counter_human = 0;

            if(typeof wallet[0] == 'undefined') {
                return;
            };

            // Base
            if (base.currency == 'XRP' && typeof wallet[0].xrp !== 'undefined') {
                var _xrp = (wallet[0].xrp - 50) * 1000000;
                _xrp = (_xrp > 0) ? _xrp : 0;
                $scope.balance.base = _xrp;
                $scope.balance.base_human = _xrp / 1000000;
            }
            else if (typeof wallet[0].lines !== 'undefined') {
                if(wallet[0].lines.hasOwnProperty(base.issuer+base.currency)) {
                    $scope.balance.base = wallet[0].lines[base.issuer+base.currency].balance;
                    $scope.balance.base_human = $filter('rpamount')(wallet[0].lines[base.issuer+base.currency].balance, { abs_precision: CRYPTO_PRECISION });
                }
            };

            // Counter
            if (counter.currency == 'XRP' && typeof wallet[0].xrp !== 'undefined') {
                var _xrp = (wallet[0].xrp - 50) * 1000000;
                _xrp = (_xrp > 0) ? _xrp : 0;
                $scope.balance.counter = _xrp;
                $scope.balance.counter_human = _xrp / 1000000;
            }
            else if (typeof wallet[0].lines !== 'undefined') {
                if(wallet[0].lines.hasOwnProperty(counter.issuer+counter.currency)) {
                    $scope.balance.counter = wallet[0].lines[counter.issuer+counter.currency].balance;
                    $scope.balance.counter_human = $filter('rpamount')(wallet[0].lines[counter.issuer+counter.currency].balance, { abs_precision: CRYPTO_PRECISION });
                }
            };

            // Update choices
            for (var i = choices.length - 1; i >= 0; i--) {
                if(choices[i].currency == 'XRP' && typeof wallet[0].xrp !== 'undefined') {
                    var _xrp = (wallet[0].xrp - 50) * 1000000;
                    _xrp = (_xrp > 0) ? _xrp : 0;
                    choices[i].balance = _xrp;
                }
                else if (typeof wallet[0].lines !== 'undefined') {
                    if(wallet[0].lines.hasOwnProperty(choices[i].issuer+choices[i].currency)) {
                        choices[i].balance = wallet[0].lines[choices[i].issuer+choices[i].currency].balance;
                    }
                };
            };

        };

        $scope.setMode = function (mode) {

            $scope.mode = mode;

        };

        walletChangeListener = $rootScope.$on('$walletChanged', function() {
            $timeout(function(){
                // calling parent here
                $scope.updateWalletType().then(function() {
                    if ($scope.wallet_type === 10 || $scope.wallet_type === 11) {
                        init();
                    }
                });
            }, 0);
        });

        $scope.changeBase = function (currency, issuer) {
            base = {
                currency: currency,
                issuer: issuer
            };

            $scope.base = base;

            getExchanges();
            updateBalance();

        };

        $scope.changeCounter = function (currency, issuer) {
            counter = {
                currency: currency,
                issuer: issuer
            };

            $scope.counter = counter;

            getExchanges();
            updateBalance();
        };

        $scope.flipMarket = function () {

            base = $scope.counter;
            counter = $scope.base;

            $scope.base = base;
            $scope.counter = counter;

            getExchanges();
            updateBalance();
            resetForm();

            // Fee
            if(counter.currency == 'XRP') {
                $scope.fee = 0;
            }
            else {
                $scope.fee = 0.2;
            }

        };

        function resetForm() {

            $scope.mode = 'ready';
            $scope.sending = false;
            $scope.exchange = {};
            $scope.lock = false;

            $scope.errorMessage = false;

            $timeout(function () {
                if(typeof $scope.form != 'undefined' && typeof $scope.form.exchange != 'undefined') {
                    $scope.form.exchange.$setPristine(true)
                };
            });

        };

        $scope.resetForm = function() {

            $scope.mode = 'ready';

        };

        function calculate() {

            var focused = $scope.lock;

            var price = $scope.price;

            if(focused == 'base') {
                var amount = $scope.exchange.amount_dest;

                if(counter.currency === 'USD' || counter.currency === 'EUR'){
                    var amount_counter = Math.ceil(amount * price * FIAT_PRECISION_DIVISOR * 1.05) / FIAT_PRECISION_DIVISOR;
                } else {
                    var amount_counter = Math.ceil(amount * price * CRYPTO_PRECISION_DIVISOR * 1.05) / CRYPTO_PRECISION_DIVISOR;
                }

                if(isNaN(amount_counter)) {
                    return;
                }
                else {
                    $scope.exchange.amount = amount_counter;
                }

            }
            else {
                var amount = $scope.exchange.amount;

                // todo: Check this price rounding
                if(base.currency === 'USD' || base.currency === 'EUR'){
                    var amount_counter = Math.floor(amount / price * FIAT_PRECISION_DIVISOR * 0.95) / FIAT_PRECISION_DIVISOR;
                } else {
                    var amount_counter = Math.floor(amount / price * CRYPTO_PRECISION_DIVISOR * 0.95) / CRYPTO_PRECISION_DIVISOR;
                }

                if(isNaN(amount_counter)) {
                    return;
                }
                else {
                    $scope.exchange.amount_dest = amount_counter;
                }
            }

            // Start interval update

            // Fee
            if(counter.currency == 'XRP') {
                $scope.fee = 0;
            }
            else {
                $scope.fee = 0.2;
            }

        };

        $scope.calculate = function (focused) {

            $scope.mode = 'ready';
            $scope.lock = focused;
            calculate();

        };

        $scope.spendAll = function () {

            $scope.lock = 'counter';
            if(counter.currency === 'USD' || counter.currency === 'EUR'){ // dirty hack, in GateHub 3.0 we'll be able to chose based on type (crpyto / fiat) and vault precision
                $scope.exchange.amount = Math.ceil( $scope.balance.counter.to_number() * FIAT_PRECISION_DIVISOR) / FIAT_PRECISION_DIVISOR;
            } else {
                $scope.exchange.amount = Math.ceil( parseFloat($scope.balance.counter_human) * CRYPTO_PRECISION_DIVISOR) / CRYPTO_PRECISION_DIVISOR;
            }

            calculate();

        };

        $scope.submitForm = function(isValid) {

            // Make sure the form is completely valid - should be!
            if (!isValid) {
                console.log('One or more required fields are invalid');
                return;
            }

            $scope.mode = 'sending';
            $scope.sending = true;

            var lock = $scope.lock;

            if(lock == 'counter') {
                // Gets is fixed
                // console.log('Counter - Spend exactly gets');
                var gets = parseFloat($scope.exchange.amount);
                var price = parseFloat($scope.price);
                var pays = (gets / price)*0.95;
            }
            else {
                // Pays is fixed
                // console.log('Base - Buy exactly pays')
                var pays = parseFloat($scope.exchange.amount_dest);
                var price = parseFloat($scope.price);
                var gets = (pays * price)*1.05;
            }

            if(isNaN(gets) || isNaN(pays) || isNaN(price)) {

                $scope.mode = 'error';
                $scope.errorMessage = 'Not available. Please try again';

                $timeout(function() {
                    resetForm();
                }, 3000);

                return;
            };

            // Calculate pay amount
            var TakerGets = 0;
            var TakerPays = 0;

            if (counter.currency != 'XRP') {
                TakerGets = gets + '/' + counter.currency + '/' + counter.issuer;
            }
            else {
                TakerGets = (parseFloat(gets) * 1000000).toFixed(0);
            }

            if (base.currency != 'XRP') {
                TakerPays = pays + '/' + base.currency + '/' + base.issuer;
            }
            else {
                TakerPays = (parseFloat(pays) * 1000000).toFixed(0);
            }

            // console.log('T Gets', TakerGets);
            // console.log('T Pays', TakerPays);

            // Submit TX
            var tx = RippleNetwork.remote.createTransaction('OfferCreate', {
                account: address,
                taker_pays: TakerPays,
                taker_gets: TakerGets
            });

            // Set Sell
            if(lock == 'counter') {
                tx.set_flags('Sell');
            };

            // FillOrKill
            tx.set_flags('FillOrKill');

            console.log(tx);


            tx.on('error', function (error) {
                $exceptionHandler(error);
                $scope.mode = 'error';
                $scope.errorMessage = error.engine_result_message;
                $scope.$apply();

                $timeout(function() {
                    resetForm();
                }, 2000)
            });
            tx.on('success', function (res) {
                // our old ripple-lib returns "metadata", subscribing to the ledger tx returns "meta". ffs
                var processedTxn = JsonRewriter.processTxn(res.tx_json, res.metadata || res.meta, address);

                if (typeof processedTxn.balance_changer != 'undefined' && processedTxn.balance_changer == true) {
                    $scope.mode = 'success';
                    $timeout(function() {
                        resetForm();
                    }, 2000)
                }
                else {
                    $scope.mode = 'error';
                    $scope.errorMessage = 'Selected amount could not be exchanged at the current rate. Please try again with lower amount.';

                    $timeout(function() {
                        resetForm();
                    }, 3000)
                }
                updateBalance();
                $scope.$apply();
            });

            RippleTx.submitTransaction(tx, $scope.wallet)
                .catch(function (error) {
                    if (error.status === 403 && error.data.message && error.data.message.toLowerCase() === '2fa required') {
                        $scope.isUnlocked = false;
                        var listener = $scope.$on('2fa_authorized', function() {
                            $scope.isUnlocked = true;
                            $scope.submitForm(isValid);
                            listener();
                        });
                    } else {
                        $exceptionHandler(error);
                        $scope.mode = 'error';
                        $scope.errorMessage = error;
                        $scope.$apply();
                        $timeout(function() {
                            resetForm();
                        }, 3000);
                    }
                });
        };

        $scope.focusExchangeInput = function(event) {
            event.stopPropagation();
            var el = event.target;
            if (el) {
                while (!el.querySelector('.input')) {
                    el = el.parentElement;
                }
                el.querySelector('.input').focus();
            }
        }

        $scope.getBalanceLine = function(line) {
            if ($scope.wallet && $scope.wallet.lines && $scope.wallet.lines[line.issuer + line.currency]) {
                return $scope.wallet.lines[line.issuer + line.currency].balance;
            }
        }

        // destroy listeners
        $scope.$on('$destroy', function() {
            if (walletChangeListener) {
                walletChangeListener();
            }
            if (balanceUpdateListener) {
                balanceUpdateListener();
            }
            if (offerUpdateListener) {
                offerUpdateListener();
            }
        });
    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:ExchangeHostedCtrl
 * @description
 * # ExchangeHostedCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('ExchangeHostedCtrl', ["ENV", "$scope", "$rootScope", "$timeout", "$state", "WalletsService", "CurrencyConverterRestangular", "CoreRestangular", "$exceptionHandler", "$filter", "VaultsService", "FeatureService", function (ENV, $scope, $rootScope, $timeout, $state, WalletsService, CurrencyConverterRestangular, CoreRestangular, $exceptionHandler, $filter, VaultsService, FeatureService) {

        $scope.state = $state;
        $scope.wallet = false;
        $scope.wallets = [];
        $scope.loading = true;
        $scope.mode = 'ready';
        $scope.fee = 0;

        $scope.counterFocus = false;
        $scope.baseFocus = false;

        var balanceUpdateListener;
        var offerUpdateListener;
        var walletChangeListener;

        var balancePromise = null;

        var FIAT_PRECISION = 2;
        var CRYPTO_PRECISION = 6;
        var FIAT_PRECISION_DIVISOR = Math.pow(10, FIAT_PRECISION);
        var CRYPTO_PRECISION_DIVISOR = Math.pow(10, CRYPTO_PRECISION);
        $scope.FIAT_PRECISION = FIAT_PRECISION;
        $scope.CRYPTO_PRECISION = CRYPTO_PRECISION;

        var rate_uuid;

        var choices = [...ENV.exchangeChoices].filter(choice => choice.currency !== 'XAU'); // right side dropdown choices
        FeatureService.isEnabledForUser({flag: 'FlareLaunch'}).then(function (isEnabled) {
            if (isEnabled) {
                const flrVault = _.find(ENV.vaults, {currency: 'FLR'});
                if (flrVault) {
                    choices.push(
                        { name: 'GateHub UAB', currency: 'FLR', issuer: flrVault.cold, vault_id: flrVault.vault_id }
                    );
                }
            }
        });

        // add vault_id to each currency choice
        for(var i = 0; i < choices.length; i++){
            var vault = _.find(ENV.vaults, function(v){
                return v.currency === choices[i].currency; // && (choices[i].name === v.gateway_name || choices[i].name === 'Ripple');
            });
            if(vault){
                choices[i].vault_id = vault.vault_id
            } else {
                console.log(choices[i].currency, "("+choices[i].name+") is missing its vault_id or currency codes don't match");
            }
        }

        $scope.choices = choices;

        /* VaultsService.getConnectedVaults().then(function(vaults) {
            console.log(vaults);
        }); */

        var wallet;

        var counter = {
            currency: choices[0].currency,
            issuer: choices[0].issuer,
            vault_id: choices[0].vault_id
        };
        var base = {
            currency: choices[1].currency,
            issuer: choices[1].issuer,
            vault_id: choices[1].vault_id
        };

        $scope.base = base;
        $scope.counter = counter;
        $scope.balance = {
            base: 0,
            counter: 0,
            base_human: 0,
            counter_human: 0
        };

        $scope.lock = false;

        $scope.form = {};


        // Start Wallet
        init();
        calculate(); // get rate for default selected pair (for amount == 1)

        ///////////////////////////////////////////////////////////

        function init() {

            resetForm();

            // Wait until wallets are fully loaded
            WalletsService.getWallets().then(function(data) {
                loadWallet(data);
                $scope.$broadcast('walletsLoaded', true);
                refreshPositiveBalances();
            }, function(error) {
                $scope.loading = false;
                $exceptionHandler(error);
                return;
            });

        };

        function refreshPositiveBalances() {
            if (!balancePromise) {
                if(wallet[0].type !== 24) { // non-PSD balances
                    balancePromise = CoreRestangular.one('wallets', wallet[0].address).one('balances').customPOST({}).then(function (data) {
                        var balances = data.plain();
                        $scope.positiveBalances = _.filter(balances, function(balance){
                            return parseFloat(balance.available) > 0 && balance.vault.asset_code !== 'XAU'; // left side dropdown choices
                        });
                    })
                    .catch($exceptionHandler)
                    .finally(function() { balancePromise = null; });
                } else { // PSD balances
                    balancePromise = VaultsService.getConnectedVaults().then(function (vaults) {
                        $scope.positiveBalances = vaults.map(v => {
                            return {
                                currency: v.asset_code,
                                account_name: v.cold_wallet ? v.cold_wallet.address : ''
                            }
                        });
                    })
                    .catch($exceptionHandler)
                    .finally(function() { balancePromise = null; });
                }
            }
        }

        $scope.hasGatehubVault = hasGatehubVault;
        function hasGatehubVault(currency) {
            var vault = VaultsService.getVaultByCurrency(currency);
            if(vault) {
                return true;
            }
            return false;
        }

        function loadWallet(data) {

            // Get active wallet
            wallet = WalletsService.getActive();

            // Something went wrong, let's stop before it gets even worse
            if(!wallet) {
                $exceptionHandler('wallet_not_found');
                return;
            };

            WalletsService.getHistory(wallet[0]);

            $scope.loading = false;
            $scope.wallet = wallet[0];
            $scope.wallets = data;

            counter = {
                currency: choices[0].currency,
                issuer: choices[0].issuer,
                vault_id: choices[0].vault_id
            };

            updateBalance();

            // Update data on change
            balanceUpdateListener = $rootScope.$on('$balancesUpdate', function() {
                $timeout(function(){
                    $scope.wallet = wallet[0];
                    updateBalance();
                }, 0);
            });

            offerUpdateListener = $rootScope.$on('$offersUpdate', function() {
                $timeout(function(){
                    $scope.wallet = wallet[0];
                    updateBalance();
                }, 0);
            });
        };

        function updateBalance() {
            wallet = WalletsService.getActive();

            // Reset
            $scope.balance.base = 0;
            $scope.balance.base_human = 0;
            $scope.balance.counter = 0;
            $scope.balance.counter_human = 0;

            if(typeof wallet[0] == 'undefined') {
                return;
            };

            refreshPositiveBalances();

            // Base
            if (typeof wallet[0].lines !== 'undefined') {
                if(wallet[0].lines.hasOwnProperty(base.issuer+base.currency) || wallet[0].lines.hasOwnProperty(base.currency)) {
                    $scope.balance.base = wallet[0].lines[base.issuer+base.currency].balance;
                    $scope.balance.base_human = wallet[0].lines[base.issuer+base.currency].display_balance;
                }
            };

            // Counter
            if (typeof wallet[0].lines !== 'undefined') {
                if(wallet[0].lines.hasOwnProperty(counter.issuer+counter.currency) || wallet[0].lines.hasOwnProperty(counter.currency)) {
                    $scope.balance.counter = wallet[0].lines[counter.issuer+counter.currency].balance;
                    $scope.balance.counter_human = wallet[0].lines[counter.issuer+counter.currency].display_balance;
                }
            };

            // Update choices
            for (var i = choices.length - 1; i >= 0; i--) {
                if (typeof wallet[0].lines !== 'undefined') {
                    if(wallet[0].lines.hasOwnProperty(choices[i].issuer+choices[i].currency)) {
                        choices[i].balance = wallet[0].lines[choices[i].issuer+choices[i].currency].balance;
                    }
                };
            };

        };

        $scope.setMode = function (mode) {
            $scope.mode = mode;
        };

        walletChangeListener = $rootScope.$on('$walletChanged', function() {
            $timeout(function(){
                // calling parent here
                $scope.updateWalletType().then(function() {
                    // refresh view on wallet type change
                    if ($scope.wallet_type === 0 || $scope.wallet_type === 24) {
                        init();
                    }
                });
            }, 0);
        });

        $scope.changeBase = function (currency, issuer, vault_id) {

            $scope.errorMessage = false;
            $scope.changeUnknown = true;

            // tmp dirty hack: add missing vault id for markets in the bottom screen
            if (vault_id === undefined){
              var choices = $scope.choices;
              for (var i = 0; i < choices.length; i++){
                if(currency == choices[i].currency && issuer == choices[i].issuer){
                  vault_id = choices[i].vault_id;
                }
              }
            }

            base = {
                currency: currency,
                issuer: issuer,
                vault_id: vault_id
            };
            $scope.base = base;
            updateBalance();

            calculate();
        };

        $scope.changeCounter = function (currency, issuer, vault_id) {

            $scope.errorMessage = false;
            $scope.changeUnknown = true;

            // tmp dirty hack: add missing vault id for markets in the bottom screen
            if (vault_id === undefined){
              var choices = $scope.choices;
              for (var i = 0; i < choices.length; i++){
                if (currency == choices[i].currency && issuer == choices[i].issuer){
                  vault_id = choices[i].vault_id;
                }
              }
            }

            counter = {
                currency: currency,
                issuer: issuer,
                vault_id: vault_id
            };

            $scope.counter = counter;

            updateBalance();

            calculate();

        };

        $scope.changePSDCounter = function (currency) {
            var vault = VaultsService.getVaultByCurrency(currency);
            if(vault) {
                counter = {
                    currency: currency,
                    issuer: vault.cold,
                    vault_id: vault.vault_id
                }
                $scope.counter = counter;
                updateBalance();
                calculate();
            } else {
                console.log('No data for selected counter');
            }
        }

        $scope.flipMarket = function () {

            $scope.errorMessage = false;
            $scope.changeUnknown = true;

            base = $scope.counter;
            counter = $scope.base;

            $scope.base = base;
            $scope.counter = counter;

            updateBalance();
            resetForm();
            calculate();
        };

        function resetForm() {

            $scope.mode = 'ready';
            $scope.sending = false;
            $scope.exchange = {};
            $scope.lock = false;

            $scope.errorMessage = false;
            $scope.err_code = false;

            $timeout(function () {
                if(typeof $scope.form != 'undefined' && typeof $scope.form.exchange != 'undefined') {
                    $scope.form.exchange.$setPristine(true)
                };
            });

        };

        $scope.resetForm = function() {
            $scope.mode = 'ready';
        };

        function calculate() {

            $scope.mode = 'ready';
            $scope.errorMessage = false;

            var focused = $scope.lock;

            var getRateParams = {
                sending_vault: counter.vault_id,
                receiving_vault:  base.vault_id,
            }

            if(focused == 'base') {
                getRateParams.amount = $scope.exchange.amount_dest;

                if(!getRateParams.amount){ // if no amount entered yet, just get price for 1 unit
                    getRateParams.amount = 1;
                    $scope.exchange.amount = null;
                    return CurrencyConverterRestangular.one('best').one('counter').get(getRateParams).then(function (data) {
                        $scope.err_code = false;
                        $scope.changeUnknown = false;
                        $scope.price = parseFloat(data.rate) || '?';
                    }, function(error) {
                        $exceptionHandler(error);
                        $scope.err_code = false;
                        $scope.changeUnknown = true;
                        $scope.price = '?';
                    });
                }

                CurrencyConverterRestangular.one('best').one('counter').get(getRateParams).then(function (data) {
                    $scope.err_code = false;
                    $scope.price = parseFloat(data.rate) || '?';
                    $scope.exchange.amount = parseFloat(data.amount) || '?';
                    rate_uuid = data.rate_uuid;
                    if($scope.price === '?' || $scope.exchange.amount === '?'){
                        $scope.changeUnknown = true;
                    } else {
                        if(counter.currency === 'USD' || counter.currency === 'EUR'){ // dirty hack, in GateHub 3.0 we'll be able to chose based on type (crpyto / fiat) and vault precision
                            $scope.exchange.amount = Math.ceil( $scope.exchange.amount * FIAT_PRECISION_DIVISOR) / FIAT_PRECISION_DIVISOR;
                        } else {
                            $scope.exchange.amount = Math.ceil( $scope.exchange.amount * CRYPTO_PRECISION_DIVISOR) / CRYPTO_PRECISION_DIVISOR;
                        }
                        $scope.changeUnknown = false;

                        if( $scope.exchange.amount > $filter('rpamount')($scope.balance.counter) ){
                            $scope.err_code = 'INSUFFICIENT_BALANCE';
                        }
                    }
                }, function(error) {
                    $scope.price = '?';
                    $scope.err_code = error.data.code;
                    if (error.data.code === 'VALUE_OUT_OF_BOUNDS') {
                      $scope.exchange.amount = null;
                      console.log('Convert value out of bounds');
                    } else {
                      console.log('Liquidity provider for pair does not exist:', base.currency,  '('+base.vault_id+')', counter.currency, '('+counter.vault_id+')');
                    }
                    $scope.changeUnknown = true;
                    return;
                });

            }
            else {
                getRateParams.amount = $scope.exchange.amount;

                if(!getRateParams.amount){
                    getRateParams.amount = 1;
                    $scope.exchange.amount_dest = null;
                    return CurrencyConverterRestangular.one('best').one('base').get(getRateParams).then(function (data) {
                        $scope.err_code = false;
                        $scope.changeUnknown = false;
                        $scope.price = 1 / parseFloat(data.rate) || '?';
                    }, function(error){
                        $scope.err_code = false;
                        $scope.changeUnknown = true;
                        $scope.price = '?';
                        $exceptionHandler(error);
                    });
                }

                CurrencyConverterRestangular.one('best').one('base').get(getRateParams).then(function (data) {
                    $scope.err_code = false;
                    $scope.price = 1 / parseFloat(data.rate) || '?';
                    $scope.exchange.amount_dest = parseFloat(data.amount) || '?';
                    rate_uuid = data.rate_uuid;
                    if($scope.price === '?' || $scope.exchange.amount_dest === '?'){
                        $scope.changeUnknown = true;
                    } else {
                        if(base.currency === 'USD' || base.currency === 'EUR'){ // dirty hack, in GateHub 3.0 we'll be able to chose based on type (crpyto / fiat) and vault precision
                            $scope.exchange.amount_dest = Math.floor( $scope.exchange.amount_dest * FIAT_PRECISION_DIVISOR) / FIAT_PRECISION_DIVISOR;
                        } else {
                            $scope.exchange.amount_dest = Math.floor( $scope.exchange.amount_dest * CRYPTO_PRECISION_DIVISOR) / CRYPTO_PRECISION_DIVISOR;
                        }
                        $scope.changeUnknown = false;

                        if( $scope.exchange.amount > $filter('rpamount')($scope.balance.counter) ){
                            $scope.err_code = 'INSUFFICIENT_BALANCE';
                        }
                    }
                }, function(error){
                    $scope.price = '?';
                    $scope.err_code = error.data.code;
                    if(error.data.code === 'VALUE_OUT_OF_BOUNDS'){
                      $scope.exchange.amount_dest = null;
                      console.log('Convert value out of bounds');
                    } else {
                      console.log('Liquidity provider for pair does not exist:', base.currency,  '('+base.vault_id+')', counter.currency, '('+counter.vault_id+')');
                    }
                    $scope.changeUnknown = true;
                    return;
                });

            }
            // Start interval update
        };

        $scope.calculate = function (focused) {

            $scope.mode = 'ready';
            $scope.lock = focused;
            calculate();

        };

        $scope.spendAll = function () {

            $scope.lock = 'counter';
            if(counter.currency === 'USD' || counter.currency === 'EUR'){ // dirty hack, in GateHub 3.0 we'll be able to chose based on type (crpyto / fiat) and vault precision
                $scope.exchange.amount = Math.ceil( parseFloat($scope.balance.counter_human) * FIAT_PRECISION_DIVISOR) / FIAT_PRECISION_DIVISOR;
            } else {
                $scope.exchange.amount = Math.ceil( parseFloat($scope.balance.counter_human) * CRYPTO_PRECISION_DIVISOR) / CRYPTO_PRECISION_DIVISOR;
            }

            calculate();

        };

        $scope.submitForm = function(isValid) {

            // Make sure the form is completely valid - should be!
            if (!isValid) {
                console.log('One or more required fields are invalid');
                return;
            }

            $scope.sending = true;
            $scope.mode = 'sending';

            // wallet logic: left=counter, right=base ... converter logic: left=convert by base, right=convert by counter ... therefore, switch! yes, it's ugly and should be rewritten sometime.
            var doConversionBy = ($scope.lock == 'base') ? 'counter' : 'base';

            var params = {
                sending_wallet: $scope.wallet.address,
                receiving_wallet: $scope.wallet.address,
                amount: ($scope.lock == 'base') ? $scope.exchange.amount_dest : $scope.exchange.amount,
                rate: rate_uuid // if it fails, I get an expired error (rate invalid or expired)
            }

            CurrencyConverterRestangular.one('convert').post(doConversionBy, params).then(function(data) {

                console.log('conversion successful:', data);

                $scope.sending = false;
                $scope.mode = 'success';

                // Refresh Wallet
                WalletsService.refreshWallet($scope.wallet);

                $timeout(function() {
                    refreshPositiveBalances();
                    resetForm();
                }, 2000);

            }, function(error) {
                $timeout(function() {
                    $scope.sending = false;
                    $scope.mode = 'error';
                    // Display error message
                    $scope.errorMessage = error.data.message ? error.data.message : "An error occurred trying to convert specified amount.";
                    if(error.data.message == 'RATE_INVALID_OR_EXPIRED'){
                        $scope.errorMessage = 'Rate expired (you have 60 seconds to confirm exchange). Please try again.';
                    }
                    $exceptionHandler(error);
                }, 0);
                // RATE_INVALID_OR_EXPIRED
            });

        };

        $scope.focusExchangeInput = function(event) {
            event.stopPropagation();
            var el = event.target;
            if (el) {
                while (!el.querySelector('.input')) {
                    el = el.parentElement;
                }
                el.querySelector('.input').focus();
            }
        }


        // destroy listeners
        $scope.$on('$destroy', function() {
            if (walletChangeListener) {
                walletChangeListener();
            }
            if (balanceUpdateListener) {
                balanceUpdateListener();
            }
            if (offerUpdateListener) {
                offerUpdateListener();
            }
        });
    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:RatesCtrl
 * @description
 * # RatesCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('RatesCtrl', ["MarketsService", "UserPreferencesService", "$uibModal", "NonstandardCurrencies", function (MarketsService, UserPreferencesService, $uibModal, NonstandardCurrencies) {

        var vm = this;

        vm.loading = true;
        vm.ratePairList = [];
        vm.selectedPair = null;

        // vm functions
        vm.selectPair = selectPair;
        vm.openAddPairModal = openAddPairModal;
        vm.removePair = removePair;

        UserPreferencesService.getUserPreferences().then(function(config) {
            if (!_.isEmpty(config.customRatePairs)) {
                vm.ratePairList = config.customRatePairs.map(function(pair) {
                    var baseCounter = pair.split('/');
                    return { base: baseCounter[0], counter: baseCounter[1] };
                });
            }
            else {
                vm.ratePairList = MarketsService.getDefaultRatePairs();
            }

            vm.selectedPair = vm.ratePairList[0];
        }, function(error) {
            vm.ratePairList = MarketsService.getDefaultRatePairs();
        }).finally(function() {
            vm.loading = false;
        });


        function selectPair(pair) {
            vm.selectedPair = pair;
        }

        function openAddPairModal() {
            $uibModal.open({
                templateUrl: 'views/exchange/modal_add_rate_pair.html',
                controller: 'RatePairAddCtrl',
                controllerAs: 'vm'
            }).result.then(function(response) {
                var existingPair = vm.ratePairList.find(function(ratePair) {
                    return ratePair.base === response.base && ratePair.counter === response.counter;
                });

                if (existingPair) {
                    selectPair(existingPair);
                    return;
                }

                vm.ratePairList.push(response);
                // concat to trigger change detection
                vm.ratePairList = vm.ratePairList.concat();

                selectPair(response);

                var formattedPairs = vm.ratePairList.map(function(pair) {
                    return NonstandardCurrencies.encodeAssetCode(pair.base) + '/' + NonstandardCurrencies.encodeAssetCode(pair.counter);
                });
                UserPreferencesService.updateUserPreferences('customRatePairs', formattedPairs)
                    .then(function() { })
                    .catch(function() { });
            });
        }

        function removePair(pair) {
            _.remove(vm.ratePairList, function(element) {
                return element.base === pair.base && element.counter === pair.counter;
            });
            vm.ratePairList = vm.ratePairList.concat();

            var formattedPairs = vm.ratePairList.map(function(pair) {
                return pair.base + '/' + pair.counter;
            });
            UserPreferencesService.updateUserPreferences('customRatePairs', formattedPairs)
                .then(function() { })
                .catch(function() { });

            if (vm.ratePairList.length > 0) {
                selectPair(vm.ratePairList[0]);
            }
            else {
                selectPair(null);
            }
        }


    }]);


'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:RatePairAddCtrl
 * @description
 * # RatePairAddCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('RatePairAddCtrl', ["ENV", "$scope", "RatesRestangular", "FeatureService", "NonstandardCurrencies", function (ENV, $scope, RatesRestangular, FeatureService, NonstandardCurrencies) {
        var vm = this;

        var choices = [...ENV.exchangeChoices];

        FeatureService.isEnabledForUser({ flag: 'FlareLaunch' }).then(function (isEnabled) {
            if (isEnabled) {
                const flrVault = _.find(ENV.vaults, {currency: 'FLR'});
                if (flrVault) {
                    choices.push(
                        {name: 'GateHub UAB', currency: 'FLR', issuer: flrVault.cold}
                    );
                }
            }
        });

        vm.currencyList = choices;

        vm.baseIndex = -1;
        vm.counterIndex = -1;

        vm.exchangeRate = '--';

        vm.setBase = setBase;
        vm.setCounter = setCounter;
        vm.flipPairs = flipPairs;
        vm.submitForm = submitForm;
        vm.close = close;

        function setBase(index) {
            vm.baseIndex = index;
            getExchangeRate();
        }
        function setCounter(index) {
            vm.counterIndex = index;
            getExchangeRate();
        }
        function flipPairs() {
            var temp = vm.baseIndex;
            vm.baseIndex = vm.counterIndex;
            vm.counterIndex = temp;
            if (vm.exchangeRate) {
                vm.exchangeRate = 1 / vm.exchangeRate;
            }
        }

        function getExchangeRate() {
            vm.exchangeRate = '--';
            if (vm.counterIndex === -1 || vm.baseIndex === -1) {
                return;
            }

            var counter = vm.currencyList[vm.counterIndex].currency;
            var base = vm.currencyList[vm.baseIndex].currency;

            // DSH -> DASH hack
            counter = NonstandardCurrencies.parseAssetCode(counter.replace('DSH', 'DASH'));
            base = NonstandardCurrencies.parseAssetCode(base.replace('DSH', 'DASH'));

            if (vm.baseIndex !== -1 && vm.counterIndex !== -1) {
                RatesRestangular
                    .one('rates')
                    .one(counter)
                    .one(base)
                    .get()
                    .then(function(data) {
                        var rate = 1 / +data[counter].rate;
                        // var decimalPlaces = data[vm.currencyList[vm.counterIndex].currency].type === 'crypto' ? 8 : 2;
                        vm.exchangeRate = rate;
                    });
            }
            else {
                vm.exchangeRate = '--';
            }
        }

        function submitForm() {
            if (vm.baseIndex === vm.counterIndex) {
                vm.error = "Select different currencies.";
                return;
            }

            var ratePair = {
                base: vm.currencyList[vm.baseIndex].currency,
                counter: vm.currencyList[vm.counterIndex].currency
            };

            $scope.$close(ratePair);
        }

        function close() {
            $scope.$dismiss();
        }
    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:HistoryCtrl
 * @description
 * # HistoryCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('HistoryCtrl', ["$scope", "Auth", "CoreRestangular", "$exceptionHandler", function ($scope, Auth, CoreRestangular, $exceptionHandler) {

        $scope.loading = true;
        $scope.history = [];
        
        init();

        ///////////////////////////////////////////////////////////

        function init() {
            
            Auth.getProfile().then(function(data) {

                // Core
                CoreRestangular.one('users', data.uid).all('logs').getList().then(function(data) {

                    $scope.history = data.plain();
                    $scope.loading = false;

                }, function(error) {

                    $exceptionHandler(error);
                    $scope.loading = false;

                });
                
            });

        };

    }]);
'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:DevicesCtrl
 * @description
 * # DevicesCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('DevicesCtrl', ["$scope", "Auth", "Restangular", "$exceptionHandler", function ($scope, Auth, Restangular, $exceptionHandler) {

        $scope.devices = [];
        $scope.loading = true;

        init();

        ///////////////////////////////////////////////////////////

        function init() {

            Auth.getProfile().then(function(data) {

                // Auth
                Restangular.one('user').all('devices').getList().then(function(data) {

                    $scope.devices = data.plain();
                    $scope.loading = false;

                }, function(error) {

                    $exceptionHandler(error);
                    $scope.loading = false;

                });

            }, function(error){
                $exceptionHandler(error);
            });

        };

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:EventCtrl
 * @description
 * # EventCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('EventCtrl', ["$scope", "Auth", "AuthRestangular", "$exceptionHandler", function ($scope, Auth, AuthRestangular, $exceptionHandler) {

        $scope.loading = true;

        init();

        ///////////////////////////////////////////////////////////

        function init() {
            
            Auth.getProfile().then(function(data) {

                // Core
                AuthRestangular.all('user/audit/search').post({ "sortDirection": "desc" })
                .then(function(data) {
                    $scope.events = data;
                    $scope.loading = false;

                }, function(error) {
                    $exceptionHandler(error);
                    $scope.loading = false;

                });
                
            });

        };

    }]);
'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:DeviceRemoveCtrl
 * @description
 * # DeviceRemoveCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('DeviceRemoveCtrl', ["$scope", "$stateParams", "Auth", "Restangular", "$timeout", "$exceptionHandler", function ($scope, $stateParams, Auth, Restangular, $timeout, $exceptionHandler) {

        $scope.loading = true;
        var id = $stateParams.id;

        init();

        ///////////////////////////////////////////////////////////

        function init() {

            Auth.getProfile().then(function(data) {

                // Restangular
                Restangular.one('user').all('devices').getList().then(function(data) {

                    var devices = data.plain();
                    var device = _.find(devices, {id: id});

                    if(typeof device != 'undefined') {
                        $scope.device = device;
                        $scope.loading = false;
                    }
                    else {
                        $scope.$dismiss();
                    };


                }, function(error) {

                    $exceptionHandler(error);
                    $scope.loading = false;

                });

            });

        };

        $scope.submitForm = function(isValid) {

            $scope.errorMessage = false;
            $scope.sending = true;
            $scope.mode = 'sending';

            Restangular.one('user', 'devices').one(id).remove().then(function(data) {

                $scope.sending = false;
                $scope.mode = 'success';

                $timeout(function() {
                    $scope.$dismiss();
                }, 1000);

            }, function(error) {
                $exceptionHandler(error);
                $scope.sending = false;
                $scope.mode = 'error';
                $scope.errorMessage = error.data.message;

            });

        };

        $scope.cancel = function() {
            console.log('Close');
            $scope.$dismiss();
        };

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:Security2fa
 * @description
 * # Security2fa
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('Security2fa', ["$scope", "$state", "Auth", "Restangular", "coreSecurity", "$timeout", "$exceptionHandler", function ($scope, $state, Auth, Restangular, coreSecurity, $timeout, $exceptionHandler) {

        // Init
        resetForm();

        $scope.loading = true;

        Restangular.one('user').get().then(function(data){
            $scope.secret_key = coreSecurity.generate2faKey();
            $scope.qrcode = 'otpauth://totp/GateHub:'+encodeURIComponent(data.email)+'?secret='+encodeURIComponent($scope.secret_key)+'&issuer=GateHub&digits=6';

            if(data.type2fa === 'totp') {
                $scope.enabled = true;
            }
            else {
                $scope.enabled = false;
            }
            $scope.loading = false;
        });

        ///////////////////////////////////////////////////////////

        function resetForm() {

            $scope.errorMessage = false;
            $scope.mode = false,

            $scope.send = {};

        };

        $scope.submitEnable = function(isValid, key) {

            $scope.errorMessage = false;
            $scope.success_message = false;

            if (!isValid) {
                $scope.errorMessage = "One or more required fields are invalid";
                return;
            }

            $scope.mode = 'sending';

            var secret = $scope.secret_key;

            Restangular.one('user', 'secret2fa')
              .customPOST({
                token2fa: key,
                secret2fa: secret
              }).then(function(data) {

                $scope.mode = 'success';
                $scope.enabled = true;
                $scope.success_message = '2-Factor authentication is now enabled.';

                Auth.getProfile(true);

                $timeout(function(){
                    $state.go('wallets');
                }, 2000);

            }, function(error) {

                handleError(error);

                $timeout(function(){
                    resetForm();
                }, 3000);
            });

        };

        $scope.submitDisable = function(isValid, key) {

            $scope.errorMessage = false;
            $scope.success_message = false;

            if (!isValid) {
                $scope.errorMessage = "One or more required fields are invalid";
                return;
            }

            $scope.mode = 'sending';

            Restangular.one('user', 'secret2fa').remove({ token2fa: key })
            .then(function(data) {
                $scope.mode = 'success';
                $scope.enabled = false;
                $scope.success_message = '2-Factor authentication has been disabled.';

                Auth.getProfile(true);

            }, handleError)
            .finally(function() {
                $timeout(function(){
                    $state.go('security.twostep', {}, { reload: true });
                }, 2000);
            });

        };

        function handleError(error) {
            $scope.mode = 'error';

            if(error && error.data){
                if (error.data.error === '2fa_wrong_token') {
                    $scope.errorMessage = "Provided verification code is not valid.";
                } else if (error.data.error === '2fa_expired_token') {
                    $scope.errorMessage = "Provided verification code has expired.";
                } else {
                    $scope.errorMessage = "Something went wrong.";
                    $exceptionHandler(error);
                }
            } else {
                $exceptionHandler("OTHER_2FA_ERROR", error);
            }

            Auth.getProfile(true);
        };

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:SecurityRekey
 * @description
 * # SecurityRekey
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('RekeyCtrl', ["$scope", "$q", "Auth", "CoreRestangular", "coreSecurity", "RippleNetwork", "instantMemory", "$timeout", "WalletsService", "$state", "$exceptionHandler", "RippleTx", "Restangular", function ($scope, $q, Auth, CoreRestangular, coreSecurity, RippleNetwork, instantMemory, $timeout, WalletsService, $state, $exceptionHandler, RippleTx, Restangular) {

        $scope.loading = true;
        $scope.migrationRequired = false;
        $scope.migrationRequiredWithRegular = false;
        $scope.wallets = {};
        $scope.master = {};

        $scope.status = 'Updating';

        var authUser;
        var wallets;
        var started = false;

        $scope.errorMessage = false;
        $scope.mode = 'sending';

        Auth.getProfile(true).then(function (data) {

            authUser = data;

            $scope.type2fa = data.type2fa;

            // should not happen now, because we require 2FA before rekey now, but it's here for future-proofing, in case the flows get changed again
            if ($scope.type2fa === 'none') {
                $scope.errorMessage = "No 2FA options enabled to unlock secret keys.";
                $scope.mode = 'error';
                $scope.loading = false;
                return;
            }

            if (data.migration_status != 'completed') {
                $scope.loading = false;
                return;
            }

            // Check if password change is also required
            if (typeof data.lastPasswordChange == 'undefined') {
                $scope.passwordChangeRequired = true;
            }
            else {
                $scope.passwordChangeRequired = false;
            }

            CoreRestangular.one('users', data.uid).get().then(function(data) {

                _.remove(data.wallets, function (wallet) {
                    return wallet.type != 10 && wallet.type != 11; // ripple wallets only
                });

                $scope.wallets = data.wallets;
                wallets = data.wallets;

                var _wallets = angular.copy(data.wallets);

                for (var i = _wallets.length - 1; i >= 0; i--) {
                    if (_wallets[i].migration_status == 2 || _wallets[i].migration_status == 3) {
                        $scope.migrationRequiredWithRegular = true;
                    }
                }

                for (var i = _wallets.length - 1; i >= 0; i--) {
                    if (_wallets[i].migration_status == 1 || _wallets[i].migration_status == 2 || _wallets[i].migration_status == 3) {
                        $scope.migrationRequired = true;
                        $scope.loading = false;
                        return;
                    }
                }

                $scope.loading = false;

            })
            .catch(function(err) {
                $exceptionHandler(err);
            });

        })
        .catch(function(err) {
            $exceptionHandler(err);
        });

        function startProcess() {
            if (started == true) return;
            if ($scope.migrationRequired == false) return;
            started = true;

            console.log('Unlocked');

            // Set Master Key status
            $scope.master.status = 1;
            $scope.master.text = 'Completed';

            var chain = $q.when();

            for (var i = 0; i < wallets.length; i++) {
                (function(i) {
                    chain = chain.then(function() {
                        return RippleTx.getSecrets(wallets[i]).then(function(secrets) {
                            return process_wallet(i, secrets);
                        }, function(error) {
                            set_status('Error', 3, i);
                        });
                    });
                })(i);
            }

            chain.then(function(res) {
                console.log('res', res);

                WalletsService.getWallets(true).then(function() {
                    $scope.mode = 'success';
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                },function() {
                    $scope.mode = 'success';
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                })

            }, function(error) {
                console.log('error', error);
                $scope.errorMessage = error;
                $scope.mode = 'error';
                document.body.scrollTop = document.documentElement.scrollTop = 0;
            })

        };

        // Check if Master Key valid (Account info)
        // Generate Regular Key
        // Submit Set Regular Key Transaction
        // Submit Account Set Transaction
        // Save to Core

        function process_wallet(i, wallet_i_secrets) {

            var deferred = $q.defer();

            set_status('Processing', 1, i);

            var address = wallets[i].address;
            var migration_status = wallets[i].migration_status;

            if (migration_status >= 100) {

                set_status('Completed', 2, i);
                deferred.resolve();

            }
            else if (migration_status === 0 || wallet_i_secrets.secret === null) {
                // Migration is not required or we don't have secret key (watch only wallets), mark as completed and skip
                set_status('Completed', 2, i);

                deferred.resolve();
            }
            else {

                var base_security = ($scope.isUnlocked) ? instantMemory.getValue('base_security') : null;
                var master_key = ($scope.isUnlocked) ? base_security.master_key : null;
                var master_key_old = ($scope.isUnlocked) ? base_security.master_key_old : null;

                // Decrypt secret with old master key
                var secret_encrypted = wallet_i_secrets.secret;

                var secret = coreSecurity.AESDecrypt(secret_encrypted, master_key_old, wallets[i].version);

                // Encrypt secret with new master key
                var secret_encrypted_new = coreSecurity.AESEncrypt(secret, master_key);

                // Decrypt secret with new master key
                var secret_decrypted_new = coreSecurity.AESDecrypt(secret_encrypted_new, master_key, 2);

                // console.log(i, address, secret, secret_decrypted_new, wallets[i].version);

                // Compose payload for potential error
                var errorContext = {
                    migrationStatus: migration_status,
                    masterKey: !!master_key,
                    masterKeyOld: !!master_key_old,
                    secretEncrypt: !!secret_encrypted,
                    secret: !!secret,
                    secretNewEncrypt: !!secret_encrypted_new,
                    secretNewDecrypt: !!secret_decrypted_new,
                };
                // Check encryption
                if (secret !== secret_decrypted_new) {

                    set_status('Error', 3, i);

                    $exceptionHandler('[Rekey] Secret Mismatch', errorContext);

                    deferred.reject('error_secret_mismatch');
                }
                else if (secret == null && migration_status != 3) {
                    set_status('Error', 3, i);

                    $exceptionHandler('[Rekey] Decryption Failed', errorContext);

                    deferred.reject('error_secret_decrypt');
                }
                else {

                    if (migration_status == 1) {  // Secret re-crypt with new master required
                        save_master_wallet(address, secret_encrypted, secret_encrypted_new, 100, i).then(function(res) {
                            set_status('Completed', 2, i);
                            deferred.resolve();
                        }, function(error) {
                            set_status('Error', 3, i);
                            // Error handled in function
                            deferred.reject(error);
                        });

                    }
                    else if (migration_status == 2) { // Secret re-crypt with new master required + regular key

                        // Get Account Info
                        account_info(address, i).then(function(res) {

                            set_status('Updating', 1, i);

                            // Generate new regular wallet
                            var regular = ripple.Wallet.generate();
                            var address_regular = regular.address;
                            var secret_regular = regular.secret;

                            // Test Secret
                            try {
                                !ripple.Seed.from_json(secret_regular).get_key(address_regular);
                            }
                            catch (error) {
                                set_status('Error', 3, i);
                                $exceptionHandler('[Rekey] Regular key generation error', error);

                                deferred.reject('regular_key_generate_error');
                            }

                            // Encrypt regular secret
                            var secret_regular_encrypted = coreSecurity.AESEncrypt(secret_regular, master_key);
                            var secret_regular_decrypted = coreSecurity.AESDecrypt(secret_regular_encrypted, master_key, 2);

                            // console.log(address, secret, address_regular, secret_regular)

                            // Check encryption
                            if (secret_regular !== secret_regular_decrypted) {
                                set_status('Error', 3, i);

                                var errorContext = {
                                    masterKey: !!master_key,
                                    regularKeyEncrypted: !!secret_regular_encrypted,
                                    regularKeyDecrypt: !!secret_regular_decrypted
                                }
                                $exceptionHandler('[Rekey] Regular kex secret mismatch', errorContext);

                                deferred.reject('error_regular_secret_mismatch');
                            }
                            else {

                                // Set Regular Key
                                set_regular_key(address, address_regular, secret).then(function(res) {

                                    // Test Regular Key
                                    account_set_regular_test(address, secret_regular).then(function(res) {

                                        // Save Regular Wallet
                                        save_regular_wallet(address, secret_encrypted, secret_encrypted_new, address_regular, secret_regular_encrypted, i).then(function(res) {

                                            disable_master(address, i).then(function(res) {
                                                set_status('Completed', 2, i);
                                                deferred.resolve();
                                            }, function(error) {
                                                set_status('Error', 3, i);
                                                // Error handled in function
                                                deferred.reject(error);
                                            });

                                        }, function(error) {
                                            set_status('Error', 3, i);
                                            // Error handled in function
                                            deferred.reject(error);
                                        });

                                    }, function(error) {
                                        set_status('Error', 3, i);
                                        // Error handled in function
                                        deferred.reject(error);
                                    });

                                }, function(error) {
                                    set_status('Error', 3, i);
                                    // Error handled in function
                                    deferred.reject(error);
                                });

                            };

                        }, function(error) {

                            var status = 200;

                            if (error == 'account_not_found') {
                                status = 201;
                            }
                            else if (error == 'error_master_disabled') {
                                status = 202;
                            };

                            if (status != 200) {
                                save_master_wallet(address, secret_encrypted, secret_encrypted_new, status, i).then(function(res) {
                                    set_status('Completed', 2, i);
                                    deferred.resolve();
                                }, function(error) {
                                    set_status('Error', 3, i);
                                    // Error handled in function
                                    deferred.reject(error);
                                });
                            }
                            else {
                                set_status('Error', 3, i);
                                // Error handled in function
                                deferred.reject(error);
                            };

                        });

                    }
                    else if (migration_status == 3) { // Regular key set, master key disable required

                        // Check account info
                        // Check if master disabled
                        account_info(address, i).then(function(res) {

                            // Master key is not disabled, try to disable it
                            disable_master(address, i).then(function(res) {
                                set_status('Completed', 2, i);
                                deferred.resolve();
                            }, function(error) {
                                set_status('Error', 3, i);
                                // Error handled in function
                                deferred.reject(error);
                            });

                        }, function(error) {

                            // If master is already disabled test regular key and update
                            if (error == 'error_master_disabled') {

                                // Test regular
                                var secret_regular = coreSecurity.AESDecrypt(wallet_i_secrets.regular_secret, master_key, 2);

                                // Test Regular Key
                                account_set_regular_test(address, secret_regular).then(function(res) {

                                    // Save Regular Wallet
                                    update_regular_wallet(address).then(function(res) {
                                        set_status('Completed', 2, i);
                                        deferred.resolve();
                                    }, function(error) {
                                        // Error handled in function
                                        deferred.reject(error);
                                    });

                                }, function(error) {
                                    set_status('Error', 3, i);
                                    // Error handled in function
                                    deferred.reject(error);
                                });

                            }
                            else {
                                set_status('Error', 3, i);
                                $exceptionHandler('[Rekey] Account info', error);
                                deferred.reject(error);
                            };

                        });

                    }
                    else if (migration_status >= 200) { // Completed with error

                        set_status('Error - ' + migration_status, 3, i);
                        deferred.resolve();

                    }
                    else { // Status 0 or undefined, migration not required

                        set_status('Completed', 2, i);
                        deferred.resolve();

                    };

                };

            };

            return deferred.promise;

        };

        function set_status(text, status, i) {

            $timeout(function() {
                wallets[i].status_text = text;
                wallets[i].status = status;
            }, 0);

        };

        function disable_master(address, i) {

            console.log('Disable master');

            var deferred = $q.defer();

            // Get wallet and its secrets from core
            $q.all([
                get_wallet(address),
                RippleTx.getSecrets(wallets[i])
            ]).then(function(results) {

                // merge wallet and its secrets for the needs of existing code:
                var res = Object.assign({}, results[0], results[1]);

                var base_security = ($scope.isUnlocked) ? instantMemory.getValue('base_security') : null;
                var master_key = ($scope.isUnlocked) ? base_security.master_key : null;

                // Decrypt secret with new master key
                var secret_encrypted = res.secret;
                var secret = coreSecurity.AESDecrypt(secret_encrypted, master_key, 2);

                // Decrypt regular secret with new master key
                var secret_regular_encrypted = res.regular_secret;
                var secret_regular = coreSecurity.AESDecrypt(secret_regular_encrypted, master_key, 2);

                // Test Regular Key
                account_set_regular_test(address, secret_regular).then(function(res) {

                    console.log('Reg test success');

                    // Disable Master Key
                    account_set_disable_master(address, secret).then(function(res) {

                        // Update Regular Wallet
                        update_regular_wallet(address).then(function(res) {
                            deferred.resolve();
                        }, function(error) {
                            // Error handled in function
                            deferred.reject(error);
                        });

                    }, function(error) {
                        // Error handled in function
                        deferred.reject(error);
                    });

                }, function(error) {
                    // Error handled in function
                    deferred.reject(error);
                });

            }, function(error) {
                // Error handled in function
                deferred.reject(error);
            });

            return deferred.promise;

        };

        function get_wallet(address) {

            var deferred = $q.defer();

            // Get History
            CoreRestangular.one('users', authUser.id).one('wallets', address).get().then(function(data) {
                deferred.resolve(data.plain());
            }, function(error) {
                $exceptionHandler('[Rekey] Get wallet history', error);
                deferred.reject(error);
            });

            return deferred.promise;

        };

        function account_info(address, i) {

            var deferred = $q.defer();

            RippleNetwork.remote.requestAccountInfo({account:address})
                .on('success', function onSuccess(res) {

                    if ((res.account_data.Flags & 0x00100000) === 0) {
                        console.log('Master Enabled');
                        deferred.resolve();
                    }
                    else {
                        console.log('Master Disabled');
                        $exceptionHandler('[Rekey] Master disabled');
                        deferred.reject('error_master_disabled');
                    }

                })
                .on('error', function onError(error) {
                    if (err.remote.error == 'actNotFound') {
                        $exceptionHandler('[Rekey] Account not found', error);
                        deferred.reject('account_not_found');
                    }
                    else {
                        $exceptionHandler('[Rekey] Ripple network error', error);
                        deferred.reject('error_ripple_network');
                    }
                })
                .request();

            return deferred.promise;

        };

        function set_regular_key(address, address_regular, secret) {

            var deferred = $q.defer();

            // Set Regular Key Transaction
            var tx = RippleNetwork.remote.transaction()
                .set_regular_key(address, address_regular)
                .on('success', function (res) {
                    deferred.resolve();
                })
                .on('error', function (error) {
                    $exceptionHandler('[Rekey] Set regular key error', error);
                    deferred.reject('set_regular_key');
                });

            RippleTx.submitTxNormally(tx, secret)
                .catch(function (error) {
                    console.log(error);
                    deferred.reject('set_regular_key');
                });
            return deferred.promise;

        };

        function account_set_regular_test(address, secret_regular) {

            var deferred = $q.defer();

            var tx = RippleNetwork.remote.transaction()
                .account_set(address)
                .on('success', function (res) {
                    deferred.resolve();
                })
                .on('error', function (error) {
                    $exceptionHandler('[Rekey] Account set regular key', error);
                    deferred.reject('account_set_regular_test');
                });

            RippleTx.submitTxNormally(tx, secret_regular)
                .catch(function (error) {
                    console.log(error);
                    $exceptionHandler('[Rekey] Account set regular key', error);
                    deferred.reject('account_set_regular_test');
                });

            return deferred.promise;

        };

        function account_set_disable_master(address, secret) {

            var deferred = $q.defer();

            // Set Regular Key Transaction
            var tx = RippleNetwork.remote.transaction()
                .account_set(address)
                .setSetFlag(4)
                .on('success', function (res) {
                    console.log(res);
                    deferred.resolve();
                })
                .on('error', function (error) {
                    $exceptionHandler('[Rekey] Account disable master', error);
                    deferred.reject('account_set_disable_master');
                });

            RippleTx.submitTxNormally(tx, secret)
                .catch(function (error) {
                    $exceptionHandler('[Rekey] Account disable master', error);
                    deferred.reject('account_set_disable_master');
                });

            return deferred.promise;

        };

        function save_master_wallet(address, secret_encrypted, secret_encrypted_new, status, i) {

            var deferred = $q.defer();

            var Wallet = CoreRestangular.one('users', authUser.uid).one('wallets', address);

            var postData = {
                secret: secret_encrypted_new,
                secret_old: secret_encrypted,
                migration_status: status,
                version: 2
            };

            Wallet.customPUT(postData).then(function(data) {
                deferred.resolve();
            }, function(error) {
                $exceptionHandler('[Rekey] Save master error', error);
                deferred.reject('save_master_error');
            });

            return deferred.promise;

        };

        function update_regular_wallet(address) {

            var deferred = $q.defer();

            var Wallet = CoreRestangular.one('users', authUser.uid).one('wallets', address); // IVAN-CHECK: Endpoint for GET secrets changed. Just to be sure: does the PUT endpoint for wallet's secrets stay the same?

            var postData = {
                migration_status: 101
            };

            Wallet.customPUT(postData).then(function(data) {
                deferred.resolve();
            }, function(error) {
                $exceptionHandler('[Rekey] Save master error', error);
                deferred.reject('save_master_error');
            });

            return deferred.promise;

        };

        function save_regular_wallet(address, secret_encrypted, secret_encrypted_new, address_regular, secret_regular_encrypted, i) {

            var deferred = $q.defer();

            var Wallet = CoreRestangular.one('users', authUser.uid).one('wallets', address); // IVAN-CHECK: Endpoint for GET secrets changed. Just to be sure: does the PUT endpoint for wallet's secrets stay the same?

            var postData = {
                secret: secret_encrypted_new,
                secret_old: secret_encrypted,
                regular_address: address_regular,
                regular_secret: secret_regular_encrypted,
                migration_status: 3,
                version: 2
            };

            Wallet.customPUT(postData).then(function(data) {
                deferred.resolve();
            }, function(error) {
                $exceptionHandler('[Rekey] Save regular error', error);
                deferred.reject('save_regular_error');
            });

            return deferred.promise;

        };

        $scope.reloadPage = function() {
          $state.reload();
        }

        // LOCK / AUTHORIZE LOGIC
        // we will be unlocking multiple wallets during the process, so we should wait for 2FA authorize before trying to get secrets for each
        $scope.isUnlocked = false;
        var isMasterUnlocked = coreSecurity.isMasterUnlocked();
        if (isMasterUnlocked) {
            authorizeForSecrets();
        } else {
            var listener = $scope.$on('master_unlocked', function() {
                authorizeForSecrets();
                listener();
            });
        }

        function authorizeForSecrets() {
            if ($scope.type2fa === 'sms') { // not used at the moment, because we require 2FA before rekey now, but it's here in case we change the flow in the future again
                Restangular.one('user/secret2fa/authorize').customPOST()
                    .then(function() {
                        // already authorized
                        $scope.isUnlocked = true;
                        startProcess();
                    }, function(error) {
                        if (error.data.error === "2fa_sms_required") {
                            $scope.phoneNumber = error.data.data.phoneNumber;
                        }
                        var listener = $scope.$on('2fa_authorized', function() {
                            $scope.isUnlocked = true;
                            startProcess();
                            listener();
                        });
                    });
            } else if ($scope.type2fa === 'totp') {
                var listener = $scope.$on('2fa_authorized', function() {
                    $scope.isUnlocked = true;
                    startProcess();
                    listener();
                });
            }
        }

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:RekeyFixCtrl
 * @description
 * # RekeyFixCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp').controller('RekeyFixCtrl', RekeyFixCtrl);

function RekeyFixCtrl($scope, $state, coreSecurity, Auth, Restangular, $exceptionHandler) {

    var vm = this;

    var authUser = null;
    vm.loading = true;

    // Init
    resetForm()

    Auth.getProfile(true).then(function (data) {
        authUser = data;
        vm.loading = false;
    }, function (err) {
        $exceptionHandler(err);
    });

    vm.submitFixForm = submitFixForm;


    ///////////////////////////////////////////////////////////

    $scope.reloadPage = function(){
      $state.reload();
    }

    function resetForm() {
        vm.errorMessage = false;
        vm.mode = false;
        vm.settings = {};
    }

    function submitFixForm(isValid) {
        vm.errorMessage = false;
        vm.success_message = false;

        // Make sure the form is completely valid
        if (!isValid) return;

        vm.mode = 'sending';

        Auth.getProfile(true).then(function (data) {
            authUser = data;

            if(data.migration_status != 'completed') {

                vm.errorMessage = "error_migration_not_completed";
                $exceptionHandler('error_migration_not_completed');
                vm.mode = 'error';
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                return;
            }
            else if(data.meta.master_key_old == null) {
                $exceptionHandler("error_master_null");
                vm.errorMessage = "error_master_null";
                vm.mode = 'error';
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                return;
            }
            else if(data.meta.master_key_salt == data.meta.master_key_salt_old) {
                $exceptionHandler("error_master_salt");
                vm.errorMessage = "error_master_salt";
                vm.mode = 'error';
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                return;
            }
            else {

                coreSecurity.unlockUser(vm.settings.current, authUser).then(function (data) {

                    // Decrypt old master with old pass
                    // Encrypt old master with new pass
                    // Save old master to auth

                    var master_key_old;
                    if(vm.settings.old_password){ // If user entered old password
                        var pbkdf_pass_old = coreSecurity.get_pbkdf(vm.settings.old_password, authUser.meta.master_key_salt_old, authUser.meta.master_key_iterations_old);
                        master_key_old = coreSecurity.AESDecrypt(authUser.meta.master_key_old, pbkdf_pass_old, authUser.meta.version_old);
                    } else if(vm.settings.old_recovery_key) { // If user entered old recovery key
                        master_key_old = coreSecurity.AESDecrypt(authUser.meta.mnemonic_old, vm.settings.old_recovery_key, authUser.meta.version_old);
                    }

                    if (master_key_old != null) {

                        var pbkdf_pass = coreSecurity.get_pbkdf(vm.settings.current, authUser.meta.master_key_salt, authUser.meta.master_key_iterations);
                        var master_key_old_encrypted_with_new_password = coreSecurity.AESEncrypt(master_key_old, pbkdf_pass);

                        // Check encryption
                        var master_key_old_decrypted_with_new_password = coreSecurity.AESDecrypt(master_key_old_encrypted_with_new_password, pbkdf_pass, 2);

                        if(master_key_old_decrypted_with_new_password !== master_key_old) {
                            $exceptionHandler('error_master_mismatch');
                            vm.errorMessage = "error_master_mismatch";
                            vm.mode = 'error';
                            document.body.scrollTop = document.documentElement.scrollTop = 0;
                            return;
                        }

                        var formData = {
                            master_key_old: master_key_old_encrypted_with_new_password,
                            master_key_iterations_old: authUser.meta.master_key_iterations,
                            master_key_salt_old: authUser.meta.master_key_salt,
                            version_old: 2,
                            master_key_old_fix: 1
                        };

                        // Save to auth
                        var updateUser = Restangular.restangularizeElement(null, formData, "user/meta");
                        updateUser.customPUT(formData).then(function (data) {

                            vm.mode = 'success';
                            document.body.scrollTop = document.documentElement.scrollTop = 0;

                            // Reset form
                            vm.settings = {};
                            $scope.fixForm.$setPristine();

                        }, function (err) {

                            $exceptionHandler(err);
                            vm.errorMessage = "error_auth_update";
                            vm.mode = 'error';
                            document.body.scrollTop = document.documentElement.scrollTop = 0;

                            // Reset form
                            vm.settings = {};
                            $scope.fixForm.$setPristine();

                        });

                    }
                    else {
                        if(vm.settings.old_recovery_key){
                            vm.errorMessage = "Old recovery key is wrong!";
                        } else {
                            vm.errorMessage = "Old password is wrong!";
                        }
                        vm.mode = 'error';
                        document.body.scrollTop = document.documentElement.scrollTop = 0;

                        $exceptionHandler('wrong_old_password');

                        // Reset form
                        vm.settings = {};
                        $scope.fixForm.$setPristine();
                    };

                }, function (reason) {
                    $exceptionHandler(reason);
                    vm.errorMessage = "Current password is wrong!";
                    vm.mode = 'error';
                    document.body.scrollTop = document.documentElement.scrollTop = 0;

                    // Reset form
                    vm.settings = {};
                    $scope.fixForm.$setPristine();
                });

            }

        });

    }

}
RekeyFixCtrl.$inject = ["$scope", "$state", "coreSecurity", "Auth", "Restangular", "$exceptionHandler"];

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:SecurityOverviewCtrl
 * @description
 * # SecurityOverviewCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('SecurityOverviewCtrl', ["Restangular", "$exceptionHandler", function (Restangular, $exceptionHandler) {

        var vm = this;

        vm.user = null;
        vm.devices = [];

        Restangular.one('user').get().then(function(data){
            vm.user = data.plain();

            Restangular.one('user').all('devices').getList().then(function(data) {

                vm.devices = data.plain();

            },$exceptionHandler);

        },$exceptionHandler)
        .finally(function() {
            vm.loading = false;
        });


    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:NavctrlCtrl
 * @description
 * # NavctrlCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
  .controller('NavCtrl', ["Auth", "$scope", "$state", function (Auth, $scope, $state) {

     $scope.state = $state;
     $scope.navbarVisible = false;
     
     $scope.logout = function(){
         Auth.logout();
     };

     $scope.toggleNavbar = function(visibility) {
       $scope.navbarVisible = visibility;
     }

  }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:AnalyticsCtrl
 * @description
 * # AnalyticsCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('AnalyticsCtrl', ["Auth", "CoreRestangular", "$q", "$rootScope", "$localStorage", "WalletsService", "CurrencyMeta", "RippleCharts", "$sce", "$filter", "RatesRestangular", "$exceptionHandler", "$scope", "NonstandardCurrencies", function (Auth, CoreRestangular, $q, $rootScope, $localStorage, WalletsService, CurrencyMeta, RippleCharts, $sce, $filter, RatesRestangular, $exceptionHandler, $scope, NonstandardCurrencies) {

        var vm = this;

        vm.wallets = [];
        vm.walletFilters = [];
        vm.activeMetricCode = $localStorage.activeMetricCode;

        vm.netWorth = 0;
        vm.netWorthNonNegative = 0;
        vm.assetNetWorth = 0;
        vm.historicBalances = {
            native: [{}, {}, {}],
            converted: [0, 0, 0],
            diff: [{}, {}, {}]
        };
        var availableCurrencies = new Map();
        vm.currencyList = [];
        vm.assetChart = setupRadialGraph();

        vm.loading = true;
        vm.error = null;

        vm.changeMetric = changeMetric;
        vm.changeAssetFilter = changeAssetFilter;
        vm.isDisplayableLine = isDisplayableLine;

        vm.walletsToDisplay = 5;
        vm.tooltipHtml = '';

        var balanceUpdateListener;

        // Init
        loadWallets();
        getBalanceHistory();


        // lines load asynchronously from wallets
        // listen for balances changes
        balanceUpdateListener = $rootScope.$on('$balancesUpdate', function() {
            loadAnalytics();
        });

        $scope.$on('$destroy', function() {
            if (balanceUpdateListener) {
                balanceUpdateListener();
            }
        });

        var walletsLoading = new Set();

        ///////////////////////////////////////////////////////////

        function loadWallets() {
            // add default xrp currency
            WalletsService.getWallets().then(function(data) {
                vm.wallets = data;
                vm.filteredWallets = data;
                vm.walletFilters = vm.wallets.map(function(wallet) {
                    return { label: wallet.name, checked: true, address: wallet.address }
                });

                loadAnalytics();
                sumUpNetWorths();   // if wallets are already loaded calculate sum
            }, function(error) {
                vm.loading = false;
                $exceptionHandler(error);
            });
        }

        function loadAnalytics() {
            vm.loading = true;

            // only process a wallet once
            var unprocessedWallets = vm.wallets.filter(function(wallet) {
                return wallet.loadingLines === false && !walletsLoading.has(wallet.address);
            });


            var netWorthPromises = unprocessedWallets.map(function(wallet) {
                walletsLoading.add(wallet.address); // add wallet to set, so we don't process it multiple times
                return calculateNetWorth(wallet);
            });

            $q.all(netWorthPromises).then(function(response) {
                // All wallets have been processed
                if (walletsLoading.size === vm.wallets.length) {
                    sumUpNetWorths();
                    convertBalances();
                    vm.loading = false;
                }
            }).catch(function(error) {
                console.error(error);
            })

        };

        function calculateNetWorth(wallet) {
            return WalletsService.updateWalletNetWorth(wallet)
                .then(function(netWorth) {
                    wallet.netWorth = netWorth;
                    updateCurrencies(wallet);
                })
                .catch(function (error) {
                    console.error(error);
                });

        }

        function sumUpNetWorths() {
            const netWorths = vm.wallets
                .filter(function(wallet) { return !_.isEmpty(wallet.netWorth) })
                .map(function(wallet) { return wallet.netWorth.total });

            vm.netWorth = netWorths.reduce(function(a, b) { return a + b }, 0);
            vm.netWorthNonNegative = netWorths.reduce(function(a, b) { return a + (b > 0 ? b : 0) }, 0);
        }

        function updateCurrencies(wallet) {
            if (!wallet) {
                return;
            }

            var lines = Object.values(wallet.lines);

            // psd balances have a different formatting than hosted and xrpl
            if (wallet.type === 24) {
                lines = wallet.balances.map(balance => ({
                    currency: balance.currency,
                    available: balance.amount,
                    account: ''
                }))
            }
            // Add xrp balance for wallets
            else if (wallet.type === 10 || wallet.type === 11) {
                lines.push({
                    currency: 'XRP',
                    available: wallet.xrp,
                    account: ''
                });
            }

            if (lines.length === 0) {
                return;
            }

            lines.map(function(line, index) {
                if (!availableCurrencies.has(line.currency)) {
                    availableCurrencies.set(line.currency, { native: 0, converted: 0 });
                }
                var currentAmount = availableCurrencies.get(line.currency);

                var balanceNative = isNaN(line.available) ? line.balance.to_number() : line.available; //hosted or xrp line
                var balanceConverted = 0;
                if ([10, 11, 0].includes(wallet.type)) {
                    balanceConverted  = _.isEmpty(wallet.netWorth) ? 0 : wallet.netWorth[line.account + line.currency];
                }
                else if (wallet.type === 24) {
                    balanceConverted = _.isEmpty(wallet.netWorth) ? 0 : wallet.netWorth[index];
                }

                balanceNative = parseFloat(balanceNative);
                balanceConverted = parseFloat(balanceConverted);


                currentAmount.native += isNaN(balanceNative) ? 0 : balanceNative;
                currentAmount.converted += isNaN(balanceConverted) ? 0 : balanceConverted;

                availableCurrencies.set(line.currency, currentAmount);
            });


            vm.currencyList = Array.from(availableCurrencies)
                .sort(function(a, b) { return b[1].converted - a[1].converted });

            vm.assetNetWorth = 0;
            vm.currencyList.forEach(asset => {
                if (asset[1].converted <= 0) {
                    return;
                }
                vm.assetNetWorth += asset[1].converted;
            });

            vm.assetChart = setupRadialGraph();
        }


        function changeMetric(currency) {

            // Update last selected in storage
            $localStorage.activeMetricCode = currency;

            // Update view
            vm.activeMetricCode = currency;

            walletsLoading.clear();
            loadAnalytics();
        };

        function isDisplayableLine(line) {
            if (line.display_balance === '0') {
                return false;
            }

            return WalletsService.isConvertableCurrency(line.account);
        }

        function setupRadialGraph() {
            var data = vm.currencyList
                .filter(function(balance) { return balance[1].native > 0 })
                .map(function(currency) {
                    return {
                        name: $filter('xrplCurrency')(currency[0]),
                        y: currency[1].converted,
                        color: CurrencyMeta.getCurrencyColor(currency[0])
                    };
                });

            var config = {

                options: {
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        borderWidth: 0,
                        plotShadow: false,
                        backgroundColor:'rgba(255, 255, 255, 0)',
                        type: 'pie',
                        margin: 0,
                        height: 340,
                    },
                    legend: { enabled: false },
                    exporting: { enabled: false },
                    plotOptions: {
                        pie: {
                            dataLabels: {
                                enabled: true,
                                /* formatter: function () {
                                    console.log(this);
                                    return '<span style="color:' + this.point.color + '">' + this.point.name + '</span>';
                                } */
                            },
                            borderWidth: 0,
                            center: ['50%', null],
                            startAngle: 0,
                        }
                    },
                    tooltip: {
                        borderRadius: 5,
                        backgroundColor: 'rgba(255, 255, 255, 1)',
                        borderWidth: 0,
                        shadow: true,
                        valueDecimals : 4,
                        formatter: function() {
                            var s = '';
                            s += `<div style="font-size: 14px; color:${this.color}; font-weight:bold">${this.point.name}</div><br>`;
                            s += `<div>${$filter('numberFormat')(this.y, { currency: vm.activeMetricCode }) } ${vm.activeMetricCode}</div><br>`;
                            s += `<div>${$filter('numberFormat')(this.y / this.total * 100, 2)}%<div>`;

                            return s;
                        },
                    }
                },
                series: [{
                    type: 'pie',
                    name: false,
                    size: 240,
                    innerSize: 160,
                    data: data,
                }],
                title: {
                    text: undefined
                }
            };

            return config;
        };

        function getBalanceHistory() {
            vm.historicBalances.native = [];

            $q.all([
                Auth.getProfile(),
                WalletsService.getWallets()
            ])
            .then(responses => {
                var userId = responses[0].id;
                var xrplWallets = responses[1].filter(wallet => wallet.type === 11 || wallet.type === 10).map(wallet => wallet.address);

                var lastWeekMoment = moment().subtract(1, 'weeks');
                var lastMonthMoment = moment().subtract(1, 'months');
                var lastYearMoment = moment().subtract(1, 'years');

                // XRP Balance requests
                // Catch errors to wait for all requests
                var xrplWeekPromise = $q.all(xrplWallets.map(wallet => {
                    return RippleCharts.getBalances(wallet, { date: lastWeekMoment.toISOString() }).catch(_ => null)
                }));
                var xrplMonthPromise = $q.all(xrplWallets.map(wallet => {
                    return RippleCharts.getBalances(wallet, { date: lastMonthMoment.toISOString() }).catch(_ => null)
                }));
                var xrplYearPromise = $q.all(xrplWallets.map(wallet => {
                    return RippleCharts.getBalances(wallet, { date: lastYearMoment.toISOString() }).catch(_ => null)
                }));
                var xrpBalances = $q.all([xrplWeekPromise, xrplMonthPromise, xrplYearPromise])
                    .then(data => {
                        for (let i = 0; i < data.length; i++) {
                            data[i] = data[i].filter(response => !_.isEmpty(response))
                        }
                        return data;
                    });
                // HOSTED Balance requests
                var balanceCall = CoreRestangular.one('users').one(userId).one('historicBalances');
                var hostedWeekPromise = balanceCall.customPOST({
                    filters: {
                        interval: { unit: { value : "day" } },
                        created_at: {
                            from: lastWeekMoment.startOf('day').toISOString(),
                            to: lastWeekMoment.endOf('day').toISOString()
                        }
                    }
                });
                var hostedMonthPromise = balanceCall.customPOST({
                    filters: {
                        interval: { unit: { value : "day" } },
                        created_at: {
                            from: lastMonthMoment.startOf('day').toISOString(),
                            to: lastMonthMoment.endOf('day').toISOString()
                        }
                    }
                });
                var hostedYearPromise = balanceCall.customPOST({
                    filters: {
                        interval: { unit: { value : "day" } },
                        created_at: {
                            from: lastYearMoment.startOf('day').toISOString(),
                            to: lastYearMoment.endOf('day').toISOString()
                        }
                    }
                });

                // PSD Balance requests
                var psdBalanceCall = CoreRestangular.one('users').one(userId).one('psdHistoricBalances');
                var psdWeekPromise = psdBalanceCall.customPOST({
                    filters: {
                        interval: { unit: { value : "day" } },
                        created_at: {
                            from: lastWeekMoment.startOf('day').toISOString(),
                            to: lastWeekMoment.endOf('day').toISOString()
                        }
                    }
                });
                var psdMonthPromise = psdBalanceCall.customPOST({
                    filters: {
                        interval: { unit: { value : "day" } },
                        created_at: {
                            from: lastMonthMoment.startOf('day').toISOString(),
                            to: lastMonthMoment.endOf('day').toISOString()
                        }
                    }
                });
                var psdYearPromise = psdBalanceCall.customPOST({
                    filters: {
                        interval: { unit: { value : "day" } },
                        created_at: {
                            from: lastYearMoment.startOf('day').toISOString(),
                            to: lastYearMoment.endOf('day').toISOString()
                        }
                    }
                });

                var psdBalances = $q.all([psdWeekPromise, psdMonthPromise, psdYearPromise])


                var hostedBalances = $q.all([hostedWeekPromise, hostedMonthPromise, hostedYearPromise])
                    .then(data => data.map(balances => balances.plain()));

                var psdBalances = $q.all([psdWeekPromise, psdMonthPromise, psdYearPromise])
                    .then(data => data.map(balances => balances.plain()));

                $q.all([hostedBalances, xrpBalances, psdBalances])
                    .then(function(data) {
                        vm.historicBalances.native = combineHistoricBalances(data[0], data[1]);
                        convertBalances();
                    })
                    .catch(function(error) {
                        $exceptionHandler('Error fetching historic balances', error);
                    });


            })
        }

        function combineHistoricBalances(hostedBalances, xrpBalances) {
            var historicBalances = [];
            for (let i = 0; i < 3; i++) {
                var _balances = [];
                hostedBalances[i].forEach(currency => {
                    _balances.push({
                        issuer: currency.vault.uuid, // hosted balances only have vaultId, not cold address,
                        assetCode: currency.vault.asset_code,
                        balance: +currency.data[0].balance // should only have 1 entry for 1 day
                    });
                });

                xrpBalances[i].forEach(wallet => {
                    wallet.data.balances.forEach(balance => {
                        _balances.push({
                            issuer: balance.counterparty, // hosted balances only have vaultId, not cold address,
                            assetCode: balance.currency,
                            balance: +balance.value
                        });
                    });
                });

                historicBalances.push(_balances);
            }

            // console.log(historicBalances);
            return historicBalances;
        }

        function convertBalances() {
            getHistoricRates().then(rates => {
                // console.log(rates);
                for (let i = 0; i < vm.historicBalances.native.length; i++) {
                    const balances = vm.historicBalances.native[i];
                    vm.historicBalances.converted[i] = convertBalancesWithRates(balances, rates[i]);
                }

                // console.log(vm.historicBalances.converted);
                calculateHistoryDifference();
            });
        }

        function convertBalancesWithRates(balances, rates) {
            if (!Array.isArray(balances) || _.isEmpty(rates)) {
                return 0;
            }
            var sum = 0;
            balances.forEach(function(currency) {
                var vault = currency.issuer;
                var value = currency.balance;
                var currency = currency.assetCode;
                // console.log('Balance', vault, value, currency);

                var rateKey = NonstandardCurrencies.parseAssetCode(currency) + '/' + NonstandardCurrencies.parseAssetCode(vm.activeMetricCode);
                // DSH -> DASH hack
                rateKey = rateKey.replace(/DSH/g, 'DASH');

                var historicRate = rates[rateKey];
                var rate = 0;

                if (currency === vm.activeMetricCode) {
                    rate = 1;
                }
                else if (historicRate) {
                    rate = parseFloat(historicRate[0].rate);
                }
                else {
                    console.warn('Rate not found (analyticsCtrl)', rateKey, vault, rates);
                }

                sum += value * rate;
            });

            return sum;
        }

        function calculateHistoryDifference() {
            for (var i = 0; i < vm.historicBalances.converted.length; i++) {
                var balance = vm.historicBalances.converted[i];
                vm.historicBalances.diff[i].absolute = vm.netWorth - balance;
                vm.historicBalances.diff[i].relative = (vm.netWorth - balance) / balance * 100;
            }
        }

        function getHistoricRates() {

            var deferred = $q.defer();

            var pairList = _.uniq(_.flatten(vm.historicBalances.native)
                .map(balance => 
                    NonstandardCurrencies.parseAssetCode(balance.assetCode) + '/' + NonstandardCurrencies.parseAssetCode(vm.activeMetricCode)
                )).toString();
            // DSH -> DASH hack
            pairList = pairList.replace(/DSH/g, 'DASH');

            if (!pairList) {
                deferred.reject('No rate pairs');
            }
            else {
                var dates = [
                    moment().subtract(1, 'weeks'),
                    moment().subtract(1, 'months'),
                    moment().subtract(1, 'years')
                ];

                var queryParams = {
                    from: '',
                    to: '',
                    interval: 'day',
                    pair: pairList,
                    return: 'object'
                };

                $q.all(
                    dates.map(date => {
                        queryParams.from = date.startOf('day').format('YYYY-MM-DD');
                        queryParams.to = date.endOf('day').format('YYYY-MM-DD');

                        return RatesRestangular.one('exchange_rates').one('historical').get(queryParams).then(data => data.plain());
                    })
                )
                .then(deferred.resolve)
                .catch(deferred.reject);
            }
            return deferred.promise;
        }

        function changeAssetFilter() {
            // console.log('changed filter');
            availableCurrencies.clear();

            var includedWallets = vm.walletFilters
                .filter(function(filter) { return filter.checked })
                .map(function(filter) { return filter.address });

            vm.filteredWallets = vm.wallets
                .filter(function(wallet) {
                    return includedWallets.indexOf(wallet.address) > -1;
                })
                .map(function(wallet) {
                    updateCurrencies(wallet);
                    return wallet;
                });

            if (vm.filteredWallets.length === 0) {
                vm.currencyList = [];
                vm.assetChart = setupRadialGraph();
            }
        }


        vm.generateTooltip = function(wallet) {
            var balances = [];
            var html = '';
            for (var lineId in wallet.lines) {
                if (wallet.lines.hasOwnProperty(lineId)) {
                    balances.push({
                        currency: wallet.lines[lineId].currency,
                        lineId: lineId,
                        value: wallet.netWorth[lineId]
                    });
                }
            }

            if (wallet.xrp > 0) {
                balances.push({ currency: 'XRP', lineId: 'XRP', value: wallet.netWorth['XRP'] });
            }

            balances = balances.sort((a, b) => b.value - a.value);

            balances.forEach(balance => {
                html += `
                <div style="display: flex; justify-content: space-between">
                <div>
                    <span class="mr-1" style="color: ${CurrencyMeta.getCurrencyColor(balance.currency)}">●</span>
                    <b class="mr-4">${$filter('xrplCurrency')(balance.currency)}</b>
                </div>
                    <div>${$filter('numberFormat')(balance.value, { currency: vm.activeMetricCode } ) } ${vm.activeMetricCode}</div>
                </div>`;
            });

            if (!html.length) {
                html = '<span class="text-gray-light">No balances</span>';
            }

            vm.tooltipHtml = $sce.trustAsHtml(html);
        }
    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:AnalyticsTransactionsCtrl
 * @description
 * # AnalyticsTransactionsCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('AnalyticsTransactionsCtrl', ["$scope", "WalletsService", function ($scope, WalletsService) {

        $scope.transactionsPageTitle = "All Transactions";

        $scope.loading = true;
        $scope.wallet = false;
        $scope.wallets = [];

        WalletsService.getWallets().then(function () {
            var wallet = WalletsService.getActive();
            WalletsService.getHistory(wallet[0]);
            $scope.loading = false;
            $scope.wallet = wallet[0];

            // Something went wrong, let's stop before it gets even worse
            if (!$scope.wallet) {
                $exceptionHandler('wallet_not_found');
                return;
            };
        }, function(error){
            $exceptionHandler(error);
        });


    }]);
'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:CashflowCtrl
 * @description
 * # CashflowCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('CashflowCtrl', ["Auth", "$localStorage", "$q", "CoreRestangular", "WalletsService", "CurrencyMeta", "RippleAnalytics", "RatesRestangular", "$exceptionHandler", "ENV", "NonstandardCurrencies", function (Auth, $localStorage, $q, CoreRestangular, WalletsService, CurrencyMeta, RippleAnalytics, RatesRestangular, $exceptionHandler, ENV, NonstandardCurrencies) {

        var vm = this;

        vm.range = 'month';
        vm.userId = null;

        // cashflow contains 2 * range items for change comparison
        vm.cashflowMap = new Map();
        vm.chartData = [];

        vm.incomeSum = 0;
        vm.expensesSum = 0;
        vm.incomeDiffRatio = 0;
        vm.expensesDiffRatio = 0;

        vm.baseCurrency = $localStorage.activeMetricCode;
        vm.historicRates = [];
        vm.wallets = [];

        vm.loading = true;
        vm.error = null;

        vm.changeMetric = changeMetric;
        vm.changeRange = changeRange;

        var userPromise = Auth.getProfile();
        var ratesPromise = getHistoricRates();
        $q.all([userPromise, ratesPromise]).then(responses => {
            vm.userId = responses[0].id;
            vm.historicRates = responses[1];
            CoreRestangular.one('users', vm.userId).get({ includeDeleted: true }).then(data => {
                vm.wallets = data.wallets;
                getBalanceChanges();
            })
            .catch(error => {
                vm.error = error;
                $exceptionHandler(error);
            });
            // console.log(responses);
        })
        .catch(error => {
            vm.error = error;
            $exceptionHandler(error);
        });


        function initValues() {
            vm.cashflowMap.clear();
            vm.incomeSum = 0;
            vm.expensesSum = 0;
            vm.incomeDiffRatio = 0;
            vm.expensesDiffRatio = 0;
        }


        function getBalanceChanges() {
            vm.loading = true
            initValues();

            var psdBalancePromise = getPsdBalanceChanges();
            var hostedBalancePromise = getHostedBalanceChanges();
            var xrpBalancePromises = $q.all(getXrpBalanceChanges());

            var balancePromiseArray = [hostedBalancePromise, psdBalancePromise];
            if (ENV.name === 'production') { // testnet ripple data api not available anymore
                balancePromiseArray.push(xrpBalancePromises);
            }

            // todo: enable xrplRequests
            $q.all(balancePromiseArray)
                .then(responses => {
                    processHostedBalances(responses[0]);
                    processPsdBalances(responses[1]);
                    if (ENV.name === 'production') { // testnet ripple data api not available anymore
                        processXrpBalances(responses[2]);
                    }
                    calculateVolumes();

                    var half = Math.ceil(vm.cashflowMap.size / 2);
                    vm.chartData = Array.from(vm.cashflowMap).splice(half, vm.cashflowMap.size - half);

                    // console.log(Array.from(vm.cashflowMap).map(d => moment(d[0]).format() ));
                    // console.log(vm.chartData);
                    // console.log(vm.chartData.map(d => moment(d[0]).format() ));
                    vm.loading = false;
                })
                .catch(error => {
                    vm.error = error;
                    vm.loading = false;
                    console.error(error);
                });
        }

        function getHostedBalanceChanges() {
            return CoreRestangular
            .one('users')
            .one(vm.userId)
            .one('historicBalances')
            .customPOST({
                filters: {
                    interval: { unit: { value : "day" } },
                    created_at: {
                        from: moment().utc().subtract(2, vm.range).startOf('day').toISOString(),
                        to: moment().utc().endOf('day').toISOString()
                    }
                }
            })
            .then(response => response.plain());
        }

        function getPsdBalanceChanges() {
            return CoreRestangular
            .one('users')
            .one(vm.userId)
            .one('psdHistoricBalances')
            .customPOST({
                filters: {
                    interval: { unit: { value : "day" } },
                    created_at: {
                        from: moment().utc().subtract(2, vm.range).startOf('day').toISOString(),
                        to: moment().utc().endOf('day').toISOString()
                    }
                }
            })
            .then(response => response.plain());
        }

        function getXrpBalanceChanges() {
            var walletAddresses = vm.wallets.map(wallet => wallet.address);
            return vm.wallets
                .filter(wallet => { return wallet.type === 10 || wallet.type === 11 })
                .map(wallet => {
                    var range = {
                        start: moment().subtract(2, vm.range).startOf('day').toISOString(),
                        end: moment().endOf('day').toISOString()
                    };

                    if (wallet.deleted) {
                        var timeDeleted = moment(wallet.updated_at);

                        if (timeDeleted.isBetween(range.start, range.end)) {
                            range.end = moment(wallet.updated_at).toISOString();
                        }
                    }
                    return RippleAnalytics.getXrpVolumeChanges(wallet.address, range, walletAddresses);
                });
        }

        function processHostedBalances(balanceHistory) {
            balanceHistory.forEach(vaultHistory => {
                var vault = vaultHistory.vault;
                var historyData = vaultHistory.data;

                historyData.forEach(function(history) {
                    var date = moment.utc(history.created_at).startOf('day').unix() * 1000;
                    var rate = findDailyRate(vault.asset_code, vault.uuid, date);
                    var incomeConverted = parseFloat(history.incomes) * rate;
                    var expensesConverted = parseFloat(history.expenses) * rate;
                    addToMapValue(date, incomeConverted, expensesConverted, vm.cashflowMap);
                });
            });
        }

        function processPsdBalances(balanceHistory) {
            balanceHistory.forEach(assetHistory => {
                var currency = assetHistory.asset_code;
                var historyData = assetHistory.data;

                historyData.forEach(function(history) {
                    var date = moment.utc(history.created_at).startOf('day').unix() * 1000;
                    var rate = findDailyRate(currency, null, date);
                    var incomeConverted = parseFloat(history.incomes) * rate;
                    var expensesConverted = parseFloat(history.expenses) * rate;
                    addToMapValue(date, incomeConverted, expensesConverted, vm.cashflowMap);
                });
            });
        }

        function processXrpBalances(balanceHistory) {
            balanceHistory.forEach(walletHistory => {
                walletHistory.balanceChanges.forEach(history => {
                    var date = history.date;
                    var rate = findDailyRate(history.asset_code, history.issuer, date);
                    if (rate) {
                        history.changes.forEach(change => {
                            var balanceChange = parseFloat(change.value) * rate;
                            var incomeConverted = balanceChange <= 0 ? 0 : balanceChange;
                            var expensesConverted = balanceChange <= 0 ? -balanceChange : 0;
                            // console.log('Balance Change', balanceChange);
                            addToMapValue(date, incomeConverted, expensesConverted, vm.cashflowMap);
                        });
                    }
                });

            });
        }

        function calculateVolumes() {
            var dailyVolumes = Array.from(vm.cashflowMap);

            var rangeStart = moment().subtract(1, vm.range);
            var incomeSumPrevious = 0;
            var expensesSumPrevious = 0;

            dailyVolumes.forEach(volume => {
                // volume[0] unix time, volume[0][0] inflow, volume[0][1] outflow
                var date = moment(volume[0]);

                if (date.diff(rangeStart, 'days') < 0) {
                    incomeSumPrevious += volume[1][0];
                    expensesSumPrevious += volume[1][1];
                }

                else {
                    vm.incomeSum += volume[1][0];
                    vm.expensesSum += volume[1][1];
                }
            });

            vm.incomeDiffRatio = (vm.incomeSum - incomeSumPrevious) / incomeSumPrevious * 100;
            vm.expensesDiffRatio = (vm.expensesSum - expensesSumPrevious) / expensesSumPrevious * 100;
        }


        function changeMetric(currency) {
            if (vm.baseCurrency !== currency) {
                vm.baseCurrency = currency;
                $localStorage.activeMetricCode = currency;

                vm.loading = true;
                getHistoricRates().then(data => {
                    vm.historicRates = data;
                    getBalanceChanges();
                })
                .catch(error => {
                    vm.error = error;
                    $exceptionHandler(error);
                });
            }
        }

        function changeRange(range) {
            if (vm.range !== range) {
                vm.range = range;
                getBalanceChanges();
            }
        }


        function addToMapValue(key, inflow, outflow, map) {
            // console.log(key, moment(key).format(), inflow, outflow);
            if (!map.has(key)) {
                map.set(key, [0, 0]);
            }

            var currentValues = map.get(key);

            currentValues[0] = currentValues[0] + inflow;
            currentValues[1] = currentValues[1] + outflow;

            map.set(key, currentValues);
        }

        function getHistoricRates() {
            var pairList = CurrencyMeta.getDefaultCurrencies().map(currency => {
                return NonstandardCurrencies.parseAssetCode(currency.code) + '/' + NonstandardCurrencies.parseAssetCode(vm.baseCurrency);
            }).toString();

            var queryParams = {
                frame: '2y',
                interval: 'day',
                return: 'object',
                pair: pairList
            };

            return RatesRestangular
                .one('exchange_rates')
                .one('historical')
                .get(queryParams);
        }

        function findDailyRate(currency, vault, unixTime) {
            if (currency === vm.baseCurrency) {
                return 1;
            }

            if (currency !== 'XRP' && vault && !WalletsService.isConvertableCurrency(vault)) {
                console.warn('Currency not supported', currency, vault)
                return 0;
            }

            var rateKey = NonstandardCurrencies.parseAssetCode(currency) + '/' + NonstandardCurrencies.parseAssetCode(vm.baseCurrency);
            // DSH -> DASH hack
            rateKey = rateKey.replace('DSH', 'DASH');
            var historicRates = vm.historicRates[rateKey];
            if (!historicRates) {
                console.warn('No rates for pair!', rateKey);
                return 0;
            }
            var formattedDay = moment(unixTime).format('YYYY-MM-DD');
            var rateInfo = historicRates.find(rate => rate.datetime === formattedDay);
            if (rateInfo) {
                return rateInfo.rate;
            }

            console.warn('No rate for day!', rateKey, formattedDay);
            return 0;
        }
    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:FaqCtrl
 * @description
 * # FaqCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('FaqCtrl', function () {

        var vm = this;

        vm.toggleItem = function(item) {
            item.expanded = !item.expanded;
        }

        vm.faqItems = [
            {
                title: "Getting Started",
                items: [
                    {
                        question: "What is GateHub Wallet?",
                        answer: `<p>The website you are seeing now is called <strong>GateHub Wallet</strong>. It enables you to manage assets on multiple wallets, send & receive payments via XRPL, SEPA, International Wire and more.</p>
                        <p>Special types of wallets called XRPL wallets also enable you to trade multiple assets on the decentralized XRPL exchange.</p>`
                    },
                    {
                        question: "What is GateHub Identity?",
                        answer: `<p>GateHub Identity is a highly secure storage for your personal information. You need to create your identity and get verified before we can let you add funds. With GateHub Identity, you are able to connect to any gateway on the GateHub Network without having to upload and enter personal information every time.</p>
                        <p>Each gateway you connect will be able to access personal information stored in your GateHub Identity. Depending on the gateway’s compliance requirements, they might ask you to provide additional information or reject your request for a connection.</p>
                        <p>GateHub wallet is not fully operational until you successfully connect at least one gateway. Connecting a gateway will allow you to receive, send and exchange assets provided by the gateway.</p>`
                    },
                    {
                        question: "What is a gateway?",
                        answer: `<p>A gateway is a service that allows users to deposit and withdraw assets for use on the GateHub private network via Hosted wallets and on the public XRP Ledger via XRPL wallets. These assets are represented as IOUs and can only be withdrawn to their respective (native) networks via GateHub.</p>
                        <p>The XRP currency and XRPL wallets are the exception as the XRP Ledger is a public network on its own. GateHub holds no authority over XRP or the XRP Ledger.</p>`
                    }
                ]
            },
            {
                title: "Gateways",
                items: [
                    {
                        question: "GateHub UAB",
                        answer: `<p>GateHub UAB is our FIAT and cryptoasset gateway which allows you to deposit and withdraw <strong>EUR</strong>, <strong>USD</strong>, <strong>GBP</strong>, <strong>BTC</strong>, <strong>BCH</strong>, <strong>ETH</strong>, <strong>ETC</strong>, <strong>DSH</strong>, <strong>SGB</strong>, <strong>LTC</strong>, <strong>USDT</strong>, <strong>USDC</strong>, <strong>WXRP</strong>, and <strong>GALA</strong>. It also supports <strong>XRP</strong> transfers between the XRPL and the GateHub Hosted network.</p>`
                    },
                    {
                        question: "BPG Kovine",
                        answer: `<p>BPG Kovine (metals) is our affiliated commodity gateway, which supports buying <strong>XAU</strong> (digital gold) and withdrawing gold bullion via mail.</p>`
                    },
                ]
            },
            {
                title: "Wallets",
                items: [
                    {
                        question: "Primary wallet",
                        answer: `<p>One of your wallets is the Primary wallet. The Primary wallet will be used as the destination when other GateHub users send funds to your email, phone number or PayString. If you own more than one wallet, you can choose which one of your wallets will be primary.</p>`
                    },
                    {
                        question: "Types of wallets",
                        answer: `
                        <p>GateHub supports two types of wallets:
                            <ul>
                                <li><strong>XRP Ledger</strong> wallets</li>
                                <li><strong>Hosted</strong> wallets</li>
                            </ul>
                        </p>
                        <p>The main difference between hosted and XRP Ledger wallets is that XRP Ledger wallet transactions are recorded on the <strong>public XRP Ledger</strong>, while hosted wallet transactions are recorded on <strong>GateHub’s private ledger</strong>. Hosted wallets offer more privacy and zero fee transactions.</p>
                        <p>Only XRPL wallets can be used for trading, however you can exchange your funds instantly with a Hosted wallet.</p>
                        <p>Hosted wallets on the other hand are Interledger (ILP) ready, which means you can receive payment streams via Coil to your Hosted wallet.</p>
                        <p>XRPL wallets require to be funded with 10 XRP to start operating while Hosted wallets have no funding restrictions.</p>
                        <h3>Comparison table</h3>
                        <table border="1">
                            <tr>
                                <th>Wallet type</th>
                                <th>Hosted</th>
                                <th>XRPL</th>
                            </tr>
                            <tr>
                                <td>Receive funds</td>
                                <td>Yes</td>
                                <td>Yes</td>
                            </tr>
                            <tr>
                                <td>Send funds</td>
                                <td>Yes</td>
                                <td>Yes</td>
                            </tr>
                            <tr>
                                <td>Exchanging funds</td>
                                <td>Yes</td>
                                <td>Yes</td>
                            </tr>
                            <tr>
                                <td>Free to use</td>
                                <td>Yes</td>
                                <td>No</td>
                            </tr>
                            <tr>
                                <td>Private</td>
                                <td>Yes</td>
                                <td>No</td>
                            </tr>
                            <tr>
                                <td>Interledger ready</td>
                                <td>Yes</td>
                                <td>No</td>
                            </tr>
                            <tr>
                                <td>Trading funds</td>
                                <td>No</td>
                                <td>Yes</td>
                            </tr>
                        </table>
                        `
                    }
                ]
            },
            {
                title: "XRP Ledger",
                items: [
                    {
                        question: "What is XRP Ledger?",
                        answer: `<p>XRP Ledger is an internet protocol for financial transactions. It uses a shared ledger to track balances among parties, regardless of their geographical location. This allows each payment to clear in seconds rather than days. It also makes it possible for a person who uses one currency to seamlessly pay a person who uses a different currency.</p>
                        <p>XRP is the native currency of the XRP Ledger.</p>`
                    },
                    {
                        question: "Who is the XRP Ledger for?",
                        answer: `<p>The XRPL can be used by individuals and businesses who strive for faster and easier ways of managing their funds.</p>`
                    },
                    {
                        question: "How does it work?",
                        answer: `<p>The XRPL network is, at its core, a <strong>shared public database</strong>. This database includes a ledger, which serves to track accounts and the balances associated with them. XRPL supports any currency and gives users complete freedom to transact in their chosen currency. A user can hold balances in one currency and send payments in another; the network takes care of the conversion on the fly.</p>`
                    },
                    {
                        question: "What is a Ripple Gateway?",
                        answer: `<p>A ripple gateway is a bridge between the XRPL, a FIAT currency, and other virtual currencies. It enables customers to do three things:
                            <ul>
                                <li>Deposit funds in exchange for a balance issued by that gateway.</li>
                                <li>Transfer their balance to another customer of the gateway.</li>
                                <li>Withdraw funds by redeeming a balance issued by that gateway.</li>
                            </ul>
                        </p>`
                    }
                ]
            },
            {
                title: "XRP Currency",
                items: [
                    {
                        question: "What is XRP?",
                        answer: `<p>XRP is the <strong>native currency</strong> of the XRP Ledger. It can also function as an intermediary currency between any other currency pair on the XRPL decentralized exchange, e.g. USD/BTC.</p>`
                    },
                    {
                        question: "How does XRP protect the network from spam?",
                        answer: `<p>XRP protects its network from spam by introducing a <strong>base reserve of 10 XRP</strong> for each account and a transaction fee which depletes a "spammer"’s wallet. Furthermore, any other currency on the XRP Ledger requires the user to extend a trust line, which can be canceled at any given time.</p>`
                    },
                    {
                        question: "What is their value?",
                        answer: `<p>The value of XRP (and other assets) can be monitored in real time on <a href="https://gatehub.net/markets" target="_blank">Markets Analytics</a>.</p>`
                    },
                    {
                        question: "Reserves",
                        answer: `<p>To protect the network from the abusive creation of excess entries in the ledger, XRPL wallets are required to have and maintain a minimum reserve of XRP to operate.</p>
                        <p>The current reserve set by the ledger is <strong>10 XRP + 2 XRP owner reserve</strong>.</p>
                        <p>The owner reserve is the amount of XRP reserved in the account for each ledger item owned by the account. An account may own ledger items such as <strong>trust lines</strong> and <strong>open orders</strong>.</p>
                        <p>We recommend a reserve of at least 50 XRP for uninterrupted working.</p>`
                    }
                ]
            },
            {
                title: "XRPL Wallet",
                items: [
                    {
                        question: "What is an XRPL wallet?",
                        answer: `<p>An XRPL wallet is an <strong>address</strong> on the public XRP Ledger which can have a balance and can own items on the Ledger.</p>
                        <p>An XRP Ledger public address has the following attributes:
                            <ul>
                                <li>Between 25 and 35 characters in length</li>
                                <li>Starts with the character "r"</li>
                                <li>Uses alphanumeric characters, excluding the number "0" capital letter "O", capital letter "I", and lowercase letter "l"</li>
                                <li>Case-sensitive</li>
                            </ul>
                        </p>`
                    },
                    {
                        question: "How does an XRPL wallet work?",
                        answer: `<p>XRPL wallets require 10 XRP to operate and trust lines in order to receive assets other than XRP.</p>
                        <p>A wallet is a combination of a public address (described above) and a secret key, which is a very sensitive piece of information. GateHub does not know any user’s XRPL secret key so keep it safe and store it in a safe place. The secret key is used to create transactions by the address on the Ledger.</p>
                        <p>Anyone who obtains a wallet’s secret key has full authority over it.</p>`
                    }
                ]
            },
            {
                title: "Hosted Wallet",
                items: [
                    {
                        question: "What is a Hosted wallet",
                        answer: `<p>Hosted wallets on GateHub are booked on an internal (private) ledger. Hosted wallets can receive, send and exchange funds. They can also be used to stream payments via Interledger.</p>`
                    },
                    {
                        question: "How does a Hosted wallet work?",
                        answer: `<p>A hosted wallet is completely free and needs no trust line to accept any currency. You will need to connect to a gateway in order to receive any currency supported by that gateway.</p>
                        <p>Streaming funds via Coil is also possible with a Hosted wallet. <a target="_blank" rel="noopener noreferrer" href="https://support.gatehub.net/hc/en-us/articles/360019507633-Interledger-deposit-via-Coil">Here</a> is our guide.</p>`
                    }
                ]
            },
            {
                title: "Trade and Exchange",
                items: [
                    {
                        question: "How can I trade and exchange funds on GateHub?",
                        answer: `<p>On GateHub you can trade your funds on the decentralized XRPL exchange. The market is populated by users like you creating open orders and any currency can be traded for any other currency.</p>
                        <p>Our most popular markets are:
                            <ul>
                                <li>USD to XRP</li>
                                <li>USD to BTC</li>
                                <li>EUR to XRP</li>
                                <li>EUR to BTC</li>
                                <li>BTC to XRP</li>
                            </ul>
                        </p>`
                    },
                    {
                        question: "What are the limitations?",
                        answer: `<p>Note that you can only trade your funds by using an XRPL wallet.</p>
                        <p>Exchanging funds on GateHub is instant and can be done with an XRPL wallet, which relies on the market mentioned above. Exchanging with a hosted wallet is also possible and is instant as long as your order does not exceed the available amount in our liquidity provider at that moment.</p>`
                    }
                ]
            },
            {
                title: "PayString",
                items: [
                    {
                        question: "What is PayString?",
                        answer: `<p>PayString is your unique identifier for payments like an email is for messages. You can use it to receive funds over the XRPL and we will be adding other networks when they gain wider support.</p>`
                    },
                    {
                        question: "What does PayString look like?",
                        answer: `<p>PayString on GateHub looks like this: your_name + $ + paystring.gatehub.net<br>
                        The result is something like <strong>enej$paystring.gatehub.net</strong><br>
                        You can set your custom PayString via the Add Funds modal.</p>`
                    },
                    {
                        question: "How does PayString work?",
                        answer: `<p>Payments sent to your PayString will be added to your Primary wallet balance. Note that you need to establish trust lines to receive currencies other than XRP if your primary wallet is an XRPL wallet.</p>
                        <p>You can set your PayString in the Add Funds modal.</p>`
                    }
                ]
            },
            {
                title: "General",
                items: [
                    {
                        question: "Can I have multiple wallets?",
                        answer: `Yes. You can have up to 40 wallets.`
                    },
                    {
                        question: "Is my personal information safe on GateHub?",
                        answer: `All sensitive identity information is encrypted with industry standard encryption and can be accessed only by select GateHub KYC professionals. This includes all personal documents sent during the account verification process.`
                    },
                    {
                        question: "What is an XRPL wallet secret key?",
                        answer: `The secret key of an XRPL wallet, which starts with the letter "s", is a cryptographic key that allows you to sign transactions and spend balance from your XRPL address. It is a part of the XRPL protocol. Anyone with access to the secret key has full control over the account and its assets, so keep it safe.`
                    },
                    {
                        question: "Are my XRPL wallet secret keys safe on GateHub?",
                        answer: `Your XRPL wallet secret keys are safely encrypted and cannot be accessed by GateHub. We strongly suggest that you maintain a backup of your XRPL secret keys and the GateHub recovery key somewhere safe, preferably offline, to prevent losing access to your funds in any scenario.`
                    },
                    {
                        question: "How do I change my email address?",
                        answer: `If you wish to change your email address, go to your Personal details settings and scroll to the Contact info section and click on your email. After typing your new email address you will have to verify the new email and log in again.`
                    },
                    {
                        question: "How do I deactivate my GateHub account?",
                        answer: `To close your account, go to your Personal details settings, scroll down to the Close account section and click the "Close account" button. Make sure you withdraw all your money first and store your XRPL secret keys. After you close your account, you will not be able to do so!`
                    }
                ]
            }
        ];

    });

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:AccountCtrl
 * @description
 * # AccountCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('AccountCtrl', ["$scope", "Auth", "$stateParams", "$timeout", "CoreRestangular", "$sessionStorage", "$exceptionHandler", function ($scope, Auth, $stateParams, $timeout, CoreRestangular, $sessionStorage, $exceptionHandler) {

        $scope.loading = true;

        var id = $stateParams.id;
        var user = $sessionStorage.user;

        var wallet;
        var network_type;

        // Init
        init();

        ///////////////////////////////////////////////////////////


        function init() {

            Auth.getProfile().then(function (data) {

                loadContact();

            }, function (error) {
                $scope.loading = false;
                $exceptionHandler(error);
            });

        };

        function loadContact() {

            // Core
            CoreRestangular.one('users', user.uid).one('accounts', id).get().then(function(data) {

                var account = data.plain();

                // Determine network_type
                network_type = (typeof account.network != 'undefined') ? account.network : false;

                // Router
                if(network_type == 0) {
                    $sessionStorage.previousAccountsState = 'eubank';
                }
                else if (network_type == 1) {
                    $sessionStorage.previousAccountsState = 'bank';
                }
                else if (network_type == 2){
                    $sessionStorage.previousAccountsState = 'ripple';
                }
                else if (network_type == 3){
                    $sessionStorage.previousAccountsState = 'bitcoin';
                }
                else if (network_type == 5){
                    $sessionStorage.previousAccountsState = 'ethereum';
                }
                else if (network_type == 6){
                    $sessionStorage.previousAccountsState = 'rep';
                }
                else if (network_type == 7){
                    $sessionStorage.previousAccountsState = 'mail';
                }
                else if (network_type == 9){
                    $sessionStorage.previousAccountsState = 'ethereum_classic';
                }
                else if (network_type == 10){
                    $sessionStorage.previousAccountsState = 'dash';
                }
                else if (network_type == 13){
                    $sessionStorage.previousAccountsState = 'litecoin';
                }
                else if (network_type == 14){
                    $sessionStorage.previousAccountsState = 'bitcoincash';
                }
                else if (network_type == 15){
                    $sessionStorage.previousAccountsState = 'flare';
                }
                else if (network_type == 16){
                    $sessionStorage.previousAccountsState = 'songbird';
                }
                else if (network_type == 18){
                    $sessionStorage.previousAccountsState = 'gala';
                }
                else if (network_type == 19){
                    $sessionStorage.previousAccountsState = 'usdt';
                }
                else if (network_type == 20){
                    $sessionStorage.previousAccountsState = 'usdc';
                }
                else if (network_type == 21){
                    $sessionStorage.previousAccountsState = 'wxrp';
                }
                else if (network_type == 22){
                    $sessionStorage.previousAccountsState = 'gbp';
                }

                $timeout(function(){
                    $scope.account = account;
                    $scope.loading = false;
                });

            }, function(error) {
                $scope.loading = false;
                $exceptionHandler(error);
            });

        };

        $scope.cancel = function() {
            $scope.$dismiss();
        };

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:AccountsCtrl
 * @description
 * # AccountsCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('AccountsCtrl', ["$uibModal", "$state", "Auth", "CoreRestangular", "WalletsService", "AccountsService", "$exceptionHandler", function ($uibModal, $state, Auth, CoreRestangular, WalletsService, AccountsService, $exceptionHandler) {

        var vm = this;

        vm.contacts = [];
        vm.error = null;
        vm.loading = true;

        var allContacts = [];

        // index = network (check core's models/enums:Network)
        vm.filters = [
            { label: 'XRP Ledger', index: 2, checked: true },
            { label: 'Bitcoin', index: 3, checked: true },
            { label: 'Bitcoin Cash', index: 14, checked: true },
            { label: 'Ether', index: 5, checked: true },
            { label: 'Ether Classic', index: 9, checked: true },
            { label: 'Augur REP', index: 6, checked: true },
            { label: 'Dash', index: 10, checked: true },
            { label: 'Litecoin', index: 13, checked: true },
            { label: 'Flare', index: 15, checked: true },
            { label: 'EU Bank', index: 0, checked: true },
            { label: 'Bank', index: 1, checked: true },
            { label: 'Mail', index: 7, checked: true },
            { label: 'Songbird', index: 16, checked: true },
            { label: 'USDT', index: 19, checked: true },
            { label: 'USDC', index: 20, checked: true },
            { label: 'WXRP', index: 21, checked: true },
            { label: 'GALA', index: 18, checked: true },
            { label: 'UK Bank', index: 22, checked: true },
        ];

        vm.removeAccount = removeAccount;
        vm.editAccount = editAccount;
        vm.sendTo = sendTo;

        vm.resolveContactType = resolveContactType;
        vm.combineAddresAndDestTag = combineAddresAndDestTag;
        vm.filterContacts = filterContacts;

        var userID = null;

        getContacts();

        ///////////////////////////////////////////////////////////

        function getContacts() {

            Auth.getProfile().then(function(data) {
                userID = data.uid;
                AccountsService.getAccounts(true).then(function(data) {

                    allContacts = data;

                    vm.contacts = allContacts;

                    vm.loading = false;


                }, function(error) {
                    vm.error = error;
                    $exceptionHandler(error);
                })
                .finally(function() {
                    vm.loading = false;
                });
            });

        };

        function filterContacts() {

            var networkArray = vm.filters
                .filter(function(filter) { return filter.checked })
                .map(function(item) { return item.index });

            vm.contacts = allContacts.filter(function(contact) {
                return networkArray.indexOf(contact.network) > -1;
            });
        }

        function resolveContactType(network) {
            var type = '';

            switch (network) {
                case 0:
                    type = 'EU Bank';
                    break;
                case 1:
                    type = 'Bank';
                    break;
                case 2:
                    type = 'Ripple';
                    break;
                case 3:
                    type = 'Bitcoin';
                    break;
                // 4 = gatehub (hosted)
                case 5:
                    type = 'Ethereum';
                    break;
                case 6:
                    type = 'Rep';
                    break;
                case 7:
                    type = 'Mail';
                    break;
                // 8 = manual
                case 9:
                    type = 'Ethereum Classic';
                    break;
                case 10:
                    type = 'Dash';
                    break;
                // 11 = quantum (deprecated)
                // 12 = geni (deprecated)
                case 13:
                    type = "Litecoin";
                    break;
                case 14:
                    type = 'Bitcoin Cash';
                    break;
                case 15:
                    type = 'Flare';
                    break;
                case 16:
                    type = 'Songbird';
                    break;
                // 17 = mmaon
                case 18:
                    type = 'GALA';
                    break;
                case 19:
                    type = 'USDT';
                    break;
                case 20:
                    type = 'USDC';
                    break;
                case 21:
                    type = 'WXRP';
                    break;
                case 22:
                    type = 'GBP';
                    break;
                default:
                    type = 'Unknown';
                    break;
            }

            return type;
        }

        function combineAddresAndDestTag(contact) {
            var addressAndDT = contact.address + (contact.destination_tag ? ':' + contact.destination_tag : '');
            return addressAndDT;
        }

        function removeAccount(id, $event) {

            if ($event) {
                $event.stopPropagation();
            }

            if (!id) return;

            var Account = CoreRestangular.one('users', userID).one('accounts', id);

            _.remove(vm.contacts, function(contact) {
                return contact.uuid === id;
            })

            Account.remove().then(function(data) {
                // init();

            }, function(error){
                $exceptionHandler(error);
            });

        };

        function sendTo(address, dt, $event) {

            if($event !== false)
                $event.stopPropagation();

            if (!address) return;

            // Wait untill wallets are fully loaded
            WalletsService.getWallets().then(function(data) {

                // Load active wallet
                var wallet = WalletsService.getActive();

                // Something went wrong, let's stop before it gets even worse
                if(!wallet) {
                    $exceptionHandler('wallet_not_found');
                    return;
                };

                $state.go('wallets.item.send.ripple', {id: wallet[0].address, to: address, dt: dt});

            }, function(error) {
                $exceptionHandler(error);
                return;
            });

        };

        function editAccount(contact, $event) {
            if ($event) {
                $event.stopPropagation();
            }

            $uibModal.open({
                templateUrl: 'views/settings/modal_edit_contact.html',
                controller: 'EditAccountCtrl',
                controllerAs: 'vm',
                resolve: {
                    data: function () {
                        return {
                            contact: contact
                        };
                    }
                }
            });
        }
    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:AccountAddCtrl
 * @description
 * # AccountAddCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('AccountAddCtrl', ["$scope", "$stateParams", "$timeout", "$sessionStorage", "CoreRestangular", "$exceptionHandler", "Countries", function ($scope, $stateParams, $timeout, $sessionStorage, CoreRestangular, $exceptionHandler, Countries) {

        // Init
        resetForm();
        $scope.errorMessage = false;
        $scope.countries = Countries.filteredCountries; // needed for WIRE/SEPA accounts

        var userID = $sessionStorage.user.uid;
        var User = CoreRestangular.one('users', userID);

        var network_type;

        $scope.network = $stateParams.network;
        var network = $scope.network;

        // Determine network_type
        if (network == 'eubank') {
            network_type = 0;
        }
        else if (network == 'bank' || network == 'wire_gbp') {
            network_type = 1;
        }
        else if (network == 'ripple') {
            network_type = 2;
        }
        else if (network == 'bitcoin') {
            network_type = 3;
        }
        // 4 = gatehub (hosted)
        else if (network == 'ethereum') {
            network_type = 5;
        }
        else if (network == 'rep') {
            network_type = 6;
        }
        else if (network == 'mail') {
            network_type = 7;
        }
        // 8 = manual
        else if (network == 'ethereum_classic') {
            network_type = 9;
        }
        else if (network == 'dash') {
            network_type = 10;
        }
        // 11 = quantum (deprecated)
        // 12 = geni (deprecated)
        else if (network == 'litecoin') {
            network_type = 13;
        }
        else if (network == 'bitcoincash') {
            network_type = 14;
        }
        else if (network == 'flare') {
            network_type = 15;
        }
        else if (network == 'songbird') {
            network_type = 16;
        }
        else if (network == 'gala') {
            network_type = 18;
        }
        else if (network == 'usdt') {
            network_type = 19;
        }
        else if (network == 'usdc') {
            network_type = 20;
        }
        else if (network == 'wxrp') {
            network_type = 21;
        }
        else if (network == 'gbp') {
            network_type = 22;
        }
        else {
            $scope.$close();
            return;
        }

        ///////////////////////////////////////////////////////////

        function resetForm() {

            $scope.errorMessage = false;
            $scope.sending = false;
            $scope.mode = false;

            $scope.send = {};

        }

        $scope.submitForm = function(isValid) {

            $scope.errorMessage = false;

            // Make sure the form is completely valid - should be!
            if (!isValid) {
                $scope.errorMessage = "One or more required fields are invalid";
                return;
            }

            $scope.sending = true;
            $scope.mode = 'sending';

            var send = $scope.send;

            send.network = network_type;

            // Bank Names Fix
            if(network_type == 0 || network_type == 1) {
                send.legal_name = send.name;
            }

            // Destination tag fix (server doesn't allow empty string DT)
            if(send.destination_tag === ""){
              delete send.destination_tag;
            }

            var postData = JSON.stringify(send);

            User.post('accounts', postData).then(function(data) {

                $scope.sending = false;
                $scope.mode = 'success';

                $timeout(function() {
                    $scope.$close();
                }, 1000);

            }, function(err) {
                $exceptionHandler(err);
                $scope.sending = false;
                $scope.mode = 'error';
                $scope.errorMessage = err.data.message;

            });

        };

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:EditAccountCtrl
 * @description
 * # EditAccountCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
.controller('EditAccountCtrl', ["$scope", "CoreRestangular", "data", "$timeout", function ($scope, CoreRestangular, data, $timeout) {

    var vm = this;

    vm.contact = data.contact;
    // console.log(vm.contact);
    vm.contactName = vm.contact.name;

    vm.loading = false;
    vm.error = false;
    vm.done = false;

    vm.submitForm = submitForm;
    vm.closeModal = closeModal;


    function submitForm() {

        vm.loading = true;

        // todo: Add call to core when implemented
        $timeout(function() {
            vm.loading = false;
            vm.done = true;
            $timeout(function() {
                closeModal();
            }, 1000);
        }, 1000);
    }

    function closeModal () {
        $scope.$close();
    }
}]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:EidQrModalCtrl
 * @description
 * # EidQrModalCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
  .controller('EidQrModalCtrl', ["$scope", "data", function ($scope, data) {
    var vm = this;

    vm.eidUrl = data.eidUrl;
    vm.cancel = cancel;

    function cancel() {
      $scope.$dismiss();
    };

  }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:ChangepasswordCtrl
 * @description
 * # ChangepasswordCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp').controller('ChangePasswordCtrl', ChangePasswordCtrl);

function ChangePasswordCtrl($scope, coreSecurity, Auth, Restangular, $exceptionHandler, $interval) {

    var vm = this;

    var authUser = null;
    vm.loading = true;
    vm.passwordAllow = "^[\u0020-\u007E]+$";

    // Init
    resetForm()

    Auth.getProfile(true).then(function (data) {
        authUser = data;
        vm.lastPasswordChange = data.lastPasswordChange;
        vm.twoFaEnabled = data.type2fa === 'totp';
        vm.isSms2fa = data.type2fa === 'sms';
        vm.loading = false;
    }, function(error){
        $exceptionHandler(error);
    });

    vm.submitChangePassword = submitChangePassword;


    ///////////////////////////////////////////////////////////

    function resetForm() {
        vm.errorMessage = false;
        vm.sending = false;
        vm.mode = false;
        vm.settings = {};
    }

    function submitChangePassword(isValid) {
        vm.errorMessage = false;
        vm.success_message = false;
        vm.smsCodeRequired = false;

        // Make sure the form is completely valid
        if (!isValid) {
            handleError("One or more required fields are invalid", false);
            return;
        }

        vm.mode = 'sending';

        coreSecurity.unlockUser(vm.settings.current, authUser).then(function (data) {
            vm.errorMessage = false;

            // When unlocked need to lock master key and send data to api

            var pbkdf_pass;
            try {
              pbkdf_pass = coreSecurity.generate_pbkdf(vm.settings.new_password);
            }
            catch(error) {
              handleError("Please avoid using special unicode characters in password.", false);
              return;
            }
            var master_encrypted_with_new_password = coreSecurity.AESEncrypt(data.master_key, pbkdf_pass.hash);

            // Check encryption
            var master_decrypted_with_new_password = coreSecurity.AESDecrypt(master_encrypted_with_new_password, pbkdf_pass.hash, 2);

            if(master_decrypted_with_new_password !== data.master_key) {
                $exceptionHandler("Change password error [0]");
                handleError("Change password error [0]", false);
                return;
            }

            var formData = {
                password: vm.settings.new_password,
                oldPassword: vm.settings.current,
                token2fa: vm.settings.token2fa,
                meta: {
                    master_key: master_encrypted_with_new_password,
                    master_key_iterations: pbkdf_pass.iterations,
                    master_key_salt: pbkdf_pass.salt,
                    version: 2
                }
            };

            // If migration completed also encrypt old master with new password
            if(authUser.migration_status == 'completed') {

                var master_old_encrypted_with_new_password = coreSecurity.AESEncrypt(data.master_key_old, pbkdf_pass.hash);

                // Check encryption
                var master_old_decrypted_with_new_password = coreSecurity.AESDecrypt(master_old_encrypted_with_new_password, pbkdf_pass.hash, 2);

                if(master_old_decrypted_with_new_password !== data.master_key_old) {
                    $exceptionHandler("Change password error [1]");
                    handleError("Change password error [1]", false);
                    return;
                }


                formData = {
                    password: vm.settings.new_password,
                    oldPassword: vm.settings.current,
                    token2fa: vm.settings.token2fa,
                    meta: {
                        master_key: master_encrypted_with_new_password,
                        master_key_iterations: pbkdf_pass.iterations,
                        master_key_salt: pbkdf_pass.salt,
                        version: 2,

                        master_key_old: master_old_encrypted_with_new_password,
                        master_key_iterations_old: pbkdf_pass.iterations,
                        master_key_salt_old: pbkdf_pass.salt,
                        version_old: 2
                    }
                };

            };

            Restangular.one('user', 'password').customPOST(formData).then(function(data) {

                if (angular.isArray(data))
                    vm.messages = data;

                Auth.getProfile(true).then(function(data){
                    authUser = data;

                    vm.lastPasswordChange = data.lastPasswordChange;

                    vm.mode = 'success';
                    document.body.scrollTop = document.documentElement.scrollTop = 0;

                    // Reset form
                    vm.settings = {};
                    $scope.resetPasswordForm.$setPristine();

                }, function (error) {
                    $exceptionHandler(error);

                    vm.mode = 'success';
                    document.body.scrollTop = document.documentElement.scrollTop = 0;

                    // Reset form
                    vm.settings = {};
                    $scope.resetPasswordForm.$setPristine();

                });

            }, function (error) {
                var errorMessage = "";

                if (error.data.error === '2fa_sms_required') {
                    vm.smsCodeRequired = true;
                    vm.mode = 'sms2fa';
                    vm.retryData = error.data.data;
                    startSmsTimer();
                    return; // do not proceed to handle errors, further user input is required
                }

                if (error.data.error === 'common_password') {
                    errorMessage = "Provided password is insecure.";
                }
                else if (error.data.error === '2fa_wrong_token') {
                    errorMessage = "Provided verification code is not valid.";
                }
                else if (error.data.error === 'same_password') {
                    errorMessage = "New password can not be the same as old password.";
                }
                else if (error.data.error === '2fa_expired_token') {
                    errorMessage = "Provided verification code has expired.";
                }
                else if (error.data.error === 'too-many-attempts') {
                    errorMessage = "You exceeded your hourly SMS limit. <a href='/#/security/twostep'>Set up 2FA</a> to change your password now.";
                }
                else {
                    $exceptionHandler(error);
                    errorMessage = "Change password error";
                }

                handleError(errorMessage, true);
            });

        },
        function (error) {
            var errorMessage = "";
            if (error === "Wrong password") {
                errorMessage = "Current password is wrong!";
            }
            else {
                errorMessage = "Please avoid using special unicode characters in password.";
            }

            handleError(errorMessage, true);
        });
    }

    function handleError(message, clearForm) {
        vm.errorMessage = message;
        vm.mode = 'error';
        document.body.scrollTop = document.documentElement.scrollTop = 0;

        if (clearForm) {
            vm.settings = {};
            $scope.resetPasswordForm.$setPristine();
        }
    }

    vm.timer = 0;
    vm.retryData = null;
    var timerInterval = null;

    function startSmsTimer() {
        if(vm.timer > 0){
            return;
        }
        vm.timer = 30;
        timerInterval = $interval(refreshSmsResendTimer, 1000);
    }

    function refreshSmsResendTimer() {
        vm.timer--;
        if (vm.timer <= 0) {
            $interval.cancel(timerInterval);
        }
    }

    vm.resend2faSms = function() {
        if (!vm.retryData) {
            return;
        }
        if (timerInterval && vm.timer === 0) {
            $interval.cancel(timerInterval);
            
            Restangular.one('user', 'resend').one('sms').customPOST(undefined, undefined, undefined,
                {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + vm.retryData.token
                }
            ).then(function(){
                startSmsTimer();
            }).catch(function(error) {
                console.error(error);
                vm.errorMessage = "You exceeded your hourly SMS limit. <a href='/#/security/twostep'>Set up 2FA</a> to change your password now.";
                vm.smsCodeRequired = false;
                vm.mode = 'error';
                vm.retryData = null;
            });

        }
    }
}
ChangePasswordCtrl.$inject = ["$scope", "coreSecurity", "Auth", "Restangular", "$exceptionHandler", "$interval"];

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:ChangeEmailCtrl
 * @description
 * # ChangeEmailCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp').controller('ChangeEmailCtrl', ChangeEmailCtrl);

function ChangeEmailCtrl(Auth, Restangular, $scope, $exceptionHandler) {

    var vm = this;

    vm.loading = false;
    vm.error = null;
    vm.done = false;

    vm.email = '';


    Auth.getProfile().then(function (data) {
        vm.email = data.email;
    }, $exceptionHandler);

    vm.submitChangeEmail = submitChangeEmail;
    vm.closeModal = closeModal;


    ///////////////////////////////////////////////////////////


    function submitChangeEmail() {

        vm.error = false;
        vm.loading = true;

        Restangular.one('user', 'email').customPOST({
            email: vm.email
        }).then(function (data) {
            vm.done = true;
        }, function(error) {
            if (error.data.error === 'user_email_already_exists') {
                vm.error = 'Email is already taken.';
            }
            else if (error.data.error === 'email_not_changed') {
                vm.error = 'Email has not changed.';
            }
            else {
                vm.error = 'An error occured. Could not change email.';
                $exceptionHandler(error);
            }
        })
        .finally(function() {
            vm.loading = false;
        });
    }

    function closeModal () {
        $scope.$close();
    }
}
ChangeEmailCtrl.$inject = ["Auth", "Restangular", "$scope", "$exceptionHandler"];

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:ChangePhoneCtrl
 * @description
 * # ChangePhoneCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp').controller('ChangePhoneCtrl', ChangePhoneCtrl);

function ChangePhoneCtrl(IDRestangular, Auth, $scope, Countries, $exceptionHandler) {

    var vm = this;

    vm.loading = false;
    vm.error = null;
    vm.done = false;

    vm.phoneNumber = '';
    vm.ghvPin = '';
    vm.idUser = null;
    vm.verificationUuid = null;
    vm.intlTelInputOptions = { };

    vm.submitChangePhone = submitChangePhone;
    vm.goBack = goBack;
    vm.closeModal = closeModal;

    init();

    ///////////////////////////////////////////////////////////

    function init() {
        Auth.getProfile().then(function (data) {
            vm.idUser = data.identity;
        }, $exceptionHandler);

        var excludedCountriesArray = [];
        for(var i = 0; i < Countries.bannedCountries.length; i++){
            excludedCountriesArray.push( Countries.bannedCountries[i].code.toLowerCase() );
        }

        vm.intlTelInputOptions = {
            autoFormat: true,
            autoPlaceholder: true,
            defaultCountry: 'auto',
            excludeCountries: excludedCountriesArray,
            nationalMode: false
        };
    }

    function submitChangePhone() {
        vm.error = false;
        vm.loading = true;

        if (!vm.verificationUuid) {
            IDRestangular.one('users', vm.idUser.uuid).one('requestPhoneNumber').customPOST({
                phone_number: vm.phoneNumber
            }).then(function(data) {
                vm.verificationUuid = data.uuid;
                vm.ghvPin = '';
            }).catch(function(error) {
                vm.error = error.data.developerMessage;
            }).finally(function() {
                vm.loading = false;
            });
        }
        else {
            IDRestangular.one('users', vm.idUser.uuid).one('verifications', vm.verificationUuid).one('verifyPhoneNumber').customPOST({
                verification_code: vm.ghvPin
            }).then(function() {
                vm.done = true;
                vm.idUser.phone_number = vm.phoneNumber;
                setTimeout(() => {
                    closeModal();
                }, 3000);
            }).catch(function(error) {
                vm.error = error.data.developerMessage;
            }).finally(function() {
                vm.loading = false;
            });

        }
    }

    function goBack() {
        vm.verificationUuid = null;
        vm.error = null;
    }


    function closeModal () {
        $scope.$close();
    }
}
ChangePhoneCtrl.$inject = ["IDRestangular", "Auth", "$scope", "Countries", "$exceptionHandler"];

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:AntiPhishingCtrl
 * @description
 * # AntiPhishingCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp').controller('AntiPhishingCtrl', AntiPhishingCtrl);

function AntiPhishingCtrl(Auth, AuthRestangular, $exceptionHandler) {

    var vm = this;
    vm.antiPhishingMessage = '';
    vm.antiPhishingEnabled = false;
    vm.loading = true;

    vm.submitAntiPhishing = submitAntiPhishing;

    Auth.getProfile(true).then(function (data) {
        if (data.securityCode) {
            vm.antiPhishingEnabled = true;
            vm.antiPhishingMessage = data.securityCode;
        }
    }, function(error){
        $exceptionHandler(error);
    })
    .finally(function() {
        vm.loading = false;
    });

    function submitAntiPhishing(isValid){
        vm.errorMessage = false;
        vm.success_message = false;
        vm.mode = 'sending';

        if (!isValid) {
            vm.mode = 'error';
            vm.errorMessage = "One or more required fields are invalid";
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            return;
        }

        var antiPhishingMessage = vm.antiPhishingMessage;
        AuthRestangular.one('user', 'security_code').customPOST({
            securityCode: antiPhishingMessage
          }).then(function (data) {
              vm.mode = 'success';
              vm.success_message = 'Great job! We sent you an email with your new Anti-phishing message.';
              vm.antiPhishingEnabled = true;
          }, function(error){
              vm.mode = 'error';
              vm.errorMessage = 'An error occured. Could not update Anti-phishing message.';
              $exceptionHandler(error);
          });
    }

}
AntiPhishingCtrl.$inject = ["Auth", "AuthRestangular", "$exceptionHandler"];

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:WalletSettingsCtrl
 * @description
 * # WalletSettingsCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('WalletSettingsCtrl', ["Auth", "CoreRestangular", "$exceptionHandler", "$uibModal", "ExportService", function (Auth, CoreRestangular, $exceptionHandler, $uibModal, ExportService) {

        var vm = this;
        // vm variables
        vm.wallets = [];

        vm.typeFilter = '';

        vm.loading = true;
        vm.errorMessage = null;

        // vm methods
        vm.openExportModal = openExportModal;
        vm.filterWalletTypes = filterWalletTypes;

        getWallets();

        function getWallets() {

            vm.loading = true;

            var filteredTypes = [];
            switch (vm.typeFilter) {
                case 'hosted':
                    filteredTypes = [0];
                    break;
                case 'xrpl':
                    filteredTypes = [10, 11];
                    break;
                case 'psd':
                    filteredTypes = [24];
                    break;
                default:
                    filteredTypes = [0, 10, 11, 24];
                    break;
            }

            Auth.getProfile().then(function(user) {
                CoreRestangular
                    .one('users', user.uid)
                    .get({ includeDeleted: true })
                    .then(function(data) {
                        vm.wallets = _.filter(data.wallets, function (wallet) { 
                            var isAllowedType = filteredTypes.indexOf(wallet.type) > -1; // keep only hosted, xrpl and bank wallets (no shadow)
                            var isPsdAndNotDeleted = (wallet.type === 24) ? !wallet.deleted : true; // if psd, remove deleted ones
                            return isAllowedType && isPsdAndNotDeleted;
                        });
                }, function(error) {
                    $exceptionHandler(error);
                    vm.errorMessage = 'Error fetching wallets.';
                })
                .finally(function() {
                    vm.loading = false;
                });
            });
        }

        function filterWalletTypes(type) {
            console.log(vm.typeFilter, type);
            if (vm.typeFilter !== type) {
                vm.typeFilter = type;
                getWallets();
            }

        }

        function openExportModal(wallet) {
            $uibModal.open({
                templateUrl: 'views/settings/modal_export_wallets.html',
                controller: 'ExportCtrl',
                controllerAs: 'vm',
                resolve: {
                    data: function () {
                        return {
                            wallet: wallet
                        };
                    }
                }
            });
        }

        vm.setOrderSort = function(property){
          vm.orderSortReverse = (vm.orderSortBy === property) ? !vm.orderSortReverse : false;
          vm.orderSortBy = property;
          //refreshOffersArray();
        }

        vm.getSortArrowClass = function(type){
          if(type == vm.orderSortBy){
            if(vm.orderSortReverse){
              return "sort_desc";
            } else {
              return "sort_asc";
            }
          } else {
            return "sortable";
          }
        }

    }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:ExportCtrl
 * @description
 * # ExportCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('ExportCtrl', ["$scope", "data", "$exceptionHandler", "ExportService", function ($scope, data, $exceptionHandler, ExportService) {

        var vm = this;

        vm.exportHeaderHosted = ExportService.getHostedExportHeader();
        vm.exportHeaderRipple = ExportService.getRippleExportHeader();
        vm.exportHeaderPsd = ExportService.getPsdExportHeader();

        vm.loading = false;
        vm.error = null;
        vm.done = false;

        vm.orderSortReverse = false;
        vm.orderSortBy = 'created_at';

        vm.walletType = data.wallet.type;
        vm.address = data.wallet.address;
        if (vm.walletType === 24) {
            vm.iban = data.wallet.meta.iban ? data.wallet.meta.iban : '-';
        }

        vm.datePickerOpts = {
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Apply",
                fromLabel: "From",
                format: "MMM D, YYYY",
                toLabel: "To",
                cancelLabel: 'Cancel',
                customRangeLabel: 'Custom range',
                autoApply: 'true'
            },
            ranges: {
                Today: [new Date, new Date],
                Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
                "Last 7 Days": [moment().subtract(6, "days"), new Date],
                "Last 30 Days": [moment().subtract(29, "days"), new Date],
                "This Month": [moment().startOf("month"), moment().endOf("month")],
                "Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")],
                "This Year": [moment().startOf("year"), moment().endOf("year")],
                "Last Year": [moment().subtract(1, "year").startOf("year"), moment().subtract(1, "year").endOf("year")],
                "All Time": [moment().year(2012).startOf("year"), new Date()]
            },
            drops: 'down'
        };

        // for PSD wallets we only store 1 year of data, so remove "Last year" from options
        vm.datePickerOptsPSD = angular.copy(vm.datePickerOpts);
        delete vm.datePickerOptsPSD.ranges["Last Year"];

        vm.exportRange = { startDate: null, endDate: null };

        // vm methods
        vm.startExport = startExport;
        vm.closeModal = closeModal;
        vm.setOrderSort = setOrderSort;
        vm.getSortArrowClass = getSortArrowClass;

        function startExport(from, to) {

            vm.loading = true;
            vm.error = "";

            var exportPromise = null;
            if (vm.walletType === 0) {
                exportPromise = ExportService.hostedExport(vm.address, from, to);
            }
            else if (vm.walletType === 24) {
                exportPromise = ExportService.psdExport(vm.address, from, to);
            }
            else {
                exportPromise = ExportService.rippleExport(vm.address, from, to);
            }

            return exportPromise.then(function (result) {
                vm.done = true;
                setTimeout(function () {
                    closeModal();
                }, 4000);
                return result;
            }, function (error) {
                vm.error = "There was an error exporting transactions from wallet " + vm.address + ".";

                $exceptionHandler(error);
                console.log("Error exporting hosted transactions: ", error);

                return false;
            })
            .finally(function () {
                vm.loading = false;
            });
        }

        function closeModal(result) {
            $scope.$close(result || false);
        }

        function setOrderSort(property) {
            $scope.orderSortReverse = ($scope.orderSortBy === property) ? !$scope.orderSortReverse : false;
            $scope.orderSortBy = property;
            //refreshOffersArray();
        }

        function getSortArrowClass(type) {
            if (type == $scope.orderSortBy) {
                if ($scope.orderSortReverse) {
                    return "sort_desc";
                } else {
                    return "sort_asc";
                }
            } else {
                return "sortable";
            }
        }

    }]);

"use strict";

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:WalletTxCtrl
 * @description
 * # WalletTxCtrl
 * Controller of the gatehubClientApp
 */
angular
    .module("gatehubClientApp")
    .controller("MultisigSetupCtrl", ["$exceptionHandler", "$scope", "MultisigRestangular", "data", "$timeout", "RippleNetwork", "CoreRestangular", "instantMemory", "RippleTx", "coreSecurity", "$q", "$localStorage", "TrackingService", function(
        $exceptionHandler,
        $scope,
        MultisigRestangular,
        data,
        $timeout,
        RippleNetwork,
        CoreRestangular,
        instantMemory,
        RippleTx,
        coreSecurity,
        $q,
        $localStorage,
        TrackingService
    ) {

/* ----------------------------------- Controller Setup -----------------------------------------*/

        var vm = this;

        // Input data
        vm.address = data.address;
        vm.user = data.user;
        vm.wallet = data.wallet;
        vm.isRenewal = data.isRenewal || false;

        /* Possible statuses:
        INIT (only on frontend for flow management)
        PREPARE_SETUP
        SIGNERS_TRANSACTION
        TEST_TRANSACTION
        DISABLE_REGULAR_TRANSACTION
        DISABLE_MASTER_TRANSACTION
        ENABLED
        UPGRADE_PREPARE (only on frontend for flow management)
        UPGRADE_PLAN
        UPDATE_INSURANCE
        CREATE_INVOICE
        */
        vm.multisigStatusInfo = null;
        vm.multisigStatus = null;

        // 0: welcome, 1: plan select, 2: payment overview, 3: progress screen
        vm.initStep = 0;
        vm.step = 0;
        vm.done = false;
        vm.isUpgrade = false;

        vm.confirmedToc = false;
        vm.confirmedDisable = false;

        // plan select
        vm.plans = [];
        vm.selectedPlanIndex = -1;
        vm.paymentOptions = [];
        vm.selectedPaymentOptionIndex = 0;
        vm.paymentOptionsLoading = false;
        vm.pathFinding = null;

        vm.secrets = null;
        vm.pubKeyData = null

        vm.loading = false;
        vm.account = null;
        vm.error = null;
        var scopeActive = true;

        vm.continueInit = continueInit;
        vm.handleStep = handleStep;
        vm.getPlanDateRange = getPlanDateRange;
        vm.closeModal = closeModal;

        // Lock
        vm.isUnlocked = coreSecurity.is2FaAuthorized();
        if (vm.isUnlocked) {
            getSecrets();
        } else {
            var listener = $scope.$on('2fa_authorized', function (event, secrets) {
                vm.isUnlocked = true;
                vm.secrets = secrets;
                initData();
                listener();
            });
        }

/* ----------------------------------- Process Functions -----------------------------------------*/

        function initData() {
            vm.loading = true;

            TrackingService.emitRouteChangeEvent('/wallet_protect_modal_open');

            MultisigRestangular.one("wallet", vm.address).one("eligible").get().then(function() {
                getAccountInfo(vm.address).then(function(account) {
                    // Account found and funded
                    vm.account = account.account_data;

                    var disableMasterFlag = 0x00100000;
                    var isDisabledMaster = (vm.account.Flags & disableMasterFlag) > 0;

                    getWalletMultisigStatus().then(function() {
                        // If multisig is enabled on start
                        console.log(vm.multisigStatus);

                        if (vm.multisigStatus.status === 'ENABLED') {
                            vm.initStep = 1; // go directly to plans
                            if (vm.isRenewal) {
                                vm.multisigStatus.status = 'RENEW_PREPARE'  // helper status, only on FE
                            }
                            else {
                                vm.multisigStatus.status = 'UPGRADE_PREPARE'  // helper status, only on FE
                            }
                            vm.isUpgrade = true;
                            resolveStep();
                            handleStep();
                        }
                        if (vm.step > 9) {
                            vm.isUpgrade = true;
                        }
                    });
                })
                .catch(function(error) {
                    if (error.remote && error.remote.error === 'actNotFound') {
                        vm.error = 'A funded wallet is required to enable Wallet Protect.';
                    }
                    else {
                        vm.error = error.remote.error_message;
                        $exceptionHandler('[Multisig] Get XRPL Account info error', error);
                    }
                    vm.loading = false;
                });
            })
            .catch(function(error) {
                handleSetupError(error, 'not_eligible');
            });

        }

        function getWalletMultisigStatus(continueSetup) {
            return MultisigRestangular.one("wallet", vm.address)
                .get()
                .then(function(response) {
                    console.log(response.info);

                    if (!vm.multisigStatus && response.info.substatus === 'PENDING') {
                        vm.error = 'A transaction is still being validated. Try again in a few moments.';
                    }


                    // deleted wallet exist with theese statuses. triger init
                    if (response.info.status === 'DISABLED' && response.info.substatus === 'COMPLETED') {
                        vm.multisigStatus = {
                            status: "INIT",
                            substatus: ""
                        };
                        return;
                    }

                    vm.multisigStatusInfo = response.info;
                    vm.multisigStatus = {
                        status: response.info.status,
                        substatus: response.info.substatus
                    };
                })
                .catch(function(error) {
                    // if not found, start process
                    if (error.status === 404) {
                        // multisigStatus doesn't exist yet. assign INIT value to handle process
                        vm.multisigStatus = {
                            status: "INIT",
                            substatus: ""
                        };
                    } else {
                        handleSetupError(error, 'get_status');
                    }
                })
                .finally(function() {
                    resolveStep();
                    if (continueSetup && scopeActive) {
                        handleStep();
                    }
                    else {
                        vm.loading = false;
                    }
                });
        }

        /* ----------------------------------- Setup Step Handlers ---------------------------------------*/

        function resolveStep() {
            switch (vm.multisigStatus.status) {
                case "INIT":        // helper status
                    vm.step = 0;
                    break;
                // case "PREPARE_SETUP":
                //     vm.step = 1;
                //     break;
                case "SIGNERS_TRANSACTION":
                    vm.step = 2;
                    break;
                case "TEST_TRANSACTION":
                    vm.step = 3;
                    break;
                case "DISABLE_REGULAR_TRANSACTION":
                    vm.step = 4;
                    break;
                case "DISABLE_MASTER_TRANSACTION":
                    vm.step = 5;
                    break;
                case "SEND_RECOVERY_DATA":
                    vm.step = 6;
                    break;
                case "CREATE_COINCOVER_INSURANCE":
                    vm.step = 7;
                    break;
                case "CREATE_INVOICE":
                    // status is same for initial and upgrade so we distinguish them for each flow
                    vm.step = !vm.isUpgrade ? 8 : 13;
                    break;
                case "ENABLED":
                    // status is same for initial and upgrade so we distinguish them for each flow
                    vm.step = !vm.isUpgrade ? 9 : 14;
                    break;
                case "RENEW":
                    vm.step = 11;
                    break;
                case "UPGRADE_PREPARE": // helper status
                case "UPGRADE_PLAN":
                case "RENEW_PREPARE":
                    vm.step = 10;
                    // step 11 comes always after the plan select, not from the actually status
                    // because we need the plan id, if UPGRADE_PLAN was canceled prior
                    break;
                case "UPDATE_INSURANCE":
                    vm.step = 12;
                    break;
                case "CREATE_INVOICE":
                    vm.step = 13;
                    break;
                default:
                    vm.step = -1;
                    vm.error = "Unexpected multi-sign status.";
                    break;
            }

            console.log(vm.multisigStatus.status, 'Resolved step: ', vm.step);
        }

        function handleStep() {
            vm.error = null;
            vm.confirmed = false;

            switch (vm.step) {
                case 0:
                    console.log('Step 0: get plans');
                    getAvailablePlans()
                        .then(function() { vm.step++; });
                    break;
                case 1:
                    console.log('Step 1: Init setup');
                    TrackingService.emitRouteChangeEvent('/wallet_protect_setup_initiated');
                    initWalletMultisig();
                    break;
                case 2:
                    console.log('Step 2: Submit signers tx');
                    submitSignersTX();
                    break;
                case 3:
                    console.log('Step 3: Submit test tx');
                    submitTestTX();
                    break;
                case 4:
                    console.log('Step 4: Disable Regular');
                    disableRegularKey();
                    break;
                case 5:
                    console.log('Step 5: Disable master');
                    disableMasterKey();
                    break;
                case 6:
                    console.log('Step 6: Send recovery data');
                    sendRecoveryData();
                    break;
                case 7:
                    console.log('Step 7: Create insurance');
                    createConincoverInsurance();
                    break;
                case 8:
                    console.log('Step 8: Create invoice');
                    createInvoice();
                    break;
                case 10:
                    console.log('Step 10: get upgrade plans');
                    getAvailablePlans()
                        .then(function() { vm.step++; });
                    break;
                case 11:
                    console.log('Step 11: upgrade plan');
                    upgradePlan();
                    break;
                case 12:
                    console.log('Step 12: upgrade insurance...');
                    upgradeInsurance();
                    break;
                case 13:
                    console.log('Step 13: Create invoice...');
                    createInvoice();
                    break;
                case 15:
                    console.log('Step 15: Init renewal');
                    initRenew();
                    break;

                case 9:
                case 14:
                    vm.done = true;
                    RippleTx.setMultisigStatus(vm.address, true, vm.multisigStatusInfo);
                    $timeout(function() {
                        closeModal();
                    }, 4000);
                    break;
                default:
                    console.log('Unknown step');
                    break;
            }
        }

        function continueInit(processState) {
            // If setup already started, go to progress screen. except on upgrade
            console.log(vm.step, processState);

            if (
                // for a normal flow in progress
                (vm.step > 1 && vm.step <= 9) ||
                // for an upgrade flow with plan already upgraded
                (vm.isUpgrade && vm.step > 11)
            ) {
                vm.initStep = 3;
            }
            else {
                vm.initStep++;
            }
            if (vm.initStep === 2) {
                getPaymentOptions();
            }
            if (vm.initStep === 3 && vm.pathFinding) {
                vm.pathFinding.close();
                vm.pathFinding = null;
            }

            if (processState) {
                // resolveStep();
                handleStep();
            }

        }

        // Step 0
        function getAvailablePlans() {
            vm.loading = true;

            var plansPromise = MultisigRestangular.one("plan");
            if (vm.isRenewal) {
                plansPromise = MultisigRestangular.one("wallet", vm.wallet.address).one("renewal_plans")
            }
            else if (vm.isUpgrade) {
                plansPromise = MultisigRestangular.one("wallet", vm.wallet.address).one("upgrade")
            }

            return plansPromise
                .get()
                .then(function(response) {
                    vm.plans = response.data;

                    var userPlanUuid = null;
                    if (vm.multisigStatusInfo && vm.multisigStatusInfo.plan) {
                        userPlanUuid = vm.multisigStatusInfo.plan.uuid;
                    }
                    vm.plans.forEach((plan, index) => {
                        plan._price = {
                            total:plan.price.total,
                            isSpecialOffer: false
                        };

                        if (plan.price.withDiscount) {
                            if (plan.price.withDiscount.total) {
                                plan._price.isSpecialOffer = true;
                                plan._price.total = plan.price.withDiscount.total;
                            }

                            if (plan.price.withDiscount.unusedCredits) {
                                plan._price.total = plan.price.withDiscount.unusedCredits.payment;
                            }
                        }

                        if (plan.uuid === userPlanUuid) {
                            vm.selectedPlanIndex = index;
                        }
                    });
                })
                .catch(function(error) {
                    vm.error = error.data.message;
                })
                .finally(function() {
                    vm.loading = false;
                });
        }

        // Step 1
        function initWalletMultisig() {
            vm.loading = true;
            var deferred = $q.defer();

            const signerWallet = ripple.Wallet.generate();

            try {
                !ripple.Seed.from_json(signerWallet.secret).get_key(signerWallet.address);
            }
            catch (error) {
                handleSetupError(error, 'pubkey_setup');
                return;
            }
            var base_security = instantMemory.getValue('base_security');
            var master_key = base_security.master_key;
            var secretEncrypted = coreSecurity.AESEncrypt(signerWallet.secret, master_key);

            var signerData = {
                multisign_address: signerWallet.address,
                multisign_secret: secretEncrypted
            };

            CoreRestangular.one('users', vm.user.id).one('wallets', vm.wallet.address)
                .customPUT(signerData)
                .then(function(walletData) {
                    MultisigRestangular.one('wallet')
                        .customPOST({
                            address: vm.address,
                            weight: 1,
                            signPubKey: signerWallet.address,
                            plan: vm.plans[vm.selectedPlanIndex].uuid
                        })
                        .then(function() {
                            // save multisign secrets for the session
                            vm.secrets.multisign_address = signerWallet.address;
                            vm.wallet.multisign_address = signerWallet.address;
                            vm.secrets.multisign_secret = secretEncrypted;
                            vm.secrets.multisign_secret_decoded = signerWallet.secret;

                            deferred.resolve();
                            getWalletMultisigStatus(true);
                        })
                        .catch(function(error) {
                            handleSetupError(error, 'start_setup');
                            deferred.reject(error);
                        });

                })
                .catch(function(error) {
                    handleSetupError(error, 'pubkey_setup');
                    deferred.reject(error);
                });


            return deferred.promise;
        }

        // Step 2
        function submitSignersTX() {
            vm.loading = true;

            getSetupTX('signers_tx').then(function(response) {
                var signedTx = window.sign(response.txJSON, vm.secrets.secret_decoded).signedTransaction;

                postSetupTX(response.txJSON, signedTx, 'signers_tx')
                    .then(function(postResponse) {
                        getWalletMultisigStatus(true);
                    })
                    .catch(function(error) {
                        handleSetupError(error, 'tx_submit');
                    });
            })
            .catch(function(error) {
                handleSetupError(error, 'get_tx');
            });
        }

        // Step 3
        function submitTestTX() {
            vm.loading = true;

            if (!vm.paymentOptions.length) {
                vm.initStep = 2;    // plan select screen
                getAvailablePlans().then(function() {
                    getPaymentOptions();
                });
                return;
            }

            var selectedPaymentOption = vm.paymentOptions[vm.selectedPaymentOptionIndex];
            var queryParams = {};
            if (!selectedPaymentOption.amount.is_native()) {
                queryParams = {
                    assetCode: selectedPaymentOption.amount.currency().to_json(),
                    issuer: selectedPaymentOption.amount.issuer().to_json(),
                    paths: btoa(JSON.stringify(selectedPaymentOption.paths))
                };
            }


            MultisigRestangular.one('wallet', vm.address).one('test_tx').get(queryParams)
                .then(function(response) {
                    var signedTx = window.sign(response.txJSON, vm.secrets.multisign_secret_decoded, { signAs: vm.secrets.multisign_address }).signedTransaction;

                    // return;
                    postSetupTX(response.txJSON, signedTx, 'test_tx')
                        .then(function(postResponse) {
                            getWalletMultisigStatus(true);
                        })
                        .catch(function(error) {
                            handleSetupError(error, 'tx_submit');
                        });
                })
                .catch(function(error) {
                    handleSetupError(error, 'get_tx');
                });
        }

        // Step 4
        function disableRegularKey() {
            vm.loading = true;

            getSetupTX('disable_regular_tx').then(function(response) {
                var signedTx = window.sign(response.txJSON, vm.secrets.secret_decoded).signedTransaction;

                postSetupTX(response.txJSON, signedTx, 'disable_regular_tx')
                    .then(function(postResponse) {
                        getWalletMultisigStatus(true);
                    })
                    .catch(function(error) {
                        handleSetupError(error, 'tx_submit');
                    });
            })
            .catch(function(error) {
                handleSetupError(error, 'get_tx');
            });
        }

        // Step 5
        function disableMasterKey() {
            vm.loading = true;

            getSetupTX('disable_tx').then(function(response) {
                var signedTx = window.sign(response.txJSON, vm.secrets.secret_decoded).signedTransaction;

                postSetupTX(response.txJSON, signedTx, 'disable_tx')
                    .then(function(postResponse) {
                        getWalletMultisigStatus(true);
                    })
                    .catch(function(error) {
                        handleSetupError(error, 'tx_submit');
                    });
            })
            .catch(function(error) {
                handleSetupError(error, 'get_tx');
            });
        }

        // Step 6
        function sendRecoveryData() {
            MultisigRestangular.one('wallet', vm.address).one('send_recovery_data')
                .customPOST()
                .then(function(response) {
                    getWalletMultisigStatus(true);
                })
                .catch(function(error) {
                    handleSetupError(error, 'send_recovery_data');
                })
        }
        // Step 7
        function createConincoverInsurance() {
            MultisigRestangular.one('wallet', vm.address).one('create_insurance')
                .customPOST()
                .then(function(response) {
                    getWalletMultisigStatus(true);
                })
                .catch(function(error) {
                    handleSetupError(error, 'create_insurance');
                });
        }
        // Step 8
        function createInvoice() {
            MultisigRestangular.one('wallet', vm.address).one('create_invoice')
                .customPOST()
                .then(function(response) {
                    getWalletMultisigStatus(true);
                })
                .catch(function(error) {
                    handleSetupError(error, 'create_invoice');
                });
        }

        // Step 11
        function upgradePlan() {
            var endpoint = '';
            if (vm.isRenewal) {
                endpoint = 'renew';
            }

            else {
                endpoint = 'upgrade/plan/' + vm.plans[vm.selectedPlanIndex].uuid;
                // Because WP setup is already complete, status wont transition automatically.
                // We set it here explicitly to have correct status checking
                vm.multisigStatus.status = 'UPGRADE_PLAN';
            }

            if (vm.isRenewal && vm.multisigStatus.status === 'RENEW_PREPARE') {
                initRenew();
                return;
            }

            getSetupTX(endpoint).then(function(response) {
                var signedTx = window.sign(response.txJSON, vm.secrets.multisign_secret_decoded, { signAs: vm.secrets.multisign_address }).signedTransaction;

                postSetupTX(response.txJSON, signedTx, endpoint)
                    .then(function(postResponse) {
                        getWalletMultisigStatus(true);
                    })
                    .catch(function(error) {
                        handleSetupError(error, 'tx_submit');
                    });
            })
            .catch(function(error) {
                handleSetupError(error, 'get_tx');
            });
        }

        // Step 12
        function upgradeInsurance() {
            MultisigRestangular
                .one('wallet', vm.address)
                .one('update_insurance')
                .customPOST()
                .then(function(response) {
                    getWalletMultisigStatus(true);
                })
                .catch(function(error) {
                    handleSetupError(error, 'update_insurance');
                });
        }

        // Step 15
        function initRenew() {
            vm.loading = true;

            MultisigRestangular
                .one('wallet', vm.address)
                .one('renew')
                .customPOST()
                .then(function(response) {
                    getWalletMultisigStatus(true);
                })
                .catch(function(error) {
                    handleSetupError(error, 'renew');
                });
        }

/* ----------------------------------- Helper Functions -----------------------------------------*/

        function getAccountInfo(address) {
            return new Promise(function(resolve, reject) {
                RippleNetwork.remote.account(address).entry(function(error, account) {
                    if (error) {
                        reject(error);
                    }
                    else {
                        resolve(account);
                    }
                });
            })
        }

        /**
         * @param {string} tx - options: 'signers_tx', 'test_tx', 'disable_regular_tx', 'disable_tx'
         */
        function getSetupTX(tx) {
            return MultisigRestangular.one('wallet', vm.address).one(tx).get();
        }

        /**
         * @param {string} txJSON - transaction json string
         * @param {string} signedTx - signed tx blob
         * @param {string} tx - options: 'signers_tx', 'test_tx', 'disable_regular_tx', 'disable_tx'
         */
        function postSetupTX(txJSON, signedTx, tx) {
            var deferred = $q.defer();

            MultisigRestangular.one('wallet', vm.address).one(tx)
                .customPUT({
                    txJSON: txJSON,
                    signedTransaction: signedTx
                })
                .then(function(tx) {
                    var currentSetupState = vm.multisigStatus.status;

                    if (!RippleTx.wasTxSuccessful(tx)) {
                        deferred.reject(tx);
                        return;
                    }
                    (function pollSetupStatus() {
                        MultisigRestangular.one("wallet", vm.address).get().then(function(setupStatus) {
                            var activeState = setupStatus.info.status;
                            console.log('Setup status', currentSetupState, activeState);
                            if (!activeState) {
                                deferred.reject(new Error('No setup status'));
                                return;
                            }

                            else if (!scopeActive) {
                                return;
                            }

                            // check if status has progressed
                            else if (currentSetupState !== activeState) {
                                deferred.resolve(setupStatus);
                            }
                            else {
                                $timeout(function() {
                                    pollSetupStatus();
                                }, 1000);
                            }
                        })
                        .catch(function(error) {
                            deferred.reject(error);
                        });
                    })();
                })
                .catch(function(error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        function handleSetupError(error, errorCode) {
            console.log('Setup error', error, errorCode);
            // if error message from exists
            if (error.data && error.data.message) {
                vm.error = error.data.message;
            }
            // if tx error exists
            else if (error.resultMessage) {
                vm.error = error.resultMessage
            }
            else {
                switch (errorCode) {
                    case 'init':
                        vm.error = 'There was a problem with starting the multi-sign setup process. Please try again later.';
                        break;
                    case 'get_status':
                        vm.error = 'There was a problem with retrieving your multi-sign status. Please try again later.';
                        break;
                    case 'pubkey_setup':
                        vm.error = 'There was a problem setting your signer key. Please try again.';
                        break;
                    case 'start_setup':
                        vm.error = 'There was a problem starting the multi-sign setup. Please try again.';
                        break;
                    case 'get_tx':
                        vm.error = 'Setup transaction status check error. Retry later.';
                        break;
                    case 'tx_submit':
                        vm.error = 'Error submitting the transaction.'
                        break;
                    case 'test_tx':
                        vm.error = 'Error on posting the test transaction.'
                        break;
                    case 'tecUNFUNDED_PAYMENT':
                        vm.error = 'Insufficient balance for transaction.';
                        break;
                    case 'send_recovery_data':
                        vm.error = 'Error creating recovery data.';
                        break;
                    case 'create_insurance':
                        vm.error = 'Error creating insurance.';
                        break;
                    case 'create_invoice':
                        vm.error = 'Error creating an invoice.';
                        break;
                    case 'renew':
                        vm.error = 'Error starting renew process.';
                        break;
                    default:
                        vm.error = 'Something unexpectedly went wrong. Retry later.'
                        break;
                }
            }
            vm.loading = false;
            var errorFormatted = "[Multisig] Service error (" + errorCode + ")";
            $exceptionHandler(errorFormatted, error);
        }

        function getPlanDateRange() {
            var plan = vm.multisigStatusInfo ? vm.multisigStatusInfo.plan : vm.plans[vm.selectedPlanIndex];
            if (!plan) {
                return '';
            }

            var duration = plan.duration;
            return moment().add(duration.value, duration.interval).format('MMMM D, YYYY');
        }

        function getSecrets() {
            vm.loading = true;
            RippleTx.getSecrets(vm.wallet).then(function(secrets){
                vm.secrets = secrets;
                vm.error = null;
                vm.loading = false;
                initData();
            }, function(error) {
                if (error.status === 403 && error.data.message && error.data.message.toLowerCase() === '2fa required') {
                    vm.isUnlocked = false;
                    vm.loading = false;
                    var listener = $scope.$on('2fa_authorized', function(event, secrets) {
                        vm.isUnlocked = true;
                        vm.secrets = secrets;
                        vm.error = null;
                        initData();
                        listener();
                    });
                }
            });
        };

        function getPaymentOptions() {
            vm.loading = true;
            vm.paymentOptions = [];

            // if plan is not selected, go to plan select screen
            if (!vm.plans.length || vm.selectedPlanIndex < 0) {
                vm.initStep = 1;
                vm.loading = false;
                return;
            }


            const amountInXrp = vm.plans[vm.selectedPlanIndex].priceInXrp;
            if (vm.wallet.xrp > amountInXrp) {
                vm.paymentOptions.push({
                    amount: Amount.from_human(amountInXrp + 'XRP'),
                    paths: []
                });
                vm.selectedPaymentOptionIndex = 0;
            }

            return MultisigRestangular.one('wallet', vm.address).one('test_tx/paths').get({ planId: vm.plans[vm.selectedPlanIndex].uuid })
                .then(function(response) {
                    vm.paymentOptions.push(...response.map(function(path) {
                        var source = path.source;
                        var amount = Amount.from_human(source.maxAmount.value + source.maxAmount.currency);
                        var paths = JSON.parse(path.paths);
                        if (paths.length && paths[0][0].account) {
                            amount.set_issuer(paths[0][0].account);
                        }
                        return {
                            amount: amount,
                            paths: paths
                        };
                    }));
                })
                .catch(function(error) {
                    console.log(error);
                })
                .finally(function() {
                    vm.loading = false;
                });

        }

        // Set flag to prevent further background polling
        $scope.$on("$destroy", function() {
            scopeActive = false;
        });

        function closeModal (suppressWpBanner) {
            TrackingService.emitRouteChangeEvent('/wallet_protect_modal_cancelled');
            if (suppressWpBanner) {
                const acknowledgedWP = $localStorage['ghMultisignAck'] || [];
                acknowledgedWP.push(vm.wallet.address);
                $localStorage['ghMultisignAck'] = acknowledgedWP;
            }
            $scope.$close(vm.multisigStatus && vm.multisigStatus.status === "ENABLED");
        };

    }]);

"use strict";

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:SongbirdCtrl
 * @description
 * # SongbirdCtrl
 * Controller of the gatehubClientApp
 */
angular
  .module("gatehubClientApp")
  .controller("SongbirdCtrl", ["$scope", "$rootScope", "WalletsService", "$timeout", "$exceptionHandler", "SgbRestangular", "$state", "VaultsService", function ($scope, $rootScope, WalletsService, $timeout, $exceptionHandler, SgbRestangular, $state, VaultsService) {

    var vm = this;

    var sgbWalletAddress;
    var vault = VaultsService.getVaultByCurrency('SGB');
    vm.loading = true;

    // scope functions
    vm.giveConsentAndClaimSgb = giveConsentAndClaimSgb;
    vm.setSgbTrust = setSgbTrust;
    vm.closeModal = closeModal;

    if (!vault) {
      vm.error = 'no_vault';
      $exceptionHandler('sgb_vault_missing');
      return;
    }

    init();

    function init() {
      WalletsService.getWallets().then(function () {
        var wallet = WalletsService.getActive();
        if (!wallet) { // Something went wrong, stop before it gets even worse
          $exceptionHandler('wallet_not_found');
          return false;
        };
        vm.wallet = wallet[0];

        if (vm.wallet.loadingLines) {
          $timeout(function() {
            init();
          }, 1000);
          return;
        }
        vm.isXrplWallet = vm.wallet.type === 10 || vm.wallet.type === 11;

        // Get address based on wallet type
        if (vm.isXrplWallet) {
          sgbWalletAddress = wallet[0].shadow_address;
        } else if (wallet[0].type === 0) {
          sgbWalletAddress = wallet[0].address;
        } else {
          $exceptionHandler('sgb_not_allowed_for_psd_wallets');
          return false;
        }

        checkVault().then(function(){
          SgbRestangular.one("account", sgbWalletAddress).get().then(function (response) {
            if (response.consented) {
              goToDeposit();
            }
          });
        }).finally(function() {
          vm.loading = false;
        });

      }, function (error) {
        $exceptionHandler(error);
        return;
      });
    }

    function giveConsentAndClaimSgb() {
      SgbRestangular.one("account", sgbWalletAddress).one('consent').customPUT({}).then(function (response) {
        if (response.consented) {
          goToDeposit();
        }
      }, function (error) {
        $exceptionHandler(error);
      });
    }

    function setSgbTrust() {
      $state.go('wallets.item.trust', {
        issuer: vault.cold,
        currency: vault.currency,
        redirect: 'wallets.item.balance.sgbclaim'
      });
      // close here must have a param not to get redirected to balances, as defined in app.js router
      $scope.$close('setTrust');
    }

    function checkVault() {
      return VaultsService.getConnectedVaults().then(function (vaults) {
        for (var i = vaults.length - 1; i >= 0; i--) {
          if (vaults[i].asset_code === vault.currency) {
            // 1 = active, 3 = action required
            if (vaults[i].gateway_connection_status === 1 || vaults[i].gateway_connection_status === 3) {
              if (vm.isXrplWallet) {
                checkTrustline();
                $scope.$watch('wallet.lines', function() {
                    checkTrustline();
                });
                return;
              }
            } else {
              vm.error = 'gateway_pending';
              return;
            }
            return; // no error = gateway is connected
          }
        }
        vm.error = 'gateway_not_connected';
      }, function(error) {
        $exceptionHandler(error);
      });
    };

    function checkTrustline() {
      vm.error = false;
      if (typeof vm.wallet.lines === 'undefined') {
        vm.error = "sgb_trustline_missing";
        return;
      };
      if (typeof vm.wallet.lines[vault.cold + vault.currency] !== 'undefined') {
        var _line = vm.wallet.lines[vault.cold + vault.currency];
        if (_line._limit == 0) {
          vm.error = "sgb_trustline_missing";
        }
      } else {
        vm.error = "sgb_trustline_missing";
      }
    };

    function goToDeposit() {
      $scope.$close('goToDepositSGB');
    }

    function closeModal() {
      $scope.$close();
    }

  }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:RedirectCtrl
 * @description
 * # RedirectCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
  .controller('RedirectCtrl', ["ENV", "$scope", function (ENV, $scope) {

    $scope.redirectUri = location.protocol + '//' + location.host + '/#/token';
    $scope.signinUrl = ENV.apiSignin;
    $scope.clientID = ENV.clientID;
  }]);

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:FeatureCtrl
 * @description
 * # FeatureCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
    .controller('FeatureCtrl', ["FeatureService", "Auth", function (FeatureService, Auth) {
        var vm = this;

        vm.featureSupported = FeatureService.isSupportedFeature();
        vm.userFeatures = { };

        Auth.getProfile().then(function(user) {
            if (Array.isArray(user.features)) {
                user.features.forEach(function(feature) {
                    vm.userFeatures[feature] = true;
                });
            }
        })


    }]);

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.identity
 * @description
 * # identity
 * Factory in the gatehubClientApp.
 */
angular
    .module('gatehubClientApp')
    .factory('FeatureService', FeatureService);

FeatureService.$inject = ['$state', 'ENV', 'Auth'];

function FeatureService($state, ENV, Auth) {

    if (!ENV || !ENV.featureFlags) {
        console.error('Env config of feature flags not defined');
    }

    var featureFlags = ENV.featureFlags || {};

    var factory = {
        isSupportedFeature: isSupportedFeature,
        isEnabledForUser: isEnabledForUser
    };

    return factory;


    function isSupportedFeature (_requestedFeature) {

        /**
        * @param {Object} feature - The provided feature object parameter, usually provided in the ui-router data property
        * @param {string} feature.flag - The feature name, found in config (ENV.featureFlags)
        * @param {boolean} feature.redirectTo - A flag that indicates wether to redirect to home on disabled flag or not
        */

       if (!_requestedFeature && (!$state.current.data || !$state.current.data.featureFlag)) {
           return true;
        }

        var requestedFeature = _requestedFeature || $state.current.data.featureFlag;

        if (!requestedFeature.flag) {
            return true;
        }

        if (featureFlags.hasOwnProperty(requestedFeature.flag)) {
            var isEnabled = featureFlags[requestedFeature.flag];
            if (!isEnabled && requestedFeature.redirectTo) {
                $state.go(requestedFeature.redirectTo);
            }
            return isEnabled;
        }

        return true;
    }

    /**
    * @param {Object} feature - The provided feature object parameter, usually provided in the ui-router data property
    * @param {string} feature.flag - The feature name. Flags are stored on auth
    * @param {boolean} feature.redirectTo - A flag that indicates wether to redirect to home on disabled flag or not
    */
    function isEnabledForUser(_requestedFeature) {
        return new Promise(function(resolve, reject) {
            if (!_requestedFeature && (!$state.current.data || !$state.current.data.enabledForUser)) {
                resolve(true);
            }

            var requestedFeature = _requestedFeature || $state.current.data.enabledForUser;
            var redirectTo = requestedFeature.redirectTo;

            Auth.getProfile()
                .then(function(user) {
                    if (Array.isArray(user.features) && user.features.indexOf(requestedFeature.flag) > -1) {
                        resolve(true);
                    }
                    else {
                        if (requestedFeature.redirectTo) {
                            $state.go(redirectTo);
                        }
                        resolve(false);
                    }
                })
                .catch(function(error) {
                    if (requestedFeature.redirectTo) {
                        $state.go(redirectTo);
                    }
                    reject(error);
                });
        })
    }
};

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:SwitchComponent
 * @description
 * # SwitchComponent
 * Component of the gatehubClientApp
 */
angular.module('gatehubClientApp').component('ghSwitch', {
    template:
    '<div class="switch" ng-class="{ \'active\': vm.value }" ng-click="vm.toggleValue()">' +
        '<div class="switch-pill"></div>' +
    '</div>',
    bindings: {
        value: "<?",    // one way bound. we set the status in the callback
        onChange: '&'
    },
    controller: switchController,
    controllerAs: 'vm'
});
function switchController() {
    var vm = this;

    vm.$onInit = function() {
        if (vm.value == undefined) {
            vm.value = false;
        }
    };

    vm.toggleValue = function() {
        vm.value = !vm.value;
        vm.onChange({ value: vm.value });
    };
}

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:SwitchComponent
 * @description
 * # SwitchComponent
 * Component of the gatehubClientApp
 */
angular.module('gatehubClientApp').component('ghRadio', {
    template:
    '<label>' +
    '<input' +
    ' type="radio"' +
    ' id={{vm.idValue}}' +
    ' name={{vm.group}}' +
    ' value={{vm.value}}' +
    ' ng-disabled="vm.disabled == true"' +
    ' ng-model="vm.model" ' +
    ' ng-required="vm.isRequired">' +
    '<span class="outer-circle" tabindex="0" ng-keydown="vm.switchOnSpace($event)"></span>' +
    '<span class="inner-circle"></span>' +
    '<span class="text" data-ng-bind="vm.label"></span>' +
    '</label>',
    require: '^ngModel',
    bindings: {
        idValue: "@",
        group: "@",
        model:'=',
        label: "@",
        value: "@",
        isDisabled: "<",
        onChange: '&',
        isRequired: '<'
    },
    controller: radioController,
    controllerAs: 'vm'
});
function radioController() {
    var vm = this;
    vm.switchOnSpace = function(event) {
        if (event.originalEvent.keyCode === 32) {
            event.target.click();
            event.preventDefault();
        }
    }
}

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:CurrencyComponent
 * @description
 * # CurrencyComponent
 * Component of the gatehubClientApp
 */
angular.module('gatehubClientApp').component('ghCurrency', {
    template:
    '<div class="currency-badge {{vm.size || \'\'}} " ' +
    'ng-attr-title="{{ vm.displayCurrency }}"' +
    'ng-style="vm.currencyStyle">' +
    '<span class="currency-label" ng-if="!vm.currencyMeta.icon && vm.variant.length === 3">' +
    '{{ (vm.currencyMeta.variant || vm.variant) | uppercase }}</span>' +
    '<span class="currency-label" ng-if="!vm.currencyMeta.icon && vm.variant.length > 3" title="{{ vm.variant }}" alt="Nonstandard">{{ (vm.variant | nameCurrency) || (vm.variant | xrplCurrency) | limitTo: 1 }}</span>' +
    '</div>',
    bindings: {
        variant: "@",
        size: '@',
        disableTooltip: '<?'
    },
    controller: currencyController,
    controllerAs: 'vm'
});
currencyController.$inject = ['CurrencyMeta', 'NonstandardCurrencies'];
function currencyController(CurrencyMeta, NonstandardCurrencies) {
    var vm = this;
    vm.currencyStyle = {};

    vm.$onChanges = function() {
        var decodedCurrencyCode = NonstandardCurrencies.parseAssetCode(vm.variant);
        vm.currencyMeta = CurrencyMeta.getCurrencyMeta(decodedCurrencyCode);

        if (vm.variant) {
            vm.currencyStyle = {
                'background-color': vm.currencyMeta.color || '#818594',
                'transform': vm.currencyMeta.transform
            };
            // if a full background exists, set it instead of just background-image (except for small icons)
            if (vm.currencyMeta.background && vm.size !== 'small') { 
                vm.currencyStyle['background'] = vm.currencyMeta.background;
            } else if (vm.currencyMeta.icon) {
                vm.currencyStyle['background-image'] = 'url(' + vm.currencyMeta.icon + ')';
            }
        }
        else {
            vm.currencyStyle = {
                'background-color': '#A6A8AF',
                'background-image': 'none'
            };
        }

        var formatCurrency = '';
        if (!vm.disableTooltip) {
            formatCurrency = (vm.currencyMeta.tooltip || vm.variant).replace('-', ' ').toUpperCase();
        }

        vm.displayCurrency = formatCurrency;
    }
}

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:ghWalletSelectorComponent
 * @description
 * # ghWalletSelectorComponent
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp').component('ghWalletSelector', {
    templateUrl: 'scripts/components/wallet-selector/walletSelector.html',
    bindings: {
        walletItems: "<",
        activeWallet: "<",
        onWalletSelect: '&',
        onHide: '&'
    },
    controller: ['$localStorage', '$filter', '$scope', '$exceptionHandler', 'WalletsService', walletSelectorController],
    controllerAs: "vm"
});

function walletSelectorController($localStorage, $filter, $scope, $exceptionHandler, WalletsService) {
    var vm = this;

    vm.wallets = [];

    vm.activeMetricCode = $localStorage.activeMetricCode

    vm.$onInit = function() {
        document.addEventListener('keyup', escapeListener);

        initWallets();
    }

    vm.$onDestroy = function() {
        document.removeEventListener('keyup', escapeListener);
    }

    vm.noBalances = function(wallet) {
        if (wallet.type == 10 || wallet.type == 11) {
            return wallet.xrp === 0;
        }

        if (wallet.lines) {
            return (_.isEmpty(wallet.lines));
        } else {
            return true;
        }
    }

    vm.switchWallet = function(walletAddress) {
        vm.onWalletSelect({ address: walletAddress });
    }

    vm.hideSelector = function() {
        vm.onHide({ value: false });
    }

    function getNetWorth(wallet, lineId) {
        if (wallet.netWorth) {
            return wallet.netWorth[lineId] || 0;
        }
        return 0;
    }

    vm.showMore = function(event, wallet) {
        event.stopPropagation();
        wallet.balanceDisplayLimit += 3;
    }

    function escapeListener(event) {
        if (event.key === 'Escape') {
            vm.hideSelector();
            $scope.$apply();
        }
    }

    function initWallets() {
        var sortedWallets = $filter('orderBy')(vm.walletItems, ['-primary','name']);

        var wallets = [];

        sortedWallets.forEach(wallet => {
            var walletData = {
                name: wallet.name,
                address: wallet.address,
                primary: wallet.primary,
                multisign: false,
                type: wallet.type,
                addressHuman: getWalletAddressHuman(wallet),
                balanceDisplayLimit: 3,
                totalWorth: getNetWorth(wallet, 'total'),
                balances: []
            };

            if (wallet.multisign_address) {
                WalletsService.isMultisigWallet(wallet)
                    .then(function (status) {
                        walletData.multisign = status.isEnabled;
                        $scope.$apply();
                    });
            }

            for (var [key, value] of Object.entries(wallet.netWorth || {})) {

                if (key === 'total') {
                    continue;
                }

                if (key === 'XRP') {
                    walletData.balances.push({
                        lineId: key,
                        balance: value,
                        currency: 'XRP',
                        currencyLong: 'XRP',
                        amount: wallet.xrp
                    });
                }
                else if (wallet.type !== 24) {
                    var lineInfo = wallet.lines[key];
                    if (!lineInfo) {
                        console.error('No line data', wallet.name, key, wallet.lines, wallet.balances);
                        $exceptionHandler(new Error('No line data'));
                    }
                    else {
                        const decodedCurrency = $filter('xrplCurrency')(lineInfo.currency);
                        walletData.balances.push({
                            lineId: key,
                            balance: value,
                            currency: decodedCurrency,
                            currencyLong: $filter('nameCurrency')(decodedCurrency) || decodedCurrency,
                            amount: $filter('rpamount')(lineInfo.balance)
                        });
                    }
                } else if (wallet.type === 24) {
                    var balancesInfo = wallet.balances[key];
                    if(!balancesInfo) {
                        console.error('No balances data', wallet.name, key, wallet.balances);
                        $exceptionHandler(new Error('No balances data'));
                    }
                    walletData.balances.push({
                        lineId: key,
                        balance: value,
                        currency: balancesInfo.currency,
                        currencyLong: $filter('nameCurrency')(balancesInfo.currency) || balancesInfo.currency,
                        amount: balancesInfo.amount
                    });
                }
            }

            walletData.balances = walletData.balances.sort(function(a, b) {
                return b.balance - a.balance;
            });

            wallets.push(walletData);
        });

        vm.wallets = wallets;
    }

    function getWalletAddressHuman(wallet) {
        if (wallet.type === 24) {
            if (wallet.meta && wallet.meta.iban) {
                return $filter('spacedIban')(wallet.meta.iban) + ' - ' + getHumanWalletType(wallet);
            }
            return getHumanWalletType(wallet);
        }

        return wallet.address + ' - ' + getHumanWalletType(wallet);
    }

    function getHumanWalletType(wallet) {
        if (wallet.type === 24) {
            return 'Bank';
        }
        if (wallet.type === 11 || wallet.type === 10) {
            return 'XRPL';
        }
        if (wallet.type === 0) {
            return 'Hosted';
        }

        return 'Unknown';
    }
}

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:ghWalletSelectorTogglerComponent
 * @description
 * # ghWalletSelectorTogglerComponent
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp').component('ghWalletSelectorToggler', {
    templateUrl: 'scripts/components/wallet-selector-toggler/walletSelectorToggler.html',
    bindings: {
        activeWallet: '<'
    },
    controller: ghWalletSelectorTogglerController,
    controllerAs: 'vm'
});

function ghWalletSelectorTogglerController() {
    var vm = this;

    // vm.$onChanges = function() {
    //     console.log(vm);
    // }

    // vm.toggleWalletSelector = function() {
    //     vm.isWalletSelectorActive = !vm.isWalletSelectorActive;
    //     vm.onToggle({ active: vm.isWalletSelectorActive });
    // }

}

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:CurrencyComponent
 * @description
 * # CurrencyComponent
 * Component of the gatehubClientApp
 */
angular.module('gatehubClientApp').component('ghRateGraph', {
    templateUrl: 'scripts/components/rate-graph/rate-graph-component.html',
    bindings: {
        counter: '@',
        base: '@',
        network: '@', // 'hosted' or 'ripple'
        longTimeFormat: '<?',
        hideChange: '<?'
    },
    controller: rateGraphController,
    controllerAs: 'vm'
});

rateGraphController.$inject = ['RatesRestangular', 'RippleCharts', 'NonstandardCurrencies'];

function rateGraphController(RatesRestangular, RippleCharts, NonstandardCurrencies) {
    var vm = this;

    vm.rates = [];
    vm.exchangeRate = -1;
    vm.chartConfig = null;
    vm.rateChange = {
        absolute: 0,
        relative: 0,
        startEndChange: 0
    }

    vm.loading = false;

    vm.interval = '1w';

    vm.setRateInterval = setRateInterval;
    vm.trimIssuer = trimIssuer;

    vm.$onChanges = function(change) {
        if (vm.base && vm.counter) {
            vm.rates = [];
            vm.exchangeRate = -1;
            vm.loading = true;
            vm.rateChange = {
                relative: 0,
                absolute: 0,
                startEndChange: 0
            };

            getExchangeRate();

            getRateHistory();
        }
    }

    function setRateInterval(interval) {
        if (vm.interval !== interval) {
            vm.interval = interval;
            vm.rates = [];
            getRateHistory();
        }
    }

    function setupGraph() {
        var chartColor = vm.rateChange.startEndChange >= 0 ? '#0A6CF1' : '#EE0066'

        var config = {
            options: {
                chart: {
                    type: 'areaspline',
                    backgroundColor:'rgba(255, 255, 255, 0)',
                    plotBackgroundColor: 'rgba(255, 255, 255, 0)',
                    margin: [0, -6, 30, -6],
                    style: { fontFamily: '"Roboto", sans-serif;' }
                },
                legend: { enabled: false },
                exporting: { enabled: false },
                marker: { enabled: false },
                plotOptions: {
                    areaspline: {
                        fillOpacity: 0.10,
                        threshold: null,
                        marker : { enabled : false },
                    },
                    series: { marker: { symbol: 'circle' }}
                },
                tooltip: {
                    borderRadius: 5,
                    backgroundColor: 'rgba(255, 255, 255, 1)',
                    borderWidth: 0,
                    shadow: true,
                    style: {
                        color: '#A6A8AF',
                        boxShadow: '0px 3px 20px #00000029;',
                        fontSize: '14px'
                    },
                    valueDecimals : 6,
                    shared: true,
                    pointFormat: '<span style="font-size: 16px;color:{series.color}">1 {series.name} = {point.y} ' + trimIssuer(vm.counter) + '</span>',
                },
            },
            yAxis: {
                tickColor: '#E6E6E6',
                gridLineWidth: 1,
                labels: { enabled: false },
                title: { enabled: false }
            },
            xAxis: {
                type: 'datetime',
                tickLength: 5,
                tickWidth: 2,
                tickColor: '#E6E6E6',
                lineColor: '#E6E6E6',
                lineWidth: 1,
                labels: {
                    style: {
                        color: '#A6A8AF',
                        fontSize: '12px',
                    }
                },
                dateTimeLabelFormats: {
                    day:"%b %e",
                },
            },
            series: [
                {
                    data: vm.rates,
                    color: chartColor,
                    name: trimIssuer(vm.base),
                }
            ],
            title: {
                text: undefined
            }
        };

        return config;
    }

    function getExchangeRate() {

        // get rates from ripple
        if (vm.network === 'ripple') {
            /* RippleCharts.getExchangeRates(vm.base, vm.counter)
            .success(function(data) {
                // console.log(data);
                vm.exchangeRate = data.rate;
            }); */
            var params = {
                interval: '1day',
                limit: 1,
                descending: true,
            };
            RippleCharts.getExchanges(vm.base, vm.counter, params)
            .success(function(data) {
                if(data.exchanges.length == 0) {
                    vm.exchangeRate = 0;
                    console.warn('No rates found on XRPL');
                    return;
                };

                var rate = parseFloat(data.exchanges[0].close);
                if (!isNaN(rate)) {
                    vm.exchangeRate = rate;
                }
                else {
                    vm.exchangeRate = 0;
                }
            })
            .error(function(error) {
                console.warn('Error fetching rates from XRPL', error);
                vm.exchangeRate = 0;
            });
        }

        // get rates from ourrates service
        else {
            var counter = vm.counter;
            var base = vm.base;

            // DSH -> DASH hack
            counter = counter.replace('DSH', 'DASH');
            base = base.replace('DSH', 'DASH');

            // parse XRPL nonstandard codes
            counter = NonstandardCurrencies.parseAssetCode(counter);
            base = NonstandardCurrencies.parseAssetCode(base);

            RatesRestangular
                .one('rates')
                .one(base)
                .one(counter)
                .get()
                .then(function(data) {
                    var rate = data[base].rate;
                    vm.exchangeRate = rate || 0;
                });
        }
    }

    function calculateChangeRatio() {
        var changeRatio = {
            relative: 0,
            absolute: 0,
            startEndChange: 0
        };
        if (vm.rates.length > 1) {
            var latestRate = vm.rates[vm.rates.length - 1];
            var latestRateDay = moment(latestRate[0]);
            for (let i = vm.rates.length - 1; i >= 0; i--) {
                var previousRate = vm.rates[i];
                var day = moment(previousRate[0]);
                // console.log(latestRateDay.format(), day.format(), latestRateDay.diff(day, 'days'));
                if (latestRateDay.diff(day, 'days') >= 1) {
                    // console.log(latestRate, previousRate, i);

                    changeRatio.absolute = latestRate[1] - previousRate[1];
                    changeRatio.relative = _.round((latestRate[1] - previousRate[1]) / previousRate[1] * 100, 2);
                    changeRatio.startEndChange = vm.rates[vm.rates.length - 1][1] - vm.rates[0][1]
                    // console.log(latestRate[1] - previousRate[1], (latestRate[1] - previousRate[1]) / previousRate[1] * 100, changeRatio);
                    // console.log(vm.rates, changeRatio);
                    return changeRatio;
                }
            }
        }

        return changeRatio;
    }

    function getRateHistory() {
        if (vm.network === 'ripple') {
            getRateHistoryRipple();
        }

        else {
            getRateHistoryHosted();
        }
    }

    function getRateHistoryHosted() {
        vm.loading = true;
        vm.error = null;

        var rateInterval = vm.interval === '1w' ? 'hour' : 'day';

        // ! temporary workaround for better graphs because we only have daily fiat/fiat rates
        if ([vm.base, vm.counter].includes('EUR') && [vm.base, vm.counter].includes('USD')) {
            rateInterval = 'day';
        }
        var queryParams = {
            frame: vm.interval,
            interval: rateInterval,
            pair: (vm.base + '/' + vm.counter).replace('DSH', 'DASH'),
            return: 'object'
        };

        RatesRestangular
            .one('exchange_rates')
            .one('historical')
            .get(queryParams)
            .then(function(data) {
                var _base = NonstandardCurrencies.parseAssetCode(vm.base).replace('DSH', 'DASH');
                var _counter = NonstandardCurrencies.parseAssetCode(vm.counter).replace('DSH', 'DASH');
                var key = (_base + '/' + _counter);
                vm.rates = (data[key] || []).map(function(rate) {
                    return [moment.utc(rate.datetime).valueOf(), +rate.rate];
                });

                vm.rateChange = calculateChangeRatio();
                vm.chartConfig = setupGraph();
            })
            .catch(function(error) {
                vm.error = error;
            })
            .finally(function() {
                vm.loading = false;
            });

    }

    function getRateHistoryRipple() {
        // console.log('fetch ripple');

        vm.loading = true;

        var momentInterval = '';
        switch (vm.interval) {
            case '1w':
                momentInterval = 'weeks';
                break;
            case '1m':
                momentInterval = 'months';
                break;
            case '1y':
                momentInterval = 'years';
                break;
            default:
                momentInterval = 'weeks';
                break;
        }
        var params = {
            start: moment().subtract(1, momentInterval).startOf('minute').toISOString(),
            end: moment().startOf('minute').toISOString(),
            interval: '1day',
            limit: 1000,
            descending: true,
        };

        RippleCharts.getExchanges(vm.base, vm.counter, params)
        .success(function(data) {

            var exchanges = data.exchanges;

            vm.rates = [];

            for (var i = exchanges.length - 1; i >= 0; i--) {

                var price = parseFloat(exchanges[i]['close']);
                var UTC = moment.utc(exchanges[i]['close_time']).unix() * 1000;

                vm.rates.push([UTC, price]);

            };

            // console.log(vm.rates);

            vm.rateChange = calculateChangeRatio();
            vm.chartConfig = setupGraph();

            vm.loading = false;

        })
        .error(function(error) {
            // vm.error = error;
            vm.loading = false;
            console.error(error);
        });
    }

    function trimIssuer(address) {
        return address.split('+')[0];
    }
}

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:CurrencyComponent
 * @description
 * # CurrencyComponent
 * Component of the gatehubClientApp
 */
angular.module('gatehubClientApp').component('ghValueGraph', {
    templateUrl: 'scripts/components/value-graph/value-graph-component.html',
    bindings: {
        wallets: '<', // array of wallets { type: number, address: string }[]
        separateValues: '<?',
        baseCurrency: '@',
        longTimeFormat: '<?'
    },
    controller: valueGraphController,
    controllerAs: 'vm'
});

valueGraphController.$inject = ['CoreRestangular', '$q', 'CurrencyMeta', 'RippleAnalytics', '$localStorage', 'WalletsService', 'RatesRestangular', '$exceptionHandler', '$filter', 'NonstandardCurrencies'];

function valueGraphController(CoreRestangular, $q, CurrencyMeta, RippleAnalytics, $localStorage, WalletsService, RatesRestangular, $exceptionHandler, $filter, NonstandardCurrencies) {
    var vm = this;

    vm.currencyGroups = {};
    vm.chartConfig = null;

    vm.loading = true;
    vm.error = true;
    vm.range = 'months';

    vm.historicRates = [];
    vm.currentRates = [];

    vm.setHistoryRange = setHistoryRange;

    var forceRatesRefresh = false;
    var existingPromise = null;

    vm.$onChanges = function(change) {
        if (!Array.isArray(vm.wallets)) {
            return;
        }

        vm.error = false;
        if (change.wallets) {
            getValueHistory();
        }
        else if (change.baseCurrency && !_.isEmpty(vm.currencyGroups)) {
            forceRatesRefresh = true;
            getHistoricRates().then(function(rates) {
                forceRatesRefresh = false;
                vm.currentRates = rates[0];
                vm.historicRates = rates[1];
                var dataSeries = prepareConvertedValues();
                vm.chartConfig = setupGraph(dataSeries);
            })
            .catch(error => {
                vm.error = error;
            });
        }
    }

    function setHistoryRange(range) {
        if (vm.range !== range) {
            vm.range = range;
            getValueHistory();
        }
    }

    function getValueHistory() {
        vm.loading = true;
        vm.currencyGroups = {};

        var historyPromises = vm.wallets.map(function(wallet) {
            if (wallet.type === 10 || wallet.type === 11) {
                return getXrplHistory(wallet.address);
            }
            else if (wallet.type === 0) {
                return getHostedHistory(wallet.address);
            }
            else if (wallet.type === 24) {
                return getPsdHistory(wallet.address);
            }
            else {
                console.log('Unknown wallet type', wallet)
            }
        });

        if (existingPromise) {
            existingPromise.canceled = true;
        }

        existingPromise = { canceled: false };
        ((promise) => {
            $q.all(historyPromises)
            .then(function(responses) {
                if (promise.canceled) {
                    vm.loading = false;
                    return;
                }
                responses.forEach(balance => {
                    if (!balance) {
                        return;
                    }
                    if (balance.type === 'hosted') {
                        balance.data.forEach(function(vault) {
                            aggregateValuesHosted(vault)
                        });
                    }
                    else if (balance.type === 'xrp') {
                        aggregateValuesXrpl(balance.data);
                    }
                    else if (balance.type === 'psd') {
                        aggregateValuesPsd(balance.data);
                    }
                });
                getHistoricRates().then(function(rates) {
                    vm.currentRates = rates[0];
                    vm.historicRates = rates[1];
                    var dataSeries = prepareConvertedValues();
                    vm.chartConfig = setupGraph(dataSeries);
                    vm.loading = false;
                })
                .catch(function(error) {
                    vm.error = error;
                    vm.loading = false;
                });
            })
            .catch(function(error) {
                vm.error = error;
                vm.loading = false;
                $exceptionHandler(error);
            });
        })(existingPromise);
    }

    /*
    format for each currency:
    [{
        created_at: "2020-05-23T00:00:00+00:00",
        incomes: "0",
        expenses: "0",
        balance: "0.33"
    }]
    */

    function getHostedHistory(address) {
        return CoreRestangular
            .one('wallets')
            .one(address)
            .one('historicBalances')
            .customPOST({
                filters: {
                    interval: { unit: { value : "day" } },
                    created_at: {
                        from: moment().utc().subtract(1, vm.range).startOf('day').toISOString(),
                        to: moment().utc().add(1, "hours").endOf('day').toISOString()
                    }
                }
            })
            .then(function(response) {
                return {
                    type: 'hosted',
                    data: response.plain()
                };
            });
    }

    function getPsdHistory(address) {
        return CoreRestangular
            .one('wallets')
            .one(address)
            .one('psdHistoricBalances')
            .customPOST({
                filters: {
                    interval: { unit: { value : "day" } },
                    created_at: {
                        from: moment().utc().subtract(1, vm.range).startOf('day').toISOString(),
                        to: moment().utc().add(1, "hours").endOf('day').toISOString()
                    }
                }
            })
            .then(function(response) {
                return {
                    type: 'psd',
                    data: response.plain()
                };
            });
    }

    function getXrplHistory(address) {
        var range = {
            from: moment().subtract(1, vm.range).endOf('day').toISOString(),
            to: moment().startOf('day').toISOString()
        };

        return RippleAnalytics.getXrplBalanceHistory(address, range)
            .then(response => {
                return {
                    type: 'xrp',
                    data: response
                };
            })
            .catch(error => {
                console.error(error);
            });
    }

    function aggregateValuesHosted(vaultHistory) {
        var vault = vaultHistory.vault;
        var data = vaultHistory.data;
        if (!vault || !Array.isArray(data)) {
            console.error('Malformed history data', vaultHistory);
            return;
        }

        var valueField = vault.asset_code;

        data.map(function(history) {
            var date = moment.utc(history.created_at).valueOf();

            // console.log(moment.utc(date).format(), date);
            if (!vm.currencyGroups[valueField]) {
                vm.currencyGroups[valueField] = new Map();
            }

            var groupMap = vm.currencyGroups[valueField];

            addToMapValue(date, history.balance, groupMap);
        });
    }

    function aggregateValuesPsd(balanceHistory) {
        if (!Array.isArray(balanceHistory)) {
            console.error('Malformed history data', balanceHistory);
            return;
        }

        balanceHistory.forEach(balance => {
            var asset = balance.asset_code;
            balance.data.map(function(history) {
                var date = moment.utc(history.created_at).valueOf();

                if (!vm.currencyGroups[asset]) {
                    vm.currencyGroups[asset] = new Map();
                }

                var groupMap = vm.currencyGroups[asset];

                addToMapValue(date, history.balance, groupMap);
            });
        });
    }

    function aggregateValuesXrpl(xrplCurrencyGroups) {
        for (var currency in xrplCurrencyGroups) {
            if (xrplCurrencyGroups.hasOwnProperty(currency)) {
                var asset = currency.split('+')[0];
                var issuer = currency.split('+')[1];
                if (asset !== 'XRP' && !WalletsService.isConvertableCurrency(issuer)) {
                    console.warn('Currency not supported', asset, issuer)
                    continue;
                }

                if (!vm.currencyGroups[asset]) {
                    vm.currencyGroups[asset] = new Map();
                }
                var groupMap = vm.currencyGroups[asset];
                Array.from(xrplCurrencyGroups[currency]).forEach(change => {
                    // console.log('Add xrp', moment(change[0]).format(), change[1]);
                    addToMapValue(change[0], change[1], groupMap);
                });
            }
        }
    }

    function prepareConvertedValues() {

        // used only if we want to sum up all converted currencies
        var totalSum = new Map();
        var dataSeries = [];
        for (var currency in vm.currencyGroups) {
            if (vm.currencyGroups.hasOwnProperty(currency)) {
                var valueArray = Array.from(vm.currencyGroups[currency])
                    .sort((a,b) => a[0] < b[0] ? -1 : 1)
                    .map(function(value) {
                        var time = value[0];
                        var amount = value[1];
                        var dailyRate = findDailyRate(currency, null, time);
                        var convertedAmount = amount * dailyRate;
                        addToMapValue(time, convertedAmount, totalSum);
                        return [time, convertedAmount];
                    })
                    .sort(function(a, b) {
                        return a[0] - b[0];
                    });

                dataSeries.push({
                    name: $filter('xrplCurrency')(currency),
                    data: valueArray,
                    color: CurrencyMeta.getCurrencyColor(currency)
                });
            }
        }

        if (vm.separateValues) {
            return dataSeries;
        }

        var summedArray = Array.from(totalSum).sort(function(a, b) {
            return a[0] - b[0];
        });


        return [{
            name: 'Total value',
            data: summedArray,
            color: '#0A6CF1'
        }];

    }

    function getHistoricRates() {

        var deferred = $q.defer();

        if (!_.isEmpty(vm.historicRates) && !forceRatesRefresh) {
            deferred.resolve([vm.currentRates, vm.historicRates]);
        }

        else {
            var baseCurrency = $localStorage.activeMetricCode;

            var pairList = Object.keys(vm.currencyGroups).map(function(pair) {
                return NonstandardCurrencies.parseAssetCode(pair) + '/' + NonstandardCurrencies.parseAssetCode(baseCurrency);
            }).toString();

            // In case of no balances
            if (!pairList) {
                deferred.reject('No rate pairs');
            }
            else {
                // DSH -> DASH hack
               pairList = pairList.replace(/DSH/g, 'DASH');

               var queryParams = {
                   frame: '1y',
                   interval: 'day',
                   return: 'object',
                   pair: pairList
               };

               var currentRates = WalletsService.getExchangeRates();
               var historicRates = RatesRestangular.one('exchange_rates').one('historical').get(queryParams);

               $q.all([currentRates, historicRates])
                .then(function(data) {
                    var rates = [data[0], data[1].plain()];
                    deferred.resolve(rates)
                })
                .catch(function(error) {
                    $exceptionHandler(error);
                    deferred.reject(error);
                });

            }
        }

        return deferred.promise;
    }

    function findDailyRate(currency, vault, unixTime) {
        if (currency === vm.baseCurrency) {
            return 1;
        }

        // At this point there should be no unsupported currencies
        currency = NonstandardCurrencies.parseAssetCode(currency);
        vm.baseCurrency = NonstandardCurrencies.parseAssetCode(vm.baseCurrency);

        var rateKey = currency + '/' + vm.baseCurrency;
         // DSH -> DASH hack
        rateKey = rateKey.replace('DSH', 'DASH');

        var historicRates = vm.historicRates[rateKey];
        if (!historicRates) {
            console.warn('No rates for pair!', rateKey);
            return 0;
        }
        var day = moment(unixTime);
        var rateAtTime;

        if (day.isSame(moment(), 'day') && vm.currentRates) {
            rateAtTime = vm.currentRates.rates[currency.replace(/DSH/g, 'DASH')];
            if (rateAtTime.rate) {
                return rateAtTime.rate;
            }
        }

        var formattedDay = day.format('YYYY-MM-DD');

        rateAtTime = historicRates.find(rate => rate.datetime === formattedDay);
        if (rateAtTime) {
            return rateAtTime.rate;
        }

        console.warn('No rate for day!', rateKey, formattedDay);
        return 0;
    }

    function addToMapValue(key, value, map) {
        if (!map.has(key)) {
            map.set(key, 0);
        }

        var currentValue = map.get(key);
        currentValue += parseFloat(value);

        map.set(key, currentValue);
    }

    function setupGraph(dataSeries) {

        var config = {
            options: {
                chart: {
                    type: 'column',
                    backgroundColor:'rgba(255, 255, 255, 0)',
                    plotBackgroundColor: 'rgba(255, 255, 255, 0)',
                    margin: [25, 0, 30, 0],
                    style: { fontFamily: '"Roboto", sans-serif;' }
                },
                legend: {
                    verticalAlign: 'top',
                    align: 'left',
                    shadow: false,
                    y: -14,
                    x: 5
                },
                exporting: { enabled: false },
                marker: { enabled: false },
                plotOptions: {
                    column: {
                        stacking: 'normal',
                        borderRadius: 1,
                        groupPadding: 0.05
                    }
                },
                tooltip: {
                    borderRadius: 5,
                    backgroundColor: 'rgba(255, 255, 255, 1)',
                    borderWidth: 0,
                    shadow: true,
                    style: {
                        color: '#585C6A',
                        fontSize: '14px'
                    },
                    xDateFormat: '%b %e, %Y',
                    shared: true,
                    formatter: function() {
                        var s =`<span style="font-size:10px">${moment(this.x).format('LL')}</span>`;
                        $.each(this.points, function(i, point) {
                            s += '<br/>'+ `${this.series.name}: <b>${ _.floor(point.y, 4).toLocaleString('en-US', { minimumFractionDigits: 4 }) } ${vm.baseCurrency}</b><br/>`;
                        });

                        if (vm.separateValues) {
                            var sum = 0;
                            if (this.points.length) {
                                sum = this.points.map(p => p.y).reduce((a, b) => a + b, 0);
                            }

                            s += `<br/><span>Total: <b>${_.round(sum, 4)} ${vm.baseCurrency}</b></span>`
                        }
                        return s;
                    },
                    // pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.y} ' + vm.baseCurrency + '</b><br/>'
                },
            },
            yAxis: {
                tickColor: '#A6A8AF',
                gridLineWidth: 1,
                labels: { enabled: false },
                title: { enabled: false }
            },
            xAxis: {
                type: 'datetime'
            },
            series: dataSeries,
            title: {
                text: undefined
            }
        };

        return config;
    }
}

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:CurrencyComponent
 * @description
 * # CurrencyComponent
 * Component of the gatehubClientApp
 */
angular.module('gatehubClientApp').component('ghRatePairs', {
    templateUrl: 'scripts/components/rate-pairs/rate-pairs-component.html',
    bindings: {
        pairs: '<?', // array of base string pairs { base: string, counter: string }[]
        onPairSelect: '&'
    },
    controller: ratePairsController,
    controllerAs: 'vm'
});

ratePairsController.$inject = ['RatesRestangular', '$exceptionHandler', 'MarketsService', 'NonstandardCurrencies'];

function ratePairsController(RatesRestangular, $exceptionHandler, MarketsService, NonstandardCurrencies) {
    var vm = this;

    vm.ratePairs = [];

    vm.selectPair = selectPair;


    vm.$onChanges = function(change) {

        var pairList = [];
        if (Array.isArray(vm.pairs)) {
            pairList = _.clone(vm.pairs)
        }

        else {
            pairList = MarketsService.getDefaultRatePairs();
        }

        var previousPairs = vm.ratePairs;
        vm.ratePairs = [];

        // try to reuse existing pairs on change
        pairList.forEach(function(pair) {
            var existingPair = previousPairs.find(function(existingPair) {
                return pair.base === existingPair.base && pair.counter === existingPair.counter;
            });
            if (existingPair) {
                vm.ratePairs.push(existingPair);
            }
            else {
                vm.ratePairs.push({
                    base: pair.base,
                    counter: pair.counter,
                    chart: null,
                    rates: [],
                    currentRate: 0,
                    decimalPlaces: 4,
                    rateLoading: true,
                    rateError: false
                });
            }
        });

        var missingRates = vm.ratePairs.filter(function(pair) {
            return pair.rateLoading
        });

        getRates(missingRates);

    }

    function calculateChangeRatio(pair) {
        var changeRatio = 0;
        if (pair.rates.length > 1) {
            // latest 24h
            var latestRate = pair.rates[pair.rates.length - 1];
            var latestRateDay = moment(latestRate.datetime);
            for (let i = pair.rates.length - 1; i >= 0; i--) {
                var previousRate = pair.rates[i];
                var day = moment(previousRate.datetime);
                if (latestRateDay.diff(day, 'days') >= 1) {
                    changeRatio = (latestRate.rate - previousRate.rate) / previousRate.rate * 100;
                    return changeRatio;
                }
            }
        }

        return 0;
    }


    function getRates(ratePairs) {
        var pairList = ratePairs.map(function(pair) {
            return pair.base + '/' + pair.counter;
        }).toString();

        // DSH -> DASH hack
        pairList = pairList.replace(/DSH/g, 'DASH');

        var queryParams = {
            frame: '1w',
            interval: 'hour',
            return: 'object',
            pair: pairList
        };

        RatesRestangular
            .one('exchange_rates')
            .one('historical')
            .get(queryParams)
            .then(function(data) {
                ratePairs.map(function(pair) {
                    var key = pair.base + '/' + pair.counter;
                    key = NonstandardCurrencies.parseAssetCode(key);
                    key = key.replace('DSH', 'DASH');

                    pair.rates = data[key] || [];
                    pair.changeRatio = calculateChangeRatio(pair);
                    pair.chart = generateChart(pair);
                    return pair;
                })
            })
            .catch(error => {
                $exceptionHandler('Error fetching historic rates', error);
            });


        ratePairs.map(function(pair) {
            var counter = pair.counter;
            var base = pair.base;

            // DSH -> DASH hack
            counter = NonstandardCurrencies.parseAssetCode(counter).replace('DSH', 'DASH');
            base = NonstandardCurrencies.parseAssetCode(base).replace('DSH', 'DASH');

            return RatesRestangular
                .one('rates')
                .one(counter)
                .one(base)
                .get()
                .then(function(data) {
                    var decimalPlaces = data[counter].type === 'crypto' ? 8 : 2;
                    pair.currentRate = 1 / +data[counter].rate;
                    pair.decimalPlaces = decimalPlaces;

                    return pair;
                },
                function(error) {
                    // rate not found
                    pair.currentRate = -1;
                    pair.error = true;
                })
                .finally(() => pair.rateLoading = false );

        });
    }

    function selectPair(pair) {
        vm.onPairSelect({ value: { base: pair.base, counter: pair.counter } });
    }


    function generateChart(market) {

        var data = market.rates.map(function(rate) {
            return [moment(rate.datetime).valueOf(), +rate.rate];
        });

        var color = '#0A6CF1';
        if (data.length > 2) {
            color = data[data.length - 1][1] - data[0][1] >= 0 ? '#0A6CF1' : '#EE0066';
        }

        var config = {
            options: {
                chart: {
                    type: 'spline',
                    backgroundColor: 'rgba(255, 255, 255, 0)',
                    plotBackgroundColor: 'rgba(255, 255, 255, 0)',
                    margin: [0, 0, 0, 0],
                    spacing: [0, 0, 0, 0],
                    height: 30,
                    width: 50,
                    style: { fontFamily: '"Roboto", sans-serif;' },
                    animation: false
                },
                legend: { enabled: false },
                rangeSelector: { enabled: false },
                navigator: { enabled: false },
                scrollbar: { enabled: false },
                exporting: { enabled: false },
                plotOptions: {
                    line: {
                        marker: { enabled: false },
                        states: {
                            hover: { enabled: false },
                            marker: { enabled: false }
                        }
                    },
                    series: {
                        animation: false,
                        marker: { enabled: false },
                    }
                },
                tooltip: { enabled: false },
                marker: { enabled: false },
                title: null
            },
            yAxis: {
                title: false,
                lineWidth: 0,
                gridLineWidth: 0,
                labels: {
                    enabled: false
                },
                plotLines: [{
                    color: '#A6A8AF',
                    width: 1,
                    dashStyle: 'ShortDash',
                    value: data[0] ? data[0][1] : 0
                }]
            },
            xAxis: {
                type: "datetime",
                lineWidth: 0,
                tickLength: 0,
                labels: { enabled: false }
            },
            series: [{
                color: color,
                data: data,
                states: {
                    hover: { enabled: false }
                }
            }]
        };

        return config;
    }
}

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:CurrencyComponent
 * @description
 * # CurrencyComponent
 * Component of the gatehubClientApp
 */
angular.module('gatehubClientApp').component('ghCashflowGraph', {
    templateUrl: 'scripts/components/cashflow-graph/cashflow-graph-component.html',
    bindings: {
        baseCurrency: '@',
        longTimeFormat: '<?',
        onRangeChange: '&',
        chartData: '<',
        loadingFlag: '<?'
    },
    controller: cashflowGraphController,
    controllerAs: 'vm'
});

function cashflowGraphController() {
    var vm = this;

    vm.chartConfig = null;
    vm.range = 'months';

    vm.setHistoryRange = setHistoryRange;

    vm.$onChanges = function(change) {
        if (vm.chartData.length) {
            vm.chartConfig = setupGraph(vm.chartData);
        }
    }

    function setHistoryRange(range) {
        if (vm.range !== range) {
            vm.range = range;
            var rangeSingular = range.slice(0,-1);
            vm.onRangeChange({value: rangeSingular}); // component output
        }
    }

    function setupGraph(cashflowData) {
        var seriesData = [
            {
                name: 'Inflow',
                color: '#0A6CF1',
                data: cashflowData.map(function(x) { return [x[0], x[1][0]] })
            },
            {
                name: 'Outflow',
                color: '#EE0066',
                data: cashflowData.map(function(x) { return [x[0], -x[1][1]] })
            }
        ];

        var config = {
            options: {
                chart: {
                    type: 'column',
                    backgroundColor:'rgba(255, 255, 255, 0)',
                    plotBackgroundColor: 'rgba(255, 255, 255, 0)',
                    margin: [20, 0, 30, 0],
                    style: { fontFamily: '"Roboto", sans-serif;' }
                },
                legend: {
                    verticalAlign: 'top',
                    align: 'left',
                    shadow: false,
                    y: -14,
                    x: 5
                },
                exporting: { enabled: false },
                marker: { enabled: false },
                plotOptions: {
                    column: {
                        stacking: 'normal',
                        borderRadius: 1,
                        groupPadding: 0.05
                    }
                },
                tooltip: {
                    borderRadius: 5,
                    backgroundColor: 'rgba(255, 255, 255, 1)',
                    borderWidth: 0,
                    shadow: true,
                    style: {
                        color: '#585C6A',
                        fontSize: '14px'
                    },
                    valueDecimals : 4,
                    xDateFormat: '%b %e, %Y',
                    pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.y} ' + vm.baseCurrency + '</b><br/>'
                },
            },
            yAxis: {
                tickColor: '#E6E6E6',
                gridLineWidth: 1,
                labels: { enabled: false },
                title: { enabled: false }
            },
            xAxis: {
                type: 'datetime',
                tickLength: 5,
                tickWidth: 2,
                tickColor: '#E6E6E6',
                lineColor: '#E6E6E6',
                lineWidth: 1,
                labels: {
                    style: {
                        color: '#A6A8AF',
                        fontSize: '12px',
                    }
                },
                dateTimeLabelFormats: {
                    day:"%b %e",
                },
            },
            series: seriesData,
            title: {
                text: undefined
            }
        };

        return config;
    }


}

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:ChangeComponent
 * @description
 * # ChangeComponent
 * Component of the gatehubClientApp
 */
angular.module('gatehubClientApp').component('ghChange', {
    template:
    '<div class="{{ vm.class }}" ng-if="!vm.isInfinite && !vm.isNaN">' +
        '<span class="d-inline-block rot-270" ng-if="vm.parsedValue > 0">&#10142;</span>' +
        '<span class="d-inline-block rot-90" ng-if="vm.parsedValue < 0">&#10142;</span>' +
        '<span ng-if="vm.parsedValue === 0"></span>' +
        '<span class="ml-1">{{ vm.displayValue }}%</span>' +
    '</div>',
    bindings: {
        value: "<",
        decimalPlaces: '<?',
        invert: '<?'
    },
    controller: changeController,
    controllerAs: 'vm'
});
function changeController() {
    var vm = this;
    vm.class = '';
    vm.displayValue = '';
    vm.parsedValue = 0;

    vm.$onChanges = function() {
        var value = parseFloat(vm.value);
        vm.parsedValue = value;
        vm.isInfinite = false;
        vm.isNaN = false;

        if (isNaN(value)) {
            vm.displayValue = '--';
            vm.class = '';
            vm.isNaN = true;
            return;
        }

        vm.class = value > 0 ? 'text-primary' : value < 0 ? 'text-danger' : '';

        if (vm.invert) {
            vm.class = vm.class === 'text-primary' ? 'text-danger' : vm.class === 'text-danger' ? 'text-primary' : '';
        }
        if (!isFinite(value)) {
            vm.displayValue = '∞';
            vm.isInfinite = true;
        }
        else {
            var places = Number.isInteger(vm.decimalPlaces) ? vm.decimalPlaces : 2;
            vm.displayValue = _.round(value, places);
        }
    };

}

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:CheckboxComponent
 * @description
 * # CheckboxComponent
 * Component of the gatehubClientApp
 */
angular.module('gatehubClientApp').component('ghCheckbox', {
    template:
    '<input ng-attr-id="{{vm.idValue}}" type="checkbox" ' +
    '   ng-model="vm.isChecked" ng-disabled="vm.isDisabled" ng-required="vm.isRequired" ng-change="vm.onValueChange()">' +
    '<div class="checkbox-indicator" ng-click="vm.toggleValue()" tabindex="0" ng-keydown="vm.toggleOnSpace($event)"></div>' +
    '<label ng-attr-for="{{vm.idValue}}" ng-bind-html="vm.label"></label>',
    bindings: {
        isChecked: "<?",  // one way bound. we set the status in the callback
        isDisabled: "<?",
        idValue: "@",
        label: "@?",
        isRequired: "<?",
        onChange: '&'
    },
    controller: checkboxController,
    controllerAs: 'vm'
});
function checkboxController() {
    var vm = this;

    vm.toggleValue = function() {
        vm.isChecked = !vm.isChecked;
        vm.onValueChange();
    }
    vm.onValueChange = function() {
        vm.onChange({ value: vm.isChecked });
    };
    vm.toggleOnSpace = function(event) {
        if (event.originalEvent.keyCode === 32) {
            vm.toggleValue();
            event.preventDefault();
        }
    }
}

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:ProfileMenuComponent
 * @description
 * # ProfileMenuComponent
 * Component of the gatehubClientApp
 */
angular.module('gatehubClientApp').component('ghProfileMenu', {
    templateUrl: 'scripts/components/profile-menu/pofile-menu-component.html',
    bindings: {
    },
    controller: profileMenuController,
    controllerAs: 'vm'
});
profileMenuController.$inject = ['Auth', 'StorageCore', '$uibModal', '$rootScope', '$scope'];
function profileMenuController(Auth, StorageCore, $uibModal, $rootScope, $scope) {
    var vm = this;

    vm.user = null;
    var DEFAULT_IMAGE = '/images/ico/avatar@2x.png';
    vm.profileImage = DEFAULT_IMAGE;
    vm.displayName = '';
    vm.logoutActive = false;

    vm.openProfilePictureModal = openProfilePictureModal;
    vm.logout = logout;
    var profilePictureChangeListener;

    profilePictureChangeListener = $rootScope.$on('profilePictureChange', function(event, data) {
        if (data) {
            vm.user.identity.photo = data;
            getProfilePhoto(data, true);
        }
        else {
            vm.profileImage = DEFAULT_IMAGE;
        }
    });


    vm.$onInit = function() {
        Auth.getProfile().then(function (data) {

            vm.user = data;
            var id = data.identity.profile;
            if (data.identity.user_type === 0) {
                vm.displayName = (id.first_name || '') + ' ' + (id.middle_name || '') + ' ' + (id.last_name || '');
            }
            else if (data.identity.user_type === 1) {
                vm.displayName = data.identity.companyProfile.legal_name;
            }

            getProfilePhoto(vm.user.identity.photo);

        });
    }

    function getProfilePhoto(photoId, refresh) {
        StorageCore.getProfilePhoto(photoId, refresh).then(function(data){
            if (data) {
                vm.profileImage = data;
            }
        }, function(error) {
            console.error(error);
        });
    }

    function openProfilePictureModal() {
        // ! leave this! grunt usemin for some reason skips the first occurrence of this html file
        console.info('views/settings/modal_upload_profile_picture.html');

        $uibModal.open({
            templateUrl: 'views/settings/modal_upload_profile_picture.html',
            controller: 'UploadProfilePictureController',
            controllerAs: 'vm',
            resolve: {
                data: function () {
                    return {
                        userId: vm.user.id,
                        existingPhotoId: (vm.profileImage !== DEFAULT_IMAGE ? vm.profileImage : null)
                    };
                }
            }
        });
    }

    function logout() {
        vm.logoutActive = true;
        Auth.logout();
    }

    function unsubscribeListeners() {
        if (profilePictureChangeListener) {
            profilePictureChangeListener();
        }
    }

    $scope.$on('$destroy', function() {
        unsubscribeListeners();
    });


}

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:NotificationMenuComponent
 * @description
 * # NotificationMenuComponent
 * Component of the gatehubClientApp
 */
angular.module('gatehubClientApp').component('ghNotificationMenu', {
    templateUrl: 'scripts/components/notification-menu/notification-menu-component.html',
    bindings: {
    },
    controller: notificationMenuController,
    controllerAs: 'vm'
});
notificationMenuController.$inject = ['Auth', '$localStorage', '$state', 'Documents', 'CoreRestangular'];
function notificationMenuController(Auth, $localStorage, $state, Documents, CoreRestangular) {
    var vm = this;

    vm.notifications = [ ]

    vm.markAsRead = markAsRead;
    vm.markAllAsRead = markAllAsRead;
    vm.navigateToLink = navigateToLink;

    vm.$onInit = function() {
        Auth.getProfile().then(function(user) {
            CoreRestangular.one('users', user.uid).all('gateways').getList().then(function (gatewaysData) {

                if (user.type2fa !== 'totp') {
                    vm.notifications.push({
                        type: 'security',
                        header: 'Security',
                        content: 'For your own safety please enable 2-Factor Authentication.',
                        link: 'security.twostep'
                    });
                }
                if (!user.securityCode) {
                    vm.notifications.push({
                        type: 'security',
                        header: 'Security',
                        content: 'For your own safety please set your Anti-phishing message.',
                        link: 'security.antiphishing'
                    });
                }
                if (videoVerificationFailed(user)) {
                    vm.notifications.push({
                        type: 'verification',
                        header: 'Verification Failed',
                        content: 'Unfortunately, we could not verify your account. Please retry the process to unlock all your wallet\'s functionality. <a class="text-danger">Verify Account</a>',
                        link: 'identity.form.profile'
                    });
                }
                var secNotification = {
                    type: 'announcement',
                    header: 'Announcement',
                    content: 'We have released a statement regarding XRP on GateHub. Read more <a href="https://gatehub.net/blog/announcement-to-xrp-holders/" target="_blank" rel="noopener noreferrer">HERE</a>.',
                    storageKey: 'usSec'
                };
                if (user.identity && user.identity.profile.citizenship === 'US') {
                    if (!isMarkedAsRead(secNotification.storageKey)) {
                        vm.notifications.push(secNotification);
                    }
                }
                var uabNotification = {
                    type: 'announcement',
                    header: 'Bank deposit details changed',
                    content: 'Our bank deposit details have changed. Please make sure to deposit your funds to the correct account.',
                    storageKey: 'bankUAB'
                };
                if (user.identity) {
                    if (!isMarkedAsRead(uabNotification.storageKey)) {
                        vm.notifications.push(uabNotification);
                    }
                }

                if (hasActionRequiredGateway(gatewaysData)) {
                    vm.notifications.push({
                        type: 'verification',
                        header: 'Action required',
                        content: 'Please review your personal data and documents. We need to make sure your information is up to date for regulatory purposes.',
                        link: 'identity.form.profile',
                    });
                }
            });
        });
    }

    function hasActionRequiredGateway(gatewaysData) {
        var gateways = gatewaysData.plain();
        for (var i = 0; i < gateways.length; i++) {
            // if has action required (AND that gateway is actually operational)
            if (gateways[i].status === 3 && gateways[i].gateway.status === 1) {
                return true;
            }
        }
        return false;
    }

    function videoVerificationFailed(authUser) {
        const verificationLevel = authUser.identity.verification_level;
        const identity = authUser.identity.plain();
        const gatehubGatewayConnected = isGatehubGatewayConnected(identity.hubs);
        if (gatehubGatewayConnected) {
            return false;
        }
        const legacyUser = (identity.labels && identity.labels.indexOf("KYC_LEGACY") > -1) ? true : false;
        if (!legacyUser && verificationLevel > 0 && identity.user_type !== 1) { 
            const hasEidVerification = Documents.hasEidVerification(identity.verifications);
            const isEidVerificationOK = Documents.isEidVerificationOK(identity.verifications);
            if (hasEidVerification && !isEidVerificationOK) {
                return true; // show notification
            }
        }
        return false;
    }

    function isGatehubGatewayConnected(hubs) {
        for (var i = 0; i < hubs.length; i++) {
            if (hubs[i].name === 'GateHub' || hubs[i].name === 'GateHub UAB') {
                return hubs[i].verified === 1;
            }
        }
        return false;
    }

    function isMarkedAsRead(storageKey) {
        if (storageKey) {
            var storageKey = 'ghNotification-' + storageKey;
            return $localStorage[storageKey];
        }
        return false;
    }

    function markAsRead(notification) {
        if (notification.storageKey) {
            var storageKey = 'ghNotification-' + notification.storageKey;
            $localStorage[storageKey] = true;
        }
    }

    function navigateToLink(link) {
        if (link) {
            $state.go(link);
        }
    }

    function markAllAsRead() {
        vm.notifications.map(function(n) {
            markAsRead(n);
        });

        vm.notifications = [];
    }
}

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:CurrencyListComponent
 * @description
 * # CurrencyListComponent
 * Component of the gatehubClientApp
 */
angular.module('gatehubClientApp').component('ghCurrencyList', {
    template:
    '<div class="currency-list card m-0">' +
    '   <div ng-repeat="currency in vm.currencyList" ng-click="vm.onCurrencySelect(currency)">' +
    '       <gh-currency class="mr-3" variant="{{ currency.code }}" size="medium"></gh-currency>' +
    '       <div>' +
    '           <span class="currency-title">{{ currency.code | xrplCurrency }}</span>' +
    '           <span class="currency-subtitle">{{ currency.name }}</span>' +
    '       </div>' +
    '   </div>' +
    '</div>',
    bindings: {
        onSelect: "&"
    },
    controller: currencyListController,
    controllerAs: 'vm'
});
currencyListController.$inject = ['CurrencyMeta']
function currencyListController(CurrencyMeta) {
    var vm = this;
    vm.currencyList = [];

    vm.onCurrencySelect = onCurrencySelect;

    vm.$onInit = function() {
        vm.currencyList = CurrencyMeta.getDefaultCurrencies();
    };

    function onCurrencySelect(currency) {
        vm.onSelect({ value: currency.code });
    }
}

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:CurrencyListComponent
 * @description
 * # CurrencyListComponent
 * Component of the gatehubClientApp
 */
angular.module('gatehubClientApp').component('ghChecklist', {
    template:
    '<div class="checklist card m-0">' +
    '   <gh-checkbox' +
    '       ng-repeat="item in vm.checkList"' +
    '       is-checked="item.checked"' +
    '       id-value="{{$index}}-{{item.label}}"' +
    '       label="{{item.label}}"' +
    '       on-change="vm.listCheckChanged($index)"' +
    '   ></gh-checkbox>' +
    '</div>',
    bindings: {
        checkList: '<', // { label: string, checked: boolean, ...}
        onChange: "&"
    },
    controller: checklistController,
    controllerAs: 'vm'
});
function checklistController() {
    var vm = this;

    vm.listCheckChanged = listCheckChanged;


    function listCheckChanged(index) {
        vm.checkList[index].checked = !vm.checkList[index].checked;
        vm.onChange({ value: vm.checkList[index] });
    }
}

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:MarketComponent
 * @description
 * # MarketComponent
 * Component of the gatehubClientApp
 */
angular.module('gatehubClientApp').component('ghMarket', {
    template: `
    <div class="market"
        ng-click="vm.marketClicked()"
        ui-sref="trade({base: '{{vm.market.base.currency}}{{(vm.market.base.issuer ? ':' + vm.market.base.issuer : '')}}',
            counter: '{{vm.market.counter.currency}}{{(vm.market.counter.issuer ? ':' + vm.market.counter.issuer : '')}}'})"
    >
        <div class="market-header spaced-between">
            <div class="currency">
            {{ vm.market.base.currency | realCurrencyCode }}
            <span class="text-gray"> / </span>
            {{ vm.market.counter.currency | realCurrencyCode }}
            </div>
            <span class="value" ng-show="vm.market.change_ratio" ng-class="vm.market.red ? 'text-danger' : 'text-success'">
                <!-- <span ng-show="vm.market.change > 0">+</span>{{ vm.market.change | number: 4 }} -->
                <span ng-show="vm.market.change_ratio > 0">+</span>{{ vm.market.change_ratio | number: 2 }}%
            </span>
            <button class="btn btn-basic remove-market" ng-click="vm.removeMarket($event)" ng-if="vm.onMarketDelete">
                <span class="icon cross"></span>
            </button>
        </div>
        <div class="spaced-between text-gray is-size-6">
            <div>
                {{ vm.market.base.issuer | nameGateway }} /
                {{ vm.market.counter.issuer | nameGateway }}
            </div>
        <div>{{ vm.market.last | numberFormat }}</div>
        </div>
        <div class="chart-container">
            <highchart ng-if="!vm.market.loadingMarket" config="vm.loadChartFunc(vm.market)" class="chart"></highchart>
            <img ng-if="vm.market.loadingMarket" class="loader" src="images/ico/loader2.svg" />
        </div>
        <div class="spaced-between text-gray is-size-6">
            <div>H: {{ (vm.market.high || 0) | numberFormat }}</div>
            <div>L: {{ (vm.market.low || 0) | numberFormat }}</div>
            <div>V: {{ (vm.market.volume || 0) | numberFormat }}</div>
        </div>
    </div>
    `,
    bindings: {
        market: "<",
        loadChartFunc: '<',
        onMarketSelect: '&',
        onMarketDelete: '&?'
    },
    controller: marketController,
    controllerAs: 'vm'
});
function marketController() {
    var vm = this;

    vm.marketClicked = function() {
        vm.onMarketSelect({ value: vm.market });
    }

    vm.removeMarket = function(event) {
        event.stopPropagation();
        vm.onMarketDelete({ value: vm.market.id});
    }
}

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:ghMultisignProgress
 * @description
 * # ghMultisignProgress
 * Component of the gatehubClientApp
 */
angular.module('gatehubClientApp').component('ghMultisignProgress', {
    templateUrl: 'scripts/components/multisign-progress/multisign-progress-component.html',
    bindings: {
        step: "<",
        hasError: '<',
        isUpgrade: '<?'
    },
    controller: multisignProgressController,
    controllerAs: 'vm'
});
function multisignProgressController() {
    var vm = this;

    vm.progressSteps = [
        { label: 'Enable Multi-sign', stepInterval: [0, 2], status: 'Pending' },
        { label: 'Payment Confirmation', stepInterval: [3, 3], status: 'Pending' },
        { label: 'Disable Master Key', stepInterval: [4, 8], status: 'Pending' }
    ];

    if (vm.isUpgrade) {
        vm.progressSteps = [
            { label: 'Upgrade plan', stepInterval: [10, 11], status: 'Pending' },
            { label: 'Update insurance', stepInterval: [12, 12], status: 'Pending' },
            { label: 'Create invoice', stepInterval: [13, 14], status: 'Pending' }
        ];
    }
    vm.$onChanges = function() {
        vm.progressSteps.map(function(progressStep) {
            if (vm.step < progressStep.stepInterval[0]) {
                progressStep.status = 'Pending';
            }
            else if (vm.step >= progressStep.stepInterval[0] && vm.step <= progressStep.stepInterval[1]) {
                progressStep.status = 'Processing';
                if (vm.hasError) {
                    progressStep.status = 'Error';
                }
            }
            else {
                progressStep.status = 'Completed';
            }
        });
    }
}

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:sepaQRController
 * @description
 * # SepaQRController
 * Component of the gatehubClientApp
 */
angular.module('gatehubClientApp').component('sepaQr', {
    templateUrl: 'scripts/components/sepaQR/sepa-qr-component.html',
    bindings: {
        sepa: '='
    },
    controller: sepaQRController,
    controllerAs: 'vm'
});

class EcbFormats {
    constructor(type) {
        this.defaultType = 'bcd1';
        this.sepa = {};
        this.changeType(type);
    }

    changeType(type) {
        this.type = (type || this.defaultType).toLowerCase();
        if (this.formats.indexOf(this.type) === -1) {
            this.type = this.defaultType;
        }
    }

    toString(sepa) {
        this.sepa = sepa;
        return this[this.type];
    }

    checkAndCut(value, valueDefault, maxLength, doTrim) {
        let ret = String(value || valueDefault);
        if (doTrim) {
            ret = ret.trim();
        }
        return ret.substring(0, maxLength); // here we should create exception
    }

    checkValue(value, valueDefault, maxLength) {
        let ret = (value || valueDefault).toFixed(2);
        return String(ret).replace('.','').padStart(maxLength, '0');
    }

    get formats() {
        return ['bcd1', 'upnqr', 'bcd2'];
    }

    _bcd(version) {
        let ret = '';
        ret += `BCD\n`; // Service tag
        ret += this.checkAndCut(String(version || 2).padStart(3, '0'), '002', 3) + `\n`; // Version
        ret += `1\n`; // Character set
        ret += `SCT\n`; // Identification
        ret += this.checkAndCut(this.sepa.receiver.bic, '', 11) + `\n`; // BIC
        ret += this.checkAndCut(this.sepa.receiver.name, '', 70) + `\n`; // Name
        ret += this.checkAndCut(this.sepa.receiver.iban, '', 34) + `\n`; // IBAN
        ret += this.checkAndCut(this.sepa.currency, 'EUR', 3) + `\n`; // Currency
        ret += this.checkAndCut((this.sepa.value || 0).toFixed(2), '0', 12) + `\n`; // Amount
        ret += this.checkAndCut(this.sepa.purposeCode, 'GDDS', 4) + `\n`; // Purpose
        ret += this.checkAndCut(this.sepa.purpose, '', 35) + `\n`; // Reference
        ret += this.checkAndCut(this.sepa.text, '', 140) + `\n`; // Text
        return ret;
    }

    get bcd1() {
        return this._bcd(1);
    }

    get bcd2() {
        return this._bcd(2);
    }

    get upnqr() {
        let ret = '';
        ret += `UPNQR\n`; // Vodilni slog
        ret += `\n`; // IBAN plačnika
        ret += `\n`; // Polog
        ret += `\n`; // Dvig
        ret += `\n`; // Referenca plačnika
        ret += this.checkAndCut(this.sepa.sender.name, '', 33, true) + `\n`; // Ime plačnika
        ret += this.checkAndCut(this.sepa.sender.address, '', 33, true) + `\n`; // Ulica in št. plačnika
        ret += this.checkAndCut(this.sepa.sender.city, '', 33, true) + `\n`; // Kraj plačnika
        ret += this.checkValue(this.sepa.value, 0, 12) + `\n`; // Znesek
        ret += `\n`; // Datum plačila
        ret += `\n`; // Nujno
        ret += this.checkAndCut(this.sepa.purposeCode, 'OTHR', 4) + `\n`; // Koda namena
        ret += this.checkAndCut(this.sepa.purpose, '', 42, true) + `\n`; // Namen plačila
        ret += `\n`; // Rok plačila
        ret += this.checkAndCut(this.sepa.receiver.iban, '', 34) + `\n`; // IBAN
        ret += this.checkAndCut(this.sepa.reference, '', 26) + `\n`; // Referenca
        ret += this.checkAndCut(this.sepa.receiver.name, '', 33, true) + `\n`; // Ime prejemnika
        ret += this.checkAndCut(this.sepa.receiver.address, '', 33, true) + `\n`; // Ulica prejemnika
        ret += this.checkAndCut(this.sepa.receiver.city, '', 33, true) + `\n`; // Kraj prejemnika
        const cont = ret.length;
        ret += cont.toString().padStart(3, '0') + `\n`; // Kontrolna številka
        return ret;
    }
}

sepaQRController.$inject = ['$element'];

function sepaQRController($element) {
    let vm = this;
    let formatTypes = new EcbFormats(vm.sepa.type);
    vm.lastType = vm.sepa.type;

    vm.$doCheck = function () {
        if (vm.lastType !== vm.sepa.type) {
            vm.lastType = vm.sepa.type;
            vm.render();
        }
    };

    vm.showNextQRType = function() {
        const formats = formatTypes.formats;
        let idx = formats.indexOf(vm.sepa.type) + 1;
        if (idx >= formats.length) {
            idx = 0;
        }
        vm.sepa.type = formats[idx];
    };

    vm.render = function () {
        formatTypes.changeType(vm.sepa.type);
        vm.text = formatTypes.toString(vm.sepa);
        QRCode.toCanvas($element.find('canvas')[0], vm.text, {width: 180}, function (error) {
            if (error) {
                console.error(error);
            }
        });
    };

    vm.render();
}

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:copyTextComponent
 * @description
 * # copyTextComponent
 * Component of the gatehubClientApp
 */
angular.module('gatehubClientApp').component('copyTextButton', {
    templateUrl: 'scripts/components/copy-text/copy-text-component.html',
    bindings: {
        copyText: "<?",
        tooltip: "<?",
        delay: "<?",
    },
    controller: ['$scope', ($scope) => {
        let vm = this;
        $scope.tooltip = vm.tooltip || 'Copied!';
        $scope.delay = vm.delay || '2000';
    }],
    controllerAs: 'vm'
});

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:newApiKey
 * @description
 * # newApiKey
 * Component of the gatehubClientApp
 */
angular.module('gatehubClientApp').component('newApiKey', {
    templateUrl: 'scripts/components/api-keys/new-api-key-component.html',
    bindings: {
        onSubmit: "&",
    },
    controller: NewApiKeyController,
    controllerAs: 'vm'
});

function NewApiKeyController() {
    let vm = this;

    vm.toggleNewKeyScope = toggleNewKeyScope;
    vm.checkKeyScope = checkKeyScope;
    vm.addAuthorizedIp = addAuthorizedIp;
    vm.removeAuthorizedIp = removeAuthorizedIp;
    vm.submit = submit;

    vm.availableScopes = [
        {
            scope: 'withdrawals',
            label: 'Enable Withdrawals',
            description: `
                <p>
                    This option allows you to withdraw via API.<br>
                    You must apply the IP Access Restriction filter in order to enable withdrawals.
                </p>`,
            enabled: false
        },
        {
            scope: 'deposits',
            label: 'Create deposit address',
            enabled: false
        },
        {
            scope: 'hosted_exchange',
            label: 'Enable hosted exchange',
            enabled: false
        },
        {
            scope: 'hosted_payment',
            label: 'Enable hosted payments',
            enabled: false
        }
    ];

    vm.restrictIps = 1;
    vm.newIpValue = '';

    vm.newApiKey = {
        name: '',
        scope: [],
        authorizedIps: []
    };


    function toggleNewKeyScope(scope) {
        const scopeIndex = vm.newApiKey.scope.indexOf(scope);
        if (scopeIndex > -1) {
            vm.newApiKey.scope.splice(scopeIndex, 1);
        }
        else {
            vm.newApiKey.scope.push(scope);
        }
    }

    function addAuthorizedIp(value) {
        vm.newIpValue = '';
        // ip can be added when pressing the comma. remove the trailing comma here
        value = value.replace(',', '');
        if (value.trim().length === 0 || vm.newApiKey.authorizedIps.includes(value)) {
            return;
        }
        vm.newApiKey.authorizedIps.push(value.trim());
    }
    function removeAuthorizedIp(index) {
        vm.newApiKey.authorizedIps.splice(index, 1);
    }

    function checkKeyScope(scope) {
        return vm.newApiKey.scope && vm.newApiKey.scope.includes(scope);
    }

    function submit(form, data) {
        if (vm.newIpValue && vm.newIpValue.length) {
            addAuthorizedIp(vm.newIpValue);
        }

        if (form && form.$invalid) {
            angular.forEach(form.$error, function(controls) {
                angular.forEach(controls, function(control) {
                    control.$setDirty();
                });
            });
            return;
        }

        if (vm.restrictIps == false) {
            vm.newApiKey.authorizedIps = [];
        }
        vm.onSubmit({ value: data });
    }
}

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:apiKeyDetails
 * @description
 * # apiKeyDetails
 * Component of the gatehubClientApp
 */
angular.module('gatehubClientApp').component('apiKeyDetails', {
    templateUrl: 'scripts/components/api-keys/api-key-details-component.html',
    bindings: {
        apiKey: "<",
        onClose: "&",
    },
    controller: ApiKeyEditController,
    controllerAs: 'vm'
});

function ApiKeyEditController() {
    let vm = this;
    vm.close = close;

    function close() {
        vm.onClose();
    }
}

'use strict';

/**
 * @ngdoc function
 * @name gatehubClientApp.controller:DevCtrl
 * @description
 * # DevCtrl
 * Controller of the gatehubClientApp
 */
angular.module('gatehubClientApp')
.controller('DevCtrl', function () {
    var vm = this;

    vm.switchVar = true;
    vm.input_1 = '';
    vm.radioModel = 'value_1';

    vm.checkboxModels = {
        value: false,
        isDisabled: true
    };

    vm.switchChange = function(change) {
        console.log(change);
    }

    vm.checkboxChange = function(change) {
        console.log(change);
    }

    vm.currencySelected = function(value) {
        console.log(value);
    }
});

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.VaultsService
 * @description
 * # VaultsService
 * Service in the gatehubClientApp.
 */
angular
    .module('gatehubClientApp')
    .service('VaultsService', VaultsService);

function VaultsService(Auth, Settings, CoreRestangular, IDRestangular, $q, ENV, NonstandardCurrencies) {

    var vaults = Settings.vaults;

    var factory = {
        list: list,
        listCurrencies: listCurrencies,
        getVaults: getVaults,
        getAllVaults: getAllVaults,
        getConnectedVaults: getConnectedVaults,
        getUserGateways: getUserGateways,
        getConnectedGateways: getConnectedGateways,
        getAllGateways: getAllGateways,
        getVaultByCurrency: getVaultByCurrency,
        getVaultByVaultId: getVaultByVaultId,
        checkIfGatewayConnectedByVaultId: checkIfGatewayConnectedByVaultId
    };

    return factory;

    ///////////////////////////////////////////////////////////

    function list() {
        return vaults;
    };

    function listCurrencies() {
        var result = _(vaults).uniq('currency').pluck('currency').value();
        return result;
    };

    function getVaults() {
        var deferred = $q.defer();
        getUserGateways().then(function (gateways) {
            var _vaults = [];
            // Gateways
            for (var i = gateways.length - 1; i >= 0; i--) {
                var gateway_vaults = gateways[i].gateway.vaults;
                // Vaults
                for (var j = gateway_vaults.length - 1; j >= 0; j--) {
                    gateway_vaults[j].gateway_connection_status = gateways[i].status;
                    gateway_vaults[j].gateway_operational_status = gateways[i].gateway.status;
                    gateway_vaults[j].gateway_uuid = gateways[i].gateway.uuid;
                    _vaults.push(gateway_vaults[j]);
                }
            }
            deferred.resolve(_vaults);
        }, function(error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    function getAllVaults() {
        var deferred = $q.defer();
        CoreRestangular.one('search/vaults').get().then(function (data) {
            var _vaults = data.plain();
            deferred.resolve(_vaults);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    function getConnectedVaults() {
        var deferred = $q.defer();
        getConnectedGateways().then(function (gateways) {
            var _vaults = [];
            // Gateways
            for (var i = gateways.length - 1; i >= 0; i--) {
                var gateway_vaults = gateways[i].gateway.vaults.filter(v => v.status === 1);
                // Vaults
                for (var j = gateway_vaults.length - 1; j >= 0; j--) {
                    if(gateway_vaults[j].status == 1) {
                        gateway_vaults[j].gateway_connection_status = gateways[i].status;
                        gateway_vaults[j].gateway_operational_status = gateways[i].gateway.status;
                        _vaults.push(gateway_vaults[j]);
                    };
                }
            }
            deferred.resolve(_vaults);
        }, function(error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    function getConnectedGateways() {
        var deferred = $q.defer();
        Auth.getProfile().then(function (data) {
            var user = data;
            CoreRestangular.one('users', user.uid).all('gateways').getList().then(function (data) {
                var gateways = data.plain();
                var _gateways = [];
                for (var i = gateways.length - 1; i >= 0; i--) {
                    // Check gateway connection and operational status
                    if((gateways[i].status === 1 || gateways[i].status === 3) && gateways[i].gateway.status === 1) {
                        _gateways.push(gateways[i]);
                    };
                }
                deferred.resolve(_gateways);
            }, function (error) {
                deferred.reject(error);
            });
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    function getUserGateways () {
        var deferred = $q.defer();
        Auth.getProfile().then(function (data) {
            var user = data;
            CoreRestangular.one('users', user.uid).all('gateways').getList().then(function (data) {
                var gateways = data.plain();
                var _gateways = [];
                for (var i = 0; i < gateways.length; i++) {
                    _gateways.push(gateways[i]);
                }
                deferred.resolve(_gateways);
            }, function (error) {
                deferred.reject(error);
            });
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    function getVaultByCurrency(currency) {
        currency = NonstandardCurrencies.parseAssetCode(currency);
        for (var i = vaults.length - 1; i >= 0; i--) {
          if (vaults[i].currency == currency) {
            if (ENV.name === 'production' && vaults[i].admin_only || vaults[i].skip){
              // skip admin_only vaults on production or if "skip" property set to true
            } else {
              return vaults[i];
            }
          }
        }
        return false;
    };

    function getVaultByVaultId(vault) {
        for (var i = vaults.length - 1; i >= 0; i--) {
            if(vaults[i].vault_id == vault) {
              return vaults[i];
            }
        }
        return false;
    }

    function checkIfGatewayConnectedByVaultId(vaultId){
      return getConnectedGateways().then(function (gateways) {
        for(var i=0; i < gateways.length; i++){
          var gateway_vaults = gateways[i].gateway.vaults;
          for(var j=0; j < gateway_vaults.length; j++){
            if(gateway_vaults[j].uuid == vaultId){
              return true;
            }
          }
        }
        return false;
      });
    }

    function getAllGateways() {
        var deferred = $q.defer();
        $q.all([
            IDRestangular.one('hubs').get(),
            getAllVaults()
        ]).then(function(values) {
            var gateways = new Map();
            values[0].items.filter(function(hub) {
                return hub.state === 1;
            }).map(function(hub) {
                var hubData = {
                    gateway_uuid: hub.uuid,
                    is_shown_in_wallet: hub.is_shown_in_wallet || false,
                    name: hub.name,
                    vaults: []
                }
                gateways.set(hub.uuid, hubData);
            })
            values[1].forEach(function(vault) {
                if (gateways.has(vault.gateway_uuid)) {
                    gateways.get(vault.gateway_uuid).vaults.push(vault);
                }
            });
            deferred.resolve(Array.from(gateways.values()))
        })
        .catch(function(error) {
            deferred.reject(error);
        });
        return deferred.promise;
    }
}
VaultsService.$inject = ["Auth", "Settings", "CoreRestangular", "IDRestangular", "$q", "ENV", "NonstandardCurrencies"];;

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.ThirdPartyService
 * @description
 * # ThirdPartyService
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
  .factory('ThirdPartyService', ThirdPartyService);

  function ThirdPartyService(VaultsService, IDRestangular, Auth, UserPreferencesService, $exceptionHandler) {

    var firstPartyIssuers = getFirstPartyVaults();
    var userConsents = [];

    var factory = {
      isThirdPartyWithoutConsent,
      getThirdPartyWarning,
      addConsent
    }

    refreshUserConsents(); // init

    return factory;

    //////////////////////////////////////////////////////////////////

    function getFirstPartyVaults() {
      var vaults = VaultsService.list();
      var firstPartyIssuers = _(vaults)
        .filter(v => v.firstParty)
        .map(v => v.cold)
        .value();
      return firstPartyIssuers;
    }

    function isThirdParty(asset) {
      if (asset.currency === 'XRP') {
        return false;
      }
      return firstPartyIssuers.indexOf(asset.issuer) === -1;
    }

    function refreshUserConsents() {
      return UserPreferencesService.getUserPreferences(true).then(config => {
        userConsents = config.customConsents;
      });
    }

    function hasConsent(asset) {
      for (let consent of userConsents) {
          if(consent.currency === asset.currency && consent.issuer === asset.issuer) {
              return true;
          }
      }
      return false;
    }

    function addConsent(base, counter) {
      var consentsArray = [];
      if (isThirdPartyWithoutConsent(base)) {
        consentsArray.push({
            issuer: base.issuer,
            currency: base.currency
        });
      }
      if (isThirdPartyWithoutConsent(counter)) {
        consentsArray.push({
            issuer: counter.issuer,
            currency: counter.currency
        });
      }

      if (consentsArray.length === 0) {
        return Promise.resolve();
      }

      return Auth.getProfile().then(function(user) {
        var userId = user.id;
        return IDRestangular.one('users', userId).one('userConfig', 'consent')
          .customPOST({
            customConsents: consentsArray
          }).then(function(response) {
            userConsents = response.user_config.customConsents;
          });
      }, function(error) {
        $exceptionHandler(error);
      });
    }

    function getThirdPartyWarning(base, counter) {
      return refreshUserConsents().then(function(){
        var thirdPartyWarning = null;
        if (isThirdPartyWithoutConsent(base)) {
          thirdPartyWarning = 'base';
          if (isThirdPartyWithoutConsent(counter)) {
            thirdPartyWarning = 'both';
          }
        } else if (isThirdPartyWithoutConsent(counter)) {
          thirdPartyWarning = 'counter';
        }
        return thirdPartyWarning;
      });
    }

    function isThirdPartyWithoutConsent(asset) {
      if (!asset) {
        return false;
      }
      return isThirdParty(asset) && !hasConsent(asset);
    }
  }
  ThirdPartyService.$inject = ["VaultsService", "IDRestangular", "Auth", "UserPreferencesService", "$exceptionHandler"];

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.WalletsService
 * @description
 * # WalletsService
 * Service in the gatehubClientApp.
 */
angular
    .module('gatehubClientApp')
    .factory('WalletsService', WalletsService);

WalletsService.$inject = ['$rootScope', '$interval', '$q', '$filter', 'RippleHistory', '$localStorage', 'Auth', 'CoreRestangular', 'Settings', 'RippleNetwork', 'AccountsService', 'RippleTx', 'RatesRestangular', 'VaultsService', '$exceptionHandler', 'NonstandardCurrencies'];

function WalletsService($rootScope, $interval, $q, $filter, RippleHistory, $localStorage, Auth, CoreRestangular, Settings, RippleNetwork, AccountsService, RippleTx, RatesRestangular, VaultsService, $exceptionHandler, NonstandardCurrencies) {

    var wallets = {};
    var shadow_wallets = {};

    var loaded = false;
    var time = false;
    var limit = 20;

    var hostedTxHistoryUniqueUuidArray = [];

    var exchangeRateCache = {
        forCurrency: null,
        lastUpdated: null,
        rates: []
    };

    var txHistoryFilters = {
      type: null,
      vault_uuid: null,
      date_from: null,
      date_to: null
    };

    var factory = {
        getWallets: getWallets,
        loadMore: loadMore,
        list: list,
        getPrimary: getPrimary,
        getActive: getActive,
        getHosted: getHosted,
        setActive: setActive,
        saveWallet: saveWallet,
        refreshWallet: refreshWallet,
        deleteWallet: deleteWallet,
        getById: getById,
        getByAddress: getByAddress,
        connect: connect,
        renameWallet: renameWallet,
        setGatehubPrimary: setGatehubPrimary,
        getGatehubWallet: getGatehubWallet,
        getHistory: getHistory,
        setTrust: setTrust,
        setTxHistoryFilter: setTxHistoryFilter,
        getTxHistoryFilters: getTxHistoryFilters,
        isMultisigWallet: RippleTx.isMultisigWallet,
        updateWalletNetWorth: updateWalletNetWorth,
        getExchangeRates: getExchangeRates,
        getExchangePairRate: getExchangePairRate,
        isConvertableCurrency: isConvertableCurrency,
        findShadowAddress: findShadowAddress
    };

    return factory;

    ///////////////////////////////////////////////////////////


    function getWallets(refresh) {

        var deferred = $q.defer();

        if (loaded && refresh !== true) {
            deferred.resolve(wallets);
        }
        else {

            Auth.getProfile(true).then(function(data) {

                loaded = true;

                wallets = data.core.wallets;
                //console.log('WALLETS FROM AUTH', wallets);

                // Remove deleted
                _.remove(wallets, function (wallet) {
                    return wallet.deleted == 1
                });

                // Shadow Wallets
                shadow_wallets = _.filter(wallets, { 'type': 1 });

                // Prepend shadow wallet hosted address to ripple wallets
                _.each(wallets, function(wallet){

                    if(wallet.type == 10 || wallet.type == 11) {

                        _.each(shadow_wallets, function(shadow_wallet){

                            // Strip address
                            var address = shadow_wallet.name.split('@');

                            if(address[1] == wallet.address) {
                                wallet.shadow_address = shadow_wallet.address;
                            };

                        });

                    };

                });

                // Remove all but ripple, hosted and PSD
                _.remove(wallets, function (wallet) {
                    return wallet.type != 0 && wallet.type != 10 && wallet.type != 11 && wallet.type != 24;
                });

                connect();

                // Get Accounts
                AccountsService.getAccounts().then(function(data) {
                    deferred.resolve(wallets);
                }, function(){
                    deferred.resolve(wallets);
                })

            }, function(error) {
                deferred.reject(error);
            });

        }

        return deferred.promise;

    };
    function list() {
        return wallets;
    };
    function getPrimary() {
        var result = _(wallets).filter({primary: true}).pluck('address').value();

        // Temp fix, if no primary display first ripple wallet
        if(result.length == 0) {
            result = _(wallets).filter({type: 10}).pluck('address').value();
            return result[0];
        }

        return result[0];
    };
    function getActive() {

        // Get active wallet
        var address = $localStorage.activeWallet;
        var wallet = getById(address);

        // Get primary if active not available
        if(wallet.length) {
            return wallet;
        }
        else {
            address = getPrimary();
            wallet = getById(address);
        }

        // Check if wallet is OK
        if(!wallet.length) return false;

        // Save active wallet
        setActive(address);

        return wallet;

    };
    function getHosted() {

        var wallet = false;

        for (var i = wallets.length - 1; i >= 0; i--) {
            if(wallets[i].type == 0) {
                wallet = wallets[i];
            };
        };

        return wallet;

    };
    function setActive(address) {

        var wallet = getById(address);

        // Check if wallet is OK
        if(!wallet.length) return false;

        // Broadcast
        $rootScope.$broadcast('$walletChanged');

        // Save active wallet
        $localStorage.activeWallet = address;

        $rootScope.activeWallet = address;

        return wallet;

    };
    function renameWallet(wallet, name) {

        wallet.name = name;

        // Broadcast
        $rootScope.$broadcast('$walletChanged');

    };
    function setGatehubPrimary(wallet) {

        // Update old primary
        var old = getPrimary();
        var old_wallet = getByAddress(old);

        var i = wallets.indexOf(old_wallet);
        wallets[i].primary = false;

        // Update new primary
        var i = wallets.indexOf(wallet);
        wallets[i].primary = true;

        // Broadcast
        $rootScope.$broadcast('$walletChanged');

    };
    function saveWallet(wallet) {

        wallets.push(wallet);

        addWallet(wallet);

        setActive(wallet.address);

        // Refresh list to get shadow wallet
        if(wallet.type == 10) getWallets(true);

        return wallet;

    };
    function deleteWallet(address) {

        _.remove(wallets, function (wallet) {
            return wallet.address === address
        });

        // Unsubrscribe
        var xaccount = RippleNetwork.remote.account(address)
        xaccount.removeListener('transaction', function(data) {
            console.log(data);
        });
        xaccount.removeListener('entry', function(data) {
            console.log(data);
        });

        return;

    };
    function getById(address) {
        var result = _(wallets).filter({address: address}).value();
        return result;
    };
    function getByAddress(address) {
        var result = _(wallets).filter({address: address}).value();
        return result[0];
    };
    function connect() {
        for (var i = wallets.length - 1; i >= 0; i--) {
            addWallet(wallets[i]);
        }

        // Temporary long polling
        if(!time) {
            time = $interval(refreshActive, Settings.client.hostedBalanceInterval);
        }

    };
    function addWallet(wallet) {

        wallet['loadingWallet'] = true;
        wallet['loadingLines'] = true;
        wallet['loadingOffers'] = true;
        wallet['loadingHistory'] = false;

        wallet['xrp'] = 0;
        wallet['unfunded'] = false;
        wallet['noHistory'] = false;
        wallet['endHistory'] = false;

        wallet['history'] = [];

        var i = wallets.indexOf(wallet);
        var address = wallet.address;

        if(wallet.type == 10 || wallet.type == 11) {

            (function(i){
                RippleNetwork.remote.account(address)
                    .on('entry', function(data) {
                        wallet['account_info'] = data;
                        wallet['master_enabled'] = (data.Flags & 0x00100000) === 0;
                        wallet['xrp'] = data.Balance / 1000000;
                        $rootScope.$broadcast('$balancesUpdate');
                        wallet['unfunded'] = false;
                    })
                    .on('transaction', function(data) {
                        processTxn(data.transaction, data.meta, false, i);
                    })
                    .entry(function (err, entry) {
                        if (err) {
                            // console.error(err);
                            if (err.remote.error == 'actNotFound') {
                                wallet['unfunded'] = true;
                                // an unfunded wallet still has a secret key
                                wallet['master_enabled'] = true;
                            }
                        }
                        wallet['loadingWallet'] = false;
                    });

                // Ripple Lines
                RippleNetwork.remote.requestAccountLines({account: address})
                    .on('success', function(data) {
                        handleRippleLines(data, i);

                        updateWalletNetWorth(wallet)
                            .then(function(netWorth) {
                                wallet.netWorth = netWorth;
                            })
                            .catch(function(error) {
                                // console.log(wallet, error)
                            });
                    })
                    .on('error', function(error) {
                        handleRippleLinesError(error, i);
                    })
                    .request();

                // Ripple Orders
                RippleNetwork.remote.requestAccountOffers({account: address})
                    .on('success', function(data){
                        handleRippleOffers(data, i);
                    })
                    .on('error', function(error) {
                        handleRippleOffersError(error, i);
                    })
                    .request();
            })(i);
        }
        else if (wallet.type === 0) {
            getGatehubBalance(wallet);
        }
        else if (wallet.type === 24) {
            getPsdBalance(wallet);
        }

    };

    function getHistory(wallet, refresh) {

        if(wallet.type == 10 || wallet.type == 11) {
            getRippleHistory(wallet, refresh);
        }
        else if(wallet.type == 0) {
            getGatehubHistory(wallet, refresh);
        }
        else if(wallet.type == 24) {
            getPsdHistory(wallet, refresh);
        }

    };

    function refreshWallet(wallet) {

        var i = wallets.indexOf(wallet);
        var address = wallet.address;

        // Only Hosted
        if(wallet.type !== 0) {
            return;
        }

        // Get Balance
        getGatehubBalance(wallet);

        // Get History
        getGatehubHistory(wallet, true);

    };

    function refreshActive() {

        var wallet = getActive();
        wallet = wallet[0];

        // Something went wrong, let's stop before it gets even worse
        if(!wallet) {
            console.error('Wallet not found');
            return;
        };

        refreshWallet(wallet);

    };

    function getGatehubBalance(wallet) {

        var i = wallets.indexOf(wallet);
        var address = wallet.address;

        (function(i){

            // Get Balance
            CoreRestangular.one('wallets', address).all('balances').getList().then(function(data) {

                var lines = data.plain();

                handleGatehubLines(lines, i);

                updateWalletNetWorth(wallet)
                    .then(function(netWorth) {
                        wallet.netWorth = netWorth;
                    })
                    .catch(function(error) {
                        // console.log(wallet, error)
                    });

            }, function(error) {
                handleGatehubLinesError(error, i);
            });

        })(i);

    };

    function getGatehubHistory(wallet, live) {

        var i = wallets.indexOf(wallet);
        var address = wallet.address;

        wallets[i]['loadingHistory'] = true;

        if(typeof wallets[i] == 'undefined') return;

        var offset = hostedTxHistoryUniqueUuidArray.length;

        if(live == true) {
            offset = 0;
        };

        var txFilters = {};

        // offset+limit pagination
        txFilters.define_range = txFilters.define_range || {};
        txFilters.define_range.offset = offset;
        txFilters.define_range.limit = limit;

        // type filter
        if(txHistoryFilters.type !== null){
            txFilters.type = {
                value: txHistoryFilters.type
            };
        }
        // asset filter
        if(txHistoryFilters.vault_uuid !== null){
            txFilters.vault_uuid = {
                value: txHistoryFilters.vault_uuid
            };
        }
        // date from filter
        if(txHistoryFilters.date_from !== null){
            txFilters.created_at = txFilters.created_at || {};
            txFilters.created_at.from = txHistoryFilters.date_from.startOf('day').format("YYYY-MM-DD HH:mm:ss");
        }
        // date to filter
        if(txHistoryFilters.date_to !== null){
            txFilters.created_at = txFilters.created_at || {};
            txFilters.created_at.to = txHistoryFilters.date_to.endOf('day').format("YYYY-MM-DD HH:mm:ss");
        }

        (function(i){

            // Get History
            CoreRestangular.one('wallets', address).all('transactions').customPOST({
                filters: txFilters
            }).then(function(data){
                var history = data.plain();
                handleGatehubHistory(history, i);
            }, function(error) {
                handleGatehubHistoryError(error, i);
            });

        })(i);

    };

    function getRippleHistory(wallet, refresh) {

        var i = wallets.indexOf(wallet);
        var address = wallet.address;

        wallets[i]['loadingHistory'] = true;

        var offset = wallets[i]['marker'];

        if(refresh){
            offset = undefined;
        }

        var start = txHistoryFilters.date_from !== null ? txHistoryFilters.date_from.startOf('day').toISOString() : undefined;
        var end = txHistoryFilters.date_to !== null ? txHistoryFilters.date_to.endOf('day').startOf('minute').toISOString() : undefined;

        (function(i){

            RippleHistory
                .getHistory({
                    limit: limit,
                    marker: offset,
                    descending: true,
                    start: start,
                    end: end
                }, address)
                .success(function(data) {
                    if (Array.isArray(data.transactions)) {
                      handleHistory(data, i);
                    }
                    else {
                      handleHistoryError(data, i);
                    }
                })
                .error(function(data) {
                    handleHistoryError(data, i);
                });

        })(i);

    };

    function getPsdBalance(wallet) {
        var i = wallets.indexOf(wallet);
        var address = wallet.address;

        (function(i) {
            wallet.loadingBalances = true;
            CoreRestangular.one('wallets', address).one('psdBalances').get().then(function(data) {
                wallet.balances = data.plain();
                wallet.lines = wallet.balances;

                wallet.loadingBalances = false;
                wallet.loadingWallet = false;
                wallet.loadingLines = false;
                wallet.xrp = false;

                updateWalletNetWorth(wallet)
                    .then(function(netWorth) {
                        wallet.netWorth = netWorth;
                    })
                    .catch(function(error) {
                        $exceptionHandler('[WalletService] Error updating wallet net worth', error);
                    });
            }, function(error) {
                $exceptionHandler('[WalletService] Error getting psdBalances', error);
                wallet.balances = [];
                wallet.loadingBalances = false;
            });
        })(i);
    }

    function getPsdHistory(wallet, live) {
        var i = wallets.indexOf(wallet);
        var address = wallet.address;
        wallets[i]['loadingHistory'] = true;

        if(typeof wallets[i] == 'undefined') return;

        //var offset = hostedTxHistoryUniqueUuidArray.length;
        var offset = wallets[i].history.length;

        if(live == true) {
            offset = 0;
        };

        var txFilters = {};

        // psd transactions must have order direction set:
        txFilters.order = {
            "field": "psd_transactions.created_at",
            "direction": "desc"
        }

        // offset+limit pagination
        txFilters.define_range = txFilters.define_range || {};
        txFilters.define_range.offset = offset;
        txFilters.define_range.limit = limit;

        // date from filter
        if(txHistoryFilters.date_from !== null){
            txFilters["psd_transactions.created_at"] = txFilters["psd_transactions.created_at"] || {};
            txFilters["psd_transactions.created_at"].from = txHistoryFilters.date_from.startOf('day').format("YYYY-MM-DD HH:mm:ss");
        }
        // date to filter
        if(txHistoryFilters.date_to !== null){
            txFilters["psd_transactions.created_at"] = txFilters["psd_transactions.created_at"] || {};
            txFilters["psd_transactions.created_at"].to = txHistoryFilters.date_to.endOf('day').format("YYYY-MM-DD HH:mm:ss");
        }
        // asset filter
        if(txHistoryFilters.asset_code !== null){
            txFilters.currency = {
                value: txHistoryFilters.asset_code
            };
        }

        (function(i){
            CoreRestangular.one('wallets', address).all('filtetredPsdTransactions').customPOST({
                filters: txFilters
            }).then(function(data){
                var history = data.plain();
                handlePsdHistory(history, i);
            }, function(error) {
                $exceptionHandler('[WalletService] Error getting filtetredPsdTransactions', error);
            });
        })(i);
    };

    function handlePsdHistory(data, i) {
        wallets[i]['loadingHistory'] = false;

        if(data.length < limit) {
            wallets[i]['endHistory'] = true;
        }

        var old_data = wallets[i].history;
        var new_data = data;

        data = _.uniq(_.union(new_data, old_data), false, _.property('uuid'));

        wallets[i].history = data;

        if(old_data.length !== wallets[i].history.length) {
            $rootScope.$broadcast('$balancesUpdate');
        };
    }

    function loadMore(wallet) {
        var i = wallets.indexOf(wallet);
        if(typeof wallets[i] == 'undefined') return;

        if(wallets[i].type == 10 || wallets[i].type == 11) {
            getRippleHistory(wallet);
        }
        else if(wallets[i].type === 0) {
            getGatehubHistory(wallet);
        }
        else if(wallets[i].type === 24) {
            getPsdHistory(wallet);
        }
    };

    function handleGatehubLines(data, i) {

        if(typeof wallets[i] == 'undefined') return;

        wallets[i]['loadingWallet'] = false;
        wallets[i]['loadingLines'] = false;
        wallets[i]['xrp'] = false;
        wallets[i].lines = {};

        if(data.length == 0) {
            wallets[i]['unfunded'] = true;
        }
        else {
            wallets[i]['unfunded'] = false;
        }

        for (var n = 0, l = data.length; n < l; n++) {
            var line = data[n];
            var issuer = (line.vault.cold_wallet != null) ? line.vault.cold_wallet.address : '';
            var currency = line.vault.asset_code;

            line = $.extend({}, line, {
                // limit: ripple.Amount.from_json({value: line.limit, currency: line.currency, issuer: line.account}),
                // limit_peer: ripple.Amount.from_json({value: line.limit_peer, currency: line.currency, issuer: line.account}),
                balance: ripple.Amount.from_json({value: line.available, currency: currency, issuer: issuer}), // TODO get from vault
                display_balance: line.available,
                account: issuer,
                currency: currency,
                vaultUuid: line.vault.uuid
            });

            wallets[i].lines[issuer + currency] = line;  // TODO get from vault

        }

        $rootScope.$broadcast('$balancesUpdate');
    };

    function handleGatehubLinesError(error, i) {

        wallets[i]['loadingLines'] = false;
        wallets[i]['loadingWallet'] = false;

        wallets[i].lines = {};

        console.error(error);
    };

    function handleGatehubHistory(data, i) {

        wallets[i]['loadingHistory'] = false;

        if(data.length < limit) {
            wallets[i]['endHistory'] = true;
        }

        var old_data = wallets[i].history;
        var new_data = data;

        data = _.uniq(_.union(new_data, old_data), false, _.property('uuid'));

        // Merge hosted exchange buy+sell into one exchange transaction!
        var _lastExchangeItem = { meta: { convertRef: null }};
        for(var j=data.length-1; j>=0; j--){
            // separate count of unique transactions to solve the infinite scroll bug
            if( hostedTxHistoryUniqueUuidArray.indexOf(data[j].uuid) === -1 ){
                hostedTxHistoryUniqueUuidArray.push(data[j].uuid);
            }
            if(data[j].meta && data[j].meta.convertRef){
                if(data[j].meta.convertRef === _lastExchangeItem.meta.convertRef ){
                    var hostedExchangeItem = _lastExchangeItem;
                    hostedExchangeItem.convertData = {
                        counterAmount: data[j].amount,
                        counterCurrency: data[j].vault.asset_code,
                        counterTxUuid: data[j].uuid,
                        rate: (_lastExchangeItem.amount > 0) ? data[j].amount / _lastExchangeItem.amount : "N/A",
                    }
                    data[j] = hostedExchangeItem;
                    data.splice(j+1, 1); // remove 2nd half of hosted exchange, we merged it into this one
                }
                _lastExchangeItem = data[j];
            }
        }

        wallets[i].history = data;

        if(old_data.length != wallets[i].history.length) {
            $rootScope.$broadcast('$balancesUpdate');
        };

    };

    function handleGatehubHistoryError(error, i) {
        console.error('History Error', error, wallets, i);
        wallets[i]['loadingHistory'] = false;
    };

    function handleRippleLines(data, i) {

        wallets[i]['loadingLines'] = false;
        wallets[i].lines = {};
        wallets[i].balances = {};

        for (var n = 0, l = data.lines.length; n < l; n++) {
            var line = data.lines[n];

            line = $.extend({}, line, {
                _limit: line.limit,
                limit: ripple.Amount.from_json({value: line.limit, currency: line.currency, issuer: line.account}),
                limit_peer: ripple.Amount.from_json({value: line.limit_peer, currency: line.currency, issuer: line.account}),
                balance: ripple.Amount.from_json({value: line.balance, currency: line.currency, issuer: line.account}),
                display_balance: line.balance
            });

            wallets[i].lines[line.account + line.currency] = line;

            updateRippleBalance(line.currency, line.account, line.balance, i);

        }

        $rootScope.$broadcast('$balancesUpdate');

    };

    function handleRippleLinesError(error, i) {

        wallets[i]['loadingLines'] = false;
        wallets[i].lines = {};
        wallets[i].balances = {};

        console.error(error);

    };

    function handleRippleOffers(data, i) {

        wallets[i]['loadingOffers'] = false;
        wallets[i].offers = {};

        data.offers.forEach(function (offerData) {
            var offer = {
                seq: +offerData.seq,
                gets: ripple.Amount.from_json(offerData.taker_gets),
                pays: ripple.Amount.from_json(offerData.taker_pays),
                flags: offerData.flags
            };

            updateOffer(offer, i);
        });

        $rootScope.$broadcast('$offersUpdate');

    };

    function handleRippleOffersError(error, i) {

        wallets[i]['loadingOffers'] = false;
        wallets[i].offers = {};

        // console.error(error);

    };

    function handleHistory(data, i) {

        wallets[i]['loadingHistory'] = false;

        if(data.count < limit) {
            wallets[i]['endHistory'] = true;
        }

        wallets[i]['marker'] = data.marker;

        data.transactions.forEach(function (e, key) {
            e.tx.date = e.date;
            e.tx.hash = e.hash;
            e.tx.ledger_index = e.ledger_index;
            processTxn(e.tx, e.meta, true, i);
        });

        // $rootScope.$broadcast('$balancesUpdate');

    };

    function handleHistoryError(error, i) {
        console.error(error);
        if(typeof wallets[i] != 'undefined');
        wallets[i]['loadingHistory'] = false;
        wallets[i]['errorHistory'] = true;
        wallets[i]['endHistory'] = true;
    };

    function processTxn(tx, meta, is_historic, i) {

        var address = wallets[i].address;

        var processedTxn = JsonRewriter.processTxn(tx, meta, address);
        if (!processedTxn) return;

        if(!is_historic) {
            if(!angular.isUndefined(processedTxn.date)) {
                processedTxn.date = ripple.utils.toTimestamp(processedTxn.date);
            }
        }

        if (typeof wallets[i].history == 'undefined') return;

        // Update Ripple lines if not historic
        if (processedTxn.effects && !is_historic) {
            updateLines(processedTxn.effects, i);
        }

        // Update Offers if not historic
        if (processedTxn.effects && !is_historic) {
            // Iterate on each effect to find offers
            processedTxn.effects.forEach(function (effect) {
                // Only these types are offers
                if (_.contains([
                    'offer_created',
                    'offer_funded',
                    'offer_partially_funded',
                    'offer_cancelled'], effect.type))
                {
                    var offer = {
                        seq: +effect.seq,
                        gets: effect.gets,
                        pays: effect.pays,
                        deleted: effect.deleted,
                        flags: effect.flags
                    };

                    updateOffer(offer, i);
                }
            });

            $rootScope.$broadcast('$offersUpdate');
        }

        // Build display history
        var event = processedTxn;

        event.native = tx;

        var effects = [];
        var isFundedTrade = false; // Partially / fully funded
        var isCancellation = false;

        if (event.effects) {

            // Show effects
            $.each(event.effects, function(){
                var _this = this;

                switch (_this.type) {
                case 'offer_funded':
                case 'offer_partially_funded':
                case 'offer_bought':
                    isFundedTrade = true;
                    /* falls through */
                case 'offer_cancelled':
                    if (_this.type === 'offer_cancelled') {
                        isCancellation = true;
                        if (event.transaction && event.transaction.type === 'offercancel')
                            return;
                    }
                    effects.push(_this);
                    break;
                }
            });

            event.showEffects = effects;

            effects = [];

            // Balance changer effects
            $.each(event.effects, function(){
                var _this = this;

                switch (_this.type) {
                    case 'fee':
                    case 'balance_change':
                    case 'trust_change_balance':
                    case 'trust_create_remote':
                        effects.push(_this);
                        break;
                }
            });

            event.balanceEffects = effects;

        }

        // FillOrKill flag
        event.fillorkill = tx.Flags & ripple.Transaction.flags.OfferCreate.FillOrKill;

        // Check bridge transactions
        if(typeof tx.InvoiceID != 'undefined') {

            var invoice = tx.InvoiceID;

            // Format Invoice ID to UUID
            invoice = invoice.slice(0, 32).toLowerCase();
            invoice = invoice.replace( /([0-9a-fA-F]{8})([0-9a-fA-F]{4})([0-9a-fA-F]{4})([0-9a-fA-F]{4})([0-9a-fA-F]+)/, '$1-$2-$3-$4-$5' );

            // Check Accounts (contacts)
            var account = AccountsService.getById(invoice);
            if (typeof account !== 'undefined') {
                event.account = account;
            }

        }

        // Don't add if fillorkill
        if(typeof event.transaction != 'undefined' && event.transaction.type == 'offernew' && event.balance_changer != true && event.fillorkill) return;

        // Add to history
        if(is_historic) {
            wallets[i].history.push(event);
        }
        else {
            // console.log(event);
            wallets[i].history.unshift(event);
        }

        // Remove duplicates
        wallets[i].history = _.uniq(wallets[i].history, 'hash');

    };

    function updateLines(effects, i) {
        if (!Array.isArray(effects)) return;

        var balancesUpdated;

        $.each(effects, function () {
            if (_.contains([
            'trust_create_local',
            'trust_create_remote',
            'trust_change_local',
            'trust_change_remote',
            'trust_change_balance',
            'trust_change_no_ripple'], this.type))
            {
                var effect = this,
                line = {},
                index = effect.counterparty + effect.currency;

                line.currency = effect.currency;
                line.account = effect.counterparty;
                line.flags = effect.flags;
                line.no_ripple = !!effect.noRipple; // Force Boolean

                if (effect.balance) {
                    line.balance = effect.balance;
                    updateRippleBalance(effect.currency, effect.counterparty, effect.balance, i);
                    balancesUpdated = true;
                }

                if (effect.limit) {
                    line.limit = effect.limit;
                }

                if (effect.limit_peer) {
                    line.limit_peer = effect.limit_peer;
                }

                if (effect.deleted) {
                    return delete wallets[i].lines[index];
                }

                wallets[i].lines[index] = $.extend(wallets[i].lines[index], line);

            }
        });

        if (balancesUpdated) $rootScope.$broadcast('$balancesUpdate');
    };

    function updateOffer(offer, i) {
        if (offer.flags && offer.flags === ripple.Remote.flags.offer.Sell) {
            offer.type = 'sell';
            offer.first = offer.gets;
            offer.second = offer.pays;
        } else {
            offer.type = 'buy';
            offer.first = offer.pays;
            offer.second = offer.gets;
        }

        var price = $filter('rpamountratio')(offer.second, offer.first);
        var options = {
            hard_precision: true,
            precision: 6,
            tiny_precision: 6
        };

        offer.price = $filter('rpamount')(price, options).replace(/,/g, '');

        if(!wallets[i].offers){
            wallets[i].offers = {};
        }

        if (!offer.deleted) {
            wallets[i].offers[""+offer.seq] = offer;
        } else {
            if(wallets[i].offers[""+offer.seq]){
                delete wallets[i].offers[""+offer.seq];
            }
        }
    };

    function updateRippleBalance(currency, new_account, new_balance, i) {

        // Ensure the balances entry exists first
        if (!wallets[i].balances[currency]) {
            wallets[i].balances[currency] = {components: {}, total: null};
        }

        var balance = wallets[i].balances[currency];

        if (new_account) {
            balance.components[new_account] = new_balance;
        }

        $(balance.components).sort(function(a,b){
            return a.compareTo(b);
        });

        balance.total = null;
        for (var counterparty in balance.components) {
            var amount = balance.components[counterparty];
            balance.total = balance.total ? balance.total.add(amount) : amount;
        }

    };

    function getGatehubWallet(address) {
        if(address){
            return CoreRestangular.all('search').one('wallets', address);
        } else {
            console.log('Cannot call getGatehubWallet without passing in the address parameter');
        }
    };

    function setTrust(issuer, currency, master_key) {

        console.log('Set Trust');

        // Check if currency not XRP - no trust needed for XRP
        if(currency == 'XRP') {
            return;
        }

        for (var i = wallets.length - 1; i >= 0; i--) {

            // Check it's ripple wallet
            if(wallets[i].type !== 10 && wallets[i].type !== 11) {
                continue;
            };

            // Prepare TX
            var limit = 1000000000;
            var address = wallets[i].address;

            sendSetTrust(limit, issuer, currency, wallets[i]);

        };

    };

    function sendSetTrust(limit, issuer, currency, wallet) {

        // Ripple Transaction
        var tx = RippleNetwork.remote.createTransaction('TrustSet',
        {
            account: wallet.address,
            limit: limit+'/'+currency+'/'+issuer,
        });

        // Set rippling off
        tx.setFlags(ripple.Transaction.flags.TrustSet.SetNoRipple);


        var maxLedger = Settings.client.tx_last_ledger || 3;
        tx.lastLedger(RippleNetwork.remote._ledger_current_index + maxLedger);

        tx.on('success', function (res) {
            // console.log('Trust set');
        });

        tx.on('error', function (res) {
            console.error('Error', res);
        });


        RippleTx.submitTransaction(tx, wallet)
            .then(function(response) {
                console.log('Transaction processed', response);
            })
            .catch(function (error) {
                console.error(error);
            });

    };


    function setTxHistoryFilter(filter, value){
        txHistoryFilters[filter] = value;
    }

    function getTxHistoryFilters(){
      return txHistoryFilters;
    }

    function getExchangeRates(global, forCurrency) {
        var base = forCurrency || $localStorage.activeMetricCode;
        base = NonstandardCurrencies.parseAssetCode(base);

        // dash fix
        if (base === 'DSH') {
            base = 'DASH';
        }

        var CACHE_TIME = 2 // in minutes

        var deferred = $q.defer();

        if (exchangeRateCache.lastUpdated &&
            moment().diff(exchangeRateCache.lastUpdated, 'minutes') < CACHE_TIME &&
            exchangeRateCache.forCurrency === base
        ) {
            deferred.resolve(exchangeRateCache);
        }
        else {
            RatesRestangular
                .one('rates')
                .one('current?counter=' + base)
                .get()
                .then(function(data) {
                    var _exchnageRate = {
                        forCurrency: base,
                        lastUpdated: moment(),
                        rates: data
                    };
                    if (global) {
                        exchangeRateCache = _exchnageRate
                    }

                    deferred.resolve(_exchnageRate);
                })
                .catch(function(error) {
                    console.error(error);
                    deferred.reject(error);
                })
        }

        return deferred.promise;
    }

    // base is optional, will default to currency in local storage
    function updateWalletNetWorth(wallet) {

        var deferred = $q.defer();

        // we can still calculate xrp wallet balances
        if (!wallet) {
            deferred.reject('Wallet not defined');
        }

        if ((!wallet.lines || (_.isEmpty(wallet.lines) && !wallet.xrp)) && wallet.type !== 24) {
            deferred.resolve({ total: 0 });
        } else {
            getExchangeRates(true).then(function(data) {

                var netWorth = { };

                var rates = data.rates;

                for (var lineId in wallet.lines) {
                    if (wallet.lines.hasOwnProperty(lineId)) {
                        var line = wallet.lines[lineId];
                        netWorth[lineId] = calculateBalanceWorth(line, rates);
                    }
                }

                // handle ripple wallet xrp balances, as this is not a line
                if (wallet.type === 11 || wallet.type === 10) {
                    // todo: fetch id from vaults
                    var xrpLine = {
                        currency: "XRP",
                        available: wallet.xrp
                    };
                    netWorth['XRP'] = calculateBalanceWorth(xrpLine, rates);
                }

                netWorth.total = Object.values(netWorth).reduce(function(a,b) {
                    return a + b;
                }, 0);

                deferred.resolve(netWorth);
            })
            .catch(function(error) {
                deferred.reject(error);
            });
        }

        return deferred.promise;
    }


    // unless base is specified, currency from local storage will be used
    function calculateBalanceWorth(line, rates) {
        var rate = getExchangePairRate(line.currency, rates, line.account);
        if (rate) {
            // console.log('RATE', rate, line);
            var availableBalance = line.available || line.amount || line.balance.to_number();
            return availableBalance * rate;
        }
        else {
            console.warn('No rate!', NonstandardCurrencies.parseAssetCode(line.currency), '('+line.currency+') :', line.account);
            line.noRate = true;
            return 0;
        }
    }

    // base: eur, counter: usd -> 1.08 ....
    function getExchangePairRate(base, exchangeRates, vaultId) {
        if (!base || !exchangeRates) {
            console.error('Empty parameters');
            return null;
        }

        var _base = base.toUpperCase();

        var currencyVault = isConvertableCurrency(vaultId);
        if (vaultId && !currencyVault && _base !== 'XRP') {
            // console.error('Currency from unsupported issuer', base);
            return 0;
        }


        if (_base === exchangeRates.counter) {
            return 1.0;
        }

        // dash fix
        if (_base === 'DSH') {
            _base = 'DASH';
        }

        _base = NonstandardCurrencies.parseAssetCode(_base);

        // try to get exchange directly
        var exchangeRate = exchangeRates[_base];
        if (exchangeRate) {
            // console.log('Direct rate');
            return parseFloat(exchangeRate.rate);
        }
        else {
            //console.error('Rate not found (walletsService)', _base);
            return 0;
        }

        // if no direct exchange exists, try with usd as with a midway currency usd
        /* var usdCounterRate = _.find(exchangeRates, { base: 'USD', counter: _counter });
        var usdBaseRate = _.find(exchangeRates, { base: _base, counter: 'USD' });

        if (!usdBaseRate || !usdCounterRate) {
            return 0;
        }

        // console.log('Non-direct rate', usdCounterRate, usdBaseRate);
        rate = parseFloat(usdCounterRate.ask) * parseFloat(usdBaseRate.ask);

        if (isNaN(rate)) {
            return 0;
        }
        */
    }

    // check both id and issuer, cold address is not always available
    // backend should always provide same vault details
    function isConvertableCurrency(vaultId) {

        // Additional (non-gatehub) issuers
        var whitelistedIssuers = [
            'rvYAfWj5gh67oV6fW32ZzP3Aw4Eubs59B' // Bitstamp USD, BTC
        ];

        if (whitelistedIssuers.includes(vaultId)) {
            return true;
        }

        return VaultsService.list().find(vault => {
            return vault.vault_id === vaultId || vault.cold === vaultId;
        });
    }

    function findShadowAddress(xrpAddress) {
        return Auth.getProfile().then(function(user) {
            return CoreRestangular.one('users', user.id).get().then(function(data) {
                if (!Array.isArray(data.wallets)) {
                    console.error('No wallets returned');
                    return;
                }

                var walletShadow = data.wallets.find(function(wallet) {
                    return wallet.name === ('shadow@' + xrpAddress);
                });

                if (walletShadow) {
                    var wallet = getByAddress(xrpAddress);
                    wallet.shadow_address = walletShadow.address;
                }
                else {
                    console.error('No shadow wallet found for ' + xrpAddress);
                }
            });
        });
    }

};

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.storage
 * @description
 * # storage
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
  .factory('BalanceSorting', ['UserPreferencesService', '$q', balanceSorting]);

  function balanceSorting(UserPreferencesService, $q) {

    var addressOrder = null;

    var factory = {
        getBalanceOrder : getBalanceOrder,
        setBalanceOrder : setBalanceOrder,
    }

    return factory;

    function getBalanceOrder(walletAddress) {
        var deferred = $q.defer();
        var walletBalances = null;

        if (Array.isArray(addressOrder)) {
            walletBalances = findWallet(walletAddress);
            deferred.resolve(walletBalances.balances);
        }
        else {
            UserPreferencesService.getUserPreferences().then(function(config) {
                if (!_.isEmpty(config.currencyOrder)) {
                    addressOrder = config.currencyOrder;
                }
                else {
                    addressOrder = [];
                }
                walletBalances = findWallet(walletAddress);
                deferred.resolve(walletBalances.balances);

            }, function(error) {
                addressOrder = [];
                deferred.reject(error);
            });
        }

        return deferred.promise;
    }

    function setBalanceOrder(walletAddress, order) {
        // console.log('order: ', order);
        var walletBalances = findWallet(walletAddress);
        for (var i = 0; i < order.length; i++) {
            var element = order[i];
            if (typeof element != "string") {
                console.error('Order id type not string.');
                return walletBalances.balances;
            }
        }

        walletBalances.balances = _.uniq(order);

        UserPreferencesService.updateUserPreferences('currencyOrder', addressOrder)
            .then(function() { })
            .catch(function() { });

        return walletBalances.balances;
    }

    function findWallet(address) {
        var walletBalances = addressOrder.find(function(order) {
            return order.wallet === address;
        });

        if (walletBalances) {
            return walletBalances;
        }
        else {
            var newBalaceInfo = {
                wallet: address,
                balances: []
            }
            addressOrder.push(newBalaceInfo);

            return newBalaceInfo;
        }
    }

  }

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.AccountsService
 * @description
 * # AccountsService
 * Service in the gatehubClientApp.
 */
angular
    .module('gatehubClientApp')
    .factory('AccountsService', AccountsService);

AccountsService.$inject = ['$q', 'Auth', 'CoreRestangular'];

function AccountsService($q, Auth, CoreRestangular) {

    var accounts = [];
    var time = false;
    var loaded = false;


    // Hardcoded utility addresses
    var presetAddresses = [
        { address: 'rNnSa58mNaNo5u54u53Qc6dYEn5qW1iCB6', destination_tag: null, name: 'Wallet Protect payment account' },
        { address: 'rhub8VRN55s94qWKDv6jmDy1pUykJzF3wq', destination_tag: '322010847', name: 'Wallet Protect payment account' }
    ]

    var factory = {
        getAccounts: getAccounts,
        getById: getById,
        getByAddress: getByAddress,
    };

    return factory;

    ///////////////////////////////////////////////////////////


    function getAccounts(refresh) {

        // console.log('Get accounts');
        var deferred = $q.defer();

        if (loaded && !refresh) {
            deferred.resolve(accounts);
        }
        else {

            Auth.getProfile().then(function(data) {

                loaded = true;

                CoreRestangular.one('users', data.uid).all('accounts').getList().then(function(data) {

                    accounts = data.plain();

                    // Remove deleted
                    _.remove(accounts, function (accounts) {
                        return accounts.deleted == 1
                    });

                    deferred.resolve(accounts);

                }, function(error) {
                    deferred.reject(error);
                });

            }, function(error) {
                deferred.reject(error);
            });

        }

        return deferred.promise;

    };

    function getById(id) {
        var result = _(accounts).filter({uuid: id}).value();
        return result[0];
    };
    function getByAddress(address, dt) {
        var filter = {
            address: address,
            destination_tag: dt ? dt.toString() : null
        };

        const allAccounts = accounts ? [...accounts, ...presetAddresses] : presetAddresses;

        var results = _(allAccounts).filter(filter).value();

        return results[0];
    };
};

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.MarketsService
 * @description
 * # MarketsService
 * Service in the gatehubClientApp.
 */
angular
    .module('gatehubClientApp')
    .factory('MarketsService', MarketsService);

function MarketsService($rootScope, RippleCharts, $localStorage, Gateways, RippleNetwork, VaultsService, UserPreferencesService, NonstandardCurrencies) {

    var activeMarketListener = null;

    var gateways_list = [
        {currency: 'XRP', name: 'Ripple'}, // XRP must be first on the list!
        {currency: 'USD', issuer: 'rhub8VRN55s94qWKDv6jmDy1pUykJzF3wq', name: 'GateHub UAB'},
        {currency: 'EUR', issuer: 'rhub8VRN55s94qWKDv6jmDy1pUykJzF3wq', name: 'GateHub UAB'},
        {currency: 'GBP', issuer: 'r4GN9eEoz9K4BhMQXe4H1eYNtvtkwGdt8g', name: 'GateHub UAB'},
        {currency: 'BTC', issuer: 'rchGBxcD1A1C2tdxF6papQYZ8kjRKMYcL', name: 'GateHub UAB'},
        {currency: 'BCH', issuer: 'rcyS4CeCZVYvTiKcxj6Sx32ibKwcDHLds', name: 'GateHub UAB'},
        {currency: 'ETH', issuer: 'rcA8X3TVMST1n3CJeAdGk1RdRCHii7N2h', name: 'GateHub UAB'},
        {currency: 'ETC', issuer: 'rDAN8tzydyNfnNf2bfUQY6iR96UbpvNsze', name: 'GateHub UAB'},
        {currency: 'DSH', issuer: 'rcXY84C4g14iFp6taFXjjQGVeHqSCh9RX', name: 'GateHub UAB'},
        {currency: 'FLR', issuer: 'rcxJwVnftZzXqyH9YheB8TgeiZUhNo1Eu', name: 'GateHub UAB'},
        {currency: 'LTC', issuer: 'rcRzGWq6Ng3jeYhqnmM4zcWcUh69hrQ8V', name: 'GateHub UAB'},
        {currency: 'SGB', issuer: 'rctArjqVvTHihekzDeecKo6mkTYTUSBNc', name: 'GateHub UAB'},
        {currency: 'GALA', issuer: 'rf5YPb9y9P3fTjhxNaZqmrwaj5ar8PG1gM', name: 'GateHub UAB'},
        {currency: 'USDT', issuer: 'rcvxE9PS9YBwxtGg1qNeewV6ZB3wGubZq', name: 'GateHub UAB'},
        {currency: 'USDC', issuer: 'rcEGREd8NmkKRE8GE424sksyt1tJVFZwu', name: 'GateHub UAB'},
        {currency: 'WXRP', issuer: 'rEa5QY8tdbjgitLyfKF1E5Qx3VGgvbUhB3', name: 'GateHub UAB'},
        {currency: 'XAU', issuer: 'rcoef87SYMJ58NAFx7fNM5frVknmvHsvJ', name: 'BPG Kovine'},
        {currency: 'ELS', issuer: 'rHXuEaRYnnJHbDeuBH5w8yPh5uwNVh5zAg', name: 'Elysian'},
        {currency: 'SOLO', issuer: 'rsoLo2S1kiGeCcn6hCUXVrCpGMWLrRrLZz', name: 'Sologenic'},
    ];

    var markets_analytics = [
        {
            base: {
                name: 'GateHub UAB',
                currency: 'USD',
                issuer: 'rhub8VRN55s94qWKDv6jmDy1pUykJzF3wq',
            },
            counter: {
                name: 'Ripple',
                currency: 'XRP',
            },
        },
        {
            base: {
                name: 'GateHub UAB',
                currency: 'EUR',
                issuer: 'rhub8VRN55s94qWKDv6jmDy1pUykJzF3wq',
            },
            counter: {
                name: 'Ripple',
                currency: 'XRP',
            },
        },
        {
            base: {
                name: 'GateHub UAB',
                currency: 'EUR',
                issuer: 'rhub8VRN55s94qWKDv6jmDy1pUykJzF3wq',
            },
            counter: {
                name: 'GateHub UAB',
                currency: 'USD',
                issuer: 'rhub8VRN55s94qWKDv6jmDy1pUykJzF3wq',
            },
        },
        {
            base: {
                name: 'GateHub UAB',
                currency: 'ETH',
                issuer: 'rcA8X3TVMST1n3CJeAdGk1RdRCHii7N2h',
            },
            counter: {
                name: 'Ripple',
                currency: 'XRP',
            },
        },
        {
            base: {
                name: 'Bitstamp',
                currency: 'BTC',
                issuer: 'rvYAfWj5gh67oV6fW32ZzP3Aw4Eubs59B',
            },
            counter: {
                name: 'Ripple',
                currency: 'XRP',
            },
        },
    ];

    var defaultRatePairs = [
        { base: 'BTC', counter: 'USD' },
        { base: 'XRP', counter: 'USD' },
        { base: 'ETH', counter: 'USD' },
        { base: 'BTC', counter: 'EUR' },
        { base: 'XRP', counter: 'EUR' },
        { base: 'ETH', counter: 'EUR' },
        { base: 'XRP', counter: 'BTC' },
        { base: 'ETH', counter: 'BTC' },
    ];

    // Initial setup
    if(typeof $localStorage.gatewaysList === 'undefined') {
        $localStorage.gatewaysList = gateways_list;
    } else {
        var newGatewaysList = $localStorage.gatewaysList;

        // Rename GateHub & Fifth to UAB in users' localstorage
        newGatewaysList = newGatewaysList.map((gateway) => {
            return {
                currency: gateway.currency,
                issuer: gateway.issuer,
                name: (gateway.name === 'GateHub' || gateway.name === 'GateHub Fifth') ? "GateHub UAB" : gateway.name
            }
        });

        // Remove old DASH (now it should be DSH) from user's local storage. If we ever add DSH (DashCoin), delete this part
        _.remove(newGatewaysList, function (gateway) {
            return gateway && gateway.currency == 'DASH';
        });

        // Remove Quantum from user's local storage
        _.remove(newGatewaysList, function (gateway) {
            return gateway && gateway.currency == 'QAU';
        });

        // Remove obsolete TokyoJPY gateway from user's local storage
        _.remove(newGatewaysList, function (gateway) {
            return gateway && gateway.issuer == 'r94s8px6kSw1uZ1MV98dhSRTvc6VMPoPcN';
        });

        // Remove obsolete QAU gateway from user's local storage
        _.remove(newGatewaysList, function (gateway) {
            return gateway && gateway.issuer == 'r3ttJ41YnMrKiLqGUXJpQE8urqyMGjC8vE';
        });

        // Add XRP (to first place) if not present to user's local storage
        if (_.filter(newGatewaysList, {currency: 'XRP', name: 'Ripple'}).length === 0) {
            newGatewaysList.unshift({currency: 'XRP', name: 'Ripple'});
        }

        // Add all GateHub currencies (except the first one - XRP) that are not yet present in user's local storage
        for (var i = 1; i < gateways_list.length; i++) {
            if (_.filter(newGatewaysList, {currency: gateways_list[i].currency, issuer: gateways_list[i].issuer}).length === 0) {
                newGatewaysList.push(gateways_list[i]);
            }
        }

        gateways_list = newGatewaysList.filter(gw => gw); // filter any undefined / falsy values
        $localStorage.gatewaysList = gateways_list; // save modified list to local storage
    };

    // REMOVE DUPLICATES
    var unique_gateways_list = [];
    for(var i = 0; i < gateways_list.length; i++){
        var is_duplicate = false;
        for(var j = 0; j < unique_gateways_list.length; j++){
            if(
                gateways_list[i].currency == unique_gateways_list[j].currency &&
                gateways_list[i].issuer == unique_gateways_list[j].issuer
            ){
                is_duplicate = true;
            }
        }
        if(!is_duplicate){
            unique_gateways_list.push(gateways_list[i]);
        }
    }
    gateways_list = unique_gateways_list;

    var markets = {
        default: [],
        custom: [],
        onDemand: []
    };

    var pairs = [];
    var customUserMarkets = [];

    var firstLoad = true;
    var currencies = {};

    var factory = {
        pairs: getPairs(),
        list: list,
        list_gateways: list_gateways,
        getMarket: getMarket,
        addMarket: addMarket,
        addCustomMarket: addCustomMarket,
        deleteMarket: deleteMarket,
        addCurrency: addCurrency,
        getAnalyticsMarkets: getAnalyticsMarkets,
        updateLastTrades: updateLastTrades,
        getDefaultRatePairs: getDefaultRatePairs,
        updateConfigArray: updateConfigArray,
        subscribeToMarket: subscribeToMarket,
        unsubscribeMarketFeed: unsubscribeMarketFeed,
        refreshHistoricMarketsData: refreshHistoricMarketsData
    };

    return factory;

    ///////////////////////////////////////////////////////////

    function getPairs() {
        return pairs;
    }

    function getDefaultRatePairs() {
        return defaultRatePairs;
    }

    function getAnalyticsMarkets() {

        for (var i = markets_analytics.length - 1; i >= 0; i--) {

            (function(i){

                var _base = (markets_analytics[i].base.currency != 'XRP') ? NonstandardCurrencies.encodeAssetCode(markets_analytics[i].base.currency) + '+' + markets_analytics[i].base.issuer : 'XRP';
                var _counter = (markets_analytics[i].counter.currency != 'XRP') ? NonstandardCurrencies.encodeAssetCode(markets_analytics[i].counter.currency) + '+' + markets_analytics[i].counter.issuer : 'XRP';

                // Trades history 7d - Markets Charts
                var params = {
                    start: moment().subtract(7, 'd').startOf('minute').toISOString(),
                    end: moment().startOf('minute').toISOString(),
                    interval: '1hour',
                    limit: 1000,
                    descending: false,
                };

                RippleCharts.getExchanges(_base, _counter, params)
                    .success(function(data){
                        handleOffersAnalytics(data, i)
                    });

            })(i);

        }

        return markets_analytics;
    };

    function list() {
        connect();
        return markets;
    };

    function list_gateways() {
        return gateways_list;
    };

    function addCurrency(currency) {

        var found = false;

        for (var i = gateways_list.length - 1; i >= 0; i--) {
            if(gateways_list[i].issuer == currency.issuer && gateways_list[i].currency == currency.currency) {
                found = true;
            }
        }

        if(found != true) {
            gateways_list.push(currency);
            $localStorage.gatewaysList = gateways_list;
        };

    };

    function getMarket(base, counter, marketType) {
        var id = base.currency + (base.issuer ? '+' + base.issuer : '') + '/' + counter.currency + (counter.issuer ? '+' + counter.issuer : '');

        var allMarkets = [];
        if (marketType) {
            allMarkets = markets[marketType];
        }
        else {
            allMarkets = [...markets.default, ...markets.custom, ...markets.onDemand];
        }
        for (var i = 0; i < allMarkets.length; i++) {
            if (allMarkets[i].id == id) {
                return allMarkets[i];
            }
        };
        return null;

    };

    function connect() {

        if(!firstLoad) return;

        firstLoad = false;

        pairs = getDefaultMarkets();
        // Connect all pairs
        for (var i = 0; i < pairs.length; i++) {
            addMarket(pairs[i], 'default');
        }

        UserPreferencesService.getUserPreferences().then(function(config) {
            customUserMarkets = _.clone(config.customMarkets);
            if (_.isEmpty(customUserMarkets)) {
                customUserMarkets = [];
            }
            addUserMarkets(customUserMarkets);
        })
        .catch(function() { });
    };

    function deleteMarket(id) {
        _.remove(markets.custom, function (market) {
            return market.id === id
        });

        if (customUserMarkets) {
            var removed = _.remove(customUserMarkets, function(market) {
                return market === id;
            });

            if (removed) {
                UserPreferencesService.updateUserPreferences('customMarkets', customUserMarkets)
                    .then(function() { })
                    .catch(function() { });
            }
        }
    };

    function addMarket(pair, marketType) {

        // Check if already added
        if (getMarket(pair.base, pair.counter, marketType)) {
            if (marketType !== 'default') { // don't skip default markets, even if duplicated
                return;
            }
        }

        // Check names
        pair.base.name = (pair.base.currency === 'XRP') ? 'Ripple': nameGateway(pair.base.issuer);
        pair.counter.name = (pair.counter.currency === 'XRP') ? 'Ripple': nameGateway(pair.counter.issuer);

        var market = {
            id: pair.base.currency + (pair.base.issuer ? '+' + pair.base.issuer : '') + '/' + pair.counter.currency + (pair.counter.issuer ? '+' + pair.counter.issuer : ''),
            base: pair.base,
            counter: pair.counter,
            listIn: pair.listIn,

            loadingMarket: true,
            loadingTrades: true,

            trades: [],

            day: {
                volume: '',
                open: '',
                high: '',
                low: '',
                last: '',
                change: '',
            },
            fetchMarketData: function() {}
        }

        // separate default and custom markets
        var _marketType = marketType || 'default';
        markets[_marketType].push(market);

        $rootScope.$broadcast('$marketsAnalyticsCustomUpdate');

        market.fetchMarketData = function() {
            var _base = (market.base.currency !== 'XRP') ? NonstandardCurrencies.encodeAssetCode(market.base.currency) + '+' + market.base.issuer : 'XRP';
            var _counter = (market.counter.currency !== 'XRP') ? NonstandardCurrencies.encodeAssetCode(market.counter.currency) + '+' + market.counter.issuer : 'XRP';

            // Trades history 7d - Markets Charts
            var params = {
                start: moment().subtract(7, 'd').startOf('minute').toISOString(),
                end: moment().startOf('minute').toISOString(),
                interval: '1hour',
                limit: 1000,
                descending: false,
            };

            RippleCharts.getExchanges(_base, _counter, params)
                .success(function(data){
                    handleOffers(data, market)
                })
                .error(handleOffersError);


            // Trades history - Last Trades
            var params = {
                start: moment().subtract(1, 'y').startOf('minute').toISOString(),
                end: moment().startOf('minute').toISOString(),
                limit: 80,
                descending: true,
                reduce: false,
            };

            RippleCharts.getExchanges(_base, _counter, params)
                .success(function(data){
                    handleOffersLast(data, market)
                })
                .error(handleOffersError);

            // 24h stats
            var params = {
                start: moment().subtract(24, 'h').startOf('minute').toISOString(),
                end: moment().startOf('minute').toISOString(),
                limit: 1000,
                interval: '15minute',
            };

            RippleCharts.getExchanges(_base, _counter, params)
                .success(function(data){
                    handleDayStats(data, market)
                })
                .error(handleOffersError);
        };

        // offset the loading of historic data a bit so every thing else
        // loads more responsively
        setTimeout(() => {
            market.fetchMarketData();
        }, 2000);

        return market;
    };

    function subscribeToMarket(market) {
        if (activeMarketListener) {
            unsubscribeMarketFeed();
        }

        // Live Feed
        var requestFeed = {
            base: market.base,
            counter: market.counter,
            openTime: moment.utc().subtract(24, 'h').startOf('minute')
        };
        activeMarketListener = new OffersExercisedListener(RippleNetwork.remote, requestFeed, function(data) {
            handleTrades(data, market);
        });
    }

    function unsubscribeMarketFeed() {
        if (activeMarketListener) {
            activeMarketListener.stopListener();
        }
    }

    function refreshHistoricMarketsData() {
        Object.values(markets).flat().map(function(market) {
            market.fetchMarketData()
        });
    }

    function addCustomMarket(pair) {
        if (!pair || !pair.counter || !pair.base || !pair.base.currency || !pair.counter.currency) {
            console.error('Bad market pair format');
        }
        else {
            var base = pair.base.currency + (pair.base.issuer ? ('+' + pair.base.issuer) : '');
            var counter = pair.counter.currency + (pair.counter.issuer ? ('+' + pair.counter.issuer) : '');
            var marketPair = base + '/' + counter;

            if (customUserMarkets.indexOf(marketPair) > -1) {
                console.error('Market pair already exists');
            }
            else {
                customUserMarkets.push(marketPair);
                var market = addMarket(pair, 'custom');
                if (market) {
                    UserPreferencesService.updateUserPreferences('customMarkets', customUserMarkets)
                        .then(function() { })
                        .catch(function() { })
                }
            }
        }
    }

    function addUserMarkets(markets) {
        markets.forEach(function(marketPairs) {
            var pairIds = marketPairs.split('/');
            var baseId = pairIds[0];
            var counterId = pairIds[1];

            var base = baseId.split('+');
            var baseCurrency = base[0];
            var baseIssuer = base[1];

            var counter = counterId.split('+');
            var counterCurrency = counter[0];
            var counterIssuer = counter[1];

            var pair = {
                base: { currency: baseCurrency, issuer: baseIssuer },
                counter: { currency: counterCurrency, issuer: counterIssuer },
            };
            addMarket(pair, 'custom');
        });
    }

    function handleDayStats(data, market) {

        if (!market) return;

        var exchanges = data.exchanges;

        var volume_total = 0;
        var low;
        var high;
        var open;
        var close;

        for (var x in exchanges) {

            if(x == 0) {
                open = parseFloat(exchanges[x]['open']);
                high = parseFloat(exchanges[x]['high']);
                low = parseFloat(exchanges[x]['low']);
            };

            close = parseFloat(exchanges[x]['close']);
            high = (parseFloat(exchanges[x]['high']) > high) ? parseFloat(exchanges[x]['high']) : high;
            low = (parseFloat(exchanges[x]['low']) < low) ? parseFloat(exchanges[x]['low']) : low;

            volume_total += parseFloat(exchanges[x]['base_volume']);

        }

        // Update change
        var change = close - open;
        var change_ratio = (change / open) * 100;

        // Update data
        market.day.volume = volume_total;
        market.day.open = open;
        market.day.close = close;
        market.day.high = high;
        market.day.low = low;

        market.day.change = change;
        market.day.change_ratio = change_ratio;

    };

    function handleTrades(data, market) {
        if (!market) return;

        market['loadingTrades'] = false;

        var last = market.trades[0];

        var trade = {
            time   : moment.utc(data.value[5]).unix(),
            price  : ""+data.value[2],
            amount : ""+data.value[0],
            type   : '',
            tx     : data.value[6] // tx hash
        }


        if (last && last.price < trade.price)      trade.type = 'ask';
        else if (last && last.price > trade.price) trade.type = 'bid';

        trade.id = market.id + "_" + trade.time + "_" + trade.price + "_" + trade.amount + "_" + trade.tx + "_" + trade.type;

        // REMOVE NON-UNIQUE TRADES, angularjs list throws errors otherwise
        var isDuplicate = _.find(market.trades, function(t) {
            return t.id === trade.id;
        });
        if(!isDuplicate) {
            market.trades.unshift(trade);  // prepend trade
        } else {
            // console.log('Duplicate last trade, ignoring:', trade);
        }

        // if last trade arrived out of order for some reason, sort trades
        if(market.trades.length > 1){
            if(market.trades[0].time < market.trades[1].time) {
                console.log('Last trade out of order, sorting...')
                market.trades = _.sortByOrder(market.trades, 'time', 'desc');
            }
        }

        if (trade.price > market.high) market.high = trade.price;
        if (trade.price < market.low)  market.low  = trade.price;

        // Update Weekly Data
        market.last   =  data.value[2];
        market.volume += data.value[0];

        // Update Daily Data
        market.day.last   =  data.value[2];
        market.day.volume += data.value[0];

    };

    function handleOffersAnalyticsCustom(data, i) {

        if (typeof markets.custom[i] == 'undefined') return;

        var _data = [];

        markets.custom[i]['loadingMarket'] = false;
        markets.custom[i].data = [];

        var exchanges = data.exchanges;

        for (var x = exchanges.length - 1; x >= 0; x--) {

            var price = parseFloat(exchanges[x]['close']);
            var UTC = moment.utc(exchanges[x]['close_time']).unix() * 1000;

            _data.push([UTC, price]);

        };

        if(_data.length == 0) return;

        // Color
        var color = '#A6CD43';

        var open = _data[0][1];
        var close = _data[_data.length-1][1];

        var change = close - open;
        var change_ratio = (change / open) * 100;

        // Update data
        markets.custom[i].last = close;
        markets.custom[i].data = _data;
        markets.custom[i].change = change;
        markets.custom[i].change_ratio = change_ratio;

        if(price < open) {
            markets.custom[i].red = true;
        }

        $rootScope.$broadcast('$marketsAnalyticsCustomUpdate');

    };

    function handleOffersAnalytics(data, i) {

        if (typeof markets_analytics[i] == 'undefined') return;

        var datax = [];
        var volume_total = 0;
        var last;
        var low;
        var high;
        var open;
        var volume;
        var change;
        var change_ratio;

        markets_analytics[i]['loadingMarket'] = false;
        markets_analytics[i].data = [];

        var exchanges = data.exchanges;

        for (var x in exchanges) {

            var price = parseFloat(exchanges[x]['close']);

            if(x == 0) {
                low = price;
                high = price;
                open = price;
            }

            var price_open = parseFloat(exchanges[x]['open']);
            var price_high = parseFloat(exchanges[x]['high']);
            var price_low = parseFloat(exchanges[x]['low']);
            var volume = parseFloat(exchanges[x]['base_volume']);

            var UTC = moment.utc(exchanges[x]['close_time']).unix()*1000;

            // Update Volume
            volume_total += volume;

            // Update Low
            if(price_low < low) {
                low = price_low;
            }

            // Update High
            if(price_high > high) {
                high = price_high;
            }

            // Push chart data
            datax.push([UTC, price]);

        };

        // Update change
        var change = price - open;
        var change_ratio = (change / open) * 100;

        // Update data
        markets_analytics[i].volume = volume_total;
        markets_analytics[i].open = open;
        markets_analytics[i].high = high;
        markets_analytics[i].low = low;
        markets_analytics[i].last = price;
        markets_analytics[i].data = datax;
        markets_analytics[i].change = change;
        markets_analytics[i].change_ratio = change_ratio;

        if(price < open) {
            markets_analytics[i].red = true;
        }

        $rootScope.$broadcast('$marketsAnalyticsUpdate');

    };

    function handleOffers(data, market) {

        if (!market) return;

        var datax = [];
        var volume_total = 0;
        var last;
        var low;
        var high;
        var open;
        var volume;
        var change;
        var change_ratio;

        market['loadingMarket'] = false;
        market.data = [];

        var exchanges = data.exchanges;

        for (var x in exchanges) {

            var price = parseFloat(exchanges[x]['close']);

            if(x == 0) {
                low = price;
                high = price;
                open = price;
            }

            var price_open = parseFloat(exchanges[x]['open']);
            var price_high = parseFloat(exchanges[x]['high']);
            var price_low = parseFloat(exchanges[x]['low']);
            var volume = parseFloat(exchanges[x]['base_volume']);

            var UTC = moment.utc(exchanges[x]['close_time']).unix()*1000;

            // Update Volume
            volume_total += volume;

            // Update Low
            if(price_low < low) {
                low = price_low;
            }

            // Update High
            if(price_high > high) {
                high = price_high;
            }

            // Push chart data
            datax.push([UTC, price]);

        };

        // Update change
        var change = price - open;
        var change_ratio = (change / open) * 100;

        // Update data
        market.volume = volume_total;
        market.open = open;
        market.high = high;
        market.low = low;
        market.last = price;
        market.data = datax;
        market.change = change;
        market.change_ratio = change_ratio;

        if(price < open) {
            market.red = true;
        }

        $rootScope.$broadcast('$marketsUpdate');

    };

    function handleOffersLast(data, market) {

        if (!market) return;

        market['loadingTrades'] = false;

        var exchanges = data.exchanges;
        if(exchanges.length > 0) {

            // use only unique last trades in list
            const newData = [];
            const map = new Map();
            for (let trade of exchanges) {
                const id = market.id + "_" + trade['executed_time'] + "_" + trade['rate'] + "_" + trade['base_amount'] + "_" + trade['counter_amount'] + "_" + trade['tx_hash'] + "_" + trade['offer_sequence'];
                if(!map.has(id)){
                    map.set(id, true);
                    newData.push({
                        id      : id,
                        time    : moment.utc(trade['executed_time']).unix(),
                        price   : trade['rate'],
                        amount  : trade['base_amount'],
                        value   : trade['counter_amount'],
                        tx      : trade['tx_hash'],
                        seq     : trade['offer_sequence'],
                        type    : ''
                    });
                }
            }

            var prev = null;
            for (var j = newData.length; j >- 1; j--) {
                if (prev && prev.price > newData[j].price) {
                    newData[j].type = 'bid';
                }
                else if (prev && prev.price < newData[j].price) {
                    newData[j].type = 'ask';
                }
                prev = newData[j];
            }

            market.trades = newData;
        };
    };

    function handleOffersError(error) {
        console.error(error);
    };

    function nameGateway(address) {
        // Check predefined gateways
        for (var i = 0, l = Gateways.length; i < l; i++) {
            if (Gateways[i].accounts[0].address === address) {
                return Gateways[i].name;
            }
        }
        // Check custom gateways
        for (var i = gateways_list.length - 1; i >= 0; i--) {
            if(gateways_list[i].issuer == address) {
                return gateways_list[i].name;
            }

        }
        return address
    };

    function updateLastTrades(market, showMoreTradesSuccessCallback, showMoreTradesErrorCallback){
        var xbase = market.base.currency + (market.base.issuer ? '+' + market.base.issuer : '');
        var xcounter = market.counter.currency + (market.counter.issuer ? '+' + market.counter.issuer : '');

        var params = {
            start: moment().subtract(1, 'y').startOf('minute').toISOString(),
            end: moment().add(1, 'm').startOf('minute').toISOString(),
            limit: 400, // 400 is max, don't think we need more
            descending: true,
            reduce: false
        };

        RippleCharts.getExchanges(xbase, xcounter, params)
            .success(function(data) {
                handleOffersLast(data, market);
                showMoreTradesSuccessCallback();
            })
            .error(function(error) {
                handleOffersError(error);
                showMoreTradesErrorCallback();
            });
    }

    function getDefaultMarkets() {
        VaultsService.list().filter(function(vault) {
            return !vault.admin_only && vault.cold
        }).map(function(vault) {
            currencies[vault.currency] = { currency: vault.currency, issuer: vault.currency === 'XRP' ? '' : vault.cold };
        });

        // hack for adding 3rd party coins
        currencies['CSC'] = { currency: 'CSC', issuer: 'rCSCManTZ8ME9EoLrSHHYKW8PPwWMgkwr' };
        currencies['ELS'] = { currency: 'ELS', issuer: 'rHXuEaRYnnJHbDeuBH5w8yPh5uwNVh5zAg' };
        currencies['SOLO'] = { currency: 'SOLO', issuer: 'rsoLo2S1kiGeCcn6hCUXVrCpGMWLrRrLZz' };

        var defaultMarkets = [
            // USD
            { base: currencies.XRP, counter: currencies.USD, listIn: 'USD' },
            { base: currencies.EUR, counter: currencies.USD, listIn: 'USD' },
            { base: currencies.GBP, counter: currencies.USD, listIn: 'USD' },
            { base: currencies.BTC, counter: currencies.USD, listIn: 'USD' },
            { base: currencies.ETH, counter: currencies.USD, listIn: 'USD' },
            { base: currencies.LTC, counter: currencies.USD, listIn: 'USD' },
            { base: currencies.BCH, counter: currencies.USD, listIn: 'USD' },
            { base: currencies.ETC, counter: currencies.USD, listIn: 'USD' },
            { base: currencies.DSH, counter: currencies.USD, listIn: 'USD' },
            { base: currencies.XAU, counter: currencies.USD, listIn: 'USD' },
            { base: currencies.CSC, counter: currencies.USD, listIn: 'USD' },
            { base: currencies.SGB, counter: currencies.USD, listIn: 'USD' },
            { base: currencies.ELS, counter: currencies.USD, listIn: 'USD' },
            { base: currencies.SOLO, counter: currencies.USD, listIn: 'USD' },
            { base: currencies.GALA, counter: currencies.USD, listIn: 'USD' },
            { base: currencies.USDT, counter: currencies.USD, listIn: 'USD' },
            { base: currencies.USDC, counter: currencies.USD, listIn: 'USD' },
            { base: currencies.WXRP, counter: currencies.USD, listIn: 'USD' },
            
            // EUR
            { base: currencies.XRP, counter: currencies.EUR, listIn: 'EUR' },
            { base: currencies.USD, counter: currencies.EUR, listIn: 'EUR' },
            { base: currencies.GBP, counter: currencies.EUR, listIn: 'EUR' },
            { base: currencies.BTC, counter: currencies.EUR, listIn: 'EUR' },
            { base: currencies.ETH, counter: currencies.EUR, listIn: 'EUR' },
            { base: currencies.LTC, counter: currencies.EUR, listIn: 'EUR' },
            { base: currencies.BCH, counter: currencies.EUR, listIn: 'EUR' },
            { base: currencies.ETC, counter: currencies.EUR, listIn: 'EUR' },
            { base: currencies.DSH, counter: currencies.EUR, listIn: 'EUR' },
            { base: currencies.XAU, counter: currencies.EUR, listIn: 'EUR' },
            { base: currencies.CSC, counter: currencies.EUR, listIn: 'EUR' },
            { base: currencies.SGB, counter: currencies.EUR, listIn: 'EUR' },
            { base: currencies.ELS, counter: currencies.EUR, listIn: 'EUR' },
            { base: currencies.SOLO, counter: currencies.EUR, listIn: 'EUR' },
            { base: currencies.GALA, counter: currencies.EUR, listIn: 'EUR' },
            { base: currencies.USDT, counter: currencies.EUR, listIn: 'EUR' },
            { base: currencies.USDC, counter: currencies.EUR, listIn: 'EUR' },
            { base: currencies.WXRP, counter: currencies.EUR, listIn: 'EUR' },
            
            // XRP
            { base: currencies.XRP, counter: currencies.USD, listIn: 'XRP' },
            { base: currencies.XRP, counter: currencies.EUR, listIn: 'XRP' },
            { base: currencies.XRP, counter: currencies.GBP, listIn: 'XRP' },
            { base: currencies.XRP, counter: currencies.BTC, listIn: 'XRP' },
            { base: currencies.XRP, counter: currencies.ETH, listIn: 'XRP' },
            { base: currencies.XRP, counter: currencies.LTC, listIn: 'XRP' },
            { base: currencies.XRP, counter: currencies.BCH, listIn: 'XRP' },
            { base: currencies.XRP, counter: currencies.ETC, listIn: 'XRP' },
            { base: currencies.XRP, counter: currencies.DSH, listIn: 'XRP' },
            { base: currencies.XRP, counter: currencies.XAU, listIn: 'XRP' },
            { base: currencies.XRP, counter: currencies.CSC, listIn: 'XRP' },
            { base: currencies.XRP, counter: currencies.SGB, listIn: 'XRP' },
            { base: currencies.XRP, counter: currencies.ELS, listIn: 'XRP' },
            { base: currencies.XRP, counter: currencies.SOLO, listIn: 'XRP' },
            { base: currencies.XRP, counter: currencies.GALA, listIn: 'XRP' },
            { base: currencies.XRP, counter: currencies.USDT, listIn: 'XRP' },
            { base: currencies.XRP, counter: currencies.USDC, listIn: 'XRP' },
            { base: currencies.XRP, counter: currencies.WXRP, listIn: 'XRP' },
        ];

        defaultMarkets = defaultMarkets.filter(currency => currency.base && currency.counter);

        return defaultMarkets;
    }

    function updateConfigArray(configArr) {
        return configArr.map((e) => {
            return {
                base: currencies[e.base],
                counter: currencies[e.counter],
                listIn: e.listIn,
            };
        });
    }
}
MarketsService.$inject = ["$rootScope", "RippleCharts", "$localStorage", "Gateways", "RippleNetwork", "VaultsService", "UserPreferencesService", "NonstandardCurrencies"];;

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.idService
 * @description
 * # idService
 * Service in the gatehubClientApp.
 */
angular
    .module('gatehubClientApp')
    .factory('IdService', IdService);

IdService.$inject = ['$http', 'Settings'];

function IdService($http, Settings) {

    var factory = {
        getRippleAddress: getRippleAddress,
        getGatehubRippleAddress: getGatehubRippleAddress,
    };

    return factory;

    ///////////////////////////////////////////////////////////

    function getRippleAddress(account) {

        // Get prefix
        var address = encodeURIComponent(account);
        var prefix = '~';
        if(address.indexOf('~') == 0){
            prefix = ''
        }

        return $http({
            url: Settings.id.ripple_name_server + '/authinfo?domain=rippletrade.com&username='+prefix+address,
            method: 'GET',
        })

    };

    function getGatehubRippleAddress(name) {

        // Get prefix
        name = name.replace('+', '');

        return $http({
            url: Settings.id.gatehub_name_server + '?query=name:'+name,
            method: 'GET',
        })

    };

};

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.Interledger
 * @description
 * # Interledger
 * Service in the gatehubClientApp.
 */
angular
    .module('gatehubClientApp')
    .factory('Interledger', Interledger);

Interledger.$inject = ['$q', 'InterledgerRestangular', 'RatesRestangular', 'CoreRestangular'];

function Interledger($q, InterledgerRestangular, RatesRestangular, CoreRestangular) {

    var factory = {
        getName: getName,
        getRate: getRate,
        getLiquidityProvider: getLiquidityProvider,
        submit: submit,
        getBasesByCounter: getBasesByCounter
    };

    return factory;

    ///////////////////////////////////////////////////////////

    function getName(name) {

        var deferred = $q.defer();

        CoreRestangular.one('search/email', name).getList().then(function(data) {
            deferred.resolve(data.plain());
        }, function(error) {
            deferred.reject(error);
        });

        return deferred.promise;

    };

    function getLiquidityProvider() {

        var deferred = $q.defer();

        RatesRestangular.all('liquidity_provider/vaults').getList().then(function (data) {
            var _data = data.plain();

            // Find first norml LP
            for (var i = _data.length - 1; i >= 0; i--) {
                if(_data[i].type == 'normal'){
                    deferred.resolve(_data[i]);
                    return;
                };
            };

            // No normal LP
            deferred.reject('Connector not available');

        }, function(error) {
            deferred.reject(error);
        });

        return deferred.promise;

    };

    function getRate(base, counter) {

        var deferred = $q.defer();

        getLiquidityProvider().then(function(data) {

            // Don't search for vault combinations that are not supported
            var baseEnabled = _.find(data.vaults, {vault_uuid: base});
            var counterEnabled = _.find(data.vaults, {vault_uuid: counter});

            if(typeof baseEnabled != 'undefined' && typeof counterEnabled != 'undefined') {
                RatesRestangular.one('liquidity_provider', data.uuid).one('rate_curve').one(base).one(counter).get().then(function (data) {
                    deferred.resolve(data);
                }, function(error) {
                    deferred.reject(error);
                });
            }
            else {
                deferred.reject('Base or counter vault not enabled by LP');
            }

        }, function(error) {
            deferred.reject(error);
        });

        return deferred.promise;

    };

    function getBasesByCounter(vault_uuid){
       var deferred = $q.defer();

       RatesRestangular.one('liquidity_provider').one('pairs').one('*').one(vault_uuid).get().then(function(data){
           var bases = data.map(function(el){
               return el.base;
           });
           bases = _.uniq(bases);
           deferred.resolve(bases);
       }, function(error) {
           deferred.reject(error);
       });
       return deferred.promise;
    }

    function submit(params) { // xxx nov submit naredi

        var deferred = $q.defer();

        InterledgerRestangular.all('withdraw').post(params).then(function(data) { // xxx nov restangular
            deferred.resolve(data);
        }, function(error) {
            deferred.reject(error);
        });

        return deferred.promise;

    };

};

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.ExportService
 * @description
 * # ExportService
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
	.factory('ExportService', ExportService);

function ExportService(Restangular, CoreRestangular, $filter, Settings, $exceptionHandler) {

	var nameAddress = $filter('nameAddress');
	var snakeToSpacedCase = $filter('snakeToSpacedCase');
	var rippleExportData = []; // storage for data in case of multiple pages (markers)
	var psdExportData = []; // storage for data in case of lots of PSD transactions

	var factory = {
		hostedExport: hostedExport,
		rippleExport: rippleExport,
		psdExport: psdExport,
		getHostedExportHeader: getHostedExportHeader,
		getRippleExportHeader: getRippleExportHeader,
		getPsdExportHeader: getPsdExportHeader
	}
	return factory;

	function getHostedExportHeader(){
		return ["Time", "TX hash", "Type", "Amount", "Currency", "Base Wallet Address", "Base Wallet Name", "Counter Wallet Address", "Counter Wallet Name", "Counter Wallet Type", "Exchange Reference"];
	}

	function getRippleExportHeader(){
		return ["Time", "TX hash", "Type", "Amount", "Currency", "Currency Issuer Address", "Currency Issuer Name", "Balance"];
	}

	function getPsdExportHeader(){
		return ["Time", "Category", "Amount", "Currency"];
	}

	function hostedExport(account, from, to) {

		var from = from.format('YYYY-MM-DDTHH:mm:ss');
		var to = to.format('YYYY-MM-DDTHH:mm:ss');

		var params = {
			"filters": {
				"transactions.created_at": {
					"from": from,
					"to": to
				}
			}
		}

		return CoreRestangular.one('wallets', account).post('transactions', params).then(function (data) {
			var exportData = [];
			data = data.plain();

			data.forEach(function (tx) {
				var isRippleSend = tx.type == 0;
				var isRippleReceive = tx.type == 1;
				var isHostedSend = tx.type == 2 && tx.sending_wallet.address == account;
				var isHostedReceive = tx.type == 2 && tx.receiving_wallet.address == account;
				var isSuccessful = tx.status == 100 || tx.status == 107;

				if (!isSuccessful) {
					return;
				}

				var base_address, base_name, counter_address, counter_name;

				if (isRippleSend) {
					base_address = tx.sending_wallet.address;
					base_name = tx.sending_wallet.name;
					counter_address = tx.account ? tx.account.address : '';
					counter_name = tx.account && nameAddress(tx.account.address) != tx.account.address ? nameAddress(tx.account.address) : '';
				}
				if (isRippleReceive) {
					base_address = tx.receiving_wallet.address;
					base_name = tx.receiving_wallet.name;
					counter_address = tx.account ? tx.account.address : '';
					counter_name = tx.account && nameAddress(tx.account.address) != tx.account.address ? nameAddress(tx.account.address) : '';
				}
				if (isHostedSend) {
					base_address = tx.sending_wallet.address;
					base_name = tx.sending_wallet.name;
					counter_address = tx.receiving_wallet.address;
					counter_name = tx.receiving_wallet.name;
				}
				if (isHostedReceive) {
					base_address = tx.receiving_wallet.address;
					base_name = tx.receiving_wallet.name;
					counter_address = tx.sending_wallet.address;
					counter_name = tx.sending_wallet.name;
				}

				var type = (isRippleSend || isHostedSend) ? 'payment_sent' : 'payment_received';
				var exchangeReference = "";
				if(tx.meta && tx.meta.convertRef){
					type = 'exchange';
					exchangeReference = tx.meta.convertRef;
				}

				var history_item = {
					"Time": moment.utc(tx.created_at).format('MMM DD, YYYY, HH:mm'),
					"TX hash": tx.uid,
					"Type": type,
					"Amount": (isRippleSend || isHostedSend) ? "-" + tx.amount : tx.amount,
					"Currency": tx.vault.asset_code,
					"Base Wallet Address": base_address,
					"Base Wallet Name": base_name,
					"Counter Wallet Address": counter_address,
					"Counter Wallet Name": counter_name,
					"Counter Wallet Type": (isRippleSend || isRippleReceive) ? 'xrpl' : 'hosted',
					"Exchange Reference": exchangeReference
				}
				exportData.push(history_item);

			});

			return exportData;
		});

	}

	function rippleExport(account, from, to){
		rippleExportData = [];
		var marker = '';
		return rippleExportNext(account, marker, from, to);
	}

	function rippleExportNext(account, marker, from, to){
		return getXrplBalanceChanges(account, marker, from, to)
			.then(function (response) {
				if (response) {
					response.balance_changes.forEach(function (b) {

						if(b.node_index === null){
							return;
						}

						var counterparty = b.counterparty ? b.counterparty : '';
						var counterpartyName = b.counterparty ? nameAddress(b.counterparty) : '';
						var change_type = b.change_type;
						if (change_type == 'transaction_cost') change_type = 'xrpl_network_fee';
						if (change_type == 'payment_destination') change_type = 'payment';
						if (change_type == 'payment_source') change_type = 'payment';
						var balance_change_prepared = {
							"Time": moment.utc(b.executed_time).format('MMM DD, YYYY, HH:mm'),
							"TX hash": b.tx_hash,
							"Type": change_type,
							"Amount": b.amount_change,
							"Currency": b.currency,
							"Currency Issuer Address": counterparty,
							"Currency Issuer Name": counterpartyName,
							"Balance": b.final_balance
						};
						rippleExportData.push(balance_change_prepared);
					});
					if (response.marker) {
						return rippleExportNext(account, response.marker, from, to);
					} else {
						return rippleExportData;
					}
				} else {
					console.log('error - no balance changes response');
					return false;
				}
			});
	}

	function getXrplBalanceChanges(account, marker, from, to) {

		marker = marker || '';

		var	from_str = "&start=" + from.format('YYYY-MM-DDTHH:mm:ss');
		var	to_str = "&end=" + to.format('YYYY-MM-DDTHH:mm:ss');

		var requestUrl = Settings.data.server + '/accounts/' + account + '/balance_changes?descending=true&limit=1000&marker=' + marker + from_str + to_str;

		return Restangular
			.oneUrl('balance_changes', requestUrl)
			.get()
			.then(function (response) {
				return response;
			}, function (error) {
				$exceptionHandler(error);
				return false;
      });
	}

	function psdExport(account, from, to) {
		psdExportData = [];
		from = from.format('YYYY-MM-DDTHH:mm:ss')
		to = to.format('YYYY-MM-DDTHH:mm:ss');
		var offset = 0;
		var limit = 10000;
		return getNextPsdTransctions(account, from, to, offset, limit);
	}

	function getNextPsdTransctions(account, from, to, offset, limit) {
	
		var params = {
			"filters": {
				"psd_transactions.created_at": {
					"from": from,
					"to": to
				},
				"order": {
					field: "psd_transactions.created_at",
					direction: "desc"
				}
			}
		};

		return CoreRestangular.one('wallets', account).post('filtetredPsdTransactions', params).then(function (data) {
			var history = data.plain();
			history.forEach(tx => {
				var psdTxPrepared = {
					"Time": moment.utc(tx.created_at).format('MMM DD, YYYY, HH:mm'),
					"Category": snakeToSpacedCase(tx.category),
					"Amount": tx.amount,
					"Currency": tx.currency
				};
				psdExportData.push(psdTxPrepared);
			});
			if (history.length == limit) {
				offset = offset + limit;
				return getNextPsdTransctions(account, from, to, offset, limit);
			} else {
				return psdExportData;
			}
		}, function(error) {
			$exceptionHandler('[ExportService] Error getting filtetredPsdTransactions', error);
		});

	}

}
ExportService.$inject = ["Restangular", "CoreRestangular", "$filter", "Settings", "$exceptionHandler"];

'use strict';

/**
 * @ngdoc factory
 * @name gatehubClientApp.RippleNetworkService
 * @description
 * # RippleNetworkService
 * Factory in the gatehubClientApp.
 */
angular
    .module('gatehubClientApp')
    .run(["RippleNetwork", function(RippleNetwork) {
        RippleNetwork.connect();
    }])
    .factory('RippleNetwork', ["Settings", function (Settings) {

        var Network = function ()
        {
            this.remote = new ripple.Remote(Settings.server, true);
            window.rippleRemote = this.remote;
            for(var i = 0; i < this.remote.servers.length; i++) {
                this.remote._servers[i]._opts.url = Settings.server.servers[i];
                this.remote._servers[i].url = Settings.server.servers[i];
            }
            this.server = null;

            this.handleConnect = this.handleConnect.bind(this);
            this.remote.on('connected', this.handleConnect);
            this.remote.on('disconnected', this.handleDisconnect);

            //this.remote.max_fee = 12;

            this.disconnectTimeout = null;
        };

        Network.prototype.connect = function ()
        {
            console.log('Connecting to xrpl ws');
            if (this.remote.isConnected()) {
                console.log('Already connected');
                return;
            }
            this.remote.connect();
        };

        Network.prototype.handleConnect = function ()
        {
            this.server = this.remote.getServer();
            console.log('Connected');
        };

        Network.prototype.handleDisconnect = function ()
        {
            console.log('Disconnected');
        };

        return new Network();

    }]);

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.RippleHistory
 * @description
 * # RippleHistory
 * Service in the gatehubClientApp.
 */
angular
    .module('gatehubClientApp')
    .factory('RippleHistory', RippleHistory);

RippleHistory.$inject = ['$http', 'Settings'];

function RippleHistory($http, Settings) {

    var factory = {
        getHistory: getHistory,
        getTransaction: getTransaction,
    };

    return factory;

    ///////////////////////////////////////////////////////////

    function getHistory(opts, account) {
        return $http({
            url: Settings.data.server + '/accounts/' + account + '/transactions',
            method: 'GET',
            params: opts
        })
    };

    function getTransaction(hash) {
        return $http({
            url: Settings.data.server + '/transactions/' + hash,
            method: 'GET'
        })
    };

};
'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.RippleCharts
 * @description
 * # RippleCharts
 * Service in the gatehubClientApp.
 */
angular
    .module('gatehubClientApp')
    .factory('RippleCharts', RippleCharts);

RippleCharts.$inject = ['$http', 'Settings', 'NonstandardCurrencies'];

function RippleCharts($http, Settings, NonstandardCurrencies) {

    var factory = {
        getExchanges: getExchanges,
        getPayments: getPayments,
        getAccountPayments: getAccountPayments,
        getOffersExercised: getOffersExercised,
        getExchangeRates: getExchangeRates,
        getBalances: getBalances,
        getBalanceChanges: getBalanceChanges
    };

    return factory;

    ///////////////////////////////////////////////////////////

    function getExchanges(base, counter, params) {
        return $http({
            url: Settings.data.server + '/exchanges/' + parseXrplAsset(base) + '/' + parseXrplAsset(counter),
            method: 'GET',
            params: params,
        })
    };
    function getPayments(currency, params) {
        return $http({
            url: Settings.data.server + '/payments/' + currency,
            method: 'GET',
            params: params,
        })
    };
    function getAccountPayments(account, params) {
        return $http({
            url: Settings.data.server + '/accounts/' + account + '/payments',
            method: 'GET',
            params: params,
        })
    };
    function getOffersExercised(data) {
        return $http({
            url: Settings.charts.server + '/offersExercised',
            method: 'POST',
            data: data,
        })
    };
    function getExchangeRates(base, counter) {
        return $http({
            url: Settings.data.server + '/exchange_rates/' + parseXrplAsset(base) + '/' + parseXrplAsset(counter),
            method: 'GET',
        })
    };

    function getBalances(account, params) {
        return $http({
            url: Settings.data.server + '/accounts/' + account + '/balances',
            method: 'GET',
            params: params,
        })
    }

    function getBalanceChanges(account, params) {
        return $http({
            url: Settings.data.server + '/accounts/' + account + '/balance_changes',
            method: 'GET',
            params: params,
        })
    }

    function parseXrplAsset(asset) {
        const split = asset.split('+');

        if (split.length === 1) {
            return asset;
        }

        split[0] = NonstandardCurrencies.encodeAssetCode(split[0]);
        return split.join('+');
    }
};

/**
 * BOOKS
 *
 * The books service is used to keep track of orderbooks.
 */
var Amount = ripple.Amount;

angular
    .module('gatehubClientApp')
    .factory('RippleBook', ['RippleNetwork', '$rootScope', '$filter',

    function(net, $scope, $filter) {

      var rowCount;
      var account;

      function loadBook(gets, pays, taker) {
        var book = net.remote.book(gets.currency, gets.issuer, pays.currency, pays.issuer, taker);
        account = taker;
        if (gets.currency !== 'XRP') {
            net.remote.account(gets.issuer).on('transaction', function() {});
        }
        book.on('transaction', function(tx) {
            book._offersModifiedAt = net.remote.getLedgerSequence() - 1;
            book.onTransaction(tx)
        });
        book._subscribed = true;

        return book;
      }

      function filterRedundantPrices(data, action, combine) {
        var max_rows = 100;

        var price;
        var lastprice;
        var current = 0;
        var rpamount = $filter('rpamount');
        var newData = jQuery.extend(true, {}, data);

        // Amount bar
        if(action === 'asks') {
          var max = _.max(data.slice(0, 28), function(o){return o.taker_gets_funded;});
          max = max.taker_gets_funded;
        }
        else {
          var max = _.max(data.slice(0, 28), function(o){return o.taker_pays_funded;});
          max = max.taker_pays_funded;
        };

        rowCount = 0;
        newData = _.values(_.compact(_.map(newData, function(d, i) {
          // This check is redundant, but saves the CPU some work
          if (rowCount > max_rows) return;

          // rippled has a bug where it shows some unfunded offers
          // We're ignoring them
          if (d.taker_gets_funded === "0" || d.taker_pays_funded === "0")
            return;

          if (d.TakerGets.value) {
            d.TakerGets.value = d.taker_gets_funded;
            d.nativeTakerGets = parseInt(d.taker_gets_funded);
          } else {
            d.TakerGets = parseInt(Number(d.taker_gets_funded), 10);
            d.nativeTakerGets = d.TakerGets;
          }

          if (d.TakerPays.value) {
            d.TakerPays.value = d.taker_pays_funded;
            d.nativeTakerPays = parseInt(d.taker_pays_funded);
          } else {
            d.TakerPays = parseInt(Number(d.taker_pays_funded), 10);
            d.nativeTakerPays = d.TakerPays;
          }

          d.TakerGets = Amount.from_json(d.TakerGets);
          d.TakerPays = Amount.from_json(d.TakerPays);

          // You never know
          if (!d.TakerGets.is_valid() || !d.TakerPays.is_valid())
            return;

          if (action === "asks") {
            d.price = Amount.from_quality(d.BookDirectory,
                                          d.TakerPays.currency(),
                                          d.TakerPays.issuer(), {
              base_currency: d.TakerGets.currency(),
              reference_date: new Date()
            });
          } else {
            d.price = Amount.from_quality(d.BookDirectory,
                                          d.TakerGets.currency(),
                                          d.TakerGets.issuer(), {
              inverse: true,
              base_currency: d.TakerPays.currency(),
              reference_date: new Date()
            });
          }

          var price = rpamount(d.price, {
            rel_precision: 4,
            rel_min_precision: 2
          });

          // Don't combine current user's orders.
         if (d.Account == account) {
           // d.my = true;
           newData[current].mine = true;
         }

          if (lastprice === price) { // && !d.my
            if (combine) {
              try {
                newData[current].TakerPays = Amount.from_json(newData[current].TakerPays).add(d.TakerPays);
                newData[current].TakerGets = Amount.from_json(newData[current].TakerGets).add(d.TakerGets);
              }
              catch(e) {
                // console.log(e);
              }

            }
            d = false;
          } else {
            current = i;
          }

          if (!d.my) {
            lastprice = price;
          }

          if (d) {
            rowCount++;
          }

          // Amount Bar
          if(action === 'asks') {
            d.amountBarWidth = (d.nativeTakerGets / max) * 100;
          }
          else {
            d.amountBarWidth = (d.nativeTakerPays / max) * 100;
          }

          if (rowCount > max_rows) return false;

          return d;
        })));

        var key = action === "asks" ? "TakerGets" : "TakerPays";
        var sum;
        _.each(newData, function (order, i) {
          if (sum) sum = order.sum = sum.add(order[key]);
          else sum = order.sum = order[key];
        });

        return newData;
      }

      return {
        get: function(first, second, taker) {

          account = taker;

          var asks = loadBook(first, second, taker);
          var bids = loadBook(second, first, taker);

          var asksReady = false;
          var bidsReady = false;

          asks._shouldSubscribe = true;
          bids._shouldSubscribe = true;

          var model = {
            asks: filterRedundantPrices(asks.offersSync(), 'asks', true),
            bids: filterRedundantPrices(bids.offersSync(), 'bids', true),
            asksLastUpdate: +new Date(),
            bidsLastUpdate: +new Date(),
            ready: false  // whether BOTH Bids & Asks are ready
          };

          function handleAskModel(offers) {
            $scope.$apply(function () {
              model.asks = filterRedundantPrices(offers, 'asks', true);

              if (!asksReady) {
                asksReady = true;
                if (!model.ready && bidsReady) model.ready = true;
              }
            });
            model.asksLastUpdate = +new Date();
          }

          function handleAskTrade(gets, pays) {
            $scope.$apply(function () {
              model.last_price = gets.ratio_human(pays);
            });
            model.asksLastUpdate = +new Date();
          }
          asks.on('model', handleAskModel);
          asks.on('trade', handleAskTrade);


          function handleBidModel(offers) {
            $scope.$apply(function () {
              model.bids = filterRedundantPrices(offers, 'bids', true);

              if (!bidsReady) {
                bidsReady = true;
                if (!model.ready && asksReady) model.ready = true;
              }
              model.bidsLastUpdate = +new Date();
            });
          }

          function handleBidTrade(gets, pays) {
            $scope.$apply(function () {
              model.last_price = pays.ratio_human(gets);
              model.bidsLastUpdate = +new Date();
            });
          }
          bids.on('model', handleBidModel);
          bids.on('trade', handleBidTrade);


          model.unsubscribe = function() {
            asks.removeListener('model', handleAskModel);
            asks.removeListener('trade', handleAskTrade);
            bids.removeListener('model', handleBidModel);
            bids.removeListener('trade', handleBidTrade);

            asksReady = false;
            bidsReady = false;
            model.ready = false;
          };

          model.requestOffers = function() {
            asks.requestOffers();
            bids.requestOffers();
          };

          asks.subscribe();
          bids.subscribe();
          return model;
        },

        getLength: function() {
          return rowCount;
        }
      };

}]);

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.RippleTx
 * @description
 * # RippleTx
 * Service in the gatehubClientApp.
 */
angular
    .module('gatehubClientApp')
    .factory('RippleTx', RippleTx);

function RippleTx(RippleNetwork, MultisigRestangular, $exceptionHandler, instantMemory, coreSecurity, Auth, $q, CoreRestangular) {

    // address -> { isEligible: boolean, isEnabled: boolean, multisignInfo: any }
    var walletMultisigCache = new Map();

    var factory = {
        submitTransaction: submitTransaction,
        submitTxBlob: submitTxBlob,
        isMultisigWallet: isMultisigWallet,
        getSecrets: getSecrets,
        submitTxNormally: submitTxNormally,  // expose this for rekey purposes
        setMultisigStatus: setMultisigStatus, // expose this for setup status update
        wasTxSuccessful: wasTxSuccessful    // utility status check
    };

    return factory;

    ///////////////////////////////////////////////////////////

    /**
     *
     * @param {any} tx - ripple lib tx object
     * @param {any} wallet - wallet object
     * @param {string} vaultUuid - for risk engine purposes
     */
    function submitTransaction(tx, wallet, vaultUuid) {
        console.log('Incomming tx', tx);

        if (!tx || !tx.tx_json) {
            console.error('Tx or tx_json undefined');
            return Promise.reject(new Error('Invalid Transaction'));
        }

        setTxFlags(tx);

        return getSecrets(wallet).then(function(secrets) {
            // Check if wallet has multisig enabled to avoid rechecking
            var existingStatus = walletMultisigCache.get(tx.tx_json.Account);
            if (existingStatus && existingStatus.isEnabled) {
                console.log('Multisig status cached, send via multisig');
                return submitTxViaMultisig(tx, secrets.multisign_secret_decoded, secrets.multisign_address, vaultUuid);
            }

            // If not in cache, check status
            return new Promise(function(resolve, reject) {
                isMultisigWallet(wallet).then(function(status) {
                    console.log('Multisig status', status);
                    if (status.isEnabled) {
                        submitTxViaMultisig(tx, secrets.multisign_secret_decoded, secrets.multisign_address, vaultUuid).then(resolve).catch(reject);
                    }
                    else {
                        console.log('Multisig not enabled, send normally');
                        submitTxNormally(tx, secrets.secret_decoded).then(resolve).catch(reject);
                    }
                });
            });
        });
    };

    function submitTxViaMultisig(tx, secret, signAs, vaultUuid) {
        try {
            tx.addMemo('client', 'text/plain', '@gatehub/wallet-multisign')
        } catch (error) {
            $exceptionHandler('could not add memo');
        }

        return new Promise(function (resolve, reject) {
            if (!secret || !signAs) {
                reject(new Error('Multisign secret or signer address not provided'));
                return;
            }
            if (!tx.tx_json.Fee) {
                var multisignStatus = walletMultisigCache.get(tx.tx_json.Account);
                var calculatedFee = (+tx._computeFee() * (multisignStatus.multisignInfo.signerListSet.signers.threshold + 1)).toString();
                if (!calculatedFee) {
                    reject(new Error('Unable to get fee'));
                    return;
                }
                tx.tx_json.Fee = calculatedFee;
            }
            if (!tx.tx_json.Sequence) {
                var accSequence = RippleNetwork.remote.account(tx.tx_json.Account)._entry.Sequence;
                if (!accSequence) {
                    reject(new Error('Unable to get sequence'));
                    return;
                }
                tx.tx_json.Sequence = accSequence;
            }

            // if LastLedgerSequence not set, ripple-lib does it automatically (too low)
            tx.tx_json.LastLedgerSequence = RippleNetwork.remote.getLedgerSequence() + 20;

            tx = cleanDeprecatedFields(tx);

            var txJSON = JSON.stringify(tx.tx_json);
            var signedTx = window.sign(txJSON, secret, { signAs: signAs }).signedTransaction;

            var payload = {
                txJSON: txJSON,
                signedTransaction: signedTx
            };
            if (vaultUuid) {
                payload.vaultUuid = vaultUuid;
            }

            MultisigRestangular.one('wallet', tx.tx_json.Account).one('transaction').customPOST(payload)
            .then(function (response) {
                tx.emit('submitted', response);

                if (!response.tx_json) {
                    var errorMessage = response && response.resultMessage ?
                        response.resultMessage :
                        'Failed to publish the transaction';

                    reject(new Error(errorMessage));
                    return;
                }

                // watch until validated on the ledger
                RippleNetwork.remote.on('transaction', handleAccountEvent);
                function handleAccountEvent(e) {
                    if (e.transaction.hash === response.tx_json.hash) {
                        wasTxSuccessful(e, tx) ?
                            tx.emit('success', e) :
                            tx.emit('error', e);

                        RippleNetwork.remote.removeListener('transaction', handleAccountEvent);
                        resolve(e);
                    }
                }

            })
            .catch(function (error) {
                if (error.data && error.data.data && error.data.data.engine_result) {
                    // emit tx errors
                    tx.emit('error', error.data.data);
                }
                else {
                    // emit service errors
                    reject(error.data);
                }
                $exceptionHandler(error);
            });
        });
    }

    function submitTxNormally(tx, secret) {
        try {
            tx.addMemo('client', 'text/plain', '@gatehub/wallet')
        } catch (error) {
            $exceptionHandler('could not add memo');
        }

        return new Promise(function(resolve, reject) {
            if (!secret) {
                reject(new Error('No secret to sign the transaction.'));
                return;
            }
            tx.secret(secret);
            if (tx && tx.submit) {
                tx.submit();
                resolve(tx);
            }
            else {
                reject(new Error('Transaction invalid'));
            }
        })
    }

    function submitTxBlob(sigendTxBlob, successCallback, submittedCallback, errorCallback, tx) {
        var request = RippleNetwork.remote.requestSubmit();
        request.tx_blob(sigendTxBlob);

        handleRequestMessages(request, successCallback, submittedCallback, errorCallback, tx);

        if (tx) {
            tx.emit('presubmit');

            // add tx to manager queue to register callbacks
            tx.getManager()._pending.push(tx);
        }

        request.broadcast().request();

        if (tx) { tx.emit('postsubmit'); }

    };

    function getSecrets(wallet) {
        var deferred = $q.defer();

        return Auth.getProfile().then(function (user) {
            return CoreRestangular.one('users', user.id).one('wallets', wallet.address).one('secrets').get().then(function(data) {
                var secrets = data.plain();

                // we shouldn't be able to get this far if we don't have master unlocked, but just to be sure...
                var base_security = instantMemory.getValue('base_security');
                if (!base_security || !base_security.master_key) {
                    deferred.reject(new Error('Wallet locked.'));
                    return deferred.promise;
                }

                var master_key = base_security.master_key;

                if (secrets.multisign_secret) {
                    secrets.multisign_secret_decoded = coreSecurity.AESDecrypt(secrets.multisign_secret, master_key, wallet.version);
                    try {
                        !ripple.Seed.from_json(secrets.multisign_secret_decoded).get_key(secrets.multisign_address)
                    }
                    catch (error) {
                        console.error('Error decoding multisign secret.', error);
                    }
                }

                var verifyAddress = secrets.address;
                if (wallet.migration_status == 101) {
                    verifyAddress = secrets.regular_address;
                    secrets.secret_decoded = coreSecurity.AESDecrypt(secrets.regular_secret, master_key, 2);
                }
                else {
                    secrets.secret_decoded = coreSecurity.AESDecrypt(secrets.secret, master_key, wallet.version);
                }

                try {
                    !ripple.Seed.from_json(secrets.secret_decoded).get_key(verifyAddress)
                }
                catch (error) {
                    console.warn('Secret decrypt error, trying with old master');
                    // try with old master
                    var master_key_old = base_security.master_key_old;
                    if (!master_key_old) {
                        console.error('Wallet not unlocked or old master not defined.');
                    }

                    secrets.secret_decoded = coreSecurity.AESDecrypt(secrets.secret, master_key_old, wallet.version);
                    try {
                        !ripple.Seed.from_json(secrets.secret_decoded).get_key(secrets.address)
                    }
                    catch (error) {
                        console.error('Secret decrypt with old master error', error);
                    }
                }

                deferred.resolve(secrets);
                return deferred.promise;
            });
        });
    }

    /* ----------------------------------- Helper Functions -----------------------------------------*/

    function isFunction(fun) {
        return fun && {}.toString.call(fun) === '[object Function]';
    }

    function setTxFlags(tx) {
        var tfFullyCanonicalSig = 0x80000000;

        if ((tx.tx_json.Flags & tfFullyCanonicalSig) === 0) {
            tx.tx_json.Flags |= tfFullyCanonicalSig;
            // JavaScript converts operands to 32-bit signed ints before doing bitwise
	        // operations. We need to convert it back to an unsigned int.
            tx.tx_json.Flags = tx.tx_json.Flags >>> 0;
        }
    }

    // Helper function to handle tx callbacks
    function handleRequestMessages(request, successCallback, submittedCallback, errorCallback, tx) {

        function handleError(message) {
            if (isFunction(errorCallback)) {
                errorCallback(message);
            }
        }

        function handleSuccess(message) {
            if (isFunction(successCallback)) {
                successCallback(message);
            }
        }

        function submitted(message) {
            message.result = message.engine_result || '';

            if (tx) {
                tx.emit('submitted', message);
            }

            switch (message.result.slice(0, 3)) {
                case 'tes':
                    handleSuccess(message)
                    break;
                case 'tec':
                case 'tef':
                case 'tel':
                    handleError(message);
                    break;
                case 'ter':
                    request.broadcast().request();
                    break;
                default:
                    // tem
                    handleError(message);
            }
        }


        /*
        Event are not emitted as you might expect
        The flow of a normal submition is following:
        before -> proposed -> success -> submitted -> error -> cleanup
        Tx messages from the network are of type 'success' and handled by one hanlder
        The both listners provide the same handler which emits events based on the result
        either errors or success
        ! todo: will change when moving to newer ripple-lib !
        */
        request.once('error', submitted);
        request.once('success', submitted);

        request.once('proposed', function (res) {
            console.log('Transaction was submitted successfully to the network - PENDING', res);


            if (res.error) {
                tx.emit('error', res);
            }
            else {
                if (isFunction(submittedCallback)) {
                    submittedCallback(res);
                }

                // we have to explicitly emit callbacks because we submit the tx manully
                if (tx) {
                    // Add id to trigger on message callbacks
                    // ! remove after on ripple-lib update
                    tx.addId(res.tx_json.hash);

                    tx.emit('proposed', res);
                }
            }

        });
    }


    function cleanDeprecatedFields(tx) {
        if (tx.tx_json.Paths) {
            tx.tx_json.Paths.forEach(function(pathNode) {
                // Fields are deprecated and sending them will cause the tx to error
                pathNode.forEach(function(path) {
                    // Fields are deprecated and sending them will cause the tx to error
                    delete path.type;
                    delete path.type_hex;
                });
            });
        }

        return tx;
    }

    function isMultisigWallet(wallet) {
        var multisignStatus = {
            isEligible: false,
            isEnabled: false,
            canRenew: false,
            isExpired: false,
            multisignInfo: null
        };
        return new Promise(function(resolve) {
            var existingStatus = walletMultisigCache.get(wallet.address);
            if (existingStatus) {
                if (existingStatus.isEnabled || !existingStatus.isEligible) {
                    resolve(existingStatus);
                    return;
                }
                // resolve(existingStatus);
            }

            if (wallet.version < 2) {
                multisignStatus.isEligible = false;
                walletMultisigCache.set(wallet.address, multisignStatus);
                resolve(multisignStatus);
                return;
            }

            Auth.getProfile().then(function(user) {
                // only individual users can have wallet protect
                if (user.identity.user_type !== 0 || user.version < 2) {
                    multisignStatus.isEligible = false;
                    walletMultisigCache.set(wallet.address, multisignStatus);
                    resolve(multisignStatus);
                    return;
                }

                multisignStatus.isEligible = true;

                MultisigRestangular.one("wallet", wallet.address).get().then(function (response) {
                    multisignStatus.isEnabled = response && response.info.status === 'ENABLED';

                    multisignStatus.multisignInfo = response.info;

                    multisignStatus.canRenew = response.info.canRenew || false;
                    multisignStatus.isExpired = response.info.isExpired || false;

                    walletMultisigCache.set(wallet.address, multisignStatus);
                    resolve(multisignStatus);

                }, function(error){
                    resolve(multisignStatus);
                });
            })
            .catch(function() {
                resolve(multisignStatus);
            })

        });

    }

    function setMultisigStatus(walletAddress, isEnabled, multisignInfo) {
        var multisignStatus = {
            isEligible: true,
            isEnabled: false,
            canRenew: false,
            isExpired: false,
            multisignInfo: null
        };

        var existingStatus = walletMultisigCache.get(walletAddress);
        if (existingStatus) {
            multisignStatus = existingStatus;
        }

        multisignStatus.isEnabled = isEnabled;
        // status is set on enable and disable so these flags should be false
        multisignStatus.canRenew = false;
        multisignStatus.isExpired = false;

        multisignStatus.multisignInfo = multisignInfo ? multisignInfo : null;

        walletMultisigCache.set(walletAddress,  multisignStatus);
    }


    function wasTxSuccessful(tx) {
        switch (tx.engine_result.slice(0, 3)) {
            case 'tes':
                return true;
            case 'tec':
            case 'tef':
            case 'tel':
            case 'tem':
            case 'ter':
                return false;
            default:
                return false;
        }
    }
}
RippleTx.$inject = ["RippleNetwork", "MultisigRestangular", "$exceptionHandler", "instantMemory", "coreSecurity", "Auth", "$q", "CoreRestangular"];;



'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.RippleAnalytics
 * @description
 * # RippleAnalytics
 * Service in the gatehubClientApp.
 */
angular
    .module('gatehubClientApp')
    .factory('RippleAnalytics', RippleAnalytics);


function RippleAnalytics($exceptionHandler, Settings, Restangular, RippleCharts, $q) {

    return {
        getXrplBalanceHistory: getXrplBalanceHistory,
        getXrplBalances: getXrplBalances,
        getXrpVolumeChanges: getXrpVolumeChanges
    }

    function getXrplBalanceHistory(address, range) {
        var deferred = $q.defer();

        var currencyGroups = {};
        var params = {
            start: range.from,
            end: range.to,
            limit: 1000,
            descending: false,
            marker: ''
        };

        function fetchRippleBalanceChangesFromDataAPI() {
            RippleCharts.getBalanceChanges(address, params)
                .then(function(response) {
                    if (response.data) {
                        // paymentsArray = paymentsArray.concat(filterPayments(address, response.data.payments, xrpWallets));
                        response.data.balance_changes.forEach(change => {
                            var currencyKey = `${change.currency}${change.counterparty ? '+' + change.counterparty : ''}`;
                            var unixTime = moment.utc(change.executed_time).startOf('day').valueOf();
                            if (!currencyGroups[currencyKey]) {
                                currencyGroups[currencyKey] = new Map();
                            }
                            // console.log(currencyKey, change.executed_time, unixTime, +change.final_balance);
                            currencyGroups[currencyKey].set(unixTime, +change.final_balance);
                        });

                        if (response.data.marker) {
                            params.marker = response.data.marker;
                            fetchRippleBalanceChangesFromDataAPI();
                        }
                        else {
                            // console.log(currencyGroups);
                            forwardFillBalanceHistory(range.from, currencyGroups);

                            deferred.resolve(currencyGroups);
                        }
                    }
                })
                .catch(function(error) {
                    console.error(error);
                    deferred.reject(error);
                });
        }

        RippleCharts.getBalances(address, { date: range.from }).then(response => {
            response.data.balances.forEach(balance => {
                var currencyKey = `${balance.currency}${balance.counterparty ? '+' + balance.counterparty : ''}`;
                currencyGroups[currencyKey] = new Map();
                currencyGroups[currencyKey].set(moment.utc(range.from).startOf('day').valueOf(), +balance.value);
            });

        }).catch(error => {
            console.error(error); // error can be thrown if date is too old
        })
        .finally(() => {
            fetchRippleBalanceChangesFromDataAPI();
        });
        return deferred.promise;
    }

    function getXrplBalances(address){
        var requestUrl = Settings.data.server + '/accounts/' + address + '/balances';
        return Restangular
            .oneUrl('balances', requestUrl)
            .get()
            .then(function (response) {
                var balances = response.balances.map(b => {
                    if(typeof b.counterparty === 'undefined'){
                        b.counterparty = 'ripple';
                    }
                    return b;
                });
                balances = balances.filter(b => ghVaults.indexOf(b.counterparty) > -1);
                return balances;
            }, function (error) {
                $exceptionHandler(error);
                return false;
            });
    }

    function forwardFillBalanceHistory(from, currencyGroups) {
        // console.log('Forward fill from', moment(from).format());
        var today = moment().endOf('day');
        var day = moment.utc(from).startOf('day');
        var mostRecentBalances = {};

        // console.log('Days to fill', today.diff(day, 'day'));
        // console.log(currencyGroups);

        while (today.isSameOrAfter(day, 'day')) {
            var unixTime = day.valueOf();
            // console.log(day.format());
            for (var currency in currencyGroups) {
                if (currencyGroups.hasOwnProperty(currency)) {
                    // console.log(currencyGroups[currency].get(unixTime));
                    // console.log(currencyGroups[currency], unixTime, moment(unixTime).format());
                    if (!isNaN(currencyGroups[currency].get(unixTime))) {
                        // console.log('new recent', currency, currencyGroups[currency]);
                        mostRecentBalances[currency] = currencyGroups[currency].get(unixTime);
                    }
                }

                currencyGroups[currency].set(unixTime, mostRecentBalances[currency] || 0);
            }

            day.add(1, 'day');
        }


        // Sort filled data
    }

    function getXrpVolumeChanges(address, range, xrpWallets) {
        var deferred = $q.defer();
        var params = {
            start: range.start,
            end: range.end,
            interval: '1day',
            limit: 1000,
            descending: true,
            marker: ''
        };

        var paymentsArray = [];

        function fetchAccountPaymentsFromDataAPI(address, params) {
            RippleCharts.getAccountPayments(address, params)
                .then(function(response) {
                    if (response.data) {
                        paymentsArray = paymentsArray.concat(filterPayments(address, response.data.payments, xrpWallets));
                        if (response.data.marker) {
                            params.marker = response.data.marker;
                            fetchAccountPaymentsFromDataAPI(address, params);
                        }
                        else {
                            deferred.resolve({
                                address: address,
                                balanceChanges: paymentsArray
                            });
                        }
                    }
                })
                .catch(function(error) {
                    console.error(error);
                    deferred.reject(error);
                });
        }
        fetchAccountPaymentsFromDataAPI(address, params);

        return deferred.promise;
    }

    function filterPayments(address, payments, xrpWallets) {
        return payments.filter(payment => {
            return !(xrpWallets.includes(payment.destination) && xrpWallets.includes(payment.source));
        }).map(payment => {
            return {
                asset_code: payment.currency,
                issuer: payment.issuer,
                date: moment.utc(payment.executed_time).startOf('day').valueOf(),
                changes: payment.destination === address ? payment.destination_balance_changes : payment.source_balance_changes,
                amount: payment.destination === address ? +payment.amount : -1 * +payment.amount,
                fee: payment.source === address ? payment.transaction_cost : 0
            }
        });
    }
}
RippleAnalytics.$inject = ["$exceptionHandler", "Settings", "Restangular", "RippleCharts", "$q"];

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.Settings
 * @description
 * # Settings
 * Service in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
  .service('Settings', ["ENV", function (ENV) {

        var settings = {

            // Rippled to connect
            server: {
                trusted: false,
                local_signing: true,
                local_fee: true,
                fee_cushion: 1.5,
                local_sequence: true,
                servers: ENV.rippleServers,
                trace: false,
                max_listeners: 15
            },

            // Ripple Client
            client: {
                sendMaxDeviation: 0.1,
                exchangeMaxDeviation: 0.1,
                passwordProtection: false,
                hostedBalanceInterval: 10 * 1000,   // ms

                xrp_reserve: 10 * 1000000,          // TODO: get this from network service
                tx_last_ledger: 8,
                confirmation: true,                 // Do we show send confirmation splash
            },

            // Identity API
            id: {
                ripple_name_server: 'https://id.ripple.com/v1',
                gatehub_name_server: 'https://api.gatehub.net/search/search', // ENV.search
            },

            // Charts API
            charts: {
                server: 'https://api.ripplecharts.com/api',
            },

            // Data API
            data: {
                //server: 'https://data.ripple.com/v2'
                //server: 'https://api.gatehub.net/rippledata/v2'
                server: ENV.rippleDataApi
            },

            // Order Book Settings
            book: {
                orderbook_max_rows: 100,
            },

            // GateHub Wallet App
            app: {
                client_id:  ENV.clientID,
                client_secret:  ENV.clientSecret,
            },
            auth: {
                keepAlive: {
                  idle: 60*30, //5
                  timeout: 60*30, //5
                  interval: 10 //10
                }
            },
            maxFileSize: 20 * 1000000, // 20 MB
            vaults: ENV.vaults,
            environment: ENV.name,

        };

        return settings;

  }]);

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.Countries
 * @description
 * # Countries
 * Service in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
    .service('Countries', ["IDRestangular", "$q", function (IDRestangular, $q) {
        var initPromise = false;
        var globalPromise = false;
        var countries = {
            allCountries: [],
            bannedCountries: [],
            filteredCountries: [],
            init: initFromBackend,
            getCountries: getCountries,
            isEidSupported: isEidSupported
        };

        return countries;

        function getPlainCountries() {
            return _.pick(countries, ['allCountries','bannedCountries','filteredCountries']);
        }

        function initFromBackend() {
            initPromise = $q.defer();
            IDRestangular.one('countries').get().catch(function (error) {
                return {error: error};
            }).then(function (data) {
                if (data.hasOwnProperty('items')) {
                    data.items.map(function (item) {
                        item.code = item.isoCode;
                    });
                    countries.allCountries.push.apply(countries.allCountries, data.items);
                    countries.bannedCountries.push.apply(countries.bannedCountries, data.items.filter(function (country) { return country.type === 0; }));
                    countries.filteredCountries.push.apply(countries.filteredCountries, data.items.filter(function (country) { return country.type !== 0; }) );
                }
                if (globalPromise) {
                    globalPromise.resolve(getPlainCountries());
                }
                initPromise.resolve(getPlainCountries());
            });
        }

        function getCountries() {
            globalPromise = $q.defer();
            if (initPromise) {
                initPromise.promise.then(function () {
                    globalPromise.resolve(getPlainCountries());
                });
            } else if (countries.allCountries.length) {
                globalPromise.resolve(getPlainCountries());
                globalPromise = null;
            }
            return globalPromise.promise;
        }

        function isEidSupported(countryCode) {
            return getCountries().then(function(countries) {
                const country = _.find(countries.allCountries, {isoCode: countryCode});
                return country.isEidSupported;
            });
        }
    }]);

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.Gateways
 * @description
 * # Gateways
 * Service in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
    .service('Gateways', function () {

        return [
            /************************************** Production **************************************/
            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "startDate": "2015-2-15",
                "accounts": [{
                    "address": "rhub8VRN55s94qWKDv6jmDy1pUykJzF3wq",
                    "currencies": ["EUR", "USD"]
                }],
                "hotwallets": ["rhotcWYdfn6qxhVMbPKGDF3XCKqwXar5J4"],
                "domain": "gatehub.net",
                "gan": "true",
                "fee": "0.002"
            },
            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "r4GN9eEoz9K4BhMQXe4H1eYNtvtkwGdt8g",
                    "currencies": ["GBP"]
                }],
                "hotwallets": ["rcb6cGT25CcSaLk2NZ4CadU6XddQ5aLq9"],
            },
            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "startDate": "2016-3-30",
                "accounts": [{
                    "address": "rcA8X3TVMST1n3CJeAdGk1RdRCHii7N2h",
                    "currencies": ["ETH"]
                }],
                "hotwallets": ["rhPGyJfM8bGjfNCiXLL7WRU8VZ5Cw4kHVe"],
                "domain": "gatehub.net",
                "gan": "true",
                "fee": "0.003"
            },
            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "startDate": "2016-11-13",
                "accounts": [{
                    "address": "rchGBxcD1A1C2tdxF6papQYZ8kjRKMYcL",
                    "currencies": ["BTC"]
                }],
                "hotwallets": ["rhKgFxe7Mp38yeJzvwoNLm46RxMdXotTn6"],
                "domain": "gatehub.net",
                "gan": "true",
                "fee": "0.002"
            },
            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "startDate": "2016-8-9",
                "accounts": [{
                    "address": "rDAN8tzydyNfnNf2bfUQY6iR96UbpvNsze",
                    "currencies": ["ETC"]
                }],
                "hotwallets": ["rsXAifedPJ3ESTgSHJ5XzrXw6oYD8Uha7x"],
                "domain": "gatehub.net",
                "gan": "true",
                "fee": "0.003"
            },
            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "startDate": "2016-4-22",
                "accounts": [{
                    "address": "rckzVpTnKpP4TJ1puQe827bV3X4oYtdTP",
                    "currencies": ["REP"]
                }],
                "hotwallets": ["rhdT3DksUegs6SDztyLRaCNP2ukfbHKy5g"],
                "domain": "gatehub.net",
                "gan": "true",
                "fee": "0.005"
            },
            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "startDate": "2017-8-8",
                "accounts": [{
                    "address": "rcyS4CeCZVYvTiKcxj6Sx32ibKwcDHLds",
                    "currencies": ["BCH"]
                }],
                "hotwallets": ["rh7YWTfjKXi1rbToH6pV9m5f2mHpx28Rbv"],
                "domain": "gatehub.net",
                "gan": "true",
                "fee": "0.003"
            },
            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "startDate": "2021-6-11",
                "accounts": [{
                    "address": "rcRzGWq6Ng3jeYhqnmM4zcWcUh69hrQ8V",
                    "currencies": ["LTC"]
                }],
                "hotwallets": ["rhdw8pseC8fpeVLnvZDfJVG3CPuEp426AV"],
                "domain": "gatehub.net",
                "gan": "true",
                "fee": "0.000"
            },
            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "startDate": "2017-9-15",
                "accounts": [{
                    "address": "rcXY84C4g14iFp6taFXjjQGVeHqSCh9RX",
                    "currencies": ["DSH"]
                }],
                "hotwallets": ["rhnjnaUMwe6BxVkszuU6sM6qbNXBAqwQGu"],
                "domain": "gatehub.net",
                "gan": "true",
                "fee": "0.003"
            },
            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "rf5YPb9y9P3fTjhxNaZqmrwaj5ar8PG1gM",
                    "currencies": ["GALA"]
                }],
                "hotwallets": ["rMSEtzTiszpQAMsphtkUfrQYYxVUCi1W5R"],
            },
            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "rcEGREd8NmkKRE8GE424sksyt1tJVFZwu",
                    "currencies": ["USDC"]
                }],
                "hotwallets": ["rh5MLV7PdpNhgAnLBEWu8AptC5NSrRAihc"],
            },
            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "rcvxE9PS9YBwxtGg1qNeewV6ZB3wGubZq",
                    "currencies": ["USDT"]
                }],
                "hotwallets": ["rhh2jrhPBFnGZoRdM2wxww979SayUj2En6"],
            },
            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "rEa5QY8tdbjgitLyfKF1E5Qx3VGgvbUhB3",
                    "currencies": ["WXRP"]
                }],
                "hotwallets": ["rhjx4ZWEAhFkrxZLpY1hjHm7B1FwV2nkMR"],
            },
            {
                "name": "BPG Kovine",
                "logo": "logo_bpg.png",
                "startDate": "2016-4-22",
                "accounts": [{
                    "address": "rcoef87SYMJ58NAFx7fNM5frVknmvHsvJ",
                    "currencies": ["XAU"]
                }],
                "hotwallets": ["rh7WFDNxbZ7zfpvpUh5kjrfpGPkDodZFvr"],
                "domain": "gatehub.net",
                "gan": "false",
                "fee": "0.003"
            },
            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "rcxJwVnftZzXqyH9YheB8TgeiZUhNo1Eu",
                    "currencies": ["FLR"]
                }],
            },
            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "rctArjqVvTHihekzDeecKo6mkTYTUSBNc",
                    "currencies": ["SGB"]
                }],
                "hotwallets": ["rhrFfvzZAytd8UHPH87UHMgHQ18nnLbpgN"],
            },
            {
                "name": "Bitstamp",
                "logo": "logo_bitstamp.png",
                "startDate": "2013-02-22",
                "accounts": [{
                    "address": "rvYAfWj5gh67oV6fW32ZzP3Aw4Eubs59B",
                    "currencies": ["BTC", "USD"],
                    "hotwallets": ["rrpNnNLKrartuEqfJGpqyDwPj1AFPg9vn1"]
                }],
            }, {
                "name": "RippleChina",
                "logo": "logo_ripplechina.png",
                "startDate": "2013-05-21",
                "accounts": [{
                    "address": "razqQKzJRdB4UxFPWf5NEpEG3WMkmwgcXA",
                    "currencies": ["CNY"],
                    "hotwallets": ["r45dBj4S3VvMMYXxr9vHX4Z4Ma6ifPMCkK"]
                }]
            }, {
                "name": "rippleCN",
                "logo": "logo_ripplecn.png",
                "startDate": "2013-05-05",
                "accounts": [{
                    "address": "rnuF96W4SZoCJmbHYBFoJZpR8eCaxNvekK",
                    "currencies": ["BTC", "CNY"],
                    "hotwallets": ["rNaptDNfFXo1quhKwMaNPf66iwPqA8YLky", "rno91tGDJeRcnM7EMXj8KG9UTyxRGMMz8s"]
                }]
            }, {
                "name": "Payroutes",
                "startDate": "2013-04-24",
                "accounts": [{
                    "address": "rNPRNzBB92BVpAhhZr4iXDTveCgV5Pofm9",
                    "currencies": ["BTC", "ILS"],
                    "hotwallets": []
                }]
            }, {
                "name": "SnapSwap",
                "logo": "logo_snapswap.png",
                "startDate": "2013-06-18",
                "accounts": [{
                    "address": "rMwjYedjc7qqtKYVLiAccJSmCwih4LnE2q",
                    "currencies": ["USD", "BTC", "EUR", "GBP"],
                    "hotwallets": ["rUQTpMqAF5jhykj4FExVeXakrZpiKF6cQV", "rhasPLL5GaXzBh5amQkN7Dr1SNF4Whb2ZT"]
                }]
            }, {
                "name": "The Rock Trading",
                "logo": "logo_therocktrading.png",
                "startDate": "2013-05-19",
                "accounts": [{
                    "address": "rLEsXccBGNR3UPuPu2hUXPjziKC3qKSBun",
                    "currencies": ["BTC", "EUR", "USD"],
                    "hotwallets": ["rUeFPRGNjtcbtezyQKKiDcS1eQyYLQ1gcr"]
                }]
            }, {
                "name": "WisePass",
                "logo": "logo_wisepass.png",
                "startDate": "2013-04-28",
                "accounts": [{
                    "address": "rPDXxSZcuVL3ZWoyU82bcde3zwvmShkRyF",
                    "currencies": ["BTC", "LTC", "USD"],
                    "hotwallets": ["r9xAQUyqs53QH2PLxe7iFbNbpU2RA9QtZx"]
                }]
            }, {
                "name": "RippleUnion",
                "startDate": "2013-03-22",
                "accounts": [{
                    "address": "r3ADD8kXSUKHd6zTCKfnKT3zV9EZHjzp1S",
                    "currencies": ["CAD"],
                    "hotwallets": []
                }]
            }, {
                "name": "Justcoin",
                "logo": "logo_justcoin.png",
                "startDate": "2013-07-29",
                "accounts": [{
                    "address": "rJHygWcTLVpSXkowott6kzgZU6viQSVYM1",
                    "currencies": ["LTC", "BTC", "STR", "EUR", "NOK"],
                    "hotwallets": []
                }]
            }, {
                "name": "DotPayco",
                "startDate": "2013-06-02",
                "accounts": [{
                    "address": "rM8199qFwspxiWNZRChZdZbGN5WrCepVP1",
                    "currencies": ["CNY"],
                    "hotwallets": []
                }]
            }, {
                "name": "Ripple Singapore",
                "logo": "logo_ripplesingapore.png",
                "startDate": "2014-01-25",
                "accounts": [{
                    "address": "r9Dr5xwkeLegBeXq6ujinjSBLQzQ1zQGjH",
                    "currencies": ["XAU", "XAG", "USD", "SGD"],
                    "hotwallets": []
                }]
            }, {
                "name": "Ripple Trade Japan",
                "startDate": "2014-02-21",
                "accounts": [{
                    "address": "rMAz5ZnK73nyNUL4foAvaxdreczCkG3vA6",
                    "currencies": ["JPY"],
                    "hotwallets": []
                }]
            }, {
                "name": "Bitso",
                "logo": "logo_bitso.jpg",
                "startDate": "2014-05-22",
                "accounts": [{
                    "address": "rG6FZ31hDHN1K5Dkbma3PSB5uVCuVVRzfn",
                    "currencies": ["MXN", "BTC"],
                    "hotwallets": ["rHZaDC6tsGN2JWGeXhjKL6664RNCq5hu4B"]
                }],
            }, {
                "name": "Coinex",
                "startDate": "2014-04-01",
                "accounts": [{
                    "address": "rsP3mgGb2tcYUrxiLFiHJiQXhsziegtwBc",
                    "currencies": ["NZD", "BTC", "USD", "AUD", "STR"],
                    "hotwallets": ["rGAmy1w1ENyTJ9BCAEicYyRM2Yk1iWZ7Z5"],
                    "domain": "coinexgateway.com"
                }]
            }, {
                "name": "Ripple LatAm",
                "startDate": "2014-05-01",
                "accounts": [{
                    "address": "rP5ShE8dGBH6hHtNvRESdMceen36XFBQmh",
                    "currencies": ["BRL", "UYU", "PEN", "MXN", "BTC", "LTC", "USD", "CLP", "ARS"],
                    "hotwallets": ["raoFdQah8c8owTj4TPMr8o1WntnXybXCgB"],
                    "domain": "ripplelatam.com"
                }]
            }, {
                "name": "GBI",
                "logo": "logo_gbi.png",
                "startDate": "2014-07-28",
                "accounts": [{
                    "address": "rrh7rf1gV2pXAoqA8oYbpHd8TKv5ZQeo67",
                    "currencies": [
                        {
                            "label": "XAU",
                            "code": "0158415500000000C1F76FF6ECB0BAC600000000"
                        }
                    ]
                }],
                "hotwallets": [
                ],
                "domain": "goldbullioninternational.com"
            }, {
                "name": "Lake BTC",
                "startDate": "2014-05-19",
                "accounts": [{
                    "address": "rpDMez6pm6dBve2TJsmDpv7Yae6V5Pyvy2",
                    "currencies": ["USD"]
                }],
                "hotwallets": [
                    "rP9gFJKqKGWdR4n6XjdsUPqmJfXkg4kSgZ"
                ],
                "domain": "lakebtc.com"
            }, {
                "name": "Ripple Fox",
                "logo": "logo_ripplefox.png",
                "startDate": "2014-04-19",
                "accounts": [{
                    "address": "rKiCet8SdvWxPXnAgYarFUXMh1zCPz432Y",
                    "currencies": ["CNY", "STR"]
                }],
                "hotwallets": [
                    "rLSnkKvMfPD9abLoQFxQJMYyZqJcsqkL3o",
                    "rPcQaiyDxMwLr7Q9eFmn5VnVx2RN57MUmN",
                    "r3ipidkRUZWq8JYVjnSnNMf3v7o69vgLEW"
                ],
                "domain": "ripplefox.com"
            }, {
                "name": "Rippex",
                "startDate": "2014-09-13",
                "accounts": [{
                    "address": "rfNZPxoZ5Uaamdp339U9dCLWz2T73nZJZH",
                    "currencies": ["BRL"]
                }],
                "hotwallets": ["r37FUji17jCgCZvAUc8m5YqXquwHpgwa9q"],
                "domain": "rippex.net"
            }, {
                "name": "Ripple Market Japan",
                "startDate": "2014-08-12",
                "accounts": [{
                    "address": "rJRi8WW24gt9X85PHAxfWNPCizMMhqUQwg",
                    "currencies": ["JPY"]
                }],
                "hotwallets": [],
                "domain": "ripple-market.jp"
            }, {
                "name": "Pax Moneta",
                "startDate": "2014-09-06",
                "accounts": [{
                    "address": "rUkMKjQitpgAM5WTGk79xpjT38DEJY283d",
                    "currencies": ["KRW"]
                }],
                "hotwallets": ["rhLSigWL4J9JBBW1JFMBvaduDkVghG7cc2"],
                "domain": "paxmoneta.com"
            }, {
                "name": "Exchange Tokyo",
                "startDate": "2014-09-25",
                "accounts": [{
                    "address": "r9ZFPSb1TFdnJwbTMYHvVwFK1bQPUCVNfJ",
                    "currencies": ["JPY"]
                }],
                "hotwallets": [],
                "domain": "exchangetokyo.com"
            }, {
                "name": "Ripula",
                "startDate": "2014-10-16",
                "accounts": [{
                    "address": "rBycsjqxD8RVZP5zrrndiVtJwht7Z457A8",
                    "currencies": ["GBP"]
                }],
                "hotwallets": ["rUR5QVHqFxRa8TSQawc1M6jKj7BvKzbHek"],
                "domain": "ripula.co.uk"
            },
            {
                "name": "Mr. Ripple",
                "startDate": "2014-10-5",
                "accounts": [{
                    "address": "rB3gZey7VWHYRqJHLoHDEJXJ2pEPNieKiS",
                    "currencies": ["JPY"]
                }],
                "hotwallets": [],
                "domain": "mr-ripple.com"
            },
            {
                "name": "Bluzelle",
                "logo": "logo_bluzelle.png",
                "startDate": "2015-2-15",
                "accounts": [{
                    "address": "raBDVR7JFq3Yho2jf7mcx36sjTwpRJJrGU",
                    "currencies": ["CAD"]
                }],
                "domain": "gatehub.net"
            },

            /************************************** Staging **************************************/

            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "rVnYNK9yuxBz4uP8zC8LEFokM2nqH3poc",
                    "currencies": ["EUR", "USD"]
                }],
                "hotwallets": ["rhDFTfJg9Weu76TbSEJHoY9JQVupRhtWYU"],
            },
            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "rfkeeF9mGw3iJTTwykNpwCqBDsnLdT46v3",
                    "currencies": ["GBP"]
                }],
                "hotwallets": ["rP22SS1o9LKS9s6BP2HSo4PK2uWy7RmVCS"],
            },
            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "rEaHks1SfoAqY2NgHbvxne9fEYHDNRfqDC",
                    "currencies": ["ETH"]
                }],
            },
            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "rLiEKM2QL4w3tXoqEALQ6MG7FkYeyjowtC",
                    "currencies": ["ETC"]
                }],
            },
            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "rEsGqiLamotwjLgqbDaMayRrjbofjnpkCw",
                    "currencies": ["REP"]
                }],
            },
            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "rP7hDgU6qTJYdyPiitnpyfNheV4aR6vFXM",
                    "currencies": ["BTC"]
                }],
            },
            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "rprZ8BwMEm76o6HChGaU22ZvP8H6j1i1AU",
                    "currencies": ["DSH"]
                }],
            },
            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "rK7rfcV1UhmgLWjnJyTnAR3WGrkusa84kj",
                    "currencies": ["BCH"]
                }],
            },
            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "rHp6SFi2MFEWVbp3hsbRLWrjKKwagwa1N1",
                    "currencies": ["FLR"]
                }],
            },
            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "rH3kXmqKnt81LcribjJR4KRBEcWB7VqbfK",
                    "currencies": ["LTC"]
                }],
                "hotwallets": ["rwdKmifxPUe5fUwytKwRsP7sSdvWf3mNdz"],
            },

            /************************************** Sandbox **************************************/

            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "rBMqNVUk5iF5Z27nAwRjJnMjdmTsrmJ1Ln",
                    "currencies": ["GBP"]
                }],
                "hotwallets": ["rNbgeH1pNB1ZoVNGtuzh5HutySLYN1bmqv"],
            },
            {
                "name": "GateHub UAB",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "rBA4kJaerTBxf7voaFnVboFU5LmCdbSQrk",
                    "currencies": ["LTC"]
                }],
            },
            {
                "name": "BPG Kovine Sandbox",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "rcLwVL5cSpxprr3yPjWvtguwjrUPvBaVu",
                    "currencies": ["XAU"]
                }],
            },
            {
                "name": "GateHub Canada Sandbox",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "ra3A2Q1S5r4YsV5597aCNvYndqBEJrQ73o",
                    "currencies": ["CAD"]
                }],
            },
            {
                "name": "Flash FX Sandbox",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "r4MmkWD7XjZuHGypMgerCRzi1Z4TFs9kwQ",
                    "currencies": ["EUR"]
                }],
            },
            {
                "name": "Flash FX Sandbox",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "rrpmyHJjkgXExmqzJfFiq4jDsosmeMaoUm",
                    "currencies": ["USD"]
                }],
            },
            {
                "name": "India Sandbox",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "rrpXA3KYP9ihHHZ4R7Ci57CvjJf6gUPHjh",
                    "currencies": ["INR"]
                }],
            },
            {
                "name": "China Sandbox",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "rrhc8KMpR4yYzqo5e3PfjyDARt38MbaqBW",
                    "currencies": ["CNY"]
                }],
            },
            {
                "name": "Ripple Sandbox",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "rrZr2WvoZJVeTMQ6X1fUDRgtg695DX9uE",
                    "currencies": ["USD"]
                }],
            },
            {
                "name": "Ripple Sandbox",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "rrnTcSDFcYuWJZcQReNgktnkuPfKWFoucM",
                    "currencies": ["EUR"]
                }],
            },
            {
                "name": "xCowry Sandbox",
                "logo": "logo_gatehub.png",
                "accounts": [{
                    "address": "rrs1eFzzwWcZjh8JXSFv9XDcVv3iqHLcRZ",
                    "currencies": ["NGN"]
                }],
            },

            // new issuers for nameGateway (taken from Default Market Pairs document)
            {
                "name": "CasinoCoin",
                "accounts": [{
                    "address": "rCSCManTZ8ME9EoLrSHHYKW8PPwWMgkwr"
                }],
            },
            {
                "name": "Frinkcoin",
                "accounts": [{
                    "address": "rPA73XSVQ3UEz7gSixREhMzBMtF4RGZPie"
                }],
            },
            {
                "name": "Sologenic",
                "accounts": [{
                    "address": "rsoLo2S1kiGeCcn6hCUXVrCpGMWLrRrLZz"
                }],
            },
            {
                "name": "Question.life",
                "accounts": [{
                    "address": "r4sYcbdi4oE18FhVYWEhXa1AEe21XGR39z"
                }],
            },
            {
                "name": "Peercover",
                "accounts": [{
                    "address": "ra9eZxMbJrUcgV8ui7aPc161FgrqWScQxV"
                }],
            },
            {
                "name": "GBI",
                "accounts": [{
                    "address": "rrh7rf1gV2pXAoqA8oYbpHd8TKv5ZQeo67"
                }],
            },
            {
                "name": "Allvor",
                "accounts": [{
                    "address": "raEQc5krJ2rUXyi6fgmUAf63oAXmF7p6jp"
                }],
            },
            {
                "name": "Elysian",
                "accounts": [{
                    "address": "rHXuEaRYnnJHbDeuBH5w8yPh5uwNVh5zAg"
                }],
            },
        ];
    });

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.Currencies
 * @description
 * # Currencies
 * Service in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
  .service('Currencies', function () {

        return [
            // Display used for dropdown menu
            // XRP - IMPORTANT: XRP must be first entry in this list
            {value: 'XRP', name: 'Ripple', custom_trade_currency_dropdown: true, standard_precision: 4, order: 5},

            // Fiat - Official ISO-4217
            // From USD until HKD, the order is based on https://www.bullionvault.com/gold-news/all_the_money_in_the_world_102720093.
            // After HKD, the order is alphabetical.
            {value: 'USD', name: 'US Dollar', display: true, custom_trade_currency_dropdown: true, standard_precision: 2, order: 4},
            {value: 'EUR', name: 'Euro', display: true, custom_trade_currency_dropdown: true, standard_precision: 2, order: 3},
            {value: 'JPY', name: 'Japanese Yen', display: true, custom_trade_currency_dropdown: true, standard_precision: 2, order: 0},
            {value: 'CNY', name: 'Chinese Yuan', display: true, custom_trade_currency_dropdown: true, standard_precision: 2, order: 0},
            {value: 'INR', name: 'Indian Rupee', display: true, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0},
            {value: 'RUB', name: 'Russian Ruble', display: true, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0},
            {value: 'GBP', name: 'British Pound', display: true, custom_trade_currency_dropdown: true, standard_precision: 2, order: 0},
            {value: 'CAD', name: 'Canadian Dollar', display: true, custom_trade_currency_dropdown: true, standard_precision: 2, order: 0},
            {value: 'BRL', name: 'Brazilian Real', display: true, custom_trade_currency_dropdown: true, standard_precision: 2, order: 0},
            {value: 'CHF', name: 'Swiss Franc', display: true, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0},
            {value: 'DKK', name: 'Danish Krone', display: true, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0},
            {value: 'NOK', name: 'Norwegian Krone', display: true, custom_trade_currency_dropdown: true, standard_precision: 2, order: 0},
            {value: 'SEK', name: 'Swedish Krona', display: true, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0},
            {value: 'CZK', name: 'Czech Koruna', display: true, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0},
            {value: 'PLN', name: 'Polish Zloty', display: true, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0},
            {value: 'AUD', name: 'Australian Dollar', display: true, custom_trade_currency_dropdown: true, standard_precision: 2, order: 0},
            {value: 'MXN', name: 'Mexican Peso', display: true, custom_trade_currency_dropdown: true, standard_precision: 2, order: 0},
            {value: 'KRW', name: 'South Korean Won', display: true, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0},
            {value: 'TWD', name: 'New Taiwan Dollar', display: true, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0},
            {value: 'HKD', name: 'Hong Kong Dollar', display: true, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0},

            // Alphabetical from here
            {value: 'AMD', name: 'Armenian Drams', display: true, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0},
            {value: 'KES', name: 'Kenyan Shilling', display: true, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0},
            {value: 'NZD', name: 'New Zealand Dollar', display: true, custom_trade_currency_dropdown: true, standard_precision: 2, order: 0},
            {value: 'RON', name: 'Romanian Leu', display: true, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0},
            {value: 'TRY', name: 'Turkish Lira', display: true, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0},

            // Fiat currencies NOT SHOWN
            {value: 'AFN', name: 'Afghan Afghani', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'ALL', name: 'Albanian Lek', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'DZD', name: 'Algerian Dinar', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'AOA', name: 'Angolan Kwanza Readjustado', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'XCD', name: 'East Caribbean Dollar', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'ARS', name: 'Argentine peso', display: false, custom_trade_currency_dropdown: true, standard_precision: 2, order: 0 },
            {value: 'AWG', name: 'Aruban Florin', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'AZN', name: 'Azerbaijani Manat', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'BSD', name: 'Bahamian Dollar', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'BHD', name: 'Bahraini Dinar', display: false, custom_trade_currency_dropdown: false, standard_precision: 3, order: 0 },
            {value: 'BDT', name: 'Taka', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'BBD', name: 'Barbados Dollar', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'BYR', name: 'Belarussian Ruble', display: false, custom_trade_currency_dropdown: false, standard_precision: 0, order: 0 },
            {value: 'BZD', name: 'Belize Dollar', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'XOF', name: 'CFA Franc BCEAO', display: false, custom_trade_currency_dropdown: false, standard_precision: 0, order: 0 },
            {value: 'BMD', name: 'Bermudian Dollar', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'BTN', name: 'Ngultrum', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'BOB', name: 'Boliviano', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'BOV', name: 'Mvdol', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'BAM', name: 'Convertible Mark', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'BWP', name: 'Pula', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'BND', name: 'Brunei Dollar', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'BGN', name: 'Bulgarian Lev', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'BIF', name: 'Burundi Franc', display: false, custom_trade_currency_dropdown: false, standard_precision: 0, order: 0 },
            {value: 'KHR', name: 'Riel', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'XAF', name: 'CFA Franc BEAC', display: false, custom_trade_currency_dropdown: false, standard_precision: 0, order: 0 },
            {value: 'CVE', name: 'Cabo Verde Escudo', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'KYD', name: 'Cayman Islands Dollar', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'CLF', name: 'Chilean Unidad de Formentos', display: false, custom_trade_currency_dropdown: false, standard_precision: 0, order: 0 },
            {value: 'CLP', name: 'Chilean Peso', display: false, custom_trade_currency_dropdown: true, standard_precision: 0, order: 0 },
            {value: 'COP', name: 'Colombian Peso', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'COU', name: 'Unidad de Valor Real', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'KMF', name: 'Comoro Franc', display: false, custom_trade_currency_dropdown: false, standard_precision: 0, order: 0 },
            {value: 'CDF', name: 'Congolese Franc', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'CRC', name: 'Costa Rican Colon', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'HRK', name: 'Croatian Kuna', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'CUC', name: 'Peso Convertible', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'CUP', name: 'Cuban Peso', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'ANG', name: 'Netherlands Antillean Guilder', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'DJF', name: 'Djibouti Franc', display: false, custom_trade_currency_dropdown: false, standard_precision: 0, order: 0 },
            {value: 'DOP', name: 'Dominican Peso', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'EGP', name: 'Egyptian Pound', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'SVC', name: 'El Salvador Colon', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'ERN', name: 'Nakfa', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'ETB', name: 'Ethiopian Birr', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'FKP', name: 'Falkland Islands Pound', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'FJD', name: 'Fiji Dollar', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'XPF', name: 'CFP Franc', display: false, custom_trade_currency_dropdown: false, standard_precision: 0, order: 0 },
            {value: 'GMD', name: 'Dalasi', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'GEL', name: 'Lari', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'GHS', name: 'Ghana Cedi', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'GIP', name: 'Gibraltar Pound', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'GTQ', name: 'Quetzal', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'GNF', name: 'Guinea Franc', display: false, custom_trade_currency_dropdown: false, standard_precision: 0, order: 0 },
            {value: 'GYD', name: 'Guyana Dollar', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'HTG', name: 'Gourde', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'HNL', name: 'Lempira', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'HUF', name: 'Forint', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'ISK', name: 'Iceland Krona', display: false, custom_trade_currency_dropdown: false, standard_precision: 0, order: 0 },
            {value: 'IDR', name: 'Indonesia Rupiah', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'IRR', name: 'Iranian Rial', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'IQD', name: 'Iraqi Dinar', display: false, custom_trade_currency_dropdown: false, standard_precision: 3, order: 0 },
            {value: 'ILS', name: 'New Israeli Sheqel', display: false, custom_trade_currency_dropdown: true, standard_precision: 2, order: 0 },
            {value: 'JMD', name: 'Jamaican Dollar', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'JOD', name: 'Jordanian Dinar', display: false, custom_trade_currency_dropdown: false, standard_precision: 3, order: 0 },
            {value: 'KZT', name: 'Tenge', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'KPW', name: 'North Korean Won', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'KWD', name: 'Kuwaiti Dinar', display: false, custom_trade_currency_dropdown: false, standard_precision: 3, order: 0 },
            {value: 'KGS', name: 'Som', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'LAK', name: 'Kip', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'LVL', name: 'Latvian Lats', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'LBP', name: 'Lebanese Pound', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'LSL', name: 'Loti', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'ZAR', name: 'Rand', display: true, custom_trade_currency_dropdown: true, standard_precision: 2, order: 0 },
            {value: 'LRD', name: 'Liberian Dollar', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'LYD', name: 'Libyan Dinar', display: false, custom_trade_currency_dropdown: false, standard_precision: 3, order: 0 },
            {value: 'LTL', name: 'Lithuanian Litas', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'MOP', name: 'Pataca', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'MKD', name: 'Denar', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'MGA', name: 'Malagasy Ariary', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'MWK', name: 'Kwacha', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'MYR', name: 'Malaysian Ringgit', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'MVR', name: 'Rufiyaa', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'MRO', name: 'Ouguiya', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'MUR', name: 'Mauritius Rupee', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'MXV', name: 'Mexican Unidad de Inversion (UDI)', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'MDL', name: 'Moldovan Leu', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'MNT', name: 'Tugrik', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'MAD', name: 'Moroccan Dirham', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'MZN', name: 'Mozambique Metical', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'MMK', name: 'Kyat', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'NAD', name: 'Namibia Dollar', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'NPR', name: 'Nepalese Rupee', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'NIO', name: 'Cordoba Oro', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'NGN', name: 'Naira', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'OMR', name: 'Rial Omani', display: false, custom_trade_currency_dropdown: false, standard_precision: 3, order: 0 },
            {value: 'PKR', name: 'Pakistan Rupee', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'PAB', name: 'Balboa', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'PGK', name: 'Kina', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'PYG', name: 'Guarani', display: false, custom_trade_currency_dropdown: false, standard_precision: 0, order: 0 },
            {value: 'PEN', name: 'Nuevo Sol', display: false, custom_trade_currency_dropdown: true, standard_precision: 2, order: 0 },
            {value: 'PHP', name: 'Philippine Peso', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'QAR', name: 'Qatari Rial', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'RWF', name: 'Rwanda Franc', display: false, custom_trade_currency_dropdown: false, standard_precision: 0, order: 0 },
            {value: 'SHP', name: 'Saint Helena Pound', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'WST', name: 'Tala', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'STD', name: 'Dobra', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'SAR', name: 'Saudi Riyal', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'RSD', name: 'Serbian Dinar', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'SCR', name: 'Seychelles Rupee', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'SLL', name: 'Leone', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'SGD', name: 'Singapore Dollar', display: true, custom_trade_currency_dropdown: true, standard_precision: 2, order: 0 },
            {value: 'SBD', name: 'Solomon Islands Dollar', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'SOS', name: 'Somali Shilling', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'SSP', name: 'South Sudanese Pound', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'LKR', name: 'Sri Lanka Rupee', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'SDG', name: 'Sudanese Pound', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'SRD', name: 'Surinam Dollar', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'SZL', name: 'Lilangeni', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'CHE', name: 'WIR Euro', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'CHW', name: 'WIR Franc', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'SYP', name: 'Syrian Pound', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'TJS', name: 'Somoni', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'TZS', name: 'Tanzanian Shilling', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'THB', name: 'Thai Baht', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'TOP', name: 'Pa’anga', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'TTD', name: 'Trinidad and Tobago Dollar', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'TND', name: 'Tunisian Dinar', display: false, custom_trade_currency_dropdown: false, standard_precision: 3, order: 0 },
            {value: 'TMT', name: 'Turkmenistan New Manat', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'UGX', name: 'Uganda Shilling', display: false, custom_trade_currency_dropdown: false, standard_precision: 0, order: 0 },
            {value: 'UAH', name: 'Hryvnia', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'AED', name: 'UAE Dirham', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'USN', name: 'US Dollar (Next day)', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'USS', name: 'US Dollar (Same day)', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'UYI', name: 'Uruguay Peso en Unidades Indexadas (URUIURUI)', display: false, custom_trade_currency_dropdown: false, standard_precision: 0, order: 0 },
            {value: 'UYU', name: 'Peso Uruguayo', display: false, custom_trade_currency_dropdown: true, standard_precision: 2, order: 0 },
            {value: 'UZS', name: 'Uzbekistan Sum', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'VUV', name: 'Vatu', display: false, custom_trade_currency_dropdown: false, standard_precision: 0, order: 0 },
            {value: 'VEF', name: 'Bolivar', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'VND', name: 'Dong', display: false, custom_trade_currency_dropdown: false, standard_precision: 0, order: 0 },
            {value: 'YER', name: 'Yemeni Rial', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'ZMK', name: 'Zambian Kwacha', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },
            {value: 'ZWL', name: 'Zimbabwean Dollar', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0 },

            // Precious Metals
            {value: 'XAU', name: 'Gold', display: true, custom_trade_currency_dropdown: true, standard_precision: 4, order: 0},
            {value: 'XAU (-0.5%pa)', name: 'Gold', display: false, custom_trade_currency_dropdown: false, standard_precision: 2, order: 0},
            {value: 'XAG', name: 'Silver', display: true, custom_trade_currency_dropdown: true, standard_precision: 2, order: 0},
            {value: 'XPT', name: 'Platinum', display: true, custom_trade_currency_dropdown: true, standard_precision: 2, order: 0},

            // Cryptocurrencies
            {value: 'QAU', name: 'Quantum', display: true, custom_trade_currency_dropdown: true, standard_precision: 4, order: 2},
            {value: 'ETH', name: 'Ether', display: true, custom_trade_currency_dropdown: true, standard_precision: 4, order: 2},
            {value: 'ETC', name: 'Ether Classic', display: true, custom_trade_currency_dropdown: true, standard_precision: 4, order: 2},
            {value: 'REP', name: 'Augur REP', display: true, custom_trade_currency_dropdown: true, standard_precision: 4, order: 0},
            {value: 'BTC', name: 'Bitcoin', display: true, custom_trade_currency_dropdown: true, standard_precision: 4, order: 2},
            {value: 'LTC', name: 'Litecoin', display: true, custom_trade_currency_dropdown: true, standard_precision: 4, order: 1},
            {value: 'STR', name: 'Stellars', display: true, custom_trade_currency_dropdown: true, standard_precision: 0, order: 0},
            {value: 'BCH', name: 'Bitcoin Cash', display: true, custom_trade_currency_dropdown: true, standard_precision: 4, order: 2},
            {value: 'DSH', real_code: 'DASH', name: 'Dash', display: true, custom_trade_currency_dropdown: true, standard_precision: 4, order: 2},
            {value: 'FLR', name: 'Flare', display: true, custom_trade_currency_dropdown: false, standard_precision: 4, order: 1},
            {value: 'SGB', name: 'Songbird', display: true, custom_trade_currency_dropdown: false, standard_precision: 4, order: 1},
            {value: 'ELS', name: 'Elysian', display: true, custom_trade_currency_dropdown: true, standard_precision: 4, order: 1},
            
            // Nonstandard currency codes
            {value: 'SOLO', name: 'Sologenic', display: true, custom_trade_currency_dropdown: false, standard_precision: 4, order: 1, xrplHex: '534F4C4F00000000000000000000000000000000'},
            {value: 'GALA', name: 'Gala', display: true, custom_trade_currency_dropdown: true, standard_precision: 4, order: 1, xrplHex: '47414C4100000000000000000000000000000000'},
            {value: 'USDT', name: 'Tether', display: true, custom_trade_currency_dropdown: true, standard_precision: 4, order: 1, xrplHex: '5553445400000000000000000000000000000000'},
            {value: 'USDC', name: 'USD Coin', display: true, custom_trade_currency_dropdown: true, standard_precision: 4, order: 1, xrplHex: '5553444300000000000000000000000000000000'},
            {value: 'WXRP', name: 'Wrapped XRP', display: true, custom_trade_currency_dropdown: true, standard_precision: 4, order: 1, xrplHex: '5758525000000000000000000000000000000000'},

            // Custom
            {value: 'PTT', name: 'Points', display: true, custom_trade_currency_dropdown: true, standard_precision: 2, order: 0},
            {value: 'FMM', name: 'Market Making Fund', display: true, custom_trade_currency_dropdown: true, standard_precision: 4, order: 0},

        ];

  });

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.CurrencyMeta
 * @description
 * # CurrencyMeta
 * Service in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
  .service('CurrencyMeta', function () {
    var factory = {
        getCurrencyMeta: getCurrencyMeta,
        getCurrencyColor: getCurrencyColor,
        getDefaultCurrencies: getDefaultCurrencies
    };

    var currencies = [
        { variant: 'eur', icon: '/images/ico/svg/eur_icon.svg', color: '#0A6CF1' },
        { variant: 'usd', icon: '/images/ico/svg/usd_icon.svg', color: '#75B103' },
        { variant: 'gbp', icon: '/images/ico/svg/gbp_icon.svg', color: '#E02524' },
        { variant: 'btc', icon: '/images/ico/svg/btc_icon.svg', color: '#F7773E', transform: 'rotate(14deg)' },
        { variant: 'bch', icon: '/images/ico/svg/btc_icon.svg', color: '#0AC18E', transform: 'rotate(-14deg)' },
        { variant: 'xrp', icon: '/images/ico/svg/xrp_icon.svg', color: '#3B3F4D' },
        { variant: 'eth', icon: '/images/ico/svg/eth_icon.svg', color: '#8037FF' },
        { variant: 'etc', icon: '/images/ico/svg/eth_icon.svg', color: '#0C8412' },
        { variant: 'dsh', icon: '/images/ico/svg/dsh_icon.svg', color: '#0AAAF1' },
        { variant: 'dash', icon: '/images/ico/svg/dsh_icon.svg', color: '#0AAAF1' }, // DASH & DSH workaround :/
        { variant: 'rep', icon: '/images/ico/svg/rep_icon.svg', color: '#602A52' },
        { variant: 'ltc', icon: '/images/ico/svg/ltc_icon.svg', color: '#285BA0' },
        { variant: 'csc', icon: '/images/ico/svg/csc_icon.svg', color: '#105434' },
        { variant: 'gala', icon: '/images/ico/svg/gala_icon.svg', color: '#090A0F', background: 'url(/images/ico/svg/gala_icon.svg) 50% 50% no-repeat, linear-gradient(180deg, #182B46 0%, #0C1727 100%)' },
        { variant: 'usdt', icon: '/images/ico/svg/usdt_icon.svg', color: '#26A17B', background: 'url(/images/ico/svg/usdt_icon.svg) 50% 50% no-repeat, linear-gradient(180deg, #63C4A6 0%, #26A17B 100%)' },
        { variant: 'usdc', icon: '/images/ico/svg/usdc_icon.svg', color: '#2775CA', background: 'url(/images/ico/svg/usdc_icon.svg) 50% 50% no-repeat, linear-gradient(180deg, #4898EF 0%, #2775CA 100%)' },
        { variant: 'wxrp', icon: '/images/ico/svg/wxrp_icon.svg', color: '#df5a69', background: 'url(/images/ico/svg/wxrp_icon.svg) 50% 50% no-repeat, linear-gradient(180deg, #2D344D 0%, #090A0F 100%)' },
        { variant: 'gala-dark', icon: '/images/ico/svg/gala-dark_icon.svg', color: '#fff' },
        { variant: 'usdt-dark', icon: '/images/ico/svg/usdt-dark_icon.svg', color: '#fff' },
        { variant: 'usdc-dark', icon: '/images/ico/svg/usdc-dark_icon.svg', color: '#fff' },
        { variant: 'wxrp-dark', icon: '/images/ico/svg/wxrp-dark_icon.svg', color: '#fff' },
        { variant: 'xau', color: '#7E5B20' },
        { variant: 'coil', icon: '/images/ico/svg/coil-logo_icon.svg', color: '#2B3040' },
        { variant: 'btc-dark', icon: 'images/ico/svg/btc-dark_icon.svg', color: '#fff', transform: 'rotate(14deg)' },
        { variant: 'bch-dark', icon: 'images/ico/svg/btc-dark_icon.svg', color: '#fff', transform: 'rotate(-14deg)' },
        { variant: 'xrp-dark', icon: 'images/ico/svg/xrp-dark_icon.svg', color: '#fff' },
        { variant: 'eth-dark', icon: 'images/ico/svg/eth-dark_icon.svg', color: '#fff' },
        { variant: 'dsh-dark', icon: 'images/ico/svg/dsh-dark_icon.svg', color: '#fff' },
        { variant: 'rep-dark', icon: 'images/ico/svg/rep-dark_icon.svg', color: '#fff' },
        { variant: 'ltc-dark', icon: 'images/ico/svg/ltc-dark_icon.svg', color: '#fff' },
        { variant: 'credit-card', icon: 'images/ico/svg/credit-card_icon.svg', color: '#fff' },
        { variant: 'bank', icon: 'images/ico/svg/bank-dark_icon.svg', color: '#fff' },
        { variant: 'ilp', icon: 'images/ico/svg/ilp-dark_icon.svg', color: '#fff' },
        { variant: 'gold', icon: 'images/ico/svg/gold-dark_icon.svg', color: '#fff' },
        { variant: 'wallet', icon: 'images/ico/svg/wallet-dark_icon.svg', color: '#fff' },
        { variant: 'paystring', icon: 'images/ico/svg/paystring-dark_icon.svg', color: '#fff' },
        { variant: 'flr', tooltip: 'flare', icon: 'images/ico/svg/flr_icon.svg', color: '#353A69' },
        { variant: 'flr-dark', tooltip: 'flare', icon: 'images/ico/svg/flr-dark_icon.svg', color: '#fff' },
        { variant: 'multisign', icon: '/images/ico/svg/shield_icon.svg', color: '#fff' },
        { variant: 'sgb', icon: '/images/ico/svg/sgb_icon.svg', color: '#df5a69', background: 'url(/images/ico/svg/sgb_icon.svg) 50% 50% no-repeat, linear-gradient(180deg, #f4909b 0%, #df5a69 100%)' },
        { variant: 'sgb-dark', icon: 'images/ico/svg/sgb-dark_icon.svg', color: '#fff' },
        { variant: 'solo', icon: 'images/ico/svg/solo_icon.svg', color: '#000' },
        { variant: 'els', icon: 'images/ico/svg/els_icon.svg', color: '#000' },
    ];

    var defaultCurrencies = [
        { code: 'EUR', name: 'Euro' },
        { code: 'USD', name: 'US Dollar' },
        { code: 'XRP', name: 'Ripple' },
        { code: 'BTC', name: 'Bitcoin' },
        { code: 'ETH', name: 'Ether' },
        { code: 'BCH', name: 'Bitcoin Cash' },
        { code: 'ETC', name: 'Ether Classic' },
        { code: 'DSH', name: 'Dash' },
        { code: 'LTC', name: 'Litecoin' },
        { code: 'GALA', name: 'Gala' },
        { code: 'USDT', name: 'Tether' },
        { code: 'USDC', name: 'USD Coin' },
        { code: 'WXRP', name: 'Wrapped XRP' },
        { code: 'GBP', name: 'British Pound' },
    ];

    function getCurrencyMeta(currency) {
        if (!currency || typeof currency != 'string') {
            return {};
        }
        return _.find(currencies, { variant: currency.toLowerCase() }) || {};
    }

    function getCurrencyColor(currency) {
        var currencyMeta = _.find(currencies, { variant: currency.toLowerCase() });

        if (!_.isEmpty(currencyMeta)) {
            return currencyMeta.color;
        }

        return '#585C6A';
    }

    function getDefaultCurrencies() {
        return defaultCurrencies;
    }

    return factory;
  });

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.auth
 * @description
 * # auth
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
    .factory('Auth', Auth)
    .run(runAuth)
    .config(configAuth);

function Auth(Restangular, $sessionStorage, $location, ENV, $q, $timeout, MigrationRestangular, Endpoint, Settings, EthRestangular, IDRestangular, CoreRestangular, instantMemory, $state, $rootScope, AuthRestangular, AuthRestangularV2, OAuthRestangular, TokenRestangular, RepRestangular, EtcRestangular, BtcRestangular, BchRestangular, DshRestangular, LtcRestangular, SgbRestangular, EventRestangular, InterledgerRestangular, IlpRestangular, RatesRestangular, CurrencyConverterRestangular, ShadowRestangular, StorageRestangular, MultisigRestangular, GalaRestangular, UsdcRestangular, UsdtRestangular, WxrpRestangular, StripeRestangular) {

    var reqRefreshToken = false;
    var firstLoad = true;
    var user = undefined;
    var getUserRequest = null;

    $rootScope.hideAll = true;

    var factory = {
        getProfile : getProfile,
        refreshToken : refreshToken,
        setToken : setToken,
        getIdentityUser : getIdentityUser,
        checkLogin : checkLogin,
        setRestangularToken : setRestangularToken,
        redirect : redirect,
        logout: logout,
        setTokenOnChange: setTokenOnChange,
        getIdProvider: getIdProvider
    }

    return factory;

    ///////////////////////////////////////////////////////////

    function checkProfileSteps(identityProfile, version) {

        // Check steps

        // Bypass if identity page
        if($state.includes('identity') && $state.includes('help')) {
            return;
        }

        // Bypass only if user is old GateHub user and it has already been showned identity
        if(version == 1 && firstLoad == false) {
            return;
        }
        firstLoad = false;

        // console.log(identityProfile);

        // Bypass if Gateway already connected
        CoreRestangular.one('users', identityProfile.uuid).all('gateways').getList().then(function (data) {

            var gateways = data.plain();

            var profileEmpty = !Object.keys(identityProfile.profile).filter(function(e) {
                return !!identityProfile.profile[e] && !~[ 'uuid', 'created_at', 'documents' ].indexOf(e);
            }).length;

            // User either connected to a gateway or pending
            if (gateways.length != 0) {
                return;
            }

            // Bypass if migrated
            if(identityProfile.score && identityProfile.score.absolute != 0) {
                return;
            }

            // Bypass if on rekey page
            if($state.includes('security.rekey')) {
                return;
            }

            // Bypass if on rekey fix page
            if($state.includes('security.rekeyfix')) {
                return;
            }

            // Individual
            if(identityProfile.user_type != 1) {
                if(identityProfile.verification_level < 1) {
                    if(identityProfile.phone_number){
                        $state.go('identity.form.phone'); // phone exists, but not yet verified
                    } else {
                        $state.go("identity.form.profile"); // no phone yet, not verified: go to individual/company selection
                    }
                };
            }
            // Company
            else {
                if(!Object.keys(identityProfile.companyProfile).length && identityProfile.phone_number == null) {
                    $state.go("identity.form.phone");
                }
                else if(!Object.keys(identityProfile.companyProfile).length && identityProfile.uuid != null) {
                    $state.go("identity.form.profile");
                }
            }

        });

    };

    function getProfile(refresh) {

        var deferred = $q.defer();

        if(!angular.isUndefined(user) && refresh != true) {
            //checkWalletEncryption(user); // it is now checked in app.js
            deferred.resolve(user);
            return deferred.promise;
        }
        // Try to reuse existing promise
        else if (getUserRequest && angular.isUndefined(user)) {
            return getUserRequest.promise;
        }
        else {
            getUserRequest = deferred;

            $timeout(function(){

                var isSessionTokenDefined = $sessionStorage.token && $sessionStorage.token.access_token;

                if (angular.isUndefined(Restangular.defaultHeaders.Authorization) && !isSessionTokenDefined) {
                    deferred.reject("Header undefined");
                } else {
                    // hack: if defaultHeaders.Authorization is not yet present, but it exists in $sessionStorage, get it from there
                    if(angular.isUndefined(Restangular.defaultHeaders.Authorization) && isSessionTokenDefined) {
                        Restangular.setDefaultHeaders({Authorization: 'Bearer '+ $sessionStorage.token.access_token});
                    }

                    // default restangular: Auth API
                    Restangular.one('user').get().then(function(data) {

                        data.uid = data.id;
                        data.version = data.meta.version;
                        data.version_old = data.meta.version_old;

                        data.master_key = data.meta.master_key;
                        data.master_key_iterations = data.meta.master_key_iterations;
                        data.master_key_salt = data.meta.master_key_salt;

                        data.master_key_old = data.meta.master_key_old;
                        data.master_key_iterations_old = data.meta.master_key_iterations_old;
                        data.master_key_salt_old = data.meta.master_key_salt_old;

                        data.migration_status = data.meta.migration_status;

                        // Identity User
                        getIdentityUser(data.uid, data.version).then(function(response){
                            data.identity = response;

                            // hot fix identity problem returning string instead of array
                            if(data.identity.companyProfile && data.identity.companyProfile.profiles && typeof data.identity.companyProfile.profiles === 'string' ){
                                data.identity.companyProfile.profiles = JSON.parse(data.identity.companyProfile.profiles);
                            }

                            // Pre-fill Zendesk form with user data
                            if (window.zE) {
                                var userIdentity = {
                                    name: '',
                                    email: data.email || ''
                                };
                                if (data.identity.profile) {
                                    userIdentity.name += data.identity.profile.first_name || '';
                                    userIdentity.name += data.identity.profile.middle_name ? ' ' + data.identity.profile.middle_name : '';
                                    userIdentity.name += data.identity.profile.last_name ? ' ' + data.identity.profile.last_name : '';
                                }
                                zE('webWidget', 'prefill', {
                                    name: {
                                        value: userIdentity.name,
                                        readOnly: true
                                    },
                                    email: {
                                        value: data.email,
                                        readOnly: true
                                    }
                                });
                            }

                            // Core User
                            getCoreUser(data.uid).then(function(coreresponse){
                                data.core = coreresponse;
                                user = data;
                                $sessionStorage.user = data;
                                //checkWalletEncryption(user); // it is now checked in app.js
                                deferred.resolve(data);

                                getUserRequest = null;
                                // ! check if this is okay
                                $rootScope.hideAll = false;

                            }, function(error){
                                console.error('Core user error', error);
                                getUserRequest = null;
                                deferred.reject(error);
                            });

                        }, function(error) {
                            console.error('Identity user error', error);
                            getUserRequest = null;
                            deferred.reject(error);
                        });

                    }, function(error) {
                        console.error('Auth user error', error);
                        getUserRequest = null;
                        deferred.reject(error);
                    });

                };

            }, 0);

            return getUserRequest.promise;
        };

    };

    function logout() {

        var token = $sessionStorage._token || { };
        // This might cause some problems?
        $sessionStorage.previousState = $location.path();

        var data = {
            access_token_revoke : token.access_token,
            refresh_token_revoke : token.refresh_token
        };


        TokenRestangular.all("oauth").withHttpConfig({transformRequest:  function(obj) {
            var str = [];
            for(var p in obj)
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            return str.join("&");
        }}).customPOST(data, "revoke", {}, { 'Content-Type': 'application/x-www-form-urlencoded'}).then(function(response){
            $sessionStorage.token = undefined;
            $sessionStorage._token = undefined;
            $sessionStorage.user = undefined;
            $rootScope.hideAll = true;
            Endpoint.redirect();
        }, function(reason){
            console.log(reason);
            $rootScope.hideAll = true;
            Endpoint.redirect();
        });
    };


    function getIdentityUser(uid, version) {

        return IDRestangular.one('users', uid).get().then(function(data){
            if($location.$$url.indexOf("/identity") !== 0)
                checkProfileSteps(data, version);
            return data;
        });

    };

    function getCoreUser(uid) {

        return CoreRestangular.one('users', uid).get().then(function(data){
            return data;
        });

    };

    function refreshToken(){

        var deferred = $q.defer();


        if(angular.isUndefined($sessionStorage.token)){
            deferred.reject("Token is not defined in session");
        }
        else {

            var token = $sessionStorage.token;

            var data = {
                grant_type: 'refresh_token',
                client_id: Settings.app.client_id,
                client_secret: Settings.app.client_secret,
                refresh_token: token.refresh_token
            }
            var refresh_token_req = instantMemory.getValue("refresh_token_req");

            if(!reqRefreshToken) {
                reqRefreshToken = true;
                // Restangular.setDefaultHeaders({Authorization: 'Bearer '+token.access_token});

                // Refresh access-token logic
                TokenRestangular.all("oauth").withHttpConfig({transformRequest:  function(obj) {
                    var str = [];
                    for(var p in obj)
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                }}).customPOST(data, "token", {}, { 'Content-Type': 'application/x-www-form-urlencoded'}).then(function(response){
                    // this callback will be called asynchronously
                    // when the response is available
                    setRestangularToken(response.access_token);
                    $sessionStorage.token = response.plain();
                    $sessionStorage._token = response.plain();
                    reqRefreshToken = false;
                    deferred.resolve(response);
                }, function(reason){
                    reqRefreshToken = false;
                    deferred.reject(reason);
                });

            }
            else {
                if (!angular.isUndefined(refresh_token_req)) {
                    return refresh_token_req.promise;
                } else {
                    deferred.reject(true);
                }
            }

        }

        return deferred.promise;

    };

    function setToken(stateParams, location){

        // console.log('Set Token')

        var deferred = $q.defer();

        if(!!stateParams.access_token) {

            var token = {
                access_token : stateParams.access_token,
                refresh_token : stateParams.refresh_token
            }

            setRestangularToken(stateParams.access_token);

            $sessionStorage.token = token;
            $sessionStorage._token = token;
            //AccessToken.setTokenFromString(location.$$absUrl);

            this.getProfile().then(function(data){
                $sessionStorage.user = data;
                deferred.resolve();
            });

            // Next

        } else {
            deferred.reject("Access token missing, login required!");
        }

        return deferred.promise;

    };

    /**
     * set token ok state change in app
     */
    function setTokenOnChange() {
        if (!angular.isUndefined($sessionStorage.token)) {
            var token = $sessionStorage.token;
            setRestangularToken(token.access_token);
        } else {
            logout();
        }
    }

    function setRestangularToken(token) {

        if (token) {
            AuthRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            AuthRestangularV2.setDefaultHeaders({Authorization: 'Bearer '+ token});
            OAuthRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            TokenRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            Restangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            IDRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            CoreRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            MigrationRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            EthRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            RepRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            EtcRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            BtcRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            DshRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            BchRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            LtcRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            SgbRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            GalaRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            UsdtRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            UsdcRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            WxrpRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            EventRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            InterledgerRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            IlpRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            RatesRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            CurrencyConverterRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            ShadowRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            MultisigRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            StorageRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
            StripeRestangular.setDefaultHeaders({Authorization: 'Bearer '+ token});
        } else {
            console.log('Error set token - undefined')
        }

    };

    function redirect() {
        var redirectUrl = encodeURIComponent(location.protocol + '//' + location.host + '/#/token');
        var url = ENV.apiSignin + "/oauth/authorize?response_type=token&client_id=" + ENV.clientID + "&redirect_uri=" + redirectUrl + "&scope=public&state=";
        window.location.replace(url);

    };

    function checkLogin() {
        // $rootScope.hideAll = false;
        if(angular.isUndefined($sessionStorage.token)) {
            $rootScope.hideAll = true;
        };

        if($location.$$url.indexOf("/token") !== 0) {
            $sessionStorage.previousState = $location.path();
            $state.go("auth");
        }
        else {
            // $rootScope.hideAll = false;
        };

    };

    function getIdProvider(providerName) {
        return new Promise(function(resolve, reject) {
            AuthRestangular.one('identity_providers').get()
                .then(function(data) {
                    var provider = data.find(function(idProvider) {
                        return idProvider.provider === providerName;
                    });

                    resolve(provider);
                })
                .catch(function(error) {
                    reject(error);
                })
        })
    }

}
Auth.$inject = ["Restangular", "$sessionStorage", "$location", "ENV", "$q", "$timeout", "MigrationRestangular", "Endpoint", "Settings", "EthRestangular", "IDRestangular", "CoreRestangular", "instantMemory", "$state", "$rootScope", "AuthRestangular", "AuthRestangularV2", "OAuthRestangular", "TokenRestangular", "RepRestangular", "EtcRestangular", "BtcRestangular", "BchRestangular", "DshRestangular", "LtcRestangular", "SgbRestangular", "EventRestangular", "InterledgerRestangular", "IlpRestangular", "RatesRestangular", "CurrencyConverterRestangular", "ShadowRestangular", "StorageRestangular", "MultisigRestangular", "GalaRestangular", "UsdcRestangular", "UsdtRestangular", "WxrpRestangular", "StripeRestangular"];;


function runAuth(Restangular, AuthRestangular, AuthRestangularV2, OAuthRestangular, AccessToken, $rootScope, Auth, $http, Idle, IDRestangular, CoreRestangular, EthRestangular, EtcRestangular, RepRestangular, BtcRestangular, DshRestangular, BchRestangular, LtcRestangular, SgbRestangular, GalaRestangular, UsdcRestangular, UsdtRestangular, WxrpRestangular, EventRestangular, InterledgerRestangular, IlpRestangular, RatesRestangular, CurrencyConverterRestangular, ShadowRestangular, StorageRestangular, MultisigRestangular, $route, coreSecurity, $timeout, StripeRestangular) {

    AuthRestangular.setErrorInterceptor(function(response, deferred, responseHandler) {
       return checkResponse(response, deferred, responseHandler);
    });

    AuthRestangularV2.setErrorInterceptor(function(response, deferred, responseHandler) {
        return checkResponse(response, deferred, responseHandler);
    });

    OAuthRestangular.setErrorInterceptor(function(response, deferred, responseHandler) {
        return checkResponse(response, deferred, responseHandler);
    });

    Restangular.setErrorInterceptor(function(response, deferred, responseHandler) {
       return checkResponse(response, deferred, responseHandler);
    });

    CoreRestangular.setErrorInterceptor(function(response, deferred, responseHandler) {
       return checkResponse(response, deferred, responseHandler);
    });

    IDRestangular.setErrorInterceptor(function(response, deferred, responseHandler) {
       return checkResponse(response, deferred, responseHandler);
    });

    EthRestangular.setErrorInterceptor(function(response, deferred, responseHandler) {
       return checkResponse(response, deferred, responseHandler);
    });

    RepRestangular.setErrorInterceptor(function(response, deferred, responseHandler) {
       return checkResponse(response, deferred, responseHandler);
    });

    EtcRestangular.setErrorInterceptor(function(response, deferred, responseHandler) {
       return checkResponse(response, deferred, responseHandler);
    });

    BtcRestangular.setErrorInterceptor(function(response, deferred, responseHandler) {
       return checkResponse(response, deferred, responseHandler);
    });

    DshRestangular.setErrorInterceptor(function(response, deferred, responseHandler) {
        return checkResponse(response, deferred, responseHandler);
    });

    BchRestangular.setErrorInterceptor(function(response, deferred, responseHandler) {
       return checkResponse(response, deferred, responseHandler);
    });

    LtcRestangular.setErrorInterceptor(function(response, deferred, responseHandler) {
        return checkResponse(response, deferred, responseHandler);
    });

    SgbRestangular.setErrorInterceptor(function(response, deferred, responseHandler) {
        return checkResponse(response, deferred, responseHandler);
    });

    GalaRestangular.setErrorInterceptor(function(response, deferred, responseHandler) {
        return checkResponse(response, deferred, responseHandler);
    });

    UsdtRestangular.setErrorInterceptor(function(response, deferred, responseHandler) {
        return checkResponse(response, deferred, responseHandler);
    });

    UsdcRestangular.setErrorInterceptor(function(response, deferred, responseHandler) {
        return checkResponse(response, deferred, responseHandler);
    });

    WxrpRestangular.setErrorInterceptor(function(response, deferred, responseHandler) {
        return checkResponse(response, deferred, responseHandler);
    });

    EventRestangular.setErrorInterceptor(function(response, deferred, responseHandler) {
       return checkResponse(response, deferred, responseHandler);
    });

    InterledgerRestangular.setErrorInterceptor(function(response, deferred, responseHandler) {
       return checkResponse(response, deferred, responseHandler);
    });

    IlpRestangular.setErrorInterceptor(function(response, deferred, responseHandler) {
        return checkResponse(response, deferred, responseHandler);
     });

    RatesRestangular.setErrorInterceptor(function(response, deferred, responseHandler) {
       return checkResponse(response, deferred, responseHandler);
    });

    CurrencyConverterRestangular.setErrorInterceptor(function(response, deferred, responseHandler) {
        return checkResponse(response, deferred, responseHandler);
    });

    ShadowRestangular.setErrorInterceptor(function(response, deferred, responseHandler) {
        return checkResponse(response, deferred, responseHandler);
    });

    StorageRestangular.setErrorInterceptor(function(response, deferred, responseHandler) {
        return checkResponse(response, deferred, responseHandler);
    });

    MultisigRestangular.setErrorInterceptor(function(response, deferred, responseHandler) {
        return checkResponse(response, deferred, responseHandler);
    });

    StripeRestangular.setErrorInterceptor(function(response, deferred, responseHandler) {
        return checkResponse(response, deferred, responseHandler);
    });

    function checkResponse(response, deferred, responseHandler) {

        if (response.data && (response.status === 401 || response.status === 403)) {
            // catch 2fa errors from auth and core
            if (response.data.error === '2fa_required' || (response.data.message && response.data.message.toLowerCase() === "2fa required")) {
                coreSecurity.set2FaAuthorized(false);
            }
        }
        if (
            response.status === 401
            && (
                response.data
                && (
                    response.data.status_code === 401 ||
                    response.data.error === 'invalid_token' ||
                    response.data.error && response.data.error.status_code === 401
                )
            )
        ) {
            Auth.refreshToken().then(function (data) {
                // Repeat the request and then call the handlers the usual way.
                response.config.headers.Authorization = 'Bearer ' + data.access_token;
                $route.reload();
                $http(response.config).then(responseHandler, deferred.reject);
                // Be aware that no request interceptors are called this way.
            }, function (reason) {
                //console.log(reason);
                if (reason !== true) {
                    Auth.redirect();
                }
                else {
                    $timeout(function() {
                        //console.log('reload route')
                        $route.reload();
                    }, 5000);
                }
            });
            return false;
        }

        return true;

    };

    $rootScope.$on('oauth:authorized', function (event, token) {
        Auth.setTokenOnChange();
    });

    $rootScope.$on('oauth:logout', function() {
        // console.log("Logged out");
        Auth.logout();
    });

    $rootScope.$on('oauth:expired', function() {
        // console.log("Expired");
        $rootScope.hideAll = true;
        Auth.redirect();
    });

    $rootScope.$on('IdleTimeout', function() {
        // User has timed out (meaning idleDuration + timeout has passed without any activity)
        // console.log("Timeout");
        $rootScope.hideAll = true;
        AccessToken.destroy();
        Auth.redirect();
    });

    Idle.watch();
    Auth.checkLogin();
}
runAuth.$inject = ["Restangular", "AuthRestangular", "AuthRestangularV2", "OAuthRestangular", "AccessToken", "$rootScope", "Auth", "$http", "Idle", "IDRestangular", "CoreRestangular", "EthRestangular", "EtcRestangular", "RepRestangular", "BtcRestangular", "DshRestangular", "BchRestangular", "LtcRestangular", "SgbRestangular", "GalaRestangular", "UsdcRestangular", "UsdtRestangular", "WxrpRestangular", "EventRestangular", "InterledgerRestangular", "IlpRestangular", "RatesRestangular", "CurrencyConverterRestangular", "ShadowRestangular", "StorageRestangular", "MultisigRestangular", "$route", "coreSecurity", "$timeout", "StripeRestangular"];;

function configAuth(IdleProvider, KeepaliveProvider){
    IdleProvider.idle(10*60);              // 10*60 seconds - 10 minutes
    IdleProvider.timeout(10*60);           // 10*60 seconds - 10 minutes
    KeepaliveProvider.interval(10);         // 10
}
configAuth.$inject = ["IdleProvider", "KeepaliveProvider"];;

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.documents
 * @description
 * # documents
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
  .factory('Documents', documents);


function documents() {

  var factory = {
    allowedAllDocuments : allDocuments,
    requiredDocumentsUploaded: requiredDocumentsUploaded,
    requiredCompanyDocumentsUploaded: requiredCompanyDocumentsUploaded,
    hasEidVerification: hasEidVerification,
    isEidVerificationOK: isEidVerificationOK
  }

  return factory;
  /*
    Acceptable: ID both sides, DL both sides, International Passport

    US
    Canada
    Australia
    New Zealand
    South Africa
    EU (minus exceptions; see below)(Ukraine Belarus Russia)

   */
  function allDocuments(country_code) {
    if ((isEUCountry(country_code) && country_code !== 'UA' && country_code !== 'BY' && country_code !== 'RU') || country_code == 'US' || country_code == 'CA' || country_code == 'AU' || country_code == 'NZ' || country_code == 'ZA') {
      return true;
    }
    return false;
  }

  function isEUCountry(country_code) {
    var isEUCountryBool = false;
    getEUCountries().forEach(function (code) {
      if (country_code == code) {
        isEUCountryBool = true;
        return;
      }

    });

    return isEUCountryBool;
  }

  function getEUCountries() {
    return [
      'AL', 'AD', 'AM', 'AT', 'BY', 'BE', 'BA', 'BG', 'CH', 'CY', 'CZ', 'DE',
      'DK', 'EE', 'ES', 'FO', 'FI', 'FR', 'GB', 'GE', 'GI', 'GR', 'HU', 'HR',
      'IE', 'IS', 'IT', 'LT', 'LU', 'LV', 'MC', 'MK', 'MT', 'NO', 'NL', 'PL',
      'PT', 'RO', 'RU', 'SE', 'SI', 'SK', 'SM', 'TR', 'UA', 'VA'
    ];
  }

  function requiredDocumentsUploaded(docs){
    if(!docs){
      return false;
    }
    
    if(docs.length < 2) {
      console.log('Documents length < 2', docs.length);
      return false;
    }

    /* 
    Note: NEED TO RE-ENABLE THIS ONLY WITH DB MIGRATION FOR DOCS WITHOUT TYPE
    
    var docsPID = _.filter(docs, function(doc) {
      return doc.type == 'pid';
    });
    var docsPOR = _.filter(docs, function(doc) {
      return doc.type == 'por';
    });

    if(!docsPID.length){
      console.log('PID missing');
      return false;
    }
    if(!docsPOR.length){
      console.log('POR missing');
      return false;
    }
    */

    return true;
  }

  function requiredCompanyDocumentsUploaded(docs){
    if(!docs){
      return false;
    }

    if(docs.length < 1) {
      console.log('Documents length < 1', docs.length);
      return false;
    }

    /*
    var docsCorporate = _.filter(docs, function(doc) {
      return doc.type == 'corporate' && doc.subtype == 'certificate';
    });
    if(!docsCorporate.length){
      console.log('Certificate of incorporation missing');
      return false;
    }
    */

    return true;
  }

  function hasEidVerification(verifications) {
    if (verifications) {
      for (var i = 0; i < verifications.length; i++) {
        if (verifications[i].provider_type === "user-video-ocr") {
          return true;
        }
      }
    }
    return false;
  }

  function isEidVerificationOK(verifications) {
    for (var i = 0; i < verifications.length; i++) {
      if (verifications[i].provider_type === "user-video-ocr") {
        return verifications[i].status === 1;
      }
    }
    return false;
  }

}

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.identity
 * @description
 * # identity
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
  .factory('IdentityService', identity);


  function identity() {

    var factory = {
        checkProfileDiff: checkProfileDiff
    }

    return factory;

    function checkProfileDiff(base, to_compare){

        var has_changes = false;
        console.log(base, to_compare);

        if (Object.keys(to_compare).length == 0)
            return true;

        for(var key in base){
            if(to_compare.hasOwnProperty(key)) {
                if(!angular.equals(base[key], to_compare[key])) {
                    console.log("change", key, base[key], "-", to_compare[key] );
                    has_changes = true;
                    break;
                }
            }
        }

        console.log("Has changes", has_changes);
        return has_changes;
    }

  }

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.storage
 * @description
 * # storage
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
    .factory('StorageCore', StorageCore);

function StorageCore(StorageRestangular, $q) {

    var cachedProfilePhoto = null;
    var factory = {
        getProfilePhoto: getProfilePhoto,
        getCoverByUserId: getCoverByUserId
    };

    return factory;

    function getProfilePhoto(photoId, refresh) {
        var deferred = $q.defer();

        if (cachedProfilePhoto && !refresh) {
            deferred.resolve(cachedProfilePhoto);
        }
        else {
            StorageRestangular.one('cover', photoId).withHttpConfig({ responseType: 'arraybuffer' }).customGET('', { type: 'square' }).then(function (img) {
                var data = new Uint8Array(img);
                var raw = '';
                var i, j, subArray, chunk = 5000;
                for (i = 0, j = data.length; i < j; i += chunk) {
                    subArray = data.subarray(i, i + chunk);
                    raw += String.fromCharCode.apply(null, subArray);
                }
                var base64 = btoa(raw);
                var src = 'data:image;base64,' + base64;
                cachedProfilePhoto = src;
                deferred.resolve(cachedProfilePhoto);
                return src;

            }, function () {
                var src = '';
                return src;
            });
        }


        return deferred.promise;
    }

    function getCoverByUserId(userId) {

        var deferred = $q.defer();

        StorageRestangular
            .one('user', userId)
            .one('cover')
            .withHttpConfig({ responseType: 'arraybuffer' })
            .customGET('', { type: 'square' })
            .then(function (img) {
                var data = new Uint8Array(img);
                var raw = '';
                var i, j, subArray, chunk = 5000;
                for (i = 0, j = data.length; i < j; i += chunk) {
                    subArray = data.subarray(i, i + chunk);
                    raw += String.fromCharCode.apply(null, subArray);
                }
                var base64 = btoa(raw);
                var src = 'data:image;base64,' + base64;
                cachedProfilePhoto = src;
                deferred.resolve(cachedProfilePhoto);
                return src;

            }, function () {
                var src = '';
                return src;
        });

    return deferred.promise;

    }

}
StorageCore.$inject = ["StorageRestangular", "$q"];

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.instantMemory
 * @description
 * # instantMemory
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
  .factory('instantMemory', instantMemory);
   

   function instantMemory() {
    
    // AngularJS will instantiate a singleton by calling "new" on this function
    var hashtable = {};

    var factory = {
        setValue : setValue,
        getValue : getValue
    };

    return factory;

    function setValue(key, value) {
        hashtable[key] = value;
    };
    function getValue(key) {
        return hashtable[key];
    };

  }
'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.coreSecurity
 * @description
 * # coreSecurity
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
    .factory('coreSecurity', coreSecurity);


function coreSecurity($q, instantMemory) {

    var twoFaAuthorized = false;

    var unlockStatus = {
        masterUnlocked: isMasterUnlocked(),
        twoFaAuthorized: is2FaAuthorized(),
        unlocked: isMasterUnlocked() && is2FaAuthorized()
    };

    var factory = {
        generate2faKey: generate2faKey,
        generateKeyPair: generateKeyPair,
        encrypt: encrypt,
        decrypt: decrypt,
        AESEncrypt: AESEncrypt,
        AESDecrypt: AESDecrypt,
        generate_key: generate_key,
        generate_pbkdf: generate_pbkdf,
        get_pbkdf: get_pbkdf,
        unlockUser: unlockUser,
        is2FaAuthorized: is2FaAuthorized,
        unlockStatus: unlockStatus,
        set2FaAuthorized: set2FaAuthorized,
        isMasterUnlocked: isMasterUnlocked
    }

    return factory;

    function is2FaAuthorized() {
        return twoFaAuthorized;
    }

    function updateUnlockStatus() {
        unlockStatus.masterUnlocked = isMasterUnlocked(),
        unlockStatus.twoFaAuthorized = is2FaAuthorized(),
        unlockStatus.unlocked =
            unlockStatus.masterUnlocked &&
            unlockStatus.twoFaAuthorized;
    }

    function set2FaAuthorized(_twoFaAuthorized) {
        twoFaAuthorized = _twoFaAuthorized ? true : false;
        updateUnlockStatus();
    }

    function isMasterUnlocked() {
        return !angular.isUndefined(instantMemory.getValue("base_security"));
    }

    function generate2faKey() {

        var length = 16;

        var set = '234567QWERTYUIOPASDFGHJKLZXCVBNM';
        var key = '';

        for (var i = 0; i < length; i++) {
            key += set.charAt(Math.floor(Math.random() * set.length));
        }

        return key;

    };

    function generateKeyPair(numBits, userId, passphrase) {

        var options = {
            numBits: numBits,
            userId: userId, //'Jon Smith <jon.smith@example.org>'
            passphrase: passphrase
        };

        return openpgp.generateKeyPair(options).then(function (keypair) {
            // success
            var privkey = keypair.privateKeyArmored;
            var pubkey = keypair.publicKeyArmored;

            return keypair;
        }).catch(function (error) {
            // failure
            return false;
        });

    }


    function encrypt(key, data) {
        var publicKey = openpgp.key.readArmored(key);

        return openpgp.encryptMessage(publicKey.keys, data).then(function (pgpMessage) {
            // success
            return pgpMessage;

        }).catch(function (error) {
            // failure
            return error;
        });

    }


    function decrypt(key, passphrase, pgpMessage) {
        var privateKey = openpgp.key.readArmored(key).keys[0];

        privateKey.decrypt(passphrase);

        pgpMessage = openpgp.message.readArmored(pgpMessage);

        return openpgp.decryptMessage(privateKey, pgpMessage).then(function (plaintext) {
            return plaintext;
        }).catch(function (error) {
            // failure
            return error;
        });

    }


    // data format: string
    // key format:  string
    // returns base64 string
    function AESEncrypt(data, key) {
        if (!data || !key) return null;

        var iv = asmCrypto.bytes_to_hex(window.crypto.getRandomValues(new Uint8Array(8)));

        return asmCrypto.bytes_to_base64(asmCrypto.AES_CBC.encrypt(iv + data, key, true));

    };

    // data format: base64 string
    // key format: string
    function AESDecrypt(data, key, version) {
        if (!data || !key) return null;

        var raw_data = atob(data);
        var iv = raw_data.substring(0, 16);
        var ciphertext = raw_data.substring(16);
        var decrypted = null;

        try {
            decrypted = asmCrypto.bytes_to_string(asmCrypto.AES_CBC.decrypt(ciphertext, key, version != 1, iv));
        } catch (err) {
            // console.error(data, key, version);
            // console.error(err.name + ': "' + err.message + '" occurred');
        }

        // Strip null bytes from the end if no padding
        if (version == 1) {
            decrypted = decrypted.replace(/\0+$/, '');
        }

        return decrypted;
    }

    // returns 32 bytes key
    function generate_key() {
        return asmCrypto.bytes_to_hex(window.crypto.getRandomValues(new Uint8Array(16)));
    };

    function generate_pbkdf(data) {
        var iterations = 20000;
        var salt = window.crypto.getRandomValues(new Uint8Array(16));

        var hash_key = asmCrypto.PBKDF2_HMAC_SHA256.hex(data, salt, iterations, 16);

        var result = {
            iterations: iterations,
            salt: asmCrypto.bytes_to_base64(salt),
            hash: hash_key,
        }

        return result;

    };

    function get_pbkdf(data, salt, iterations) {
        var salt = asmCrypto.base64_to_bytes(salt);

        var hash_key = asmCrypto.PBKDF2_HMAC_SHA256.hex(data, salt, iterations, 16);

        return hash_key

    };

    function unlockUser(password, user) {
        var deferred = $q.defer();

        //check if user
        if (user == null || angular.isUndefined(user)) {
            deferred.reject("User still loading!");
        } else {
            //check if password
            if (password == "" || angular.isUndefined(password)) {
                deferred.reject("Password required!");
            } else {

                try {
                    //we can contiune unlock process if all paramaters OK
                    var pbkdf_pass = get_pbkdf(password, user.master_key_salt, user.master_key_iterations);
                    var master_key = AESDecrypt(user.master_key, pbkdf_pass, user.meta.version);

                    // Check migration
                    if(user.migration_status == 'completed') {
                        var pbkdf_pass_old = get_pbkdf(password, user.master_key_salt_old, user.master_key_iterations_old);
                        var master_key_old = AESDecrypt(user.master_key_old, pbkdf_pass_old, user.meta.version_old);
                    }
                    else {
                        var master_key_old = null;
                    }
                }
                catch(error) {
                    deferred.reject(error.message || error);
                }

                if (master_key != null) {

                    var base_security_object = {
                        master_key: master_key,
                        master_key_old: master_key_old
                    }

                    instantMemory.setValue('base_security', base_security_object);
                    deferred.resolve(base_security_object);

                    updateUnlockStatus();
                }
                else {
                    deferred.reject("Wrong password");
                }
            }
        }

        return deferred.promise;
    }
}
coreSecurity.$inject = ["$q", "instantMemory"];

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.UserPreferencesService
 * @description
 * # UserPreferencesService
 * Service in the gatehubClientApp.
 */
angular
    .module('gatehubClientApp')
    .factory('UserPreferencesService', UserPreferencesService)
    .run(["UserPreferencesService", function (UserPreferencesService) { }]);

UserPreferencesService.$inject = ['$q', 'Auth', 'IDRestangular', '$exceptionHandler'];

function UserPreferencesService($q, Auth, IDRestangular, $exceptionHandler) {

    var userPreferences = null;
    var userId = null;

    var SUPPORTED_KEYS = ['currencyOrder', 'customMarkets', 'customRatePairs'];

    var factory = {
        getUserPreferences: getUserPreferences,
        updateUserPreferences: updateUserPreferences
    };

    getUserPreferences();

    return factory;


    ///////////////////////////////////////////////////////////

    function getUserPreferences(refresh) {

        var deferred = $q.defer();

        if (userPreferences && !refresh) {
            deferred.resolve(userPreferences);
        }
        else {
            Auth.getProfile().then(function(user) {
                userId = user.id;

                IDRestangular.one('users', userId).one('userConfig').get().then(function(data) {
                    if (!data.user_config) {
                        userPreferences = {
                            currencyOrder: [],
                            customMarkets: [],
                            customRatePairs: [],
                            customConsents: []
                        };
                    }
                    else {
                        userPreferences = data.user_config;
                    }
                    deferred.resolve(userPreferences);
                }, function(error) {
                    $exceptionHandler('Failed to get user config', error);
                    deferred.reject(error);
                });

            }, function(error) {
                deferred.reject(error);
            });

        }

        return deferred.promise;
    };

    function updateUserPreferences(key, data) {
        var deferred = $q.defer();

        if (SUPPORTED_KEYS.indexOf(key) === -1) {
            deferred.reject('Unsupported key', key);
        }

        else {
            if (userPreferences) {
                userPreferences[key] = data;

                const payload = { };
                SUPPORTED_KEYS.forEach(supportedKey => {
                    if (supportedKey === key) {
                        payload[key] = data;
                    }
                    else {
                        payload[supportedKey] = userPreferences[supportedKey];
                    }
                });

                IDRestangular.one('users', userId).one('userConfig')
                .customPUT(payload)
                .then(deferred.resolve)
                .catch(function(error) {
                    $exceptionHandler('Failed to save user config', error);
                    deferred.reject(error);
                });
            }

            else {
                getUserPreferences().then(function() {
                    updateUserPreferences(key, data)
                        .then(deferred.resolve)
                        .catch(deferred.reject);
                })
                .catch(function() { })
            }
        }


        return deferred.promise;
    }
};

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.PayStringService
 * @description
 * # PayStringService
 * Service in the gatehubClientApp.
 */
angular
    .module('gatehubClientApp')
    .factory('PayStringService', PayStringService);

PayStringService.$inject = ['ENV', 'PaystringRestangular'];

function PayStringService(ENV, PaystringRestangular) {

    // Import xrp Address codec
    var XCodec = require('xrpl-tagged-address-codec');
    var gatehubPayStringDomain = generatePayStringDomain() ;

    var factory = {
        getPayStringDomain: getPayStringDomain,
        resolvePayString: resolvePayString,
        decodeXrpAddress: decodeXrpAddress
    };

    return factory;

    ///////////////////////////////////////////////////////////

    function getPayStringDomain() {
        return gatehubPayStringDomain;
    }

    function generatePayStringDomain() {
        var envPrefix = '';
            switch(ENV.name) {
                case 'staging':
                case 'development':
                    envPrefix = ".staging";
                    break;
                case 'sandbox':
                    envPrefix = ".sandbox";
                    break;
            }

        return 'paystring' + envPrefix + '.gatehub.net';
    }

    function resolvePayString(payString) {
        return PaystringRestangular.one(payString).get()
    }

    function decodeXrpAddress(addressInfo) {

        var rTypeRegex = /^r[A-Za-z0-9]{24,34}$/;
        if (rTypeRegex.test(addressInfo.address)) {
            // format output to match the decode object
            return {
                account: addressInfo.address,
                tag: addressInfo.tag || ''
            };
        }

        else {
            try {
                return XCodec.Decode(addressInfo.address);
            } catch (error) {
                console.error('Bad address');
                return null;
            }
        }
    }
};

// 


'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.TrackingService
 * @description
 * # TrackingService
 * Factory in the gatehubClientApp
 * Custom tracking service, for emitting custom events to Google Tag Manager, like modal opens/closes, button clicks...
 */
angular.module('gatehubClientApp')
  .factory('TrackingService', TrackingService);

  function TrackingService($window, $location) {

    var factory = {
      emitRouteChangeEvent: emitRouteChangeEvent,
      // emitButtonClick: emitButtonClick // example for future if needed
    }

    function emitRouteChangeEvent(URI) {
      // GTM
		  var dataLayer = $window.dataLayer || [];
        dataLayer.push({
          event: 'ngRouteChange',
          attributes: {
            route: URI
          }
        });
    }

    return factory;
  }
  TrackingService.$inject = ["$window", "$location"];

'use strict';

angular.module('gatehubClientApp')
    .factory('NonstandardCurrencies', NonstandardCurrencies);

function NonstandardCurrencies() {

    var factory = {
        xrplCurrencyCodeRegex: /^([A-Fa-f0-9]{40}|[a-zA-Z0-9?!@#$%^&*<>(){}|[\]]{3})$/,
        parseAssetCode: parseAssetCode,
        encodeAssetCode: encodeAssetCode
    };

    return factory;

    function parseAssetCode(inputString, appendHexCodeIfNonstandard) {
        if(!inputString) {
            return;
        }

        let assetCode = inputString.toString().trim();
        // normal currency code
        if (assetCode.length !== 40) {
            return assetCode;
        }

        // take only printable characters from nonstandard currency code
        var outputString = '';
        for (var n = 0; n < assetCode.length; n += 2) {
            var hexCode = parseInt(assetCode.substr(n, 2), 16);
            if (hexCode > 32 && hexCode < 127) {
                outputString += String.fromCharCode(hexCode);
            }
        }

        // if the printable part of the currency code is not at least 3 chars long, add questionmarks until it is
        while (outputString.length < 3) {
            outputString += '?';
        }

        if (appendHexCodeIfNonstandard) {
            outputString += ' - ' + assetCode;
        }

        return outputString;
    }

    function encodeAssetCode(inputString) {
        let assetCode = inputString.trim();
        if (assetCode.length < 3) {
            throw new Error('Standard currency code must have 3 characters.');
        }
        // normal or already encoded currency code
        if (factory.xrplCurrencyCodeRegex.test(assetCode)) {
            return assetCode;
        }

        // nonstandard currency code must be 40 characters
        if (assetCode.length > 20) {
            throw new Error('Non standard asset codes must have at most 20 characters.');
        }

        var hexString = '';
        var i = 0;
        while (hexString.length < 40) {
            if (i < assetCode.length) {
                hexString += assetCode.charCodeAt(i).toString(16);
                i++;
            }
            else {
                hexString += "00";
            }
        }

        return hexString.toUpperCase();
    }

}

'use strict';

/**
* @ngdoc service
* @name gatehubClientApp.CoreRestangular
* @description
* # CoreRestangular
* Factory in the gatehubClientApp.
*/
angular.module('gatehubClientApp')
  .factory('CoreRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
      return Restangular.withConfig(function(RestangularConfigurer) {
        RestangularConfigurer.setBaseUrl(ENV.apiCoreV1);
      });
  }]);
'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.IDRestangular
 * @description
 * # IDRestangular
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
    .factory('IDRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
        return Restangular.withConfig(function(RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(ENV.apiIdV1);
        });
    }]);


'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.StripeRestangular
 * @description
 * # StripeRestangular
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
    .factory('StripeRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
        return Restangular.withConfig(function(RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(ENV.apiStripe);
        });
    }]);


'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.storageRestangular
 * @description
 * # storageRestangular
 * Factory in the gatehubClientApp.
 */

angular.module('gatehubClientApp')
    .factory('StorageRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
        return Restangular.withConfig(function(RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(ENV.apiStorage);
        });
    }]);

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.EventRestangular
 * @description
 * # EventRestangular
 * Factory in the gatehubClientApp.
 */

angular.module('gatehubClientApp')
    .factory('EventRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
        return Restangular.withConfig(function(RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(ENV.apiEventstore);
        });
    }]);

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.InterledgerRestangular
 * @description
 * # InterledgerRestangular
 * Factory in the gatehubClientApp.
 */

angular.module('gatehubClientApp')
    .factory('InterledgerRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
        return Restangular.withConfig(function(RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(ENV.apiInterledger);
        });
    }]);

angular.module('gatehubClientApp')
    .factory('IlpRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
        return Restangular.withConfig(function(RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(ENV.apiILP);
        });
    }]);

angular.module('gatehubClientApp')
    .factory('CurrencyConverterRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
        return Restangular.withConfig(function(RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(ENV.apiCurrencyConverter);
        });
    }]);

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.AuthRestangular
 * @description
 * # AuthRestangular
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
  .factory('AuthRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
      return Restangular.withConfig(function(RestangularConfigurer) {
        RestangularConfigurer.setBaseUrl(ENV.apiAuth);
      });
  }]);

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.AuthRestangularV2
 * @description
 * # AuthRestangularV2
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
  .factory('AuthRestangularV2', ["Restangular", "ENV", function (Restangular, ENV) {
      return Restangular.withConfig(function(RestangularConfigurer) {
        RestangularConfigurer.setBaseUrl(ENV.apiAuthV2);
      });
  }]);

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.OAuthRestangular
 * @description
 * # OAuthRestangular
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
  .factory('OAuthRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
      return Restangular.withConfig(function(RestangularConfigurer) {
        RestangularConfigurer.setBaseUrl(ENV.apiOAuth);
      });
  }]);

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.tokenrestangular
 * @description
 * # idrestangular
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
  .factory('TokenRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
      return Restangular.withConfig(function(RestangularConfigurer) {
        RestangularConfigurer.setBaseUrl(ENV.apiAuth);
      });
  }]);

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.MigrationRestangular
 * @description
 * # MigrationRestangular
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
    .factory('MigrationRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
        return Restangular.withConfig(function(RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(ENV.migrationAPI);
        });
    }]);

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.EthRestangular
 * @description
 * # EthRestangular
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
  .factory('EthRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
      return Restangular.withConfig(function(RestangularConfigurer) {
        RestangularConfigurer.setBaseUrl(ENV.ethApi);
      });
  }]);

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.RepRestangular
 * @description
 * # RepRestangular
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
  .factory('RepRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
    return Restangular.withConfig(function(RestangularConfigurer) {
      RestangularConfigurer.setBaseUrl(ENV.repApi);
    });
  }]);

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.EtcRestangular
 * @description
 * # EtcRestangular
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
  .factory('EtcRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
      return Restangular.withConfig(function(RestangularConfigurer) {
        RestangularConfigurer.setBaseUrl(ENV.etcApi);
      });
  }]);

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.BtcRestangular
 * @description
 * # BtcRestangular
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
  .factory('BtcRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
    return Restangular.withConfig(function(RestangularConfigurer) {
      RestangularConfigurer.setBaseUrl(ENV.btcApi);
    });
  }]);

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.EtcRestangular
 * @description
 * # EtcRestangular
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
  .factory('BchRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
      return Restangular.withConfig(function(RestangularConfigurer) {
        RestangularConfigurer.setBaseUrl(ENV.bchApi);
      });
  }]);

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.DshRestangular
 * @description
 * # DshRestangular
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
  .factory('DshRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
    return Restangular.withConfig(function(RestangularConfigurer) {
      RestangularConfigurer.setBaseUrl(ENV.dshApi);
    });
  }]);

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.LtcRestangular
 * @description
 * # LtcRestangular
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
  .factory('LtcRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
    return Restangular.withConfig(function(RestangularConfigurer) {
      RestangularConfigurer.setBaseUrl(ENV.ltcApi);
    });
  }]);

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.ShadowRestangular
 * @description
 * # ShadowRestangular
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
    .factory('ShadowRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
        return Restangular.withConfig(function(RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(ENV.shadowApi);
        });
    }]);


'use strict';

/**
* @ngdoc service
* @name gatehubClientApp.CoreRestangular
* @description
* # CoreRestangular
* Factory in the gatehubClientApp.
*/
angular.module('gatehubClientApp')
  .factory('MultisigRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
      return Restangular.withConfig(function(RestangularConfigurer) {
        RestangularConfigurer.setBaseUrl(ENV.apiMultisig);
      });
  }]);

'use strict';

/**
* @ngdoc service
* @name gatehubClientApp.XrpForensicsRestangular
* @description
* # XrpForensicsRestangular
* Factory in the gatehubClientApp.
*/
angular.module('gatehubClientApp')
  .factory('XrpForensicsRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
    return Restangular.withConfig(function(RestangularConfigurer) {
      RestangularConfigurer.setBaseUrl(ENV.xrpfApi);
    });
  }]);
'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.RatesRestangular
 * @description
 * # RatesRestangular
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
  .factory('RatesRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
    return Restangular.withConfig(function(RestangularConfigurer) {
      RestangularConfigurer.setBaseUrl(ENV.apiRates);
    });
  }]);

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.EthRestangular
 * @description
 * # FlrRestangular
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
  .factory('FlrRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
      return Restangular.withConfig(function(RestangularConfigurer) {
        RestangularConfigurer.setBaseUrl(ENV.flrApi);
      });
  }]);

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.EthRestangular
 * @description
 * # EthRestangular
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
  .factory('SgbRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
      return Restangular.withConfig(function(RestangularConfigurer) {
        RestangularConfigurer.setBaseUrl(ENV.sgbApi);
      });
  }]);

'use strict';

/**
* @ngdoc service
* @name gatehubClientApp.paystringRestangular
* @description
* # paystringRestangular
* Factory in the gatehubClientApp.
*/
angular.module('gatehubClientApp')
  .factory('PaystringRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
    return Restangular.withConfig(function(RestangularConfigurer) {
      RestangularConfigurer.setBaseUrl(ENV.paystringApi);
    });
  }]);

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.UsdtRestangular
 * @description
 * # UsdtRestangular
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
  .factory('UsdtRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
      return Restangular.withConfig(function(RestangularConfigurer) {
        RestangularConfigurer.setBaseUrl(ENV.usdtApi);
      });
  }]);

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.usdcRestangular
 * @description
 * # usdcRestangular
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
  .factory('UsdcRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
      return Restangular.withConfig(function(RestangularConfigurer) {
        RestangularConfigurer.setBaseUrl(ENV.usdcApi);
      });
  }]);

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.wxrpRestangular
 * @description
 * # wxrpRestangular
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
  .factory('WxrpRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
      return Restangular.withConfig(function(RestangularConfigurer) {
        RestangularConfigurer.setBaseUrl(ENV.wxrpApi);
      });
  }]);

'use strict';

/**
 * @ngdoc service
 * @name gatehubClientApp.galaRestangular
 * @description
 * # galaRestangular
 * Factory in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
  .factory('GalaRestangular', ["Restangular", "ENV", function (Restangular, ENV) {
      return Restangular.withConfig(function(RestangularConfigurer) {
        RestangularConfigurer.setBaseUrl(ENV.galaApi);
      });
  }]);

'use strict';

/**
 * @ngdoc directive
 * @name gatehubClientApp.directive:passwordEnter
 * @description
 * # passwordEnter
 */

angular.module('gatehubClientApp').component('passwordEnter', {
    templateUrl: 'views/partials/passwordEnter.html',
    bindings: {
        requireSecretsForWallet: '<?', // applied in HTML only, where controller expects secrets as payload with unlock event
        requireTwofa: '@?', // TODO: add where not only password

        typeTwofa: '<?',
        phoneNumber: '<?',

        onCheck: "&"
    },
    controller: passwordEnterController,
    controllerAs: 'vm'
});

passwordEnterController.$inject = ['Auth', 'coreSecurity', 'RippleTx', 'Restangular', '$exceptionHandler', '$scope', '$timeout']
function passwordEnterController(Auth, coreSecurity, RippleTx, Restangular, $exceptionHandler, $scope, $timeout) {
    var vm = this;

    var masterLocked = !coreSecurity.isMasterUnlocked();
    var requireSecretsForWallet = false;
    var requireTwofa = false;

    // template
    vm.errorMessage = null;
    vm.unlockMasterKey = unlockMasterKey;
    vm.$onChanges = onChanges;
    vm.check2fa = check2fa;
    vm.checkForEnter = checkForEnter;

    // ------------------------------------ functions ------------------------------------

    function onChanges(changes) {

        requireTwofa = !angular.isUndefined(vm.requireTwofa);
        requireSecretsForWallet = !angular.isUndefined(vm.requireSecretsForWallet);

        if (masterLocked) {
            vm.step = 1;
        } else if (requireTwofa || requireSecretsForWallet) {
            checkIfAlreadyAuthorized();
        }

        // --- If wallets changed (via wallet selector) proceed here --- //
        if(!changes.requireSecretsForWallet) {
            return;
        }
        var currentWallet = changes.requireSecretsForWallet.currentValue;
        var previousWallet = changes.requireSecretsForWallet.previousValue;
        if (currentWallet && previousWallet && currentWallet.address !== previousWallet.address) {
            // Wallet was changed! Reset errors and check lock status!
            vm.errorMessage = null; // reset errors
            if (masterLocked) {
                vm.step = 1; // enter password
            } else {
                vm.step = 2; // just go to 2fa screen (new flow)
            }
        }
    }

    function checkIfAlreadyAuthorized() {
        Restangular.one('user/secret2fa/authorize').customPOST()
            .then(function(){
                coreSecurity.set2FaAuthorized(true); // set for faster UX
                if (requireTwofa) {
                    $scope.$emit('2fa_authorized'); // already authorized
                    return;
                }
                if (requireSecretsForWallet) {
                    getWalletSecrets();
                    return;
                }
            }, function(error) {
                vm.step = 2; // just go to 2fa screen
                return;
            });
    }

    function unlockMasterKey() {
        vm.onCheck();

        Auth.getProfile().then(function(user) {
            coreSecurity.unlockUser(vm.password, user).then(function() {
                vm.errorMessage = null;
                $scope.$emit('master_unlocked');

                if (requireTwofa || requireSecretsForWallet) {
                    checkIfAlreadyAuthorized();
                }

            }, function(error) {
                vm.errorMessage = error;
            });
        }, function(error) {
            $exceptionHandler(error);
        });
    }

    function check2fa() {
        if (vm.code2fa && /\d{6}/.test(vm.code2fa)) {
            authorize2fa();
        } else {
            vm.errorMessage = null;
        }
    }

    function checkForEnter(event) {
        if (event.keyCode === 13) {
            unlockMasterKey();
        }
    }

    function authorize2fa() {
        vm.onCheck();

        return Restangular.one('user/secret2fa/authorize')
            .customPOST({ token2fa: vm.code2fa })
            .then(function() {
                coreSecurity.set2FaAuthorized(true); // set for faster UX
                if (requireTwofa) {
                    $scope.$emit('2fa_authorized');
                } else if (requireSecretsForWallet) {
                    getWalletSecrets();
                } else {
                    console.error("Code should never reach here");
                    $exceptionHandler("UNEXPECTED_2FA_ERROR");
                }
            }, function(error) {
                handle2faError(error);
            });
    }

    function getWalletSecrets() {
        return RippleTx.getSecrets(vm.requireSecretsForWallet).then(function(secrets) {
            $scope.$emit('2fa_authorized', secrets);
        }, function(error) {
            if (error.status === 403 && error.data.message && error.data.message.toLowerCase() === '2fa required') {
                vm.step = 2; // await 2FA input
            } else {
                $exceptionHandler(error);
            }
        });
    }

    function handle2faError(error) {
        if (error && error.data) {
            if (error.data.error === '2fa_wrong_token') {
                vm.errorMessage = "Provided verification code is not valid.";
            } else if (error.data.error === '2fa_expired_token') {
                vm.errorMessage = "Provided verification code has expired.";
            } else if (error.data.error === 'code_already_used') {
                vm.errorMessage = "Entered 2FA code was already used.";
            } else {
                vm.errorMessage = "2fa authentication error.";
                $exceptionHandler(error);
            }
        } else {
            vm.errorMessage = "2fa authentication error.";
            $exceptionHandler("OTHER_2FA_ERROR", error);
        }

        $timeout(function() {
            var focusElement = document.getElementById('code2fa');
            if (focusElement) {
                focusElement.focus();
                focusElement.select();
            }
        }, 1000);
    }

}

'use strict';

/**
 * @ngdoc directive
 * @name gatehubClientApp.directive:validators
 * @description
 * # validators
 */
angular.module('gatehubClientApp')
    .directive('rpAddress', function () {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function (scope, elm, attr, ctrl) {
                if (!ctrl) return;

                var validator = function(value) {
                    if (value && !ripple.UInt160.is_valid(value)) {
                        ctrl.$setValidity('rpAddress', false);
                        return;
                    }

                    ctrl.$setValidity('rpAddress', true);
                    return value;
                };

                ctrl.$formatters.push(validator);
                ctrl.$parsers.unshift(validator);

                attr.$observe('rpAddress', function() {
                    validator(ctrl.$viewValue);
                });
            }
        };
    })
    .directive('rpMasterKey', function () {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function (scope, elm, attr, ctrl) {
                if (!ctrl) return;

                var validator = function(value) {
                    if (value && !ripple.Base.decode_check(33, value)) {
                        ctrl.$setValidity('rpMasterKey', false);
                        return;
                    }

                    ctrl.$setValidity('rpMasterKey', true);
                    return value;
                };

                ctrl.$formatters.push(validator);
                ctrl.$parsers.unshift(validator);

                attr.$observe('rpMasterKey', function() {
                    validator(ctrl.$viewValue);
                });
            }
        };
    })
    .directive('rpStdt', function () {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function (scope, elm, attr, ctrl) {
                if (!ctrl) return;

                var validator = function(value) {
                    if (!value || (!isNaN(parseFloat(value)) && isFinite(value) && value >= 0 && value < Math.pow(2,32) - 1)) {
                        ctrl.$setValidity('rpStdt', true);
                        return value;
                    } else {
                        ctrl.$setValidity('rpStdt', false);
                        return;
                    }
                };

                ctrl.$formatters.push(validator);
                ctrl.$parsers.unshift(validator);

                attr.$observe('rpStdt', function() {
                    validator(ctrl.$viewValue);
                });
            }
        };
    })
    .directive('validateName', function() {
        return {
            restrict: 'A',
            require: '?ngModel',

            link: function(scope, elem, attr, ngModel) {
                var validator = function(value) {
                    if (/^[a-žA-Ž'\s]+$/.test(value)) {
                        ngModel.$setValidity('validatename', true);
                        return value;
                    } else {
                        ngModel.$setValidity('validatename', false);
                        return undefined;
                    }
                };
                ngModel.$parsers.unshift(validator);
                ngModel.$formatters.unshift(validator);
            }
        };
    })
    .directive('validateGatehubName', function() {
        return {
            restrict: 'A',
            require: '?ngModel',

            link: function(scope, elem, attr, ngModel) {
                var validator = function(value) {
                    if (isGatehubName('+'+value)) {
                        ngModel.$setValidity('gatehubName', true);
                        return value;
                    } else {
                        ngModel.$setValidity('gatehubName', false);
                        return undefined;
                    }
                };
                ngModel.$parsers.unshift(validator);
                ngModel.$formatters.unshift(validator);
            }
        };
    })
    .directive('validateBic', function() {
        return {
            restrict: 'A',
            require: '?ngModel',

            link: function(scope, elem, attr, ngModel) {
                var validator = function(value) {
                    if (isBIC(value)) {
                        ngModel.$setValidity('BIC', true);
                        return value;
                    } else {
                        ngModel.$setValidity('BIC', false);
                        return undefined;
                    }
                };
                ngModel.$parsers.unshift(validator);
                ngModel.$formatters.unshift(validator);
            }
        };
    })
    .directive('ghEthereum', function() {
        return {
            restrict: 'A',
            require: '?ngModel',

            link: function(scope, elem, attr, ngModel) {
                var validator = function(value) {
                    if (/^0x[0-9a-f]{40}$/i.test(value)) { // check if ethereum address is valid
                        if (/^0x1d2C3D49460D34739809a096cC05832A0A3d79eE$/i.test(value)) { // do not allow quantum coin swap address anymore (since 26.06.2018)
                            ngModel.$setValidity('coinswap', false);
                            ngModel.$setValidity('ethereum', true);
                            return undefined;
                        } else {
                            ngModel.$setValidity('coinswap', true);
                            ngModel.$setValidity('ethereum', true);
                            return value;
                        }
                    } else {
                        ngModel.$setValidity('coinswap', true); // this is actually false, but we don't want to display the coin swap message here
                        ngModel.$setValidity('ethereum', false);
                        return undefined;
                    }
                };
                ngModel.$parsers.unshift(validator);
                ngModel.$formatters.unshift(validator);
            }
        };
    })
    .directive('ghBitcoin', ["ENV", function(ENV) {
        return {
            restrict: 'A',
            require: '?ngModel',

            link: function(scope, elem, attr, ngModel) {
                var validator = function(value) {

                    if(ENV.name === 'production'){

                        var strippedValue = stripRippleAddress(value),
                            address = ripple.UInt160.from_json(strippedValue);

                        if (typeof strippedValue !== 'string'
                            || (strippedValue.length && strippedValue[0] !== 'r')) {
                            address = ripple.UInt160.from_json();
                        }

                        if (!isNaN(ripple.Base.decode_check([0, 5], strippedValue, 'bitcoin'))) {
                            ngModel.$setValidity('bitcoin', true);
                            return value;
                        } else {
                            ngModel.$setValidity('bitcoin', false);
                            return undefined;
                        }

                    } else { // on staging allow also TESTNET addresses, starting with digit "2" or letters "m", "n", "t"

                        if (/^[1-3mnt][a-km-zA-HJ-NP-Z1-9]{25,49}$/.test(value)) {
                            ngModel.$setValidity('bitcoin', true);
                            return value;
                        } else {
                            ngModel.$setValidity('bitcoin', false);
                            return undefined;
                        }

                    }

                };
                ngModel.$parsers.unshift(validator);
                ngModel.$formatters.unshift(validator);
            }
        };
    }])
    .directive('ghBitcoincash', ["ENV", function(ENV) {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function(scope, elem, attr, ngModel) {
                var validator = function(value) {

                    var isValidBchAddress = bchaddr.isValidAddress;
                    var isMainnetAddress = bchaddr.isMainnetAddress;
                    var isTestnetAddress = bchaddr.isTestnetAddress;
                    if (isValidBchAddress(value)) {
                        ngModel.$setValidity('bitcoincash', true);
                        if(ENV.name === 'production'){
                            if(isMainnetAddress(value)){
                                ngModel.$setValidity('bitcoincashmainnet', true);
                                return value;
                            } else {
                                ngModel.$setValidity('bitcoincashmainnet', false);
                                return undefined;
                            }
                        } else {
                            if(isTestnetAddress(value)){
                                ngModel.$setValidity('bitcoincashtestnet', true);
                                return value;
                            } else {
                                ngModel.$setValidity('bitcoincashtestnet', false);
                                return undefined;
                            }
                        }
                    } else {
                        ngModel.$setValidity('bitcoincash', false);
                        return undefined;
                    }
                };
                ngModel.$parsers.unshift(validator);
                ngModel.$formatters.unshift(validator);
            }
        };
    }])
    .directive('ghDash', ["ENV", function(ENV) {
        return {
            restrict: 'A',
            require: '?ngModel',

            link: function(scope, elem, attr, ngModel) {
                var validator = function(value) {
                    if(ENV.name === 'production'){
                        if (/^(X|7)[0-9a-zA-Z]{33}$/i.test(value)) {
                            ngModel.$setValidity('dash', true);
                            return value;
                        } else {
                            ngModel.$setValidity('dash', false);
                            return undefined;
                        }
                    } else {
                        if (/^(y|X|7)[0-9a-zA-Z]{33}$/i.test(value)) {
                            ngModel.$setValidity('dash', true);
                            return value;
                        } else {
                            ngModel.$setValidity('dash', false);
                            return undefined;
                        }
                    }
                };
                ngModel.$parsers.unshift(validator);
                ngModel.$formatters.unshift(validator);
            }
        };
    }])
    .directive('ghLitecoin', ["ENV", function(ENV) {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function(scope, elem, attr, ngModel) {
                var validator = function(value) {
                    if(ENV.name === 'production'){
                        if (/^[LM3][a-km-zA-HJ-NP-Z1-9]{26,33}$/.test(value)) {
                            ngModel.$setValidity('litecoin', true);
                            return value;
                        } else {
                            ngModel.$setValidity('litecoin', false);
                            return undefined;
                        }
                    } else {
                        if (/^Q[a-km-zA-HJ-NP-Z1-9]{26,33}$/.test(value)) {
                            ngModel.$setValidity('litecoin', true);
                            return value;
                        } else {
                            ngModel.$setValidity('litecoin', false);
                            return undefined;
                        }
                    }
                };
                ngModel.$parsers.unshift(validator);
                ngModel.$formatters.unshift(validator);
            }
        };
    }])
    .directive('countTo', ['$timeout','$filter', function ($timeout, $filter) {
        return {
            replace: false,
            scope: true,
            link: function (scope, element, attrs) {

                var e = element[0];
                var num, refreshInterval, duration, steps, step, countTo, value, increment;

                var calculate = function () {
                    refreshInterval = 30;
                    step = 0;
                    scope.timoutId = null;
                    countTo = parseFloat(attrs.countTo).toFixed(2) || 0;
                    scope.value = parseInt(attrs.value, 10) || 0;
                    duration = (parseFloat(attrs.duration) * 1000) || 0;

                    steps = Math.ceil(duration / refreshInterval);
                    increment = ((countTo - scope.value) / steps);
                    num = scope.value;
                }

                var tick = function () {
                    scope.timoutId = $timeout(function () {
                        num += increment;
                        step++;
                        if (step >= steps) {
                            $timeout.cancel(scope.timoutId);
                            num = countTo;
                            // e.textContent = countTo;
                            if(isNaN(countTo)) {
                                e.textContent = 'N/A';
                            } else {
                                e.textContent = $filter('number')(countTo, 2);
                            };
                        } else {
                            // e.textContent = Math.round(num);
                            if(isNaN(countTo)) {
                                e.textContent = 'N/A';
                            } else {
                                e.textContent = $filter('number')(num, 2);
                            };
                            tick();
                        }
                    }, refreshInterval);

                }

                var start = function () {
                    if (scope.timoutId) {
                        $timeout.cancel(scope.timoutId);
                    }
                    calculate();
                    tick();
                }

                attrs.$observe('countTo', function (val) {
                    if (val) {
                        start();
                    }
                });

                attrs.$observe('value', function (val) {
                    start();
                });

                return true;
            }
        }

    }])
    .directive( 'ignoreMouseWheel', ["$rootScope", "$timeout", function( $rootScope, $timeout ) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.bind('mousewheel', function (event) {
                    element.blur();
                    $timeout(function () {
                        element.focus();
                    }, 10);
                });
            }
        }
    }])
    .directive('countryAllowed', ["Countries", function(Countries) {

      function isPhoneAllowed(phone){
        if(phone){
          for(var i = 0; i < Countries.bannedCountries.length; i++){
            if( phone.indexOf(Countries.bannedCountries[i].phonePrefix) > -1 ){
              return false;
            }
          }
        }
        return true;
      }

      return {
        restrict: 'A',
        require: '?ngModel',

        link: function(scope, elem, attr, ngModel) {
          var validator = function(value) {
            if ( isPhoneAllowed(value) ) {
              ngModel.$setValidity('country_allowed', true);
              return value;
            } else {
              ngModel.$setValidity('country_allowed', false);
              return undefined;
            }
          };
          ngModel.$parsers.unshift(validator);
          ngModel.$formatters.unshift(validator);
        }
      };
    }])
    .directive('noPoBoxes', function() {
        return {
            restrict: 'A',
            require: '?ngModel',

            link: function(scope, elem, attr, ngModel) {
                var validator = function(value) {
                    if (/^p\.?\s*o\.?\s*box/i.test(value)) {
                        ngModel.$setValidity('noPoBoxes', false);
                        return value;
                    } else {
                        ngModel.$setValidity('noPoBoxes', true);
                        return value;
                    }
                };
                ngModel.$parsers.unshift(validator);
                ngModel.$formatters.unshift(validator);
            }
        };
    })
    .directive('importBlacklist', function () {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function(scope, elem, attr, ngModel) {
                var validator = function(value) {
                    if (/^snoPBrXtMeMyMHUVTgbuqAfg1SUTb$/.test(value)) { // genesis secret
                        ngModel.$setValidity('blacklisted', false);
                        return;
                    } else {
                        ngModel.$setValidity('blacklisted', true);
                        return value;
                    }
                };
                ngModel.$parsers.unshift(validator);
                ngModel.$formatters.unshift(validator);
            }
        };
    })
    .directive('accountnumber', function () {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function(scope, elem, attr, ngModel) {
                var validator = function(value) {
                    if (/^(\d){8}$/.test(value)) {
                        ngModel.$setValidity('accountnumber', true);
                        return value;
                    } else {
                        ngModel.$setValidity('accountnumber', false);
                        return undefined;
                    }
                };
                ngModel.$parsers.unshift(validator);
                ngModel.$formatters.unshift(validator);
            }
        };
    })
    .directive('sortcode', function () {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function(scope, elem, attr, ngModel) {
                var validator = function(value) {
                    if (/^(?!(?:0{6}|00-00-00))(?:\d{6}|\d\d-\d\d-\d\d)$/.test(value)) {
                        ngModel.$setValidity('sortcode', true);
                        return value;
                    } else {
                        ngModel.$setValidity('sortcode', false);
                        return undefined;
                    }
                };
                ngModel.$parsers.unshift(validator);
                ngModel.$formatters.unshift(validator);
            }
        };
    });
    // TODO-GBP: ukModulus validation directive
    // https://www.npmjs.com/package/uk-modulus-checking
    // new UkModulusChecking({ accountNumber, sortCode }).isValid()

angular.module('gatehubClientApp')
    .directive('fileUploader', ['Settings', 'Upload', 'Auth', '$route', '$timeout', '$exceptionHandler', function (Settings, Upload, Auth, $route, $timeout, $exceptionHandler) {
        return {
            restrict: 'E',
            transclude: true,
            scope: {
                id: '@',
                index: '@',
                source: '=',
                header: '@',
                title: '@',
                onSuccess: '&',
                onUpload: '&',
                uploadOptions: '&',
                small: '@',
                onError: '&',
                errorMessage: '&',
                isMultiple: '@',
                removeItem: '&',
                limit: '@'
            },
            templateUrl: 'views/partials/fileuploader.html',
            link: function (directiveScope, elem, attr) {
                if (!angular.isDefined(directiveScope.id)) {
                    throw Error('ID not defined');
                }
                if (!angular.isDefined(directiveScope.source)) {
                    throw Error('SOURCE not defined');
                }
                if (!angular.isDefined(attr.uploadOptions)) {
                    throw Error('uploadOptions not defined');
                }

                directiveScope.idValid = false;
                directiveScope.isMultiple = (directiveScope.isMultiple == 'true') ? true : false;
                directiveScope.filesRemovable = angular.isDefined(attr.removeItem);
                directiveScope.maxfileSize = Settings.maxFileSize;
                directiveScope.fileLimit = attr.limit ? +attr.limit : 5;

                directiveScope._files = [];
                directiveScope.files = [];
                directiveScope.jobsActive = 0;
                directiveScope.progressTotal = 0;

                directiveScope.showError = function(msg, error) {
                    if (angular.isDefined(attr.errorMessage)) {
                        var errMsg = msg;
                        if (typeof error !== 'undefined') {
                            errMsg += ' ' + error;
                        }
                        directiveScope.errorMessage({msg: errMsg});
                    }
                    if (angular.isDefined(attr.onError)) {
                        directiveScope.onError({id: directiveScope.id, error: error});
                    }
                };

                directiveScope._removeFile = function(index) {
                    if (Array.isArray(directiveScope._files)) {
                        directiveScope._files.splice(index, 1);
                    }
                    else {
                        directiveScope._files = null;
                    }
                    directiveScope.removeItem({index: index, id: directiveScope.id});
                }

                directiveScope.mapID = function (newID) {
                    var key = newID.split('.');
                    directiveScope.files = directiveScope.source;

                    for (var word in key) {
                        if (angular.isDefined(directiveScope.files[key[word]])) {
                            directiveScope.files = directiveScope.files[key[word]];
                        }
                        else {
                            directiveScope.files = null;
                            directiveScope.idValid = false;
                            console.error('Fileuploader id not valid.');
                            return false;
                        }
                    }

                    directiveScope.idValid = true;
                };

                // watch ID change
                directiveScope.$watch(function () {
                    return elem.attr('id');
                }, function (newValue) {
                    directiveScope.mapID(newValue);
                });

                directiveScope.mapID(directiveScope.id);



                function doUpload(options){
                    directiveScope.jobsActive++;

                    Upload.upload(options).then(function (data) { //success
                        directiveScope.jobsActive--;

                        data.file_name = data.config.file.name;
                        if (directiveScope.isMultiple) {
                            directiveScope.files.push(data);
                        }
                        else {
                            if(directiveScope.files.length){
                                directiveScope.files[0] = data;
                            } else {
                                directiveScope.files.push(data);
                            }
                        }

                        if (angular.isDefined(attr.errorMessage)) {
                            directiveScope.errorMessage({msg: ''});
                        }
                        if (angular.isDefined(attr.onSuccess)) {
                            directiveScope.onSuccess({id: directiveScope.id});
                        }
                    }, function (error) {
                        directiveScope.jobsActive--;
                        options.file.progress = -1;

                        _.remove(directiveScope._files, function(file) {
                            return file.progress < 0;
                        })

                        if(error.status === 401){ // refresh token!
                            Auth.refreshToken().then(function (data) {
                                $route.reload();
                                options.headers = { 'Authorization': 'Bearer ' + data.access_token };
                                doUpload(options);
                            }, function (reason) {
                                console.log('error refreshing token');
                                if (reason !== true) {
                                    Auth.redirect();
                                }
                                else {
                                    $timeout(function(){
                                        $route.reload();
                                    }, 1000);
                                }
                            });
                            return;
                        }

                        // temporary fix until storage service is fixed:
                        if(error.status == -1){
                            directiveScope.showError('Image too big. Maximum allowed image resolution is 10328x7760px.');
                            return;
                        }

                        var errorMsg = (error.data !== null) ? error.data.message : '';

                        if(error.data && error.data.code){
                            if (error.data.code === 'IMAGE_SIZE_TOO_SMALL') {
                                directiveScope.showError('Image too small. Minimum allowed image resolution is 300x340px.');
                            }
                            else if (error.data.code === 'IMAGE_SIZE_TOO_BIG') {
                                directiveScope.showError('Image too big. Maximum allowed image resolution is 10328x7760px.');
                            }
                            else {
                                directiveScope.showError('Upload failed!', errorMsg);
                                $exceptionHandler(error);
                            }
                        }
                        else if (error.data && error.data.message === 'WrongMimeType') {
                            directiveScope.showError('Uploaded format not supported.');
                        }
                        else {
                            directiveScope.showError('Upload failed! Refresh page and retry.');
                            $exceptionHandler(error);
                        }

                    }, function (evt) { //progress
                        options.file.progress = evt.loaded / evt.total;

                        var activeUploads = [];
                        if (Array.isArray(directiveScope._files)) {
                            activeUploads = _.filter(directiveScope._files, function(file) {
                                return file && file.progress >= 0; // return all un-uploaded files and
                            });
                        }
                        else {
                            activeUploads.push(directiveScope._files);
                        }

                        directiveScope.progressTotal = Math.floor(
                            activeUploads
                            .map(function(file) {
                                return file ? file.progress : 1;
                            })
                            .reduce(function(a, b) {
                                return a + b;
                            }, 0) * 100 / activeUploads.length
                        );
                    });
                }

                directiveScope.upload = function (files, file, newFiles, duplicateFiles, invalidFiles) {
                    // console.log(files, file, newFiles, duplicateFiles, invalidFiles);

                    if (!directiveScope.files && directiveScope.files.$error) {
                        directiveScope.showError('Upload failed!', files.$error);
                        $exceptionHandler(files.$error);
                        return;
                    }

                    var fileError = '';
                    if (invalidFiles.length) {
                        var multiple = newFiles.length > 1;
                        for (var i = 0; i < newFiles.length; i++) {
                            var invalidFile = newFiles[i];
                            switch (invalidFile.$error) {
                                case 'pattern':
                                    fileError = multiple ? 'Format of some files is unsupported.' : 'Uploaded format not supported.';
                                    break;
                                case 'maxWidth':
                                case 'maxHeight':
                                    fileError = multiple ? 'Some files are too big. ' : 'Image too big. ';
                                    fileError += 'Maximum allowed image resolution is 10328x7760px.'
                                    break;
                                case 'minWidth':
                                case 'minHeight':
                                    fileError = multiple ? 'Some files are too small. ' : 'Image too small. ';
                                    fileError += 'Minimum allowed image resolution is 300x340px.'
                                    break;
                                case 'maxSize':
                                    fileError = multiple ? 'Some files are too large. ' : 'File too large. ';
                                    fileError += 'Max file size is ' + (Settings.maxFileSize / 1000000) + 'MB.'
                                    break;
                                case 'maxFiles':
                                    fileError = 'You may upload only ' + directiveScope.fileLimit + ' files at once.';
                                    break;
                                default:
                                    break;
                            }

                            if (fileError) {
                                break;
                            }
                        }
                    }
                    directiveScope.showError(fileError);


                    var f = _.filter(files, function(file) {
                        return file.progress == undefined || file.progress < 0; // return all un-uploaded files and
                    });


                    for (var i = 0; i < f.length; i++) {
                        var options = directiveScope.uploadOptions();
                        options.file = f[i];

                        f[i].progress = 0;

                        doUpload(options);

                        directiveScope.onUpload({ file: f[i] });

                    }

                };
            }
        };
    }]);

'use strict';

/**
 * @ngdoc filter
 * @name gatehubClientApp.filter:rpamount
 * @function
 * @description
 * # rpamount
 * Filter in the gatehubClientApp.
 */
angular.module('gatehubClientApp')
    .filter('rpamount', ["Currencies", function (Currencies) {

        var currencies = Currencies;

        /**
         * Format a ripple.Amount.
         *
         * If the parameter is a number, the number is treated the relative
         */

        return function (input, options) {
            var currency;
            var opts = jQuery.extend(true, {}, options);

            if ('number' === typeof opts) {
                opts = {
                    rel_min_precision: opts
                };
            } else if ('object' !== typeof opts) {
                opts = {};
            }

            if (!input) return "0.0000"; //n/a

            if (opts.xrp_human && input === ("" + parseInt(input, 10))) {
                input += "/XRP";
            }

            var origPrecision = opts.precision;

            // Reference date
            // XXX Should maybe use last ledger close time instead
            if (!opts.reference_date && !opts.no_interest) {
                opts.reference_date = new Date();
            }

            // if hard_precision is true, do not allow precision & min_precision to be overridden
            if (!opts.hard_precision && input._is_native) {
                // If XRP, then set standard precision here
                currency = currencies[0].standard_precision;
                opts.min_precision = currency;
                opts.precision = currency;
            }

            try {
                var amount = Amount.from_json(input);
            }
            catch (e) {
                return "0.0000"
            }

            if (!amount.is_valid()) return "0.0000"; //n/a

            if (opts.force_precision) {
                opts.precision = opts.force_precision;
                return amount.to_human(opts);
            }
            // if abs_precision is passed, bypass entire currency look up (for loop - expensive)
            if (opts.abs_precision) {
                opts.min_precision = opts.abs_precision;
                opts.precision = opts.abs_precision;

                return amount.to_human(opts);
            }

            if (!opts.hard_precision) {
                // Currency default precision
                const currency_human = amount.currency().to_human();
                let found = false; // currency found in currencies.js
                for (var i = 0; i < currencies.length; i++) {
                    if (currencies[i].value === currency_human || currencies[i].xrplHex === currency_human) {
                        found = true;
                        currency = currencies[i].standard_precision;

                        // Default standard precision per currency is taken from currencies.js
                        opts.min_precision = currency;
                        opts.precision = currency;
                        break;
                    }
                }

                // Default standard precision for currencies not in currencies.js
                if (!found) {
                    opts.min_precision = 8;
                    opts.precision = 8;
                }
            }

            var amtHuman = amount.to_human();
            if ((amtHuman < 0.01 && amtHuman > 0) ||
                ("number" === typeof opts.tiny_precision && amtHuman < 0.1)) {
                // We attempt to show the entire number, by setting opts.precision to a high number... 100
                // opts.precision = 100;
                // quick fix. Amount.to_human uses Number.toFixed, which throws RangeError for values larger then 20.
                // opts.precision = 15;
            }

            var cdp = ("undefined" !== typeof currency) ? currency : 4;
            // Certain formatting options are relative to the currency default precision
            if ("number" === typeof opts.rel_precision) {
                opts.precision = cdp + opts.rel_precision;
            }
            if ("number" === typeof opts.rel_min_precision) {
                opts.min_precision = cdp + opts.rel_min_precision;
            }

            // But we will cut off after five significant decimals
            // if ("number" !== typeof opts.max_sig_digits) {
            //   opts.max_sig_digits = 30;
            // }

            var out = amount.to_human(opts);

            // tiny_precision is for tiny numbers e.g a value of 5 would format:
            // 0.000000000012866401 as
            // 0.000000000012866
            if ("number" === typeof opts.tiny_precision) {
                var reformat = false;
                var outs = out.split('.');

                if (+(outs[0].replace(/,/g, '')) >= 1) {
                    // if integer is not zero, format with original precision
                    if (opts.hard_precision) {
                        opts.precision = origPrecision;
                        reformat = true;
                    }
                }
                else {
                    // if integer is zero, format the fraction with tiny_precision number of digits
                    // after any leading zeros
                    var frac = outs[1];

                    if (frac && frac.length > opts.tiny_precision) {
                        var regex = /^0*/;
                        var res = regex.exec(frac);
                        var leadZeros = res[0].length;

                        if (leadZeros) {
                            opts.precision = leadZeros + opts.tiny_precision;
                            reformat = true;
                        }
                    }
                }

                if (reformat) out = amount.to_human(opts);
            }

            // If amount is very small and only has zeros (ex. 0.0000), raise precision
            // to make it useful.
            // if (out.length > 1 && 0 === +out && !opts.hard_precision) {
            //   opts.precision = 5;

            //   out = amount.to_human(opts);
            // }

            return out;
        };

    }]);

/**
 * Get the currency from an Amount or Currency object.
 *
 * If the input is neither an Amount or Currency object it will be passed to
 * Amount#from_json to try to interpret it.
 */
angular.module('gatehubClientApp')
    .filter('rpcurrency', ["Currencies", "NonstandardCurrencies", function (Currencies, NonstandardCurrencies) {

        return function (input, options) {
            if (!input) return "";

            var appendHexCodeIfNonstandard = false;
            if (options === 'APPEND_HEX_IF_NONSTANDARD') {
                appendHexCodeIfNonstandard = true;
            }

            var amount = Amount.from_json(input);
            var currency = amount.currency();
            var currency_human = currency.to_human();

            // DSH -> DASH, etc
            var real_currency_human = _(Currencies).filter({ value: currency_human }).pluck('real_code').value()[0];
            if(real_currency_human){
                return real_currency_human;
            } else {
                return NonstandardCurrencies.parseAssetCode(currency_human, appendHexCodeIfNonstandard);
            }
        };

    }]);

/**
 * Get the currency issuer.
 */
angular.module('gatehubClientApp')
    .filter('rpissuer', function () {
        return function (input) {
            if (!input) return "";

            var amount = Amount.from_json(input);
            if (!amount.is_valid()) return "";
            if (!amount.issuer().is_valid()) return "";
            return amount.issuer().to_json();
        };
    });

/**
 * Get the full currency name from an Amount.
 */
angular.module('gatehubClientApp')
    .filter('rpcurrencyfull', ['$rootScope', function ($scope) {
        return function (input) {
            if (!input) return "";

            var amount = Amount.from_json(input);
            var currency = $.grep($scope.currencies_all, function (e) { return e.value == amount.currency().to_human(); })[0];

            if (currency) {
                return currency.name;
            } else {
                return amount.currency().to_human();
            }
        };
    }]);

/**
 * Calculate a ratio of two Amounts.
 */
angular.module('gatehubClientApp')
    .filter('rpamountratio', function () {
        return function (numerator, denominator) {
            try {
                return Amount.from_json(numerator).ratio_human(denominator, { reference_date: new Date() });
            } catch (err) {
                return Amount.NaN();
            }
        };
    });

/**
 * Calculate the sum of two Amounts.
 */
angular.module('gatehubClientApp')
    .filter('rpamountadd', function () {
        return function (a, b) {
            try {
                b = Amount.from_json(b);
                if (b.is_zero()) return a;
                return Amount.from_json(a).add(b);
            } catch (err) {
                return Amount.NaN();
            }
        };
    });

/**
 * Calculate the difference of two Amounts.
 */
angular.module('gatehubClientApp')
    .filter('rpamountsubtract', function () {
        return function (a, b) {
            try {
                return Amount.from_json(a).subtract(b);
            } catch (err) {
                return Amount.NaN();
            }
        };
    });

/**
 * Get Gateway name
 */
angular.module('gatehubClientApp')
    .filter('nameGateway', ["Gateways", "MarketsService", function (Gateways, MarketsService) {
        var gateways_list = MarketsService.list_gateways();
        return function (address) {
            // Check cold addresses
            for (var i = 0, l = Gateways.length; i < l; i++) {
                if (Gateways[i].accounts[0].address === address) {
                    return Gateways[i].name;
                }
            }
            // Check hot addresses
            for (var i = 0, l = Gateways.length; i < l; i++) {
                if(Gateways[i].hotwallets != undefined && Gateways[i].hotwallets[0] != undefined) {
                    for (var j = Gateways[i].hotwallets.length - 1; j >= 0; j--) {
                        if (Gateways[i].hotwallets[j] == address) {
                            return Gateways[i].name;
                        }
                    }
                }
            }
            // Check custom gateways cold addresses
            for (var i = gateways_list.length - 1; i >= 0; i--) {
                if(gateways_list[i].issuer == address) {
                    return gateways_list[i].name;
                }
            }
            return address
        };
    }]);

/**
 * Get Gateway logo
 */
angular.module('gatehubClientApp')
    .filter('getGatewayLogo', ["Gateways", function (Gateways) {
        return function (address) {
            for (var i = 0, l = Gateways.length; i < l; i++) {
                if (Gateways[i].accounts[0].address === address) {
                    return 'images/gateways/' + Gateways[i].logo;
                }
            }
            return 'images/gateways/logo_ripple_white.png'
        };
    }]);

/**
 * Get Currency name
 */
angular.module('gatehubClientApp')
    .filter('nameCurrency', ["Currencies", function (Currencies) {
        return function (input) {
            var result = _(Currencies).filter({ value: input }).pluck('name').value();
            return result[0];
        };
    }]);

/**
 * Normalize XRP
 */
angular.module('gatehubClientApp')
    .filter('normalizeXRP', ["$localStorage", function ($localStorage) {
        return function (input) {

            if (isNaN(input)) {
                return 0;
            };

            var result = parseFloat(input) / $localStorage.exchangeRates['USD:rhub8VRN55s94qWKDv6jmDy1pUykJzF3wq'];

            return result;
        };
    }]);

/**
 * Number format
 */
angular.module('gatehubClientApp')
    .filter('numberFormat', ["Currencies", function (Currencies) {

        var currencies = Currencies;

        return function (input, options) {

            var custom = false;
            var places = 2;

            input = parseFloat(input);

            if (isNaN(input)) {
                return '';
            };
            if (!Number.isFinite(input)) {
                return '';
            };

            if (typeof options === 'object') {

                var places = false;
                custom = true;

                var currency_exists = false;
                for (var i = currencies.length - 1; i >= 0; i--) {
                    if(currencies[i].value == options.currency) {
                        places = currencies[i].standard_precision;
                        currency_exists = true;
                    }
                }
                if(!currency_exists){
                    console.warn("Currency not found in list!", options.currency);
                    places = 2; // default to 2 places
                }

            }
            else if (typeof options === 'number') {
                places = parseInt(options);
                custom = true;
            }
            else {
                places = 2;
            }

            // Only allow if not custom
            if (input < 10 && !custom) {
                places = 3;
            }

            if (input < 1 && !custom) {
                places = 4;
            }

            if (input < 0.1 && !custom) {
                places = 5;
            }

            if (input < 0.001 && !custom) {
                places = 8;
            };

            var _amount = new Decimal(input);
            var result = _amount.toFixed(places, 1); // Round down

            return _formatNumber(result);
        };
    }]);

function _formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d)\.)/g, "$1,")
};

/**
 * Get Address name
 */
angular.module('gatehubClientApp')
    .filter('nameAddress', ["WalletsService", "AccountsService", "$filter", function (WalletsService, AccountsService, $filter) {
        return function (address, dt) {

            if (!address) {
                return 'Unknown';
            }

            // Check Wallets
            var wallets = WalletsService.getByAddress(address);
            if (typeof wallets !== 'undefined') {
                return wallets.name;
            }

            if (dt) {
                wallets = WalletsService.getByAddress(dt.toString());
                if (typeof wallets !== 'undefined') {
                    return wallets.name;
                }
            }

            // Check Accounts (contacts)
            var accounts = AccountsService.getByAddress(address, dt);
            if (typeof accounts !== 'undefined') {
                return accounts.name;
            }

            var gateway = $filter('nameGateway')(address);
            if (gateway !== address) {
                return gateway;
            }

            // Check Gateways
            return 'Unknown';

            // return address;
        };
    }]);

/**
 * Get Invoice Address name
 */
angular.module('gatehubClientApp')
    .filter('nameInvoiceAddress', ["WalletsService", "AccountsService", function (WalletsService, AccountsService) {
        return function (invoice) {

            // Format Invoice ID to UUID
            invoice = invoice.slice(0, 32).toLowerCase();
            invoice = invoice.replace( /([0-9a-fA-F]{8})([0-9a-fA-F]{4})([0-9a-fA-F]{4})([0-9a-fA-F]{4})([0-9a-fA-F]+)/, '$1-$2-$3-$4-$5' );

            // Check Accounts (contacts)
            var account = AccountsService.getById(invoice);
            if (typeof account !== 'undefined') {
                return account.name;
            }

            return invoice;
        };
    }]);

/**
 * Transactions
 */
angular.module('gatehubClientApp')
    .filter('nameTxType', function () {
        return function (input) {

            var types = [
                { code: 0, name: "Withdrawal" },
                { code: 1, name: "Deposit" },
                { code: 2, name: "Hosted" },
                { code: 3, name: "Trade" },
            ];

            return _.first(_(types).filter({ code: input }).pluck('name').value());

        };
    });

angular.module('gatehubClientApp')
    .filter('nameNetwork', function () {
        return function (input) {

            var types = [
                { code: 0, name: "SEPA" },
                { code: 1, name: "International Wire" },
                { code: 2, name: "Ripple" },
                { code: 3, name: "Bitcoin" },
                { code: 4, name: "GateHub" },
                { code: 5, name: "Ethereum" },
                { code: 6, name: "REP" },
                { code: 7, name: "Mail" },
                { code: 8, name: "Manual" },
                { code: 9, name: "Ethereum Classic" },
                { code: 10, name: "Dash" },
                { code: 11, name: "Quantum" }, // deprecated
                // 12 = geni (deprecated)
                { code: 13, name: "Litecoin" },
                { code: 14, name: "Bitcoin Cash" },
                { code: 15, name: "Flare" },
                { code: 16, name: "Songbird" },
                // 17 = mmaon
                { code: 18, name: "GALA" },
                { code: 19, name: "USDT" },
                { code: 20, name: "USDC" },
                { code: 21, name: "WXRP" },
                { code: 22, name: "Faster Payments" },
                { code: 23, name: "Card" },
            ];

            return _.first(_(types).filter({ code: input }).pluck('name').value());

        };
    });

angular.module('gatehubClientApp')
    .filter('nameTxStatus', function () {
        return function (input) {

            // XRPL
            if(isNaN(input)){
                if(input === 'tesSUCCESS'){
                    return 'Success';
                } else if (input === 'tecINSUF_RESERVE_OFFER') {
                    return "Insufficient reserve";
                } else if (input === 'tecUNFUNDED_PAYMENT') {
                    return "Unfunded payment";
                } else if (input === 'tecUNFUNDED_OFFER') {
                    return "Unfunded offer";
                } else if (input === 'tecNO_LINE_INSUF_RESERVE') {
                    return "Insufficient reserve";
                } else if (input === 'tecKILLED') {
                    return "Offer could not be filled";
                } else {
                    return input;
                }
            }

            // HOSTED
            var types = [
                { code: 0, name: "Pending" },
                { code: 1, name: "Processing" },
                { code: 2, name: "Unmatched" },
                { code: 3, name: "Invitation" },
                { code: 4, name: "Returning" },
                { code: 100, name: "Completed" },
                { code: 101, name: "Failed" },
                { code: 102, name: "User Canceled" },
                { code: 103, name: "Admin Canceled" },
                { code: 104, name: "No Trust" },
                { code: 105, name: "Unprocessable" },
                { code: 106, name: "Returned" },
                { code: 107, name: "Completed" },
            ];

            return _.first(_(types).filter({ code: input }).pluck('name').value());

        };
    });

angular.module('gatehubClientApp')
    .filter('companyTypeByCode', function () {
        return function (input) {

            var types = [
                { k: 0, l: "PLC/AG/SA/Spa/K.K or equivalent" },
                { k: 1, l: "LTD/GmBH/SARL/Srl/G.K. or equivalent" },
                { k: 2, l: "partnership/LLC/KG/SNC/Ss/GMK or equivalent" },
                { k: 3, l: "trusts/funds/associations or equivalent" },
                { k: 4, l: "other, not specified" }
            ];

            return _.first(_(types).filter({ k: input }).pluck('l').value());

        };
    });

angular.module('gatehubClientApp')
    .filter('eventType', function () {
        return function (input) {

            var types = [
                { k: "create", l: "Signin" },
                { k: "update", l: "Password change" }
            ];

            return _.first(_(types).filter({ k: input }).pluck('l').value());

        };
    });

angular.module('gatehubClientApp')
    .filter('purposeByCode', function () {
        return function (input) {

            var types = [
                { k: 0, l: "merchant" },
                { k: 1, l: "broker" },
                { k: 2, l: "arbitrage" },
                { k: 3, l: "trading" },
                { k: 4, l: "hedging" },
                { k: 5, l: "other" }
            ];

            return _.first(_(types).filter({ k: input }).pluck('l').value());

        };
    });

angular.module('gatehubClientApp')
    .filter('dimZeros', function () {

        return function(input, className) {

            var className = className || 'dim-zeros';
            var str = input.toString();
            var trailingZerosRegex = /^(\d+\.\d+?)(0+)$/; // doesn't dim first decimal
            var result = str.replace(trailingZerosRegex, "$1<span class='"+className+"'>$2</span>");

            return result;
        };

    });


/**
 * Display certain 3-letter (mandatory on the Ripple network) currency codes with their real codes (DSH -> DASH, etc.)
 */
angular.module('gatehubClientApp')
.filter('realCurrencyCode', ['Currencies', 'NonstandardCurrencies', function (Currencies, NonstandardCurrencies) {
    return function (input) {
        var real_code = _(Currencies).filter({ value: input }).pluck('real_code').value()[0];
        if(real_code){
            return real_code;
        } else {
            return NonstandardCurrencies.parseAssetCode(input);
        }
    };
}]);

angular.module('gatehubClientApp')
.filter('xrplCurrencyCode', ['Currencies', 'NonstandardCurrencies', function (NonstandardCurrencies) {
    return function (input) {
        return NonstandardCurrencies.encodeAssetCode(input);
    };
}]);

/**
 * Display short version of pricechart interval, for example '1hour' -> '1H'
 */
angular.module('gatehubClientApp')
.filter('priceIntervalFilter', function () {
    return function (input) {
        switch(input){
            // 1minute, 5minute, 15minute, 30minute, 1hour, 2hour, 4hour, 1day, 3day, 7day, or 1month
            case '1minute': return '1m';
            case '5minute': return '5m';
            case '15minute': return '15m';
            case '30minute': return '30m';
            case '1hour': return '1h';
            case '2hour': return '2h';
            case '4hour': return '4h';
            case '1day': return '1d';
            case '3day': return '3d';
            case '7day': return '7d';
            case '1month': return '1M';
        }
    };
});

/* On views cut the special _dxxx or _wxxx suffix from transaction uuids */
angular.module('gatehubClientApp')
.filter('txUuidFilter', function(){
    return function (input) {
        var txUuid = null;
        if(input){
          txUuid = input.replace(/_(w|d)?[0-9]*$/, "");
        }
        return (txUuid) ? txUuid : input;
    };
});

angular.module('gatehubClientApp')
.filter('activeVaults', function(){
    return function (vaults) {
        return _.filter(vaults, function(vault){
            return vault.status === 1;
        });
    };
});

angular.module('gatehubClientApp')
.filter('walletTypeReadable', function () {
    return function (input) {

        var types = {
            '0': 'Hosted',
            '1': 'Ripple Hosted',
            '2': 'Interledger Hosted',
            '10': 'XRP Ledger',
            '11': 'XRP Ledger Imported',
            '20': 'Vault Hot',
            '21': 'Vault Cold',
            '22': 'Vault Hosted',
            '23': 'Vault Fee',
            '24': 'Bank Account'
        };

        return types[input] || 'Unknown';

    };
});



angular.module('gatehubClientApp')
.filter('isoCountryTaiwan', ['Countries', function(Countries){
    var isWaiting = false;
    var countries = null;

    localFilter.$stateful = true;

    function localFilter(input) {

        var displayName = '-';
        if (countries && countries.length) {
            displayName = _(countries).filter(function (t) {
                return t.code === input;
            }).map(function (d) {
                return d.name;
            }).first() || input;
        } else {
            if (isWaiting === false) {
                isWaiting = true;
                Countries.getCountries().then(function (data) {
                    countries = data.allCountries;
                    isWaiting = false;
                });
            }
        }
        return displayName;
    }

    return localFilter;
}]);

angular.module('gatehubClientApp')
.filter('nameOrText', function(){
    return function (input, index) {
        var num = parseInt(index) + 1;
        if(input){
            var result = "";
            if(input.first_name) result += input.first_name + " ";
            if(input.middle_name) result += input.middle_name + " ";
            if(input.last_name) result += input.last_name + " ";
            result = result.trim();

            return (result) ? num + " - " + result : "Person #"+num;
        } else {
            return "Person #"+num;
        }

    };
});

angular.module('gatehubClientApp')
.filter('passwordStrengthHuman', function(){
    return function (input) {
        var statuses = ['Very weak', 'Weak', 'Medium', 'Strong', 'Very strong'];
        return statuses[input];
    };
});

angular.module('gatehubClientApp')
.filter('objectKeyLength', function () {
    return function (input) {
        return (input && typeof input === 'object') ? Object.keys(input).length : 0;
    };
});

angular.module('gatehubClientApp')
.filter('fromMap', function() {
    return function(input) {
      var out = {};
      input.forEach(function(v, k) { out[k] = v });
      return out;
    };
});

angular.module('gatehubClientApp')
.filter('startEndString', function() {
    return function(input, numOfChars, limit) {

        var charLimit;
        if (parseInt(numOfChars)) {
            charLimit = numOfChars;
        }
        else {
            charLimit = 8;
        }

        if (input.length < (limit ? limit : (2 * numOfChars))) {
            return input;
        }

        return (
            input.substring(0, charLimit) + '...' +
            input.substring(input.length, input.length - charLimit)
        );
    };
});


angular.module('gatehubClientApp')
.filter('qrTypes', function () {
    return function (input) {
        var types = [
            {code: 'bcd1', name: 'ECB version 1'},
            {code: 'bcd2', name: 'ECB version 2'},
            {code: 'upnqr', name: 'Slovenian banks standard'}
        ];

        return _(types).filter(function (t) {
            return t.code === input;
        }).map(function (t) {
            return t.name;
        }).first() || input;
    };
});

angular.module('gatehubClientApp')
.filter('snakeToSpacedCase', function () {
    return function (input) {
        return input ? input.replace(/_/g, ' ') : '';
    };
});

angular.module('gatehubClientApp')
.filter('currencyScale', function() {
    return function(input, exponent) {
        return input * Math.pow(10, -exponent);
    }
});

angular.module('gatehubClientApp')
.filter('spacedIban', function() {
    return function(input) {
        if (!input) {
            return;
        }
        return input.replace(/(.{4})/g, '$1 ');
    }
});

angular.module('gatehubClientApp')
.filter('xrplCurrency', ['NonstandardCurrencies', function (NonstandardCurrencies) {
    return function (input) {
        if (!input) {
            return '';
        }
        return NonstandardCurrencies.parseAssetCode(input);
    };
}]);

angular.module('gatehubClientApp')
.filter('isoToLocalTime', function() {
    return function(input) {
        if (!input) {
            return;
        }

        var isoDateRegex = /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)((-(\d{2}):(\d{2})|Z)?)/g;
        var matches = input.match(isoDateRegex);

        if (!matches) {
            return input;
        }
        
        var isoTime = matches[0];
        var localTime = moment.utc(isoTime).local().format('MMM DD, YYYY [at] HH:mm');
        return input.replace(isoDateRegex, localTime);
    }
});

angular.module('gatehubClientApp')
.filter('appScope', function () {
    return function (input) {
        const app = input;
        const scopes = app.scope;

        if (!scopes || scopes.length === 0) {
            return '/';
        }
        const formattedScopes = scopes.map((scope) => {
            switch (scope) {
                case 'ramp':
                    return 'See your wallet addresses, crypto deposit addresses, bank deposit details, verification status and transaction details.';
                case 'offline_access':
                    return '';
                default:
                    return '[MISSING SCOPE DESCRIPTION]';
            }
        });

        return 'This allows ' + app.client.name + ' to: ' + formattedScopes.join(' ');
    };
});

'use strict';

/**
 * @ngdoc directive
 * @name gatehubSigninApp.directive:passwordStrength
 * @description
 * # Directive for validating password stength. 0 - very weak -> 4 - very strong
 */


angular.module('gatehubClientApp').directive('passwordStrength', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, elem, attr, ngModel) {
            var passwordStrength = attr.passwordStrength;

            attr.$observe('passwordStrength', function () {
                passwordStrength = attr.passwordStrength;
                ngModel.$validate();
            });

            ngModel.$validators['weak-password'] = function () {
                var minScore = 3;
                var isStrong = passwordStrength >= minScore;
                return isStrong;
            };

        }
    };
});
angular.module('gatehubClientApp')
    .directive('uppercased', function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, modelCtrl) {
                modelCtrl.$parsers.push(function (input) {
                    if (input) {
                        element.css('text-transform', 'uppercase');
                        return input.toUpperCase();
                    } else {
                        element.css('text-transform', 'none');
                        return '';
                    }
                });
            }
        };
    });

angular.module('gatehubClientApp')
  .directive('iframeOnload', function () {
    return {
      scope: {
        callBack: '&iframeOnload'
      },
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.on('load', function () {
          if (element[0].id) {
            return scope.callBack({ element: element[0].id });
          } else {
            console.error('iframeOnload directive requires element to have an id attribute!');
            return false;
          }
        });
      }
    };
  });
